var map = {
	"./blog/images/sites/default/files/11-25-forensics-01.jpeg": [
		745860,
		9,
		745860
	],
	"./blog/images/sites/default/files/1x-whole-genome-sequencing-vs-30x-wgs.jpg": [
		968622,
		9,
		968622
	],
	"./blog/images/sites/default/files/23andme-dna-data-upload.jpg": [
		326634,
		9,
		326634
	],
	"./blog/images/sites/default/files/30x_whole_genome_sequencing.jpeg": [
		685637,
		9,
		685637
	],
	"./blog/images/sites/default/files/50-off-rare-disease-screen-app-sequencing.jpg": [
		95470,
		9,
		95470
	],
	"./blog/images/sites/default/files/advantages-whole-genome-sequencing-wgs-sequencing.com-dna-app-store.jpeg": [
		894394,
		9,
		894394
	],
	"./blog/images/sites/default/files/ancesrty_0.jpg": [
		448049,
		9,
		448049
	],
	"./blog/images/sites/default/files/ancestry.jpg": [
		158761,
		9,
		158761
	],
	"./blog/images/sites/default/files/anne-nygard-0ragdalrppk-unsplash.jpg": [
		520691,
		9,
		520691
	],
	"./blog/images/sites/default/files/anonymous_dna_account.png": [
		577586,
		9,
		577586
	],
	"./blog/images/sites/default/files/apps-for-raw-dna-data-interpretation-sequencing.jpeg": [
		45282,
		9,
		45282
	],
	"./blog/images/sites/default/files/are_twins_genetically_identical_1.jpg": [
		197209,
		9,
		197209
	],
	"./blog/images/sites/default/files/basespace.jpg": [
		657164,
		9,
		657164
	],
	"./blog/images/sites/default/files/best-way-to-store-save-protect-raw-dna-data-sequencing-blog-article.jpg": [
		13693,
		9,
		13693
	],
	"./blog/images/sites/default/files/blood-type-corona.jpg": [
		253692,
		9,
		253692
	],
	"./blog/images/sites/default/files/blood_type_and_covid-19.jpg": [
		662976,
		9,
		662976
	],
	"./blog/images/sites/default/files/breast-cancer.jpg": [
		586539,
		9,
		586539
	],
	"./blog/images/sites/default/files/bruce_willis_dementia_diagnosis-min.png": [
		450578,
		9,
		450578
	],
	"./blog/images/sites/default/files/buying_a_dna_test_as_a_gift.jpg": [
		31266,
		9,
		31266
	],
	"./blog/images/sites/default/files/can_a_dna_test_be_wrong.jpg": [
		315934,
		9,
		315934
	],
	"./blog/images/sites/default/files/can_genetic_testing_determine_autism.jpg": [
		996746,
		9,
		996746
	],
	"./blog/images/sites/default/files/caroline-hernandez-vgacdiuid7i-unsplash.jpg": [
		912619,
		9,
		912619
	],
	"./blog/images/sites/default/files/concierge-medicine.jpg": [
		194003,
		9,
		194003
	],
	"./blog/images/sites/default/files/crucifiction.jpg": [
		960166,
		9,
		960166
	],
	"./blog/images/sites/default/files/dante-labs.jpg": [
		159066,
		9,
		159066
	],
	"./blog/images/sites/default/files/dante_labs.jpg": [
		195227,
		9,
		195227
	],
	"./blog/images/sites/default/files/delete-23andme-dna-data.jpeg": [
		654471,
		9,
		654471
	],
	"./blog/images/sites/default/files/depression.jpg": [
		233766,
		9,
		233766
	],
	"./blog/images/sites/default/files/detoxify-your-body-better-skin-care-and-personalized-fitness.jpg": [
		270266,
		9,
		270266
	],
	"./blog/images/sites/default/files/dna-analysis-online.jpg": [
		103357,
		9,
		103357
	],
	"./blog/images/sites/default/files/dna-api-build-develop-code-dna-genome-gene-apps-sequencing.com-app-store.jpg": [
		917447,
		9,
		917447
	],
	"./blog/images/sites/default/files/dna-app-spotlight.jpg": [
		797374,
		9,
		797374
	],
	"./blog/images/sites/default/files/dna-app-store-helix-sequencing-apps.jpeg": [
		599039,
		9,
		599039
	],
	"./blog/images/sites/default/files/dna-app-store-helix-sequencing-apps.jpg": [
		774559,
		9,
		774559
	],
	"./blog/images/sites/default/files/dna-data.jpg": [
		817953,
		9,
		817953
	],
	"./blog/images/sites/default/files/dna-raw-data-analysis.jpg": [
		116519,
		9,
		116519
	],
	"./blog/images/sites/default/files/dna_and_love.jpg": [
		478443,
		9,
		478443
	],
	"./blog/images/sites/default/files/dna_nutrition_testing_apps.jpeg": [
		500235,
		9,
		500235
	],
	"./blog/images/sites/default/files/dna_testing_for_fitness_and_nutrition.jpg": [
		106767,
		9,
		106767
	],
	"./blog/images/sites/default/files/does_genetic_testing_for_antidepressants_work_0.jpg": [
		196882,
		9,
		196882
	],
	"./blog/images/sites/default/files/donate-dna.jpg": [
		599377,
		9,
		599377
	],
	"./blog/images/sites/default/files/drupal-news_frequently-asked-questions-about-the-novel-coronavirus-2019-ncov-male-patient.jpeg": [
		59414,
		9,
		59414
	],
	"./blog/images/sites/default/files/fathers-day-perfect-gift-dna-kit.jpg": [
		607259,
		9,
		607259
	],
	"./blog/images/sites/default/files/firstword-medtech-sequencing.jpg": [
		394709,
		9,
		394709
	],
	"./blog/images/sites/default/files/five_ways_to_prevent_breast_cancer_.jpg": [
		974055,
		9,
		974055
	],
	"./blog/images/sites/default/files/fleur-6ewcffx1fus-unsplash.jpg": [
		411898,
		9,
		411898
	],
	"./blog/images/sites/default/files/gene-driven-plan-for-health.jpg": [
		39234,
		9,
		39234
	],
	"./blog/images/sites/default/files/gene-driven-plan-for-health2.jpg": [
		684250,
		9,
		684250
	],
	"./blog/images/sites/default/files/geneology.jpg": [
		930672,
		9,
		930672
	],
	"./blog/images/sites/default/files/genetic-api-alternative.jpg": [
		654321,
		9,
		654321
	],
	"./blog/images/sites/default/files/genetic-dna-testing-rare-disease-guide.jpg": [
		682998,
		9,
		682998
	],
	"./blog/images/sites/default/files/genetic-testing-health-fitness-sequencingcom.jpg": [
		204373,
		9,
		204373
	],
	"./blog/images/sites/default/files/genetic_testing_scams.jpg": [
		602710,
		9,
		602710
	],
	"./blog/images/sites/default/files/genetics_and_dentistry.jpg": [
		838754,
		9,
		838754
	],
	"./blog/images/sites/default/files/genomeweb.jpg": [
		447959,
		9,
		447959
	],
	"./blog/images/sites/default/files/how-to-upload-data.jpg": [
		718170,
		9,
		718170
	],
	"./blog/images/sites/default/files/how_is_happiness_genetic.jpg": [
		16090,
		9,
		16090
	],
	"./blog/images/sites/default/files/how_long_does_a_dna_test_take_1.jpg": [
		398034,
		9,
		398034
	],
	"./blog/images/sites/default/files/how_soon_can_you_dna_test_a_baby_after_birth.jpg": [
		570531,
		9,
		570531
	],
	"./blog/images/sites/default/files/how_to_get_online_dna_tests_for_free.jpg": [
		635308,
		9,
		635308
	],
	"./blog/images/sites/default/files/image-1.jpg": [
		298365,
		9,
		298365
	],
	"./blog/images/sites/default/files/image-1_0.jpg": [
		2605,
		9,
		2605
	],
	"./blog/images/sites/default/files/image-1_1.jpg": [
		679089,
		9,
		679089
	],
	"./blog/images/sites/default/files/image-1_2.jpg": [
		310411,
		9,
		310411
	],
	"./blog/images/sites/default/files/image-1_3.jpg": [
		97224,
		9,
		97224
	],
	"./blog/images/sites/default/files/image-1_4.jpg": [
		260922,
		9,
		260922
	],
	"./blog/images/sites/default/files/image-1_5.jpg": [
		286318,
		9,
		286318
	],
	"./blog/images/sites/default/files/image-1_6.jpg": [
		121575,
		9,
		121575
	],
	"./blog/images/sites/default/files/image-1_7.jpg": [
		311182,
		9,
		311182
	],
	"./blog/images/sites/default/files/image-1_8.jpg": [
		782929,
		9,
		782929
	],
	"./blog/images/sites/default/files/image-1_9.jpg": [
		9312,
		9,
		9312
	],
	"./blog/images/sites/default/files/img-428689_0.jpeg": [
		496816,
		9,
		496816
	],
	"./blog/images/sites/default/files/istock-1042441156-scaled.jpeg": [
		753268,
		9,
		753268
	],
	"./blog/images/sites/default/files/jack-ripper-dna-profile-genetic-testing-sequencing-blog.jpg": [
		477731,
		9,
		477731
	],
	"./blog/images/sites/default/files/killer.jpg": [
		590918,
		9,
		590918
	],
	"./blog/images/sites/default/files/losing_weight.jpg": [
		586225,
		9,
		586225
	],
	"./blog/images/sites/default/files/making-a-life-plan-based-on-your-dna.jpg": [
		270218,
		9,
		270218
	],
	"./blog/images/sites/default/files/map_my_genes.jpg": [
		337629,
		9,
		337629
	],
	"./blog/images/sites/default/files/medicine.jpg": [
		796667,
		9,
		796667
	],
	"./blog/images/sites/default/files/myheritage-review-dna-testing-article_0.jpg": [
		914615,
		9,
		914615
	],
	"./blog/images/sites/default/files/online-genetic-counseling.jpg": [
		876609,
		9,
		876609
	],
	"./blog/images/sites/default/files/prevention_magazine_-_outsmart_your_genes.jpg": [
		993885,
		9,
		993885
	],
	"./blog/images/sites/default/files/reach-peak-performance.jpg": [
		902442,
		9,
		902442
	],
	"./blog/images/sites/default/files/spotlight.jpg": [
		549788,
		9,
		549788
	],
	"./blog/images/sites/default/files/spotlight3.jpg": [
		971416,
		9,
		971416
	],
	"./blog/images/sites/default/files/tech.jpg": [
		209231,
		9,
		209231
	],
	"./blog/images/sites/default/files/tests-from-athletigen.jpg": [
		172275,
		9,
		172275
	],
	"./blog/images/sites/default/files/thumbnail-photos-blog.jpg": [
		323247,
		9,
		323247
	],
	"./blog/images/sites/default/files/thumbnail-photos-blog_0.jpg": [
		466574,
		9,
		466574
	],
	"./blog/images/sites/default/files/thumbnail-photos-blog_1.jpg": [
		860524,
		9,
		860524
	],
	"./blog/images/sites/default/files/thumbnail-photos-blog_2.jpg": [
		664635,
		9,
		664635
	],
	"./blog/images/sites/default/files/upload-data.jpg": [
		579389,
		9,
		579389
	],
	"./blog/images/sites/default/files/upload-raw-ancestry-dna.jpg": [
		534626,
		9,
		534626
	],
	"./blog/images/sites/default/files/using-raw-dna-data.jpg": [
		597736,
		9,
		597736
	],
	"./blog/images/sites/default/files/weight-loss.jpg": [
		740472,
		9,
		740472
	],
	"./blog/images/sites/default/files/weight-loss_0.jpg": [
		413046,
		9,
		413046
	],
	"./blog/images/sites/default/files/weight.jpg": [
		289586,
		9,
		289586
	],
	"./blog/images/sites/default/files/what-is-genetic-counseling-sequencing-genome-dna-app-store.jpg": [
		268783,
		9,
		268783
	],
	"./blog/images/sites/default/files/what-is-whole-genome-sequencing-wgs_0.jpg": [
		876789,
		9,
		876789
	],
	"./blog/images/sites/default/files/what-is-your-heritage-genealogy-ancestry-dna-analysis-app-sequencing.com-blog.jpg": [
		720889,
		9,
		720889
	],
	"./blog/images/sites/default/files/what_does_dna_have_to_do_with_weight.jpg": [
		196848,
		9,
		196848
	],
	"./blog/images/sites/default/files/what_is_the_cost_of_breast_cancer_genetic_testing.jpg": [
		733801,
		9,
		733801
	],
	"./blog/images/sites/default/files/where_can_i_get_a_dna_test.jpg": [
		182238,
		9,
		182238
	],
	"./blog/images/sites/default/files/where_can_i_get_a_dna_test_while_pregnant.jpg": [
		273637,
		9,
		273637
	],
	"./blog/images/sites/default/files/worlds-first-app-store-for-dna.jpg": [
		240384,
		9,
		240384
	],
	"./blog/markdown/5-things-you-need-know-about-cell-free-dna-tests": [
		13385,
		9,
		13385
	],
	"./blog/markdown/5-things-you-need-know-about-cell-free-dna-tests.md": [
		13385,
		9,
		13385
	],
	"./blog/markdown/5-things-you-need-know-about-dna-nutrition": [
		390792,
		9,
		390792
	],
	"./blog/markdown/5-things-you-need-know-about-dna-nutrition.md": [
		390792,
		9,
		390792
	],
	"./blog/markdown/5-things-you-need-know-about-hair-dna-tests": [
		390089,
		9,
		390089
	],
	"./blog/markdown/5-things-you-need-know-about-hair-dna-tests.md": [
		390089,
		9,
		390089
	],
	"./blog/markdown/7-dna-apps-help-you-better-optimize-your-health": [
		724360,
		9,
		724360
	],
	"./blog/markdown/7-dna-apps-help-you-better-optimize-your-health.md": [
		724360,
		9,
		724360
	],
	"./blog/markdown/7-remedies-help-treat-skin-inflammation": [
		114185,
		9,
		114185
	],
	"./blog/markdown/7-remedies-help-treat-skin-inflammation.md": [
		114185,
		9,
		114185
	],
	"./blog/markdown/advantages-whole-genome-sequencing-wgs": [
		358996,
		9,
		358996
	],
	"./blog/markdown/advantages-whole-genome-sequencing-wgs.md": [
		358996,
		9,
		358996
	],
	"./blog/markdown/ancestrydna-raw-data-interpretation-analysis": [
		669608,
		9,
		669608
	],
	"./blog/markdown/ancestrydna-raw-data-interpretation-analysis.md": [
		669608,
		9,
		669608
	],
	"./blog/markdown/ancient-dna-analysis": [
		626026,
		9,
		626026
	],
	"./blog/markdown/ancient-dna-analysis.md": [
		626026,
		9,
		626026
	],
	"./blog/markdown/anonymous-account-setup": [
		679555,
		9,
		679555
	],
	"./blog/markdown/anonymous-account-setup.md": [
		679555,
		9,
		679555
	],
	"./blog/markdown/apps-for-raw-dna-data-interpretation": [
		229408,
		9,
		229408
	],
	"./blog/markdown/apps-for-raw-dna-data-interpretation.md": [
		229408,
		9,
		229408
	],
	"./blog/markdown/are-athletic-genes-real": [
		107636,
		9,
		107636
	],
	"./blog/markdown/are-athletic-genes-real.md": [
		107636,
		9,
		107636
	],
	"./blog/markdown/are-twins-genetically-identical": [
		556396,
		9,
		556396
	],
	"./blog/markdown/are-twins-genetically-identical.md": [
		556396,
		9,
		556396
	],
	"./blog/markdown/autism-hereditary-explaining-autism-genetics": [
		287595,
		9,
		287595
	],
	"./blog/markdown/autism-hereditary-explaining-autism-genetics.md": [
		287595,
		9,
		287595
	],
	"./blog/markdown/best-way-store-protect-dna-raw-data": [
		281925,
		9,
		281925
	],
	"./blog/markdown/best-way-store-protect-dna-raw-data.md": [
		281925,
		9,
		281925
	],
	"./blog/markdown/brain-inflammation-genetic": [
		658107,
		9,
		658107
	],
	"./blog/markdown/brain-inflammation-genetic.md": [
		658107,
		9,
		658107
	],
	"./blog/markdown/breast-cancer-genetic-testing-news": [
		282930,
		9,
		282930
	],
	"./blog/markdown/breast-cancer-genetic-testing-news.md": [
		282930,
		9,
		282930
	],
	"./blog/markdown/buying-dna-tests-as-gift": [
		413811,
		9,
		413811
	],
	"./blog/markdown/buying-dna-tests-as-gift.md": [
		413811,
		9,
		413811
	],
	"./blog/markdown/can-dna-test-help-weight-loss": [
		3765,
		9,
		3765
	],
	"./blog/markdown/can-dna-test-help-weight-loss.md": [
		3765,
		9,
		3765
	],
	"./blog/markdown/can-dna-test-identify-jewish-ancestry": [
		592359,
		9,
		592359
	],
	"./blog/markdown/can-dna-test-identify-jewish-ancestry.md": [
		592359,
		9,
		592359
	],
	"./blog/markdown/can-dna-testing-be-wrong": [
		40981,
		9,
		40981
	],
	"./blog/markdown/can-dna-testing-be-wrong.md": [
		40981,
		9,
		40981
	],
	"./blog/markdown/can-genetic-testing-determine-autism": [
		733530,
		9,
		733530
	],
	"./blog/markdown/can-genetic-testing-determine-autism.md": [
		733530,
		9,
		733530
	],
	"./blog/markdown/celiac-disease-genetic-everything-you-need-know": [
		200923,
		9,
		200923
	],
	"./blog/markdown/celiac-disease-genetic-everything-you-need-know.md": [
		200923,
		9,
		200923
	],
	"./blog/markdown/coronavirus-and-blood-type": [
		78117,
		9,
		78117
	],
	"./blog/markdown/coronavirus-and-blood-type.md": [
		78117,
		9,
		78117
	],
	"./blog/markdown/dante-labs": [
		47666,
		9,
		47666
	],
	"./blog/markdown/dante-labs-whole-genome-sequencing-worth-it": [
		970345,
		9,
		970345
	],
	"./blog/markdown/dante-labs-whole-genome-sequencing-worth-it.md": [
		970345,
		9,
		970345
	],
	"./blog/markdown/dante-labs.md": [
		47666,
		9,
		47666
	],
	"./blog/markdown/dating-and-dna": [
		60828,
		9,
		60828
	],
	"./blog/markdown/dating-and-dna.md": [
		60828,
		9,
		60828
	],
	"./blog/markdown/detox-genes-what-are-they-and-are-they-even-real": [
		908585,
		9,
		908585
	],
	"./blog/markdown/detox-genes-what-are-they-and-are-they-even-real.md": [
		908585,
		9,
		908585
	],
	"./blog/markdown/dna-analysis-forensics-identity-jack-ripper": [
		429833,
		9,
		429833
	],
	"./blog/markdown/dna-analysis-forensics-identity-jack-ripper.md": [
		429833,
		9,
		429833
	],
	"./blog/markdown/dna-api-build-develop-code-genome-dna-apps": [
		907166,
		9,
		907166
	],
	"./blog/markdown/dna-api-build-develop-code-genome-dna-apps.md": [
		907166,
		9,
		907166
	],
	"./blog/markdown/dna-app-better-sleep-improving-moods-managing-alzheimers-risk": [
		79578,
		9,
		79578
	],
	"./blog/markdown/dna-app-better-sleep-improving-moods-managing-alzheimers-risk.md": [
		79578,
		9,
		79578
	],
	"./blog/markdown/dna-app-spotlight-gene-informed": [
		969719,
		9,
		969719
	],
	"./blog/markdown/dna-app-spotlight-gene-informed.md": [
		969719,
		9,
		969719
	],
	"./blog/markdown/dna-app-spotlight-heart-health-inflammation-essential-minerals": [
		646358,
		9,
		646358
	],
	"./blog/markdown/dna-app-spotlight-heart-health-inflammation-essential-minerals.md": [
		646358,
		9,
		646358
	],
	"./blog/markdown/dna-app-spotlight-silverberry-genomix": [
		109209,
		9,
		109209
	],
	"./blog/markdown/dna-app-spotlight-silverberry-genomix.md": [
		109209,
		9,
		109209
	],
	"./blog/markdown/dna-app-spotlight-toolbox-genomics": [
		677264,
		9,
		677264
	],
	"./blog/markdown/dna-app-spotlight-toolbox-genomics.md": [
		677264,
		9,
		677264
	],
	"./blog/markdown/dna-app-spotlight-what-genome-explorer": [
		661424,
		9,
		661424
	],
	"./blog/markdown/dna-app-spotlight-what-genome-explorer.md": [
		661424,
		9,
		661424
	],
	"./blog/markdown/dna-app-store": [
		569593,
		9,
		569593
	],
	"./blog/markdown/dna-app-store.md": [
		569593,
		9,
		569593
	],
	"./blog/markdown/dna-data-download-explained": [
		142966,
		9,
		142966
	],
	"./blog/markdown/dna-data-download-explained.md": [
		142966,
		9,
		142966
	],
	"./blog/markdown/dna-diets": [
		782088,
		9,
		782088
	],
	"./blog/markdown/dna-diets.md": [
		782088,
		9,
		782088
	],
	"./blog/markdown/dna-genetic-ancestry-haplogroups-app-spotlight": [
		681644,
		9,
		681644
	],
	"./blog/markdown/dna-genetic-ancestry-haplogroups-app-spotlight.md": [
		681644,
		9,
		681644
	],
	"./blog/markdown/dna-nutrition-testing-apps": [
		426406,
		9,
		426406
	],
	"./blog/markdown/dna-nutrition-testing-apps.md": [
		426406,
		9,
		426406
	],
	"./blog/markdown/dna-raw-data-analysis": [
		551477,
		9,
		551477
	],
	"./blog/markdown/dna-raw-data-analysis.md": [
		551477,
		9,
		551477
	],
	"./blog/markdown/dna-testing-fitness-nutrition-gene-analysis-apps": [
		113533,
		9,
		113533
	],
	"./blog/markdown/dna-testing-fitness-nutrition-gene-analysis-apps.md": [
		113533,
		9,
		113533
	],
	"./blog/markdown/does-genetic-testing-antidepressants-work": [
		199405,
		9,
		199405
	],
	"./blog/markdown/does-genetic-testing-antidepressants-work.md": [
		199405,
		9,
		199405
	],
	"./blog/markdown/father-day-dna-kit": [
		728685,
		9,
		728685
	],
	"./blog/markdown/father-day-dna-kit.md": [
		728685,
		9,
		728685
	],
	"./blog/markdown/five-ways-prevent-breast-cancer": [
		391187,
		9,
		391187
	],
	"./blog/markdown/five-ways-prevent-breast-cancer.md": [
		391187,
		9,
		391187
	],
	"./blog/markdown/free-dna-analysis-online-sequencing": [
		282980,
		9,
		282980
	],
	"./blog/markdown/free-dna-analysis-online-sequencing.md": [
		282980,
		9,
		282980
	],
	"./blog/markdown/gene-driven-plan-health": [
		440945,
		9,
		440945
	],
	"./blog/markdown/gene-driven-plan-health.md": [
		440945,
		9,
		440945
	],
	"./blog/markdown/genetic-api-alternative-23andme-api": [
		979394,
		9,
		979394
	],
	"./blog/markdown/genetic-api-alternative-23andme-api.md": [
		979394,
		9,
		979394
	],
	"./blog/markdown/genetic-genealogy-apps": [
		132220,
		9,
		132220
	],
	"./blog/markdown/genetic-genealogy-apps.md": [
		132220,
		9,
		132220
	],
	"./blog/markdown/genetic-test-identifies-best-antidepressant": [
		974052,
		9,
		974052
	],
	"./blog/markdown/genetic-test-identifies-best-antidepressant.md": [
		974052,
		9,
		974052
	],
	"./blog/markdown/genetic-testing-rare-diseases-sequencing": [
		382714,
		9,
		382714
	],
	"./blog/markdown/genetic-testing-rare-diseases-sequencing.md": [
		382714,
		9,
		382714
	],
	"./blog/markdown/genetics-and-dentistry": [
		691071,
		9,
		691071
	],
	"./blog/markdown/genetics-and-dentistry.md": [
		691071,
		9,
		691071
	],
	"./blog/markdown/get-free-dna-health-analysis-free-dna-reports": [
		403197,
		9,
		403197
	],
	"./blog/markdown/get-free-dna-health-analysis-free-dna-reports.md": [
		403197,
		9,
		403197
	],
	"./blog/markdown/golden-state-killer-dna-kit-privacy": [
		624152,
		9,
		624152
	],
	"./blog/markdown/golden-state-killer-dna-kit-privacy.md": [
		624152,
		9,
		624152
	],
	"./blog/markdown/happiness-genetic": [
		887998,
		9,
		887998
	],
	"./blog/markdown/happiness-genetic.md": [
		887998,
		9,
		887998
	],
	"./blog/markdown/hay-fever-genetic-guide-seasonal-allergies-and-your-dna": [
		122110,
		9,
		122110
	],
	"./blog/markdown/hay-fever-genetic-guide-seasonal-allergies-and-your-dna.md": [
		122110,
		9,
		122110
	],
	"./blog/markdown/how-accurate-walgreens-dna-test": [
		665200,
		9,
		665200
	],
	"./blog/markdown/how-accurate-walgreens-dna-test.md": [
		665200,
		9,
		665200
	],
	"./blog/markdown/how-avoid-genetic-testing-scams": [
		66800,
		9,
		66800
	],
	"./blog/markdown/how-avoid-genetic-testing-scams.md": [
		66800,
		9,
		66800
	],
	"./blog/markdown/how-delete-23andme-data-account-guide": [
		534645,
		9,
		534645
	],
	"./blog/markdown/how-delete-23andme-data-account-guide.md": [
		534645,
		9,
		534645
	],
	"./blog/markdown/how-dna-testing-can-improve-health-and-fitness": [
		482071,
		9,
		482071
	],
	"./blog/markdown/how-dna-testing-can-improve-health-and-fitness.md": [
		482071,
		9,
		482071
	],
	"./blog/markdown/how-do-you-know-if-you-have-roma-gypsy-ancestry": [
		218783,
		9,
		218783
	],
	"./blog/markdown/how-do-you-know-if-you-have-roma-gypsy-ancestry.md": [
		218783,
		9,
		218783
	],
	"./blog/markdown/how-find-online-genetic-counseling-service": [
		484619,
		9,
		484619
	],
	"./blog/markdown/how-find-online-genetic-counseling-service.md": [
		484619,
		9,
		484619
	],
	"./blog/markdown/how-genetics-impacted-bruce-willis-dementia-aphasia-diagnosis": [
		403579,
		9,
		403579
	],
	"./blog/markdown/how-genetics-impacted-bruce-willis-dementia-aphasia-diagnosis.md": [
		403579,
		9,
		403579
	],
	"./blog/markdown/how-get-online-dna-test-free": [
		830181,
		9,
		830181
	],
	"./blog/markdown/how-get-online-dna-test-free.md": [
		830181,
		9,
		830181
	],
	"./blog/markdown/how-long-does-dna-test-take": [
		36549,
		9,
		36549
	],
	"./blog/markdown/how-long-does-dna-test-take.md": [
		36549,
		9,
		36549
	],
	"./blog/markdown/how-soon-can-you-dna-test-a-baby-after-birth": [
		62469,
		9,
		62469
	],
	"./blog/markdown/how-soon-can-you-dna-test-a-baby-after-birth.md": [
		62469,
		9,
		62469
	],
	"./blog/markdown/how-to-download-23andme-raw-dna-data": [
		722514,
		9,
		722514
	],
	"./blog/markdown/how-to-download-23andme-raw-dna-data.md": [
		722514,
		9,
		722514
	],
	"./blog/markdown/how-to-upload-23andme-data-sequencing": [
		27174,
		9,
		27174
	],
	"./blog/markdown/how-to-upload-23andme-data-sequencing.md": [
		27174,
		9,
		27174
	],
	"./blog/markdown/how-to-upload-raw-dna-data-genome-data-sequencing.com": [
		479079,
		9,
		479079
	],
	"./blog/markdown/how-to-upload-raw-dna-data-genome-data-sequencing.com.md": [
		479079,
		9,
		479079
	],
	"./blog/markdown/how-to-use-genome-sequencing-data-files": [
		941605,
		9,
		941605
	],
	"./blog/markdown/how-to-use-genome-sequencing-data-files.md": [
		941605,
		9,
		941605
	],
	"./blog/markdown/how-upload-raw-ancestry-dna-data-sequencing": [
		20607,
		9,
		20607
	],
	"./blog/markdown/how-upload-raw-ancestry-dna-data-sequencing.md": [
		20607,
		9,
		20607
	],
	"./blog/markdown/is-a-there-genetic-test-breast-cancer": [
		268614,
		9,
		268614
	],
	"./blog/markdown/is-a-there-genetic-test-breast-cancer.md": [
		268614,
		9,
		268614
	],
	"./blog/markdown/jesus-dna": [
		228095,
		9,
		228095
	],
	"./blog/markdown/jesus-dna.md": [
		228095,
		9,
		228095
	],
	"./blog/markdown/making-life-plan-based-your-dna": [
		987251,
		9,
		987251
	],
	"./blog/markdown/making-life-plan-based-your-dna.md": [
		987251,
		9,
		987251
	],
	"./blog/markdown/myheritage-review-dna-testing-genealogy-and-health": [
		204780,
		9,
		204780
	],
	"./blog/markdown/myheritage-review-dna-testing-genealogy-and-health.md": [
		204780,
		9,
		204780
	],
	"./blog/markdown/national-news-sequencingcom-concierge-medicine-today-announce-partnership-help-physicians-bring": [
		197440,
		9,
		197440
	],
	"./blog/markdown/national-news-sequencingcom-concierge-medicine-today-announce-partnership-help-physicians-bring.md": [
		197440,
		9,
		197440
	],
	"./blog/markdown/new-fitness-nutrition-dna-tests-athletigen-nutrigenomics": [
		204637,
		9,
		204637
	],
	"./blog/markdown/new-fitness-nutrition-dna-tests-athletigen-nutrigenomics.md": [
		204637,
		9,
		204637
	],
	"./blog/markdown/personalized-dna-health-report-post-quarantine": [
		86955,
		9,
		86955
	],
	"./blog/markdown/personalized-dna-health-report-post-quarantine.md": [
		86955,
		9,
		86955
	],
	"./blog/markdown/prevention-magazine-recognizes-outsmart-your-genes-promote-power-dna": [
		56850,
		9,
		56850
	],
	"./blog/markdown/prevention-magazine-recognizes-outsmart-your-genes-promote-power-dna.md": [
		56850,
		9,
		56850
	],
	"./blog/markdown/quarantine-tech-products-to-try": [
		453641,
		9,
		453641
	],
	"./blog/markdown/quarantine-tech-products-to-try.md": [
		453641,
		9,
		453641
	],
	"./blog/markdown/research-reveals-most-people-do-not-want-donate-dna-science": [
		468140,
		9,
		468140
	],
	"./blog/markdown/research-reveals-most-people-do-not-want-donate-dna-science.md": [
		468140,
		9,
		468140
	],
	"./blog/markdown/sequencingcom-hopes-shepherd-growing-market-diy-genomics-tools": [
		713017,
		9,
		713017
	],
	"./blog/markdown/sequencingcom-hopes-shepherd-growing-market-diy-genomics-tools.md": [
		713017,
		9,
		713017
	],
	"./blog/markdown/sequencingcom-introduces-first-agnostic-platform-genetic-data": [
		780804,
		9,
		780804
	],
	"./blog/markdown/sequencingcom-introduces-first-agnostic-platform-genetic-data.md": [
		780804,
		9,
		780804
	],
	"./blog/markdown/sequencingcom-launches-free-genetic-analysis-assess-risk-and-severity-coronavirus-infection": [
		594613,
		9,
		594613
	],
	"./blog/markdown/sequencingcom-launches-free-genetic-analysis-assess-risk-and-severity-coronavirus-infection.md": [
		594613,
		9,
		594613
	],
	"./blog/markdown/sequencingcom-launches-worlds-first-app-store-dna": [
		479325,
		9,
		479325
	],
	"./blog/markdown/sequencingcom-launches-worlds-first-app-store-dna.md": [
		479325,
		9,
		479325
	],
	"./blog/markdown/support-for-use-whole-genome-sequencing-concierge-medicine": [
		785197,
		9,
		785197
	],
	"./blog/markdown/support-for-use-whole-genome-sequencing-concierge-medicine.md": [
		785197,
		9,
		785197
	],
	"./blog/markdown/these-are-todays-5-best-ancestry-and-genealogy-sites": [
		772779,
		9,
		772779
	],
	"./blog/markdown/these-are-todays-5-best-ancestry-and-genealogy-sites.md": [
		772779,
		9,
		772779
	],
	"./blog/markdown/using-dna-learn-what-is-your-heritage-ancestry-genealogy": [
		462863,
		9,
		462863
	],
	"./blog/markdown/using-dna-learn-what-is-your-heritage-ancestry-genealogy.md": [
		462863,
		9,
		462863
	],
	"./blog/markdown/using-raw-dna-data": [
		820031,
		9,
		820031
	],
	"./blog/markdown/using-raw-dna-data.md": [
		820031,
		9,
		820031
	],
	"./blog/markdown/weight-loss-through-dna-testing": [
		763200,
		9,
		518568
	],
	"./blog/markdown/weight-loss-through-dna-testing.md": [
		763200,
		9,
		518568
	],
	"./blog/markdown/what-1x-whole-genome-sequencing-1x-vs-30x-wgs-explained": [
		417945,
		9,
		417945
	],
	"./blog/markdown/what-1x-whole-genome-sequencing-1x-vs-30x-wgs-explained.md": [
		417945,
		9,
		417945
	],
	"./blog/markdown/what-30x-and-04x-whole-genome-sequencing": [
		697717,
		9,
		697717
	],
	"./blog/markdown/what-30x-and-04x-whole-genome-sequencing.md": [
		697717,
		9,
		697717
	],
	"./blog/markdown/what-ancestral-lineage-healing": [
		119681,
		9,
		119681
	],
	"./blog/markdown/what-ancestral-lineage-healing.md": [
		119681,
		9,
		119681
	],
	"./blog/markdown/what-cost-genetic-testing-breast-cancer": [
		375773,
		9,
		375773
	],
	"./blog/markdown/what-cost-genetic-testing-breast-cancer.md": [
		375773,
		9,
		375773
	],
	"./blog/markdown/what-do-when-medicines-have-side-effects": [
		953491,
		9,
		953491
	],
	"./blog/markdown/what-do-when-medicines-have-side-effects.md": [
		953491,
		9,
		953491
	],
	"./blog/markdown/what-does-dna-have-do-weight-loss": [
		688986,
		9,
		688986
	],
	"./blog/markdown/what-does-dna-have-do-weight-loss.md": [
		688986,
		9,
		688986
	],
	"./blog/markdown/what-is-genetic-counseling-for-dna-tests": [
		155658,
		9,
		155658
	],
	"./blog/markdown/what-is-genetic-counseling-for-dna-tests.md": [
		155658,
		9,
		155658
	],
	"./blog/markdown/what-is-rare-disease-day": [
		137154,
		9,
		137154
	],
	"./blog/markdown/what-is-rare-disease-day.md": [
		137154,
		9,
		137154
	],
	"./blog/markdown/what-is-whole-genome-sequencing-wgs": [
		73821,
		9,
		73821
	],
	"./blog/markdown/what-is-whole-genome-sequencing-wgs.md": [
		73821,
		9,
		73821
	],
	"./blog/markdown/what-single-cell-whole-genome-sequencing": [
		534475,
		9,
		534475
	],
	"./blog/markdown/what-single-cell-whole-genome-sequencing.md": [
		534475,
		9,
		534475
	],
	"./blog/markdown/whats-most-private-dna-test-market": [
		714787,
		9,
		714787
	],
	"./blog/markdown/whats-most-private-dna-test-market.md": [
		714787,
		9,
		714787
	],
	"./blog/markdown/where-can-get-dna-test": [
		707871,
		9,
		707871
	],
	"./blog/markdown/where-can-get-dna-test.md": [
		707871,
		9,
		707871
	],
	"./blog/markdown/where-can-i-get-a-dna-test-while-pregnant": [
		927920,
		9,
		927920
	],
	"./blog/markdown/where-can-i-get-a-dna-test-while-pregnant.md": [
		927920,
		9,
		927920
	],
	"./blog/markdown/why-am-i-not-losing-weight": [
		253595,
		9,
		253595
	],
	"./blog/markdown/why-am-i-not-losing-weight.md": [
		253595,
		9,
		253595
	],
	"./blog/markdown/why-blood-type-matters-covid-19-infection": [
		988603,
		9,
		988603
	],
	"./blog/markdown/why-blood-type-matters-covid-19-infection.md": [
		988603,
		9,
		988603
	],
	"./blog/structured-data/5-things-you-need-know-about-cell-free-dna-tests": [
		470860,
		3,
		470860
	],
	"./blog/structured-data/5-things-you-need-know-about-cell-free-dna-tests.json": [
		470860,
		3,
		470860
	],
	"./blog/structured-data/5-things-you-need-know-about-dna-nutrition": [
		27896,
		3,
		27896
	],
	"./blog/structured-data/5-things-you-need-know-about-dna-nutrition.json": [
		27896,
		3,
		27896
	],
	"./blog/structured-data/5-things-you-need-know-about-hair-dna-tests": [
		8668,
		3,
		8668
	],
	"./blog/structured-data/5-things-you-need-know-about-hair-dna-tests.json": [
		8668,
		3,
		8668
	],
	"./blog/structured-data/7-dna-apps-help-you-better-optimize-your-health": [
		862808,
		3,
		862808
	],
	"./blog/structured-data/7-dna-apps-help-you-better-optimize-your-health.json": [
		862808,
		3,
		862808
	],
	"./blog/structured-data/7-remedies-help-treat-skin-inflammation": [
		772460,
		3,
		772460
	],
	"./blog/structured-data/7-remedies-help-treat-skin-inflammation.json": [
		772460,
		3,
		772460
	],
	"./blog/structured-data/advantages-whole-genome-sequencing-wgs": [
		840632,
		3,
		840632
	],
	"./blog/structured-data/advantages-whole-genome-sequencing-wgs.json": [
		840632,
		3,
		840632
	],
	"./blog/structured-data/ancestrydna-raw-data-interpretation-analysis": [
		330244,
		3,
		330244
	],
	"./blog/structured-data/ancestrydna-raw-data-interpretation-analysis.json": [
		330244,
		3,
		330244
	],
	"./blog/structured-data/ancient-dna-analysis": [
		602035,
		3,
		602035
	],
	"./blog/structured-data/ancient-dna-analysis.json": [
		602035,
		3,
		602035
	],
	"./blog/structured-data/anonymous-account-setup": [
		787141,
		3,
		787141
	],
	"./blog/structured-data/anonymous-account-setup.json": [
		787141,
		3,
		787141
	],
	"./blog/structured-data/apps-for-raw-dna-data-interpretation": [
		477547,
		3,
		477547
	],
	"./blog/structured-data/apps-for-raw-dna-data-interpretation.json": [
		477547,
		3,
		477547
	],
	"./blog/structured-data/are-athletic-genes-real": [
		623558,
		3,
		623558
	],
	"./blog/structured-data/are-athletic-genes-real.json": [
		623558,
		3,
		623558
	],
	"./blog/structured-data/are-twins-genetically-identical": [
		280051,
		3,
		280051
	],
	"./blog/structured-data/are-twins-genetically-identical.json": [
		280051,
		3,
		280051
	],
	"./blog/structured-data/autism-hereditary-explaining-autism-genetics": [
		756632,
		3,
		756632
	],
	"./blog/structured-data/autism-hereditary-explaining-autism-genetics.json": [
		756632,
		3,
		756632
	],
	"./blog/structured-data/best-way-store-protect-dna-raw-data": [
		378828,
		3,
		378828
	],
	"./blog/structured-data/best-way-store-protect-dna-raw-data.json": [
		378828,
		3,
		378828
	],
	"./blog/structured-data/brain-inflammation-genetic": [
		366163,
		3,
		366163
	],
	"./blog/structured-data/brain-inflammation-genetic.json": [
		366163,
		3,
		366163
	],
	"./blog/structured-data/breast-cancer-genetic-testing-news": [
		210190,
		3,
		210190
	],
	"./blog/structured-data/breast-cancer-genetic-testing-news.json": [
		210190,
		3,
		210190
	],
	"./blog/structured-data/buying-dna-tests-as-gift": [
		468052,
		3,
		468052
	],
	"./blog/structured-data/buying-dna-tests-as-gift.json": [
		468052,
		3,
		468052
	],
	"./blog/structured-data/can-dna-test-help-weight-loss": [
		73478,
		3,
		73478
	],
	"./blog/structured-data/can-dna-test-help-weight-loss.json": [
		73478,
		3,
		73478
	],
	"./blog/structured-data/can-dna-test-identify-jewish-ancestry": [
		546947,
		3,
		546947
	],
	"./blog/structured-data/can-dna-test-identify-jewish-ancestry.json": [
		546947,
		3,
		546947
	],
	"./blog/structured-data/can-dna-testing-be-wrong": [
		33580,
		3,
		33580
	],
	"./blog/structured-data/can-dna-testing-be-wrong.json": [
		33580,
		3,
		33580
	],
	"./blog/structured-data/can-genetic-testing-determine-autism": [
		399220,
		3,
		399220
	],
	"./blog/structured-data/can-genetic-testing-determine-autism.json": [
		399220,
		3,
		399220
	],
	"./blog/structured-data/celiac-disease-genetic-everything-you-need-know": [
		889869,
		3,
		889869
	],
	"./blog/structured-data/celiac-disease-genetic-everything-you-need-know.json": [
		889869,
		3,
		889869
	],
	"./blog/structured-data/coronavirus-and-blood-type": [
		78806,
		3,
		78806
	],
	"./blog/structured-data/coronavirus-and-blood-type.json": [
		78806,
		3,
		78806
	],
	"./blog/structured-data/dante-labs": [
		23262,
		3,
		23262
	],
	"./blog/structured-data/dante-labs-whole-genome-sequencing-worth-it": [
		646838,
		3,
		646838
	],
	"./blog/structured-data/dante-labs-whole-genome-sequencing-worth-it.json": [
		646838,
		3,
		646838
	],
	"./blog/structured-data/dante-labs.json": [
		23262,
		3,
		23262
	],
	"./blog/structured-data/dating-and-dna": [
		986100,
		3,
		986100
	],
	"./blog/structured-data/dating-and-dna.json": [
		986100,
		3,
		986100
	],
	"./blog/structured-data/detox-genes-what-are-they-and-are-they-even-real": [
		15263,
		3,
		15263
	],
	"./blog/structured-data/detox-genes-what-are-they-and-are-they-even-real.json": [
		15263,
		3,
		15263
	],
	"./blog/structured-data/dna-analysis-forensics-identity-jack-ripper": [
		71132,
		3,
		71132
	],
	"./blog/structured-data/dna-analysis-forensics-identity-jack-ripper.json": [
		71132,
		3,
		71132
	],
	"./blog/structured-data/dna-api-build-develop-code-genome-dna-apps": [
		252654,
		3,
		252654
	],
	"./blog/structured-data/dna-api-build-develop-code-genome-dna-apps.json": [
		252654,
		3,
		252654
	],
	"./blog/structured-data/dna-app-better-sleep-improving-moods-managing-alzheimers-risk": [
		437272,
		3,
		437272
	],
	"./blog/structured-data/dna-app-better-sleep-improving-moods-managing-alzheimers-risk.json": [
		437272,
		3,
		437272
	],
	"./blog/structured-data/dna-app-spotlight-gene-informed": [
		539881,
		3,
		539881
	],
	"./blog/structured-data/dna-app-spotlight-gene-informed.json": [
		539881,
		3,
		539881
	],
	"./blog/structured-data/dna-app-spotlight-heart-health-inflammation-essential-minerals": [
		863014,
		3,
		863014
	],
	"./blog/structured-data/dna-app-spotlight-heart-health-inflammation-essential-minerals.json": [
		863014,
		3,
		863014
	],
	"./blog/structured-data/dna-app-spotlight-silverberry-genomix": [
		39432,
		3,
		39432
	],
	"./blog/structured-data/dna-app-spotlight-silverberry-genomix.json": [
		39432,
		3,
		39432
	],
	"./blog/structured-data/dna-app-spotlight-toolbox-genomics": [
		361311,
		3,
		361311
	],
	"./blog/structured-data/dna-app-spotlight-toolbox-genomics.json": [
		361311,
		3,
		361311
	],
	"./blog/structured-data/dna-app-spotlight-what-genome-explorer": [
		690369,
		3,
		690369
	],
	"./blog/structured-data/dna-app-spotlight-what-genome-explorer.json": [
		690369,
		3,
		690369
	],
	"./blog/structured-data/dna-app-store": [
		494537,
		3,
		494537
	],
	"./blog/structured-data/dna-app-store.json": [
		494537,
		3,
		494537
	],
	"./blog/structured-data/dna-data-download-explained": [
		140778,
		3,
		140778
	],
	"./blog/structured-data/dna-data-download-explained.json": [
		140778,
		3,
		140778
	],
	"./blog/structured-data/dna-diets": [
		845606,
		3,
		845606
	],
	"./blog/structured-data/dna-diets.json": [
		845606,
		3,
		845606
	],
	"./blog/structured-data/dna-genetic-ancestry-haplogroups-app-spotlight": [
		946044,
		3,
		946044
	],
	"./blog/structured-data/dna-genetic-ancestry-haplogroups-app-spotlight.json": [
		946044,
		3,
		946044
	],
	"./blog/structured-data/dna-nutrition-testing-apps": [
		263634,
		3,
		263634
	],
	"./blog/structured-data/dna-nutrition-testing-apps.json": [
		263634,
		3,
		263634
	],
	"./blog/structured-data/dna-raw-data-analysis": [
		574276,
		3,
		574276
	],
	"./blog/structured-data/dna-raw-data-analysis.json": [
		574276,
		3,
		574276
	],
	"./blog/structured-data/dna-testing-fitness-nutrition-gene-analysis-apps": [
		16734,
		3,
		16734
	],
	"./blog/structured-data/dna-testing-fitness-nutrition-gene-analysis-apps.json": [
		16734,
		3,
		16734
	],
	"./blog/structured-data/does-genetic-testing-antidepressants-work": [
		321817,
		3,
		321817
	],
	"./blog/structured-data/does-genetic-testing-antidepressants-work.json": [
		321817,
		3,
		321817
	],
	"./blog/structured-data/father-day-dna-kit": [
		115884,
		3,
		115884
	],
	"./blog/structured-data/father-day-dna-kit.json": [
		115884,
		3,
		115884
	],
	"./blog/structured-data/five-ways-prevent-breast-cancer": [
		439545,
		3,
		439545
	],
	"./blog/structured-data/five-ways-prevent-breast-cancer.json": [
		439545,
		3,
		439545
	],
	"./blog/structured-data/free-dna-analysis-online-sequencing": [
		301527,
		3,
		301527
	],
	"./blog/structured-data/free-dna-analysis-online-sequencing.json": [
		301527,
		3,
		301527
	],
	"./blog/structured-data/gene-driven-plan-health": [
		410620,
		3,
		410620
	],
	"./blog/structured-data/gene-driven-plan-health.json": [
		410620,
		3,
		410620
	],
	"./blog/structured-data/genetic-api-alternative-23andme-api": [
		33696,
		3,
		33696
	],
	"./blog/structured-data/genetic-api-alternative-23andme-api.json": [
		33696,
		3,
		33696
	],
	"./blog/structured-data/genetic-genealogy-apps": [
		87465,
		3,
		87465
	],
	"./blog/structured-data/genetic-genealogy-apps.json": [
		87465,
		3,
		87465
	],
	"./blog/structured-data/genetic-test-identifies-best-antidepressant": [
		703489,
		3,
		703489
	],
	"./blog/structured-data/genetic-test-identifies-best-antidepressant.json": [
		703489,
		3,
		703489
	],
	"./blog/structured-data/genetic-testing-rare-diseases-sequencing": [
		622345,
		3,
		622345
	],
	"./blog/structured-data/genetic-testing-rare-diseases-sequencing.json": [
		622345,
		3,
		622345
	],
	"./blog/structured-data/genetics-and-dentistry": [
		64054,
		3,
		64054
	],
	"./blog/structured-data/genetics-and-dentistry.json": [
		64054,
		3,
		64054
	],
	"./blog/structured-data/get-free-dna-health-analysis-free-dna-reports": [
		168978,
		3,
		168978
	],
	"./blog/structured-data/get-free-dna-health-analysis-free-dna-reports.json": [
		168978,
		3,
		168978
	],
	"./blog/structured-data/golden-state-killer-dna-kit-privacy": [
		607296,
		3,
		607296
	],
	"./blog/structured-data/golden-state-killer-dna-kit-privacy.json": [
		607296,
		3,
		607296
	],
	"./blog/structured-data/happiness-genetic": [
		989950,
		3,
		989950
	],
	"./blog/structured-data/happiness-genetic.json": [
		989950,
		3,
		989950
	],
	"./blog/structured-data/hay-fever-genetic-guide-seasonal-allergies-and-your-dna": [
		757623,
		3,
		757623
	],
	"./blog/structured-data/hay-fever-genetic-guide-seasonal-allergies-and-your-dna.json": [
		757623,
		3,
		757623
	],
	"./blog/structured-data/how-accurate-walgreens-dna-test": [
		701030,
		3,
		701030
	],
	"./blog/structured-data/how-accurate-walgreens-dna-test.json": [
		701030,
		3,
		701030
	],
	"./blog/structured-data/how-avoid-genetic-testing-scams": [
		405843,
		3,
		405843
	],
	"./blog/structured-data/how-avoid-genetic-testing-scams.json": [
		405843,
		3,
		405843
	],
	"./blog/structured-data/how-delete-23andme-data-account-guide": [
		381881,
		3,
		381881
	],
	"./blog/structured-data/how-delete-23andme-data-account-guide.json": [
		381881,
		3,
		381881
	],
	"./blog/structured-data/how-dna-testing-can-improve-health-and-fitness": [
		116015,
		3,
		116015
	],
	"./blog/structured-data/how-dna-testing-can-improve-health-and-fitness.json": [
		116015,
		3,
		116015
	],
	"./blog/structured-data/how-do-you-know-if-you-have-roma-gypsy-ancestry": [
		866453,
		3,
		866453
	],
	"./blog/structured-data/how-do-you-know-if-you-have-roma-gypsy-ancestry.json": [
		866453,
		3,
		866453
	],
	"./blog/structured-data/how-find-online-genetic-counseling-service": [
		122014,
		3,
		122014
	],
	"./blog/structured-data/how-find-online-genetic-counseling-service.json": [
		122014,
		3,
		122014
	],
	"./blog/structured-data/how-genetics-impacted-bruce-willis-dementia-aphasia-diagnosis": [
		41710,
		3,
		41710
	],
	"./blog/structured-data/how-genetics-impacted-bruce-willis-dementia-aphasia-diagnosis.json": [
		41710,
		3,
		41710
	],
	"./blog/structured-data/how-get-online-dna-test-free": [
		598030,
		3,
		598030
	],
	"./blog/structured-data/how-get-online-dna-test-free.json": [
		598030,
		3,
		598030
	],
	"./blog/structured-data/how-long-does-dna-test-take": [
		852822,
		3,
		852822
	],
	"./blog/structured-data/how-long-does-dna-test-take.json": [
		852822,
		3,
		852822
	],
	"./blog/structured-data/how-soon-can-you-dna-test-a-baby-after-birth": [
		780965,
		3,
		780965
	],
	"./blog/structured-data/how-soon-can-you-dna-test-a-baby-after-birth.json": [
		780965,
		3,
		780965
	],
	"./blog/structured-data/how-to-download-23andme-raw-dna-data": [
		412892,
		3,
		412892
	],
	"./blog/structured-data/how-to-download-23andme-raw-dna-data.json": [
		412892,
		3,
		412892
	],
	"./blog/structured-data/how-to-upload-23andme-data-sequencing": [
		59450,
		3,
		59450
	],
	"./blog/structured-data/how-to-upload-23andme-data-sequencing.json": [
		59450,
		3,
		59450
	],
	"./blog/structured-data/how-to-upload-raw-dna-data-genome-data-sequencing.com": [
		598910,
		3,
		598910
	],
	"./blog/structured-data/how-to-upload-raw-dna-data-genome-data-sequencing.com.json": [
		598910,
		3,
		598910
	],
	"./blog/structured-data/how-to-use-genome-sequencing-data-files": [
		441848,
		3,
		441848
	],
	"./blog/structured-data/how-to-use-genome-sequencing-data-files.json": [
		441848,
		3,
		441848
	],
	"./blog/structured-data/how-upload-raw-ancestry-dna-data-sequencing": [
		753339,
		3,
		753339
	],
	"./blog/structured-data/how-upload-raw-ancestry-dna-data-sequencing.json": [
		753339,
		3,
		753339
	],
	"./blog/structured-data/is-a-there-genetic-test-breast-cancer": [
		954278,
		3,
		954278
	],
	"./blog/structured-data/is-a-there-genetic-test-breast-cancer.json": [
		954278,
		3,
		954278
	],
	"./blog/structured-data/jesus-dna": [
		447587,
		3,
		447587
	],
	"./blog/structured-data/jesus-dna.json": [
		447587,
		3,
		447587
	],
	"./blog/structured-data/making-life-plan-based-your-dna": [
		867193,
		3,
		867193
	],
	"./blog/structured-data/making-life-plan-based-your-dna.json": [
		867193,
		3,
		867193
	],
	"./blog/structured-data/myheritage-review-dna-testing-genealogy-and-health": [
		403370,
		3,
		403370
	],
	"./blog/structured-data/myheritage-review-dna-testing-genealogy-and-health.json": [
		403370,
		3,
		403370
	],
	"./blog/structured-data/national-news-sequencingcom-concierge-medicine-today-announce-partnership-help-physicians-bring": [
		571393,
		3,
		571393
	],
	"./blog/structured-data/national-news-sequencingcom-concierge-medicine-today-announce-partnership-help-physicians-bring.json": [
		571393,
		3,
		571393
	],
	"./blog/structured-data/new-fitness-nutrition-dna-tests-athletigen-nutrigenomics": [
		456393,
		3,
		456393
	],
	"./blog/structured-data/new-fitness-nutrition-dna-tests-athletigen-nutrigenomics.json": [
		456393,
		3,
		456393
	],
	"./blog/structured-data/personalized-dna-health-report-post-quarantine": [
		602522,
		3,
		602522
	],
	"./blog/structured-data/personalized-dna-health-report-post-quarantine.json": [
		602522,
		3,
		602522
	],
	"./blog/structured-data/prevention-magazine-recognizes-outsmart-your-genes-promote-power-dna": [
		220182,
		3,
		220182
	],
	"./blog/structured-data/prevention-magazine-recognizes-outsmart-your-genes-promote-power-dna.json": [
		220182,
		3,
		220182
	],
	"./blog/structured-data/quarantine-tech-products-to-try": [
		226121,
		3,
		226121
	],
	"./blog/structured-data/quarantine-tech-products-to-try.json": [
		226121,
		3,
		226121
	],
	"./blog/structured-data/research-reveals-most-people-do-not-want-donate-dna-science": [
		184565,
		3,
		184565
	],
	"./blog/structured-data/research-reveals-most-people-do-not-want-donate-dna-science.json": [
		184565,
		3,
		184565
	],
	"./blog/structured-data/sequencingcom-hopes-shepherd-growing-market-diy-genomics-tools": [
		889944,
		3,
		889944
	],
	"./blog/structured-data/sequencingcom-hopes-shepherd-growing-market-diy-genomics-tools.json": [
		889944,
		3,
		889944
	],
	"./blog/structured-data/sequencingcom-introduces-first-agnostic-platform-genetic-data": [
		155060,
		3,
		155060
	],
	"./blog/structured-data/sequencingcom-introduces-first-agnostic-platform-genetic-data.json": [
		155060,
		3,
		155060
	],
	"./blog/structured-data/sequencingcom-launches-free-genetic-analysis-assess-risk-and-severity-coronavirus-infection": [
		337740,
		3,
		337740
	],
	"./blog/structured-data/sequencingcom-launches-free-genetic-analysis-assess-risk-and-severity-coronavirus-infection.json": [
		337740,
		3,
		337740
	],
	"./blog/structured-data/sequencingcom-launches-worlds-first-app-store-dna": [
		734058,
		3,
		734058
	],
	"./blog/structured-data/sequencingcom-launches-worlds-first-app-store-dna.json": [
		734058,
		3,
		734058
	],
	"./blog/structured-data/support-for-use-whole-genome-sequencing-concierge-medicine": [
		985902,
		3,
		985902
	],
	"./blog/structured-data/support-for-use-whole-genome-sequencing-concierge-medicine.json": [
		985902,
		3,
		985902
	],
	"./blog/structured-data/these-are-todays-5-best-ancestry-and-genealogy-sites": [
		632098,
		3,
		632098
	],
	"./blog/structured-data/these-are-todays-5-best-ancestry-and-genealogy-sites.json": [
		632098,
		3,
		632098
	],
	"./blog/structured-data/using-dna-learn-what-is-your-heritage-ancestry-genealogy": [
		522832,
		3,
		522832
	],
	"./blog/structured-data/using-dna-learn-what-is-your-heritage-ancestry-genealogy.json": [
		522832,
		3,
		522832
	],
	"./blog/structured-data/using-raw-dna-data": [
		640025,
		3,
		640025
	],
	"./blog/structured-data/using-raw-dna-data.json": [
		640025,
		3,
		640025
	],
	"./blog/structured-data/weight-loss-through-dna-testing": [
		264397,
		3,
		264397
	],
	"./blog/structured-data/weight-loss-through-dna-testing.json": [
		264397,
		3,
		264397
	],
	"./blog/structured-data/what-1x-whole-genome-sequencing-1x-vs-30x-wgs-explained": [
		798264,
		3,
		798264
	],
	"./blog/structured-data/what-1x-whole-genome-sequencing-1x-vs-30x-wgs-explained.json": [
		798264,
		3,
		798264
	],
	"./blog/structured-data/what-30x-and-04x-whole-genome-sequencing": [
		585835,
		3,
		585835
	],
	"./blog/structured-data/what-30x-and-04x-whole-genome-sequencing.json": [
		585835,
		3,
		585835
	],
	"./blog/structured-data/what-ancestral-lineage-healing": [
		264183,
		3,
		264183
	],
	"./blog/structured-data/what-ancestral-lineage-healing.json": [
		264183,
		3,
		264183
	],
	"./blog/structured-data/what-cost-genetic-testing-breast-cancer": [
		424891,
		3,
		424891
	],
	"./blog/structured-data/what-cost-genetic-testing-breast-cancer.json": [
		424891,
		3,
		424891
	],
	"./blog/structured-data/what-do-when-medicines-have-side-effects": [
		541454,
		3,
		541454
	],
	"./blog/structured-data/what-do-when-medicines-have-side-effects.json": [
		541454,
		3,
		541454
	],
	"./blog/structured-data/what-does-dna-have-do-weight-loss": [
		501036,
		3,
		501036
	],
	"./blog/structured-data/what-does-dna-have-do-weight-loss.json": [
		501036,
		3,
		501036
	],
	"./blog/structured-data/what-is-genetic-counseling-for-dna-tests": [
		530432,
		3,
		530432
	],
	"./blog/structured-data/what-is-genetic-counseling-for-dna-tests.json": [
		530432,
		3,
		530432
	],
	"./blog/structured-data/what-is-rare-disease-day": [
		678375,
		3,
		678375
	],
	"./blog/structured-data/what-is-rare-disease-day.json": [
		678375,
		3,
		678375
	],
	"./blog/structured-data/what-is-whole-genome-sequencing-wgs": [
		330871,
		3,
		330871
	],
	"./blog/structured-data/what-is-whole-genome-sequencing-wgs.json": [
		330871,
		3,
		330871
	],
	"./blog/structured-data/what-single-cell-whole-genome-sequencing": [
		694701,
		3,
		694701
	],
	"./blog/structured-data/what-single-cell-whole-genome-sequencing.json": [
		694701,
		3,
		694701
	],
	"./blog/structured-data/whats-most-private-dna-test-market": [
		500550,
		3,
		500550
	],
	"./blog/structured-data/whats-most-private-dna-test-market.json": [
		500550,
		3,
		500550
	],
	"./blog/structured-data/where-can-get-dna-test": [
		934148,
		3,
		934148
	],
	"./blog/structured-data/where-can-get-dna-test.json": [
		934148,
		3,
		934148
	],
	"./blog/structured-data/where-can-i-get-a-dna-test-while-pregnant": [
		874880,
		3,
		874880
	],
	"./blog/structured-data/where-can-i-get-a-dna-test-while-pregnant.json": [
		874880,
		3,
		874880
	],
	"./blog/structured-data/why-am-i-not-losing-weight": [
		513262,
		3,
		513262
	],
	"./blog/structured-data/why-am-i-not-losing-weight.json": [
		513262,
		3,
		513262
	],
	"./blog/structured-data/why-blood-type-matters-covid-19-infection": [
		810105,
		3,
		810105
	],
	"./blog/structured-data/why-blood-type-matters-covid-19-infection.json": [
		810105,
		3,
		810105
	],
	"./education-center/images/sites/default/files/book_pages/11q-partial-monosomy-syndrome.jpg": [
		755811,
		9,
		755811
	],
	"./education-center/images/sites/default/files/book_pages/3-m-syndrome.jpg": [
		439385,
		9,
		439385
	],
	"./education-center/images/sites/default/files/book_pages/3-oxo-5-alpha-steroid-delta-4-dehydrogenase-deficiency.jpg": [
		935596,
		9,
		935596
	],
	"./education-center/images/sites/default/files/book_pages/46xy-disorder-sex-development-due-testicular-1720-desmolase-deficiency.jpg": [
		15744,
		9,
		15744
	],
	"./education-center/images/sites/default/files/book_pages/46xy-dsd46xy-cgd.jpg": [
		127928,
		9,
		127928
	],
	"./education-center/images/sites/default/files/book_pages/46xy-sex-reversal-4.jpg": [
		574386,
		9,
		574386
	],
	"./education-center/images/sites/default/files/book_pages/abacavir-hypersensitivity.jpg": [
		722900,
		9,
		722900
	],
	"./education-center/images/sites/default/files/book_pages/abca1-polymorphism.jpg": [
		671874,
		9,
		671874
	],
	"./education-center/images/sites/default/files/book_pages/abca1-related-disorders.jpg": [
		584960,
		9,
		584960
	],
	"./education-center/images/sites/default/files/book_pages/abca4-related-disorders.jpg": [
		126285,
		9,
		126285
	],
	"./education-center/images/sites/default/files/book_pages/abcb4-related-intrahepatic-cholestasis.jpg": [
		108055,
		9,
		108055
	],
	"./education-center/images/sites/default/files/book_pages/abcd-syndrome.jpg": [
		903774,
		9,
		903774
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-activity-mitochondrial-respiratory-chain.jpg": [
		54058,
		9,
		54058
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-anterior-chamber-morphology.jpg": [
		665772,
		9,
		665772
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-anterior-eye-segment-morphology.jpg": [
		628018,
		9,
		628018
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-aortic-valve-morphology.jpg": [
		671077,
		9,
		671077
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-aortic-valve-physiology.jpg": [
		556349,
		9,
		556349
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-bleeding.jpg": [
		719276,
		9,
		719276
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-blistering-skin.jpg": [
		256212,
		9,
		256212
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-bone-structure.jpg": [
		896050,
		9,
		896050
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-cardiac-atrium-morphology.jpg": [
		297625,
		9,
		297625
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-cartilage-collagen.jpg": [
		185495,
		9,
		185495
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-central-motor-function.jpg": [
		643148,
		9,
		643148
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-cerebellar-vermis-morphology.jpg": [
		744092,
		9,
		744092
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-cerebral-morphology.jpg": [
		905850,
		9,
		905850
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-circulating-carbohydrate-concentration.jpg": [
		276959,
		9,
		276959
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-circulating-glucose-6-phosphate-dehydrogenase-concentration.jpg": [
		11081,
		9,
		11081
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-circulating-lipid-concentration.jpg": [
		737249,
		9,
		29009
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-circulating-porphyrin-concentration.jpg": [
		45864,
		9,
		45864
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-circulating-thyroid-hormone-concentration.jpg": [
		917641,
		9,
		917641
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-corpus-callosum-morphology.jpg": [
		192536,
		9,
		192536
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-cortical-gyration.jpg": [
		316095,
		9,
		316095
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-facial-shape.jpg": [
		968325,
		9,
		968325
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-finger-morphology.jpg": [
		408376,
		9,
		408376
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-hemoglobin.jpg": [
		548363,
		9,
		548363
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-immunoglobulin-level.jpg": [
		13647,
		9,
		13647
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-intrahepatic-bile-duct-morphology.jpg": [
		389796,
		9,
		389796
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-lactate-dehydrogenase-level.jpg": [
		996654,
		9,
		996654
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-mitral-valve-physiology.jpg": [
		785211,
		9,
		785211
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-platelet-aggregation.jpg": [
		785138,
		9,
		785138
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-platelet-function.jpg": [
		305108,
		9,
		305108
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-protein-o-linked-glycosylation.jpg": [
		115393,
		9,
		115393
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-pyramidal-sign.jpg": [
		609184,
		9,
		609184
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-radial-ray-morphology.jpg": [
		24866,
		9,
		24866
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-sperm-tail-morphology.jpg": [
		74525,
		9,
		74525
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-spermatogenesis.jpg": [
		892961,
		9,
		892961
	],
	"./education-center/images/sites/default/files/book_pages/abnormal-synaptic-transmission.jpg": [
		611391,
		9,
		611391
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-blood-and-blood-forming-tissues.jpg": [
		948343,
		9,
		948343
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-bone-mineral-density.jpg": [
		61987,
		9,
		61987
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-brain-morphology.jpg": [
		195056,
		9,
		195056
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-cardiovascular-system-morphology.jpg": [
		957024,
		9,
		957024
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-cardiovascular-system.jpg": [
		965434,
		9,
		965434
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-coagulation.jpg": [
		387533,
		9,
		387533
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-connective-tissue.jpg": [
		548336,
		9,
		548336
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-dentition.jpg": [
		135737,
		9,
		135737
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-female-genitalia.jpg": [
		377377,
		9,
		377377
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-immune-system-physiology.jpg": [
		959869,
		9,
		959869
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-immune-system.jpg": [
		628855,
		9,
		628855
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-iron-homeostasis.jpg": [
		798505,
		9,
		798505
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-lysosomal-metabolism.jpg": [
		259157,
		9,
		259157
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-metabolismhomeostasis.jpg": [
		8738,
		9,
		8738
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-mitochondrion.jpg": [
		889277,
		9,
		889277
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-mucopolysaccharide-metabolism.jpg": [
		285265,
		9,
		285265
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-musculature.jpg": [
		407908,
		9,
		407908
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-neuronal-migration.jpg": [
		509086,
		9,
		509086
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-ovary.jpg": [
		601262,
		9,
		601262
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-pancreas.jpg": [
		583748,
		9,
		583748
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-prenatal-development-or-birth.jpg": [
		197894,
		9,
		197894
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-pulmonary-vasculature.jpg": [
		174274,
		9,
		174274
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-refraction.jpg": [
		427610,
		9,
		427610
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-skeletal-system.jpg": [
		988433,
		9,
		988433
	],
	"./education-center/images/sites/default/files/book_pages/abnormality-urinary-system.jpg": [
		915515,
		9,
		915515
	],
	"./education-center/images/sites/default/files/book_pages/abo-blood-group-system.jpg": [
		625997,
		9,
		625997
	],
	"./education-center/images/sites/default/files/book_pages/aborted-sudden-cardiac-death.jpg": [
		295935,
		9,
		295935
	],
	"./education-center/images/sites/default/files/book_pages/absent-radius.jpg": [
		45424,
		9,
		45424
	],
	"./education-center/images/sites/default/files/book_pages/acampomelic-campomelic-dysplasia.jpg": [
		678990,
		9,
		678990
	],
	"./education-center/images/sites/default/files/book_pages/acanthocytosis-due-band-3-ht.jpg": [
		396310,
		9,
		396310
	],
	"./education-center/images/sites/default/files/book_pages/acanthocytosis.jpg": [
		203021,
		9,
		203021
	],
	"./education-center/images/sites/default/files/book_pages/acanthosis-nigricans.jpg": [
		384664,
		9,
		384664
	],
	"./education-center/images/sites/default/files/book_pages/acatalasemia-japanese-type_0.jpg": [
		712713,
		9,
		712713
	],
	"./education-center/images/sites/default/files/book_pages/accelerated-tumor-formation-susceptibility.jpg": [
		379893,
		9,
		379893
	],
	"./education-center/images/sites/default/files/book_pages/accessory-ectopic-thyroid-tissue.jpg": [
		843393,
		9,
		843393
	],
	"./education-center/images/sites/default/files/book_pages/acenocoumarol-response-dosage.jpg": [
		323227,
		9,
		323227
	],
	"./education-center/images/sites/default/files/book_pages/achondrogenesis-type-ii.jpg": [
		76234,
		9,
		76234
	],
	"./education-center/images/sites/default/files/book_pages/achondroplasia.jpg": [
		731645,
		9,
		731645
	],
	"./education-center/images/sites/default/files/book_pages/acid-alpha-glucosidase-allele-2.jpg": [
		586931,
		9,
		586931
	],
	"./education-center/images/sites/default/files/book_pages/acne-inversa-familial-1.jpg": [
		85315,
		9,
		85315
	],
	"./education-center/images/sites/default/files/book_pages/acquired-immunodeficiency-syndrome-delayed-progression.jpg": [
		660770,
		9,
		660770
	],
	"./education-center/images/sites/default/files/book_pages/acquired-immunodeficiency-syndrome-rapid-progression.jpg": [
		83962,
		9,
		83962
	],
	"./education-center/images/sites/default/files/book_pages/acquired-immunodeficiency-syndrome-slow-progression.jpg": [
		558295,
		9,
		558295
	],
	"./education-center/images/sites/default/files/book_pages/acquired-susceptibility-long-qt-syndrome-1.jpg": [
		385910,
		9,
		385910
	],
	"./education-center/images/sites/default/files/book_pages/acrocephalosyndactyly-type-i.jpg": [
		407045,
		9,
		407045
	],
	"./education-center/images/sites/default/files/book_pages/acrodysostosis-1-or-without-hormone-resistance.jpg": [
		537773,
		9,
		537773
	],
	"./education-center/images/sites/default/files/book_pages/acrokeratosis-verruciformis-hopf.jpg": [
		811945,
		9,
		811945
	],
	"./education-center/images/sites/default/files/book_pages/acromicric-dysplasia.jpg": [
		990336,
		9,
		990336
	],
	"./education-center/images/sites/default/files/book_pages/actn3-deficiency.jpg": [
		729982,
		9,
		729982
	],
	"./education-center/images/sites/default/files/book_pages/aculeiform-cataract.jpg": [
		576338,
		9,
		576338
	],
	"./education-center/images/sites/default/files/book_pages/acute-coronary-syndrome.jpg": [
		307765,
		9,
		307765
	],
	"./education-center/images/sites/default/files/book_pages/acute-recurrent-myoglobinuria.jpg": [
		683800,
		9,
		683800
	],
	"./education-center/images/sites/default/files/book_pages/acute-respiratory-failure.jpg": [
		446075,
		9,
		446075
	],
	"./education-center/images/sites/default/files/book_pages/adams-oliver-syndrome.jpg": [
		7182,
		9,
		7182
	],
	"./education-center/images/sites/default/files/book_pages/adan-amyloidosis.jpg": [
		382046,
		9,
		382046
	],
	"./education-center/images/sites/default/files/book_pages/adenocarcinoma-lung-response-tyrosine-kinase-inhibitor-somatic.jpg": [
		544075,
		9,
		544075
	],
	"./education-center/images/sites/default/files/book_pages/adenoma-cortisol-producing.jpg": [
		432197,
		9,
		432197
	],
	"./education-center/images/sites/default/files/book_pages/adenomatous-colonic-polyposis.jpg": [
		568844,
		9,
		568844
	],
	"./education-center/images/sites/default/files/book_pages/adenomatous-polyposis-coli-attenuated.jpg": [
		830182,
		9,
		830182
	],
	"./education-center/images/sites/default/files/book_pages/adenomatous-polyposis-coli-congenital-cholesteatoma.jpg": [
		24596,
		9,
		24596
	],
	"./education-center/images/sites/default/files/book_pages/adenylosuccinate-lyase-deficiency.jpg": [
		488970,
		9,
		488970
	],
	"./education-center/images/sites/default/files/book_pages/adermatoglyphia.jpg": [
		165509,
		9,
		165509
	],
	"./education-center/images/sites/default/files/book_pages/adolescent-alopeciam-dentogingival-abnormalitites-and-intellectual-disability.jpg": [
		14267,
		9,
		14267
	],
	"./education-center/images/sites/default/files/book_pages/adrenal-cortex-carcinoma.jpg": [
		310953,
		9,
		310953
	],
	"./education-center/images/sites/default/files/book_pages/adrenal-hyperplasia.jpg": [
		785957,
		9,
		785957
	],
	"./education-center/images/sites/default/files/book_pages/adrenal-insufficiency-nr5a1-related.jpg": [
		497965,
		9,
		497965
	],
	"./education-center/images/sites/default/files/book_pages/adrenal-insufficiency.jpg": [
		247954,
		9,
		247954
	],
	"./education-center/images/sites/default/files/book_pages/adrenocortical-carcinoma-pediatric.jpg": [
		739141,
		9,
		739141
	],
	"./education-center/images/sites/default/files/book_pages/adrenocortical-tumor-somatic.jpg": [
		546906,
		9,
		546906
	],
	"./education-center/images/sites/default/files/book_pages/adult-hypophosphatasia.jpg": [
		747597,
		9,
		747597
	],
	"./education-center/images/sites/default/files/book_pages/adult-i-blood-group-or-without-congenital-cataract.jpg": [
		748980,
		9,
		748980
	],
	"./education-center/images/sites/default/files/book_pages/adult-i-blood-group-phenotype.jpg": [
		686676,
		9,
		686676
	],
	"./education-center/images/sites/default/files/book_pages/adult-polyglucosan-body-neuropathy.jpg": [
		469250,
		9,
		469250
	],
	"./education-center/images/sites/default/files/book_pages/adult-syndrome.jpg": [
		302363,
		9,
		302363
	],
	"./education-center/images/sites/default/files/book_pages/aerodigestive-tract-cancer-squamous-cell-alcohol-related-protection-against.jpg": [
		652648,
		9,
		652648
	],
	"./education-center/images/sites/default/files/book_pages/afibrinogenemia.jpg": [
		936071,
		9,
		936071
	],
	"./education-center/images/sites/default/files/book_pages/age-related-macular-degeneration-2.jpg": [
		28605,
		9,
		28605
	],
	"./education-center/images/sites/default/files/book_pages/agenesis-corpus-callosum-peripheral-neuropathy.jpg": [
		793858,
		9,
		793858
	],
	"./education-center/images/sites/default/files/book_pages/agk-related-disorders.jpg": [
		448231,
		9,
		448231
	],
	"./education-center/images/sites/default/files/book_pages/aicardi-goutieres-syndrome-1-autosomal-dominant.jpg": [
		783679,
		9,
		783679
	],
	"./education-center/images/sites/default/files/book_pages/aipl1-related-disorders.jpg": [
		275242,
		9,
		275242
	],
	"./education-center/images/sites/default/files/book_pages/alagille-syndrome-atp8b1-related.jpg": [
		562402,
		9,
		562402
	],
	"./education-center/images/sites/default/files/book_pages/alcohol-dependence.jpg": [
		509095,
		9,
		509095
	],
	"./education-center/images/sites/default/files/book_pages/aldosterone-producing-adrenal-adenoma-somatic.jpg": [
		140167,
		9,
		140167
	],
	"./education-center/images/sites/default/files/book_pages/aldosterone-renin-ratio-increased.jpg": [
		687941,
		9,
		687941
	],
	"./education-center/images/sites/default/files/book_pages/alloalbuminemia.jpg": [
		73285,
		9,
		73285
	],
	"./education-center/images/sites/default/files/book_pages/alopecia-androgenetic-1.jpg": [
		422423,
		9,
		422423
	],
	"./education-center/images/sites/default/files/book_pages/alpha-fetoprotein-deficiency.jpg": [
		188461,
		9,
		188461
	],
	"./education-center/images/sites/default/files/book_pages/alpha-fetoprotein-hereditary-persistence.jpg": [
		875707,
		9,
		875707
	],
	"./education-center/images/sites/default/files/book_pages/alpha-thalassemia-2-nondeletional.jpg": [
		262201,
		9,
		262201
	],
	"./education-center/images/sites/default/files/book_pages/alpha-thalassemia-dutch-type.jpg": [
		285813,
		9,
		285813
	],
	"./education-center/images/sites/default/files/book_pages/alpha-thalassemia-hmong-type.jpg": [
		770795,
		9,
		770795
	],
	"./education-center/images/sites/default/files/book_pages/alpha-thalassemiaintellectual-disability-syndrome.jpg": [
		82547,
		9,
		82547
	],
	"./education-center/images/sites/default/files/book_pages/alpha-trait-thalassemia.jpg": [
		888056,
		9,
		888056
	],
	"./education-center/images/sites/default/files/book_pages/als2-related-disorders.jpg": [
		784037,
		9,
		784037
	],
	"./education-center/images/sites/default/files/book_pages/altered-myosin-contractile-function.jpg": [
		866976,
		9,
		866976
	],
	"./education-center/images/sites/default/files/book_pages/altered-potassium-channel-function.jpg": [
		133811,
		9,
		133811
	],
	"./education-center/images/sites/default/files/book_pages/alternating-hemiplegia-childhood-1.jpg": [
		821529,
		9,
		821529
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-2.jpg": [
		604675,
		9,
		604675
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-3.jpg": [
		376248,
		9,
		376248
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-familial-3-spastic-paraparesis-and-apraxia.jpg": [
		116264,
		9,
		116264
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-familial-3-spastic-paraparesis-and-unusual-plaques.jpg": [
		297692,
		9,
		297692
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-familial-3-spastic-paraparesis.jpg": [
		80507,
		9,
		80507
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-familial-3-unusual-plaques.jpg": [
		871685,
		9,
		871685
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-familial-spastic-paraparesis-and-unusual-plaques.jpg": [
		790671,
		9,
		790671
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-late-onset-susceptibility.jpg": [
		750172,
		9,
		750172
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-protection-against.jpg": [
		707033,
		9,
		707033
	],
	"./education-center/images/sites/default/files/book_pages/alzheimer-disease-type-1.jpg": [
		137574,
		9,
		137574
	],
	"./education-center/images/sites/default/files/book_pages/ambiguous-genitalia.jpg": [
		227269,
		9,
		227269
	],
	"./education-center/images/sites/default/files/book_pages/amelogenesis-imperfecta-dominant.jpg": [
		800913,
		9,
		800913
	],
	"./education-center/images/sites/default/files/book_pages/amelogenesis-imperfecta-hypocalcification-type.jpg": [
		253966,
		9,
		253966
	],
	"./education-center/images/sites/default/files/book_pages/amelogenesis-imperfecta-hypoplastic-autosomal-dominant-local.jpg": [
		65715,
		9,
		65715
	],
	"./education-center/images/sites/default/files/book_pages/amelogenesis-imperfecta-recessive.jpg": [
		72519,
		9,
		72519
	],
	"./education-center/images/sites/default/files/book_pages/amelogenesis-imperfecta-type-1a.jpg": [
		888821,
		9,
		888821
	],
	"./education-center/images/sites/default/files/book_pages/amyloid-cardiomyopathy-transthyretin-related.jpg": [
		494509,
		9,
		494509
	],
	"./education-center/images/sites/default/files/book_pages/amyloidogenic-transthyretin-amyloidosis.jpg": [
		898223,
		9,
		898223
	],
	"./education-center/images/sites/default/files/book_pages/amyloidosis-cardiac-and-cutaneous.jpg": [
		26902,
		9,
		26902
	],
	"./education-center/images/sites/default/files/book_pages/amyloidosis-leptomeningeal-transthyretin-related.jpg": [
		200677,
		9,
		200677
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-1-autosomal-recessive.jpg": [
		320381,
		9,
		320381
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-22-frontotemporal-dementia.jpg": [
		603619,
		9,
		603619
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-6-autosomal-recessive.jpg": [
		161860,
		9,
		161860
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-dominant.jpg": [
		173048,
		9,
		173048
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-parkinsonism-dementia-complex.jpg": [
		670907,
		9,
		670907
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-recessive.jpg": [
		411387,
		9,
		411387
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-susceptibility.jpg": [
		205257,
		9,
		205257
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-type-1.jpg": [
		772622,
		9,
		772622
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosis-type-4.jpg": [
		768388,
		9,
		768388
	],
	"./education-center/images/sites/default/files/book_pages/amyotrophic-lateral-sclerosisfrontotemporal-dementia.jpg": [
		921484,
		9,
		921484
	],
	"./education-center/images/sites/default/files/book_pages/anadysplasia-spontaneously-remitting-spondylometaphyseal-dysplasia.jpg": [
		844864,
		9,
		844864
	],
	"./education-center/images/sites/default/files/book_pages/analbuminemia-baghdad.jpg": [
		108709,
		9,
		108709
	],
	"./education-center/images/sites/default/files/book_pages/analbuminemia.jpg": [
		958476,
		9,
		958476
	],
	"./education-center/images/sites/default/files/book_pages/anemia-hereditary-sideroblastic-1-pyridoxine-refractory.jpg": [
		369990,
		9,
		369990
	],
	"./education-center/images/sites/default/files/book_pages/anemia-perinatal-hemolytic-fatal-or-near-fatal.jpg": [
		232305,
		9,
		232305
	],
	"./education-center/images/sites/default/files/book_pages/anemia.jpg": [
		129054,
		9,
		129054
	],
	"./education-center/images/sites/default/files/book_pages/anencephaly.jpg": [
		140932,
		9,
		140932
	],
	"./education-center/images/sites/default/files/book_pages/angelman-syndrome.jpg": [
		758229,
		9,
		758229
	],
	"./education-center/images/sites/default/files/book_pages/angelman-syndrome_0.jpg": [
		434725,
		9,
		434725
	],
	"./education-center/images/sites/default/files/book_pages/angiofibroma-somatic.jpg": [
		851674,
		9,
		851674
	],
	"./education-center/images/sites/default/files/book_pages/angioma-serpiginosum-autosomal-dominant.jpg": [
		328961,
		9,
		328961
	],
	"./education-center/images/sites/default/files/book_pages/angioosteohypertrophic-syndrome.jpg": [
		966840,
		9,
		966840
	],
	"./education-center/images/sites/default/files/book_pages/angiotensin-i-converting-enzyme-benign-serum-increase.jpg": [
		596474,
		9,
		596474
	],
	"./education-center/images/sites/default/files/book_pages/anhydramnios.jpg": [
		90619,
		9,
		90619
	],
	"./education-center/images/sites/default/files/book_pages/aniridia-atypical.jpg": [
		375365,
		9,
		375365
	],
	"./education-center/images/sites/default/files/book_pages/aniridia-cerebellar-ataxia-and-intellectual-disability.jpg": [
		947393,
		9,
		947393
	],
	"./education-center/images/sites/default/files/book_pages/ankrd1-related-dilated-cardiomyopathy.jpg": [
		793242,
		9,
		793242
	],
	"./education-center/images/sites/default/files/book_pages/ankyloblepharon-ectodermal-defects-cleft-lippalate-syndrome.jpg": [
		421908,
		9,
		421908
	],
	"./education-center/images/sites/default/files/book_pages/ano5-related-disorders.jpg": [
		790371,
		9,
		790371
	],
	"./education-center/images/sites/default/files/book_pages/ano5-related-muscle-diseases.jpg": [
		183844,
		9,
		183844
	],
	"./education-center/images/sites/default/files/book_pages/anonychia.jpg": [
		789792,
		9,
		789792
	],
	"./education-center/images/sites/default/files/book_pages/anophthalmia.jpg": [
		568879,
		9,
		568879
	],
	"./education-center/images/sites/default/files/book_pages/anosmia.jpg": [
		695863,
		9,
		695863
	],
	"./education-center/images/sites/default/files/book_pages/anterior-segment-anomalies-and-cataract.jpg": [
		301641,
		9,
		301641
	],
	"./education-center/images/sites/default/files/book_pages/anterior-segment-dysgenesis-1-multiple-subtypes.jpg": [
		643602,
		9,
		643602
	],
	"./education-center/images/sites/default/files/book_pages/anterior-segment-dysgenesis-1.jpg": [
		842941,
		9,
		842941
	],
	"./education-center/images/sites/default/files/book_pages/anterior-segment-dysgenesis-4.jpg": [
		202486,
		9,
		202486
	],
	"./education-center/images/sites/default/files/book_pages/anterior-segment-dysgenesis-5-multiple-subtypes.jpg": [
		822852,
		9,
		822852
	],
	"./education-center/images/sites/default/files/book_pages/anti-sema4d-monoclonal-antibody-vx152503.jpg": [
		724411,
		9,
		724411
	],
	"./education-center/images/sites/default/files/book_pages/antidepressant-drug-treatment-accelerated-response.jpg": [
		867779,
		9,
		867779
	],
	"./education-center/images/sites/default/files/book_pages/antigen-scianna-blood-group-system.jpg": [
		157813,
		9,
		157813
	],
	"./education-center/images/sites/default/files/book_pages/aortic-aneurysm-familial-thoracic-4.jpg": [
		579283,
		9,
		579283
	],
	"./education-center/images/sites/default/files/book_pages/aortic-aneurysm-familial-thoracic-tgfb2-related.jpg": [
		213210,
		9,
		213210
	],
	"./education-center/images/sites/default/files/book_pages/aortic-dilatation.jpg": [
		789579,
		9,
		789579
	],
	"./education-center/images/sites/default/files/book_pages/aortic-dissection.jpg": [
		502675,
		9,
		502675
	],
	"./education-center/images/sites/default/files/book_pages/aortic-root-aneurysm.jpg": [
		582692,
		9,
		582692
	],
	"./education-center/images/sites/default/files/book_pages/aortic-valve-disease-2.jpg": [
		613498,
		9,
		613498
	],
	"./education-center/images/sites/default/files/book_pages/apc-associated-polyposis-disorders.jpg": [
		147211,
		9,
		147211
	],
	"./education-center/images/sites/default/files/book_pages/apc-mutation-negative-familial-colorectal-cancer.jpg": [
		415595,
		9,
		415595
	],
	"./education-center/images/sites/default/files/book_pages/aplasia-cutis-congenita.jpg": [
		240702,
		9,
		240702
	],
	"./education-center/images/sites/default/files/book_pages/apocrine-gland-secretion-variation.jpg": [
		302738,
		9,
		302738
	],
	"./education-center/images/sites/default/files/book_pages/apoe5-variant.jpg": [
		139387,
		9,
		139387
	],
	"./education-center/images/sites/default/files/book_pages/apolipoprotein-ii-deficiency.jpg": [
		12662,
		9,
		12662
	],
	"./education-center/images/sites/default/files/book_pages/apparent-mineralocorticoid-excess-mild.jpg": [
		873813,
		9,
		873813
	],
	"./education-center/images/sites/default/files/book_pages/appendicitis.jpg": [
		84297,
		9,
		84297
	],
	"./education-center/images/sites/default/files/book_pages/appendicular-lean-mass-relative-body-height.jpg": [
		183381,
		9,
		183381
	],
	"./education-center/images/sites/default/files/book_pages/aprt-deficiency-japanese-type.jpg": [
		536081,
		9,
		536081
	],
	"./education-center/images/sites/default/files/book_pages/armc9-related-joubert-syndrome.jpg": [
		882374,
		9,
		882374
	],
	"./education-center/images/sites/default/files/book_pages/aromatase-excess-syndrome.jpg": [
		350964,
		9,
		350964
	],
	"./education-center/images/sites/default/files/book_pages/arrhythmogenic-cardiomyopathy.jpg": [
		452659,
		9,
		452659
	],
	"./education-center/images/sites/default/files/book_pages/arrhythmogenic-right-ventricular-dysplasia-1.jpg": [
		556483,
		9,
		556483
	],
	"./education-center/images/sites/default/files/book_pages/arrhythmogenic-right-ventricular-dysplasia-13.jpg": [
		678181,
		9,
		678181
	],
	"./education-center/images/sites/default/files/book_pages/arrhythmogenic-right-ventricular-dysplasia-familial-11-mild-palmoplantar-keratoderma-and-woolly-hair.jpg": [
		521231,
		9,
		521231
	],
	"./education-center/images/sites/default/files/book_pages/arterial-dissection.jpg": [
		559891,
		9,
		559891
	],
	"./education-center/images/sites/default/files/book_pages/arterial-tortuosity.jpg": [
		994629,
		9,
		994629
	],
	"./education-center/images/sites/default/files/book_pages/arteriohepatic-dysplasia.jpg": [
		830776,
		9,
		830776
	],
	"./education-center/images/sites/default/files/book_pages/arteriovenous-malformation.jpg": [
		736017,
		9,
		736017
	],
	"./education-center/images/sites/default/files/book_pages/arthrogryposis-distal-type-1a.jpg": [
		912202,
		9,
		912202
	],
	"./education-center/images/sites/default/files/book_pages/arthrogryposis-oculomotor-limitation-electroretinal-anomalies-syndrome.jpg": [
		110862,
		9,
		110862
	],
	"./education-center/images/sites/default/files/book_pages/arthyrgryposis-distal-type-2b.jpg": [
		290121,
		9,
		290121
	],
	"./education-center/images/sites/default/files/book_pages/arv1-related-condition.jpg": [
		278266,
		9,
		278266
	],
	"./education-center/images/sites/default/files/book_pages/arylsulfatase-pseudodeficiency-intermediate.jpg": [
		908921,
		9,
		908921
	],
	"./education-center/images/sites/default/files/book_pages/arylsulfatase-pseudodeficiency-severe.jpg": [
		550605,
		9,
		550605
	],
	"./education-center/images/sites/default/files/book_pages/arylsulfatase-pseudodeficiency.jpg": [
		666244,
		9,
		666244
	],
	"./education-center/images/sites/default/files/book_pages/ascending-aortic-dissection.jpg": [
		152901,
		9,
		152901
	],
	"./education-center/images/sites/default/files/book_pages/asher.jpg": [
		574156,
		9,
		574156
	],
	"./education-center/images/sites/default/files/book_pages/aspartate-aminotransferase-serum-level-quantitative-trait-locus-1.jpg": [
		381148,
		9,
		381148
	],
	"./education-center/images/sites/default/files/book_pages/aspartylglucosaminuria-finnish-type.jpg": [
		399746,
		9,
		399746
	],
	"./education-center/images/sites/default/files/book_pages/asplenia.jpg": [
		429921,
		9,
		429921
	],
	"./education-center/images/sites/default/files/book_pages/association-systemic-lupus-erythematosus.jpg": [
		3347,
		9,
		3347
	],
	"./education-center/images/sites/default/files/book_pages/asthma-and-nasal-polyps.jpg": [
		893952,
		9,
		893952
	],
	"./education-center/images/sites/default/files/book_pages/asthma-protection-against.jpg": [
		673460,
		9,
		673460
	],
	"./education-center/images/sites/default/files/book_pages/astrocytoma-low-grade-somatic.jpg": [
		728023,
		9,
		728023
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-and-retinitis-pigmentosa-isolated-vitamin-e-deficiency.jpg": [
		220931,
		9,
		220931
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-friedreich-isolated-vitamin-e-deficiency.jpg": [
		187253,
		9,
		187253
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-neuropathy-spectrum-disorders.jpg": [
		386865,
		9,
		386865
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-pancytopenia-syndrome.jpg": [
		317158,
		9,
		317158
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-progressive-seizures-mental-deterioration-and-hearing-loss.jpg": [
		633974,
		9,
		633974
	],
	"./education-center/images/sites/default/files/book_pages/ataxia-telangiectasia-without-immunodeficiency.jpg": [
		72086,
		9,
		72086
	],
	"./education-center/images/sites/default/files/book_pages/atelis-syndrome-1.jpg": [
		804625,
		9,
		804625
	],
	"./education-center/images/sites/default/files/book_pages/atelis-syndrome-2.jpg": [
		143747,
		9,
		143747
	],
	"./education-center/images/sites/default/files/book_pages/atelosteogenesis-type-i.jpg": [
		310047,
		9,
		310047
	],
	"./education-center/images/sites/default/files/book_pages/atelosteogenesis-type-iii.jpg": [
		403161,
		9,
		403161
	],
	"./education-center/images/sites/default/files/book_pages/atelosteogenesis.jpg": [
		516998,
		9,
		516998
	],
	"./education-center/images/sites/default/files/book_pages/atherosclerosis-susceptibility.jpg": [
		151121,
		9,
		151121
	],
	"./education-center/images/sites/default/files/book_pages/atopy-resistance.jpg": [
		540732,
		9,
		540732
	],
	"./education-center/images/sites/default/files/book_pages/atopy-susceptibility.jpg": [
		16126,
		9,
		16126
	],
	"./education-center/images/sites/default/files/book_pages/atorvastatin-response-efficacy.jpg": [
		987852,
		9,
		987852
	],
	"./education-center/images/sites/default/files/book_pages/atorvastatin-response.jpg": [
		661173,
		9,
		661173
	],
	"./education-center/images/sites/default/files/book_pages/atrial-fibrillation-somatic.jpg": [
		702026,
		9,
		702026
	],
	"./education-center/images/sites/default/files/book_pages/atrial-septal-defect-1.jpg": [
		712743,
		9,
		712743
	],
	"./education-center/images/sites/default/files/book_pages/atrial-septal-defect-7.jpg": [
		177699,
		9,
		177699
	],
	"./education-center/images/sites/default/files/book_pages/atrial-septal-defect.jpg": [
		606005,
		9,
		606005
	],
	"./education-center/images/sites/default/files/book_pages/atrial-standstill-1-digenic.jpg": [
		323833,
		9,
		323833
	],
	"./education-center/images/sites/default/files/book_pages/atrioventricular-septal-defect-partial-heterotaxy-syndrome.jpg": [
		596214,
		9,
		596214
	],
	"./education-center/images/sites/default/files/book_pages/atrioventricular-septal-defect-somatic.jpg": [
		183807,
		9,
		183807
	],
	"./education-center/images/sites/default/files/book_pages/attention-deficit-hyperactivity-disorder.jpg": [
		922616,
		9,
		922616
	],
	"./education-center/images/sites/default/files/book_pages/atypical-behavior.jpg": [
		670526,
		9,
		670526
	],
	"./education-center/images/sites/default/files/book_pages/atypical-cerebral-palsy.jpg": [
		965923,
		9,
		965923
	],
	"./education-center/images/sites/default/files/book_pages/atypical-gaucher-disease.jpg": [
		395306,
		9,
		395306
	],
	"./education-center/images/sites/default/files/book_pages/auditory-neuropathy-autosomal-recessive-1.jpg": [
		70273,
		9,
		70273
	],
	"./education-center/images/sites/default/files/book_pages/auditory-neuropathy-spectrum-disorder.jpg": [
		836383,
		9,
		836383
	],
	"./education-center/images/sites/default/files/book_pages/auriculocondylar-syndrome.jpg": [
		89338,
		9,
		89338
	],
	"./education-center/images/sites/default/files/book_pages/autistic-behavior.jpg": [
		235007,
		9,
		235007
	],
	"./education-center/images/sites/default/files/book_pages/autistic-spectrum-disorder-isolated-skills.jpg": [
		242212,
		9,
		242212
	],
	"./education-center/images/sites/default/files/book_pages/autoimmune-lymphoproliferative-syndrome-type-1a.jpg": [
		8131,
		9,
		8131
	],
	"./education-center/images/sites/default/files/book_pages/autoimmune-lymphoproliferative-syndrome-type-1b.jpg": [
		610135,
		9,
		610135
	],
	"./education-center/images/sites/default/files/book_pages/autoimmune-polyglandular-syndrome-type-1-autosomal-dominant.jpg": [
		124562,
		9,
		124562
	],
	"./education-center/images/sites/default/files/book_pages/autoimmune-polyglandular-syndrome-type-1-reversible-metaphyseal-dysplasia.jpg": [
		633509,
		9,
		633509
	],
	"./education-center/images/sites/default/files/book_pages/autoinflammation-pulmonary-and-cutaneous-vasculitis.jpg": [
		298781,
		9,
		298781
	],
	"./education-center/images/sites/default/files/book_pages/autonomic-nervous-system-dysfunction.jpg": [
		253050,
		9,
		253050
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-alport-syndrome.jpg": [
		954657,
		9,
		954657
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-childhood-onset-proximal-spinal-muscular-atrophy-without-contractures.jpg": [
		221987,
		9,
		221987
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-deafness-onychodystrophy-syndrome.jpg": [
		966505,
		9,
		966505
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-epilepsy.jpg": [
		439224,
		9,
		439224
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-ichthyosis-vulgaris.jpg": [
		186401,
		9,
		186401
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-kenny-caffey-syndrome.jpg": [
		782895,
		9,
		782895
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-keratitis-ichthyosis-hearing-loss-syndrome.jpg": [
		367173,
		9,
		367173
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-keratitis.jpg": [
		720113,
		9,
		720113
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-lamellar-ichthyosis.jpg": [
		442761,
		9,
		442761
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-neovascular-inflammatory-vitreoretinopathy.jpg": [
		787665,
		9,
		787665
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-nonsyndromic-hearing-loss-1.jpg": [
		51394,
		9,
		51394
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-opitz-gbbb-syndrome.jpg": [
		423855,
		9,
		423855
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-palmoplantar-keratoderma-and-congenital-alopecia.jpg": [
		916366,
		9,
		916366
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-polycystic-liver-disease.jpg": [
		517612,
		9,
		517612
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-popliteal-pterygium-syndrome.jpg": [
		760171,
		9,
		760171
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-progressive-external-ophthalmoplegia.jpg": [
		853879,
		9,
		853879
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-dominant-retinitis-pigmentosa.jpg": [
		253607,
		9,
		253607
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-axonal-hereditary-motor-and-sensory-neuropathy.jpg": [
		673742,
		9,
		673742
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-axonal-neuropathy-neuromyotonia.jpg": [
		583778,
		9,
		583778
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-chorioretinopathy-microcephaly-syndrome.jpg": [
		625332,
		9,
		625332
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-congenital-ichthyosis-5.jpg": [
		130113,
		9,
		130113
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-dejerine-sottas-syndrome.jpg": [
		360082,
		9,
		360082
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-hearing-impairment-normal-menstrual-cycles.jpg": [
		788847,
		9,
		788847
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-hypotrichosis-woolly-hair.jpg": [
		595519,
		9,
		595519
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-infantile-epilepsy.jpg": [
		63391,
		9,
		63391
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-infantile-hypercalcemia.jpg": [
		535621,
		9,
		535621
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-inheritance.jpg": [
		206204,
		9,
		206204
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-piezo2-associated-disease.jpg": [
		512638,
		9,
		512638
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-retinitis-pigmentosa.jpg": [
		896960,
		9,
		896960
	],
	"./education-center/images/sites/default/files/book_pages/autosomal-recessive-syndrome-syndactyly-undescended-testes-and-central-nervous-system-defects.jpg": [
		973070,
		9,
		973070
	],
	"./education-center/images/sites/default/files/book_pages/av-block-third-degree-adverse-event.jpg": [
		761155,
		9,
		761155
	],
	"./education-center/images/sites/default/files/book_pages/av-junctional-rhythm.jpg": [
		900668,
		9,
		900668
	],
	"./education-center/images/sites/default/files/book_pages/axenfeld-rieger-anomaly-partially-absent-eye-muscles-distinctive-face-hydrocephaly-and-skeletal.jpg": [
		267999,
		9,
		267999
	],
	"./education-center/images/sites/default/files/book_pages/axial-hypotonia.jpg": [
		18705,
		9,
		18705
	],
	"./education-center/images/sites/default/files/book_pages/axial-myopathy-late-onset.jpg": [
		540583,
		9,
		540583
	],
	"./education-center/images/sites/default/files/book_pages/axillary-odor.jpg": [
		575561,
		9,
		575561
	],
	"./education-center/images/sites/default/files/book_pages/azathioprine-response.jpg": [
		24753,
		9,
		24753
	],
	"./education-center/images/sites/default/files/book_pages/azoospermia.jpg": [
		129596,
		9,
		129596
	],
	"./education-center/images/sites/default/files/book_pages/azorean-disease.jpg": [
		701951,
		9,
		701951
	],
	"./education-center/images/sites/default/files/book_pages/b-acute-lymphoblastic-leukemia.jpg": [
		266046,
		9,
		266046
	],
	"./education-center/images/sites/default/files/book_pages/b-lymphoblastic-leukemia-lymphoma-no-icd-o-subtype.jpg": [
		715721,
		9,
		715721
	],
	"./education-center/images/sites/default/files/book_pages/b-lymphoblastic-leukemia-lymphoma-t1221p13q22-tel-aml1-etv6-runx1.jpg": [
		538987,
		9,
		538987
	],
	"./education-center/images/sites/default/files/book_pages/b-lymphoblastic-leukemialymphoma-not-otherwise-specified.jpg": [
		893752,
		9,
		893752
	],
	"./education-center/images/sites/default/files/book_pages/b-lymphoblastic-leukemialymphoma-t922q341q112-bcr-abl1.jpg": [
		694165,
		9,
		694165
	],
	"./education-center/images/sites/default/files/book_pages/b-lymphoblastic-leukemialymphoma-tv11q233-kmt2a-rearranged.jpg": [
		36548,
		9,
		36548
	],
	"./education-center/images/sites/default/files/book_pages/bacteremia-susceptibility.jpg": [
		855597,
		9,
		855597
	],
	"./education-center/images/sites/default/files/book_pages/bannayan-riley-ruvalcaba-syndrome.jpg": [
		778506,
		9,
		778506
	],
	"./education-center/images/sites/default/files/book_pages/bap1-cancer-syndrome.jpg": [
		309746,
		9,
		309746
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-1-modifier.jpg": [
		95729,
		9,
		95729
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-110-digenic.jpg": [
		913913,
		9,
		913913
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-12-digenic.jpg": [
		650673,
		9,
		650673
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-14-modifier.jpg": [
		585134,
		9,
		585134
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-17-digenic.jpg": [
		74250,
		9,
		74250
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-24-digenic.jpg": [
		739328,
		9,
		739328
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-26-digenic.jpg": [
		418893,
		9,
		418893
	],
	"./education-center/images/sites/default/files/book_pages/bardet-biedl-syndrome-610-digenic.jpg": [
		225566,
		9,
		225566
	],
	"./education-center/images/sites/default/files/book_pages/bare-lymphocyte-syndrome-type-2-complementation-group-e.jpg": [
		542055,
		9,
		542055
	],
	"./education-center/images/sites/default/files/book_pages/bare-lymphocyte-syndrome-type-2-complementation-group.jpg": [
		123689,
		9,
		123689
	],
	"./education-center/images/sites/default/files/book_pages/bare-lymphocyte-syndrome-type-ii-complementation-group-b.jpg": [
		142532,
		9,
		142532
	],
	"./education-center/images/sites/default/files/book_pages/bare-lymphocyte-syndrome-type-ii-complementation-group-c.jpg": [
		772729,
		9,
		772729
	],
	"./education-center/images/sites/default/files/book_pages/bare-lymphocyte-syndrome-type-ii-complementation-group-d.jpg": [
		224703,
		9,
		224703
	],
	"./education-center/images/sites/default/files/book_pages/barrett-esophagusesophageal-adenocarcinoma.jpg": [
		991251,
		9,
		991251
	],
	"./education-center/images/sites/default/files/book_pages/bartter-disease-type-3.jpg": [
		858759,
		9,
		858759
	],
	"./education-center/images/sites/default/files/book_pages/bartter-disease-type-4b.jpg": [
		984435,
		9,
		984435
	],
	"./education-center/images/sites/default/files/book_pages/bartter-syndrome-type-3-hypocalciuria.jpg": [
		794473,
		9,
		794473
	],
	"./education-center/images/sites/default/files/book_pages/basal-cell-carcinoma-somatic.jpg": [
		559591,
		9,
		559591
	],
	"./education-center/images/sites/default/files/book_pages/basal-cell-nevus-syndrome-2.jpg": [
		451948,
		9,
		451948
	],
	"./education-center/images/sites/default/files/book_pages/basal-laminar-drusen.jpg": [
		880725,
		9,
		880725
	],
	"./education-center/images/sites/default/files/book_pages/basan-syndrome.jpg": [
		678829,
		9,
		678829
	],
	"./education-center/images/sites/default/files/book_pages/bbs2-related-disorders.jpg": [
		816408,
		9,
		816408
	],
	"./education-center/images/sites/default/files/book_pages/bche-flouride-1.jpg": [
		405516,
		9,
		405516
	],
	"./education-center/images/sites/default/files/book_pages/bche-fluoride-2.jpg": [
		8743,
		9,
		8743
	],
	"./education-center/images/sites/default/files/book_pages/bcs1l-related-disorders.jpg": [
		23146,
		9,
		23146
	],
	"./education-center/images/sites/default/files/book_pages/beaded-hair.jpg": [
		553274,
		9,
		553274
	],
	"./education-center/images/sites/default/files/book_pages/beare-stevenson-cutis-gyrata-syndrome.jpg": [
		626301,
		9,
		626301
	],
	"./education-center/images/sites/default/files/book_pages/beckwith-wiedemann-syndrome.jpg": [
		414741,
		9,
		414741
	],
	"./education-center/images/sites/default/files/book_pages/behavior-disorder.jpg": [
		153048,
		9,
		153048
	],
	"./education-center/images/sites/default/files/book_pages/behcet-disease.jpg": [
		957136,
		9,
		957136
	],
	"./education-center/images/sites/default/files/book_pages/benign-concentric-annular-macular-dystrophy.jpg": [
		216506,
		9,
		216506
	],
	"./education-center/images/sites/default/files/book_pages/benign-familial-hematuria.jpg": [
		323580,
		9,
		323580
	],
	"./education-center/images/sites/default/files/book_pages/benign-neonatal-epilepsy.jpg": [
		295176,
		9,
		295176
	],
	"./education-center/images/sites/default/files/book_pages/benign-rolandic-epilepsy.jpg": [
		240407,
		9,
		240407
	],
	"./education-center/images/sites/default/files/book_pages/benign-soft-tissue-neoplasm-uncertain-differentiation.jpg": [
		118675,
		9,
		118675
	],
	"./education-center/images/sites/default/files/book_pages/bent-bone-dysplasia-syndrome-2.jpg": [
		614495,
		9,
		614495
	],
	"./education-center/images/sites/default/files/book_pages/benzene-toxicity-susceptibility.jpg": [
		81105,
		9,
		81105
	],
	"./education-center/images/sites/default/files/book_pages/bernard-soulier-syndrome-type-a1.jpg": [
		719821,
		9,
		719821
	],
	"./education-center/images/sites/default/files/book_pages/bernard-soulier-syndrome-type-a2-autosomal-dominant.jpg": [
		629567,
		9,
		629567
	],
	"./education-center/images/sites/default/files/book_pages/bernard-soulier-syndrome-type-b.jpg": [
		524848,
		9,
		524848
	],
	"./education-center/images/sites/default/files/book_pages/bernard-soulier-syndrome-type-c.jpg": [
		541263,
		9,
		541263
	],
	"./education-center/images/sites/default/files/book_pages/best1-related-disorders.jpg": [
		425714,
		9,
		425714
	],
	"./education-center/images/sites/default/files/book_pages/beta-2-adrenoreceptor-agonist-reduced-response.jpg": [
		970480,
		9,
		970480
	],
	"./education-center/images/sites/default/files/book_pages/beta-glucopyranoside-tasting.jpg": [
		547401,
		9,
		547401
	],
	"./education-center/images/sites/default/files/book_pages/beta-hexosaminidase-pseudodeficiency.jpg": [
		187513,
		9,
		187513
	],
	"./education-center/images/sites/default/files/book_pages/beta-knossos-thalassemia.jpg": [
		145306,
		9,
		145306
	],
	"./education-center/images/sites/default/files/book_pages/beta-malay-thalassemia.jpg": [
		544856,
		9,
		544856
	],
	"./education-center/images/sites/default/files/book_pages/beta-plus-thalassemia-dominant.jpg": [
		552049,
		9,
		552049
	],
	"./education-center/images/sites/default/files/book_pages/beta-plus-thalassemia.jpg": [
		513097,
		9,
		513097
	],
	"./education-center/images/sites/default/files/book_pages/beta-showa-yakushiji-thalassemia.jpg": [
		334956,
		9,
		334956
	],
	"./education-center/images/sites/default/files/book_pages/beta-thalassemia-lermontov-type.jpg": [
		807204,
		9,
		807204
	],
	"./education-center/images/sites/default/files/book_pages/beta-zero-thalassemia.jpg": [
		194860,
		9,
		194860
	],
	"./education-center/images/sites/default/files/book_pages/bethlem-myopathy.jpg": [
		50036,
		9,
		50036
	],
	"./education-center/images/sites/default/files/book_pages/bh4-deficient-hyperphenylalaninemia.jpg": [
		515287,
		9,
		515287
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-breast-cancer.jpg": [
		87203,
		9,
		87203
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-cleft-lip.jpg": [
		875378,
		9,
		875378
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-congenital-mydriasis.jpg": [
		690378,
		9,
		690378
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-cryptorchidism.jpg": [
		969312,
		9,
		969312
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-microphthalmos.jpg": [
		735990,
		9,
		735990
	],
	"./education-center/images/sites/default/files/book_pages/bilateral-sensorineural-hearing-impairment.jpg": [
		593564,
		9,
		593564
	],
	"./education-center/images/sites/default/files/book_pages/bilirubin-serum-level-quantitative-trait-locus-1.jpg": [
		508157,
		9,
		508157
	],
	"./education-center/images/sites/default/files/book_pages/birk-barel-intellectual-disability-dysmorphism-syndrome.jpg": [
		976733,
		9,
		976733
	],
	"./education-center/images/sites/default/files/book_pages/biventricular-noncompaction-cardiomyopathy.jpg": [
		797688,
		9,
		797688
	],
	"./education-center/images/sites/default/files/book_pages/bjornstad-syndrome-mild-mitochondrial-complex-iii-deficiency.jpg": [
		323560,
		9,
		323560
	],
	"./education-center/images/sites/default/files/book_pages/bladder-cancer-transitional-cell-somatic.jpg": [
		413474,
		9,
		413474
	],
	"./education-center/images/sites/default/files/book_pages/bleeding-disorder-platelet-type-macrothrombocytopenia.jpg": [
		85907,
		9,
		85907
	],
	"./education-center/images/sites/default/files/book_pages/blepharophimosis-ptosis-and-epicanthus-inversus-syndrome.jpg": [
		299434,
		9,
		299434
	],
	"./education-center/images/sites/default/files/book_pages/blepharophimosis-ptosis-and-epicanthus-inversus-type-ii-duane-retraction-syndrome.jpg": [
		899557,
		9,
		899557
	],
	"./education-center/images/sites/default/files/book_pages/blepharophimosis.jpg": [
		223024,
		9,
		223024
	],
	"./education-center/images/sites/default/files/book_pages/blindness.jpg": [
		192473,
		9,
		192473
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-diego-system.jpg": [
		464875,
		9,
		464875
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-dombrock-system.jpg": [
		871295,
		9,
		871295
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-er.jpg": [
		914588,
		9,
		914588
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-erik.jpg": [
		497506,
		9,
		497506
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-froese.jpg": [
		601100,
		9,
		601100
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-gerbich-system.jpg": [
		149166,
		9,
		149166
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-indian-system.jpg": [
		326978,
		9,
		326978
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-junior-system.jpg": [
		4119,
		9,
		4119
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-lutheran-inhibitor.jpg": [
		642115,
		9,
		642115
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-lutheran-null.jpg": [
		999448,
		9,
		999448
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-ok.jpg": [
		436804,
		9,
		436804
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-sid-system.jpg": [
		725516,
		9,
		725516
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-ss.jpg": [
		146483,
		9,
		146483
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-waldner-type.jpg": [
		786948,
		9,
		786948
	],
	"./education-center/images/sites/default/files/book_pages/blood-group-wright-antigen.jpg": [
		462884,
		9,
		462884
	],
	"./education-center/images/sites/default/files/book_pages/blue-rubber-bleb-nevus.jpg": [
		948994,
		9,
		644728
	],
	"./education-center/images/sites/default/files/book_pages/bmp4-related-syndromic-microphthalmia.jpg": [
		307921,
		9,
		307921
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-10.jpg": [
		615159,
		9,
		615159
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-18.jpg": [
		191529,
		9,
		191529
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-19.jpg": [
		49334,
		9,
		49334
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-20.jpg": [
		141901,
		9,
		141901
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-4.jpg": [
		479632,
		9,
		479632
	],
	"./education-center/images/sites/default/files/book_pages/body-mass-index-quantitative-trait-locus-9.jpg": [
		125523,
		9,
		125523
	],
	"./education-center/images/sites/default/files/book_pages/bombay-phenotype-digenic.jpg": [
		661811,
		9,
		661811
	],
	"./education-center/images/sites/default/files/book_pages/bombay-phenotype.jpg": [
		5695,
		9,
		5695
	],
	"./education-center/images/sites/default/files/book_pages/bone-marrow-hypocellularity.jpg": [
		443249,
		9,
		443249
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-quantitative-trait-locus-1.jpg": [
		123496,
		9,
		123496
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-quantitative-trait-locus-15.jpg": [
		510722,
		9,
		510722
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-quantitative-trait-locus-17.jpg": [
		686086,
		9,
		686086
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-quantitative-trait-locus-18.jpg": [
		630209,
		9,
		630209
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-variation-quantitative-trait-locus.jpg": [
		298795,
		9,
		298795
	],
	"./education-center/images/sites/default/files/book_pages/bone-mineral-density-variation.jpg": [
		980076,
		9,
		980076
	],
	"./education-center/images/sites/default/files/book_pages/boomerang-dysplasia.jpg": [
		519331,
		9,
		519331
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-arterial-hypertension-syndrome.jpg": [
		815883,
		9,
		815883
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-preaxial-hallux-varus-syndrome.jpg": [
		371138,
		9,
		371138
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-syndrome-type-e.jpg": [
		931962,
		9,
		931962
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-a1.jpg": [
		204595,
		9,
		204595
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-a2.jpg": [
		709580,
		9,
		709580
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-b1.jpg": [
		680650,
		9,
		680650
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-b1robinow-syndrome-autosomal-recessive.jpg": [
		875801,
		9,
		875801
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-c.jpg": [
		528718,
		9,
		528718
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-d.jpg": [
		432853,
		9,
		432853
	],
	"./education-center/images/sites/default/files/book_pages/brachydactyly-type-e1.jpg": [
		495340,
		9,
		495340
	],
	"./education-center/images/sites/default/files/book_pages/brachyrachia-short-spine-dysplasia.jpg": [
		922158,
		9,
		922158
	],
	"./education-center/images/sites/default/files/book_pages/braddock-carey-syndrome-2.jpg": [
		259360,
		9,
		259360
	],
	"./education-center/images/sites/default/files/book_pages/brain-tumor-polyposis-syndrome-2.jpg": [
		426822,
		9,
		426822
	],
	"./education-center/images/sites/default/files/book_pages/branchiooculofacial-syndrome.jpg": [
		848688,
		9,
		848688
	],
	"./education-center/images/sites/default/files/book_pages/branchiootorenal-spectrum-disorders.jpg": [
		399088,
		9,
		399088
	],
	"./education-center/images/sites/default/files/book_pages/branchiootorenal-syndrome-1.jpg": [
		594994,
		9,
		594994
	],
	"./education-center/images/sites/default/files/book_pages/branchiootorenal-syndrome-cataract.jpg": [
		297855,
		9,
		297855
	],
	"./education-center/images/sites/default/files/book_pages/brca2-related-disorders.jpg": [
		527121,
		9,
		527121
	],
	"./education-center/images/sites/default/files/book_pages/breast-and-colorectal-cancer-susceptibility.jpg": [
		801205,
		9,
		801205
	],
	"./education-center/images/sites/default/files/book_pages/breast-and-colorectal-cancer.jpg": [
		666617,
		9,
		666617
	],
	"./education-center/images/sites/default/files/book_pages/breast-and-ovarian-cancer-susceptibility.jpg": [
		68303,
		9,
		68303
	],
	"./education-center/images/sites/default/files/book_pages/breast-andor-ovarian-cancer.jpg": [
		721283,
		9,
		721283
	],
	"./education-center/images/sites/default/files/book_pages/breast-cancer-early-onset.jpg": [
		582272,
		9,
		582272
	],
	"./education-center/images/sites/default/files/book_pages/breast-cancer-post-chemotherapy-poor-survival.jpg": [
		411348,
		9,
		411348
	],
	"./education-center/images/sites/default/files/book_pages/breast-cancer-protection-against.jpg": [
		412320,
		9,
		412320
	],
	"./education-center/images/sites/default/files/book_pages/breast-cancer-susceptibility.jpg": [
		388009,
		9,
		388009
	],
	"./education-center/images/sites/default/files/book_pages/breast-lobular-carcinoma.jpg": [
		51243,
		9,
		51243
	],
	"./education-center/images/sites/default/files/book_pages/brip1-related-disorders.jpg": [
		737317,
		9,
		737317
	],
	"./education-center/images/sites/default/files/book_pages/british-hpfh.jpg": [
		28547,
		9,
		28547
	],
	"./education-center/images/sites/default/files/book_pages/broad-distal-phalanx-thumb.jpg": [
		212735,
		9,
		212735
	],
	"./education-center/images/sites/default/files/book_pages/bronchiectasis-or-without-elevated-sweat-chloride-1-modifier.jpg": [
		896331,
		9,
		896331
	],
	"./education-center/images/sites/default/files/book_pages/brown-oculocutaneous-albinism.jpg": [
		358577,
		9,
		358577
	],
	"./education-center/images/sites/default/files/book_pages/brugada-syndrome-lidocaine-induced.jpg": [
		847868,
		9,
		847868
	],
	"./education-center/images/sites/default/files/book_pages/brugada-syndrome-shorter-normal-qt-interval.jpg": [
		532064,
		9,
		532064
	],
	"./education-center/images/sites/default/files/book_pages/bullous-ichthyosiform-erythroderma.jpg": [
		269436,
		9,
		269436
	],
	"./education-center/images/sites/default/files/book_pages/burkitt-lymphoma.jpg": [
		977588,
		9,
		977588
	],
	"./education-center/images/sites/default/files/book_pages/butyrylcholinesterase-deficiency-fluoride-resistant-japanese-type.jpg": [
		804506,
		9,
		804506
	],
	"./education-center/images/sites/default/files/book_pages/c1q-deficiency-2.jpg": [
		737971,
		9,
		737971
	],
	"./education-center/images/sites/default/files/book_pages/c1q-deficiency-3.jpg": [
		299394,
		9,
		299394
	],
	"./education-center/images/sites/default/files/book_pages/c2-deficiency-type-i.jpg": [
		621777,
		9,
		621777
	],
	"./education-center/images/sites/default/files/book_pages/c2-deficiency-type-ii.jpg": [
		331726,
		9,
		331726
	],
	"./education-center/images/sites/default/files/book_pages/c3-deficiency.jpg": [
		421589,
		9,
		421589
	],
	"./education-center/images/sites/default/files/book_pages/c3hex-ability-smell.jpg": [
		517828,
		9,
		517828
	],
	"./education-center/images/sites/default/files/book_pages/c6-deficiency-subtotal.jpg": [
		49561,
		9,
		49561
	],
	"./education-center/images/sites/default/files/book_pages/c7-and-c6-deficiency-combined-subtotal.jpg": [
		367786,
		9,
		367786
	],
	"./education-center/images/sites/default/files/book_pages/cafe-au-lait-spot.jpg": [
		212545,
		9,
		212545
	],
	"./education-center/images/sites/default/files/book_pages/cafe-au-lait-spots-multiple.jpg": [
		167364,
		9,
		167364
	],
	"./education-center/images/sites/default/files/book_pages/calfan-syndrome.jpg": [
		373158,
		9,
		373158
	],
	"./education-center/images/sites/default/files/book_pages/calvarial-doughnut-lesions-bone-fragility-or-without-spondylometaphyseal-dysplasia.jpg": [
		219443,
		9,
		219443
	],
	"./education-center/images/sites/default/files/book_pages/calvarial-doughnut-lesions-bone-fragility-syndrome.jpg": [
		448270,
		9,
		448270
	],
	"./education-center/images/sites/default/files/book_pages/campomelic-dysplasia-autosomal-sex-reversal.jpg": [
		18982,
		9,
		18982
	],
	"./education-center/images/sites/default/files/book_pages/camptomelic-dysplasia.jpg": [
		111307,
		9,
		111307
	],
	"./education-center/images/sites/default/files/book_pages/canavan-disease-familial-form.jpg": [
		551742,
		9,
		551742
	],
	"./education-center/images/sites/default/files/book_pages/cancer-alopecia-pigment-dyscrasia-onychodystrophy-and-keratoderma.jpg": [
		212968,
		9,
		212968
	],
	"./education-center/images/sites/default/files/book_pages/cancer-pancreas.jpg": [
		358148,
		9,
		358148
	],
	"./education-center/images/sites/default/files/book_pages/cancer-progression-and-tumor-cell-motility.jpg": [
		261588,
		9,
		261588
	],
	"./education-center/images/sites/default/files/book_pages/cap-congenital-myopathy-arthrogryposis-multiplex-congenita-without-heart-involvement.jpg": [
		511028,
		9,
		511028
	],
	"./education-center/images/sites/default/files/book_pages/capn3-related-disorders.jpg": [
		387603,
		9,
		387603
	],
	"./education-center/images/sites/default/files/book_pages/captopril-response-efficacy.jpg": [
		799386,
		9,
		799386
	],
	"./education-center/images/sites/default/files/book_pages/carbamazepine-hypersensitivity.jpg": [
		714950,
		9,
		714950
	],
	"./education-center/images/sites/default/files/book_pages/carbamazepine-response-dosage.jpg": [
		74498,
		9,
		74498
	],
	"./education-center/images/sites/default/files/book_pages/carbonic-anhydrase-i-deficiency.jpg": [
		894776,
		9,
		894776
	],
	"./education-center/images/sites/default/files/book_pages/carbonic-anhydrase-i-guam.jpg": [
		44845,
		9,
		44845
	],
	"./education-center/images/sites/default/files/book_pages/carboxymethyl-dextran-a2-gadolinium-dota.jpg": [
		14277,
		9,
		14277
	],
	"./education-center/images/sites/default/files/book_pages/carcinoma-adrenocortical-androgen-secreting.jpg": [
		267552,
		9,
		267552
	],
	"./education-center/images/sites/default/files/book_pages/carcinoma-head-pancreas.jpg": [
		953517,
		9,
		953517
	],
	"./education-center/images/sites/default/files/book_pages/carcinoma-male-breast.jpg": [
		605250,
		9,
		605250
	],
	"./education-center/images/sites/default/files/book_pages/cardiac-arrest.jpg": [
		203802,
		9,
		203802
	],
	"./education-center/images/sites/default/files/book_pages/cardiac-conduction-defect-nonprogressive.jpg": [
		221841,
		9,
		221841
	],
	"./education-center/images/sites/default/files/book_pages/cardiac-valvular-dysplasia-2.jpg": [
		291733,
		9,
		291733
	],
	"./education-center/images/sites/default/files/book_pages/cardio-cutaneous-syndrome.jpg": [
		109641,
		9,
		109641
	],
	"./education-center/images/sites/default/files/book_pages/cardiofaciocutaneous-syndrome-1.jpg": [
		904129,
		9,
		904129
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-and-deafness.jpg": [
		679988,
		9,
		679988
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-apical-hypertrophic-and-neuropathy.jpg": [
		858959,
		9,
		858959
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-familial-restrictive-1.jpg": [
		828700,
		9,
		828700
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-familial-restrictive-4.jpg": [
		65990,
		9,
		65990
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-fatal-infantile.jpg": [
		149425,
		9,
		149425
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-fatal.jpg": [
		230679,
		9,
		230679
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-hypertrophic-midventricular-digenic.jpg": [
		434505,
		9,
		434505
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-hypertrophic-mitochondrial.jpg": [
		741923,
		9,
		741923
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-idiopathic-dilated-mitochondrial.jpg": [
		354432,
		9,
		354432
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-mitochondrial.jpg": [
		702654,
		9,
		702654
	],
	"./education-center/images/sites/default/files/book_pages/cardiomyopathy-or-without-skeletal-myopathy.jpg": [
		116694,
		9,
		116694
	],
	"./education-center/images/sites/default/files/book_pages/cardiospondylocarpofacial-syndrome.jpg": [
		191472,
		9,
		191472
	],
	"./education-center/images/sites/default/files/book_pages/cardiovascular-phenotype.jpg": [
		429156,
		9,
		429156
	],
	"./education-center/images/sites/default/files/book_pages/carotid-intimal-medial-thickness-1.jpg": [
		914710,
		9,
		914710
	],
	"./education-center/images/sites/default/files/book_pages/carpal-osteolysis.jpg": [
		936875,
		9,
		936875
	],
	"./education-center/images/sites/default/files/book_pages/carpal-tunnel-syndrome.jpg": [
		816005,
		9,
		816005
	],
	"./education-center/images/sites/default/files/book_pages/cartilage-hair-hypoplasia-anauxetic-dysplasia-spectrum-disorders.jpg": [
		105747,
		9,
		105747
	],
	"./education-center/images/sites/default/files/book_pages/cataract-1-multiple-types.jpg": [
		9469,
		9,
		9469
	],
	"./education-center/images/sites/default/files/book_pages/cataract-11-posterior-polar-microphthalmia-and-neurodevelopmental-abnormalities.jpg": [
		521781,
		9,
		521781
	],
	"./education-center/images/sites/default/files/book_pages/cataract-11-posterior-polar.jpg": [
		763100,
		9,
		763100
	],
	"./education-center/images/sites/default/files/book_pages/cataract-13-adult-i-phenotype.jpg": [
		400583,
		9,
		400583
	],
	"./education-center/images/sites/default/files/book_pages/cataract-2-coppock.jpg": [
		255529,
		9,
		255529
	],
	"./education-center/images/sites/default/files/book_pages/cataract-20-multiple-types.jpg": [
		516298,
		9,
		516298
	],
	"./education-center/images/sites/default/files/book_pages/cataract-30.jpg": [
		169142,
		9,
		169142
	],
	"./education-center/images/sites/default/files/book_pages/cataract-33.jpg": [
		956330,
		9,
		956330
	],
	"./education-center/images/sites/default/files/book_pages/cataract-36.jpg": [
		126816,
		9,
		126816
	],
	"./education-center/images/sites/default/files/book_pages/cataract-38.jpg": [
		95981,
		9,
		95981
	],
	"./education-center/images/sites/default/files/book_pages/cataract-4-multiple-types.jpg": [
		140640,
		9,
		140640
	],
	"./education-center/images/sites/default/files/book_pages/cataract-41.jpg": [
		796209,
		9,
		796209
	],
	"./education-center/images/sites/default/files/book_pages/cataract-43.jpg": [
		602373,
		9,
		602373
	],
	"./education-center/images/sites/default/files/book_pages/cataract-5-multiple-types.jpg": [
		424109,
		9,
		424109
	],
	"./education-center/images/sites/default/files/book_pages/cataract-6-age-related-cortical.jpg": [
		776647,
		9,
		776647
	],
	"./education-center/images/sites/default/files/book_pages/cataract-6-multiple-types.jpg": [
		305352,
		9,
		305352
	],
	"./education-center/images/sites/default/files/book_pages/cataract-9-autosomal-recessive.jpg": [
		561998,
		9,
		561998
	],
	"./education-center/images/sites/default/files/book_pages/cataract-9-multiple-types-microcornea.jpg": [
		670347,
		9,
		670347
	],
	"./education-center/images/sites/default/files/book_pages/cataracts-congenital-late-onset-corneal-dystrophy.jpg": [
		388640,
		9,
		388640
	],
	"./education-center/images/sites/default/files/book_pages/cataracts-spastic-paraparesis-and-speech-delay.jpg": [
		182730,
		9,
		182730
	],
	"./education-center/images/sites/default/files/book_pages/caused-mutation-tafazzin-gene.jpg": [
		216206,
		9,
		216206
	],
	"./education-center/images/sites/default/files/book_pages/cc2d2a-related-disorders.jpg": [
		897912,
		9,
		897912
	],
	"./education-center/images/sites/default/files/book_pages/cd99-positive-neoplastic-cells-present.jpg": [
		227909,
		9,
		227909
	],
	"./education-center/images/sites/default/files/book_pages/cdh23-related-disorders.jpg": [
		995589,
		9,
		995589
	],
	"./education-center/images/sites/default/files/book_pages/central-core-disease-autosomal-recessive.jpg": [
		11620,
		9,
		11620
	],
	"./education-center/images/sites/default/files/book_pages/central-core-myopathy.jpg": [
		993387,
		9,
		993387
	],
	"./education-center/images/sites/default/files/book_pages/centromeric-instability-chromosomes-19-and-16-and-immunodeficiency.jpg": [
		874023,
		9,
		874023
	],
	"./education-center/images/sites/default/files/book_pages/centronuclear-myopathy-dominant.jpg": [
		943215,
		9,
		943215
	],
	"./education-center/images/sites/default/files/book_pages/cep152-related-disorders.jpg": [
		369149,
		9,
		369149
	],
	"./education-center/images/sites/default/files/book_pages/cep290-related-disorders.jpg": [
		663049,
		9,
		663049
	],
	"./education-center/images/sites/default/files/book_pages/cerebellar-ataxia-cataract-and-diabetes-mellitus.jpg": [
		649716,
		9,
		649716
	],
	"./education-center/images/sites/default/files/book_pages/cerebellar-ataxia.jpg": [
		517204,
		9,
		517204
	],
	"./education-center/images/sites/default/files/book_pages/cerebellar-cyst.jpg": [
		413937,
		9,
		413937
	],
	"./education-center/images/sites/default/files/book_pages/cerebellar-medulloblastoma.jpg": [
		647117,
		9,
		647117
	],
	"./education-center/images/sites/default/files/book_pages/cerebellar-vermis-hypoplasia.jpg": [
		678955,
		9,
		678955
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-amyloid-angiopathy-prnp-related.jpg": [
		512793,
		9,
		512793
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-arteriopathy-autosomal-dominant-subcortical-infarcts-and-leukoencephalopathy-type-1.jpg": [
		945524,
		9,
		945524
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-arteriovenous-malformation.jpg": [
		625923,
		9,
		625923
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-atrophy.jpg": [
		681378,
		9,
		681378
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-autosomal-dominant-arteriopathy-subcortical-infarcts-and-leukoencephalopathy.jpg": [
		842050,
		9,
		842050
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-cavernous-malformation.jpg": [
		22536,
		9,
		22536
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-creatine-deficiency-syndrome.jpg": [
		9809,
		9,
		9809
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-edema.jpg": [
		740384,
		9,
		740384
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-hemorrhage_0.jpg": [
		874580,
		9,
		874580
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-hypomyelination.jpg": [
		50353,
		9,
		50353
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-infarction-susceptibility.jpg": [
		298874,
		9,
		298874
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-palsy-spastic-quadriplegic.jpg": [
		791645,
		9,
		791645
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-palsy.jpg": [
		377781,
		9,
		377781
	],
	"./education-center/images/sites/default/files/book_pages/cerebral-visual-impairment-and-intellectual-disability.jpg": [
		968473,
		9,
		968473
	],
	"./education-center/images/sites/default/files/book_pages/cerebro-costo-mandibular-syndrome.jpg": [
		30417,
		9,
		30417
	],
	"./education-center/images/sites/default/files/book_pages/ceroid-lipofuscinosis-neuronal-3-protracted.jpg": [
		224304,
		9,
		224304
	],
	"./education-center/images/sites/default/files/book_pages/cfh-related-dense-deposit-disease-membranoproliferative-glomerulonephritis-type-ii.jpg": [
		794863,
		9,
		794863
	],
	"./education-center/images/sites/default/files/book_pages/cfh-related-disorders.jpg": [
		517557,
		9,
		517557
	],
	"./education-center/images/sites/default/files/book_pages/cfhr5-deficiency.jpg": [
		209750,
		9,
		209750
	],
	"./education-center/images/sites/default/files/book_pages/cfi-related-disorders.jpg": [
		217827,
		9,
		217827
	],
	"./education-center/images/sites/default/files/book_pages/channelopathy.jpg": [
		24514,
		9,
		24514
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-axonal-type-2p.jpg": [
		301651,
		9,
		301651
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-dominant-intermediate-b-neutropenia.jpg": [
		945881,
		9,
		945881
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-1a-autosomal-recessive.jpg": [
		510600,
		9,
		510600
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-1a-focally-folded-myelin-sheaths.jpg": [
		969292,
		9,
		969292
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-1b-focally-folded-myelin-sheaths.jpg": [
		290448,
		9,
		290448
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-1b.jpg": [
		344748,
		9,
		344748
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-1e.jpg": [
		192862,
		9,
		192862
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-2a1.jpg": [
		866090,
		9,
		866090
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-4b2-early-onset-glaucoma.jpg": [
		534461,
		9,
		534461
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-disease-type-ia.jpg": [
		309489,
		9,
		309489
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-intermediate.jpg": [
		870582,
		9,
		870582
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-neuropathy-x.jpg": [
		860822,
		9,
		860822
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-vocal-cord-paresis.jpg": [
		892217,
		9,
		892217
	],
	"./education-center/images/sites/default/files/book_pages/charcot-marie-tooth-x-linked.jpg": [
		802134,
		9,
		802134
	],
	"./education-center/images/sites/default/files/book_pages/chediak-higashi-syndrome-adult-type.jpg": [
		356082,
		9,
		356082
	],
	"./education-center/images/sites/default/files/book_pages/chediak-higashi-syndrome-childhood-type.jpg": [
		951257,
		9,
		951257
	],
	"./education-center/images/sites/default/files/book_pages/chek2-related-cancer-susceptibility.jpg": [
		227751,
		9,
		227751
	],
	"./education-center/images/sites/default/files/book_pages/chiari-malformation.jpg": [
		156175,
		9,
		156175
	],
	"./education-center/images/sites/default/files/book_pages/childhood-epilepsy-centrotemporal-spikes.jpg": [
		136353,
		9,
		136353
	],
	"./education-center/images/sites/default/files/book_pages/childhood-ganglioglioma.jpg": [
		306677,
		9,
		306677
	],
	"./education-center/images/sites/default/files/book_pages/childhood-hypophosphatasia.jpg": [
		13685,
		9,
		13685
	],
	"./education-center/images/sites/default/files/book_pages/childhood-myocerebrohepatopathy-spectrum.jpg": [
		947674,
		9,
		947674
	],
	"./education-center/images/sites/default/files/book_pages/childhood-onset-sensorineural-hearing-impairment.jpg": [
		584022,
		9,
		584022
	],
	"./education-center/images/sites/default/files/book_pages/chitotriosidase-deficiency.jpg": [
		669859,
		9,
		669859
	],
	"./education-center/images/sites/default/files/book_pages/chloramphenicol-resistance.jpg": [
		38417,
		9,
		38417
	],
	"./education-center/images/sites/default/files/book_pages/cholestasis-intrahepatic-pregnancy-1.jpg": [
		854821,
		9,
		854821
	],
	"./education-center/images/sites/default/files/book_pages/cholesteatoma-middle-ear.jpg": [
		230814,
		9,
		230814
	],
	"./education-center/images/sites/default/files/book_pages/cholesteatoma.jpg": [
		796890,
		9,
		796890
	],
	"./education-center/images/sites/default/files/book_pages/chondrocalcinosis-2-sporadic.jpg": [
		13619,
		9,
		13619
	],
	"./education-center/images/sites/default/files/book_pages/chondrocalcinosis-2.jpg": [
		595516,
		9,
		595516
	],
	"./education-center/images/sites/default/files/book_pages/chondrocalcinosis.jpg": [
		977721,
		9,
		977721
	],
	"./education-center/images/sites/default/files/book_pages/chondrodysplasia-punctata-2-x-linked-dominant.jpg": [
		290773,
		9,
		290773
	],
	"./education-center/images/sites/default/files/book_pages/chorioretinal-coloboma.jpg": [
		239192,
		9,
		239192
	],
	"./education-center/images/sites/default/files/book_pages/choroidal-dystrophy.jpg": [
		994840,
		9,
		994840
	],
	"./education-center/images/sites/default/files/book_pages/chrna1-related-congenital-myasthenic-syndrome.jpg": [
		493052,
		9,
		493052
	],
	"./education-center/images/sites/default/files/book_pages/chromosome-2q231-deletion-syndrome.jpg": [
		829056,
		9,
		829056
	],
	"./education-center/images/sites/default/files/book_pages/chronic-adenoiditis.jpg": [
		217366,
		9,
		217366
	],
	"./education-center/images/sites/default/files/book_pages/chronic-and-progressive-ataxia.jpg": [
		779863,
		9,
		779863
	],
	"./education-center/images/sites/default/files/book_pages/chronic-granulomatous-disease-autosomal-due-deficiency-cyba.jpg": [
		121519,
		9,
		121519
	],
	"./education-center/images/sites/default/files/book_pages/chronic-granulomatous-disease-due-deficiency-ncf-1.jpg": [
		454037,
		9,
		454037
	],
	"./education-center/images/sites/default/files/book_pages/chronic-lung-disease.jpg": [
		416194,
		9,
		416194
	],
	"./education-center/images/sites/default/files/book_pages/chronic-sinusitis.jpg": [
		309261,
		9,
		309261
	],
	"./education-center/images/sites/default/files/book_pages/cic-dux-sarcoma.jpg": [
		191434,
		9,
		191434
	],
	"./education-center/images/sites/default/files/book_pages/cirrhosis-cryptogenic.jpg": [
		210574,
		9,
		210574
	],
	"./education-center/images/sites/default/files/book_pages/cirrhosis-familial.jpg": [
		827968,
		9,
		827968
	],
	"./education-center/images/sites/default/files/book_pages/citrullinemia-mild.jpg": [
		36210,
		9,
		36210
	],
	"./education-center/images/sites/default/files/book_pages/classical-galactosemia-homozygous-duarte-type.jpg": [
		143487,
		9,
		143487
	],
	"./education-center/images/sites/default/files/book_pages/classical-primary-microcephaly.jpg": [
		717261,
		9,
		717261
	],
	"./education-center/images/sites/default/files/book_pages/clcn4-related-disorder.jpg": [
		146566,
		9,
		146566
	],
	"./education-center/images/sites/default/files/book_pages/cleft-lip-cleft-palate-autosomal-dominant.jpg": [
		469721,
		9,
		469721
	],
	"./education-center/images/sites/default/files/book_pages/cleft-palate-ankyloglossia.jpg": [
		24803,
		9,
		24803
	],
	"./education-center/images/sites/default/files/book_pages/cleidocranial-dysostosis.jpg": [
		11011,
		9,
		11011
	],
	"./education-center/images/sites/default/files/book_pages/cleidocranial-dysplasia-1-forme-fruste-brachydactyly.jpg": [
		869685,
		9,
		869685
	],
	"./education-center/images/sites/default/files/book_pages/cleidocranial-dysplasia-1-forme-fruste-dental-anomalies-only.jpg": [
		869982,
		9,
		869982
	],
	"./education-center/images/sites/default/files/book_pages/cleidocranial-dysplasia-2.jpg": [
		504206,
		9,
		504206
	],
	"./education-center/images/sites/default/files/book_pages/clopidogrel-response-efficacy.jpg": [
		635438,
		9,
		635438
	],
	"./education-center/images/sites/default/files/book_pages/clopidogrel-response.jpg": [
		31202,
		9,
		31202
	],
	"./education-center/images/sites/default/files/book_pages/clubfoot.jpg": [
		818025,
		9,
		818025
	],
	"./education-center/images/sites/default/files/book_pages/cngb3-related-disorders.jpg": [
		825016,
		9,
		825016
	],
	"./education-center/images/sites/default/files/book_pages/coagulation-factor-deficiency-syndrome.jpg": [
		158908,
		9,
		158908
	],
	"./education-center/images/sites/default/files/book_pages/cocaine-related-disorders.jpg": [
		752801,
		9,
		752801
	],
	"./education-center/images/sites/default/files/book_pages/coenzyme-q10-deficiency-oculomotor-apraxia-type.jpg": [
		9771,
		9,
		9771
	],
	"./education-center/images/sites/default/files/book_pages/coenzyme-q10-deficiency-spinocerebellar-ataxia-type.jpg": [
		200420,
		9,
		200420
	],
	"./education-center/images/sites/default/files/book_pages/coffin-siris-syndrome-1.jpg": [
		214196,
		9,
		214196
	],
	"./education-center/images/sites/default/files/book_pages/coffin-sirisintellectual-disability.jpg": [
		507643,
		9,
		507643
	],
	"./education-center/images/sites/default/files/book_pages/cognitive-impairment.jpg": [
		120089,
		9,
		120089
	],
	"./education-center/images/sites/default/files/book_pages/colchicine-resistance.jpg": [
		457036,
		9,
		457036
	],
	"./education-center/images/sites/default/files/book_pages/cole-carpenter-syndrome-1.jpg": [
		597505,
		9,
		597505
	],
	"./education-center/images/sites/default/files/book_pages/collapse-finding.jpg": [
		706881,
		9,
		706881
	],
	"./education-center/images/sites/default/files/book_pages/coloboma-congenital-heart-disease-ichthyosiform-dermatosis-intellectual-disability-and-ear-anomalies.jpg": [
		551141,
		9,
		551141
	],
	"./education-center/images/sites/default/files/book_pages/coloboma-ocular-autosomal-dominant.jpg": [
		975768,
		9,
		975768
	],
	"./education-center/images/sites/default/files/book_pages/coloboma-optic-nerve.jpg": [
		92226,
		9,
		92226
	],
	"./education-center/images/sites/default/files/book_pages/colon-cancer-advanced.jpg": [
		313493,
		9,
		313493
	],
	"./education-center/images/sites/default/files/book_pages/colon-cancer-susceptibility.jpg": [
		91432,
		9,
		91432
	],
	"./education-center/images/sites/default/files/book_pages/colonic-neoplasm.jpg": [
		711111,
		9,
		711111
	],
	"./education-center/images/sites/default/files/book_pages/color-vision-defect.jpg": [
		457417,
		9,
		457417
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-adenoma.jpg": [
		204728,
		9,
		204728
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-adenomatous-polyposis-autosomal-recessive-pilomatricomas.jpg": [
		303754,
		9,
		303754
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer-chromosomal-instability-somatic.jpg": [
		653672,
		9,
		653672
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer-early-onset.jpg": [
		16520,
		9,
		16520
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer-non-polyposis.jpg": [
		808732,
		9,
		808732
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer-protection-against.jpg": [
		328175,
		9,
		328175
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer-susceptibility.jpg": [
		767097,
		9,
		767097
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-cancer.jpg": [
		744928,
		9,
		744928
	],
	"./education-center/images/sites/default/files/book_pages/colorectal-endometrial-cancer.jpg": [
		152141,
		9,
		152141
	],
	"./education-center/images/sites/default/files/book_pages/colostrum-secretion.jpg": [
		478037,
		9,
		478037
	],
	"./education-center/images/sites/default/files/book_pages/colton-null-phenotype.jpg": [
		739181,
		9,
		739181
	],
	"./education-center/images/sites/default/files/book_pages/combined-oxidative-phosphorylation-deficiency.jpg": [
		21666,
		9,
		21666
	],
	"./education-center/images/sites/default/files/book_pages/combined-pituitary-hormone-deficiency-dominant.jpg": [
		644311,
		9,
		644311
	],
	"./education-center/images/sites/default/files/book_pages/combined-pituitary-hormone-deficiency-dominantrecessive.jpg": [
		888090,
		9,
		888090
	],
	"./education-center/images/sites/default/files/book_pages/combined-pituitary-hormone-deficiency-recessive.jpg": [
		10773,
		9,
		10773
	],
	"./education-center/images/sites/default/files/book_pages/common-variable-immune-deficiency-dominant.jpg": [
		353791,
		9,
		353791
	],
	"./education-center/images/sites/default/files/book_pages/common-variable-immune-deficiency-recessive.jpg": [
		785418,
		9,
		785418
	],
	"./education-center/images/sites/default/files/book_pages/complement-component-4-partial-deficiency-due-dysfunctional-c1-inhibitor.jpg": [
		923835,
		9,
		923835
	],
	"./education-center/images/sites/default/files/book_pages/complex-febrile-seizure.jpg": [
		193179,
		9,
		193179
	],
	"./education-center/images/sites/default/files/book_pages/concentric-hypertrophic-cardiomyopathy.jpg": [
		290837,
		9,
		290837
	],
	"./education-center/images/sites/default/files/book_pages/cone-dystrophy.jpg": [
		780115,
		9,
		780115
	],
	"./education-center/images/sites/default/files/book_pages/cone-rod-dystrophy-2.jpg": [
		676890,
		9,
		676890
	],
	"./education-center/images/sites/default/files/book_pages/cone-rod-dystrophy-24.jpg": [
		856199,
		9,
		856199
	],
	"./education-center/images/sites/default/files/book_pages/cone-rod-dystrophy-aipl1-related.jpg": [
		824299,
		9,
		824299
	],
	"./education-center/images/sites/default/files/book_pages/cone-rod-dystrophy-dominant.jpg": [
		581188,
		9,
		581188
	],
	"./education-center/images/sites/default/files/book_pages/cone-rod-dystrophy-recessive.jpg": [
		665596,
		9,
		665596
	],
	"./education-center/images/sites/default/files/book_pages/congenital-adrenal-insufficiency.jpg": [
		564409,
		9,
		564409
	],
	"./education-center/images/sites/default/files/book_pages/congenital-and-infantile-nephrotic-syndrome.jpg": [
		627883,
		9,
		627883
	],
	"./education-center/images/sites/default/files/book_pages/congenital-blindness.jpg": [
		139073,
		9,
		139073
	],
	"./education-center/images/sites/default/files/book_pages/congenital-contractural-arachnodactyly.jpg": [
		653877,
		9,
		653877
	],
	"./education-center/images/sites/default/files/book_pages/congenital-diaphragmatic-hernia.jpg": [
		832626,
		9,
		832626
	],
	"./education-center/images/sites/default/files/book_pages/congenital-disorder-glycosylation-type-i.jpg": [
		643458,
		9,
		643458
	],
	"./education-center/images/sites/default/files/book_pages/congenital-disorder-glycosylation-type-ii.jpg": [
		854949,
		9,
		854949
	],
	"./education-center/images/sites/default/files/book_pages/congenital-disorders-glycosylation-type-ii.jpg": [
		60253,
		9,
		60253
	],
	"./education-center/images/sites/default/files/book_pages/congenital-dyserythropoietic-anemia-type-iii.jpg": [
		745491,
		9,
		745491
	],
	"./education-center/images/sites/default/files/book_pages/congenital-fibrosis-extraocular-muscles.jpg": [
		212810,
		9,
		212810
	],
	"./education-center/images/sites/default/files/book_pages/congenital-generalized-lipodystrophy.jpg": [
		592736,
		9,
		592736
	],
	"./education-center/images/sites/default/files/book_pages/congenital-heart-defects-1-nonsyndromic-1.jpg": [
		717899,
		9,
		717899
	],
	"./education-center/images/sites/default/files/book_pages/congenital-heart-defects-multiple-types-8-or-without-heterotaxy.jpg": [
		649774,
		9,
		649774
	],
	"./education-center/images/sites/default/files/book_pages/congenital-heart-defects-multiple-types-9.jpg": [
		588723,
		9,
		588723
	],
	"./education-center/images/sites/default/files/book_pages/congenital-heart-disease-variable.jpg": [
		370249,
		9,
		370249
	],
	"./education-center/images/sites/default/files/book_pages/congenital-heart-disease.jpg": [
		12544,
		9,
		12544
	],
	"./education-center/images/sites/default/files/book_pages/congenital-hemolytic-anemia.jpg": [
		498861,
		9,
		498861
	],
	"./education-center/images/sites/default/files/book_pages/congenital-ichthyosis-skin.jpg": [
		560898,
		9,
		560898
	],
	"./education-center/images/sites/default/files/book_pages/congenital-indifference-pain.jpg": [
		642376,
		9,
		642376
	],
	"./education-center/images/sites/default/files/book_pages/congenital-lactic-acidosis.jpg": [
		497814,
		9,
		497814
	],
	"./education-center/images/sites/default/files/book_pages/congenital-macrodactylia.jpg": [
		851715,
		9,
		851715
	],
	"./education-center/images/sites/default/files/book_pages/congenital-microvillous-atrophy.jpg": [
		58905,
		9,
		58905
	],
	"./education-center/images/sites/default/files/book_pages/congenital-multicore-myopathy-external-ophthalmoplegia.jpg": [
		769951,
		9,
		769951
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-alpha-dystroglycanopathy-brain-and-eye-anomalies.jpg": [
		462917,
		9,
		462917
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-alpha-dystroglycan-related.jpg": [
		583306,
		9,
		583306
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-chkb-related.jpg": [
		290687,
		9,
		290687
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-due-partial-lama2-deficiency.jpg": [
		207641,
		9,
		207641
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-itga7-related.jpg": [
		375512,
		9,
		375512
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-lama2-related.jpg": [
		47435,
		9,
		47435
	],
	"./education-center/images/sites/default/files/book_pages/congenital-muscular-dystrophy-rigid-spine.jpg": [
		253794,
		9,
		253794
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myasthenic-syndrome-dominantrecessive.jpg": [
		914431,
		9,
		914431
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myasthenic-syndrome-recessive.jpg": [
		198314,
		9,
		198314
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-10b-mild-variant.jpg": [
		938377,
		9,
		938377
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-20.jpg": [
		351301,
		9,
		351301
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-21-early-respiratory-failure.jpg": [
		53342,
		9,
		53342
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-2b-severe-infantile-autosomal-recessive.jpg": [
		341804,
		9,
		341804
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-2c-severe-infantile-autosomal-dominant.jpg": [
		292031,
		9,
		292031
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myopathy-fiber-type-disproportion.jpg": [
		770441,
		9,
		770441
	],
	"./education-center/images/sites/default/files/book_pages/congenital-myotonia-autosomal-dominant-form.jpg": [
		741939,
		9,
		741939
	],
	"./education-center/images/sites/default/files/book_pages/congenital-nad-deficiency-disorder.jpg": [
		185550,
		9,
		185550
	],
	"./education-center/images/sites/default/files/book_pages/congenital-neutropenia.jpg": [
		621037,
		9,
		621037
	],
	"./education-center/images/sites/default/files/book_pages/congenital-nystagmus.jpg": [
		995015,
		9,
		995015
	],
	"./education-center/images/sites/default/files/book_pages/congenital-ocular-coloboma.jpg": [
		830105,
		9,
		830105
	],
	"./education-center/images/sites/default/files/book_pages/congenital-pontocerebellar-hypoplasia.jpg": [
		798415,
		9,
		798415
	],
	"./education-center/images/sites/default/files/book_pages/congenital-scoliosis.jpg": [
		268682,
		9,
		268682
	],
	"./education-center/images/sites/default/files/book_pages/congenital-sensorineural-hearing-impairment.jpg": [
		389277,
		9,
		389277
	],
	"./education-center/images/sites/default/files/book_pages/congenital-short-bowel-syndrome-x-linked.jpg": [
		443010,
		9,
		443010
	],
	"./education-center/images/sites/default/files/book_pages/congenital-stationary-night-blindness-dominant.jpg": [
		783195,
		9,
		783195
	],
	"./education-center/images/sites/default/files/book_pages/congenital-stationary-night-blindness-recessive.jpg": [
		929541,
		9,
		929541
	],
	"./education-center/images/sites/default/files/book_pages/congenital-total-pulmonary-venous-return-anomaly.jpg": [
		814728,
		9,
		814728
	],
	"./education-center/images/sites/default/files/book_pages/congestive-heart-failure-and-beta-blocker-response-modifier.jpg": [
		184507,
		9,
		184507
	],
	"./education-center/images/sites/default/files/book_pages/conotruncal-anomaly-face-syndrome.jpg": [
		781332,
		9,
		781332
	],
	"./education-center/images/sites/default/files/book_pages/conotruncal-defect.jpg": [
		222152,
		9,
		222152
	],
	"./education-center/images/sites/default/files/book_pages/conspicuously-happy-disposition.jpg": [
		76389,
		9,
		76389
	],
	"./education-center/images/sites/default/files/book_pages/coproporphyria-digenic.jpg": [
		259132,
		9,
		259132
	],
	"./education-center/images/sites/default/files/book_pages/coproporphyria.jpg": [
		779677,
		9,
		779677
	],
	"./education-center/images/sites/default/files/book_pages/corneal-dystrophy-dominant.jpg": [
		768100,
		9,
		768100
	],
	"./education-center/images/sites/default/files/book_pages/corneal-dystrophy-dominantrecessive.jpg": [
		791805,
		9,
		791805
	],
	"./education-center/images/sites/default/files/book_pages/corneal-dystrophy-fuchs-endothelial-1.jpg": [
		213860,
		9,
		213860
	],
	"./education-center/images/sites/default/files/book_pages/corneal-dystrophy-punctiform-and-polychromatic-pre-descemet.jpg": [
		178216,
		9,
		178216
	],
	"./education-center/images/sites/default/files/book_pages/corneal-dystrophy-recessive.jpg": [
		891424,
		9,
		891424
	],
	"./education-center/images/sites/default/files/book_pages/corneal-intraepithelial-dyskeratosis-palmoplantar-hyperkeratosis-laryngeal-dyskeratosis-syndrome.jpg": [
		379337,
		9,
		379337
	],
	"./education-center/images/sites/default/files/book_pages/cornelia-de-lange-syndrome-1.jpg": [
		341245,
		9,
		341245
	],
	"./education-center/images/sites/default/files/book_pages/coronal-craniosynostosis.jpg": [
		113372,
		9,
		113372
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-disease-development-hiv.jpg": [
		649369,
		9,
		649369
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-disease-modifier.jpg": [
		951855,
		9,
		951855
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-disease-susceptibility.jpg": [
		911294,
		9,
		911294
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-spasm-1-susceptibility.jpg": [
		46315,
		9,
		46315
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-spasm-2-susceptibility.jpg": [
		99120,
		9,
		99120
	],
	"./education-center/images/sites/default/files/book_pages/coronary-artery-spasm-3-susceptibility.jpg": [
		92794,
		9,
		92794
	],
	"./education-center/images/sites/default/files/book_pages/coronary-heart-disease-familial-hypercholesterolemia-protection-against.jpg": [
		949820,
		9,
		949820
	],
	"./education-center/images/sites/default/files/book_pages/coronary-sclerosis-medial-infancy.jpg": [
		175819,
		9,
		175819
	],
	"./education-center/images/sites/default/files/book_pages/cortical-dysplasia-complex-other-brain-malformations-12.jpg": [
		6379,
		9,
		6379
	],
	"./education-center/images/sites/default/files/book_pages/cortical-pulverulent-cataract.jpg": [
		389618,
		9,
		389618
	],
	"./education-center/images/sites/default/files/book_pages/cortical-tubers.jpg": [
		226611,
		9,
		226611
	],
	"./education-center/images/sites/default/files/book_pages/costello-syndrome-severe.jpg": [
		999582,
		9,
		999582
	],
	"./education-center/images/sites/default/files/book_pages/cowden-syndrome-1.jpg": [
		734300,
		9,
		734300
	],
	"./education-center/images/sites/default/files/book_pages/coxopodopatellar-syndrome.jpg": [
		991480,
		9,
		991480
	],
	"./education-center/images/sites/default/files/book_pages/craniofacial-deafness-hand-syndrome.jpg": [
		246399,
		9,
		246399
	],
	"./education-center/images/sites/default/files/book_pages/craniofacial-dysmorphism-skeletal-anomalies-and-impaired-intellectual-development-syndrome-2.jpg": [
		126939,
		9,
		126939
	],
	"./education-center/images/sites/default/files/book_pages/craniofacial-skeletal-dermatologic-dysplasia.jpg": [
		844262,
		9,
		844262
	],
	"./education-center/images/sites/default/files/book_pages/craniometaphyseal-dysplasia-autosomal-dominant.jpg": [
		106300,
		9,
		106300
	],
	"./education-center/images/sites/default/files/book_pages/craniosynostosis-7-susceptibility.jpg": [
		273112,
		9,
		273112
	],
	"./education-center/images/sites/default/files/book_pages/craniosynostosis-nonclassifiable-autosomal-dominant.jpg": [
		497213,
		9,
		497213
	],
	"./education-center/images/sites/default/files/book_pages/craniosynostosis-nonspecific.jpg": [
		905706,
		9,
		905706
	],
	"./education-center/images/sites/default/files/book_pages/craniosynostosis-nonsyndromic-unicoronal.jpg": [
		535094,
		9,
		535094
	],
	"./education-center/images/sites/default/files/book_pages/craniotubular-dysplasia-ikegawa-type.jpg": [
		368711,
		9,
		368711
	],
	"./education-center/images/sites/default/files/book_pages/cranium-bifidum-occultum.jpg": [
		605637,
		9,
		605637
	],
	"./education-center/images/sites/default/files/book_pages/crohn-disease-associated-growth-failure-susceptibility.jpg": [
		355555,
		9,
		355555
	],
	"./education-center/images/sites/default/files/book_pages/crohn-disease-association.jpg": [
		733654,
		9,
		733654
	],
	"./education-center/images/sites/default/files/book_pages/cromer-blood-group-system.jpg": [
		48104,
		9,
		48104
	],
	"./education-center/images/sites/default/files/book_pages/crouzon-syndrome.jpg": [
		15654,
		9,
		15654
	],
	"./education-center/images/sites/default/files/book_pages/cryptozoospermia.jpg": [
		106541,
		9,
		106541
	],
	"./education-center/images/sites/default/files/book_pages/ctsc-related-disorders.jpg": [
		238813,
		9,
		238813
	],
	"./education-center/images/sites/default/files/book_pages/cutaneous-malignant-melanoma-dominant.jpg": [
		374527,
		9,
		374527
	],
	"./education-center/images/sites/default/files/book_pages/cutis-laxa-autosomal-dominant-1.jpg": [
		456032,
		9,
		456032
	],
	"./education-center/images/sites/default/files/book_pages/cutis-laxa-dominantrecessive.jpg": [
		869210,
		9,
		869210
	],
	"./education-center/images/sites/default/files/book_pages/cyp1b1-related-disorders.jpg": [
		576264,
		9,
		576264
	],
	"./education-center/images/sites/default/files/book_pages/cystathioninuria.jpg": [
		951921,
		9,
		951921
	],
	"./education-center/images/sites/default/files/book_pages/cystic-parathyroid-adenoma.jpg": [
		872127,
		9,
		872127
	],
	"./education-center/images/sites/default/files/book_pages/cystine-urolithiasis.jpg": [
		793607,
		9,
		793607
	],
	"./education-center/images/sites/default/files/book_pages/cystinosis-atypical-nephropathic.jpg": [
		909742,
		9,
		909742
	],
	"./education-center/images/sites/default/files/book_pages/dabrafenib-response.jpg": [
		412950,
		9,
		412950
	],
	"./education-center/images/sites/default/files/book_pages/darier-disease-acral-hemorrhagic-type.jpg": [
		509366,
		9,
		509366
	],
	"./education-center/images/sites/default/files/book_pages/darier-disease-segmental.jpg": [
		982987,
		9,
		982987
	],
	"./education-center/images/sites/default/files/book_pages/deafness-autosomal-dominant-nonsyndromic-sensorineural-39-dentinogenesis-imperfecta-1.jpg": [
		357507,
		9,
		357507
	],
	"./education-center/images/sites/default/files/book_pages/deafness-autosomal-recessive-12-modifier.jpg": [
		952318,
		9,
		952318
	],
	"./education-center/images/sites/default/files/book_pages/deafness-autosomal-recessive-26-modifier.jpg": [
		942850,
		9,
		942850
	],
	"./education-center/images/sites/default/files/book_pages/deafness-autosomal-recessive-36-without-vestibular-involvement.jpg": [
		563063,
		9,
		563063
	],
	"./education-center/images/sites/default/files/book_pages/deafness-digenic-gjb2gjb3.jpg": [
		96682,
		9,
		96682
	],
	"./education-center/images/sites/default/files/book_pages/deafness-digenic-gjb2gjb6.jpg": [
		841910,
		9,
		841910
	],
	"./education-center/images/sites/default/files/book_pages/deafness-mitochondrial-modifier.jpg": [
		669410,
		9,
		669410
	],
	"./education-center/images/sites/default/files/book_pages/deafness-neurosensory-autosomal-recessive-21.jpg": [
		570370,
		9,
		570370
	],
	"./education-center/images/sites/default/files/book_pages/deafness-sensorineural-neurologic-features.jpg": [
		296951,
		9,
		296951
	],
	"./education-center/images/sites/default/files/book_pages/deafness-smith-magenis-syndrome.jpg": [
		218795,
		9,
		218795
	],
	"./education-center/images/sites/default/files/book_pages/deafness-without-vestibular-involvement-autosomal-dominant.jpg": [
		45838,
		9,
		45838
	],
	"./education-center/images/sites/default/files/book_pages/deafness-x-linked-5.jpg": [
		847534,
		9,
		847534
	],
	"./education-center/images/sites/default/files/book_pages/death-early-adulthood.jpg": [
		913191,
		9,
		913191
	],
	"./education-center/images/sites/default/files/book_pages/death-infancy.jpg": [
		125039,
		9,
		125039
	],
	"./education-center/images/sites/default/files/book_pages/debrisoquine-poor-metabolism.jpg": [
		849170,
		9,
		849170
	],
	"./education-center/images/sites/default/files/book_pages/decreased-activity-mitochondrial-atp-synthase-complex.jpg": [
		537951,
		9,
		537951
	],
	"./education-center/images/sites/default/files/book_pages/decreased-activity-mitochondrial-complex-iii.jpg": [
		295819,
		9,
		295819
	],
	"./education-center/images/sites/default/files/book_pages/decreased-activity-mitochondrial-complex-iv.jpg": [
		460332,
		9,
		460332
	],
	"./education-center/images/sites/default/files/book_pages/decreased-activity-pyruvate-dehydrogenase-complex.jpg": [
		645522,
		9,
		645522
	],
	"./education-center/images/sites/default/files/book_pages/decreased-blood-alpha-hydroxyisovalerate-levels.jpg": [
		685885,
		9,
		685885
	],
	"./education-center/images/sites/default/files/book_pages/decreased-circulating-antibody-level.jpg": [
		963934,
		9,
		963934
	],
	"./education-center/images/sites/default/files/book_pages/decreased-circulating-igg2-level.jpg": [
		243801,
		9,
		243801
	],
	"./education-center/images/sites/default/files/book_pages/decreased-glucose-6-phosphate-dehydrogenase-level-blood.jpg": [
		406326,
		9,
		406326
	],
	"./education-center/images/sites/default/files/book_pages/decreased-plasma-carnitine.jpg": [
		98111,
		9,
		98111
	],
	"./education-center/images/sites/default/files/book_pages/decreased-response-growth-hormone-stimulation-test.jpg": [
		264870,
		9,
		264870
	],
	"./education-center/images/sites/default/files/book_pages/decreased-testicular-size.jpg": [
		667982,
		9,
		667982
	],
	"./education-center/images/sites/default/files/book_pages/deep-venous-thrombosis-protection-against.jpg": [
		28883,
		9,
		28883
	],
	"./education-center/images/sites/default/files/book_pages/deep-venous-thrombosis.jpg": [
		303946,
		9,
		303946
	],
	"./education-center/images/sites/default/files/book_pages/dejerine-sottas-disease.jpg": [
		707314,
		9,
		707314
	],
	"./education-center/images/sites/default/files/book_pages/dejerine-sottas-neuropathy-autosomal-dominant.jpg": [
		824735,
		9,
		824735
	],
	"./education-center/images/sites/default/files/book_pages/dejerine-sottas-syndrome-autosomal-dominant.jpg": [
		491455,
		9,
		491455
	],
	"./education-center/images/sites/default/files/book_pages/delayed-ability-walk.jpg": [
		780249,
		9,
		780249
	],
	"./education-center/images/sites/default/files/book_pages/delayed-gross-motor-development.jpg": [
		51157,
		9,
		51157
	],
	"./education-center/images/sites/default/files/book_pages/delayed-skeletal-maturation.jpg": [
		253545,
		9,
		253545
	],
	"./education-center/images/sites/default/files/book_pages/delayed-speech-and-language-development.jpg": [
		714430,
		9,
		714430
	],
	"./education-center/images/sites/default/files/book_pages/deleterious-rad51d-gene-mutation.jpg": [
		126883,
		9,
		126883
	],
	"./education-center/images/sites/default/files/book_pages/delta-0-thalassemia.jpg": [
		728161,
		9,
		728161
	],
	"./education-center/images/sites/default/files/book_pages/delta-plus-thalassemia.jpg": [
		347863,
		9,
		347863
	],
	"./education-center/images/sites/default/files/book_pages/delta-thalassemia.jpg": [
		692666,
		9,
		692666
	],
	"./education-center/images/sites/default/files/book_pages/delta-zero-thalassemia-knossos-type.jpg": [
		106583,
		9,
		106583
	],
	"./education-center/images/sites/default/files/book_pages/dementia-deafness-and-sensory-neuropathy.jpg": [
		996962,
		9,
		996962
	],
	"./education-center/images/sites/default/files/book_pages/dementia-lewy-body-susceptibility.jpg": [
		628867,
		9,
		628867
	],
	"./education-center/images/sites/default/files/book_pages/dementia.jpg": [
		427551,
		9,
		427551
	],
	"./education-center/images/sites/default/files/book_pages/dengue-fever-protection-against.jpg": [
		58348,
		9,
		58348
	],
	"./education-center/images/sites/default/files/book_pages/dentatorubral-pallidoluysian-atrophy.jpg": [
		416391,
		9,
		416391
	],
	"./education-center/images/sites/default/files/book_pages/denticles.jpg": [
		727443,
		9,
		727443
	],
	"./education-center/images/sites/default/files/book_pages/dentin-dysplasia-type-i-extreme-microdontia-and-misshapen-teeth.jpg": [
		926457,
		9,
		926457
	],
	"./education-center/images/sites/default/files/book_pages/dentin-dysplasia-type-i.jpg": [
		126754,
		9,
		126754
	],
	"./education-center/images/sites/default/files/book_pages/dentinogenesis-imperfecta-type-2.jpg": [
		913369,
		9,
		913369
	],
	"./education-center/images/sites/default/files/book_pages/dentinogenesis-imperfecta-type-3.jpg": [
		957196,
		9,
		957196
	],
	"./education-center/images/sites/default/files/book_pages/dermatitis-atopic-2-susceptibility.jpg": [
		356837,
		9,
		356837
	],
	"./education-center/images/sites/default/files/book_pages/dermatofibrosis-lenticularis-disseminata-isolated.jpg": [
		921910,
		9,
		921910
	],
	"./education-center/images/sites/default/files/book_pages/dermatopathia-pigmentosa-reticularis.jpg": [
		143935,
		9,
		143935
	],
	"./education-center/images/sites/default/files/book_pages/desbuquois-dysplasia-1.jpg": [
		872249,
		9,
		872249
	],
	"./education-center/images/sites/default/files/book_pages/descending-aortic-dissection.jpg": [
		551860,
		9,
		551860
	],
	"./education-center/images/sites/default/files/book_pages/desmoid-disease-hereditary.jpg": [
		790172,
		9,
		790172
	],
	"./education-center/images/sites/default/files/book_pages/desmoid-tumor.jpg": [
		681139,
		9,
		681139
	],
	"./education-center/images/sites/default/files/book_pages/deuteranomaly.jpg": [
		55385,
		9,
		55385
	],
	"./education-center/images/sites/default/files/book_pages/deuteranopia.jpg": [
		452013,
		9,
		452013
	],
	"./education-center/images/sites/default/files/book_pages/deutetrabenazine-response.jpg": [
		507412,
		9,
		507412
	],
	"./education-center/images/sites/default/files/book_pages/developmental-and-epileptic-encephalopathy-31b-autosomal-recessive.jpg": [
		166501,
		9,
		166501
	],
	"./education-center/images/sites/default/files/book_pages/developmental-delay.jpg": [
		309048,
		9,
		309048
	],
	"./education-center/images/sites/default/files/book_pages/developmental-dyslexia.jpg": [
		140136,
		9,
		140136
	],
	"./education-center/images/sites/default/files/book_pages/developmental-regression.jpg": [
		616648,
		9,
		616648
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-insipidus-nephrogenic-autosomal.jpg": [
		129101,
		9,
		129101
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-insipidus-neurohypophyseal-autosomal-recessive.jpg": [
		763817,
		9,
		763817
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-ketosis-prone-susceptibility.jpg": [
		846895,
		9,
		846895
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-noninsulin-dependent-acanthosis-nigricans-and-hypertension.jpg": [
		777472,
		9,
		777472
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-noninsulin-dependent-association.jpg": [
		633382,
		9,
		633382
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-noninsulin-dependent-maternally-transmitted.jpg": [
		291584,
		9,
		291584
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-type-1-susceptibility.jpg": [
		534724,
		9,
		534724
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-type-2-susceptibility.jpg": [
		139273,
		9,
		139273
	],
	"./education-center/images/sites/default/files/book_pages/diabetes-mellitus-type-ii-digenic.jpg": [
		437580,
		9,
		437580
	],
	"./education-center/images/sites/default/files/book_pages/diamond-blackfan-anemia-1.jpg": [
		515414,
		9,
		515414
	],
	"./education-center/images/sites/default/files/book_pages/diaphragmatic-hernia-4-cardiovascular-defects.jpg": [
		593933,
		9,
		593933
	],
	"./education-center/images/sites/default/files/book_pages/diaphyseal-dysplasia.jpg": [
		158002,
		9,
		158002
	],
	"./education-center/images/sites/default/files/book_pages/diaphyseal-medullary-stenosis-bone-malignancy-syndrome.jpg": [
		265790,
		9,
		265790
	],
	"./education-center/images/sites/default/files/book_pages/diarrhea-microvillus-atrophy.jpg": [
		969461,
		9,
		969461
	],
	"./education-center/images/sites/default/files/book_pages/diastema-dental-medial.jpg": [
		182134,
		9,
		182134
	],
	"./education-center/images/sites/default/files/book_pages/diastolic-dysfunction.jpg": [
		186610,
		9,
		186610
	],
	"./education-center/images/sites/default/files/book_pages/diastrophic-dysplasia-broad-bone-platyspondylic-variant.jpg": [
		567693,
		9,
		567693
	],
	"./education-center/images/sites/default/files/book_pages/diencephalic-mesencephalic-junction-dysplasia-syndrome-1.jpg": [
		746929,
		9,
		746929
	],
	"./education-center/images/sites/default/files/book_pages/diffuse-intrinsic-pontine-glioma.jpg": [
		463478,
		9,
		463478
	],
	"./education-center/images/sites/default/files/book_pages/diffuse-mesangial-sclerosis.jpg": [
		622881,
		9,
		622881
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-1a.jpg": [
		987831,
		9,
		987831
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-1m.jpg": [
		616560,
		9,
		616560
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-1t.jpg": [
		198891,
		9,
		198891
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-dominant.jpg": [
		369654,
		9,
		369654
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-left-ventricular-noncompaction.jpg": [
		717797,
		9,
		717797
	],
	"./education-center/images/sites/default/files/book_pages/dilated-cardiomyopathy-recessive.jpg": [
		712872,
		9,
		712872
	],
	"./education-center/images/sites/default/files/book_pages/dilated-left-ventricle.jpg": [
		635201,
		9,
		635201
	],
	"./education-center/images/sites/default/files/book_pages/disease-association-nos.jpg": [
		364633,
		9,
		364633
	],
	"./education-center/images/sites/default/files/book_pages/disease.jpg": [
		318553,
		9,
		318553
	],
	"./education-center/images/sites/default/files/book_pages/disorders-intracellular-cobalamin-metabolism.jpg": [
		807614,
		9,
		807614
	],
	"./education-center/images/sites/default/files/book_pages/disproportionate-short-stature.jpg": [
		359539,
		9,
		359539
	],
	"./education-center/images/sites/default/files/book_pages/disproportionate-tall-stature.jpg": [
		237267,
		9,
		237267
	],
	"./education-center/images/sites/default/files/book_pages/disrupted-sleep-wake-cycle-developmental-delay-and-learning-difficulty.jpg": [
		503206,
		9,
		503206
	],
	"./education-center/images/sites/default/files/book_pages/disseminated-atypical-mycobacterial-infection.jpg": [
		325087,
		9,
		325087
	],
	"./education-center/images/sites/default/files/book_pages/distal-amyotrophy.jpg": [
		52997,
		9,
		52997
	],
	"./education-center/images/sites/default/files/book_pages/distal-lower-limb-muscle-weakness.jpg": [
		656106,
		9,
		656106
	],
	"./education-center/images/sites/default/files/book_pages/distal-muscle-weakness.jpg": [
		794357,
		9,
		794357
	],
	"./education-center/images/sites/default/files/book_pages/distal-renal-tubular-acidosis-dominant.jpg": [
		602873,
		9,
		602873
	],
	"./education-center/images/sites/default/files/book_pages/distal-renal-tubular-acidosis-recessive.jpg": [
		934483,
		9,
		934483
	],
	"./education-center/images/sites/default/files/book_pages/distal-shortening-limbs.jpg": [
		200853,
		9,
		200853
	],
	"./education-center/images/sites/default/files/book_pages/distichiasis-lymphedema-syndrome.jpg": [
		75676,
		9,
		75676
	],
	"./education-center/images/sites/default/files/book_pages/dizygotic-twins.jpg": [
		408587,
		9,
		408587
	],
	"./education-center/images/sites/default/files/book_pages/dld-related-disorders.jpg": [
		139602,
		9,
		139602
	],
	"./education-center/images/sites/default/files/book_pages/dna-topoisomerase-i-camptothecin-resistant.jpg": [
		995547,
		9,
		995547
	],
	"./education-center/images/sites/default/files/book_pages/dna-topoisomerase-ii-resistance-inhibition-amsacrine.jpg": [
		826508,
		9,
		826508
	],
	"./education-center/images/sites/default/files/book_pages/dominant-dystrophic-epidermolysis-bullosa-absence-skin.jpg": [
		330010,
		9,
		330010
	],
	"./education-center/images/sites/default/files/book_pages/dopamine-beta-hydroxylase-polymorphism.jpg": [
		740285,
		9,
		740285
	],
	"./education-center/images/sites/default/files/book_pages/dopamine-receptor-d2-reduced-brain-density.jpg": [
		260669,
		9,
		260669
	],
	"./education-center/images/sites/default/files/book_pages/doyne-honeycomb-retinal-dystrophy.jpg": [
		134039,
		9,
		134039
	],
	"./education-center/images/sites/default/files/book_pages/drug-induced-liver-injury-due-flucloxacillin.jpg": [
		609916,
		9,
		609916
	],
	"./education-center/images/sites/default/files/book_pages/drug-metabolism-altered-ces1-related.jpg": [
		896997,
		9,
		896997
	],
	"./education-center/images/sites/default/files/book_pages/drug-metabolism-altered-cyp2c8-related.jpg": [
		781890,
		9,
		781890
	],
	"./education-center/images/sites/default/files/book_pages/duane-retraction-syndrome.jpg": [
		527857,
		9,
		527857
	],
	"./education-center/images/sites/default/files/book_pages/ductal-breast-carcinoma.jpg": [
		860508,
		9,
		860508
	],
	"./education-center/images/sites/default/files/book_pages/duodenal-adenocarcinoma.jpg": [
		388368,
		9,
		388368
	],
	"./education-center/images/sites/default/files/book_pages/duodenal-stenosis.jpg": [
		648173,
		9,
		648173
	],
	"./education-center/images/sites/default/files/book_pages/dysequilibrium-syndrome.jpg": [
		845735,
		9,
		845735
	],
	"./education-center/images/sites/default/files/book_pages/dysf-related-disorders.jpg": [
		875031,
		9,
		875031
	],
	"./education-center/images/sites/default/files/book_pages/dysfibrinogenemia.jpg": [
		229389,
		9,
		229389
	],
	"./education-center/images/sites/default/files/book_pages/dysgenesis-cerebellar-vermis.jpg": [
		126784,
		9,
		126784
	],
	"./education-center/images/sites/default/files/book_pages/dyskeratosis-congenita-autosomal-dominant-1.jpg": [
		686365,
		9,
		686365
	],
	"./education-center/images/sites/default/files/book_pages/dyskeratosis-congenita-dominant.jpg": [
		759872,
		9,
		759872
	],
	"./education-center/images/sites/default/files/book_pages/dyskeratosis-congenita-recessive.jpg": [
		972536,
		9,
		972536
	],
	"./education-center/images/sites/default/files/book_pages/dyslexia-susceptibility-1.jpg": [
		979950,
		9,
		979950
	],
	"./education-center/images/sites/default/files/book_pages/dysmetria.jpg": [
		653472,
		9,
		653472
	],
	"./education-center/images/sites/default/files/book_pages/dysostosis-multiplex-ain-naz-type.jpg": [
		175163,
		9,
		175163
	],
	"./education-center/images/sites/default/files/book_pages/dysplasminogenemia.jpg": [
		436895,
		9,
		436895
	],
	"./education-center/images/sites/default/files/book_pages/dysplastic-corpus-callosum.jpg": [
		352891,
		9,
		352891
	],
	"./education-center/images/sites/default/files/book_pages/dyssynergia.jpg": [
		528874,
		9,
		528874
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-1-torsion-late-onset.jpg": [
		767289,
		9,
		767289
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-12.jpg": [
		708832,
		9,
		708832
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-32.jpg": [
		600058,
		9,
		600058
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-5.jpg": [
		984682,
		9,
		984682
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-adult-onset.jpg": [
		526789,
		9,
		526789
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-early-onset-atypical-myoclonic-features.jpg": [
		625374,
		9,
		625374
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-intellectual-disability-and-language-impairment.jpg": [
		599438,
		9,
		599438
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-mitochondrial.jpg": [
		825763,
		9,
		825763
	],
	"./education-center/images/sites/default/files/book_pages/dystonia-primary-cervical.jpg": [
		861751,
		9,
		861751
	],
	"./education-center/images/sites/default/files/book_pages/ear-malformation.jpg": [
		30158,
		9,
		30158
	],
	"./education-center/images/sites/default/files/book_pages/early-infantile-epileptic-encephalopathy-autosomal-dominant.jpg": [
		100664,
		9,
		100664
	],
	"./education-center/images/sites/default/files/book_pages/early-infantile-epileptic-encephalopathy-autosomal-recessive.jpg": [
		586317,
		9,
		586317
	],
	"./education-center/images/sites/default/files/book_pages/early-onset-alzheimer-disease-behavioral-disturbance.jpg": [
		496139,
		9,
		496139
	],
	"./education-center/images/sites/default/files/book_pages/early-onset-coronary-artery-disease.jpg": [
		227407,
		9,
		227407
	],
	"./education-center/images/sites/default/files/book_pages/early-onset-epileptic-encephalopathy.jpg": [
		757081,
		9,
		757081
	],
	"./education-center/images/sites/default/files/book_pages/early-onset-generalized-limb-onset-dystonia.jpg": [
		734361,
		9,
		734361
	],
	"./education-center/images/sites/default/files/book_pages/early-spermatogenesis-maturation-arrest.jpg": [
		223220,
		9,
		223220
	],
	"./education-center/images/sites/default/files/book_pages/ebf3-related-disorder.jpg": [
		407358,
		9,
		407358
	],
	"./education-center/images/sites/default/files/book_pages/eccrine-angiomatous-hamartoma.jpg": [
		613812,
		9,
		613812
	],
	"./education-center/images/sites/default/files/book_pages/ectodermal-dysplasia-10a-hypohidrotichairtooth-type-autosomal-dominant.jpg": [
		558323,
		9,
		558323
	],
	"./education-center/images/sites/default/files/book_pages/ectopia-lentis-1-isolated-autosomal-dominant.jpg": [
		433914,
		9,
		433914
	],
	"./education-center/images/sites/default/files/book_pages/ectrodactyly-and-ectodermal-dysplasia-without-cleft-lippalate.jpg": [
		187011,
		9,
		187011
	],
	"./education-center/images/sites/default/files/book_pages/ectrodactyly.jpg": [
		120963,
		9,
		120963
	],
	"./education-center/images/sites/default/files/book_pages/eculizumab-poor-response.jpg": [
		260536,
		9,
		260536
	],
	"./education-center/images/sites/default/files/book_pages/eeg-focal-epileptiform-discharges.jpg": [
		751984,
		9,
		751984
	],
	"./education-center/images/sites/default/files/book_pages/efavirenz-response-metabolismpk.jpg": [
		899448,
		9,
		899448
	],
	"./education-center/images/sites/default/files/book_pages/effort-induced-polymorphic-ventricular-tachycardia.jpg": [
		233240,
		9,
		233240
	],
	"./education-center/images/sites/default/files/book_pages/egfr-related-lung-cancer.jpg": [
		188954,
		9,
		188954
	],
	"./education-center/images/sites/default/files/book_pages/ehlers-danlos-syndrome-arthrochalasis-type.jpg": [
		956301,
		9,
		956301
	],
	"./education-center/images/sites/default/files/book_pages/ehlers-danlos-syndrome-classic-type.jpg": [
		956305,
		9,
		956305
	],
	"./education-center/images/sites/default/files/book_pages/ehlers-danlos-syndrome-progeroid-type.jpg": [
		848410,
		9,
		848410
	],
	"./education-center/images/sites/default/files/book_pages/ehlers-danlos-syndrome-type-3.jpg": [
		982152,
		9,
		982152
	],
	"./education-center/images/sites/default/files/book_pages/elevated-basal-serum-calcitonin.jpg": [
		683360,
		9,
		683360
	],
	"./education-center/images/sites/default/files/book_pages/elevated-circulating-alkaline-phosphatase-concentration.jpg": [
		372057,
		9,
		372057
	],
	"./education-center/images/sites/default/files/book_pages/elevated-circulating-creatine-kinase-concentration.jpg": [
		823773,
		9,
		823773
	],
	"./education-center/images/sites/default/files/book_pages/elevated-circulating-glutaric-acid-concentration.jpg": [
		655874,
		9,
		655874
	],
	"./education-center/images/sites/default/files/book_pages/elliptocytosis-2.jpg": [
		916064,
		9,
		916064
	],
	"./education-center/images/sites/default/files/book_pages/elliptocytosis.jpg": [
		618172,
		9,
		618172
	],
	"./education-center/images/sites/default/files/book_pages/emery-nelson-syndrome.jpg": [
		190327,
		9,
		190327
	],
	"./education-center/images/sites/default/files/book_pages/emm-null-phenotype.jpg": [
		294127,
		9,
		294127
	],
	"./education-center/images/sites/default/files/book_pages/empty-follicle-syndrome.jpg": [
		739477,
		9,
		739477
	],
	"./education-center/images/sites/default/files/book_pages/empty-ovarian-follicle.jpg": [
		312653,
		9,
		312653
	],
	"./education-center/images/sites/default/files/book_pages/encephalocardiomyopathy-mitochondrial.jpg": [
		461056,
		9,
		461056
	],
	"./education-center/images/sites/default/files/book_pages/encephalopathy-familial-progressive-necrotizing.jpg": [
		501060,
		9,
		501060
	],
	"./education-center/images/sites/default/files/book_pages/endometrial-endometrioid-adenocarcinoma-variant-squamous-differentiation.jpg": [
		950802,
		9,
		950802
	],
	"./education-center/images/sites/default/files/book_pages/endometrial-neoplasm.jpg": [
		907482,
		9,
		907482
	],
	"./education-center/images/sites/default/files/book_pages/endometriosis.jpg": [
		82933,
		9,
		82933
	],
	"./education-center/images/sites/default/files/book_pages/enhancement-c-reflex.jpg": [
		298071,
		9,
		298071
	],
	"./education-center/images/sites/default/files/book_pages/enzyme-activity-finding.jpg": [
		587015,
		9,
		587015
	],
	"./education-center/images/sites/default/files/book_pages/epidermal-nevus-urothelial-cancer-somatic.jpg": [
		621634,
		9,
		621634
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-dystrophica-autosomal-recessive-localisata-variant.jpg": [
		521605,
		9,
		521605
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-dystrophica-inversa-autosomal-recessive.jpg": [
		451240,
		9,
		451240
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-dystrophica.jpg": [
		402169,
		9,
		402169
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-junctional-6-pyloric-atresia.jpg": [
		395086,
		9,
		395086
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-pretibial-autosomal-recessive.jpg": [
		790956,
		9,
		790956
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-pruriginosa-autosomal-dominant.jpg": [
		127069,
		9,
		127069
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-pruriginosa-autosomal-recessive.jpg": [
		883649,
		9,
		883649
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-simplex-1a-generalized-severe.jpg": [
		240439,
		9,
		240439
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-simplex-1c-localized.jpg": [
		427962,
		9,
		427962
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-simplex-koebner-type.jpg": [
		332167,
		9,
		332167
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-simplex-mottled-pigmentation.jpg": [
		817812,
		9,
		817812
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa-simplex-ogna-type.jpg": [
		825962,
		9,
		825962
	],
	"./education-center/images/sites/default/files/book_pages/epidermolysis-bullosa.jpg": [
		655277,
		9,
		655277
	],
	"./education-center/images/sites/default/files/book_pages/epidermolytic-hyperkeratosis-late-onset.jpg": [
		586233,
		9,
		586233
	],
	"./education-center/images/sites/default/files/book_pages/epidermolytic-palmoplantar-keratoderma.jpg": [
		509821,
		9,
		509821
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-childhood-absence-2.jpg": [
		473118,
		9,
		473118
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-childhood-absence-4.jpg": [
		551946,
		9,
		551946
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-due-perinatal-stroke.jpg": [
		619300,
		9,
		619300
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-juvenile-absence-2.jpg": [
		355816,
		9,
		355816
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-juvenile-myoclonic-7.jpg": [
		783746,
		9,
		783746
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-juvenile-myoclonic-8.jpg": [
		682622,
		9,
		682622
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-mitochondrial.jpg": [
		68452,
		9,
		68452
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-progressive-myoclonic-3-intracellular-inclusions.jpg": [
		98420,
		9,
		98420
	],
	"./education-center/images/sites/default/files/book_pages/epilepsy-x-linked-2-or-without-impaired-intellectual-development-and-dysmorphic-features.jpg": [
		418824,
		9,
		418824
	],
	"./education-center/images/sites/default/files/book_pages/epileptic-encephalopathy-early-infanitle-1.jpg": [
		502772,
		9,
		502772
	],
	"./education-center/images/sites/default/files/book_pages/epileptic-encephalopathy.jpg": [
		363816,
		9,
		363816
	],
	"./education-center/images/sites/default/files/book_pages/epileptic-spasm.jpg": [
		81315,
		9,
		81315
	],
	"./education-center/images/sites/default/files/book_pages/epiphyseal-dysplasia-multiple-1-severe.jpg": [
		154434,
		9,
		154434
	],
	"./education-center/images/sites/default/files/book_pages/epiphyseal-dysplasia-multiple-3-myopathy.jpg": [
		37619,
		9,
		37619
	],
	"./education-center/images/sites/default/files/book_pages/episodic-ataxia-type-2-and-epilepsy.jpg": [
		599768,
		9,
		599768
	],
	"./education-center/images/sites/default/files/book_pages/episodic-ataxia-type-2.jpg": [
		586987,
		9,
		586987
	],
	"./education-center/images/sites/default/files/book_pages/episodic-ataxiamyokymia-syndrome.jpg": [
		596741,
		9,
		596741
	],
	"./education-center/images/sites/default/files/book_pages/epithelial-basement-membrane-dystrophy.jpg": [
		717808,
		9,
		717808
	],
	"./education-center/images/sites/default/files/book_pages/epithelial-recurrent-erosion-dystrophy.jpg": [
		501752,
		9,
		501752
	],
	"./education-center/images/sites/default/files/book_pages/epithelial-stromal-tgfbi-dystrophy.jpg": [
		814573,
		9,
		814573
	],
	"./education-center/images/sites/default/files/book_pages/ercc2-related-disorders.jpg": [
		605267,
		9,
		605267
	],
	"./education-center/images/sites/default/files/book_pages/ercc6-related-disorders.jpg": [
		108577,
		9,
		108577
	],
	"./education-center/images/sites/default/files/book_pages/erlotinib-response-efficacy.jpg": [
		79454,
		9,
		79454
	],
	"./education-center/images/sites/default/files/book_pages/erlotinib-response.jpg": [
		396278,
		9,
		396278
	],
	"./education-center/images/sites/default/files/book_pages/erythrocyte-amp-deaminase-deficiency.jpg": [
		984163,
		9,
		984163
	],
	"./education-center/images/sites/default/files/book_pages/erythrocytosis-jak2-related-somatic.jpg": [
		540544,
		9,
		540544
	],
	"./education-center/images/sites/default/files/book_pages/erythrocytosis.jpg": [
		621394,
		9,
		621394
	],
	"./education-center/images/sites/default/files/book_pages/erythroleukemia-familial-susceptibility.jpg": [
		853446,
		9,
		853446
	],
	"./education-center/images/sites/default/files/book_pages/esophageal-atresia.jpg": [
		935107,
		9,
		935107
	],
	"./education-center/images/sites/default/files/book_pages/esophageal-cancer-alcohol-related-susceptibility.jpg": [
		495642,
		9,
		495642
	],
	"./education-center/images/sites/default/files/book_pages/esophageal-carcinoma-somatic.jpg": [
		80671,
		9,
		80671
	],
	"./education-center/images/sites/default/files/book_pages/esophageal-squamous-cell-carcinoma-somatic.jpg": [
		200821,
		9,
		200821
	],
	"./education-center/images/sites/default/files/book_pages/esophageal-squamous-cell-carcinoma.jpg": [
		160630,
		9,
		160630
	],
	"./education-center/images/sites/default/files/book_pages/essential-hypertension-genetic.jpg": [
		86331,
		9,
		86331
	],
	"./education-center/images/sites/default/files/book_pages/essential-hypertension.jpg": [
		455063,
		9,
		455063
	],
	"./education-center/images/sites/default/files/book_pages/estrogen-receptor-mutant-temperature-sensitive.jpg": [
		624290,
		9,
		624290
	],
	"./education-center/images/sites/default/files/book_pages/etanercept-response-efficacy.jpg": [
		745562,
		9,
		745562
	],
	"./education-center/images/sites/default/files/book_pages/euthyroid-goiter.jpg": [
		338000,
		9,
		338000
	],
	"./education-center/images/sites/default/files/book_pages/evans-syndrome-immunodeficiency-and-premature-immunosenescence-associated-tripeptidyl-peptidase-ii.jpg": [
		487473,
		9,
		487473
	],
	"./education-center/images/sites/default/files/book_pages/ewing-sarcoma-soft-tissue.jpg": [
		388384,
		9,
		388384
	],
	"./education-center/images/sites/default/files/book_pages/exaggerated-startle-response.jpg": [
		523466,
		9,
		523466
	],
	"./education-center/images/sites/default/files/book_pages/exercise-intolerance-and-complex-iii-deficiency-somatic.jpg": [
		957042,
		9,
		957042
	],
	"./education-center/images/sites/default/files/book_pages/exercise-intolerance-muscle-pain-and-lactic-acidemia.jpg": [
		465186,
		9,
		465186
	],
	"./education-center/images/sites/default/files/book_pages/exercise-intolerance.jpg": [
		240450,
		9,
		240450
	],
	"./education-center/images/sites/default/files/book_pages/exercise-stress-response-impaired-association.jpg": [
		172516,
		9,
		172516
	],
	"./education-center/images/sites/default/files/book_pages/exertional-myalgia-muscle-stiffness-and-myoglobinuria.jpg": [
		49428,
		9,
		49428
	],
	"./education-center/images/sites/default/files/book_pages/exostoses-multiple-type-1.jpg": [
		420598,
		9,
		420598
	],
	"./education-center/images/sites/default/files/book_pages/exostoses-multiple-type-2.jpg": [
		86868,
		9,
		86868
	],
	"./education-center/images/sites/default/files/book_pages/exudative-vitreoretinopathy-1.jpg": [
		609231,
		9,
		609231
	],
	"./education-center/images/sites/default/files/book_pages/exudative-vitreoretinopathy-4-autosomal-dominant.jpg": [
		900432,
		9,
		900432
	],
	"./education-center/images/sites/default/files/book_pages/exudative-vitreoretinopathy-4-autosomal-recessive.jpg": [
		66929,
		9,
		66929
	],
	"./education-center/images/sites/default/files/book_pages/exudative-vitreoretinopathy-4-digenic.jpg": [
		169065,
		9,
		169065
	],
	"./education-center/images/sites/default/files/book_pages/exudative-vitreoretinopathy-digenic.jpg": [
		63847,
		9,
		63847
	],
	"./education-center/images/sites/default/files/book_pages/eya4-related-disorders.jpg": [
		190994,
		9,
		190994
	],
	"./education-center/images/sites/default/files/book_pages/ezetimibe-response.jpg": [
		604081,
		9,
		604081
	],
	"./education-center/images/sites/default/files/book_pages/f12-related-disorders.jpg": [
		367079,
		9,
		367079
	],
	"./education-center/images/sites/default/files/book_pages/fabry-disease-cardiac-variant.jpg": [
		361163,
		9,
		361163
	],
	"./education-center/images/sites/default/files/book_pages/facial-hypotonia.jpg": [
		936076,
		9,
		936076
	],
	"./education-center/images/sites/default/files/book_pages/facioscapulohumeral-muscular-dystrophy-2.jpg": [
		368280,
		9,
		368280
	],
	"./education-center/images/sites/default/files/book_pages/factor-v-hong-kong.jpg": [
		300563,
		9,
		300563
	],
	"./education-center/images/sites/default/files/book_pages/factor-vii-marburg-i-variant-thrombophilia.jpg": [
		845826,
		9,
		845826
	],
	"./education-center/images/sites/default/files/book_pages/familial-amyloid-polyneuropathy-iowa-type.jpg": [
		356631,
		9,
		356631
	],
	"./education-center/images/sites/default/files/book_pages/familial-aortic-aneurysms.jpg": [
		231591,
		9,
		231591
	],
	"./education-center/images/sites/default/files/book_pages/familial-aortopathy.jpg": [
		771814,
		9,
		771814
	],
	"./education-center/images/sites/default/files/book_pages/familial-atypical-hemolytic-uremic-syndrome.jpg": [
		347042,
		9,
		347042
	],
	"./education-center/images/sites/default/files/book_pages/familial-atypical-mycobacteriosis-autosomal-dominant.jpg": [
		764412,
		9,
		764412
	],
	"./education-center/images/sites/default/files/book_pages/familial-atypical-mycobacteriosis-autosomal-recessive.jpg": [
		953747,
		9,
		953747
	],
	"./education-center/images/sites/default/files/book_pages/familial-candidiasis-recessive.jpg": [
		278726,
		9,
		278726
	],
	"./education-center/images/sites/default/files/book_pages/familial-cold-autoinflammatory-syndrome-1.jpg": [
		283930,
		9,
		283930
	],
	"./education-center/images/sites/default/files/book_pages/familial-congenital-nasolacrimal-duct-obstruction.jpg": [
		736816,
		9,
		736816
	],
	"./education-center/images/sites/default/files/book_pages/familial-cylindromatosis.jpg": [
		328803,
		9,
		328803
	],
	"./education-center/images/sites/default/files/book_pages/familial-ectopia-lentis.jpg": [
		120164,
		9,
		120164
	],
	"./education-center/images/sites/default/files/book_pages/familial-erythrocytosis.jpg": [
		855030,
		9,
		855030
	],
	"./education-center/images/sites/default/files/book_pages/familial-hematuria.jpg": [
		196968,
		9,
		196968
	],
	"./education-center/images/sites/default/files/book_pages/familial-hemiplegic-migraine.jpg": [
		650182,
		9,
		650182
	],
	"./education-center/images/sites/default/files/book_pages/familial-high-density-lipoprotein-deficiency.jpg": [
		484206,
		9,
		484206
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypercholesterolemia.jpg": [
		972045,
		9,
		972045
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypertrophic-cardiomyopathy-22.jpg": [
		438605,
		9,
		438605
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypertrophic-cardiomyopathy-24.jpg": [
		78411,
		9,
		78411
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypertrophic-cardiomyopathy-wolff-parkinson-white-syndrome.jpg": [
		459744,
		9,
		459744
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypoalphalipoproteinemia.jpg": [
		27477,
		9,
		27477
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypobetalipoproteinemia.jpg": [
		386203,
		9,
		386203
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypocalciuric-hypercalcemia-1.jpg": [
		621391,
		9,
		621391
	],
	"./education-center/images/sites/default/files/book_pages/familial-hypocalciuric-hypercalcemia-2.jpg": [
		908454,
		9,
		908454
	],
	"./education-center/images/sites/default/files/book_pages/familial-idiopathic-hypercalciuria.jpg": [
		202536,
		9,
		202536
	],
	"./education-center/images/sites/default/files/book_pages/familial-mediterranean-fever-autosomal-dominant.jpg": [
		259021,
		9,
		259021
	],
	"./education-center/images/sites/default/files/book_pages/familial-medullary-thyroid-carcinoma.jpg": [
		881209,
		9,
		881209
	],
	"./education-center/images/sites/default/files/book_pages/familial-partial-lipodystrophy-dunnigan-type.jpg": [
		729042,
		9,
		729042
	],
	"./education-center/images/sites/default/files/book_pages/familial-periodic-fever.jpg": [
		667075,
		9,
		667075
	],
	"./education-center/images/sites/default/files/book_pages/familial-periodic-paralysis.jpg": [
		592080,
		9,
		592080
	],
	"./education-center/images/sites/default/files/book_pages/familial-type-5-hyperlipoproteinemia.jpg": [
		812142,
		9,
		812142
	],
	"./education-center/images/sites/default/files/book_pages/familial-visceral-amyloidosis-ostertag-type.jpg": [
		602695,
		9,
		300493
	],
	"./education-center/images/sites/default/files/book_pages/family-history-cardiomyopathy.jpg": [
		296998,
		9,
		296998
	],
	"./education-center/images/sites/default/files/book_pages/family-history-sudden-cardiac-death.jpg": [
		622140,
		9,
		622140
	],
	"./education-center/images/sites/default/files/book_pages/family-history.jpg": [
		606608,
		9,
		606608
	],
	"./education-center/images/sites/default/files/book_pages/fanconi-anemia-complementation-group-m.jpg": [
		62678,
		9,
		62678
	],
	"./education-center/images/sites/default/files/book_pages/fanconi-anemia-x-linked.jpg": [
		527001,
		9,
		527001
	],
	"./education-center/images/sites/default/files/book_pages/fasting-plasma-glucose-level-quantitative-trait-locus-1.jpg": [
		22224,
		9,
		22224
	],
	"./education-center/images/sites/default/files/book_pages/fasting-plasma-glucose-level-quantitative-trait-locus-5.jpg": [
		174042,
		9,
		174042
	],
	"./education-center/images/sites/default/files/book_pages/fatal-infantile-cardioencephalomyopathy.jpg": [
		167955,
		9,
		167955
	],
	"./education-center/images/sites/default/files/book_pages/fatal-infantile-mitochondrial-cardiomyopathy.jpg": [
		561084,
		9,
		561084
	],
	"./education-center/images/sites/default/files/book_pages/febrile-seizures-familial-1.jpg": [
		428675,
		9,
		428675
	],
	"./education-center/images/sites/default/files/book_pages/febrile-seizures-familial.jpg": [
		706729,
		9,
		706729
	],
	"./education-center/images/sites/default/files/book_pages/fetal-cystic-hygroma.jpg": [
		931546,
		9,
		931546
	],
	"./education-center/images/sites/default/files/book_pages/fetal-hemoglobin-quantitative-trait-locus-1.jpg": [
		456106,
		9,
		456106
	],
	"./education-center/images/sites/default/files/book_pages/fetal-hemoglobin-quantitative-trait-locus-5.jpg": [
		23337,
		9,
		23337
	],
	"./education-center/images/sites/default/files/book_pages/fetal-hemoglobin-quantitative-trait-locus-6.jpg": [
		151055,
		9,
		151055
	],
	"./education-center/images/sites/default/files/book_pages/fgfr2-related-craniosynostosis.jpg": [
		557657,
		9,
		557657
	],
	"./education-center/images/sites/default/files/book_pages/fibrinogen-milano-xii-digenic.jpg": [
		449747,
		9,
		449747
	],
	"./education-center/images/sites/default/files/book_pages/fibromatosis-gingival-1.jpg": [
		608626,
		9,
		608626
	],
	"./education-center/images/sites/default/files/book_pages/fibromuscular-dysplasia-multifocal.jpg": [
		283107,
		9,
		283107
	],
	"./education-center/images/sites/default/files/book_pages/fibrous-dysplasia-jaw.jpg": [
		58968,
		9,
		58968
	],
	"./education-center/images/sites/default/files/book_pages/fibrous-sheath-dysplasia.jpg": [
		667508,
		9,
		667508
	],
	"./education-center/images/sites/default/files/book_pages/fig4-related-disorders.jpg": [
		613472,
		9,
		613472
	],
	"./education-center/images/sites/default/files/book_pages/first-degree-atrioventricular-block.jpg": [
		266998,
		9,
		266998
	],
	"./education-center/images/sites/default/files/book_pages/fish-eye-disease.jpg": [
		30041,
		9,
		30041
	],
	"./education-center/images/sites/default/files/book_pages/fleck-corneal-dystrophy.jpg": [
		204963,
		9,
		204963
	],
	"./education-center/images/sites/default/files/book_pages/flna-related-disorders.jpg": [
		801969,
		9,
		801969
	],
	"./education-center/images/sites/default/files/book_pages/flnb-related-disorders.jpg": [
		325083,
		9,
		325083
	],
	"./education-center/images/sites/default/files/book_pages/flnb-related-spectrum-disorders.jpg": [
		581926,
		9,
		581926
	],
	"./education-center/images/sites/default/files/book_pages/floating-harbor-syndrome.jpg": [
		195264,
		9,
		195264
	],
	"./education-center/images/sites/default/files/book_pages/flurbiprofen-response.jpg": [
		464902,
		9,
		464902
	],
	"./education-center/images/sites/default/files/book_pages/fmo3-activity-decreased.jpg": [
		646238,
		9,
		646238
	],
	"./education-center/images/sites/default/files/book_pages/focal-clonic-seizure.jpg": [
		374376,
		9,
		374376
	],
	"./education-center/images/sites/default/files/book_pages/focal-cortical-dysplasia-taylor-type-2b.jpg": [
		683637,
		9,
		683637
	],
	"./education-center/images/sites/default/files/book_pages/focal-impaired-awareness-seizure.jpg": [
		579264,
		9,
		579264
	],
	"./education-center/images/sites/default/files/book_pages/focal-onset-seizure.jpg": [
		899818,
		9,
		899818
	],
	"./education-center/images/sites/default/files/book_pages/focal-segmental-glomerulosclerosis-3.jpg": [
		26411,
		9,
		26411
	],
	"./education-center/images/sites/default/files/book_pages/focal-segmental-glomerulosclerosis-and-dilated-cardiomyopathy.jpg": [
		887872,
		9,
		887872
	],
	"./education-center/images/sites/default/files/book_pages/forebrain-defects.jpg": [
		316563,
		9,
		316563
	],
	"./education-center/images/sites/default/files/book_pages/foveal-hypoplasia-1-cataract.jpg": [
		938753,
		9,
		938753
	],
	"./education-center/images/sites/default/files/book_pages/foveal-hypoplasia-1-or-without-anterior-segment-anomalies.jpg": [
		837714,
		9,
		837714
	],
	"./education-center/images/sites/default/files/book_pages/foveal-hypoplasia-1.jpg": [
		74586,
		9,
		74586
	],
	"./education-center/images/sites/default/files/book_pages/foveal-hypoplasia-2-and-optic-nerve-misrouting-or-without-anterior-segment-dysgenesis.jpg": [
		411019,
		9,
		411019
	],
	"./education-center/images/sites/default/files/book_pages/frasier-syndrome.jpg": [
		346060,
		9,
		346060
	],
	"./education-center/images/sites/default/files/book_pages/frontorhiny.jpg": [
		614475,
		9,
		614475
	],
	"./education-center/images/sites/default/files/book_pages/frontotemporal-dementia-andor-amyotrophic-lateral-sclerosis-1.jpg": [
		449441,
		9,
		449441
	],
	"./education-center/images/sites/default/files/book_pages/frontotemporal-dementia-tdp43-inclusions-tardbp-related.jpg": [
		995530,
		9,
		995530
	],
	"./education-center/images/sites/default/files/book_pages/frontotemporal-lobar-degeneration-tardbp-related.jpg": [
		881253,
		9,
		881253
	],
	"./education-center/images/sites/default/files/book_pages/fulminant-hepatic-failure.jpg": [
		550585,
		9,
		550585
	],
	"./education-center/images/sites/default/files/book_pages/fumarylacetoacetase-pseudodeficiency.jpg": [
		386719,
		9,
		386719
	],
	"./education-center/images/sites/default/files/book_pages/fundus-albipunctatus-autosomal-recessive.jpg": [
		592397,
		9,
		592397
	],
	"./education-center/images/sites/default/files/book_pages/g6pd-deficiency.jpg": [
		176210,
		9,
		176210
	],
	"./education-center/images/sites/default/files/book_pages/galactose-epimerase-deficiency-severe.jpg": [
		502624,
		9,
		502624
	],
	"./education-center/images/sites/default/files/book_pages/galactosialidosis-adult.jpg": [
		614775,
		9,
		614775
	],
	"./education-center/images/sites/default/files/book_pages/galactosialidosis-early-infantile.jpg": [
		777457,
		9,
		777457
	],
	"./education-center/images/sites/default/files/book_pages/galactosialidosis-late-infantile.jpg": [
		235287,
		9,
		235287
	],
	"./education-center/images/sites/default/files/book_pages/gallbladder-cancer.jpg": [
		324658,
		9,
		324658
	],
	"./education-center/images/sites/default/files/book_pages/gallbladder-disease-4.jpg": [
		407371,
		9,
		407371
	],
	"./education-center/images/sites/default/files/book_pages/galloway-mowat-syndrome.jpg": [
		147237,
		9,
		147237
	],
	"./education-center/images/sites/default/files/book_pages/gars-associated-axonal-neuropathy.jpg": [
		388211,
		9,
		388211
	],
	"./education-center/images/sites/default/files/book_pages/gastric-cancer-familial-diffuse-and-cleft-lip-or-without-cleft-palate.jpg": [
		127210,
		9,
		127210
	],
	"./education-center/images/sites/default/files/book_pages/gastric-cancer.jpg": [
		686738,
		9,
		686738
	],
	"./education-center/images/sites/default/files/book_pages/gastrointestinal-hemorrhage.jpg": [
		642508,
		9,
		642508
	],
	"./education-center/images/sites/default/files/book_pages/gastrointestinal-polyposis.jpg": [
		449515,
		9,
		449515
	],
	"./education-center/images/sites/default/files/book_pages/gastrointestinal-stromal-tumor-familial.jpg": [
		865686,
		9,
		865686
	],
	"./education-center/images/sites/default/files/book_pages/gastrointestinal-stromal-tumor-small-intestine.jpg": [
		823984,
		9,
		823984
	],
	"./education-center/images/sites/default/files/book_pages/gbe1-related-disorders.jpg": [
		610367,
		9,
		610367
	],
	"./education-center/images/sites/default/files/book_pages/gefitinib-response-efficacy.jpg": [
		815737,
		9,
		815737
	],
	"./education-center/images/sites/default/files/book_pages/gefitinib-response.jpg": [
		747412,
		9,
		747412
	],
	"./education-center/images/sites/default/files/book_pages/geleophysic-dysplasia.jpg": [
		790271,
		9,
		790271
	],
	"./education-center/images/sites/default/files/book_pages/gemcitabine-response.jpg": [
		90234,
		9,
		90234
	],
	"./education-center/images/sites/default/files/book_pages/generalized-cerebral-atrophyhypoplasia.jpg": [
		342573,
		9,
		342573
	],
	"./education-center/images/sites/default/files/book_pages/generalized-dominant-dystrophic-epidermolysis-bullosa.jpg": [
		579896,
		9,
		579896
	],
	"./education-center/images/sites/default/files/book_pages/generalized-dystonia.jpg": [
		320368,
		9,
		320368
	],
	"./education-center/images/sites/default/files/book_pages/generalized-epilepsy-febrile-seizures-plus-3.jpg": [
		154873,
		9,
		154873
	],
	"./education-center/images/sites/default/files/book_pages/generalized-epilepsy-febrile-seizures-plus-type-5.jpg": [
		863306,
		9,
		863306
	],
	"./education-center/images/sites/default/files/book_pages/generalized-hypotonia.jpg": [
		90526,
		9,
		90526
	],
	"./education-center/images/sites/default/files/book_pages/generalized-muscle-weakness.jpg": [
		430659,
		9,
		430659
	],
	"./education-center/images/sites/default/files/book_pages/generalized-myoclonic-seizure.jpg": [
		616284,
		9,
		616284
	],
	"./education-center/images/sites/default/files/book_pages/generalized-non-motor-absence-seizure.jpg": [
		110888,
		9,
		110888
	],
	"./education-center/images/sites/default/files/book_pages/generalized-onset-seizure.jpg": [
		461833,
		9,
		461833
	],
	"./education-center/images/sites/default/files/book_pages/generalized-tonic-clonic-seizures.jpg": [
		953634,
		9,
		953634
	],
	"./education-center/images/sites/default/files/book_pages/genetic-non-acquired-premature-ovarian-failure.jpg": [
		356060,
		9,
		356060
	],
	"./education-center/images/sites/default/files/book_pages/gentamicin-response.jpg": [
		291810,
		9,
		291810
	],
	"./education-center/images/sites/default/files/book_pages/gerstmann-straussler-scheinker-syndrome.jpg": [
		339085,
		9,
		339085
	],
	"./education-center/images/sites/default/files/book_pages/gestational-diabetes-mellitus-uncontrolled.jpg": [
		851513,
		9,
		851513
	],
	"./education-center/images/sites/default/files/book_pages/gestational-diabetes.jpg": [
		372649,
		9,
		372649
	],
	"./education-center/images/sites/default/files/book_pages/ghosal-hematodiaphyseal-syndrome.jpg": [
		165890,
		9,
		165890
	],
	"./education-center/images/sites/default/files/book_pages/gil-blood-group.jpg": [
		803453,
		9,
		803453
	],
	"./education-center/images/sites/default/files/book_pages/gilbert-syndrome-susceptibility.jpg": [
		378147,
		9,
		378147
	],
	"./education-center/images/sites/default/files/book_pages/gilbert-syndrome.jpg": [
		479707,
		9,
		479707
	],
	"./education-center/images/sites/default/files/book_pages/gillessen-kaesbach-nishimura-dysplasia.jpg": [
		658304,
		9,
		658304
	],
	"./education-center/images/sites/default/files/book_pages/gingival-fibromatosis-hypertrichosis-syndrome.jpg": [
		663096,
		9,
		663096
	],
	"./education-center/images/sites/default/files/book_pages/gjb6-related-disorders.jpg": [
		315164,
		9,
		315164
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-autosomal-recessive.jpg": [
		993454,
		9,
		993454
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-b.jpg": [
		161525,
		9,
		161525
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-digenic.jpg": [
		400917,
		9,
		400917
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-e.jpg": [
		885059,
		9,
		885059
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-f.jpg": [
		898119,
		9,
		898119
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-g.jpg": [
		793717,
		9,
		793717
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle-p.jpg": [
		386173,
		9,
		386173
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-1-open-angle.jpg": [
		925446,
		9,
		925446
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-3-primary-congenital-digenic.jpg": [
		686974,
		9,
		686974
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-early-onset-digenic.jpg": [
		500944,
		9,
		500944
	],
	"./education-center/images/sites/default/files/book_pages/glaucoma-primary-open-angle-juvenile-onset.jpg": [
		376351,
		9,
		376351
	],
	"./education-center/images/sites/default/files/book_pages/glb1-related-disorders.jpg": [
		203905,
		9,
		203905
	],
	"./education-center/images/sites/default/files/book_pages/gli3-related-disorders.jpg": [
		744721,
		9,
		744721
	],
	"./education-center/images/sites/default/files/book_pages/glibenclamide-response.jpg": [
		402669,
		9,
		402669
	],
	"./education-center/images/sites/default/files/book_pages/glioblastoma-multiforme-somatic.jpg": [
		155442,
		9,
		155442
	],
	"./education-center/images/sites/default/files/book_pages/glioblastoma-multiforme.jpg": [
		211037,
		9,
		211037
	],
	"./education-center/images/sites/default/files/book_pages/glipizide-response.jpg": [
		50748,
		9,
		50748
	],
	"./education-center/images/sites/default/files/book_pages/global-developmental-delay.jpg": [
		280997,
		9,
		280997
	],
	"./education-center/images/sites/default/files/book_pages/globozoospermia.jpg": [
		750707,
		9,
		750707
	],
	"./education-center/images/sites/default/files/book_pages/glomuvenous-malformation.jpg": [
		419866,
		9,
		419866
	],
	"./education-center/images/sites/default/files/book_pages/glucocorticoid-deficiency.jpg": [
		65714,
		9,
		65714
	],
	"./education-center/images/sites/default/files/book_pages/glucocorticoid-remediable-aldosteronism.jpg": [
		996238,
		9,
		996238
	],
	"./education-center/images/sites/default/files/book_pages/glucocorticoid-resistance-cellular.jpg": [
		433732,
		9,
		433732
	],
	"./education-center/images/sites/default/files/book_pages/glucocorticoid-resistance-relative.jpg": [
		217652,
		9,
		217652
	],
	"./education-center/images/sites/default/files/book_pages/glucose-6-phosphate-transport-defect.jpg": [
		312946,
		9,
		312946
	],
	"./education-center/images/sites/default/files/book_pages/glut1-deficiency-syndrome-1-autosomal-recessive.jpg": [
		233496,
		9,
		233496
	],
	"./education-center/images/sites/default/files/book_pages/glut1-deficiency-syndrome.jpg": [
		49249,
		9,
		49249
	],
	"./education-center/images/sites/default/files/book_pages/glutaric-acidemia-iic-late-onset.jpg": [
		62835,
		9,
		62835
	],
	"./education-center/images/sites/default/files/book_pages/glycerol-release-during-exercise-defective.jpg": [
		916539,
		9,
		916539
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-phosphorylase-kinase-deficiency.jpg": [
		401864,
		9,
		401864
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-due-phosphoglycerate-kinase-1-deficiency.jpg": [
		448101,
		9,
		448101
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-ii-adult-form.jpg": [
		957187,
		9,
		957187
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iiia.jpg": [
		530648,
		9,
		530648
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iiib.jpg": [
		541658,
		9,
		541658
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iiic.jpg": [
		984471,
		9,
		984471
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iv-classic-hepatic.jpg": [
		714549,
		9,
		714549
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iv-combined-hepatic-and-myopathic.jpg": [
		232826,
		9,
		232826
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-iv-nonprogressive-hepatic.jpg": [
		91587,
		9,
		91587
	],
	"./education-center/images/sites/default/files/book_pages/glycogen-storage-disease-type-ii-infantile.jpg": [
		114810,
		9,
		114810
	],
	"./education-center/images/sites/default/files/book_pages/gm1-gangliosidosis-type-i-cardiac-involvement.jpg": [
		357135,
		9,
		357135
	],
	"./education-center/images/sites/default/files/book_pages/gm2-ganglioside-accumulation.jpg": [
		689891,
		9,
		689891
	],
	"./education-center/images/sites/default/files/book_pages/gm2-gangliosidosis-adult-onset.jpg": [
		146322,
		9,
		146322
	],
	"./education-center/images/sites/default/files/book_pages/gm2-gangliosidosis-chronic.jpg": [
		221241,
		9,
		221241
	],
	"./education-center/images/sites/default/files/book_pages/gm2-gangliosidosis-juvenile.jpg": [
		860080,
		9,
		860080
	],
	"./education-center/images/sites/default/files/book_pages/gm2-gangliosidosis-variant-b1.jpg": [
		983076,
		9,
		983076
	],
	"./education-center/images/sites/default/files/book_pages/gnptab-related-disorders.jpg": [
		618758,
		9,
		618758
	],
	"./education-center/images/sites/default/files/book_pages/gonadotropin-deficiency.jpg": [
		549425,
		9,
		549425
	],
	"./education-center/images/sites/default/files/book_pages/gordon-syndrome.jpg": [
		979531,
		9,
		979531
	],
	"./education-center/images/sites/default/files/book_pages/gorham-stout-disease.jpg": [
		657791,
		9,
		657791
	],
	"./education-center/images/sites/default/files/book_pages/gorlin-syndrome.jpg": [
		496320,
		9,
		496320
	],
	"./education-center/images/sites/default/files/book_pages/gpsm2-related-disorders.jpg": [
		631602,
		9,
		631602
	],
	"./education-center/images/sites/default/files/book_pages/graft-versus-host-disease-resistance.jpg": [
		765907,
		9,
		765907
	],
	"./education-center/images/sites/default/files/book_pages/granular-corneal-dystrophy.jpg": [
		338133,
		9,
		338133
	],
	"./education-center/images/sites/default/files/book_pages/granulomatous-disease-chronic-x-linked-variant.jpg": [
		425024,
		9,
		425024
	],
	"./education-center/images/sites/default/files/book_pages/granulosa-cell-tumor.jpg": [
		661233,
		9,
		661233
	],
	"./education-center/images/sites/default/files/book_pages/gray-platelet-syndrome.jpg": [
		996532,
		9,
		996532
	],
	"./education-center/images/sites/default/files/book_pages/greig-cephalopolysyndactyly-syndrome-severe.jpg": [
		699308,
		9,
		699308
	],
	"./education-center/images/sites/default/files/book_pages/groenouw-corneal-dystrophy-type-i.jpg": [
		642461,
		9,
		234691
	],
	"./education-center/images/sites/default/files/book_pages/growth-hormone-deficiency-pituitary-anomalies.jpg": [
		444494,
		9,
		444494
	],
	"./education-center/images/sites/default/files/book_pages/guanidinoacetate-methyltransferase-gamt-deficiency.jpg": [
		379582,
		9,
		379582
	],
	"./education-center/images/sites/default/files/book_pages/gyrate-atrophy-choroid-and-retina-pyridoxine-responsive-ornithinemia.jpg": [
		987596,
		9,
		987596
	],
	"./education-center/images/sites/default/files/book_pages/haemorrhagic-telangiectasia-1.jpg": [
		697578,
		9,
		697578
	],
	"./education-center/images/sites/default/files/book_pages/haemorrhagic-telangiectasia-2.jpg": [
		684399,
		9,
		684399
	],
	"./education-center/images/sites/default/files/book_pages/hair-morphology-1-hair-thickness.jpg": [
		117298,
		9,
		117298
	],
	"./education-center/images/sites/default/files/book_pages/hajdu-cheney-syndrome.jpg": [
		440824,
		9,
		440824
	],
	"./education-center/images/sites/default/files/book_pages/hamartoma.jpg": [
		628301,
		9,
		628301
	],
	"./education-center/images/sites/default/files/book_pages/hamartomatous-polyposis.jpg": [
		279304,
		9,
		279304
	],
	"./education-center/images/sites/default/files/book_pages/hand-foot-genital-syndrome.jpg": [
		177546,
		9,
		177546
	],
	"./education-center/images/sites/default/files/book_pages/hand-muscle-atrophy.jpg": [
		33204,
		9,
		33204
	],
	"./education-center/images/sites/default/files/book_pages/hatipoglu-immunodeficiency-syndrome.jpg": [
		582966,
		9,
		216890
	],
	"./education-center/images/sites/default/files/book_pages/hawkinsinuria.jpg": [
		810527,
		9,
		810527
	],
	"./education-center/images/sites/default/files/book_pages/hbb-related-disorders.jpg": [
		811130,
		9,
		811130
	],
	"./education-center/images/sites/default/files/book_pages/head-and-neck-cancer.jpg": [
		890274,
		9,
		890274
	],
	"./education-center/images/sites/default/files/book_pages/head-and-neck-neoplasm.jpg": [
		953881,
		9,
		953881
	],
	"./education-center/images/sites/default/files/book_pages/hearing-loss.jpg": [
		645843,
		9,
		645843
	],
	"./education-center/images/sites/default/files/book_pages/heart-block-nonprogressive.jpg": [
		519517,
		9,
		519517
	],
	"./education-center/images/sites/default/files/book_pages/hecht-syndrome.jpg": [
		362581,
		9,
		362581
	],
	"./education-center/images/sites/default/files/book_pages/heimler-syndrome-1.jpg": [
		667980,
		9,
		667980
	],
	"./education-center/images/sites/default/files/book_pages/heimler-syndrome-2.jpg": [
		682105,
		9,
		682105
	],
	"./education-center/images/sites/default/files/book_pages/heinz-body-anemia.jpg": [
		491765,
		9,
		491765
	],
	"./education-center/images/sites/default/files/book_pages/helicoid-peripapillary-chorioretinal-degeneration.jpg": [
		774341,
		9,
		774341
	],
	"./education-center/images/sites/default/files/book_pages/hemangioma.jpg": [
		786552,
		9,
		786552
	],
	"./education-center/images/sites/default/files/book_pages/hemangiomatosis.jpg": [
		934037,
		9,
		934037
	],
	"./education-center/images/sites/default/files/book_pages/hematologic-neoplasm.jpg": [
		260933,
		9,
		260933
	],
	"./education-center/images/sites/default/files/book_pages/hemihypertrophy.jpg": [
		625121,
		9,
		625121
	],
	"./education-center/images/sites/default/files/book_pages/hemiplegia.jpg": [
		14352,
		9,
		14352
	],
	"./education-center/images/sites/default/files/book_pages/hemiplegiahemiparesis.jpg": [
		134775,
		9,
		134775
	],
	"./education-center/images/sites/default/files/book_pages/hemochromatosis-juvenile-digenic.jpg": [
		733773,
		9,
		733773
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-constant-spring.jpg": [
		795944,
		9,
		795944
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-h-disease-nondeletional.jpg": [
		919709,
		9,
		919709
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-h-hydrops-fetalis-syndrome.jpg": [
		352503,
		9,
		352503
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-lepore-trait.jpg": [
		861395,
		9,
		861395
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-s.jpg": [
		26248,
		9,
		26248
	],
	"./education-center/images/sites/default/files/book_pages/hemoglobin-val-de-marne.jpg": [
		959079,
		9,
		959079
	],
	"./education-center/images/sites/default/files/book_pages/hemolytic-anemia-nonspherocytic-and-neurologic-deficits-due-glucose-phosphate-isomerase-deficiency.jpg": [
		91908,
		9,
		91908
	],
	"./education-center/images/sites/default/files/book_pages/hemolytic-disease-fetus-or-newborn-due-isoimmunization.jpg": [
		426350,
		9,
		426350
	],
	"./education-center/images/sites/default/files/book_pages/hemolytic-uremic-syndrome-atypical-susceptibility-7.jpg": [
		910224,
		9,
		910224
	],
	"./education-center/images/sites/default/files/book_pages/hemolytic-uremic-syndrome.jpg": [
		34090,
		9,
		34090
	],
	"./education-center/images/sites/default/files/book_pages/hemophagocytosis.jpg": [
		378391,
		9,
		378391
	],
	"./education-center/images/sites/default/files/book_pages/hemophilia-b-factor-ix-deficiency.jpg": [
		428953,
		9,
		428953
	],
	"./education-center/images/sites/default/files/book_pages/hemophilia-bm.jpg": [
		967515,
		9,
		967515
	],
	"./education-center/images/sites/default/files/book_pages/hemophilia-fviii-deficiency.jpg": [
		977323,
		9,
		977323
	],
	"./education-center/images/sites/default/files/book_pages/hemorrhage.jpg": [
		361016,
		9,
		361016
	],
	"./education-center/images/sites/default/files/book_pages/hemosiderosis-systemic-due-aceruloplasminemia.jpg": [
		54857,
		9,
		54857
	],
	"./education-center/images/sites/default/files/book_pages/hepatitis-b-virus-resistance.jpg": [
		75254,
		9,
		75254
	],
	"./education-center/images/sites/default/files/book_pages/hepatitis-c-virus-infection-response-therapy.jpg": [
		869036,
		9,
		869036
	],
	"./education-center/images/sites/default/files/book_pages/hepatocellular-carcinoma.jpg": [
		578874,
		9,
		578874
	],
	"./education-center/images/sites/default/files/book_pages/hepatorenocardiac-degenerative-fibrosis.jpg": [
		26004,
		9,
		26004
	],
	"./education-center/images/sites/default/files/book_pages/her2-positive-breast-carcinoma.jpg": [
		362869,
		9,
		362869
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-arterial-and-articular-multiple-calcification-syndrome.jpg": [
		489317,
		9,
		489317
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-cancer.jpg": [
		867473,
		9,
		867473
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-cerebral-amyloid-angiopathy-icelandic-type.jpg": [
		308107,
		9,
		308107
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-cerebral-hemorrhage-amyloidosis.jpg": [
		76826,
		9,
		76826
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-coproporphyria.jpg": [
		495889,
		9,
		495889
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-diffuse-gastric-adenocarcinoma.jpg": [
		152179,
		9,
		152179
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-essential-tremor.jpg": [
		64254,
		9,
		64254
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-hearing-loss-and-deafness.jpg": [
		635949,
		9,
		635949
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-hemochromatosis.jpg": [
		569582,
		9,
		569582
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-hypercarotenemia-and-vitamin-deficiency.jpg": [
		177308,
		9,
		177308
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-leiomyomatosis-and-renal-cell-cancer.jpg": [
		569716,
		9,
		569716
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-lymphedema-type-i.jpg": [
		10651,
		9,
		10651
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-multiple-osteochondromatosis.jpg": [
		916675,
		9,
		916675
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-neuralgic-amyotrophy-hna.jpg": [
		858178,
		9,
		858178
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-nonpolyposis-colorectal-carcinoma.jpg": [
		54642,
		9,
		54642
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-nonpolyposis-colorectal-neoplasms.jpg": [
		825673,
		9,
		825673
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-orotic-aciduria-type-1.jpg": [
		290924,
		9,
		290924
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-sideroblastic-anemia-myopathy-and-lactic-acidosis.jpg": [
		455228,
		9,
		455228
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-spherocytosis-type-2.jpg": [
		681465,
		9,
		681465
	],
	"./education-center/images/sites/default/files/book_pages/hereditary-spherocytosis.jpg": [
		437248,
		9,
		437248
	],
	"./education-center/images/sites/default/files/book_pages/heritable-thoracic-aortic-disease.jpg": [
		444655,
		9,
		444655
	],
	"./education-center/images/sites/default/files/book_pages/heterogeneous-nuclear-ribonucleoprotein-g-human.jpg": [
		611788,
		9,
		611788
	],
	"./education-center/images/sites/default/files/book_pages/heterotaxy-visceral-12-autosomal.jpg": [
		569785,
		9,
		569785
	],
	"./education-center/images/sites/default/files/book_pages/heterotaxy.jpg": [
		970647,
		9,
		970647
	],
	"./education-center/images/sites/default/files/book_pages/hexosaminidase-b-paris.jpg": [
		347318,
		9,
		347318
	],
	"./education-center/images/sites/default/files/book_pages/hiatus-hernia.jpg": [
		954773,
		9,
		954773
	],
	"./education-center/images/sites/default/files/book_pages/hidrotic-ectodermal-dysplasia-syndrome.jpg": [
		3529,
		9,
		3529
	],
	"./education-center/images/sites/default/files/book_pages/high-bone-mass.jpg": [
		538140,
		9,
		538140
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-10.jpg": [
		436116,
		9,
		436116
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-11.jpg": [
		252083,
		9,
		252083
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-12.jpg": [
		986312,
		9,
		986312
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.jpg": [
		9896,
		9,
		9896
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.jpg": [
		601347,
		9,
		601347
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.jpg": [
		534276,
		9,
		534276
	],
	"./education-center/images/sites/default/files/book_pages/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-9.jpg": [
		210762,
		9,
		210762
	],
	"./education-center/images/sites/default/files/book_pages/high-grade-surface-osteosarcoma.jpg": [
		114792,
		9,
		114792
	],
	"./education-center/images/sites/default/files/book_pages/high-myopia.jpg": [
		955582,
		9,
		955582
	],
	"./education-center/images/sites/default/files/book_pages/hip-dysplasia-beukes-type.jpg": [
		851787,
		9,
		851787
	],
	"./education-center/images/sites/default/files/book_pages/hirschsprung-disease-dominant.jpg": [
		273339,
		9,
		273339
	],
	"./education-center/images/sites/default/files/book_pages/hirschsprung-disease-intellectual-disability-syndrome-late-infantile.jpg": [
		761650,
		9,
		761650
	],
	"./education-center/images/sites/default/files/book_pages/hirschsprung-disease-protection-against.jpg": [
		436526,
		9,
		436526
	],
	"./education-center/images/sites/default/files/book_pages/hirschsprung-disease-recessive.jpg": [
		185389,
		9,
		185389
	],
	"./education-center/images/sites/default/files/book_pages/hirschsprung-disease-susceptibility-1.jpg": [
		208556,
		9,
		208556
	],
	"./education-center/images/sites/default/files/book_pages/history-neurodevelopmental-disorder.jpg": [
		158007,
		9,
		158007
	],
	"./education-center/images/sites/default/files/book_pages/hiv-1-viremia-susceptibility.jpg": [
		491792,
		9,
		491792
	],
	"./education-center/images/sites/default/files/book_pages/holoprosencephaly-2.jpg": [
		883770,
		9,
		883770
	],
	"./education-center/images/sites/default/files/book_pages/holoprosencephaly-3.jpg": [
		991719,
		9,
		991719
	],
	"./education-center/images/sites/default/files/book_pages/holoprosencephaly-4.jpg": [
		315776,
		9,
		315776
	],
	"./education-center/images/sites/default/files/book_pages/holt-oram-syndrome.jpg": [
		958569,
		9,
		958569
	],
	"./education-center/images/sites/default/files/book_pages/homocysteine-level-elevated.jpg": [
		833606,
		9,
		833606
	],
	"./education-center/images/sites/default/files/book_pages/homocystinuria-cbld-type-variant-1.jpg": [
		588441,
		9,
		588441
	],
	"./education-center/images/sites/default/files/book_pages/homocystinuria-due-mthfr-deficiency.jpg": [
		906051,
		9,
		906051
	],
	"./education-center/images/sites/default/files/book_pages/homocystinuria-pyridoxine-nonresponsive.jpg": [
		607003,
		9,
		607003
	],
	"./education-center/images/sites/default/files/book_pages/homocystinuria-pyridoxine-responsive.jpg": [
		433250,
		9,
		433250
	],
	"./education-center/images/sites/default/files/book_pages/hr-related-disorders.jpg": [
		984251,
		9,
		984251
	],
	"./education-center/images/sites/default/files/book_pages/human-immunodeficiency-virus-type-1-delayed-disease-progression-infection.jpg": [
		518275,
		9,
		518275
	],
	"./education-center/images/sites/default/files/book_pages/human-immunodeficiency-virus-type-1-increased-perinatal-transmission.jpg": [
		565511,
		9,
		565511
	],
	"./education-center/images/sites/default/files/book_pages/human-immunodeficiency-virus-type-1-rapid-disease-progression-infection.jpg": [
		561187,
		9,
		561187
	],
	"./education-center/images/sites/default/files/book_pages/human-immunodeficiency-virus-type-1-rapid-progression-aids.jpg": [
		534379,
		9,
		534379
	],
	"./education-center/images/sites/default/files/book_pages/huntington-disease.jpg": [
		98338,
		9,
		98338
	],
	"./education-center/images/sites/default/files/book_pages/hutchinson-gilford-progeria-syndrome-atypical.jpg": [
		521576,
		9,
		521576
	],
	"./education-center/images/sites/default/files/book_pages/hutchinson-gilford-progeria-syndrome-childhood-onset.jpg": [
		266945,
		9,
		266945
	],
	"./education-center/images/sites/default/files/book_pages/hyalinosis-segmental-glomerular.jpg": [
		63390,
		9,
		63390
	],
	"./education-center/images/sites/default/files/book_pages/hydatidiform-mole.jpg": [
		679802,
		9,
		679802
	],
	"./education-center/images/sites/default/files/book_pages/hydranencephaly-abnormal-genitalia.jpg": [
		62724,
		9,
		62724
	],
	"./education-center/images/sites/default/files/book_pages/hydrocephalus-due-aqueductal-stenosis.jpg": [
		923145,
		9,
		923145
	],
	"./education-center/images/sites/default/files/book_pages/hydrocephalus-x-linked-congenital-idiopathic-intestinal-pseudoobstruction.jpg": [
		77763,
		9,
		77763
	],
	"./education-center/images/sites/default/files/book_pages/hydrocephalus.jpg": [
		983958,
		9,
		983958
	],
	"./education-center/images/sites/default/files/book_pages/hydrochlorothiazide-response-efficacy.jpg": [
		176419,
		9,
		176419
	],
	"./education-center/images/sites/default/files/book_pages/hydrolethalus-syndrome.jpg": [
		300771,
		9,
		300771
	],
	"./education-center/images/sites/default/files/book_pages/hyper-ige-recurrent-infection-syndrome-1.jpg": [
		523308,
		9,
		523308
	],
	"./education-center/images/sites/default/files/book_pages/hyperalphalipoproteinemia-1.jpg": [
		488198,
		9,
		488198
	],
	"./education-center/images/sites/default/files/book_pages/hyperammonemia.jpg": [
		383831,
		9,
		383831
	],
	"./education-center/images/sites/default/files/book_pages/hyperandrogenism-nonclassic-type-due-21-hydroxylase-deficiency.jpg": [
		955473,
		9,
		955473
	],
	"./education-center/images/sites/default/files/book_pages/hyperapobetalipoproteinemia-susceptibility.jpg": [
		84092,
		9,
		84092
	],
	"./education-center/images/sites/default/files/book_pages/hypercalcemia.jpg": [
		571099,
		9,
		571099
	],
	"./education-center/images/sites/default/files/book_pages/hypercalciuria-childhood-self-limiting.jpg": [
		522352,
		9,
		522352
	],
	"./education-center/images/sites/default/files/book_pages/hypercholesterolemia-autosomal-dominant-type-b.jpg": [
		497270,
		9,
		497270
	],
	"./education-center/images/sites/default/files/book_pages/hypercholesterolemia-familial-1.jpg": [
		901714,
		9,
		901714
	],
	"./education-center/images/sites/default/files/book_pages/hypercholesterolemia-susceptibility.jpg": [
		13396,
		9,
		13396
	],
	"./education-center/images/sites/default/files/book_pages/hypercholesterolemia.jpg": [
		677716,
		9,
		677716
	],
	"./education-center/images/sites/default/files/book_pages/hyperechogenic-kidneys.jpg": [
		650555,
		9,
		650555
	],
	"./education-center/images/sites/default/files/book_pages/hyperekplexia-1.jpg": [
		654958,
		9,
		654958
	],
	"./education-center/images/sites/default/files/book_pages/hypereosinophilic-syndrome-idiopathic-resistant-imatinib.jpg": [
		375443,
		9,
		375443
	],
	"./education-center/images/sites/default/files/book_pages/hyperglycinuria.jpg": [
		526217,
		9,
		526217
	],
	"./education-center/images/sites/default/files/book_pages/hypergonadotropic-hypogonadism.jpg": [
		342373,
		9,
		342373
	],
	"./education-center/images/sites/default/files/book_pages/hyperhomocysteinemia-thrombotic-cbs-related.jpg": [
		271038,
		9,
		271038
	],
	"./education-center/images/sites/default/files/book_pages/hyperinsulinemic-hypoglycemia.jpg": [
		789540,
		9,
		789540
	],
	"./education-center/images/sites/default/files/book_pages/hyperinsulinism-dominant.jpg": [
		932250,
		9,
		932250
	],
	"./education-center/images/sites/default/files/book_pages/hyperinsulinism-dominantrecessive.jpg": [
		172615,
		9,
		172615
	],
	"./education-center/images/sites/default/files/book_pages/hyperkeratotic-cutaneous-capillary-venous-malformations-associated-cerebral-capillary-malformations.jpg": [
		643829,
		9,
		643829
	],
	"./education-center/images/sites/default/files/book_pages/hyperlipidemia-familial-combined-lpl-related.jpg": [
		433452,
		9,
		433452
	],
	"./education-center/images/sites/default/files/book_pages/hyperlipidemia-familial-combined-susceptibility.jpg": [
		762634,
		9,
		762634
	],
	"./education-center/images/sites/default/files/book_pages/hyperlipoproteinemia-type-iii-due-apoe2.jpg": [
		457519,
		9,
		457519
	],
	"./education-center/images/sites/default/files/book_pages/hypermagnesemia.jpg": [
		302529,
		9,
		302529
	],
	"./education-center/images/sites/default/files/book_pages/hypermetabolism-due-uncoupled-mitochondrial-oxidative-phosphorylation-2.jpg": [
		568719,
		9,
		568719
	],
	"./education-center/images/sites/default/files/book_pages/hypermethioninemia.jpg": [
		569906,
		9,
		569906
	],
	"./education-center/images/sites/default/files/book_pages/hyperornithinemia.jpg": [
		40962,
		9,
		40962
	],
	"./education-center/images/sites/default/files/book_pages/hyperostosis-cranialis-interna.jpg": [
		789121,
		9,
		789121
	],
	"./education-center/images/sites/default/files/book_pages/hyperparathyroidism-1.jpg": [
		974268,
		9,
		974268
	],
	"./education-center/images/sites/default/files/book_pages/hyperparathyroidism-2-jaw-tumors.jpg": [
		426264,
		9,
		426264
	],
	"./education-center/images/sites/default/files/book_pages/hyperphenylalaninemia-bh4-deficient-due-partial-pts-deficiency.jpg": [
		81327,
		9,
		81327
	],
	"./education-center/images/sites/default/files/book_pages/hyperphenylalaninemia.jpg": [
		209665,
		9,
		209665
	],
	"./education-center/images/sites/default/files/book_pages/hyperpigmentation-or-without-hypopigmentation-familial-progressive.jpg": [
		729589,
		9,
		729589
	],
	"./education-center/images/sites/default/files/book_pages/hyperproreninemia-familial.jpg": [
		468259,
		9,
		468259
	],
	"./education-center/images/sites/default/files/book_pages/hypertaurinuric-cardiomyopathy.jpg": [
		47486,
		9,
		47486
	],
	"./education-center/images/sites/default/files/book_pages/hypertension-diastolic-resistance.jpg": [
		550132,
		9,
		550132
	],
	"./education-center/images/sites/default/files/book_pages/hypertension-early-onset-autosomal-dominant-exacerbation-pregnancy.jpg": [
		948212,
		9,
		948212
	],
	"./education-center/images/sites/default/files/book_pages/hypertension-pregnancy-induced-susceptibility.jpg": [
		623482,
		9,
		623482
	],
	"./education-center/images/sites/default/files/book_pages/hypertension-resistant-conventional-therapy.jpg": [
		528929,
		9,
		528929
	],
	"./education-center/images/sites/default/files/book_pages/hypertension-salt-sensitive-essential-susceptibility.jpg": [
		968291,
		9,
		968291
	],
	"./education-center/images/sites/default/files/book_pages/hyperthyroxinemia-dysalbuminemic.jpg": [
		360538,
		9,
		360538
	],
	"./education-center/images/sites/default/files/book_pages/hyperthyroxinemia-dystransthyretinemic.jpg": [
		978363,
		9,
		978363
	],
	"./education-center/images/sites/default/files/book_pages/hypertriglyceridemia-2.jpg": [
		548886,
		9,
		548886
	],
	"./education-center/images/sites/default/files/book_pages/hypertriglyceridemia-familial.jpg": [
		239156,
		9,
		239156
	],
	"./education-center/images/sites/default/files/book_pages/hypertrophic-cardiomyopathy-2.jpg": [
		392093,
		9,
		392093
	],
	"./education-center/images/sites/default/files/book_pages/hypertrophic-cardiomyopathy-4.jpg": [
		506831,
		9,
		506831
	],
	"./education-center/images/sites/default/files/book_pages/hypertyrosinemia.jpg": [
		16705,
		9,
		16705
	],
	"./education-center/images/sites/default/files/book_pages/hypoadiponectinemia.jpg": [
		583743,
		9,
		583743
	],
	"./education-center/images/sites/default/files/book_pages/hypoalphalipoproteinemia-primary-2-intermediate.jpg": [
		444088,
		9,
		444088
	],
	"./education-center/images/sites/default/files/book_pages/hypoammonemia.jpg": [
		241418,
		9,
		241418
	],
	"./education-center/images/sites/default/files/book_pages/hypoceruloplasminemia.jpg": [
		58064,
		9,
		58064
	],
	"./education-center/images/sites/default/files/book_pages/hypochondroplasia.jpg": [
		66290,
		9,
		66290
	],
	"./education-center/images/sites/default/files/book_pages/hypodysfibrinogenemia.jpg": [
		465125,
		9,
		465125
	],
	"./education-center/images/sites/default/files/book_pages/hypofibrinogenemia.jpg": [
		430422,
		9,
		430422
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-10-without-anosmia.jpg": [
		36263,
		9,
		36263
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-14-anosmia.jpg": [
		796449,
		9,
		796449
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-15-anosmia.jpg": [
		753821,
		9,
		753821
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-18-anosmia.jpg": [
		367794,
		9,
		367794
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-2-anosmia.jpg": [
		633516,
		9,
		633516
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-2-or-without-anosmia.jpg": [
		680598,
		9,
		680598
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-20-without-anosmia.jpg": [
		883909,
		9,
		883909
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-22-anosmia.jpg": [
		835923,
		9,
		835923
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-3-without-anosmia.jpg": [
		985970,
		9,
		985970
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-5-without-anosmia.jpg": [
		579887,
		9,
		579887
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-7-or-without-anosmia.jpg": [
		643051,
		9,
		643051
	],
	"./education-center/images/sites/default/files/book_pages/hypogonadotropic-hypogonadism-8-without-anosmia.jpg": [
		293207,
		9,
		293207
	],
	"./education-center/images/sites/default/files/book_pages/hypohidrotic-ectodermal-dysplasia-dominant.jpg": [
		857762,
		9,
		857762
	],
	"./education-center/images/sites/default/files/book_pages/hypohidrotic-ectodermal-dysplasia-recessive.jpg": [
		823875,
		9,
		823875
	],
	"./education-center/images/sites/default/files/book_pages/hypoinsulinemia.jpg": [
		403524,
		9,
		403524
	],
	"./education-center/images/sites/default/files/book_pages/hypokalemic-tubulopathy-and-deafness.jpg": [
		98655,
		9,
		98655
	],
	"./education-center/images/sites/default/files/book_pages/hypokinetic-non-dilated-cardiomyopathy.jpg": [
		844856,
		9,
		844856
	],
	"./education-center/images/sites/default/files/book_pages/hypomaturation-hypoplastic-amelogenesis-imperfecta-taurodontism.jpg": [
		353442,
		9,
		353442
	],
	"./education-center/images/sites/default/files/book_pages/hypoparathyroidism-deafness-renal-disease-syndrome.jpg": [
		378392,
		9,
		378392
	],
	"./education-center/images/sites/default/files/book_pages/hypoparathyroidism-familial-isolated-1.jpg": [
		327304,
		9,
		327304
	],
	"./education-center/images/sites/default/files/book_pages/hypophosphatemia.jpg": [
		403083,
		9,
		403083
	],
	"./education-center/images/sites/default/files/book_pages/hypophosphatemic-rickets-dominant.jpg": [
		842279,
		9,
		842279
	],
	"./education-center/images/sites/default/files/book_pages/hypophosphatemic-rickets-recessive.jpg": [
		447613,
		9,
		447613
	],
	"./education-center/images/sites/default/files/book_pages/hypoplasia-iris.jpg": [
		893755,
		9,
		893755
	],
	"./education-center/images/sites/default/files/book_pages/hypothyroidism.jpg": [
		994870,
		9,
		994870
	],
	"./education-center/images/sites/default/files/book_pages/hypotrichosis-2.jpg": [
		671871,
		9,
		671871
	],
	"./education-center/images/sites/default/files/book_pages/hypotrichosis-3.jpg": [
		562259,
		9,
		562259
	],
	"./education-center/images/sites/default/files/book_pages/ichthyosis-annular-epidermolytic-2.jpg": [
		958422,
		9,
		958422
	],
	"./education-center/images/sites/default/files/book_pages/ichthyosis-bullosa-siemens.jpg": [
		321226,
		9,
		321226
	],
	"./education-center/images/sites/default/files/book_pages/ichthyosis-hystrix-curth-macklin.jpg": [
		106662,
		9,
		106662
	],
	"./education-center/images/sites/default/files/book_pages/idiopathic-environmental-intolerance.jpg": [
		475269,
		9,
		475269
	],
	"./education-center/images/sites/default/files/book_pages/idiopathic-generalized-epilepsy.jpg": [
		938065,
		9,
		938065
	],
	"./education-center/images/sites/default/files/book_pages/idiopathic-growth-hormone-deficiency.jpg": [
		880022,
		9,
		880022
	],
	"./education-center/images/sites/default/files/book_pages/idiopathic-scoliosis.jpg": [
		648694,
		9,
		648694
	],
	"./education-center/images/sites/default/files/book_pages/idiopathic-transverse-myelitis.jpg": [
		734272,
		9,
		734272
	],
	"./education-center/images/sites/default/files/book_pages/idua-pseudodeficiency.jpg": [
		199892,
		9,
		199892
	],
	"./education-center/images/sites/default/files/book_pages/ifn-gamma-receptor-1-deficiency.jpg": [
		149670,
		9,
		149670
	],
	"./education-center/images/sites/default/files/book_pages/iga-nephropathy-susceptibility.jpg": [
		818680,
		9,
		818680
	],
	"./education-center/images/sites/default/files/book_pages/ige-responsiveness-atopic.jpg": [
		910749,
		9,
		910749
	],
	"./education-center/images/sites/default/files/book_pages/igg-receptor-i-phagocytic-familial-deficiency.jpg": [
		385723,
		9,
		385723
	],
	"./education-center/images/sites/default/files/book_pages/iminoglycinuria-digenic.jpg": [
		349048,
		9,
		349048
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-109-lymphoproliferation.jpg": [
		487974,
		9,
		487974
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-18-severe-combined-immunodeficiency-variant.jpg": [
		560426,
		9,
		560426
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-26-without-neurologic-abnormalities.jpg": [
		747874,
		9,
		747874
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-37.jpg": [
		629794,
		9,
		629794
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-60.jpg": [
		280176,
		9,
		280176
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-66.jpg": [
		784401,
		9,
		784401
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-due-defect-cd3-gamma.jpg": [
		948443,
		9,
		948443
	],
	"./education-center/images/sites/default/files/book_pages/immunodeficiency-x-linked-hyper-igm.jpg": [
		543719,
		9,
		543719
	],
	"./education-center/images/sites/default/files/book_pages/impaired-adp-induced-platelet-aggregation.jpg": [
		925937,
		9,
		925937
	],
	"./education-center/images/sites/default/files/book_pages/impaired-intellectual-development-and-distinctive-facial-features-cardiac-defects.jpg": [
		205304,
		9,
		205304
	],
	"./education-center/images/sites/default/files/book_pages/impaired-ristocetin-induced-platelet-aggregation.jpg": [
		443994,
		9,
		443994
	],
	"./education-center/images/sites/default/files/book_pages/impaired-temperature-sensation.jpg": [
		68959,
		9,
		68959
	],
	"./education-center/images/sites/default/files/book_pages/impaired-thromboxane-a2-agonist-induced-platelet-aggregation.jpg": [
		707058,
		9,
		707058
	],
	"./education-center/images/sites/default/files/book_pages/impdh2-enzyme-activity-variation.jpg": [
		477272,
		9,
		477272
	],
	"./education-center/images/sites/default/files/book_pages/inborn-genetic-diseases.jpg": [
		307437,
		9,
		307437
	],
	"./education-center/images/sites/default/files/book_pages/inclusion-body-myopathy-dominant.jpg": [
		534201,
		9,
		534201
	],
	"./education-center/images/sites/default/files/book_pages/inclusion-body-myopathy-paget-disease-bone-and-frontotemporal-dementia.jpg": [
		937020,
		9,
		937020
	],
	"./education-center/images/sites/default/files/book_pages/inclusion-body-myopathy-recessive.jpg": [
		484227,
		9,
		484227
	],
	"./education-center/images/sites/default/files/book_pages/increased-analgesia-kappa-opioid-receptor-agonist-female-specific.jpg": [
		943411,
		9,
		943411
	],
	"./education-center/images/sites/default/files/book_pages/increased-circulating-iga-level.jpg": [
		884591,
		9,
		884591
	],
	"./education-center/images/sites/default/files/book_pages/increased-circulating-ige-level.jpg": [
		851194,
		9,
		851194
	],
	"./education-center/images/sites/default/files/book_pages/increased-erythrocyte-protoporphyrin-concentration.jpg": [
		501051,
		9,
		501051
	],
	"./education-center/images/sites/default/files/book_pages/increased-hepatic-glycogen-content.jpg": [
		509974,
		9,
		509974
	],
	"./education-center/images/sites/default/files/book_pages/increased-histidine.jpg": [
		774062,
		9,
		774062
	],
	"./education-center/images/sites/default/files/book_pages/increased-left-ventricular-wall-thickness.jpg": [
		213600,
		9,
		213600
	],
	"./education-center/images/sites/default/files/book_pages/increased-mean-platelet-volume.jpg": [
		359544,
		9,
		359544
	],
	"./education-center/images/sites/default/files/book_pages/increased-muscle-glycogen-content.jpg": [
		555128,
		9,
		555128
	],
	"./education-center/images/sites/default/files/book_pages/increased-nuchal-translucency.jpg": [
		322811,
		9,
		322811
	],
	"./education-center/images/sites/default/files/book_pages/increased-susceptibility-fractures.jpg": [
		646885,
		9,
		646885
	],
	"./education-center/images/sites/default/files/book_pages/indifference-pain-congenital-autosomal-dominant.jpg": [
		468703,
		9,
		468703
	],
	"./education-center/images/sites/default/files/book_pages/infant-onset-multiple-organ-failure.jpg": [
		841317,
		9,
		841317
	],
	"./education-center/images/sites/default/files/book_pages/infantile-cortical-hyperostosis.jpg": [
		459978,
		9,
		459978
	],
	"./education-center/images/sites/default/files/book_pages/infantile-encephalopathy.jpg": [
		820578,
		9,
		820578
	],
	"./education-center/images/sites/default/files/book_pages/infantile-epilepsy.jpg": [
		718745,
		9,
		718745
	],
	"./education-center/images/sites/default/files/book_pages/infantile-hypercalcemia.jpg": [
		249620,
		9,
		249620
	],
	"./education-center/images/sites/default/files/book_pages/infantile-hypophosphatasia.jpg": [
		300017,
		9,
		300017
	],
	"./education-center/images/sites/default/files/book_pages/infantile-liver-failure.jpg": [
		698277,
		9,
		698277
	],
	"./education-center/images/sites/default/files/book_pages/infantile-nystagmus.jpg": [
		519825,
		9,
		519825
	],
	"./education-center/images/sites/default/files/book_pages/infantile-spasms.jpg": [
		664417,
		9,
		664417
	],
	"./education-center/images/sites/default/files/book_pages/infertility.jpg": [
		539720,
		9,
		539720
	],
	"./education-center/images/sites/default/files/book_pages/infiltrating-duct-carcinoma-breast.jpg": [
		667596,
		9,
		667596
	],
	"./education-center/images/sites/default/files/book_pages/inflammation.jpg": [
		829389,
		9,
		829389
	],
	"./education-center/images/sites/default/files/book_pages/inflammatory-bowel-disease-14-susceptibility.jpg": [
		941416,
		9,
		941416
	],
	"./education-center/images/sites/default/files/book_pages/inflammatory-bowel-disease-17-protection-against.jpg": [
		29151,
		9,
		29151
	],
	"./education-center/images/sites/default/files/book_pages/inherited-bleeding-disorder-platelet-type.jpg": [
		34358,
		9,
		34358
	],
	"./education-center/images/sites/default/files/book_pages/inherited-creutzfeldt-jakob-disease.jpg": [
		198649,
		9,
		198649
	],
	"./education-center/images/sites/default/files/book_pages/inherited-erythromelalgia.jpg": [
		177892,
		9,
		177892
	],
	"./education-center/images/sites/default/files/book_pages/inherited-immunodeficiency-diseases.jpg": [
		908665,
		9,
		908665
	],
	"./education-center/images/sites/default/files/book_pages/inner-ear-malformation.jpg": [
		78396,
		9,
		78396
	],
	"./education-center/images/sites/default/files/book_pages/insulin-resistance-severe-digenic.jpg": [
		134946,
		9,
		134946
	],
	"./education-center/images/sites/default/files/book_pages/insulin-resistance-susceptibility.jpg": [
		690284,
		9,
		690284
	],
	"./education-center/images/sites/default/files/book_pages/insulin-resistance.jpg": [
		327718,
		9,
		327718
	],
	"./education-center/images/sites/default/files/book_pages/insulin-resistant-diabetes-mellitus.jpg": [
		275544,
		9,
		275544
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-deficiency.jpg": [
		654889,
		9,
		654889
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-developmental-disorder-autism-and-dysmorphic-facies.jpg": [
		908871,
		9,
		908871
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-developmental-disorder-autosomal-dominant-71-behavioral-abnormalities.jpg": [
		445812,
		9,
		445812
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-developmental-disorder-x-linked-syndromic-16.jpg": [
		205738,
		9,
		205738
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-developmental-disorder.jpg": [
		268977,
		9,
		268977
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-and-seizures.jpg": [
		923860,
		9,
		923860
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-autosomal-dominant-1.jpg": [
		224897,
		9,
		224897
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-cask-related-x-linked.jpg": [
		115590,
		9,
		115590
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-dominant.jpg": [
		329490,
		9,
		329490
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-episodic-ataxia-and-congenital-arthrogryposis.jpg": [
		470491,
		9,
		470491
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-fra12a-type.jpg": [
		394169,
		9,
		394169
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-language-impairment-and-autistic-features.jpg": [
		651456,
		9,
		651456
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-profound.jpg": [
		334914,
		9,
		334914
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-recessive.jpg": [
		547663,
		9,
		547663
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-severe-speech-impairment.jpg": [
		89371,
		9,
		89371
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-stereotypic-movements-epilepsy-andor-cerebral-malformations.jpg": [
		147509,
		9,
		147509
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability-x-linked-1.jpg": [
		387697,
		9,
		387697
	],
	"./education-center/images/sites/default/files/book_pages/intellectual-disability.jpg": [
		87535,
		9,
		87535
	],
	"./education-center/images/sites/default/files/book_pages/interferon-gamma-receptor-deficiency.jpg": [
		195239,
		9,
		195239
	],
	"./education-center/images/sites/default/files/book_pages/interferons-peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.jpg": [
		524416,
		9,
		524416
	],
	"./education-center/images/sites/default/files/book_pages/interleukin-6-serum-level-quantitative-trait-locus.jpg": [
		239073,
		9,
		239073
	],
	"./education-center/images/sites/default/files/book_pages/intermediate-maple-syrup-urine-disease-type-2.jpg": [
		921951,
		9,
		921951
	],
	"./education-center/images/sites/default/files/book_pages/interstitial-cardiac-fibrosis.jpg": [
		418900,
		9,
		418900
	],
	"./education-center/images/sites/default/files/book_pages/interstitial-nephritis.jpg": [
		209114,
		9,
		209114
	],
	"./education-center/images/sites/default/files/book_pages/intervertebral-disc-disease-susceptibility.jpg": [
		130237,
		9,
		130237
	],
	"./education-center/images/sites/default/files/book_pages/intervertebral-disk-calcification.jpg": [
		320409,
		9,
		320409
	],
	"./education-center/images/sites/default/files/book_pages/intestinal-dysmotility-syndrome.jpg": [
		960295,
		9,
		960295
	],
	"./education-center/images/sites/default/files/book_pages/intractable-seizure.jpg": [
		463385,
		9,
		463385
	],
	"./education-center/images/sites/default/files/book_pages/intraventricular-hemorrhage.jpg": [
		61466,
		9,
		61466
	],
	"./education-center/images/sites/default/files/book_pages/intrinsic-cardiomyopathy.jpg": [
		999865,
		9,
		999865
	],
	"./education-center/images/sites/default/files/book_pages/invasive-breast-carcinoma.jpg": [
		284849,
		9,
		284849
	],
	"./education-center/images/sites/default/files/book_pages/invasive-pneumococcal-disease-protection-against.jpg": [
		355601,
		9,
		355601
	],
	"./education-center/images/sites/default/files/book_pages/invasive-pneumococcal-disease-recurrent-isolated.jpg": [
		496545,
		9,
		496545
	],
	"./education-center/images/sites/default/files/book_pages/irinotecan-response.jpg": [
		915326,
		9,
		915326
	],
	"./education-center/images/sites/default/files/book_pages/iron-accumulation-brain.jpg": [
		530262,
		9,
		530262
	],
	"./education-center/images/sites/default/files/book_pages/iron-deficiency-anemia.jpg": [
		976190,
		9,
		976190
	],
	"./education-center/images/sites/default/files/book_pages/iron-overload.jpg": [
		411012,
		9,
		411012
	],
	"./education-center/images/sites/default/files/book_pages/ischemic-stroke.jpg": [
		935600,
		9,
		935600
	],
	"./education-center/images/sites/default/files/book_pages/islet-cell-adenomatosis.jpg": [
		560242,
		9,
		560242
	],
	"./education-center/images/sites/default/files/book_pages/isolated-anhidrosis-normal-sweat-glands.jpg": [
		703393,
		9,
		703393
	],
	"./education-center/images/sites/default/files/book_pages/isolated-cleft-palate.jpg": [
		161038,
		9,
		161038
	],
	"./education-center/images/sites/default/files/book_pages/isolated-congenital-digital-clubbing.jpg": [
		719218,
		9,
		719218
	],
	"./education-center/images/sites/default/files/book_pages/isolated-congenital-growth-hormone-deficiency.jpg": [
		528499,
		9,
		528499
	],
	"./education-center/images/sites/default/files/book_pages/isolated-coronal-synostosis.jpg": [
		437083,
		9,
		437083
	],
	"./education-center/images/sites/default/files/book_pages/isolated-cryptophthalmia.jpg": [
		955027,
		9,
		955027
	],
	"./education-center/images/sites/default/files/book_pages/isolated-gnrh-deficiency.jpg": [
		791533,
		9,
		791533
	],
	"./education-center/images/sites/default/files/book_pages/isolated-hyperchlorhidrosis.jpg": [
		771222,
		9,
		771222
	],
	"./education-center/images/sites/default/files/book_pages/isolated-hyperparathyroidism.jpg": [
		860221,
		9,
		860221
	],
	"./education-center/images/sites/default/files/book_pages/isolated-macular-dystrophy.jpg": [
		173782,
		9,
		173782
	],
	"./education-center/images/sites/default/files/book_pages/isolated-nonsyndromic-congenital-heart-disease.jpg": [
		26817,
		9,
		26817
	],
	"./education-center/images/sites/default/files/book_pages/isovaleric-acidemia-type-i.jpg": [
		717232,
		9,
		717232
	],
	"./education-center/images/sites/default/files/book_pages/isovaleric-acidemia-type-iii.jpg": [
		144028,
		9,
		144028
	],
	"./education-center/images/sites/default/files/book_pages/ivacaftor-lumacaftor-response-efficacy.jpg": [
		430075,
		9,
		430075
	],
	"./education-center/images/sites/default/files/book_pages/ivacaftor-response-efficacy.jpg": [
		565007,
		9,
		565007
	],
	"./education-center/images/sites/default/files/book_pages/jackson-weiss-syndrome.jpg": [
		599998,
		9,
		599998
	],
	"./education-center/images/sites/default/files/book_pages/jawad-syndrome.jpg": [
		149578,
		9,
		149578
	],
	"./education-center/images/sites/default/files/book_pages/john-milton-hagen-blood-group-system.jpg": [
		981906,
		9,
		981906
	],
	"./education-center/images/sites/default/files/book_pages/joint-hypermobility.jpg": [
		853284,
		9,
		853284
	],
	"./education-center/images/sites/default/files/book_pages/joubert-syndrome-12.jpg": [
		522112,
		9,
		522112
	],
	"./education-center/images/sites/default/files/book_pages/joubert-syndrome-1215-digenic.jpg": [
		960524,
		9,
		960524
	],
	"./education-center/images/sites/default/files/book_pages/joubert-syndrome-915-digenic.jpg": [
		262451,
		9,
		262451
	],
	"./education-center/images/sites/default/files/book_pages/juberg-hayward-syndrome.jpg": [
		810981,
		9,
		810981
	],
	"./education-center/images/sites/default/files/book_pages/juvenile-hemochromatosis.jpg": [
		245119,
		9,
		245119
	],
	"./education-center/images/sites/default/files/book_pages/juvenile-onset-psychosis.jpg": [
		201181,
		9,
		201181
	],
	"./education-center/images/sites/default/files/book_pages/juvenile-polyposis-stomach.jpg": [
		212782,
		9,
		212782
	],
	"./education-center/images/sites/default/files/book_pages/juvenile-polyposis.jpg": [
		980021,
		9,
		980021
	],
	"./education-center/images/sites/default/files/book_pages/juvenile-retinitis-pigmentosa-aipl1-related.jpg": [
		556904,
		9,
		556904
	],
	"./education-center/images/sites/default/files/book_pages/kabuki-syndrome-1.jpg": [
		342209,
		9,
		342209
	],
	"./education-center/images/sites/default/files/book_pages/karak-syndrome.jpg": [
		50522,
		9,
		50522
	],
	"./education-center/images/sites/default/files/book_pages/kat6b-related-spectrum-disorders.jpg": [
		588381,
		9,
		588381
	],
	"./education-center/images/sites/default/files/book_pages/kbg-syndrome.jpg": [
		942250,
		9,
		942250
	],
	"./education-center/images/sites/default/files/book_pages/kcne2-related-disorders.jpg": [
		887013,
		9,
		887013
	],
	"./education-center/images/sites/default/files/book_pages/kcnj10-related-disorders.jpg": [
		25155,
		9,
		25155
	],
	"./education-center/images/sites/default/files/book_pages/kcnq1-related-disorders.jpg": [
		856979,
		9,
		856979
	],
	"./education-center/images/sites/default/files/book_pages/kcnq2-related-disorders.jpg": [
		965608,
		9,
		965608
	],
	"./education-center/images/sites/default/files/book_pages/kcnq3-related-developmental-disability.jpg": [
		794969,
		9,
		794969
	],
	"./education-center/images/sites/default/files/book_pages/kcnt2-related-condition.jpg": [
		878158,
		9,
		878158
	],
	"./education-center/images/sites/default/files/book_pages/kel6-antigen.jpg": [
		334592,
		9,
		334592
	],
	"./education-center/images/sites/default/files/book_pages/keloid-formation.jpg": [
		102001,
		9,
		102001
	],
	"./education-center/images/sites/default/files/book_pages/keratitis-fugax-hereditaria.jpg": [
		994818,
		9,
		994818
	],
	"./education-center/images/sites/default/files/book_pages/keratoconus-1.jpg": [
		774105,
		9,
		774105
	],
	"./education-center/images/sites/default/files/book_pages/keratolytic-winter-erythema.jpg": [
		510765,
		9,
		510765
	],
	"./education-center/images/sites/default/files/book_pages/keratosis-follicularis.jpg": [
		119415,
		9,
		119415
	],
	"./education-center/images/sites/default/files/book_pages/kidney-damage.jpg": [
		873581,
		9,
		873581
	],
	"./education-center/images/sites/default/files/book_pages/kininogen-deficiency-total.jpg": [
		427923,
		9,
		427923
	],
	"./education-center/images/sites/default/files/book_pages/kleine-levin-syndrome.jpg": [
		923825,
		9,
		923825
	],
	"./education-center/images/sites/default/files/book_pages/klippel-feil-syndrome-1-autosomal-dominant.jpg": [
		564706,
		9,
		564706
	],
	"./education-center/images/sites/default/files/book_pages/klippel-feil-syndrome.jpg": [
		814787,
		9,
		814787
	],
	"./education-center/images/sites/default/files/book_pages/klippel-tr%C3%A3%C2%A9naunay-syndrome.jpg": [
		809972,
		9,
		809972
	],
	"./education-center/images/sites/default/files/book_pages/kniest-dysplasia.jpg": [
		867912,
		9,
		867912
	],
	"./education-center/images/sites/default/files/book_pages/knops-blood-group-system.jpg": [
		605259,
		9,
		605259
	],
	"./education-center/images/sites/default/files/book_pages/knuckle-pads-deafness-and-leukonychia-syndrome.jpg": [
		388587,
		9,
		388587
	],
	"./education-center/images/sites/default/files/book_pages/kuru-protection-against.jpg": [
		229690,
		9,
		229690
	],
	"./education-center/images/sites/default/files/book_pages/l-ferritin-deficiency-autosomal-recessive.jpg": [
		895408,
		9,
		895408
	],
	"./education-center/images/sites/default/files/book_pages/lacrimoauriculodentodigital-syndrome-3.jpg": [
		979835,
		9,
		979835
	],
	"./education-center/images/sites/default/files/book_pages/lactase-persistence.jpg": [
		589888,
		9,
		589888
	],
	"./education-center/images/sites/default/files/book_pages/lactic-acidosis.jpg": [
		667933,
		9,
		667933
	],
	"./education-center/images/sites/default/files/book_pages/landsteiner-wiener-phenotype.jpg": [
		94104,
		9,
		94104
	],
	"./education-center/images/sites/default/files/book_pages/langer-giedion-syndrome.jpg": [
		580075,
		9,
		580075
	],
	"./education-center/images/sites/default/files/book_pages/langereis-blood-group.jpg": [
		319586,
		9,
		319586
	],
	"./education-center/images/sites/default/files/book_pages/language-retardation.jpg": [
		93920,
		9,
		93920
	],
	"./education-center/images/sites/default/files/book_pages/large-gestational-age.jpg": [
		838876,
		9,
		838876
	],
	"./education-center/images/sites/default/files/book_pages/large-vessel-vasculitis.jpg": [
		86605,
		9,
		86605
	],
	"./education-center/images/sites/default/files/book_pages/laron-syndrome-elevated-serum-gh-binding-protein.jpg": [
		24646,
		9,
		24646
	],
	"./education-center/images/sites/default/files/book_pages/laron-syndrome-undetectable-serum-gh-binding-protein.jpg": [
		75096,
		9,
		75096
	],
	"./education-center/images/sites/default/files/book_pages/larsen-syndrome.jpg": [
		527509,
		9,
		527509
	],
	"./education-center/images/sites/default/files/book_pages/late-onset-citrullinemia.jpg": [
		256157,
		9,
		256157
	],
	"./education-center/images/sites/default/files/book_pages/lateral-meningocele-syndrome.jpg": [
		752509,
		9,
		752509
	],
	"./education-center/images/sites/default/files/book_pages/lattice-corneal-dystrophy-type-i.jpg": [
		54134,
		9,
		54134
	],
	"./education-center/images/sites/default/files/book_pages/lazy-leukocyte-syndrome.jpg": [
		550368,
		9,
		550368
	],
	"./education-center/images/sites/default/files/book_pages/lcat-deficiency.jpg": [
		449721,
		9,
		449721
	],
	"./education-center/images/sites/default/files/book_pages/lchad-deficiency-maternal-acute-fatty-liver-pregnancy.jpg": [
		475666,
		9,
		475666
	],
	"./education-center/images/sites/default/files/book_pages/leber-congenital-amaurosis-18.jpg": [
		753565,
		9,
		753565
	],
	"./education-center/images/sites/default/files/book_pages/leber-congenital-amaurosis.jpg": [
		31121,
		9,
		31121
	],
	"./education-center/images/sites/default/files/book_pages/left-right-axis-malformations.jpg": [
		289399,
		9,
		289399
	],
	"./education-center/images/sites/default/files/book_pages/left-ventricular-noncompaction-3.jpg": [
		243551,
		9,
		243551
	],
	"./education-center/images/sites/default/files/book_pages/left-ventricular-noncompaction-cardiomyopathy.jpg": [
		535006,
		9,
		535006
	],
	"./education-center/images/sites/default/files/book_pages/legg-calve-perthes-disease.jpg": [
		217213,
		9,
		217213
	],
	"./education-center/images/sites/default/files/book_pages/leigh-syndrome-due-mitochondrial-complex-i-deficiency.jpg": [
		37497,
		9,
		37497
	],
	"./education-center/images/sites/default/files/book_pages/lenz-majewski-hyperostosis-syndrome.jpg": [
		351376,
		9,
		351376
	],
	"./education-center/images/sites/default/files/book_pages/leprosy-early-onset-susceptibility.jpg": [
		194766,
		9,
		194766
	],
	"./education-center/images/sites/default/files/book_pages/leprosy-protection-against.jpg": [
		826887,
		9,
		826887
	],
	"./education-center/images/sites/default/files/book_pages/leptin-dysfunction.jpg": [
		789743,
		9,
		789743
	],
	"./education-center/images/sites/default/files/book_pages/leri-weill-dyschondrosteosis.jpg": [
		177908,
		9,
		177908
	],
	"./education-center/images/sites/default/files/book_pages/lesch-nyhan-syndrome-neurologic-variant.jpg": [
		836205,
		9,
		836205
	],
	"./education-center/images/sites/default/files/book_pages/lesinurad-response.jpg": [
		792098,
		9,
		792098
	],
	"./education-center/images/sites/default/files/book_pages/lethal-encephalopathy.jpg": [
		583090,
		9,
		583090
	],
	"./education-center/images/sites/default/files/book_pages/lethal-skeletal-dysplasia.jpg": [
		770005,
		9,
		770005
	],
	"./education-center/images/sites/default/files/book_pages/leukemia-acute-lymphoblastic-susceptibility.jpg": [
		149925,
		9,
		149925
	],
	"./education-center/images/sites/default/files/book_pages/leukemia-acute-myeloid-m0-subtype.jpg": [
		398767,
		9,
		398767
	],
	"./education-center/images/sites/default/files/book_pages/leukemia-megakaryoblastic-down-syndrome-somatic.jpg": [
		879736,
		9,
		879736
	],
	"./education-center/images/sites/default/files/book_pages/leukemia-philadelphia-chromosome-positive-resistant-imatinib.jpg": [
		60395,
		9,
		60395
	],
	"./education-center/images/sites/default/files/book_pages/leukemia-post-chemotherapy-susceptibility.jpg": [
		184123,
		9,
		184123
	],
	"./education-center/images/sites/default/files/book_pages/leukemoid-reaction.jpg": [
		481969,
		9,
		481969
	],
	"./education-center/images/sites/default/files/book_pages/leukocyte-adhesion-deficiency-1.jpg": [
		326212,
		9,
		326212
	],
	"./education-center/images/sites/default/files/book_pages/leukodystrophy-adult-onset.jpg": [
		53532,
		9,
		53532
	],
	"./education-center/images/sites/default/files/book_pages/leukodystrophy-childhood-onset-remitting.jpg": [
		756934,
		9,
		756934
	],
	"./education-center/images/sites/default/files/book_pages/leukodystrophy-hypomyelinating-26-chondrodysplasia.jpg": [
		4209,
		9,
		4209
	],
	"./education-center/images/sites/default/files/book_pages/leukoencephalopathy-vanishing-white-matter-2.jpg": [
		504732,
		9,
		504732
	],
	"./education-center/images/sites/default/files/book_pages/leukoencephalopathy-vanishing-white-matter-3.jpg": [
		743721,
		9,
		743721
	],
	"./education-center/images/sites/default/files/book_pages/leukoencephalopathy-vanishing-white-matter-4.jpg": [
		59151,
		9,
		59151
	],
	"./education-center/images/sites/default/files/book_pages/leukoencephalopathy-vanishing-white-matter-5.jpg": [
		167508,
		9,
		167508
	],
	"./education-center/images/sites/default/files/book_pages/leukoencephalopathy.jpg": [
		722500,
		9,
		722500
	],
	"./education-center/images/sites/default/files/book_pages/levy-hollister-syndrome.jpg": [
		571453,
		9,
		571453
	],
	"./education-center/images/sites/default/files/book_pages/lewy-body-dementia.jpg": [
		380019,
		9,
		380019
	],
	"./education-center/images/sites/default/files/book_pages/leydig-cell-adenoma-somatic-male-limited-precocious-puberty.jpg": [
		245253,
		9,
		245253
	],
	"./education-center/images/sites/default/files/book_pages/leydig-cell-hypoplasia-type-ii.jpg": [
		835378,
		9,
		835378
	],
	"./education-center/images/sites/default/files/book_pages/leydig-hypoplasia-type-i.jpg": [
		584905,
		9,
		584905
	],
	"./education-center/images/sites/default/files/book_pages/lhermitte-duclos-disease.jpg": [
		795827,
		9,
		795827
	],
	"./education-center/images/sites/default/files/book_pages/li-fraumeni-syndrome-1.jpg": [
		591293,
		9,
		591293
	],
	"./education-center/images/sites/default/files/book_pages/lig4-related-disorders.jpg": [
		456705,
		9,
		456705
	],
	"./education-center/images/sites/default/files/book_pages/limb-girdle-muscular-dystrophy-dominant.jpg": [
		498973,
		9,
		498973
	],
	"./education-center/images/sites/default/files/book_pages/limb-girdle-muscular-dystrophy-recessive.jpg": [
		707551,
		9,
		707551
	],
	"./education-center/images/sites/default/files/book_pages/lingual-thyroid.jpg": [
		629460,
		9,
		629460
	],
	"./education-center/images/sites/default/files/book_pages/lipoatrophy-diabetes-hepatic-steatosis-hypertrophic-cardiomyopathy-and-leukomelanodermic-papules.jpg": [
		773250,
		9,
		773250
	],
	"./education-center/images/sites/default/files/book_pages/lipodystrophy.jpg": [
		518144,
		9,
		518144
	],
	"./education-center/images/sites/default/files/book_pages/lipoid-nephrosis.jpg": [
		924452,
		9,
		924452
	],
	"./education-center/images/sites/default/files/book_pages/lipoma-somatic.jpg": [
		1846,
		9,
		1846
	],
	"./education-center/images/sites/default/files/book_pages/lipoproteina-deficiency-congenital.jpg": [
		577713,
		9,
		577713
	],
	"./education-center/images/sites/default/files/book_pages/lissencephaly-4.jpg": [
		467462,
		9,
		467462
	],
	"./education-center/images/sites/default/files/book_pages/lissencephaly-recessive.jpg": [
		949922,
		9,
		949922
	],
	"./education-center/images/sites/default/files/book_pages/lissencephalysubcortical-band-heterotopia.jpg": [
		460623,
		9,
		460623
	],
	"./education-center/images/sites/default/files/book_pages/liver-disease-severe-congenital.jpg": [
		972133,
		9,
		972133
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-1-recessive.jpg": [
		883071,
		9,
		883071
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-12-digenic.jpg": [
		742235,
		9,
		742235
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-2-acquired-susceptibility.jpg": [
		450854,
		9,
		450854
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-23-digenic.jpg": [
		944392,
		9,
		944392
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-25-digenic.jpg": [
		745005,
		9,
		745005
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-29-digenic.jpg": [
		490762,
		9,
		490762
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-3-acquired-susceptibility.jpg": [
		862089,
		9,
		862089
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-36-digenic.jpg": [
		88019,
		9,
		88019
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-5-acquired-susceptibility.jpg": [
		856908,
		9,
		856908
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-6-acquired-susceptibility.jpg": [
		912976,
		9,
		912976
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-bradycardia-induced.jpg": [
		305891,
		9,
		305891
	],
	"./education-center/images/sites/default/files/book_pages/long-qt-syndrome-drug-associated.jpg": [
		735386,
		9,
		735386
	],
	"./education-center/images/sites/default/files/book_pages/low-alkaline-phosphatase.jpg": [
		968595,
		9,
		968595
	],
	"./education-center/images/sites/default/files/book_pages/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-1.jpg": [
		858614,
		9,
		858614
	],
	"./education-center/images/sites/default/files/book_pages/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-3.jpg": [
		694985,
		9,
		694985
	],
	"./education-center/images/sites/default/files/book_pages/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.jpg": [
		786343,
		9,
		786343
	],
	"./education-center/images/sites/default/files/book_pages/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.jpg": [
		712596,
		9,
		712596
	],
	"./education-center/images/sites/default/files/book_pages/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.jpg": [
		101330,
		9,
		101330
	],
	"./education-center/images/sites/default/files/book_pages/low-serum-calcitriol.jpg": [
		319167,
		9,
		319167
	],
	"./education-center/images/sites/default/files/book_pages/low-set-posteriorly-rotated-ears.jpg": [
		672053,
		9,
		672053
	],
	"./education-center/images/sites/default/files/book_pages/lower-limb-muscle-weakness.jpg": [
		15728,
		9,
		15728
	],
	"./education-center/images/sites/default/files/book_pages/lower-limb-spasticity.jpg": [
		296266,
		9,
		296266
	],
	"./education-center/images/sites/default/files/book_pages/lung-cancer-protection-against-smokers.jpg": [
		34093,
		9,
		34093
	],
	"./education-center/images/sites/default/files/book_pages/lung-cancer-protection-against.jpg": [
		643494,
		9,
		643494
	],
	"./education-center/images/sites/default/files/book_pages/lung-cancer-susceptibility-2.jpg": [
		116075,
		9,
		116075
	],
	"./education-center/images/sites/default/files/book_pages/lung-cancer.jpg": [
		176110,
		9,
		176110
	],
	"./education-center/images/sites/default/files/book_pages/lung-carcinoid-tumor.jpg": [
		211675,
		9,
		211675
	],
	"./education-center/images/sites/default/files/book_pages/lung-carcinoma.jpg": [
		179974,
		9,
		179974
	],
	"./education-center/images/sites/default/files/book_pages/lung-damage-immunodeficiency-and-chromosome-breakage-syndrome.jpg": [
		815893,
		9,
		815893
	],
	"./education-center/images/sites/default/files/book_pages/lung-disease-non-specific.jpg": [
		725858,
		9,
		725858
	],
	"./education-center/images/sites/default/files/book_pages/luteinizing-hormone-resistance-female.jpg": [
		87557,
		9,
		87557
	],
	"./education-center/images/sites/default/files/book_pages/lymphedema-distichiasis-syndrome-renal-disease-and-diabetes-mellitus.jpg": [
		149546,
		9,
		149546
	],
	"./education-center/images/sites/default/files/book_pages/lynch-syndrome-1.jpg": [
		726888,
		9,
		726888
	],
	"./education-center/images/sites/default/files/book_pages/lynch-syndrome.jpg": [
		685577,
		9,
		685577
	],
	"./education-center/images/sites/default/files/book_pages/macrocephaly-and-epileptic-encephalopathy.jpg": [
		670320,
		9,
		670320
	],
	"./education-center/images/sites/default/files/book_pages/macrocephaly-macrosomia-facial-dysmorphism-syndrome.jpg": [
		135068,
		9,
		135068
	],
	"./education-center/images/sites/default/files/book_pages/macrocephaly-neurodevelopmental-delay-lymphoid-hyperplasia-and-persistent-fetal-hemoglobin.jpg": [
		709906,
		9,
		709906
	],
	"./education-center/images/sites/default/files/book_pages/macrocephaly.jpg": [
		460013,
		9,
		460013
	],
	"./education-center/images/sites/default/files/book_pages/macroglobulinemia-waldenstrom-somatic.jpg": [
		13861,
		9,
		13861
	],
	"./education-center/images/sites/default/files/book_pages/macronodular-adrenal-hyperplasia.jpg": [
		742310,
		9,
		742310
	],
	"./education-center/images/sites/default/files/book_pages/macroscopic-hematuria.jpg": [
		631271,
		9,
		631271
	],
	"./education-center/images/sites/default/files/book_pages/macrothrombocytopenia-familial-bernard-soulier-type.jpg": [
		479492,
		9,
		479492
	],
	"./education-center/images/sites/default/files/book_pages/macrothrombocytopenia.jpg": [
		556689,
		9,
		556689
	],
	"./education-center/images/sites/default/files/book_pages/macular-corneal-dystrophy-type-ii.jpg": [
		829468,
		9,
		829468
	],
	"./education-center/images/sites/default/files/book_pages/macular-degeneration-age-related-13-susceptibility.jpg": [
		365961,
		9,
		365961
	],
	"./education-center/images/sites/default/files/book_pages/macular-dystrophy-retinal-4.jpg": [
		314406,
		9,
		314406
	],
	"./education-center/images/sites/default/files/book_pages/macular-dystrophy-retinal-5.jpg": [
		154598,
		9,
		154598
	],
	"./education-center/images/sites/default/files/book_pages/macular-dystrophy.jpg": [
		429319,
		9,
		429319
	],
	"./education-center/images/sites/default/files/book_pages/major-depressive-disorder-response-citalopram-therapy.jpg": [
		896380,
		9,
		896380
	],
	"./education-center/images/sites/default/files/book_pages/malaria-cerebral-resistance.jpg": [
		37945,
		9,
		37945
	],
	"./education-center/images/sites/default/files/book_pages/malaria-cerebral-susceptibility.jpg": [
		979437,
		9,
		979437
	],
	"./education-center/images/sites/default/files/book_pages/malaria-resistance.jpg": [
		507275,
		9,
		507275
	],
	"./education-center/images/sites/default/files/book_pages/malaria-severe-resistance.jpg": [
		94786,
		9,
		94786
	],
	"./education-center/images/sites/default/files/book_pages/malaria-severe-susceptibility.jpg": [
		653620,
		9,
		653620
	],
	"./education-center/images/sites/default/files/book_pages/malattia-leventinese.jpg": [
		793260,
		9,
		793260
	],
	"./education-center/images/sites/default/files/book_pages/male-germ-cell-tumor-somatic.jpg": [
		31523,
		9,
		31523
	],
	"./education-center/images/sites/default/files/book_pages/male-infertility-due-obstructive-azoospermia.jpg": [
		411302,
		9,
		411302
	],
	"./education-center/images/sites/default/files/book_pages/male-infertility-spermatogenesis-disorder.jpg": [
		548513,
		9,
		548513
	],
	"./education-center/images/sites/default/files/book_pages/male-pseudohermaphroditism.jpg": [
		745330,
		9,
		745330
	],
	"./education-center/images/sites/default/files/book_pages/malformation-heart-and-great-vessels.jpg": [
		688173,
		9,
		688173
	],
	"./education-center/images/sites/default/files/book_pages/malignant-hyperthermia-and-exertional-rhabdomyolosis.jpg": [
		721829,
		9,
		721829
	],
	"./education-center/images/sites/default/files/book_pages/malignant-hyperthermia-equivocal-halotane.jpg": [
		729074,
		9,
		729074
	],
	"./education-center/images/sites/default/files/book_pages/malignant-hyperthermia-susceptibility-1.jpg": [
		413023,
		9,
		413023
	],
	"./education-center/images/sites/default/files/book_pages/malignant-hypothermia.jpg": [
		77997,
		9,
		77997
	],
	"./education-center/images/sites/default/files/book_pages/malignant-melanoma-susceptibility.jpg": [
		577649,
		9,
		577649
	],
	"./education-center/images/sites/default/files/book_pages/malignant-neoplasm-brain.jpg": [
		301480,
		9,
		301480
	],
	"./education-center/images/sites/default/files/book_pages/malignant-peritoneal-mesothelioma.jpg": [
		815928,
		9,
		815928
	],
	"./education-center/images/sites/default/files/book_pages/malignant-rhabdoid-tumor-somatic.jpg": [
		992360,
		9,
		992360
	],
	"./education-center/images/sites/default/files/book_pages/malignant-tumor-breast.jpg": [
		58854,
		9,
		58854
	],
	"./education-center/images/sites/default/files/book_pages/malignant-tumor-esophagus.jpg": [
		206988,
		9,
		206988
	],
	"./education-center/images/sites/default/files/book_pages/malignant-tumor-testis.jpg": [
		836404,
		9,
		836404
	],
	"./education-center/images/sites/default/files/book_pages/malignant-tumor-urinary-bladder.jpg": [
		666337,
		9,
		666337
	],
	"./education-center/images/sites/default/files/book_pages/mandibuloacral-dysplasia-type-lipodystrophy-atypical.jpg": [
		45250,
		9,
		45250
	],
	"./education-center/images/sites/default/files/book_pages/maple-syrup-urine-disease-classic-type-ib.jpg": [
		404313,
		9,
		404313
	],
	"./education-center/images/sites/default/files/book_pages/maple-syrup-urine-disease-intermediate-type-ia.jpg": [
		238457,
		9,
		238457
	],
	"./education-center/images/sites/default/files/book_pages/maple-syrup-urine-disease-thiamine-responsive-type-ii.jpg": [
		460362,
		9,
		875050
	],
	"./education-center/images/sites/default/files/book_pages/mapt-related-spectrum-disorders.jpg": [
		389790,
		9,
		389790
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-atypical.jpg": [
		918709,
		9,
		918709
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-autosomal-recessive.jpg": [
		371532,
		9,
		371532
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-incomplete.jpg": [
		524353,
		9,
		524353
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-mild-variable.jpg": [
		437885,
		9,
		437885
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-mild.jpg": [
		614618,
		9,
		614618
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome-severe-classic.jpg": [
		820845,
		9,
		820845
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndrome.jpg": [
		350778,
		9,
		350778
	],
	"./education-center/images/sites/default/files/book_pages/marfan-syndromeloeys-dietz-syndromefamilial-thoracic-aortic-aneurysms-and-dissections.jpg": [
		908294,
		9,
		908294
	],
	"./education-center/images/sites/default/files/book_pages/marfanoid-habitus-and-intellectual-disability.jpg": [
		245616,
		9,
		245616
	],
	"./education-center/images/sites/default/files/book_pages/marshall-syndrome.jpg": [
		864822,
		9,
		864822
	],
	"./education-center/images/sites/default/files/book_pages/marshallstickler-syndrome.jpg": [
		502276,
		9,
		502276
	],
	"./education-center/images/sites/default/files/book_pages/mastocytosis-cutaneous-and-systemic-somatic.jpg": [
		587362,
		9,
		587362
	],
	"./education-center/images/sites/default/files/book_pages/mastocytosis.jpg": [
		651100,
		9,
		651100
	],
	"./education-center/images/sites/default/files/book_pages/maturity-onset-diabetes-young-type-1.jpg": [
		539766,
		9,
		539766
	],
	"./education-center/images/sites/default/files/book_pages/maturity-onset-diabetes-young-type-2.jpg": [
		769508,
		9,
		769508
	],
	"./education-center/images/sites/default/files/book_pages/mbd5-associated-neurodevelopmental-disorder.jpg": [
		970038,
		9,
		970038
	],
	"./education-center/images/sites/default/files/book_pages/mcardle-disease-mild.jpg": [
		99888,
		9,
		99888
	],
	"./education-center/images/sites/default/files/book_pages/median-cleft-lip-and-palate.jpg": [
		47948,
		9,
		47948
	],
	"./education-center/images/sites/default/files/book_pages/medium-chain-dicarboxylic-aciduria.jpg": [
		57783,
		9,
		57783
	],
	"./education-center/images/sites/default/files/book_pages/medulloblastoma.jpg": [
		199312,
		9,
		199312
	],
	"./education-center/images/sites/default/files/book_pages/megacolon.jpg": [
		823949,
		9,
		823949
	],
	"./education-center/images/sites/default/files/book_pages/megalencephaly-thick-corpus-callosum-cerebellar-atrophy-and-intellectual-disability.jpg": [
		628223,
		9,
		628223
	],
	"./education-center/images/sites/default/files/book_pages/melanoma-and-neural-system-tumor-syndrome.jpg": [
		488301,
		9,
		488301
	],
	"./education-center/images/sites/default/files/book_pages/melanoma-cutaneous-malignant-susceptibility-1.jpg": [
		82020,
		9,
		82020
	],
	"./education-center/images/sites/default/files/book_pages/melanoma-cutaneous-malignant-susceptibility-2.jpg": [
		451552,
		9,
		451552
	],
	"./education-center/images/sites/default/files/book_pages/melanoma.jpg": [
		653645,
		9,
		653645
	],
	"./education-center/images/sites/default/files/book_pages/melioidosis-resistance.jpg": [
		78858,
		9,
		78858
	],
	"./education-center/images/sites/default/files/book_pages/melnick-fraser-syndrome.jpg": [
		827783,
		9,
		827783
	],
	"./education-center/images/sites/default/files/book_pages/melorheostosis.jpg": [
		606038,
		9,
		606038
	],
	"./education-center/images/sites/default/files/book_pages/memory-quantitative-trait-locus.jpg": [
		728998,
		9,
		728998
	],
	"./education-center/images/sites/default/files/book_pages/men2-phenotype-unclassified.jpg": [
		826675,
		9,
		826675
	],
	"./education-center/images/sites/default/files/book_pages/meniere-disease.jpg": [
		929133,
		9,
		929133
	],
	"./education-center/images/sites/default/files/book_pages/menkes-disease-copper-replacement-responsive.jpg": [
		309570,
		9,
		309570
	],
	"./education-center/images/sites/default/files/book_pages/menkes-disease-mild.jpg": [
		291144,
		9,
		291144
	],
	"./education-center/images/sites/default/files/book_pages/mephenytoin-poor-metabolism.jpg": [
		278763,
		9,
		278763
	],
	"./education-center/images/sites/default/files/book_pages/meretoja-syndrome.jpg": [
		723338,
		9,
		723338
	],
	"./education-center/images/sites/default/files/book_pages/merff-syndrome.jpg": [
		660917,
		9,
		660917
	],
	"./education-center/images/sites/default/files/book_pages/merrfmelas-overlap-syndrome.jpg": [
		391479,
		9,
		391479
	],
	"./education-center/images/sites/default/files/book_pages/metabolic-syndrome-susceptibility.jpg": [
		875442,
		9,
		875442
	],
	"./education-center/images/sites/default/files/book_pages/metachondromatosis.jpg": [
		47567,
		9,
		47567
	],
	"./education-center/images/sites/default/files/book_pages/metachromatic-leukodystrophy-late-onset.jpg": [
		112882,
		9,
		112882
	],
	"./education-center/images/sites/default/files/book_pages/metachromatic-leukodystrophy-mild.jpg": [
		687487,
		9,
		687487
	],
	"./education-center/images/sites/default/files/book_pages/metachromatic-leukodystrophy-severe.jpg": [
		359203,
		9,
		602695
	],
	"./education-center/images/sites/default/files/book_pages/metachromatic-leukodystrophy-variant.jpg": [
		593971,
		9,
		593971
	],
	"./education-center/images/sites/default/files/book_pages/metaphyseal-anadysplasia-1-autosomal-dominant.jpg": [
		921124,
		9,
		921124
	],
	"./education-center/images/sites/default/files/book_pages/metaphyseal-chondrodysplasia-jansen-type.jpg": [
		318056,
		9,
		318056
	],
	"./education-center/images/sites/default/files/book_pages/metaphyseal-chondrodysplasia-schmid-type.jpg": [
		731907,
		9,
		731907
	],
	"./education-center/images/sites/default/files/book_pages/metaphyseal-chondrodysplasia.jpg": [
		417147,
		9,
		417147
	],
	"./education-center/images/sites/default/files/book_pages/metaphyseal-dysplasia-maxillary-hypoplasia-brachydacty-syndrome.jpg": [
		142194,
		9,
		142194
	],
	"./education-center/images/sites/default/files/book_pages/metastatic-prostate-small-cell-carcinoma.jpg": [
		806340,
		9,
		806340
	],
	"./education-center/images/sites/default/files/book_pages/metatropic-dysplasia.jpg": [
		543208,
		9,
		543208
	],
	"./education-center/images/sites/default/files/book_pages/methemoglobinemia-beta-globin-type.jpg": [
		757100,
		9,
		757100
	],
	"./education-center/images/sites/default/files/book_pages/methemoglobinemia-type-2.jpg": [
		715397,
		9,
		715397
	],
	"./education-center/images/sites/default/files/book_pages/methemoglobinemia-type-i.jpg": [
		314143,
		9,
		314143
	],
	"./education-center/images/sites/default/files/book_pages/methotrexate-response-efficacy.jpg": [
		248554,
		9,
		248554
	],
	"./education-center/images/sites/default/files/book_pages/methylmalonic-acidemia-homocystinuria-cblc.jpg": [
		994392,
		9,
		994392
	],
	"./education-center/images/sites/default/files/book_pages/methylmalonic-aciduria-and-homocystinuria-cblc-type-digenic.jpg": [
		636500,
		9,
		636500
	],
	"./education-center/images/sites/default/files/book_pages/methylmalonic-aciduria-mut-type.jpg": [
		550659,
		9,
		550659
	],
	"./education-center/images/sites/default/files/book_pages/methylmalonic-aciduria-mut0-type.jpg": [
		513268,
		9,
		513268
	],
	"./education-center/images/sites/default/files/book_pages/mevalonic-aciduria.jpg": [
		304383,
		9,
		304383
	],
	"./education-center/images/sites/default/files/book_pages/microcephalic-osteodysplastic-primordial-dwarfism.jpg": [
		422903,
		9,
		422903
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly-and-chorioretinopathy-or-without-intellectual-disability.jpg": [
		918045,
		9,
		918045
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly-cortical-malformations-and-intellectual-disability.jpg": [
		517328,
		9,
		517328
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly-or-without-chorioretinopathy-lymphedema-or-intellectual-disability.jpg": [
		810247,
		9,
		810247
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly-short-stature-and-impaired-glucose-metabolism-1.jpg": [
		614192,
		9,
		614192
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly-short-stature-and-polymicrogyria-seizures.jpg": [
		862628,
		9,
		862628
	],
	"./education-center/images/sites/default/files/book_pages/microcephaly.jpg": [
		972813,
		9,
		972813
	],
	"./education-center/images/sites/default/files/book_pages/microcytic-anemia.jpg": [
		765851,
		9,
		765851
	],
	"./education-center/images/sites/default/files/book_pages/micropenis.jpg": [
		560432,
		9,
		560432
	],
	"./education-center/images/sites/default/files/book_pages/microphthalmia-cataracts-and-iris-abnormalities.jpg": [
		859435,
		9,
		859435
	],
	"./education-center/images/sites/default/files/book_pages/microphthalmia-syndromic-15.jpg": [
		939720,
		9,
		939720
	],
	"./education-center/images/sites/default/files/book_pages/microprolactinoma.jpg": [
		298679,
		9,
		298679
	],
	"./education-center/images/sites/default/files/book_pages/microscopic-hematuria.jpg": [
		586044,
		9,
		586044
	],
	"./education-center/images/sites/default/files/book_pages/microspherophakia.jpg": [
		978005,
		9,
		978005
	],
	"./education-center/images/sites/default/files/book_pages/microtia-or-without-hearing-impairment.jpg": [
		573959,
		9,
		573959
	],
	"./education-center/images/sites/default/files/book_pages/migalastat-response.jpg": [
		974405,
		9,
		974405
	],
	"./education-center/images/sites/default/files/book_pages/migraine-familial-basilar.jpg": [
		320755,
		9,
		320755
	],
	"./education-center/images/sites/default/files/book_pages/migraine-or-without-aura-susceptibility-1.jpg": [
		810512,
		9,
		810512
	],
	"./education-center/images/sites/default/files/book_pages/migraine-resistance.jpg": [
		917399,
		9,
		917399
	],
	"./education-center/images/sites/default/files/book_pages/migraine-sporadic-hemiplegic-progressive-cerebellar-ataxia.jpg": [
		339039,
		9,
		339039
	],
	"./education-center/images/sites/default/files/book_pages/migraine.jpg": [
		42162,
		9,
		42162
	],
	"./education-center/images/sites/default/files/book_pages/mild-global-developmental-delay.jpg": [
		26740,
		9,
		26740
	],
	"./education-center/images/sites/default/files/book_pages/mild-non-pku-hyperphenylalanemia.jpg": [
		824158,
		9,
		824158
	],
	"./education-center/images/sites/default/files/book_pages/mild-short-stature.jpg": [
		990915,
		9,
		990915
	],
	"./education-center/images/sites/default/files/book_pages/mineralocorticoid-deficiency-isolated.jpg": [
		675873,
		9,
		675873
	],
	"./education-center/images/sites/default/files/book_pages/mirror-movements-1.jpg": [
		783928,
		9,
		783928
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-complex-iii-deficiency-nuclear-type-1.jpg": [
		52276,
		9,
		52276
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-complex-iv-deficiency-recurrent-myoglobinuria.jpg": [
		251778,
		9,
		251778
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-cytochrome-c-oxidase-deficiency.jpg": [
		7497,
		9,
		7497
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-disorder-due-defect-assembly-or-maturation-respiratory-chain-complexes.jpg": [
		219390,
		9,
		219390
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-dna-associated-leigh-syndrome-and-narp.jpg": [
		987729,
		9,
		987729
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-dna-depletion-syndrome-16a.jpg": [
		15053,
		9,
		15053
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-dna-depletion-syndrome-8b-mngie-type.jpg": [
		251822,
		9,
		251822
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-dna-depletion-syndrome-hepatocerebral-form.jpg": [
		250243,
		9,
		250243
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-dna-related-disorder.jpg": [
		583140,
		9,
		583140
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-encephalomyopathy.jpg": [
		142443,
		9,
		142443
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-encephalopathy.jpg": [
		777118,
		9,
		777118
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-hepatopathy.jpg": [
		529692,
		9,
		529692
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-inheritance.jpg": [
		659175,
		9,
		659175
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-myopathy-episodic-without-optic-atrophy-and-reversible-leukoencephalopathy.jpg": [
		859808,
		9,
		859808
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-myopathy-isolated.jpg": [
		44547,
		9,
		44547
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-trifunctional-protein-deficiency-2-myopathy-and-neuropathy.jpg": [
		866031,
		9,
		866031
	],
	"./education-center/images/sites/default/files/book_pages/mitochondrial-trifunctional-protein-deficiency-2.jpg": [
		172590,
		9,
		172590
	],
	"./education-center/images/sites/default/files/book_pages/mixed-phenotype-acute-leukemia-tv11q233-kmt2a-rearranged.jpg": [
		318843,
		9,
		318843
	],
	"./education-center/images/sites/default/files/book_pages/mks1-related-disorders.jpg": [
		843668,
		9,
		843668
	],
	"./education-center/images/sites/default/files/book_pages/moderate-global-developmental-delay.jpg": [
		70480,
		9,
		70480
	],
	"./education-center/images/sites/default/files/book_pages/moderate-intellectual-deficiency.jpg": [
		152868,
		9,
		152868
	],
	"./education-center/images/sites/default/files/book_pages/monocarboxylate-transporter-1-deficiency-autosomal-dominant.jpg": [
		861922,
		9,
		861922
	],
	"./education-center/images/sites/default/files/book_pages/monocarboxylate-transporter-1-deficiency-autosomal-recessive.jpg": [
		905380,
		9,
		905380
	],
	"./education-center/images/sites/default/files/book_pages/monochromacy.jpg": [
		928573,
		9,
		928573
	],
	"./education-center/images/sites/default/files/book_pages/monoclonal-b-cell-lymphocytosis.jpg": [
		299991,
		9,
		299991
	],
	"./education-center/images/sites/default/files/book_pages/monogenic-non-syndromic-obesity.jpg": [
		478474,
		9,
		478474
	],
	"./education-center/images/sites/default/files/book_pages/monomelic-amyotrophy.jpg": [
		640104,
		9,
		640104
	],
	"./education-center/images/sites/default/files/book_pages/mononeuropathy-median-nerve.jpg": [
		964374,
		9,
		964374
	],
	"./education-center/images/sites/default/files/book_pages/morbid-obesity.jpg": [
		539434,
		9,
		539434
	],
	"./education-center/images/sites/default/files/book_pages/morm-syndrome.jpg": [
		253870,
		9,
		253870
	],
	"./education-center/images/sites/default/files/book_pages/mosaic-variegated-aneuploidy-syndrome.jpg": [
		882687,
		9,
		882687
	],
	"./education-center/images/sites/default/files/book_pages/motor-axonal-neuropathy.jpg": [
		282149,
		9,
		282149
	],
	"./education-center/images/sites/default/files/book_pages/motor-delay.jpg": [
		134545,
		9,
		134545
	],
	"./education-center/images/sites/default/files/book_pages/motor-tics.jpg": [
		738635,
		9,
		738635
	],
	"./education-center/images/sites/default/files/book_pages/movement-disorder.jpg": [
		614266,
		9,
		614266
	],
	"./education-center/images/sites/default/files/book_pages/mpv17-related-disorders.jpg": [
		852635,
		9,
		852635
	],
	"./education-center/images/sites/default/files/book_pages/mthfr-thermolabile-polymorphism.jpg": [
		217557,
		9,
		217557
	],
	"./education-center/images/sites/default/files/book_pages/mucolipidosis-iii-alphabeta-atypical.jpg": [
		726240,
		9,
		726240
	],
	"./education-center/images/sites/default/files/book_pages/mucolipidosis-type-iii-alphabeta.jpg": [
		67104,
		9,
		67104
	],
	"./education-center/images/sites/default/files/book_pages/mucolipidosis.jpg": [
		19866,
		9,
		19866
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysaccharidosis-type-1.jpg": [
		443751,
		9,
		443751
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysaccharidosis-type-ii-mild-form.jpg": [
		541093,
		9,
		541093
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysaccharidosis-type-vi-intermediate.jpg": [
		406157,
		9,
		406157
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysaccharidosis-type-vi-mild.jpg": [
		992321,
		9,
		992321
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysaccharidosis-type-vi-severe.jpg": [
		708410,
		9,
		708410
	],
	"./education-center/images/sites/default/files/book_pages/mucopolysacchariduria.jpg": [
		76450,
		9,
		76450
	],
	"./education-center/images/sites/default/files/book_pages/mucosa-associated-lymphoma.jpg": [
		443626,
		9,
		443626
	],
	"./education-center/images/sites/default/files/book_pages/muir-torr%C3%A9-syndrome.jpg": [
		963023,
		9,
		963023
	],
	"./education-center/images/sites/default/files/book_pages/mullerian-aplasia-and-hyperandrogenism.jpg": [
		598250,
		9,
		598250
	],
	"./education-center/images/sites/default/files/book_pages/multi-minicore-disease-and-atypical-periodic-paralysis.jpg": [
		569940,
		9,
		569940
	],
	"./education-center/images/sites/default/files/book_pages/multicentric-osteolysis-nodulosis-arthropathy-mona-spectrum-disorders.jpg": [
		233733,
		9,
		233733
	],
	"./education-center/images/sites/default/files/book_pages/multifocal-breast-carcinoma_0.jpg": [
		760796,
		9,
		760796
	],
	"./education-center/images/sites/default/files/book_pages/multiminicoreminicoremulticore-disease.jpg": [
		535229,
		9,
		535229
	],
	"./education-center/images/sites/default/files/book_pages/multiple-congenital-anomalies.jpg": [
		926403,
		9,
		926403
	],
	"./education-center/images/sites/default/files/book_pages/multiple-congenital-exostosis.jpg": [
		195335,
		9,
		195335
	],
	"./education-center/images/sites/default/files/book_pages/multiple-endocrine-neoplasia-type-1.jpg": [
		246000,
		9,
		246000
	],
	"./education-center/images/sites/default/files/book_pages/multiple-endocrine-neoplasia-type-iia-hirschsprung-disease.jpg": [
		723204,
		9,
		723204
	],
	"./education-center/images/sites/default/files/book_pages/multiple-endocrine-neoplasia-type-iia-without-pheochromocytoma.jpg": [
		701959,
		9,
		701959
	],
	"./education-center/images/sites/default/files/book_pages/multiple-epiphyseal-dysplasia-dominant.jpg": [
		58374,
		9,
		58374
	],
	"./education-center/images/sites/default/files/book_pages/multiple-epiphyseal-dysplasia-type-1.jpg": [
		637016,
		9,
		637016
	],
	"./education-center/images/sites/default/files/book_pages/multiple-fibrofolliculomas.jpg": [
		486065,
		9,
		486065
	],
	"./education-center/images/sites/default/files/book_pages/multiple-myeloma-resistance.jpg": [
		11039,
		9,
		11039
	],
	"./education-center/images/sites/default/files/book_pages/multiple-myeloma-translocation-1114-type.jpg": [
		480595,
		9,
		480595
	],
	"./education-center/images/sites/default/files/book_pages/multiple-sclerosis-modifier-disease-progression.jpg": [
		859767,
		9,
		859767
	],
	"./education-center/images/sites/default/files/book_pages/multiple-sclerosis-susceptibility.jpg": [
		397379,
		9,
		397379
	],
	"./education-center/images/sites/default/files/book_pages/multiple-self-healing-squamous-epithelioma.jpg": [
		895901,
		9,
		895901
	],
	"./education-center/images/sites/default/files/book_pages/multiple-system-atrophy.jpg": [
		54706,
		9,
		54706
	],
	"./education-center/images/sites/default/files/book_pages/multisystem-disorder.jpg": [
		725243,
		9,
		725243
	],
	"./education-center/images/sites/default/files/book_pages/multisystem-inflammatory-syndrome-children.jpg": [
		511715,
		9,
		511715
	],
	"./education-center/images/sites/default/files/book_pages/muscle-stiffness-painful.jpg": [
		140889,
		9,
		140889
	],
	"./education-center/images/sites/default/files/book_pages/muscular-dystrophy-and-arthrogryposis.jpg": [
		118917,
		9,
		118917
	],
	"./education-center/images/sites/default/files/book_pages/muscular-dystrophy-congenital-or-without-seizures.jpg": [
		553596,
		9,
		553596
	],
	"./education-center/images/sites/default/files/book_pages/muscular-dystrophy-dystroglycanopathy-congenital-without-impaired-intellectual-development-type-b-5.jpg": [
		456114,
		9,
		456114
	],
	"./education-center/images/sites/default/files/book_pages/mutilating-keratoderma.jpg": [
		832174,
		9,
		832174
	],
	"./education-center/images/sites/default/files/book_pages/mvk-related-disorders.jpg": [
		727300,
		9,
		727300
	],
	"./education-center/images/sites/default/files/book_pages/myasthenic-syndrome-slow-channel-congenital.jpg": [
		756626,
		9,
		756626
	],
	"./education-center/images/sites/default/files/book_pages/mybpc3-related-disorders.jpg": [
		652541,
		9,
		652541
	],
	"./education-center/images/sites/default/files/book_pages/mycobacterium-tuberculosis-protection-against.jpg": [
		564385,
		9,
		564385
	],
	"./education-center/images/sites/default/files/book_pages/myelodysplastic-syndrome-progressed-acute-myeloid-leukemia.jpg": [
		978260,
		9,
		978260
	],
	"./education-center/images/sites/default/files/book_pages/myeloproliferative-disorder-chronic-eosinophilia.jpg": [
		633707,
		9,
		633707
	],
	"./education-center/images/sites/default/files/book_pages/myeloproliferative-disorder.jpg": [
		623165,
		9,
		623165
	],
	"./education-center/images/sites/default/files/book_pages/myh3-related-disorders.jpg": [
		544676,
		9,
		544676
	],
	"./education-center/images/sites/default/files/book_pages/myh7-related-disorders.jpg": [
		931757,
		9,
		931757
	],
	"./education-center/images/sites/default/files/book_pages/myh7-related-skeletal-myopathy.jpg": [
		894183,
		9,
		894183
	],
	"./education-center/images/sites/default/files/book_pages/myh9-related-disorder.jpg": [
		208633,
		9,
		208633
	],
	"./education-center/images/sites/default/files/book_pages/myhre-syndrome.jpg": [
		572997,
		9,
		572997
	],
	"./education-center/images/sites/default/files/book_pages/myo7a-related-disorders.jpg": [
		510972,
		9,
		510972
	],
	"./education-center/images/sites/default/files/book_pages/myoc-related-disorders.jpg": [
		213401,
		9,
		213401
	],
	"./education-center/images/sites/default/files/book_pages/myocardial-infarction-1.jpg": [
		925737,
		9,
		925737
	],
	"./education-center/images/sites/default/files/book_pages/myocardial-infarction-protection-against.jpg": [
		637369,
		9,
		637369
	],
	"./education-center/images/sites/default/files/book_pages/myoclonic-absence-seizure.jpg": [
		163294,
		9,
		163294
	],
	"./education-center/images/sites/default/files/book_pages/myoclonic-encephalopathy.jpg": [
		550106,
		9,
		550106
	],
	"./education-center/images/sites/default/files/book_pages/myofibrillar-myopathy-dominant.jpg": [
		776056,
		9,
		776056
	],
	"./education-center/images/sites/default/files/book_pages/myokymia-1-hypomagnesemia.jpg": [
		111394,
		9,
		111394
	],
	"./education-center/images/sites/default/files/book_pages/myokymia.jpg": [
		538089,
		9,
		538089
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-centronuclear-2.jpg": [
		648671,
		9,
		648671
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-congenital-due-dihydropyridine-receptor-defect.jpg": [
		637480,
		9,
		637480
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-congenital-neonatal-respiratory-insufficiency.jpg": [
		986527,
		9,
		986527
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-congenital-nonprogressive.jpg": [
		236716,
		9,
		236716
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-lactic-acidosis-and-sideroblastic-anemia.jpg": [
		465248,
		9,
		465248
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-mitochondrial-diabetes-mellitus.jpg": [
		796500,
		9,
		796500
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-mitochondrial-late-onset.jpg": [
		96106,
		9,
		96106
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-myalgia-increased-serum-creatine-kinase-and-or-without-episodic-rhabdomyolysis.jpg": [
		592012,
		9,
		592012
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-progressive-axial-cataracts.jpg": [
		188503,
		9,
		188503
	],
	"./education-center/images/sites/default/files/book_pages/myopathy-ryr1-associated.jpg": [
		456293,
		9,
		456293
	],
	"./education-center/images/sites/default/files/book_pages/myopia.jpg": [
		98054,
		9,
		98054
	],
	"./education-center/images/sites/default/files/book_pages/myositis-eosinophilic.jpg": [
		221117,
		9,
		221117
	],
	"./education-center/images/sites/default/files/book_pages/myotonia-congenita-atypical-acetazolamide-responsive.jpg": [
		188558,
		9,
		188558
	],
	"./education-center/images/sites/default/files/book_pages/myotonia-levior.jpg": [
		318650,
		9,
		318650
	],
	"./education-center/images/sites/default/files/book_pages/myotonia.jpg": [
		857684,
		9,
		857684
	],
	"./education-center/images/sites/default/files/book_pages/nager-syndrome.jpg": [
		232731,
		9,
		232731
	],
	"./education-center/images/sites/default/files/book_pages/nanophthalmia.jpg": [
		123773,
		9,
		123773
	],
	"./education-center/images/sites/default/files/book_pages/nemaline-myopathy-3-autosomal-dominant-or-recessive.jpg": [
		984264,
		9,
		984264
	],
	"./education-center/images/sites/default/files/book_pages/nemaline-myopathy-7.jpg": [
		136371,
		9,
		136371
	],
	"./education-center/images/sites/default/files/book_pages/nemaline-myopathy-dominant.jpg": [
		719291,
		9,
		719291
	],
	"./education-center/images/sites/default/files/book_pages/nemaline-myopathy-recessive.jpg": [
		218606,
		9,
		218606
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-death.jpg": [
		753132,
		9,
		753132
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-encephalopathy.jpg": [
		744232,
		9,
		744232
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-epileptic-spasm.jpg": [
		796581,
		9,
		796581
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-hypotonia.jpg": [
		298441,
		9,
		298441
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-insulin-dependent-diabetes-mellitus.jpg": [
		661444,
		9,
		661444
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-lactic-acidosis.jpg": [
		433713,
		9,
		433713
	],
	"./education-center/images/sites/default/files/book_pages/neonatal-respiratory-distress.jpg": [
		965783,
		9,
		965783
	],
	"./education-center/images/sites/default/files/book_pages/neoplasm-central-nervous-system.jpg": [
		192020,
		9,
		192020
	],
	"./education-center/images/sites/default/files/book_pages/neoplasm-parathyroid-gland.jpg": [
		677107,
		9,
		677107
	],
	"./education-center/images/sites/default/files/book_pages/nephritis.jpg": [
		840541,
		9,
		840541
	],
	"./education-center/images/sites/default/files/book_pages/nephroblastoma.jpg": [
		813846,
		9,
		813846
	],
	"./education-center/images/sites/default/files/book_pages/nephrocalcinosis.jpg": [
		631825,
		9,
		631825
	],
	"./education-center/images/sites/default/files/book_pages/nephrolithiasisnephrocalcinosis.jpg": [
		595477,
		9,
		595477
	],
	"./education-center/images/sites/default/files/book_pages/nephrolithiasisosteoporosis-hypophosphatemic.jpg": [
		293932,
		9,
		293932
	],
	"./education-center/images/sites/default/files/book_pages/nephronophthisis-14.jpg": [
		685792,
		9,
		685792
	],
	"./education-center/images/sites/default/files/book_pages/nephronophthisis-8.jpg": [
		30575,
		9,
		30575
	],
	"./education-center/images/sites/default/files/book_pages/nephronophthisis-nephropathy.jpg": [
		815984,
		9,
		815984
	],
	"./education-center/images/sites/default/files/book_pages/nephrotic-range-proteinuria.jpg": [
		843716,
		9,
		843716
	],
	"./education-center/images/sites/default/files/book_pages/neuroblastoma-susceptibility.jpg": [
		365229,
		9,
		365229
	],
	"./education-center/images/sites/default/files/book_pages/neuroblastoma.jpg": [
		196179,
		9,
		196179
	],
	"./education-center/images/sites/default/files/book_pages/neurocirculatory-asthenia.jpg": [
		991405,
		9,
		991405
	],
	"./education-center/images/sites/default/files/book_pages/neurodegeneration-and-seizures-due-copper-transport-defect.jpg": [
		631576,
		9,
		631576
	],
	"./education-center/images/sites/default/files/book_pages/neurodegeneration-brain-iron-accumulation-1-atypical.jpg": [
		145350,
		9,
		145350
	],
	"./education-center/images/sites/default/files/book_pages/neurodegeneration-developmental-delay-early-respiratory-failure-myoclonic-seizures-and-brain.jpg": [
		828877,
		9,
		828877
	],
	"./education-center/images/sites/default/files/book_pages/neurodegeneration-due-3-hydroxyisobutyryl-coenzyme-hydrolase-deficiency.jpg": [
		197801,
		9,
		197801
	],
	"./education-center/images/sites/default/files/book_pages/neurodegeneration.jpg": [
		843946,
		9,
		843946
	],
	"./education-center/images/sites/default/files/book_pages/neurodegenerative-illness-progressing-crippling-dystonia-and-death-relentless-cerebral-atrophy.jpg": [
		157148,
		9,
		157148
	],
	"./education-center/images/sites/default/files/book_pages/neurodevelopmental-abnormality.jpg": [
		573636,
		9,
		573636
	],
	"./education-center/images/sites/default/files/book_pages/neurodevelopmental-delay.jpg": [
		452038,
		9,
		452038
	],
	"./education-center/images/sites/default/files/book_pages/neurodevelopmental-disorder-epilepsy-and-hemochromatosis.jpg": [
		411134,
		9,
		411134
	],
	"./education-center/images/sites/default/files/book_pages/neurodevelopmental-disorder-microcephaly-and-speech-delay-or-without-brain-abnormalities.jpg": [
		490608,
		9,
		490608
	],
	"./education-center/images/sites/default/files/book_pages/neurodevelopmental-disorder-mtor-related.jpg": [
		112232,
		9,
		112232
	],
	"./education-center/images/sites/default/files/book_pages/neuroendocrine-tumor-pancreas.jpg": [
		84508,
		9,
		84508
	],
	"./education-center/images/sites/default/files/book_pages/neurofibromatosis-type-2.jpg": [
		321461,
		9,
		321461
	],
	"./education-center/images/sites/default/files/book_pages/neurogastrointestinal-syndrome-mitochondrial.jpg": [
		415903,
		9,
		415903
	],
	"./education-center/images/sites/default/files/book_pages/neurohypophyseal-diabetes-insipidus.jpg": [
		889694,
		9,
		889694
	],
	"./education-center/images/sites/default/files/book_pages/neuromuscular-disease-congenital-uniform-type-1-fiber.jpg": [
		494505,
		9,
		494505
	],
	"./education-center/images/sites/default/files/book_pages/neuronal-ceroid-lipofuscinosis-dominantrecessive.jpg": [
		399753,
		9,
		399753
	],
	"./education-center/images/sites/default/files/book_pages/neuronal-ceroid-lipofuscinosis-recessive.jpg": [
		445328,
		9,
		445328
	],
	"./education-center/images/sites/default/files/book_pages/neuronopathy-distal-hereditary-motor-type-2a.jpg": [
		113649,
		9,
		113649
	],
	"./education-center/images/sites/default/files/book_pages/neuronopathy-distal-hereditary-motor-type-7a.jpg": [
		469331,
		9,
		469331
	],
	"./education-center/images/sites/default/files/book_pages/neuronopathy-distal-hereditary-motor.jpg": [
		323079,
		9,
		323079
	],
	"./education-center/images/sites/default/files/book_pages/neurooculorenal-syndrome.jpg": [
		52018,
		9,
		52018
	],
	"./education-center/images/sites/default/files/book_pages/neuropathy-axonal-vocal-cord-paresis-autosomal-recessive.jpg": [
		692772,
		9,
		692772
	],
	"./education-center/images/sites/default/files/book_pages/neuropathy-hereditary-sensory-and-autonomic-type-ia-severe.jpg": [
		655945,
		9,
		655945
	],
	"./education-center/images/sites/default/files/book_pages/neuropathy-hereditary-sensory-and-autonomic-type-ic-severe.jpg": [
		363729,
		9,
		363729
	],
	"./education-center/images/sites/default/files/book_pages/neuropsychiatric-disorder-and-early-onset-cataract.jpg": [
		507477,
		9,
		507477
	],
	"./education-center/images/sites/default/files/book_pages/neutropenia.jpg": [
		2926,
		9,
		2926
	],
	"./education-center/images/sites/default/files/book_pages/neutrophil-inclusion-bodies.jpg": [
		654197,
		9,
		654197
	],
	"./education-center/images/sites/default/files/book_pages/nevus-sebaceous.jpg": [
		339971,
		9,
		339971
	],
	"./education-center/images/sites/default/files/book_pages/newfoundland-cone-rod-dystrophy.jpg": [
		453406,
		9,
		453406
	],
	"./education-center/images/sites/default/files/book_pages/nicotine-addiction-protection-against.jpg": [
		203545,
		9,
		203545
	],
	"./education-center/images/sites/default/files/book_pages/nicotine-dependence-protection-against.jpg": [
		815439,
		9,
		815439
	],
	"./education-center/images/sites/default/files/book_pages/nicotine-poor-metabolism.jpg": [
		783770,
		9,
		783770
	],
	"./education-center/images/sites/default/files/book_pages/niemann-pick-disease-intermediate-protracted-neurovisceral.jpg": [
		55483,
		9,
		55483
	],
	"./education-center/images/sites/default/files/book_pages/niemann-pick-disease-type-c1-adult-form.jpg": [
		437997,
		9,
		437997
	],
	"./education-center/images/sites/default/files/book_pages/niemann-pick-disease-type-c1-juvenile-form.jpg": [
		649246,
		9,
		649246
	],
	"./education-center/images/sites/default/files/book_pages/niemann-pick-disease-type-d.jpg": [
		956013,
		9,
		956013
	],
	"./education-center/images/sites/default/files/book_pages/nik-deficiency.jpg": [
		749048,
		9,
		749048
	],
	"./education-center/images/sites/default/files/book_pages/nodal-related-disorders.jpg": [
		676164,
		9,
		676164
	],
	"./education-center/images/sites/default/files/book_pages/non-obstructive-azoospermia.jpg": [
		539221,
		9,
		539221
	],
	"./education-center/images/sites/default/files/book_pages/non-syndromic-intellectual-disability.jpg": [
		537474,
		9,
		537474
	],
	"./education-center/images/sites/default/files/book_pages/non-syndromic-oligodontia.jpg": [
		273256,
		9,
		273256
	],
	"./education-center/images/sites/default/files/book_pages/noncompaction-cardiomyopathy.jpg": [
		733912,
		9,
		733912
	],
	"./education-center/images/sites/default/files/book_pages/nonpapillary-renal-cell-carcinoma.jpg": [
		96275,
		9,
		96275
	],
	"./education-center/images/sites/default/files/book_pages/nonpersistence-intestinal-lactase.jpg": [
		926561,
		9,
		926561
	],
	"./education-center/images/sites/default/files/book_pages/nonsmall-cell-lung-cancer-resistance-tyrosine-kinase-inhibitor.jpg": [
		366485,
		9,
		366485
	],
	"./education-center/images/sites/default/files/book_pages/nonsmall-cell-lung-cancer-response-tyrosine-kinase-inhibitor-somatic.jpg": [
		540814,
		9,
		540814
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-cleft-lip-or-without-cleft-palate.jpg": [
		992739,
		9,
		992739
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-congenital-nail-disorder-3.jpg": [
		674074,
		9,
		674074
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-deafness.jpg": [
		276970,
		9,
		276970
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-hearing-loss-and-deafness-autosomal-recessive.jpg": [
		734057,
		9,
		734057
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-hearing-loss-dominant.jpg": [
		545543,
		9,
		545543
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-hearing-loss-mixed.jpg": [
		383562,
		9,
		383562
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-hearing-loss-recessive.jpg": [
		142985,
		9,
		142985
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-hypergonadotropic-hypogonadism.jpg": [
		904633,
		9,
		904633
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-oculocutaneous-albinism.jpg": [
		822695,
		9,
		822695
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-otitis-media.jpg": [
		626211,
		9,
		626211
	],
	"./education-center/images/sites/default/files/book_pages/nonsyndromic-sensorineural-hearing-loss.jpg": [
		692395,
		9,
		692395
	],
	"./education-center/images/sites/default/files/book_pages/noonan-syndrome-disorder-juvenile-myelomonocytic-leukemia.jpg": [
		654962,
		9,
		654962
	],
	"./education-center/images/sites/default/files/book_pages/noonan-syndrome-multiple-lentigines.jpg": [
		173095,
		9,
		173095
	],
	"./education-center/images/sites/default/files/book_pages/noonan-syndrome.jpg": [
		173810,
		9,
		173810
	],
	"./education-center/images/sites/default/files/book_pages/nor-polyagglutination-syndrome.jpg": [
		911578,
		9,
		911578
	],
	"./education-center/images/sites/default/files/book_pages/normal-pregnancy.jpg": [
		538610,
		9,
		538610
	],
	"./education-center/images/sites/default/files/book_pages/normokalemic-periodic-paralysis-potassium-sensitive.jpg": [
		323158,
		9,
		323158
	],
	"./education-center/images/sites/default/files/book_pages/north-carolina-macular-dystrophy.jpg": [
		821584,
		9,
		821584
	],
	"./education-center/images/sites/default/files/book_pages/nphp4-related-disorders.jpg": [
		892762,
		9,
		892762
	],
	"./education-center/images/sites/default/files/book_pages/nr2e3-related-disorders.jpg": [
		901809,
		9,
		901809
	],
	"./education-center/images/sites/default/files/book_pages/nuclear-pulverulent-cataract.jpg": [
		312955,
		9,
		312955
	],
	"./education-center/images/sites/default/files/book_pages/obesity-age-onset.jpg": [
		747983,
		9,
		747983
	],
	"./education-center/images/sites/default/files/book_pages/obesity-association.jpg": [
		222947,
		9,
		222947
	],
	"./education-center/images/sites/default/files/book_pages/obesity-autosomal-dominant.jpg": [
		284374,
		9,
		284374
	],
	"./education-center/images/sites/default/files/book_pages/obesity-bmiq12-susceptibility.jpg": [
		909300,
		9,
		909300
	],
	"./education-center/images/sites/default/files/book_pages/obesity-early-onset-susceptibility.jpg": [
		879562,
		9,
		879562
	],
	"./education-center/images/sites/default/files/book_pages/obesity-mild-early-onset.jpg": [
		871635,
		9,
		871635
	],
	"./education-center/images/sites/default/files/book_pages/obesity-resistance.jpg": [
		723194,
		9,
		723194
	],
	"./education-center/images/sites/default/files/book_pages/obesity-severe-and-type-ii-diabetes.jpg": [
		73490,
		9,
		73490
	],
	"./education-center/images/sites/default/files/book_pages/obstructive-azoospermia.jpg": [
		439135,
		9,
		439135
	],
	"./education-center/images/sites/default/files/book_pages/ochoa-syndrome.jpg": [
		743166,
		9,
		743166
	],
	"./education-center/images/sites/default/files/book_pages/ocular-albinism-congenital-sensorineural-hearing-loss.jpg": [
		834537,
		9,
		834537
	],
	"./education-center/images/sites/default/files/book_pages/oculocutaneous-albinism-type-ii-modifier.jpg": [
		81316,
		9,
		81316
	],
	"./education-center/images/sites/default/files/book_pages/oculomotor-apraxia.jpg": [
		949918,
		9,
		949918
	],
	"./education-center/images/sites/default/files/book_pages/oculootoradial-syndrome.jpg": [
		871503,
		9,
		871503
	],
	"./education-center/images/sites/default/files/book_pages/oculoskeletodental-syndrome.jpg": [
		886700,
		9,
		886700
	],
	"./education-center/images/sites/default/files/book_pages/oligodontia.jpg": [
		690895,
		9,
		690895
	],
	"./education-center/images/sites/default/files/book_pages/olivopontocerebellar-hypoplasia.jpg": [
		309209,
		9,
		309209
	],
	"./education-center/images/sites/default/files/book_pages/oocytezygoteembryo-maturation-arrest-17.jpg": [
		96841,
		9,
		96841
	],
	"./education-center/images/sites/default/files/book_pages/oocytezygoteembryo-maturation-arrest-19.jpg": [
		561491,
		9,
		561491
	],
	"./education-center/images/sites/default/files/book_pages/ophthalmoplegia-isolated.jpg": [
		756883,
		9,
		756883
	],
	"./education-center/images/sites/default/files/book_pages/optic-atrophy-dominant.jpg": [
		695111,
		9,
		695111
	],
	"./education-center/images/sites/default/files/book_pages/optic-atrophy-or-without-deafness-ophthalmoplegia-myopathy-ataxia-and-neuropathy.jpg": [
		440613,
		9,
		440613
	],
	"./education-center/images/sites/default/files/book_pages/optic-atrophy-recessive.jpg": [
		332731,
		9,
		332731
	],
	"./education-center/images/sites/default/files/book_pages/optic-nerve-aplasia-bilateral.jpg": [
		379102,
		9,
		379102
	],
	"./education-center/images/sites/default/files/book_pages/optic-nerve-dysplasia.jpg": [
		179037,
		9,
		179037
	],
	"./education-center/images/sites/default/files/book_pages/optic-nerve-hypoplasia-and-abnormalities-central-nervous-system.jpg": [
		949221,
		9,
		949221
	],
	"./education-center/images/sites/default/files/book_pages/optic-nerve-hypoplasia.jpg": [
		115298,
		9,
		115298
	],
	"./education-center/images/sites/default/files/book_pages/ornithine-decarboxylase-1-polymorphism.jpg": [
		579904,
		9,
		579904
	],
	"./education-center/images/sites/default/files/book_pages/orofacial-cleft-7.jpg": [
		209316,
		9,
		209316
	],
	"./education-center/images/sites/default/files/book_pages/orofacial-cleft.jpg": [
		798403,
		9,
		798403
	],
	"./education-center/images/sites/default/files/book_pages/oromandibular-limb-hypogenesis-spectrum.jpg": [
		411470,
		9,
		411470
	],
	"./education-center/images/sites/default/files/book_pages/orthostatic-hypotension.jpg": [
		316847,
		9,
		316847
	],
	"./education-center/images/sites/default/files/book_pages/ossifying-fibroma-jaw.jpg": [
		375194,
		9,
		375194
	],
	"./education-center/images/sites/default/files/book_pages/osteoarthritis-hip.jpg": [
		293936,
		9,
		293936
	],
	"./education-center/images/sites/default/files/book_pages/osteoarthritis-susceptibility-2.jpg": [
		295858,
		9,
		295858
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-dominant.jpg": [
		52273,
		9,
		52273
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-mild.jpg": [
		32107,
		9,
		32107
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-recessive.jpg": [
		211118,
		9,
		211118
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-type-1-mild.jpg": [
		825756,
		9,
		825756
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-type-2-thin-bone.jpg": [
		569156,
		9,
		569156
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-type-iic.jpg": [
		215591,
		9,
		215591
	],
	"./education-center/images/sites/default/files/book_pages/osteogenesis-imperfecta-type-iiiiv.jpg": [
		519621,
		9,
		519621
	],
	"./education-center/images/sites/default/files/book_pages/osteopoikilosis.jpg": [
		966923,
		9,
		966923
	],
	"./education-center/images/sites/default/files/book_pages/osteoporosis-early-onset-susceptibility.jpg": [
		776634,
		9,
		776634
	],
	"./education-center/images/sites/default/files/book_pages/otitis-media.jpg": [
		249955,
		9,
		249955
	],
	"./education-center/images/sites/default/files/book_pages/otx2-related-syndromic-microphthalmia.jpg": [
		566481,
		9,
		566481
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-cancer-epithelial-somatic.jpg": [
		328028,
		9,
		328028
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-carcinoma.jpg": [
		715323,
		9,
		715323
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-dysgenesis.jpg": [
		180930,
		9,
		180930
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-papillary-adenocarcinoma.jpg": [
		437727,
		9,
		437727
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-response-fsh-stimulation.jpg": [
		640618,
		9,
		640618
	],
	"./education-center/images/sites/default/files/book_pages/ovarian-serous-cystadenocarcinoma.jpg": [
		874087,
		9,
		874087
	],
	"./education-center/images/sites/default/files/book_pages/p-phenotype.jpg": [
		788549,
		9,
		788549
	],
	"./education-center/images/sites/default/files/book_pages/pain-insensitivity.jpg": [
		693066,
		9,
		693066
	],
	"./education-center/images/sites/default/files/book_pages/palb2-related-disorders.jpg": [
		473574,
		9,
		473574
	],
	"./education-center/images/sites/default/files/book_pages/pallister-hall-syndrome.jpg": [
		907411,
		9,
		907411
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-hyperkeratosis-and-true-hermaphroditism.jpg": [
		244841,
		9,
		244841
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma-deafness-syndrome.jpg": [
		19186,
		9,
		19186
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma-epidermolytic-knuckle-pads.jpg": [
		785284,
		9,
		785284
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma-esophageal-carcinoma-syndrome.jpg": [
		863549,
		9,
		863549
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma-i-striate-focal-or-diffuse.jpg": [
		941550,
		9,
		941550
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma-punctate-type-1a.jpg": [
		227207,
		9,
		227207
	],
	"./education-center/images/sites/default/files/book_pages/palmoplantar-keratoderma.jpg": [
		620202,
		9,
		620202
	],
	"./education-center/images/sites/default/files/book_pages/pancreatic-adenocarcinoma.jpg": [
		44066,
		9,
		44066
	],
	"./education-center/images/sites/default/files/book_pages/pancreatic-hypoplasia.jpg": [
		577986,
		9,
		577986
	],
	"./education-center/images/sites/default/files/book_pages/pancreatitis-chronic-protection-against.jpg": [
		345906,
		9,
		345906
	],
	"./education-center/images/sites/default/files/book_pages/pancreatitis-chronic-susceptibility.jpg": [
		421901,
		9,
		421901
	],
	"./education-center/images/sites/default/files/book_pages/pancytopenia.jpg": [
		436529,
		9,
		436529
	],
	"./education-center/images/sites/default/files/book_pages/papillary-renal-cell-carcinoma-sporadic.jpg": [
		920218,
		9,
		920218
	],
	"./education-center/images/sites/default/files/book_pages/papillary-renal-cell-carcinoma-type-1.jpg": [
		929934,
		9,
		929934
	],
	"./education-center/images/sites/default/files/book_pages/papillary-thyroid-carcinoma.jpg": [
		883255,
		9,
		883255
	],
	"./education-center/images/sites/default/files/book_pages/papillorenal-syndrome-macular-abnormalities.jpg": [
		734862,
		9,
		734862
	],
	"./education-center/images/sites/default/files/book_pages/para-bombay-phenotype.jpg": [
		19552,
		9,
		19552
	],
	"./education-center/images/sites/default/files/book_pages/paraganglioma.jpg": [
		259780,
		9,
		259780
	],
	"./education-center/images/sites/default/files/book_pages/paragangliomas-1-sensorineural-hearing-loss.jpg": [
		948370,
		9,
		948370
	],
	"./education-center/images/sites/default/files/book_pages/paragangliomas-4.jpg": [
		867862,
		9,
		867862
	],
	"./education-center/images/sites/default/files/book_pages/paramyotonia-congenitahyperkalemic-periodic-paralysis.jpg": [
		91728,
		9,
		91728
	],
	"./education-center/images/sites/default/files/book_pages/paramyotonia-congenitamyotonia-congenita.jpg": [
		687167,
		9,
		687167
	],
	"./education-center/images/sites/default/files/book_pages/parathyroid-adenoma-somatic.jpg": [
		727444,
		9,
		727444
	],
	"./education-center/images/sites/default/files/book_pages/parathyroid-gland-adenoma.jpg": [
		60646,
		9,
		60646
	],
	"./education-center/images/sites/default/files/book_pages/parkes-weber-syndrome.jpg": [
		166365,
		9,
		166365
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-6.jpg": [
		291084,
		9,
		291084
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-autosomal-recessive-early-onset-digenic-pink1dj1.jpg": [
		29108,
		9,
		29108
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-dominant.jpg": [
		550152,
		9,
		550152
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-dominantrecessive.jpg": [
		495072,
		9,
		495072
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-juvenile.jpg": [
		541919,
		9,
		541919
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-recessive.jpg": [
		891873,
		9,
		891873
	],
	"./education-center/images/sites/default/files/book_pages/parkinson-disease-x-linked-dominant.jpg": [
		688750,
		9,
		688750
	],
	"./education-center/images/sites/default/files/book_pages/parkinsonism-plus.jpg": [
		941929,
		9,
		941929
	],
	"./education-center/images/sites/default/files/book_pages/parkinsonism.jpg": [
		29003,
		9,
		29003
	],
	"./education-center/images/sites/default/files/book_pages/paroxysmal-atrial-fibrillation.jpg": [
		480504,
		9,
		480504
	],
	"./education-center/images/sites/default/files/book_pages/partial-adenosine-deaminase-deficiency.jpg": [
		826575,
		9,
		826575
	],
	"./education-center/images/sites/default/files/book_pages/partial-agenesis-corpus-callosum.jpg": [
		889196,
		9,
		889196
	],
	"./education-center/images/sites/default/files/book_pages/partial-congenital-absence-teeth.jpg": [
		407216,
		9,
		407216
	],
	"./education-center/images/sites/default/files/book_pages/pazopanib-response.jpg": [
		886489,
		9,
		886489
	],
	"./education-center/images/sites/default/files/book_pages/peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.jpg": [
		206493,
		9,
		206493
	],
	"./education-center/images/sites/default/files/book_pages/peginterferon-alfa-2a-peginterferon-alfa-2b-ribavirin-and-telaprevir-response-efficacy.jpg": [
		493621,
		9,
		493621
	],
	"./education-center/images/sites/default/files/book_pages/peginterferon-alfa-2a-response-efficacy.jpg": [
		778736,
		9,
		778736
	],
	"./education-center/images/sites/default/files/book_pages/peginterferon-alfa-2b-response-efficacy.jpg": [
		620479,
		9,
		620479
	],
	"./education-center/images/sites/default/files/book_pages/pelizaeus-merzbacher-disease-atypical.jpg": [
		688572,
		9,
		688572
	],
	"./education-center/images/sites/default/files/book_pages/periampullary-adenoma.jpg": [
		547284,
		9,
		547284
	],
	"./education-center/images/sites/default/files/book_pages/pericementitis.jpg": [
		208523,
		9,
		208523
	],
	"./education-center/images/sites/default/files/book_pages/periventricular-laminar-heterotopia.jpg": [
		722862,
		9,
		722862
	],
	"./education-center/images/sites/default/files/book_pages/periventricular-nodular-heterotopia-syndactyly-cleft-palate-and-developmental-delay.jpg": [
		781061,
		9,
		781061
	],
	"./education-center/images/sites/default/files/book_pages/perlman-syndrome.jpg": [
		302852,
		9,
		302852
	],
	"./education-center/images/sites/default/files/book_pages/peroxisomal-biogenesis-disorder-3b.jpg": [
		554250,
		9,
		554250
	],
	"./education-center/images/sites/default/files/book_pages/peroxisome-biogenesis-disorder-complementation-group-7.jpg": [
		431138,
		9,
		431138
	],
	"./education-center/images/sites/default/files/book_pages/persistent-mullerian-duct-syndrome-type-i.jpg": [
		640857,
		9,
		640857
	],
	"./education-center/images/sites/default/files/book_pages/persistent-mullerian-duct-syndrome-type-ii.jpg": [
		720305,
		9,
		720305
	],
	"./education-center/images/sites/default/files/book_pages/pervasive-developmental-disorder.jpg": [
		628684,
		9,
		628684
	],
	"./education-center/images/sites/default/files/book_pages/pes-cavus.jpg": [
		223173,
		9,
		223173
	],
	"./education-center/images/sites/default/files/book_pages/pex7-related-disorders.jpg": [
		793020,
		9,
		793020
	],
	"./education-center/images/sites/default/files/book_pages/pfeiffer-syndrome.jpg": [
		628473,
		9,
		628473
	],
	"./education-center/images/sites/default/files/book_pages/phenprocoumon-response-dosage.jpg": [
		612970,
		9,
		612970
	],
	"./education-center/images/sites/default/files/book_pages/phenylthiocarbamide-tasting.jpg": [
		126965,
		9,
		126965
	],
	"./education-center/images/sites/default/files/book_pages/phenytoin-response.jpg": [
		134118,
		9,
		134118
	],
	"./education-center/images/sites/default/files/book_pages/pheochromocytoma-susceptibility.jpg": [
		206598,
		9,
		206598
	],
	"./education-center/images/sites/default/files/book_pages/phonic-tics.jpg": [
		189478,
		9,
		189478
	],
	"./education-center/images/sites/default/files/book_pages/phosphoglycerate-kinase-electrophoretic-variant-pgk-ii.jpg": [
		468370,
		9,
		468370
	],
	"./education-center/images/sites/default/files/book_pages/piebaldism-progressive.jpg": [
		557117,
		9,
		557117
	],
	"./education-center/images/sites/default/files/book_pages/piebaldism-sensorineural-deafness.jpg": [
		421515,
		9,
		421515
	],
	"./education-center/images/sites/default/files/book_pages/pierre-robin-syndrome.jpg": [
		731856,
		9,
		731856
	],
	"./education-center/images/sites/default/files/book_pages/pigmentary-retinal-dystrophy.jpg": [
		920374,
		9,
		920374
	],
	"./education-center/images/sites/default/files/book_pages/pigmentary-retinopathy-and-sensorineural-deafness.jpg": [
		2322,
		9,
		2322
	],
	"./education-center/images/sites/default/files/book_pages/pigmentary-retinopathy.jpg": [
		806370,
		9,
		806370
	],
	"./education-center/images/sites/default/files/book_pages/pilomatrixoma.jpg": [
		466469,
		9,
		466469
	],
	"./education-center/images/sites/default/files/book_pages/piroxicam-response.jpg": [
		500316,
		9,
		500316
	],
	"./education-center/images/sites/default/files/book_pages/pituitary-adenoma-predisposition.jpg": [
		290375,
		9,
		290375
	],
	"./education-center/images/sites/default/files/book_pages/pituitary-hormone-deficiency-combined-5.jpg": [
		371809,
		9,
		371809
	],
	"./education-center/images/sites/default/files/book_pages/pituitary-hormone-deficiency-combined-or-isolated-8.jpg": [
		805552,
		9,
		805552
	],
	"./education-center/images/sites/default/files/book_pages/pituitary-hypothyroidism.jpg": [
		878352,
		9,
		878352
	],
	"./education-center/images/sites/default/files/book_pages/pitx2-related-eye-abnormalities.jpg": [
		621956,
		9,
		621956
	],
	"./education-center/images/sites/default/files/book_pages/plasma-triglyceride-level-quantitative-trait-locus.jpg": [
		670127,
		9,
		670127
	],
	"./education-center/images/sites/default/files/book_pages/plasminogen-deficiency-type-i.jpg": [
		503392,
		9,
		503392
	],
	"./education-center/images/sites/default/files/book_pages/plasmodium-vivax-resistance.jpg": [
		944780,
		9,
		944780
	],
	"./education-center/images/sites/default/files/book_pages/platyspondylic-dysplasia-torrance-type.jpg": [
		20891,
		9,
		20891
	],
	"./education-center/images/sites/default/files/book_pages/pol-iii-related-leukodystrophy.jpg": [
		997279,
		9,
		997279
	],
	"./education-center/images/sites/default/files/book_pages/pole-exonuclease-domain-mutation.jpg": [
		345907,
		9,
		345907
	],
	"./education-center/images/sites/default/files/book_pages/polg-related-disorders.jpg": [
		589180,
		9,
		589180
	],
	"./education-center/images/sites/default/files/book_pages/polg-related-spectrum-disorders.jpg": [
		573880,
		9,
		573880
	],
	"./education-center/images/sites/default/files/book_pages/polr1c-related-disorders.jpg": [
		938514,
		9,
		938514
	],
	"./education-center/images/sites/default/files/book_pages/polr3-related-leukodystrophy.jpg": [
		845371,
		9,
		845371
	],
	"./education-center/images/sites/default/files/book_pages/poly-adp-ribose-polymerase-inhibitor-response.jpg": [
		366356,
		9,
		366356
	],
	"./education-center/images/sites/default/files/book_pages/polycythemia.jpg": [
		826113,
		9,
		826113
	],
	"./education-center/images/sites/default/files/book_pages/polyglucosan-body-myopathy-1-immunodeficiency.jpg": [
		952316,
		9,
		952316
	],
	"./education-center/images/sites/default/files/book_pages/polyglucosan-body-myopathy-1-without-immunodeficiency.jpg": [
		558904,
		9,
		558904
	],
	"./education-center/images/sites/default/files/book_pages/polymerase-proofreading-associated-polyposis.jpg": [
		94235,
		9,
		94235
	],
	"./education-center/images/sites/default/files/book_pages/polymicrogyria.jpg": [
		307144,
		9,
		307144
	],
	"./education-center/images/sites/default/files/book_pages/polyostotic-fibrous-dysplasia-somatic-mosaic.jpg": [
		300218,
		9,
		300218
	],
	"./education-center/images/sites/default/files/book_pages/polysyndactyly.jpg": [
		702765,
		9,
		702765
	],
	"./education-center/images/sites/default/files/book_pages/pomgnt1-related-disorders.jpg": [
		804608,
		9,
		804608
	],
	"./education-center/images/sites/default/files/book_pages/pontocerebellar-hypoplasia-type-1a.jpg": [
		962806,
		9,
		962806
	],
	"./education-center/images/sites/default/files/book_pages/porencephalic-cyst.jpg": [
		173295,
		9,
		173295
	],
	"./education-center/images/sites/default/files/book_pages/porphyria-acute-hepatic-digenic.jpg": [
		41326,
		9,
		41326
	],
	"./education-center/images/sites/default/files/book_pages/porphyria-acute-intermittent-nonerythroid-variant.jpg": [
		585411,
		9,
		585411
	],
	"./education-center/images/sites/default/files/book_pages/postanesthetic-apnea.jpg": [
		156488,
		9,
		156488
	],
	"./education-center/images/sites/default/files/book_pages/postaxial-polydactyly-type-a1b.jpg": [
		776413,
		9,
		776413
	],
	"./education-center/images/sites/default/files/book_pages/posterior-polar-cataract.jpg": [
		981104,
		9,
		981104
	],
	"./education-center/images/sites/default/files/book_pages/posterior-polymorphous-corneal-dystrophy-1.jpg": [
		361834,
		9,
		361834
	],
	"./education-center/images/sites/default/files/book_pages/postural-tremor.jpg": [
		277870,
		9,
		277870
	],
	"./education-center/images/sites/default/files/book_pages/ppargc1b-polymorphism.jpg": [
		899721,
		9,
		899721
	],
	"./education-center/images/sites/default/files/book_pages/pravastatin-response-efficacy.jpg": [
		468600,
		9,
		468600
	],
	"./education-center/images/sites/default/files/book_pages/precocious-puberty-males.jpg": [
		859473,
		9,
		859473
	],
	"./education-center/images/sites/default/files/book_pages/predisposition-invasive-fungal-disease-due-card9-deficiency.jpg": [
		538220,
		9,
		538220
	],
	"./education-center/images/sites/default/files/book_pages/prednisolone-response.jpg": [
		510601,
		9,
		510601
	],
	"./education-center/images/sites/default/files/book_pages/preimplantation-embryonic-lethality-1.jpg": [
		386946,
		9,
		737249
	],
	"./education-center/images/sites/default/files/book_pages/preimplantation-embryonic-lethality-2.jpg": [
		987850,
		9,
		987850
	],
	"./education-center/images/sites/default/files/book_pages/preimplantation-lethality.jpg": [
		678250,
		9,
		678250
	],
	"./education-center/images/sites/default/files/book_pages/prelingual-sensorineural-hearing-impairment.jpg": [
		172470,
		9,
		172470
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait.jpg": [
		317826,
		9,
		317826
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_0.jpg": [
		295913,
		9,
		295913
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_1.jpg": [
		57700,
		9,
		57700
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_10.jpg": [
		542127,
		9,
		542127
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_11.jpg": [
		97573,
		9,
		97573
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_12.jpg": [
		763619,
		9,
		763619
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_13.jpg": [
		361463,
		9,
		361463
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_14.jpg": [
		803088,
		9,
		803088
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_15.jpg": [
		336347,
		9,
		336347
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_16.jpg": [
		628760,
		9,
		628760
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_17.jpg": [
		905177,
		9,
		905177
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_18.jpg": [
		571592,
		9,
		571592
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_19.jpg": [
		610207,
		9,
		610207
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_2.jpg": [
		324426,
		9,
		324426
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_20.jpg": [
		685350,
		9,
		685350
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_21.jpg": [
		386175,
		9,
		386175
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_22.jpg": [
		336971,
		9,
		336971
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_23.jpg": [
		777399,
		9,
		777399
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_24.jpg": [
		25862,
		9,
		25862
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_25.jpg": [
		855377,
		9,
		855377
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_26.jpg": [
		80862,
		9,
		80862
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_27.jpg": [
		167058,
		9,
		167058
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_28.jpg": [
		494946,
		9,
		494946
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_29.jpg": [
		391698,
		9,
		391698
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_3.jpg": [
		992358,
		9,
		992358
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_30.jpg": [
		273534,
		9,
		273534
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_4.jpg": [
		11351,
		9,
		11351
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_5.jpg": [
		836186,
		9,
		836186
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_6.jpg": [
		321610,
		9,
		321610
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_7.jpg": [
		553647,
		9,
		553647
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_8.jpg": [
		124824,
		9,
		124824
	],
	"./education-center/images/sites/default/files/book_pages/premature-chromatid-separation-trait_9.jpg": [
		229345,
		9,
		229345
	],
	"./education-center/images/sites/default/files/book_pages/premature-coronary-artery-atherosclerosis.jpg": [
		720375,
		9,
		720375
	],
	"./education-center/images/sites/default/files/book_pages/premature-ovarian-failure-21.jpg": [
		953235,
		9,
		953235
	],
	"./education-center/images/sites/default/files/book_pages/premature-ovarian-failure.jpg": [
		355487,
		9,
		355487
	],
	"./education-center/images/sites/default/files/book_pages/premature-ovarian-insufficiency.jpg": [
		463231,
		9,
		463231
	],
	"./education-center/images/sites/default/files/book_pages/preterm-intraventricular-hemorrhage.jpg": [
		127481,
		9,
		127481
	],
	"./education-center/images/sites/default/files/book_pages/pretibial-dystrophic-epidermolysis-bullosa.jpg": [
		381664,
		9,
		381664
	],
	"./education-center/images/sites/default/files/book_pages/primary-aldosteronism.jpg": [
		810240,
		9,
		810240
	],
	"./education-center/images/sites/default/files/book_pages/primary-amenorrhea.jpg": [
		74993,
		9,
		74993
	],
	"./education-center/images/sites/default/files/book_pages/primary-congenital-glaucoma.jpg": [
		344097,
		9,
		344097
	],
	"./education-center/images/sites/default/files/book_pages/primary-degenerative-dementia-alzheimer-type-presenile-onset.jpg": [
		113137,
		9,
		113137
	],
	"./education-center/images/sites/default/files/book_pages/primary-erythromelalgia.jpg": [
		277922,
		9,
		277922
	],
	"./education-center/images/sites/default/files/book_pages/primary-failure-tooth-eruption.jpg": [
		89193,
		9,
		89193
	],
	"./education-center/images/sites/default/files/book_pages/primary-familial-polycythemia-due-epo-receptor-mutation.jpg": [
		891352,
		9,
		891352
	],
	"./education-center/images/sites/default/files/book_pages/primary-interstitial-lung-disease-specific-childhood-due-pulmonary-surfactant-protein-anomalies.jpg": [
		656819,
		9,
		656819
	],
	"./education-center/images/sites/default/files/book_pages/primary-low-grade-serous-adenocarcinoma-ovary.jpg": [
		719406,
		9,
		719406
	],
	"./education-center/images/sites/default/files/book_pages/primary-microcephaly-2-or-without-cortical-malformations.jpg": [
		50383,
		9,
		50383
	],
	"./education-center/images/sites/default/files/book_pages/primary-microcephaly-recessive.jpg": [
		65366,
		9,
		65366
	],
	"./education-center/images/sites/default/files/book_pages/primary-microcephaly.jpg": [
		79826,
		9,
		79826
	],
	"./education-center/images/sites/default/files/book_pages/primary-open-angle-glaucoma.jpg": [
		630932,
		9,
		630932
	],
	"./education-center/images/sites/default/files/book_pages/primitive-neuroectodermal-tumor.jpg": [
		826966,
		9,
		826966
	],
	"./education-center/images/sites/default/files/book_pages/prkag2-cardiac-syndrome.jpg": [
		872235,
		9,
		872235
	],
	"./education-center/images/sites/default/files/book_pages/profound-global-developmental-delay.jpg": [
		359827,
		9,
		359827
	],
	"./education-center/images/sites/default/files/book_pages/profound-hearing-impairment.jpg": [
		32091,
		9,
		32091
	],
	"./education-center/images/sites/default/files/book_pages/programmed-death-ligand-1-pd-l1-blocking-antibody-response.jpg": [
		657044,
		9,
		657044
	],
	"./education-center/images/sites/default/files/book_pages/progressive-cerebellar-ataxia.jpg": [
		866299,
		9,
		866299
	],
	"./education-center/images/sites/default/files/book_pages/progressive-childhood-encephalopathy.jpg": [
		665835,
		9,
		665835
	],
	"./education-center/images/sites/default/files/book_pages/progressive-cone-degeneration.jpg": [
		516013,
		9,
		516013
	],
	"./education-center/images/sites/default/files/book_pages/progressive-cone-dystrophy-without-rod-involvement.jpg": [
		469743,
		9,
		469743
	],
	"./education-center/images/sites/default/files/book_pages/progressive-congenital-scoliosis.jpg": [
		741631,
		9,
		741631
	],
	"./education-center/images/sites/default/files/book_pages/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions-digenic.jpg": [
		452491,
		9,
		452491
	],
	"./education-center/images/sites/default/files/book_pages/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions.jpg": [
		5192,
		9,
		5192
	],
	"./education-center/images/sites/default/files/book_pages/progressive-external-ophthalmoplegia-myoclonus.jpg": [
		282140,
		9,
		282140
	],
	"./education-center/images/sites/default/files/book_pages/progressive-external-ophthalmoplegia-proximal-myopathy-and-sudden-death.jpg": [
		308048,
		9,
		308048
	],
	"./education-center/images/sites/default/files/book_pages/progressive-familial-heart-block-type-1a.jpg": [
		215833,
		9,
		215833
	],
	"./education-center/images/sites/default/files/book_pages/progressive-microcephaly.jpg": [
		209494,
		9,
		209494
	],
	"./education-center/images/sites/default/files/book_pages/progressive-muscle-weakness.jpg": [
		933467,
		9,
		933467
	],
	"./education-center/images/sites/default/files/book_pages/progressive-myoclonic-epilepsy-type-5.jpg": [
		530818,
		9,
		530818
	],
	"./education-center/images/sites/default/files/book_pages/progressive-myositis-ossificans.jpg": [
		683206,
		9,
		683206
	],
	"./education-center/images/sites/default/files/book_pages/progressive-neurodegenerative-disease.jpg": [
		876007,
		9,
		876007
	],
	"./education-center/images/sites/default/files/book_pages/progressive-psychomotor-deterioration.jpg": [
		946233,
		9,
		946233
	],
	"./education-center/images/sites/default/files/book_pages/progressive-pulmonary-failure.jpg": [
		463974,
		9,
		463974
	],
	"./education-center/images/sites/default/files/book_pages/progressive-sensorineural-hearing-impairment.jpg": [
		426893,
		9,
		426893
	],
	"./education-center/images/sites/default/files/book_pages/progressive-spastic-paraparesis.jpg": [
		19892,
		9,
		19892
	],
	"./education-center/images/sites/default/files/book_pages/progressive-supranuclear-ophthalmoplegia.jpg": [
		607644,
		9,
		607644
	],
	"./education-center/images/sites/default/files/book_pages/progressive-ventriculomegaly.jpg": [
		128773,
		9,
		128773
	],
	"./education-center/images/sites/default/files/book_pages/proguanil-poor-metabolism.jpg": [
		607228,
		9,
		607228
	],
	"./education-center/images/sites/default/files/book_pages/prolonged-prothrombin-time.jpg": [
		402670,
		9,
		402670
	],
	"./education-center/images/sites/default/files/book_pages/properdin-deficiency-type-ii.jpg": [
		180503,
		9,
		180503
	],
	"./education-center/images/sites/default/files/book_pages/properdin-deficiency-type-iii.jpg": [
		198805,
		9,
		198805
	],
	"./education-center/images/sites/default/files/book_pages/proportionate-short-stature.jpg": [
		620025,
		9,
		620025
	],
	"./education-center/images/sites/default/files/book_pages/prostate-cancer-somatic.jpg": [
		805399,
		9,
		805399
	],
	"./education-center/images/sites/default/files/book_pages/prostate-cancer-susceptibility.jpg": [
		157718,
		9,
		157718
	],
	"./education-center/images/sites/default/files/book_pages/prostate-cancer-susceptibility_0.jpg": [
		682328,
		9,
		682328
	],
	"./education-center/images/sites/default/files/book_pages/proteasome-associated-autoinflammatory-syndrome-1-digenic.jpg": [
		965163,
		9,
		694976
	],
	"./education-center/images/sites/default/files/book_pages/proximal-16p112-microdeletion-syndrome.jpg": [
		900413,
		9,
		900413
	],
	"./education-center/images/sites/default/files/book_pages/proximal-muscle-weakness-upper-limbs.jpg": [
		553872,
		9,
		553872
	],
	"./education-center/images/sites/default/files/book_pages/proximal-muscle-weakness.jpg": [
		262381,
		9,
		262381
	],
	"./education-center/images/sites/default/files/book_pages/prph2-related-disorders.jpg": [
		77325,
		9,
		77325
	],
	"./education-center/images/sites/default/files/book_pages/prune-belly-syndrome.jpg": [
		347362,
		9,
		347362
	],
	"./education-center/images/sites/default/files/book_pages/pseudo-fractures.jpg": [
		577671,
		9,
		577671
	],
	"./education-center/images/sites/default/files/book_pages/pseudoarylsulfatase-deficiency.jpg": [
		698637,
		9,
		698637
	],
	"./education-center/images/sites/default/files/book_pages/pseudocholinesterase-deficiency.jpg": [
		345466,
		9,
		345466
	],
	"./education-center/images/sites/default/files/book_pages/pseudohermaphroditism-female-hypokalemia-due-glucocorticoid-resistance.jpg": [
		465913,
		9,
		465913
	],
	"./education-center/images/sites/default/files/book_pages/pseudohermaphroditism.jpg": [
		323003,
		9,
		323003
	],
	"./education-center/images/sites/default/files/book_pages/pseudohypoaldosteronism-type-2a.jpg": [
		863341,
		9,
		863341
	],
	"./education-center/images/sites/default/files/book_pages/pseudohypoparathyroidism-type-i.jpg": [
		974891,
		9,
		974891
	],
	"./education-center/images/sites/default/files/book_pages/pseudohypoparathyroidism-type-ia-testotoxicosis.jpg": [
		110571,
		9,
		110571
	],
	"./education-center/images/sites/default/files/book_pages/pseudoxanthoma-elasticum-modifier-severity.jpg": [
		961827,
		9,
		961827
	],
	"./education-center/images/sites/default/files/book_pages/psoriasis-2-pustular.jpg": [
		737903,
		9,
		737903
	],
	"./education-center/images/sites/default/files/book_pages/psoriasis-protection-against.jpg": [
		156465,
		9,
		156465
	],
	"./education-center/images/sites/default/files/book_pages/psychomotor-retardation.jpg": [
		145685,
		9,
		145685
	],
	"./education-center/images/sites/default/files/book_pages/psychotic-disorder.jpg": [
		476840,
		9,
		476840
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-alveolar-proteinosis.jpg": [
		299449,
		9,
		299449
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-arterial-hypertension-associated-another-disease.jpg": [
		865739,
		9,
		865739
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-arterial-hypertension-associated-congenital-heart-disease.jpg": [
		400832,
		9,
		400832
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-arterial-hypertension-related-hereditary-hemorrhagic-telangiectasia.jpg": [
		36940,
		9,
		36940
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-artery-atresia.jpg": [
		833989,
		9,
		833989
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-fibrosis-idiopathic-susceptibility.jpg": [
		113999,
		9,
		113999
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-hypertension-primary-1-hereditary-hemorrhagic-telangiectasia.jpg": [
		85978,
		9,
		85978
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-hypertension-primary-dexfenfluramine-associated.jpg": [
		793884,
		9,
		793884
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-hypertension-primary-fenfluramine-associated.jpg": [
		170327,
		9,
		170327
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-lymphangiectasia.jpg": [
		685755,
		9,
		685755
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-surfactant-metabolism-dysfunction-dominant.jpg": [
		321466,
		9,
		321466
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-surfactant-metabolism-dysfunction-recessive.jpg": [
		170586,
		9,
		170586
	],
	"./education-center/images/sites/default/files/book_pages/pulmonary-venoocclusive-disease-1-autosomal-dominant.jpg": [
		513458,
		9,
		513458
	],
	"./education-center/images/sites/default/files/book_pages/pura-syndrome.jpg": [
		938020,
		9,
		938020
	],
	"./education-center/images/sites/default/files/book_pages/pyruvate-kinase-hyperactivity.jpg": [
		291845,
		9,
		291845
	],
	"./education-center/images/sites/default/files/book_pages/qualitative-or-quantitative-defects-collagen-6.jpg": [
		725281,
		9,
		725281
	],
	"./education-center/images/sites/default/files/book_pages/radin-blood-group.jpg": [
		59822,
		9,
		59822
	],
	"./education-center/images/sites/default/files/book_pages/rapsn-related-disorders.jpg": [
		174701,
		9,
		174701
	],
	"./education-center/images/sites/default/files/book_pages/rare-disease-autism.jpg": [
		423150,
		9,
		423150
	],
	"./education-center/images/sites/default/files/book_pages/rare-genetic-deafness.jpg": [
		467160,
		9,
		467160
	],
	"./education-center/images/sites/default/files/book_pages/rare-genetic-intellectual-disability.jpg": [
		645399,
		9,
		645399
	],
	"./education-center/images/sites/default/files/book_pages/rare-isolated-myopia.jpg": [
		742697,
		9,
		742697
	],
	"./education-center/images/sites/default/files/book_pages/rare-syndromic-intellectual-disability.jpg": [
		816457,
		9,
		816457
	],
	"./education-center/images/sites/default/files/book_pages/ras-inhibitor-response.jpg": [
		673234,
		9,
		673234
	],
	"./education-center/images/sites/default/files/book_pages/rbbp8-related-disorders.jpg": [
		237731,
		9,
		237731
	],
	"./education-center/images/sites/default/files/book_pages/reclassified-mttp-polymorphism.jpg": [
		589747,
		9,
		589747
	],
	"./education-center/images/sites/default/files/book_pages/recombination-rate-quantitative-trait-locus-1.jpg": [
		315243,
		9,
		315243
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-fever.jpg": [
		609430,
		9,
		609430
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-hand-flapping.jpg": [
		291866,
		9,
		291866
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-infections.jpg": [
		339422,
		9,
		339422
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-pancreatitis.jpg": [
		476795,
		9,
		476795
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-spontaneous-abortion.jpg": [
		742479,
		9,
		742479
	],
	"./education-center/images/sites/default/files/book_pages/recurrent-subcortical-infarcts.jpg": [
		458429,
		9,
		458429
	],
	"./education-center/images/sites/default/files/book_pages/reduced-delayed-hypersensitivity.jpg": [
		564668,
		9,
		564668
	],
	"./education-center/images/sites/default/files/book_pages/reduced-factor-ix-activity.jpg": [
		454379,
		9,
		454379
	],
	"./education-center/images/sites/default/files/book_pages/reduced-muscle-fiber-perlecan.jpg": [
		508006,
		9,
		508006
	],
	"./education-center/images/sites/default/files/book_pages/reduced-phenylalanine-hydroxylase-level.jpg": [
		47901,
		9,
		47901
	],
	"./education-center/images/sites/default/files/book_pages/reduced-protein-c-activity.jpg": [
		906121,
		9,
		906121
	],
	"./education-center/images/sites/default/files/book_pages/reduced-serum-alpha-1-antitrypsin.jpg": [
		653218,
		9,
		653218
	],
	"./education-center/images/sites/default/files/book_pages/reduced-von-willebrand-factor-activity.jpg": [
		397743,
		9,
		397743
	],
	"./education-center/images/sites/default/files/book_pages/refractory-anemia-ringed-sideroblasts-clinical.jpg": [
		502511,
		9,
		502511
	],
	"./education-center/images/sites/default/files/book_pages/refractory-epilepsy.jpg": [
		613043,
		9,
		613043
	],
	"./education-center/images/sites/default/files/book_pages/refsum-disease-adult-1.jpg": [
		289872,
		9,
		289872
	],
	"./education-center/images/sites/default/files/book_pages/regorafenib-response.jpg": [
		614548,
		9,
		614548
	],
	"./education-center/images/sites/default/files/book_pages/regression-motor-development-severe-dystonia-and-corresponding-basal-ganglia-lesions.jpg": [
		498912,
		9,
		498912
	],
	"./education-center/images/sites/default/files/book_pages/renal-cell-carcinoma-paraneoplastic-erythrocytosis.jpg": [
		67585,
		9,
		67585
	],
	"./education-center/images/sites/default/files/book_pages/renal-coloboma-syndrome.jpg": [
		712504,
		9,
		712504
	],
	"./education-center/images/sites/default/files/book_pages/renal-cortical-hyperechogenicity.jpg": [
		897887,
		9,
		897887
	],
	"./education-center/images/sites/default/files/book_pages/renal-cysts-and-diabetes-syndrome.jpg": [
		289115,
		9,
		289115
	],
	"./education-center/images/sites/default/files/book_pages/renal-hypomagnesemia-2.jpg": [
		945515,
		9,
		945515
	],
	"./education-center/images/sites/default/files/book_pages/renal-hypomagnesemia-dominant.jpg": [
		586675,
		9,
		586675
	],
	"./education-center/images/sites/default/files/book_pages/renal-hypomagnesemia-recessive.jpg": [
		437304,
		9,
		437304
	],
	"./education-center/images/sites/default/files/book_pages/renal-hypoplasiaaplasia.jpg": [
		495922,
		9,
		495922
	],
	"./education-center/images/sites/default/files/book_pages/renal-insufficiency.jpg": [
		745521,
		9,
		745521
	],
	"./education-center/images/sites/default/files/book_pages/renal-transitional-cell-carcinoma.jpg": [
		276661,
		9,
		276661
	],
	"./education-center/images/sites/default/files/book_pages/renal-tubular-acidosis-distal-normal-red-cell-morphology.jpg": [
		12186,
		9,
		12186
	],
	"./education-center/images/sites/default/files/book_pages/renal-tubular-epithelial-cell-apoptosis.jpg": [
		187799,
		9,
		187799
	],
	"./education-center/images/sites/default/files/book_pages/renier-gabreels-jasper-syndrome.jpg": [
		456736,
		9,
		456736
	],
	"./education-center/images/sites/default/files/book_pages/repeat-number-microsatellite.jpg": [
		453879,
		9,
		453879
	],
	"./education-center/images/sites/default/files/book_pages/resistance-hepatitis-c-virus.jpg": [
		972398,
		9,
		972398
	],
	"./education-center/images/sites/default/files/book_pages/respiratory-infections-recurrent-and-failure-thrive-or-without-diarrhea.jpg": [
		352866,
		9,
		352866
	],
	"./education-center/images/sites/default/files/book_pages/resting-heart-rate.jpg": [
		917498,
		9,
		917498
	],
	"./education-center/images/sites/default/files/book_pages/retinal-arterial-macroaneurysm-supravascular-pulmonic-stenosis.jpg": [
		454802,
		9,
		454802
	],
	"./education-center/images/sites/default/files/book_pages/retinal-atrophy.jpg": [
		208399,
		9,
		208399
	],
	"./education-center/images/sites/default/files/book_pages/retinal-degeneration-autosomal-recessive-clumped-pigment-type.jpg": [
		872406,
		9,
		872406
	],
	"./education-center/images/sites/default/files/book_pages/retinal-detachment.jpg": [
		52546,
		9,
		52546
	],
	"./education-center/images/sites/default/files/book_pages/retinal-dystrophy-and-microvillus-inclusion-disease.jpg": [
		123362,
		9,
		123362
	],
	"./education-center/images/sites/default/files/book_pages/retinal-dystrophy-early-onset-severe-lrat-related.jpg": [
		884115,
		9,
		884115
	],
	"./education-center/images/sites/default/files/book_pages/retinal-dystrophy-early-onset-severe.jpg": [
		101412,
		9,
		101412
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-39.jpg": [
		950074,
		9,
		950074
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-4-autosomal-recessive.jpg": [
		585917,
		9,
		585917
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-43.jpg": [
		256562,
		9,
		256562
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-6.jpg": [
		833441,
		9,
		833441
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-61.jpg": [
		750698,
		9,
		750698
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-7-digenic.jpg": [
		230493,
		9,
		230493
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-dominant.jpg": [
		46352,
		9,
		46352
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-dominantrecessive.jpg": [
		851310,
		9,
		851310
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-juvenile-lrat-related.jpg": [
		629207,
		9,
		629207
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-recessive.jpg": [
		193343,
		9,
		193343
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-pigmentosa-x-linked-and-sinorespiratory-infections-or-without-deafness.jpg": [
		832239,
		9,
		832239
	],
	"./education-center/images/sites/default/files/book_pages/retinitis-punctata-albescens-autosomal-dominant.jpg": [
		897344,
		9,
		897344
	],
	"./education-center/images/sites/default/files/book_pages/retinoblastoma.jpg": [
		852987,
		9,
		852987
	],
	"./education-center/images/sites/default/files/book_pages/retinopathy-prematurity.jpg": [
		831574,
		9,
		831574
	],
	"./education-center/images/sites/default/files/book_pages/rett-syndrome-zappella-variant.jpg": [
		564661,
		9,
		564661
	],
	"./education-center/images/sites/default/files/book_pages/rh-mod-blood-group-phenotype.jpg": [
		826112,
		9,
		826112
	],
	"./education-center/images/sites/default/files/book_pages/rh-null-amorph-type.jpg": [
		257501,
		9,
		257501
	],
	"./education-center/images/sites/default/files/book_pages/rh-null-regulator-type.jpg": [
		358454,
		9,
		358454
	],
	"./education-center/images/sites/default/files/book_pages/rhabdomyosarcoma-somatic.jpg": [
		832361,
		9,
		832361
	],
	"./education-center/images/sites/default/files/book_pages/rhd-negative.jpg": [
		27326,
		9,
		27326
	],
	"./education-center/images/sites/default/files/book_pages/rheumatic-heart-disease.jpg": [
		373804,
		9,
		373804
	],
	"./education-center/images/sites/default/files/book_pages/rheumatoid-arthritis-progression.jpg": [
		863590,
		9,
		863590
	],
	"./education-center/images/sites/default/files/book_pages/rheumatoid-arthritis.jpg": [
		525746,
		9,
		525746
	],
	"./education-center/images/sites/default/files/book_pages/rhizomelic-dysplasia-ain-naz-type.jpg": [
		272063,
		9,
		272063
	],
	"./education-center/images/sites/default/files/book_pages/ribavirin-response-efficacy.jpg": [
		591527,
		9,
		591527
	],
	"./education-center/images/sites/default/files/book_pages/right-ventricular-cardiomyopathy.jpg": [
		601515,
		9,
		601515
	],
	"./education-center/images/sites/default/files/book_pages/rippling-muscle-disease-2-autosomal-recessive.jpg": [
		898274,
		9,
		898274
	],
	"./education-center/images/sites/default/files/book_pages/rlbp1-related-disorders.jpg": [
		378634,
		9,
		378634
	],
	"./education-center/images/sites/default/files/book_pages/robinow-syndrome-autosomal-recessive-aplasiahypoplasia-phalanges-and-metacarpalsmetatarsals.jpg": [
		480514,
		9,
		480514
	],
	"./education-center/images/sites/default/files/book_pages/robinow-syndrome-autosomal-recessive-brachy-syn-polydactyly.jpg": [
		532439,
		9,
		532439
	],
	"./education-center/images/sites/default/files/book_pages/rod-cone-dystrophy.jpg": [
		858599,
		9,
		858599
	],
	"./education-center/images/sites/default/files/book_pages/rosuvastatin-response-efficacy.jpg": [
		473702,
		9,
		473702
	],
	"./education-center/images/sites/default/files/book_pages/rpe65-related-disorders.jpg": [
		608657,
		9,
		608657
	],
	"./education-center/images/sites/default/files/book_pages/rrm2b-related-mitochondrial-disease.jpg": [
		603633,
		9,
		603633
	],
	"./education-center/images/sites/default/files/book_pages/ryr1-related-disorders.jpg": [
		67475,
		9,
		67475
	],
	"./education-center/images/sites/default/files/book_pages/sacral-defect-anterior-meningocele.jpg": [
		895887,
		9,
		895887
	],
	"./education-center/images/sites/default/files/book_pages/saethre-chotzen-syndrome-eyelid-anomalies.jpg": [
		981713,
		9,
		981713
	],
	"./education-center/images/sites/default/files/book_pages/saethre-chotzen-syndrome.jpg": [
		509883,
		9,
		509883
	],
	"./education-center/images/sites/default/files/book_pages/saldino-mainzer-syndrome.jpg": [
		319132,
		9,
		319132
	],
	"./education-center/images/sites/default/files/book_pages/sall4-related-spectrum-disorders.jpg": [
		788212,
		9,
		788212
	],
	"./education-center/images/sites/default/files/book_pages/salmeterol-response-efficacy.jpg": [
		166338,
		9,
		166338
	],
	"./education-center/images/sites/default/files/book_pages/sandhoff-disease-chronic.jpg": [
		218378,
		9,
		218378
	],
	"./education-center/images/sites/default/files/book_pages/sardinian-hpfh.jpg": [
		442808,
		9,
		442808
	],
	"./education-center/images/sites/default/files/book_pages/scaphocephaly-and-axenfeld-rieger-anomaly.jpg": [
		985975,
		9,
		985975
	],
	"./education-center/images/sites/default/files/book_pages/scapular-winging.jpg": [
		722328,
		9,
		722328
	],
	"./education-center/images/sites/default/files/book_pages/scapuloperoneal-myopathy.jpg": [
		605020,
		9,
		605020
	],
	"./education-center/images/sites/default/files/book_pages/scapuloperoneal-weakness.jpg": [
		799567,
		9,
		799567
	],
	"./education-center/images/sites/default/files/book_pages/schizophrenia-15.jpg": [
		193585,
		9,
		193585
	],
	"./education-center/images/sites/default/files/book_pages/schnyder-crystalline-corneal-dystrophy.jpg": [
		746208,
		9,
		746208
	],
	"./education-center/images/sites/default/files/book_pages/schwannomatosis-1-somatic.jpg": [
		744075,
		9,
		744075
	],
	"./education-center/images/sites/default/files/book_pages/scid-due-ada-deficiency-delayed-onset.jpg": [
		179898,
		9,
		179898
	],
	"./education-center/images/sites/default/files/book_pages/scn2a-related-generalized-epilepsy-febrile-seizures-plus.jpg": [
		917576,
		9,
		917576
	],
	"./education-center/images/sites/default/files/book_pages/scn5a-related-disorders.jpg": [
		369795,
		9,
		369795
	],
	"./education-center/images/sites/default/files/book_pages/scoliosis.jpg": [
		764056,
		9,
		764056
	],
	"./education-center/images/sites/default/files/book_pages/sdhb-related-disorders.jpg": [
		146349,
		9,
		146349
	],
	"./education-center/images/sites/default/files/book_pages/seizures-benign-familial-infantile-6.jpg": [
		436345,
		9,
		436345
	],
	"./education-center/images/sites/default/files/book_pages/seizures-benign-familial-neonatal-1-andor-myokymia.jpg": [
		690479,
		9,
		690479
	],
	"./education-center/images/sites/default/files/book_pages/seizures-benign-familial-neonatal-1.jpg": [
		932361,
		9,
		932361
	],
	"./education-center/images/sites/default/files/book_pages/seizures-benign-familial-neonatal-2.jpg": [
		660498,
		9,
		660498
	],
	"./education-center/images/sites/default/files/book_pages/seizures-sensorineural-deafness-ataxia-intellectual-disability-and-electrolyte-imbalance-syndrome.jpg": [
		448183,
		9,
		448183
	],
	"./education-center/images/sites/default/files/book_pages/selective-pituitary-resistance-thyroid-hormone.jpg": [
		125265,
		9,
		125265
	],
	"./education-center/images/sites/default/files/book_pages/selective-tooth-agenesis.jpg": [
		988148,
		9,
		988148
	],
	"./education-center/images/sites/default/files/book_pages/senior-loken-syndrome-1.jpg": [
		387988,
		9,
		387988
	],
	"./education-center/images/sites/default/files/book_pages/sensorimotor-neuropathy.jpg": [
		633018,
		9,
		633018
	],
	"./education-center/images/sites/default/files/book_pages/sensorineural-deafness-and-migraine.jpg": [
		579015,
		9,
		579015
	],
	"./education-center/images/sites/default/files/book_pages/sensorineural-deafness-hypertrophic-cardiomyopathy.jpg": [
		749558,
		9,
		749558
	],
	"./education-center/images/sites/default/files/book_pages/sensorineural-deafness-mild-renal-dysfunction.jpg": [
		646972,
		9,
		646972
	],
	"./education-center/images/sites/default/files/book_pages/sensory-axonal-neuropathy.jpg": [
		376072,
		9,
		376072
	],
	"./education-center/images/sites/default/files/book_pages/sensory-neuropathy-spastic-paraplegia.jpg": [
		339586,
		9,
		339586
	],
	"./education-center/images/sites/default/files/book_pages/sepn1-related-disorders.jpg": [
		901537,
		9,
		901537
	],
	"./education-center/images/sites/default/files/book_pages/septooptic-dysplasia-mild.jpg": [
		886305,
		9,
		886305
	],
	"./education-center/images/sites/default/files/book_pages/serum-level-adiponectin-1.jpg": [
		785052,
		9,
		785052
	],
	"./education-center/images/sites/default/files/book_pages/setx-related-disorders.jpg": [
		336788,
		9,
		336788
	],
	"./education-center/images/sites/default/files/book_pages/severe-combined-immunodeficiency-athabascan-type.jpg": [
		68188,
		9,
		68188
	],
	"./education-center/images/sites/default/files/book_pages/severe-combined-immunodeficiency-autosomal-recessive-t-cell-negative-b-cell-negative-nk-cell.jpg": [
		692894,
		9,
		692894
	],
	"./education-center/images/sites/default/files/book_pages/severe-combined-immunodeficiency-b-cell-negative.jpg": [
		708211,
		9,
		708211
	],
	"./education-center/images/sites/default/files/book_pages/severe-combined-immunodeficiency-partial.jpg": [
		107660,
		9,
		107660
	],
	"./education-center/images/sites/default/files/book_pages/severe-combined-immunodeficiency-sensitivity-ionizing-radiation-due-nhej1-deficiency.jpg": [
		682304,
		9,
		682304
	],
	"./education-center/images/sites/default/files/book_pages/severe-global-developmental-delay.jpg": [
		553374,
		9,
		553374
	],
	"./education-center/images/sites/default/files/book_pages/severe-hydrocephalus.jpg": [
		564554,
		9,
		564554
	],
	"./education-center/images/sites/default/files/book_pages/severe-intellectual-deficiency.jpg": [
		58380,
		9,
		58380
	],
	"./education-center/images/sites/default/files/book_pages/severe-lactic-acidosis.jpg": [
		607085,
		9,
		607085
	],
	"./education-center/images/sites/default/files/book_pages/severe-neonatal-hypotonia-improving-age.jpg": [
		376211,
		9,
		376211
	],
	"./education-center/images/sites/default/files/book_pages/severe-postnatal-growth-retardation.jpg": [
		384257,
		9,
		384257
	],
	"./education-center/images/sites/default/files/book_pages/severe-sensorineural-hearing-impairment.jpg": [
		114979,
		9,
		114979
	],
	"./education-center/images/sites/default/files/book_pages/severe-short-limb-dwarfism.jpg": [
		738328,
		9,
		738328
	],
	"./education-center/images/sites/default/files/book_pages/sex-cord-stromal-tumor.jpg": [
		365195,
		9,
		365195
	],
	"./education-center/images/sites/default/files/book_pages/sex-hormone-binding-globulin-deficiency.jpg": [
		852173,
		9,
		852173
	],
	"./education-center/images/sites/default/files/book_pages/sex-reversal.jpg": [
		133125,
		9,
		133125
	],
	"./education-center/images/sites/default/files/book_pages/sh3tc2-related-disorders.jpg": [
		555219,
		9,
		555219
	],
	"./education-center/images/sites/default/files/book_pages/short-fetal-femur-length.jpg": [
		295296,
		9,
		295296
	],
	"./education-center/images/sites/default/files/book_pages/short-nose.jpg": [
		670065,
		9,
		670065
	],
	"./education-center/images/sites/default/files/book_pages/short-qt-syndrome-4.jpg": [
		28778,
		9,
		28778
	],
	"./education-center/images/sites/default/files/book_pages/short-qt-syndrome-5.jpg": [
		440558,
		9,
		440558
	],
	"./education-center/images/sites/default/files/book_pages/short-qt-syndrome.jpg": [
		685968,
		9,
		685968
	],
	"./education-center/images/sites/default/files/book_pages/short-rib-thoracic-dysplasia-10-polydactyly.jpg": [
		700986,
		9,
		700986
	],
	"./education-center/images/sites/default/files/book_pages/short-rib-thoracic-dysplasia-10-without-polydactyly.jpg": [
		220001,
		9,
		220001
	],
	"./education-center/images/sites/default/files/book_pages/short-rib-thoracic-dysplasia-without-polydactyly.jpg": [
		990201,
		9,
		990201
	],
	"./education-center/images/sites/default/files/book_pages/short-sleep-familial-natural-1.jpg": [
		82256,
		9,
		82256
	],
	"./education-center/images/sites/default/files/book_pages/short-sleep-familial-natural-2.jpg": [
		208191,
		9,
		208191
	],
	"./education-center/images/sites/default/files/book_pages/short-stature-and-advanced-bone-age-early-onset-osteoarthritis.jpg": [
		498914,
		9,
		498914
	],
	"./education-center/images/sites/default/files/book_pages/short-stature-and-advanced-bone-age.jpg": [
		613942,
		9,
		613942
	],
	"./education-center/images/sites/default/files/book_pages/short-stature.jpg": [
		687525,
		9,
		687525
	],
	"./education-center/images/sites/default/files/book_pages/shoulder-girdle-muscle-weakness.jpg": [
		16189,
		9,
		16189
	],
	"./education-center/images/sites/default/files/book_pages/shoulder-subluxation.jpg": [
		565892,
		9,
		565892
	],
	"./education-center/images/sites/default/files/book_pages/sickle-cell-hemoglobin-o-arab-disease.jpg": [
		816308,
		9,
		816308
	],
	"./education-center/images/sites/default/files/book_pages/sideroblastic-anemia-1-late-onset.jpg": [
		578034,
		9,
		578034
	],
	"./education-center/images/sites/default/files/book_pages/sideroblastic-anemia-and-ataxia.jpg": [
		331092,
		9,
		331092
	],
	"./education-center/images/sites/default/files/book_pages/sigmoid-colon-cancer.jpg": [
		130729,
		9,
		130729
	],
	"./education-center/images/sites/default/files/book_pages/simplified-gyral-pattern.jpg": [
		279455,
		9,
		279455
	],
	"./education-center/images/sites/default/files/book_pages/sinus-node-disease.jpg": [
		890288,
		9,
		890288
	],
	"./education-center/images/sites/default/files/book_pages/skeletal-dysplasia-acanthosis-nigricans.jpg": [
		462186,
		9,
		462186
	],
	"./education-center/images/sites/default/files/book_pages/skeletal-muscle-glycogen-content-and-metabolism-quantitative-trait-locus.jpg": [
		567109,
		9,
		567109
	],
	"./education-center/images/sites/default/files/book_pages/skeletal-myopathy-responsive-riboflavin.jpg": [
		303044,
		9,
		303044
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-2-blond-hairfair-skin.jpg": [
		839234,
		9,
		839234
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-2-red-hairfair-skin.jpg": [
		447084,
		9,
		447084
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-3-bluegreen-eyes.jpg": [
		374813,
		9,
		374813
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-3-lightdark-skin.jpg": [
		81513,
		9,
		81513
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-6-blondbrown-hair.jpg": [
		813022,
		9,
		813022
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-7-darklight-skin.jpg": [
		488850,
		9,
		488850
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-9-darklight-hair.jpg": [
		784715,
		9,
		784715
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-variation-2.jpg": [
		243073,
		9,
		243073
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-variation-5.jpg": [
		528794,
		9,
		528794
	],
	"./education-center/images/sites/default/files/book_pages/skinhaireye-pigmentation-variation-8.jpg": [
		818080,
		9,
		818080
	],
	"./education-center/images/sites/default/files/book_pages/slc26a2-related-disorders.jpg": [
		233183,
		9,
		233183
	],
	"./education-center/images/sites/default/files/book_pages/slc26a4-related-disorders.jpg": [
		641342,
		9,
		641342
	],
	"./education-center/images/sites/default/files/book_pages/sleep-myoclonus.jpg": [
		572592,
		9,
		572592
	],
	"./education-center/images/sites/default/files/book_pages/sleep-related-hypermotor-epilepsy.jpg": [
		245809,
		9,
		245809
	],
	"./education-center/images/sites/default/files/book_pages/small-cell-carcinoma-ovary-hypercalcemic-type.jpg": [
		800459,
		9,
		800459
	],
	"./education-center/images/sites/default/files/book_pages/small-cervical-vertebral-bodies.jpg": [
		866010,
		9,
		866010
	],
	"./education-center/images/sites/default/files/book_pages/small-gestational-age.jpg": [
		562781,
		9,
		562781
	],
	"./education-center/images/sites/default/files/book_pages/small-intestine-carcinoid.jpg": [
		487144,
		9,
		487144
	],
	"./education-center/images/sites/default/files/book_pages/small-scrotum.jpg": [
		792658,
		9,
		792658
	],
	"./education-center/images/sites/default/files/book_pages/small-vessel-cerebrovascular-disease.jpg": [
		966481,
		9,
		966481
	],
	"./education-center/images/sites/default/files/book_pages/smith-magenis-syndrome.jpg": [
		712734,
		9,
		712734
	],
	"./education-center/images/sites/default/files/book_pages/smoking-quantitative-trait-locus-3.jpg": [
		964839,
		9,
		964839
	],
	"./education-center/images/sites/default/files/book_pages/sodium-serum-level-quantitative-trait-locus-1.jpg": [
		118953,
		9,
		118953
	],
	"./education-center/images/sites/default/files/book_pages/solitary-median-maxillary-central-incisor-syndrome.jpg": [
		357319,
		9,
		357319
	],
	"./education-center/images/sites/default/files/book_pages/soluble-interleukin-6-receptor-serum-level-quantitative-trait-locus.jpg": [
		869267,
		9,
		869267
	],
	"./education-center/images/sites/default/files/book_pages/somatostatin-analog-resistance.jpg": [
		312432,
		9,
		312432
	],
	"./education-center/images/sites/default/files/book_pages/somatotroph-adenoma.jpg": [
		537478,
		9,
		537478
	],
	"./education-center/images/sites/default/files/book_pages/sorsby-fundus-dystrophy.jpg": [
		191259,
		9,
		191259
	],
	"./education-center/images/sites/default/files/book_pages/sotos-syndrome-1.jpg": [
		561317,
		9,
		561317
	],
	"./education-center/images/sites/default/files/book_pages/spastic-ataxia-1.jpg": [
		553216,
		9,
		553216
	],
	"./education-center/images/sites/default/files/book_pages/spastic-cerebral-palsy.jpg": [
		666936,
		9,
		666936
	],
	"./education-center/images/sites/default/files/book_pages/spastic-paraplegia-70-autosomal-recessive.jpg": [
		225938,
		9,
		225938
	],
	"./education-center/images/sites/default/files/book_pages/spastic-paraplegia-72-autosomal-dominant.jpg": [
		258192,
		9,
		258192
	],
	"./education-center/images/sites/default/files/book_pages/spastic-paraplegia-autosomal-dominant.jpg": [
		110929,
		9,
		110929
	],
	"./education-center/images/sites/default/files/book_pages/spastic-paraplegia-recessive.jpg": [
		968205,
		9,
		968205
	],
	"./education-center/images/sites/default/files/book_pages/spastic-tetraparesis.jpg": [
		941672,
		9,
		941672
	],
	"./education-center/images/sites/default/files/book_pages/spata7-related-disorders.jpg": [
		678381,
		9,
		678381
	],
	"./education-center/images/sites/default/files/book_pages/spermatogenesis-maturation-arrest.jpg": [
		953828,
		9,
		953828
	],
	"./education-center/images/sites/default/files/book_pages/spermatogenic-failure-2.jpg": [
		681901,
		9,
		681901
	],
	"./education-center/images/sites/default/files/book_pages/spermatogenic-failure-x-linked-7.jpg": [
		773840,
		9,
		773840
	],
	"./education-center/images/sites/default/files/book_pages/spherocytosis-dominant.jpg": [
		352607,
		9,
		352607
	],
	"./education-center/images/sites/default/files/book_pages/spherocytosis-recessive.jpg": [
		903571,
		9,
		903571
	],
	"./education-center/images/sites/default/files/book_pages/spherocytosis-type-1-autosomal-recessive.jpg": [
		397741,
		9,
		397741
	],
	"./education-center/images/sites/default/files/book_pages/spherocytosis-type-3-autosomal-recessive.jpg": [
		596982,
		9,
		596982
	],
	"./education-center/images/sites/default/files/book_pages/spherocytosis.jpg": [
		138442,
		9,
		138442
	],
	"./education-center/images/sites/default/files/book_pages/spinal-muscular-atrophy-dominant.jpg": [
		915656,
		9,
		915656
	],
	"./education-center/images/sites/default/files/book_pages/spinal-muscular-atrophy-lower-extremity-predominant-2-ad.jpg": [
		802381,
		9,
		802381
	],
	"./education-center/images/sites/default/files/book_pages/spinal-muscular-atrophy.jpg": [
		371075,
		9,
		371075
	],
	"./education-center/images/sites/default/files/book_pages/spinal-neurofibromas.jpg": [
		645847,
		9,
		645847
	],
	"./education-center/images/sites/default/files/book_pages/spinocerebellar-ataxia-type-29.jpg": [
		413387,
		9,
		413387
	],
	"./education-center/images/sites/default/files/book_pages/spinocerebellar-ataxia-type-31.jpg": [
		335469,
		9,
		335469
	],
	"./education-center/images/sites/default/files/book_pages/spinocerebellar-ataxia-type-34.jpg": [
		851944,
		9,
		851944
	],
	"./education-center/images/sites/default/files/book_pages/spinocerebellar-ataxia-x-linked.jpg": [
		108226,
		9,
		108226
	],
	"./education-center/images/sites/default/files/book_pages/spinocerebellar-atrophy.jpg": [
		934207,
		9,
		934207
	],
	"./education-center/images/sites/default/files/book_pages/spondylocostal-dysostosis-5.jpg": [
		598114,
		9,
		598114
	],
	"./education-center/images/sites/default/files/book_pages/spondylocostal-dysostosis.jpg": [
		332547,
		9,
		332547
	],
	"./education-center/images/sites/default/files/book_pages/spondyloepimetaphyseal-dysplasia-joint-laxity-type-1-fractures.jpg": [
		371018,
		9,
		371018
	],
	"./education-center/images/sites/default/files/book_pages/spondyloepiphyseal-dysplasia-congenital-joint-dislocations.jpg": [
		812401,
		9,
		812401
	],
	"./education-center/images/sites/default/files/book_pages/spontaneous-recurrent-epistaxis.jpg": [
		658174,
		9,
		658174
	],
	"./education-center/images/sites/default/files/book_pages/sporadic-abdominal-aortic-aneurysm.jpg": [
		210365,
		9,
		210365
	],
	"./education-center/images/sites/default/files/book_pages/sprinting-performance.jpg": [
		232965,
		9,
		232965
	],
	"./education-center/images/sites/default/files/book_pages/squamous-cell-carcinoma-burn-scar-related-somatic.jpg": [
		275624,
		9,
		275624
	],
	"./education-center/images/sites/default/files/book_pages/squamous-cell-lung-carcinoma.jpg": [
		245842,
		9,
		245842
	],
	"./education-center/images/sites/default/files/book_pages/stargardt-disease-dominant.jpg": [
		178376,
		9,
		178376
	],
	"./education-center/images/sites/default/files/book_pages/stargardt-disease-recessive.jpg": [
		927735,
		9,
		927735
	],
	"./education-center/images/sites/default/files/book_pages/statins-attenuated-cholesterol-lowering.jpg": [
		921538,
		9,
		921538
	],
	"./education-center/images/sites/default/files/book_pages/stickler-syndrome-dominant.jpg": [
		962252,
		9,
		962252
	],
	"./education-center/images/sites/default/files/book_pages/stickler-syndrome-recessive.jpg": [
		999192,
		9,
		999192
	],
	"./education-center/images/sites/default/files/book_pages/stickler-syndrome-type-1.jpg": [
		569073,
		9,
		569073
	],
	"./education-center/images/sites/default/files/book_pages/striatal-degeneration.jpg": [
		419643,
		9,
		419643
	],
	"./education-center/images/sites/default/files/book_pages/striatal-necrosis-bilateral-dystonia.jpg": [
		737098,
		9,
		737098
	],
	"./education-center/images/sites/default/files/book_pages/subcortical-laminar-heterotopia-x-linked.jpg": [
		833017,
		9,
		833017
	],
	"./education-center/images/sites/default/files/book_pages/sublingual-nitroglycerin-susceptibility-poor-response.jpg": [
		811449,
		9,
		811449
	],
	"./education-center/images/sites/default/files/book_pages/subvalvular-aortic-stenosis.jpg": [
		457101,
		9,
		457101
	],
	"./education-center/images/sites/default/files/book_pages/sudden-unexplained-death-childhood.jpg": [
		248749,
		9,
		248749
	],
	"./education-center/images/sites/default/files/book_pages/sudden-unexplained-death.jpg": [
		360555,
		9,
		360555
	],
	"./education-center/images/sites/default/files/book_pages/sulfate-transporter-related-osteochondrodysplasia.jpg": [
		554406,
		9,
		554406
	],
	"./education-center/images/sites/default/files/book_pages/superoxide-dismutase-elevated-extracellular.jpg": [
		692114,
		9,
		692114
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-hangover.jpg": [
		78687,
		9,
		78687
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-leprosy-and-multibacillary-leprosy.jpg": [
		222178,
		9,
		222178
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-neovascular-type-age-related-macular-degeneration.jpg": [
		598546,
		9,
		598546
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-nonalcoholic-fatty-liver-disease.jpg": [
		20482,
		9,
		20482
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-progression-renal-failure-iga-nephropathy.jpg": [
		843675,
		9,
		843675
	],
	"./education-center/images/sites/default/files/book_pages/susceptibility-severe-cutaneous-adverse-reaction.jpg": [
		549743,
		9,
		549743
	],
	"./education-center/images/sites/default/files/book_pages/sweat-chloride-elevation-without-cystic-fibrosis.jpg": [
		610746,
		9,
		610746
	],
	"./education-center/images/sites/default/files/book_pages/symmetrical-dyschromatosis-extremities.jpg": [
		73050,
		9,
		73050
	],
	"./education-center/images/sites/default/files/book_pages/symphalangism-affecting-proximal-phalanx-4th-finger.jpg": [
		365838,
		9,
		365838
	],
	"./education-center/images/sites/default/files/book_pages/syndrome-entercolitis-and-autoinflmmation-caused-mutation-nlrc4-scan4.jpg": [
		303009,
		9,
		303009
	],
	"./education-center/images/sites/default/files/book_pages/syndrome-microcephaly-major-feature.jpg": [
		604965,
		9,
		604965
	],
	"./education-center/images/sites/default/files/book_pages/syndromic-intellectual-disability.jpg": [
		438606,
		9,
		781063
	],
	"./education-center/images/sites/default/files/book_pages/syndromic-microphthalmia-dominant.jpg": [
		285288,
		9,
		285288
	],
	"./education-center/images/sites/default/files/book_pages/syndromic-microphthalmia-recessive.jpg": [
		717946,
		9,
		717946
	],
	"./education-center/images/sites/default/files/book_pages/synovial-plica-syndrome.jpg": [
		766343,
		9,
		766343
	],
	"./education-center/images/sites/default/files/book_pages/systemic-autoinflammation.jpg": [
		351262,
		9,
		351262
	],
	"./education-center/images/sites/default/files/book_pages/systemic-lupus-erythematosus-association-susceptibility-10.jpg": [
		684425,
		9,
		684425
	],
	"./education-center/images/sites/default/files/book_pages/systemic-lupus-erythematosus-resistance-1.jpg": [
		65576,
		9,
		65576
	],
	"./education-center/images/sites/default/files/book_pages/systemic-lupus-erythematosus-susceptibility.jpg": [
		192665,
		9,
		192665
	],
	"./education-center/images/sites/default/files/book_pages/systemic-lupus-erythematosus.jpg": [
		214487,
		9,
		214487
	],
	"./education-center/images/sites/default/files/book_pages/systolic-heart-failure.jpg": [
		283781,
		9,
		283781
	],
	"./education-center/images/sites/default/files/book_pages/tacrolimus-response.jpg": [
		461006,
		9,
		461006
	],
	"./education-center/images/sites/default/files/book_pages/tamoxifen-response.jpg": [
		75721,
		9,
		75721
	],
	"./education-center/images/sites/default/files/book_pages/tap1-deficiency-somatic.jpg": [
		3122,
		9,
		3122
	],
	"./education-center/images/sites/default/files/book_pages/tay-sachs-disease-juvenile.jpg": [
		988582,
		9,
		988582
	],
	"./education-center/images/sites/default/files/book_pages/tctn2-related-disorders.jpg": [
		512904,
		9,
		512904
	],
	"./education-center/images/sites/default/files/book_pages/tegafur-response.jpg": [
		803968,
		9,
		912581
	],
	"./education-center/images/sites/default/files/book_pages/telomere-length-mean-leukocyte.jpg": [
		268393,
		9,
		268393
	],
	"./education-center/images/sites/default/files/book_pages/teratoid-tumor-atypical.jpg": [
		8954,
		9,
		8954
	],
	"./education-center/images/sites/default/files/book_pages/testicular-atrophy.jpg": [
		80376,
		9,
		80376
	],
	"./education-center/images/sites/default/files/book_pages/thalassemia.jpg": [
		958919,
		9,
		958919
	],
	"./education-center/images/sites/default/files/book_pages/thecoma-somatic.jpg": [
		347054,
		9,
		347054
	],
	"./education-center/images/sites/default/files/book_pages/thiamine-metabolism-dysfunction-syndrome.jpg": [
		992110,
		9,
		992110
	],
	"./education-center/images/sites/default/files/book_pages/thiamine-responsive-megaloblastic-anemia.jpg": [
		625496,
		9,
		625496
	],
	"./education-center/images/sites/default/files/book_pages/thiopurine-response.jpg": [
		664049,
		9,
		664049
	],
	"./education-center/images/sites/default/files/book_pages/thiopurines-poor-metabolism-2.jpg": [
		363626,
		9,
		363626
	],
	"./education-center/images/sites/default/files/book_pages/third-degree-atrioventricular-block.jpg": [
		151223,
		9,
		151223
	],
	"./education-center/images/sites/default/files/book_pages/thoracic-aortic-aneurysm.jpg": [
		115365,
		9,
		115365
	],
	"./education-center/images/sites/default/files/book_pages/three-vessel-coronary-disease.jpg": [
		760576,
		9,
		760576
	],
	"./education-center/images/sites/default/files/book_pages/thrombocythemia-2-somatic.jpg": [
		260085,
		9,
		260085
	],
	"./education-center/images/sites/default/files/book_pages/thrombocytopenia-x-linked-intermittent.jpg": [
		245606,
		9,
		245606
	],
	"./education-center/images/sites/default/files/book_pages/thrombophilia-13-x-linked-due-factor-viii-defect.jpg": [
		405958,
		9,
		405958
	],
	"./education-center/images/sites/default/files/book_pages/thrombotic-stroke.jpg": [
		669832,
		9,
		669832
	],
	"./education-center/images/sites/default/files/book_pages/thrombus.jpg": [
		402742,
		9,
		402742
	],
	"./education-center/images/sites/default/files/book_pages/thymoma.jpg": [
		618161,
		9,
		618161
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-adenoma-hyperfunctioning.jpg": [
		418097,
		9,
		418097
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-carcinoma-sporadic-medullary.jpg": [
		841376,
		9,
		841376
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-dyshormonogenesis.jpg": [
		32349,
		9,
		32349
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-gland-undifferentiated-anaplastic-carcinoma.jpg": [
		457981,
		9,
		457981
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-hormone-resistance-syndrome.jpg": [
		856492,
		9,
		856492
	],
	"./education-center/images/sites/default/files/book_pages/thyroid-hormonogenesis-defect.jpg": [
		186517,
		9,
		186517
	],
	"./education-center/images/sites/default/files/book_pages/thyroxine-binding-globulin-deficiency-partial.jpg": [
		324708,
		9,
		324708
	],
	"./education-center/images/sites/default/files/book_pages/thyroxine-binding-globulin-deficiency.jpg": [
		878841,
		9,
		878841
	],
	"./education-center/images/sites/default/files/book_pages/thyroxine-binding-globulin-quantitative-trait-locus.jpg": [
		339340,
		9,
		339340
	],
	"./education-center/images/sites/default/files/book_pages/tibial-pseudarthrosis.jpg": [
		543931,
		9,
		543931
	],
	"./education-center/images/sites/default/files/book_pages/tietz-syndrome.jpg": [
		188143,
		9,
		188143
	],
	"./education-center/images/sites/default/files/book_pages/tip-toe-gait.jpg": [
		903884,
		9,
		903884
	],
	"./education-center/images/sites/default/files/book_pages/tmem67-related-disorders.jpg": [
		145956,
		9,
		145956
	],
	"./education-center/images/sites/default/files/book_pages/tnf-receptor-associated-periodic-fever-syndrome-traps.jpg": [
		172573,
		9,
		172573
	],
	"./education-center/images/sites/default/files/book_pages/tnf-receptor-binding-altered.jpg": [
		990783,
		9,
		990783
	],
	"./education-center/images/sites/default/files/book_pages/tolbutamide-response.jpg": [
		293004,
		9,
		293004
	],
	"./education-center/images/sites/default/files/book_pages/tooth-agenesis-selective-1.jpg": [
		252678,
		9,
		252678
	],
	"./education-center/images/sites/default/files/book_pages/tooth-agenesis-selective-4.jpg": [
		806123,
		9,
		806123
	],
	"./education-center/images/sites/default/files/book_pages/tooth-agenesis.jpg": [
		719883,
		9,
		719883
	],
	"./education-center/images/sites/default/files/book_pages/torsion-dystonia-4.jpg": [
		611006,
		9,
		611006
	],
	"./education-center/images/sites/default/files/book_pages/tourette-syndrome.jpg": [
		723255,
		9,
		723255
	],
	"./education-center/images/sites/default/files/book_pages/townes-brocks-branchiootorenal-syndrome.jpg": [
		581962,
		9,
		581962
	],
	"./education-center/images/sites/default/files/book_pages/townes-syndrome.jpg": [
		669355,
		9,
		669355
	],
	"./education-center/images/sites/default/files/book_pages/tp63-related-spectrum-disorders.jpg": [
		945385,
		9,
		945385
	],
	"./education-center/images/sites/default/files/book_pages/tpm2-related-cap-myopathy.jpg": [
		660486,
		9,
		660486
	],
	"./education-center/images/sites/default/files/book_pages/tramadol-response.jpg": [
		755132,
		9,
		755132
	],
	"./education-center/images/sites/default/files/book_pages/transferrin-serum-level-quantitative-trait-locus-2.jpg": [
		31908,
		9,
		31908
	],
	"./education-center/images/sites/default/files/book_pages/transient-hyperlipidemia.jpg": [
		818814,
		9,
		818814
	],
	"./education-center/images/sites/default/files/book_pages/transient-myeloproliferative-disorder-down-syndrome.jpg": [
		707453,
		9,
		707453
	],
	"./education-center/images/sites/default/files/book_pages/transient-neonatal-diabetes-dominant.jpg": [
		546154,
		9,
		546154
	],
	"./education-center/images/sites/default/files/book_pages/transient-neonatal-diabetes-dominantrecessive.jpg": [
		700861,
		9,
		700861
	],
	"./education-center/images/sites/default/files/book_pages/transient-neonatal-diabetes-recessive.jpg": [
		532721,
		9,
		532721
	],
	"./education-center/images/sites/default/files/book_pages/transitional-cell-carcinoma-bladder.jpg": [
		6498,
		9,
		6498
	],
	"./education-center/images/sites/default/files/book_pages/transposition-great-arteries.jpg": [
		661210,
		9,
		661210
	],
	"./education-center/images/sites/default/files/book_pages/treacher-collins-syndrome-1.jpg": [
		749842,
		9,
		749842
	],
	"./education-center/images/sites/default/files/book_pages/treacher-collins-syndrome-dominant.jpg": [
		316341,
		9,
		316341
	],
	"./education-center/images/sites/default/files/book_pages/treacher-collins-syndrome-recessive.jpg": [
		217182,
		9,
		217182
	],
	"./education-center/images/sites/default/files/book_pages/tretinoin-response.jpg": [
		447544,
		9,
		447544
	],
	"./education-center/images/sites/default/files/book_pages/trichothiodystrophy-5-nonphotosensitive.jpg": [
		822365,
		9,
		822365
	],
	"./education-center/images/sites/default/files/book_pages/trichotillomania.jpg": [
		162612,
		9,
		162612
	],
	"./education-center/images/sites/default/files/book_pages/trifascicular-block-electrocardiogram.jpg": [
		165467,
		9,
		165467
	],
	"./education-center/images/sites/default/files/book_pages/trigonocephaly.jpg": [
		599785,
		9,
		599785
	],
	"./education-center/images/sites/default/files/book_pages/triosephosphate-isomerase-manchester.jpg": [
		126765,
		9,
		126765
	],
	"./education-center/images/sites/default/files/book_pages/triphalangeal-thumb.jpg": [
		129162,
		9,
		129162
	],
	"./education-center/images/sites/default/files/book_pages/triple-negative-breast-cancer-finding.jpg": [
		131165,
		9,
		131165
	],
	"./education-center/images/sites/default/files/book_pages/triple-negative-breast-cancer.jpg": [
		346469,
		9,
		346469
	],
	"./education-center/images/sites/default/files/book_pages/triple-negative-breast-carcinoma.jpg": [
		969020,
		9,
		969020
	],
	"./education-center/images/sites/default/files/book_pages/trit1-deficiency.jpg": [
		390548,
		9,
		390548
	],
	"./education-center/images/sites/default/files/book_pages/trpm4-related-disorders.jpg": [
		975631,
		9,
		975631
	],
	"./education-center/images/sites/default/files/book_pages/tryptophan-5-monooxygenase-deficiency.jpg": [
		769998,
		9,
		769998
	],
	"./education-center/images/sites/default/files/book_pages/tuberculosis-susceptibility.jpg": [
		994966,
		9,
		994966
	],
	"./education-center/images/sites/default/files/book_pages/tuberous-sclerosis-and-lymphangiomyomatosis.jpg": [
		801056,
		9,
		801056
	],
	"./education-center/images/sites/default/files/book_pages/twist1-related-craniosynostosis.jpg": [
		894490,
		9,
		894490
	],
	"./education-center/images/sites/default/files/book_pages/type-1-diabetes-mellitus-2.jpg": [
		30770,
		9,
		30770
	],
	"./education-center/images/sites/default/files/book_pages/type-2-diabetes-mellitus-1-susceptibility.jpg": [
		870618,
		9,
		870618
	],
	"./education-center/images/sites/default/files/book_pages/type-i-truncus-arteriosus.jpg": [
		622082,
		9,
		622082
	],
	"./education-center/images/sites/default/files/book_pages/type-ii-collagenopathies.jpg": [
		576693,
		9,
		576693
	],
	"./education-center/images/sites/default/files/book_pages/tyrosine-kinase-inhibitor-response.jpg": [
		130574,
		9,
		130574
	],
	"./education-center/images/sites/default/files/book_pages/ullrich-congenital-muscular-dystrophy-1-autosomal-dominant.jpg": [
		258776,
		9,
		258776
	],
	"./education-center/images/sites/default/files/book_pages/ullrich-congenital-muscular-dystrophy.jpg": [
		658474,
		9,
		658474
	],
	"./education-center/images/sites/default/files/book_pages/ulnar-deviation-wrist.jpg": [
		374266,
		9,
		374266
	],
	"./education-center/images/sites/default/files/book_pages/unilateral-deafness.jpg": [
		751075,
		9,
		751075
	],
	"./education-center/images/sites/default/files/book_pages/unilateral-microphthalmos.jpg": [
		474819,
		9,
		474819
	],
	"./education-center/images/sites/default/files/book_pages/uric-acid-concentration-serum-quantitative-trait-locus-1.jpg": [
		973234,
		9,
		973234
	],
	"./education-center/images/sites/default/files/book_pages/uric-acid-concentration-serum-quantitative-trait-locus-2.jpg": [
		595,
		9,
		595
	],
	"./education-center/images/sites/default/files/book_pages/uric-acid-concentration-serum-quantitative-trait-locus-4.jpg": [
		718372,
		9,
		718372
	],
	"./education-center/images/sites/default/files/book_pages/ush2a-related-disorders.jpg": [
		874271,
		9,
		874271
	],
	"./education-center/images/sites/default/files/book_pages/usher-syndrome-type-idf-digenic.jpg": [
		766278,
		9,
		766278
	],
	"./education-center/images/sites/default/files/book_pages/usher-syndrome-type-iic-gpr98pdzd7-digenic.jpg": [
		518677,
		9,
		518677
	],
	"./education-center/images/sites/default/files/book_pages/uterine-carcinosarcoma.jpg": [
		130736,
		9,
		130736
	],
	"./education-center/images/sites/default/files/book_pages/uterine-corpus-cancer.jpg": [
		104192,
		9,
		104192
	],
	"./education-center/images/sites/default/files/book_pages/uterine-leiomyoma.jpg": [
		237159,
		9,
		237159
	],
	"./education-center/images/sites/default/files/book_pages/uveal-coloboma-cleft-lip-and-palate-intellectual-disability.jpg": [
		179787,
		9,
		179787
	],
	"./education-center/images/sites/default/files/book_pages/uveal-melanoma.jpg": [
		259804,
		9,
		259804
	],
	"./education-center/images/sites/default/files/book_pages/vacterl-association.jpg": [
		489527,
		9,
		489527
	],
	"./education-center/images/sites/default/files/book_pages/van-der-woude-syndrome-1.jpg": [
		965666,
		9,
		965666
	],
	"./education-center/images/sites/default/files/book_pages/variegate-porphyria-homozygous.jpg": [
		753035,
		9,
		753035
	],
	"./education-center/images/sites/default/files/book_pages/vascular-dementia.jpg": [
		808432,
		9,
		808432
	],
	"./education-center/images/sites/default/files/book_pages/vascular-endothelial-growth-factor-vegf-inhibitor-response.jpg": [
		88015,
		9,
		88015
	],
	"./education-center/images/sites/default/files/book_pages/vater-association-macrocephaly-and-ventriculomegaly.jpg": [
		537350,
		9,
		537350
	],
	"./education-center/images/sites/default/files/book_pages/vatervacterl-association-cns-malformations.jpg": [
		80038,
		9,
		80038
	],
	"./education-center/images/sites/default/files/book_pages/vel-blood-group-system.jpg": [
		723248,
		9,
		723248
	],
	"./education-center/images/sites/default/files/book_pages/venous-malformation_0.jpg": [
		899324,
		9,
		899324
	],
	"./education-center/images/sites/default/files/book_pages/venous-thromboembolism-susceptibility.jpg": [
		104321,
		9,
		104321
	],
	"./education-center/images/sites/default/files/book_pages/venous-thromboembolism.jpg": [
		364356,
		9,
		364356
	],
	"./education-center/images/sites/default/files/book_pages/venous-thrombosis-protection-against.jpg": [
		788033,
		9,
		788033
	],
	"./education-center/images/sites/default/files/book_pages/venous-thrombosis-susceptibility.jpg": [
		131646,
		9,
		131646
	],
	"./education-center/images/sites/default/files/book_pages/ventricular-tachycardia-somatic.jpg": [
		843094,
		9,
		843094
	],
	"./education-center/images/sites/default/files/book_pages/ventriculomegaly-and-arthrogryposis.jpg": [
		680893,
		9,
		680893
	],
	"./education-center/images/sites/default/files/book_pages/ventriculomegaly-cystic-kidney-disease.jpg": [
		803051,
		9,
		803051
	],
	"./education-center/images/sites/default/files/book_pages/ventriculomegaly.jpg": [
		486191,
		9,
		486191
	],
	"./education-center/images/sites/default/files/book_pages/very-long-chain-fatty-acid-accumulation.jpg": [
		943643,
		9,
		943643
	],
	"./education-center/images/sites/default/files/book_pages/vesicoureteral-reflux.jpg": [
		447512,
		9,
		447512
	],
	"./education-center/images/sites/default/files/book_pages/vibratory-urticaria.jpg": [
		357003,
		9,
		357003
	],
	"./education-center/images/sites/default/files/book_pages/virus-induced-diabetes.jpg": [
		428396,
		9,
		428396
	],
	"./education-center/images/sites/default/files/book_pages/vitamin-b12-plasma-level-quantitative-trait-locus-1.jpg": [
		664920,
		9,
		664920
	],
	"./education-center/images/sites/default/files/book_pages/vitamin-d-dependent-rickets-type-1.jpg": [
		560184,
		9,
		560184
	],
	"./education-center/images/sites/default/files/book_pages/vitamin-k-dependent-clotting-factors.jpg": [
		941787,
		9,
		941787
	],
	"./education-center/images/sites/default/files/book_pages/vitelliform-macular-dystrophy-2.jpg": [
		308013,
		9,
		308013
	],
	"./education-center/images/sites/default/files/book_pages/vitelliform-macular-dystrophy.jpg": [
		835279,
		9,
		835279
	],
	"./education-center/images/sites/default/files/book_pages/vsx2-related-microphthalmia.jpg": [
		396608,
		9,
		396608
	],
	"./education-center/images/sites/default/files/book_pages/vulvar-adenocarcinoma-mammary-gland-type.jpg": [
		701881,
		9,
		701881
	],
	"./education-center/images/sites/default/files/book_pages/waardenburg-syndrome-type-2a.jpg": [
		815514,
		9,
		815514
	],
	"./education-center/images/sites/default/files/book_pages/waardenburg-syndrome-type-2e-neurologic-involvement.jpg": [
		475471,
		9,
		475471
	],
	"./education-center/images/sites/default/files/book_pages/waardenburg-syndrome-type-2e-without-neurologic-involvement.jpg": [
		722695,
		9,
		722695
	],
	"./education-center/images/sites/default/files/book_pages/waardenburg-syndrome-type-3.jpg": [
		317079,
		9,
		317079
	],
	"./education-center/images/sites/default/files/book_pages/wagner-syndrome.jpg": [
		450003,
		9,
		450003
	],
	"./education-center/images/sites/default/files/book_pages/walker-warburg-congenital-muscular-dystrophy.jpg": [
		277874,
		9,
		277874
	],
	"./education-center/images/sites/default/files/book_pages/warfarin-response-dosage.jpg": [
		47457,
		9,
		47457
	],
	"./education-center/images/sites/default/files/book_pages/warfarin-response-toxicityadr.jpg": [
		179664,
		9,
		179664
	],
	"./education-center/images/sites/default/files/book_pages/warfarin-response.jpg": [
		996801,
		9,
		996801
	],
	"./education-center/images/sites/default/files/book_pages/warfarin-sensitivity-x-linked.jpg": [
		382861,
		9,
		382861
	],
	"./education-center/images/sites/default/files/book_pages/wdr1-deficiency_0.jpg": [
		859195,
		9,
		859195
	],
	"./education-center/images/sites/default/files/book_pages/wdr35-related-disorders.jpg": [
		125690,
		9,
		125690
	],
	"./education-center/images/sites/default/files/book_pages/weakness-facial-musculature.jpg": [
		548369,
		9,
		548369
	],
	"./education-center/images/sites/default/files/book_pages/wee1-inhibitor-response.jpg": [
		972737,
		9,
		972737
	],
	"./education-center/images/sites/default/files/book_pages/wfs1-related-spectrum-disorders.jpg": [
		145078,
		9,
		145078
	],
	"./education-center/images/sites/default/files/book_pages/white-blood-cell-count-quantitative-trait-locus-1.jpg": [
		28091,
		9,
		28091
	],
	"./education-center/images/sites/default/files/book_pages/wieacker-wolff-syndrome.jpg": [
		559095,
		9,
		559095
	],
	"./education-center/images/sites/default/files/book_pages/wolff-parkinson-white-syndrome-childhood-onset.jpg": [
		34726,
		9,
		34726
	],
	"./education-center/images/sites/default/files/book_pages/woolly-hair-autosomal-recessive-2-or-without-hypotrichosis.jpg": [
		618292,
		9,
		618292
	],
	"./education-center/images/sites/default/files/book_pages/worth-disease.jpg": [
		160272,
		9,
		160272
	],
	"./education-center/images/sites/default/files/book_pages/wt1-related-disorders.jpg": [
		385195,
		9,
		385195
	],
	"./education-center/images/sites/default/files/book_pages/x-linked-intellectual-disability-cabezas-type.jpg": [
		184944,
		9,
		184944
	],
	"./education-center/images/sites/default/files/book_pages/x-linked-retinitis-pigmentosa.jpg": [
		901919,
		9,
		901919
	],
	"./education-center/images/sites/default/files/book_pages/xanthinuria-type-ii.jpg": [
		107804,
		9,
		107804
	],
	"./education-center/images/sites/default/files/book_pages/xanthinuria.jpg": [
		389590,
		9,
		389590
	],
	"./education-center/images/sites/default/files/book_pages/zmpste24-related-disorders.jpg": [
		987687,
		9,
		987687
	],
	"./education-center/images/sites/default/files/book_pages/zonular-pulverulent-cataract.jpg": [
		511233,
		9,
		511233
	],
	"./education-center/images/sites/default/files/wysiwyg/14/abo-blood-type-dna-report-icon.png": [
		846821,
		9,
		846821
	],
	"./education-center/images/sites/default/files/wysiwyg/14/alzheimers-diet.jpg": [
		804148,
		9,
		804148
	],
	"./education-center/images/sites/default/files/wysiwyg/14/ancestry-dna-test.jpg": [
		283359,
		9,
		283359
	],
	"./education-center/images/sites/default/files/wysiwyg/14/apoe4-omega3.jpg": [
		321681,
		9,
		586693
	],
	"./education-center/images/sites/default/files/wysiwyg/14/brandon_colby_md_-_founder_-_sequencing.com_.png": [
		680892,
		9,
		680892
	],
	"./education-center/images/sites/default/files/wysiwyg/14/bun-creatinine-ratio-high-low-levels.jpg": [
		494296,
		9,
		494296
	],
	"./education-center/images/sites/default/files/wysiwyg/14/coronavirus-covid-19-test-results-example.png": [
		760884,
		9,
		760884
	],
	"./education-center/images/sites/default/files/wysiwyg/14/covid-health-guide-personalized-dna-report.jpg": [
		144927,
		9,
		144927
	],
	"./education-center/images/sites/default/files/wysiwyg/14/dna-sequencing.jpg": [
		606443,
		9,
		606443
	],
	"./education-center/images/sites/default/files/wysiwyg/14/ehlers-danlos-syndrome-dna-test.jpg": [
		244114,
		9,
		244114
	],
	"./education-center/images/sites/default/files/wysiwyg/14/ehlers-danlos-syndrome-types-subtypes.jpeg": [
		116124,
		9,
		116124
	],
	"./education-center/images/sites/default/files/wysiwyg/14/gedmatch-upload.jpg": [
		165927,
		9,
		165927
	],
	"./education-center/images/sites/default/files/wysiwyg/14/genetic-testing-alzheimers.jpg": [
		117566,
		9,
		117566
	],
	"./education-center/images/sites/default/files/wysiwyg/14/genome-sequencing-cost.jpg": [
		417396,
		9,
		417396
	],
	"./education-center/images/sites/default/files/wysiwyg/14/head-injury-alzheimers.jpg": [
		962981,
		9,
		962981
	],
	"./education-center/images/sites/default/files/wysiwyg/14/healthy-active-alzheimers-prevention.jpg": [
		871291,
		9,
		871291
	],
	"./education-center/images/sites/default/files/wysiwyg/14/how-to-choose-dna-test-for-diseases_0.jpg": [
		141242,
		9,
		141242
	],
	"./education-center/images/sites/default/files/wysiwyg/14/illumina-sequencers.jpg": [
		924021,
		9,
		924021
	],
	"./education-center/images/sites/default/files/wysiwyg/14/medication-dna-pharmacogenomics-report-sample1.png": [
		144401,
		9,
		144401
	],
	"./education-center/images/sites/default/files/wysiwyg/14/medication-dna-pharmacogenomics-report-sample2_0.png": [
		467557,
		9,
		467557
	],
	"./education-center/images/sites/default/files/wysiwyg/14/medications-to-prevent-alzheimers-disease.jpg": [
		429461,
		9,
		429461
	],
	"./education-center/images/sites/default/files/wysiwyg/14/national-geographic-dna-data-upload.jpg": [
		560165,
		9,
		560165
	],
	"./education-center/images/sites/default/files/wysiwyg/14/prevent-alzheimers.jpg": [
		457976,
		9,
		457976
	],
	"./education-center/images/sites/default/files/wysiwyg/14/risk-factors-alzheimers.jpg": [
		756532,
		9,
		756532
	],
	"./education-center/images/sites/default/files/wysiwyg/14/sequencing-dna.jpg": [
		610081,
		9,
		610081
	],
	"./education-center/images/sites/default/files/wysiwyg/14/sequencing-doctor.jpg": [
		783666,
		9,
		783666
	],
	"./education-center/images/sites/default/files/wysiwyg/14/sequencing-researcher.jpg": [
		290717,
		9,
		290717
	],
	"./education-center/images/sites/default/files/wysiwyg/14/sequencing.jpg": [
		446310,
		9,
		446310
	],
	"./education-center/images/sites/default/files/wysiwyg/14/ways-prevent-alzheimers.jpg": [
		897216,
		9,
		897216
	],
	"./education-center/images/sites/default/files/wysiwyg/14/what-does-dna-stand-for.jpg": [
		480979,
		9,
		480979
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/23andme_dna_test.png": [
		50884,
		9,
		50884
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/23andme_upload_data.jpg": [
		451317,
		9,
		451317
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/accuracy_of_dna_tests_0.jpg": [
		412511,
		9,
		412511
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/accuracy_of_dna_tests_1.jpg": [
		760230,
		9,
		760230
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/alzheimer_prevention_games.jpg": [
		701365,
		9,
		701365
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/alzheimers_prevention_diet.jpg": [
		147952,
		9,
		147952
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/ancestry_dna.png": [
		826805,
		9,
		826805
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/ancestry_dna_test_results.png": [
		547052,
		9,
		547052
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/at_home_genetic_testing_for_breast_cancer.jpg": [
		489578,
		9,
		489578
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/best_dna_test_for_adoptees_1.jpg": [
		892578,
		9,
		892578
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image.jpg": [
		566859,
		9,
		566859
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_0.png": [
		301735,
		9,
		301735
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_13.jpg": [
		825719,
		9,
		825719
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_14.jpg": [
		288347,
		9,
		288347
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_15.jpg": [
		669765,
		9,
		669765
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_16.jpg": [
		672625,
		9,
		672625
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_17.jpg": [
		611099,
		9,
		611099
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_18.jpg": [
		808243,
		9,
		808243
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_1_1.jpg": [
		518376,
		9,
		518376
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blog_image_3_0.jpg": [
		634289,
		9,
		634289
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/blood_type_results.jpg": [
		747394,
		9,
		747394
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/breast_cancer_genetic_testing.jpg": [
		842758,
		9,
		842758
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/breast_cancer_genetic_testing_pros_and_cons.jpg": [
		163297,
		9,
		163297
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/carrier-testing-how-a-person-gets-cf-graphic.png": [
		118638,
		9,
		118638
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/carrier_status.png": [
		163265,
		9,
		163265
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/common_and_serious_side_effects.png": [
		102710,
		9,
		102710
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/coronavirus.jpg": [
		3840,
		9,
		3840
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/covid-19_and_blood_type_0.jpg": [
		290463,
		9,
		290463
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/covid-19_symptoms_0.jpg": [
		560280,
		9,
		560280
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/difference_between_genealogy_and_family_history.jpg": [
		564487,
		9,
		564487
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dna_test.jpg": [
		934208,
		9,
		934208
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dna_test_-_whole_genome_sequencing.png": [
		382030,
		9,
		382030
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dna_test_breast_cancer_genetic_testing.jpg": [
		652601,
		9,
		652601
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dna_test_for_medication_side_effects.jpg": [
		142741,
		9,
		142741
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dna_tests.jpg": [
		873336,
		9,
		873336
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/dr_brandon_colby.jpg": [
		307789,
		9,
		307789
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/environmental_risk_factors_for_alzheimers.jpg": [
		485983,
		9,
		485983
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/free_dna_analysis.jpg": [
		359869,
		9,
		359869
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/free_dna_test_reports.jpg": [
		264413,
		9,
		264413
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/free_dna_upload.jpg": [
		957976,
		9,
		957976
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/free_dna_upload_for_living_dna.jpg": [
		880336,
		9,
		880336
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/gedmatch_registration.jpg": [
		783793,
		9,
		783793
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic-ancestry-dna-report-sample-page2.jpg": [
		289086,
		9,
		289086
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic-dna-testing-rare-disease-guide.webp": [
		559578,
		9,
		559578
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic_risk_factors_for_alzheimers_disease.jpg": [
		760323,
		9,
		760323
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic_testing_and_drug_side_effects.png": [
		607441,
		9,
		607441
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic_testing_for_alzheimers_1.jpg": [
		376901,
		9,
		376901
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic_testing_for_alzheimers_2.jpg": [
		196264,
		9,
		196264
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/genetic_testing_for_breast_cancer.jpg": [
		847107,
		9,
		847107
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/health_insurance_genetic_testing.jpg": [
		888172,
		9,
		888172
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/how_does_dna_testing_work.jpg": [
		670624,
		9,
		670624
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/how_quickly_do_side_effects_happen_0.jpg": [
		685605,
		9,
		685605
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/how_to_reduce_side_effects_of_medicine.jpg": [
		803219,
		9,
		803219
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/living-dna-logo.jpg": [
		417108,
		9,
		417108
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/living_dna_upload.jpg": [
		946483,
		9,
		946483
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/low_cost_breast_cancer_genetic_testing.jpg": [
		333322,
		9,
		333322
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/medicare_coverage_for_breast_cancer_genetic_testing.jpg": [
		609452,
		9,
		609452
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/medications_and_drugs_response_process.jpg": [
		286429,
		9,
		286429
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/myheritage.jpg": [
		662505,
		9,
		662505
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/myheritage_dna_upload.jpg": [
		667060,
		9,
		667060
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/national_geographic_dna_upload_raw.jpg": [
		312005,
		9,
		312005
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/natural_ways_to_prevent_alzheimers.jpg": [
		14193,
		9,
		14193
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/natural_ways_to_prevent_alzheimers.png": [
		15435,
		9,
		15435
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/order_a_dna_test_kit.jpg": [
		498732,
		9,
		498732
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/paternity_test.jpg": [
		929146,
		9,
		929146
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/prevent_alzheimers.jpg": [
		621357,
		9,
		621357
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/preventive_measures_for_breast_cancer.jpg": [
		778864,
		9,
		778864
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/promethease_dna.png": [
		68693,
		9,
		68693
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/promethease_dna_upload.jpg": [
		778072,
		9,
		778072
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/pros_and_cons_of_breast_cancer_genetic_testing.jpg": [
		92800,
		9,
		92800
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/rare-disease-screen-carrier-genetic-test.jpg": [
		964041,
		9,
		964041
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/risk_alzheimers.jpg": [
		191093,
		9,
		191093
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/risk_factors_of_alzheimers_disease.jpg": [
		883506,
		9,
		883506
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/the_effects_of_medicine_on_the_body.png": [
		552087,
		9,
		552087
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/ultimate-dna-test-from-sequencing-raw-dna-data-file.jpg": [
		587892,
		9,
		587892
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/upload_data_to_23andme.jpg": [
		392798,
		9,
		392798
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/upload_dna_to_myheritage.png": [
		264863,
		9,
		264863
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/warning-signs5-1-1024x556.jpg": [
		640811,
		9,
		640811
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/ways_to_prevent_alzheimers_0.jpg": [
		467158,
		9,
		467158
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/ways_to_prevent_alzheimers_naturally_-_supplements.jpg": [
		515530,
		9,
		515530
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/we_can_study_our_genetic_code_and_use_the_information_to_take_control_of_our_destiny.jpg": [
		243387,
		9,
		243387
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/weight-management-app-icon-silverberry-genomix-sequencing.com-dna-app-market_0.png": [
		254258,
		9,
		254258
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/weight_0.png": [
		532495,
		9,
		532495
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_affects_how_quickly_side_effects_happen.jpg": [
		322638,
		9,
		322638
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_can_whole_genome_sequence_detect1.jpg": [
		143307,
		9,
		143307
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_causes_alzheimers.jpg": [
		930350,
		9,
		930350
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_is_dna.jpg": [
		412403,
		9,
		412403
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_to_do_when_medicines_have_side_effects_-_blog_image.jpg": [
		285270,
		9,
		285270
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/what_to_do_when_medicines_have_side_effects_-_blog_image_2.jpg": [
		29503,
		9,
		29503
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/whats-your-blood-type-genetic-analysis_0.webp": [
		957490,
		9,
		957490
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/when_do_side_effects_happen.jpg": [
		842374,
		9,
		842374
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/who-covid19-response-oxygen.png": [
		800875,
		9,
		800875
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/whole_genome_sequencing.jpg": [
		449196,
		9,
		449196
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/whole_genome_sequencing_cost.jpg": [
		68514,
		9,
		68514
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/whole_genome_sequencing_results.webp": [
		815120,
		9,
		815120
	],
	"./education-center/images/sites/default/files/wysiwyg/283026/whole_genome_shotgun_sequencing.jpg": [
		5365,
		9,
		5365
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/dna_744w.png": [
		185283,
		9,
		185283
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/dna_education_1.png": [
		512056,
		9,
		512056
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/dr_brandon_colby_100w.png": [
		943539,
		9,
		943539
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/img_744w_2.png": [
		530187,
		9,
		530187
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/mask_group_744w-2.png": [
		261757,
		9,
		261757
	],
	"./education-center/images/sites/default/files/wysiwyg/360347/mask_group_744w.png": [
		170804,
		9,
		170804
	],
	"./education-center/images/sites/default/files/wysiwyg/735/23andme_2.png": [
		328411,
		9,
		328411
	],
	"./education-center/images/sites/default/files/wysiwyg/735/23ndme_logo.png": [
		34511,
		9,
		34511
	],
	"./education-center/images/sites/default/files/wysiwyg/735/african-ancestry-upload.jpeg": [
		864011,
		9,
		864011
	],
	"./education-center/images/sites/default/files/wysiwyg/735/alzheimers_genetic_testing_0.jpeg": [
		362385,
		9,
		362385
	],
	"./education-center/images/sites/default/files/wysiwyg/735/analyze_genome.jpeg": [
		539306,
		9,
		539306
	],
	"./education-center/images/sites/default/files/wysiwyg/735/ancestrydnafullcolor.png": [
		383617,
		9,
		383617
	],
	"./education-center/images/sites/default/files/wysiwyg/735/ancestrylogo.png": [
		226561,
		9,
		226561
	],
	"./education-center/images/sites/default/files/wysiwyg/735/average_ancestry_dna_test_cost_0.jpeg": [
		878070,
		9,
		878070
	],
	"./education-center/images/sites/default/files/wysiwyg/735/benefits_of_whole_genome_sequencing.jpeg": [
		376607,
		9,
		376607
	],
	"./education-center/images/sites/default/files/wysiwyg/735/benefits_of_whole_genome_sequencing_0_0.jpeg": [
		727534,
		9,
		727534
	],
	"./education-center/images/sites/default/files/wysiwyg/735/best_dna_test_for_adoptees.jpeg": [
		48410,
		9,
		48410
	],
	"./education-center/images/sites/default/files/wysiwyg/735/best_dna_test_for_adoptees_0.jpeg": [
		511846,
		9,
		511846
	],
	"./education-center/images/sites/default/files/wysiwyg/735/best_dna_test_for_genetic_conditions.jpeg": [
		638663,
		9,
		638663
	],
	"./education-center/images/sites/default/files/wysiwyg/735/blood_type_and_covid.jpeg": [
		562935,
		9,
		562935
	],
	"./education-center/images/sites/default/files/wysiwyg/735/blood_types.jpeg": [
		446931,
		9,
		446931
	],
	"./education-center/images/sites/default/files/wysiwyg/735/breast_cancer_genetic_testing_pros_and_cons_0.jpeg": [
		377537,
		9,
		377537
	],
	"./education-center/images/sites/default/files/wysiwyg/735/buy_an_ancestry_test_kit.jpeg": [
		578012,
		9,
		578012
	],
	"./education-center/images/sites/default/files/wysiwyg/735/buy_the_best_test_for_adoptees.jpeg": [
		89920,
		9,
		89920
	],
	"./education-center/images/sites/default/files/wysiwyg/735/carrier_screening.jpeg": [
		118715,
		9,
		118715
	],
	"./education-center/images/sites/default/files/wysiwyg/735/check_blood_type_for_free.jpeg": [
		252824,
		9,
		252824
	],
	"./education-center/images/sites/default/files/wysiwyg/735/coronavirus-and-dna-covid.jpeg": [
		195890,
		9,
		195890
	],
	"./education-center/images/sites/default/files/wysiwyg/735/coronavirus_and_dna_0.jpeg": [
		313325,
		9,
		313325
	],
	"./education-center/images/sites/default/files/wysiwyg/735/coronavirus_treatment_0.jpeg": [
		366915,
		9,
		366915
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_analysis_app_market_0.png": [
		754620,
		9,
		754620
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_and_adoption.jpeg": [
		80576,
		9,
		80576
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_genealogy.jpeg": [
		786896,
		9,
		786896
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_money.jpeg": [
		356284,
		9,
		356284
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_sites_for_raw_data_uploads.jpeg": [
		463885,
		9,
		463885
	],
	"./education-center/images/sites/default/files/wysiwyg/735/dna_test_for_finding_adopted_child.jpeg": [
		355483,
		9,
		355483
	],
	"./education-center/images/sites/default/files/wysiwyg/735/family_tree_builder.jpeg": [
		437633,
		9,
		437633
	],
	"./education-center/images/sites/default/files/wysiwyg/735/find_an_adopted_sister_or_brother.jpeg": [
		92261,
		9,
		92261
	],
	"./education-center/images/sites/default/files/wysiwyg/735/finding_a_biological_father_through_dna.jpeg": [
		69821,
		9,
		69821
	],
	"./education-center/images/sites/default/files/wysiwyg/735/finding_an_adopted_child_online_1.jpeg": [
		888209,
		9,
		888209
	],
	"./education-center/images/sites/default/files/wysiwyg/735/finding_an_adopted_sibling.jpeg": [
		845360,
		9,
		845360
	],
	"./education-center/images/sites/default/files/wysiwyg/735/free_dna_upload_sites_0.jpeg": [
		729858,
		9,
		729858
	],
	"./education-center/images/sites/default/files/wysiwyg/735/gedmatch_privacy.jpeg": [
		694790,
		9,
		694790
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_disease.jpeg": [
		666927,
		9,
		666927
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_diseases_in_children.jpeg": [
		85987,
		9,
		85987
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_disorders.jpeg": [
		53930,
		9,
		53930
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_disorders_in_children_0.jpeg": [
		41241,
		9,
		41241
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_genealogy.jpeg": [
		75311,
		9,
		75311
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_during_pregnancy_0.jpeg": [
		735479,
		9,
		735479
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_alzheimers_0.jpeg": [
		552956,
		9,
		552956
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_autism.jpeg": [
		492855,
		9,
		492855
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_autism_treatment.jpeg": [
		7741,
		9,
		7741
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_babies.jpeg": [
		858544,
		9,
		858544
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_baby.jpeg": [
		836388,
		9,
		836388
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_cystic_fibrosis.jpeg": [
		238668,
		9,
		238668
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_diseases.jpeg": [
		504736,
		9,
		504736
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_for_down_syndrome_1.jpg": [
		173605,
		9,
		173605
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_testing_on_a_baby.jpeg": [
		146155,
		9,
		146155
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_tests_for_alzheimer_0.jpeg": [
		13155,
		9,
		13155
	],
	"./education-center/images/sites/default/files/wysiwyg/735/genetic_tests_for_down_syndrome.jpeg": [
		315465,
		9,
		315465
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_accurate_are_dna_tests.jpeg": [
		841071,
		9,
		841071
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_accurate_is_dna_testing_ancestry.jpeg": [
		162723,
		9,
		162723
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_does_dna_testing_work_0.jpeg": [
		173049,
		9,
		173049
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_does_genetic_genealogy_work.jpeg": [
		479974,
		9,
		479974
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_much_does_it_cost_for_alzheimers_genetic_testing.jpeg": [
		192689,
		9,
		192689
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_to_find_a_biological_father_through_dna.jpeg": [
		133193,
		9,
		133193
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_to_find_biological_parents_through_dna.jpeg": [
		690672,
		9,
		690672
	],
	"./education-center/images/sites/default/files/wysiwyg/735/how_whole_genome_shotgun_sequencing_works.jpeg": [
		652589,
		9,
		652589
	],
	"./education-center/images/sites/default/files/wysiwyg/735/living-dna-logo-sequencing.com-compatibility_0.png": [
		80726,
		9,
		80726
	],
	"./education-center/images/sites/default/files/wysiwyg/735/medication_side_effects.jpeg": [
		914919,
		9,
		914919
	],
	"./education-center/images/sites/default/files/wysiwyg/735/myheritage-dna-logo-sequencing.png": [
		320486,
		9,
		320486
	],
	"./education-center/images/sites/default/files/wysiwyg/735/myheritage_dna_logo_0.png": [
		535754,
		9,
		535754
	],
	"./education-center/images/sites/default/files/wysiwyg/735/myheritage_dna_test.jpeg": [
		259154,
		9,
		259154
	],
	"./education-center/images/sites/default/files/wysiwyg/735/myheritage_dna_upload_0_0.jpeg": [
		328776,
		9,
		328776
	],
	"./education-center/images/sites/default/files/wysiwyg/735/mytrueancestry-upload.png": [
		414052,
		9,
		414052
	],
	"./education-center/images/sites/default/files/wysiwyg/735/prenatal_genetic_screening.jpeg": [
		470163,
		9,
		470163
	],
	"./education-center/images/sites/default/files/wysiwyg/735/pros_and_cons_of_whole_genome_sequencing.jpeg": [
		993584,
		9,
		993584
	],
	"./education-center/images/sites/default/files/wysiwyg/735/screening_tests_for_down_sydnrome.jpeg": [
		442304,
		9,
		442304
	],
	"./education-center/images/sites/default/files/wysiwyg/735/searching_for_an_adopted_child.jpeg": [
		474107,
		9,
		474107
	],
	"./education-center/images/sites/default/files/wysiwyg/735/sequencing.com-logo.png": [
		884874,
		9,
		884874
	],
	"./education-center/images/sites/default/files/wysiwyg/735/sequencing_the_whole_genome.jpeg": [
		652274,
		9,
		652274
	],
	"./education-center/images/sites/default/files/wysiwyg/735/single_gene_vs_whole_genome_sequencing_0.jpeg": [
		172367,
		9,
		172367
	],
	"./education-center/images/sites/default/files/wysiwyg/735/upload_dna_to_ancestry.png": [
		288011,
		9,
		288011
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_diseases_can_be_detected_through_genetic_testing.jpeg": [
		658312,
		9,
		658312
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_does_a_dna_report_look_like.jpeg": [
		426581,
		9,
		426581
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_is_a_dna_test.jpeg": [
		685100,
		9,
		685100
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_is_a_genetic_disease.jpeg": [
		195487,
		9,
		195487
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_is_genealogy.jpeg": [
		428560,
		9,
		428560
	],
	"./education-center/images/sites/default/files/wysiwyg/735/what_you_need_to_know_about_dna_genealogy_accuracy.jpeg": [
		162705,
		9,
		162705
	],
	"./education-center/images/sites/default/files/wysiwyg/735/where-can-i-get-my-genome-sequenced.jpeg": [
		779539,
		9,
		779539
	],
	"./education-center/images/sites/default/files/wysiwyg/735/where_can_i_get_my_blood_type_for_free.jpeg": [
		902214,
		9,
		902214
	],
	"./education-center/images/sites/default/files/wysiwyg/735/where_to_get_a_dna_test.jpeg": [
		430608,
		9,
		430608
	],
	"./education-center/images/sites/default/files/wysiwyg/735/whole-genome-sequencing-cost.jpeg": [
		369963,
		9,
		369963
	],
	"./education-center/images/sites/default/files/wysiwyg/735/whole_genome_sequencing_0.jpeg": [
		137895,
		9,
		137895
	],
	"./education-center/images/sites/default/files/wysiwyg/735/whole_genome_sequencing_1.jpeg": [
		495695,
		9,
		495695
	],
	"./education-center/images/sites/default/files/wysiwyg/735/whole_genome_sequencing_analysis_service_1.jpeg": [
		68844,
		9,
		68844
	],
	"./education-center/markdown": [
		911284,
		9,
		911284
	],
	"./education-center/markdown/": [
		911284,
		9,
		911284
	],
	"./education-center/markdown/coronavirus-and-dna": [
		156795,
		9,
		156795
	],
	"./education-center/markdown/coronavirus-and-dna/": [
		156795,
		9,
		156795
	],
	"./education-center/markdown/coronavirus-and-dna/blood-type-and-covid-infection-and-severity": [
		796460,
		9,
		796460
	],
	"./education-center/markdown/coronavirus-and-dna/blood-type-and-covid-infection-and-severity.md": [
		796460,
		9,
		796460
	],
	"./education-center/markdown/coronavirus-and-dna/coronavirus-treatment": [
		835284,
		9,
		835284
	],
	"./education-center/markdown/coronavirus-and-dna/coronavirus-treatment.md": [
		835284,
		9,
		835284
	],
	"./education-center/markdown/coronavirus-and-dna/index": [
		156795,
		9,
		156795
	],
	"./education-center/markdown/coronavirus-and-dna/index.md": [
		156795,
		9,
		156795
	],
	"./education-center/markdown/coronavirus-and-dna/where-can-i-get-my-blood-type-checked-free": [
		47336,
		9,
		47336
	],
	"./education-center/markdown/coronavirus-and-dna/where-can-i-get-my-blood-type-checked-free.md": [
		47336,
		9,
		47336
	],
	"./education-center/markdown/coronavirus-and-dna/your-dna-and-covid-19-risk": [
		338793,
		9,
		338793
	],
	"./education-center/markdown/coronavirus-and-dna/your-dna-and-covid-19-risk.md": [
		338793,
		9,
		338793
	],
	"./education-center/markdown/definitions/what-is-a-variant": [
		167650,
		9,
		167650
	],
	"./education-center/markdown/definitions/what-is-a-variant.md": [
		167650,
		9,
		167650
	],
	"./education-center/markdown/dna-101": [
		987690,
		9,
		987690
	],
	"./education-center/markdown/dna-101/": [
		987690,
		9,
		987690
	],
	"./education-center/markdown/dna-101/cost-of-whole-genome-sequencing": [
		630669,
		9,
		630669
	],
	"./education-center/markdown/dna-101/cost-of-whole-genome-sequencing.md": [
		630669,
		9,
		630669
	],
	"./education-center/markdown/dna-101/index": [
		987690,
		9,
		987690
	],
	"./education-center/markdown/dna-101/index.md": [
		987690,
		9,
		987690
	],
	"./education-center/markdown/dna-101/multi-factorial-disorders-role-genetics": [
		952024,
		9,
		952024
	],
	"./education-center/markdown/dna-101/multi-factorial-disorders-role-genetics.md": [
		952024,
		9,
		952024
	],
	"./education-center/markdown/dna-101/not-all-dna-products-are-created-equal": [
		947809,
		9,
		947809
	],
	"./education-center/markdown/dna-101/not-all-dna-products-are-created-equal.md": [
		947809,
		9,
		947809
	],
	"./education-center/markdown/dna-101/one-genome-technology": [
		529281,
		9,
		529281
	],
	"./education-center/markdown/dna-101/one-genome-technology.md": [
		529281,
		9,
		529281
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds": [
		818819,
		9,
		818819
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/": [
		818819,
		9,
		818819
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/diagnosing-ehlers-danlos-syndrome-guide": [
		612314,
		9,
		612314
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/diagnosing-ehlers-danlos-syndrome-guide.md": [
		612314,
		9,
		612314
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/genetic-testing-ehlers-danlos-syndrome-eds": [
		346771,
		9,
		346771
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/genetic-testing-ehlers-danlos-syndrome-eds.md": [
		346771,
		9,
		346771
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/index": [
		818819,
		9,
		818819
	],
	"./education-center/markdown/dna-101/understanding-ehlers-danlos-syndome-eds/index.md": [
		818819,
		9,
		818819
	],
	"./education-center/markdown/dna-101/what-are-multifactorial-disorders": [
		287344,
		9,
		287344
	],
	"./education-center/markdown/dna-101/what-are-multifactorial-disorders/": [
		287344,
		9,
		287344
	],
	"./education-center/markdown/dna-101/what-are-multifactorial-disorders/index": [
		287344,
		9,
		287344
	],
	"./education-center/markdown/dna-101/what-are-multifactorial-disorders/index.md": [
		287344,
		9,
		287344
	],
	"./education-center/markdown/dna-101/what-can-you-learn-from-your-dna": [
		370351,
		9,
		370351
	],
	"./education-center/markdown/dna-101/what-can-you-learn-from-your-dna/": [
		370351,
		9,
		370351
	],
	"./education-center/markdown/dna-101/what-can-you-learn-from-your-dna/index": [
		370351,
		9,
		370351
	],
	"./education-center/markdown/dna-101/what-can-you-learn-from-your-dna/index.md": [
		370351,
		9,
		370351
	],
	"./education-center/markdown/dna-101/what-does-dna-stand-for": [
		17391,
		9,
		17391
	],
	"./education-center/markdown/dna-101/what-does-dna-stand-for.md": [
		17391,
		9,
		17391
	],
	"./education-center/markdown/dna-101/what-is-genetic-counseling": [
		944926,
		9,
		944926
	],
	"./education-center/markdown/dna-101/what-is-genetic-counseling.md": [
		944926,
		9,
		944926
	],
	"./education-center/markdown/dna-101/what-to-expect-when-you-get-your-whole-genome-sequenced": [
		479401,
		9,
		479401
	],
	"./education-center/markdown/dna-101/what-to-expect-when-you-get-your-whole-genome-sequenced.md": [
		479401,
		9,
		479401
	],
	"./education-center/markdown/dna-and-adoption": [
		257430,
		9,
		257430
	],
	"./education-center/markdown/dna-and-adoption/": [
		257430,
		9,
		257430
	],
	"./education-center/markdown/dna-and-adoption/best-dna-test-adoptees": [
		33621,
		9,
		33621
	],
	"./education-center/markdown/dna-and-adoption/best-dna-test-adoptees.md": [
		33621,
		9,
		33621
	],
	"./education-center/markdown/dna-and-adoption/finding-adopted-child-online": [
		186582,
		9,
		186582
	],
	"./education-center/markdown/dna-and-adoption/finding-adopted-child-online.md": [
		186582,
		9,
		186582
	],
	"./education-center/markdown/dna-and-adoption/finding-adopted-sibling": [
		758545,
		9,
		758545
	],
	"./education-center/markdown/dna-and-adoption/finding-adopted-sibling.md": [
		758545,
		9,
		758545
	],
	"./education-center/markdown/dna-and-adoption/how-find-biological-father-through-dna": [
		482188,
		9,
		482188
	],
	"./education-center/markdown/dna-and-adoption/how-find-biological-father-through-dna.md": [
		482188,
		9,
		482188
	],
	"./education-center/markdown/dna-and-adoption/index": [
		257430,
		9,
		257430
	],
	"./education-center/markdown/dna-and-adoption/index.md": [
		257430,
		9,
		257430
	],
	"./education-center/markdown/fastest-expedited-sequencing": [
		923996,
		9,
		923996
	],
	"./education-center/markdown/fastest-expedited-sequencing.md": [
		923996,
		9,
		923996
	],
	"./education-center/markdown/free-dna-upload-sites": [
		110078,
		9,
		110078
	],
	"./education-center/markdown/free-dna-upload-sites/": [
		110078,
		9,
		110078
	],
	"./education-center/markdown/free-dna-upload-sites/23andme-upload-data-tool": [
		670756,
		9,
		670756
	],
	"./education-center/markdown/free-dna-upload-sites/23andme-upload-data-tool.md": [
		670756,
		9,
		670756
	],
	"./education-center/markdown/free-dna-upload-sites/gedmatch-dna-upload-instructions": [
		997456,
		9,
		997456
	],
	"./education-center/markdown/free-dna-upload-sites/gedmatch-dna-upload-instructions.md": [
		997456,
		9,
		997456
	],
	"./education-center/markdown/free-dna-upload-sites/index": [
		110078,
		9,
		110078
	],
	"./education-center/markdown/free-dna-upload-sites/index.md": [
		110078,
		9,
		110078
	],
	"./education-center/markdown/free-dna-upload-sites/living-dna-upload": [
		794462,
		9,
		794462
	],
	"./education-center/markdown/free-dna-upload-sites/living-dna-upload.md": [
		794462,
		9,
		794462
	],
	"./education-center/markdown/free-dna-upload-sites/myheritage-dna-upload": [
		360396,
		9,
		360396
	],
	"./education-center/markdown/free-dna-upload-sites/myheritage-dna-upload.md": [
		360396,
		9,
		360396
	],
	"./education-center/markdown/free-dna-upload-sites/national-geographic-dna-upload-raw-data": [
		9871,
		9,
		9871
	],
	"./education-center/markdown/free-dna-upload-sites/national-geographic-dna-upload-raw-data.md": [
		9871,
		9,
		9871
	],
	"./education-center/markdown/free-dna-upload-sites/promethease-dna-upload": [
		226369,
		9,
		226369
	],
	"./education-center/markdown/free-dna-upload-sites/promethease-dna-upload.md": [
		226369,
		9,
		226369
	],
	"./education-center/markdown/free-dna-upload-sites/upload-dna-ancestry": [
		455237,
		9,
		455237
	],
	"./education-center/markdown/free-dna-upload-sites/upload-dna-ancestry.md": [
		455237,
		9,
		455237
	],
	"./education-center/markdown/genetic-genealogy": [
		483099,
		9,
		483099
	],
	"./education-center/markdown/genetic-genealogy/": [
		483099,
		9,
		483099
	],
	"./education-center/markdown/genetic-genealogy/ancestry-dna-test": [
		176760,
		9,
		176760
	],
	"./education-center/markdown/genetic-genealogy/ancestry-dna-test.md": [
		176760,
		9,
		176760
	],
	"./education-center/markdown/genetic-genealogy/dna-genealogy": [
		328933,
		9,
		328933
	],
	"./education-center/markdown/genetic-genealogy/dna-genealogy.md": [
		328933,
		9,
		328933
	],
	"./education-center/markdown/genetic-genealogy/index": [
		483099,
		9,
		483099
	],
	"./education-center/markdown/genetic-genealogy/index.md": [
		483099,
		9,
		483099
	],
	"./education-center/markdown/genetic-genealogy/myheritage-dna-test": [
		53999,
		9,
		53999
	],
	"./education-center/markdown/genetic-genealogy/myheritage-dna-test.md": [
		53999,
		9,
		53999
	],
	"./education-center/markdown/genetic-genealogy/what-is-genealogy": [
		355930,
		9,
		355930
	],
	"./education-center/markdown/genetic-genealogy/what-is-genealogy.md": [
		355930,
		9,
		355930
	],
	"./education-center/markdown/genetic-testing-baby": [
		794485,
		9,
		794485
	],
	"./education-center/markdown/genetic-testing-baby/": [
		794485,
		9,
		794485
	],
	"./education-center/markdown/genetic-testing-baby/carrier-screening": [
		627807,
		9,
		627807
	],
	"./education-center/markdown/genetic-testing-baby/carrier-screening.md": [
		627807,
		9,
		627807
	],
	"./education-center/markdown/genetic-testing-baby/genetic-diseases-in-children": [
		704139,
		9,
		704139
	],
	"./education-center/markdown/genetic-testing-baby/genetic-diseases-in-children.md": [
		704139,
		9,
		704139
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-down-syndrome": [
		194479,
		9,
		194479
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-down-syndrome.md": [
		194479,
		9,
		194479
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-during-pregnancy": [
		240866,
		9,
		240866
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-during-pregnancy.md": [
		240866,
		9,
		240866
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-for-autism": [
		400392,
		9,
		400392
	],
	"./education-center/markdown/genetic-testing-baby/genetic-testing-for-autism.md": [
		400392,
		9,
		400392
	],
	"./education-center/markdown/genetic-testing-baby/index": [
		794485,
		9,
		794485
	],
	"./education-center/markdown/genetic-testing-baby/index.md": [
		794485,
		9,
		794485
	],
	"./education-center/markdown/genetic-testing-for-diseases": [
		220459,
		9,
		220459
	],
	"./education-center/markdown/genetic-testing-for-diseases/": [
		220459,
		9,
		220459
	],
	"./education-center/markdown/genetic-testing-for-diseases/cystic-fibrosis-gene-test": [
		361944,
		9,
		361944
	],
	"./education-center/markdown/genetic-testing-for-diseases/cystic-fibrosis-gene-test.md": [
		361944,
		9,
		361944
	],
	"./education-center/markdown/genetic-testing-for-diseases/how-choose-dna-test-diseases": [
		423454,
		9,
		423454
	],
	"./education-center/markdown/genetic-testing-for-diseases/how-choose-dna-test-diseases.md": [
		423454,
		9,
		423454
	],
	"./education-center/markdown/genetic-testing-for-diseases/index": [
		220459,
		9,
		220459
	],
	"./education-center/markdown/genetic-testing-for-diseases/index.md": [
		220459,
		9,
		220459
	],
	"./education-center/markdown/genetic-testing-for-diseases/what-diseases-can-be-detected-through-genetic-testing": [
		480857,
		9,
		480857
	],
	"./education-center/markdown/genetic-testing-for-diseases/what-diseases-can-be-detected-through-genetic-testing.md": [
		480857,
		9,
		480857
	],
	"./education-center/markdown/genetic-testing-for-diseases/what-is-a-genetic-disease": [
		600035,
		9,
		600035
	],
	"./education-center/markdown/genetic-testing-for-diseases/what-is-a-genetic-disease.md": [
		600035,
		9,
		600035
	],
	"./education-center/markdown/genetic-testing-weight-loss": [
		363838,
		9,
		363838
	],
	"./education-center/markdown/genetic-testing-weight-loss/": [
		363838,
		9,
		363838
	],
	"./education-center/markdown/genetic-testing-weight-loss/dna-testing-weight-loss-diets": [
		584776,
		9,
		584776
	],
	"./education-center/markdown/genetic-testing-weight-loss/dna-testing-weight-loss-diets.md": [
		584776,
		9,
		584776
	],
	"./education-center/markdown/genetic-testing-weight-loss/does-dna-work-weight-loss": [
		932661,
		9,
		932661
	],
	"./education-center/markdown/genetic-testing-weight-loss/does-dna-work-weight-loss.md": [
		932661,
		9,
		932661
	],
	"./education-center/markdown/genetic-testing-weight-loss/index": [
		363838,
		9,
		363838
	],
	"./education-center/markdown/genetic-testing-weight-loss/index.md": [
		363838,
		9,
		363838
	],
	"./education-center/markdown/genetic-testing-weight-loss/weight-loss-dna-tests": [
		128870,
		9,
		128870
	],
	"./education-center/markdown/genetic-testing-weight-loss/weight-loss-dna-tests.md": [
		128870,
		9,
		128870
	],
	"./education-center/markdown/genetic-testing/breast-cancer": [
		440930,
		9,
		440930
	],
	"./education-center/markdown/genetic-testing/breast-cancer.md": [
		440930,
		9,
		440930
	],
	"./education-center/markdown/genetic-testing/hair-loss": [
		817626,
		9,
		817626
	],
	"./education-center/markdown/genetic-testing/hair-loss.md": [
		817626,
		9,
		817626
	],
	"./education-center/markdown/guide-dna-tests": [
		707303,
		9,
		707303
	],
	"./education-center/markdown/guide-dna-tests/": [
		707303,
		9,
		707303
	],
	"./education-center/markdown/guide-dna-tests/dna-report-look-like": [
		115629,
		9,
		115629
	],
	"./education-center/markdown/guide-dna-tests/dna-report-look-like.md": [
		115629,
		9,
		115629
	],
	"./education-center/markdown/guide-dna-tests/how-accurate-are-dna-tests": [
		520949,
		9,
		520949
	],
	"./education-center/markdown/guide-dna-tests/how-accurate-are-dna-tests.md": [
		520949,
		9,
		520949
	],
	"./education-center/markdown/guide-dna-tests/how-does-dna-testing-work": [
		782522,
		9,
		782522
	],
	"./education-center/markdown/guide-dna-tests/how-does-dna-testing-work.md": [
		782522,
		9,
		782522
	],
	"./education-center/markdown/guide-dna-tests/index": [
		707303,
		9,
		707303
	],
	"./education-center/markdown/guide-dna-tests/index.md": [
		707303,
		9,
		707303
	],
	"./education-center/markdown/guide-dna-tests/what-is-a-dna-test": [
		938453,
		9,
		938453
	],
	"./education-center/markdown/guide-dna-tests/what-is-a-dna-test.md": [
		938453,
		9,
		938453
	],
	"./education-center/markdown/how-prevent-alzheimers/natural-ways-prevent-alzheimers": [
		43457,
		9,
		43457
	],
	"./education-center/markdown/how-prevent-alzheimers/natural-ways-prevent-alzheimers.md": [
		43457,
		9,
		43457
	],
	"./education-center/markdown/how-prevent-alzheimers/ways-prevent-alzheimers": [
		440891,
		9,
		440891
	],
	"./education-center/markdown/how-prevent-alzheimers/ways-prevent-alzheimers.md": [
		440891,
		9,
		440891
	],
	"./education-center/markdown/how-to-prevent-alzheimers": [
		79019,
		9,
		79019
	],
	"./education-center/markdown/how-to-prevent-alzheimers/": [
		79019,
		9,
		79019
	],
	"./education-center/markdown/how-to-prevent-alzheimers/genetic-testing-alzheimers": [
		89374,
		9,
		89374
	],
	"./education-center/markdown/how-to-prevent-alzheimers/genetic-testing-alzheimers.md": [
		89374,
		9,
		89374
	],
	"./education-center/markdown/how-to-prevent-alzheimers/index": [
		79019,
		9,
		79019
	],
	"./education-center/markdown/how-to-prevent-alzheimers/index.md": [
		79019,
		9,
		79019
	],
	"./education-center/markdown/how-to-prevent-alzheimers/medications-prevent-alzheimers": [
		181530,
		9,
		181530
	],
	"./education-center/markdown/how-to-prevent-alzheimers/medications-prevent-alzheimers.md": [
		181530,
		9,
		181530
	],
	"./education-center/markdown/how-to-prevent-alzheimers/risk-factors-alzheimers-disease": [
		835013,
		9,
		835013
	],
	"./education-center/markdown/how-to-prevent-alzheimers/risk-factors-alzheimers-disease.md": [
		835013,
		9,
		835013
	],
	"./education-center/markdown/index": [
		911284,
		9,
		911284
	],
	"./education-center/markdown/index.md": [
		911284,
		9,
		911284
	],
	"./education-center/markdown/medical/11q-partial-monosomy-syndrome": [
		154382,
		9,
		154382
	],
	"./education-center/markdown/medical/11q-partial-monosomy-syndrome.md": [
		154382,
		9,
		154382
	],
	"./education-center/markdown/medical/3-m-syndrome": [
		4792,
		9,
		4792
	],
	"./education-center/markdown/medical/3-m-syndrome.md": [
		4792,
		9,
		4792
	],
	"./education-center/markdown/medical/3-oxo-5-alpha-steroid-delta-4-dehydrogenase-deficiency": [
		836901,
		9,
		836901
	],
	"./education-center/markdown/medical/3-oxo-5-alpha-steroid-delta-4-dehydrogenase-deficiency.md": [
		836901,
		9,
		836901
	],
	"./education-center/markdown/medical/46xy-disorder-sex-development-due-testicular-1720-desmolase-deficiency": [
		845141,
		9,
		845141
	],
	"./education-center/markdown/medical/46xy-disorder-sex-development-due-testicular-1720-desmolase-deficiency.md": [
		845141,
		9,
		845141
	],
	"./education-center/markdown/medical/46xy-dsd46xy-cgd": [
		21605,
		9,
		21605
	],
	"./education-center/markdown/medical/46xy-dsd46xy-cgd.md": [
		21605,
		9,
		21605
	],
	"./education-center/markdown/medical/46xy-sex-reversal-4": [
		46021,
		9,
		46021
	],
	"./education-center/markdown/medical/46xy-sex-reversal-4.md": [
		46021,
		9,
		46021
	],
	"./education-center/markdown/medical/abacavir-hypersensitivity": [
		232161,
		9,
		232161
	],
	"./education-center/markdown/medical/abacavir-hypersensitivity.md": [
		232161,
		9,
		232161
	],
	"./education-center/markdown/medical/abca1-polymorphism": [
		721298,
		9,
		721298
	],
	"./education-center/markdown/medical/abca1-polymorphism.md": [
		721298,
		9,
		721298
	],
	"./education-center/markdown/medical/abca1-related-disorders": [
		332536,
		9,
		332536
	],
	"./education-center/markdown/medical/abca1-related-disorders.md": [
		332536,
		9,
		332536
	],
	"./education-center/markdown/medical/abca4-related-disorders": [
		711123,
		9,
		711123
	],
	"./education-center/markdown/medical/abca4-related-disorders.md": [
		711123,
		9,
		711123
	],
	"./education-center/markdown/medical/abcb4-related-intrahepatic-cholestasis": [
		987926,
		9,
		987926
	],
	"./education-center/markdown/medical/abcb4-related-intrahepatic-cholestasis.md": [
		987926,
		9,
		987926
	],
	"./education-center/markdown/medical/abcd-syndrome": [
		200058,
		9,
		200058
	],
	"./education-center/markdown/medical/abcd-syndrome.md": [
		200058,
		9,
		200058
	],
	"./education-center/markdown/medical/abnormal-activity-mitochondrial-respiratory-chain": [
		992715,
		9,
		992715
	],
	"./education-center/markdown/medical/abnormal-activity-mitochondrial-respiratory-chain.md": [
		992715,
		9,
		992715
	],
	"./education-center/markdown/medical/abnormal-anterior-chamber-morphology": [
		89894,
		9,
		89894
	],
	"./education-center/markdown/medical/abnormal-anterior-chamber-morphology.md": [
		89894,
		9,
		89894
	],
	"./education-center/markdown/medical/abnormal-anterior-eye-segment-morphology": [
		431616,
		9,
		431616
	],
	"./education-center/markdown/medical/abnormal-anterior-eye-segment-morphology.md": [
		431616,
		9,
		431616
	],
	"./education-center/markdown/medical/abnormal-aortic-valve-morphology": [
		840481,
		9,
		840481
	],
	"./education-center/markdown/medical/abnormal-aortic-valve-morphology.md": [
		840481,
		9,
		840481
	],
	"./education-center/markdown/medical/abnormal-aortic-valve-physiology": [
		910856,
		9,
		910856
	],
	"./education-center/markdown/medical/abnormal-aortic-valve-physiology.md": [
		910856,
		9,
		910856
	],
	"./education-center/markdown/medical/abnormal-bleeding": [
		943920,
		9,
		943920
	],
	"./education-center/markdown/medical/abnormal-bleeding.md": [
		943920,
		9,
		943920
	],
	"./education-center/markdown/medical/abnormal-blistering-skin": [
		838590,
		9,
		838590
	],
	"./education-center/markdown/medical/abnormal-blistering-skin.md": [
		838590,
		9,
		838590
	],
	"./education-center/markdown/medical/abnormal-bone-structure": [
		458837,
		9,
		458837
	],
	"./education-center/markdown/medical/abnormal-bone-structure.md": [
		458837,
		9,
		458837
	],
	"./education-center/markdown/medical/abnormal-cardiac-atrium-morphology": [
		539873,
		9,
		539873
	],
	"./education-center/markdown/medical/abnormal-cardiac-atrium-morphology.md": [
		539873,
		9,
		539873
	],
	"./education-center/markdown/medical/abnormal-cartilage-collagen": [
		872329,
		9,
		872329
	],
	"./education-center/markdown/medical/abnormal-cartilage-collagen.md": [
		872329,
		9,
		872329
	],
	"./education-center/markdown/medical/abnormal-central-motor-function": [
		37350,
		9,
		37350
	],
	"./education-center/markdown/medical/abnormal-central-motor-function.md": [
		37350,
		9,
		37350
	],
	"./education-center/markdown/medical/abnormal-cerebellar-vermis-morphology": [
		24004,
		9,
		24004
	],
	"./education-center/markdown/medical/abnormal-cerebellar-vermis-morphology.md": [
		24004,
		9,
		24004
	],
	"./education-center/markdown/medical/abnormal-cerebral-morphology": [
		551496,
		9,
		551496
	],
	"./education-center/markdown/medical/abnormal-cerebral-morphology.md": [
		551496,
		9,
		551496
	],
	"./education-center/markdown/medical/abnormal-circulating-carbohydrate-concentration": [
		216744,
		9,
		216744
	],
	"./education-center/markdown/medical/abnormal-circulating-carbohydrate-concentration.md": [
		216744,
		9,
		216744
	],
	"./education-center/markdown/medical/abnormal-circulating-glucose-6-phosphate-dehydrogenase-concentration": [
		352338,
		9,
		352338
	],
	"./education-center/markdown/medical/abnormal-circulating-glucose-6-phosphate-dehydrogenase-concentration.md": [
		352338,
		9,
		352338
	],
	"./education-center/markdown/medical/abnormal-circulating-lipid-concentration": [
		782894,
		9,
		782894
	],
	"./education-center/markdown/medical/abnormal-circulating-lipid-concentration.md": [
		782894,
		9,
		782894
	],
	"./education-center/markdown/medical/abnormal-circulating-porphyrin-concentration": [
		55102,
		9,
		55102
	],
	"./education-center/markdown/medical/abnormal-circulating-porphyrin-concentration.md": [
		55102,
		9,
		55102
	],
	"./education-center/markdown/medical/abnormal-circulating-thyroid-hormone-concentration": [
		804109,
		9,
		804109
	],
	"./education-center/markdown/medical/abnormal-circulating-thyroid-hormone-concentration.md": [
		804109,
		9,
		804109
	],
	"./education-center/markdown/medical/abnormal-corpus-callosum-morphology": [
		543196,
		9,
		543196
	],
	"./education-center/markdown/medical/abnormal-corpus-callosum-morphology.md": [
		543196,
		9,
		543196
	],
	"./education-center/markdown/medical/abnormal-cortical-gyration": [
		610319,
		9,
		610319
	],
	"./education-center/markdown/medical/abnormal-cortical-gyration.md": [
		610319,
		9,
		610319
	],
	"./education-center/markdown/medical/abnormal-facial-shape": [
		427970,
		9,
		427970
	],
	"./education-center/markdown/medical/abnormal-facial-shape.md": [
		427970,
		9,
		427970
	],
	"./education-center/markdown/medical/abnormal-finger-morphology": [
		937505,
		9,
		937505
	],
	"./education-center/markdown/medical/abnormal-finger-morphology.md": [
		937505,
		9,
		937505
	],
	"./education-center/markdown/medical/abnormal-hemoglobin": [
		377056,
		9,
		377056
	],
	"./education-center/markdown/medical/abnormal-hemoglobin.md": [
		377056,
		9,
		377056
	],
	"./education-center/markdown/medical/abnormal-immunoglobulin-level": [
		898565,
		9,
		898565
	],
	"./education-center/markdown/medical/abnormal-immunoglobulin-level.md": [
		898565,
		9,
		898565
	],
	"./education-center/markdown/medical/abnormal-intrahepatic-bile-duct-morphology": [
		869590,
		9,
		869590
	],
	"./education-center/markdown/medical/abnormal-intrahepatic-bile-duct-morphology.md": [
		869590,
		9,
		869590
	],
	"./education-center/markdown/medical/abnormal-lactate-dehydrogenase-level": [
		7726,
		9,
		7726
	],
	"./education-center/markdown/medical/abnormal-lactate-dehydrogenase-level.md": [
		7726,
		9,
		7726
	],
	"./education-center/markdown/medical/abnormal-mitral-valve-physiology": [
		584964,
		9,
		584964
	],
	"./education-center/markdown/medical/abnormal-mitral-valve-physiology.md": [
		584964,
		9,
		584964
	],
	"./education-center/markdown/medical/abnormal-platelet-aggregation": [
		585018,
		9,
		585018
	],
	"./education-center/markdown/medical/abnormal-platelet-aggregation.md": [
		585018,
		9,
		585018
	],
	"./education-center/markdown/medical/abnormal-platelet-function": [
		693825,
		9,
		693825
	],
	"./education-center/markdown/medical/abnormal-platelet-function.md": [
		693825,
		9,
		693825
	],
	"./education-center/markdown/medical/abnormal-protein-o-linked-glycosylation": [
		261516,
		9,
		261516
	],
	"./education-center/markdown/medical/abnormal-protein-o-linked-glycosylation.md": [
		261516,
		9,
		261516
	],
	"./education-center/markdown/medical/abnormal-pyramidal-sign": [
		82235,
		9,
		82235
	],
	"./education-center/markdown/medical/abnormal-pyramidal-sign.md": [
		82235,
		9,
		82235
	],
	"./education-center/markdown/medical/abnormal-radial-ray-morphology": [
		183698,
		9,
		183698
	],
	"./education-center/markdown/medical/abnormal-radial-ray-morphology.md": [
		183698,
		9,
		183698
	],
	"./education-center/markdown/medical/abnormal-sperm-tail-morphology": [
		155623,
		9,
		155623
	],
	"./education-center/markdown/medical/abnormal-sperm-tail-morphology.md": [
		155623,
		9,
		155623
	],
	"./education-center/markdown/medical/abnormal-spermatogenesis": [
		749825,
		9,
		749825
	],
	"./education-center/markdown/medical/abnormal-spermatogenesis.md": [
		749825,
		9,
		749825
	],
	"./education-center/markdown/medical/abnormal-synaptic-transmission": [
		542961,
		9,
		542961
	],
	"./education-center/markdown/medical/abnormal-synaptic-transmission.md": [
		542961,
		9,
		542961
	],
	"./education-center/markdown/medical/abnormality-blood-and-blood-forming-tissues": [
		28387,
		9,
		28387
	],
	"./education-center/markdown/medical/abnormality-blood-and-blood-forming-tissues.md": [
		28387,
		9,
		28387
	],
	"./education-center/markdown/medical/abnormality-bone-mineral-density": [
		955899,
		9,
		955899
	],
	"./education-center/markdown/medical/abnormality-bone-mineral-density.md": [
		955899,
		9,
		955899
	],
	"./education-center/markdown/medical/abnormality-brain-morphology": [
		703994,
		9,
		703994
	],
	"./education-center/markdown/medical/abnormality-brain-morphology.md": [
		703994,
		9,
		703994
	],
	"./education-center/markdown/medical/abnormality-cardiovascular-system": [
		488243,
		9,
		488243
	],
	"./education-center/markdown/medical/abnormality-cardiovascular-system-morphology": [
		734047,
		9,
		734047
	],
	"./education-center/markdown/medical/abnormality-cardiovascular-system-morphology.md": [
		734047,
		9,
		734047
	],
	"./education-center/markdown/medical/abnormality-cardiovascular-system.md": [
		488243,
		9,
		488243
	],
	"./education-center/markdown/medical/abnormality-coagulation": [
		323760,
		9,
		323760
	],
	"./education-center/markdown/medical/abnormality-coagulation.md": [
		323760,
		9,
		323760
	],
	"./education-center/markdown/medical/abnormality-connective-tissue": [
		407107,
		9,
		407107
	],
	"./education-center/markdown/medical/abnormality-connective-tissue.md": [
		407107,
		9,
		407107
	],
	"./education-center/markdown/medical/abnormality-dentition": [
		395077,
		9,
		395077
	],
	"./education-center/markdown/medical/abnormality-dentition.md": [
		395077,
		9,
		395077
	],
	"./education-center/markdown/medical/abnormality-female-genitalia": [
		596019,
		9,
		596019
	],
	"./education-center/markdown/medical/abnormality-female-genitalia.md": [
		596019,
		9,
		596019
	],
	"./education-center/markdown/medical/abnormality-immune-system": [
		444326,
		9,
		444326
	],
	"./education-center/markdown/medical/abnormality-immune-system-physiology": [
		212649,
		9,
		212649
	],
	"./education-center/markdown/medical/abnormality-immune-system-physiology.md": [
		212649,
		9,
		212649
	],
	"./education-center/markdown/medical/abnormality-immune-system.md": [
		444326,
		9,
		444326
	],
	"./education-center/markdown/medical/abnormality-iron-homeostasis": [
		561545,
		9,
		561545
	],
	"./education-center/markdown/medical/abnormality-iron-homeostasis.md": [
		561545,
		9,
		561545
	],
	"./education-center/markdown/medical/abnormality-lysosomal-metabolism": [
		997146,
		9,
		997146
	],
	"./education-center/markdown/medical/abnormality-lysosomal-metabolism.md": [
		997146,
		9,
		997146
	],
	"./education-center/markdown/medical/abnormality-metabolismhomeostasis": [
		747005,
		9,
		747005
	],
	"./education-center/markdown/medical/abnormality-metabolismhomeostasis.md": [
		747005,
		9,
		747005
	],
	"./education-center/markdown/medical/abnormality-mitochondrion": [
		807727,
		9,
		807727
	],
	"./education-center/markdown/medical/abnormality-mitochondrion.md": [
		807727,
		9,
		807727
	],
	"./education-center/markdown/medical/abnormality-mucopolysaccharide-metabolism": [
		293481,
		9,
		293481
	],
	"./education-center/markdown/medical/abnormality-mucopolysaccharide-metabolism.md": [
		293481,
		9,
		293481
	],
	"./education-center/markdown/medical/abnormality-musculature": [
		487015,
		9,
		487015
	],
	"./education-center/markdown/medical/abnormality-musculature.md": [
		487015,
		9,
		487015
	],
	"./education-center/markdown/medical/abnormality-neuronal-migration": [
		524915,
		9,
		524915
	],
	"./education-center/markdown/medical/abnormality-neuronal-migration.md": [
		524915,
		9,
		524915
	],
	"./education-center/markdown/medical/abnormality-ovary": [
		170467,
		9,
		170467
	],
	"./education-center/markdown/medical/abnormality-ovary.md": [
		170467,
		9,
		170467
	],
	"./education-center/markdown/medical/abnormality-pancreas": [
		471088,
		9,
		471088
	],
	"./education-center/markdown/medical/abnormality-pancreas.md": [
		471088,
		9,
		471088
	],
	"./education-center/markdown/medical/abnormality-prenatal-development-or-birth": [
		432902,
		9,
		432902
	],
	"./education-center/markdown/medical/abnormality-prenatal-development-or-birth.md": [
		432902,
		9,
		432902
	],
	"./education-center/markdown/medical/abnormality-pulmonary-vasculature": [
		527102,
		9,
		527102
	],
	"./education-center/markdown/medical/abnormality-pulmonary-vasculature.md": [
		527102,
		9,
		527102
	],
	"./education-center/markdown/medical/abnormality-refraction": [
		699516,
		9,
		699516
	],
	"./education-center/markdown/medical/abnormality-refraction.md": [
		699516,
		9,
		699516
	],
	"./education-center/markdown/medical/abnormality-skeletal-system": [
		204920,
		9,
		204920
	],
	"./education-center/markdown/medical/abnormality-skeletal-system.md": [
		204920,
		9,
		204920
	],
	"./education-center/markdown/medical/abnormality-urinary-system": [
		579616,
		9,
		579616
	],
	"./education-center/markdown/medical/abnormality-urinary-system.md": [
		579616,
		9,
		579616
	],
	"./education-center/markdown/medical/abo-blood-group-system": [
		900993,
		9,
		900993
	],
	"./education-center/markdown/medical/abo-blood-group-system.md": [
		900993,
		9,
		900993
	],
	"./education-center/markdown/medical/aborted-sudden-cardiac-death": [
		665244,
		9,
		665244
	],
	"./education-center/markdown/medical/aborted-sudden-cardiac-death.md": [
		665244,
		9,
		665244
	],
	"./education-center/markdown/medical/absent-radius": [
		81693,
		9,
		81693
	],
	"./education-center/markdown/medical/absent-radius.md": [
		81693,
		9,
		81693
	],
	"./education-center/markdown/medical/acampomelic-campomelic-dysplasia": [
		60590,
		9,
		60590
	],
	"./education-center/markdown/medical/acampomelic-campomelic-dysplasia.md": [
		60590,
		9,
		60590
	],
	"./education-center/markdown/medical/acanthocytosis": [
		227594,
		9,
		227594
	],
	"./education-center/markdown/medical/acanthocytosis-due-band-3-ht": [
		261687,
		9,
		261687
	],
	"./education-center/markdown/medical/acanthocytosis-due-band-3-ht.md": [
		261687,
		9,
		261687
	],
	"./education-center/markdown/medical/acanthocytosis.md": [
		227594,
		9,
		227594
	],
	"./education-center/markdown/medical/acanthosis-nigricans": [
		335950,
		9,
		335950
	],
	"./education-center/markdown/medical/acanthosis-nigricans.md": [
		335950,
		9,
		335950
	],
	"./education-center/markdown/medical/acatalasemia-japanese-type": [
		495706,
		9,
		495706
	],
	"./education-center/markdown/medical/acatalasemia-japanese-type.md": [
		495706,
		9,
		495706
	],
	"./education-center/markdown/medical/accelerated-tumor-formation-susceptibility": [
		282853,
		9,
		282853
	],
	"./education-center/markdown/medical/accelerated-tumor-formation-susceptibility.md": [
		282853,
		9,
		282853
	],
	"./education-center/markdown/medical/accessory-ectopic-thyroid-tissue": [
		234279,
		9,
		234279
	],
	"./education-center/markdown/medical/accessory-ectopic-thyroid-tissue.md": [
		234279,
		9,
		234279
	],
	"./education-center/markdown/medical/acenocoumarol-response-dosage": [
		146586,
		9,
		146586
	],
	"./education-center/markdown/medical/acenocoumarol-response-dosage.md": [
		146586,
		9,
		146586
	],
	"./education-center/markdown/medical/achondrogenesis-type-ii": [
		771839,
		9,
		771839
	],
	"./education-center/markdown/medical/achondrogenesis-type-ii.md": [
		771839,
		9,
		771839
	],
	"./education-center/markdown/medical/achondroplasia": [
		897171,
		9,
		897171
	],
	"./education-center/markdown/medical/achondroplasia.md": [
		897171,
		9,
		897171
	],
	"./education-center/markdown/medical/acid-alpha-glucosidase-allele-2": [
		468999,
		9,
		468999
	],
	"./education-center/markdown/medical/acid-alpha-glucosidase-allele-2.md": [
		468999,
		9,
		468999
	],
	"./education-center/markdown/medical/acne-inversa-familial-1": [
		831131,
		9,
		831131
	],
	"./education-center/markdown/medical/acne-inversa-familial-1.md": [
		831131,
		9,
		831131
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-delayed-progression": [
		910603,
		9,
		910603
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-delayed-progression.md": [
		910603,
		9,
		910603
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-rapid-progression": [
		272034,
		9,
		272034
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-rapid-progression.md": [
		272034,
		9,
		272034
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-slow-progression": [
		159664,
		9,
		159664
	],
	"./education-center/markdown/medical/acquired-immunodeficiency-syndrome-slow-progression.md": [
		159664,
		9,
		159664
	],
	"./education-center/markdown/medical/acquired-susceptibility-long-qt-syndrome-1": [
		266274,
		9,
		266274
	],
	"./education-center/markdown/medical/acquired-susceptibility-long-qt-syndrome-1.md": [
		266274,
		9,
		266274
	],
	"./education-center/markdown/medical/acrocephalosyndactyly-type-i": [
		27198,
		9,
		27198
	],
	"./education-center/markdown/medical/acrocephalosyndactyly-type-i.md": [
		27198,
		9,
		27198
	],
	"./education-center/markdown/medical/acrodysostosis-1-or-without-hormone-resistance": [
		197438,
		9,
		197438
	],
	"./education-center/markdown/medical/acrodysostosis-1-or-without-hormone-resistance.md": [
		197438,
		9,
		197438
	],
	"./education-center/markdown/medical/acrokeratosis-verruciformis-hopf": [
		718541,
		9,
		718541
	],
	"./education-center/markdown/medical/acrokeratosis-verruciformis-hopf.md": [
		718541,
		9,
		718541
	],
	"./education-center/markdown/medical/acromicric-dysplasia": [
		491548,
		9,
		491548
	],
	"./education-center/markdown/medical/acromicric-dysplasia.md": [
		491548,
		9,
		491548
	],
	"./education-center/markdown/medical/actn3-deficiency": [
		899737,
		9,
		899737
	],
	"./education-center/markdown/medical/actn3-deficiency.md": [
		899737,
		9,
		899737
	],
	"./education-center/markdown/medical/aculeiform-cataract": [
		361906,
		9,
		361906
	],
	"./education-center/markdown/medical/aculeiform-cataract.md": [
		361906,
		9,
		361906
	],
	"./education-center/markdown/medical/acute-coronary-syndrome": [
		98664,
		9,
		98664
	],
	"./education-center/markdown/medical/acute-coronary-syndrome.md": [
		98664,
		9,
		98664
	],
	"./education-center/markdown/medical/acute-recurrent-myoglobinuria": [
		839740,
		9,
		839740
	],
	"./education-center/markdown/medical/acute-recurrent-myoglobinuria.md": [
		839740,
		9,
		839740
	],
	"./education-center/markdown/medical/acute-respiratory-failure": [
		76753,
		9,
		76753
	],
	"./education-center/markdown/medical/acute-respiratory-failure.md": [
		76753,
		9,
		76753
	],
	"./education-center/markdown/medical/adams-oliver-syndrome": [
		189495,
		9,
		189495
	],
	"./education-center/markdown/medical/adams-oliver-syndrome.md": [
		189495,
		9,
		189495
	],
	"./education-center/markdown/medical/adan-amyloidosis": [
		871675,
		9,
		871675
	],
	"./education-center/markdown/medical/adan-amyloidosis.md": [
		871675,
		9,
		871675
	],
	"./education-center/markdown/medical/adenocarcinoma-lung-response-tyrosine-kinase-inhibitor-somatic": [
		536159,
		9,
		536159
	],
	"./education-center/markdown/medical/adenocarcinoma-lung-response-tyrosine-kinase-inhibitor-somatic.md": [
		536159,
		9,
		536159
	],
	"./education-center/markdown/medical/adenoma-cortisol-producing": [
		990940,
		9,
		990940
	],
	"./education-center/markdown/medical/adenoma-cortisol-producing.md": [
		990940,
		9,
		990940
	],
	"./education-center/markdown/medical/adenomatous-colonic-polyposis": [
		928031,
		9,
		928031
	],
	"./education-center/markdown/medical/adenomatous-colonic-polyposis.md": [
		928031,
		9,
		928031
	],
	"./education-center/markdown/medical/adenomatous-polyposis-coli-attenuated": [
		749799,
		9,
		749799
	],
	"./education-center/markdown/medical/adenomatous-polyposis-coli-attenuated.md": [
		749799,
		9,
		749799
	],
	"./education-center/markdown/medical/adenomatous-polyposis-coli-congenital-cholesteatoma": [
		856982,
		9,
		856982
	],
	"./education-center/markdown/medical/adenomatous-polyposis-coli-congenital-cholesteatoma.md": [
		856982,
		9,
		856982
	],
	"./education-center/markdown/medical/adenylosuccinate-lyase-deficiency": [
		539007,
		9,
		539007
	],
	"./education-center/markdown/medical/adenylosuccinate-lyase-deficiency.md": [
		539007,
		9,
		539007
	],
	"./education-center/markdown/medical/adermatoglyphia": [
		900294,
		9,
		900294
	],
	"./education-center/markdown/medical/adermatoglyphia.md": [
		900294,
		9,
		900294
	],
	"./education-center/markdown/medical/adolescent-alopeciam-dentogingival-abnormalitites-and-intellectual-disability": [
		95391,
		9,
		95391
	],
	"./education-center/markdown/medical/adolescent-alopeciam-dentogingival-abnormalitites-and-intellectual-disability.md": [
		95391,
		9,
		95391
	],
	"./education-center/markdown/medical/adrenal-cortex-carcinoma": [
		451268,
		9,
		451268
	],
	"./education-center/markdown/medical/adrenal-cortex-carcinoma.md": [
		451268,
		9,
		451268
	],
	"./education-center/markdown/medical/adrenal-hyperplasia": [
		223930,
		9,
		223930
	],
	"./education-center/markdown/medical/adrenal-hyperplasia.md": [
		223930,
		9,
		223930
	],
	"./education-center/markdown/medical/adrenal-insufficiency": [
		97666,
		9,
		97666
	],
	"./education-center/markdown/medical/adrenal-insufficiency-nr5a1-related": [
		569041,
		9,
		569041
	],
	"./education-center/markdown/medical/adrenal-insufficiency-nr5a1-related.md": [
		569041,
		9,
		569041
	],
	"./education-center/markdown/medical/adrenal-insufficiency.md": [
		97666,
		9,
		97666
	],
	"./education-center/markdown/medical/adrenocortical-carcinoma-pediatric": [
		422457,
		9,
		422457
	],
	"./education-center/markdown/medical/adrenocortical-carcinoma-pediatric.md": [
		422457,
		9,
		422457
	],
	"./education-center/markdown/medical/adrenocortical-tumor-somatic": [
		697421,
		9,
		697421
	],
	"./education-center/markdown/medical/adrenocortical-tumor-somatic.md": [
		697421,
		9,
		697421
	],
	"./education-center/markdown/medical/adult-hypophosphatasia": [
		72218,
		9,
		72218
	],
	"./education-center/markdown/medical/adult-hypophosphatasia.md": [
		72218,
		9,
		72218
	],
	"./education-center/markdown/medical/adult-i-blood-group-or-without-congenital-cataract": [
		70358,
		9,
		70358
	],
	"./education-center/markdown/medical/adult-i-blood-group-or-without-congenital-cataract.md": [
		70358,
		9,
		70358
	],
	"./education-center/markdown/medical/adult-i-blood-group-phenotype": [
		279516,
		9,
		279516
	],
	"./education-center/markdown/medical/adult-i-blood-group-phenotype.md": [
		279516,
		9,
		279516
	],
	"./education-center/markdown/medical/adult-polyglucosan-body-neuropathy": [
		543721,
		9,
		543721
	],
	"./education-center/markdown/medical/adult-polyglucosan-body-neuropathy.md": [
		543721,
		9,
		543721
	],
	"./education-center/markdown/medical/adult-syndrome": [
		678154,
		9,
		678154
	],
	"./education-center/markdown/medical/adult-syndrome.md": [
		678154,
		9,
		678154
	],
	"./education-center/markdown/medical/aerodigestive-tract-cancer-squamous-cell-alcohol-related-protection-against": [
		508995,
		9,
		508995
	],
	"./education-center/markdown/medical/aerodigestive-tract-cancer-squamous-cell-alcohol-related-protection-against.md": [
		508995,
		9,
		508995
	],
	"./education-center/markdown/medical/afibrinogenemia": [
		618663,
		9,
		618663
	],
	"./education-center/markdown/medical/afibrinogenemia.md": [
		618663,
		9,
		618663
	],
	"./education-center/markdown/medical/age-related-macular-degeneration-2": [
		208010,
		9,
		208010
	],
	"./education-center/markdown/medical/age-related-macular-degeneration-2.md": [
		208010,
		9,
		208010
	],
	"./education-center/markdown/medical/agenesis-corpus-callosum-peripheral-neuropathy": [
		428000,
		9,
		428000
	],
	"./education-center/markdown/medical/agenesis-corpus-callosum-peripheral-neuropathy.md": [
		428000,
		9,
		428000
	],
	"./education-center/markdown/medical/agk-related-disorders": [
		455247,
		9,
		455247
	],
	"./education-center/markdown/medical/agk-related-disorders.md": [
		455247,
		9,
		455247
	],
	"./education-center/markdown/medical/aicardi-goutieres-syndrome-1-autosomal-dominant": [
		305232,
		9,
		305232
	],
	"./education-center/markdown/medical/aicardi-goutieres-syndrome-1-autosomal-dominant.md": [
		305232,
		9,
		305232
	],
	"./education-center/markdown/medical/aipl1-related-disorders": [
		924829,
		9,
		924829
	],
	"./education-center/markdown/medical/aipl1-related-disorders.md": [
		924829,
		9,
		924829
	],
	"./education-center/markdown/medical/alagille-syndrome-atp8b1-related": [
		337078,
		9,
		337078
	],
	"./education-center/markdown/medical/alagille-syndrome-atp8b1-related.md": [
		337078,
		9,
		337078
	],
	"./education-center/markdown/medical/alcohol-dependence": [
		814426,
		9,
		814426
	],
	"./education-center/markdown/medical/alcohol-dependence.md": [
		814426,
		9,
		814426
	],
	"./education-center/markdown/medical/aldosterone-producing-adrenal-adenoma-somatic": [
		142428,
		9,
		142428
	],
	"./education-center/markdown/medical/aldosterone-producing-adrenal-adenoma-somatic.md": [
		142428,
		9,
		142428
	],
	"./education-center/markdown/medical/aldosterone-renin-ratio-increased": [
		791378,
		9,
		791378
	],
	"./education-center/markdown/medical/aldosterone-renin-ratio-increased.md": [
		791378,
		9,
		791378
	],
	"./education-center/markdown/medical/alloalbuminemia": [
		970077,
		9,
		970077
	],
	"./education-center/markdown/medical/alloalbuminemia.md": [
		970077,
		9,
		970077
	],
	"./education-center/markdown/medical/alopecia-androgenetic-1": [
		761343,
		9,
		761343
	],
	"./education-center/markdown/medical/alopecia-androgenetic-1.md": [
		761343,
		9,
		761343
	],
	"./education-center/markdown/medical/alpha-fetoprotein-deficiency": [
		434176,
		9,
		434176
	],
	"./education-center/markdown/medical/alpha-fetoprotein-deficiency.md": [
		434176,
		9,
		434176
	],
	"./education-center/markdown/medical/alpha-fetoprotein-hereditary-persistence": [
		14044,
		9,
		14044
	],
	"./education-center/markdown/medical/alpha-fetoprotein-hereditary-persistence.md": [
		14044,
		9,
		14044
	],
	"./education-center/markdown/medical/alpha-thalassemia-2-nondeletional": [
		451672,
		9,
		451672
	],
	"./education-center/markdown/medical/alpha-thalassemia-2-nondeletional.md": [
		451672,
		9,
		451672
	],
	"./education-center/markdown/medical/alpha-thalassemia-dutch-type": [
		448221,
		9,
		448221
	],
	"./education-center/markdown/medical/alpha-thalassemia-dutch-type.md": [
		448221,
		9,
		448221
	],
	"./education-center/markdown/medical/alpha-thalassemia-hmong-type": [
		258759,
		9,
		258759
	],
	"./education-center/markdown/medical/alpha-thalassemia-hmong-type.md": [
		258759,
		9,
		258759
	],
	"./education-center/markdown/medical/alpha-thalassemiaintellectual-disability-syndrome": [
		516762,
		9,
		516762
	],
	"./education-center/markdown/medical/alpha-thalassemiaintellectual-disability-syndrome.md": [
		516762,
		9,
		516762
	],
	"./education-center/markdown/medical/alpha-trait-thalassemia": [
		155908,
		9,
		155908
	],
	"./education-center/markdown/medical/alpha-trait-thalassemia.md": [
		155908,
		9,
		155908
	],
	"./education-center/markdown/medical/als2-related-disorders": [
		607619,
		9,
		607619
	],
	"./education-center/markdown/medical/als2-related-disorders.md": [
		607619,
		9,
		607619
	],
	"./education-center/markdown/medical/altered-myosin-contractile-function": [
		993921,
		9,
		993921
	],
	"./education-center/markdown/medical/altered-myosin-contractile-function.md": [
		993921,
		9,
		993921
	],
	"./education-center/markdown/medical/altered-potassium-channel-function": [
		789965,
		9,
		789965
	],
	"./education-center/markdown/medical/altered-potassium-channel-function.md": [
		789965,
		9,
		789965
	],
	"./education-center/markdown/medical/alternating-hemiplegia-childhood-1": [
		981913,
		9,
		981913
	],
	"./education-center/markdown/medical/alternating-hemiplegia-childhood-1.md": [
		981913,
		9,
		981913
	],
	"./education-center/markdown/medical/alzheimer-disease-2": [
		902302,
		9,
		902302
	],
	"./education-center/markdown/medical/alzheimer-disease-2.md": [
		902302,
		9,
		902302
	],
	"./education-center/markdown/medical/alzheimer-disease-3": [
		416803,
		9,
		416803
	],
	"./education-center/markdown/medical/alzheimer-disease-3.md": [
		416803,
		9,
		416803
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis": [
		637483,
		9,
		637483
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-apraxia": [
		850786,
		9,
		850786
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-apraxia.md": [
		850786,
		9,
		850786
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-unusual-plaques": [
		977155,
		9,
		977155
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-unusual-plaques.md": [
		977155,
		9,
		977155
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-spastic-paraparesis.md": [
		637483,
		9,
		637483
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-unusual-plaques": [
		208549,
		9,
		208549
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-3-unusual-plaques.md": [
		208549,
		9,
		208549
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-spastic-paraparesis-and-unusual-plaques": [
		591451,
		9,
		591451
	],
	"./education-center/markdown/medical/alzheimer-disease-familial-spastic-paraparesis-and-unusual-plaques.md": [
		591451,
		9,
		591451
	],
	"./education-center/markdown/medical/alzheimer-disease-late-onset-susceptibility": [
		553918,
		9,
		553918
	],
	"./education-center/markdown/medical/alzheimer-disease-late-onset-susceptibility.md": [
		553918,
		9,
		553918
	],
	"./education-center/markdown/medical/alzheimer-disease-protection-against": [
		63676,
		9,
		63676
	],
	"./education-center/markdown/medical/alzheimer-disease-protection-against.md": [
		63676,
		9,
		63676
	],
	"./education-center/markdown/medical/alzheimer-disease-type-1": [
		143085,
		9,
		143085
	],
	"./education-center/markdown/medical/alzheimer-disease-type-1.md": [
		143085,
		9,
		143085
	],
	"./education-center/markdown/medical/ambiguous-genitalia": [
		321082,
		9,
		321082
	],
	"./education-center/markdown/medical/ambiguous-genitalia.md": [
		321082,
		9,
		321082
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-dominant": [
		216223,
		9,
		216223
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-dominant.md": [
		216223,
		9,
		216223
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-hypocalcification-type": [
		999868,
		9,
		999868
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-hypocalcification-type.md": [
		999868,
		9,
		999868
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-hypoplastic-autosomal-dominant-local": [
		143337,
		9,
		143337
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-hypoplastic-autosomal-dominant-local.md": [
		143337,
		9,
		143337
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-recessive": [
		312227,
		9,
		312227
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-recessive.md": [
		312227,
		9,
		312227
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-type-1a": [
		549029,
		9,
		549029
	],
	"./education-center/markdown/medical/amelogenesis-imperfecta-type-1a.md": [
		549029,
		9,
		549029
	],
	"./education-center/markdown/medical/amyloid-cardiomyopathy-transthyretin-related": [
		18920,
		9,
		18920
	],
	"./education-center/markdown/medical/amyloid-cardiomyopathy-transthyretin-related.md": [
		18920,
		9,
		18920
	],
	"./education-center/markdown/medical/amyloidogenic-transthyretin-amyloidosis": [
		827649,
		9,
		827649
	],
	"./education-center/markdown/medical/amyloidogenic-transthyretin-amyloidosis.md": [
		827649,
		9,
		827649
	],
	"./education-center/markdown/medical/amyloidosis-cardiac-and-cutaneous": [
		862386,
		9,
		862386
	],
	"./education-center/markdown/medical/amyloidosis-cardiac-and-cutaneous.md": [
		862386,
		9,
		862386
	],
	"./education-center/markdown/medical/amyloidosis-leptomeningeal-transthyretin-related": [
		373930,
		9,
		373930
	],
	"./education-center/markdown/medical/amyloidosis-leptomeningeal-transthyretin-related.md": [
		373930,
		9,
		373930
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-1-autosomal-recessive": [
		541321,
		9,
		541321
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-1-autosomal-recessive.md": [
		541321,
		9,
		541321
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-22-frontotemporal-dementia": [
		496702,
		9,
		496702
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-22-frontotemporal-dementia.md": [
		496702,
		9,
		496702
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-6-autosomal-recessive": [
		76748,
		9,
		76748
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-6-autosomal-recessive.md": [
		76748,
		9,
		76748
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-dominant": [
		675390,
		9,
		675390
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-dominant.md": [
		675390,
		9,
		675390
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-parkinsonism-dementia-complex": [
		819289,
		9,
		819289
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-parkinsonism-dementia-complex.md": [
		819289,
		9,
		819289
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-recessive": [
		269649,
		9,
		269649
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-recessive.md": [
		269649,
		9,
		269649
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-susceptibility": [
		911015,
		9,
		911015
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-susceptibility.md": [
		911015,
		9,
		911015
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-type-1": [
		377116,
		9,
		377116
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-type-1.md": [
		377116,
		9,
		377116
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-type-4": [
		743522,
		9,
		743522
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosis-type-4.md": [
		743522,
		9,
		743522
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosisfrontotemporal-dementia": [
		660084,
		9,
		660084
	],
	"./education-center/markdown/medical/amyotrophic-lateral-sclerosisfrontotemporal-dementia.md": [
		660084,
		9,
		660084
	],
	"./education-center/markdown/medical/anadysplasia-spontaneously-remitting-spondylometaphyseal-dysplasia": [
		216707,
		9,
		216707
	],
	"./education-center/markdown/medical/anadysplasia-spontaneously-remitting-spondylometaphyseal-dysplasia.md": [
		216707,
		9,
		216707
	],
	"./education-center/markdown/medical/analbuminemia": [
		52165,
		9,
		52165
	],
	"./education-center/markdown/medical/analbuminemia-baghdad": [
		293186,
		9,
		293186
	],
	"./education-center/markdown/medical/analbuminemia-baghdad.md": [
		293186,
		9,
		293186
	],
	"./education-center/markdown/medical/analbuminemia.md": [
		52165,
		9,
		52165
	],
	"./education-center/markdown/medical/anemia": [
		636923,
		9,
		636923
	],
	"./education-center/markdown/medical/anemia-hereditary-sideroblastic-1-pyridoxine-refractory": [
		939490,
		9,
		939490
	],
	"./education-center/markdown/medical/anemia-hereditary-sideroblastic-1-pyridoxine-refractory.md": [
		939490,
		9,
		939490
	],
	"./education-center/markdown/medical/anemia-perinatal-hemolytic-fatal-or-near-fatal": [
		41570,
		9,
		41570
	],
	"./education-center/markdown/medical/anemia-perinatal-hemolytic-fatal-or-near-fatal.md": [
		41570,
		9,
		41570
	],
	"./education-center/markdown/medical/anemia.md": [
		636923,
		9,
		636923
	],
	"./education-center/markdown/medical/anencephaly": [
		604735,
		9,
		604735
	],
	"./education-center/markdown/medical/anencephaly.md": [
		604735,
		9,
		604735
	],
	"./education-center/markdown/medical/angelman-syndrome": [
		52058,
		9,
		52058
	],
	"./education-center/markdown/medical/angelman-syndrome-0": [
		274131,
		9,
		274131
	],
	"./education-center/markdown/medical/angelman-syndrome-0.md": [
		274131,
		9,
		274131
	],
	"./education-center/markdown/medical/angelman-syndrome.md": [
		52058,
		9,
		52058
	],
	"./education-center/markdown/medical/angiofibroma-somatic": [
		874234,
		9,
		571195
	],
	"./education-center/markdown/medical/angiofibroma-somatic.md": [
		874234,
		9,
		571195
	],
	"./education-center/markdown/medical/angioma-serpiginosum-autosomal-dominant": [
		131802,
		9,
		131802
	],
	"./education-center/markdown/medical/angioma-serpiginosum-autosomal-dominant.md": [
		131802,
		9,
		131802
	],
	"./education-center/markdown/medical/angioosteohypertrophic-syndrome": [
		996555,
		9,
		996555
	],
	"./education-center/markdown/medical/angioosteohypertrophic-syndrome.md": [
		996555,
		9,
		996555
	],
	"./education-center/markdown/medical/angiotensin-i-converting-enzyme-benign-serum-increase": [
		753386,
		9,
		753386
	],
	"./education-center/markdown/medical/angiotensin-i-converting-enzyme-benign-serum-increase.md": [
		753386,
		9,
		753386
	],
	"./education-center/markdown/medical/anhydramnios": [
		578485,
		9,
		578485
	],
	"./education-center/markdown/medical/anhydramnios.md": [
		578485,
		9,
		578485
	],
	"./education-center/markdown/medical/aniridia-atypical": [
		976264,
		9,
		976264
	],
	"./education-center/markdown/medical/aniridia-atypical.md": [
		976264,
		9,
		976264
	],
	"./education-center/markdown/medical/aniridia-cerebellar-ataxia-and-intellectual-disability": [
		41259,
		9,
		41259
	],
	"./education-center/markdown/medical/aniridia-cerebellar-ataxia-and-intellectual-disability.md": [
		41259,
		9,
		41259
	],
	"./education-center/markdown/medical/ankrd1-related-dilated-cardiomyopathy": [
		353495,
		9,
		353495
	],
	"./education-center/markdown/medical/ankrd1-related-dilated-cardiomyopathy.md": [
		353495,
		9,
		353495
	],
	"./education-center/markdown/medical/ankyloblepharon-ectodermal-defects-cleft-lippalate-syndrome": [
		497689,
		9,
		497689
	],
	"./education-center/markdown/medical/ankyloblepharon-ectodermal-defects-cleft-lippalate-syndrome.md": [
		497689,
		9,
		497689
	],
	"./education-center/markdown/medical/ano5-related-disorders": [
		437903,
		9,
		437903
	],
	"./education-center/markdown/medical/ano5-related-disorders.md": [
		437903,
		9,
		437903
	],
	"./education-center/markdown/medical/ano5-related-muscle-diseases": [
		395056,
		9,
		395056
	],
	"./education-center/markdown/medical/ano5-related-muscle-diseases.md": [
		395056,
		9,
		395056
	],
	"./education-center/markdown/medical/anonychia": [
		770658,
		9,
		770658
	],
	"./education-center/markdown/medical/anonychia.md": [
		770658,
		9,
		770658
	],
	"./education-center/markdown/medical/anophthalmia": [
		13149,
		9,
		13149
	],
	"./education-center/markdown/medical/anophthalmia.md": [
		13149,
		9,
		13149
	],
	"./education-center/markdown/medical/anosmia": [
		50018,
		9,
		50018
	],
	"./education-center/markdown/medical/anosmia.md": [
		50018,
		9,
		50018
	],
	"./education-center/markdown/medical/anterior-segment-anomalies-and-cataract": [
		282918,
		9,
		282918
	],
	"./education-center/markdown/medical/anterior-segment-anomalies-and-cataract.md": [
		282918,
		9,
		282918
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-1": [
		358164,
		9,
		358164
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-1-multiple-subtypes": [
		168634,
		9,
		168634
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-1-multiple-subtypes.md": [
		168634,
		9,
		168634
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-1.md": [
		358164,
		9,
		358164
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-4": [
		158286,
		9,
		158286
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-4.md": [
		158286,
		9,
		158286
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-5-multiple-subtypes": [
		970029,
		9,
		970029
	],
	"./education-center/markdown/medical/anterior-segment-dysgenesis-5-multiple-subtypes.md": [
		970029,
		9,
		970029
	],
	"./education-center/markdown/medical/anti-sema4d-monoclonal-antibody-vx152503": [
		570740,
		9,
		570740
	],
	"./education-center/markdown/medical/anti-sema4d-monoclonal-antibody-vx152503.md": [
		570740,
		9,
		570740
	],
	"./education-center/markdown/medical/antidepressant-drug-treatment-accelerated-response": [
		385575,
		9,
		385575
	],
	"./education-center/markdown/medical/antidepressant-drug-treatment-accelerated-response.md": [
		385575,
		9,
		385575
	],
	"./education-center/markdown/medical/antigen-scianna-blood-group-system": [
		808919,
		9,
		808919
	],
	"./education-center/markdown/medical/antigen-scianna-blood-group-system.md": [
		808919,
		9,
		808919
	],
	"./education-center/markdown/medical/aortic-aneurysm-familial-thoracic-4": [
		711860,
		9,
		711860
	],
	"./education-center/markdown/medical/aortic-aneurysm-familial-thoracic-4.md": [
		711860,
		9,
		711860
	],
	"./education-center/markdown/medical/aortic-aneurysm-familial-thoracic-tgfb2-related": [
		892871,
		9,
		892871
	],
	"./education-center/markdown/medical/aortic-aneurysm-familial-thoracic-tgfb2-related.md": [
		892871,
		9,
		892871
	],
	"./education-center/markdown/medical/aortic-dilatation": [
		932499,
		9,
		932499
	],
	"./education-center/markdown/medical/aortic-dilatation.md": [
		932499,
		9,
		932499
	],
	"./education-center/markdown/medical/aortic-dissection": [
		661216,
		9,
		661216
	],
	"./education-center/markdown/medical/aortic-dissection.md": [
		661216,
		9,
		661216
	],
	"./education-center/markdown/medical/aortic-root-aneurysm": [
		242645,
		9,
		242645
	],
	"./education-center/markdown/medical/aortic-root-aneurysm.md": [
		242645,
		9,
		242645
	],
	"./education-center/markdown/medical/aortic-valve-disease-2": [
		819062,
		9,
		819062
	],
	"./education-center/markdown/medical/aortic-valve-disease-2.md": [
		819062,
		9,
		819062
	],
	"./education-center/markdown/medical/apc-associated-polyposis-disorders": [
		653115,
		9,
		653115
	],
	"./education-center/markdown/medical/apc-associated-polyposis-disorders.md": [
		653115,
		9,
		653115
	],
	"./education-center/markdown/medical/apc-mutation-negative-familial-colorectal-cancer": [
		799898,
		9,
		799898
	],
	"./education-center/markdown/medical/apc-mutation-negative-familial-colorectal-cancer.md": [
		799898,
		9,
		799898
	],
	"./education-center/markdown/medical/aplasia-cutis-congenita": [
		776676,
		9,
		776676
	],
	"./education-center/markdown/medical/aplasia-cutis-congenita.md": [
		776676,
		9,
		776676
	],
	"./education-center/markdown/medical/apocrine-gland-secretion-variation": [
		760338,
		9,
		760338
	],
	"./education-center/markdown/medical/apocrine-gland-secretion-variation.md": [
		760338,
		9,
		760338
	],
	"./education-center/markdown/medical/apoe5-variant": [
		866594,
		9,
		866594
	],
	"./education-center/markdown/medical/apoe5-variant.md": [
		866594,
		9,
		866594
	],
	"./education-center/markdown/medical/apolipoprotein-ii-deficiency": [
		303592,
		9,
		303592
	],
	"./education-center/markdown/medical/apolipoprotein-ii-deficiency.md": [
		303592,
		9,
		303592
	],
	"./education-center/markdown/medical/apparent-mineralocorticoid-excess-mild": [
		334081,
		9,
		334081
	],
	"./education-center/markdown/medical/apparent-mineralocorticoid-excess-mild.md": [
		334081,
		9,
		334081
	],
	"./education-center/markdown/medical/appendicitis": [
		404403,
		9,
		404403
	],
	"./education-center/markdown/medical/appendicitis.md": [
		404403,
		9,
		404403
	],
	"./education-center/markdown/medical/appendicular-lean-mass-relative-body-height": [
		682223,
		9,
		682223
	],
	"./education-center/markdown/medical/appendicular-lean-mass-relative-body-height.md": [
		682223,
		9,
		682223
	],
	"./education-center/markdown/medical/aprt-deficiency-japanese-type": [
		508085,
		9,
		508085
	],
	"./education-center/markdown/medical/aprt-deficiency-japanese-type.md": [
		508085,
		9,
		508085
	],
	"./education-center/markdown/medical/armc9-related-joubert-syndrome": [
		71175,
		9,
		71175
	],
	"./education-center/markdown/medical/armc9-related-joubert-syndrome.md": [
		71175,
		9,
		71175
	],
	"./education-center/markdown/medical/aromatase-excess-syndrome": [
		203755,
		9,
		203755
	],
	"./education-center/markdown/medical/aromatase-excess-syndrome.md": [
		203755,
		9,
		203755
	],
	"./education-center/markdown/medical/arrhythmogenic-cardiomyopathy": [
		892627,
		9,
		892627
	],
	"./education-center/markdown/medical/arrhythmogenic-cardiomyopathy.md": [
		892627,
		9,
		892627
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-1": [
		791711,
		9,
		791711
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-1.md": [
		791711,
		9,
		791711
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-13": [
		454846,
		9,
		454846
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-13.md": [
		454846,
		9,
		454846
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-familial-11-mild-palmoplantar-keratoderma-and-woolly-hair": [
		522232,
		9,
		522232
	],
	"./education-center/markdown/medical/arrhythmogenic-right-ventricular-dysplasia-familial-11-mild-palmoplantar-keratoderma-and-woolly-hair.md": [
		522232,
		9,
		522232
	],
	"./education-center/markdown/medical/arterial-dissection": [
		549340,
		9,
		549340
	],
	"./education-center/markdown/medical/arterial-dissection.md": [
		549340,
		9,
		549340
	],
	"./education-center/markdown/medical/arterial-tortuosity": [
		151403,
		9,
		151403
	],
	"./education-center/markdown/medical/arterial-tortuosity.md": [
		151403,
		9,
		151403
	],
	"./education-center/markdown/medical/arteriohepatic-dysplasia": [
		977560,
		9,
		977560
	],
	"./education-center/markdown/medical/arteriohepatic-dysplasia.md": [
		977560,
		9,
		977560
	],
	"./education-center/markdown/medical/arteriovenous-malformation": [
		404656,
		9,
		404656
	],
	"./education-center/markdown/medical/arteriovenous-malformation.md": [
		404656,
		9,
		404656
	],
	"./education-center/markdown/medical/arthrogryposis-distal-type-1a": [
		747440,
		9,
		747440
	],
	"./education-center/markdown/medical/arthrogryposis-distal-type-1a.md": [
		747440,
		9,
		747440
	],
	"./education-center/markdown/medical/arthrogryposis-oculomotor-limitation-electroretinal-anomalies-syndrome": [
		511810,
		9,
		511810
	],
	"./education-center/markdown/medical/arthrogryposis-oculomotor-limitation-electroretinal-anomalies-syndrome.md": [
		511810,
		9,
		511810
	],
	"./education-center/markdown/medical/arthyrgryposis-distal-type-2b": [
		626512,
		9,
		626512
	],
	"./education-center/markdown/medical/arthyrgryposis-distal-type-2b.md": [
		626512,
		9,
		626512
	],
	"./education-center/markdown/medical/arv1-related-condition": [
		323591,
		9,
		323591
	],
	"./education-center/markdown/medical/arv1-related-condition.md": [
		323591,
		9,
		323591
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency": [
		669100,
		9,
		669100
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency-intermediate": [
		319921,
		9,
		319921
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency-intermediate.md": [
		319921,
		9,
		319921
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency-severe": [
		396909,
		9,
		396909
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency-severe.md": [
		396909,
		9,
		396909
	],
	"./education-center/markdown/medical/arylsulfatase-pseudodeficiency.md": [
		669100,
		9,
		669100
	],
	"./education-center/markdown/medical/ascending-aortic-dissection": [
		422107,
		9,
		422107
	],
	"./education-center/markdown/medical/ascending-aortic-dissection.md": [
		422107,
		9,
		422107
	],
	"./education-center/markdown/medical/asher": [
		166539,
		9,
		166539
	],
	"./education-center/markdown/medical/asher.md": [
		166539,
		9,
		166539
	],
	"./education-center/markdown/medical/aspartate-aminotransferase-serum-level-quantitative-trait-locus-1": [
		637150,
		9,
		637150
	],
	"./education-center/markdown/medical/aspartate-aminotransferase-serum-level-quantitative-trait-locus-1.md": [
		637150,
		9,
		637150
	],
	"./education-center/markdown/medical/aspartylglucosaminuria-finnish-type": [
		624001,
		9,
		624001
	],
	"./education-center/markdown/medical/aspartylglucosaminuria-finnish-type.md": [
		624001,
		9,
		624001
	],
	"./education-center/markdown/medical/asplenia": [
		362971,
		9,
		362971
	],
	"./education-center/markdown/medical/asplenia.md": [
		362971,
		9,
		362971
	],
	"./education-center/markdown/medical/association-systemic-lupus-erythematosus": [
		229179,
		9,
		229179
	],
	"./education-center/markdown/medical/association-systemic-lupus-erythematosus.md": [
		229179,
		9,
		229179
	],
	"./education-center/markdown/medical/asthma-and-nasal-polyps": [
		209292,
		9,
		209292
	],
	"./education-center/markdown/medical/asthma-and-nasal-polyps.md": [
		209292,
		9,
		209292
	],
	"./education-center/markdown/medical/asthma-protection-against": [
		589304,
		9,
		589304
	],
	"./education-center/markdown/medical/asthma-protection-against.md": [
		589304,
		9,
		589304
	],
	"./education-center/markdown/medical/astrocytoma-low-grade-somatic": [
		58535,
		9,
		58535
	],
	"./education-center/markdown/medical/astrocytoma-low-grade-somatic.md": [
		58535,
		9,
		58535
	],
	"./education-center/markdown/medical/ataxia-and-retinitis-pigmentosa-isolated-vitamin-e-deficiency": [
		541738,
		9,
		541738
	],
	"./education-center/markdown/medical/ataxia-and-retinitis-pigmentosa-isolated-vitamin-e-deficiency.md": [
		541738,
		9,
		541738
	],
	"./education-center/markdown/medical/ataxia-friedreich-isolated-vitamin-e-deficiency": [
		242815,
		9,
		242815
	],
	"./education-center/markdown/medical/ataxia-friedreich-isolated-vitamin-e-deficiency.md": [
		242815,
		9,
		242815
	],
	"./education-center/markdown/medical/ataxia-neuropathy-spectrum-disorders": [
		908195,
		9,
		908195
	],
	"./education-center/markdown/medical/ataxia-neuropathy-spectrum-disorders.md": [
		908195,
		9,
		908195
	],
	"./education-center/markdown/medical/ataxia-pancytopenia-syndrome": [
		361269,
		9,
		361269
	],
	"./education-center/markdown/medical/ataxia-pancytopenia-syndrome.md": [
		361269,
		9,
		361269
	],
	"./education-center/markdown/medical/ataxia-progressive-seizures-mental-deterioration-and-hearing-loss": [
		784296,
		9,
		784296
	],
	"./education-center/markdown/medical/ataxia-progressive-seizures-mental-deterioration-and-hearing-loss.md": [
		784296,
		9,
		784296
	],
	"./education-center/markdown/medical/ataxia-telangiectasia-without-immunodeficiency": [
		191790,
		9,
		191790
	],
	"./education-center/markdown/medical/ataxia-telangiectasia-without-immunodeficiency.md": [
		191790,
		9,
		191790
	],
	"./education-center/markdown/medical/atelis-syndrome-1": [
		350495,
		9,
		350495
	],
	"./education-center/markdown/medical/atelis-syndrome-1.md": [
		350495,
		9,
		350495
	],
	"./education-center/markdown/medical/atelis-syndrome-2": [
		865434,
		9,
		865434
	],
	"./education-center/markdown/medical/atelis-syndrome-2.md": [
		865434,
		9,
		865434
	],
	"./education-center/markdown/medical/atelosteogenesis": [
		164406,
		9,
		164406
	],
	"./education-center/markdown/medical/atelosteogenesis-type-i": [
		630227,
		9,
		630227
	],
	"./education-center/markdown/medical/atelosteogenesis-type-i.md": [
		630227,
		9,
		630227
	],
	"./education-center/markdown/medical/atelosteogenesis-type-iii": [
		711005,
		9,
		711005
	],
	"./education-center/markdown/medical/atelosteogenesis-type-iii.md": [
		711005,
		9,
		711005
	],
	"./education-center/markdown/medical/atelosteogenesis.md": [
		164406,
		9,
		164406
	],
	"./education-center/markdown/medical/atherosclerosis-susceptibility": [
		957037,
		9,
		957037
	],
	"./education-center/markdown/medical/atherosclerosis-susceptibility.md": [
		957037,
		9,
		957037
	],
	"./education-center/markdown/medical/atopy-resistance": [
		707999,
		9,
		707999
	],
	"./education-center/markdown/medical/atopy-resistance.md": [
		707999,
		9,
		707999
	],
	"./education-center/markdown/medical/atopy-susceptibility": [
		36825,
		9,
		36825
	],
	"./education-center/markdown/medical/atopy-susceptibility.md": [
		36825,
		9,
		36825
	],
	"./education-center/markdown/medical/atorvastatin-response": [
		822978,
		9,
		822978
	],
	"./education-center/markdown/medical/atorvastatin-response-efficacy": [
		719829,
		9,
		719829
	],
	"./education-center/markdown/medical/atorvastatin-response-efficacy.md": [
		719829,
		9,
		719829
	],
	"./education-center/markdown/medical/atorvastatin-response.md": [
		822978,
		9,
		822978
	],
	"./education-center/markdown/medical/atrial-fibrillation-somatic": [
		405805,
		9,
		405805
	],
	"./education-center/markdown/medical/atrial-fibrillation-somatic.md": [
		405805,
		9,
		405805
	],
	"./education-center/markdown/medical/atrial-septal-defect": [
		7416,
		9,
		7416
	],
	"./education-center/markdown/medical/atrial-septal-defect-1": [
		941155,
		9,
		941155
	],
	"./education-center/markdown/medical/atrial-septal-defect-1.md": [
		941155,
		9,
		941155
	],
	"./education-center/markdown/medical/atrial-septal-defect-7": [
		832808,
		9,
		832808
	],
	"./education-center/markdown/medical/atrial-septal-defect-7.md": [
		832808,
		9,
		832808
	],
	"./education-center/markdown/medical/atrial-septal-defect.md": [
		7416,
		9,
		7416
	],
	"./education-center/markdown/medical/atrial-standstill-1-digenic": [
		824712,
		9,
		824712
	],
	"./education-center/markdown/medical/atrial-standstill-1-digenic.md": [
		824712,
		9,
		824712
	],
	"./education-center/markdown/medical/atrioventricular-septal-defect-partial-heterotaxy-syndrome": [
		452667,
		9,
		452667
	],
	"./education-center/markdown/medical/atrioventricular-septal-defect-partial-heterotaxy-syndrome.md": [
		452667,
		9,
		452667
	],
	"./education-center/markdown/medical/atrioventricular-septal-defect-somatic": [
		714883,
		9,
		714883
	],
	"./education-center/markdown/medical/atrioventricular-septal-defect-somatic.md": [
		714883,
		9,
		714883
	],
	"./education-center/markdown/medical/attention-deficit-hyperactivity-disorder": [
		707593,
		9,
		707593
	],
	"./education-center/markdown/medical/attention-deficit-hyperactivity-disorder.md": [
		707593,
		9,
		707593
	],
	"./education-center/markdown/medical/atypical-behavior": [
		681386,
		9,
		681386
	],
	"./education-center/markdown/medical/atypical-behavior.md": [
		681386,
		9,
		681386
	],
	"./education-center/markdown/medical/atypical-cerebral-palsy": [
		978815,
		9,
		978815
	],
	"./education-center/markdown/medical/atypical-cerebral-palsy.md": [
		978815,
		9,
		978815
	],
	"./education-center/markdown/medical/atypical-gaucher-disease": [
		579232,
		9,
		579232
	],
	"./education-center/markdown/medical/atypical-gaucher-disease.md": [
		579232,
		9,
		579232
	],
	"./education-center/markdown/medical/auditory-neuropathy-autosomal-recessive-1": [
		545419,
		9,
		545419
	],
	"./education-center/markdown/medical/auditory-neuropathy-autosomal-recessive-1.md": [
		545419,
		9,
		545419
	],
	"./education-center/markdown/medical/auditory-neuropathy-spectrum-disorder": [
		765637,
		9,
		765637
	],
	"./education-center/markdown/medical/auditory-neuropathy-spectrum-disorder.md": [
		765637,
		9,
		765637
	],
	"./education-center/markdown/medical/auriculocondylar-syndrome": [
		726354,
		9,
		726354
	],
	"./education-center/markdown/medical/auriculocondylar-syndrome.md": [
		726354,
		9,
		726354
	],
	"./education-center/markdown/medical/autistic-behavior": [
		123473,
		9,
		123473
	],
	"./education-center/markdown/medical/autistic-behavior.md": [
		123473,
		9,
		123473
	],
	"./education-center/markdown/medical/autistic-spectrum-disorder-isolated-skills": [
		630243,
		9,
		630243
	],
	"./education-center/markdown/medical/autistic-spectrum-disorder-isolated-skills.md": [
		630243,
		9,
		630243
	],
	"./education-center/markdown/medical/autoimmune-lymphoproliferative-syndrome-type-1a": [
		258686,
		9,
		258686
	],
	"./education-center/markdown/medical/autoimmune-lymphoproliferative-syndrome-type-1a.md": [
		258686,
		9,
		258686
	],
	"./education-center/markdown/medical/autoimmune-lymphoproliferative-syndrome-type-1b": [
		502370,
		9,
		502370
	],
	"./education-center/markdown/medical/autoimmune-lymphoproliferative-syndrome-type-1b.md": [
		502370,
		9,
		502370
	],
	"./education-center/markdown/medical/autoimmune-polyglandular-syndrome-type-1-autosomal-dominant": [
		73951,
		9,
		73951
	],
	"./education-center/markdown/medical/autoimmune-polyglandular-syndrome-type-1-autosomal-dominant.md": [
		73951,
		9,
		73951
	],
	"./education-center/markdown/medical/autoimmune-polyglandular-syndrome-type-1-reversible-metaphyseal-dysplasia": [
		72956,
		9,
		72956
	],
	"./education-center/markdown/medical/autoimmune-polyglandular-syndrome-type-1-reversible-metaphyseal-dysplasia.md": [
		72956,
		9,
		72956
	],
	"./education-center/markdown/medical/autoinflammation-pulmonary-and-cutaneous-vasculitis": [
		673594,
		9,
		673594
	],
	"./education-center/markdown/medical/autoinflammation-pulmonary-and-cutaneous-vasculitis.md": [
		673594,
		9,
		673594
	],
	"./education-center/markdown/medical/autonomic-nervous-system-dysfunction": [
		346370,
		9,
		346370
	],
	"./education-center/markdown/medical/autonomic-nervous-system-dysfunction.md": [
		346370,
		9,
		346370
	],
	"./education-center/markdown/medical/autosomal-dominant-alport-syndrome": [
		788752,
		9,
		788752
	],
	"./education-center/markdown/medical/autosomal-dominant-alport-syndrome.md": [
		788752,
		9,
		788752
	],
	"./education-center/markdown/medical/autosomal-dominant-childhood-onset-proximal-spinal-muscular-atrophy-without-contractures": [
		960569,
		9,
		960569
	],
	"./education-center/markdown/medical/autosomal-dominant-childhood-onset-proximal-spinal-muscular-atrophy-without-contractures.md": [
		960569,
		9,
		960569
	],
	"./education-center/markdown/medical/autosomal-dominant-deafness-onychodystrophy-syndrome": [
		709971,
		9,
		709971
	],
	"./education-center/markdown/medical/autosomal-dominant-deafness-onychodystrophy-syndrome.md": [
		709971,
		9,
		709971
	],
	"./education-center/markdown/medical/autosomal-dominant-epilepsy": [
		711707,
		9,
		711707
	],
	"./education-center/markdown/medical/autosomal-dominant-epilepsy.md": [
		711707,
		9,
		711707
	],
	"./education-center/markdown/medical/autosomal-dominant-ichthyosis-vulgaris": [
		764856,
		9,
		764856
	],
	"./education-center/markdown/medical/autosomal-dominant-ichthyosis-vulgaris.md": [
		764856,
		9,
		764856
	],
	"./education-center/markdown/medical/autosomal-dominant-kenny-caffey-syndrome": [
		46890,
		9,
		46890
	],
	"./education-center/markdown/medical/autosomal-dominant-kenny-caffey-syndrome.md": [
		46890,
		9,
		46890
	],
	"./education-center/markdown/medical/autosomal-dominant-keratitis": [
		91430,
		9,
		91430
	],
	"./education-center/markdown/medical/autosomal-dominant-keratitis-ichthyosis-hearing-loss-syndrome": [
		965104,
		9,
		965104
	],
	"./education-center/markdown/medical/autosomal-dominant-keratitis-ichthyosis-hearing-loss-syndrome.md": [
		965104,
		9,
		965104
	],
	"./education-center/markdown/medical/autosomal-dominant-keratitis.md": [
		91430,
		9,
		91430
	],
	"./education-center/markdown/medical/autosomal-dominant-lamellar-ichthyosis": [
		344221,
		9,
		344221
	],
	"./education-center/markdown/medical/autosomal-dominant-lamellar-ichthyosis.md": [
		344221,
		9,
		344221
	],
	"./education-center/markdown/medical/autosomal-dominant-neovascular-inflammatory-vitreoretinopathy": [
		131609,
		9,
		131609
	],
	"./education-center/markdown/medical/autosomal-dominant-neovascular-inflammatory-vitreoretinopathy.md": [
		131609,
		9,
		131609
	],
	"./education-center/markdown/medical/autosomal-dominant-nonsyndromic-hearing-loss-1": [
		210767,
		9,
		210767
	],
	"./education-center/markdown/medical/autosomal-dominant-nonsyndromic-hearing-loss-1.md": [
		210767,
		9,
		210767
	],
	"./education-center/markdown/medical/autosomal-dominant-opitz-gbbb-syndrome": [
		304825,
		9,
		304825
	],
	"./education-center/markdown/medical/autosomal-dominant-opitz-gbbb-syndrome.md": [
		304825,
		9,
		304825
	],
	"./education-center/markdown/medical/autosomal-dominant-palmoplantar-keratoderma-and-congenital-alopecia": [
		541979,
		9,
		541979
	],
	"./education-center/markdown/medical/autosomal-dominant-palmoplantar-keratoderma-and-congenital-alopecia.md": [
		541979,
		9,
		541979
	],
	"./education-center/markdown/medical/autosomal-dominant-polycystic-liver-disease": [
		305466,
		9,
		305466
	],
	"./education-center/markdown/medical/autosomal-dominant-polycystic-liver-disease.md": [
		305466,
		9,
		305466
	],
	"./education-center/markdown/medical/autosomal-dominant-popliteal-pterygium-syndrome": [
		874323,
		9,
		874323
	],
	"./education-center/markdown/medical/autosomal-dominant-popliteal-pterygium-syndrome.md": [
		874323,
		9,
		874323
	],
	"./education-center/markdown/medical/autosomal-dominant-progressive-external-ophthalmoplegia": [
		981466,
		9,
		981466
	],
	"./education-center/markdown/medical/autosomal-dominant-progressive-external-ophthalmoplegia.md": [
		981466,
		9,
		981466
	],
	"./education-center/markdown/medical/autosomal-dominant-retinitis-pigmentosa": [
		461647,
		9,
		461647
	],
	"./education-center/markdown/medical/autosomal-dominant-retinitis-pigmentosa.md": [
		461647,
		9,
		461647
	],
	"./education-center/markdown/medical/autosomal-recessive-axonal-hereditary-motor-and-sensory-neuropathy": [
		69446,
		9,
		69446
	],
	"./education-center/markdown/medical/autosomal-recessive-axonal-hereditary-motor-and-sensory-neuropathy.md": [
		69446,
		9,
		69446
	],
	"./education-center/markdown/medical/autosomal-recessive-axonal-neuropathy-neuromyotonia": [
		574429,
		9,
		574429
	],
	"./education-center/markdown/medical/autosomal-recessive-axonal-neuropathy-neuromyotonia.md": [
		574429,
		9,
		574429
	],
	"./education-center/markdown/medical/autosomal-recessive-chorioretinopathy-microcephaly-syndrome": [
		523720,
		9,
		523720
	],
	"./education-center/markdown/medical/autosomal-recessive-chorioretinopathy-microcephaly-syndrome.md": [
		523720,
		9,
		523720
	],
	"./education-center/markdown/medical/autosomal-recessive-congenital-ichthyosis-5": [
		911208,
		9,
		911208
	],
	"./education-center/markdown/medical/autosomal-recessive-congenital-ichthyosis-5.md": [
		911208,
		9,
		911208
	],
	"./education-center/markdown/medical/autosomal-recessive-dejerine-sottas-syndrome": [
		257009,
		9,
		257009
	],
	"./education-center/markdown/medical/autosomal-recessive-dejerine-sottas-syndrome.md": [
		257009,
		9,
		257009
	],
	"./education-center/markdown/medical/autosomal-recessive-hearing-impairment-normal-menstrual-cycles": [
		196411,
		9,
		196411
	],
	"./education-center/markdown/medical/autosomal-recessive-hearing-impairment-normal-menstrual-cycles.md": [
		196411,
		9,
		196411
	],
	"./education-center/markdown/medical/autosomal-recessive-hypotrichosis-woolly-hair": [
		599590,
		9,
		599590
	],
	"./education-center/markdown/medical/autosomal-recessive-hypotrichosis-woolly-hair.md": [
		599590,
		9,
		599590
	],
	"./education-center/markdown/medical/autosomal-recessive-infantile-epilepsy": [
		294980,
		9,
		294980
	],
	"./education-center/markdown/medical/autosomal-recessive-infantile-epilepsy.md": [
		294980,
		9,
		294980
	],
	"./education-center/markdown/medical/autosomal-recessive-infantile-hypercalcemia": [
		715343,
		9,
		715343
	],
	"./education-center/markdown/medical/autosomal-recessive-infantile-hypercalcemia.md": [
		715343,
		9,
		715343
	],
	"./education-center/markdown/medical/autosomal-recessive-inheritance": [
		619159,
		9,
		619159
	],
	"./education-center/markdown/medical/autosomal-recessive-inheritance.md": [
		619159,
		9,
		619159
	],
	"./education-center/markdown/medical/autosomal-recessive-piezo2-associated-disease": [
		915655,
		9,
		915655
	],
	"./education-center/markdown/medical/autosomal-recessive-piezo2-associated-disease.md": [
		915655,
		9,
		915655
	],
	"./education-center/markdown/medical/autosomal-recessive-retinitis-pigmentosa": [
		595081,
		9,
		595081
	],
	"./education-center/markdown/medical/autosomal-recessive-retinitis-pigmentosa.md": [
		595081,
		9,
		595081
	],
	"./education-center/markdown/medical/autosomal-recessive-syndrome-syndactyly-undescended-testes-and-central-nervous-system-defects": [
		186660,
		9,
		186660
	],
	"./education-center/markdown/medical/autosomal-recessive-syndrome-syndactyly-undescended-testes-and-central-nervous-system-defects.md": [
		186660,
		9,
		186660
	],
	"./education-center/markdown/medical/av-block-third-degree-adverse-event": [
		719837,
		9,
		719837
	],
	"./education-center/markdown/medical/av-block-third-degree-adverse-event.md": [
		719837,
		9,
		719837
	],
	"./education-center/markdown/medical/av-junctional-rhythm": [
		584069,
		9,
		584069
	],
	"./education-center/markdown/medical/av-junctional-rhythm.md": [
		584069,
		9,
		584069
	],
	"./education-center/markdown/medical/axenfeld-rieger-anomaly-partially-absent-eye-muscles-distinctive-face-hydrocephaly-and-skeletal": [
		562424,
		9,
		562424
	],
	"./education-center/markdown/medical/axenfeld-rieger-anomaly-partially-absent-eye-muscles-distinctive-face-hydrocephaly-and-skeletal.md": [
		562424,
		9,
		562424
	],
	"./education-center/markdown/medical/axial-hypotonia": [
		348557,
		9,
		348557
	],
	"./education-center/markdown/medical/axial-hypotonia.md": [
		348557,
		9,
		348557
	],
	"./education-center/markdown/medical/axial-myopathy-late-onset": [
		136211,
		9,
		136211
	],
	"./education-center/markdown/medical/axial-myopathy-late-onset.md": [
		136211,
		9,
		136211
	],
	"./education-center/markdown/medical/axillary-odor": [
		421721,
		9,
		421721
	],
	"./education-center/markdown/medical/axillary-odor.md": [
		421721,
		9,
		421721
	],
	"./education-center/markdown/medical/azathioprine-response": [
		724989,
		9,
		724989
	],
	"./education-center/markdown/medical/azathioprine-response.md": [
		724989,
		9,
		724989
	],
	"./education-center/markdown/medical/azoospermia": [
		390,
		9,
		390
	],
	"./education-center/markdown/medical/azoospermia.md": [
		390,
		9,
		390
	],
	"./education-center/markdown/medical/azorean-disease": [
		164853,
		9,
		164853
	],
	"./education-center/markdown/medical/azorean-disease.md": [
		164853,
		9,
		164853
	],
	"./education-center/markdown/medical/b-acute-lymphoblastic-leukemia": [
		510165,
		9,
		510165
	],
	"./education-center/markdown/medical/b-acute-lymphoblastic-leukemia.md": [
		510165,
		9,
		510165
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemia-lymphoma-no-icd-o-subtype": [
		525012,
		9,
		525012
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemia-lymphoma-no-icd-o-subtype.md": [
		525012,
		9,
		525012
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemia-lymphoma-t1221p13q22-tel-aml1-etv6-runx1": [
		115918,
		9,
		115918
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemia-lymphoma-t1221p13q22-tel-aml1-etv6-runx1.md": [
		115918,
		9,
		115918
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-not-otherwise-specified": [
		521410,
		9,
		521410
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-not-otherwise-specified.md": [
		521410,
		9,
		521410
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-t922q341q112-bcr-abl1": [
		455144,
		9,
		455144
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-t922q341q112-bcr-abl1.md": [
		455144,
		9,
		455144
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-tv11q233-kmt2a-rearranged": [
		371251,
		9,
		371251
	],
	"./education-center/markdown/medical/b-lymphoblastic-leukemialymphoma-tv11q233-kmt2a-rearranged.md": [
		371251,
		9,
		371251
	],
	"./education-center/markdown/medical/bacteremia-susceptibility": [
		150666,
		9,
		150666
	],
	"./education-center/markdown/medical/bacteremia-susceptibility.md": [
		150666,
		9,
		150666
	],
	"./education-center/markdown/medical/bannayan-riley-ruvalcaba-syndrome": [
		825964,
		9,
		825964
	],
	"./education-center/markdown/medical/bannayan-riley-ruvalcaba-syndrome.md": [
		825964,
		9,
		825964
	],
	"./education-center/markdown/medical/bap1-cancer-syndrome": [
		83485,
		9,
		83485
	],
	"./education-center/markdown/medical/bap1-cancer-syndrome.md": [
		83485,
		9,
		83485
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-1-modifier": [
		488986,
		9,
		488986
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-1-modifier.md": [
		488986,
		9,
		488986
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-110-digenic": [
		98104,
		9,
		98104
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-110-digenic.md": [
		98104,
		9,
		98104
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-12-digenic": [
		42421,
		9,
		42421
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-12-digenic.md": [
		42421,
		9,
		42421
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-14-modifier": [
		978168,
		9,
		978168
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-14-modifier.md": [
		978168,
		9,
		978168
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-17-digenic": [
		747057,
		9,
		747057
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-17-digenic.md": [
		747057,
		9,
		747057
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-24-digenic": [
		955477,
		9,
		955477
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-24-digenic.md": [
		955477,
		9,
		955477
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-26-digenic": [
		402502,
		9,
		402502
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-26-digenic.md": [
		402502,
		9,
		402502
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-610-digenic": [
		118892,
		9,
		118892
	],
	"./education-center/markdown/medical/bardet-biedl-syndrome-610-digenic.md": [
		118892,
		9,
		118892
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-2-complementation-group": [
		159293,
		9,
		159293
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-2-complementation-group-e": [
		499181,
		9,
		499181
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-2-complementation-group-e.md": [
		499181,
		9,
		499181
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-2-complementation-group.md": [
		159293,
		9,
		159293
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-b": [
		688412,
		9,
		688412
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-b.md": [
		688412,
		9,
		688412
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-c": [
		454662,
		9,
		454662
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-c.md": [
		454662,
		9,
		454662
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-d": [
		765289,
		9,
		765289
	],
	"./education-center/markdown/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-d.md": [
		765289,
		9,
		765289
	],
	"./education-center/markdown/medical/barrett-esophagusesophageal-adenocarcinoma": [
		980053,
		9,
		980053
	],
	"./education-center/markdown/medical/barrett-esophagusesophageal-adenocarcinoma.md": [
		980053,
		9,
		980053
	],
	"./education-center/markdown/medical/bartter-disease-type-3": [
		424598,
		9,
		424598
	],
	"./education-center/markdown/medical/bartter-disease-type-3.md": [
		424598,
		9,
		424598
	],
	"./education-center/markdown/medical/bartter-disease-type-4b": [
		848206,
		9,
		848206
	],
	"./education-center/markdown/medical/bartter-disease-type-4b.md": [
		848206,
		9,
		848206
	],
	"./education-center/markdown/medical/bartter-syndrome-type-3-hypocalciuria": [
		325397,
		9,
		325397
	],
	"./education-center/markdown/medical/bartter-syndrome-type-3-hypocalciuria.md": [
		325397,
		9,
		325397
	],
	"./education-center/markdown/medical/basal-cell-carcinoma-somatic": [
		444489,
		9,
		444489
	],
	"./education-center/markdown/medical/basal-cell-carcinoma-somatic.md": [
		444489,
		9,
		444489
	],
	"./education-center/markdown/medical/basal-cell-nevus-syndrome-2": [
		345333,
		9,
		345333
	],
	"./education-center/markdown/medical/basal-cell-nevus-syndrome-2.md": [
		345333,
		9,
		345333
	],
	"./education-center/markdown/medical/basal-laminar-drusen": [
		733785,
		9,
		733785
	],
	"./education-center/markdown/medical/basal-laminar-drusen.md": [
		733785,
		9,
		733785
	],
	"./education-center/markdown/medical/basan-syndrome": [
		110169,
		9,
		110169
	],
	"./education-center/markdown/medical/basan-syndrome.md": [
		110169,
		9,
		110169
	],
	"./education-center/markdown/medical/bbs2-related-disorders": [
		216159,
		9,
		216159
	],
	"./education-center/markdown/medical/bbs2-related-disorders.md": [
		216159,
		9,
		216159
	],
	"./education-center/markdown/medical/bche-flouride-1": [
		917420,
		9,
		917420
	],
	"./education-center/markdown/medical/bche-flouride-1.md": [
		917420,
		9,
		917420
	],
	"./education-center/markdown/medical/bche-fluoride-2": [
		155649,
		9,
		155649
	],
	"./education-center/markdown/medical/bche-fluoride-2.md": [
		155649,
		9,
		155649
	],
	"./education-center/markdown/medical/bcs1l-related-disorders": [
		492284,
		9,
		492284
	],
	"./education-center/markdown/medical/bcs1l-related-disorders.md": [
		492284,
		9,
		492284
	],
	"./education-center/markdown/medical/beaded-hair": [
		619194,
		9,
		619194
	],
	"./education-center/markdown/medical/beaded-hair.md": [
		619194,
		9,
		619194
	],
	"./education-center/markdown/medical/beare-stevenson-cutis-gyrata-syndrome": [
		609360,
		9,
		609360
	],
	"./education-center/markdown/medical/beare-stevenson-cutis-gyrata-syndrome.md": [
		609360,
		9,
		609360
	],
	"./education-center/markdown/medical/beckwith-wiedemann-syndrome": [
		543684,
		9,
		543684
	],
	"./education-center/markdown/medical/beckwith-wiedemann-syndrome.md": [
		543684,
		9,
		543684
	],
	"./education-center/markdown/medical/behavior-disorder": [
		320988,
		9,
		320988
	],
	"./education-center/markdown/medical/behavior-disorder.md": [
		320988,
		9,
		320988
	],
	"./education-center/markdown/medical/behcet-disease": [
		270529,
		9,
		270529
	],
	"./education-center/markdown/medical/behcet-disease.md": [
		270529,
		9,
		270529
	],
	"./education-center/markdown/medical/benign-concentric-annular-macular-dystrophy": [
		482778,
		9,
		482778
	],
	"./education-center/markdown/medical/benign-concentric-annular-macular-dystrophy.md": [
		482778,
		9,
		482778
	],
	"./education-center/markdown/medical/benign-familial-hematuria": [
		672378,
		9,
		672378
	],
	"./education-center/markdown/medical/benign-familial-hematuria.md": [
		672378,
		9,
		672378
	],
	"./education-center/markdown/medical/benign-neonatal-epilepsy": [
		76470,
		9,
		76470
	],
	"./education-center/markdown/medical/benign-neonatal-epilepsy.md": [
		76470,
		9,
		76470
	],
	"./education-center/markdown/medical/benign-rolandic-epilepsy": [
		686250,
		9,
		686250
	],
	"./education-center/markdown/medical/benign-rolandic-epilepsy.md": [
		686250,
		9,
		686250
	],
	"./education-center/markdown/medical/benign-soft-tissue-neoplasm-uncertain-differentiation": [
		243746,
		9,
		243746
	],
	"./education-center/markdown/medical/benign-soft-tissue-neoplasm-uncertain-differentiation.md": [
		243746,
		9,
		243746
	],
	"./education-center/markdown/medical/bent-bone-dysplasia-syndrome-2": [
		27005,
		9,
		27005
	],
	"./education-center/markdown/medical/bent-bone-dysplasia-syndrome-2.md": [
		27005,
		9,
		27005
	],
	"./education-center/markdown/medical/benzene-toxicity-susceptibility": [
		35183,
		9,
		35183
	],
	"./education-center/markdown/medical/benzene-toxicity-susceptibility.md": [
		35183,
		9,
		35183
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-a1": [
		64534,
		9,
		64534
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-a1.md": [
		64534,
		9,
		64534
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-a2-autosomal-dominant": [
		534441,
		9,
		534441
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-a2-autosomal-dominant.md": [
		534441,
		9,
		534441
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-b": [
		596687,
		9,
		596687
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-b.md": [
		596687,
		9,
		596687
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-c": [
		855722,
		9,
		855722
	],
	"./education-center/markdown/medical/bernard-soulier-syndrome-type-c.md": [
		855722,
		9,
		855722
	],
	"./education-center/markdown/medical/best1-related-disorders": [
		89221,
		9,
		89221
	],
	"./education-center/markdown/medical/best1-related-disorders.md": [
		89221,
		9,
		89221
	],
	"./education-center/markdown/medical/beta-2-adrenoreceptor-agonist-reduced-response": [
		712182,
		9,
		712182
	],
	"./education-center/markdown/medical/beta-2-adrenoreceptor-agonist-reduced-response.md": [
		712182,
		9,
		712182
	],
	"./education-center/markdown/medical/beta-glucopyranoside-tasting": [
		171426,
		9,
		171426
	],
	"./education-center/markdown/medical/beta-glucopyranoside-tasting.md": [
		171426,
		9,
		171426
	],
	"./education-center/markdown/medical/beta-hexosaminidase-pseudodeficiency": [
		767167,
		9,
		767167
	],
	"./education-center/markdown/medical/beta-hexosaminidase-pseudodeficiency.md": [
		767167,
		9,
		767167
	],
	"./education-center/markdown/medical/beta-knossos-thalassemia": [
		675435,
		9,
		675435
	],
	"./education-center/markdown/medical/beta-knossos-thalassemia.md": [
		675435,
		9,
		675435
	],
	"./education-center/markdown/medical/beta-malay-thalassemia": [
		874057,
		9,
		874057
	],
	"./education-center/markdown/medical/beta-malay-thalassemia.md": [
		874057,
		9,
		874057
	],
	"./education-center/markdown/medical/beta-plus-thalassemia": [
		812989,
		9,
		812989
	],
	"./education-center/markdown/medical/beta-plus-thalassemia-dominant": [
		233534,
		9,
		233534
	],
	"./education-center/markdown/medical/beta-plus-thalassemia-dominant.md": [
		233534,
		9,
		233534
	],
	"./education-center/markdown/medical/beta-plus-thalassemia.md": [
		812989,
		9,
		812989
	],
	"./education-center/markdown/medical/beta-showa-yakushiji-thalassemia": [
		529469,
		9,
		529469
	],
	"./education-center/markdown/medical/beta-showa-yakushiji-thalassemia.md": [
		529469,
		9,
		529469
	],
	"./education-center/markdown/medical/beta-thalassemia-lermontov-type": [
		786738,
		9,
		786738
	],
	"./education-center/markdown/medical/beta-thalassemia-lermontov-type.md": [
		786738,
		9,
		786738
	],
	"./education-center/markdown/medical/beta-zero-thalassemia": [
		310426,
		9,
		310426
	],
	"./education-center/markdown/medical/beta-zero-thalassemia.md": [
		310426,
		9,
		310426
	],
	"./education-center/markdown/medical/bethlem-myopathy": [
		996773,
		9,
		996773
	],
	"./education-center/markdown/medical/bethlem-myopathy.md": [
		996773,
		9,
		996773
	],
	"./education-center/markdown/medical/bh4-deficient-hyperphenylalaninemia": [
		996600,
		9,
		996600
	],
	"./education-center/markdown/medical/bh4-deficient-hyperphenylalaninemia.md": [
		996600,
		9,
		996600
	],
	"./education-center/markdown/medical/bilateral-breast-cancer": [
		853532,
		9,
		853532
	],
	"./education-center/markdown/medical/bilateral-breast-cancer.md": [
		853532,
		9,
		853532
	],
	"./education-center/markdown/medical/bilateral-cleft-lip": [
		209998,
		9,
		209998
	],
	"./education-center/markdown/medical/bilateral-cleft-lip.md": [
		209998,
		9,
		209998
	],
	"./education-center/markdown/medical/bilateral-congenital-mydriasis": [
		335002,
		9,
		335002
	],
	"./education-center/markdown/medical/bilateral-congenital-mydriasis.md": [
		335002,
		9,
		335002
	],
	"./education-center/markdown/medical/bilateral-cryptorchidism": [
		833221,
		9,
		833221
	],
	"./education-center/markdown/medical/bilateral-cryptorchidism.md": [
		833221,
		9,
		833221
	],
	"./education-center/markdown/medical/bilateral-microphthalmos": [
		812180,
		9,
		812180
	],
	"./education-center/markdown/medical/bilateral-microphthalmos.md": [
		812180,
		9,
		812180
	],
	"./education-center/markdown/medical/bilateral-sensorineural-hearing-impairment": [
		563993,
		9,
		563993
	],
	"./education-center/markdown/medical/bilateral-sensorineural-hearing-impairment.md": [
		563993,
		9,
		563993
	],
	"./education-center/markdown/medical/bilirubin-serum-level-quantitative-trait-locus-1": [
		570617,
		9,
		570617
	],
	"./education-center/markdown/medical/bilirubin-serum-level-quantitative-trait-locus-1.md": [
		570617,
		9,
		570617
	],
	"./education-center/markdown/medical/birk-barel-intellectual-disability-dysmorphism-syndrome": [
		485131,
		9,
		485131
	],
	"./education-center/markdown/medical/birk-barel-intellectual-disability-dysmorphism-syndrome.md": [
		485131,
		9,
		485131
	],
	"./education-center/markdown/medical/biventricular-noncompaction-cardiomyopathy": [
		432756,
		9,
		432756
	],
	"./education-center/markdown/medical/biventricular-noncompaction-cardiomyopathy.md": [
		432756,
		9,
		432756
	],
	"./education-center/markdown/medical/bjornstad-syndrome-mild-mitochondrial-complex-iii-deficiency": [
		347505,
		9,
		347505
	],
	"./education-center/markdown/medical/bjornstad-syndrome-mild-mitochondrial-complex-iii-deficiency.md": [
		347505,
		9,
		347505
	],
	"./education-center/markdown/medical/bladder-cancer-transitional-cell-somatic": [
		194235,
		9,
		194235
	],
	"./education-center/markdown/medical/bladder-cancer-transitional-cell-somatic.md": [
		194235,
		9,
		194235
	],
	"./education-center/markdown/medical/bleeding-disorder-platelet-type-macrothrombocytopenia": [
		189828,
		9,
		189828
	],
	"./education-center/markdown/medical/bleeding-disorder-platelet-type-macrothrombocytopenia.md": [
		189828,
		9,
		189828
	],
	"./education-center/markdown/medical/blepharophimosis": [
		935661,
		9,
		935661
	],
	"./education-center/markdown/medical/blepharophimosis-ptosis-and-epicanthus-inversus-syndrome": [
		153983,
		9,
		153983
	],
	"./education-center/markdown/medical/blepharophimosis-ptosis-and-epicanthus-inversus-syndrome.md": [
		153983,
		9,
		153983
	],
	"./education-center/markdown/medical/blepharophimosis-ptosis-and-epicanthus-inversus-type-ii-duane-retraction-syndrome": [
		339122,
		9,
		339122
	],
	"./education-center/markdown/medical/blepharophimosis-ptosis-and-epicanthus-inversus-type-ii-duane-retraction-syndrome.md": [
		339122,
		9,
		339122
	],
	"./education-center/markdown/medical/blepharophimosis.md": [
		935661,
		9,
		935661
	],
	"./education-center/markdown/medical/blindness": [
		593458,
		9,
		593458
	],
	"./education-center/markdown/medical/blindness.md": [
		593458,
		9,
		593458
	],
	"./education-center/markdown/medical/blood-group-diego-system": [
		652680,
		9,
		652680
	],
	"./education-center/markdown/medical/blood-group-diego-system.md": [
		652680,
		9,
		652680
	],
	"./education-center/markdown/medical/blood-group-dombrock-system": [
		593344,
		9,
		593344
	],
	"./education-center/markdown/medical/blood-group-dombrock-system.md": [
		593344,
		9,
		593344
	],
	"./education-center/markdown/medical/blood-group-er": [
		876890,
		9,
		876890
	],
	"./education-center/markdown/medical/blood-group-er.md": [
		876890,
		9,
		876890
	],
	"./education-center/markdown/medical/blood-group-erik": [
		123570,
		9,
		123570
	],
	"./education-center/markdown/medical/blood-group-erik.md": [
		123570,
		9,
		123570
	],
	"./education-center/markdown/medical/blood-group-froese": [
		291783,
		9,
		291783
	],
	"./education-center/markdown/medical/blood-group-froese.md": [
		291783,
		9,
		291783
	],
	"./education-center/markdown/medical/blood-group-gerbich-system": [
		998273,
		9,
		998273
	],
	"./education-center/markdown/medical/blood-group-gerbich-system.md": [
		998273,
		9,
		998273
	],
	"./education-center/markdown/medical/blood-group-indian-system": [
		227045,
		9,
		227045
	],
	"./education-center/markdown/medical/blood-group-indian-system.md": [
		227045,
		9,
		227045
	],
	"./education-center/markdown/medical/blood-group-junior-system": [
		618787,
		9,
		618787
	],
	"./education-center/markdown/medical/blood-group-junior-system.md": [
		618787,
		9,
		618787
	],
	"./education-center/markdown/medical/blood-group-lutheran-inhibitor": [
		736460,
		9,
		736460
	],
	"./education-center/markdown/medical/blood-group-lutheran-inhibitor.md": [
		736460,
		9,
		736460
	],
	"./education-center/markdown/medical/blood-group-lutheran-null": [
		970833,
		9,
		970833
	],
	"./education-center/markdown/medical/blood-group-lutheran-null.md": [
		970833,
		9,
		970833
	],
	"./education-center/markdown/medical/blood-group-ok": [
		17719,
		9,
		17719
	],
	"./education-center/markdown/medical/blood-group-ok.md": [
		17719,
		9,
		17719
	],
	"./education-center/markdown/medical/blood-group-sid-system": [
		635833,
		9,
		635833
	],
	"./education-center/markdown/medical/blood-group-sid-system.md": [
		635833,
		9,
		635833
	],
	"./education-center/markdown/medical/blood-group-ss": [
		423723,
		9,
		423723
	],
	"./education-center/markdown/medical/blood-group-ss.md": [
		423723,
		9,
		423723
	],
	"./education-center/markdown/medical/blood-group-waldner-type": [
		756164,
		9,
		756164
	],
	"./education-center/markdown/medical/blood-group-waldner-type.md": [
		756164,
		9,
		756164
	],
	"./education-center/markdown/medical/blood-group-wright-antigen": [
		311554,
		9,
		311554
	],
	"./education-center/markdown/medical/blood-group-wright-antigen.md": [
		311554,
		9,
		311554
	],
	"./education-center/markdown/medical/blue-rubber-bleb-nevus": [
		502986,
		9,
		502986
	],
	"./education-center/markdown/medical/blue-rubber-bleb-nevus.md": [
		502986,
		9,
		502986
	],
	"./education-center/markdown/medical/bmp4-related-syndromic-microphthalmia": [
		544768,
		9,
		544768
	],
	"./education-center/markdown/medical/bmp4-related-syndromic-microphthalmia.md": [
		544768,
		9,
		544768
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-10": [
		409855,
		9,
		409855
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-10.md": [
		409855,
		9,
		409855
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-18": [
		226300,
		9,
		226300
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-18.md": [
		226300,
		9,
		226300
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-19": [
		564143,
		9,
		564143
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-19.md": [
		564143,
		9,
		564143
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-20": [
		458801,
		9,
		458801
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-20.md": [
		458801,
		9,
		458801
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-4": [
		694440,
		9,
		694440
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-4.md": [
		694440,
		9,
		694440
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-9": [
		947377,
		9,
		947377
	],
	"./education-center/markdown/medical/body-mass-index-quantitative-trait-locus-9.md": [
		947377,
		9,
		947377
	],
	"./education-center/markdown/medical/bombay-phenotype": [
		790029,
		9,
		790029
	],
	"./education-center/markdown/medical/bombay-phenotype-digenic": [
		100562,
		9,
		100562
	],
	"./education-center/markdown/medical/bombay-phenotype-digenic.md": [
		100562,
		9,
		100562
	],
	"./education-center/markdown/medical/bombay-phenotype.md": [
		790029,
		9,
		790029
	],
	"./education-center/markdown/medical/bone-marrow-hypocellularity": [
		113937,
		9,
		113937
	],
	"./education-center/markdown/medical/bone-marrow-hypocellularity.md": [
		113937,
		9,
		113937
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-1": [
		562765,
		9,
		562765
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-1.md": [
		562765,
		9,
		562765
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-15": [
		971073,
		9,
		971073
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-15.md": [
		971073,
		9,
		971073
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-17": [
		341672,
		9,
		341672
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-17.md": [
		341672,
		9,
		341672
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-18": [
		783917,
		9,
		783917
	],
	"./education-center/markdown/medical/bone-mineral-density-quantitative-trait-locus-18.md": [
		783917,
		9,
		783917
	],
	"./education-center/markdown/medical/bone-mineral-density-variation": [
		348785,
		9,
		348785
	],
	"./education-center/markdown/medical/bone-mineral-density-variation-quantitative-trait-locus": [
		377723,
		9,
		377723
	],
	"./education-center/markdown/medical/bone-mineral-density-variation-quantitative-trait-locus.md": [
		377723,
		9,
		377723
	],
	"./education-center/markdown/medical/bone-mineral-density-variation.md": [
		348785,
		9,
		348785
	],
	"./education-center/markdown/medical/boomerang-dysplasia": [
		800423,
		9,
		800423
	],
	"./education-center/markdown/medical/boomerang-dysplasia.md": [
		800423,
		9,
		800423
	],
	"./education-center/markdown/medical/brachydactyly-arterial-hypertension-syndrome": [
		920462,
		9,
		920462
	],
	"./education-center/markdown/medical/brachydactyly-arterial-hypertension-syndrome.md": [
		920462,
		9,
		920462
	],
	"./education-center/markdown/medical/brachydactyly-preaxial-hallux-varus-syndrome": [
		295421,
		9,
		295421
	],
	"./education-center/markdown/medical/brachydactyly-preaxial-hallux-varus-syndrome.md": [
		295421,
		9,
		295421
	],
	"./education-center/markdown/medical/brachydactyly-syndrome-type-e": [
		511250,
		9,
		464120
	],
	"./education-center/markdown/medical/brachydactyly-syndrome-type-e.md": [
		511250,
		9,
		464120
	],
	"./education-center/markdown/medical/brachydactyly-type-a1": [
		519653,
		9,
		519653
	],
	"./education-center/markdown/medical/brachydactyly-type-a1.md": [
		519653,
		9,
		519653
	],
	"./education-center/markdown/medical/brachydactyly-type-a2": [
		648878,
		9,
		648878
	],
	"./education-center/markdown/medical/brachydactyly-type-a2.md": [
		648878,
		9,
		648878
	],
	"./education-center/markdown/medical/brachydactyly-type-b1": [
		58341,
		9,
		58341
	],
	"./education-center/markdown/medical/brachydactyly-type-b1.md": [
		58341,
		9,
		58341
	],
	"./education-center/markdown/medical/brachydactyly-type-b1robinow-syndrome-autosomal-recessive": [
		555227,
		9,
		555227
	],
	"./education-center/markdown/medical/brachydactyly-type-b1robinow-syndrome-autosomal-recessive.md": [
		555227,
		9,
		555227
	],
	"./education-center/markdown/medical/brachydactyly-type-c": [
		114542,
		9,
		114542
	],
	"./education-center/markdown/medical/brachydactyly-type-c.md": [
		114542,
		9,
		114542
	],
	"./education-center/markdown/medical/brachydactyly-type-d": [
		49702,
		9,
		49702
	],
	"./education-center/markdown/medical/brachydactyly-type-d.md": [
		49702,
		9,
		49702
	],
	"./education-center/markdown/medical/brachydactyly-type-e1": [
		453046,
		9,
		453046
	],
	"./education-center/markdown/medical/brachydactyly-type-e1.md": [
		453046,
		9,
		453046
	],
	"./education-center/markdown/medical/brachyrachia-short-spine-dysplasia": [
		234926,
		9,
		234926
	],
	"./education-center/markdown/medical/brachyrachia-short-spine-dysplasia.md": [
		234926,
		9,
		234926
	],
	"./education-center/markdown/medical/braddock-carey-syndrome-2": [
		61422,
		9,
		61422
	],
	"./education-center/markdown/medical/braddock-carey-syndrome-2.md": [
		61422,
		9,
		61422
	],
	"./education-center/markdown/medical/brain-tumor-polyposis-syndrome-2": [
		520686,
		9,
		520686
	],
	"./education-center/markdown/medical/brain-tumor-polyposis-syndrome-2.md": [
		520686,
		9,
		520686
	],
	"./education-center/markdown/medical/branchiooculofacial-syndrome": [
		354460,
		9,
		354460
	],
	"./education-center/markdown/medical/branchiooculofacial-syndrome.md": [
		354460,
		9,
		354460
	],
	"./education-center/markdown/medical/branchiootorenal-spectrum-disorders": [
		605973,
		9,
		605973
	],
	"./education-center/markdown/medical/branchiootorenal-spectrum-disorders.md": [
		605973,
		9,
		605973
	],
	"./education-center/markdown/medical/branchiootorenal-syndrome-1": [
		965191,
		9,
		965191
	],
	"./education-center/markdown/medical/branchiootorenal-syndrome-1.md": [
		965191,
		9,
		965191
	],
	"./education-center/markdown/medical/branchiootorenal-syndrome-cataract": [
		517784,
		9,
		517784
	],
	"./education-center/markdown/medical/branchiootorenal-syndrome-cataract.md": [
		517784,
		9,
		517784
	],
	"./education-center/markdown/medical/brca2-related-disorders": [
		209634,
		9,
		209634
	],
	"./education-center/markdown/medical/brca2-related-disorders.md": [
		209634,
		9,
		209634
	],
	"./education-center/markdown/medical/breast-and-colorectal-cancer": [
		143237,
		9,
		143237
	],
	"./education-center/markdown/medical/breast-and-colorectal-cancer-susceptibility": [
		393022,
		9,
		393022
	],
	"./education-center/markdown/medical/breast-and-colorectal-cancer-susceptibility.md": [
		393022,
		9,
		393022
	],
	"./education-center/markdown/medical/breast-and-colorectal-cancer.md": [
		143237,
		9,
		143237
	],
	"./education-center/markdown/medical/breast-and-ovarian-cancer-susceptibility": [
		898345,
		9,
		898345
	],
	"./education-center/markdown/medical/breast-and-ovarian-cancer-susceptibility.md": [
		898345,
		9,
		898345
	],
	"./education-center/markdown/medical/breast-andor-ovarian-cancer": [
		308643,
		9,
		308643
	],
	"./education-center/markdown/medical/breast-andor-ovarian-cancer.md": [
		308643,
		9,
		308643
	],
	"./education-center/markdown/medical/breast-cancer-early-onset": [
		466523,
		9,
		466523
	],
	"./education-center/markdown/medical/breast-cancer-early-onset.md": [
		466523,
		9,
		466523
	],
	"./education-center/markdown/medical/breast-cancer-post-chemotherapy-poor-survival": [
		332553,
		9,
		332553
	],
	"./education-center/markdown/medical/breast-cancer-post-chemotherapy-poor-survival.md": [
		332553,
		9,
		332553
	],
	"./education-center/markdown/medical/breast-cancer-protection-against": [
		349114,
		9,
		349114
	],
	"./education-center/markdown/medical/breast-cancer-protection-against.md": [
		349114,
		9,
		349114
	],
	"./education-center/markdown/medical/breast-cancer-susceptibility": [
		165643,
		9,
		165643
	],
	"./education-center/markdown/medical/breast-cancer-susceptibility.md": [
		165643,
		9,
		165643
	],
	"./education-center/markdown/medical/breast-lobular-carcinoma": [
		926254,
		9,
		926254
	],
	"./education-center/markdown/medical/breast-lobular-carcinoma.md": [
		926254,
		9,
		926254
	],
	"./education-center/markdown/medical/brip1-related-disorders": [
		259976,
		9,
		259976
	],
	"./education-center/markdown/medical/brip1-related-disorders.md": [
		259976,
		9,
		259976
	],
	"./education-center/markdown/medical/british-hpfh": [
		475849,
		9,
		475849
	],
	"./education-center/markdown/medical/british-hpfh.md": [
		475849,
		9,
		475849
	],
	"./education-center/markdown/medical/broad-distal-phalanx-thumb": [
		781236,
		9,
		781236
	],
	"./education-center/markdown/medical/broad-distal-phalanx-thumb.md": [
		781236,
		9,
		781236
	],
	"./education-center/markdown/medical/bronchiectasis-or-without-elevated-sweat-chloride-1-modifier": [
		893329,
		9,
		893329
	],
	"./education-center/markdown/medical/bronchiectasis-or-without-elevated-sweat-chloride-1-modifier.md": [
		893329,
		9,
		893329
	],
	"./education-center/markdown/medical/brown-oculocutaneous-albinism": [
		936424,
		9,
		936424
	],
	"./education-center/markdown/medical/brown-oculocutaneous-albinism.md": [
		936424,
		9,
		936424
	],
	"./education-center/markdown/medical/brugada-syndrome-lidocaine-induced": [
		602325,
		9,
		602325
	],
	"./education-center/markdown/medical/brugada-syndrome-lidocaine-induced.md": [
		602325,
		9,
		602325
	],
	"./education-center/markdown/medical/brugada-syndrome-shorter-normal-qt-interval": [
		820322,
		9,
		820322
	],
	"./education-center/markdown/medical/brugada-syndrome-shorter-normal-qt-interval.md": [
		820322,
		9,
		820322
	],
	"./education-center/markdown/medical/bullous-ichthyosiform-erythroderma": [
		962449,
		9,
		962449
	],
	"./education-center/markdown/medical/bullous-ichthyosiform-erythroderma.md": [
		962449,
		9,
		962449
	],
	"./education-center/markdown/medical/bun-creatinine-ratio-high-and-low-levels-normal-range": [
		401605,
		9,
		401605
	],
	"./education-center/markdown/medical/bun-creatinine-ratio-high-and-low-levels-normal-range.md": [
		401605,
		9,
		401605
	],
	"./education-center/markdown/medical/burkitt-lymphoma": [
		720207,
		9,
		720207
	],
	"./education-center/markdown/medical/burkitt-lymphoma.md": [
		720207,
		9,
		720207
	],
	"./education-center/markdown/medical/butyrylcholinesterase-deficiency-fluoride-resistant-japanese-type": [
		87842,
		9,
		87842
	],
	"./education-center/markdown/medical/butyrylcholinesterase-deficiency-fluoride-resistant-japanese-type.md": [
		87842,
		9,
		87842
	],
	"./education-center/markdown/medical/c1q-deficiency-2": [
		215906,
		9,
		215906
	],
	"./education-center/markdown/medical/c1q-deficiency-2.md": [
		215906,
		9,
		215906
	],
	"./education-center/markdown/medical/c1q-deficiency-3": [
		982924,
		9,
		982924
	],
	"./education-center/markdown/medical/c1q-deficiency-3.md": [
		982924,
		9,
		982924
	],
	"./education-center/markdown/medical/c2-deficiency-type-i": [
		294595,
		9,
		294595
	],
	"./education-center/markdown/medical/c2-deficiency-type-i.md": [
		294595,
		9,
		294595
	],
	"./education-center/markdown/medical/c2-deficiency-type-ii": [
		911704,
		9,
		911704
	],
	"./education-center/markdown/medical/c2-deficiency-type-ii.md": [
		911704,
		9,
		911704
	],
	"./education-center/markdown/medical/c3-deficiency": [
		831018,
		9,
		831018
	],
	"./education-center/markdown/medical/c3-deficiency.md": [
		831018,
		9,
		831018
	],
	"./education-center/markdown/medical/c3hex-ability-smell": [
		829084,
		9,
		829084
	],
	"./education-center/markdown/medical/c3hex-ability-smell.md": [
		829084,
		9,
		829084
	],
	"./education-center/markdown/medical/c6-deficiency-subtotal": [
		58797,
		9,
		58797
	],
	"./education-center/markdown/medical/c6-deficiency-subtotal.md": [
		58797,
		9,
		58797
	],
	"./education-center/markdown/medical/c7-and-c6-deficiency-combined-subtotal": [
		293011,
		9,
		293011
	],
	"./education-center/markdown/medical/c7-and-c6-deficiency-combined-subtotal.md": [
		293011,
		9,
		293011
	],
	"./education-center/markdown/medical/cafe-au-lait-spot": [
		77831,
		9,
		77831
	],
	"./education-center/markdown/medical/cafe-au-lait-spot.md": [
		77831,
		9,
		77831
	],
	"./education-center/markdown/medical/cafe-au-lait-spots-multiple": [
		441592,
		9,
		441592
	],
	"./education-center/markdown/medical/cafe-au-lait-spots-multiple.md": [
		441592,
		9,
		441592
	],
	"./education-center/markdown/medical/calfan-syndrome": [
		795782,
		9,
		795782
	],
	"./education-center/markdown/medical/calfan-syndrome.md": [
		795782,
		9,
		795782
	],
	"./education-center/markdown/medical/calvarial-doughnut-lesions-bone-fragility-or-without-spondylometaphyseal-dysplasia": [
		320559,
		9,
		320559
	],
	"./education-center/markdown/medical/calvarial-doughnut-lesions-bone-fragility-or-without-spondylometaphyseal-dysplasia.md": [
		320559,
		9,
		320559
	],
	"./education-center/markdown/medical/calvarial-doughnut-lesions-bone-fragility-syndrome": [
		682378,
		9,
		682378
	],
	"./education-center/markdown/medical/calvarial-doughnut-lesions-bone-fragility-syndrome.md": [
		682378,
		9,
		682378
	],
	"./education-center/markdown/medical/campomelic-dysplasia-autosomal-sex-reversal": [
		503589,
		9,
		503589
	],
	"./education-center/markdown/medical/campomelic-dysplasia-autosomal-sex-reversal.md": [
		503589,
		9,
		503589
	],
	"./education-center/markdown/medical/camptomelic-dysplasia": [
		687883,
		9,
		687883
	],
	"./education-center/markdown/medical/camptomelic-dysplasia.md": [
		687883,
		9,
		687883
	],
	"./education-center/markdown/medical/canavan-disease-familial-form": [
		220286,
		9,
		220286
	],
	"./education-center/markdown/medical/canavan-disease-familial-form.md": [
		220286,
		9,
		220286
	],
	"./education-center/markdown/medical/cancer-alopecia-pigment-dyscrasia-onychodystrophy-and-keratoderma": [
		215143,
		9,
		215143
	],
	"./education-center/markdown/medical/cancer-alopecia-pigment-dyscrasia-onychodystrophy-and-keratoderma.md": [
		215143,
		9,
		215143
	],
	"./education-center/markdown/medical/cancer-pancreas": [
		131498,
		9,
		131498
	],
	"./education-center/markdown/medical/cancer-pancreas.md": [
		131498,
		9,
		131498
	],
	"./education-center/markdown/medical/cancer-progression-and-tumor-cell-motility": [
		214482,
		9,
		214482
	],
	"./education-center/markdown/medical/cancer-progression-and-tumor-cell-motility.md": [
		214482,
		9,
		214482
	],
	"./education-center/markdown/medical/cap-congenital-myopathy-arthrogryposis-multiplex-congenita-without-heart-involvement": [
		399300,
		9,
		399300
	],
	"./education-center/markdown/medical/cap-congenital-myopathy-arthrogryposis-multiplex-congenita-without-heart-involvement.md": [
		399300,
		9,
		399300
	],
	"./education-center/markdown/medical/capn3-related-disorders": [
		577949,
		9,
		577949
	],
	"./education-center/markdown/medical/capn3-related-disorders.md": [
		577949,
		9,
		577949
	],
	"./education-center/markdown/medical/captopril-response-efficacy": [
		661743,
		9,
		661743
	],
	"./education-center/markdown/medical/captopril-response-efficacy.md": [
		661743,
		9,
		661743
	],
	"./education-center/markdown/medical/carbamazepine-hypersensitivity": [
		83914,
		9,
		83914
	],
	"./education-center/markdown/medical/carbamazepine-hypersensitivity.md": [
		83914,
		9,
		83914
	],
	"./education-center/markdown/medical/carbamazepine-response-dosage": [
		197525,
		9,
		197525
	],
	"./education-center/markdown/medical/carbamazepine-response-dosage.md": [
		197525,
		9,
		197525
	],
	"./education-center/markdown/medical/carbonic-anhydrase-i-deficiency": [
		270562,
		9,
		270562
	],
	"./education-center/markdown/medical/carbonic-anhydrase-i-deficiency.md": [
		270562,
		9,
		270562
	],
	"./education-center/markdown/medical/carbonic-anhydrase-i-guam": [
		288527,
		9,
		288527
	],
	"./education-center/markdown/medical/carbonic-anhydrase-i-guam.md": [
		288527,
		9,
		288527
	],
	"./education-center/markdown/medical/carboxymethyl-dextran-a2-gadolinium-dota": [
		481175,
		9,
		481175
	],
	"./education-center/markdown/medical/carboxymethyl-dextran-a2-gadolinium-dota.md": [
		481175,
		9,
		481175
	],
	"./education-center/markdown/medical/carcinoma-adrenocortical-androgen-secreting": [
		421470,
		9,
		421470
	],
	"./education-center/markdown/medical/carcinoma-adrenocortical-androgen-secreting.md": [
		421470,
		9,
		421470
	],
	"./education-center/markdown/medical/carcinoma-head-pancreas": [
		200652,
		9,
		200652
	],
	"./education-center/markdown/medical/carcinoma-head-pancreas.md": [
		200652,
		9,
		200652
	],
	"./education-center/markdown/medical/carcinoma-male-breast": [
		632342,
		9,
		632342
	],
	"./education-center/markdown/medical/carcinoma-male-breast.md": [
		632342,
		9,
		632342
	],
	"./education-center/markdown/medical/cardiac-arrest": [
		300472,
		9,
		300472
	],
	"./education-center/markdown/medical/cardiac-arrest.md": [
		300472,
		9,
		300472
	],
	"./education-center/markdown/medical/cardiac-conduction-defect-nonprogressive": [
		874108,
		9,
		874108
	],
	"./education-center/markdown/medical/cardiac-conduction-defect-nonprogressive.md": [
		874108,
		9,
		874108
	],
	"./education-center/markdown/medical/cardiac-valvular-dysplasia-2": [
		140979,
		9,
		140979
	],
	"./education-center/markdown/medical/cardiac-valvular-dysplasia-2.md": [
		140979,
		9,
		140979
	],
	"./education-center/markdown/medical/cardio-cutaneous-syndrome": [
		858962,
		9,
		858962
	],
	"./education-center/markdown/medical/cardio-cutaneous-syndrome.md": [
		858962,
		9,
		858962
	],
	"./education-center/markdown/medical/cardiofaciocutaneous-syndrome-1": [
		638585,
		9,
		638585
	],
	"./education-center/markdown/medical/cardiofaciocutaneous-syndrome-1.md": [
		638585,
		9,
		638585
	],
	"./education-center/markdown/medical/cardiomyopathy-and-deafness": [
		648918,
		9,
		648918
	],
	"./education-center/markdown/medical/cardiomyopathy-and-deafness.md": [
		648918,
		9,
		648918
	],
	"./education-center/markdown/medical/cardiomyopathy-apical-hypertrophic-and-neuropathy": [
		114765,
		9,
		114765
	],
	"./education-center/markdown/medical/cardiomyopathy-apical-hypertrophic-and-neuropathy.md": [
		114765,
		9,
		114765
	],
	"./education-center/markdown/medical/cardiomyopathy-familial-restrictive-1": [
		300661,
		9,
		300661
	],
	"./education-center/markdown/medical/cardiomyopathy-familial-restrictive-1.md": [
		300661,
		9,
		300661
	],
	"./education-center/markdown/medical/cardiomyopathy-familial-restrictive-4": [
		749705,
		9,
		749705
	],
	"./education-center/markdown/medical/cardiomyopathy-familial-restrictive-4.md": [
		749705,
		9,
		749705
	],
	"./education-center/markdown/medical/cardiomyopathy-fatal": [
		536446,
		9,
		536446
	],
	"./education-center/markdown/medical/cardiomyopathy-fatal-infantile": [
		653789,
		9,
		653789
	],
	"./education-center/markdown/medical/cardiomyopathy-fatal-infantile.md": [
		653789,
		9,
		653789
	],
	"./education-center/markdown/medical/cardiomyopathy-fatal.md": [
		536446,
		9,
		536446
	],
	"./education-center/markdown/medical/cardiomyopathy-hypertrophic-midventricular-digenic": [
		253941,
		9,
		253941
	],
	"./education-center/markdown/medical/cardiomyopathy-hypertrophic-midventricular-digenic.md": [
		253941,
		9,
		253941
	],
	"./education-center/markdown/medical/cardiomyopathy-hypertrophic-mitochondrial": [
		380815,
		9,
		380815
	],
	"./education-center/markdown/medical/cardiomyopathy-hypertrophic-mitochondrial.md": [
		380815,
		9,
		380815
	],
	"./education-center/markdown/medical/cardiomyopathy-idiopathic-dilated-mitochondrial": [
		579957,
		9,
		579957
	],
	"./education-center/markdown/medical/cardiomyopathy-idiopathic-dilated-mitochondrial.md": [
		579957,
		9,
		579957
	],
	"./education-center/markdown/medical/cardiomyopathy-mitochondrial": [
		489237,
		9,
		489237
	],
	"./education-center/markdown/medical/cardiomyopathy-mitochondrial.md": [
		489237,
		9,
		489237
	],
	"./education-center/markdown/medical/cardiomyopathy-or-without-skeletal-myopathy": [
		897776,
		9,
		897776
	],
	"./education-center/markdown/medical/cardiomyopathy-or-without-skeletal-myopathy.md": [
		897776,
		9,
		897776
	],
	"./education-center/markdown/medical/cardiospondylocarpofacial-syndrome": [
		33424,
		9,
		33424
	],
	"./education-center/markdown/medical/cardiospondylocarpofacial-syndrome.md": [
		33424,
		9,
		33424
	],
	"./education-center/markdown/medical/cardiovascular-phenotype": [
		203615,
		9,
		203615
	],
	"./education-center/markdown/medical/cardiovascular-phenotype.md": [
		203615,
		9,
		203615
	],
	"./education-center/markdown/medical/carotid-intimal-medial-thickness-1": [
		203444,
		9,
		203444
	],
	"./education-center/markdown/medical/carotid-intimal-medial-thickness-1.md": [
		203444,
		9,
		203444
	],
	"./education-center/markdown/medical/carpal-osteolysis": [
		888129,
		9,
		888129
	],
	"./education-center/markdown/medical/carpal-osteolysis.md": [
		888129,
		9,
		888129
	],
	"./education-center/markdown/medical/carpal-tunnel-syndrome": [
		858227,
		9,
		858227
	],
	"./education-center/markdown/medical/carpal-tunnel-syndrome.md": [
		858227,
		9,
		858227
	],
	"./education-center/markdown/medical/cartilage-hair-hypoplasia-anauxetic-dysplasia-spectrum-disorders": [
		946889,
		9,
		946889
	],
	"./education-center/markdown/medical/cartilage-hair-hypoplasia-anauxetic-dysplasia-spectrum-disorders.md": [
		946889,
		9,
		946889
	],
	"./education-center/markdown/medical/cataract-1-multiple-types": [
		108948,
		9,
		108948
	],
	"./education-center/markdown/medical/cataract-1-multiple-types.md": [
		108948,
		9,
		108948
	],
	"./education-center/markdown/medical/cataract-11-posterior-polar": [
		710937,
		9,
		710937
	],
	"./education-center/markdown/medical/cataract-11-posterior-polar-microphthalmia-and-neurodevelopmental-abnormalities": [
		373577,
		9,
		373577
	],
	"./education-center/markdown/medical/cataract-11-posterior-polar-microphthalmia-and-neurodevelopmental-abnormalities.md": [
		373577,
		9,
		373577
	],
	"./education-center/markdown/medical/cataract-11-posterior-polar.md": [
		710937,
		9,
		710937
	],
	"./education-center/markdown/medical/cataract-13-adult-i-phenotype": [
		407433,
		9,
		407433
	],
	"./education-center/markdown/medical/cataract-13-adult-i-phenotype.md": [
		407433,
		9,
		407433
	],
	"./education-center/markdown/medical/cataract-2-coppock": [
		538854,
		9,
		538854
	],
	"./education-center/markdown/medical/cataract-2-coppock.md": [
		538854,
		9,
		538854
	],
	"./education-center/markdown/medical/cataract-20-multiple-types": [
		145730,
		9,
		145730
	],
	"./education-center/markdown/medical/cataract-20-multiple-types.md": [
		145730,
		9,
		145730
	],
	"./education-center/markdown/medical/cataract-30": [
		616354,
		9,
		616354
	],
	"./education-center/markdown/medical/cataract-30.md": [
		616354,
		9,
		616354
	],
	"./education-center/markdown/medical/cataract-33": [
		365531,
		9,
		365531
	],
	"./education-center/markdown/medical/cataract-33.md": [
		365531,
		9,
		365531
	],
	"./education-center/markdown/medical/cataract-36": [
		276036,
		9,
		276036
	],
	"./education-center/markdown/medical/cataract-36.md": [
		276036,
		9,
		276036
	],
	"./education-center/markdown/medical/cataract-38": [
		395047,
		9,
		395047
	],
	"./education-center/markdown/medical/cataract-38.md": [
		395047,
		9,
		395047
	],
	"./education-center/markdown/medical/cataract-4-multiple-types": [
		368555,
		9,
		368555
	],
	"./education-center/markdown/medical/cataract-4-multiple-types.md": [
		368555,
		9,
		368555
	],
	"./education-center/markdown/medical/cataract-41": [
		771878,
		9,
		771878
	],
	"./education-center/markdown/medical/cataract-41.md": [
		771878,
		9,
		771878
	],
	"./education-center/markdown/medical/cataract-43": [
		855136,
		9,
		855136
	],
	"./education-center/markdown/medical/cataract-43.md": [
		855136,
		9,
		855136
	],
	"./education-center/markdown/medical/cataract-5-multiple-types": [
		93307,
		9,
		93307
	],
	"./education-center/markdown/medical/cataract-5-multiple-types.md": [
		93307,
		9,
		93307
	],
	"./education-center/markdown/medical/cataract-6-age-related-cortical": [
		726639,
		9,
		726639
	],
	"./education-center/markdown/medical/cataract-6-age-related-cortical.md": [
		726639,
		9,
		726639
	],
	"./education-center/markdown/medical/cataract-6-multiple-types": [
		424578,
		9,
		424578
	],
	"./education-center/markdown/medical/cataract-6-multiple-types.md": [
		424578,
		9,
		424578
	],
	"./education-center/markdown/medical/cataract-9-autosomal-recessive": [
		346133,
		9,
		346133
	],
	"./education-center/markdown/medical/cataract-9-autosomal-recessive.md": [
		346133,
		9,
		346133
	],
	"./education-center/markdown/medical/cataract-9-multiple-types-microcornea": [
		370412,
		9,
		370412
	],
	"./education-center/markdown/medical/cataract-9-multiple-types-microcornea.md": [
		370412,
		9,
		370412
	],
	"./education-center/markdown/medical/cataracts-congenital-late-onset-corneal-dystrophy": [
		790432,
		9,
		790432
	],
	"./education-center/markdown/medical/cataracts-congenital-late-onset-corneal-dystrophy.md": [
		790432,
		9,
		790432
	],
	"./education-center/markdown/medical/cataracts-spastic-paraparesis-and-speech-delay": [
		222768,
		9,
		222768
	],
	"./education-center/markdown/medical/cataracts-spastic-paraparesis-and-speech-delay.md": [
		222768,
		9,
		222768
	],
	"./education-center/markdown/medical/caused-mutation-tafazzin-gene": [
		29460,
		9,
		29460
	],
	"./education-center/markdown/medical/caused-mutation-tafazzin-gene.md": [
		29460,
		9,
		29460
	],
	"./education-center/markdown/medical/cc2d2a-related-disorders": [
		173914,
		9,
		173914
	],
	"./education-center/markdown/medical/cc2d2a-related-disorders.md": [
		173914,
		9,
		173914
	],
	"./education-center/markdown/medical/cd99-positive-neoplastic-cells-present": [
		446014,
		9,
		446014
	],
	"./education-center/markdown/medical/cd99-positive-neoplastic-cells-present.md": [
		446014,
		9,
		446014
	],
	"./education-center/markdown/medical/cdh23-related-disorders": [
		787951,
		9,
		787951
	],
	"./education-center/markdown/medical/cdh23-related-disorders.md": [
		787951,
		9,
		787951
	],
	"./education-center/markdown/medical/central-core-disease-autosomal-recessive": [
		515211,
		9,
		515211
	],
	"./education-center/markdown/medical/central-core-disease-autosomal-recessive.md": [
		515211,
		9,
		515211
	],
	"./education-center/markdown/medical/central-core-myopathy": [
		622699,
		9,
		622699
	],
	"./education-center/markdown/medical/central-core-myopathy.md": [
		622699,
		9,
		622699
	],
	"./education-center/markdown/medical/centromeric-instability-chromosomes-19-and-16-and-immunodeficiency": [
		548497,
		9,
		548497
	],
	"./education-center/markdown/medical/centromeric-instability-chromosomes-19-and-16-and-immunodeficiency.md": [
		548497,
		9,
		548497
	],
	"./education-center/markdown/medical/centronuclear-myopathy-dominant": [
		608361,
		9,
		608361
	],
	"./education-center/markdown/medical/centronuclear-myopathy-dominant.md": [
		608361,
		9,
		608361
	],
	"./education-center/markdown/medical/cep152-related-disorders": [
		39123,
		9,
		39123
	],
	"./education-center/markdown/medical/cep152-related-disorders.md": [
		39123,
		9,
		39123
	],
	"./education-center/markdown/medical/cep290-related-disorders": [
		47147,
		9,
		47147
	],
	"./education-center/markdown/medical/cep290-related-disorders.md": [
		47147,
		9,
		47147
	],
	"./education-center/markdown/medical/cerebellar-ataxia": [
		649360,
		9,
		649360
	],
	"./education-center/markdown/medical/cerebellar-ataxia-cataract-and-diabetes-mellitus": [
		126527,
		9,
		126527
	],
	"./education-center/markdown/medical/cerebellar-ataxia-cataract-and-diabetes-mellitus.md": [
		126527,
		9,
		126527
	],
	"./education-center/markdown/medical/cerebellar-ataxia.md": [
		649360,
		9,
		649360
	],
	"./education-center/markdown/medical/cerebellar-cyst": [
		854512,
		9,
		854512
	],
	"./education-center/markdown/medical/cerebellar-cyst.md": [
		854512,
		9,
		854512
	],
	"./education-center/markdown/medical/cerebellar-medulloblastoma": [
		117455,
		9,
		117455
	],
	"./education-center/markdown/medical/cerebellar-medulloblastoma.md": [
		117455,
		9,
		117455
	],
	"./education-center/markdown/medical/cerebellar-vermis-hypoplasia": [
		534946,
		9,
		534946
	],
	"./education-center/markdown/medical/cerebellar-vermis-hypoplasia.md": [
		534946,
		9,
		534946
	],
	"./education-center/markdown/medical/cerebral-amyloid-angiopathy-prnp-related": [
		699369,
		9,
		699369
	],
	"./education-center/markdown/medical/cerebral-amyloid-angiopathy-prnp-related.md": [
		699369,
		9,
		699369
	],
	"./education-center/markdown/medical/cerebral-arteriopathy-autosomal-dominant-subcortical-infarcts-and-leukoencephalopathy-type-1": [
		325396,
		9,
		325396
	],
	"./education-center/markdown/medical/cerebral-arteriopathy-autosomal-dominant-subcortical-infarcts-and-leukoencephalopathy-type-1.md": [
		325396,
		9,
		325396
	],
	"./education-center/markdown/medical/cerebral-arteriovenous-malformation": [
		416905,
		9,
		416905
	],
	"./education-center/markdown/medical/cerebral-arteriovenous-malformation.md": [
		416905,
		9,
		416905
	],
	"./education-center/markdown/medical/cerebral-atrophy": [
		373958,
		9,
		373958
	],
	"./education-center/markdown/medical/cerebral-atrophy.md": [
		373958,
		9,
		373958
	],
	"./education-center/markdown/medical/cerebral-autosomal-dominant-arteriopathy-subcortical-infarcts-and-leukoencephalopathy": [
		143834,
		9,
		143834
	],
	"./education-center/markdown/medical/cerebral-autosomal-dominant-arteriopathy-subcortical-infarcts-and-leukoencephalopathy.md": [
		143834,
		9,
		143834
	],
	"./education-center/markdown/medical/cerebral-cavernous-malformation": [
		602328,
		9,
		602328
	],
	"./education-center/markdown/medical/cerebral-cavernous-malformation.md": [
		602328,
		9,
		602328
	],
	"./education-center/markdown/medical/cerebral-creatine-deficiency-syndrome": [
		176606,
		9,
		176606
	],
	"./education-center/markdown/medical/cerebral-creatine-deficiency-syndrome.md": [
		176606,
		9,
		176606
	],
	"./education-center/markdown/medical/cerebral-edema": [
		194978,
		9,
		194978
	],
	"./education-center/markdown/medical/cerebral-edema.md": [
		194978,
		9,
		194978
	],
	"./education-center/markdown/medical/cerebral-hemorrhage": [
		224387,
		9,
		224387
	],
	"./education-center/markdown/medical/cerebral-hemorrhage.md": [
		224387,
		9,
		224387
	],
	"./education-center/markdown/medical/cerebral-hypomyelination": [
		775958,
		9,
		775958
	],
	"./education-center/markdown/medical/cerebral-hypomyelination.md": [
		775958,
		9,
		775958
	],
	"./education-center/markdown/medical/cerebral-infarction-susceptibility": [
		329763,
		9,
		329763
	],
	"./education-center/markdown/medical/cerebral-infarction-susceptibility.md": [
		329763,
		9,
		329763
	],
	"./education-center/markdown/medical/cerebral-palsy": [
		594072,
		9,
		594072
	],
	"./education-center/markdown/medical/cerebral-palsy-spastic-quadriplegic": [
		805808,
		9,
		805808
	],
	"./education-center/markdown/medical/cerebral-palsy-spastic-quadriplegic.md": [
		805808,
		9,
		805808
	],
	"./education-center/markdown/medical/cerebral-palsy.md": [
		594072,
		9,
		594072
	],
	"./education-center/markdown/medical/cerebral-visual-impairment-and-intellectual-disability": [
		657669,
		9,
		657669
	],
	"./education-center/markdown/medical/cerebral-visual-impairment-and-intellectual-disability.md": [
		657669,
		9,
		657669
	],
	"./education-center/markdown/medical/cerebro-costo-mandibular-syndrome": [
		43976,
		9,
		43976
	],
	"./education-center/markdown/medical/cerebro-costo-mandibular-syndrome.md": [
		43976,
		9,
		43976
	],
	"./education-center/markdown/medical/ceroid-lipofuscinosis-neuronal-3-protracted": [
		74690,
		9,
		74690
	],
	"./education-center/markdown/medical/ceroid-lipofuscinosis-neuronal-3-protracted.md": [
		74690,
		9,
		74690
	],
	"./education-center/markdown/medical/cfh-related-dense-deposit-disease-membranoproliferative-glomerulonephritis-type-ii": [
		489612,
		9,
		489612
	],
	"./education-center/markdown/medical/cfh-related-dense-deposit-disease-membranoproliferative-glomerulonephritis-type-ii.md": [
		489612,
		9,
		489612
	],
	"./education-center/markdown/medical/cfh-related-disorders": [
		51494,
		9,
		51494
	],
	"./education-center/markdown/medical/cfh-related-disorders.md": [
		51494,
		9,
		51494
	],
	"./education-center/markdown/medical/cfhr5-deficiency": [
		340101,
		9,
		340101
	],
	"./education-center/markdown/medical/cfhr5-deficiency.md": [
		340101,
		9,
		340101
	],
	"./education-center/markdown/medical/cfi-related-disorders": [
		106146,
		9,
		106146
	],
	"./education-center/markdown/medical/cfi-related-disorders.md": [
		106146,
		9,
		106146
	],
	"./education-center/markdown/medical/channelopathy": [
		220217,
		9,
		220217
	],
	"./education-center/markdown/medical/channelopathy.md": [
		220217,
		9,
		220217
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-axonal-type-2p": [
		169589,
		9,
		169589
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-axonal-type-2p.md": [
		169589,
		9,
		169589
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-dominant-intermediate-b-neutropenia": [
		614138,
		9,
		614138
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-dominant-intermediate-b-neutropenia.md": [
		614138,
		9,
		614138
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1a-autosomal-recessive": [
		556512,
		9,
		556512
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1a-autosomal-recessive.md": [
		556512,
		9,
		556512
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1a-focally-folded-myelin-sheaths": [
		411647,
		9,
		411647
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1a-focally-folded-myelin-sheaths.md": [
		411647,
		9,
		411647
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1b": [
		570067,
		9,
		570067
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1b-focally-folded-myelin-sheaths": [
		445627,
		9,
		445627
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1b-focally-folded-myelin-sheaths.md": [
		445627,
		9,
		445627
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1b.md": [
		570067,
		9,
		570067
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1e": [
		257931,
		9,
		257931
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-1e.md": [
		257931,
		9,
		257931
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-2a1": [
		930487,
		9,
		930487
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-2a1.md": [
		930487,
		9,
		930487
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-4b2-early-onset-glaucoma": [
		161649,
		9,
		161649
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-4b2-early-onset-glaucoma.md": [
		161649,
		9,
		161649
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-ia": [
		46028,
		9,
		46028
	],
	"./education-center/markdown/medical/charcot-marie-tooth-disease-type-ia.md": [
		46028,
		9,
		46028
	],
	"./education-center/markdown/medical/charcot-marie-tooth-intermediate": [
		188194,
		9,
		188194
	],
	"./education-center/markdown/medical/charcot-marie-tooth-intermediate.md": [
		188194,
		9,
		188194
	],
	"./education-center/markdown/medical/charcot-marie-tooth-neuropathy-x": [
		862187,
		9,
		862187
	],
	"./education-center/markdown/medical/charcot-marie-tooth-neuropathy-x.md": [
		862187,
		9,
		862187
	],
	"./education-center/markdown/medical/charcot-marie-tooth-vocal-cord-paresis": [
		921969,
		9,
		921969
	],
	"./education-center/markdown/medical/charcot-marie-tooth-vocal-cord-paresis.md": [
		921969,
		9,
		921969
	],
	"./education-center/markdown/medical/charcot-marie-tooth-x-linked": [
		190582,
		9,
		190582
	],
	"./education-center/markdown/medical/charcot-marie-tooth-x-linked.md": [
		190582,
		9,
		190582
	],
	"./education-center/markdown/medical/chediak-higashi-syndrome-adult-type": [
		932026,
		9,
		932026
	],
	"./education-center/markdown/medical/chediak-higashi-syndrome-adult-type.md": [
		932026,
		9,
		932026
	],
	"./education-center/markdown/medical/chediak-higashi-syndrome-childhood-type": [
		6617,
		9,
		6617
	],
	"./education-center/markdown/medical/chediak-higashi-syndrome-childhood-type.md": [
		6617,
		9,
		6617
	],
	"./education-center/markdown/medical/chek2-related-cancer-susceptibility": [
		406956,
		9,
		406956
	],
	"./education-center/markdown/medical/chek2-related-cancer-susceptibility.md": [
		406956,
		9,
		406956
	],
	"./education-center/markdown/medical/chiari-malformation": [
		973076,
		9,
		973076
	],
	"./education-center/markdown/medical/chiari-malformation.md": [
		973076,
		9,
		973076
	],
	"./education-center/markdown/medical/childhood-epilepsy-centrotemporal-spikes": [
		457498,
		9,
		457498
	],
	"./education-center/markdown/medical/childhood-epilepsy-centrotemporal-spikes.md": [
		457498,
		9,
		457498
	],
	"./education-center/markdown/medical/childhood-ganglioglioma": [
		168332,
		9,
		168332
	],
	"./education-center/markdown/medical/childhood-ganglioglioma.md": [
		168332,
		9,
		168332
	],
	"./education-center/markdown/medical/childhood-hypophosphatasia": [
		399051,
		9,
		399051
	],
	"./education-center/markdown/medical/childhood-hypophosphatasia.md": [
		399051,
		9,
		399051
	],
	"./education-center/markdown/medical/childhood-myocerebrohepatopathy-spectrum": [
		544769,
		9,
		544769
	],
	"./education-center/markdown/medical/childhood-myocerebrohepatopathy-spectrum.md": [
		544769,
		9,
		544769
	],
	"./education-center/markdown/medical/childhood-onset-sensorineural-hearing-impairment": [
		721191,
		9,
		721191
	],
	"./education-center/markdown/medical/childhood-onset-sensorineural-hearing-impairment.md": [
		721191,
		9,
		721191
	],
	"./education-center/markdown/medical/chitotriosidase-deficiency": [
		647035,
		9,
		647035
	],
	"./education-center/markdown/medical/chitotriosidase-deficiency.md": [
		647035,
		9,
		647035
	],
	"./education-center/markdown/medical/chloramphenicol-resistance": [
		897617,
		9,
		897617
	],
	"./education-center/markdown/medical/chloramphenicol-resistance.md": [
		897617,
		9,
		897617
	],
	"./education-center/markdown/medical/cholestasis-intrahepatic-pregnancy-1": [
		393416,
		9,
		393416
	],
	"./education-center/markdown/medical/cholestasis-intrahepatic-pregnancy-1.md": [
		393416,
		9,
		393416
	],
	"./education-center/markdown/medical/cholesteatoma": [
		278788,
		9,
		278788
	],
	"./education-center/markdown/medical/cholesteatoma-middle-ear": [
		327551,
		9,
		327551
	],
	"./education-center/markdown/medical/cholesteatoma-middle-ear.md": [
		327551,
		9,
		327551
	],
	"./education-center/markdown/medical/cholesteatoma.md": [
		278788,
		9,
		278788
	],
	"./education-center/markdown/medical/chondrocalcinosis": [
		844591,
		9,
		844591
	],
	"./education-center/markdown/medical/chondrocalcinosis-2": [
		223360,
		9,
		223360
	],
	"./education-center/markdown/medical/chondrocalcinosis-2-sporadic": [
		178092,
		9,
		178092
	],
	"./education-center/markdown/medical/chondrocalcinosis-2-sporadic.md": [
		178092,
		9,
		178092
	],
	"./education-center/markdown/medical/chondrocalcinosis-2.md": [
		223360,
		9,
		223360
	],
	"./education-center/markdown/medical/chondrocalcinosis.md": [
		844591,
		9,
		844591
	],
	"./education-center/markdown/medical/chondrodysplasia-punctata-2-x-linked-dominant": [
		389904,
		9,
		389904
	],
	"./education-center/markdown/medical/chondrodysplasia-punctata-2-x-linked-dominant.md": [
		389904,
		9,
		389904
	],
	"./education-center/markdown/medical/chorioretinal-coloboma": [
		97553,
		9,
		97553
	],
	"./education-center/markdown/medical/chorioretinal-coloboma.md": [
		97553,
		9,
		97553
	],
	"./education-center/markdown/medical/choroidal-dystrophy": [
		754148,
		9,
		754148
	],
	"./education-center/markdown/medical/choroidal-dystrophy.md": [
		754148,
		9,
		754148
	],
	"./education-center/markdown/medical/chrna1-related-congenital-myasthenic-syndrome": [
		415637,
		9,
		415637
	],
	"./education-center/markdown/medical/chrna1-related-congenital-myasthenic-syndrome.md": [
		415637,
		9,
		415637
	],
	"./education-center/markdown/medical/chromosome-2q231-deletion-syndrome": [
		790152,
		9,
		790152
	],
	"./education-center/markdown/medical/chromosome-2q231-deletion-syndrome.md": [
		790152,
		9,
		790152
	],
	"./education-center/markdown/medical/chronic-adenoiditis": [
		701929,
		9,
		701929
	],
	"./education-center/markdown/medical/chronic-adenoiditis.md": [
		701929,
		9,
		701929
	],
	"./education-center/markdown/medical/chronic-and-progressive-ataxia": [
		755970,
		9,
		755970
	],
	"./education-center/markdown/medical/chronic-and-progressive-ataxia.md": [
		755970,
		9,
		755970
	],
	"./education-center/markdown/medical/chronic-granulomatous-disease-autosomal-due-deficiency-cyba": [
		421628,
		9,
		421628
	],
	"./education-center/markdown/medical/chronic-granulomatous-disease-autosomal-due-deficiency-cyba.md": [
		421628,
		9,
		421628
	],
	"./education-center/markdown/medical/chronic-granulomatous-disease-due-deficiency-ncf-1": [
		492345,
		9,
		492345
	],
	"./education-center/markdown/medical/chronic-granulomatous-disease-due-deficiency-ncf-1.md": [
		492345,
		9,
		492345
	],
	"./education-center/markdown/medical/chronic-lung-disease": [
		280064,
		9,
		280064
	],
	"./education-center/markdown/medical/chronic-lung-disease.md": [
		280064,
		9,
		280064
	],
	"./education-center/markdown/medical/chronic-sinusitis": [
		360732,
		9,
		360732
	],
	"./education-center/markdown/medical/chronic-sinusitis.md": [
		360732,
		9,
		360732
	],
	"./education-center/markdown/medical/cic-dux-sarcoma": [
		780290,
		9,
		780290
	],
	"./education-center/markdown/medical/cic-dux-sarcoma.md": [
		780290,
		9,
		780290
	],
	"./education-center/markdown/medical/cirrhosis-cryptogenic": [
		116607,
		9,
		116607
	],
	"./education-center/markdown/medical/cirrhosis-cryptogenic.md": [
		116607,
		9,
		116607
	],
	"./education-center/markdown/medical/cirrhosis-familial": [
		975606,
		9,
		975606
	],
	"./education-center/markdown/medical/cirrhosis-familial.md": [
		975606,
		9,
		975606
	],
	"./education-center/markdown/medical/citrullinemia-mild": [
		325325,
		9,
		325325
	],
	"./education-center/markdown/medical/citrullinemia-mild.md": [
		325325,
		9,
		325325
	],
	"./education-center/markdown/medical/classical-galactosemia-homozygous-duarte-type": [
		922448,
		9,
		922448
	],
	"./education-center/markdown/medical/classical-galactosemia-homozygous-duarte-type.md": [
		922448,
		9,
		922448
	],
	"./education-center/markdown/medical/classical-primary-microcephaly": [
		554402,
		9,
		554402
	],
	"./education-center/markdown/medical/classical-primary-microcephaly.md": [
		554402,
		9,
		554402
	],
	"./education-center/markdown/medical/clcn4-related-disorder": [
		640843,
		9,
		640843
	],
	"./education-center/markdown/medical/clcn4-related-disorder.md": [
		640843,
		9,
		640843
	],
	"./education-center/markdown/medical/cleft-lip-cleft-palate-autosomal-dominant": [
		258205,
		9,
		258205
	],
	"./education-center/markdown/medical/cleft-lip-cleft-palate-autosomal-dominant.md": [
		258205,
		9,
		258205
	],
	"./education-center/markdown/medical/cleft-palate-ankyloglossia": [
		790752,
		9,
		790752
	],
	"./education-center/markdown/medical/cleft-palate-ankyloglossia.md": [
		790752,
		9,
		790752
	],
	"./education-center/markdown/medical/cleidocranial-dysostosis": [
		686339,
		9,
		686339
	],
	"./education-center/markdown/medical/cleidocranial-dysostosis.md": [
		686339,
		9,
		686339
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-1-forme-fruste-brachydactyly": [
		830227,
		9,
		830227
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-1-forme-fruste-brachydactyly.md": [
		830227,
		9,
		830227
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-1-forme-fruste-dental-anomalies-only": [
		513650,
		9,
		513650
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-1-forme-fruste-dental-anomalies-only.md": [
		513650,
		9,
		513650
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-2": [
		308403,
		9,
		308403
	],
	"./education-center/markdown/medical/cleidocranial-dysplasia-2.md": [
		308403,
		9,
		308403
	],
	"./education-center/markdown/medical/clopidogrel-response": [
		928491,
		9,
		928491
	],
	"./education-center/markdown/medical/clopidogrel-response-efficacy": [
		133838,
		9,
		133838
	],
	"./education-center/markdown/medical/clopidogrel-response-efficacy.md": [
		133838,
		9,
		133838
	],
	"./education-center/markdown/medical/clopidogrel-response.md": [
		928491,
		9,
		928491
	],
	"./education-center/markdown/medical/clubfoot": [
		573552,
		9,
		573552
	],
	"./education-center/markdown/medical/clubfoot.md": [
		573552,
		9,
		573552
	],
	"./education-center/markdown/medical/cngb3-related-disorders": [
		126951,
		9,
		126951
	],
	"./education-center/markdown/medical/cngb3-related-disorders.md": [
		126951,
		9,
		126951
	],
	"./education-center/markdown/medical/coagulation-factor-deficiency-syndrome": [
		471480,
		9,
		471480
	],
	"./education-center/markdown/medical/coagulation-factor-deficiency-syndrome.md": [
		471480,
		9,
		471480
	],
	"./education-center/markdown/medical/cocaine-related-disorders": [
		789924,
		9,
		789924
	],
	"./education-center/markdown/medical/cocaine-related-disorders.md": [
		789924,
		9,
		789924
	],
	"./education-center/markdown/medical/coenzyme-q10-deficiency-oculomotor-apraxia-type": [
		607530,
		9,
		607530
	],
	"./education-center/markdown/medical/coenzyme-q10-deficiency-oculomotor-apraxia-type.md": [
		607530,
		9,
		607530
	],
	"./education-center/markdown/medical/coenzyme-q10-deficiency-spinocerebellar-ataxia-type": [
		248040,
		9,
		248040
	],
	"./education-center/markdown/medical/coenzyme-q10-deficiency-spinocerebellar-ataxia-type.md": [
		248040,
		9,
		248040
	],
	"./education-center/markdown/medical/coffin-siris-syndrome-1": [
		107044,
		9,
		107044
	],
	"./education-center/markdown/medical/coffin-siris-syndrome-1.md": [
		107044,
		9,
		107044
	],
	"./education-center/markdown/medical/coffin-sirisintellectual-disability": [
		335949,
		9,
		335949
	],
	"./education-center/markdown/medical/coffin-sirisintellectual-disability.md": [
		335949,
		9,
		335949
	],
	"./education-center/markdown/medical/cognitive-impairment": [
		531026,
		9,
		531026
	],
	"./education-center/markdown/medical/cognitive-impairment.md": [
		531026,
		9,
		531026
	],
	"./education-center/markdown/medical/colchicine-resistance": [
		562552,
		9,
		562552
	],
	"./education-center/markdown/medical/colchicine-resistance.md": [
		562552,
		9,
		562552
	],
	"./education-center/markdown/medical/cole-carpenter-syndrome-1": [
		162801,
		9,
		162801
	],
	"./education-center/markdown/medical/cole-carpenter-syndrome-1.md": [
		162801,
		9,
		162801
	],
	"./education-center/markdown/medical/collapse-finding": [
		695413,
		9,
		695413
	],
	"./education-center/markdown/medical/collapse-finding.md": [
		695413,
		9,
		695413
	],
	"./education-center/markdown/medical/coloboma-congenital-heart-disease-ichthyosiform-dermatosis-intellectual-disability-and-ear-anomalies": [
		726607,
		9,
		726607
	],
	"./education-center/markdown/medical/coloboma-congenital-heart-disease-ichthyosiform-dermatosis-intellectual-disability-and-ear-anomalies.md": [
		726607,
		9,
		726607
	],
	"./education-center/markdown/medical/coloboma-ocular-autosomal-dominant": [
		938614,
		9,
		938614
	],
	"./education-center/markdown/medical/coloboma-ocular-autosomal-dominant.md": [
		938614,
		9,
		938614
	],
	"./education-center/markdown/medical/coloboma-optic-nerve": [
		492034,
		9,
		492034
	],
	"./education-center/markdown/medical/coloboma-optic-nerve.md": [
		492034,
		9,
		492034
	],
	"./education-center/markdown/medical/colon-cancer-advanced": [
		220200,
		9,
		220200
	],
	"./education-center/markdown/medical/colon-cancer-advanced.md": [
		220200,
		9,
		220200
	],
	"./education-center/markdown/medical/colon-cancer-susceptibility": [
		964906,
		9,
		964906
	],
	"./education-center/markdown/medical/colon-cancer-susceptibility.md": [
		964906,
		9,
		964906
	],
	"./education-center/markdown/medical/colonic-neoplasm": [
		644677,
		9,
		644677
	],
	"./education-center/markdown/medical/colonic-neoplasm.md": [
		644677,
		9,
		644677
	],
	"./education-center/markdown/medical/color-vision-defect": [
		753405,
		9,
		753405
	],
	"./education-center/markdown/medical/color-vision-defect.md": [
		753405,
		9,
		753405
	],
	"./education-center/markdown/medical/colorectal-adenoma": [
		314933,
		9,
		314933
	],
	"./education-center/markdown/medical/colorectal-adenoma.md": [
		314933,
		9,
		314933
	],
	"./education-center/markdown/medical/colorectal-adenomatous-polyposis-autosomal-recessive-pilomatricomas": [
		451422,
		9,
		451422
	],
	"./education-center/markdown/medical/colorectal-adenomatous-polyposis-autosomal-recessive-pilomatricomas.md": [
		451422,
		9,
		451422
	],
	"./education-center/markdown/medical/colorectal-cancer": [
		2057,
		9,
		2057
	],
	"./education-center/markdown/medical/colorectal-cancer-chromosomal-instability-somatic": [
		335519,
		9,
		335519
	],
	"./education-center/markdown/medical/colorectal-cancer-chromosomal-instability-somatic.md": [
		335519,
		9,
		335519
	],
	"./education-center/markdown/medical/colorectal-cancer-early-onset": [
		321575,
		9,
		321575
	],
	"./education-center/markdown/medical/colorectal-cancer-early-onset.md": [
		321575,
		9,
		321575
	],
	"./education-center/markdown/medical/colorectal-cancer-non-polyposis": [
		635286,
		9,
		635286
	],
	"./education-center/markdown/medical/colorectal-cancer-non-polyposis.md": [
		635286,
		9,
		635286
	],
	"./education-center/markdown/medical/colorectal-cancer-protection-against": [
		726062,
		9,
		726062
	],
	"./education-center/markdown/medical/colorectal-cancer-protection-against.md": [
		726062,
		9,
		726062
	],
	"./education-center/markdown/medical/colorectal-cancer-susceptibility": [
		177058,
		9,
		177058
	],
	"./education-center/markdown/medical/colorectal-cancer-susceptibility.md": [
		177058,
		9,
		177058
	],
	"./education-center/markdown/medical/colorectal-cancer.md": [
		2057,
		9,
		2057
	],
	"./education-center/markdown/medical/colorectal-endometrial-cancer": [
		148038,
		9,
		148038
	],
	"./education-center/markdown/medical/colorectal-endometrial-cancer.md": [
		148038,
		9,
		148038
	],
	"./education-center/markdown/medical/colostrum-secretion": [
		27092,
		9,
		27092
	],
	"./education-center/markdown/medical/colostrum-secretion.md": [
		27092,
		9,
		27092
	],
	"./education-center/markdown/medical/colton-null-phenotype": [
		410178,
		9,
		410178
	],
	"./education-center/markdown/medical/colton-null-phenotype.md": [
		410178,
		9,
		410178
	],
	"./education-center/markdown/medical/combined-oxidative-phosphorylation-deficiency": [
		980412,
		9,
		980412
	],
	"./education-center/markdown/medical/combined-oxidative-phosphorylation-deficiency.md": [
		980412,
		9,
		980412
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-dominant": [
		464633,
		9,
		464633
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-dominant.md": [
		464633,
		9,
		464633
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-dominantrecessive": [
		420392,
		9,
		420392
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-dominantrecessive.md": [
		420392,
		9,
		420392
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-recessive": [
		925778,
		9,
		925778
	],
	"./education-center/markdown/medical/combined-pituitary-hormone-deficiency-recessive.md": [
		925778,
		9,
		925778
	],
	"./education-center/markdown/medical/common-variable-immune-deficiency-dominant": [
		485926,
		9,
		485926
	],
	"./education-center/markdown/medical/common-variable-immune-deficiency-dominant.md": [
		485926,
		9,
		485926
	],
	"./education-center/markdown/medical/common-variable-immune-deficiency-recessive": [
		209267,
		9,
		209267
	],
	"./education-center/markdown/medical/common-variable-immune-deficiency-recessive.md": [
		209267,
		9,
		209267
	],
	"./education-center/markdown/medical/complement-component-4-partial-deficiency-due-dysfunctional-c1-inhibitor": [
		208575,
		9,
		208575
	],
	"./education-center/markdown/medical/complement-component-4-partial-deficiency-due-dysfunctional-c1-inhibitor.md": [
		208575,
		9,
		208575
	],
	"./education-center/markdown/medical/complex-febrile-seizure": [
		780938,
		9,
		780938
	],
	"./education-center/markdown/medical/complex-febrile-seizure.md": [
		780938,
		9,
		780938
	],
	"./education-center/markdown/medical/concentric-hypertrophic-cardiomyopathy": [
		616002,
		9,
		616002
	],
	"./education-center/markdown/medical/concentric-hypertrophic-cardiomyopathy.md": [
		616002,
		9,
		616002
	],
	"./education-center/markdown/medical/cone-dystrophy": [
		123375,
		9,
		123375
	],
	"./education-center/markdown/medical/cone-dystrophy.md": [
		123375,
		9,
		123375
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-2": [
		657501,
		9,
		657501
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-2.md": [
		657501,
		9,
		657501
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-24": [
		600039,
		9,
		600039
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-24.md": [
		600039,
		9,
		600039
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-aipl1-related": [
		399078,
		9,
		399078
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-aipl1-related.md": [
		399078,
		9,
		399078
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-dominant": [
		415345,
		9,
		415345
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-dominant.md": [
		415345,
		9,
		415345
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-recessive": [
		666113,
		9,
		666113
	],
	"./education-center/markdown/medical/cone-rod-dystrophy-recessive.md": [
		666113,
		9,
		666113
	],
	"./education-center/markdown/medical/congenital-adrenal-insufficiency": [
		337464,
		9,
		337464
	],
	"./education-center/markdown/medical/congenital-adrenal-insufficiency.md": [
		337464,
		9,
		337464
	],
	"./education-center/markdown/medical/congenital-and-infantile-nephrotic-syndrome": [
		326086,
		9,
		326086
	],
	"./education-center/markdown/medical/congenital-and-infantile-nephrotic-syndrome.md": [
		326086,
		9,
		326086
	],
	"./education-center/markdown/medical/congenital-blindness": [
		591920,
		9,
		591920
	],
	"./education-center/markdown/medical/congenital-blindness.md": [
		591920,
		9,
		591920
	],
	"./education-center/markdown/medical/congenital-contractural-arachnodactyly": [
		576645,
		9,
		576645
	],
	"./education-center/markdown/medical/congenital-contractural-arachnodactyly.md": [
		576645,
		9,
		576645
	],
	"./education-center/markdown/medical/congenital-diaphragmatic-hernia": [
		175611,
		9,
		175611
	],
	"./education-center/markdown/medical/congenital-diaphragmatic-hernia.md": [
		175611,
		9,
		175611
	],
	"./education-center/markdown/medical/congenital-disorder-glycosylation-type-i": [
		272438,
		9,
		272438
	],
	"./education-center/markdown/medical/congenital-disorder-glycosylation-type-i.md": [
		272438,
		9,
		272438
	],
	"./education-center/markdown/medical/congenital-disorder-glycosylation-type-ii": [
		24428,
		9,
		24428
	],
	"./education-center/markdown/medical/congenital-disorder-glycosylation-type-ii.md": [
		24428,
		9,
		24428
	],
	"./education-center/markdown/medical/congenital-disorders-glycosylation-type-ii": [
		334103,
		9,
		334103
	],
	"./education-center/markdown/medical/congenital-disorders-glycosylation-type-ii.md": [
		334103,
		9,
		334103
	],
	"./education-center/markdown/medical/congenital-dyserythropoietic-anemia-type-iii": [
		180246,
		9,
		180246
	],
	"./education-center/markdown/medical/congenital-dyserythropoietic-anemia-type-iii.md": [
		180246,
		9,
		180246
	],
	"./education-center/markdown/medical/congenital-fibrosis-extraocular-muscles": [
		798082,
		9,
		798082
	],
	"./education-center/markdown/medical/congenital-fibrosis-extraocular-muscles.md": [
		798082,
		9,
		798082
	],
	"./education-center/markdown/medical/congenital-generalized-lipodystrophy": [
		551051,
		9,
		551051
	],
	"./education-center/markdown/medical/congenital-generalized-lipodystrophy.md": [
		551051,
		9,
		551051
	],
	"./education-center/markdown/medical/congenital-heart-defects-1-nonsyndromic-1": [
		322107,
		9,
		322107
	],
	"./education-center/markdown/medical/congenital-heart-defects-1-nonsyndromic-1.md": [
		322107,
		9,
		322107
	],
	"./education-center/markdown/medical/congenital-heart-defects-multiple-types-8-or-without-heterotaxy": [
		528307,
		9,
		528307
	],
	"./education-center/markdown/medical/congenital-heart-defects-multiple-types-8-or-without-heterotaxy.md": [
		528307,
		9,
		528307
	],
	"./education-center/markdown/medical/congenital-heart-defects-multiple-types-9": [
		737851,
		9,
		737851
	],
	"./education-center/markdown/medical/congenital-heart-defects-multiple-types-9.md": [
		737851,
		9,
		737851
	],
	"./education-center/markdown/medical/congenital-heart-disease": [
		172226,
		9,
		172226
	],
	"./education-center/markdown/medical/congenital-heart-disease-variable": [
		511787,
		9,
		511787
	],
	"./education-center/markdown/medical/congenital-heart-disease-variable.md": [
		511787,
		9,
		511787
	],
	"./education-center/markdown/medical/congenital-heart-disease.md": [
		172226,
		9,
		172226
	],
	"./education-center/markdown/medical/congenital-hemolytic-anemia": [
		251112,
		9,
		251112
	],
	"./education-center/markdown/medical/congenital-hemolytic-anemia.md": [
		251112,
		9,
		251112
	],
	"./education-center/markdown/medical/congenital-ichthyosis-skin": [
		300157,
		9,
		300157
	],
	"./education-center/markdown/medical/congenital-ichthyosis-skin.md": [
		300157,
		9,
		300157
	],
	"./education-center/markdown/medical/congenital-indifference-pain": [
		838733,
		9,
		838733
	],
	"./education-center/markdown/medical/congenital-indifference-pain.md": [
		838733,
		9,
		838733
	],
	"./education-center/markdown/medical/congenital-lactic-acidosis": [
		441243,
		9,
		441243
	],
	"./education-center/markdown/medical/congenital-lactic-acidosis.md": [
		441243,
		9,
		441243
	],
	"./education-center/markdown/medical/congenital-macrodactylia": [
		686575,
		9,
		686575
	],
	"./education-center/markdown/medical/congenital-macrodactylia.md": [
		686575,
		9,
		686575
	],
	"./education-center/markdown/medical/congenital-microvillous-atrophy": [
		869162,
		9,
		869162
	],
	"./education-center/markdown/medical/congenital-microvillous-atrophy.md": [
		869162,
		9,
		869162
	],
	"./education-center/markdown/medical/congenital-multicore-myopathy-external-ophthalmoplegia": [
		132986,
		9,
		132986
	],
	"./education-center/markdown/medical/congenital-multicore-myopathy-external-ophthalmoplegia.md": [
		132986,
		9,
		132986
	],
	"./education-center/markdown/medical/congenital-muscular-alpha-dystroglycanopathy-brain-and-eye-anomalies": [
		738240,
		9,
		738240
	],
	"./education-center/markdown/medical/congenital-muscular-alpha-dystroglycanopathy-brain-and-eye-anomalies.md": [
		738240,
		9,
		738240
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-alpha-dystroglycan-related": [
		643899,
		9,
		643899
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-alpha-dystroglycan-related.md": [
		643899,
		9,
		643899
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-chkb-related": [
		832952,
		9,
		832952
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-chkb-related.md": [
		832952,
		9,
		832952
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-due-partial-lama2-deficiency": [
		438845,
		9,
		438845
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-due-partial-lama2-deficiency.md": [
		438845,
		9,
		438845
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-itga7-related": [
		654712,
		9,
		654712
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-itga7-related.md": [
		654712,
		9,
		654712
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-lama2-related": [
		520257,
		9,
		520257
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-lama2-related.md": [
		520257,
		9,
		520257
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-rigid-spine": [
		521245,
		9,
		521245
	],
	"./education-center/markdown/medical/congenital-muscular-dystrophy-rigid-spine.md": [
		521245,
		9,
		521245
	],
	"./education-center/markdown/medical/congenital-myasthenic-syndrome-dominantrecessive": [
		838501,
		9,
		838501
	],
	"./education-center/markdown/medical/congenital-myasthenic-syndrome-dominantrecessive.md": [
		838501,
		9,
		838501
	],
	"./education-center/markdown/medical/congenital-myasthenic-syndrome-recessive": [
		597799,
		9,
		597799
	],
	"./education-center/markdown/medical/congenital-myasthenic-syndrome-recessive.md": [
		597799,
		9,
		597799
	],
	"./education-center/markdown/medical/congenital-myopathy-10b-mild-variant": [
		683094,
		9,
		683094
	],
	"./education-center/markdown/medical/congenital-myopathy-10b-mild-variant.md": [
		683094,
		9,
		683094
	],
	"./education-center/markdown/medical/congenital-myopathy-20": [
		817957,
		9,
		817957
	],
	"./education-center/markdown/medical/congenital-myopathy-20.md": [
		817957,
		9,
		817957
	],
	"./education-center/markdown/medical/congenital-myopathy-21-early-respiratory-failure": [
		524387,
		9,
		524387
	],
	"./education-center/markdown/medical/congenital-myopathy-21-early-respiratory-failure.md": [
		524387,
		9,
		524387
	],
	"./education-center/markdown/medical/congenital-myopathy-2b-severe-infantile-autosomal-recessive": [
		407804,
		9,
		407804
	],
	"./education-center/markdown/medical/congenital-myopathy-2b-severe-infantile-autosomal-recessive.md": [
		407804,
		9,
		407804
	],
	"./education-center/markdown/medical/congenital-myopathy-2c-severe-infantile-autosomal-dominant": [
		885155,
		9,
		885155
	],
	"./education-center/markdown/medical/congenital-myopathy-2c-severe-infantile-autosomal-dominant.md": [
		885155,
		9,
		885155
	],
	"./education-center/markdown/medical/congenital-myopathy-fiber-type-disproportion": [
		164018,
		9,
		164018
	],
	"./education-center/markdown/medical/congenital-myopathy-fiber-type-disproportion.md": [
		164018,
		9,
		164018
	],
	"./education-center/markdown/medical/congenital-myotonia-autosomal-dominant-form": [
		127720,
		9,
		127720
	],
	"./education-center/markdown/medical/congenital-myotonia-autosomal-dominant-form.md": [
		127720,
		9,
		127720
	],
	"./education-center/markdown/medical/congenital-nad-deficiency-disorder": [
		943065,
		9,
		943065
	],
	"./education-center/markdown/medical/congenital-nad-deficiency-disorder.md": [
		943065,
		9,
		943065
	],
	"./education-center/markdown/medical/congenital-neutropenia": [
		866729,
		9,
		866729
	],
	"./education-center/markdown/medical/congenital-neutropenia.md": [
		866729,
		9,
		866729
	],
	"./education-center/markdown/medical/congenital-nystagmus": [
		337931,
		9,
		337931
	],
	"./education-center/markdown/medical/congenital-nystagmus.md": [
		337931,
		9,
		337931
	],
	"./education-center/markdown/medical/congenital-ocular-coloboma": [
		947444,
		9,
		947444
	],
	"./education-center/markdown/medical/congenital-ocular-coloboma.md": [
		947444,
		9,
		947444
	],
	"./education-center/markdown/medical/congenital-pontocerebellar-hypoplasia": [
		617640,
		9,
		617640
	],
	"./education-center/markdown/medical/congenital-pontocerebellar-hypoplasia.md": [
		617640,
		9,
		617640
	],
	"./education-center/markdown/medical/congenital-scoliosis": [
		738099,
		9,
		738099
	],
	"./education-center/markdown/medical/congenital-scoliosis.md": [
		738099,
		9,
		738099
	],
	"./education-center/markdown/medical/congenital-sensorineural-hearing-impairment": [
		696341,
		9,
		696341
	],
	"./education-center/markdown/medical/congenital-sensorineural-hearing-impairment.md": [
		696341,
		9,
		696341
	],
	"./education-center/markdown/medical/congenital-short-bowel-syndrome-x-linked": [
		568212,
		9,
		568212
	],
	"./education-center/markdown/medical/congenital-short-bowel-syndrome-x-linked.md": [
		568212,
		9,
		568212
	],
	"./education-center/markdown/medical/congenital-stationary-night-blindness-dominant": [
		154862,
		9,
		154862
	],
	"./education-center/markdown/medical/congenital-stationary-night-blindness-dominant.md": [
		154862,
		9,
		154862
	],
	"./education-center/markdown/medical/congenital-stationary-night-blindness-recessive": [
		268225,
		9,
		268225
	],
	"./education-center/markdown/medical/congenital-stationary-night-blindness-recessive.md": [
		268225,
		9,
		268225
	],
	"./education-center/markdown/medical/congenital-total-pulmonary-venous-return-anomaly": [
		194160,
		9,
		194160
	],
	"./education-center/markdown/medical/congenital-total-pulmonary-venous-return-anomaly.md": [
		194160,
		9,
		194160
	],
	"./education-center/markdown/medical/congestive-heart-failure-and-beta-blocker-response-modifier": [
		420613,
		9,
		420613
	],
	"./education-center/markdown/medical/congestive-heart-failure-and-beta-blocker-response-modifier.md": [
		420613,
		9,
		420613
	],
	"./education-center/markdown/medical/conotruncal-anomaly-face-syndrome": [
		23516,
		9,
		23516
	],
	"./education-center/markdown/medical/conotruncal-anomaly-face-syndrome.md": [
		23516,
		9,
		23516
	],
	"./education-center/markdown/medical/conotruncal-defect": [
		700238,
		9,
		700238
	],
	"./education-center/markdown/medical/conotruncal-defect.md": [
		700238,
		9,
		700238
	],
	"./education-center/markdown/medical/conspicuously-happy-disposition": [
		403678,
		9,
		403678
	],
	"./education-center/markdown/medical/conspicuously-happy-disposition.md": [
		403678,
		9,
		403678
	],
	"./education-center/markdown/medical/coproporphyria": [
		800871,
		9,
		800871
	],
	"./education-center/markdown/medical/coproporphyria-digenic": [
		407693,
		9,
		407693
	],
	"./education-center/markdown/medical/coproporphyria-digenic.md": [
		407693,
		9,
		407693
	],
	"./education-center/markdown/medical/coproporphyria.md": [
		800871,
		9,
		800871
	],
	"./education-center/markdown/medical/corneal-dystrophy-dominant": [
		129123,
		9,
		129123
	],
	"./education-center/markdown/medical/corneal-dystrophy-dominant.md": [
		129123,
		9,
		129123
	],
	"./education-center/markdown/medical/corneal-dystrophy-dominantrecessive": [
		463300,
		9,
		463300
	],
	"./education-center/markdown/medical/corneal-dystrophy-dominantrecessive.md": [
		463300,
		9,
		463300
	],
	"./education-center/markdown/medical/corneal-dystrophy-fuchs-endothelial-1": [
		555689,
		9,
		555689
	],
	"./education-center/markdown/medical/corneal-dystrophy-fuchs-endothelial-1.md": [
		555689,
		9,
		555689
	],
	"./education-center/markdown/medical/corneal-dystrophy-punctiform-and-polychromatic-pre-descemet": [
		305657,
		9,
		305657
	],
	"./education-center/markdown/medical/corneal-dystrophy-punctiform-and-polychromatic-pre-descemet.md": [
		305657,
		9,
		305657
	],
	"./education-center/markdown/medical/corneal-dystrophy-recessive": [
		307235,
		9,
		307235
	],
	"./education-center/markdown/medical/corneal-dystrophy-recessive.md": [
		307235,
		9,
		307235
	],
	"./education-center/markdown/medical/corneal-intraepithelial-dyskeratosis-palmoplantar-hyperkeratosis-laryngeal-dyskeratosis-syndrome": [
		619185,
		9,
		619185
	],
	"./education-center/markdown/medical/corneal-intraepithelial-dyskeratosis-palmoplantar-hyperkeratosis-laryngeal-dyskeratosis-syndrome.md": [
		619185,
		9,
		619185
	],
	"./education-center/markdown/medical/cornelia-de-lange-syndrome-1": [
		223048,
		9,
		223048
	],
	"./education-center/markdown/medical/cornelia-de-lange-syndrome-1.md": [
		223048,
		9,
		223048
	],
	"./education-center/markdown/medical/coronal-craniosynostosis": [
		48567,
		9,
		48567
	],
	"./education-center/markdown/medical/coronal-craniosynostosis.md": [
		48567,
		9,
		48567
	],
	"./education-center/markdown/medical/coronary-artery-disease-development-hiv": [
		439611,
		9,
		439611
	],
	"./education-center/markdown/medical/coronary-artery-disease-development-hiv.md": [
		439611,
		9,
		439611
	],
	"./education-center/markdown/medical/coronary-artery-disease-modifier": [
		746821,
		9,
		746821
	],
	"./education-center/markdown/medical/coronary-artery-disease-modifier.md": [
		746821,
		9,
		746821
	],
	"./education-center/markdown/medical/coronary-artery-disease-susceptibility": [
		178402,
		9,
		178402
	],
	"./education-center/markdown/medical/coronary-artery-disease-susceptibility.md": [
		178402,
		9,
		178402
	],
	"./education-center/markdown/medical/coronary-artery-spasm-1-susceptibility": [
		136473,
		9,
		136473
	],
	"./education-center/markdown/medical/coronary-artery-spasm-1-susceptibility.md": [
		136473,
		9,
		136473
	],
	"./education-center/markdown/medical/coronary-artery-spasm-2-susceptibility": [
		211852,
		9,
		211852
	],
	"./education-center/markdown/medical/coronary-artery-spasm-2-susceptibility.md": [
		211852,
		9,
		211852
	],
	"./education-center/markdown/medical/coronary-artery-spasm-3-susceptibility": [
		989612,
		9,
		989612
	],
	"./education-center/markdown/medical/coronary-artery-spasm-3-susceptibility.md": [
		989612,
		9,
		989612
	],
	"./education-center/markdown/medical/coronary-heart-disease-familial-hypercholesterolemia-protection-against": [
		378109,
		9,
		378109
	],
	"./education-center/markdown/medical/coronary-heart-disease-familial-hypercholesterolemia-protection-against.md": [
		378109,
		9,
		378109
	],
	"./education-center/markdown/medical/coronary-sclerosis-medial-infancy": [
		767725,
		9,
		767725
	],
	"./education-center/markdown/medical/coronary-sclerosis-medial-infancy.md": [
		767725,
		9,
		767725
	],
	"./education-center/markdown/medical/cortical-dysplasia-complex-other-brain-malformations-12": [
		734235,
		9,
		734235
	],
	"./education-center/markdown/medical/cortical-dysplasia-complex-other-brain-malformations-12.md": [
		734235,
		9,
		734235
	],
	"./education-center/markdown/medical/cortical-pulverulent-cataract": [
		885788,
		9,
		885788
	],
	"./education-center/markdown/medical/cortical-pulverulent-cataract.md": [
		885788,
		9,
		885788
	],
	"./education-center/markdown/medical/cortical-tubers": [
		321297,
		9,
		321297
	],
	"./education-center/markdown/medical/cortical-tubers.md": [
		321297,
		9,
		321297
	],
	"./education-center/markdown/medical/costello-syndrome-severe": [
		783964,
		9,
		783964
	],
	"./education-center/markdown/medical/costello-syndrome-severe.md": [
		783964,
		9,
		783964
	],
	"./education-center/markdown/medical/cowden-syndrome-1": [
		437921,
		9,
		437921
	],
	"./education-center/markdown/medical/cowden-syndrome-1.md": [
		437921,
		9,
		437921
	],
	"./education-center/markdown/medical/coxopodopatellar-syndrome": [
		973848,
		9,
		973848
	],
	"./education-center/markdown/medical/coxopodopatellar-syndrome.md": [
		973848,
		9,
		973848
	],
	"./education-center/markdown/medical/craniofacial-deafness-hand-syndrome": [
		759241,
		9,
		759241
	],
	"./education-center/markdown/medical/craniofacial-deafness-hand-syndrome.md": [
		759241,
		9,
		759241
	],
	"./education-center/markdown/medical/craniofacial-dysmorphism-skeletal-anomalies-and-impaired-intellectual-development-syndrome-2": [
		537392,
		9,
		537392
	],
	"./education-center/markdown/medical/craniofacial-dysmorphism-skeletal-anomalies-and-impaired-intellectual-development-syndrome-2.md": [
		537392,
		9,
		537392
	],
	"./education-center/markdown/medical/craniofacial-skeletal-dermatologic-dysplasia": [
		74680,
		9,
		74680
	],
	"./education-center/markdown/medical/craniofacial-skeletal-dermatologic-dysplasia.md": [
		74680,
		9,
		74680
	],
	"./education-center/markdown/medical/craniometaphyseal-dysplasia-autosomal-dominant": [
		874408,
		9,
		874408
	],
	"./education-center/markdown/medical/craniometaphyseal-dysplasia-autosomal-dominant.md": [
		874408,
		9,
		874408
	],
	"./education-center/markdown/medical/craniosynostosis-7-susceptibility": [
		545498,
		9,
		545498
	],
	"./education-center/markdown/medical/craniosynostosis-7-susceptibility.md": [
		545498,
		9,
		545498
	],
	"./education-center/markdown/medical/craniosynostosis-nonclassifiable-autosomal-dominant": [
		211526,
		9,
		211526
	],
	"./education-center/markdown/medical/craniosynostosis-nonclassifiable-autosomal-dominant.md": [
		211526,
		9,
		211526
	],
	"./education-center/markdown/medical/craniosynostosis-nonspecific": [
		509292,
		9,
		509292
	],
	"./education-center/markdown/medical/craniosynostosis-nonspecific.md": [
		509292,
		9,
		509292
	],
	"./education-center/markdown/medical/craniosynostosis-nonsyndromic-unicoronal": [
		74549,
		9,
		74549
	],
	"./education-center/markdown/medical/craniosynostosis-nonsyndromic-unicoronal.md": [
		74549,
		9,
		74549
	],
	"./education-center/markdown/medical/craniotubular-dysplasia-ikegawa-type": [
		478124,
		9,
		478124
	],
	"./education-center/markdown/medical/craniotubular-dysplasia-ikegawa-type.md": [
		478124,
		9,
		478124
	],
	"./education-center/markdown/medical/cranium-bifidum-occultum": [
		781743,
		9,
		781743
	],
	"./education-center/markdown/medical/cranium-bifidum-occultum.md": [
		781743,
		9,
		781743
	],
	"./education-center/markdown/medical/crohn-disease-associated-growth-failure-susceptibility": [
		712324,
		9,
		712324
	],
	"./education-center/markdown/medical/crohn-disease-associated-growth-failure-susceptibility.md": [
		712324,
		9,
		712324
	],
	"./education-center/markdown/medical/crohn-disease-association": [
		111031,
		9,
		111031
	],
	"./education-center/markdown/medical/crohn-disease-association.md": [
		111031,
		9,
		111031
	],
	"./education-center/markdown/medical/cromer-blood-group-system": [
		968633,
		9,
		968633
	],
	"./education-center/markdown/medical/cromer-blood-group-system.md": [
		968633,
		9,
		968633
	],
	"./education-center/markdown/medical/crouzon-syndrome": [
		157726,
		9,
		157726
	],
	"./education-center/markdown/medical/crouzon-syndrome.md": [
		157726,
		9,
		157726
	],
	"./education-center/markdown/medical/cryptozoospermia": [
		105416,
		9,
		105416
	],
	"./education-center/markdown/medical/cryptozoospermia.md": [
		105416,
		9,
		105416
	],
	"./education-center/markdown/medical/ctsc-related-disorders": [
		609651,
		9,
		609651
	],
	"./education-center/markdown/medical/ctsc-related-disorders.md": [
		609651,
		9,
		609651
	],
	"./education-center/markdown/medical/cutaneous-malignant-melanoma-dominant": [
		551425,
		9,
		551425
	],
	"./education-center/markdown/medical/cutaneous-malignant-melanoma-dominant.md": [
		551425,
		9,
		551425
	],
	"./education-center/markdown/medical/cutis-laxa-autosomal-dominant-1": [
		253526,
		9,
		253526
	],
	"./education-center/markdown/medical/cutis-laxa-autosomal-dominant-1.md": [
		253526,
		9,
		253526
	],
	"./education-center/markdown/medical/cutis-laxa-dominantrecessive": [
		499987,
		9,
		499987
	],
	"./education-center/markdown/medical/cutis-laxa-dominantrecessive.md": [
		499987,
		9,
		499987
	],
	"./education-center/markdown/medical/cyp1b1-related-disorders": [
		553442,
		9,
		553442
	],
	"./education-center/markdown/medical/cyp1b1-related-disorders.md": [
		553442,
		9,
		553442
	],
	"./education-center/markdown/medical/cystathioninuria": [
		335497,
		9,
		335497
	],
	"./education-center/markdown/medical/cystathioninuria.md": [
		335497,
		9,
		335497
	],
	"./education-center/markdown/medical/cystic-parathyroid-adenoma": [
		933401,
		9,
		933401
	],
	"./education-center/markdown/medical/cystic-parathyroid-adenoma.md": [
		933401,
		9,
		933401
	],
	"./education-center/markdown/medical/cystine-urolithiasis": [
		10946,
		9,
		10946
	],
	"./education-center/markdown/medical/cystine-urolithiasis.md": [
		10946,
		9,
		10946
	],
	"./education-center/markdown/medical/cystinosis-atypical-nephropathic": [
		181586,
		9,
		181586
	],
	"./education-center/markdown/medical/cystinosis-atypical-nephropathic.md": [
		181586,
		9,
		181586
	],
	"./education-center/markdown/medical/dabrafenib-response": [
		558313,
		9,
		558313
	],
	"./education-center/markdown/medical/dabrafenib-response.md": [
		558313,
		9,
		558313
	],
	"./education-center/markdown/medical/darier-disease-acral-hemorrhagic-type": [
		881092,
		9,
		881092
	],
	"./education-center/markdown/medical/darier-disease-acral-hemorrhagic-type.md": [
		881092,
		9,
		881092
	],
	"./education-center/markdown/medical/darier-disease-segmental": [
		711217,
		9,
		711217
	],
	"./education-center/markdown/medical/darier-disease-segmental.md": [
		711217,
		9,
		711217
	],
	"./education-center/markdown/medical/deafness-autosomal-dominant-nonsyndromic-sensorineural-39-dentinogenesis-imperfecta-1": [
		393944,
		9,
		393944
	],
	"./education-center/markdown/medical/deafness-autosomal-dominant-nonsyndromic-sensorineural-39-dentinogenesis-imperfecta-1.md": [
		393944,
		9,
		393944
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-12-modifier": [
		37161,
		9,
		37161
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-12-modifier.md": [
		37161,
		9,
		37161
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-26-modifier": [
		278527,
		9,
		278527
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-26-modifier.md": [
		278527,
		9,
		278527
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-36-without-vestibular-involvement": [
		164399,
		9,
		164399
	],
	"./education-center/markdown/medical/deafness-autosomal-recessive-36-without-vestibular-involvement.md": [
		164399,
		9,
		164399
	],
	"./education-center/markdown/medical/deafness-digenic-gjb2gjb3": [
		545746,
		9,
		545746
	],
	"./education-center/markdown/medical/deafness-digenic-gjb2gjb3.md": [
		545746,
		9,
		545746
	],
	"./education-center/markdown/medical/deafness-digenic-gjb2gjb6": [
		151541,
		9,
		151541
	],
	"./education-center/markdown/medical/deafness-digenic-gjb2gjb6.md": [
		151541,
		9,
		151541
	],
	"./education-center/markdown/medical/deafness-mitochondrial-modifier": [
		337756,
		9,
		337756
	],
	"./education-center/markdown/medical/deafness-mitochondrial-modifier.md": [
		337756,
		9,
		337756
	],
	"./education-center/markdown/medical/deafness-neurosensory-autosomal-recessive-21": [
		157279,
		9,
		157279
	],
	"./education-center/markdown/medical/deafness-neurosensory-autosomal-recessive-21.md": [
		157279,
		9,
		157279
	],
	"./education-center/markdown/medical/deafness-sensorineural-neurologic-features": [
		261453,
		9,
		261453
	],
	"./education-center/markdown/medical/deafness-sensorineural-neurologic-features.md": [
		261453,
		9,
		261453
	],
	"./education-center/markdown/medical/deafness-smith-magenis-syndrome": [
		478300,
		9,
		478300
	],
	"./education-center/markdown/medical/deafness-smith-magenis-syndrome.md": [
		478300,
		9,
		478300
	],
	"./education-center/markdown/medical/deafness-without-vestibular-involvement-autosomal-dominant": [
		980291,
		9,
		980291
	],
	"./education-center/markdown/medical/deafness-without-vestibular-involvement-autosomal-dominant.md": [
		980291,
		9,
		980291
	],
	"./education-center/markdown/medical/deafness-x-linked-5": [
		763806,
		9,
		763806
	],
	"./education-center/markdown/medical/deafness-x-linked-5.md": [
		763806,
		9,
		763806
	],
	"./education-center/markdown/medical/death-early-adulthood": [
		274989,
		9,
		274989
	],
	"./education-center/markdown/medical/death-early-adulthood.md": [
		274989,
		9,
		274989
	],
	"./education-center/markdown/medical/death-infancy": [
		16610,
		9,
		16610
	],
	"./education-center/markdown/medical/death-infancy.md": [
		16610,
		9,
		16610
	],
	"./education-center/markdown/medical/debrisoquine-poor-metabolism": [
		632136,
		9,
		632136
	],
	"./education-center/markdown/medical/debrisoquine-poor-metabolism.md": [
		632136,
		9,
		632136
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-atp-synthase-complex": [
		452269,
		9,
		452269
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-atp-synthase-complex.md": [
		452269,
		9,
		452269
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-complex-iii": [
		7982,
		9,
		582966
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-complex-iii.md": [
		7982,
		9,
		582966
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-complex-iv": [
		121598,
		9,
		121598
	],
	"./education-center/markdown/medical/decreased-activity-mitochondrial-complex-iv.md": [
		121598,
		9,
		121598
	],
	"./education-center/markdown/medical/decreased-activity-pyruvate-dehydrogenase-complex": [
		468201,
		9,
		468201
	],
	"./education-center/markdown/medical/decreased-activity-pyruvate-dehydrogenase-complex.md": [
		468201,
		9,
		468201
	],
	"./education-center/markdown/medical/decreased-blood-alpha-hydroxyisovalerate-levels": [
		849031,
		9,
		849031
	],
	"./education-center/markdown/medical/decreased-blood-alpha-hydroxyisovalerate-levels.md": [
		849031,
		9,
		849031
	],
	"./education-center/markdown/medical/decreased-circulating-antibody-level": [
		737610,
		9,
		737610
	],
	"./education-center/markdown/medical/decreased-circulating-antibody-level.md": [
		737610,
		9,
		737610
	],
	"./education-center/markdown/medical/decreased-circulating-igg2-level": [
		19645,
		9,
		19645
	],
	"./education-center/markdown/medical/decreased-circulating-igg2-level.md": [
		19645,
		9,
		19645
	],
	"./education-center/markdown/medical/decreased-glucose-6-phosphate-dehydrogenase-level-blood": [
		212790,
		9,
		212790
	],
	"./education-center/markdown/medical/decreased-glucose-6-phosphate-dehydrogenase-level-blood.md": [
		212790,
		9,
		212790
	],
	"./education-center/markdown/medical/decreased-plasma-carnitine": [
		66786,
		9,
		66786
	],
	"./education-center/markdown/medical/decreased-plasma-carnitine.md": [
		66786,
		9,
		66786
	],
	"./education-center/markdown/medical/decreased-response-growth-hormone-stimulation-test": [
		269914,
		9,
		269914
	],
	"./education-center/markdown/medical/decreased-response-growth-hormone-stimulation-test.md": [
		269914,
		9,
		269914
	],
	"./education-center/markdown/medical/decreased-testicular-size": [
		571370,
		9,
		571370
	],
	"./education-center/markdown/medical/decreased-testicular-size.md": [
		571370,
		9,
		571370
	],
	"./education-center/markdown/medical/deep-venous-thrombosis": [
		661084,
		9,
		661084
	],
	"./education-center/markdown/medical/deep-venous-thrombosis-protection-against": [
		764968,
		9,
		764968
	],
	"./education-center/markdown/medical/deep-venous-thrombosis-protection-against.md": [
		764968,
		9,
		764968
	],
	"./education-center/markdown/medical/deep-venous-thrombosis.md": [
		661084,
		9,
		661084
	],
	"./education-center/markdown/medical/dejerine-sottas-disease": [
		962264,
		9,
		962264
	],
	"./education-center/markdown/medical/dejerine-sottas-disease.md": [
		962264,
		9,
		962264
	],
	"./education-center/markdown/medical/dejerine-sottas-neuropathy-autosomal-dominant": [
		912179,
		9,
		912179
	],
	"./education-center/markdown/medical/dejerine-sottas-neuropathy-autosomal-dominant.md": [
		912179,
		9,
		912179
	],
	"./education-center/markdown/medical/dejerine-sottas-syndrome-autosomal-dominant": [
		739749,
		9,
		763200
	],
	"./education-center/markdown/medical/dejerine-sottas-syndrome-autosomal-dominant.md": [
		739749,
		9,
		763200
	],
	"./education-center/markdown/medical/delayed-ability-walk": [
		235093,
		9,
		235093
	],
	"./education-center/markdown/medical/delayed-ability-walk.md": [
		235093,
		9,
		235093
	],
	"./education-center/markdown/medical/delayed-gross-motor-development": [
		54053,
		9,
		54053
	],
	"./education-center/markdown/medical/delayed-gross-motor-development.md": [
		54053,
		9,
		54053
	],
	"./education-center/markdown/medical/delayed-skeletal-maturation": [
		990650,
		9,
		990650
	],
	"./education-center/markdown/medical/delayed-skeletal-maturation.md": [
		990650,
		9,
		990650
	],
	"./education-center/markdown/medical/delayed-speech-and-language-development": [
		26253,
		9,
		26253
	],
	"./education-center/markdown/medical/delayed-speech-and-language-development.md": [
		26253,
		9,
		26253
	],
	"./education-center/markdown/medical/deleterious-rad51d-gene-mutation": [
		708309,
		9,
		708309
	],
	"./education-center/markdown/medical/deleterious-rad51d-gene-mutation.md": [
		708309,
		9,
		708309
	],
	"./education-center/markdown/medical/delta-0-thalassemia": [
		839395,
		9,
		839395
	],
	"./education-center/markdown/medical/delta-0-thalassemia.md": [
		839395,
		9,
		839395
	],
	"./education-center/markdown/medical/delta-plus-thalassemia": [
		473010,
		9,
		473010
	],
	"./education-center/markdown/medical/delta-plus-thalassemia.md": [
		473010,
		9,
		473010
	],
	"./education-center/markdown/medical/delta-thalassemia": [
		869121,
		9,
		869121
	],
	"./education-center/markdown/medical/delta-thalassemia.md": [
		869121,
		9,
		869121
	],
	"./education-center/markdown/medical/delta-zero-thalassemia-knossos-type": [
		945324,
		9,
		945324
	],
	"./education-center/markdown/medical/delta-zero-thalassemia-knossos-type.md": [
		945324,
		9,
		945324
	],
	"./education-center/markdown/medical/dementia": [
		164554,
		9,
		164554
	],
	"./education-center/markdown/medical/dementia-deafness-and-sensory-neuropathy": [
		438615,
		9,
		438615
	],
	"./education-center/markdown/medical/dementia-deafness-and-sensory-neuropathy.md": [
		438615,
		9,
		438615
	],
	"./education-center/markdown/medical/dementia-lewy-body-susceptibility": [
		60705,
		9,
		60705
	],
	"./education-center/markdown/medical/dementia-lewy-body-susceptibility.md": [
		60705,
		9,
		60705
	],
	"./education-center/markdown/medical/dementia.md": [
		164554,
		9,
		164554
	],
	"./education-center/markdown/medical/dengue-fever-protection-against": [
		147013,
		9,
		147013
	],
	"./education-center/markdown/medical/dengue-fever-protection-against.md": [
		147013,
		9,
		147013
	],
	"./education-center/markdown/medical/dentatorubral-pallidoluysian-atrophy": [
		759899,
		9,
		759899
	],
	"./education-center/markdown/medical/dentatorubral-pallidoluysian-atrophy.md": [
		759899,
		9,
		759899
	],
	"./education-center/markdown/medical/denticles": [
		367777,
		9,
		367777
	],
	"./education-center/markdown/medical/denticles.md": [
		367777,
		9,
		367777
	],
	"./education-center/markdown/medical/dentin-dysplasia-type-i": [
		551282,
		9,
		551282
	],
	"./education-center/markdown/medical/dentin-dysplasia-type-i-extreme-microdontia-and-misshapen-teeth": [
		299285,
		9,
		299285
	],
	"./education-center/markdown/medical/dentin-dysplasia-type-i-extreme-microdontia-and-misshapen-teeth.md": [
		299285,
		9,
		299285
	],
	"./education-center/markdown/medical/dentin-dysplasia-type-i.md": [
		551282,
		9,
		551282
	],
	"./education-center/markdown/medical/dentinogenesis-imperfecta-type-2": [
		190181,
		9,
		190181
	],
	"./education-center/markdown/medical/dentinogenesis-imperfecta-type-2.md": [
		190181,
		9,
		190181
	],
	"./education-center/markdown/medical/dentinogenesis-imperfecta-type-3": [
		801650,
		9,
		801650
	],
	"./education-center/markdown/medical/dentinogenesis-imperfecta-type-3.md": [
		801650,
		9,
		801650
	],
	"./education-center/markdown/medical/dermatitis-atopic-2-susceptibility": [
		866832,
		9,
		866832
	],
	"./education-center/markdown/medical/dermatitis-atopic-2-susceptibility.md": [
		866832,
		9,
		866832
	],
	"./education-center/markdown/medical/dermatofibrosis-lenticularis-disseminata-isolated": [
		532868,
		9,
		532868
	],
	"./education-center/markdown/medical/dermatofibrosis-lenticularis-disseminata-isolated.md": [
		532868,
		9,
		532868
	],
	"./education-center/markdown/medical/dermatopathia-pigmentosa-reticularis": [
		916476,
		9,
		916476
	],
	"./education-center/markdown/medical/dermatopathia-pigmentosa-reticularis.md": [
		916476,
		9,
		916476
	],
	"./education-center/markdown/medical/desbuquois-dysplasia-1": [
		806741,
		9,
		806741
	],
	"./education-center/markdown/medical/desbuquois-dysplasia-1.md": [
		806741,
		9,
		806741
	],
	"./education-center/markdown/medical/descending-aortic-dissection": [
		683774,
		9,
		683774
	],
	"./education-center/markdown/medical/descending-aortic-dissection.md": [
		683774,
		9,
		683774
	],
	"./education-center/markdown/medical/desmoid-disease-hereditary": [
		538405,
		9,
		538405
	],
	"./education-center/markdown/medical/desmoid-disease-hereditary.md": [
		538405,
		9,
		538405
	],
	"./education-center/markdown/medical/desmoid-tumor": [
		463109,
		9,
		463109
	],
	"./education-center/markdown/medical/desmoid-tumor.md": [
		463109,
		9,
		463109
	],
	"./education-center/markdown/medical/deuteranomaly": [
		27765,
		9,
		27765
	],
	"./education-center/markdown/medical/deuteranomaly.md": [
		27765,
		9,
		27765
	],
	"./education-center/markdown/medical/deuteranopia": [
		955261,
		9,
		412927
	],
	"./education-center/markdown/medical/deuteranopia.md": [
		955261,
		9,
		412927
	],
	"./education-center/markdown/medical/deutetrabenazine-response": [
		40092,
		9,
		40092
	],
	"./education-center/markdown/medical/deutetrabenazine-response.md": [
		40092,
		9,
		40092
	],
	"./education-center/markdown/medical/developmental-and-epileptic-encephalopathy-31b-autosomal-recessive": [
		104619,
		9,
		104619
	],
	"./education-center/markdown/medical/developmental-and-epileptic-encephalopathy-31b-autosomal-recessive.md": [
		104619,
		9,
		104619
	],
	"./education-center/markdown/medical/developmental-delay": [
		924795,
		9,
		924795
	],
	"./education-center/markdown/medical/developmental-delay.md": [
		924795,
		9,
		924795
	],
	"./education-center/markdown/medical/developmental-dyslexia": [
		870831,
		9,
		870831
	],
	"./education-center/markdown/medical/developmental-dyslexia.md": [
		870831,
		9,
		870831
	],
	"./education-center/markdown/medical/developmental-regression": [
		815697,
		9,
		815697
	],
	"./education-center/markdown/medical/developmental-regression.md": [
		815697,
		9,
		815697
	],
	"./education-center/markdown/medical/diabetes-insipidus-nephrogenic-autosomal": [
		747348,
		9,
		747348
	],
	"./education-center/markdown/medical/diabetes-insipidus-nephrogenic-autosomal.md": [
		747348,
		9,
		747348
	],
	"./education-center/markdown/medical/diabetes-insipidus-neurohypophyseal-autosomal-recessive": [
		422124,
		9,
		422124
	],
	"./education-center/markdown/medical/diabetes-insipidus-neurohypophyseal-autosomal-recessive.md": [
		422124,
		9,
		422124
	],
	"./education-center/markdown/medical/diabetes-mellitus-ketosis-prone-susceptibility": [
		966541,
		9,
		966541
	],
	"./education-center/markdown/medical/diabetes-mellitus-ketosis-prone-susceptibility.md": [
		966541,
		9,
		966541
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-acanthosis-nigricans-and-hypertension": [
		804424,
		9,
		804424
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-acanthosis-nigricans-and-hypertension.md": [
		804424,
		9,
		804424
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-association": [
		525175,
		9,
		525175
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-association.md": [
		525175,
		9,
		525175
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-maternally-transmitted": [
		228615,
		9,
		228615
	],
	"./education-center/markdown/medical/diabetes-mellitus-noninsulin-dependent-maternally-transmitted.md": [
		228615,
		9,
		228615
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-1-susceptibility": [
		920157,
		9,
		920157
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-1-susceptibility.md": [
		920157,
		9,
		920157
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-2-susceptibility": [
		296799,
		9,
		296799
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-2-susceptibility.md": [
		296799,
		9,
		296799
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-ii-digenic": [
		710583,
		9,
		710583
	],
	"./education-center/markdown/medical/diabetes-mellitus-type-ii-digenic.md": [
		710583,
		9,
		710583
	],
	"./education-center/markdown/medical/diamond-blackfan-anemia-1": [
		637957,
		9,
		637957
	],
	"./education-center/markdown/medical/diamond-blackfan-anemia-1.md": [
		637957,
		9,
		637957
	],
	"./education-center/markdown/medical/diaphragmatic-hernia-4-cardiovascular-defects": [
		687815,
		9,
		687815
	],
	"./education-center/markdown/medical/diaphragmatic-hernia-4-cardiovascular-defects.md": [
		687815,
		9,
		687815
	],
	"./education-center/markdown/medical/diaphyseal-dysplasia": [
		849775,
		9,
		849775
	],
	"./education-center/markdown/medical/diaphyseal-dysplasia.md": [
		849775,
		9,
		849775
	],
	"./education-center/markdown/medical/diaphyseal-medullary-stenosis-bone-malignancy-syndrome": [
		469929,
		9,
		469929
	],
	"./education-center/markdown/medical/diaphyseal-medullary-stenosis-bone-malignancy-syndrome.md": [
		469929,
		9,
		469929
	],
	"./education-center/markdown/medical/diarrhea-microvillus-atrophy": [
		779497,
		9,
		779497
	],
	"./education-center/markdown/medical/diarrhea-microvillus-atrophy.md": [
		779497,
		9,
		779497
	],
	"./education-center/markdown/medical/diastema-dental-medial": [
		193901,
		9,
		193901
	],
	"./education-center/markdown/medical/diastema-dental-medial.md": [
		193901,
		9,
		193901
	],
	"./education-center/markdown/medical/diastolic-dysfunction": [
		146610,
		9,
		146610
	],
	"./education-center/markdown/medical/diastolic-dysfunction.md": [
		146610,
		9,
		146610
	],
	"./education-center/markdown/medical/diastrophic-dysplasia-broad-bone-platyspondylic-variant": [
		714274,
		9,
		714274
	],
	"./education-center/markdown/medical/diastrophic-dysplasia-broad-bone-platyspondylic-variant.md": [
		714274,
		9,
		714274
	],
	"./education-center/markdown/medical/diencephalic-mesencephalic-junction-dysplasia-syndrome-1": [
		537644,
		9,
		537644
	],
	"./education-center/markdown/medical/diencephalic-mesencephalic-junction-dysplasia-syndrome-1.md": [
		537644,
		9,
		537644
	],
	"./education-center/markdown/medical/diffuse-intrinsic-pontine-glioma": [
		959703,
		9,
		959703
	],
	"./education-center/markdown/medical/diffuse-intrinsic-pontine-glioma.md": [
		959703,
		9,
		959703
	],
	"./education-center/markdown/medical/diffuse-mesangial-sclerosis": [
		850460,
		9,
		850460
	],
	"./education-center/markdown/medical/diffuse-mesangial-sclerosis.md": [
		850460,
		9,
		850460
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1a": [
		14611,
		9,
		14611
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1a.md": [
		14611,
		9,
		14611
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1m": [
		4791,
		9,
		4791
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1m.md": [
		4791,
		9,
		4791
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1t": [
		252448,
		9,
		252448
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-1t.md": [
		252448,
		9,
		252448
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-dominant": [
		26846,
		9,
		26846
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-dominant.md": [
		26846,
		9,
		26846
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-left-ventricular-noncompaction": [
		340430,
		9,
		340430
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-left-ventricular-noncompaction.md": [
		340430,
		9,
		340430
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-recessive": [
		966058,
		9,
		966058
	],
	"./education-center/markdown/medical/dilated-cardiomyopathy-recessive.md": [
		966058,
		9,
		966058
	],
	"./education-center/markdown/medical/dilated-left-ventricle": [
		999499,
		9,
		999499
	],
	"./education-center/markdown/medical/dilated-left-ventricle.md": [
		999499,
		9,
		999499
	],
	"./education-center/markdown/medical/disease": [
		731676,
		9,
		731676
	],
	"./education-center/markdown/medical/disease-association-nos": [
		208603,
		9,
		208603
	],
	"./education-center/markdown/medical/disease-association-nos.md": [
		208603,
		9,
		208603
	],
	"./education-center/markdown/medical/disease.md": [
		731676,
		9,
		731676
	],
	"./education-center/markdown/medical/disorders-intracellular-cobalamin-metabolism": [
		767502,
		9,
		767502
	],
	"./education-center/markdown/medical/disorders-intracellular-cobalamin-metabolism.md": [
		767502,
		9,
		767502
	],
	"./education-center/markdown/medical/disproportionate-short-stature": [
		521289,
		9,
		521289
	],
	"./education-center/markdown/medical/disproportionate-short-stature.md": [
		521289,
		9,
		521289
	],
	"./education-center/markdown/medical/disproportionate-tall-stature": [
		276076,
		9,
		276076
	],
	"./education-center/markdown/medical/disproportionate-tall-stature.md": [
		276076,
		9,
		276076
	],
	"./education-center/markdown/medical/disrupted-sleep-wake-cycle-developmental-delay-and-learning-difficulty": [
		164283,
		9,
		164283
	],
	"./education-center/markdown/medical/disrupted-sleep-wake-cycle-developmental-delay-and-learning-difficulty.md": [
		164283,
		9,
		164283
	],
	"./education-center/markdown/medical/disseminated-atypical-mycobacterial-infection": [
		26933,
		9,
		26933
	],
	"./education-center/markdown/medical/disseminated-atypical-mycobacterial-infection.md": [
		26933,
		9,
		26933
	],
	"./education-center/markdown/medical/distal-amyotrophy": [
		193600,
		9,
		193600
	],
	"./education-center/markdown/medical/distal-amyotrophy.md": [
		193600,
		9,
		193600
	],
	"./education-center/markdown/medical/distal-lower-limb-muscle-weakness": [
		957817,
		9,
		957817
	],
	"./education-center/markdown/medical/distal-lower-limb-muscle-weakness.md": [
		957817,
		9,
		957817
	],
	"./education-center/markdown/medical/distal-muscle-weakness": [
		766190,
		9,
		766190
	],
	"./education-center/markdown/medical/distal-muscle-weakness.md": [
		766190,
		9,
		766190
	],
	"./education-center/markdown/medical/distal-renal-tubular-acidosis-dominant": [
		435859,
		9,
		435859
	],
	"./education-center/markdown/medical/distal-renal-tubular-acidosis-dominant.md": [
		435859,
		9,
		435859
	],
	"./education-center/markdown/medical/distal-renal-tubular-acidosis-recessive": [
		196238,
		9,
		196238
	],
	"./education-center/markdown/medical/distal-renal-tubular-acidosis-recessive.md": [
		196238,
		9,
		196238
	],
	"./education-center/markdown/medical/distal-shortening-limbs": [
		954468,
		9,
		954468
	],
	"./education-center/markdown/medical/distal-shortening-limbs.md": [
		954468,
		9,
		954468
	],
	"./education-center/markdown/medical/distichiasis-lymphedema-syndrome": [
		396296,
		9,
		396296
	],
	"./education-center/markdown/medical/distichiasis-lymphedema-syndrome.md": [
		396296,
		9,
		396296
	],
	"./education-center/markdown/medical/dizygotic-twins": [
		990631,
		9,
		990631
	],
	"./education-center/markdown/medical/dizygotic-twins.md": [
		990631,
		9,
		990631
	],
	"./education-center/markdown/medical/dld-related-disorders": [
		185729,
		9,
		185729
	],
	"./education-center/markdown/medical/dld-related-disorders.md": [
		185729,
		9,
		185729
	],
	"./education-center/markdown/medical/dna-topoisomerase-i-camptothecin-resistant": [
		785046,
		9,
		785046
	],
	"./education-center/markdown/medical/dna-topoisomerase-i-camptothecin-resistant.md": [
		785046,
		9,
		785046
	],
	"./education-center/markdown/medical/dna-topoisomerase-ii-resistance-inhibition-amsacrine": [
		566515,
		9,
		566515
	],
	"./education-center/markdown/medical/dna-topoisomerase-ii-resistance-inhibition-amsacrine.md": [
		566515,
		9,
		566515
	],
	"./education-center/markdown/medical/dominant-dystrophic-epidermolysis-bullosa-absence-skin": [
		606101,
		9,
		606101
	],
	"./education-center/markdown/medical/dominant-dystrophic-epidermolysis-bullosa-absence-skin.md": [
		606101,
		9,
		606101
	],
	"./education-center/markdown/medical/dopamine-beta-hydroxylase-polymorphism": [
		571707,
		9,
		571707
	],
	"./education-center/markdown/medical/dopamine-beta-hydroxylase-polymorphism.md": [
		571707,
		9,
		571707
	],
	"./education-center/markdown/medical/dopamine-receptor-d2-reduced-brain-density": [
		304177,
		9,
		304177
	],
	"./education-center/markdown/medical/dopamine-receptor-d2-reduced-brain-density.md": [
		304177,
		9,
		304177
	],
	"./education-center/markdown/medical/doyne-honeycomb-retinal-dystrophy": [
		837778,
		9,
		837778
	],
	"./education-center/markdown/medical/doyne-honeycomb-retinal-dystrophy.md": [
		837778,
		9,
		837778
	],
	"./education-center/markdown/medical/drug-induced-liver-injury-due-flucloxacillin": [
		337100,
		9,
		337100
	],
	"./education-center/markdown/medical/drug-induced-liver-injury-due-flucloxacillin.md": [
		337100,
		9,
		337100
	],
	"./education-center/markdown/medical/drug-metabolism-altered-ces1-related": [
		530486,
		9,
		530486
	],
	"./education-center/markdown/medical/drug-metabolism-altered-ces1-related.md": [
		530486,
		9,
		530486
	],
	"./education-center/markdown/medical/drug-metabolism-altered-cyp2c8-related": [
		137150,
		9,
		137150
	],
	"./education-center/markdown/medical/drug-metabolism-altered-cyp2c8-related.md": [
		137150,
		9,
		137150
	],
	"./education-center/markdown/medical/duane-retraction-syndrome": [
		891132,
		9,
		891132
	],
	"./education-center/markdown/medical/duane-retraction-syndrome.md": [
		891132,
		9,
		891132
	],
	"./education-center/markdown/medical/ductal-breast-carcinoma": [
		864427,
		9,
		864427
	],
	"./education-center/markdown/medical/ductal-breast-carcinoma.md": [
		864427,
		9,
		864427
	],
	"./education-center/markdown/medical/duodenal-adenocarcinoma": [
		864480,
		9,
		864480
	],
	"./education-center/markdown/medical/duodenal-adenocarcinoma.md": [
		864480,
		9,
		864480
	],
	"./education-center/markdown/medical/duodenal-stenosis": [
		194402,
		9,
		194402
	],
	"./education-center/markdown/medical/duodenal-stenosis.md": [
		194402,
		9,
		194402
	],
	"./education-center/markdown/medical/dysequilibrium-syndrome": [
		883466,
		9,
		883466
	],
	"./education-center/markdown/medical/dysequilibrium-syndrome.md": [
		883466,
		9,
		883466
	],
	"./education-center/markdown/medical/dysf-related-disorders": [
		423798,
		9,
		423798
	],
	"./education-center/markdown/medical/dysf-related-disorders.md": [
		423798,
		9,
		423798
	],
	"./education-center/markdown/medical/dysfibrinogenemia": [
		368183,
		9,
		368183
	],
	"./education-center/markdown/medical/dysfibrinogenemia.md": [
		368183,
		9,
		368183
	],
	"./education-center/markdown/medical/dysgenesis-cerebellar-vermis": [
		8897,
		9,
		8897
	],
	"./education-center/markdown/medical/dysgenesis-cerebellar-vermis.md": [
		8897,
		9,
		8897
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-autosomal-dominant-1": [
		875970,
		9,
		875970
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-autosomal-dominant-1.md": [
		875970,
		9,
		875970
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-dominant": [
		680562,
		9,
		680562
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-dominant.md": [
		680562,
		9,
		680562
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-recessive": [
		214615,
		9,
		214615
	],
	"./education-center/markdown/medical/dyskeratosis-congenita-recessive.md": [
		214615,
		9,
		214615
	],
	"./education-center/markdown/medical/dyslexia-susceptibility-1": [
		338581,
		9,
		338581
	],
	"./education-center/markdown/medical/dyslexia-susceptibility-1.md": [
		338581,
		9,
		338581
	],
	"./education-center/markdown/medical/dysmetria": [
		785328,
		9,
		785328
	],
	"./education-center/markdown/medical/dysmetria.md": [
		785328,
		9,
		785328
	],
	"./education-center/markdown/medical/dysostosis-multiplex-ain-naz-type": [
		364177,
		9,
		364177
	],
	"./education-center/markdown/medical/dysostosis-multiplex-ain-naz-type.md": [
		364177,
		9,
		364177
	],
	"./education-center/markdown/medical/dysplasminogenemia": [
		310072,
		9,
		310072
	],
	"./education-center/markdown/medical/dysplasminogenemia.md": [
		310072,
		9,
		310072
	],
	"./education-center/markdown/medical/dysplastic-corpus-callosum": [
		573501,
		9,
		573501
	],
	"./education-center/markdown/medical/dysplastic-corpus-callosum.md": [
		573501,
		9,
		573501
	],
	"./education-center/markdown/medical/dyssynergia": [
		302139,
		9,
		302139
	],
	"./education-center/markdown/medical/dyssynergia.md": [
		302139,
		9,
		302139
	],
	"./education-center/markdown/medical/dystonia-1-torsion-late-onset": [
		261851,
		9,
		261851
	],
	"./education-center/markdown/medical/dystonia-1-torsion-late-onset.md": [
		261851,
		9,
		261851
	],
	"./education-center/markdown/medical/dystonia-12": [
		111045,
		9,
		111045
	],
	"./education-center/markdown/medical/dystonia-12.md": [
		111045,
		9,
		111045
	],
	"./education-center/markdown/medical/dystonia-32": [
		737675,
		9,
		737675
	],
	"./education-center/markdown/medical/dystonia-32.md": [
		737675,
		9,
		737675
	],
	"./education-center/markdown/medical/dystonia-5": [
		963565,
		9,
		963565
	],
	"./education-center/markdown/medical/dystonia-5.md": [
		963565,
		9,
		963565
	],
	"./education-center/markdown/medical/dystonia-adult-onset": [
		742823,
		9,
		742823
	],
	"./education-center/markdown/medical/dystonia-adult-onset.md": [
		742823,
		9,
		742823
	],
	"./education-center/markdown/medical/dystonia-early-onset-atypical-myoclonic-features": [
		490270,
		9,
		490270
	],
	"./education-center/markdown/medical/dystonia-early-onset-atypical-myoclonic-features.md": [
		490270,
		9,
		490270
	],
	"./education-center/markdown/medical/dystonia-intellectual-disability-and-language-impairment": [
		300971,
		9,
		300971
	],
	"./education-center/markdown/medical/dystonia-intellectual-disability-and-language-impairment.md": [
		300971,
		9,
		300971
	],
	"./education-center/markdown/medical/dystonia-mitochondrial": [
		706409,
		9,
		706409
	],
	"./education-center/markdown/medical/dystonia-mitochondrial.md": [
		706409,
		9,
		706409
	],
	"./education-center/markdown/medical/dystonia-primary-cervical": [
		114926,
		9,
		114926
	],
	"./education-center/markdown/medical/dystonia-primary-cervical.md": [
		114926,
		9,
		114926
	],
	"./education-center/markdown/medical/ear-malformation": [
		272924,
		9,
		272924
	],
	"./education-center/markdown/medical/ear-malformation.md": [
		272924,
		9,
		272924
	],
	"./education-center/markdown/medical/early-infantile-epileptic-encephalopathy-autosomal-dominant": [
		859456,
		9,
		859456
	],
	"./education-center/markdown/medical/early-infantile-epileptic-encephalopathy-autosomal-dominant.md": [
		859456,
		9,
		859456
	],
	"./education-center/markdown/medical/early-infantile-epileptic-encephalopathy-autosomal-recessive": [
		36514,
		9,
		36514
	],
	"./education-center/markdown/medical/early-infantile-epileptic-encephalopathy-autosomal-recessive.md": [
		36514,
		9,
		36514
	],
	"./education-center/markdown/medical/early-onset-alzheimer-disease-behavioral-disturbance": [
		234139,
		9,
		234139
	],
	"./education-center/markdown/medical/early-onset-alzheimer-disease-behavioral-disturbance.md": [
		234139,
		9,
		234139
	],
	"./education-center/markdown/medical/early-onset-coronary-artery-disease": [
		180303,
		9,
		180303
	],
	"./education-center/markdown/medical/early-onset-coronary-artery-disease.md": [
		180303,
		9,
		180303
	],
	"./education-center/markdown/medical/early-onset-epileptic-encephalopathy": [
		248636,
		9,
		248636
	],
	"./education-center/markdown/medical/early-onset-epileptic-encephalopathy.md": [
		248636,
		9,
		248636
	],
	"./education-center/markdown/medical/early-onset-generalized-limb-onset-dystonia": [
		591806,
		9,
		591806
	],
	"./education-center/markdown/medical/early-onset-generalized-limb-onset-dystonia.md": [
		591806,
		9,
		591806
	],
	"./education-center/markdown/medical/early-spermatogenesis-maturation-arrest": [
		85346,
		9,
		85346
	],
	"./education-center/markdown/medical/early-spermatogenesis-maturation-arrest.md": [
		85346,
		9,
		85346
	],
	"./education-center/markdown/medical/ebf3-related-disorder": [
		459749,
		9,
		459749
	],
	"./education-center/markdown/medical/ebf3-related-disorder.md": [
		459749,
		9,
		459749
	],
	"./education-center/markdown/medical/eccrine-angiomatous-hamartoma": [
		880667,
		9,
		880667
	],
	"./education-center/markdown/medical/eccrine-angiomatous-hamartoma.md": [
		880667,
		9,
		880667
	],
	"./education-center/markdown/medical/ectodermal-dysplasia-10a-hypohidrotichairtooth-type-autosomal-dominant": [
		313272,
		9,
		313272
	],
	"./education-center/markdown/medical/ectodermal-dysplasia-10a-hypohidrotichairtooth-type-autosomal-dominant.md": [
		313272,
		9,
		313272
	],
	"./education-center/markdown/medical/ectopia-lentis-1-isolated-autosomal-dominant": [
		908458,
		9,
		908458
	],
	"./education-center/markdown/medical/ectopia-lentis-1-isolated-autosomal-dominant.md": [
		908458,
		9,
		908458
	],
	"./education-center/markdown/medical/ectrodactyly": [
		601914,
		9,
		601914
	],
	"./education-center/markdown/medical/ectrodactyly-and-ectodermal-dysplasia-without-cleft-lippalate": [
		900637,
		9,
		900637
	],
	"./education-center/markdown/medical/ectrodactyly-and-ectodermal-dysplasia-without-cleft-lippalate.md": [
		900637,
		9,
		900637
	],
	"./education-center/markdown/medical/ectrodactyly.md": [
		601914,
		9,
		601914
	],
	"./education-center/markdown/medical/eculizumab-poor-response": [
		30275,
		9,
		30275
	],
	"./education-center/markdown/medical/eculizumab-poor-response.md": [
		30275,
		9,
		30275
	],
	"./education-center/markdown/medical/eeg-focal-epileptiform-discharges": [
		141630,
		9,
		141630
	],
	"./education-center/markdown/medical/eeg-focal-epileptiform-discharges.md": [
		141630,
		9,
		141630
	],
	"./education-center/markdown/medical/efavirenz-response-metabolismpk": [
		198205,
		9,
		198205
	],
	"./education-center/markdown/medical/efavirenz-response-metabolismpk.md": [
		198205,
		9,
		198205
	],
	"./education-center/markdown/medical/effort-induced-polymorphic-ventricular-tachycardia": [
		541254,
		9,
		541254
	],
	"./education-center/markdown/medical/effort-induced-polymorphic-ventricular-tachycardia.md": [
		541254,
		9,
		541254
	],
	"./education-center/markdown/medical/egfr-related-lung-cancer": [
		775387,
		9,
		775387
	],
	"./education-center/markdown/medical/egfr-related-lung-cancer.md": [
		775387,
		9,
		775387
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-arthrochalasis-type": [
		45400,
		9,
		45400
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-arthrochalasis-type.md": [
		45400,
		9,
		45400
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-classic-type": [
		40189,
		9,
		40189
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-classic-type.md": [
		40189,
		9,
		40189
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-progeroid-type": [
		245207,
		9,
		245207
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-progeroid-type.md": [
		245207,
		9,
		245207
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-type-3": [
		399559,
		9,
		399559
	],
	"./education-center/markdown/medical/ehlers-danlos-syndrome-type-3.md": [
		399559,
		9,
		399559
	],
	"./education-center/markdown/medical/elevated-basal-serum-calcitonin": [
		255049,
		9,
		255049
	],
	"./education-center/markdown/medical/elevated-basal-serum-calcitonin.md": [
		255049,
		9,
		255049
	],
	"./education-center/markdown/medical/elevated-circulating-alkaline-phosphatase-concentration": [
		288544,
		9,
		288544
	],
	"./education-center/markdown/medical/elevated-circulating-alkaline-phosphatase-concentration.md": [
		288544,
		9,
		288544
	],
	"./education-center/markdown/medical/elevated-circulating-creatine-kinase-concentration": [
		121529,
		9,
		121529
	],
	"./education-center/markdown/medical/elevated-circulating-creatine-kinase-concentration.md": [
		121529,
		9,
		121529
	],
	"./education-center/markdown/medical/elevated-circulating-glutaric-acid-concentration": [
		457103,
		9,
		457103
	],
	"./education-center/markdown/medical/elevated-circulating-glutaric-acid-concentration.md": [
		457103,
		9,
		457103
	],
	"./education-center/markdown/medical/elliptocytosis": [
		509804,
		9,
		509804
	],
	"./education-center/markdown/medical/elliptocytosis-2": [
		893822,
		9,
		893822
	],
	"./education-center/markdown/medical/elliptocytosis-2.md": [
		893822,
		9,
		893822
	],
	"./education-center/markdown/medical/elliptocytosis.md": [
		509804,
		9,
		509804
	],
	"./education-center/markdown/medical/emery-nelson-syndrome": [
		609684,
		9,
		609684
	],
	"./education-center/markdown/medical/emery-nelson-syndrome.md": [
		609684,
		9,
		609684
	],
	"./education-center/markdown/medical/emm-null-phenotype": [
		603493,
		9,
		603493
	],
	"./education-center/markdown/medical/emm-null-phenotype.md": [
		603493,
		9,
		603493
	],
	"./education-center/markdown/medical/empty-follicle-syndrome": [
		536012,
		9,
		536012
	],
	"./education-center/markdown/medical/empty-follicle-syndrome.md": [
		536012,
		9,
		536012
	],
	"./education-center/markdown/medical/empty-ovarian-follicle": [
		977614,
		9,
		977614
	],
	"./education-center/markdown/medical/empty-ovarian-follicle.md": [
		977614,
		9,
		977614
	],
	"./education-center/markdown/medical/encephalocardiomyopathy-mitochondrial": [
		230028,
		9,
		230028
	],
	"./education-center/markdown/medical/encephalocardiomyopathy-mitochondrial.md": [
		230028,
		9,
		230028
	],
	"./education-center/markdown/medical/encephalopathy-familial-progressive-necrotizing": [
		232452,
		9,
		232452
	],
	"./education-center/markdown/medical/encephalopathy-familial-progressive-necrotizing.md": [
		232452,
		9,
		232452
	],
	"./education-center/markdown/medical/endometrial-endometrioid-adenocarcinoma-variant-squamous-differentiation": [
		996606,
		9,
		996606
	],
	"./education-center/markdown/medical/endometrial-endometrioid-adenocarcinoma-variant-squamous-differentiation.md": [
		996606,
		9,
		996606
	],
	"./education-center/markdown/medical/endometrial-neoplasm": [
		544078,
		9,
		544078
	],
	"./education-center/markdown/medical/endometrial-neoplasm.md": [
		544078,
		9,
		544078
	],
	"./education-center/markdown/medical/endometriosis": [
		956950,
		9,
		956950
	],
	"./education-center/markdown/medical/endometriosis.md": [
		956950,
		9,
		956950
	],
	"./education-center/markdown/medical/enhancement-c-reflex": [
		188378,
		9,
		188378
	],
	"./education-center/markdown/medical/enhancement-c-reflex.md": [
		188378,
		9,
		188378
	],
	"./education-center/markdown/medical/enzyme-activity-finding": [
		32758,
		9,
		32758
	],
	"./education-center/markdown/medical/enzyme-activity-finding.md": [
		32758,
		9,
		32758
	],
	"./education-center/markdown/medical/epidermal-nevus-urothelial-cancer-somatic": [
		845443,
		9,
		845443
	],
	"./education-center/markdown/medical/epidermal-nevus-urothelial-cancer-somatic.md": [
		845443,
		9,
		845443
	],
	"./education-center/markdown/medical/epidermolysis-bullosa": [
		715943,
		9,
		715943
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica": [
		432534,
		9,
		432534
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica-autosomal-recessive-localisata-variant": [
		667972,
		9,
		667972
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica-autosomal-recessive-localisata-variant.md": [
		667972,
		9,
		667972
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica-inversa-autosomal-recessive": [
		913248,
		9,
		913248
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica-inversa-autosomal-recessive.md": [
		913248,
		9,
		913248
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-dystrophica.md": [
		432534,
		9,
		432534
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-junctional-6-pyloric-atresia": [
		129574,
		9,
		129574
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-junctional-6-pyloric-atresia.md": [
		129574,
		9,
		129574
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pretibial-autosomal-recessive": [
		897457,
		9,
		897457
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pretibial-autosomal-recessive.md": [
		897457,
		9,
		897457
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pruriginosa-autosomal-dominant": [
		565844,
		9,
		565844
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pruriginosa-autosomal-dominant.md": [
		565844,
		9,
		565844
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pruriginosa-autosomal-recessive": [
		796699,
		9,
		796699
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-pruriginosa-autosomal-recessive.md": [
		796699,
		9,
		796699
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-1a-generalized-severe": [
		536440,
		9,
		536440
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-1a-generalized-severe.md": [
		536440,
		9,
		536440
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-1c-localized": [
		836148,
		9,
		836148
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-1c-localized.md": [
		836148,
		9,
		836148
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-koebner-type": [
		546463,
		9,
		546463
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-koebner-type.md": [
		546463,
		9,
		546463
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-mottled-pigmentation": [
		215392,
		9,
		215392
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-mottled-pigmentation.md": [
		215392,
		9,
		215392
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-ogna-type": [
		316857,
		9,
		316857
	],
	"./education-center/markdown/medical/epidermolysis-bullosa-simplex-ogna-type.md": [
		316857,
		9,
		316857
	],
	"./education-center/markdown/medical/epidermolysis-bullosa.md": [
		715943,
		9,
		715943
	],
	"./education-center/markdown/medical/epidermolytic-hyperkeratosis-late-onset": [
		103467,
		9,
		103467
	],
	"./education-center/markdown/medical/epidermolytic-hyperkeratosis-late-onset.md": [
		103467,
		9,
		103467
	],
	"./education-center/markdown/medical/epidermolytic-palmoplantar-keratoderma": [
		419626,
		9,
		419626
	],
	"./education-center/markdown/medical/epidermolytic-palmoplantar-keratoderma.md": [
		419626,
		9,
		419626
	],
	"./education-center/markdown/medical/epilepsy-childhood-absence-2": [
		62369,
		9,
		62369
	],
	"./education-center/markdown/medical/epilepsy-childhood-absence-2.md": [
		62369,
		9,
		62369
	],
	"./education-center/markdown/medical/epilepsy-childhood-absence-4": [
		93261,
		9,
		93261
	],
	"./education-center/markdown/medical/epilepsy-childhood-absence-4.md": [
		93261,
		9,
		93261
	],
	"./education-center/markdown/medical/epilepsy-due-perinatal-stroke": [
		880102,
		9,
		880102
	],
	"./education-center/markdown/medical/epilepsy-due-perinatal-stroke.md": [
		880102,
		9,
		880102
	],
	"./education-center/markdown/medical/epilepsy-juvenile-absence-2": [
		182937,
		9,
		182937
	],
	"./education-center/markdown/medical/epilepsy-juvenile-absence-2.md": [
		182937,
		9,
		182937
	],
	"./education-center/markdown/medical/epilepsy-juvenile-myoclonic-7": [
		374486,
		9,
		374486
	],
	"./education-center/markdown/medical/epilepsy-juvenile-myoclonic-7.md": [
		374486,
		9,
		374486
	],
	"./education-center/markdown/medical/epilepsy-juvenile-myoclonic-8": [
		76309,
		9,
		76309
	],
	"./education-center/markdown/medical/epilepsy-juvenile-myoclonic-8.md": [
		76309,
		9,
		76309
	],
	"./education-center/markdown/medical/epilepsy-mitochondrial": [
		215103,
		9,
		215103
	],
	"./education-center/markdown/medical/epilepsy-mitochondrial.md": [
		215103,
		9,
		215103
	],
	"./education-center/markdown/medical/epilepsy-progressive-myoclonic-3-intracellular-inclusions": [
		331385,
		9,
		331385
	],
	"./education-center/markdown/medical/epilepsy-progressive-myoclonic-3-intracellular-inclusions.md": [
		331385,
		9,
		331385
	],
	"./education-center/markdown/medical/epilepsy-x-linked-2-or-without-impaired-intellectual-development-and-dysmorphic-features": [
		271362,
		9,
		271362
	],
	"./education-center/markdown/medical/epilepsy-x-linked-2-or-without-impaired-intellectual-development-and-dysmorphic-features.md": [
		271362,
		9,
		271362
	],
	"./education-center/markdown/medical/epileptic-encephalopathy": [
		740942,
		9,
		740942
	],
	"./education-center/markdown/medical/epileptic-encephalopathy-early-infanitle-1": [
		123777,
		9,
		123777
	],
	"./education-center/markdown/medical/epileptic-encephalopathy-early-infanitle-1.md": [
		123777,
		9,
		123777
	],
	"./education-center/markdown/medical/epileptic-encephalopathy.md": [
		740942,
		9,
		740942
	],
	"./education-center/markdown/medical/epileptic-spasm": [
		404658,
		9,
		404658
	],
	"./education-center/markdown/medical/epileptic-spasm.md": [
		404658,
		9,
		404658
	],
	"./education-center/markdown/medical/epiphyseal-dysplasia-multiple-1-severe": [
		502496,
		9,
		502496
	],
	"./education-center/markdown/medical/epiphyseal-dysplasia-multiple-1-severe.md": [
		502496,
		9,
		502496
	],
	"./education-center/markdown/medical/epiphyseal-dysplasia-multiple-3-myopathy": [
		41254,
		9,
		41254
	],
	"./education-center/markdown/medical/epiphyseal-dysplasia-multiple-3-myopathy.md": [
		41254,
		9,
		41254
	],
	"./education-center/markdown/medical/episodic-ataxia-type-2": [
		549802,
		9,
		549802
	],
	"./education-center/markdown/medical/episodic-ataxia-type-2-and-epilepsy": [
		714614,
		9,
		714614
	],
	"./education-center/markdown/medical/episodic-ataxia-type-2-and-epilepsy.md": [
		714614,
		9,
		714614
	],
	"./education-center/markdown/medical/episodic-ataxia-type-2.md": [
		549802,
		9,
		549802
	],
	"./education-center/markdown/medical/episodic-ataxiamyokymia-syndrome": [
		690897,
		9,
		690897
	],
	"./education-center/markdown/medical/episodic-ataxiamyokymia-syndrome.md": [
		690897,
		9,
		690897
	],
	"./education-center/markdown/medical/epithelial-basement-membrane-dystrophy": [
		76945,
		9,
		76945
	],
	"./education-center/markdown/medical/epithelial-basement-membrane-dystrophy.md": [
		76945,
		9,
		76945
	],
	"./education-center/markdown/medical/epithelial-recurrent-erosion-dystrophy": [
		430558,
		9,
		430558
	],
	"./education-center/markdown/medical/epithelial-recurrent-erosion-dystrophy.md": [
		430558,
		9,
		430558
	],
	"./education-center/markdown/medical/epithelial-stromal-tgfbi-dystrophy": [
		325589,
		9,
		325589
	],
	"./education-center/markdown/medical/epithelial-stromal-tgfbi-dystrophy.md": [
		325589,
		9,
		325589
	],
	"./education-center/markdown/medical/ercc2-related-disorders": [
		166869,
		9,
		166869
	],
	"./education-center/markdown/medical/ercc2-related-disorders.md": [
		166869,
		9,
		166869
	],
	"./education-center/markdown/medical/ercc6-related-disorders": [
		967250,
		9,
		967250
	],
	"./education-center/markdown/medical/ercc6-related-disorders.md": [
		967250,
		9,
		967250
	],
	"./education-center/markdown/medical/erlotinib-response": [
		754057,
		9,
		754057
	],
	"./education-center/markdown/medical/erlotinib-response-efficacy": [
		409473,
		9,
		409473
	],
	"./education-center/markdown/medical/erlotinib-response-efficacy.md": [
		409473,
		9,
		409473
	],
	"./education-center/markdown/medical/erlotinib-response.md": [
		754057,
		9,
		754057
	],
	"./education-center/markdown/medical/erythrocyte-amp-deaminase-deficiency": [
		633366,
		9,
		633366
	],
	"./education-center/markdown/medical/erythrocyte-amp-deaminase-deficiency.md": [
		633366,
		9,
		633366
	],
	"./education-center/markdown/medical/erythrocytosis": [
		204945,
		9,
		204945
	],
	"./education-center/markdown/medical/erythrocytosis-jak2-related-somatic": [
		603223,
		9,
		603223
	],
	"./education-center/markdown/medical/erythrocytosis-jak2-related-somatic.md": [
		603223,
		9,
		603223
	],
	"./education-center/markdown/medical/erythrocytosis.md": [
		204945,
		9,
		204945
	],
	"./education-center/markdown/medical/erythroleukemia-familial-susceptibility": [
		690712,
		9,
		690712
	],
	"./education-center/markdown/medical/erythroleukemia-familial-susceptibility.md": [
		690712,
		9,
		690712
	],
	"./education-center/markdown/medical/esophageal-atresia": [
		22983,
		9,
		22983
	],
	"./education-center/markdown/medical/esophageal-atresia.md": [
		22983,
		9,
		22983
	],
	"./education-center/markdown/medical/esophageal-cancer-alcohol-related-susceptibility": [
		14761,
		9,
		14761
	],
	"./education-center/markdown/medical/esophageal-cancer-alcohol-related-susceptibility.md": [
		14761,
		9,
		14761
	],
	"./education-center/markdown/medical/esophageal-carcinoma-somatic": [
		760354,
		9,
		760354
	],
	"./education-center/markdown/medical/esophageal-carcinoma-somatic.md": [
		760354,
		9,
		760354
	],
	"./education-center/markdown/medical/esophageal-squamous-cell-carcinoma": [
		408711,
		9,
		408711
	],
	"./education-center/markdown/medical/esophageal-squamous-cell-carcinoma-somatic": [
		759172,
		9,
		759172
	],
	"./education-center/markdown/medical/esophageal-squamous-cell-carcinoma-somatic.md": [
		759172,
		9,
		759172
	],
	"./education-center/markdown/medical/esophageal-squamous-cell-carcinoma.md": [
		408711,
		9,
		408711
	],
	"./education-center/markdown/medical/essential-hypertension": [
		850015,
		9,
		850015
	],
	"./education-center/markdown/medical/essential-hypertension-genetic": [
		206957,
		9,
		206957
	],
	"./education-center/markdown/medical/essential-hypertension-genetic.md": [
		206957,
		9,
		206957
	],
	"./education-center/markdown/medical/essential-hypertension.md": [
		850015,
		9,
		850015
	],
	"./education-center/markdown/medical/estrogen-receptor-mutant-temperature-sensitive": [
		455366,
		9,
		455366
	],
	"./education-center/markdown/medical/estrogen-receptor-mutant-temperature-sensitive.md": [
		455366,
		9,
		455366
	],
	"./education-center/markdown/medical/etanercept-response-efficacy": [
		451756,
		9,
		451756
	],
	"./education-center/markdown/medical/etanercept-response-efficacy.md": [
		451756,
		9,
		451756
	],
	"./education-center/markdown/medical/euthyroid-goiter": [
		373316,
		9,
		373316
	],
	"./education-center/markdown/medical/euthyroid-goiter.md": [
		373316,
		9,
		373316
	],
	"./education-center/markdown/medical/evans-syndrome-immunodeficiency-and-premature-immunosenescence-associated-tripeptidyl-peptidase-ii": [
		781849,
		9,
		781849
	],
	"./education-center/markdown/medical/evans-syndrome-immunodeficiency-and-premature-immunosenescence-associated-tripeptidyl-peptidase-ii.md": [
		781849,
		9,
		781849
	],
	"./education-center/markdown/medical/ewing-sarcoma-soft-tissue": [
		71047,
		9,
		71047
	],
	"./education-center/markdown/medical/ewing-sarcoma-soft-tissue.md": [
		71047,
		9,
		71047
	],
	"./education-center/markdown/medical/exaggerated-startle-response": [
		30475,
		9,
		30475
	],
	"./education-center/markdown/medical/exaggerated-startle-response.md": [
		30475,
		9,
		30475
	],
	"./education-center/markdown/medical/exercise-intolerance": [
		953906,
		9,
		953906
	],
	"./education-center/markdown/medical/exercise-intolerance-and-complex-iii-deficiency-somatic": [
		518018,
		9,
		518018
	],
	"./education-center/markdown/medical/exercise-intolerance-and-complex-iii-deficiency-somatic.md": [
		518018,
		9,
		518018
	],
	"./education-center/markdown/medical/exercise-intolerance-muscle-pain-and-lactic-acidemia": [
		787155,
		9,
		787155
	],
	"./education-center/markdown/medical/exercise-intolerance-muscle-pain-and-lactic-acidemia.md": [
		787155,
		9,
		787155
	],
	"./education-center/markdown/medical/exercise-intolerance.md": [
		953906,
		9,
		953906
	],
	"./education-center/markdown/medical/exercise-stress-response-impaired-association": [
		285272,
		9,
		285272
	],
	"./education-center/markdown/medical/exercise-stress-response-impaired-association.md": [
		285272,
		9,
		285272
	],
	"./education-center/markdown/medical/exertional-myalgia-muscle-stiffness-and-myoglobinuria": [
		717292,
		9,
		717292
	],
	"./education-center/markdown/medical/exertional-myalgia-muscle-stiffness-and-myoglobinuria.md": [
		717292,
		9,
		717292
	],
	"./education-center/markdown/medical/exostoses-multiple-type-1": [
		831704,
		9,
		831704
	],
	"./education-center/markdown/medical/exostoses-multiple-type-1.md": [
		831704,
		9,
		831704
	],
	"./education-center/markdown/medical/exostoses-multiple-type-2": [
		704407,
		9,
		704407
	],
	"./education-center/markdown/medical/exostoses-multiple-type-2.md": [
		704407,
		9,
		704407
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-1": [
		939807,
		9,
		939807
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-1.md": [
		939807,
		9,
		939807
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-autosomal-dominant": [
		789664,
		9,
		789664
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-autosomal-dominant.md": [
		789664,
		9,
		789664
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-autosomal-recessive": [
		275841,
		9,
		275841
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-autosomal-recessive.md": [
		275841,
		9,
		275841
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-digenic": [
		708217,
		9,
		708217
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-4-digenic.md": [
		708217,
		9,
		708217
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-digenic": [
		44564,
		9,
		44564
	],
	"./education-center/markdown/medical/exudative-vitreoretinopathy-digenic.md": [
		44564,
		9,
		44564
	],
	"./education-center/markdown/medical/eya4-related-disorders": [
		501700,
		9,
		501700
	],
	"./education-center/markdown/medical/eya4-related-disorders.md": [
		501700,
		9,
		501700
	],
	"./education-center/markdown/medical/ezetimibe-response": [
		707900,
		9,
		707900
	],
	"./education-center/markdown/medical/ezetimibe-response.md": [
		707900,
		9,
		707900
	],
	"./education-center/markdown/medical/f12-related-disorders": [
		298775,
		9,
		298775
	],
	"./education-center/markdown/medical/f12-related-disorders.md": [
		298775,
		9,
		298775
	],
	"./education-center/markdown/medical/fabry-disease-cardiac-variant": [
		846714,
		9,
		846714
	],
	"./education-center/markdown/medical/fabry-disease-cardiac-variant.md": [
		846714,
		9,
		846714
	],
	"./education-center/markdown/medical/facial-hypotonia": [
		561364,
		9,
		561364
	],
	"./education-center/markdown/medical/facial-hypotonia.md": [
		561364,
		9,
		561364
	],
	"./education-center/markdown/medical/facioscapulohumeral-muscular-dystrophy-2": [
		668209,
		9,
		668209
	],
	"./education-center/markdown/medical/facioscapulohumeral-muscular-dystrophy-2.md": [
		668209,
		9,
		668209
	],
	"./education-center/markdown/medical/factor-v-hong-kong": [
		666055,
		9,
		666055
	],
	"./education-center/markdown/medical/factor-v-hong-kong.md": [
		666055,
		9,
		666055
	],
	"./education-center/markdown/medical/factor-vii-marburg-i-variant-thrombophilia": [
		442133,
		9,
		442133
	],
	"./education-center/markdown/medical/factor-vii-marburg-i-variant-thrombophilia.md": [
		442133,
		9,
		442133
	],
	"./education-center/markdown/medical/familial-amyloid-polyneuropathy-iowa-type": [
		945632,
		9,
		945632
	],
	"./education-center/markdown/medical/familial-amyloid-polyneuropathy-iowa-type.md": [
		945632,
		9,
		945632
	],
	"./education-center/markdown/medical/familial-aortic-aneurysms": [
		733715,
		9,
		733715
	],
	"./education-center/markdown/medical/familial-aortic-aneurysms.md": [
		733715,
		9,
		733715
	],
	"./education-center/markdown/medical/familial-aortopathy": [
		315244,
		9,
		315244
	],
	"./education-center/markdown/medical/familial-aortopathy.md": [
		315244,
		9,
		315244
	],
	"./education-center/markdown/medical/familial-atypical-hemolytic-uremic-syndrome": [
		987923,
		9,
		987923
	],
	"./education-center/markdown/medical/familial-atypical-hemolytic-uremic-syndrome.md": [
		987923,
		9,
		987923
	],
	"./education-center/markdown/medical/familial-atypical-mycobacteriosis-autosomal-dominant": [
		55626,
		9,
		55626
	],
	"./education-center/markdown/medical/familial-atypical-mycobacteriosis-autosomal-dominant.md": [
		55626,
		9,
		55626
	],
	"./education-center/markdown/medical/familial-atypical-mycobacteriosis-autosomal-recessive": [
		799104,
		9,
		799104
	],
	"./education-center/markdown/medical/familial-atypical-mycobacteriosis-autosomal-recessive.md": [
		799104,
		9,
		799104
	],
	"./education-center/markdown/medical/familial-candidiasis-recessive": [
		733747,
		9,
		733747
	],
	"./education-center/markdown/medical/familial-candidiasis-recessive.md": [
		733747,
		9,
		733747
	],
	"./education-center/markdown/medical/familial-cold-autoinflammatory-syndrome-1": [
		219787,
		9,
		219787
	],
	"./education-center/markdown/medical/familial-cold-autoinflammatory-syndrome-1.md": [
		219787,
		9,
		219787
	],
	"./education-center/markdown/medical/familial-congenital-nasolacrimal-duct-obstruction": [
		191703,
		9,
		191703
	],
	"./education-center/markdown/medical/familial-congenital-nasolacrimal-duct-obstruction.md": [
		191703,
		9,
		191703
	],
	"./education-center/markdown/medical/familial-cylindromatosis": [
		458212,
		9,
		458212
	],
	"./education-center/markdown/medical/familial-cylindromatosis.md": [
		458212,
		9,
		458212
	],
	"./education-center/markdown/medical/familial-ectopia-lentis": [
		754151,
		9,
		754151
	],
	"./education-center/markdown/medical/familial-ectopia-lentis.md": [
		754151,
		9,
		754151
	],
	"./education-center/markdown/medical/familial-erythrocytosis": [
		573617,
		9,
		573617
	],
	"./education-center/markdown/medical/familial-erythrocytosis.md": [
		573617,
		9,
		573617
	],
	"./education-center/markdown/medical/familial-hematuria": [
		344634,
		9,
		344634
	],
	"./education-center/markdown/medical/familial-hematuria.md": [
		344634,
		9,
		344634
	],
	"./education-center/markdown/medical/familial-hemiplegic-migraine": [
		957345,
		9,
		957345
	],
	"./education-center/markdown/medical/familial-hemiplegic-migraine.md": [
		957345,
		9,
		957345
	],
	"./education-center/markdown/medical/familial-high-density-lipoprotein-deficiency": [
		770463,
		9,
		770463
	],
	"./education-center/markdown/medical/familial-high-density-lipoprotein-deficiency.md": [
		770463,
		9,
		770463
	],
	"./education-center/markdown/medical/familial-hypercholesterolemia": [
		395672,
		9,
		395672
	],
	"./education-center/markdown/medical/familial-hypercholesterolemia.md": [
		395672,
		9,
		395672
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-22": [
		534574,
		9,
		534574
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-22.md": [
		534574,
		9,
		534574
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-24": [
		390232,
		9,
		390232
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-24.md": [
		390232,
		9,
		390232
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-wolff-parkinson-white-syndrome": [
		972694,
		9,
		972694
	],
	"./education-center/markdown/medical/familial-hypertrophic-cardiomyopathy-wolff-parkinson-white-syndrome.md": [
		972694,
		9,
		972694
	],
	"./education-center/markdown/medical/familial-hypoalphalipoproteinemia": [
		608761,
		9,
		608761
	],
	"./education-center/markdown/medical/familial-hypoalphalipoproteinemia.md": [
		608761,
		9,
		608761
	],
	"./education-center/markdown/medical/familial-hypobetalipoproteinemia": [
		309829,
		9,
		309829
	],
	"./education-center/markdown/medical/familial-hypobetalipoproteinemia.md": [
		309829,
		9,
		309829
	],
	"./education-center/markdown/medical/familial-hypocalciuric-hypercalcemia-1": [
		434174,
		9,
		434174
	],
	"./education-center/markdown/medical/familial-hypocalciuric-hypercalcemia-1.md": [
		434174,
		9,
		434174
	],
	"./education-center/markdown/medical/familial-hypocalciuric-hypercalcemia-2": [
		8159,
		9,
		8159
	],
	"./education-center/markdown/medical/familial-hypocalciuric-hypercalcemia-2.md": [
		8159,
		9,
		8159
	],
	"./education-center/markdown/medical/familial-idiopathic-hypercalciuria": [
		545644,
		9,
		545644
	],
	"./education-center/markdown/medical/familial-idiopathic-hypercalciuria.md": [
		545644,
		9,
		545644
	],
	"./education-center/markdown/medical/familial-mediterranean-fever-autosomal-dominant": [
		766260,
		9,
		766260
	],
	"./education-center/markdown/medical/familial-mediterranean-fever-autosomal-dominant.md": [
		766260,
		9,
		766260
	],
	"./education-center/markdown/medical/familial-medullary-thyroid-carcinoma": [
		165301,
		9,
		165301
	],
	"./education-center/markdown/medical/familial-medullary-thyroid-carcinoma.md": [
		165301,
		9,
		165301
	],
	"./education-center/markdown/medical/familial-partial-lipodystrophy-dunnigan-type": [
		53650,
		9,
		53650
	],
	"./education-center/markdown/medical/familial-partial-lipodystrophy-dunnigan-type.md": [
		53650,
		9,
		53650
	],
	"./education-center/markdown/medical/familial-periodic-fever": [
		209603,
		9,
		209603
	],
	"./education-center/markdown/medical/familial-periodic-fever.md": [
		209603,
		9,
		209603
	],
	"./education-center/markdown/medical/familial-periodic-paralysis": [
		996805,
		9,
		996805
	],
	"./education-center/markdown/medical/familial-periodic-paralysis.md": [
		996805,
		9,
		996805
	],
	"./education-center/markdown/medical/familial-type-5-hyperlipoproteinemia": [
		623251,
		9,
		623251
	],
	"./education-center/markdown/medical/familial-type-5-hyperlipoproteinemia.md": [
		623251,
		9,
		623251
	],
	"./education-center/markdown/medical/familial-visceral-amyloidosis-ostertag-type": [
		167864,
		9,
		167864
	],
	"./education-center/markdown/medical/familial-visceral-amyloidosis-ostertag-type.md": [
		167864,
		9,
		167864
	],
	"./education-center/markdown/medical/family-history": [
		56217,
		9,
		56217
	],
	"./education-center/markdown/medical/family-history-cardiomyopathy": [
		372039,
		9,
		372039
	],
	"./education-center/markdown/medical/family-history-cardiomyopathy.md": [
		372039,
		9,
		372039
	],
	"./education-center/markdown/medical/family-history-sudden-cardiac-death": [
		375491,
		9,
		375491
	],
	"./education-center/markdown/medical/family-history-sudden-cardiac-death.md": [
		375491,
		9,
		375491
	],
	"./education-center/markdown/medical/family-history.md": [
		56217,
		9,
		56217
	],
	"./education-center/markdown/medical/fanconi-anemia-complementation-group-m": [
		649012,
		9,
		649012
	],
	"./education-center/markdown/medical/fanconi-anemia-complementation-group-m.md": [
		649012,
		9,
		649012
	],
	"./education-center/markdown/medical/fanconi-anemia-x-linked": [
		332450,
		9,
		332450
	],
	"./education-center/markdown/medical/fanconi-anemia-x-linked.md": [
		332450,
		9,
		332450
	],
	"./education-center/markdown/medical/fasting-plasma-glucose-level-quantitative-trait-locus-1": [
		90496,
		9,
		90496
	],
	"./education-center/markdown/medical/fasting-plasma-glucose-level-quantitative-trait-locus-1.md": [
		90496,
		9,
		90496
	],
	"./education-center/markdown/medical/fasting-plasma-glucose-level-quantitative-trait-locus-5": [
		182587,
		9,
		182587
	],
	"./education-center/markdown/medical/fasting-plasma-glucose-level-quantitative-trait-locus-5.md": [
		182587,
		9,
		182587
	],
	"./education-center/markdown/medical/fatal-infantile-cardioencephalomyopathy": [
		457242,
		9,
		457242
	],
	"./education-center/markdown/medical/fatal-infantile-cardioencephalomyopathy.md": [
		457242,
		9,
		457242
	],
	"./education-center/markdown/medical/fatal-infantile-mitochondrial-cardiomyopathy": [
		893749,
		9,
		893749
	],
	"./education-center/markdown/medical/fatal-infantile-mitochondrial-cardiomyopathy.md": [
		893749,
		9,
		893749
	],
	"./education-center/markdown/medical/febrile-seizures-familial": [
		384731,
		9,
		384731
	],
	"./education-center/markdown/medical/febrile-seizures-familial-1": [
		94361,
		9,
		94361
	],
	"./education-center/markdown/medical/febrile-seizures-familial-1.md": [
		94361,
		9,
		94361
	],
	"./education-center/markdown/medical/febrile-seizures-familial.md": [
		384731,
		9,
		384731
	],
	"./education-center/markdown/medical/fetal-cystic-hygroma": [
		219637,
		9,
		219637
	],
	"./education-center/markdown/medical/fetal-cystic-hygroma.md": [
		219637,
		9,
		219637
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-1": [
		788446,
		9,
		788446
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-1.md": [
		788446,
		9,
		788446
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-5": [
		504085,
		9,
		504085
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-5.md": [
		504085,
		9,
		504085
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-6": [
		205114,
		9,
		205114
	],
	"./education-center/markdown/medical/fetal-hemoglobin-quantitative-trait-locus-6.md": [
		205114,
		9,
		205114
	],
	"./education-center/markdown/medical/fgfr2-related-craniosynostosis": [
		414110,
		9,
		414110
	],
	"./education-center/markdown/medical/fgfr2-related-craniosynostosis.md": [
		414110,
		9,
		414110
	],
	"./education-center/markdown/medical/fibrinogen-milano-xii-digenic": [
		460818,
		9,
		460818
	],
	"./education-center/markdown/medical/fibrinogen-milano-xii-digenic.md": [
		460818,
		9,
		460818
	],
	"./education-center/markdown/medical/fibromatosis-gingival-1": [
		903339,
		9,
		903339
	],
	"./education-center/markdown/medical/fibromatosis-gingival-1.md": [
		903339,
		9,
		903339
	],
	"./education-center/markdown/medical/fibromuscular-dysplasia-multifocal": [
		357851,
		9,
		357851
	],
	"./education-center/markdown/medical/fibromuscular-dysplasia-multifocal.md": [
		357851,
		9,
		357851
	],
	"./education-center/markdown/medical/fibrous-dysplasia-jaw": [
		984,
		9,
		984
	],
	"./education-center/markdown/medical/fibrous-dysplasia-jaw.md": [
		984,
		9,
		984
	],
	"./education-center/markdown/medical/fibrous-sheath-dysplasia": [
		650258,
		9,
		650258
	],
	"./education-center/markdown/medical/fibrous-sheath-dysplasia.md": [
		650258,
		9,
		650258
	],
	"./education-center/markdown/medical/fig4-related-disorders": [
		176462,
		9,
		176462
	],
	"./education-center/markdown/medical/fig4-related-disorders.md": [
		176462,
		9,
		176462
	],
	"./education-center/markdown/medical/first-degree-atrioventricular-block": [
		210052,
		9,
		210052
	],
	"./education-center/markdown/medical/first-degree-atrioventricular-block.md": [
		210052,
		9,
		210052
	],
	"./education-center/markdown/medical/fish-eye-disease": [
		907012,
		9,
		907012
	],
	"./education-center/markdown/medical/fish-eye-disease.md": [
		907012,
		9,
		907012
	],
	"./education-center/markdown/medical/fleck-corneal-dystrophy": [
		30710,
		9,
		30710
	],
	"./education-center/markdown/medical/fleck-corneal-dystrophy.md": [
		30710,
		9,
		30710
	],
	"./education-center/markdown/medical/flna-related-disorders": [
		848340,
		9,
		848340
	],
	"./education-center/markdown/medical/flna-related-disorders.md": [
		848340,
		9,
		848340
	],
	"./education-center/markdown/medical/flnb-related-disorders": [
		545111,
		9,
		545111
	],
	"./education-center/markdown/medical/flnb-related-disorders.md": [
		545111,
		9,
		545111
	],
	"./education-center/markdown/medical/flnb-related-spectrum-disorders": [
		297519,
		9,
		297519
	],
	"./education-center/markdown/medical/flnb-related-spectrum-disorders.md": [
		297519,
		9,
		297519
	],
	"./education-center/markdown/medical/floating-harbor-syndrome": [
		80028,
		9,
		80028
	],
	"./education-center/markdown/medical/floating-harbor-syndrome.md": [
		80028,
		9,
		80028
	],
	"./education-center/markdown/medical/flurbiprofen-response": [
		229681,
		9,
		229681
	],
	"./education-center/markdown/medical/flurbiprofen-response.md": [
		229681,
		9,
		229681
	],
	"./education-center/markdown/medical/fmo3-activity-decreased": [
		413438,
		9,
		413438
	],
	"./education-center/markdown/medical/fmo3-activity-decreased.md": [
		413438,
		9,
		413438
	],
	"./education-center/markdown/medical/focal-clonic-seizure": [
		590257,
		9,
		590257
	],
	"./education-center/markdown/medical/focal-clonic-seizure.md": [
		590257,
		9,
		590257
	],
	"./education-center/markdown/medical/focal-cortical-dysplasia-taylor-type-2b": [
		704199,
		9,
		704199
	],
	"./education-center/markdown/medical/focal-cortical-dysplasia-taylor-type-2b.md": [
		704199,
		9,
		704199
	],
	"./education-center/markdown/medical/focal-impaired-awareness-seizure": [
		443559,
		9,
		443559
	],
	"./education-center/markdown/medical/focal-impaired-awareness-seizure.md": [
		443559,
		9,
		443559
	],
	"./education-center/markdown/medical/focal-onset-seizure": [
		418192,
		9,
		418192
	],
	"./education-center/markdown/medical/focal-onset-seizure.md": [
		418192,
		9,
		418192
	],
	"./education-center/markdown/medical/focal-segmental-glomerulosclerosis-3": [
		432464,
		9,
		432464
	],
	"./education-center/markdown/medical/focal-segmental-glomerulosclerosis-3.md": [
		432464,
		9,
		432464
	],
	"./education-center/markdown/medical/focal-segmental-glomerulosclerosis-and-dilated-cardiomyopathy": [
		370297,
		9,
		370297
	],
	"./education-center/markdown/medical/focal-segmental-glomerulosclerosis-and-dilated-cardiomyopathy.md": [
		370297,
		9,
		370297
	],
	"./education-center/markdown/medical/forebrain-defects": [
		552601,
		9,
		552601
	],
	"./education-center/markdown/medical/forebrain-defects.md": [
		552601,
		9,
		552601
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1": [
		438597,
		9,
		438597
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1-cataract": [
		958092,
		9,
		958092
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1-cataract.md": [
		958092,
		9,
		958092
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1-or-without-anterior-segment-anomalies": [
		143767,
		9,
		143767
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1-or-without-anterior-segment-anomalies.md": [
		143767,
		9,
		143767
	],
	"./education-center/markdown/medical/foveal-hypoplasia-1.md": [
		438597,
		9,
		438597
	],
	"./education-center/markdown/medical/foveal-hypoplasia-2-and-optic-nerve-misrouting-or-without-anterior-segment-dysgenesis": [
		867207,
		9,
		867207
	],
	"./education-center/markdown/medical/foveal-hypoplasia-2-and-optic-nerve-misrouting-or-without-anterior-segment-dysgenesis.md": [
		867207,
		9,
		867207
	],
	"./education-center/markdown/medical/frasier-syndrome": [
		794380,
		9,
		794380
	],
	"./education-center/markdown/medical/frasier-syndrome.md": [
		794380,
		9,
		794380
	],
	"./education-center/markdown/medical/frontorhiny": [
		272645,
		9,
		272645
	],
	"./education-center/markdown/medical/frontorhiny.md": [
		272645,
		9,
		272645
	],
	"./education-center/markdown/medical/frontotemporal-dementia-andor-amyotrophic-lateral-sclerosis-1": [
		151962,
		9,
		151962
	],
	"./education-center/markdown/medical/frontotemporal-dementia-andor-amyotrophic-lateral-sclerosis-1.md": [
		151962,
		9,
		151962
	],
	"./education-center/markdown/medical/frontotemporal-dementia-tdp43-inclusions-tardbp-related": [
		780,
		9,
		780
	],
	"./education-center/markdown/medical/frontotemporal-dementia-tdp43-inclusions-tardbp-related.md": [
		780,
		9,
		780
	],
	"./education-center/markdown/medical/frontotemporal-lobar-degeneration-tardbp-related": [
		615754,
		9,
		615754
	],
	"./education-center/markdown/medical/frontotemporal-lobar-degeneration-tardbp-related.md": [
		615754,
		9,
		615754
	],
	"./education-center/markdown/medical/fulminant-hepatic-failure": [
		151052,
		9,
		151052
	],
	"./education-center/markdown/medical/fulminant-hepatic-failure.md": [
		151052,
		9,
		151052
	],
	"./education-center/markdown/medical/fumarylacetoacetase-pseudodeficiency": [
		347357,
		9,
		347357
	],
	"./education-center/markdown/medical/fumarylacetoacetase-pseudodeficiency.md": [
		347357,
		9,
		347357
	],
	"./education-center/markdown/medical/fundus-albipunctatus-autosomal-recessive": [
		864696,
		9,
		864696
	],
	"./education-center/markdown/medical/fundus-albipunctatus-autosomal-recessive.md": [
		864696,
		9,
		864696
	],
	"./education-center/markdown/medical/g6pd-deficiency": [
		637717,
		9,
		637717
	],
	"./education-center/markdown/medical/g6pd-deficiency.md": [
		637717,
		9,
		637717
	],
	"./education-center/markdown/medical/galactose-epimerase-deficiency-severe": [
		284999,
		9,
		284999
	],
	"./education-center/markdown/medical/galactose-epimerase-deficiency-severe.md": [
		284999,
		9,
		284999
	],
	"./education-center/markdown/medical/galactosialidosis-adult": [
		116202,
		9,
		116202
	],
	"./education-center/markdown/medical/galactosialidosis-adult.md": [
		116202,
		9,
		116202
	],
	"./education-center/markdown/medical/galactosialidosis-early-infantile": [
		289358,
		9,
		289358
	],
	"./education-center/markdown/medical/galactosialidosis-early-infantile.md": [
		289358,
		9,
		289358
	],
	"./education-center/markdown/medical/galactosialidosis-late-infantile": [
		948537,
		9,
		948537
	],
	"./education-center/markdown/medical/galactosialidosis-late-infantile.md": [
		948537,
		9,
		948537
	],
	"./education-center/markdown/medical/gallbladder-cancer": [
		398471,
		9,
		398471
	],
	"./education-center/markdown/medical/gallbladder-cancer.md": [
		398471,
		9,
		398471
	],
	"./education-center/markdown/medical/gallbladder-disease-4": [
		486379,
		9,
		486379
	],
	"./education-center/markdown/medical/gallbladder-disease-4.md": [
		486379,
		9,
		486379
	],
	"./education-center/markdown/medical/galloway-mowat-syndrome": [
		390683,
		9,
		390683
	],
	"./education-center/markdown/medical/galloway-mowat-syndrome.md": [
		390683,
		9,
		390683
	],
	"./education-center/markdown/medical/gars-associated-axonal-neuropathy": [
		100712,
		9,
		100712
	],
	"./education-center/markdown/medical/gars-associated-axonal-neuropathy.md": [
		100712,
		9,
		100712
	],
	"./education-center/markdown/medical/gastric-cancer": [
		761823,
		9,
		761823
	],
	"./education-center/markdown/medical/gastric-cancer-familial-diffuse-and-cleft-lip-or-without-cleft-palate": [
		847873,
		9,
		847873
	],
	"./education-center/markdown/medical/gastric-cancer-familial-diffuse-and-cleft-lip-or-without-cleft-palate.md": [
		847873,
		9,
		847873
	],
	"./education-center/markdown/medical/gastric-cancer.md": [
		761823,
		9,
		761823
	],
	"./education-center/markdown/medical/gastrointestinal-hemorrhage": [
		482753,
		9,
		482753
	],
	"./education-center/markdown/medical/gastrointestinal-hemorrhage.md": [
		482753,
		9,
		482753
	],
	"./education-center/markdown/medical/gastrointestinal-polyposis": [
		279609,
		9,
		279609
	],
	"./education-center/markdown/medical/gastrointestinal-polyposis.md": [
		279609,
		9,
		279609
	],
	"./education-center/markdown/medical/gastrointestinal-stromal-tumor-familial": [
		642497,
		9,
		642497
	],
	"./education-center/markdown/medical/gastrointestinal-stromal-tumor-familial.md": [
		642497,
		9,
		642497
	],
	"./education-center/markdown/medical/gastrointestinal-stromal-tumor-small-intestine": [
		90567,
		9,
		90567
	],
	"./education-center/markdown/medical/gastrointestinal-stromal-tumor-small-intestine.md": [
		90567,
		9,
		90567
	],
	"./education-center/markdown/medical/gbe1-related-disorders": [
		912827,
		9,
		912827
	],
	"./education-center/markdown/medical/gbe1-related-disorders.md": [
		912827,
		9,
		912827
	],
	"./education-center/markdown/medical/gefitinib-response": [
		274161,
		9,
		274161
	],
	"./education-center/markdown/medical/gefitinib-response-efficacy": [
		501487,
		9,
		501487
	],
	"./education-center/markdown/medical/gefitinib-response-efficacy.md": [
		501487,
		9,
		501487
	],
	"./education-center/markdown/medical/gefitinib-response.md": [
		274161,
		9,
		274161
	],
	"./education-center/markdown/medical/geleophysic-dysplasia": [
		804485,
		9,
		804485
	],
	"./education-center/markdown/medical/geleophysic-dysplasia.md": [
		804485,
		9,
		804485
	],
	"./education-center/markdown/medical/gemcitabine-response": [
		254419,
		9,
		254419
	],
	"./education-center/markdown/medical/gemcitabine-response.md": [
		254419,
		9,
		254419
	],
	"./education-center/markdown/medical/generalized-cerebral-atrophyhypoplasia": [
		186207,
		9,
		186207
	],
	"./education-center/markdown/medical/generalized-cerebral-atrophyhypoplasia.md": [
		186207,
		9,
		186207
	],
	"./education-center/markdown/medical/generalized-dominant-dystrophic-epidermolysis-bullosa": [
		49664,
		9,
		49664
	],
	"./education-center/markdown/medical/generalized-dominant-dystrophic-epidermolysis-bullosa.md": [
		49664,
		9,
		49664
	],
	"./education-center/markdown/medical/generalized-dystonia": [
		730263,
		9,
		730263
	],
	"./education-center/markdown/medical/generalized-dystonia.md": [
		730263,
		9,
		730263
	],
	"./education-center/markdown/medical/generalized-epilepsy-febrile-seizures-plus-3": [
		232879,
		9,
		232879
	],
	"./education-center/markdown/medical/generalized-epilepsy-febrile-seizures-plus-3.md": [
		232879,
		9,
		232879
	],
	"./education-center/markdown/medical/generalized-epilepsy-febrile-seizures-plus-type-5": [
		384192,
		9,
		384192
	],
	"./education-center/markdown/medical/generalized-epilepsy-febrile-seizures-plus-type-5.md": [
		384192,
		9,
		384192
	],
	"./education-center/markdown/medical/generalized-hypotonia": [
		756346,
		9,
		756346
	],
	"./education-center/markdown/medical/generalized-hypotonia.md": [
		756346,
		9,
		756346
	],
	"./education-center/markdown/medical/generalized-muscle-weakness": [
		777541,
		9,
		777541
	],
	"./education-center/markdown/medical/generalized-muscle-weakness.md": [
		777541,
		9,
		777541
	],
	"./education-center/markdown/medical/generalized-myoclonic-seizure": [
		190861,
		9,
		190861
	],
	"./education-center/markdown/medical/generalized-myoclonic-seizure.md": [
		190861,
		9,
		190861
	],
	"./education-center/markdown/medical/generalized-non-motor-absence-seizure": [
		103289,
		9,
		103289
	],
	"./education-center/markdown/medical/generalized-non-motor-absence-seizure.md": [
		103289,
		9,
		103289
	],
	"./education-center/markdown/medical/generalized-onset-seizure": [
		504811,
		9,
		504811
	],
	"./education-center/markdown/medical/generalized-onset-seizure.md": [
		504811,
		9,
		504811
	],
	"./education-center/markdown/medical/generalized-tonic-clonic-seizures": [
		922747,
		9,
		922747
	],
	"./education-center/markdown/medical/generalized-tonic-clonic-seizures.md": [
		922747,
		9,
		922747
	],
	"./education-center/markdown/medical/genetic-non-acquired-premature-ovarian-failure": [
		896580,
		9,
		896580
	],
	"./education-center/markdown/medical/genetic-non-acquired-premature-ovarian-failure.md": [
		896580,
		9,
		896580
	],
	"./education-center/markdown/medical/gentamicin-response": [
		465921,
		9,
		465921
	],
	"./education-center/markdown/medical/gentamicin-response.md": [
		465921,
		9,
		465921
	],
	"./education-center/markdown/medical/gerstmann-straussler-scheinker-syndrome": [
		251892,
		9,
		251892
	],
	"./education-center/markdown/medical/gerstmann-straussler-scheinker-syndrome.md": [
		251892,
		9,
		251892
	],
	"./education-center/markdown/medical/gestational-diabetes": [
		788891,
		9,
		788891
	],
	"./education-center/markdown/medical/gestational-diabetes-mellitus-uncontrolled": [
		63136,
		9,
		63136
	],
	"./education-center/markdown/medical/gestational-diabetes-mellitus-uncontrolled.md": [
		63136,
		9,
		63136
	],
	"./education-center/markdown/medical/gestational-diabetes.md": [
		788891,
		9,
		788891
	],
	"./education-center/markdown/medical/ghosal-hematodiaphyseal-syndrome": [
		710683,
		9,
		710683
	],
	"./education-center/markdown/medical/ghosal-hematodiaphyseal-syndrome.md": [
		710683,
		9,
		710683
	],
	"./education-center/markdown/medical/gil-blood-group": [
		262179,
		9,
		262179
	],
	"./education-center/markdown/medical/gil-blood-group.md": [
		262179,
		9,
		262179
	],
	"./education-center/markdown/medical/gilbert-syndrome": [
		792505,
		9,
		792505
	],
	"./education-center/markdown/medical/gilbert-syndrome-susceptibility": [
		459725,
		9,
		459725
	],
	"./education-center/markdown/medical/gilbert-syndrome-susceptibility.md": [
		459725,
		9,
		459725
	],
	"./education-center/markdown/medical/gilbert-syndrome.md": [
		792505,
		9,
		792505
	],
	"./education-center/markdown/medical/gillessen-kaesbach-nishimura-dysplasia": [
		544293,
		9,
		544293
	],
	"./education-center/markdown/medical/gillessen-kaesbach-nishimura-dysplasia.md": [
		544293,
		9,
		544293
	],
	"./education-center/markdown/medical/gingival-fibromatosis-hypertrichosis-syndrome": [
		243613,
		9,
		243613
	],
	"./education-center/markdown/medical/gingival-fibromatosis-hypertrichosis-syndrome.md": [
		243613,
		9,
		243613
	],
	"./education-center/markdown/medical/gjb6-related-disorders": [
		219641,
		9,
		219641
	],
	"./education-center/markdown/medical/gjb6-related-disorders.md": [
		219641,
		9,
		219641
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle": [
		449856,
		9,
		449856
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-autosomal-recessive": [
		401809,
		9,
		401809
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-autosomal-recessive.md": [
		401809,
		9,
		401809
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-b": [
		403786,
		9,
		403786
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-b.md": [
		403786,
		9,
		403786
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-digenic": [
		430592,
		9,
		430592
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-digenic.md": [
		430592,
		9,
		430592
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-e": [
		832187,
		9,
		832187
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-e.md": [
		832187,
		9,
		832187
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-f": [
		297037,
		9,
		297037
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-f.md": [
		297037,
		9,
		297037
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-g": [
		772467,
		9,
		772467
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-g.md": [
		772467,
		9,
		772467
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-p": [
		517934,
		9,
		517934
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle-p.md": [
		517934,
		9,
		517934
	],
	"./education-center/markdown/medical/glaucoma-1-open-angle.md": [
		449856,
		9,
		449856
	],
	"./education-center/markdown/medical/glaucoma-3-primary-congenital-digenic": [
		272588,
		9,
		272588
	],
	"./education-center/markdown/medical/glaucoma-3-primary-congenital-digenic.md": [
		272588,
		9,
		272588
	],
	"./education-center/markdown/medical/glaucoma-early-onset-digenic": [
		169917,
		9,
		169917
	],
	"./education-center/markdown/medical/glaucoma-early-onset-digenic.md": [
		169917,
		9,
		169917
	],
	"./education-center/markdown/medical/glaucoma-primary-open-angle-juvenile-onset": [
		847701,
		9,
		847701
	],
	"./education-center/markdown/medical/glaucoma-primary-open-angle-juvenile-onset.md": [
		847701,
		9,
		847701
	],
	"./education-center/markdown/medical/glb1-related-disorders": [
		191435,
		9,
		191435
	],
	"./education-center/markdown/medical/glb1-related-disorders.md": [
		191435,
		9,
		191435
	],
	"./education-center/markdown/medical/gli3-related-disorders": [
		741115,
		9,
		741115
	],
	"./education-center/markdown/medical/gli3-related-disorders.md": [
		741115,
		9,
		741115
	],
	"./education-center/markdown/medical/glibenclamide-response": [
		672197,
		9,
		672197
	],
	"./education-center/markdown/medical/glibenclamide-response.md": [
		672197,
		9,
		672197
	],
	"./education-center/markdown/medical/glioblastoma-multiforme": [
		302750,
		9,
		302750
	],
	"./education-center/markdown/medical/glioblastoma-multiforme-somatic": [
		446166,
		9,
		446166
	],
	"./education-center/markdown/medical/glioblastoma-multiforme-somatic.md": [
		446166,
		9,
		446166
	],
	"./education-center/markdown/medical/glioblastoma-multiforme.md": [
		302750,
		9,
		302750
	],
	"./education-center/markdown/medical/glipizide-response": [
		493768,
		9,
		493768
	],
	"./education-center/markdown/medical/glipizide-response.md": [
		493768,
		9,
		493768
	],
	"./education-center/markdown/medical/global-developmental-delay": [
		670852,
		9,
		670852
	],
	"./education-center/markdown/medical/global-developmental-delay.md": [
		670852,
		9,
		670852
	],
	"./education-center/markdown/medical/globozoospermia": [
		608323,
		9,
		608323
	],
	"./education-center/markdown/medical/globozoospermia.md": [
		608323,
		9,
		608323
	],
	"./education-center/markdown/medical/glomuvenous-malformation": [
		331417,
		9,
		331417
	],
	"./education-center/markdown/medical/glomuvenous-malformation.md": [
		331417,
		9,
		331417
	],
	"./education-center/markdown/medical/glucocorticoid-deficiency": [
		676447,
		9,
		676447
	],
	"./education-center/markdown/medical/glucocorticoid-deficiency.md": [
		676447,
		9,
		676447
	],
	"./education-center/markdown/medical/glucocorticoid-remediable-aldosteronism": [
		917933,
		9,
		917933
	],
	"./education-center/markdown/medical/glucocorticoid-remediable-aldosteronism.md": [
		917933,
		9,
		917933
	],
	"./education-center/markdown/medical/glucocorticoid-resistance-cellular": [
		973584,
		9,
		973584
	],
	"./education-center/markdown/medical/glucocorticoid-resistance-cellular.md": [
		973584,
		9,
		973584
	],
	"./education-center/markdown/medical/glucocorticoid-resistance-relative": [
		776900,
		9,
		776900
	],
	"./education-center/markdown/medical/glucocorticoid-resistance-relative.md": [
		776900,
		9,
		776900
	],
	"./education-center/markdown/medical/glucose-6-phosphate-transport-defect": [
		126010,
		9,
		126010
	],
	"./education-center/markdown/medical/glucose-6-phosphate-transport-defect.md": [
		126010,
		9,
		126010
	],
	"./education-center/markdown/medical/glut1-deficiency-syndrome": [
		969369,
		9,
		969369
	],
	"./education-center/markdown/medical/glut1-deficiency-syndrome-1-autosomal-recessive": [
		71981,
		9,
		71981
	],
	"./education-center/markdown/medical/glut1-deficiency-syndrome-1-autosomal-recessive.md": [
		71981,
		9,
		71981
	],
	"./education-center/markdown/medical/glut1-deficiency-syndrome.md": [
		969369,
		9,
		969369
	],
	"./education-center/markdown/medical/glutaric-acidemia-iic-late-onset": [
		986867,
		9,
		986867
	],
	"./education-center/markdown/medical/glutaric-acidemia-iic-late-onset.md": [
		986867,
		9,
		986867
	],
	"./education-center/markdown/medical/glycerol-release-during-exercise-defective": [
		934944,
		9,
		934944
	],
	"./education-center/markdown/medical/glycerol-release-during-exercise-defective.md": [
		934944,
		9,
		934944
	],
	"./education-center/markdown/medical/glycogen-phosphorylase-kinase-deficiency": [
		399937,
		9,
		399937
	],
	"./education-center/markdown/medical/glycogen-phosphorylase-kinase-deficiency.md": [
		399937,
		9,
		399937
	],
	"./education-center/markdown/medical/glycogen-storage-disease-due-phosphoglycerate-kinase-1-deficiency": [
		653243,
		9,
		653243
	],
	"./education-center/markdown/medical/glycogen-storage-disease-due-phosphoglycerate-kinase-1-deficiency.md": [
		653243,
		9,
		653243
	],
	"./education-center/markdown/medical/glycogen-storage-disease-ii-adult-form": [
		974716,
		9,
		974716
	],
	"./education-center/markdown/medical/glycogen-storage-disease-ii-adult-form.md": [
		974716,
		9,
		974716
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiia": [
		442817,
		9,
		442817
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiia.md": [
		442817,
		9,
		442817
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiib": [
		79250,
		9,
		79250
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiib.md": [
		79250,
		9,
		79250
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiic": [
		522057,
		9,
		522057
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iiic.md": [
		522057,
		9,
		522057
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-classic-hepatic": [
		874622,
		9,
		874622
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-classic-hepatic.md": [
		874622,
		9,
		874622
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-combined-hepatic-and-myopathic": [
		226225,
		9,
		226225
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-combined-hepatic-and-myopathic.md": [
		226225,
		9,
		226225
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-nonprogressive-hepatic": [
		381600,
		9,
		381600
	],
	"./education-center/markdown/medical/glycogen-storage-disease-iv-nonprogressive-hepatic.md": [
		381600,
		9,
		381600
	],
	"./education-center/markdown/medical/glycogen-storage-disease-type-ii-infantile": [
		317902,
		9,
		317902
	],
	"./education-center/markdown/medical/glycogen-storage-disease-type-ii-infantile.md": [
		317902,
		9,
		317902
	],
	"./education-center/markdown/medical/gm1-gangliosidosis-type-i-cardiac-involvement": [
		563066,
		9,
		563066
	],
	"./education-center/markdown/medical/gm1-gangliosidosis-type-i-cardiac-involvement.md": [
		563066,
		9,
		563066
	],
	"./education-center/markdown/medical/gm2-ganglioside-accumulation": [
		909214,
		9,
		909214
	],
	"./education-center/markdown/medical/gm2-ganglioside-accumulation.md": [
		909214,
		9,
		909214
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-adult-onset": [
		304823,
		9,
		304823
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-adult-onset.md": [
		304823,
		9,
		304823
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-chronic": [
		235255,
		9,
		235255
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-chronic.md": [
		235255,
		9,
		235255
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-juvenile": [
		836115,
		9,
		836115
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-juvenile.md": [
		836115,
		9,
		836115
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-variant-b1": [
		888091,
		9,
		888091
	],
	"./education-center/markdown/medical/gm2-gangliosidosis-variant-b1.md": [
		888091,
		9,
		888091
	],
	"./education-center/markdown/medical/gnptab-related-disorders": [
		449252,
		9,
		449252
	],
	"./education-center/markdown/medical/gnptab-related-disorders.md": [
		449252,
		9,
		449252
	],
	"./education-center/markdown/medical/gonadotropin-deficiency": [
		110537,
		9,
		110537
	],
	"./education-center/markdown/medical/gonadotropin-deficiency.md": [
		110537,
		9,
		110537
	],
	"./education-center/markdown/medical/gordon-syndrome": [
		541695,
		9,
		541695
	],
	"./education-center/markdown/medical/gordon-syndrome.md": [
		541695,
		9,
		541695
	],
	"./education-center/markdown/medical/gorham-stout-disease": [
		695374,
		9,
		695374
	],
	"./education-center/markdown/medical/gorham-stout-disease.md": [
		695374,
		9,
		695374
	],
	"./education-center/markdown/medical/gorlin-syndrome": [
		765322,
		9,
		765322
	],
	"./education-center/markdown/medical/gorlin-syndrome.md": [
		765322,
		9,
		765322
	],
	"./education-center/markdown/medical/gpsm2-related-disorders": [
		643826,
		9,
		643826
	],
	"./education-center/markdown/medical/gpsm2-related-disorders.md": [
		643826,
		9,
		643826
	],
	"./education-center/markdown/medical/graft-versus-host-disease-resistance": [
		560393,
		9,
		560393
	],
	"./education-center/markdown/medical/graft-versus-host-disease-resistance.md": [
		560393,
		9,
		560393
	],
	"./education-center/markdown/medical/granular-corneal-dystrophy": [
		362601,
		9,
		362601
	],
	"./education-center/markdown/medical/granular-corneal-dystrophy.md": [
		362601,
		9,
		362601
	],
	"./education-center/markdown/medical/granulomatous-disease-chronic-x-linked-variant": [
		493846,
		9,
		493846
	],
	"./education-center/markdown/medical/granulomatous-disease-chronic-x-linked-variant.md": [
		493846,
		9,
		493846
	],
	"./education-center/markdown/medical/granulosa-cell-tumor": [
		182403,
		9,
		182403
	],
	"./education-center/markdown/medical/granulosa-cell-tumor.md": [
		182403,
		9,
		182403
	],
	"./education-center/markdown/medical/gray-platelet-syndrome": [
		401597,
		9,
		401597
	],
	"./education-center/markdown/medical/gray-platelet-syndrome.md": [
		401597,
		9,
		401597
	],
	"./education-center/markdown/medical/greig-cephalopolysyndactyly-syndrome-severe": [
		746467,
		9,
		746467
	],
	"./education-center/markdown/medical/greig-cephalopolysyndactyly-syndrome-severe.md": [
		746467,
		9,
		746467
	],
	"./education-center/markdown/medical/groenouw-corneal-dystrophy-type-i": [
		551053,
		9,
		551053
	],
	"./education-center/markdown/medical/groenouw-corneal-dystrophy-type-i.md": [
		551053,
		9,
		551053
	],
	"./education-center/markdown/medical/growth-hormone-deficiency-pituitary-anomalies": [
		301272,
		9,
		301272
	],
	"./education-center/markdown/medical/growth-hormone-deficiency-pituitary-anomalies.md": [
		301272,
		9,
		301272
	],
	"./education-center/markdown/medical/guanidinoacetate-methyltransferase-gamt-deficiency": [
		552117,
		9,
		552117
	],
	"./education-center/markdown/medical/guanidinoacetate-methyltransferase-gamt-deficiency.md": [
		552117,
		9,
		552117
	],
	"./education-center/markdown/medical/gyrate-atrophy-choroid-and-retina-pyridoxine-responsive-ornithinemia": [
		337240,
		9,
		337240
	],
	"./education-center/markdown/medical/gyrate-atrophy-choroid-and-retina-pyridoxine-responsive-ornithinemia.md": [
		337240,
		9,
		337240
	],
	"./education-center/markdown/medical/haemorrhagic-telangiectasia-1": [
		249004,
		9,
		249004
	],
	"./education-center/markdown/medical/haemorrhagic-telangiectasia-1.md": [
		249004,
		9,
		249004
	],
	"./education-center/markdown/medical/haemorrhagic-telangiectasia-2": [
		958503,
		9,
		958503
	],
	"./education-center/markdown/medical/haemorrhagic-telangiectasia-2.md": [
		958503,
		9,
		958503
	],
	"./education-center/markdown/medical/hair-morphology-1-hair-thickness": [
		659495,
		9,
		659495
	],
	"./education-center/markdown/medical/hair-morphology-1-hair-thickness.md": [
		659495,
		9,
		659495
	],
	"./education-center/markdown/medical/hajdu-cheney-syndrome": [
		671439,
		9,
		671439
	],
	"./education-center/markdown/medical/hajdu-cheney-syndrome.md": [
		671439,
		9,
		671439
	],
	"./education-center/markdown/medical/hamartoma": [
		730657,
		9,
		730657
	],
	"./education-center/markdown/medical/hamartoma.md": [
		730657,
		9,
		730657
	],
	"./education-center/markdown/medical/hamartomatous-polyposis": [
		371955,
		9,
		371955
	],
	"./education-center/markdown/medical/hamartomatous-polyposis.md": [
		371955,
		9,
		371955
	],
	"./education-center/markdown/medical/hand-foot-genital-syndrome": [
		90939,
		9,
		90939
	],
	"./education-center/markdown/medical/hand-foot-genital-syndrome.md": [
		90939,
		9,
		90939
	],
	"./education-center/markdown/medical/hand-muscle-atrophy": [
		354094,
		9,
		354094
	],
	"./education-center/markdown/medical/hand-muscle-atrophy.md": [
		354094,
		9,
		354094
	],
	"./education-center/markdown/medical/hatipoglu-immunodeficiency-syndrome": [
		874428,
		9,
		874428
	],
	"./education-center/markdown/medical/hatipoglu-immunodeficiency-syndrome.md": [
		874428,
		9,
		874428
	],
	"./education-center/markdown/medical/hawkinsinuria": [
		531260,
		9,
		531260
	],
	"./education-center/markdown/medical/hawkinsinuria.md": [
		531260,
		9,
		531260
	],
	"./education-center/markdown/medical/hbb-related-disorders": [
		531740,
		9,
		531740
	],
	"./education-center/markdown/medical/hbb-related-disorders.md": [
		531740,
		9,
		531740
	],
	"./education-center/markdown/medical/head-and-neck-cancer": [
		606447,
		9,
		606447
	],
	"./education-center/markdown/medical/head-and-neck-cancer.md": [
		606447,
		9,
		606447
	],
	"./education-center/markdown/medical/head-and-neck-neoplasm": [
		368191,
		9,
		368191
	],
	"./education-center/markdown/medical/head-and-neck-neoplasm.md": [
		368191,
		9,
		368191
	],
	"./education-center/markdown/medical/hearing-loss": [
		357648,
		9,
		357648
	],
	"./education-center/markdown/medical/hearing-loss.md": [
		357648,
		9,
		357648
	],
	"./education-center/markdown/medical/heart-block-nonprogressive": [
		878163,
		9,
		878163
	],
	"./education-center/markdown/medical/heart-block-nonprogressive.md": [
		878163,
		9,
		878163
	],
	"./education-center/markdown/medical/hecht-syndrome": [
		300126,
		9,
		300126
	],
	"./education-center/markdown/medical/hecht-syndrome.md": [
		300126,
		9,
		300126
	],
	"./education-center/markdown/medical/heimler-syndrome-1": [
		498450,
		9,
		498450
	],
	"./education-center/markdown/medical/heimler-syndrome-1.md": [
		498450,
		9,
		498450
	],
	"./education-center/markdown/medical/heimler-syndrome-2": [
		989791,
		9,
		989791
	],
	"./education-center/markdown/medical/heimler-syndrome-2.md": [
		989791,
		9,
		989791
	],
	"./education-center/markdown/medical/heinz-body-anemia": [
		906270,
		9,
		906270
	],
	"./education-center/markdown/medical/heinz-body-anemia.md": [
		906270,
		9,
		906270
	],
	"./education-center/markdown/medical/helicoid-peripapillary-chorioretinal-degeneration": [
		687701,
		9,
		687701
	],
	"./education-center/markdown/medical/helicoid-peripapillary-chorioretinal-degeneration.md": [
		687701,
		9,
		687701
	],
	"./education-center/markdown/medical/hemangioma": [
		766918,
		9,
		766918
	],
	"./education-center/markdown/medical/hemangioma.md": [
		766918,
		9,
		766918
	],
	"./education-center/markdown/medical/hemangiomatosis": [
		473946,
		9,
		473946
	],
	"./education-center/markdown/medical/hemangiomatosis.md": [
		473946,
		9,
		473946
	],
	"./education-center/markdown/medical/hematologic-neoplasm": [
		735780,
		9,
		735780
	],
	"./education-center/markdown/medical/hematologic-neoplasm.md": [
		735780,
		9,
		735780
	],
	"./education-center/markdown/medical/hemihypertrophy": [
		482724,
		9,
		482724
	],
	"./education-center/markdown/medical/hemihypertrophy.md": [
		482724,
		9,
		482724
	],
	"./education-center/markdown/medical/hemiplegia": [
		451809,
		9,
		451809
	],
	"./education-center/markdown/medical/hemiplegia.md": [
		451809,
		9,
		451809
	],
	"./education-center/markdown/medical/hemiplegiahemiparesis": [
		365373,
		9,
		365373
	],
	"./education-center/markdown/medical/hemiplegiahemiparesis.md": [
		365373,
		9,
		365373
	],
	"./education-center/markdown/medical/hemochromatosis-juvenile-digenic": [
		60279,
		9,
		60279
	],
	"./education-center/markdown/medical/hemochromatosis-juvenile-digenic.md": [
		60279,
		9,
		60279
	],
	"./education-center/markdown/medical/hemoglobin-constant-spring": [
		659514,
		9,
		659514
	],
	"./education-center/markdown/medical/hemoglobin-constant-spring.md": [
		659514,
		9,
		659514
	],
	"./education-center/markdown/medical/hemoglobin-h-disease-nondeletional": [
		511870,
		9,
		511870
	],
	"./education-center/markdown/medical/hemoglobin-h-disease-nondeletional.md": [
		511870,
		9,
		511870
	],
	"./education-center/markdown/medical/hemoglobin-h-hydrops-fetalis-syndrome": [
		995878,
		9,
		995878
	],
	"./education-center/markdown/medical/hemoglobin-h-hydrops-fetalis-syndrome.md": [
		995878,
		9,
		995878
	],
	"./education-center/markdown/medical/hemoglobin-lepore-trait": [
		324709,
		9,
		324709
	],
	"./education-center/markdown/medical/hemoglobin-lepore-trait.md": [
		324709,
		9,
		324709
	],
	"./education-center/markdown/medical/hemoglobin-s": [
		356778,
		9,
		356778
	],
	"./education-center/markdown/medical/hemoglobin-s.md": [
		356778,
		9,
		356778
	],
	"./education-center/markdown/medical/hemoglobin-val-de-marne": [
		505196,
		9,
		505196
	],
	"./education-center/markdown/medical/hemoglobin-val-de-marne.md": [
		505196,
		9,
		505196
	],
	"./education-center/markdown/medical/hemolytic-anemia-nonspherocytic-and-neurologic-deficits-due-glucose-phosphate-isomerase-deficiency": [
		959741,
		9,
		959741
	],
	"./education-center/markdown/medical/hemolytic-anemia-nonspherocytic-and-neurologic-deficits-due-glucose-phosphate-isomerase-deficiency.md": [
		959741,
		9,
		959741
	],
	"./education-center/markdown/medical/hemolytic-disease-fetus-or-newborn-due-isoimmunization": [
		19462,
		9,
		19462
	],
	"./education-center/markdown/medical/hemolytic-disease-fetus-or-newborn-due-isoimmunization.md": [
		19462,
		9,
		19462
	],
	"./education-center/markdown/medical/hemolytic-uremic-syndrome": [
		586416,
		9,
		586416
	],
	"./education-center/markdown/medical/hemolytic-uremic-syndrome-atypical-susceptibility-7": [
		523850,
		9,
		523850
	],
	"./education-center/markdown/medical/hemolytic-uremic-syndrome-atypical-susceptibility-7.md": [
		523850,
		9,
		523850
	],
	"./education-center/markdown/medical/hemolytic-uremic-syndrome.md": [
		586416,
		9,
		586416
	],
	"./education-center/markdown/medical/hemophagocytosis": [
		880806,
		9,
		880806
	],
	"./education-center/markdown/medical/hemophagocytosis.md": [
		880806,
		9,
		880806
	],
	"./education-center/markdown/medical/hemophilia-b-factor-ix-deficiency": [
		507791,
		9,
		507791
	],
	"./education-center/markdown/medical/hemophilia-b-factor-ix-deficiency.md": [
		507791,
		9,
		507791
	],
	"./education-center/markdown/medical/hemophilia-bm": [
		411690,
		9,
		411690
	],
	"./education-center/markdown/medical/hemophilia-bm.md": [
		411690,
		9,
		411690
	],
	"./education-center/markdown/medical/hemophilia-fviii-deficiency": [
		385230,
		9,
		385230
	],
	"./education-center/markdown/medical/hemophilia-fviii-deficiency.md": [
		385230,
		9,
		385230
	],
	"./education-center/markdown/medical/hemorrhage": [
		640601,
		9,
		640601
	],
	"./education-center/markdown/medical/hemorrhage.md": [
		640601,
		9,
		640601
	],
	"./education-center/markdown/medical/hemosiderosis-systemic-due-aceruloplasminemia": [
		850806,
		9,
		850806
	],
	"./education-center/markdown/medical/hemosiderosis-systemic-due-aceruloplasminemia.md": [
		850806,
		9,
		850806
	],
	"./education-center/markdown/medical/hepatitis-b-virus-resistance": [
		218365,
		9,
		218365
	],
	"./education-center/markdown/medical/hepatitis-b-virus-resistance.md": [
		218365,
		9,
		218365
	],
	"./education-center/markdown/medical/hepatitis-c-virus-infection-response-therapy": [
		792244,
		9,
		792244
	],
	"./education-center/markdown/medical/hepatitis-c-virus-infection-response-therapy.md": [
		792244,
		9,
		792244
	],
	"./education-center/markdown/medical/hepatocellular-carcinoma": [
		620851,
		9,
		620851
	],
	"./education-center/markdown/medical/hepatocellular-carcinoma.md": [
		620851,
		9,
		620851
	],
	"./education-center/markdown/medical/hepatorenocardiac-degenerative-fibrosis": [
		521463,
		9,
		521463
	],
	"./education-center/markdown/medical/hepatorenocardiac-degenerative-fibrosis.md": [
		521463,
		9,
		521463
	],
	"./education-center/markdown/medical/her2-positive-breast-carcinoma": [
		890629,
		9,
		890629
	],
	"./education-center/markdown/medical/her2-positive-breast-carcinoma.md": [
		890629,
		9,
		890629
	],
	"./education-center/markdown/medical/hereditary-arterial-and-articular-multiple-calcification-syndrome": [
		298933,
		9,
		298933
	],
	"./education-center/markdown/medical/hereditary-arterial-and-articular-multiple-calcification-syndrome.md": [
		298933,
		9,
		298933
	],
	"./education-center/markdown/medical/hereditary-cancer": [
		396506,
		9,
		396506
	],
	"./education-center/markdown/medical/hereditary-cancer.md": [
		396506,
		9,
		396506
	],
	"./education-center/markdown/medical/hereditary-cerebral-amyloid-angiopathy-icelandic-type": [
		192015,
		9,
		192015
	],
	"./education-center/markdown/medical/hereditary-cerebral-amyloid-angiopathy-icelandic-type.md": [
		192015,
		9,
		192015
	],
	"./education-center/markdown/medical/hereditary-cerebral-hemorrhage-amyloidosis": [
		807706,
		9,
		807706
	],
	"./education-center/markdown/medical/hereditary-cerebral-hemorrhage-amyloidosis.md": [
		807706,
		9,
		807706
	],
	"./education-center/markdown/medical/hereditary-coproporphyria": [
		815369,
		9,
		815369
	],
	"./education-center/markdown/medical/hereditary-coproporphyria.md": [
		815369,
		9,
		815369
	],
	"./education-center/markdown/medical/hereditary-diffuse-gastric-adenocarcinoma": [
		4869,
		9,
		4869
	],
	"./education-center/markdown/medical/hereditary-diffuse-gastric-adenocarcinoma.md": [
		4869,
		9,
		4869
	],
	"./education-center/markdown/medical/hereditary-essential-tremor": [
		723954,
		9,
		723954
	],
	"./education-center/markdown/medical/hereditary-essential-tremor.md": [
		723954,
		9,
		723954
	],
	"./education-center/markdown/medical/hereditary-hearing-loss-and-deafness": [
		225275,
		9,
		225275
	],
	"./education-center/markdown/medical/hereditary-hearing-loss-and-deafness.md": [
		225275,
		9,
		225275
	],
	"./education-center/markdown/medical/hereditary-hemochromatosis": [
		581361,
		9,
		581361
	],
	"./education-center/markdown/medical/hereditary-hemochromatosis.md": [
		581361,
		9,
		581361
	],
	"./education-center/markdown/medical/hereditary-hypercarotenemia-and-vitamin-deficiency": [
		966586,
		9,
		966586
	],
	"./education-center/markdown/medical/hereditary-hypercarotenemia-and-vitamin-deficiency.md": [
		966586,
		9,
		966586
	],
	"./education-center/markdown/medical/hereditary-leiomyomatosis-and-renal-cell-cancer": [
		241509,
		9,
		241509
	],
	"./education-center/markdown/medical/hereditary-leiomyomatosis-and-renal-cell-cancer.md": [
		241509,
		9,
		241509
	],
	"./education-center/markdown/medical/hereditary-lymphedema-type-i": [
		672178,
		9,
		672178
	],
	"./education-center/markdown/medical/hereditary-lymphedema-type-i.md": [
		672178,
		9,
		672178
	],
	"./education-center/markdown/medical/hereditary-multiple-osteochondromatosis": [
		102222,
		9,
		102222
	],
	"./education-center/markdown/medical/hereditary-multiple-osteochondromatosis.md": [
		102222,
		9,
		102222
	],
	"./education-center/markdown/medical/hereditary-neuralgic-amyotrophy-hna": [
		582597,
		9,
		582597
	],
	"./education-center/markdown/medical/hereditary-neuralgic-amyotrophy-hna.md": [
		582597,
		9,
		582597
	],
	"./education-center/markdown/medical/hereditary-nonpolyposis-colorectal-carcinoma": [
		428387,
		9,
		428387
	],
	"./education-center/markdown/medical/hereditary-nonpolyposis-colorectal-carcinoma.md": [
		428387,
		9,
		428387
	],
	"./education-center/markdown/medical/hereditary-nonpolyposis-colorectal-neoplasms": [
		450826,
		9,
		450826
	],
	"./education-center/markdown/medical/hereditary-nonpolyposis-colorectal-neoplasms.md": [
		450826,
		9,
		450826
	],
	"./education-center/markdown/medical/hereditary-orotic-aciduria-type-1": [
		919522,
		9,
		919522
	],
	"./education-center/markdown/medical/hereditary-orotic-aciduria-type-1.md": [
		919522,
		9,
		919522
	],
	"./education-center/markdown/medical/hereditary-sideroblastic-anemia-myopathy-and-lactic-acidosis": [
		31059,
		9,
		31059
	],
	"./education-center/markdown/medical/hereditary-sideroblastic-anemia-myopathy-and-lactic-acidosis.md": [
		31059,
		9,
		31059
	],
	"./education-center/markdown/medical/hereditary-spherocytosis": [
		983944,
		9,
		983944
	],
	"./education-center/markdown/medical/hereditary-spherocytosis-type-2": [
		317716,
		9,
		317716
	],
	"./education-center/markdown/medical/hereditary-spherocytosis-type-2.md": [
		317716,
		9,
		317716
	],
	"./education-center/markdown/medical/hereditary-spherocytosis.md": [
		983944,
		9,
		983944
	],
	"./education-center/markdown/medical/heritable-thoracic-aortic-disease": [
		354558,
		9,
		354558
	],
	"./education-center/markdown/medical/heritable-thoracic-aortic-disease.md": [
		354558,
		9,
		354558
	],
	"./education-center/markdown/medical/heterogeneous-nuclear-ribonucleoprotein-g-human": [
		989294,
		9,
		989294
	],
	"./education-center/markdown/medical/heterogeneous-nuclear-ribonucleoprotein-g-human.md": [
		989294,
		9,
		989294
	],
	"./education-center/markdown/medical/heterotaxy": [
		172813,
		9,
		172813
	],
	"./education-center/markdown/medical/heterotaxy-visceral-12-autosomal": [
		125810,
		9,
		125810
	],
	"./education-center/markdown/medical/heterotaxy-visceral-12-autosomal.md": [
		125810,
		9,
		125810
	],
	"./education-center/markdown/medical/heterotaxy.md": [
		172813,
		9,
		172813
	],
	"./education-center/markdown/medical/hexosaminidase-b-paris": [
		340065,
		9,
		340065
	],
	"./education-center/markdown/medical/hexosaminidase-b-paris.md": [
		340065,
		9,
		340065
	],
	"./education-center/markdown/medical/hiatus-hernia": [
		940897,
		9,
		940897
	],
	"./education-center/markdown/medical/hiatus-hernia.md": [
		940897,
		9,
		940897
	],
	"./education-center/markdown/medical/hidrotic-ectodermal-dysplasia-syndrome": [
		32237,
		9,
		32237
	],
	"./education-center/markdown/medical/hidrotic-ectodermal-dysplasia-syndrome.md": [
		32237,
		9,
		32237
	],
	"./education-center/markdown/medical/high-bone-mass": [
		232982,
		9,
		232982
	],
	"./education-center/markdown/medical/high-bone-mass.md": [
		232982,
		9,
		232982
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-10": [
		131293,
		9,
		131293
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-10.md": [
		131293,
		9,
		131293
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-11": [
		924031,
		9,
		924031
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-11.md": [
		924031,
		9,
		924031
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-12": [
		527591,
		9,
		527591
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-12.md": [
		527591,
		9,
		527591
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6": [
		417796,
		9,
		417796
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.md": [
		417796,
		9,
		417796
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7": [
		149168,
		9,
		149168
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.md": [
		149168,
		9,
		149168
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8": [
		639405,
		9,
		639405
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.md": [
		639405,
		9,
		639405
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-9": [
		418443,
		9,
		418443
	],
	"./education-center/markdown/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-9.md": [
		418443,
		9,
		418443
	],
	"./education-center/markdown/medical/high-grade-surface-osteosarcoma": [
		790513,
		9,
		790513
	],
	"./education-center/markdown/medical/high-grade-surface-osteosarcoma.md": [
		790513,
		9,
		790513
	],
	"./education-center/markdown/medical/high-myopia": [
		905776,
		9,
		905776
	],
	"./education-center/markdown/medical/high-myopia.md": [
		905776,
		9,
		905776
	],
	"./education-center/markdown/medical/hip-dysplasia-beukes-type": [
		376084,
		9,
		376084
	],
	"./education-center/markdown/medical/hip-dysplasia-beukes-type.md": [
		376084,
		9,
		376084
	],
	"./education-center/markdown/medical/hirschsprung-disease-dominant": [
		647384,
		9,
		647384
	],
	"./education-center/markdown/medical/hirschsprung-disease-dominant.md": [
		647384,
		9,
		647384
	],
	"./education-center/markdown/medical/hirschsprung-disease-intellectual-disability-syndrome-late-infantile": [
		252583,
		9,
		252583
	],
	"./education-center/markdown/medical/hirschsprung-disease-intellectual-disability-syndrome-late-infantile.md": [
		252583,
		9,
		252583
	],
	"./education-center/markdown/medical/hirschsprung-disease-protection-against": [
		101978,
		9,
		101978
	],
	"./education-center/markdown/medical/hirschsprung-disease-protection-against.md": [
		101978,
		9,
		101978
	],
	"./education-center/markdown/medical/hirschsprung-disease-recessive": [
		282926,
		9,
		282926
	],
	"./education-center/markdown/medical/hirschsprung-disease-recessive.md": [
		282926,
		9,
		282926
	],
	"./education-center/markdown/medical/hirschsprung-disease-susceptibility-1": [
		677711,
		9,
		677711
	],
	"./education-center/markdown/medical/hirschsprung-disease-susceptibility-1.md": [
		677711,
		9,
		677711
	],
	"./education-center/markdown/medical/history-neurodevelopmental-disorder": [
		309295,
		9,
		309295
	],
	"./education-center/markdown/medical/history-neurodevelopmental-disorder.md": [
		309295,
		9,
		309295
	],
	"./education-center/markdown/medical/hiv-1-viremia-susceptibility": [
		229972,
		9,
		229972
	],
	"./education-center/markdown/medical/hiv-1-viremia-susceptibility.md": [
		229972,
		9,
		229972
	],
	"./education-center/markdown/medical/holoprosencephaly-2": [
		749124,
		9,
		749124
	],
	"./education-center/markdown/medical/holoprosencephaly-2.md": [
		749124,
		9,
		749124
	],
	"./education-center/markdown/medical/holoprosencephaly-3": [
		316285,
		9,
		316285
	],
	"./education-center/markdown/medical/holoprosencephaly-3.md": [
		316285,
		9,
		316285
	],
	"./education-center/markdown/medical/holoprosencephaly-4": [
		401385,
		9,
		401385
	],
	"./education-center/markdown/medical/holoprosencephaly-4.md": [
		401385,
		9,
		401385
	],
	"./education-center/markdown/medical/holt-oram-syndrome": [
		254306,
		9,
		254306
	],
	"./education-center/markdown/medical/holt-oram-syndrome.md": [
		254306,
		9,
		254306
	],
	"./education-center/markdown/medical/homocysteine-level-elevated": [
		289396,
		9,
		289396
	],
	"./education-center/markdown/medical/homocysteine-level-elevated.md": [
		289396,
		9,
		289396
	],
	"./education-center/markdown/medical/homocystinuria-cbld-type-variant-1": [
		747247,
		9,
		747247
	],
	"./education-center/markdown/medical/homocystinuria-cbld-type-variant-1.md": [
		747247,
		9,
		747247
	],
	"./education-center/markdown/medical/homocystinuria-due-mthfr-deficiency": [
		132793,
		9,
		132793
	],
	"./education-center/markdown/medical/homocystinuria-due-mthfr-deficiency.md": [
		132793,
		9,
		132793
	],
	"./education-center/markdown/medical/homocystinuria-pyridoxine-nonresponsive": [
		712855,
		9,
		712855
	],
	"./education-center/markdown/medical/homocystinuria-pyridoxine-nonresponsive.md": [
		712855,
		9,
		712855
	],
	"./education-center/markdown/medical/homocystinuria-pyridoxine-responsive": [
		556813,
		9,
		556813
	],
	"./education-center/markdown/medical/homocystinuria-pyridoxine-responsive.md": [
		556813,
		9,
		556813
	],
	"./education-center/markdown/medical/hr-related-disorders": [
		303846,
		9,
		303846
	],
	"./education-center/markdown/medical/hr-related-disorders.md": [
		303846,
		9,
		303846
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-delayed-disease-progression-infection": [
		157379,
		9,
		157379
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-delayed-disease-progression-infection.md": [
		157379,
		9,
		157379
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-increased-perinatal-transmission": [
		730842,
		9,
		730842
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-increased-perinatal-transmission.md": [
		730842,
		9,
		730842
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-rapid-disease-progression-infection": [
		336297,
		9,
		336297
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-rapid-disease-progression-infection.md": [
		336297,
		9,
		336297
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-rapid-progression-aids": [
		213386,
		9,
		213386
	],
	"./education-center/markdown/medical/human-immunodeficiency-virus-type-1-rapid-progression-aids.md": [
		213386,
		9,
		213386
	],
	"./education-center/markdown/medical/huntington-disease": [
		237185,
		9,
		237185
	],
	"./education-center/markdown/medical/huntington-disease.md": [
		237185,
		9,
		237185
	],
	"./education-center/markdown/medical/hutchinson-gilford-progeria-syndrome-atypical": [
		972194,
		9,
		972194
	],
	"./education-center/markdown/medical/hutchinson-gilford-progeria-syndrome-atypical.md": [
		972194,
		9,
		972194
	],
	"./education-center/markdown/medical/hutchinson-gilford-progeria-syndrome-childhood-onset": [
		270151,
		9,
		270151
	],
	"./education-center/markdown/medical/hutchinson-gilford-progeria-syndrome-childhood-onset.md": [
		270151,
		9,
		270151
	],
	"./education-center/markdown/medical/hyalinosis-segmental-glomerular": [
		144486,
		9,
		144486
	],
	"./education-center/markdown/medical/hyalinosis-segmental-glomerular.md": [
		144486,
		9,
		144486
	],
	"./education-center/markdown/medical/hydatidiform-mole": [
		204829,
		9,
		204829
	],
	"./education-center/markdown/medical/hydatidiform-mole.md": [
		204829,
		9,
		204829
	],
	"./education-center/markdown/medical/hydranencephaly-abnormal-genitalia": [
		148982,
		9,
		148982
	],
	"./education-center/markdown/medical/hydranencephaly-abnormal-genitalia.md": [
		148982,
		9,
		148982
	],
	"./education-center/markdown/medical/hydrocephalus": [
		439984,
		9,
		439984
	],
	"./education-center/markdown/medical/hydrocephalus-due-aqueductal-stenosis": [
		604935,
		9,
		604935
	],
	"./education-center/markdown/medical/hydrocephalus-due-aqueductal-stenosis.md": [
		604935,
		9,
		604935
	],
	"./education-center/markdown/medical/hydrocephalus-x-linked-congenital-idiopathic-intestinal-pseudoobstruction": [
		372180,
		9,
		372180
	],
	"./education-center/markdown/medical/hydrocephalus-x-linked-congenital-idiopathic-intestinal-pseudoobstruction.md": [
		372180,
		9,
		372180
	],
	"./education-center/markdown/medical/hydrocephalus.md": [
		439984,
		9,
		439984
	],
	"./education-center/markdown/medical/hydrochlorothiazide-response-efficacy": [
		277869,
		9,
		277869
	],
	"./education-center/markdown/medical/hydrochlorothiazide-response-efficacy.md": [
		277869,
		9,
		277869
	],
	"./education-center/markdown/medical/hydrolethalus-syndrome": [
		538633,
		9,
		538633
	],
	"./education-center/markdown/medical/hydrolethalus-syndrome.md": [
		538633,
		9,
		538633
	],
	"./education-center/markdown/medical/hyper-ige-recurrent-infection-syndrome-1": [
		631216,
		9,
		631216
	],
	"./education-center/markdown/medical/hyper-ige-recurrent-infection-syndrome-1.md": [
		631216,
		9,
		631216
	],
	"./education-center/markdown/medical/hyperalphalipoproteinemia-1": [
		62746,
		9,
		62746
	],
	"./education-center/markdown/medical/hyperalphalipoproteinemia-1.md": [
		62746,
		9,
		62746
	],
	"./education-center/markdown/medical/hyperammonemia": [
		225554,
		9,
		225554
	],
	"./education-center/markdown/medical/hyperammonemia.md": [
		225554,
		9,
		225554
	],
	"./education-center/markdown/medical/hyperandrogenism-nonclassic-type-due-21-hydroxylase-deficiency": [
		286122,
		9,
		286122
	],
	"./education-center/markdown/medical/hyperandrogenism-nonclassic-type-due-21-hydroxylase-deficiency.md": [
		286122,
		9,
		286122
	],
	"./education-center/markdown/medical/hyperapobetalipoproteinemia-susceptibility": [
		145107,
		9,
		145107
	],
	"./education-center/markdown/medical/hyperapobetalipoproteinemia-susceptibility.md": [
		145107,
		9,
		145107
	],
	"./education-center/markdown/medical/hypercalcemia": [
		337581,
		9,
		337581
	],
	"./education-center/markdown/medical/hypercalcemia.md": [
		337581,
		9,
		337581
	],
	"./education-center/markdown/medical/hypercalciuria-childhood-self-limiting": [
		327277,
		9,
		327277
	],
	"./education-center/markdown/medical/hypercalciuria-childhood-self-limiting.md": [
		327277,
		9,
		327277
	],
	"./education-center/markdown/medical/hypercholesterolemia": [
		459665,
		9,
		459665
	],
	"./education-center/markdown/medical/hypercholesterolemia-autosomal-dominant-type-b": [
		204757,
		9,
		204757
	],
	"./education-center/markdown/medical/hypercholesterolemia-autosomal-dominant-type-b.md": [
		204757,
		9,
		204757
	],
	"./education-center/markdown/medical/hypercholesterolemia-familial-1": [
		611643,
		9,
		611643
	],
	"./education-center/markdown/medical/hypercholesterolemia-familial-1.md": [
		611643,
		9,
		611643
	],
	"./education-center/markdown/medical/hypercholesterolemia-susceptibility": [
		864441,
		9,
		864441
	],
	"./education-center/markdown/medical/hypercholesterolemia-susceptibility.md": [
		864441,
		9,
		864441
	],
	"./education-center/markdown/medical/hypercholesterolemia.md": [
		459665,
		9,
		459665
	],
	"./education-center/markdown/medical/hyperechogenic-kidneys": [
		935503,
		9,
		935503
	],
	"./education-center/markdown/medical/hyperechogenic-kidneys.md": [
		935503,
		9,
		935503
	],
	"./education-center/markdown/medical/hyperekplexia-1": [
		746981,
		9,
		746981
	],
	"./education-center/markdown/medical/hyperekplexia-1.md": [
		746981,
		9,
		746981
	],
	"./education-center/markdown/medical/hypereosinophilic-syndrome-idiopathic-resistant-imatinib": [
		788670,
		9,
		788670
	],
	"./education-center/markdown/medical/hypereosinophilic-syndrome-idiopathic-resistant-imatinib.md": [
		788670,
		9,
		788670
	],
	"./education-center/markdown/medical/hyperglycinuria": [
		439956,
		9,
		439956
	],
	"./education-center/markdown/medical/hyperglycinuria.md": [
		439956,
		9,
		439956
	],
	"./education-center/markdown/medical/hypergonadotropic-hypogonadism": [
		248471,
		9,
		248471
	],
	"./education-center/markdown/medical/hypergonadotropic-hypogonadism.md": [
		248471,
		9,
		248471
	],
	"./education-center/markdown/medical/hyperhomocysteinemia-thrombotic-cbs-related": [
		152427,
		9,
		152427
	],
	"./education-center/markdown/medical/hyperhomocysteinemia-thrombotic-cbs-related.md": [
		152427,
		9,
		152427
	],
	"./education-center/markdown/medical/hyperinsulinemic-hypoglycemia": [
		18499,
		9,
		18499
	],
	"./education-center/markdown/medical/hyperinsulinemic-hypoglycemia.md": [
		18499,
		9,
		18499
	],
	"./education-center/markdown/medical/hyperinsulinism-dominant": [
		690999,
		9,
		690999
	],
	"./education-center/markdown/medical/hyperinsulinism-dominant.md": [
		690999,
		9,
		690999
	],
	"./education-center/markdown/medical/hyperinsulinism-dominantrecessive": [
		686486,
		9,
		686486
	],
	"./education-center/markdown/medical/hyperinsulinism-dominantrecessive.md": [
		686486,
		9,
		686486
	],
	"./education-center/markdown/medical/hyperkeratotic-cutaneous-capillary-venous-malformations-associated-cerebral-capillary-malformations": [
		531158,
		9,
		531158
	],
	"./education-center/markdown/medical/hyperkeratotic-cutaneous-capillary-venous-malformations-associated-cerebral-capillary-malformations.md": [
		531158,
		9,
		531158
	],
	"./education-center/markdown/medical/hyperlipidemia-familial-combined-lpl-related": [
		963627,
		9,
		963627
	],
	"./education-center/markdown/medical/hyperlipidemia-familial-combined-lpl-related.md": [
		963627,
		9,
		963627
	],
	"./education-center/markdown/medical/hyperlipidemia-familial-combined-susceptibility": [
		750226,
		9,
		750226
	],
	"./education-center/markdown/medical/hyperlipidemia-familial-combined-susceptibility.md": [
		750226,
		9,
		750226
	],
	"./education-center/markdown/medical/hyperlipoproteinemia-type-iii-due-apoe2": [
		524115,
		9,
		524115
	],
	"./education-center/markdown/medical/hyperlipoproteinemia-type-iii-due-apoe2.md": [
		524115,
		9,
		524115
	],
	"./education-center/markdown/medical/hypermagnesemia": [
		71714,
		9,
		71714
	],
	"./education-center/markdown/medical/hypermagnesemia.md": [
		71714,
		9,
		71714
	],
	"./education-center/markdown/medical/hypermetabolism-due-uncoupled-mitochondrial-oxidative-phosphorylation-2": [
		324678,
		9,
		324678
	],
	"./education-center/markdown/medical/hypermetabolism-due-uncoupled-mitochondrial-oxidative-phosphorylation-2.md": [
		324678,
		9,
		324678
	],
	"./education-center/markdown/medical/hypermethioninemia": [
		614232,
		9,
		614232
	],
	"./education-center/markdown/medical/hypermethioninemia.md": [
		614232,
		9,
		614232
	],
	"./education-center/markdown/medical/hyperornithinemia": [
		640275,
		9,
		640275
	],
	"./education-center/markdown/medical/hyperornithinemia.md": [
		640275,
		9,
		640275
	],
	"./education-center/markdown/medical/hyperostosis-cranialis-interna": [
		678485,
		9,
		678485
	],
	"./education-center/markdown/medical/hyperostosis-cranialis-interna.md": [
		678485,
		9,
		678485
	],
	"./education-center/markdown/medical/hyperparathyroidism-1": [
		474227,
		9,
		474227
	],
	"./education-center/markdown/medical/hyperparathyroidism-1.md": [
		474227,
		9,
		474227
	],
	"./education-center/markdown/medical/hyperparathyroidism-2-jaw-tumors": [
		545374,
		9,
		545374
	],
	"./education-center/markdown/medical/hyperparathyroidism-2-jaw-tumors.md": [
		545374,
		9,
		545374
	],
	"./education-center/markdown/medical/hyperphenylalaninemia": [
		344907,
		9,
		344907
	],
	"./education-center/markdown/medical/hyperphenylalaninemia-bh4-deficient-due-partial-pts-deficiency": [
		982945,
		9,
		982945
	],
	"./education-center/markdown/medical/hyperphenylalaninemia-bh4-deficient-due-partial-pts-deficiency.md": [
		982945,
		9,
		982945
	],
	"./education-center/markdown/medical/hyperphenylalaninemia.md": [
		344907,
		9,
		344907
	],
	"./education-center/markdown/medical/hyperpigmentation-or-without-hypopigmentation-familial-progressive": [
		400272,
		9,
		400272
	],
	"./education-center/markdown/medical/hyperpigmentation-or-without-hypopigmentation-familial-progressive.md": [
		400272,
		9,
		400272
	],
	"./education-center/markdown/medical/hyperproreninemia-familial": [
		117292,
		9,
		117292
	],
	"./education-center/markdown/medical/hyperproreninemia-familial.md": [
		117292,
		9,
		117292
	],
	"./education-center/markdown/medical/hypertaurinuric-cardiomyopathy": [
		780948,
		9,
		780948
	],
	"./education-center/markdown/medical/hypertaurinuric-cardiomyopathy.md": [
		780948,
		9,
		780948
	],
	"./education-center/markdown/medical/hypertension-diastolic-resistance": [
		417332,
		9,
		417332
	],
	"./education-center/markdown/medical/hypertension-diastolic-resistance.md": [
		417332,
		9,
		417332
	],
	"./education-center/markdown/medical/hypertension-early-onset-autosomal-dominant-exacerbation-pregnancy": [
		37599,
		9,
		37599
	],
	"./education-center/markdown/medical/hypertension-early-onset-autosomal-dominant-exacerbation-pregnancy.md": [
		37599,
		9,
		37599
	],
	"./education-center/markdown/medical/hypertension-pregnancy-induced-susceptibility": [
		467281,
		9,
		467281
	],
	"./education-center/markdown/medical/hypertension-pregnancy-induced-susceptibility.md": [
		467281,
		9,
		467281
	],
	"./education-center/markdown/medical/hypertension-resistant-conventional-therapy": [
		973199,
		9,
		973199
	],
	"./education-center/markdown/medical/hypertension-resistant-conventional-therapy.md": [
		973199,
		9,
		973199
	],
	"./education-center/markdown/medical/hypertension-salt-sensitive-essential-susceptibility": [
		930099,
		9,
		930099
	],
	"./education-center/markdown/medical/hypertension-salt-sensitive-essential-susceptibility.md": [
		930099,
		9,
		930099
	],
	"./education-center/markdown/medical/hyperthyroxinemia-dysalbuminemic": [
		173860,
		9,
		173860
	],
	"./education-center/markdown/medical/hyperthyroxinemia-dysalbuminemic.md": [
		173860,
		9,
		173860
	],
	"./education-center/markdown/medical/hyperthyroxinemia-dystransthyretinemic": [
		163540,
		9,
		163540
	],
	"./education-center/markdown/medical/hyperthyroxinemia-dystransthyretinemic.md": [
		163540,
		9,
		163540
	],
	"./education-center/markdown/medical/hypertriglyceridemia-2": [
		366165,
		9,
		366165
	],
	"./education-center/markdown/medical/hypertriglyceridemia-2.md": [
		366165,
		9,
		366165
	],
	"./education-center/markdown/medical/hypertriglyceridemia-familial": [
		628626,
		9,
		628626
	],
	"./education-center/markdown/medical/hypertriglyceridemia-familial.md": [
		628626,
		9,
		628626
	],
	"./education-center/markdown/medical/hypertrophic-cardiomyopathy-2": [
		512268,
		9,
		512268
	],
	"./education-center/markdown/medical/hypertrophic-cardiomyopathy-2.md": [
		512268,
		9,
		512268
	],
	"./education-center/markdown/medical/hypertrophic-cardiomyopathy-4": [
		367385,
		9,
		367385
	],
	"./education-center/markdown/medical/hypertrophic-cardiomyopathy-4.md": [
		367385,
		9,
		367385
	],
	"./education-center/markdown/medical/hypertyrosinemia": [
		243202,
		9,
		243202
	],
	"./education-center/markdown/medical/hypertyrosinemia.md": [
		243202,
		9,
		243202
	],
	"./education-center/markdown/medical/hypoadiponectinemia": [
		589551,
		9,
		589551
	],
	"./education-center/markdown/medical/hypoadiponectinemia.md": [
		589551,
		9,
		589551
	],
	"./education-center/markdown/medical/hypoalphalipoproteinemia-primary-2-intermediate": [
		710539,
		9,
		710539
	],
	"./education-center/markdown/medical/hypoalphalipoproteinemia-primary-2-intermediate.md": [
		710539,
		9,
		710539
	],
	"./education-center/markdown/medical/hypoammonemia": [
		282688,
		9,
		282688
	],
	"./education-center/markdown/medical/hypoammonemia.md": [
		282688,
		9,
		282688
	],
	"./education-center/markdown/medical/hypoceruloplasminemia": [
		692410,
		9,
		692410
	],
	"./education-center/markdown/medical/hypoceruloplasminemia.md": [
		692410,
		9,
		692410
	],
	"./education-center/markdown/medical/hypochondroplasia": [
		133773,
		9,
		133773
	],
	"./education-center/markdown/medical/hypochondroplasia.md": [
		133773,
		9,
		133773
	],
	"./education-center/markdown/medical/hypodysfibrinogenemia": [
		811378,
		9,
		811378
	],
	"./education-center/markdown/medical/hypodysfibrinogenemia.md": [
		811378,
		9,
		811378
	],
	"./education-center/markdown/medical/hypofibrinogenemia": [
		743774,
		9,
		743774
	],
	"./education-center/markdown/medical/hypofibrinogenemia.md": [
		743774,
		9,
		743774
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-10-without-anosmia": [
		909542,
		9,
		909542
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-10-without-anosmia.md": [
		909542,
		9,
		909542
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-14-anosmia": [
		875180,
		9,
		875180
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-14-anosmia.md": [
		875180,
		9,
		875180
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-15-anosmia": [
		1498,
		9,
		1498
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-15-anosmia.md": [
		1498,
		9,
		1498
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-18-anosmia": [
		969633,
		9,
		969633
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-18-anosmia.md": [
		969633,
		9,
		969633
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-2-anosmia": [
		85114,
		9,
		85114
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-2-anosmia.md": [
		85114,
		9,
		85114
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-2-or-without-anosmia": [
		837488,
		9,
		837488
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-2-or-without-anosmia.md": [
		837488,
		9,
		837488
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-20-without-anosmia": [
		258040,
		9,
		258040
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-20-without-anosmia.md": [
		258040,
		9,
		258040
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-22-anosmia": [
		166207,
		9,
		166207
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-22-anosmia.md": [
		166207,
		9,
		166207
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-3-without-anosmia": [
		64855,
		9,
		64855
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-3-without-anosmia.md": [
		64855,
		9,
		64855
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-5-without-anosmia": [
		403957,
		9,
		403957
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-5-without-anosmia.md": [
		403957,
		9,
		403957
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-7-or-without-anosmia": [
		805806,
		9,
		805806
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-7-or-without-anosmia.md": [
		805806,
		9,
		805806
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-8-without-anosmia": [
		383491,
		9,
		383491
	],
	"./education-center/markdown/medical/hypogonadotropic-hypogonadism-8-without-anosmia.md": [
		383491,
		9,
		383491
	],
	"./education-center/markdown/medical/hypohidrotic-ectodermal-dysplasia-dominant": [
		847487,
		9,
		847487
	],
	"./education-center/markdown/medical/hypohidrotic-ectodermal-dysplasia-dominant.md": [
		847487,
		9,
		847487
	],
	"./education-center/markdown/medical/hypohidrotic-ectodermal-dysplasia-recessive": [
		920099,
		9,
		920099
	],
	"./education-center/markdown/medical/hypohidrotic-ectodermal-dysplasia-recessive.md": [
		920099,
		9,
		920099
	],
	"./education-center/markdown/medical/hypoinsulinemia": [
		277134,
		9,
		277134
	],
	"./education-center/markdown/medical/hypoinsulinemia.md": [
		277134,
		9,
		277134
	],
	"./education-center/markdown/medical/hypokalemic-tubulopathy-and-deafness": [
		665237,
		9,
		665237
	],
	"./education-center/markdown/medical/hypokalemic-tubulopathy-and-deafness.md": [
		665237,
		9,
		665237
	],
	"./education-center/markdown/medical/hypokinetic-non-dilated-cardiomyopathy": [
		26950,
		9,
		26950
	],
	"./education-center/markdown/medical/hypokinetic-non-dilated-cardiomyopathy.md": [
		26950,
		9,
		26950
	],
	"./education-center/markdown/medical/hypomaturation-hypoplastic-amelogenesis-imperfecta-taurodontism": [
		333803,
		9,
		333803
	],
	"./education-center/markdown/medical/hypomaturation-hypoplastic-amelogenesis-imperfecta-taurodontism.md": [
		333803,
		9,
		333803
	],
	"./education-center/markdown/medical/hypoparathyroidism-deafness-renal-disease-syndrome": [
		511865,
		9,
		511865
	],
	"./education-center/markdown/medical/hypoparathyroidism-deafness-renal-disease-syndrome.md": [
		511865,
		9,
		511865
	],
	"./education-center/markdown/medical/hypoparathyroidism-familial-isolated-1": [
		972693,
		9,
		972693
	],
	"./education-center/markdown/medical/hypoparathyroidism-familial-isolated-1.md": [
		972693,
		9,
		972693
	],
	"./education-center/markdown/medical/hypophosphatemia": [
		302652,
		9,
		302652
	],
	"./education-center/markdown/medical/hypophosphatemia.md": [
		302652,
		9,
		302652
	],
	"./education-center/markdown/medical/hypophosphatemic-rickets-dominant": [
		699381,
		9,
		699381
	],
	"./education-center/markdown/medical/hypophosphatemic-rickets-dominant.md": [
		699381,
		9,
		699381
	],
	"./education-center/markdown/medical/hypophosphatemic-rickets-recessive": [
		432187,
		9,
		432187
	],
	"./education-center/markdown/medical/hypophosphatemic-rickets-recessive.md": [
		432187,
		9,
		432187
	],
	"./education-center/markdown/medical/hypoplasia-iris": [
		625892,
		9,
		625892
	],
	"./education-center/markdown/medical/hypoplasia-iris.md": [
		625892,
		9,
		625892
	],
	"./education-center/markdown/medical/hypothyroidism": [
		589890,
		9,
		589890
	],
	"./education-center/markdown/medical/hypothyroidism.md": [
		589890,
		9,
		589890
	],
	"./education-center/markdown/medical/hypotrichosis-2": [
		599170,
		9,
		599170
	],
	"./education-center/markdown/medical/hypotrichosis-2.md": [
		599170,
		9,
		599170
	],
	"./education-center/markdown/medical/hypotrichosis-3": [
		437681,
		9,
		437681
	],
	"./education-center/markdown/medical/hypotrichosis-3.md": [
		437681,
		9,
		437681
	],
	"./education-center/markdown/medical/ichthyosis-annular-epidermolytic-2": [
		924844,
		9,
		924844
	],
	"./education-center/markdown/medical/ichthyosis-annular-epidermolytic-2.md": [
		924844,
		9,
		924844
	],
	"./education-center/markdown/medical/ichthyosis-bullosa-siemens": [
		556320,
		9,
		556320
	],
	"./education-center/markdown/medical/ichthyosis-bullosa-siemens.md": [
		556320,
		9,
		556320
	],
	"./education-center/markdown/medical/ichthyosis-hystrix-curth-macklin": [
		63518,
		9,
		63518
	],
	"./education-center/markdown/medical/ichthyosis-hystrix-curth-macklin.md": [
		63518,
		9,
		63518
	],
	"./education-center/markdown/medical/idiopathic-environmental-intolerance": [
		210685,
		9,
		210685
	],
	"./education-center/markdown/medical/idiopathic-environmental-intolerance.md": [
		210685,
		9,
		210685
	],
	"./education-center/markdown/medical/idiopathic-generalized-epilepsy": [
		860983,
		9,
		860983
	],
	"./education-center/markdown/medical/idiopathic-generalized-epilepsy.md": [
		860983,
		9,
		860983
	],
	"./education-center/markdown/medical/idiopathic-growth-hormone-deficiency": [
		366534,
		9,
		366534
	],
	"./education-center/markdown/medical/idiopathic-growth-hormone-deficiency.md": [
		366534,
		9,
		366534
	],
	"./education-center/markdown/medical/idiopathic-scoliosis": [
		420970,
		9,
		420970
	],
	"./education-center/markdown/medical/idiopathic-scoliosis.md": [
		420970,
		9,
		420970
	],
	"./education-center/markdown/medical/idiopathic-transverse-myelitis": [
		652927,
		9,
		652927
	],
	"./education-center/markdown/medical/idiopathic-transverse-myelitis.md": [
		652927,
		9,
		652927
	],
	"./education-center/markdown/medical/idua-pseudodeficiency": [
		191246,
		9,
		191246
	],
	"./education-center/markdown/medical/idua-pseudodeficiency.md": [
		191246,
		9,
		191246
	],
	"./education-center/markdown/medical/ifn-gamma-receptor-1-deficiency": [
		798523,
		9,
		798523
	],
	"./education-center/markdown/medical/ifn-gamma-receptor-1-deficiency.md": [
		798523,
		9,
		798523
	],
	"./education-center/markdown/medical/iga-nephropathy-susceptibility": [
		722249,
		9,
		722249
	],
	"./education-center/markdown/medical/iga-nephropathy-susceptibility.md": [
		722249,
		9,
		722249
	],
	"./education-center/markdown/medical/ige-responsiveness-atopic": [
		738374,
		9,
		738374
	],
	"./education-center/markdown/medical/ige-responsiveness-atopic.md": [
		738374,
		9,
		738374
	],
	"./education-center/markdown/medical/igg-receptor-i-phagocytic-familial-deficiency": [
		472182,
		9,
		472182
	],
	"./education-center/markdown/medical/igg-receptor-i-phagocytic-familial-deficiency.md": [
		472182,
		9,
		472182
	],
	"./education-center/markdown/medical/iminoglycinuria-digenic": [
		865367,
		9,
		865367
	],
	"./education-center/markdown/medical/iminoglycinuria-digenic.md": [
		865367,
		9,
		865367
	],
	"./education-center/markdown/medical/immunodeficiency-109-lymphoproliferation": [
		876688,
		9,
		876688
	],
	"./education-center/markdown/medical/immunodeficiency-109-lymphoproliferation.md": [
		876688,
		9,
		876688
	],
	"./education-center/markdown/medical/immunodeficiency-18-severe-combined-immunodeficiency-variant": [
		493919,
		9,
		493919
	],
	"./education-center/markdown/medical/immunodeficiency-18-severe-combined-immunodeficiency-variant.md": [
		493919,
		9,
		493919
	],
	"./education-center/markdown/medical/immunodeficiency-26-without-neurologic-abnormalities": [
		53400,
		9,
		53400
	],
	"./education-center/markdown/medical/immunodeficiency-26-without-neurologic-abnormalities.md": [
		53400,
		9,
		53400
	],
	"./education-center/markdown/medical/immunodeficiency-37": [
		81706,
		9,
		81706
	],
	"./education-center/markdown/medical/immunodeficiency-37.md": [
		81706,
		9,
		81706
	],
	"./education-center/markdown/medical/immunodeficiency-60": [
		696560,
		9,
		696560
	],
	"./education-center/markdown/medical/immunodeficiency-60.md": [
		696560,
		9,
		696560
	],
	"./education-center/markdown/medical/immunodeficiency-66": [
		267442,
		9,
		267442
	],
	"./education-center/markdown/medical/immunodeficiency-66.md": [
		267442,
		9,
		267442
	],
	"./education-center/markdown/medical/immunodeficiency-due-defect-cd3-gamma": [
		197797,
		9,
		197797
	],
	"./education-center/markdown/medical/immunodeficiency-due-defect-cd3-gamma.md": [
		197797,
		9,
		197797
	],
	"./education-center/markdown/medical/immunodeficiency-x-linked-hyper-igm": [
		287321,
		9,
		287321
	],
	"./education-center/markdown/medical/immunodeficiency-x-linked-hyper-igm.md": [
		287321,
		9,
		287321
	],
	"./education-center/markdown/medical/impaired-adp-induced-platelet-aggregation": [
		642290,
		9,
		642290
	],
	"./education-center/markdown/medical/impaired-adp-induced-platelet-aggregation.md": [
		642290,
		9,
		642290
	],
	"./education-center/markdown/medical/impaired-intellectual-development-and-distinctive-facial-features-cardiac-defects": [
		714958,
		9,
		714958
	],
	"./education-center/markdown/medical/impaired-intellectual-development-and-distinctive-facial-features-cardiac-defects.md": [
		714958,
		9,
		714958
	],
	"./education-center/markdown/medical/impaired-ristocetin-induced-platelet-aggregation": [
		460082,
		9,
		460082
	],
	"./education-center/markdown/medical/impaired-ristocetin-induced-platelet-aggregation.md": [
		460082,
		9,
		460082
	],
	"./education-center/markdown/medical/impaired-temperature-sensation": [
		133862,
		9,
		133862
	],
	"./education-center/markdown/medical/impaired-temperature-sensation.md": [
		133862,
		9,
		133862
	],
	"./education-center/markdown/medical/impaired-thromboxane-a2-agonist-induced-platelet-aggregation": [
		449471,
		9,
		449471
	],
	"./education-center/markdown/medical/impaired-thromboxane-a2-agonist-induced-platelet-aggregation.md": [
		449471,
		9,
		449471
	],
	"./education-center/markdown/medical/impdh2-enzyme-activity-variation": [
		64946,
		9,
		64946
	],
	"./education-center/markdown/medical/impdh2-enzyme-activity-variation.md": [
		64946,
		9,
		64946
	],
	"./education-center/markdown/medical/inborn-genetic-diseases": [
		243622,
		9,
		243622
	],
	"./education-center/markdown/medical/inborn-genetic-diseases.md": [
		243622,
		9,
		243622
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-dominant": [
		517450,
		9,
		517450
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-dominant.md": [
		517450,
		9,
		517450
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-paget-disease-bone-and-frontotemporal-dementia": [
		123723,
		9,
		123723
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-paget-disease-bone-and-frontotemporal-dementia.md": [
		123723,
		9,
		123723
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-recessive": [
		229785,
		9,
		229785
	],
	"./education-center/markdown/medical/inclusion-body-myopathy-recessive.md": [
		229785,
		9,
		229785
	],
	"./education-center/markdown/medical/increased-analgesia-kappa-opioid-receptor-agonist-female-specific": [
		875341,
		9,
		875341
	],
	"./education-center/markdown/medical/increased-analgesia-kappa-opioid-receptor-agonist-female-specific.md": [
		875341,
		9,
		875341
	],
	"./education-center/markdown/medical/increased-circulating-iga-level": [
		713952,
		9,
		713952
	],
	"./education-center/markdown/medical/increased-circulating-iga-level.md": [
		713952,
		9,
		713952
	],
	"./education-center/markdown/medical/increased-circulating-ige-level": [
		282996,
		9,
		282996
	],
	"./education-center/markdown/medical/increased-circulating-ige-level.md": [
		282996,
		9,
		282996
	],
	"./education-center/markdown/medical/increased-erythrocyte-protoporphyrin-concentration": [
		476259,
		9,
		476259
	],
	"./education-center/markdown/medical/increased-erythrocyte-protoporphyrin-concentration.md": [
		476259,
		9,
		476259
	],
	"./education-center/markdown/medical/increased-hepatic-glycogen-content": [
		132156,
		9,
		132156
	],
	"./education-center/markdown/medical/increased-hepatic-glycogen-content.md": [
		132156,
		9,
		132156
	],
	"./education-center/markdown/medical/increased-histidine": [
		539124,
		9,
		539124
	],
	"./education-center/markdown/medical/increased-histidine.md": [
		539124,
		9,
		539124
	],
	"./education-center/markdown/medical/increased-left-ventricular-wall-thickness": [
		223969,
		9,
		223969
	],
	"./education-center/markdown/medical/increased-left-ventricular-wall-thickness.md": [
		223969,
		9,
		223969
	],
	"./education-center/markdown/medical/increased-mean-platelet-volume": [
		420492,
		9,
		420492
	],
	"./education-center/markdown/medical/increased-mean-platelet-volume.md": [
		420492,
		9,
		420492
	],
	"./education-center/markdown/medical/increased-muscle-glycogen-content": [
		717262,
		9,
		717262
	],
	"./education-center/markdown/medical/increased-muscle-glycogen-content.md": [
		717262,
		9,
		717262
	],
	"./education-center/markdown/medical/increased-nuchal-translucency": [
		888223,
		9,
		888223
	],
	"./education-center/markdown/medical/increased-nuchal-translucency.md": [
		888223,
		9,
		888223
	],
	"./education-center/markdown/medical/increased-susceptibility-fractures": [
		197456,
		9,
		197456
	],
	"./education-center/markdown/medical/increased-susceptibility-fractures.md": [
		197456,
		9,
		197456
	],
	"./education-center/markdown/medical/indifference-pain-congenital-autosomal-dominant": [
		205885,
		9,
		205885
	],
	"./education-center/markdown/medical/indifference-pain-congenital-autosomal-dominant.md": [
		205885,
		9,
		205885
	],
	"./education-center/markdown/medical/infant-onset-multiple-organ-failure": [
		367581,
		9,
		367581
	],
	"./education-center/markdown/medical/infant-onset-multiple-organ-failure.md": [
		367581,
		9,
		367581
	],
	"./education-center/markdown/medical/infantile-cortical-hyperostosis": [
		718710,
		9,
		718710
	],
	"./education-center/markdown/medical/infantile-cortical-hyperostosis.md": [
		718710,
		9,
		718710
	],
	"./education-center/markdown/medical/infantile-encephalopathy": [
		83731,
		9,
		83731
	],
	"./education-center/markdown/medical/infantile-encephalopathy.md": [
		83731,
		9,
		83731
	],
	"./education-center/markdown/medical/infantile-epilepsy": [
		706309,
		9,
		706309
	],
	"./education-center/markdown/medical/infantile-epilepsy.md": [
		706309,
		9,
		706309
	],
	"./education-center/markdown/medical/infantile-hypercalcemia": [
		60249,
		9,
		60249
	],
	"./education-center/markdown/medical/infantile-hypercalcemia.md": [
		60249,
		9,
		60249
	],
	"./education-center/markdown/medical/infantile-hypophosphatasia": [
		239307,
		9,
		239307
	],
	"./education-center/markdown/medical/infantile-hypophosphatasia.md": [
		239307,
		9,
		239307
	],
	"./education-center/markdown/medical/infantile-liver-failure": [
		738342,
		9,
		738342
	],
	"./education-center/markdown/medical/infantile-liver-failure.md": [
		738342,
		9,
		738342
	],
	"./education-center/markdown/medical/infantile-nystagmus": [
		34594,
		9,
		34594
	],
	"./education-center/markdown/medical/infantile-nystagmus.md": [
		34594,
		9,
		34594
	],
	"./education-center/markdown/medical/infantile-spasms": [
		81308,
		9,
		81308
	],
	"./education-center/markdown/medical/infantile-spasms.md": [
		81308,
		9,
		81308
	],
	"./education-center/markdown/medical/infertility": [
		859650,
		9,
		859650
	],
	"./education-center/markdown/medical/infertility.md": [
		859650,
		9,
		859650
	],
	"./education-center/markdown/medical/infiltrating-duct-carcinoma-breast": [
		864108,
		9,
		864108
	],
	"./education-center/markdown/medical/infiltrating-duct-carcinoma-breast.md": [
		864108,
		9,
		864108
	],
	"./education-center/markdown/medical/inflammation": [
		606325,
		9,
		606325
	],
	"./education-center/markdown/medical/inflammation.md": [
		606325,
		9,
		606325
	],
	"./education-center/markdown/medical/inflammatory-bowel-disease-14-susceptibility": [
		112317,
		9,
		112317
	],
	"./education-center/markdown/medical/inflammatory-bowel-disease-14-susceptibility.md": [
		112317,
		9,
		112317
	],
	"./education-center/markdown/medical/inflammatory-bowel-disease-17-protection-against": [
		743434,
		9,
		743434
	],
	"./education-center/markdown/medical/inflammatory-bowel-disease-17-protection-against.md": [
		743434,
		9,
		743434
	],
	"./education-center/markdown/medical/inherited-bleeding-disorder-platelet-type": [
		426061,
		9,
		426061
	],
	"./education-center/markdown/medical/inherited-bleeding-disorder-platelet-type.md": [
		426061,
		9,
		426061
	],
	"./education-center/markdown/medical/inherited-creutzfeldt-jakob-disease": [
		390676,
		9,
		390676
	],
	"./education-center/markdown/medical/inherited-creutzfeldt-jakob-disease.md": [
		390676,
		9,
		390676
	],
	"./education-center/markdown/medical/inherited-erythromelalgia": [
		307160,
		9,
		307160
	],
	"./education-center/markdown/medical/inherited-erythromelalgia.md": [
		307160,
		9,
		307160
	],
	"./education-center/markdown/medical/inherited-immunodeficiency-diseases": [
		365121,
		9,
		365121
	],
	"./education-center/markdown/medical/inherited-immunodeficiency-diseases.md": [
		365121,
		9,
		365121
	],
	"./education-center/markdown/medical/inner-ear-malformation": [
		256589,
		9,
		256589
	],
	"./education-center/markdown/medical/inner-ear-malformation.md": [
		256589,
		9,
		256589
	],
	"./education-center/markdown/medical/insulin-resistance": [
		133466,
		9,
		133466
	],
	"./education-center/markdown/medical/insulin-resistance-severe-digenic": [
		777363,
		9,
		777363
	],
	"./education-center/markdown/medical/insulin-resistance-severe-digenic.md": [
		777363,
		9,
		777363
	],
	"./education-center/markdown/medical/insulin-resistance-susceptibility": [
		486565,
		9,
		486565
	],
	"./education-center/markdown/medical/insulin-resistance-susceptibility.md": [
		486565,
		9,
		486565
	],
	"./education-center/markdown/medical/insulin-resistance.md": [
		133466,
		9,
		133466
	],
	"./education-center/markdown/medical/insulin-resistant-diabetes-mellitus": [
		303290,
		9,
		303290
	],
	"./education-center/markdown/medical/insulin-resistant-diabetes-mellitus.md": [
		303290,
		9,
		303290
	],
	"./education-center/markdown/medical/intellectual-deficiency": [
		40237,
		9,
		40237
	],
	"./education-center/markdown/medical/intellectual-deficiency.md": [
		40237,
		9,
		40237
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder": [
		811937,
		9,
		811937
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-autism-and-dysmorphic-facies": [
		672427,
		9,
		672427
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-autism-and-dysmorphic-facies.md": [
		672427,
		9,
		672427
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-autosomal-dominant-71-behavioral-abnormalities": [
		793714,
		9,
		793714
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-autosomal-dominant-71-behavioral-abnormalities.md": [
		793714,
		9,
		793714
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-x-linked-syndromic-16": [
		848447,
		9,
		848447
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder-x-linked-syndromic-16.md": [
		848447,
		9,
		848447
	],
	"./education-center/markdown/medical/intellectual-developmental-disorder.md": [
		811937,
		9,
		811937
	],
	"./education-center/markdown/medical/intellectual-disability": [
		697225,
		9,
		697225
	],
	"./education-center/markdown/medical/intellectual-disability-and-seizures": [
		964715,
		9,
		964715
	],
	"./education-center/markdown/medical/intellectual-disability-and-seizures.md": [
		964715,
		9,
		964715
	],
	"./education-center/markdown/medical/intellectual-disability-autosomal-dominant-1": [
		234433,
		9,
		234433
	],
	"./education-center/markdown/medical/intellectual-disability-autosomal-dominant-1.md": [
		234433,
		9,
		234433
	],
	"./education-center/markdown/medical/intellectual-disability-cask-related-x-linked": [
		872379,
		9,
		872379
	],
	"./education-center/markdown/medical/intellectual-disability-cask-related-x-linked.md": [
		872379,
		9,
		872379
	],
	"./education-center/markdown/medical/intellectual-disability-dominant": [
		522445,
		9,
		522445
	],
	"./education-center/markdown/medical/intellectual-disability-dominant.md": [
		522445,
		9,
		522445
	],
	"./education-center/markdown/medical/intellectual-disability-episodic-ataxia-and-congenital-arthrogryposis": [
		32926,
		9,
		32926
	],
	"./education-center/markdown/medical/intellectual-disability-episodic-ataxia-and-congenital-arthrogryposis.md": [
		32926,
		9,
		32926
	],
	"./education-center/markdown/medical/intellectual-disability-fra12a-type": [
		891278,
		9,
		891278
	],
	"./education-center/markdown/medical/intellectual-disability-fra12a-type.md": [
		891278,
		9,
		891278
	],
	"./education-center/markdown/medical/intellectual-disability-language-impairment-and-autistic-features": [
		260508,
		9,
		260508
	],
	"./education-center/markdown/medical/intellectual-disability-language-impairment-and-autistic-features.md": [
		260508,
		9,
		260508
	],
	"./education-center/markdown/medical/intellectual-disability-profound": [
		256937,
		9,
		256937
	],
	"./education-center/markdown/medical/intellectual-disability-profound.md": [
		256937,
		9,
		256937
	],
	"./education-center/markdown/medical/intellectual-disability-recessive": [
		315235,
		9,
		315235
	],
	"./education-center/markdown/medical/intellectual-disability-recessive.md": [
		315235,
		9,
		315235
	],
	"./education-center/markdown/medical/intellectual-disability-severe-speech-impairment": [
		494216,
		9,
		494216
	],
	"./education-center/markdown/medical/intellectual-disability-severe-speech-impairment.md": [
		494216,
		9,
		494216
	],
	"./education-center/markdown/medical/intellectual-disability-stereotypic-movements-epilepsy-andor-cerebral-malformations": [
		541549,
		9,
		541549
	],
	"./education-center/markdown/medical/intellectual-disability-stereotypic-movements-epilepsy-andor-cerebral-malformations.md": [
		541549,
		9,
		541549
	],
	"./education-center/markdown/medical/intellectual-disability-x-linked-1": [
		440982,
		9,
		440982
	],
	"./education-center/markdown/medical/intellectual-disability-x-linked-1.md": [
		440982,
		9,
		440982
	],
	"./education-center/markdown/medical/intellectual-disability.md": [
		697225,
		9,
		697225
	],
	"./education-center/markdown/medical/interferon-gamma-receptor-deficiency": [
		935179,
		9,
		935179
	],
	"./education-center/markdown/medical/interferon-gamma-receptor-deficiency.md": [
		935179,
		9,
		935179
	],
	"./education-center/markdown/medical/interferons-peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy": [
		398551,
		9,
		398551
	],
	"./education-center/markdown/medical/interferons-peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.md": [
		398551,
		9,
		398551
	],
	"./education-center/markdown/medical/interleukin-6-serum-level-quantitative-trait-locus": [
		305719,
		9,
		305719
	],
	"./education-center/markdown/medical/interleukin-6-serum-level-quantitative-trait-locus.md": [
		305719,
		9,
		305719
	],
	"./education-center/markdown/medical/intermediate-maple-syrup-urine-disease-type-2": [
		542941,
		9,
		542941
	],
	"./education-center/markdown/medical/intermediate-maple-syrup-urine-disease-type-2.md": [
		542941,
		9,
		542941
	],
	"./education-center/markdown/medical/interstitial-cardiac-fibrosis": [
		437549,
		9,
		437549
	],
	"./education-center/markdown/medical/interstitial-cardiac-fibrosis.md": [
		437549,
		9,
		437549
	],
	"./education-center/markdown/medical/interstitial-nephritis": [
		557767,
		9,
		557767
	],
	"./education-center/markdown/medical/interstitial-nephritis.md": [
		557767,
		9,
		557767
	],
	"./education-center/markdown/medical/intervertebral-disc-disease-susceptibility": [
		994681,
		9,
		994681
	],
	"./education-center/markdown/medical/intervertebral-disc-disease-susceptibility.md": [
		994681,
		9,
		994681
	],
	"./education-center/markdown/medical/intervertebral-disk-calcification": [
		714259,
		9,
		714259
	],
	"./education-center/markdown/medical/intervertebral-disk-calcification.md": [
		714259,
		9,
		714259
	],
	"./education-center/markdown/medical/intestinal-dysmotility-syndrome": [
		238445,
		9,
		238445
	],
	"./education-center/markdown/medical/intestinal-dysmotility-syndrome.md": [
		238445,
		9,
		238445
	],
	"./education-center/markdown/medical/intractable-seizure": [
		103966,
		9,
		103966
	],
	"./education-center/markdown/medical/intractable-seizure.md": [
		103966,
		9,
		103966
	],
	"./education-center/markdown/medical/intraventricular-hemorrhage": [
		519083,
		9,
		519083
	],
	"./education-center/markdown/medical/intraventricular-hemorrhage.md": [
		519083,
		9,
		519083
	],
	"./education-center/markdown/medical/intrinsic-cardiomyopathy": [
		995004,
		9,
		995004
	],
	"./education-center/markdown/medical/intrinsic-cardiomyopathy.md": [
		995004,
		9,
		995004
	],
	"./education-center/markdown/medical/invasive-breast-carcinoma": [
		461074,
		9,
		461074
	],
	"./education-center/markdown/medical/invasive-breast-carcinoma.md": [
		461074,
		9,
		461074
	],
	"./education-center/markdown/medical/invasive-pneumococcal-disease-protection-against": [
		500968,
		9,
		500968
	],
	"./education-center/markdown/medical/invasive-pneumococcal-disease-protection-against.md": [
		500968,
		9,
		500968
	],
	"./education-center/markdown/medical/invasive-pneumococcal-disease-recurrent-isolated": [
		388048,
		9,
		388048
	],
	"./education-center/markdown/medical/invasive-pneumococcal-disease-recurrent-isolated.md": [
		388048,
		9,
		388048
	],
	"./education-center/markdown/medical/irinotecan-response": [
		893301,
		9,
		893301
	],
	"./education-center/markdown/medical/irinotecan-response.md": [
		893301,
		9,
		893301
	],
	"./education-center/markdown/medical/iron-accumulation-brain": [
		573682,
		9,
		573682
	],
	"./education-center/markdown/medical/iron-accumulation-brain.md": [
		573682,
		9,
		573682
	],
	"./education-center/markdown/medical/iron-deficiency-anemia": [
		595646,
		9,
		595646
	],
	"./education-center/markdown/medical/iron-deficiency-anemia.md": [
		595646,
		9,
		595646
	],
	"./education-center/markdown/medical/iron-overload": [
		346010,
		9,
		346010
	],
	"./education-center/markdown/medical/iron-overload.md": [
		346010,
		9,
		346010
	],
	"./education-center/markdown/medical/ischemic-stroke": [
		424886,
		9,
		424886
	],
	"./education-center/markdown/medical/ischemic-stroke.md": [
		424886,
		9,
		424886
	],
	"./education-center/markdown/medical/islet-cell-adenomatosis": [
		400915,
		9,
		400915
	],
	"./education-center/markdown/medical/islet-cell-adenomatosis.md": [
		400915,
		9,
		400915
	],
	"./education-center/markdown/medical/isolated-anhidrosis-normal-sweat-glands": [
		403696,
		9,
		403696
	],
	"./education-center/markdown/medical/isolated-anhidrosis-normal-sweat-glands.md": [
		403696,
		9,
		403696
	],
	"./education-center/markdown/medical/isolated-cleft-palate": [
		66407,
		9,
		66407
	],
	"./education-center/markdown/medical/isolated-cleft-palate.md": [
		66407,
		9,
		66407
	],
	"./education-center/markdown/medical/isolated-congenital-digital-clubbing": [
		709059,
		9,
		709059
	],
	"./education-center/markdown/medical/isolated-congenital-digital-clubbing.md": [
		709059,
		9,
		709059
	],
	"./education-center/markdown/medical/isolated-congenital-growth-hormone-deficiency": [
		648607,
		9,
		648607
	],
	"./education-center/markdown/medical/isolated-congenital-growth-hormone-deficiency.md": [
		648607,
		9,
		648607
	],
	"./education-center/markdown/medical/isolated-coronal-synostosis": [
		315558,
		9,
		315558
	],
	"./education-center/markdown/medical/isolated-coronal-synostosis.md": [
		315558,
		9,
		315558
	],
	"./education-center/markdown/medical/isolated-cryptophthalmia": [
		213914,
		9,
		213914
	],
	"./education-center/markdown/medical/isolated-cryptophthalmia.md": [
		213914,
		9,
		213914
	],
	"./education-center/markdown/medical/isolated-gnrh-deficiency": [
		670713,
		9,
		670713
	],
	"./education-center/markdown/medical/isolated-gnrh-deficiency.md": [
		670713,
		9,
		670713
	],
	"./education-center/markdown/medical/isolated-hyperchlorhidrosis": [
		63737,
		9,
		63737
	],
	"./education-center/markdown/medical/isolated-hyperchlorhidrosis.md": [
		63737,
		9,
		63737
	],
	"./education-center/markdown/medical/isolated-hyperparathyroidism": [
		442120,
		9,
		442120
	],
	"./education-center/markdown/medical/isolated-hyperparathyroidism.md": [
		442120,
		9,
		442120
	],
	"./education-center/markdown/medical/isolated-macular-dystrophy": [
		240856,
		9,
		240856
	],
	"./education-center/markdown/medical/isolated-macular-dystrophy.md": [
		240856,
		9,
		240856
	],
	"./education-center/markdown/medical/isolated-nonsyndromic-congenital-heart-disease": [
		177174,
		9,
		177174
	],
	"./education-center/markdown/medical/isolated-nonsyndromic-congenital-heart-disease.md": [
		177174,
		9,
		177174
	],
	"./education-center/markdown/medical/isovaleric-acidemia-type-i": [
		308432,
		9,
		308432
	],
	"./education-center/markdown/medical/isovaleric-acidemia-type-i.md": [
		308432,
		9,
		308432
	],
	"./education-center/markdown/medical/isovaleric-acidemia-type-iii": [
		856185,
		9,
		856185
	],
	"./education-center/markdown/medical/isovaleric-acidemia-type-iii.md": [
		856185,
		9,
		856185
	],
	"./education-center/markdown/medical/ivacaftor-lumacaftor-response-efficacy": [
		252896,
		9,
		252896
	],
	"./education-center/markdown/medical/ivacaftor-lumacaftor-response-efficacy.md": [
		252896,
		9,
		252896
	],
	"./education-center/markdown/medical/ivacaftor-response-efficacy": [
		135711,
		9,
		135711
	],
	"./education-center/markdown/medical/ivacaftor-response-efficacy.md": [
		135711,
		9,
		135711
	],
	"./education-center/markdown/medical/jackson-weiss-syndrome": [
		50618,
		9,
		50618
	],
	"./education-center/markdown/medical/jackson-weiss-syndrome.md": [
		50618,
		9,
		50618
	],
	"./education-center/markdown/medical/jawad-syndrome": [
		136250,
		9,
		136250
	],
	"./education-center/markdown/medical/jawad-syndrome.md": [
		136250,
		9,
		136250
	],
	"./education-center/markdown/medical/john-milton-hagen-blood-group-system": [
		563258,
		9,
		563258
	],
	"./education-center/markdown/medical/john-milton-hagen-blood-group-system.md": [
		563258,
		9,
		563258
	],
	"./education-center/markdown/medical/joint-hypermobility": [
		96540,
		9,
		96540
	],
	"./education-center/markdown/medical/joint-hypermobility.md": [
		96540,
		9,
		96540
	],
	"./education-center/markdown/medical/joubert-syndrome-12": [
		131940,
		9,
		131940
	],
	"./education-center/markdown/medical/joubert-syndrome-12.md": [
		131940,
		9,
		131940
	],
	"./education-center/markdown/medical/joubert-syndrome-1215-digenic": [
		602963,
		9,
		602963
	],
	"./education-center/markdown/medical/joubert-syndrome-1215-digenic.md": [
		602963,
		9,
		602963
	],
	"./education-center/markdown/medical/joubert-syndrome-915-digenic": [
		776963,
		9,
		776963
	],
	"./education-center/markdown/medical/joubert-syndrome-915-digenic.md": [
		776963,
		9,
		776963
	],
	"./education-center/markdown/medical/juberg-hayward-syndrome": [
		847911,
		9,
		847911
	],
	"./education-center/markdown/medical/juberg-hayward-syndrome.md": [
		847911,
		9,
		847911
	],
	"./education-center/markdown/medical/juvenile-hemochromatosis": [
		829773,
		9,
		829773
	],
	"./education-center/markdown/medical/juvenile-hemochromatosis.md": [
		829773,
		9,
		829773
	],
	"./education-center/markdown/medical/juvenile-onset-psychosis": [
		128743,
		9,
		128743
	],
	"./education-center/markdown/medical/juvenile-onset-psychosis.md": [
		128743,
		9,
		128743
	],
	"./education-center/markdown/medical/juvenile-polyposis": [
		359964,
		9,
		359964
	],
	"./education-center/markdown/medical/juvenile-polyposis-stomach": [
		99759,
		9,
		99759
	],
	"./education-center/markdown/medical/juvenile-polyposis-stomach.md": [
		99759,
		9,
		99759
	],
	"./education-center/markdown/medical/juvenile-polyposis.md": [
		359964,
		9,
		359964
	],
	"./education-center/markdown/medical/juvenile-retinitis-pigmentosa-aipl1-related": [
		936287,
		9,
		936287
	],
	"./education-center/markdown/medical/juvenile-retinitis-pigmentosa-aipl1-related.md": [
		936287,
		9,
		936287
	],
	"./education-center/markdown/medical/kabuki-syndrome-1": [
		737581,
		9,
		737581
	],
	"./education-center/markdown/medical/kabuki-syndrome-1.md": [
		737581,
		9,
		737581
	],
	"./education-center/markdown/medical/karak-syndrome": [
		827686,
		9,
		827686
	],
	"./education-center/markdown/medical/karak-syndrome.md": [
		827686,
		9,
		827686
	],
	"./education-center/markdown/medical/kat6b-related-spectrum-disorders": [
		598036,
		9,
		598036
	],
	"./education-center/markdown/medical/kat6b-related-spectrum-disorders.md": [
		598036,
		9,
		598036
	],
	"./education-center/markdown/medical/kbg-syndrome": [
		798766,
		9,
		798766
	],
	"./education-center/markdown/medical/kbg-syndrome.md": [
		798766,
		9,
		798766
	],
	"./education-center/markdown/medical/kcne2-related-disorders": [
		968228,
		9,
		968228
	],
	"./education-center/markdown/medical/kcne2-related-disorders.md": [
		968228,
		9,
		968228
	],
	"./education-center/markdown/medical/kcnj10-related-disorders": [
		121077,
		9,
		121077
	],
	"./education-center/markdown/medical/kcnj10-related-disorders.md": [
		121077,
		9,
		121077
	],
	"./education-center/markdown/medical/kcnq1-related-disorders": [
		547121,
		9,
		547121
	],
	"./education-center/markdown/medical/kcnq1-related-disorders.md": [
		547121,
		9,
		547121
	],
	"./education-center/markdown/medical/kcnq2-related-disorders": [
		864396,
		9,
		864396
	],
	"./education-center/markdown/medical/kcnq2-related-disorders.md": [
		864396,
		9,
		864396
	],
	"./education-center/markdown/medical/kcnq3-related-developmental-disability": [
		773707,
		9,
		773707
	],
	"./education-center/markdown/medical/kcnq3-related-developmental-disability.md": [
		773707,
		9,
		773707
	],
	"./education-center/markdown/medical/kcnt2-related-condition": [
		524126,
		9,
		524126
	],
	"./education-center/markdown/medical/kcnt2-related-condition.md": [
		524126,
		9,
		524126
	],
	"./education-center/markdown/medical/kel6-antigen": [
		236289,
		9,
		236289
	],
	"./education-center/markdown/medical/kel6-antigen.md": [
		236289,
		9,
		236289
	],
	"./education-center/markdown/medical/keloid-formation": [
		115818,
		9,
		115818
	],
	"./education-center/markdown/medical/keloid-formation.md": [
		115818,
		9,
		115818
	],
	"./education-center/markdown/medical/keratitis-fugax-hereditaria": [
		817338,
		9,
		817338
	],
	"./education-center/markdown/medical/keratitis-fugax-hereditaria.md": [
		817338,
		9,
		817338
	],
	"./education-center/markdown/medical/keratoconus-1": [
		559046,
		9,
		559046
	],
	"./education-center/markdown/medical/keratoconus-1.md": [
		559046,
		9,
		559046
	],
	"./education-center/markdown/medical/keratolytic-winter-erythema": [
		138289,
		9,
		138289
	],
	"./education-center/markdown/medical/keratolytic-winter-erythema.md": [
		138289,
		9,
		138289
	],
	"./education-center/markdown/medical/keratosis-follicularis": [
		838368,
		9,
		838368
	],
	"./education-center/markdown/medical/keratosis-follicularis.md": [
		838368,
		9,
		838368
	],
	"./education-center/markdown/medical/kidney-damage": [
		909664,
		9,
		909664
	],
	"./education-center/markdown/medical/kidney-damage.md": [
		909664,
		9,
		909664
	],
	"./education-center/markdown/medical/kininogen-deficiency-total": [
		333740,
		9,
		333740
	],
	"./education-center/markdown/medical/kininogen-deficiency-total.md": [
		333740,
		9,
		333740
	],
	"./education-center/markdown/medical/kleine-levin-syndrome": [
		68456,
		9,
		68456
	],
	"./education-center/markdown/medical/kleine-levin-syndrome.md": [
		68456,
		9,
		68456
	],
	"./education-center/markdown/medical/klippel-feil-syndrome": [
		93204,
		9,
		93204
	],
	"./education-center/markdown/medical/klippel-feil-syndrome-1-autosomal-dominant": [
		440744,
		9,
		440744
	],
	"./education-center/markdown/medical/klippel-feil-syndrome-1-autosomal-dominant.md": [
		440744,
		9,
		440744
	],
	"./education-center/markdown/medical/klippel-feil-syndrome.md": [
		93204,
		9,
		93204
	],
	"./education-center/markdown/medical/klippel-trã©naunay-syndrome": [
		118389,
		9,
		118389
	],
	"./education-center/markdown/medical/klippel-trã©naunay-syndrome.md": [
		118389,
		9,
		118389
	],
	"./education-center/markdown/medical/kniest-dysplasia": [
		718067,
		9,
		718067
	],
	"./education-center/markdown/medical/kniest-dysplasia.md": [
		718067,
		9,
		718067
	],
	"./education-center/markdown/medical/knops-blood-group-system": [
		767237,
		9,
		767237
	],
	"./education-center/markdown/medical/knops-blood-group-system.md": [
		767237,
		9,
		767237
	],
	"./education-center/markdown/medical/knuckle-pads-deafness-and-leukonychia-syndrome": [
		107856,
		9,
		107856
	],
	"./education-center/markdown/medical/knuckle-pads-deafness-and-leukonychia-syndrome.md": [
		107856,
		9,
		107856
	],
	"./education-center/markdown/medical/kuru-protection-against": [
		542236,
		9,
		542236
	],
	"./education-center/markdown/medical/kuru-protection-against.md": [
		542236,
		9,
		542236
	],
	"./education-center/markdown/medical/l-ferritin-deficiency-autosomal-recessive": [
		891367,
		9,
		891367
	],
	"./education-center/markdown/medical/l-ferritin-deficiency-autosomal-recessive.md": [
		891367,
		9,
		891367
	],
	"./education-center/markdown/medical/lacrimoauriculodentodigital-syndrome-3": [
		317991,
		9,
		317991
	],
	"./education-center/markdown/medical/lacrimoauriculodentodigital-syndrome-3.md": [
		317991,
		9,
		317991
	],
	"./education-center/markdown/medical/lactase-persistence": [
		764891,
		9,
		764891
	],
	"./education-center/markdown/medical/lactase-persistence.md": [
		764891,
		9,
		764891
	],
	"./education-center/markdown/medical/lactic-acidosis": [
		939252,
		9,
		939252
	],
	"./education-center/markdown/medical/lactic-acidosis.md": [
		939252,
		9,
		939252
	],
	"./education-center/markdown/medical/landsteiner-wiener-phenotype": [
		915716,
		9,
		915716
	],
	"./education-center/markdown/medical/landsteiner-wiener-phenotype.md": [
		915716,
		9,
		915716
	],
	"./education-center/markdown/medical/langer-giedion-syndrome": [
		585245,
		9,
		585245
	],
	"./education-center/markdown/medical/langer-giedion-syndrome.md": [
		585245,
		9,
		585245
	],
	"./education-center/markdown/medical/langereis-blood-group": [
		212740,
		9,
		212740
	],
	"./education-center/markdown/medical/langereis-blood-group.md": [
		212740,
		9,
		212740
	],
	"./education-center/markdown/medical/language-retardation": [
		9747,
		9,
		9747
	],
	"./education-center/markdown/medical/language-retardation.md": [
		9747,
		9,
		9747
	],
	"./education-center/markdown/medical/large-gestational-age": [
		948398,
		9,
		948398
	],
	"./education-center/markdown/medical/large-gestational-age.md": [
		948398,
		9,
		948398
	],
	"./education-center/markdown/medical/large-vessel-vasculitis": [
		581379,
		9,
		581379
	],
	"./education-center/markdown/medical/large-vessel-vasculitis.md": [
		581379,
		9,
		581379
	],
	"./education-center/markdown/medical/laron-syndrome-elevated-serum-gh-binding-protein": [
		165786,
		9,
		165786
	],
	"./education-center/markdown/medical/laron-syndrome-elevated-serum-gh-binding-protein.md": [
		165786,
		9,
		165786
	],
	"./education-center/markdown/medical/laron-syndrome-undetectable-serum-gh-binding-protein": [
		230225,
		9,
		230225
	],
	"./education-center/markdown/medical/laron-syndrome-undetectable-serum-gh-binding-protein.md": [
		230225,
		9,
		230225
	],
	"./education-center/markdown/medical/larsen-syndrome": [
		151254,
		9,
		151254
	],
	"./education-center/markdown/medical/larsen-syndrome.md": [
		151254,
		9,
		151254
	],
	"./education-center/markdown/medical/late-onset-citrullinemia": [
		87375,
		9,
		87375
	],
	"./education-center/markdown/medical/late-onset-citrullinemia.md": [
		87375,
		9,
		87375
	],
	"./education-center/markdown/medical/lateral-meningocele-syndrome": [
		461455,
		9,
		461455
	],
	"./education-center/markdown/medical/lateral-meningocele-syndrome.md": [
		461455,
		9,
		461455
	],
	"./education-center/markdown/medical/lattice-corneal-dystrophy-type-i": [
		784348,
		9,
		784348
	],
	"./education-center/markdown/medical/lattice-corneal-dystrophy-type-i.md": [
		784348,
		9,
		784348
	],
	"./education-center/markdown/medical/lazy-leukocyte-syndrome": [
		523690,
		9,
		523690
	],
	"./education-center/markdown/medical/lazy-leukocyte-syndrome.md": [
		523690,
		9,
		523690
	],
	"./education-center/markdown/medical/lcat-deficiency": [
		687657,
		9,
		687657
	],
	"./education-center/markdown/medical/lcat-deficiency.md": [
		687657,
		9,
		687657
	],
	"./education-center/markdown/medical/lchad-deficiency-maternal-acute-fatty-liver-pregnancy": [
		870718,
		9,
		870718
	],
	"./education-center/markdown/medical/lchad-deficiency-maternal-acute-fatty-liver-pregnancy.md": [
		870718,
		9,
		870718
	],
	"./education-center/markdown/medical/leber-congenital-amaurosis": [
		66894,
		9,
		66894
	],
	"./education-center/markdown/medical/leber-congenital-amaurosis-18": [
		342934,
		9,
		342934
	],
	"./education-center/markdown/medical/leber-congenital-amaurosis-18.md": [
		342934,
		9,
		342934
	],
	"./education-center/markdown/medical/leber-congenital-amaurosis.md": [
		66894,
		9,
		66894
	],
	"./education-center/markdown/medical/left-right-axis-malformations": [
		938341,
		9,
		938341
	],
	"./education-center/markdown/medical/left-right-axis-malformations.md": [
		938341,
		9,
		938341
	],
	"./education-center/markdown/medical/left-ventricular-noncompaction-3": [
		908764,
		9,
		908764
	],
	"./education-center/markdown/medical/left-ventricular-noncompaction-3.md": [
		908764,
		9,
		908764
	],
	"./education-center/markdown/medical/left-ventricular-noncompaction-cardiomyopathy": [
		856978,
		9,
		856978
	],
	"./education-center/markdown/medical/left-ventricular-noncompaction-cardiomyopathy.md": [
		856978,
		9,
		856978
	],
	"./education-center/markdown/medical/legg-calve-perthes-disease": [
		949163,
		9,
		949163
	],
	"./education-center/markdown/medical/legg-calve-perthes-disease.md": [
		949163,
		9,
		949163
	],
	"./education-center/markdown/medical/leigh-syndrome-due-mitochondrial-complex-i-deficiency": [
		821631,
		9,
		821631
	],
	"./education-center/markdown/medical/leigh-syndrome-due-mitochondrial-complex-i-deficiency.md": [
		821631,
		9,
		821631
	],
	"./education-center/markdown/medical/lenz-majewski-hyperostosis-syndrome": [
		260830,
		9,
		260830
	],
	"./education-center/markdown/medical/lenz-majewski-hyperostosis-syndrome.md": [
		260830,
		9,
		260830
	],
	"./education-center/markdown/medical/leprosy-early-onset-susceptibility": [
		405635,
		9,
		405635
	],
	"./education-center/markdown/medical/leprosy-early-onset-susceptibility.md": [
		405635,
		9,
		405635
	],
	"./education-center/markdown/medical/leprosy-protection-against": [
		294316,
		9,
		294316
	],
	"./education-center/markdown/medical/leprosy-protection-against.md": [
		294316,
		9,
		294316
	],
	"./education-center/markdown/medical/leptin-dysfunction": [
		365307,
		9,
		365307
	],
	"./education-center/markdown/medical/leptin-dysfunction.md": [
		365307,
		9,
		365307
	],
	"./education-center/markdown/medical/leri-weill-dyschondrosteosis": [
		505985,
		9,
		505985
	],
	"./education-center/markdown/medical/leri-weill-dyschondrosteosis.md": [
		505985,
		9,
		505985
	],
	"./education-center/markdown/medical/lesch-nyhan-syndrome-neurologic-variant": [
		795859,
		9,
		795859
	],
	"./education-center/markdown/medical/lesch-nyhan-syndrome-neurologic-variant.md": [
		795859,
		9,
		795859
	],
	"./education-center/markdown/medical/lesinurad-response": [
		54075,
		9,
		54075
	],
	"./education-center/markdown/medical/lesinurad-response.md": [
		54075,
		9,
		54075
	],
	"./education-center/markdown/medical/lethal-encephalopathy": [
		249465,
		9,
		249465
	],
	"./education-center/markdown/medical/lethal-encephalopathy.md": [
		249465,
		9,
		249465
	],
	"./education-center/markdown/medical/lethal-skeletal-dysplasia": [
		672279,
		9,
		672279
	],
	"./education-center/markdown/medical/lethal-skeletal-dysplasia.md": [
		672279,
		9,
		672279
	],
	"./education-center/markdown/medical/leukemia-acute-lymphoblastic-susceptibility": [
		529639,
		9,
		529639
	],
	"./education-center/markdown/medical/leukemia-acute-lymphoblastic-susceptibility.md": [
		529639,
		9,
		529639
	],
	"./education-center/markdown/medical/leukemia-acute-myeloid-m0-subtype": [
		96034,
		9,
		96034
	],
	"./education-center/markdown/medical/leukemia-acute-myeloid-m0-subtype.md": [
		96034,
		9,
		96034
	],
	"./education-center/markdown/medical/leukemia-megakaryoblastic-down-syndrome-somatic": [
		513908,
		9,
		513908
	],
	"./education-center/markdown/medical/leukemia-megakaryoblastic-down-syndrome-somatic.md": [
		513908,
		9,
		513908
	],
	"./education-center/markdown/medical/leukemia-philadelphia-chromosome-positive-resistant-imatinib": [
		373638,
		9,
		373638
	],
	"./education-center/markdown/medical/leukemia-philadelphia-chromosome-positive-resistant-imatinib.md": [
		373638,
		9,
		373638
	],
	"./education-center/markdown/medical/leukemia-post-chemotherapy-susceptibility": [
		785447,
		9,
		785447
	],
	"./education-center/markdown/medical/leukemia-post-chemotherapy-susceptibility.md": [
		785447,
		9,
		785447
	],
	"./education-center/markdown/medical/leukemoid-reaction": [
		106293,
		9,
		106293
	],
	"./education-center/markdown/medical/leukemoid-reaction.md": [
		106293,
		9,
		106293
	],
	"./education-center/markdown/medical/leukocyte-adhesion-deficiency-1": [
		701113,
		9,
		701113
	],
	"./education-center/markdown/medical/leukocyte-adhesion-deficiency-1.md": [
		701113,
		9,
		701113
	],
	"./education-center/markdown/medical/leukodystrophy-adult-onset": [
		356864,
		9,
		356864
	],
	"./education-center/markdown/medical/leukodystrophy-adult-onset.md": [
		356864,
		9,
		356864
	],
	"./education-center/markdown/medical/leukodystrophy-childhood-onset-remitting": [
		469018,
		9,
		469018
	],
	"./education-center/markdown/medical/leukodystrophy-childhood-onset-remitting.md": [
		469018,
		9,
		469018
	],
	"./education-center/markdown/medical/leukodystrophy-hypomyelinating-26-chondrodysplasia": [
		103056,
		9,
		103056
	],
	"./education-center/markdown/medical/leukodystrophy-hypomyelinating-26-chondrodysplasia.md": [
		103056,
		9,
		103056
	],
	"./education-center/markdown/medical/leukoencephalopathy": [
		279307,
		9,
		279307
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-2": [
		756689,
		9,
		756689
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-2.md": [
		756689,
		9,
		756689
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-3": [
		107317,
		9,
		107317
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-3.md": [
		107317,
		9,
		107317
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-4": [
		572436,
		9,
		572436
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-4.md": [
		572436,
		9,
		572436
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-5": [
		453259,
		9,
		453259
	],
	"./education-center/markdown/medical/leukoencephalopathy-vanishing-white-matter-5.md": [
		453259,
		9,
		453259
	],
	"./education-center/markdown/medical/leukoencephalopathy.md": [
		279307,
		9,
		279307
	],
	"./education-center/markdown/medical/levy-hollister-syndrome": [
		982716,
		9,
		982716
	],
	"./education-center/markdown/medical/levy-hollister-syndrome.md": [
		982716,
		9,
		982716
	],
	"./education-center/markdown/medical/lewy-body-dementia": [
		474835,
		9,
		474835
	],
	"./education-center/markdown/medical/lewy-body-dementia.md": [
		474835,
		9,
		474835
	],
	"./education-center/markdown/medical/leydig-cell-adenoma-somatic-male-limited-precocious-puberty": [
		759419,
		9,
		759419
	],
	"./education-center/markdown/medical/leydig-cell-adenoma-somatic-male-limited-precocious-puberty.md": [
		759419,
		9,
		759419
	],
	"./education-center/markdown/medical/leydig-cell-hypoplasia-type-ii": [
		328370,
		9,
		328370
	],
	"./education-center/markdown/medical/leydig-cell-hypoplasia-type-ii.md": [
		328370,
		9,
		328370
	],
	"./education-center/markdown/medical/leydig-hypoplasia-type-i": [
		929269,
		9,
		929269
	],
	"./education-center/markdown/medical/leydig-hypoplasia-type-i.md": [
		929269,
		9,
		929269
	],
	"./education-center/markdown/medical/lhermitte-duclos-disease": [
		957895,
		9,
		957895
	],
	"./education-center/markdown/medical/lhermitte-duclos-disease.md": [
		957895,
		9,
		957895
	],
	"./education-center/markdown/medical/li-fraumeni-syndrome-1": [
		980215,
		9,
		980215
	],
	"./education-center/markdown/medical/li-fraumeni-syndrome-1.md": [
		980215,
		9,
		980215
	],
	"./education-center/markdown/medical/lig4-related-disorders": [
		808211,
		9,
		808211
	],
	"./education-center/markdown/medical/lig4-related-disorders.md": [
		808211,
		9,
		808211
	],
	"./education-center/markdown/medical/limb-girdle-muscular-dystrophy-dominant": [
		841300,
		9,
		841300
	],
	"./education-center/markdown/medical/limb-girdle-muscular-dystrophy-dominant.md": [
		841300,
		9,
		841300
	],
	"./education-center/markdown/medical/limb-girdle-muscular-dystrophy-recessive": [
		609663,
		9,
		609663
	],
	"./education-center/markdown/medical/limb-girdle-muscular-dystrophy-recessive.md": [
		609663,
		9,
		609663
	],
	"./education-center/markdown/medical/lingual-thyroid": [
		575352,
		9,
		575352
	],
	"./education-center/markdown/medical/lingual-thyroid.md": [
		575352,
		9,
		575352
	],
	"./education-center/markdown/medical/lipoatrophy-diabetes-hepatic-steatosis-hypertrophic-cardiomyopathy-and-leukomelanodermic-papules": [
		767463,
		9,
		767463
	],
	"./education-center/markdown/medical/lipoatrophy-diabetes-hepatic-steatosis-hypertrophic-cardiomyopathy-and-leukomelanodermic-papules.md": [
		767463,
		9,
		767463
	],
	"./education-center/markdown/medical/lipodystrophy": [
		37468,
		9,
		37468
	],
	"./education-center/markdown/medical/lipodystrophy.md": [
		37468,
		9,
		37468
	],
	"./education-center/markdown/medical/lipoid-nephrosis": [
		140213,
		9,
		140213
	],
	"./education-center/markdown/medical/lipoid-nephrosis.md": [
		140213,
		9,
		140213
	],
	"./education-center/markdown/medical/lipoma-somatic": [
		627042,
		9,
		627042
	],
	"./education-center/markdown/medical/lipoma-somatic.md": [
		627042,
		9,
		627042
	],
	"./education-center/markdown/medical/lipoproteina-deficiency-congenital": [
		597102,
		9,
		597102
	],
	"./education-center/markdown/medical/lipoproteina-deficiency-congenital.md": [
		597102,
		9,
		597102
	],
	"./education-center/markdown/medical/lissencephaly-4": [
		105990,
		9,
		105990
	],
	"./education-center/markdown/medical/lissencephaly-4.md": [
		105990,
		9,
		105990
	],
	"./education-center/markdown/medical/lissencephaly-recessive": [
		556517,
		9,
		556517
	],
	"./education-center/markdown/medical/lissencephaly-recessive.md": [
		556517,
		9,
		556517
	],
	"./education-center/markdown/medical/lissencephalysubcortical-band-heterotopia": [
		688772,
		9,
		688772
	],
	"./education-center/markdown/medical/lissencephalysubcortical-band-heterotopia.md": [
		688772,
		9,
		688772
	],
	"./education-center/markdown/medical/liver-disease-severe-congenital": [
		84590,
		9,
		84590
	],
	"./education-center/markdown/medical/liver-disease-severe-congenital.md": [
		84590,
		9,
		84590
	],
	"./education-center/markdown/medical/long-qt-syndrome-1-recessive": [
		641752,
		9,
		641752
	],
	"./education-center/markdown/medical/long-qt-syndrome-1-recessive.md": [
		641752,
		9,
		641752
	],
	"./education-center/markdown/medical/long-qt-syndrome-12-digenic": [
		290997,
		9,
		290997
	],
	"./education-center/markdown/medical/long-qt-syndrome-12-digenic.md": [
		290997,
		9,
		290997
	],
	"./education-center/markdown/medical/long-qt-syndrome-2-acquired-susceptibility": [
		206230,
		9,
		206230
	],
	"./education-center/markdown/medical/long-qt-syndrome-2-acquired-susceptibility.md": [
		206230,
		9,
		206230
	],
	"./education-center/markdown/medical/long-qt-syndrome-23-digenic": [
		333155,
		9,
		333155
	],
	"./education-center/markdown/medical/long-qt-syndrome-23-digenic.md": [
		333155,
		9,
		333155
	],
	"./education-center/markdown/medical/long-qt-syndrome-25-digenic": [
		623751,
		9,
		623751
	],
	"./education-center/markdown/medical/long-qt-syndrome-25-digenic.md": [
		623751,
		9,
		623751
	],
	"./education-center/markdown/medical/long-qt-syndrome-29-digenic": [
		191723,
		9,
		191723
	],
	"./education-center/markdown/medical/long-qt-syndrome-29-digenic.md": [
		191723,
		9,
		191723
	],
	"./education-center/markdown/medical/long-qt-syndrome-3-acquired-susceptibility": [
		5344,
		9,
		5344
	],
	"./education-center/markdown/medical/long-qt-syndrome-3-acquired-susceptibility.md": [
		5344,
		9,
		5344
	],
	"./education-center/markdown/medical/long-qt-syndrome-36-digenic": [
		146200,
		9,
		146200
	],
	"./education-center/markdown/medical/long-qt-syndrome-36-digenic.md": [
		146200,
		9,
		146200
	],
	"./education-center/markdown/medical/long-qt-syndrome-5-acquired-susceptibility": [
		439890,
		9,
		439890
	],
	"./education-center/markdown/medical/long-qt-syndrome-5-acquired-susceptibility.md": [
		439890,
		9,
		439890
	],
	"./education-center/markdown/medical/long-qt-syndrome-6-acquired-susceptibility": [
		408116,
		9,
		408116
	],
	"./education-center/markdown/medical/long-qt-syndrome-6-acquired-susceptibility.md": [
		408116,
		9,
		408116
	],
	"./education-center/markdown/medical/long-qt-syndrome-bradycardia-induced": [
		670325,
		9,
		670325
	],
	"./education-center/markdown/medical/long-qt-syndrome-bradycardia-induced.md": [
		670325,
		9,
		670325
	],
	"./education-center/markdown/medical/long-qt-syndrome-drug-associated": [
		683140,
		9,
		683140
	],
	"./education-center/markdown/medical/long-qt-syndrome-drug-associated.md": [
		683140,
		9,
		683140
	],
	"./education-center/markdown/medical/low-alkaline-phosphatase": [
		730676,
		9,
		730676
	],
	"./education-center/markdown/medical/low-alkaline-phosphatase.md": [
		730676,
		9,
		730676
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-1": [
		649388,
		9,
		649388
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-1.md": [
		649388,
		9,
		649388
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-3": [
		369859,
		9,
		369859
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-3.md": [
		369859,
		9,
		369859
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6": [
		87868,
		9,
		87868
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.md": [
		87868,
		9,
		87868
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7": [
		610023,
		9,
		610023
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.md": [
		610023,
		9,
		610023
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8": [
		515026,
		9,
		515026
	],
	"./education-center/markdown/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.md": [
		515026,
		9,
		515026
	],
	"./education-center/markdown/medical/low-serum-calcitriol": [
		534208,
		9,
		534208
	],
	"./education-center/markdown/medical/low-serum-calcitriol.md": [
		534208,
		9,
		534208
	],
	"./education-center/markdown/medical/low-set-posteriorly-rotated-ears": [
		969887,
		9,
		969887
	],
	"./education-center/markdown/medical/low-set-posteriorly-rotated-ears.md": [
		969887,
		9,
		969887
	],
	"./education-center/markdown/medical/lower-limb-muscle-weakness": [
		750505,
		9,
		750505
	],
	"./education-center/markdown/medical/lower-limb-muscle-weakness.md": [
		750505,
		9,
		750505
	],
	"./education-center/markdown/medical/lower-limb-spasticity": [
		610217,
		9,
		610217
	],
	"./education-center/markdown/medical/lower-limb-spasticity.md": [
		610217,
		9,
		610217
	],
	"./education-center/markdown/medical/lung-cancer": [
		81804,
		9,
		81804
	],
	"./education-center/markdown/medical/lung-cancer-protection-against": [
		652815,
		9,
		652815
	],
	"./education-center/markdown/medical/lung-cancer-protection-against-smokers": [
		656010,
		9,
		656010
	],
	"./education-center/markdown/medical/lung-cancer-protection-against-smokers.md": [
		656010,
		9,
		656010
	],
	"./education-center/markdown/medical/lung-cancer-protection-against.md": [
		652815,
		9,
		652815
	],
	"./education-center/markdown/medical/lung-cancer-susceptibility-2": [
		994892,
		9,
		994892
	],
	"./education-center/markdown/medical/lung-cancer-susceptibility-2.md": [
		994892,
		9,
		994892
	],
	"./education-center/markdown/medical/lung-cancer.md": [
		81804,
		9,
		81804
	],
	"./education-center/markdown/medical/lung-carcinoid-tumor": [
		610671,
		9,
		610671
	],
	"./education-center/markdown/medical/lung-carcinoid-tumor.md": [
		610671,
		9,
		610671
	],
	"./education-center/markdown/medical/lung-carcinoma": [
		442079,
		9,
		442079
	],
	"./education-center/markdown/medical/lung-carcinoma.md": [
		442079,
		9,
		442079
	],
	"./education-center/markdown/medical/lung-damage-immunodeficiency-and-chromosome-breakage-syndrome": [
		327940,
		9,
		327940
	],
	"./education-center/markdown/medical/lung-damage-immunodeficiency-and-chromosome-breakage-syndrome.md": [
		327940,
		9,
		327940
	],
	"./education-center/markdown/medical/lung-disease-non-specific": [
		232101,
		9,
		232101
	],
	"./education-center/markdown/medical/lung-disease-non-specific.md": [
		232101,
		9,
		232101
	],
	"./education-center/markdown/medical/luteinizing-hormone-resistance-female": [
		273593,
		9,
		273593
	],
	"./education-center/markdown/medical/luteinizing-hormone-resistance-female.md": [
		273593,
		9,
		273593
	],
	"./education-center/markdown/medical/lymphedema-distichiasis-syndrome-renal-disease-and-diabetes-mellitus": [
		265704,
		9,
		265704
	],
	"./education-center/markdown/medical/lymphedema-distichiasis-syndrome-renal-disease-and-diabetes-mellitus.md": [
		265704,
		9,
		265704
	],
	"./education-center/markdown/medical/lynch-syndrome": [
		367475,
		9,
		367475
	],
	"./education-center/markdown/medical/lynch-syndrome-1": [
		456832,
		9,
		456832
	],
	"./education-center/markdown/medical/lynch-syndrome-1.md": [
		456832,
		9,
		456832
	],
	"./education-center/markdown/medical/lynch-syndrome.md": [
		367475,
		9,
		367475
	],
	"./education-center/markdown/medical/macrocephaly": [
		335034,
		9,
		335034
	],
	"./education-center/markdown/medical/macrocephaly-and-epileptic-encephalopathy": [
		207530,
		9,
		207530
	],
	"./education-center/markdown/medical/macrocephaly-and-epileptic-encephalopathy.md": [
		207530,
		9,
		207530
	],
	"./education-center/markdown/medical/macrocephaly-macrosomia-facial-dysmorphism-syndrome": [
		729389,
		9,
		729389
	],
	"./education-center/markdown/medical/macrocephaly-macrosomia-facial-dysmorphism-syndrome.md": [
		729389,
		9,
		729389
	],
	"./education-center/markdown/medical/macrocephaly-neurodevelopmental-delay-lymphoid-hyperplasia-and-persistent-fetal-hemoglobin": [
		302489,
		9,
		302489
	],
	"./education-center/markdown/medical/macrocephaly-neurodevelopmental-delay-lymphoid-hyperplasia-and-persistent-fetal-hemoglobin.md": [
		302489,
		9,
		302489
	],
	"./education-center/markdown/medical/macrocephaly.md": [
		335034,
		9,
		335034
	],
	"./education-center/markdown/medical/macroglobulinemia-waldenstrom-somatic": [
		593093,
		9,
		593093
	],
	"./education-center/markdown/medical/macroglobulinemia-waldenstrom-somatic.md": [
		593093,
		9,
		593093
	],
	"./education-center/markdown/medical/macronodular-adrenal-hyperplasia": [
		952567,
		9,
		952567
	],
	"./education-center/markdown/medical/macronodular-adrenal-hyperplasia.md": [
		952567,
		9,
		952567
	],
	"./education-center/markdown/medical/macroscopic-hematuria": [
		11848,
		9,
		11848
	],
	"./education-center/markdown/medical/macroscopic-hematuria.md": [
		11848,
		9,
		11848
	],
	"./education-center/markdown/medical/macrothrombocytopenia": [
		170355,
		9,
		170355
	],
	"./education-center/markdown/medical/macrothrombocytopenia-familial-bernard-soulier-type": [
		648654,
		9,
		648654
	],
	"./education-center/markdown/medical/macrothrombocytopenia-familial-bernard-soulier-type.md": [
		648654,
		9,
		648654
	],
	"./education-center/markdown/medical/macrothrombocytopenia.md": [
		170355,
		9,
		170355
	],
	"./education-center/markdown/medical/macular-corneal-dystrophy-type-ii": [
		926413,
		9,
		926413
	],
	"./education-center/markdown/medical/macular-corneal-dystrophy-type-ii.md": [
		926413,
		9,
		926413
	],
	"./education-center/markdown/medical/macular-degeneration-age-related-13-susceptibility": [
		106335,
		9,
		106335
	],
	"./education-center/markdown/medical/macular-degeneration-age-related-13-susceptibility.md": [
		106335,
		9,
		106335
	],
	"./education-center/markdown/medical/macular-dystrophy": [
		843539,
		9,
		843539
	],
	"./education-center/markdown/medical/macular-dystrophy-retinal-4": [
		842103,
		9,
		842103
	],
	"./education-center/markdown/medical/macular-dystrophy-retinal-4.md": [
		842103,
		9,
		842103
	],
	"./education-center/markdown/medical/macular-dystrophy-retinal-5": [
		402514,
		9,
		402514
	],
	"./education-center/markdown/medical/macular-dystrophy-retinal-5.md": [
		402514,
		9,
		402514
	],
	"./education-center/markdown/medical/macular-dystrophy.md": [
		843539,
		9,
		843539
	],
	"./education-center/markdown/medical/major-depressive-disorder-response-citalopram-therapy": [
		815122,
		9,
		815122
	],
	"./education-center/markdown/medical/major-depressive-disorder-response-citalopram-therapy.md": [
		815122,
		9,
		815122
	],
	"./education-center/markdown/medical/malaria-cerebral-resistance": [
		591342,
		9,
		591342
	],
	"./education-center/markdown/medical/malaria-cerebral-resistance.md": [
		591342,
		9,
		591342
	],
	"./education-center/markdown/medical/malaria-cerebral-susceptibility": [
		75497,
		9,
		75497
	],
	"./education-center/markdown/medical/malaria-cerebral-susceptibility.md": [
		75497,
		9,
		75497
	],
	"./education-center/markdown/medical/malaria-resistance": [
		46720,
		9,
		46720
	],
	"./education-center/markdown/medical/malaria-resistance.md": [
		46720,
		9,
		46720
	],
	"./education-center/markdown/medical/malaria-severe-resistance": [
		345229,
		9,
		345229
	],
	"./education-center/markdown/medical/malaria-severe-resistance.md": [
		345229,
		9,
		345229
	],
	"./education-center/markdown/medical/malaria-severe-susceptibility": [
		373925,
		9,
		373925
	],
	"./education-center/markdown/medical/malaria-severe-susceptibility.md": [
		373925,
		9,
		373925
	],
	"./education-center/markdown/medical/malattia-leventinese": [
		233709,
		9,
		233709
	],
	"./education-center/markdown/medical/malattia-leventinese.md": [
		233709,
		9,
		233709
	],
	"./education-center/markdown/medical/male-germ-cell-tumor-somatic": [
		871923,
		9,
		871923
	],
	"./education-center/markdown/medical/male-germ-cell-tumor-somatic.md": [
		871923,
		9,
		871923
	],
	"./education-center/markdown/medical/male-infertility-due-obstructive-azoospermia": [
		286476,
		9,
		286476
	],
	"./education-center/markdown/medical/male-infertility-due-obstructive-azoospermia.md": [
		286476,
		9,
		286476
	],
	"./education-center/markdown/medical/male-infertility-spermatogenesis-disorder": [
		145676,
		9,
		145676
	],
	"./education-center/markdown/medical/male-infertility-spermatogenesis-disorder.md": [
		145676,
		9,
		145676
	],
	"./education-center/markdown/medical/male-pseudohermaphroditism": [
		34069,
		9,
		34069
	],
	"./education-center/markdown/medical/male-pseudohermaphroditism.md": [
		34069,
		9,
		34069
	],
	"./education-center/markdown/medical/malformation-heart-and-great-vessels": [
		660844,
		9,
		660844
	],
	"./education-center/markdown/medical/malformation-heart-and-great-vessels.md": [
		660844,
		9,
		660844
	],
	"./education-center/markdown/medical/malignant-hyperthermia-and-exertional-rhabdomyolosis": [
		787438,
		9,
		787438
	],
	"./education-center/markdown/medical/malignant-hyperthermia-and-exertional-rhabdomyolosis.md": [
		787438,
		9,
		787438
	],
	"./education-center/markdown/medical/malignant-hyperthermia-equivocal-halotane": [
		626710,
		9,
		626710
	],
	"./education-center/markdown/medical/malignant-hyperthermia-equivocal-halotane.md": [
		626710,
		9,
		626710
	],
	"./education-center/markdown/medical/malignant-hyperthermia-susceptibility-1": [
		945861,
		9,
		945861
	],
	"./education-center/markdown/medical/malignant-hyperthermia-susceptibility-1.md": [
		945861,
		9,
		945861
	],
	"./education-center/markdown/medical/malignant-hypothermia": [
		299543,
		9,
		299543
	],
	"./education-center/markdown/medical/malignant-hypothermia.md": [
		299543,
		9,
		299543
	],
	"./education-center/markdown/medical/malignant-melanoma-susceptibility": [
		881583,
		9,
		881583
	],
	"./education-center/markdown/medical/malignant-melanoma-susceptibility.md": [
		881583,
		9,
		881583
	],
	"./education-center/markdown/medical/malignant-neoplasm-brain": [
		496519,
		9,
		496519
	],
	"./education-center/markdown/medical/malignant-neoplasm-brain.md": [
		496519,
		9,
		496519
	],
	"./education-center/markdown/medical/malignant-peritoneal-mesothelioma": [
		31497,
		9,
		31497
	],
	"./education-center/markdown/medical/malignant-peritoneal-mesothelioma.md": [
		31497,
		9,
		31497
	],
	"./education-center/markdown/medical/malignant-rhabdoid-tumor-somatic": [
		104677,
		9,
		104677
	],
	"./education-center/markdown/medical/malignant-rhabdoid-tumor-somatic.md": [
		104677,
		9,
		104677
	],
	"./education-center/markdown/medical/malignant-tumor-breast": [
		585655,
		9,
		585655
	],
	"./education-center/markdown/medical/malignant-tumor-breast.md": [
		585655,
		9,
		585655
	],
	"./education-center/markdown/medical/malignant-tumor-esophagus": [
		311274,
		9,
		311274
	],
	"./education-center/markdown/medical/malignant-tumor-esophagus.md": [
		311274,
		9,
		311274
	],
	"./education-center/markdown/medical/malignant-tumor-testis": [
		782261,
		9,
		782261
	],
	"./education-center/markdown/medical/malignant-tumor-testis.md": [
		782261,
		9,
		782261
	],
	"./education-center/markdown/medical/malignant-tumor-urinary-bladder": [
		410868,
		9,
		410868
	],
	"./education-center/markdown/medical/malignant-tumor-urinary-bladder.md": [
		410868,
		9,
		410868
	],
	"./education-center/markdown/medical/mandibuloacral-dysplasia-type-lipodystrophy-atypical": [
		12623,
		9,
		12623
	],
	"./education-center/markdown/medical/mandibuloacral-dysplasia-type-lipodystrophy-atypical.md": [
		12623,
		9,
		12623
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-classic-type-ib": [
		716832,
		9,
		716832
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-classic-type-ib.md": [
		716832,
		9,
		716832
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-intermediate-type-ia": [
		493256,
		9,
		493256
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-intermediate-type-ia.md": [
		493256,
		9,
		493256
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-thiamine-responsive-type-ii": [
		664025,
		9,
		664025
	],
	"./education-center/markdown/medical/maple-syrup-urine-disease-thiamine-responsive-type-ii.md": [
		664025,
		9,
		664025
	],
	"./education-center/markdown/medical/mapt-related-spectrum-disorders": [
		130726,
		9,
		130726
	],
	"./education-center/markdown/medical/mapt-related-spectrum-disorders.md": [
		130726,
		9,
		130726
	],
	"./education-center/markdown/medical/marfan-syndrome": [
		589460,
		9,
		589460
	],
	"./education-center/markdown/medical/marfan-syndrome-atypical": [
		361249,
		9,
		361249
	],
	"./education-center/markdown/medical/marfan-syndrome-atypical.md": [
		361249,
		9,
		361249
	],
	"./education-center/markdown/medical/marfan-syndrome-autosomal-recessive": [
		579126,
		9,
		579126
	],
	"./education-center/markdown/medical/marfan-syndrome-autosomal-recessive.md": [
		579126,
		9,
		579126
	],
	"./education-center/markdown/medical/marfan-syndrome-incomplete": [
		832859,
		9,
		832859
	],
	"./education-center/markdown/medical/marfan-syndrome-incomplete.md": [
		832859,
		9,
		832859
	],
	"./education-center/markdown/medical/marfan-syndrome-mild": [
		388233,
		9,
		388233
	],
	"./education-center/markdown/medical/marfan-syndrome-mild-variable": [
		43911,
		9,
		43911
	],
	"./education-center/markdown/medical/marfan-syndrome-mild-variable.md": [
		43911,
		9,
		43911
	],
	"./education-center/markdown/medical/marfan-syndrome-mild.md": [
		388233,
		9,
		388233
	],
	"./education-center/markdown/medical/marfan-syndrome-severe-classic": [
		437811,
		9,
		437811
	],
	"./education-center/markdown/medical/marfan-syndrome-severe-classic.md": [
		437811,
		9,
		437811
	],
	"./education-center/markdown/medical/marfan-syndrome.md": [
		589460,
		9,
		589460
	],
	"./education-center/markdown/medical/marfan-syndromeloeys-dietz-syndromefamilial-thoracic-aortic-aneurysms-and-dissections": [
		806500,
		9,
		806500
	],
	"./education-center/markdown/medical/marfan-syndromeloeys-dietz-syndromefamilial-thoracic-aortic-aneurysms-and-dissections.md": [
		806500,
		9,
		806500
	],
	"./education-center/markdown/medical/marfanoid-habitus-and-intellectual-disability": [
		925456,
		9,
		925456
	],
	"./education-center/markdown/medical/marfanoid-habitus-and-intellectual-disability.md": [
		925456,
		9,
		925456
	],
	"./education-center/markdown/medical/marshall-syndrome": [
		436744,
		9,
		436744
	],
	"./education-center/markdown/medical/marshall-syndrome.md": [
		436744,
		9,
		436744
	],
	"./education-center/markdown/medical/marshallstickler-syndrome": [
		788540,
		9,
		788540
	],
	"./education-center/markdown/medical/marshallstickler-syndrome.md": [
		788540,
		9,
		788540
	],
	"./education-center/markdown/medical/mastocytosis": [
		921949,
		9,
		921949
	],
	"./education-center/markdown/medical/mastocytosis-cutaneous-and-systemic-somatic": [
		508807,
		9,
		508807
	],
	"./education-center/markdown/medical/mastocytosis-cutaneous-and-systemic-somatic.md": [
		508807,
		9,
		508807
	],
	"./education-center/markdown/medical/mastocytosis.md": [
		921949,
		9,
		921949
	],
	"./education-center/markdown/medical/maturity-onset-diabetes-young-type-1": [
		736240,
		9,
		736240
	],
	"./education-center/markdown/medical/maturity-onset-diabetes-young-type-1.md": [
		736240,
		9,
		736240
	],
	"./education-center/markdown/medical/maturity-onset-diabetes-young-type-2": [
		688381,
		9,
		688381
	],
	"./education-center/markdown/medical/maturity-onset-diabetes-young-type-2.md": [
		688381,
		9,
		688381
	],
	"./education-center/markdown/medical/mbd5-associated-neurodevelopmental-disorder": [
		729300,
		9,
		729300
	],
	"./education-center/markdown/medical/mbd5-associated-neurodevelopmental-disorder.md": [
		729300,
		9,
		729300
	],
	"./education-center/markdown/medical/mcardle-disease-mild": [
		802354,
		9,
		802354
	],
	"./education-center/markdown/medical/mcardle-disease-mild.md": [
		802354,
		9,
		802354
	],
	"./education-center/markdown/medical/median-cleft-lip-and-palate": [
		736008,
		9,
		736008
	],
	"./education-center/markdown/medical/median-cleft-lip-and-palate.md": [
		736008,
		9,
		736008
	],
	"./education-center/markdown/medical/medium-chain-dicarboxylic-aciduria": [
		395835,
		9,
		395835
	],
	"./education-center/markdown/medical/medium-chain-dicarboxylic-aciduria.md": [
		395835,
		9,
		395835
	],
	"./education-center/markdown/medical/medulloblastoma": [
		62879,
		9,
		62879
	],
	"./education-center/markdown/medical/medulloblastoma.md": [
		62879,
		9,
		62879
	],
	"./education-center/markdown/medical/megacolon": [
		365550,
		9,
		365550
	],
	"./education-center/markdown/medical/megacolon.md": [
		365550,
		9,
		365550
	],
	"./education-center/markdown/medical/megalencephaly-thick-corpus-callosum-cerebellar-atrophy-and-intellectual-disability": [
		115235,
		9,
		115235
	],
	"./education-center/markdown/medical/megalencephaly-thick-corpus-callosum-cerebellar-atrophy-and-intellectual-disability.md": [
		115235,
		9,
		115235
	],
	"./education-center/markdown/medical/melanoma": [
		492073,
		9,
		492073
	],
	"./education-center/markdown/medical/melanoma-and-neural-system-tumor-syndrome": [
		382968,
		9,
		382968
	],
	"./education-center/markdown/medical/melanoma-and-neural-system-tumor-syndrome.md": [
		382968,
		9,
		382968
	],
	"./education-center/markdown/medical/melanoma-cutaneous-malignant-susceptibility-1": [
		160439,
		9,
		160439
	],
	"./education-center/markdown/medical/melanoma-cutaneous-malignant-susceptibility-1.md": [
		160439,
		9,
		160439
	],
	"./education-center/markdown/medical/melanoma-cutaneous-malignant-susceptibility-2": [
		152256,
		9,
		152256
	],
	"./education-center/markdown/medical/melanoma-cutaneous-malignant-susceptibility-2.md": [
		152256,
		9,
		152256
	],
	"./education-center/markdown/medical/melanoma.md": [
		492073,
		9,
		492073
	],
	"./education-center/markdown/medical/melioidosis-resistance": [
		44100,
		9,
		44100
	],
	"./education-center/markdown/medical/melioidosis-resistance.md": [
		44100,
		9,
		44100
	],
	"./education-center/markdown/medical/melnick-fraser-syndrome": [
		707878,
		9,
		707878
	],
	"./education-center/markdown/medical/melnick-fraser-syndrome.md": [
		707878,
		9,
		707878
	],
	"./education-center/markdown/medical/melorheostosis": [
		970635,
		9,
		970635
	],
	"./education-center/markdown/medical/melorheostosis.md": [
		970635,
		9,
		970635
	],
	"./education-center/markdown/medical/memory-quantitative-trait-locus": [
		659682,
		9,
		659682
	],
	"./education-center/markdown/medical/memory-quantitative-trait-locus.md": [
		659682,
		9,
		659682
	],
	"./education-center/markdown/medical/men2-phenotype-unclassified": [
		888699,
		9,
		888699
	],
	"./education-center/markdown/medical/men2-phenotype-unclassified.md": [
		888699,
		9,
		888699
	],
	"./education-center/markdown/medical/meniere-disease": [
		674010,
		9,
		674010
	],
	"./education-center/markdown/medical/meniere-disease.md": [
		674010,
		9,
		674010
	],
	"./education-center/markdown/medical/menkes-disease-copper-replacement-responsive": [
		400723,
		9,
		400723
	],
	"./education-center/markdown/medical/menkes-disease-copper-replacement-responsive.md": [
		400723,
		9,
		400723
	],
	"./education-center/markdown/medical/menkes-disease-mild": [
		834021,
		9,
		834021
	],
	"./education-center/markdown/medical/menkes-disease-mild.md": [
		834021,
		9,
		834021
	],
	"./education-center/markdown/medical/mephenytoin-poor-metabolism": [
		510075,
		9,
		510075
	],
	"./education-center/markdown/medical/mephenytoin-poor-metabolism.md": [
		510075,
		9,
		510075
	],
	"./education-center/markdown/medical/meretoja-syndrome": [
		271721,
		9,
		271721
	],
	"./education-center/markdown/medical/meretoja-syndrome.md": [
		271721,
		9,
		271721
	],
	"./education-center/markdown/medical/merff-syndrome": [
		154392,
		9,
		154392
	],
	"./education-center/markdown/medical/merff-syndrome.md": [
		154392,
		9,
		154392
	],
	"./education-center/markdown/medical/merrfmelas-overlap-syndrome": [
		469838,
		9,
		469838
	],
	"./education-center/markdown/medical/merrfmelas-overlap-syndrome.md": [
		469838,
		9,
		469838
	],
	"./education-center/markdown/medical/metabolic-syndrome-susceptibility": [
		12074,
		9,
		12074
	],
	"./education-center/markdown/medical/metabolic-syndrome-susceptibility.md": [
		12074,
		9,
		12074
	],
	"./education-center/markdown/medical/metachondromatosis": [
		2202,
		9,
		2202
	],
	"./education-center/markdown/medical/metachondromatosis.md": [
		2202,
		9,
		2202
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-late-onset": [
		358186,
		9,
		358186
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-late-onset.md": [
		358186,
		9,
		358186
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-mild": [
		473094,
		9,
		473094
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-mild.md": [
		473094,
		9,
		473094
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-severe": [
		97939,
		9,
		97939
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-severe.md": [
		97939,
		9,
		97939
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-variant": [
		990913,
		9,
		990913
	],
	"./education-center/markdown/medical/metachromatic-leukodystrophy-variant.md": [
		990913,
		9,
		990913
	],
	"./education-center/markdown/medical/metaphyseal-anadysplasia-1-autosomal-dominant": [
		595261,
		9,
		595261
	],
	"./education-center/markdown/medical/metaphyseal-anadysplasia-1-autosomal-dominant.md": [
		595261,
		9,
		595261
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia": [
		863314,
		9,
		863314
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia-jansen-type": [
		434634,
		9,
		434634
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia-jansen-type.md": [
		434634,
		9,
		434634
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia-schmid-type": [
		654342,
		9,
		654342
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia-schmid-type.md": [
		654342,
		9,
		654342
	],
	"./education-center/markdown/medical/metaphyseal-chondrodysplasia.md": [
		863314,
		9,
		863314
	],
	"./education-center/markdown/medical/metaphyseal-dysplasia-maxillary-hypoplasia-brachydacty-syndrome": [
		619513,
		9,
		619513
	],
	"./education-center/markdown/medical/metaphyseal-dysplasia-maxillary-hypoplasia-brachydacty-syndrome.md": [
		619513,
		9,
		619513
	],
	"./education-center/markdown/medical/metastatic-prostate-small-cell-carcinoma": [
		421071,
		9,
		421071
	],
	"./education-center/markdown/medical/metastatic-prostate-small-cell-carcinoma.md": [
		421071,
		9,
		421071
	],
	"./education-center/markdown/medical/metatropic-dysplasia": [
		176102,
		9,
		176102
	],
	"./education-center/markdown/medical/metatropic-dysplasia.md": [
		176102,
		9,
		176102
	],
	"./education-center/markdown/medical/methemoglobinemia-beta-globin-type": [
		841757,
		9,
		841757
	],
	"./education-center/markdown/medical/methemoglobinemia-beta-globin-type.md": [
		841757,
		9,
		841757
	],
	"./education-center/markdown/medical/methemoglobinemia-type-2": [
		153914,
		9,
		153914
	],
	"./education-center/markdown/medical/methemoglobinemia-type-2.md": [
		153914,
		9,
		153914
	],
	"./education-center/markdown/medical/methemoglobinemia-type-i": [
		181124,
		9,
		181124
	],
	"./education-center/markdown/medical/methemoglobinemia-type-i.md": [
		181124,
		9,
		181124
	],
	"./education-center/markdown/medical/methotrexate-response-efficacy": [
		625874,
		9,
		625874
	],
	"./education-center/markdown/medical/methotrexate-response-efficacy.md": [
		625874,
		9,
		625874
	],
	"./education-center/markdown/medical/methylmalonic-acidemia-homocystinuria-cblc": [
		86875,
		9,
		86875
	],
	"./education-center/markdown/medical/methylmalonic-acidemia-homocystinuria-cblc.md": [
		86875,
		9,
		86875
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-and-homocystinuria-cblc-type-digenic": [
		531072,
		9,
		531072
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-and-homocystinuria-cblc-type-digenic.md": [
		531072,
		9,
		531072
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-mut-type": [
		423236,
		9,
		423236
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-mut-type.md": [
		423236,
		9,
		423236
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-mut0-type": [
		545290,
		9,
		545290
	],
	"./education-center/markdown/medical/methylmalonic-aciduria-mut0-type.md": [
		545290,
		9,
		545290
	],
	"./education-center/markdown/medical/mevalonic-aciduria": [
		700110,
		9,
		700110
	],
	"./education-center/markdown/medical/mevalonic-aciduria.md": [
		700110,
		9,
		700110
	],
	"./education-center/markdown/medical/microcephalic-osteodysplastic-primordial-dwarfism": [
		633785,
		9,
		633785
	],
	"./education-center/markdown/medical/microcephalic-osteodysplastic-primordial-dwarfism.md": [
		633785,
		9,
		633785
	],
	"./education-center/markdown/medical/microcephaly": [
		198337,
		9,
		198337
	],
	"./education-center/markdown/medical/microcephaly-and-chorioretinopathy-or-without-intellectual-disability": [
		161197,
		9,
		161197
	],
	"./education-center/markdown/medical/microcephaly-and-chorioretinopathy-or-without-intellectual-disability.md": [
		161197,
		9,
		161197
	],
	"./education-center/markdown/medical/microcephaly-cortical-malformations-and-intellectual-disability": [
		904477,
		9,
		904477
	],
	"./education-center/markdown/medical/microcephaly-cortical-malformations-and-intellectual-disability.md": [
		904477,
		9,
		904477
	],
	"./education-center/markdown/medical/microcephaly-or-without-chorioretinopathy-lymphedema-or-intellectual-disability": [
		336514,
		9,
		336514
	],
	"./education-center/markdown/medical/microcephaly-or-without-chorioretinopathy-lymphedema-or-intellectual-disability.md": [
		336514,
		9,
		336514
	],
	"./education-center/markdown/medical/microcephaly-short-stature-and-impaired-glucose-metabolism-1": [
		253274,
		9,
		253274
	],
	"./education-center/markdown/medical/microcephaly-short-stature-and-impaired-glucose-metabolism-1.md": [
		253274,
		9,
		253274
	],
	"./education-center/markdown/medical/microcephaly-short-stature-and-polymicrogyria-seizures": [
		54062,
		9,
		54062
	],
	"./education-center/markdown/medical/microcephaly-short-stature-and-polymicrogyria-seizures.md": [
		54062,
		9,
		54062
	],
	"./education-center/markdown/medical/microcephaly.md": [
		198337,
		9,
		198337
	],
	"./education-center/markdown/medical/microcytic-anemia": [
		575469,
		9,
		575469
	],
	"./education-center/markdown/medical/microcytic-anemia.md": [
		575469,
		9,
		575469
	],
	"./education-center/markdown/medical/micropenis": [
		417415,
		9,
		417415
	],
	"./education-center/markdown/medical/micropenis.md": [
		417415,
		9,
		417415
	],
	"./education-center/markdown/medical/microphthalmia-cataracts-and-iris-abnormalities": [
		50135,
		9,
		50135
	],
	"./education-center/markdown/medical/microphthalmia-cataracts-and-iris-abnormalities.md": [
		50135,
		9,
		50135
	],
	"./education-center/markdown/medical/microphthalmia-syndromic-15": [
		303074,
		9,
		303074
	],
	"./education-center/markdown/medical/microphthalmia-syndromic-15.md": [
		303074,
		9,
		303074
	],
	"./education-center/markdown/medical/microprolactinoma": [
		139403,
		9,
		139403
	],
	"./education-center/markdown/medical/microprolactinoma.md": [
		139403,
		9,
		139403
	],
	"./education-center/markdown/medical/microscopic-hematuria": [
		486985,
		9,
		486985
	],
	"./education-center/markdown/medical/microscopic-hematuria.md": [
		486985,
		9,
		486985
	],
	"./education-center/markdown/medical/microspherophakia": [
		454109,
		9,
		454109
	],
	"./education-center/markdown/medical/microspherophakia.md": [
		454109,
		9,
		454109
	],
	"./education-center/markdown/medical/microtia-or-without-hearing-impairment": [
		857815,
		9,
		857815
	],
	"./education-center/markdown/medical/microtia-or-without-hearing-impairment.md": [
		857815,
		9,
		857815
	],
	"./education-center/markdown/medical/migalastat-response": [
		544220,
		9,
		544220
	],
	"./education-center/markdown/medical/migalastat-response.md": [
		544220,
		9,
		544220
	],
	"./education-center/markdown/medical/migraine": [
		755037,
		9,
		755037
	],
	"./education-center/markdown/medical/migraine-familial-basilar": [
		415150,
		9,
		415150
	],
	"./education-center/markdown/medical/migraine-familial-basilar.md": [
		415150,
		9,
		415150
	],
	"./education-center/markdown/medical/migraine-or-without-aura-susceptibility-1": [
		168863,
		9,
		168863
	],
	"./education-center/markdown/medical/migraine-or-without-aura-susceptibility-1.md": [
		168863,
		9,
		168863
	],
	"./education-center/markdown/medical/migraine-resistance": [
		261093,
		9,
		261093
	],
	"./education-center/markdown/medical/migraine-resistance.md": [
		261093,
		9,
		261093
	],
	"./education-center/markdown/medical/migraine-sporadic-hemiplegic-progressive-cerebellar-ataxia": [
		893819,
		9,
		893819
	],
	"./education-center/markdown/medical/migraine-sporadic-hemiplegic-progressive-cerebellar-ataxia.md": [
		893819,
		9,
		893819
	],
	"./education-center/markdown/medical/migraine.md": [
		755037,
		9,
		755037
	],
	"./education-center/markdown/medical/mild-global-developmental-delay": [
		138418,
		9,
		138418
	],
	"./education-center/markdown/medical/mild-global-developmental-delay.md": [
		138418,
		9,
		138418
	],
	"./education-center/markdown/medical/mild-non-pku-hyperphenylalanemia": [
		191374,
		9,
		191374
	],
	"./education-center/markdown/medical/mild-non-pku-hyperphenylalanemia.md": [
		191374,
		9,
		191374
	],
	"./education-center/markdown/medical/mild-short-stature": [
		346157,
		9,
		346157
	],
	"./education-center/markdown/medical/mild-short-stature.md": [
		346157,
		9,
		346157
	],
	"./education-center/markdown/medical/mineralocorticoid-deficiency-isolated": [
		896652,
		9,
		896652
	],
	"./education-center/markdown/medical/mineralocorticoid-deficiency-isolated.md": [
		896652,
		9,
		896652
	],
	"./education-center/markdown/medical/mirror-movements-1": [
		522298,
		9,
		522298
	],
	"./education-center/markdown/medical/mirror-movements-1.md": [
		522298,
		9,
		522298
	],
	"./education-center/markdown/medical/mitochondrial-complex-iii-deficiency-nuclear-type-1": [
		590098,
		9,
		590098
	],
	"./education-center/markdown/medical/mitochondrial-complex-iii-deficiency-nuclear-type-1.md": [
		590098,
		9,
		590098
	],
	"./education-center/markdown/medical/mitochondrial-complex-iv-deficiency-recurrent-myoglobinuria": [
		448813,
		9,
		448813
	],
	"./education-center/markdown/medical/mitochondrial-complex-iv-deficiency-recurrent-myoglobinuria.md": [
		448813,
		9,
		448813
	],
	"./education-center/markdown/medical/mitochondrial-cytochrome-c-oxidase-deficiency": [
		586746,
		9,
		586746
	],
	"./education-center/markdown/medical/mitochondrial-cytochrome-c-oxidase-deficiency.md": [
		586746,
		9,
		586746
	],
	"./education-center/markdown/medical/mitochondrial-disorder-due-defect-assembly-or-maturation-respiratory-chain-complexes": [
		633511,
		9,
		633511
	],
	"./education-center/markdown/medical/mitochondrial-disorder-due-defect-assembly-or-maturation-respiratory-chain-complexes.md": [
		633511,
		9,
		633511
	],
	"./education-center/markdown/medical/mitochondrial-dna-associated-leigh-syndrome-and-narp": [
		994388,
		9,
		994388
	],
	"./education-center/markdown/medical/mitochondrial-dna-associated-leigh-syndrome-and-narp.md": [
		994388,
		9,
		994388
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-16a": [
		84864,
		9,
		84864
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-16a.md": [
		84864,
		9,
		84864
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-8b-mngie-type": [
		834007,
		9,
		834007
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-8b-mngie-type.md": [
		834007,
		9,
		834007
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-hepatocerebral-form": [
		73748,
		9,
		73748
	],
	"./education-center/markdown/medical/mitochondrial-dna-depletion-syndrome-hepatocerebral-form.md": [
		73748,
		9,
		73748
	],
	"./education-center/markdown/medical/mitochondrial-dna-related-disorder": [
		907430,
		9,
		907430
	],
	"./education-center/markdown/medical/mitochondrial-dna-related-disorder.md": [
		907430,
		9,
		907430
	],
	"./education-center/markdown/medical/mitochondrial-encephalomyopathy": [
		948880,
		9,
		948880
	],
	"./education-center/markdown/medical/mitochondrial-encephalomyopathy.md": [
		948880,
		9,
		948880
	],
	"./education-center/markdown/medical/mitochondrial-encephalopathy": [
		517817,
		9,
		517817
	],
	"./education-center/markdown/medical/mitochondrial-encephalopathy.md": [
		517817,
		9,
		517817
	],
	"./education-center/markdown/medical/mitochondrial-hepatopathy": [
		467983,
		9,
		467983
	],
	"./education-center/markdown/medical/mitochondrial-hepatopathy.md": [
		467983,
		9,
		467983
	],
	"./education-center/markdown/medical/mitochondrial-inheritance": [
		558732,
		9,
		558732
	],
	"./education-center/markdown/medical/mitochondrial-inheritance.md": [
		558732,
		9,
		558732
	],
	"./education-center/markdown/medical/mitochondrial-myopathy-episodic-without-optic-atrophy-and-reversible-leukoencephalopathy": [
		109772,
		9,
		109772
	],
	"./education-center/markdown/medical/mitochondrial-myopathy-episodic-without-optic-atrophy-and-reversible-leukoencephalopathy.md": [
		109772,
		9,
		109772
	],
	"./education-center/markdown/medical/mitochondrial-myopathy-isolated": [
		934914,
		9,
		934914
	],
	"./education-center/markdown/medical/mitochondrial-myopathy-isolated.md": [
		934914,
		9,
		934914
	],
	"./education-center/markdown/medical/mitochondrial-trifunctional-protein-deficiency-2": [
		110510,
		9,
		110510
	],
	"./education-center/markdown/medical/mitochondrial-trifunctional-protein-deficiency-2-myopathy-and-neuropathy": [
		106795,
		9,
		106795
	],
	"./education-center/markdown/medical/mitochondrial-trifunctional-protein-deficiency-2-myopathy-and-neuropathy.md": [
		106795,
		9,
		106795
	],
	"./education-center/markdown/medical/mitochondrial-trifunctional-protein-deficiency-2.md": [
		110510,
		9,
		110510
	],
	"./education-center/markdown/medical/mixed-phenotype-acute-leukemia-tv11q233-kmt2a-rearranged": [
		547906,
		9,
		547906
	],
	"./education-center/markdown/medical/mixed-phenotype-acute-leukemia-tv11q233-kmt2a-rearranged.md": [
		547906,
		9,
		547906
	],
	"./education-center/markdown/medical/mks1-related-disorders": [
		26660,
		9,
		26660
	],
	"./education-center/markdown/medical/mks1-related-disorders.md": [
		26660,
		9,
		26660
	],
	"./education-center/markdown/medical/moderate-global-developmental-delay": [
		299372,
		9,
		299372
	],
	"./education-center/markdown/medical/moderate-global-developmental-delay.md": [
		299372,
		9,
		299372
	],
	"./education-center/markdown/medical/moderate-intellectual-deficiency": [
		56421,
		9,
		56421
	],
	"./education-center/markdown/medical/moderate-intellectual-deficiency.md": [
		56421,
		9,
		56421
	],
	"./education-center/markdown/medical/monocarboxylate-transporter-1-deficiency-autosomal-dominant": [
		494140,
		9,
		494140
	],
	"./education-center/markdown/medical/monocarboxylate-transporter-1-deficiency-autosomal-dominant.md": [
		494140,
		9,
		494140
	],
	"./education-center/markdown/medical/monocarboxylate-transporter-1-deficiency-autosomal-recessive": [
		809057,
		9,
		809057
	],
	"./education-center/markdown/medical/monocarboxylate-transporter-1-deficiency-autosomal-recessive.md": [
		809057,
		9,
		809057
	],
	"./education-center/markdown/medical/monochromacy": [
		317895,
		9,
		317895
	],
	"./education-center/markdown/medical/monochromacy.md": [
		317895,
		9,
		317895
	],
	"./education-center/markdown/medical/monoclonal-b-cell-lymphocytosis": [
		253068,
		9,
		253068
	],
	"./education-center/markdown/medical/monoclonal-b-cell-lymphocytosis.md": [
		253068,
		9,
		253068
	],
	"./education-center/markdown/medical/monogenic-non-syndromic-obesity": [
		34257,
		9,
		34257
	],
	"./education-center/markdown/medical/monogenic-non-syndromic-obesity.md": [
		34257,
		9,
		34257
	],
	"./education-center/markdown/medical/monomelic-amyotrophy": [
		98592,
		9,
		98592
	],
	"./education-center/markdown/medical/monomelic-amyotrophy.md": [
		98592,
		9,
		98592
	],
	"./education-center/markdown/medical/mononeuropathy-median-nerve": [
		827150,
		9,
		827150
	],
	"./education-center/markdown/medical/mononeuropathy-median-nerve.md": [
		827150,
		9,
		827150
	],
	"./education-center/markdown/medical/morbid-obesity": [
		635740,
		9,
		635740
	],
	"./education-center/markdown/medical/morbid-obesity.md": [
		635740,
		9,
		635740
	],
	"./education-center/markdown/medical/morm-syndrome": [
		531221,
		9,
		531221
	],
	"./education-center/markdown/medical/morm-syndrome.md": [
		531221,
		9,
		531221
	],
	"./education-center/markdown/medical/mosaic-variegated-aneuploidy-syndrome": [
		380073,
		9,
		380073
	],
	"./education-center/markdown/medical/mosaic-variegated-aneuploidy-syndrome.md": [
		380073,
		9,
		380073
	],
	"./education-center/markdown/medical/motor-axonal-neuropathy": [
		987618,
		9,
		987618
	],
	"./education-center/markdown/medical/motor-axonal-neuropathy.md": [
		987618,
		9,
		987618
	],
	"./education-center/markdown/medical/motor-delay": [
		453990,
		9,
		453990
	],
	"./education-center/markdown/medical/motor-delay.md": [
		453990,
		9,
		453990
	],
	"./education-center/markdown/medical/motor-tics": [
		659425,
		9,
		659425
	],
	"./education-center/markdown/medical/motor-tics.md": [
		659425,
		9,
		659425
	],
	"./education-center/markdown/medical/movement-disorder": [
		748796,
		9,
		748796
	],
	"./education-center/markdown/medical/movement-disorder.md": [
		748796,
		9,
		748796
	],
	"./education-center/markdown/medical/mpv17-related-disorders": [
		335122,
		9,
		335122
	],
	"./education-center/markdown/medical/mpv17-related-disorders.md": [
		335122,
		9,
		335122
	],
	"./education-center/markdown/medical/mthfr-thermolabile-polymorphism": [
		779533,
		9,
		779533
	],
	"./education-center/markdown/medical/mthfr-thermolabile-polymorphism.md": [
		779533,
		9,
		779533
	],
	"./education-center/markdown/medical/mucolipidosis": [
		36356,
		9,
		36356
	],
	"./education-center/markdown/medical/mucolipidosis-iii-alphabeta-atypical": [
		614748,
		9,
		614748
	],
	"./education-center/markdown/medical/mucolipidosis-iii-alphabeta-atypical.md": [
		614748,
		9,
		614748
	],
	"./education-center/markdown/medical/mucolipidosis-type-iii-alphabeta": [
		725812,
		9,
		725812
	],
	"./education-center/markdown/medical/mucolipidosis-type-iii-alphabeta.md": [
		725812,
		9,
		725812
	],
	"./education-center/markdown/medical/mucolipidosis.md": [
		36356,
		9,
		36356
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-1": [
		744096,
		9,
		744096
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-1.md": [
		744096,
		9,
		744096
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-ii-mild-form": [
		493767,
		9,
		493767
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-ii-mild-form.md": [
		493767,
		9,
		493767
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-intermediate": [
		603163,
		9,
		603163
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-intermediate.md": [
		603163,
		9,
		603163
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-mild": [
		902092,
		9,
		902092
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-mild.md": [
		902092,
		9,
		902092
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-severe": [
		459432,
		9,
		459432
	],
	"./education-center/markdown/medical/mucopolysaccharidosis-type-vi-severe.md": [
		459432,
		9,
		459432
	],
	"./education-center/markdown/medical/mucopolysacchariduria": [
		844425,
		9,
		844425
	],
	"./education-center/markdown/medical/mucopolysacchariduria.md": [
		844425,
		9,
		844425
	],
	"./education-center/markdown/medical/mucosa-associated-lymphoma": [
		693072,
		9,
		693072
	],
	"./education-center/markdown/medical/mucosa-associated-lymphoma.md": [
		693072,
		9,
		693072
	],
	"./education-center/markdown/medical/muir-torré-syndrome": [
		14636,
		9,
		14636
	],
	"./education-center/markdown/medical/muir-torré-syndrome.md": [
		14636,
		9,
		14636
	],
	"./education-center/markdown/medical/mullerian-aplasia-and-hyperandrogenism": [
		184534,
		9,
		184534
	],
	"./education-center/markdown/medical/mullerian-aplasia-and-hyperandrogenism.md": [
		184534,
		9,
		184534
	],
	"./education-center/markdown/medical/multi-minicore-disease-and-atypical-periodic-paralysis": [
		192505,
		9,
		192505
	],
	"./education-center/markdown/medical/multi-minicore-disease-and-atypical-periodic-paralysis.md": [
		192505,
		9,
		192505
	],
	"./education-center/markdown/medical/multicentric-osteolysis-nodulosis-arthropathy-mona-spectrum-disorders": [
		954846,
		9,
		954846
	],
	"./education-center/markdown/medical/multicentric-osteolysis-nodulosis-arthropathy-mona-spectrum-disorders.md": [
		954846,
		9,
		954846
	],
	"./education-center/markdown/medical/multifocal-breast-carcinoma": [
		258079,
		9,
		258079
	],
	"./education-center/markdown/medical/multifocal-breast-carcinoma.md": [
		258079,
		9,
		258079
	],
	"./education-center/markdown/medical/multiminicoreminicoremulticore-disease": [
		417400,
		9,
		417400
	],
	"./education-center/markdown/medical/multiminicoreminicoremulticore-disease.md": [
		417400,
		9,
		417400
	],
	"./education-center/markdown/medical/multiple-congenital-anomalies": [
		558585,
		9,
		558585
	],
	"./education-center/markdown/medical/multiple-congenital-anomalies.md": [
		558585,
		9,
		558585
	],
	"./education-center/markdown/medical/multiple-congenital-exostosis": [
		899554,
		9,
		899554
	],
	"./education-center/markdown/medical/multiple-congenital-exostosis.md": [
		899554,
		9,
		899554
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-1": [
		10927,
		9,
		10927
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-1.md": [
		10927,
		9,
		10927
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-iia-hirschsprung-disease": [
		160994,
		9,
		160994
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-iia-hirschsprung-disease.md": [
		160994,
		9,
		160994
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-iia-without-pheochromocytoma": [
		110020,
		9,
		110020
	],
	"./education-center/markdown/medical/multiple-endocrine-neoplasia-type-iia-without-pheochromocytoma.md": [
		110020,
		9,
		110020
	],
	"./education-center/markdown/medical/multiple-epiphyseal-dysplasia-dominant": [
		921715,
		9,
		921715
	],
	"./education-center/markdown/medical/multiple-epiphyseal-dysplasia-dominant.md": [
		921715,
		9,
		921715
	],
	"./education-center/markdown/medical/multiple-epiphyseal-dysplasia-type-1": [
		302456,
		9,
		302456
	],
	"./education-center/markdown/medical/multiple-epiphyseal-dysplasia-type-1.md": [
		302456,
		9,
		302456
	],
	"./education-center/markdown/medical/multiple-fibrofolliculomas": [
		76361,
		9,
		76361
	],
	"./education-center/markdown/medical/multiple-fibrofolliculomas.md": [
		76361,
		9,
		76361
	],
	"./education-center/markdown/medical/multiple-myeloma-resistance": [
		348946,
		9,
		348946
	],
	"./education-center/markdown/medical/multiple-myeloma-resistance.md": [
		348946,
		9,
		348946
	],
	"./education-center/markdown/medical/multiple-myeloma-translocation-1114-type": [
		446462,
		9,
		446462
	],
	"./education-center/markdown/medical/multiple-myeloma-translocation-1114-type.md": [
		446462,
		9,
		446462
	],
	"./education-center/markdown/medical/multiple-sclerosis-modifier-disease-progression": [
		264106,
		9,
		264106
	],
	"./education-center/markdown/medical/multiple-sclerosis-modifier-disease-progression.md": [
		264106,
		9,
		264106
	],
	"./education-center/markdown/medical/multiple-sclerosis-susceptibility": [
		329060,
		9,
		329060
	],
	"./education-center/markdown/medical/multiple-sclerosis-susceptibility.md": [
		329060,
		9,
		329060
	],
	"./education-center/markdown/medical/multiple-self-healing-squamous-epithelioma": [
		809641,
		9,
		809641
	],
	"./education-center/markdown/medical/multiple-self-healing-squamous-epithelioma.md": [
		809641,
		9,
		809641
	],
	"./education-center/markdown/medical/multiple-system-atrophy": [
		996675,
		9,
		996675
	],
	"./education-center/markdown/medical/multiple-system-atrophy.md": [
		996675,
		9,
		996675
	],
	"./education-center/markdown/medical/multisystem-disorder": [
		474098,
		9,
		474098
	],
	"./education-center/markdown/medical/multisystem-disorder.md": [
		474098,
		9,
		474098
	],
	"./education-center/markdown/medical/multisystem-inflammatory-syndrome-children": [
		457546,
		9,
		457546
	],
	"./education-center/markdown/medical/multisystem-inflammatory-syndrome-children.md": [
		457546,
		9,
		457546
	],
	"./education-center/markdown/medical/muscle-stiffness-painful": [
		503137,
		9,
		503137
	],
	"./education-center/markdown/medical/muscle-stiffness-painful.md": [
		503137,
		9,
		503137
	],
	"./education-center/markdown/medical/muscular-dystrophy-and-arthrogryposis": [
		963126,
		9,
		963126
	],
	"./education-center/markdown/medical/muscular-dystrophy-and-arthrogryposis.md": [
		963126,
		9,
		963126
	],
	"./education-center/markdown/medical/muscular-dystrophy-congenital-or-without-seizures": [
		664842,
		9,
		664842
	],
	"./education-center/markdown/medical/muscular-dystrophy-congenital-or-without-seizures.md": [
		664842,
		9,
		664842
	],
	"./education-center/markdown/medical/muscular-dystrophy-dystroglycanopathy-congenital-without-impaired-intellectual-development-type-b-5": [
		781064,
		9,
		781064
	],
	"./education-center/markdown/medical/muscular-dystrophy-dystroglycanopathy-congenital-without-impaired-intellectual-development-type-b-5.md": [
		781064,
		9,
		781064
	],
	"./education-center/markdown/medical/mutilating-keratoderma": [
		327658,
		9,
		327658
	],
	"./education-center/markdown/medical/mutilating-keratoderma.md": [
		327658,
		9,
		327658
	],
	"./education-center/markdown/medical/mvk-related-disorders": [
		696188,
		9,
		696188
	],
	"./education-center/markdown/medical/mvk-related-disorders.md": [
		696188,
		9,
		696188
	],
	"./education-center/markdown/medical/myasthenic-syndrome-slow-channel-congenital": [
		807131,
		9,
		807131
	],
	"./education-center/markdown/medical/myasthenic-syndrome-slow-channel-congenital.md": [
		807131,
		9,
		807131
	],
	"./education-center/markdown/medical/mybpc3-related-disorders": [
		529970,
		9,
		529970
	],
	"./education-center/markdown/medical/mybpc3-related-disorders.md": [
		529970,
		9,
		529970
	],
	"./education-center/markdown/medical/mycobacterium-tuberculosis-protection-against": [
		936542,
		9,
		936542
	],
	"./education-center/markdown/medical/mycobacterium-tuberculosis-protection-against.md": [
		936542,
		9,
		936542
	],
	"./education-center/markdown/medical/myelodysplastic-syndrome-progressed-acute-myeloid-leukemia": [
		51875,
		9,
		51875
	],
	"./education-center/markdown/medical/myelodysplastic-syndrome-progressed-acute-myeloid-leukemia.md": [
		51875,
		9,
		51875
	],
	"./education-center/markdown/medical/myeloproliferative-disorder": [
		172189,
		9,
		172189
	],
	"./education-center/markdown/medical/myeloproliferative-disorder-chronic-eosinophilia": [
		894362,
		9,
		894362
	],
	"./education-center/markdown/medical/myeloproliferative-disorder-chronic-eosinophilia.md": [
		894362,
		9,
		894362
	],
	"./education-center/markdown/medical/myeloproliferative-disorder.md": [
		172189,
		9,
		172189
	],
	"./education-center/markdown/medical/myh3-related-disorders": [
		585983,
		9,
		585983
	],
	"./education-center/markdown/medical/myh3-related-disorders.md": [
		585983,
		9,
		585983
	],
	"./education-center/markdown/medical/myh7-related-disorders": [
		446287,
		9,
		446287
	],
	"./education-center/markdown/medical/myh7-related-disorders.md": [
		446287,
		9,
		446287
	],
	"./education-center/markdown/medical/myh7-related-skeletal-myopathy": [
		507125,
		9,
		507125
	],
	"./education-center/markdown/medical/myh7-related-skeletal-myopathy.md": [
		507125,
		9,
		507125
	],
	"./education-center/markdown/medical/myh9-related-disorder": [
		228484,
		9,
		228484
	],
	"./education-center/markdown/medical/myh9-related-disorder.md": [
		228484,
		9,
		228484
	],
	"./education-center/markdown/medical/myhre-syndrome": [
		641587,
		9,
		641587
	],
	"./education-center/markdown/medical/myhre-syndrome.md": [
		641587,
		9,
		641587
	],
	"./education-center/markdown/medical/myo7a-related-disorders": [
		328128,
		9,
		328128
	],
	"./education-center/markdown/medical/myo7a-related-disorders.md": [
		328128,
		9,
		328128
	],
	"./education-center/markdown/medical/myoc-related-disorders": [
		130014,
		9,
		130014
	],
	"./education-center/markdown/medical/myoc-related-disorders.md": [
		130014,
		9,
		130014
	],
	"./education-center/markdown/medical/myocardial-infarction-1": [
		342409,
		9,
		342409
	],
	"./education-center/markdown/medical/myocardial-infarction-1.md": [
		342409,
		9,
		342409
	],
	"./education-center/markdown/medical/myocardial-infarction-protection-against": [
		338352,
		9,
		338352
	],
	"./education-center/markdown/medical/myocardial-infarction-protection-against.md": [
		338352,
		9,
		338352
	],
	"./education-center/markdown/medical/myoclonic-absence-seizure": [
		769716,
		9,
		769716
	],
	"./education-center/markdown/medical/myoclonic-absence-seizure.md": [
		769716,
		9,
		769716
	],
	"./education-center/markdown/medical/myoclonic-encephalopathy": [
		729970,
		9,
		729970
	],
	"./education-center/markdown/medical/myoclonic-encephalopathy.md": [
		729970,
		9,
		729970
	],
	"./education-center/markdown/medical/myofibrillar-myopathy-dominant": [
		990964,
		9,
		990964
	],
	"./education-center/markdown/medical/myofibrillar-myopathy-dominant.md": [
		990964,
		9,
		990964
	],
	"./education-center/markdown/medical/myokymia": [
		924421,
		9,
		924421
	],
	"./education-center/markdown/medical/myokymia-1-hypomagnesemia": [
		489454,
		9,
		489454
	],
	"./education-center/markdown/medical/myokymia-1-hypomagnesemia.md": [
		489454,
		9,
		489454
	],
	"./education-center/markdown/medical/myokymia.md": [
		924421,
		9,
		924421
	],
	"./education-center/markdown/medical/myopathy-centronuclear-2": [
		99946,
		9,
		99946
	],
	"./education-center/markdown/medical/myopathy-centronuclear-2.md": [
		99946,
		9,
		99946
	],
	"./education-center/markdown/medical/myopathy-congenital-due-dihydropyridine-receptor-defect": [
		104948,
		9,
		104948
	],
	"./education-center/markdown/medical/myopathy-congenital-due-dihydropyridine-receptor-defect.md": [
		104948,
		9,
		104948
	],
	"./education-center/markdown/medical/myopathy-congenital-neonatal-respiratory-insufficiency": [
		124736,
		9,
		124736
	],
	"./education-center/markdown/medical/myopathy-congenital-neonatal-respiratory-insufficiency.md": [
		124736,
		9,
		124736
	],
	"./education-center/markdown/medical/myopathy-congenital-nonprogressive": [
		690058,
		9,
		690058
	],
	"./education-center/markdown/medical/myopathy-congenital-nonprogressive.md": [
		690058,
		9,
		690058
	],
	"./education-center/markdown/medical/myopathy-lactic-acidosis-and-sideroblastic-anemia": [
		605409,
		9,
		605409
	],
	"./education-center/markdown/medical/myopathy-lactic-acidosis-and-sideroblastic-anemia.md": [
		605409,
		9,
		605409
	],
	"./education-center/markdown/medical/myopathy-mitochondrial-diabetes-mellitus": [
		997549,
		9,
		997549
	],
	"./education-center/markdown/medical/myopathy-mitochondrial-diabetes-mellitus.md": [
		997549,
		9,
		997549
	],
	"./education-center/markdown/medical/myopathy-mitochondrial-late-onset": [
		114755,
		9,
		114755
	],
	"./education-center/markdown/medical/myopathy-mitochondrial-late-onset.md": [
		114755,
		9,
		114755
	],
	"./education-center/markdown/medical/myopathy-myalgia-increased-serum-creatine-kinase-and-or-without-episodic-rhabdomyolysis": [
		934478,
		9,
		934478
	],
	"./education-center/markdown/medical/myopathy-myalgia-increased-serum-creatine-kinase-and-or-without-episodic-rhabdomyolysis.md": [
		934478,
		9,
		934478
	],
	"./education-center/markdown/medical/myopathy-progressive-axial-cataracts": [
		964528,
		9,
		964528
	],
	"./education-center/markdown/medical/myopathy-progressive-axial-cataracts.md": [
		964528,
		9,
		964528
	],
	"./education-center/markdown/medical/myopathy-ryr1-associated": [
		811066,
		9,
		811066
	],
	"./education-center/markdown/medical/myopathy-ryr1-associated.md": [
		811066,
		9,
		811066
	],
	"./education-center/markdown/medical/myopia": [
		983778,
		9,
		983778
	],
	"./education-center/markdown/medical/myopia.md": [
		983778,
		9,
		983778
	],
	"./education-center/markdown/medical/myositis-eosinophilic": [
		366054,
		9,
		366054
	],
	"./education-center/markdown/medical/myositis-eosinophilic.md": [
		366054,
		9,
		366054
	],
	"./education-center/markdown/medical/myotonia": [
		973616,
		9,
		973616
	],
	"./education-center/markdown/medical/myotonia-congenita-atypical-acetazolamide-responsive": [
		171062,
		9,
		171062
	],
	"./education-center/markdown/medical/myotonia-congenita-atypical-acetazolamide-responsive.md": [
		171062,
		9,
		171062
	],
	"./education-center/markdown/medical/myotonia-levior": [
		92122,
		9,
		92122
	],
	"./education-center/markdown/medical/myotonia-levior.md": [
		92122,
		9,
		92122
	],
	"./education-center/markdown/medical/myotonia.md": [
		973616,
		9,
		973616
	],
	"./education-center/markdown/medical/nager-syndrome": [
		210829,
		9,
		210829
	],
	"./education-center/markdown/medical/nager-syndrome.md": [
		210829,
		9,
		210829
	],
	"./education-center/markdown/medical/nanophthalmia": [
		187141,
		9,
		187141
	],
	"./education-center/markdown/medical/nanophthalmia.md": [
		187141,
		9,
		187141
	],
	"./education-center/markdown/medical/nemaline-myopathy-3-autosomal-dominant-or-recessive": [
		390101,
		9,
		390101
	],
	"./education-center/markdown/medical/nemaline-myopathy-3-autosomal-dominant-or-recessive.md": [
		390101,
		9,
		390101
	],
	"./education-center/markdown/medical/nemaline-myopathy-7": [
		673659,
		9,
		673659
	],
	"./education-center/markdown/medical/nemaline-myopathy-7.md": [
		673659,
		9,
		673659
	],
	"./education-center/markdown/medical/nemaline-myopathy-dominant": [
		375312,
		9,
		375312
	],
	"./education-center/markdown/medical/nemaline-myopathy-dominant.md": [
		375312,
		9,
		375312
	],
	"./education-center/markdown/medical/nemaline-myopathy-recessive": [
		888310,
		9,
		888310
	],
	"./education-center/markdown/medical/nemaline-myopathy-recessive.md": [
		888310,
		9,
		888310
	],
	"./education-center/markdown/medical/neonatal-death": [
		191085,
		9,
		191085
	],
	"./education-center/markdown/medical/neonatal-death.md": [
		191085,
		9,
		191085
	],
	"./education-center/markdown/medical/neonatal-encephalopathy": [
		422719,
		9,
		422719
	],
	"./education-center/markdown/medical/neonatal-encephalopathy.md": [
		422719,
		9,
		422719
	],
	"./education-center/markdown/medical/neonatal-epileptic-spasm": [
		174066,
		9,
		174066
	],
	"./education-center/markdown/medical/neonatal-epileptic-spasm.md": [
		174066,
		9,
		174066
	],
	"./education-center/markdown/medical/neonatal-hypotonia": [
		232654,
		9,
		232654
	],
	"./education-center/markdown/medical/neonatal-hypotonia.md": [
		232654,
		9,
		232654
	],
	"./education-center/markdown/medical/neonatal-insulin-dependent-diabetes-mellitus": [
		843427,
		9,
		843427
	],
	"./education-center/markdown/medical/neonatal-insulin-dependent-diabetes-mellitus.md": [
		843427,
		9,
		843427
	],
	"./education-center/markdown/medical/neonatal-lactic-acidosis": [
		431146,
		9,
		431146
	],
	"./education-center/markdown/medical/neonatal-lactic-acidosis.md": [
		431146,
		9,
		431146
	],
	"./education-center/markdown/medical/neonatal-respiratory-distress": [
		777241,
		9,
		777241
	],
	"./education-center/markdown/medical/neonatal-respiratory-distress.md": [
		777241,
		9,
		777241
	],
	"./education-center/markdown/medical/neoplasm-central-nervous-system": [
		852601,
		9,
		852601
	],
	"./education-center/markdown/medical/neoplasm-central-nervous-system.md": [
		852601,
		9,
		852601
	],
	"./education-center/markdown/medical/neoplasm-parathyroid-gland": [
		361799,
		9,
		361799
	],
	"./education-center/markdown/medical/neoplasm-parathyroid-gland.md": [
		361799,
		9,
		361799
	],
	"./education-center/markdown/medical/nephritis": [
		878153,
		9,
		878153
	],
	"./education-center/markdown/medical/nephritis.md": [
		878153,
		9,
		878153
	],
	"./education-center/markdown/medical/nephroblastoma": [
		924565,
		9,
		924565
	],
	"./education-center/markdown/medical/nephroblastoma.md": [
		924565,
		9,
		924565
	],
	"./education-center/markdown/medical/nephrocalcinosis": [
		782787,
		9,
		782787
	],
	"./education-center/markdown/medical/nephrocalcinosis.md": [
		782787,
		9,
		782787
	],
	"./education-center/markdown/medical/nephrolithiasisnephrocalcinosis": [
		647502,
		9,
		647502
	],
	"./education-center/markdown/medical/nephrolithiasisnephrocalcinosis.md": [
		647502,
		9,
		647502
	],
	"./education-center/markdown/medical/nephrolithiasisosteoporosis-hypophosphatemic": [
		171799,
		9,
		171799
	],
	"./education-center/markdown/medical/nephrolithiasisosteoporosis-hypophosphatemic.md": [
		171799,
		9,
		171799
	],
	"./education-center/markdown/medical/nephronophthisis-14": [
		869613,
		9,
		869613
	],
	"./education-center/markdown/medical/nephronophthisis-14.md": [
		869613,
		9,
		869613
	],
	"./education-center/markdown/medical/nephronophthisis-8": [
		559494,
		9,
		559494
	],
	"./education-center/markdown/medical/nephronophthisis-8.md": [
		559494,
		9,
		559494
	],
	"./education-center/markdown/medical/nephronophthisis-nephropathy": [
		723942,
		9,
		723942
	],
	"./education-center/markdown/medical/nephronophthisis-nephropathy.md": [
		723942,
		9,
		723942
	],
	"./education-center/markdown/medical/nephrotic-range-proteinuria": [
		187876,
		9,
		187876
	],
	"./education-center/markdown/medical/nephrotic-range-proteinuria.md": [
		187876,
		9,
		187876
	],
	"./education-center/markdown/medical/neuroblastoma": [
		766670,
		9,
		766670
	],
	"./education-center/markdown/medical/neuroblastoma-susceptibility": [
		848920,
		9,
		848920
	],
	"./education-center/markdown/medical/neuroblastoma-susceptibility.md": [
		848920,
		9,
		848920
	],
	"./education-center/markdown/medical/neuroblastoma.md": [
		766670,
		9,
		766670
	],
	"./education-center/markdown/medical/neurocirculatory-asthenia": [
		143812,
		9,
		143812
	],
	"./education-center/markdown/medical/neurocirculatory-asthenia.md": [
		143812,
		9,
		143812
	],
	"./education-center/markdown/medical/neurodegeneration": [
		945200,
		9,
		945200
	],
	"./education-center/markdown/medical/neurodegeneration-and-seizures-due-copper-transport-defect": [
		790653,
		9,
		790653
	],
	"./education-center/markdown/medical/neurodegeneration-and-seizures-due-copper-transport-defect.md": [
		790653,
		9,
		790653
	],
	"./education-center/markdown/medical/neurodegeneration-brain-iron-accumulation-1-atypical": [
		990993,
		9,
		990993
	],
	"./education-center/markdown/medical/neurodegeneration-brain-iron-accumulation-1-atypical.md": [
		990993,
		9,
		990993
	],
	"./education-center/markdown/medical/neurodegeneration-developmental-delay-early-respiratory-failure-myoclonic-seizures-and-brain": [
		250513,
		9,
		250513
	],
	"./education-center/markdown/medical/neurodegeneration-developmental-delay-early-respiratory-failure-myoclonic-seizures-and-brain.md": [
		250513,
		9,
		250513
	],
	"./education-center/markdown/medical/neurodegeneration-due-3-hydroxyisobutyryl-coenzyme-hydrolase-deficiency": [
		23686,
		9,
		23686
	],
	"./education-center/markdown/medical/neurodegeneration-due-3-hydroxyisobutyryl-coenzyme-hydrolase-deficiency.md": [
		23686,
		9,
		23686
	],
	"./education-center/markdown/medical/neurodegeneration.md": [
		945200,
		9,
		945200
	],
	"./education-center/markdown/medical/neurodegenerative-illness-progressing-crippling-dystonia-and-death-relentless-cerebral-atrophy": [
		799674,
		9,
		799674
	],
	"./education-center/markdown/medical/neurodegenerative-illness-progressing-crippling-dystonia-and-death-relentless-cerebral-atrophy.md": [
		799674,
		9,
		799674
	],
	"./education-center/markdown/medical/neurodevelopmental-abnormality": [
		332750,
		9,
		332750
	],
	"./education-center/markdown/medical/neurodevelopmental-abnormality.md": [
		332750,
		9,
		332750
	],
	"./education-center/markdown/medical/neurodevelopmental-delay": [
		590445,
		9,
		590445
	],
	"./education-center/markdown/medical/neurodevelopmental-delay.md": [
		590445,
		9,
		590445
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-epilepsy-and-hemochromatosis": [
		657449,
		9,
		657449
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-epilepsy-and-hemochromatosis.md": [
		657449,
		9,
		657449
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-microcephaly-and-speech-delay-or-without-brain-abnormalities": [
		90107,
		9,
		90107
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-microcephaly-and-speech-delay-or-without-brain-abnormalities.md": [
		90107,
		9,
		90107
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-mtor-related": [
		832037,
		9,
		832037
	],
	"./education-center/markdown/medical/neurodevelopmental-disorder-mtor-related.md": [
		832037,
		9,
		832037
	],
	"./education-center/markdown/medical/neuroendocrine-tumor-pancreas": [
		830186,
		9,
		830186
	],
	"./education-center/markdown/medical/neuroendocrine-tumor-pancreas.md": [
		830186,
		9,
		830186
	],
	"./education-center/markdown/medical/neurofibromatosis-type-2": [
		978342,
		9,
		978342
	],
	"./education-center/markdown/medical/neurofibromatosis-type-2.md": [
		978342,
		9,
		978342
	],
	"./education-center/markdown/medical/neurogastrointestinal-syndrome-mitochondrial": [
		318604,
		9,
		318604
	],
	"./education-center/markdown/medical/neurogastrointestinal-syndrome-mitochondrial.md": [
		318604,
		9,
		318604
	],
	"./education-center/markdown/medical/neurohypophyseal-diabetes-insipidus": [
		730469,
		9,
		730469
	],
	"./education-center/markdown/medical/neurohypophyseal-diabetes-insipidus.md": [
		730469,
		9,
		730469
	],
	"./education-center/markdown/medical/neuromuscular-disease-congenital-uniform-type-1-fiber": [
		470599,
		9,
		470599
	],
	"./education-center/markdown/medical/neuromuscular-disease-congenital-uniform-type-1-fiber.md": [
		470599,
		9,
		470599
	],
	"./education-center/markdown/medical/neuronal-ceroid-lipofuscinosis-dominantrecessive": [
		681499,
		9,
		681499
	],
	"./education-center/markdown/medical/neuronal-ceroid-lipofuscinosis-dominantrecessive.md": [
		681499,
		9,
		681499
	],
	"./education-center/markdown/medical/neuronal-ceroid-lipofuscinosis-recessive": [
		482021,
		9,
		482021
	],
	"./education-center/markdown/medical/neuronal-ceroid-lipofuscinosis-recessive.md": [
		482021,
		9,
		482021
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor": [
		939042,
		9,
		939042
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor-type-2a": [
		259752,
		9,
		259752
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor-type-2a.md": [
		259752,
		9,
		259752
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor-type-7a": [
		203189,
		9,
		203189
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor-type-7a.md": [
		203189,
		9,
		203189
	],
	"./education-center/markdown/medical/neuronopathy-distal-hereditary-motor.md": [
		939042,
		9,
		939042
	],
	"./education-center/markdown/medical/neurooculorenal-syndrome": [
		796993,
		9,
		796993
	],
	"./education-center/markdown/medical/neurooculorenal-syndrome.md": [
		796993,
		9,
		796993
	],
	"./education-center/markdown/medical/neuropathy-axonal-vocal-cord-paresis-autosomal-recessive": [
		165158,
		9,
		165158
	],
	"./education-center/markdown/medical/neuropathy-axonal-vocal-cord-paresis-autosomal-recessive.md": [
		165158,
		9,
		165158
	],
	"./education-center/markdown/medical/neuropathy-hereditary-sensory-and-autonomic-type-ia-severe": [
		403755,
		9,
		403755
	],
	"./education-center/markdown/medical/neuropathy-hereditary-sensory-and-autonomic-type-ia-severe.md": [
		403755,
		9,
		403755
	],
	"./education-center/markdown/medical/neuropathy-hereditary-sensory-and-autonomic-type-ic-severe": [
		251869,
		9,
		251869
	],
	"./education-center/markdown/medical/neuropathy-hereditary-sensory-and-autonomic-type-ic-severe.md": [
		251869,
		9,
		251869
	],
	"./education-center/markdown/medical/neuropsychiatric-disorder-and-early-onset-cataract": [
		152396,
		9,
		152396
	],
	"./education-center/markdown/medical/neuropsychiatric-disorder-and-early-onset-cataract.md": [
		152396,
		9,
		152396
	],
	"./education-center/markdown/medical/neutropenia": [
		159893,
		9,
		159893
	],
	"./education-center/markdown/medical/neutropenia.md": [
		159893,
		9,
		159893
	],
	"./education-center/markdown/medical/neutrophil-inclusion-bodies": [
		151376,
		9,
		151376
	],
	"./education-center/markdown/medical/neutrophil-inclusion-bodies.md": [
		151376,
		9,
		151376
	],
	"./education-center/markdown/medical/nevus-sebaceous": [
		226054,
		9,
		226054
	],
	"./education-center/markdown/medical/nevus-sebaceous.md": [
		226054,
		9,
		226054
	],
	"./education-center/markdown/medical/newfoundland-cone-rod-dystrophy": [
		868329,
		9,
		868329
	],
	"./education-center/markdown/medical/newfoundland-cone-rod-dystrophy.md": [
		868329,
		9,
		868329
	],
	"./education-center/markdown/medical/nicotine-addiction-protection-against": [
		280446,
		9,
		280446
	],
	"./education-center/markdown/medical/nicotine-addiction-protection-against.md": [
		280446,
		9,
		280446
	],
	"./education-center/markdown/medical/nicotine-dependence-protection-against": [
		41071,
		9,
		41071
	],
	"./education-center/markdown/medical/nicotine-dependence-protection-against.md": [
		41071,
		9,
		41071
	],
	"./education-center/markdown/medical/nicotine-poor-metabolism": [
		461330,
		9,
		461330
	],
	"./education-center/markdown/medical/nicotine-poor-metabolism.md": [
		461330,
		9,
		461330
	],
	"./education-center/markdown/medical/niemann-pick-disease-intermediate-protracted-neurovisceral": [
		375130,
		9,
		375130
	],
	"./education-center/markdown/medical/niemann-pick-disease-intermediate-protracted-neurovisceral.md": [
		375130,
		9,
		375130
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-c1-adult-form": [
		919804,
		9,
		919804
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-c1-adult-form.md": [
		919804,
		9,
		919804
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-c1-juvenile-form": [
		547258,
		9,
		547258
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-c1-juvenile-form.md": [
		547258,
		9,
		547258
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-d": [
		673892,
		9,
		673892
	],
	"./education-center/markdown/medical/niemann-pick-disease-type-d.md": [
		673892,
		9,
		673892
	],
	"./education-center/markdown/medical/nik-deficiency": [
		558142,
		9,
		558142
	],
	"./education-center/markdown/medical/nik-deficiency.md": [
		558142,
		9,
		558142
	],
	"./education-center/markdown/medical/nodal-related-disorders": [
		495736,
		9,
		495736
	],
	"./education-center/markdown/medical/nodal-related-disorders.md": [
		495736,
		9,
		495736
	],
	"./education-center/markdown/medical/non-obstructive-azoospermia": [
		293618,
		9,
		293618
	],
	"./education-center/markdown/medical/non-obstructive-azoospermia.md": [
		293618,
		9,
		293618
	],
	"./education-center/markdown/medical/non-syndromic-intellectual-disability": [
		971824,
		9,
		971824
	],
	"./education-center/markdown/medical/non-syndromic-intellectual-disability.md": [
		971824,
		9,
		971824
	],
	"./education-center/markdown/medical/non-syndromic-oligodontia": [
		317177,
		9,
		317177
	],
	"./education-center/markdown/medical/non-syndromic-oligodontia.md": [
		317177,
		9,
		317177
	],
	"./education-center/markdown/medical/noncompaction-cardiomyopathy": [
		85887,
		9,
		85887
	],
	"./education-center/markdown/medical/noncompaction-cardiomyopathy.md": [
		85887,
		9,
		85887
	],
	"./education-center/markdown/medical/nonpapillary-renal-cell-carcinoma": [
		476797,
		9,
		476797
	],
	"./education-center/markdown/medical/nonpapillary-renal-cell-carcinoma.md": [
		476797,
		9,
		476797
	],
	"./education-center/markdown/medical/nonpersistence-intestinal-lactase": [
		537432,
		9,
		537432
	],
	"./education-center/markdown/medical/nonpersistence-intestinal-lactase.md": [
		537432,
		9,
		537432
	],
	"./education-center/markdown/medical/nonsmall-cell-lung-cancer-resistance-tyrosine-kinase-inhibitor": [
		413305,
		9,
		413305
	],
	"./education-center/markdown/medical/nonsmall-cell-lung-cancer-resistance-tyrosine-kinase-inhibitor.md": [
		413305,
		9,
		413305
	],
	"./education-center/markdown/medical/nonsmall-cell-lung-cancer-response-tyrosine-kinase-inhibitor-somatic": [
		529901,
		9,
		529901
	],
	"./education-center/markdown/medical/nonsmall-cell-lung-cancer-response-tyrosine-kinase-inhibitor-somatic.md": [
		529901,
		9,
		529901
	],
	"./education-center/markdown/medical/nonsyndromic-cleft-lip-or-without-cleft-palate": [
		463796,
		9,
		463796
	],
	"./education-center/markdown/medical/nonsyndromic-cleft-lip-or-without-cleft-palate.md": [
		463796,
		9,
		463796
	],
	"./education-center/markdown/medical/nonsyndromic-congenital-nail-disorder-3": [
		764791,
		9,
		764791
	],
	"./education-center/markdown/medical/nonsyndromic-congenital-nail-disorder-3.md": [
		764791,
		9,
		764791
	],
	"./education-center/markdown/medical/nonsyndromic-deafness": [
		804033,
		9,
		804033
	],
	"./education-center/markdown/medical/nonsyndromic-deafness.md": [
		804033,
		9,
		804033
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-and-deafness-autosomal-recessive": [
		697572,
		9,
		697572
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-and-deafness-autosomal-recessive.md": [
		697572,
		9,
		697572
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-dominant": [
		761987,
		9,
		761987
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-dominant.md": [
		761987,
		9,
		761987
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-mixed": [
		543832,
		9,
		543832
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-mixed.md": [
		543832,
		9,
		543832
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-recessive": [
		664429,
		9,
		664429
	],
	"./education-center/markdown/medical/nonsyndromic-hearing-loss-recessive.md": [
		664429,
		9,
		664429
	],
	"./education-center/markdown/medical/nonsyndromic-hypergonadotropic-hypogonadism": [
		223411,
		9,
		223411
	],
	"./education-center/markdown/medical/nonsyndromic-hypergonadotropic-hypogonadism.md": [
		223411,
		9,
		223411
	],
	"./education-center/markdown/medical/nonsyndromic-oculocutaneous-albinism": [
		494355,
		9,
		494355
	],
	"./education-center/markdown/medical/nonsyndromic-oculocutaneous-albinism.md": [
		494355,
		9,
		494355
	],
	"./education-center/markdown/medical/nonsyndromic-otitis-media": [
		492224,
		9,
		492224
	],
	"./education-center/markdown/medical/nonsyndromic-otitis-media.md": [
		492224,
		9,
		492224
	],
	"./education-center/markdown/medical/nonsyndromic-sensorineural-hearing-loss": [
		143351,
		9,
		143351
	],
	"./education-center/markdown/medical/nonsyndromic-sensorineural-hearing-loss.md": [
		143351,
		9,
		143351
	],
	"./education-center/markdown/medical/noonan-syndrome": [
		637139,
		9,
		637139
	],
	"./education-center/markdown/medical/noonan-syndrome-disorder-juvenile-myelomonocytic-leukemia": [
		20950,
		9,
		20950
	],
	"./education-center/markdown/medical/noonan-syndrome-disorder-juvenile-myelomonocytic-leukemia.md": [
		20950,
		9,
		20950
	],
	"./education-center/markdown/medical/noonan-syndrome-multiple-lentigines": [
		535355,
		9,
		535355
	],
	"./education-center/markdown/medical/noonan-syndrome-multiple-lentigines.md": [
		535355,
		9,
		535355
	],
	"./education-center/markdown/medical/noonan-syndrome.md": [
		637139,
		9,
		637139
	],
	"./education-center/markdown/medical/nor-polyagglutination-syndrome": [
		644814,
		9,
		644814
	],
	"./education-center/markdown/medical/nor-polyagglutination-syndrome.md": [
		644814,
		9,
		644814
	],
	"./education-center/markdown/medical/normal-pregnancy": [
		256573,
		9,
		256573
	],
	"./education-center/markdown/medical/normal-pregnancy.md": [
		256573,
		9,
		256573
	],
	"./education-center/markdown/medical/normokalemic-periodic-paralysis-potassium-sensitive": [
		220002,
		9,
		220002
	],
	"./education-center/markdown/medical/normokalemic-periodic-paralysis-potassium-sensitive.md": [
		220002,
		9,
		220002
	],
	"./education-center/markdown/medical/north-carolina-macular-dystrophy": [
		652951,
		9,
		652951
	],
	"./education-center/markdown/medical/north-carolina-macular-dystrophy.md": [
		652951,
		9,
		652951
	],
	"./education-center/markdown/medical/nphp4-related-disorders": [
		320620,
		9,
		320620
	],
	"./education-center/markdown/medical/nphp4-related-disorders.md": [
		320620,
		9,
		320620
	],
	"./education-center/markdown/medical/nr2e3-related-disorders": [
		837165,
		9,
		837165
	],
	"./education-center/markdown/medical/nr2e3-related-disorders.md": [
		837165,
		9,
		837165
	],
	"./education-center/markdown/medical/nuclear-pulverulent-cataract": [
		280565,
		9,
		280565
	],
	"./education-center/markdown/medical/nuclear-pulverulent-cataract.md": [
		280565,
		9,
		280565
	],
	"./education-center/markdown/medical/obesity-age-onset": [
		484615,
		9,
		484615
	],
	"./education-center/markdown/medical/obesity-age-onset.md": [
		484615,
		9,
		484615
	],
	"./education-center/markdown/medical/obesity-association": [
		756376,
		9,
		756376
	],
	"./education-center/markdown/medical/obesity-association.md": [
		756376,
		9,
		756376
	],
	"./education-center/markdown/medical/obesity-autosomal-dominant": [
		241169,
		9,
		241169
	],
	"./education-center/markdown/medical/obesity-autosomal-dominant.md": [
		241169,
		9,
		241169
	],
	"./education-center/markdown/medical/obesity-bmiq12-susceptibility": [
		297450,
		9,
		297450
	],
	"./education-center/markdown/medical/obesity-bmiq12-susceptibility.md": [
		297450,
		9,
		297450
	],
	"./education-center/markdown/medical/obesity-early-onset-susceptibility": [
		618052,
		9,
		618052
	],
	"./education-center/markdown/medical/obesity-early-onset-susceptibility.md": [
		618052,
		9,
		618052
	],
	"./education-center/markdown/medical/obesity-mild-early-onset": [
		449472,
		9,
		449472
	],
	"./education-center/markdown/medical/obesity-mild-early-onset.md": [
		449472,
		9,
		449472
	],
	"./education-center/markdown/medical/obesity-resistance": [
		715022,
		9,
		715022
	],
	"./education-center/markdown/medical/obesity-resistance.md": [
		715022,
		9,
		715022
	],
	"./education-center/markdown/medical/obesity-severe-and-type-ii-diabetes": [
		347106,
		9,
		347106
	],
	"./education-center/markdown/medical/obesity-severe-and-type-ii-diabetes.md": [
		347106,
		9,
		347106
	],
	"./education-center/markdown/medical/obstructive-azoospermia": [
		234291,
		9,
		234291
	],
	"./education-center/markdown/medical/obstructive-azoospermia.md": [
		234291,
		9,
		234291
	],
	"./education-center/markdown/medical/ochoa-syndrome": [
		627075,
		9,
		627075
	],
	"./education-center/markdown/medical/ochoa-syndrome.md": [
		627075,
		9,
		627075
	],
	"./education-center/markdown/medical/ocular-albinism-congenital-sensorineural-hearing-loss": [
		159512,
		9,
		159512
	],
	"./education-center/markdown/medical/ocular-albinism-congenital-sensorineural-hearing-loss.md": [
		159512,
		9,
		159512
	],
	"./education-center/markdown/medical/oculocutaneous-albinism-type-ii-modifier": [
		939483,
		9,
		939483
	],
	"./education-center/markdown/medical/oculocutaneous-albinism-type-ii-modifier.md": [
		939483,
		9,
		939483
	],
	"./education-center/markdown/medical/oculomotor-apraxia": [
		486483,
		9,
		486483
	],
	"./education-center/markdown/medical/oculomotor-apraxia.md": [
		486483,
		9,
		486483
	],
	"./education-center/markdown/medical/oculootoradial-syndrome": [
		209559,
		9,
		209559
	],
	"./education-center/markdown/medical/oculootoradial-syndrome.md": [
		209559,
		9,
		209559
	],
	"./education-center/markdown/medical/oculoskeletodental-syndrome": [
		83799,
		9,
		83799
	],
	"./education-center/markdown/medical/oculoskeletodental-syndrome.md": [
		83799,
		9,
		83799
	],
	"./education-center/markdown/medical/oligodontia": [
		359030,
		9,
		359030
	],
	"./education-center/markdown/medical/oligodontia.md": [
		359030,
		9,
		359030
	],
	"./education-center/markdown/medical/olivopontocerebellar-hypoplasia": [
		962086,
		9,
		962086
	],
	"./education-center/markdown/medical/olivopontocerebellar-hypoplasia.md": [
		962086,
		9,
		962086
	],
	"./education-center/markdown/medical/oocytezygoteembryo-maturation-arrest-17": [
		355556,
		9,
		355556
	],
	"./education-center/markdown/medical/oocytezygoteembryo-maturation-arrest-17.md": [
		355556,
		9,
		355556
	],
	"./education-center/markdown/medical/oocytezygoteembryo-maturation-arrest-19": [
		122929,
		9,
		122929
	],
	"./education-center/markdown/medical/oocytezygoteembryo-maturation-arrest-19.md": [
		122929,
		9,
		122929
	],
	"./education-center/markdown/medical/ophthalmoplegia-isolated": [
		137296,
		9,
		137296
	],
	"./education-center/markdown/medical/ophthalmoplegia-isolated.md": [
		137296,
		9,
		137296
	],
	"./education-center/markdown/medical/optic-atrophy-dominant": [
		867787,
		9,
		867787
	],
	"./education-center/markdown/medical/optic-atrophy-dominant.md": [
		867787,
		9,
		867787
	],
	"./education-center/markdown/medical/optic-atrophy-or-without-deafness-ophthalmoplegia-myopathy-ataxia-and-neuropathy": [
		830630,
		9,
		830630
	],
	"./education-center/markdown/medical/optic-atrophy-or-without-deafness-ophthalmoplegia-myopathy-ataxia-and-neuropathy.md": [
		830630,
		9,
		830630
	],
	"./education-center/markdown/medical/optic-atrophy-recessive": [
		613926,
		9,
		613926
	],
	"./education-center/markdown/medical/optic-atrophy-recessive.md": [
		613926,
		9,
		613926
	],
	"./education-center/markdown/medical/optic-nerve-aplasia-bilateral": [
		42782,
		9,
		42782
	],
	"./education-center/markdown/medical/optic-nerve-aplasia-bilateral.md": [
		42782,
		9,
		42782
	],
	"./education-center/markdown/medical/optic-nerve-dysplasia": [
		396501,
		9,
		396501
	],
	"./education-center/markdown/medical/optic-nerve-dysplasia.md": [
		396501,
		9,
		396501
	],
	"./education-center/markdown/medical/optic-nerve-hypoplasia": [
		639388,
		9,
		639388
	],
	"./education-center/markdown/medical/optic-nerve-hypoplasia-and-abnormalities-central-nervous-system": [
		284202,
		9,
		284202
	],
	"./education-center/markdown/medical/optic-nerve-hypoplasia-and-abnormalities-central-nervous-system.md": [
		284202,
		9,
		284202
	],
	"./education-center/markdown/medical/optic-nerve-hypoplasia.md": [
		639388,
		9,
		639388
	],
	"./education-center/markdown/medical/ornithine-decarboxylase-1-polymorphism": [
		606793,
		9,
		606793
	],
	"./education-center/markdown/medical/ornithine-decarboxylase-1-polymorphism.md": [
		606793,
		9,
		606793
	],
	"./education-center/markdown/medical/orofacial-cleft": [
		749228,
		9,
		749228
	],
	"./education-center/markdown/medical/orofacial-cleft-7": [
		8233,
		9,
		8233
	],
	"./education-center/markdown/medical/orofacial-cleft-7.md": [
		8233,
		9,
		8233
	],
	"./education-center/markdown/medical/orofacial-cleft.md": [
		749228,
		9,
		749228
	],
	"./education-center/markdown/medical/oromandibular-limb-hypogenesis-spectrum": [
		641830,
		9,
		641830
	],
	"./education-center/markdown/medical/oromandibular-limb-hypogenesis-spectrum.md": [
		641830,
		9,
		641830
	],
	"./education-center/markdown/medical/orthostatic-hypotension": [
		418532,
		9,
		418532
	],
	"./education-center/markdown/medical/orthostatic-hypotension.md": [
		418532,
		9,
		418532
	],
	"./education-center/markdown/medical/ossifying-fibroma-jaw": [
		174108,
		9,
		174108
	],
	"./education-center/markdown/medical/ossifying-fibroma-jaw.md": [
		174108,
		9,
		174108
	],
	"./education-center/markdown/medical/osteoarthritis-hip": [
		726294,
		9,
		726294
	],
	"./education-center/markdown/medical/osteoarthritis-hip.md": [
		726294,
		9,
		726294
	],
	"./education-center/markdown/medical/osteoarthritis-susceptibility-2": [
		97488,
		9,
		97488
	],
	"./education-center/markdown/medical/osteoarthritis-susceptibility-2.md": [
		97488,
		9,
		97488
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-dominant": [
		760561,
		9,
		760561
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-dominant.md": [
		760561,
		9,
		760561
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-mild": [
		876280,
		9,
		876280
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-mild.md": [
		876280,
		9,
		876280
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-recessive": [
		198265,
		9,
		198265
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-recessive.md": [
		198265,
		9,
		198265
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-1-mild": [
		720918,
		9,
		720918
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-1-mild.md": [
		720918,
		9,
		720918
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-2-thin-bone": [
		98555,
		9,
		98555
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-2-thin-bone.md": [
		98555,
		9,
		98555
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-iic": [
		691594,
		9,
		691594
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-iic.md": [
		691594,
		9,
		691594
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-iiiiv": [
		457807,
		9,
		457807
	],
	"./education-center/markdown/medical/osteogenesis-imperfecta-type-iiiiv.md": [
		457807,
		9,
		457807
	],
	"./education-center/markdown/medical/osteopoikilosis": [
		702643,
		9,
		702643
	],
	"./education-center/markdown/medical/osteopoikilosis.md": [
		702643,
		9,
		702643
	],
	"./education-center/markdown/medical/osteoporosis-early-onset-susceptibility": [
		863168,
		9,
		863168
	],
	"./education-center/markdown/medical/osteoporosis-early-onset-susceptibility.md": [
		863168,
		9,
		863168
	],
	"./education-center/markdown/medical/otitis-media": [
		166595,
		9,
		166595
	],
	"./education-center/markdown/medical/otitis-media.md": [
		166595,
		9,
		166595
	],
	"./education-center/markdown/medical/otx2-related-syndromic-microphthalmia": [
		393782,
		9,
		393782
	],
	"./education-center/markdown/medical/otx2-related-syndromic-microphthalmia.md": [
		393782,
		9,
		393782
	],
	"./education-center/markdown/medical/ovarian-cancer-epithelial-somatic": [
		37569,
		9,
		37569
	],
	"./education-center/markdown/medical/ovarian-cancer-epithelial-somatic.md": [
		37569,
		9,
		37569
	],
	"./education-center/markdown/medical/ovarian-carcinoma": [
		37670,
		9,
		37670
	],
	"./education-center/markdown/medical/ovarian-carcinoma.md": [
		37670,
		9,
		37670
	],
	"./education-center/markdown/medical/ovarian-dysgenesis": [
		374730,
		9,
		374730
	],
	"./education-center/markdown/medical/ovarian-dysgenesis.md": [
		374730,
		9,
		374730
	],
	"./education-center/markdown/medical/ovarian-papillary-adenocarcinoma": [
		772023,
		9,
		772023
	],
	"./education-center/markdown/medical/ovarian-papillary-adenocarcinoma.md": [
		772023,
		9,
		772023
	],
	"./education-center/markdown/medical/ovarian-response-fsh-stimulation": [
		352408,
		9,
		352408
	],
	"./education-center/markdown/medical/ovarian-response-fsh-stimulation.md": [
		352408,
		9,
		352408
	],
	"./education-center/markdown/medical/ovarian-serous-cystadenocarcinoma": [
		316543,
		9,
		316543
	],
	"./education-center/markdown/medical/ovarian-serous-cystadenocarcinoma.md": [
		316543,
		9,
		316543
	],
	"./education-center/markdown/medical/p-phenotype": [
		596826,
		9,
		596826
	],
	"./education-center/markdown/medical/p-phenotype.md": [
		596826,
		9,
		596826
	],
	"./education-center/markdown/medical/pain-insensitivity": [
		835817,
		9,
		835817
	],
	"./education-center/markdown/medical/pain-insensitivity.md": [
		835817,
		9,
		835817
	],
	"./education-center/markdown/medical/palb2-related-disorders": [
		62476,
		9,
		62476
	],
	"./education-center/markdown/medical/palb2-related-disorders.md": [
		62476,
		9,
		62476
	],
	"./education-center/markdown/medical/pallister-hall-syndrome": [
		178089,
		9,
		178089
	],
	"./education-center/markdown/medical/pallister-hall-syndrome.md": [
		178089,
		9,
		178089
	],
	"./education-center/markdown/medical/palmoplantar-hyperkeratosis-and-true-hermaphroditism": [
		398556,
		9,
		398556
	],
	"./education-center/markdown/medical/palmoplantar-hyperkeratosis-and-true-hermaphroditism.md": [
		398556,
		9,
		398556
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma": [
		362199,
		9,
		362199
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-deafness-syndrome": [
		318125,
		9,
		318125
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-deafness-syndrome.md": [
		318125,
		9,
		318125
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-epidermolytic-knuckle-pads": [
		361703,
		9,
		361703
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-epidermolytic-knuckle-pads.md": [
		361703,
		9,
		361703
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-esophageal-carcinoma-syndrome": [
		678995,
		9,
		678995
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-esophageal-carcinoma-syndrome.md": [
		678995,
		9,
		678995
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-i-striate-focal-or-diffuse": [
		909898,
		9,
		909898
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-i-striate-focal-or-diffuse.md": [
		909898,
		9,
		909898
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-punctate-type-1a": [
		226664,
		9,
		226664
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma-punctate-type-1a.md": [
		226664,
		9,
		226664
	],
	"./education-center/markdown/medical/palmoplantar-keratoderma.md": [
		362199,
		9,
		362199
	],
	"./education-center/markdown/medical/pancreatic-adenocarcinoma": [
		987771,
		9,
		987771
	],
	"./education-center/markdown/medical/pancreatic-adenocarcinoma.md": [
		987771,
		9,
		987771
	],
	"./education-center/markdown/medical/pancreatic-hypoplasia": [
		823567,
		9,
		823567
	],
	"./education-center/markdown/medical/pancreatic-hypoplasia.md": [
		823567,
		9,
		823567
	],
	"./education-center/markdown/medical/pancreatitis-chronic-protection-against": [
		22265,
		9,
		22265
	],
	"./education-center/markdown/medical/pancreatitis-chronic-protection-against.md": [
		22265,
		9,
		22265
	],
	"./education-center/markdown/medical/pancreatitis-chronic-susceptibility": [
		115539,
		9,
		115539
	],
	"./education-center/markdown/medical/pancreatitis-chronic-susceptibility.md": [
		115539,
		9,
		115539
	],
	"./education-center/markdown/medical/pancytopenia": [
		102473,
		9,
		102473
	],
	"./education-center/markdown/medical/pancytopenia.md": [
		102473,
		9,
		102473
	],
	"./education-center/markdown/medical/papillary-renal-cell-carcinoma-sporadic": [
		375352,
		9,
		375352
	],
	"./education-center/markdown/medical/papillary-renal-cell-carcinoma-sporadic.md": [
		375352,
		9,
		375352
	],
	"./education-center/markdown/medical/papillary-renal-cell-carcinoma-type-1": [
		317675,
		9,
		317675
	],
	"./education-center/markdown/medical/papillary-renal-cell-carcinoma-type-1.md": [
		317675,
		9,
		317675
	],
	"./education-center/markdown/medical/papillary-thyroid-carcinoma": [
		143044,
		9,
		143044
	],
	"./education-center/markdown/medical/papillary-thyroid-carcinoma.md": [
		143044,
		9,
		143044
	],
	"./education-center/markdown/medical/papillorenal-syndrome-macular-abnormalities": [
		65916,
		9,
		65916
	],
	"./education-center/markdown/medical/papillorenal-syndrome-macular-abnormalities.md": [
		65916,
		9,
		65916
	],
	"./education-center/markdown/medical/para-bombay-phenotype": [
		549116,
		9,
		549116
	],
	"./education-center/markdown/medical/para-bombay-phenotype.md": [
		549116,
		9,
		549116
	],
	"./education-center/markdown/medical/paraganglioma": [
		448605,
		9,
		448605
	],
	"./education-center/markdown/medical/paraganglioma.md": [
		448605,
		9,
		448605
	],
	"./education-center/markdown/medical/paragangliomas-1-sensorineural-hearing-loss": [
		487756,
		9,
		487756
	],
	"./education-center/markdown/medical/paragangliomas-1-sensorineural-hearing-loss.md": [
		487756,
		9,
		487756
	],
	"./education-center/markdown/medical/paragangliomas-4": [
		967417,
		9,
		967417
	],
	"./education-center/markdown/medical/paragangliomas-4.md": [
		967417,
		9,
		967417
	],
	"./education-center/markdown/medical/paramyotonia-congenitahyperkalemic-periodic-paralysis": [
		767352,
		9,
		767352
	],
	"./education-center/markdown/medical/paramyotonia-congenitahyperkalemic-periodic-paralysis.md": [
		767352,
		9,
		767352
	],
	"./education-center/markdown/medical/paramyotonia-congenitamyotonia-congenita": [
		767209,
		9,
		767209
	],
	"./education-center/markdown/medical/paramyotonia-congenitamyotonia-congenita.md": [
		767209,
		9,
		767209
	],
	"./education-center/markdown/medical/parathyroid-adenoma-somatic": [
		372381,
		9,
		372381
	],
	"./education-center/markdown/medical/parathyroid-adenoma-somatic.md": [
		372381,
		9,
		372381
	],
	"./education-center/markdown/medical/parathyroid-gland-adenoma": [
		794327,
		9,
		794327
	],
	"./education-center/markdown/medical/parathyroid-gland-adenoma.md": [
		794327,
		9,
		794327
	],
	"./education-center/markdown/medical/parkes-weber-syndrome": [
		584263,
		9,
		584263
	],
	"./education-center/markdown/medical/parkes-weber-syndrome.md": [
		584263,
		9,
		584263
	],
	"./education-center/markdown/medical/parkinson-disease-6": [
		837555,
		9,
		837555
	],
	"./education-center/markdown/medical/parkinson-disease-6.md": [
		837555,
		9,
		837555
	],
	"./education-center/markdown/medical/parkinson-disease-autosomal-recessive-early-onset-digenic-pink1dj1": [
		772915,
		9,
		772915
	],
	"./education-center/markdown/medical/parkinson-disease-autosomal-recessive-early-onset-digenic-pink1dj1.md": [
		772915,
		9,
		772915
	],
	"./education-center/markdown/medical/parkinson-disease-dominant": [
		368343,
		9,
		368343
	],
	"./education-center/markdown/medical/parkinson-disease-dominant.md": [
		368343,
		9,
		368343
	],
	"./education-center/markdown/medical/parkinson-disease-dominantrecessive": [
		103751,
		9,
		103751
	],
	"./education-center/markdown/medical/parkinson-disease-dominantrecessive.md": [
		103751,
		9,
		103751
	],
	"./education-center/markdown/medical/parkinson-disease-juvenile": [
		473844,
		9,
		473844
	],
	"./education-center/markdown/medical/parkinson-disease-juvenile.md": [
		473844,
		9,
		473844
	],
	"./education-center/markdown/medical/parkinson-disease-recessive": [
		178564,
		9,
		178564
	],
	"./education-center/markdown/medical/parkinson-disease-recessive.md": [
		178564,
		9,
		178564
	],
	"./education-center/markdown/medical/parkinson-disease-x-linked-dominant": [
		164460,
		9,
		164460
	],
	"./education-center/markdown/medical/parkinson-disease-x-linked-dominant.md": [
		164460,
		9,
		164460
	],
	"./education-center/markdown/medical/parkinsonism": [
		610980,
		9,
		610980
	],
	"./education-center/markdown/medical/parkinsonism-plus": [
		313518,
		9,
		313518
	],
	"./education-center/markdown/medical/parkinsonism-plus.md": [
		313518,
		9,
		313518
	],
	"./education-center/markdown/medical/parkinsonism.md": [
		610980,
		9,
		610980
	],
	"./education-center/markdown/medical/paroxysmal-atrial-fibrillation": [
		295535,
		9,
		295535
	],
	"./education-center/markdown/medical/paroxysmal-atrial-fibrillation.md": [
		295535,
		9,
		295535
	],
	"./education-center/markdown/medical/partial-adenosine-deaminase-deficiency": [
		394960,
		9,
		394960
	],
	"./education-center/markdown/medical/partial-adenosine-deaminase-deficiency.md": [
		394960,
		9,
		394960
	],
	"./education-center/markdown/medical/partial-agenesis-corpus-callosum": [
		171724,
		9,
		171724
	],
	"./education-center/markdown/medical/partial-agenesis-corpus-callosum.md": [
		171724,
		9,
		171724
	],
	"./education-center/markdown/medical/partial-congenital-absence-teeth": [
		462829,
		9,
		462829
	],
	"./education-center/markdown/medical/partial-congenital-absence-teeth.md": [
		462829,
		9,
		462829
	],
	"./education-center/markdown/medical/pazopanib-response": [
		291615,
		9,
		291615
	],
	"./education-center/markdown/medical/pazopanib-response.md": [
		291615,
		9,
		291615
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy": [
		755031,
		9,
		755031
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.md": [
		755031,
		9,
		755031
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-ribavirin-and-telaprevir-response-efficacy": [
		757720,
		9,
		757720
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-ribavirin-and-telaprevir-response-efficacy.md": [
		757720,
		9,
		757720
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-response-efficacy": [
		630498,
		9,
		630498
	],
	"./education-center/markdown/medical/peginterferon-alfa-2a-response-efficacy.md": [
		630498,
		9,
		630498
	],
	"./education-center/markdown/medical/peginterferon-alfa-2b-response-efficacy": [
		469670,
		9,
		469670
	],
	"./education-center/markdown/medical/peginterferon-alfa-2b-response-efficacy.md": [
		469670,
		9,
		469670
	],
	"./education-center/markdown/medical/pelizaeus-merzbacher-disease-atypical": [
		627035,
		9,
		627035
	],
	"./education-center/markdown/medical/pelizaeus-merzbacher-disease-atypical.md": [
		627035,
		9,
		627035
	],
	"./education-center/markdown/medical/periampullary-adenoma": [
		969076,
		9,
		969076
	],
	"./education-center/markdown/medical/periampullary-adenoma.md": [
		969076,
		9,
		969076
	],
	"./education-center/markdown/medical/pericementitis": [
		158511,
		9,
		158511
	],
	"./education-center/markdown/medical/pericementitis.md": [
		158511,
		9,
		158511
	],
	"./education-center/markdown/medical/periventricular-laminar-heterotopia": [
		265999,
		9,
		265999
	],
	"./education-center/markdown/medical/periventricular-laminar-heterotopia.md": [
		265999,
		9,
		265999
	],
	"./education-center/markdown/medical/periventricular-nodular-heterotopia-syndactyly-cleft-palate-and-developmental-delay": [
		8362,
		9,
		8362
	],
	"./education-center/markdown/medical/periventricular-nodular-heterotopia-syndactyly-cleft-palate-and-developmental-delay.md": [
		8362,
		9,
		8362
	],
	"./education-center/markdown/medical/perlman-syndrome": [
		876376,
		9,
		876376
	],
	"./education-center/markdown/medical/perlman-syndrome.md": [
		876376,
		9,
		876376
	],
	"./education-center/markdown/medical/peroxisomal-biogenesis-disorder-3b": [
		661472,
		9,
		661472
	],
	"./education-center/markdown/medical/peroxisomal-biogenesis-disorder-3b.md": [
		661472,
		9,
		661472
	],
	"./education-center/markdown/medical/peroxisome-biogenesis-disorder-complementation-group-7": [
		583713,
		9,
		583713
	],
	"./education-center/markdown/medical/peroxisome-biogenesis-disorder-complementation-group-7.md": [
		583713,
		9,
		583713
	],
	"./education-center/markdown/medical/persistent-mullerian-duct-syndrome-type-i": [
		146620,
		9,
		146620
	],
	"./education-center/markdown/medical/persistent-mullerian-duct-syndrome-type-i.md": [
		146620,
		9,
		146620
	],
	"./education-center/markdown/medical/persistent-mullerian-duct-syndrome-type-ii": [
		3007,
		9,
		3007
	],
	"./education-center/markdown/medical/persistent-mullerian-duct-syndrome-type-ii.md": [
		3007,
		9,
		3007
	],
	"./education-center/markdown/medical/pervasive-developmental-disorder": [
		507946,
		9,
		507946
	],
	"./education-center/markdown/medical/pervasive-developmental-disorder.md": [
		507946,
		9,
		507946
	],
	"./education-center/markdown/medical/pes-cavus": [
		740738,
		9,
		740738
	],
	"./education-center/markdown/medical/pes-cavus.md": [
		740738,
		9,
		740738
	],
	"./education-center/markdown/medical/pex7-related-disorders": [
		556497,
		9,
		556497
	],
	"./education-center/markdown/medical/pex7-related-disorders.md": [
		556497,
		9,
		556497
	],
	"./education-center/markdown/medical/pfeiffer-syndrome": [
		304078,
		9,
		304078
	],
	"./education-center/markdown/medical/pfeiffer-syndrome.md": [
		304078,
		9,
		304078
	],
	"./education-center/markdown/medical/phenprocoumon-response-dosage": [
		349861,
		9,
		349861
	],
	"./education-center/markdown/medical/phenprocoumon-response-dosage.md": [
		349861,
		9,
		349861
	],
	"./education-center/markdown/medical/phenylthiocarbamide-tasting": [
		63127,
		9,
		63127
	],
	"./education-center/markdown/medical/phenylthiocarbamide-tasting.md": [
		63127,
		9,
		63127
	],
	"./education-center/markdown/medical/phenytoin-response": [
		800384,
		9,
		800384
	],
	"./education-center/markdown/medical/phenytoin-response.md": [
		800384,
		9,
		800384
	],
	"./education-center/markdown/medical/pheochromocytoma-susceptibility": [
		239649,
		9,
		239649
	],
	"./education-center/markdown/medical/pheochromocytoma-susceptibility.md": [
		239649,
		9,
		239649
	],
	"./education-center/markdown/medical/phonic-tics": [
		68799,
		9,
		68799
	],
	"./education-center/markdown/medical/phonic-tics.md": [
		68799,
		9,
		68799
	],
	"./education-center/markdown/medical/phosphoglycerate-kinase-electrophoretic-variant-pgk-ii": [
		299919,
		9,
		299919
	],
	"./education-center/markdown/medical/phosphoglycerate-kinase-electrophoretic-variant-pgk-ii.md": [
		299919,
		9,
		299919
	],
	"./education-center/markdown/medical/piebaldism-progressive": [
		982333,
		9,
		982333
	],
	"./education-center/markdown/medical/piebaldism-progressive.md": [
		982333,
		9,
		982333
	],
	"./education-center/markdown/medical/piebaldism-sensorineural-deafness": [
		658634,
		9,
		658634
	],
	"./education-center/markdown/medical/piebaldism-sensorineural-deafness.md": [
		658634,
		9,
		658634
	],
	"./education-center/markdown/medical/pierre-robin-syndrome": [
		114782,
		9,
		114782
	],
	"./education-center/markdown/medical/pierre-robin-syndrome.md": [
		114782,
		9,
		114782
	],
	"./education-center/markdown/medical/pigmentary-retinal-dystrophy": [
		317026,
		9,
		317026
	],
	"./education-center/markdown/medical/pigmentary-retinal-dystrophy.md": [
		317026,
		9,
		317026
	],
	"./education-center/markdown/medical/pigmentary-retinopathy": [
		852924,
		9,
		852924
	],
	"./education-center/markdown/medical/pigmentary-retinopathy-and-sensorineural-deafness": [
		267458,
		9,
		267458
	],
	"./education-center/markdown/medical/pigmentary-retinopathy-and-sensorineural-deafness.md": [
		267458,
		9,
		267458
	],
	"./education-center/markdown/medical/pigmentary-retinopathy.md": [
		852924,
		9,
		852924
	],
	"./education-center/markdown/medical/pilomatrixoma": [
		968591,
		9,
		968591
	],
	"./education-center/markdown/medical/pilomatrixoma.md": [
		968591,
		9,
		968591
	],
	"./education-center/markdown/medical/piroxicam-response": [
		735246,
		9,
		735246
	],
	"./education-center/markdown/medical/piroxicam-response.md": [
		735246,
		9,
		735246
	],
	"./education-center/markdown/medical/pituitary-adenoma-predisposition": [
		403505,
		9,
		403505
	],
	"./education-center/markdown/medical/pituitary-adenoma-predisposition.md": [
		403505,
		9,
		403505
	],
	"./education-center/markdown/medical/pituitary-hormone-deficiency-combined-5": [
		82438,
		9,
		82438
	],
	"./education-center/markdown/medical/pituitary-hormone-deficiency-combined-5.md": [
		82438,
		9,
		82438
	],
	"./education-center/markdown/medical/pituitary-hormone-deficiency-combined-or-isolated-8": [
		217472,
		9,
		217472
	],
	"./education-center/markdown/medical/pituitary-hormone-deficiency-combined-or-isolated-8.md": [
		217472,
		9,
		217472
	],
	"./education-center/markdown/medical/pituitary-hypothyroidism": [
		356104,
		9,
		356104
	],
	"./education-center/markdown/medical/pituitary-hypothyroidism.md": [
		356104,
		9,
		356104
	],
	"./education-center/markdown/medical/pitx2-related-eye-abnormalities": [
		312425,
		9,
		312425
	],
	"./education-center/markdown/medical/pitx2-related-eye-abnormalities.md": [
		312425,
		9,
		312425
	],
	"./education-center/markdown/medical/plasma-triglyceride-level-quantitative-trait-locus": [
		659093,
		9,
		659093
	],
	"./education-center/markdown/medical/plasma-triglyceride-level-quantitative-trait-locus.md": [
		659093,
		9,
		659093
	],
	"./education-center/markdown/medical/plasminogen-deficiency-type-i": [
		293118,
		9,
		293118
	],
	"./education-center/markdown/medical/plasminogen-deficiency-type-i.md": [
		293118,
		9,
		293118
	],
	"./education-center/markdown/medical/plasmodium-vivax-resistance": [
		253116,
		9,
		253116
	],
	"./education-center/markdown/medical/plasmodium-vivax-resistance.md": [
		253116,
		9,
		253116
	],
	"./education-center/markdown/medical/platyspondylic-dysplasia-torrance-type": [
		182346,
		9,
		182346
	],
	"./education-center/markdown/medical/platyspondylic-dysplasia-torrance-type.md": [
		182346,
		9,
		182346
	],
	"./education-center/markdown/medical/pol-iii-related-leukodystrophy": [
		122982,
		9,
		122982
	],
	"./education-center/markdown/medical/pol-iii-related-leukodystrophy.md": [
		122982,
		9,
		122982
	],
	"./education-center/markdown/medical/pole-exonuclease-domain-mutation": [
		165277,
		9,
		165277
	],
	"./education-center/markdown/medical/pole-exonuclease-domain-mutation.md": [
		165277,
		9,
		165277
	],
	"./education-center/markdown/medical/polg-related-disorders": [
		866070,
		9,
		866070
	],
	"./education-center/markdown/medical/polg-related-disorders.md": [
		866070,
		9,
		866070
	],
	"./education-center/markdown/medical/polg-related-spectrum-disorders": [
		801538,
		9,
		801538
	],
	"./education-center/markdown/medical/polg-related-spectrum-disorders.md": [
		801538,
		9,
		801538
	],
	"./education-center/markdown/medical/polr1c-related-disorders": [
		315494,
		9,
		315494
	],
	"./education-center/markdown/medical/polr1c-related-disorders.md": [
		315494,
		9,
		315494
	],
	"./education-center/markdown/medical/polr3-related-leukodystrophy": [
		860550,
		9,
		860550
	],
	"./education-center/markdown/medical/polr3-related-leukodystrophy.md": [
		860550,
		9,
		860550
	],
	"./education-center/markdown/medical/poly-adp-ribose-polymerase-inhibitor-response": [
		862432,
		9,
		862432
	],
	"./education-center/markdown/medical/poly-adp-ribose-polymerase-inhibitor-response.md": [
		862432,
		9,
		862432
	],
	"./education-center/markdown/medical/polycythemia": [
		58147,
		9,
		58147
	],
	"./education-center/markdown/medical/polycythemia.md": [
		58147,
		9,
		58147
	],
	"./education-center/markdown/medical/polyglucosan-body-myopathy-1-immunodeficiency": [
		155505,
		9,
		155505
	],
	"./education-center/markdown/medical/polyglucosan-body-myopathy-1-immunodeficiency.md": [
		155505,
		9,
		155505
	],
	"./education-center/markdown/medical/polyglucosan-body-myopathy-1-without-immunodeficiency": [
		451713,
		9,
		451713
	],
	"./education-center/markdown/medical/polyglucosan-body-myopathy-1-without-immunodeficiency.md": [
		451713,
		9,
		451713
	],
	"./education-center/markdown/medical/polymerase-proofreading-associated-polyposis": [
		514746,
		9,
		514746
	],
	"./education-center/markdown/medical/polymerase-proofreading-associated-polyposis.md": [
		514746,
		9,
		514746
	],
	"./education-center/markdown/medical/polymicrogyria": [
		161143,
		9,
		161143
	],
	"./education-center/markdown/medical/polymicrogyria.md": [
		161143,
		9,
		161143
	],
	"./education-center/markdown/medical/polyostotic-fibrous-dysplasia-somatic-mosaic": [
		933591,
		9,
		933591
	],
	"./education-center/markdown/medical/polyostotic-fibrous-dysplasia-somatic-mosaic.md": [
		933591,
		9,
		933591
	],
	"./education-center/markdown/medical/polysyndactyly": [
		7642,
		9,
		7642
	],
	"./education-center/markdown/medical/polysyndactyly.md": [
		7642,
		9,
		7642
	],
	"./education-center/markdown/medical/pomgnt1-related-disorders": [
		448249,
		9,
		448249
	],
	"./education-center/markdown/medical/pomgnt1-related-disorders.md": [
		448249,
		9,
		448249
	],
	"./education-center/markdown/medical/pontocerebellar-hypoplasia-type-1a": [
		440073,
		9,
		440073
	],
	"./education-center/markdown/medical/pontocerebellar-hypoplasia-type-1a.md": [
		440073,
		9,
		440073
	],
	"./education-center/markdown/medical/porencephalic-cyst": [
		169390,
		9,
		169390
	],
	"./education-center/markdown/medical/porencephalic-cyst.md": [
		169390,
		9,
		169390
	],
	"./education-center/markdown/medical/porphyria-acute-hepatic-digenic": [
		250507,
		9,
		250507
	],
	"./education-center/markdown/medical/porphyria-acute-hepatic-digenic.md": [
		250507,
		9,
		250507
	],
	"./education-center/markdown/medical/porphyria-acute-intermittent-nonerythroid-variant": [
		716425,
		9,
		716425
	],
	"./education-center/markdown/medical/porphyria-acute-intermittent-nonerythroid-variant.md": [
		716425,
		9,
		716425
	],
	"./education-center/markdown/medical/postanesthetic-apnea": [
		66235,
		9,
		66235
	],
	"./education-center/markdown/medical/postanesthetic-apnea.md": [
		66235,
		9,
		66235
	],
	"./education-center/markdown/medical/postaxial-polydactyly-type-a1b": [
		780641,
		9,
		780641
	],
	"./education-center/markdown/medical/postaxial-polydactyly-type-a1b.md": [
		780641,
		9,
		780641
	],
	"./education-center/markdown/medical/posterior-polar-cataract": [
		241094,
		9,
		241094
	],
	"./education-center/markdown/medical/posterior-polar-cataract.md": [
		241094,
		9,
		241094
	],
	"./education-center/markdown/medical/posterior-polymorphous-corneal-dystrophy-1": [
		489177,
		9,
		489177
	],
	"./education-center/markdown/medical/posterior-polymorphous-corneal-dystrophy-1.md": [
		489177,
		9,
		489177
	],
	"./education-center/markdown/medical/postural-tremor": [
		397019,
		9,
		397019
	],
	"./education-center/markdown/medical/postural-tremor.md": [
		397019,
		9,
		397019
	],
	"./education-center/markdown/medical/ppargc1b-polymorphism": [
		208143,
		9,
		208143
	],
	"./education-center/markdown/medical/ppargc1b-polymorphism.md": [
		208143,
		9,
		208143
	],
	"./education-center/markdown/medical/pravastatin-response-efficacy": [
		976895,
		9,
		976895
	],
	"./education-center/markdown/medical/pravastatin-response-efficacy.md": [
		976895,
		9,
		976895
	],
	"./education-center/markdown/medical/precocious-puberty-males": [
		674164,
		9,
		674164
	],
	"./education-center/markdown/medical/precocious-puberty-males.md": [
		674164,
		9,
		674164
	],
	"./education-center/markdown/medical/predisposition-invasive-fungal-disease-due-card9-deficiency": [
		50205,
		9,
		50205
	],
	"./education-center/markdown/medical/predisposition-invasive-fungal-disease-due-card9-deficiency.md": [
		50205,
		9,
		50205
	],
	"./education-center/markdown/medical/prednisolone-response": [
		711288,
		9,
		711288
	],
	"./education-center/markdown/medical/prednisolone-response.md": [
		711288,
		9,
		711288
	],
	"./education-center/markdown/medical/preimplantation-embryonic-lethality-1": [
		647005,
		9,
		647005
	],
	"./education-center/markdown/medical/preimplantation-embryonic-lethality-1.md": [
		647005,
		9,
		647005
	],
	"./education-center/markdown/medical/preimplantation-embryonic-lethality-2": [
		584854,
		9,
		584854
	],
	"./education-center/markdown/medical/preimplantation-embryonic-lethality-2.md": [
		584854,
		9,
		584854
	],
	"./education-center/markdown/medical/preimplantation-lethality": [
		730764,
		9,
		730764
	],
	"./education-center/markdown/medical/preimplantation-lethality.md": [
		730764,
		9,
		730764
	],
	"./education-center/markdown/medical/prelingual-sensorineural-hearing-impairment": [
		314370,
		9,
		314370
	],
	"./education-center/markdown/medical/prelingual-sensorineural-hearing-impairment.md": [
		314370,
		9,
		314370
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait": [
		129305,
		9,
		129305
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-0": [
		508166,
		9,
		508166
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-0.md": [
		508166,
		9,
		508166
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-1": [
		368950,
		9,
		368950
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-1.md": [
		368950,
		9,
		368950
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-10": [
		227295,
		9,
		227295
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-10.md": [
		227295,
		9,
		227295
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-11": [
		791933,
		9,
		791933
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-11.md": [
		791933,
		9,
		791933
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-12": [
		798925,
		9,
		798925
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-12.md": [
		798925,
		9,
		798925
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-13": [
		355563,
		9,
		355563
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-13.md": [
		355563,
		9,
		355563
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-14": [
		63310,
		9,
		63310
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-14.md": [
		63310,
		9,
		63310
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-15": [
		691640,
		9,
		691640
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-15.md": [
		691640,
		9,
		691640
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-16": [
		12961,
		9,
		12961
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-16.md": [
		12961,
		9,
		12961
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-17": [
		114484,
		9,
		114484
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-17.md": [
		114484,
		9,
		114484
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-18": [
		544101,
		9,
		544101
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-18.md": [
		544101,
		9,
		544101
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-19": [
		687226,
		9,
		687226
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-19.md": [
		687226,
		9,
		687226
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-2": [
		335807,
		9,
		335807
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-2.md": [
		335807,
		9,
		335807
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-20": [
		242978,
		9,
		242978
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-20.md": [
		242978,
		9,
		242978
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-21": [
		415170,
		9,
		415170
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-21.md": [
		415170,
		9,
		415170
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-22": [
		971893,
		9,
		971893
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-22.md": [
		971893,
		9,
		971893
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-23": [
		943789,
		9,
		943789
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-23.md": [
		943789,
		9,
		943789
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-24": [
		789847,
		9,
		789847
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-24.md": [
		789847,
		9,
		789847
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-25": [
		804719,
		9,
		804719
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-25.md": [
		804719,
		9,
		804719
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-26": [
		178373,
		9,
		178373
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-26.md": [
		178373,
		9,
		178373
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-27": [
		858442,
		9,
		858442
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-27.md": [
		858442,
		9,
		858442
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-28": [
		995770,
		9,
		995770
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-28.md": [
		995770,
		9,
		995770
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-29": [
		57390,
		9,
		57390
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-29.md": [
		57390,
		9,
		57390
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-3": [
		360208,
		9,
		360208
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-3.md": [
		360208,
		9,
		360208
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-30": [
		491383,
		9,
		491383
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-30.md": [
		491383,
		9,
		491383
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-4": [
		34432,
		9,
		34432
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-4.md": [
		34432,
		9,
		34432
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-5": [
		275241,
		9,
		275241
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-5.md": [
		275241,
		9,
		275241
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-6": [
		61148,
		9,
		61148
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-6.md": [
		61148,
		9,
		61148
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-7": [
		132480,
		9,
		132480
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-7.md": [
		132480,
		9,
		132480
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-8": [
		492569,
		9,
		492569
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-8.md": [
		492569,
		9,
		492569
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-9": [
		655817,
		9,
		655817
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait-9.md": [
		655817,
		9,
		655817
	],
	"./education-center/markdown/medical/premature-chromatid-separation-trait.md": [
		129305,
		9,
		129305
	],
	"./education-center/markdown/medical/premature-coronary-artery-atherosclerosis": [
		102851,
		9,
		102851
	],
	"./education-center/markdown/medical/premature-coronary-artery-atherosclerosis.md": [
		102851,
		9,
		102851
	],
	"./education-center/markdown/medical/premature-ovarian-failure": [
		384651,
		9,
		384651
	],
	"./education-center/markdown/medical/premature-ovarian-failure-21": [
		39263,
		9,
		39263
	],
	"./education-center/markdown/medical/premature-ovarian-failure-21.md": [
		39263,
		9,
		39263
	],
	"./education-center/markdown/medical/premature-ovarian-failure.md": [
		384651,
		9,
		384651
	],
	"./education-center/markdown/medical/premature-ovarian-insufficiency": [
		189393,
		9,
		189393
	],
	"./education-center/markdown/medical/premature-ovarian-insufficiency.md": [
		189393,
		9,
		189393
	],
	"./education-center/markdown/medical/preterm-intraventricular-hemorrhage": [
		259236,
		9,
		259236
	],
	"./education-center/markdown/medical/preterm-intraventricular-hemorrhage.md": [
		259236,
		9,
		259236
	],
	"./education-center/markdown/medical/pretibial-dystrophic-epidermolysis-bullosa": [
		507700,
		9,
		507700
	],
	"./education-center/markdown/medical/pretibial-dystrophic-epidermolysis-bullosa.md": [
		507700,
		9,
		507700
	],
	"./education-center/markdown/medical/primary-aldosteronism": [
		710647,
		9,
		710647
	],
	"./education-center/markdown/medical/primary-aldosteronism.md": [
		710647,
		9,
		710647
	],
	"./education-center/markdown/medical/primary-amenorrhea": [
		110326,
		9,
		110326
	],
	"./education-center/markdown/medical/primary-amenorrhea.md": [
		110326,
		9,
		110326
	],
	"./education-center/markdown/medical/primary-congenital-glaucoma": [
		405093,
		9,
		405093
	],
	"./education-center/markdown/medical/primary-congenital-glaucoma.md": [
		405093,
		9,
		405093
	],
	"./education-center/markdown/medical/primary-degenerative-dementia-alzheimer-type-presenile-onset": [
		583255,
		9,
		583255
	],
	"./education-center/markdown/medical/primary-degenerative-dementia-alzheimer-type-presenile-onset.md": [
		583255,
		9,
		583255
	],
	"./education-center/markdown/medical/primary-erythromelalgia": [
		44669,
		9,
		44669
	],
	"./education-center/markdown/medical/primary-erythromelalgia.md": [
		44669,
		9,
		44669
	],
	"./education-center/markdown/medical/primary-failure-tooth-eruption": [
		938989,
		9,
		938989
	],
	"./education-center/markdown/medical/primary-failure-tooth-eruption.md": [
		938989,
		9,
		938989
	],
	"./education-center/markdown/medical/primary-familial-polycythemia-due-epo-receptor-mutation": [
		874339,
		9,
		874339
	],
	"./education-center/markdown/medical/primary-familial-polycythemia-due-epo-receptor-mutation.md": [
		874339,
		9,
		874339
	],
	"./education-center/markdown/medical/primary-interstitial-lung-disease-specific-childhood-due-pulmonary-surfactant-protein-anomalies": [
		294559,
		9,
		294559
	],
	"./education-center/markdown/medical/primary-interstitial-lung-disease-specific-childhood-due-pulmonary-surfactant-protein-anomalies.md": [
		294559,
		9,
		294559
	],
	"./education-center/markdown/medical/primary-low-grade-serous-adenocarcinoma-ovary": [
		436039,
		9,
		436039
	],
	"./education-center/markdown/medical/primary-low-grade-serous-adenocarcinoma-ovary.md": [
		436039,
		9,
		436039
	],
	"./education-center/markdown/medical/primary-microcephaly": [
		915416,
		9,
		915416
	],
	"./education-center/markdown/medical/primary-microcephaly-2-or-without-cortical-malformations": [
		113380,
		9,
		113380
	],
	"./education-center/markdown/medical/primary-microcephaly-2-or-without-cortical-malformations.md": [
		113380,
		9,
		113380
	],
	"./education-center/markdown/medical/primary-microcephaly-recessive": [
		177290,
		9,
		177290
	],
	"./education-center/markdown/medical/primary-microcephaly-recessive.md": [
		177290,
		9,
		177290
	],
	"./education-center/markdown/medical/primary-microcephaly.md": [
		915416,
		9,
		915416
	],
	"./education-center/markdown/medical/primary-open-angle-glaucoma": [
		668818,
		9,
		668818
	],
	"./education-center/markdown/medical/primary-open-angle-glaucoma.md": [
		668818,
		9,
		668818
	],
	"./education-center/markdown/medical/primitive-neuroectodermal-tumor": [
		288605,
		9,
		288605
	],
	"./education-center/markdown/medical/primitive-neuroectodermal-tumor.md": [
		288605,
		9,
		288605
	],
	"./education-center/markdown/medical/prkag2-cardiac-syndrome": [
		87692,
		9,
		87692
	],
	"./education-center/markdown/medical/prkag2-cardiac-syndrome.md": [
		87692,
		9,
		87692
	],
	"./education-center/markdown/medical/profound-global-developmental-delay": [
		678299,
		9,
		678299
	],
	"./education-center/markdown/medical/profound-global-developmental-delay.md": [
		678299,
		9,
		678299
	],
	"./education-center/markdown/medical/profound-hearing-impairment": [
		394855,
		9,
		394855
	],
	"./education-center/markdown/medical/profound-hearing-impairment.md": [
		394855,
		9,
		394855
	],
	"./education-center/markdown/medical/programmed-death-ligand-1-pd-l1-blocking-antibody-response": [
		264011,
		9,
		264011
	],
	"./education-center/markdown/medical/programmed-death-ligand-1-pd-l1-blocking-antibody-response.md": [
		264011,
		9,
		264011
	],
	"./education-center/markdown/medical/progressive-cerebellar-ataxia": [
		79847,
		9,
		79847
	],
	"./education-center/markdown/medical/progressive-cerebellar-ataxia.md": [
		79847,
		9,
		79847
	],
	"./education-center/markdown/medical/progressive-childhood-encephalopathy": [
		309212,
		9,
		309212
	],
	"./education-center/markdown/medical/progressive-childhood-encephalopathy.md": [
		309212,
		9,
		309212
	],
	"./education-center/markdown/medical/progressive-cone-degeneration": [
		978423,
		9,
		978423
	],
	"./education-center/markdown/medical/progressive-cone-degeneration.md": [
		978423,
		9,
		978423
	],
	"./education-center/markdown/medical/progressive-cone-dystrophy-without-rod-involvement": [
		604802,
		9,
		604802
	],
	"./education-center/markdown/medical/progressive-cone-dystrophy-without-rod-involvement.md": [
		604802,
		9,
		604802
	],
	"./education-center/markdown/medical/progressive-congenital-scoliosis": [
		5922,
		9,
		5922
	],
	"./education-center/markdown/medical/progressive-congenital-scoliosis.md": [
		5922,
		9,
		5922
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions": [
		559162,
		9,
		559162
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions-digenic": [
		653136,
		9,
		653136
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions-digenic.md": [
		653136,
		9,
		653136
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions.md": [
		559162,
		9,
		559162
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-myoclonus": [
		590764,
		9,
		590764
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-myoclonus.md": [
		590764,
		9,
		590764
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-proximal-myopathy-and-sudden-death": [
		220545,
		9,
		220545
	],
	"./education-center/markdown/medical/progressive-external-ophthalmoplegia-proximal-myopathy-and-sudden-death.md": [
		220545,
		9,
		220545
	],
	"./education-center/markdown/medical/progressive-familial-heart-block-type-1a": [
		651869,
		9,
		651869
	],
	"./education-center/markdown/medical/progressive-familial-heart-block-type-1a.md": [
		651869,
		9,
		651869
	],
	"./education-center/markdown/medical/progressive-microcephaly": [
		207313,
		9,
		207313
	],
	"./education-center/markdown/medical/progressive-microcephaly.md": [
		207313,
		9,
		207313
	],
	"./education-center/markdown/medical/progressive-muscle-weakness": [
		636585,
		9,
		636585
	],
	"./education-center/markdown/medical/progressive-muscle-weakness.md": [
		636585,
		9,
		636585
	],
	"./education-center/markdown/medical/progressive-myoclonic-epilepsy-type-5": [
		15740,
		9,
		15740
	],
	"./education-center/markdown/medical/progressive-myoclonic-epilepsy-type-5.md": [
		15740,
		9,
		15740
	],
	"./education-center/markdown/medical/progressive-myositis-ossificans": [
		173619,
		9,
		173619
	],
	"./education-center/markdown/medical/progressive-myositis-ossificans.md": [
		173619,
		9,
		173619
	],
	"./education-center/markdown/medical/progressive-neurodegenerative-disease": [
		871348,
		9,
		871348
	],
	"./education-center/markdown/medical/progressive-neurodegenerative-disease.md": [
		871348,
		9,
		871348
	],
	"./education-center/markdown/medical/progressive-psychomotor-deterioration": [
		978776,
		9,
		978776
	],
	"./education-center/markdown/medical/progressive-psychomotor-deterioration.md": [
		978776,
		9,
		978776
	],
	"./education-center/markdown/medical/progressive-pulmonary-failure": [
		831485,
		9,
		831485
	],
	"./education-center/markdown/medical/progressive-pulmonary-failure.md": [
		831485,
		9,
		831485
	],
	"./education-center/markdown/medical/progressive-sensorineural-hearing-impairment": [
		961405,
		9,
		961405
	],
	"./education-center/markdown/medical/progressive-sensorineural-hearing-impairment.md": [
		961405,
		9,
		961405
	],
	"./education-center/markdown/medical/progressive-spastic-paraparesis": [
		390242,
		9,
		390242
	],
	"./education-center/markdown/medical/progressive-spastic-paraparesis.md": [
		390242,
		9,
		390242
	],
	"./education-center/markdown/medical/progressive-supranuclear-ophthalmoplegia": [
		394554,
		9,
		394554
	],
	"./education-center/markdown/medical/progressive-supranuclear-ophthalmoplegia.md": [
		394554,
		9,
		394554
	],
	"./education-center/markdown/medical/progressive-ventriculomegaly": [
		930604,
		9,
		930604
	],
	"./education-center/markdown/medical/progressive-ventriculomegaly.md": [
		930604,
		9,
		930604
	],
	"./education-center/markdown/medical/proguanil-poor-metabolism": [
		661153,
		9,
		661153
	],
	"./education-center/markdown/medical/proguanil-poor-metabolism.md": [
		661153,
		9,
		661153
	],
	"./education-center/markdown/medical/prolonged-prothrombin-time": [
		679722,
		9,
		679722
	],
	"./education-center/markdown/medical/prolonged-prothrombin-time.md": [
		679722,
		9,
		679722
	],
	"./education-center/markdown/medical/properdin-deficiency-type-ii": [
		342715,
		9,
		342715
	],
	"./education-center/markdown/medical/properdin-deficiency-type-ii.md": [
		342715,
		9,
		342715
	],
	"./education-center/markdown/medical/properdin-deficiency-type-iii": [
		744312,
		9,
		744312
	],
	"./education-center/markdown/medical/properdin-deficiency-type-iii.md": [
		744312,
		9,
		744312
	],
	"./education-center/markdown/medical/proportionate-short-stature": [
		416358,
		9,
		416358
	],
	"./education-center/markdown/medical/proportionate-short-stature.md": [
		416358,
		9,
		416358
	],
	"./education-center/markdown/medical/prostate-cancer-somatic": [
		126470,
		9,
		126470
	],
	"./education-center/markdown/medical/prostate-cancer-somatic.md": [
		126470,
		9,
		126470
	],
	"./education-center/markdown/medical/prostate-cancer-susceptibility": [
		716369,
		9,
		716369
	],
	"./education-center/markdown/medical/prostate-cancer-susceptibility-0": [
		659706,
		9,
		659706
	],
	"./education-center/markdown/medical/prostate-cancer-susceptibility-0.md": [
		659706,
		9,
		659706
	],
	"./education-center/markdown/medical/prostate-cancer-susceptibility.md": [
		716369,
		9,
		716369
	],
	"./education-center/markdown/medical/proteasome-associated-autoinflammatory-syndrome-1-digenic": [
		153537,
		9,
		153537
	],
	"./education-center/markdown/medical/proteasome-associated-autoinflammatory-syndrome-1-digenic.md": [
		153537,
		9,
		153537
	],
	"./education-center/markdown/medical/proximal-16p112-microdeletion-syndrome": [
		955693,
		9,
		955693
	],
	"./education-center/markdown/medical/proximal-16p112-microdeletion-syndrome.md": [
		955693,
		9,
		955693
	],
	"./education-center/markdown/medical/proximal-muscle-weakness": [
		731644,
		9,
		731644
	],
	"./education-center/markdown/medical/proximal-muscle-weakness-upper-limbs": [
		981975,
		9,
		981975
	],
	"./education-center/markdown/medical/proximal-muscle-weakness-upper-limbs.md": [
		981975,
		9,
		981975
	],
	"./education-center/markdown/medical/proximal-muscle-weakness.md": [
		731644,
		9,
		731644
	],
	"./education-center/markdown/medical/prph2-related-disorders": [
		356312,
		9,
		356312
	],
	"./education-center/markdown/medical/prph2-related-disorders.md": [
		356312,
		9,
		356312
	],
	"./education-center/markdown/medical/prune-belly-syndrome": [
		857791,
		9,
		857791
	],
	"./education-center/markdown/medical/prune-belly-syndrome.md": [
		857791,
		9,
		857791
	],
	"./education-center/markdown/medical/pseudo-fractures": [
		995883,
		9,
		995883
	],
	"./education-center/markdown/medical/pseudo-fractures.md": [
		995883,
		9,
		995883
	],
	"./education-center/markdown/medical/pseudoarylsulfatase-deficiency": [
		506609,
		9,
		506609
	],
	"./education-center/markdown/medical/pseudoarylsulfatase-deficiency.md": [
		506609,
		9,
		506609
	],
	"./education-center/markdown/medical/pseudocholinesterase-deficiency": [
		665518,
		9,
		665518
	],
	"./education-center/markdown/medical/pseudocholinesterase-deficiency.md": [
		665518,
		9,
		665518
	],
	"./education-center/markdown/medical/pseudohermaphroditism": [
		326323,
		9,
		326323
	],
	"./education-center/markdown/medical/pseudohermaphroditism-female-hypokalemia-due-glucocorticoid-resistance": [
		927388,
		9,
		927388
	],
	"./education-center/markdown/medical/pseudohermaphroditism-female-hypokalemia-due-glucocorticoid-resistance.md": [
		927388,
		9,
		927388
	],
	"./education-center/markdown/medical/pseudohermaphroditism.md": [
		326323,
		9,
		326323
	],
	"./education-center/markdown/medical/pseudohypoaldosteronism-type-2a": [
		759306,
		9,
		759306
	],
	"./education-center/markdown/medical/pseudohypoaldosteronism-type-2a.md": [
		759306,
		9,
		759306
	],
	"./education-center/markdown/medical/pseudohypoparathyroidism-type-i": [
		574289,
		9,
		574289
	],
	"./education-center/markdown/medical/pseudohypoparathyroidism-type-i.md": [
		574289,
		9,
		574289
	],
	"./education-center/markdown/medical/pseudohypoparathyroidism-type-ia-testotoxicosis": [
		233799,
		9,
		233799
	],
	"./education-center/markdown/medical/pseudohypoparathyroidism-type-ia-testotoxicosis.md": [
		233799,
		9,
		233799
	],
	"./education-center/markdown/medical/pseudoxanthoma-elasticum-modifier-severity": [
		395422,
		9,
		395422
	],
	"./education-center/markdown/medical/pseudoxanthoma-elasticum-modifier-severity.md": [
		395422,
		9,
		395422
	],
	"./education-center/markdown/medical/psoriasis-2-pustular": [
		835702,
		9,
		835702
	],
	"./education-center/markdown/medical/psoriasis-2-pustular.md": [
		835702,
		9,
		835702
	],
	"./education-center/markdown/medical/psoriasis-protection-against": [
		194566,
		9,
		194566
	],
	"./education-center/markdown/medical/psoriasis-protection-against.md": [
		194566,
		9,
		194566
	],
	"./education-center/markdown/medical/psychomotor-retardation": [
		809655,
		9,
		809655
	],
	"./education-center/markdown/medical/psychomotor-retardation.md": [
		809655,
		9,
		809655
	],
	"./education-center/markdown/medical/psychotic-disorder": [
		659474,
		9,
		659474
	],
	"./education-center/markdown/medical/psychotic-disorder.md": [
		659474,
		9,
		659474
	],
	"./education-center/markdown/medical/pulmonary-alveolar-proteinosis": [
		629858,
		9,
		629858
	],
	"./education-center/markdown/medical/pulmonary-alveolar-proteinosis.md": [
		629858,
		9,
		629858
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-associated-another-disease": [
		158148,
		9,
		158148
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-associated-another-disease.md": [
		158148,
		9,
		158148
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-associated-congenital-heart-disease": [
		589020,
		9,
		589020
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-associated-congenital-heart-disease.md": [
		589020,
		9,
		589020
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-related-hereditary-hemorrhagic-telangiectasia": [
		31858,
		9,
		31858
	],
	"./education-center/markdown/medical/pulmonary-arterial-hypertension-related-hereditary-hemorrhagic-telangiectasia.md": [
		31858,
		9,
		31858
	],
	"./education-center/markdown/medical/pulmonary-artery-atresia": [
		195789,
		9,
		195789
	],
	"./education-center/markdown/medical/pulmonary-artery-atresia.md": [
		195789,
		9,
		195789
	],
	"./education-center/markdown/medical/pulmonary-fibrosis-idiopathic-susceptibility": [
		940860,
		9,
		940860
	],
	"./education-center/markdown/medical/pulmonary-fibrosis-idiopathic-susceptibility.md": [
		940860,
		9,
		940860
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-1-hereditary-hemorrhagic-telangiectasia": [
		738982,
		9,
		738982
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-1-hereditary-hemorrhagic-telangiectasia.md": [
		738982,
		9,
		738982
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-dexfenfluramine-associated": [
		4358,
		9,
		4358
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-dexfenfluramine-associated.md": [
		4358,
		9,
		4358
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-fenfluramine-associated": [
		770663,
		9,
		770663
	],
	"./education-center/markdown/medical/pulmonary-hypertension-primary-fenfluramine-associated.md": [
		770663,
		9,
		770663
	],
	"./education-center/markdown/medical/pulmonary-lymphangiectasia": [
		467472,
		9,
		467472
	],
	"./education-center/markdown/medical/pulmonary-lymphangiectasia.md": [
		467472,
		9,
		467472
	],
	"./education-center/markdown/medical/pulmonary-surfactant-metabolism-dysfunction-dominant": [
		592608,
		9,
		592608
	],
	"./education-center/markdown/medical/pulmonary-surfactant-metabolism-dysfunction-dominant.md": [
		592608,
		9,
		592608
	],
	"./education-center/markdown/medical/pulmonary-surfactant-metabolism-dysfunction-recessive": [
		738132,
		9,
		738132
	],
	"./education-center/markdown/medical/pulmonary-surfactant-metabolism-dysfunction-recessive.md": [
		738132,
		9,
		738132
	],
	"./education-center/markdown/medical/pulmonary-venoocclusive-disease-1-autosomal-dominant": [
		74446,
		9,
		74446
	],
	"./education-center/markdown/medical/pulmonary-venoocclusive-disease-1-autosomal-dominant.md": [
		74446,
		9,
		74446
	],
	"./education-center/markdown/medical/pura-syndrome": [
		360169,
		9,
		360169
	],
	"./education-center/markdown/medical/pura-syndrome.md": [
		360169,
		9,
		360169
	],
	"./education-center/markdown/medical/pyruvate-kinase-hyperactivity": [
		55829,
		9,
		55829
	],
	"./education-center/markdown/medical/pyruvate-kinase-hyperactivity.md": [
		55829,
		9,
		55829
	],
	"./education-center/markdown/medical/qualitative-or-quantitative-defects-collagen-6": [
		882987,
		9,
		882987
	],
	"./education-center/markdown/medical/qualitative-or-quantitative-defects-collagen-6.md": [
		882987,
		9,
		882987
	],
	"./education-center/markdown/medical/radin-blood-group": [
		878705,
		9,
		878705
	],
	"./education-center/markdown/medical/radin-blood-group.md": [
		878705,
		9,
		878705
	],
	"./education-center/markdown/medical/rapsn-related-disorders": [
		363514,
		9,
		363514
	],
	"./education-center/markdown/medical/rapsn-related-disorders.md": [
		363514,
		9,
		363514
	],
	"./education-center/markdown/medical/rare-disease-autism": [
		677400,
		9,
		677400
	],
	"./education-center/markdown/medical/rare-disease-autism.md": [
		677400,
		9,
		677400
	],
	"./education-center/markdown/medical/rare-genetic-deafness": [
		871802,
		9,
		871802
	],
	"./education-center/markdown/medical/rare-genetic-deafness.md": [
		871802,
		9,
		871802
	],
	"./education-center/markdown/medical/rare-genetic-intellectual-disability": [
		640500,
		9,
		640500
	],
	"./education-center/markdown/medical/rare-genetic-intellectual-disability.md": [
		640500,
		9,
		640500
	],
	"./education-center/markdown/medical/rare-isolated-myopia": [
		959229,
		9,
		959229
	],
	"./education-center/markdown/medical/rare-isolated-myopia.md": [
		959229,
		9,
		959229
	],
	"./education-center/markdown/medical/rare-syndromic-intellectual-disability": [
		11987,
		9,
		11987
	],
	"./education-center/markdown/medical/rare-syndromic-intellectual-disability.md": [
		11987,
		9,
		11987
	],
	"./education-center/markdown/medical/ras-inhibitor-response": [
		623525,
		9,
		623525
	],
	"./education-center/markdown/medical/ras-inhibitor-response.md": [
		623525,
		9,
		623525
	],
	"./education-center/markdown/medical/rbbp8-related-disorders": [
		117987,
		9,
		117987
	],
	"./education-center/markdown/medical/rbbp8-related-disorders.md": [
		117987,
		9,
		117987
	],
	"./education-center/markdown/medical/reclassified-mttp-polymorphism": [
		372344,
		9,
		372344
	],
	"./education-center/markdown/medical/reclassified-mttp-polymorphism.md": [
		372344,
		9,
		372344
	],
	"./education-center/markdown/medical/recombination-rate-quantitative-trait-locus-1": [
		661594,
		9,
		661594
	],
	"./education-center/markdown/medical/recombination-rate-quantitative-trait-locus-1.md": [
		661594,
		9,
		661594
	],
	"./education-center/markdown/medical/recurrent-fever": [
		383683,
		9,
		383683
	],
	"./education-center/markdown/medical/recurrent-fever.md": [
		383683,
		9,
		383683
	],
	"./education-center/markdown/medical/recurrent-hand-flapping": [
		472558,
		9,
		472558
	],
	"./education-center/markdown/medical/recurrent-hand-flapping.md": [
		472558,
		9,
		472558
	],
	"./education-center/markdown/medical/recurrent-infections": [
		872065,
		9,
		872065
	],
	"./education-center/markdown/medical/recurrent-infections.md": [
		872065,
		9,
		872065
	],
	"./education-center/markdown/medical/recurrent-pancreatitis": [
		180564,
		9,
		180564
	],
	"./education-center/markdown/medical/recurrent-pancreatitis.md": [
		180564,
		9,
		180564
	],
	"./education-center/markdown/medical/recurrent-spontaneous-abortion": [
		733675,
		9,
		733675
	],
	"./education-center/markdown/medical/recurrent-spontaneous-abortion.md": [
		733675,
		9,
		733675
	],
	"./education-center/markdown/medical/recurrent-subcortical-infarcts": [
		454680,
		9,
		454680
	],
	"./education-center/markdown/medical/recurrent-subcortical-infarcts.md": [
		454680,
		9,
		454680
	],
	"./education-center/markdown/medical/reduced-delayed-hypersensitivity": [
		75200,
		9,
		75200
	],
	"./education-center/markdown/medical/reduced-delayed-hypersensitivity.md": [
		75200,
		9,
		75200
	],
	"./education-center/markdown/medical/reduced-factor-ix-activity": [
		890272,
		9,
		890272
	],
	"./education-center/markdown/medical/reduced-factor-ix-activity.md": [
		890272,
		9,
		890272
	],
	"./education-center/markdown/medical/reduced-muscle-fiber-perlecan": [
		313068,
		9,
		313068
	],
	"./education-center/markdown/medical/reduced-muscle-fiber-perlecan.md": [
		313068,
		9,
		313068
	],
	"./education-center/markdown/medical/reduced-phenylalanine-hydroxylase-level": [
		710674,
		9,
		710674
	],
	"./education-center/markdown/medical/reduced-phenylalanine-hydroxylase-level.md": [
		710674,
		9,
		710674
	],
	"./education-center/markdown/medical/reduced-protein-c-activity": [
		817806,
		9,
		775299
	],
	"./education-center/markdown/medical/reduced-protein-c-activity.md": [
		817806,
		9,
		775299
	],
	"./education-center/markdown/medical/reduced-serum-alpha-1-antitrypsin": [
		962719,
		9,
		962719
	],
	"./education-center/markdown/medical/reduced-serum-alpha-1-antitrypsin.md": [
		962719,
		9,
		962719
	],
	"./education-center/markdown/medical/reduced-von-willebrand-factor-activity": [
		618394,
		9,
		618394
	],
	"./education-center/markdown/medical/reduced-von-willebrand-factor-activity.md": [
		618394,
		9,
		618394
	],
	"./education-center/markdown/medical/refractory-anemia-ringed-sideroblasts-clinical": [
		914505,
		9,
		914505
	],
	"./education-center/markdown/medical/refractory-anemia-ringed-sideroblasts-clinical.md": [
		914505,
		9,
		914505
	],
	"./education-center/markdown/medical/refractory-epilepsy": [
		658482,
		9,
		658482
	],
	"./education-center/markdown/medical/refractory-epilepsy.md": [
		658482,
		9,
		658482
	],
	"./education-center/markdown/medical/refsum-disease-adult-1": [
		671301,
		9,
		671301
	],
	"./education-center/markdown/medical/refsum-disease-adult-1.md": [
		671301,
		9,
		671301
	],
	"./education-center/markdown/medical/regorafenib-response": [
		931205,
		9,
		931205
	],
	"./education-center/markdown/medical/regorafenib-response.md": [
		931205,
		9,
		931205
	],
	"./education-center/markdown/medical/regression-motor-development-severe-dystonia-and-corresponding-basal-ganglia-lesions": [
		2687,
		9,
		2687
	],
	"./education-center/markdown/medical/regression-motor-development-severe-dystonia-and-corresponding-basal-ganglia-lesions.md": [
		2687,
		9,
		2687
	],
	"./education-center/markdown/medical/renal-cell-carcinoma-paraneoplastic-erythrocytosis": [
		292439,
		9,
		292439
	],
	"./education-center/markdown/medical/renal-cell-carcinoma-paraneoplastic-erythrocytosis.md": [
		292439,
		9,
		292439
	],
	"./education-center/markdown/medical/renal-coloboma-syndrome": [
		288492,
		9,
		288492
	],
	"./education-center/markdown/medical/renal-coloboma-syndrome.md": [
		288492,
		9,
		288492
	],
	"./education-center/markdown/medical/renal-cortical-hyperechogenicity": [
		207013,
		9,
		207013
	],
	"./education-center/markdown/medical/renal-cortical-hyperechogenicity.md": [
		207013,
		9,
		207013
	],
	"./education-center/markdown/medical/renal-cysts-and-diabetes-syndrome": [
		525350,
		9,
		525350
	],
	"./education-center/markdown/medical/renal-cysts-and-diabetes-syndrome.md": [
		525350,
		9,
		525350
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-2": [
		583155,
		9,
		583155
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-2.md": [
		583155,
		9,
		583155
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-dominant": [
		181613,
		9,
		315405
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-dominant.md": [
		181613,
		9,
		315405
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-recessive": [
		916577,
		9,
		916577
	],
	"./education-center/markdown/medical/renal-hypomagnesemia-recessive.md": [
		916577,
		9,
		916577
	],
	"./education-center/markdown/medical/renal-hypoplasiaaplasia": [
		194318,
		9,
		194318
	],
	"./education-center/markdown/medical/renal-hypoplasiaaplasia.md": [
		194318,
		9,
		194318
	],
	"./education-center/markdown/medical/renal-insufficiency": [
		859175,
		9,
		859175
	],
	"./education-center/markdown/medical/renal-insufficiency.md": [
		859175,
		9,
		859175
	],
	"./education-center/markdown/medical/renal-transitional-cell-carcinoma": [
		565763,
		9,
		565763
	],
	"./education-center/markdown/medical/renal-transitional-cell-carcinoma.md": [
		565763,
		9,
		565763
	],
	"./education-center/markdown/medical/renal-tubular-acidosis-distal-normal-red-cell-morphology": [
		953456,
		9,
		953456
	],
	"./education-center/markdown/medical/renal-tubular-acidosis-distal-normal-red-cell-morphology.md": [
		953456,
		9,
		953456
	],
	"./education-center/markdown/medical/renal-tubular-epithelial-cell-apoptosis": [
		223401,
		9,
		223401
	],
	"./education-center/markdown/medical/renal-tubular-epithelial-cell-apoptosis.md": [
		223401,
		9,
		223401
	],
	"./education-center/markdown/medical/renier-gabreels-jasper-syndrome": [
		445104,
		9,
		445104
	],
	"./education-center/markdown/medical/renier-gabreels-jasper-syndrome.md": [
		445104,
		9,
		445104
	],
	"./education-center/markdown/medical/repeat-number-microsatellite": [
		968046,
		9,
		968046
	],
	"./education-center/markdown/medical/repeat-number-microsatellite.md": [
		968046,
		9,
		968046
	],
	"./education-center/markdown/medical/resistance-hepatitis-c-virus": [
		430217,
		9,
		430217
	],
	"./education-center/markdown/medical/resistance-hepatitis-c-virus.md": [
		430217,
		9,
		430217
	],
	"./education-center/markdown/medical/respiratory-infections-recurrent-and-failure-thrive-or-without-diarrhea": [
		494557,
		9,
		494557
	],
	"./education-center/markdown/medical/respiratory-infections-recurrent-and-failure-thrive-or-without-diarrhea.md": [
		494557,
		9,
		494557
	],
	"./education-center/markdown/medical/resting-heart-rate": [
		812027,
		9,
		812027
	],
	"./education-center/markdown/medical/resting-heart-rate.md": [
		812027,
		9,
		812027
	],
	"./education-center/markdown/medical/retinal-arterial-macroaneurysm-supravascular-pulmonic-stenosis": [
		104865,
		9,
		104865
	],
	"./education-center/markdown/medical/retinal-arterial-macroaneurysm-supravascular-pulmonic-stenosis.md": [
		104865,
		9,
		104865
	],
	"./education-center/markdown/medical/retinal-atrophy": [
		845457,
		9,
		845457
	],
	"./education-center/markdown/medical/retinal-atrophy.md": [
		845457,
		9,
		845457
	],
	"./education-center/markdown/medical/retinal-degeneration-autosomal-recessive-clumped-pigment-type": [
		356194,
		9,
		356194
	],
	"./education-center/markdown/medical/retinal-degeneration-autosomal-recessive-clumped-pigment-type.md": [
		356194,
		9,
		356194
	],
	"./education-center/markdown/medical/retinal-detachment": [
		434376,
		9,
		434376
	],
	"./education-center/markdown/medical/retinal-detachment.md": [
		434376,
		9,
		434376
	],
	"./education-center/markdown/medical/retinal-dystrophy-and-microvillus-inclusion-disease": [
		44432,
		9,
		44432
	],
	"./education-center/markdown/medical/retinal-dystrophy-and-microvillus-inclusion-disease.md": [
		44432,
		9,
		44432
	],
	"./education-center/markdown/medical/retinal-dystrophy-early-onset-severe": [
		810686,
		9,
		810686
	],
	"./education-center/markdown/medical/retinal-dystrophy-early-onset-severe-lrat-related": [
		684212,
		9,
		684212
	],
	"./education-center/markdown/medical/retinal-dystrophy-early-onset-severe-lrat-related.md": [
		684212,
		9,
		684212
	],
	"./education-center/markdown/medical/retinal-dystrophy-early-onset-severe.md": [
		810686,
		9,
		810686
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-39": [
		8977,
		9,
		8977
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-39.md": [
		8977,
		9,
		8977
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-4-autosomal-recessive": [
		548759,
		9,
		548759
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-4-autosomal-recessive.md": [
		548759,
		9,
		548759
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-43": [
		251640,
		9,
		251640
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-43.md": [
		251640,
		9,
		251640
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-6": [
		849277,
		9,
		849277
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-6.md": [
		849277,
		9,
		849277
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-61": [
		86768,
		9,
		86768
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-61.md": [
		86768,
		9,
		86768
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-7-digenic": [
		163359,
		9,
		163359
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-7-digenic.md": [
		163359,
		9,
		163359
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-dominant": [
		767664,
		9,
		767664
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-dominant.md": [
		767664,
		9,
		767664
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-dominantrecessive": [
		549276,
		9,
		549276
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-dominantrecessive.md": [
		549276,
		9,
		549276
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-juvenile-lrat-related": [
		477057,
		9,
		477057
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-juvenile-lrat-related.md": [
		477057,
		9,
		477057
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-recessive": [
		82608,
		9,
		82608
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-recessive.md": [
		82608,
		9,
		82608
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-x-linked-and-sinorespiratory-infections-or-without-deafness": [
		656807,
		9,
		656807
	],
	"./education-center/markdown/medical/retinitis-pigmentosa-x-linked-and-sinorespiratory-infections-or-without-deafness.md": [
		656807,
		9,
		656807
	],
	"./education-center/markdown/medical/retinitis-punctata-albescens-autosomal-dominant": [
		594482,
		9,
		594482
	],
	"./education-center/markdown/medical/retinitis-punctata-albescens-autosomal-dominant.md": [
		594482,
		9,
		594482
	],
	"./education-center/markdown/medical/retinoblastoma": [
		618548,
		9,
		618548
	],
	"./education-center/markdown/medical/retinoblastoma.md": [
		618548,
		9,
		618548
	],
	"./education-center/markdown/medical/retinopathy-prematurity": [
		8251,
		9,
		8251
	],
	"./education-center/markdown/medical/retinopathy-prematurity.md": [
		8251,
		9,
		8251
	],
	"./education-center/markdown/medical/rett-syndrome-zappella-variant": [
		864344,
		9,
		864344
	],
	"./education-center/markdown/medical/rett-syndrome-zappella-variant.md": [
		864344,
		9,
		864344
	],
	"./education-center/markdown/medical/rh-mod-blood-group-phenotype": [
		699865,
		9,
		699865
	],
	"./education-center/markdown/medical/rh-mod-blood-group-phenotype.md": [
		699865,
		9,
		699865
	],
	"./education-center/markdown/medical/rh-null-amorph-type": [
		660745,
		9,
		660745
	],
	"./education-center/markdown/medical/rh-null-amorph-type.md": [
		660745,
		9,
		660745
	],
	"./education-center/markdown/medical/rh-null-regulator-type": [
		693602,
		9,
		693602
	],
	"./education-center/markdown/medical/rh-null-regulator-type.md": [
		693602,
		9,
		693602
	],
	"./education-center/markdown/medical/rhabdomyosarcoma-somatic": [
		972969,
		9,
		972969
	],
	"./education-center/markdown/medical/rhabdomyosarcoma-somatic.md": [
		972969,
		9,
		972969
	],
	"./education-center/markdown/medical/rhd-negative": [
		452708,
		9,
		452708
	],
	"./education-center/markdown/medical/rhd-negative.md": [
		452708,
		9,
		452708
	],
	"./education-center/markdown/medical/rheumatic-heart-disease": [
		242110,
		9,
		242110
	],
	"./education-center/markdown/medical/rheumatic-heart-disease.md": [
		242110,
		9,
		242110
	],
	"./education-center/markdown/medical/rheumatoid-arthritis": [
		604784,
		9,
		604784
	],
	"./education-center/markdown/medical/rheumatoid-arthritis-progression": [
		102882,
		9,
		102882
	],
	"./education-center/markdown/medical/rheumatoid-arthritis-progression.md": [
		102882,
		9,
		102882
	],
	"./education-center/markdown/medical/rheumatoid-arthritis.md": [
		604784,
		9,
		604784
	],
	"./education-center/markdown/medical/rhizomelic-dysplasia-ain-naz-type": [
		483522,
		9,
		483522
	],
	"./education-center/markdown/medical/rhizomelic-dysplasia-ain-naz-type.md": [
		483522,
		9,
		483522
	],
	"./education-center/markdown/medical/ribavirin-response-efficacy": [
		601091,
		9,
		601091
	],
	"./education-center/markdown/medical/ribavirin-response-efficacy.md": [
		601091,
		9,
		601091
	],
	"./education-center/markdown/medical/right-ventricular-cardiomyopathy": [
		624678,
		9,
		624678
	],
	"./education-center/markdown/medical/right-ventricular-cardiomyopathy.md": [
		624678,
		9,
		624678
	],
	"./education-center/markdown/medical/rippling-muscle-disease-2-autosomal-recessive": [
		258685,
		9,
		258685
	],
	"./education-center/markdown/medical/rippling-muscle-disease-2-autosomal-recessive.md": [
		258685,
		9,
		258685
	],
	"./education-center/markdown/medical/rlbp1-related-disorders": [
		762541,
		9,
		762541
	],
	"./education-center/markdown/medical/rlbp1-related-disorders.md": [
		762541,
		9,
		762541
	],
	"./education-center/markdown/medical/robinow-syndrome-autosomal-recessive-aplasiahypoplasia-phalanges-and-metacarpalsmetatarsals": [
		387618,
		9,
		387618
	],
	"./education-center/markdown/medical/robinow-syndrome-autosomal-recessive-aplasiahypoplasia-phalanges-and-metacarpalsmetatarsals.md": [
		387618,
		9,
		387618
	],
	"./education-center/markdown/medical/robinow-syndrome-autosomal-recessive-brachy-syn-polydactyly": [
		575645,
		9,
		575645
	],
	"./education-center/markdown/medical/robinow-syndrome-autosomal-recessive-brachy-syn-polydactyly.md": [
		575645,
		9,
		575645
	],
	"./education-center/markdown/medical/rod-cone-dystrophy": [
		160262,
		9,
		160262
	],
	"./education-center/markdown/medical/rod-cone-dystrophy.md": [
		160262,
		9,
		160262
	],
	"./education-center/markdown/medical/rosuvastatin-response-efficacy": [
		428267,
		9,
		428267
	],
	"./education-center/markdown/medical/rosuvastatin-response-efficacy.md": [
		428267,
		9,
		428267
	],
	"./education-center/markdown/medical/rpe65-related-disorders": [
		117818,
		9,
		117818
	],
	"./education-center/markdown/medical/rpe65-related-disorders.md": [
		117818,
		9,
		117818
	],
	"./education-center/markdown/medical/rrm2b-related-mitochondrial-disease": [
		611717,
		9,
		611717
	],
	"./education-center/markdown/medical/rrm2b-related-mitochondrial-disease.md": [
		611717,
		9,
		611717
	],
	"./education-center/markdown/medical/ryr1-related-disorders": [
		408940,
		9,
		408940
	],
	"./education-center/markdown/medical/ryr1-related-disorders.md": [
		408940,
		9,
		408940
	],
	"./education-center/markdown/medical/sacral-defect-anterior-meningocele": [
		404077,
		9,
		404077
	],
	"./education-center/markdown/medical/sacral-defect-anterior-meningocele.md": [
		404077,
		9,
		404077
	],
	"./education-center/markdown/medical/saethre-chotzen-syndrome": [
		924264,
		9,
		924264
	],
	"./education-center/markdown/medical/saethre-chotzen-syndrome-eyelid-anomalies": [
		403595,
		9,
		403595
	],
	"./education-center/markdown/medical/saethre-chotzen-syndrome-eyelid-anomalies.md": [
		403595,
		9,
		403595
	],
	"./education-center/markdown/medical/saethre-chotzen-syndrome.md": [
		924264,
		9,
		924264
	],
	"./education-center/markdown/medical/saldino-mainzer-syndrome": [
		875688,
		9,
		875688
	],
	"./education-center/markdown/medical/saldino-mainzer-syndrome.md": [
		875688,
		9,
		875688
	],
	"./education-center/markdown/medical/sall4-related-spectrum-disorders": [
		530226,
		9,
		530226
	],
	"./education-center/markdown/medical/sall4-related-spectrum-disorders.md": [
		530226,
		9,
		530226
	],
	"./education-center/markdown/medical/salmeterol-response-efficacy": [
		926808,
		9,
		926808
	],
	"./education-center/markdown/medical/salmeterol-response-efficacy.md": [
		926808,
		9,
		926808
	],
	"./education-center/markdown/medical/sandhoff-disease-chronic": [
		351656,
		9,
		351656
	],
	"./education-center/markdown/medical/sandhoff-disease-chronic.md": [
		351656,
		9,
		351656
	],
	"./education-center/markdown/medical/sardinian-hpfh": [
		402601,
		9,
		402601
	],
	"./education-center/markdown/medical/sardinian-hpfh.md": [
		402601,
		9,
		402601
	],
	"./education-center/markdown/medical/scaphocephaly-and-axenfeld-rieger-anomaly": [
		722943,
		9,
		722943
	],
	"./education-center/markdown/medical/scaphocephaly-and-axenfeld-rieger-anomaly.md": [
		722943,
		9,
		722943
	],
	"./education-center/markdown/medical/scapular-winging": [
		144110,
		9,
		144110
	],
	"./education-center/markdown/medical/scapular-winging.md": [
		144110,
		9,
		144110
	],
	"./education-center/markdown/medical/scapuloperoneal-myopathy": [
		692516,
		9,
		692516
	],
	"./education-center/markdown/medical/scapuloperoneal-myopathy.md": [
		692516,
		9,
		692516
	],
	"./education-center/markdown/medical/scapuloperoneal-weakness": [
		882575,
		9,
		882575
	],
	"./education-center/markdown/medical/scapuloperoneal-weakness.md": [
		882575,
		9,
		882575
	],
	"./education-center/markdown/medical/schizophrenia-15": [
		982034,
		9,
		982034
	],
	"./education-center/markdown/medical/schizophrenia-15.md": [
		982034,
		9,
		982034
	],
	"./education-center/markdown/medical/schnyder-crystalline-corneal-dystrophy": [
		432628,
		9,
		432628
	],
	"./education-center/markdown/medical/schnyder-crystalline-corneal-dystrophy.md": [
		432628,
		9,
		432628
	],
	"./education-center/markdown/medical/schwannomatosis-1-somatic": [
		722572,
		9,
		722572
	],
	"./education-center/markdown/medical/schwannomatosis-1-somatic.md": [
		722572,
		9,
		722572
	],
	"./education-center/markdown/medical/scid-due-ada-deficiency-delayed-onset": [
		304548,
		9,
		304548
	],
	"./education-center/markdown/medical/scid-due-ada-deficiency-delayed-onset.md": [
		304548,
		9,
		304548
	],
	"./education-center/markdown/medical/scn2a-related-generalized-epilepsy-febrile-seizures-plus": [
		704381,
		9,
		704381
	],
	"./education-center/markdown/medical/scn2a-related-generalized-epilepsy-febrile-seizures-plus.md": [
		704381,
		9,
		704381
	],
	"./education-center/markdown/medical/scn5a-related-disorders": [
		893948,
		9,
		893948
	],
	"./education-center/markdown/medical/scn5a-related-disorders.md": [
		893948,
		9,
		893948
	],
	"./education-center/markdown/medical/scoliosis": [
		134523,
		9,
		134523
	],
	"./education-center/markdown/medical/scoliosis.md": [
		134523,
		9,
		134523
	],
	"./education-center/markdown/medical/sdhb-related-disorders": [
		871576,
		9,
		871576
	],
	"./education-center/markdown/medical/sdhb-related-disorders.md": [
		871576,
		9,
		871576
	],
	"./education-center/markdown/medical/seizures-benign-familial-infantile-6": [
		263317,
		9,
		263317
	],
	"./education-center/markdown/medical/seizures-benign-familial-infantile-6.md": [
		263317,
		9,
		263317
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-1": [
		364978,
		9,
		364978
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-1-andor-myokymia": [
		157717,
		9,
		157717
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-1-andor-myokymia.md": [
		157717,
		9,
		157717
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-1.md": [
		364978,
		9,
		364978
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-2": [
		197752,
		9,
		438606
	],
	"./education-center/markdown/medical/seizures-benign-familial-neonatal-2.md": [
		197752,
		9,
		438606
	],
	"./education-center/markdown/medical/seizures-sensorineural-deafness-ataxia-intellectual-disability-and-electrolyte-imbalance-syndrome": [
		271755,
		9,
		271755
	],
	"./education-center/markdown/medical/seizures-sensorineural-deafness-ataxia-intellectual-disability-and-electrolyte-imbalance-syndrome.md": [
		271755,
		9,
		271755
	],
	"./education-center/markdown/medical/selective-pituitary-resistance-thyroid-hormone": [
		22098,
		9,
		22098
	],
	"./education-center/markdown/medical/selective-pituitary-resistance-thyroid-hormone.md": [
		22098,
		9,
		22098
	],
	"./education-center/markdown/medical/selective-tooth-agenesis": [
		733386,
		9,
		733386
	],
	"./education-center/markdown/medical/selective-tooth-agenesis.md": [
		733386,
		9,
		733386
	],
	"./education-center/markdown/medical/senior-loken-syndrome-1": [
		780393,
		9,
		780393
	],
	"./education-center/markdown/medical/senior-loken-syndrome-1.md": [
		780393,
		9,
		780393
	],
	"./education-center/markdown/medical/sensorimotor-neuropathy": [
		424720,
		9,
		424720
	],
	"./education-center/markdown/medical/sensorimotor-neuropathy.md": [
		424720,
		9,
		424720
	],
	"./education-center/markdown/medical/sensorineural-deafness-and-migraine": [
		222983,
		9,
		222983
	],
	"./education-center/markdown/medical/sensorineural-deafness-and-migraine.md": [
		222983,
		9,
		222983
	],
	"./education-center/markdown/medical/sensorineural-deafness-hypertrophic-cardiomyopathy": [
		730462,
		9,
		730462
	],
	"./education-center/markdown/medical/sensorineural-deafness-hypertrophic-cardiomyopathy.md": [
		730462,
		9,
		730462
	],
	"./education-center/markdown/medical/sensorineural-deafness-mild-renal-dysfunction": [
		633803,
		9,
		633803
	],
	"./education-center/markdown/medical/sensorineural-deafness-mild-renal-dysfunction.md": [
		633803,
		9,
		633803
	],
	"./education-center/markdown/medical/sensory-axonal-neuropathy": [
		831685,
		9,
		831685
	],
	"./education-center/markdown/medical/sensory-axonal-neuropathy.md": [
		831685,
		9,
		831685
	],
	"./education-center/markdown/medical/sensory-neuropathy-spastic-paraplegia": [
		875983,
		9,
		875983
	],
	"./education-center/markdown/medical/sensory-neuropathy-spastic-paraplegia.md": [
		875983,
		9,
		875983
	],
	"./education-center/markdown/medical/sepn1-related-disorders": [
		248089,
		9,
		248089
	],
	"./education-center/markdown/medical/sepn1-related-disorders.md": [
		248089,
		9,
		248089
	],
	"./education-center/markdown/medical/septooptic-dysplasia-mild": [
		162816,
		9,
		162816
	],
	"./education-center/markdown/medical/septooptic-dysplasia-mild.md": [
		162816,
		9,
		162816
	],
	"./education-center/markdown/medical/serum-level-adiponectin-1": [
		577174,
		9,
		577174
	],
	"./education-center/markdown/medical/serum-level-adiponectin-1.md": [
		577174,
		9,
		577174
	],
	"./education-center/markdown/medical/setx-related-disorders": [
		434865,
		9,
		434865
	],
	"./education-center/markdown/medical/setx-related-disorders.md": [
		434865,
		9,
		434865
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-athabascan-type": [
		983596,
		9,
		983596
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-athabascan-type.md": [
		983596,
		9,
		983596
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-autosomal-recessive-t-cell-negative-b-cell-negative-nk-cell": [
		13077,
		9,
		13077
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-autosomal-recessive-t-cell-negative-b-cell-negative-nk-cell.md": [
		13077,
		9,
		13077
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-b-cell-negative": [
		172328,
		9,
		172328
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-b-cell-negative.md": [
		172328,
		9,
		172328
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-partial": [
		860076,
		9,
		860076
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-partial.md": [
		860076,
		9,
		860076
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-sensitivity-ionizing-radiation-due-nhej1-deficiency": [
		500640,
		9,
		500640
	],
	"./education-center/markdown/medical/severe-combined-immunodeficiency-sensitivity-ionizing-radiation-due-nhej1-deficiency.md": [
		500640,
		9,
		500640
	],
	"./education-center/markdown/medical/severe-global-developmental-delay": [
		272403,
		9,
		272403
	],
	"./education-center/markdown/medical/severe-global-developmental-delay.md": [
		272403,
		9,
		272403
	],
	"./education-center/markdown/medical/severe-hydrocephalus": [
		905403,
		9,
		905403
	],
	"./education-center/markdown/medical/severe-hydrocephalus.md": [
		905403,
		9,
		905403
	],
	"./education-center/markdown/medical/severe-intellectual-deficiency": [
		43306,
		9,
		43306
	],
	"./education-center/markdown/medical/severe-intellectual-deficiency.md": [
		43306,
		9,
		43306
	],
	"./education-center/markdown/medical/severe-lactic-acidosis": [
		810635,
		9,
		810635
	],
	"./education-center/markdown/medical/severe-lactic-acidosis.md": [
		810635,
		9,
		810635
	],
	"./education-center/markdown/medical/severe-neonatal-hypotonia-improving-age": [
		784071,
		9,
		784071
	],
	"./education-center/markdown/medical/severe-neonatal-hypotonia-improving-age.md": [
		784071,
		9,
		784071
	],
	"./education-center/markdown/medical/severe-postnatal-growth-retardation": [
		610430,
		9,
		610430
	],
	"./education-center/markdown/medical/severe-postnatal-growth-retardation.md": [
		610430,
		9,
		610430
	],
	"./education-center/markdown/medical/severe-sensorineural-hearing-impairment": [
		294354,
		9,
		294354
	],
	"./education-center/markdown/medical/severe-sensorineural-hearing-impairment.md": [
		294354,
		9,
		294354
	],
	"./education-center/markdown/medical/severe-short-limb-dwarfism": [
		535385,
		9,
		535385
	],
	"./education-center/markdown/medical/severe-short-limb-dwarfism.md": [
		535385,
		9,
		535385
	],
	"./education-center/markdown/medical/sex-cord-stromal-tumor": [
		584465,
		9,
		584465
	],
	"./education-center/markdown/medical/sex-cord-stromal-tumor.md": [
		584465,
		9,
		584465
	],
	"./education-center/markdown/medical/sex-hormone-binding-globulin-deficiency": [
		454411,
		9,
		454411
	],
	"./education-center/markdown/medical/sex-hormone-binding-globulin-deficiency.md": [
		454411,
		9,
		454411
	],
	"./education-center/markdown/medical/sex-reversal": [
		506402,
		9,
		576222
	],
	"./education-center/markdown/medical/sex-reversal.md": [
		506402,
		9,
		576222
	],
	"./education-center/markdown/medical/sh3tc2-related-disorders": [
		86157,
		9,
		86157
	],
	"./education-center/markdown/medical/sh3tc2-related-disorders.md": [
		86157,
		9,
		86157
	],
	"./education-center/markdown/medical/short-fetal-femur-length": [
		260571,
		9,
		260571
	],
	"./education-center/markdown/medical/short-fetal-femur-length.md": [
		260571,
		9,
		260571
	],
	"./education-center/markdown/medical/short-nose": [
		514082,
		9,
		514082
	],
	"./education-center/markdown/medical/short-nose.md": [
		514082,
		9,
		514082
	],
	"./education-center/markdown/medical/short-qt-syndrome": [
		546754,
		9,
		546754
	],
	"./education-center/markdown/medical/short-qt-syndrome-4": [
		646603,
		9,
		646603
	],
	"./education-center/markdown/medical/short-qt-syndrome-4.md": [
		646603,
		9,
		646603
	],
	"./education-center/markdown/medical/short-qt-syndrome-5": [
		282577,
		9,
		282577
	],
	"./education-center/markdown/medical/short-qt-syndrome-5.md": [
		282577,
		9,
		282577
	],
	"./education-center/markdown/medical/short-qt-syndrome.md": [
		546754,
		9,
		546754
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-10-polydactyly": [
		564504,
		9,
		564504
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-10-polydactyly.md": [
		564504,
		9,
		564504
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-10-without-polydactyly": [
		570441,
		9,
		570441
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-10-without-polydactyly.md": [
		570441,
		9,
		570441
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-without-polydactyly": [
		835205,
		9,
		835205
	],
	"./education-center/markdown/medical/short-rib-thoracic-dysplasia-without-polydactyly.md": [
		835205,
		9,
		835205
	],
	"./education-center/markdown/medical/short-sleep-familial-natural-1": [
		566337,
		9,
		566337
	],
	"./education-center/markdown/medical/short-sleep-familial-natural-1.md": [
		566337,
		9,
		566337
	],
	"./education-center/markdown/medical/short-sleep-familial-natural-2": [
		365893,
		9,
		365893
	],
	"./education-center/markdown/medical/short-sleep-familial-natural-2.md": [
		365893,
		9,
		365893
	],
	"./education-center/markdown/medical/short-stature": [
		180219,
		9,
		180219
	],
	"./education-center/markdown/medical/short-stature-and-advanced-bone-age": [
		914424,
		9,
		914424
	],
	"./education-center/markdown/medical/short-stature-and-advanced-bone-age-early-onset-osteoarthritis": [
		234754,
		9,
		234754
	],
	"./education-center/markdown/medical/short-stature-and-advanced-bone-age-early-onset-osteoarthritis.md": [
		234754,
		9,
		234754
	],
	"./education-center/markdown/medical/short-stature-and-advanced-bone-age.md": [
		914424,
		9,
		914424
	],
	"./education-center/markdown/medical/short-stature.md": [
		180219,
		9,
		180219
	],
	"./education-center/markdown/medical/shoulder-girdle-muscle-weakness": [
		499443,
		9,
		499443
	],
	"./education-center/markdown/medical/shoulder-girdle-muscle-weakness.md": [
		499443,
		9,
		499443
	],
	"./education-center/markdown/medical/shoulder-subluxation": [
		414271,
		9,
		414271
	],
	"./education-center/markdown/medical/shoulder-subluxation.md": [
		414271,
		9,
		414271
	],
	"./education-center/markdown/medical/sickle-cell-hemoglobin-o-arab-disease": [
		801590,
		9,
		801590
	],
	"./education-center/markdown/medical/sickle-cell-hemoglobin-o-arab-disease.md": [
		801590,
		9,
		801590
	],
	"./education-center/markdown/medical/sideroblastic-anemia-1-late-onset": [
		861755,
		9,
		861755
	],
	"./education-center/markdown/medical/sideroblastic-anemia-1-late-onset.md": [
		861755,
		9,
		861755
	],
	"./education-center/markdown/medical/sideroblastic-anemia-and-ataxia": [
		904596,
		9,
		904596
	],
	"./education-center/markdown/medical/sideroblastic-anemia-and-ataxia.md": [
		904596,
		9,
		904596
	],
	"./education-center/markdown/medical/sigmoid-colon-cancer": [
		830942,
		9,
		830942
	],
	"./education-center/markdown/medical/sigmoid-colon-cancer.md": [
		830942,
		9,
		830942
	],
	"./education-center/markdown/medical/simplified-gyral-pattern": [
		67619,
		9,
		67619
	],
	"./education-center/markdown/medical/simplified-gyral-pattern.md": [
		67619,
		9,
		67619
	],
	"./education-center/markdown/medical/sinus-node-disease": [
		680392,
		9,
		680392
	],
	"./education-center/markdown/medical/sinus-node-disease.md": [
		680392,
		9,
		680392
	],
	"./education-center/markdown/medical/skeletal-dysplasia-acanthosis-nigricans": [
		500909,
		9,
		500909
	],
	"./education-center/markdown/medical/skeletal-dysplasia-acanthosis-nigricans.md": [
		500909,
		9,
		500909
	],
	"./education-center/markdown/medical/skeletal-muscle-glycogen-content-and-metabolism-quantitative-trait-locus": [
		109714,
		9,
		109714
	],
	"./education-center/markdown/medical/skeletal-muscle-glycogen-content-and-metabolism-quantitative-trait-locus.md": [
		109714,
		9,
		109714
	],
	"./education-center/markdown/medical/skeletal-myopathy-responsive-riboflavin": [
		553674,
		9,
		553674
	],
	"./education-center/markdown/medical/skeletal-myopathy-responsive-riboflavin.md": [
		553674,
		9,
		553674
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-2-blond-hairfair-skin": [
		82757,
		9,
		82757
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-2-blond-hairfair-skin.md": [
		82757,
		9,
		82757
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-2-red-hairfair-skin": [
		903902,
		9,
		903902
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-2-red-hairfair-skin.md": [
		903902,
		9,
		903902
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-3-bluegreen-eyes": [
		660309,
		9,
		660309
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-3-bluegreen-eyes.md": [
		660309,
		9,
		660309
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-3-lightdark-skin": [
		774754,
		9,
		774754
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-3-lightdark-skin.md": [
		774754,
		9,
		774754
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-6-blondbrown-hair": [
		10339,
		9,
		10339
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-6-blondbrown-hair.md": [
		10339,
		9,
		10339
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-7-darklight-skin": [
		263721,
		9,
		263721
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-7-darklight-skin.md": [
		263721,
		9,
		263721
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-9-darklight-hair": [
		97384,
		9,
		97384
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-9-darklight-hair.md": [
		97384,
		9,
		97384
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-2": [
		803534,
		9,
		803534
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-2.md": [
		803534,
		9,
		803534
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-5": [
		365265,
		9,
		365265
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-5.md": [
		365265,
		9,
		365265
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-8": [
		35070,
		9,
		35070
	],
	"./education-center/markdown/medical/skinhaireye-pigmentation-variation-8.md": [
		35070,
		9,
		35070
	],
	"./education-center/markdown/medical/slc26a2-related-disorders": [
		787843,
		9,
		787843
	],
	"./education-center/markdown/medical/slc26a2-related-disorders.md": [
		787843,
		9,
		787843
	],
	"./education-center/markdown/medical/slc26a4-related-disorders": [
		433127,
		9,
		433127
	],
	"./education-center/markdown/medical/slc26a4-related-disorders.md": [
		433127,
		9,
		433127
	],
	"./education-center/markdown/medical/sleep-myoclonus": [
		493884,
		9,
		493884
	],
	"./education-center/markdown/medical/sleep-myoclonus.md": [
		493884,
		9,
		493884
	],
	"./education-center/markdown/medical/sleep-related-hypermotor-epilepsy": [
		251107,
		9,
		251107
	],
	"./education-center/markdown/medical/sleep-related-hypermotor-epilepsy.md": [
		251107,
		9,
		251107
	],
	"./education-center/markdown/medical/small-cell-carcinoma-ovary-hypercalcemic-type": [
		560218,
		9,
		560218
	],
	"./education-center/markdown/medical/small-cell-carcinoma-ovary-hypercalcemic-type.md": [
		560218,
		9,
		560218
	],
	"./education-center/markdown/medical/small-cervical-vertebral-bodies": [
		32666,
		9,
		32666
	],
	"./education-center/markdown/medical/small-cervical-vertebral-bodies.md": [
		32666,
		9,
		32666
	],
	"./education-center/markdown/medical/small-gestational-age": [
		238028,
		9,
		238028
	],
	"./education-center/markdown/medical/small-gestational-age.md": [
		238028,
		9,
		238028
	],
	"./education-center/markdown/medical/small-intestine-carcinoid": [
		407350,
		9,
		407350
	],
	"./education-center/markdown/medical/small-intestine-carcinoid.md": [
		407350,
		9,
		407350
	],
	"./education-center/markdown/medical/small-scrotum": [
		729503,
		9,
		729503
	],
	"./education-center/markdown/medical/small-scrotum.md": [
		729503,
		9,
		729503
	],
	"./education-center/markdown/medical/small-vessel-cerebrovascular-disease": [
		358321,
		9,
		358321
	],
	"./education-center/markdown/medical/small-vessel-cerebrovascular-disease.md": [
		358321,
		9,
		358321
	],
	"./education-center/markdown/medical/smith-magenis-syndrome": [
		351745,
		9,
		351745
	],
	"./education-center/markdown/medical/smith-magenis-syndrome.md": [
		351745,
		9,
		351745
	],
	"./education-center/markdown/medical/smoking-quantitative-trait-locus-3": [
		290496,
		9,
		290496
	],
	"./education-center/markdown/medical/smoking-quantitative-trait-locus-3.md": [
		290496,
		9,
		290496
	],
	"./education-center/markdown/medical/sodium-serum-level-quantitative-trait-locus-1": [
		854590,
		9,
		854590
	],
	"./education-center/markdown/medical/sodium-serum-level-quantitative-trait-locus-1.md": [
		854590,
		9,
		854590
	],
	"./education-center/markdown/medical/solitary-median-maxillary-central-incisor-syndrome": [
		146607,
		9,
		146607
	],
	"./education-center/markdown/medical/solitary-median-maxillary-central-incisor-syndrome.md": [
		146607,
		9,
		146607
	],
	"./education-center/markdown/medical/soluble-interleukin-6-receptor-serum-level-quantitative-trait-locus": [
		769212,
		9,
		769212
	],
	"./education-center/markdown/medical/soluble-interleukin-6-receptor-serum-level-quantitative-trait-locus.md": [
		769212,
		9,
		769212
	],
	"./education-center/markdown/medical/somatostatin-analog-resistance": [
		193431,
		9,
		193431
	],
	"./education-center/markdown/medical/somatostatin-analog-resistance.md": [
		193431,
		9,
		193431
	],
	"./education-center/markdown/medical/somatotroph-adenoma": [
		3331,
		9,
		3331
	],
	"./education-center/markdown/medical/somatotroph-adenoma.md": [
		3331,
		9,
		3331
	],
	"./education-center/markdown/medical/sorsby-fundus-dystrophy": [
		899121,
		9,
		899121
	],
	"./education-center/markdown/medical/sorsby-fundus-dystrophy.md": [
		899121,
		9,
		899121
	],
	"./education-center/markdown/medical/sotos-syndrome-1": [
		181638,
		9,
		181638
	],
	"./education-center/markdown/medical/sotos-syndrome-1.md": [
		181638,
		9,
		181638
	],
	"./education-center/markdown/medical/spastic-ataxia-1": [
		831644,
		9,
		831644
	],
	"./education-center/markdown/medical/spastic-ataxia-1.md": [
		831644,
		9,
		831644
	],
	"./education-center/markdown/medical/spastic-cerebral-palsy": [
		581956,
		9,
		581956
	],
	"./education-center/markdown/medical/spastic-cerebral-palsy.md": [
		581956,
		9,
		581956
	],
	"./education-center/markdown/medical/spastic-paraplegia-70-autosomal-recessive": [
		205796,
		9,
		205796
	],
	"./education-center/markdown/medical/spastic-paraplegia-70-autosomal-recessive.md": [
		205796,
		9,
		205796
	],
	"./education-center/markdown/medical/spastic-paraplegia-72-autosomal-dominant": [
		790881,
		9,
		790881
	],
	"./education-center/markdown/medical/spastic-paraplegia-72-autosomal-dominant.md": [
		790881,
		9,
		790881
	],
	"./education-center/markdown/medical/spastic-paraplegia-autosomal-dominant": [
		758947,
		9,
		758947
	],
	"./education-center/markdown/medical/spastic-paraplegia-autosomal-dominant.md": [
		758947,
		9,
		758947
	],
	"./education-center/markdown/medical/spastic-paraplegia-recessive": [
		737536,
		9,
		737536
	],
	"./education-center/markdown/medical/spastic-paraplegia-recessive.md": [
		737536,
		9,
		737536
	],
	"./education-center/markdown/medical/spastic-tetraparesis": [
		34013,
		9,
		34013
	],
	"./education-center/markdown/medical/spastic-tetraparesis.md": [
		34013,
		9,
		34013
	],
	"./education-center/markdown/medical/spata7-related-disorders": [
		168939,
		9,
		168939
	],
	"./education-center/markdown/medical/spata7-related-disorders.md": [
		168939,
		9,
		168939
	],
	"./education-center/markdown/medical/spermatogenesis-maturation-arrest": [
		898647,
		9,
		898647
	],
	"./education-center/markdown/medical/spermatogenesis-maturation-arrest.md": [
		898647,
		9,
		898647
	],
	"./education-center/markdown/medical/spermatogenic-failure-2": [
		800237,
		9,
		800237
	],
	"./education-center/markdown/medical/spermatogenic-failure-2.md": [
		800237,
		9,
		800237
	],
	"./education-center/markdown/medical/spermatogenic-failure-x-linked-7": [
		271933,
		9,
		271933
	],
	"./education-center/markdown/medical/spermatogenic-failure-x-linked-7.md": [
		271933,
		9,
		271933
	],
	"./education-center/markdown/medical/spherocytosis": [
		949671,
		9,
		949671
	],
	"./education-center/markdown/medical/spherocytosis-dominant": [
		6873,
		9,
		6873
	],
	"./education-center/markdown/medical/spherocytosis-dominant.md": [
		6873,
		9,
		6873
	],
	"./education-center/markdown/medical/spherocytosis-recessive": [
		88503,
		9,
		88503
	],
	"./education-center/markdown/medical/spherocytosis-recessive.md": [
		88503,
		9,
		88503
	],
	"./education-center/markdown/medical/spherocytosis-type-1-autosomal-recessive": [
		483391,
		9,
		483391
	],
	"./education-center/markdown/medical/spherocytosis-type-1-autosomal-recessive.md": [
		483391,
		9,
		483391
	],
	"./education-center/markdown/medical/spherocytosis-type-3-autosomal-recessive": [
		861646,
		9,
		861646
	],
	"./education-center/markdown/medical/spherocytosis-type-3-autosomal-recessive.md": [
		861646,
		9,
		861646
	],
	"./education-center/markdown/medical/spherocytosis.md": [
		949671,
		9,
		949671
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy": [
		658420,
		9,
		658420
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy-dominant": [
		244729,
		9,
		244729
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy-dominant.md": [
		244729,
		9,
		244729
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy-lower-extremity-predominant-2-ad": [
		749645,
		9,
		749645
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy-lower-extremity-predominant-2-ad.md": [
		749645,
		9,
		749645
	],
	"./education-center/markdown/medical/spinal-muscular-atrophy.md": [
		658420,
		9,
		658420
	],
	"./education-center/markdown/medical/spinal-neurofibromas": [
		610609,
		9,
		610609
	],
	"./education-center/markdown/medical/spinal-neurofibromas.md": [
		610609,
		9,
		610609
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-29": [
		529345,
		9,
		529345
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-29.md": [
		529345,
		9,
		529345
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-31": [
		594230,
		9,
		594230
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-31.md": [
		594230,
		9,
		594230
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-34": [
		808689,
		9,
		808689
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-type-34.md": [
		808689,
		9,
		808689
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-x-linked": [
		541008,
		9,
		541008
	],
	"./education-center/markdown/medical/spinocerebellar-ataxia-x-linked.md": [
		541008,
		9,
		541008
	],
	"./education-center/markdown/medical/spinocerebellar-atrophy": [
		260207,
		9,
		260207
	],
	"./education-center/markdown/medical/spinocerebellar-atrophy.md": [
		260207,
		9,
		260207
	],
	"./education-center/markdown/medical/spondylocostal-dysostosis": [
		992803,
		9,
		992803
	],
	"./education-center/markdown/medical/spondylocostal-dysostosis-5": [
		597925,
		9,
		597925
	],
	"./education-center/markdown/medical/spondylocostal-dysostosis-5.md": [
		597925,
		9,
		597925
	],
	"./education-center/markdown/medical/spondylocostal-dysostosis.md": [
		992803,
		9,
		992803
	],
	"./education-center/markdown/medical/spondyloepimetaphyseal-dysplasia-joint-laxity-type-1-fractures": [
		418306,
		9,
		418306
	],
	"./education-center/markdown/medical/spondyloepimetaphyseal-dysplasia-joint-laxity-type-1-fractures.md": [
		418306,
		9,
		418306
	],
	"./education-center/markdown/medical/spondyloepiphyseal-dysplasia-congenital-joint-dislocations": [
		664686,
		9,
		664686
	],
	"./education-center/markdown/medical/spondyloepiphyseal-dysplasia-congenital-joint-dislocations.md": [
		664686,
		9,
		664686
	],
	"./education-center/markdown/medical/spontaneous-recurrent-epistaxis": [
		303751,
		9,
		303751
	],
	"./education-center/markdown/medical/spontaneous-recurrent-epistaxis.md": [
		303751,
		9,
		303751
	],
	"./education-center/markdown/medical/sporadic-abdominal-aortic-aneurysm": [
		602658,
		9,
		602658
	],
	"./education-center/markdown/medical/sporadic-abdominal-aortic-aneurysm.md": [
		602658,
		9,
		602658
	],
	"./education-center/markdown/medical/sprinting-performance": [
		968489,
		9,
		968489
	],
	"./education-center/markdown/medical/sprinting-performance.md": [
		968489,
		9,
		968489
	],
	"./education-center/markdown/medical/squamous-cell-carcinoma-burn-scar-related-somatic": [
		182471,
		9,
		182471
	],
	"./education-center/markdown/medical/squamous-cell-carcinoma-burn-scar-related-somatic.md": [
		182471,
		9,
		182471
	],
	"./education-center/markdown/medical/squamous-cell-lung-carcinoma": [
		764591,
		9,
		764591
	],
	"./education-center/markdown/medical/squamous-cell-lung-carcinoma.md": [
		764591,
		9,
		764591
	],
	"./education-center/markdown/medical/stargardt-disease-dominant": [
		85775,
		9,
		85775
	],
	"./education-center/markdown/medical/stargardt-disease-dominant.md": [
		85775,
		9,
		85775
	],
	"./education-center/markdown/medical/stargardt-disease-recessive": [
		161787,
		9,
		161787
	],
	"./education-center/markdown/medical/stargardt-disease-recessive.md": [
		161787,
		9,
		161787
	],
	"./education-center/markdown/medical/statins-attenuated-cholesterol-lowering": [
		64275,
		9,
		64275
	],
	"./education-center/markdown/medical/statins-attenuated-cholesterol-lowering.md": [
		64275,
		9,
		64275
	],
	"./education-center/markdown/medical/stickler-syndrome-dominant": [
		630930,
		9,
		630930
	],
	"./education-center/markdown/medical/stickler-syndrome-dominant.md": [
		630930,
		9,
		630930
	],
	"./education-center/markdown/medical/stickler-syndrome-recessive": [
		213703,
		9,
		213703
	],
	"./education-center/markdown/medical/stickler-syndrome-recessive.md": [
		213703,
		9,
		213703
	],
	"./education-center/markdown/medical/stickler-syndrome-type-1": [
		651424,
		9,
		651424
	],
	"./education-center/markdown/medical/stickler-syndrome-type-1.md": [
		651424,
		9,
		651424
	],
	"./education-center/markdown/medical/striatal-degeneration": [
		89098,
		9,
		89098
	],
	"./education-center/markdown/medical/striatal-degeneration.md": [
		89098,
		9,
		89098
	],
	"./education-center/markdown/medical/striatal-necrosis-bilateral-dystonia": [
		129058,
		9,
		129058
	],
	"./education-center/markdown/medical/striatal-necrosis-bilateral-dystonia.md": [
		129058,
		9,
		129058
	],
	"./education-center/markdown/medical/subcortical-laminar-heterotopia-x-linked": [
		901443,
		9,
		901443
	],
	"./education-center/markdown/medical/subcortical-laminar-heterotopia-x-linked.md": [
		901443,
		9,
		901443
	],
	"./education-center/markdown/medical/sublingual-nitroglycerin-susceptibility-poor-response": [
		302800,
		9,
		302800
	],
	"./education-center/markdown/medical/sublingual-nitroglycerin-susceptibility-poor-response.md": [
		302800,
		9,
		302800
	],
	"./education-center/markdown/medical/subvalvular-aortic-stenosis": [
		50317,
		9,
		50317
	],
	"./education-center/markdown/medical/subvalvular-aortic-stenosis.md": [
		50317,
		9,
		50317
	],
	"./education-center/markdown/medical/sudden-unexplained-death": [
		867099,
		9,
		867099
	],
	"./education-center/markdown/medical/sudden-unexplained-death-childhood": [
		81177,
		9,
		81177
	],
	"./education-center/markdown/medical/sudden-unexplained-death-childhood.md": [
		81177,
		9,
		81177
	],
	"./education-center/markdown/medical/sudden-unexplained-death.md": [
		867099,
		9,
		867099
	],
	"./education-center/markdown/medical/sulfate-transporter-related-osteochondrodysplasia": [
		652939,
		9,
		652939
	],
	"./education-center/markdown/medical/sulfate-transporter-related-osteochondrodysplasia.md": [
		652939,
		9,
		652939
	],
	"./education-center/markdown/medical/superoxide-dismutase-elevated-extracellular": [
		160216,
		9,
		160216
	],
	"./education-center/markdown/medical/superoxide-dismutase-elevated-extracellular.md": [
		160216,
		9,
		160216
	],
	"./education-center/markdown/medical/susceptibility-hangover": [
		752572,
		9,
		752572
	],
	"./education-center/markdown/medical/susceptibility-hangover.md": [
		752572,
		9,
		752572
	],
	"./education-center/markdown/medical/susceptibility-leprosy-and-multibacillary-leprosy": [
		215910,
		9,
		215910
	],
	"./education-center/markdown/medical/susceptibility-leprosy-and-multibacillary-leprosy.md": [
		215910,
		9,
		215910
	],
	"./education-center/markdown/medical/susceptibility-neovascular-type-age-related-macular-degeneration": [
		98904,
		9,
		98904
	],
	"./education-center/markdown/medical/susceptibility-neovascular-type-age-related-macular-degeneration.md": [
		98904,
		9,
		98904
	],
	"./education-center/markdown/medical/susceptibility-nonalcoholic-fatty-liver-disease": [
		309355,
		9,
		309355
	],
	"./education-center/markdown/medical/susceptibility-nonalcoholic-fatty-liver-disease.md": [
		309355,
		9,
		309355
	],
	"./education-center/markdown/medical/susceptibility-progression-renal-failure-iga-nephropathy": [
		524799,
		9,
		524799
	],
	"./education-center/markdown/medical/susceptibility-progression-renal-failure-iga-nephropathy.md": [
		524799,
		9,
		524799
	],
	"./education-center/markdown/medical/susceptibility-severe-cutaneous-adverse-reaction": [
		367451,
		9,
		367451
	],
	"./education-center/markdown/medical/susceptibility-severe-cutaneous-adverse-reaction.md": [
		367451,
		9,
		367451
	],
	"./education-center/markdown/medical/sweat-chloride-elevation-without-cystic-fibrosis": [
		715770,
		9,
		715770
	],
	"./education-center/markdown/medical/sweat-chloride-elevation-without-cystic-fibrosis.md": [
		715770,
		9,
		715770
	],
	"./education-center/markdown/medical/symmetrical-dyschromatosis-extremities": [
		221340,
		9,
		221340
	],
	"./education-center/markdown/medical/symmetrical-dyschromatosis-extremities.md": [
		221340,
		9,
		221340
	],
	"./education-center/markdown/medical/symphalangism-affecting-proximal-phalanx-4th-finger": [
		764384,
		9,
		764384
	],
	"./education-center/markdown/medical/symphalangism-affecting-proximal-phalanx-4th-finger.md": [
		764384,
		9,
		764384
	],
	"./education-center/markdown/medical/syndrome-entercolitis-and-autoinflmmation-caused-mutation-nlrc4-scan4": [
		546107,
		9,
		546107
	],
	"./education-center/markdown/medical/syndrome-entercolitis-and-autoinflmmation-caused-mutation-nlrc4-scan4.md": [
		546107,
		9,
		546107
	],
	"./education-center/markdown/medical/syndrome-microcephaly-major-feature": [
		387226,
		9,
		387226
	],
	"./education-center/markdown/medical/syndrome-microcephaly-major-feature.md": [
		387226,
		9,
		387226
	],
	"./education-center/markdown/medical/syndromic-intellectual-disability": [
		613461,
		9,
		613461
	],
	"./education-center/markdown/medical/syndromic-intellectual-disability.md": [
		613461,
		9,
		613461
	],
	"./education-center/markdown/medical/syndromic-microphthalmia-dominant": [
		552026,
		9,
		552026
	],
	"./education-center/markdown/medical/syndromic-microphthalmia-dominant.md": [
		552026,
		9,
		552026
	],
	"./education-center/markdown/medical/syndromic-microphthalmia-recessive": [
		332822,
		9,
		332822
	],
	"./education-center/markdown/medical/syndromic-microphthalmia-recessive.md": [
		332822,
		9,
		332822
	],
	"./education-center/markdown/medical/synovial-plica-syndrome": [
		577615,
		9,
		577615
	],
	"./education-center/markdown/medical/synovial-plica-syndrome.md": [
		577615,
		9,
		577615
	],
	"./education-center/markdown/medical/systemic-autoinflammation": [
		234085,
		9,
		234085
	],
	"./education-center/markdown/medical/systemic-autoinflammation.md": [
		234085,
		9,
		234085
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus": [
		420793,
		9,
		420793
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-association-susceptibility-10": [
		594616,
		9,
		879561
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-association-susceptibility-10.md": [
		594616,
		9,
		879561
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-resistance-1": [
		928316,
		9,
		928316
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-resistance-1.md": [
		928316,
		9,
		928316
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-susceptibility": [
		324800,
		9,
		324800
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus-susceptibility.md": [
		324800,
		9,
		324800
	],
	"./education-center/markdown/medical/systemic-lupus-erythematosus.md": [
		420793,
		9,
		420793
	],
	"./education-center/markdown/medical/systolic-heart-failure": [
		610130,
		9,
		610130
	],
	"./education-center/markdown/medical/systolic-heart-failure.md": [
		610130,
		9,
		610130
	],
	"./education-center/markdown/medical/tacrolimus-response": [
		507158,
		9,
		507158
	],
	"./education-center/markdown/medical/tacrolimus-response.md": [
		507158,
		9,
		507158
	],
	"./education-center/markdown/medical/tamoxifen-response": [
		339883,
		9,
		339883
	],
	"./education-center/markdown/medical/tamoxifen-response.md": [
		339883,
		9,
		339883
	],
	"./education-center/markdown/medical/tap1-deficiency-somatic": [
		258374,
		9,
		258374
	],
	"./education-center/markdown/medical/tap1-deficiency-somatic.md": [
		258374,
		9,
		258374
	],
	"./education-center/markdown/medical/tay-sachs-disease-juvenile": [
		954662,
		9,
		954662
	],
	"./education-center/markdown/medical/tay-sachs-disease-juvenile.md": [
		954662,
		9,
		954662
	],
	"./education-center/markdown/medical/tctn2-related-disorders": [
		588433,
		9,
		588433
	],
	"./education-center/markdown/medical/tctn2-related-disorders.md": [
		588433,
		9,
		588433
	],
	"./education-center/markdown/medical/tegafur-response": [
		239081,
		9,
		239081
	],
	"./education-center/markdown/medical/tegafur-response.md": [
		239081,
		9,
		239081
	],
	"./education-center/markdown/medical/telomere-length-mean-leukocyte": [
		614002,
		9,
		452776
	],
	"./education-center/markdown/medical/telomere-length-mean-leukocyte.md": [
		614002,
		9,
		452776
	],
	"./education-center/markdown/medical/teratoid-tumor-atypical": [
		32783,
		9,
		32783
	],
	"./education-center/markdown/medical/teratoid-tumor-atypical.md": [
		32783,
		9,
		32783
	],
	"./education-center/markdown/medical/testicular-atrophy": [
		790002,
		9,
		790002
	],
	"./education-center/markdown/medical/testicular-atrophy.md": [
		790002,
		9,
		790002
	],
	"./education-center/markdown/medical/thalassemia": [
		906053,
		9,
		906053
	],
	"./education-center/markdown/medical/thalassemia.md": [
		906053,
		9,
		906053
	],
	"./education-center/markdown/medical/thecoma-somatic": [
		54516,
		9,
		54516
	],
	"./education-center/markdown/medical/thecoma-somatic.md": [
		54516,
		9,
		54516
	],
	"./education-center/markdown/medical/thiamine-metabolism-dysfunction-syndrome": [
		593408,
		9,
		593408
	],
	"./education-center/markdown/medical/thiamine-metabolism-dysfunction-syndrome.md": [
		593408,
		9,
		593408
	],
	"./education-center/markdown/medical/thiamine-responsive-megaloblastic-anemia": [
		902241,
		9,
		902241
	],
	"./education-center/markdown/medical/thiamine-responsive-megaloblastic-anemia.md": [
		902241,
		9,
		902241
	],
	"./education-center/markdown/medical/thiopurine-response": [
		790148,
		9,
		790148
	],
	"./education-center/markdown/medical/thiopurine-response.md": [
		790148,
		9,
		790148
	],
	"./education-center/markdown/medical/thiopurines-poor-metabolism-2": [
		664136,
		9,
		664136
	],
	"./education-center/markdown/medical/thiopurines-poor-metabolism-2.md": [
		664136,
		9,
		664136
	],
	"./education-center/markdown/medical/third-degree-atrioventricular-block": [
		223748,
		9,
		223748
	],
	"./education-center/markdown/medical/third-degree-atrioventricular-block.md": [
		223748,
		9,
		223748
	],
	"./education-center/markdown/medical/thoracic-aortic-aneurysm": [
		28648,
		9,
		28648
	],
	"./education-center/markdown/medical/thoracic-aortic-aneurysm.md": [
		28648,
		9,
		28648
	],
	"./education-center/markdown/medical/three-vessel-coronary-disease": [
		588369,
		9,
		588369
	],
	"./education-center/markdown/medical/three-vessel-coronary-disease.md": [
		588369,
		9,
		588369
	],
	"./education-center/markdown/medical/thrombocythemia-2-somatic": [
		400959,
		9,
		400959
	],
	"./education-center/markdown/medical/thrombocythemia-2-somatic.md": [
		400959,
		9,
		400959
	],
	"./education-center/markdown/medical/thrombocytopenia-x-linked-intermittent": [
		242617,
		9,
		242617
	],
	"./education-center/markdown/medical/thrombocytopenia-x-linked-intermittent.md": [
		242617,
		9,
		242617
	],
	"./education-center/markdown/medical/thrombophilia-13-x-linked-due-factor-viii-defect": [
		927970,
		9,
		927970
	],
	"./education-center/markdown/medical/thrombophilia-13-x-linked-due-factor-viii-defect.md": [
		927970,
		9,
		927970
	],
	"./education-center/markdown/medical/thrombotic-stroke": [
		293254,
		9,
		293254
	],
	"./education-center/markdown/medical/thrombotic-stroke.md": [
		293254,
		9,
		293254
	],
	"./education-center/markdown/medical/thrombus": [
		132182,
		9,
		132182
	],
	"./education-center/markdown/medical/thrombus.md": [
		132182,
		9,
		132182
	],
	"./education-center/markdown/medical/thymoma": [
		796865,
		9,
		796865
	],
	"./education-center/markdown/medical/thymoma.md": [
		796865,
		9,
		796865
	],
	"./education-center/markdown/medical/thyroid-adenoma-hyperfunctioning": [
		862984,
		9,
		862984
	],
	"./education-center/markdown/medical/thyroid-adenoma-hyperfunctioning.md": [
		862984,
		9,
		862984
	],
	"./education-center/markdown/medical/thyroid-carcinoma-sporadic-medullary": [
		343969,
		9,
		343969
	],
	"./education-center/markdown/medical/thyroid-carcinoma-sporadic-medullary.md": [
		343969,
		9,
		343969
	],
	"./education-center/markdown/medical/thyroid-dyshormonogenesis": [
		845026,
		9,
		845026
	],
	"./education-center/markdown/medical/thyroid-dyshormonogenesis.md": [
		845026,
		9,
		845026
	],
	"./education-center/markdown/medical/thyroid-gland-undifferentiated-anaplastic-carcinoma": [
		343182,
		9,
		343182
	],
	"./education-center/markdown/medical/thyroid-gland-undifferentiated-anaplastic-carcinoma.md": [
		343182,
		9,
		343182
	],
	"./education-center/markdown/medical/thyroid-hormone-resistance-syndrome": [
		741520,
		9,
		741520
	],
	"./education-center/markdown/medical/thyroid-hormone-resistance-syndrome.md": [
		741520,
		9,
		741520
	],
	"./education-center/markdown/medical/thyroid-hormonogenesis-defect": [
		367754,
		9,
		367754
	],
	"./education-center/markdown/medical/thyroid-hormonogenesis-defect.md": [
		367754,
		9,
		367754
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-deficiency": [
		290065,
		9,
		290065
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-deficiency-partial": [
		483312,
		9,
		483312
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-deficiency-partial.md": [
		483312,
		9,
		483312
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-deficiency.md": [
		290065,
		9,
		290065
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-quantitative-trait-locus": [
		516487,
		9,
		516487
	],
	"./education-center/markdown/medical/thyroxine-binding-globulin-quantitative-trait-locus.md": [
		516487,
		9,
		516487
	],
	"./education-center/markdown/medical/tibial-pseudarthrosis": [
		287688,
		9,
		287688
	],
	"./education-center/markdown/medical/tibial-pseudarthrosis.md": [
		287688,
		9,
		287688
	],
	"./education-center/markdown/medical/tietz-syndrome": [
		586732,
		9,
		586732
	],
	"./education-center/markdown/medical/tietz-syndrome.md": [
		586732,
		9,
		586732
	],
	"./education-center/markdown/medical/tip-toe-gait": [
		903479,
		9,
		903479
	],
	"./education-center/markdown/medical/tip-toe-gait.md": [
		903479,
		9,
		903479
	],
	"./education-center/markdown/medical/tmem67-related-disorders": [
		590356,
		9,
		590356
	],
	"./education-center/markdown/medical/tmem67-related-disorders.md": [
		590356,
		9,
		590356
	],
	"./education-center/markdown/medical/tnf-receptor-associated-periodic-fever-syndrome-traps": [
		190235,
		9,
		190235
	],
	"./education-center/markdown/medical/tnf-receptor-associated-periodic-fever-syndrome-traps.md": [
		190235,
		9,
		190235
	],
	"./education-center/markdown/medical/tnf-receptor-binding-altered": [
		103421,
		9,
		103421
	],
	"./education-center/markdown/medical/tnf-receptor-binding-altered.md": [
		103421,
		9,
		103421
	],
	"./education-center/markdown/medical/tolbutamide-response": [
		88031,
		9,
		88031
	],
	"./education-center/markdown/medical/tolbutamide-response.md": [
		88031,
		9,
		88031
	],
	"./education-center/markdown/medical/tooth-agenesis": [
		518036,
		9,
		518036
	],
	"./education-center/markdown/medical/tooth-agenesis-selective-1": [
		552129,
		9,
		552129
	],
	"./education-center/markdown/medical/tooth-agenesis-selective-1.md": [
		552129,
		9,
		552129
	],
	"./education-center/markdown/medical/tooth-agenesis-selective-4": [
		597207,
		9,
		597207
	],
	"./education-center/markdown/medical/tooth-agenesis-selective-4.md": [
		597207,
		9,
		597207
	],
	"./education-center/markdown/medical/tooth-agenesis.md": [
		518036,
		9,
		518036
	],
	"./education-center/markdown/medical/torsion-dystonia-4": [
		32889,
		9,
		32889
	],
	"./education-center/markdown/medical/torsion-dystonia-4.md": [
		32889,
		9,
		32889
	],
	"./education-center/markdown/medical/tourette-syndrome": [
		811764,
		9,
		811764
	],
	"./education-center/markdown/medical/tourette-syndrome.md": [
		811764,
		9,
		811764
	],
	"./education-center/markdown/medical/townes-brocks-branchiootorenal-syndrome": [
		9647,
		9,
		9647
	],
	"./education-center/markdown/medical/townes-brocks-branchiootorenal-syndrome.md": [
		9647,
		9,
		9647
	],
	"./education-center/markdown/medical/townes-syndrome": [
		532207,
		9,
		532207
	],
	"./education-center/markdown/medical/townes-syndrome.md": [
		532207,
		9,
		532207
	],
	"./education-center/markdown/medical/tp63-related-spectrum-disorders": [
		630193,
		9,
		630193
	],
	"./education-center/markdown/medical/tp63-related-spectrum-disorders.md": [
		630193,
		9,
		630193
	],
	"./education-center/markdown/medical/tpm2-related-cap-myopathy": [
		44883,
		9,
		44883
	],
	"./education-center/markdown/medical/tpm2-related-cap-myopathy.md": [
		44883,
		9,
		44883
	],
	"./education-center/markdown/medical/tramadol-response": [
		624433,
		9,
		624433
	],
	"./education-center/markdown/medical/tramadol-response.md": [
		624433,
		9,
		624433
	],
	"./education-center/markdown/medical/transferrin-serum-level-quantitative-trait-locus-2": [
		954666,
		9,
		954666
	],
	"./education-center/markdown/medical/transferrin-serum-level-quantitative-trait-locus-2.md": [
		954666,
		9,
		954666
	],
	"./education-center/markdown/medical/transient-hyperlipidemia": [
		124809,
		9,
		124809
	],
	"./education-center/markdown/medical/transient-hyperlipidemia.md": [
		124809,
		9,
		124809
	],
	"./education-center/markdown/medical/transient-myeloproliferative-disorder-down-syndrome": [
		570875,
		9,
		570875
	],
	"./education-center/markdown/medical/transient-myeloproliferative-disorder-down-syndrome.md": [
		570875,
		9,
		570875
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-dominant": [
		618238,
		9,
		618238
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-dominant.md": [
		618238,
		9,
		618238
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-dominantrecessive": [
		542028,
		9,
		542028
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-dominantrecessive.md": [
		542028,
		9,
		542028
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-recessive": [
		835262,
		9,
		835262
	],
	"./education-center/markdown/medical/transient-neonatal-diabetes-recessive.md": [
		835262,
		9,
		835262
	],
	"./education-center/markdown/medical/transitional-cell-carcinoma-bladder": [
		701767,
		9,
		701767
	],
	"./education-center/markdown/medical/transitional-cell-carcinoma-bladder.md": [
		701767,
		9,
		701767
	],
	"./education-center/markdown/medical/transposition-great-arteries": [
		406497,
		9,
		406497
	],
	"./education-center/markdown/medical/transposition-great-arteries.md": [
		406497,
		9,
		406497
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-1": [
		711067,
		9,
		711067
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-1.md": [
		711067,
		9,
		711067
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-dominant": [
		948639,
		9,
		948639
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-dominant.md": [
		948639,
		9,
		948639
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-recessive": [
		971114,
		9,
		971114
	],
	"./education-center/markdown/medical/treacher-collins-syndrome-recessive.md": [
		971114,
		9,
		971114
	],
	"./education-center/markdown/medical/tretinoin-response": [
		466119,
		9,
		466119
	],
	"./education-center/markdown/medical/tretinoin-response.md": [
		466119,
		9,
		466119
	],
	"./education-center/markdown/medical/trichothiodystrophy-5-nonphotosensitive": [
		20737,
		9,
		20737
	],
	"./education-center/markdown/medical/trichothiodystrophy-5-nonphotosensitive.md": [
		20737,
		9,
		20737
	],
	"./education-center/markdown/medical/trichotillomania": [
		728260,
		9,
		728260
	],
	"./education-center/markdown/medical/trichotillomania.md": [
		728260,
		9,
		728260
	],
	"./education-center/markdown/medical/trifascicular-block-electrocardiogram": [
		343831,
		9,
		343831
	],
	"./education-center/markdown/medical/trifascicular-block-electrocardiogram.md": [
		343831,
		9,
		343831
	],
	"./education-center/markdown/medical/trigonocephaly": [
		437281,
		9,
		437281
	],
	"./education-center/markdown/medical/trigonocephaly.md": [
		437281,
		9,
		437281
	],
	"./education-center/markdown/medical/triosephosphate-isomerase-manchester": [
		735472,
		9,
		735472
	],
	"./education-center/markdown/medical/triosephosphate-isomerase-manchester.md": [
		735472,
		9,
		735472
	],
	"./education-center/markdown/medical/triphalangeal-thumb": [
		179578,
		9,
		179578
	],
	"./education-center/markdown/medical/triphalangeal-thumb.md": [
		179578,
		9,
		179578
	],
	"./education-center/markdown/medical/triple-negative-breast-cancer": [
		882338,
		9,
		882338
	],
	"./education-center/markdown/medical/triple-negative-breast-cancer-finding": [
		334409,
		9,
		334409
	],
	"./education-center/markdown/medical/triple-negative-breast-cancer-finding.md": [
		334409,
		9,
		334409
	],
	"./education-center/markdown/medical/triple-negative-breast-cancer.md": [
		882338,
		9,
		882338
	],
	"./education-center/markdown/medical/triple-negative-breast-carcinoma": [
		821397,
		9,
		821397
	],
	"./education-center/markdown/medical/triple-negative-breast-carcinoma.md": [
		821397,
		9,
		821397
	],
	"./education-center/markdown/medical/trit1-deficiency": [
		453230,
		9,
		453230
	],
	"./education-center/markdown/medical/trit1-deficiency.md": [
		453230,
		9,
		453230
	],
	"./education-center/markdown/medical/trpm4-related-disorders": [
		908126,
		9,
		908126
	],
	"./education-center/markdown/medical/trpm4-related-disorders.md": [
		908126,
		9,
		908126
	],
	"./education-center/markdown/medical/tryptophan-5-monooxygenase-deficiency": [
		655260,
		9,
		655260
	],
	"./education-center/markdown/medical/tryptophan-5-monooxygenase-deficiency.md": [
		655260,
		9,
		655260
	],
	"./education-center/markdown/medical/tuberculosis-susceptibility": [
		269528,
		9,
		269528
	],
	"./education-center/markdown/medical/tuberculosis-susceptibility.md": [
		269528,
		9,
		269528
	],
	"./education-center/markdown/medical/tuberous-sclerosis-and-lymphangiomyomatosis": [
		294031,
		9,
		294031
	],
	"./education-center/markdown/medical/tuberous-sclerosis-and-lymphangiomyomatosis.md": [
		294031,
		9,
		294031
	],
	"./education-center/markdown/medical/twist1-related-craniosynostosis": [
		43879,
		9,
		43879
	],
	"./education-center/markdown/medical/twist1-related-craniosynostosis.md": [
		43879,
		9,
		43879
	],
	"./education-center/markdown/medical/type-1-diabetes-mellitus-2": [
		119009,
		9,
		119009
	],
	"./education-center/markdown/medical/type-1-diabetes-mellitus-2.md": [
		119009,
		9,
		119009
	],
	"./education-center/markdown/medical/type-2-diabetes-mellitus-1-susceptibility": [
		536983,
		9,
		536983
	],
	"./education-center/markdown/medical/type-2-diabetes-mellitus-1-susceptibility.md": [
		536983,
		9,
		536983
	],
	"./education-center/markdown/medical/type-i-truncus-arteriosus": [
		156956,
		9,
		156956
	],
	"./education-center/markdown/medical/type-i-truncus-arteriosus.md": [
		156956,
		9,
		156956
	],
	"./education-center/markdown/medical/type-ii-collagenopathies": [
		897437,
		9,
		897437
	],
	"./education-center/markdown/medical/type-ii-collagenopathies.md": [
		897437,
		9,
		897437
	],
	"./education-center/markdown/medical/tyrosine-kinase-inhibitor-response": [
		202248,
		9,
		202248
	],
	"./education-center/markdown/medical/tyrosine-kinase-inhibitor-response.md": [
		202248,
		9,
		202248
	],
	"./education-center/markdown/medical/ullrich-congenital-muscular-dystrophy": [
		687473,
		9,
		687473
	],
	"./education-center/markdown/medical/ullrich-congenital-muscular-dystrophy-1-autosomal-dominant": [
		831317,
		9,
		831317
	],
	"./education-center/markdown/medical/ullrich-congenital-muscular-dystrophy-1-autosomal-dominant.md": [
		831317,
		9,
		831317
	],
	"./education-center/markdown/medical/ullrich-congenital-muscular-dystrophy.md": [
		687473,
		9,
		687473
	],
	"./education-center/markdown/medical/ulnar-deviation-wrist": [
		349655,
		9,
		349655
	],
	"./education-center/markdown/medical/ulnar-deviation-wrist.md": [
		349655,
		9,
		349655
	],
	"./education-center/markdown/medical/unilateral-deafness": [
		633080,
		9,
		633080
	],
	"./education-center/markdown/medical/unilateral-deafness.md": [
		633080,
		9,
		633080
	],
	"./education-center/markdown/medical/unilateral-microphthalmos": [
		491255,
		9,
		491255
	],
	"./education-center/markdown/medical/unilateral-microphthalmos.md": [
		491255,
		9,
		491255
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-1": [
		997428,
		9,
		997428
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-1.md": [
		997428,
		9,
		997428
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-2": [
		55105,
		9,
		55105
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-2.md": [
		55105,
		9,
		55105
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-4": [
		740057,
		9,
		740057
	],
	"./education-center/markdown/medical/uric-acid-concentration-serum-quantitative-trait-locus-4.md": [
		740057,
		9,
		740057
	],
	"./education-center/markdown/medical/ush2a-related-disorders": [
		193598,
		9,
		193598
	],
	"./education-center/markdown/medical/ush2a-related-disorders.md": [
		193598,
		9,
		193598
	],
	"./education-center/markdown/medical/usher-syndrome-type-idf-digenic": [
		16517,
		9,
		16517
	],
	"./education-center/markdown/medical/usher-syndrome-type-idf-digenic.md": [
		16517,
		9,
		16517
	],
	"./education-center/markdown/medical/usher-syndrome-type-iic-gpr98pdzd7-digenic": [
		737054,
		9,
		737054
	],
	"./education-center/markdown/medical/usher-syndrome-type-iic-gpr98pdzd7-digenic.md": [
		737054,
		9,
		737054
	],
	"./education-center/markdown/medical/uterine-carcinosarcoma": [
		611866,
		9,
		611866
	],
	"./education-center/markdown/medical/uterine-carcinosarcoma.md": [
		611866,
		9,
		611866
	],
	"./education-center/markdown/medical/uterine-corpus-cancer": [
		739972,
		9,
		739972
	],
	"./education-center/markdown/medical/uterine-corpus-cancer.md": [
		739972,
		9,
		739972
	],
	"./education-center/markdown/medical/uterine-leiomyoma": [
		623804,
		9,
		623804
	],
	"./education-center/markdown/medical/uterine-leiomyoma.md": [
		623804,
		9,
		623804
	],
	"./education-center/markdown/medical/uveal-coloboma-cleft-lip-and-palate-intellectual-disability": [
		712670,
		9,
		712670
	],
	"./education-center/markdown/medical/uveal-coloboma-cleft-lip-and-palate-intellectual-disability.md": [
		712670,
		9,
		712670
	],
	"./education-center/markdown/medical/uveal-melanoma": [
		177684,
		9,
		177684
	],
	"./education-center/markdown/medical/uveal-melanoma.md": [
		177684,
		9,
		177684
	],
	"./education-center/markdown/medical/vacterl-association": [
		196018,
		9,
		196018
	],
	"./education-center/markdown/medical/vacterl-association.md": [
		196018,
		9,
		196018
	],
	"./education-center/markdown/medical/van-der-woude-syndrome-1": [
		664441,
		9,
		664441
	],
	"./education-center/markdown/medical/van-der-woude-syndrome-1.md": [
		664441,
		9,
		664441
	],
	"./education-center/markdown/medical/variegate-porphyria-homozygous": [
		162032,
		9,
		162032
	],
	"./education-center/markdown/medical/variegate-porphyria-homozygous.md": [
		162032,
		9,
		162032
	],
	"./education-center/markdown/medical/vascular-dementia": [
		874444,
		9,
		874444
	],
	"./education-center/markdown/medical/vascular-dementia.md": [
		874444,
		9,
		874444
	],
	"./education-center/markdown/medical/vascular-endothelial-growth-factor-vegf-inhibitor-response": [
		145125,
		9,
		145125
	],
	"./education-center/markdown/medical/vascular-endothelial-growth-factor-vegf-inhibitor-response.md": [
		145125,
		9,
		145125
	],
	"./education-center/markdown/medical/vater-association-macrocephaly-and-ventriculomegaly": [
		493820,
		9,
		493820
	],
	"./education-center/markdown/medical/vater-association-macrocephaly-and-ventriculomegaly.md": [
		493820,
		9,
		493820
	],
	"./education-center/markdown/medical/vatervacterl-association-cns-malformations": [
		707582,
		9,
		707582
	],
	"./education-center/markdown/medical/vatervacterl-association-cns-malformations.md": [
		707582,
		9,
		707582
	],
	"./education-center/markdown/medical/vel-blood-group-system": [
		453161,
		9,
		453161
	],
	"./education-center/markdown/medical/vel-blood-group-system.md": [
		453161,
		9,
		453161
	],
	"./education-center/markdown/medical/venous-malformation": [
		430792,
		9,
		430792
	],
	"./education-center/markdown/medical/venous-malformation.md": [
		430792,
		9,
		430792
	],
	"./education-center/markdown/medical/venous-thromboembolism": [
		934003,
		9,
		934003
	],
	"./education-center/markdown/medical/venous-thromboembolism-susceptibility": [
		608533,
		9,
		608533
	],
	"./education-center/markdown/medical/venous-thromboembolism-susceptibility.md": [
		608533,
		9,
		608533
	],
	"./education-center/markdown/medical/venous-thromboembolism.md": [
		934003,
		9,
		934003
	],
	"./education-center/markdown/medical/venous-thrombosis-protection-against": [
		104351,
		9,
		104351
	],
	"./education-center/markdown/medical/venous-thrombosis-protection-against.md": [
		104351,
		9,
		104351
	],
	"./education-center/markdown/medical/venous-thrombosis-susceptibility": [
		297640,
		9,
		297640
	],
	"./education-center/markdown/medical/venous-thrombosis-susceptibility.md": [
		297640,
		9,
		297640
	],
	"./education-center/markdown/medical/ventricular-tachycardia-somatic": [
		147336,
		9,
		147336
	],
	"./education-center/markdown/medical/ventricular-tachycardia-somatic.md": [
		147336,
		9,
		147336
	],
	"./education-center/markdown/medical/ventriculomegaly": [
		855812,
		9,
		855812
	],
	"./education-center/markdown/medical/ventriculomegaly-and-arthrogryposis": [
		698632,
		9,
		698632
	],
	"./education-center/markdown/medical/ventriculomegaly-and-arthrogryposis.md": [
		698632,
		9,
		698632
	],
	"./education-center/markdown/medical/ventriculomegaly-cystic-kidney-disease": [
		464735,
		9,
		464735
	],
	"./education-center/markdown/medical/ventriculomegaly-cystic-kidney-disease.md": [
		464735,
		9,
		464735
	],
	"./education-center/markdown/medical/ventriculomegaly.md": [
		855812,
		9,
		855812
	],
	"./education-center/markdown/medical/very-long-chain-fatty-acid-accumulation": [
		618590,
		9,
		618590
	],
	"./education-center/markdown/medical/very-long-chain-fatty-acid-accumulation.md": [
		618590,
		9,
		618590
	],
	"./education-center/markdown/medical/vesicoureteral-reflux": [
		421997,
		9,
		421997
	],
	"./education-center/markdown/medical/vesicoureteral-reflux.md": [
		421997,
		9,
		421997
	],
	"./education-center/markdown/medical/vibratory-urticaria": [
		612646,
		9,
		612646
	],
	"./education-center/markdown/medical/vibratory-urticaria.md": [
		612646,
		9,
		612646
	],
	"./education-center/markdown/medical/virus-induced-diabetes": [
		832949,
		9,
		832949
	],
	"./education-center/markdown/medical/virus-induced-diabetes.md": [
		832949,
		9,
		832949
	],
	"./education-center/markdown/medical/vitamin-b12-plasma-level-quantitative-trait-locus-1": [
		61209,
		9,
		61209
	],
	"./education-center/markdown/medical/vitamin-b12-plasma-level-quantitative-trait-locus-1.md": [
		61209,
		9,
		61209
	],
	"./education-center/markdown/medical/vitamin-d-dependent-rickets-type-1": [
		640692,
		9,
		640692
	],
	"./education-center/markdown/medical/vitamin-d-dependent-rickets-type-1.md": [
		640692,
		9,
		640692
	],
	"./education-center/markdown/medical/vitamin-k-dependent-clotting-factors": [
		186083,
		9,
		186083
	],
	"./education-center/markdown/medical/vitamin-k-dependent-clotting-factors.md": [
		186083,
		9,
		186083
	],
	"./education-center/markdown/medical/vitelliform-macular-dystrophy": [
		963798,
		9,
		963798
	],
	"./education-center/markdown/medical/vitelliform-macular-dystrophy-2": [
		516733,
		9,
		516733
	],
	"./education-center/markdown/medical/vitelliform-macular-dystrophy-2.md": [
		516733,
		9,
		516733
	],
	"./education-center/markdown/medical/vitelliform-macular-dystrophy.md": [
		963798,
		9,
		963798
	],
	"./education-center/markdown/medical/vsx2-related-microphthalmia": [
		202088,
		9,
		202088
	],
	"./education-center/markdown/medical/vsx2-related-microphthalmia.md": [
		202088,
		9,
		202088
	],
	"./education-center/markdown/medical/vulvar-adenocarcinoma-mammary-gland-type": [
		12011,
		9,
		12011
	],
	"./education-center/markdown/medical/vulvar-adenocarcinoma-mammary-gland-type.md": [
		12011,
		9,
		12011
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2a": [
		775073,
		9,
		775073
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2a.md": [
		775073,
		9,
		775073
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2e-neurologic-involvement": [
		816390,
		9,
		816390
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2e-neurologic-involvement.md": [
		816390,
		9,
		816390
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2e-without-neurologic-involvement": [
		764762,
		9,
		764762
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-2e-without-neurologic-involvement.md": [
		764762,
		9,
		764762
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-3": [
		564227,
		9,
		564227
	],
	"./education-center/markdown/medical/waardenburg-syndrome-type-3.md": [
		564227,
		9,
		564227
	],
	"./education-center/markdown/medical/wagner-syndrome": [
		766922,
		9,
		766922
	],
	"./education-center/markdown/medical/wagner-syndrome.md": [
		766922,
		9,
		766922
	],
	"./education-center/markdown/medical/walker-warburg-congenital-muscular-dystrophy": [
		812092,
		9,
		812092
	],
	"./education-center/markdown/medical/walker-warburg-congenital-muscular-dystrophy.md": [
		812092,
		9,
		812092
	],
	"./education-center/markdown/medical/warfarin-response": [
		736829,
		9,
		736829
	],
	"./education-center/markdown/medical/warfarin-response-dosage": [
		927152,
		9,
		927152
	],
	"./education-center/markdown/medical/warfarin-response-dosage.md": [
		927152,
		9,
		927152
	],
	"./education-center/markdown/medical/warfarin-response-toxicityadr": [
		318901,
		9,
		318901
	],
	"./education-center/markdown/medical/warfarin-response-toxicityadr.md": [
		318901,
		9,
		318901
	],
	"./education-center/markdown/medical/warfarin-response.md": [
		736829,
		9,
		736829
	],
	"./education-center/markdown/medical/warfarin-sensitivity-x-linked": [
		16237,
		9,
		16237
	],
	"./education-center/markdown/medical/warfarin-sensitivity-x-linked.md": [
		16237,
		9,
		16237
	],
	"./education-center/markdown/medical/wdr1-deficiency": [
		542423,
		9,
		542423
	],
	"./education-center/markdown/medical/wdr1-deficiency.md": [
		542423,
		9,
		542423
	],
	"./education-center/markdown/medical/wdr35-related-disorders": [
		128503,
		9,
		128503
	],
	"./education-center/markdown/medical/wdr35-related-disorders.md": [
		128503,
		9,
		128503
	],
	"./education-center/markdown/medical/weakness-facial-musculature": [
		7939,
		9,
		7939
	],
	"./education-center/markdown/medical/weakness-facial-musculature.md": [
		7939,
		9,
		7939
	],
	"./education-center/markdown/medical/wee1-inhibitor-response": [
		772151,
		9,
		772151
	],
	"./education-center/markdown/medical/wee1-inhibitor-response.md": [
		772151,
		9,
		772151
	],
	"./education-center/markdown/medical/wfs1-related-spectrum-disorders": [
		183745,
		9,
		183745
	],
	"./education-center/markdown/medical/wfs1-related-spectrum-disorders.md": [
		183745,
		9,
		183745
	],
	"./education-center/markdown/medical/white-blood-cell-count-quantitative-trait-locus-1": [
		382987,
		9,
		382987
	],
	"./education-center/markdown/medical/white-blood-cell-count-quantitative-trait-locus-1.md": [
		382987,
		9,
		382987
	],
	"./education-center/markdown/medical/wieacker-wolff-syndrome": [
		683009,
		9,
		683009
	],
	"./education-center/markdown/medical/wieacker-wolff-syndrome.md": [
		683009,
		9,
		683009
	],
	"./education-center/markdown/medical/wolff-parkinson-white-syndrome-childhood-onset": [
		338641,
		9,
		338641
	],
	"./education-center/markdown/medical/wolff-parkinson-white-syndrome-childhood-onset.md": [
		338641,
		9,
		338641
	],
	"./education-center/markdown/medical/woolly-hair-autosomal-recessive-2-or-without-hypotrichosis": [
		655627,
		9,
		655627
	],
	"./education-center/markdown/medical/woolly-hair-autosomal-recessive-2-or-without-hypotrichosis.md": [
		655627,
		9,
		655627
	],
	"./education-center/markdown/medical/worth-disease": [
		268852,
		9,
		268852
	],
	"./education-center/markdown/medical/worth-disease.md": [
		268852,
		9,
		268852
	],
	"./education-center/markdown/medical/wt1-related-disorders": [
		229807,
		9,
		229807
	],
	"./education-center/markdown/medical/wt1-related-disorders.md": [
		229807,
		9,
		229807
	],
	"./education-center/markdown/medical/x-linked-intellectual-disability-cabezas-type": [
		376024,
		9,
		376024
	],
	"./education-center/markdown/medical/x-linked-intellectual-disability-cabezas-type.md": [
		376024,
		9,
		376024
	],
	"./education-center/markdown/medical/x-linked-retinitis-pigmentosa": [
		906694,
		9,
		906694
	],
	"./education-center/markdown/medical/x-linked-retinitis-pigmentosa.md": [
		906694,
		9,
		906694
	],
	"./education-center/markdown/medical/xanthinuria": [
		864794,
		9,
		864794
	],
	"./education-center/markdown/medical/xanthinuria-type-ii": [
		709475,
		9,
		709475
	],
	"./education-center/markdown/medical/xanthinuria-type-ii.md": [
		709475,
		9,
		709475
	],
	"./education-center/markdown/medical/xanthinuria.md": [
		864794,
		9,
		864794
	],
	"./education-center/markdown/medical/zmpste24-related-disorders": [
		19352,
		9,
		19352
	],
	"./education-center/markdown/medical/zmpste24-related-disorders.md": [
		19352,
		9,
		19352
	],
	"./education-center/markdown/medical/zonular-pulverulent-cataract": [
		228357,
		9,
		228357
	],
	"./education-center/markdown/medical/zonular-pulverulent-cataract.md": [
		228357,
		9,
		228357
	],
	"./education-center/markdown/medication-side-effects": [
		290018,
		9,
		290018
	],
	"./education-center/markdown/medication-side-effects/": [
		290018,
		9,
		290018
	],
	"./education-center/markdown/medication-side-effects/dna-tests-medication-side-effects": [
		85117,
		9,
		85117
	],
	"./education-center/markdown/medication-side-effects/dna-tests-medication-side-effects.md": [
		85117,
		9,
		85117
	],
	"./education-center/markdown/medication-side-effects/effects-medicine-body": [
		152717,
		9,
		152717
	],
	"./education-center/markdown/medication-side-effects/effects-medicine-body.md": [
		152717,
		9,
		152717
	],
	"./education-center/markdown/medication-side-effects/how-long-do-side-effects-last": [
		198739,
		9,
		198739
	],
	"./education-center/markdown/medication-side-effects/how-long-do-side-effects-last.md": [
		198739,
		9,
		198739
	],
	"./education-center/markdown/medication-side-effects/how-quickly-side-effects-happen": [
		357232,
		9,
		357232
	],
	"./education-center/markdown/medication-side-effects/how-quickly-side-effects-happen.md": [
		357232,
		9,
		357232
	],
	"./education-center/markdown/medication-side-effects/how-to-reduce-side-effects-medicine": [
		995955,
		9,
		995955
	],
	"./education-center/markdown/medication-side-effects/how-to-reduce-side-effects-medicine.md": [
		995955,
		9,
		995955
	],
	"./education-center/markdown/medication-side-effects/index": [
		290018,
		9,
		290018
	],
	"./education-center/markdown/medication-side-effects/index.md": [
		290018,
		9,
		290018
	],
	"./education-center/markdown/medication-side-effects/what-do-when-medicines-have-side-effects": [
		297296,
		9,
		297296
	],
	"./education-center/markdown/medication-side-effects/what-do-when-medicines-have-side-effects.md": [
		297296,
		9,
		297296
	],
	"./education-center/markdown/node/16272": [
		311675,
		9,
		311675
	],
	"./education-center/markdown/node/16272/": [
		311675,
		9,
		311675
	],
	"./education-center/markdown/node/16272/index": [
		311675,
		9,
		311675
	],
	"./education-center/markdown/node/16272/index.md": [
		311675,
		9,
		311675
	],
	"./education-center/markdown/outsmart-your-genes": [
		535934,
		9,
		535934
	],
	"./education-center/markdown/outsmart-your-genes/": [
		535934,
		9,
		535934
	],
	"./education-center/markdown/outsmart-your-genes/index": [
		535934,
		9,
		535934
	],
	"./education-center/markdown/outsmart-your-genes/index.md": [
		535934,
		9,
		535934
	],
	"./education-center/markdown/outsmart-your-genes/power-dna-testing-predictive-medicine": [
		201200,
		9,
		201200
	],
	"./education-center/markdown/outsmart-your-genes/power-dna-testing-predictive-medicine.md": [
		201200,
		9,
		201200
	],
	"./education-center/markdown/preventive-measures-breast-cancer": [
		947381,
		9,
		947381
	],
	"./education-center/markdown/preventive-measures-breast-cancer/": [
		947381,
		9,
		947381
	],
	"./education-center/markdown/preventive-measures-breast-cancer/breast-cancer-genetic-testing-cost": [
		496607,
		9,
		496607
	],
	"./education-center/markdown/preventive-measures-breast-cancer/breast-cancer-genetic-testing-cost.md": [
		496607,
		9,
		496607
	],
	"./education-center/markdown/preventive-measures-breast-cancer/breast-cancer-genetic-testing-pros-and-cons": [
		576454,
		9,
		576454
	],
	"./education-center/markdown/preventive-measures-breast-cancer/breast-cancer-genetic-testing-pros-and-cons.md": [
		576454,
		9,
		576454
	],
	"./education-center/markdown/preventive-measures-breast-cancer/dna-tests-breast-cancer-genetic-testing": [
		165273,
		9,
		165273
	],
	"./education-center/markdown/preventive-measures-breast-cancer/dna-tests-breast-cancer-genetic-testing.md": [
		165273,
		9,
		165273
	],
	"./education-center/markdown/preventive-measures-breast-cancer/genetic-testing-breast-cancer": [
		413754,
		9,
		413754
	],
	"./education-center/markdown/preventive-measures-breast-cancer/genetic-testing-breast-cancer.md": [
		413754,
		9,
		413754
	],
	"./education-center/markdown/preventive-measures-breast-cancer/home-genetic-testing-breast-cancer": [
		968665,
		9,
		968665
	],
	"./education-center/markdown/preventive-measures-breast-cancer/home-genetic-testing-breast-cancer.md": [
		968665,
		9,
		968665
	],
	"./education-center/markdown/preventive-measures-breast-cancer/index": [
		947381,
		9,
		947381
	],
	"./education-center/markdown/preventive-measures-breast-cancer/index.md": [
		947381,
		9,
		947381
	],
	"./education-center/markdown/sequencing": [
		692470,
		9,
		692470
	],
	"./education-center/markdown/sequencing-education-center/definitions": [
		10669,
		9,
		10669
	],
	"./education-center/markdown/sequencing-education-center/definitions/": [
		10669,
		9,
		10669
	],
	"./education-center/markdown/sequencing-education-center/definitions/index": [
		10669,
		9,
		10669
	],
	"./education-center/markdown/sequencing-education-center/definitions/index.md": [
		10669,
		9,
		10669
	],
	"./education-center/markdown/sequencing-education-center/genetic-testing-disease/genetic-screening-ehlers-danlos-syndrome-eds": [
		935142,
		9,
		935142
	],
	"./education-center/markdown/sequencing-education-center/genetic-testing-disease/genetic-screening-ehlers-danlos-syndrome-eds.md": [
		935142,
		9,
		935142
	],
	"./education-center/markdown/sequencing.md": [
		692470,
		9,
		692470
	],
	"./education-center/markdown/whole-genome-sequencing": [
		585436,
		9,
		585436
	],
	"./education-center/markdown/whole-genome-sequencing/": [
		585436,
		9,
		585436
	],
	"./education-center/markdown/whole-genome-sequencing/importance-whole-genome-sequencing": [
		259821,
		9,
		259821
	],
	"./education-center/markdown/whole-genome-sequencing/importance-whole-genome-sequencing.md": [
		259821,
		9,
		259821
	],
	"./education-center/markdown/whole-genome-sequencing/index": [
		585436,
		9,
		585436
	],
	"./education-center/markdown/whole-genome-sequencing/index.md": [
		585436,
		9,
		585436
	],
	"./education-center/markdown/whole-genome-sequencing/what-can-whole-genome-sequencing-detect": [
		795402,
		9,
		795402
	],
	"./education-center/markdown/whole-genome-sequencing/what-can-whole-genome-sequencing-detect.md": [
		795402,
		9,
		795402
	],
	"./education-center/markdown/whole-genome-sequencing/whole-genome-sequencing-cost": [
		863176,
		9,
		863176
	],
	"./education-center/markdown/whole-genome-sequencing/whole-genome-sequencing-cost.md": [
		863176,
		9,
		863176
	],
	"./education-center/markdown/whole-genome-sequencing/whole-genome-shotgun-sequencing": [
		368964,
		9,
		368964
	],
	"./education-center/markdown/whole-genome-sequencing/whole-genome-shotgun-sequencing.md": [
		368964,
		9,
		368964
	],
	"./education-center/structured-data": [
		557073,
		3,
		557073
	],
	"./education-center/structured-data/": [
		557073,
		3,
		557073
	],
	"./education-center/structured-data/coronavirus-and-dna": [
		362624,
		3,
		362624
	],
	"./education-center/structured-data/coronavirus-and-dna/": [
		362624,
		3,
		362624
	],
	"./education-center/structured-data/coronavirus-and-dna/blood-type-and-covid-infection-and-severity": [
		727573,
		3,
		727573
	],
	"./education-center/structured-data/coronavirus-and-dna/blood-type-and-covid-infection-and-severity.json": [
		727573,
		3,
		727573
	],
	"./education-center/structured-data/coronavirus-and-dna/coronavirus-treatment": [
		532081,
		3,
		532081
	],
	"./education-center/structured-data/coronavirus-and-dna/coronavirus-treatment.json": [
		532081,
		3,
		532081
	],
	"./education-center/structured-data/coronavirus-and-dna/index": [
		362624,
		3,
		362624
	],
	"./education-center/structured-data/coronavirus-and-dna/index.json": [
		362624,
		3,
		362624
	],
	"./education-center/structured-data/coronavirus-and-dna/where-can-i-get-my-blood-type-checked-free": [
		21487,
		3,
		21487
	],
	"./education-center/structured-data/coronavirus-and-dna/where-can-i-get-my-blood-type-checked-free.json": [
		21487,
		3,
		21487
	],
	"./education-center/structured-data/coronavirus-and-dna/your-dna-and-covid-19-risk": [
		532988,
		3,
		532988
	],
	"./education-center/structured-data/coronavirus-and-dna/your-dna-and-covid-19-risk.json": [
		532988,
		3,
		532988
	],
	"./education-center/structured-data/definitions/what-is-a-variant": [
		799630,
		3,
		799630
	],
	"./education-center/structured-data/definitions/what-is-a-variant.json": [
		799630,
		3,
		799630
	],
	"./education-center/structured-data/dna-101": [
		225822,
		3,
		225822
	],
	"./education-center/structured-data/dna-101/": [
		225822,
		3,
		225822
	],
	"./education-center/structured-data/dna-101/cost-of-whole-genome-sequencing": [
		237709,
		3,
		237709
	],
	"./education-center/structured-data/dna-101/cost-of-whole-genome-sequencing.json": [
		237709,
		3,
		237709
	],
	"./education-center/structured-data/dna-101/index": [
		225822,
		3,
		225822
	],
	"./education-center/structured-data/dna-101/index.json": [
		225822,
		3,
		225822
	],
	"./education-center/structured-data/dna-101/multi-factorial-disorders-role-genetics": [
		810816,
		3,
		810816
	],
	"./education-center/structured-data/dna-101/multi-factorial-disorders-role-genetics.json": [
		810816,
		3,
		810816
	],
	"./education-center/structured-data/dna-101/not-all-dna-products-are-created-equal": [
		214361,
		3,
		214361
	],
	"./education-center/structured-data/dna-101/not-all-dna-products-are-created-equal.json": [
		214361,
		3,
		214361
	],
	"./education-center/structured-data/dna-101/one-genome-technology": [
		386109,
		3,
		386109
	],
	"./education-center/structured-data/dna-101/one-genome-technology.json": [
		386109,
		3,
		386109
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds": [
		820480,
		3,
		820480
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/": [
		820480,
		3,
		820480
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/diagnosing-ehlers-danlos-syndrome-guide": [
		71051,
		3,
		71051
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/diagnosing-ehlers-danlos-syndrome-guide.json": [
		71051,
		3,
		71051
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/genetic-testing-ehlers-danlos-syndrome-eds": [
		127057,
		3,
		127057
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/genetic-testing-ehlers-danlos-syndrome-eds.json": [
		127057,
		3,
		127057
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/index": [
		820480,
		3,
		820480
	],
	"./education-center/structured-data/dna-101/understanding-ehlers-danlos-syndome-eds/index.json": [
		820480,
		3,
		820480
	],
	"./education-center/structured-data/dna-101/what-are-multifactorial-disorders": [
		680135,
		3,
		680135
	],
	"./education-center/structured-data/dna-101/what-are-multifactorial-disorders/": [
		680135,
		3,
		680135
	],
	"./education-center/structured-data/dna-101/what-are-multifactorial-disorders/index": [
		680135,
		3,
		680135
	],
	"./education-center/structured-data/dna-101/what-are-multifactorial-disorders/index.json": [
		680135,
		3,
		680135
	],
	"./education-center/structured-data/dna-101/what-can-you-learn-from-your-dna": [
		91775,
		3,
		91775
	],
	"./education-center/structured-data/dna-101/what-can-you-learn-from-your-dna/": [
		91775,
		3,
		91775
	],
	"./education-center/structured-data/dna-101/what-can-you-learn-from-your-dna/index": [
		91775,
		3,
		91775
	],
	"./education-center/structured-data/dna-101/what-can-you-learn-from-your-dna/index.json": [
		91775,
		3,
		91775
	],
	"./education-center/structured-data/dna-101/what-does-dna-stand-for": [
		386861,
		3,
		386861
	],
	"./education-center/structured-data/dna-101/what-does-dna-stand-for.json": [
		386861,
		3,
		386861
	],
	"./education-center/structured-data/dna-101/what-is-genetic-counseling": [
		822617,
		3,
		822617
	],
	"./education-center/structured-data/dna-101/what-is-genetic-counseling.json": [
		822617,
		3,
		822617
	],
	"./education-center/structured-data/dna-101/what-to-expect-when-you-get-your-whole-genome-sequenced": [
		955854,
		3,
		955854
	],
	"./education-center/structured-data/dna-101/what-to-expect-when-you-get-your-whole-genome-sequenced.json": [
		955854,
		3,
		955854
	],
	"./education-center/structured-data/dna-and-adoption": [
		489119,
		3,
		489119
	],
	"./education-center/structured-data/dna-and-adoption/": [
		489119,
		3,
		489119
	],
	"./education-center/structured-data/dna-and-adoption/best-dna-test-adoptees": [
		434053,
		3,
		434053
	],
	"./education-center/structured-data/dna-and-adoption/best-dna-test-adoptees.json": [
		434053,
		3,
		434053
	],
	"./education-center/structured-data/dna-and-adoption/finding-adopted-child-online": [
		718787,
		3,
		718787
	],
	"./education-center/structured-data/dna-and-adoption/finding-adopted-child-online.json": [
		718787,
		3,
		718787
	],
	"./education-center/structured-data/dna-and-adoption/finding-adopted-sibling": [
		821994,
		3,
		821994
	],
	"./education-center/structured-data/dna-and-adoption/finding-adopted-sibling.json": [
		821994,
		3,
		821994
	],
	"./education-center/structured-data/dna-and-adoption/how-find-biological-father-through-dna": [
		852794,
		3,
		852794
	],
	"./education-center/structured-data/dna-and-adoption/how-find-biological-father-through-dna.json": [
		852794,
		3,
		852794
	],
	"./education-center/structured-data/dna-and-adoption/index": [
		489119,
		3,
		489119
	],
	"./education-center/structured-data/dna-and-adoption/index.json": [
		489119,
		3,
		489119
	],
	"./education-center/structured-data/fastest-expedited-sequencing": [
		23429,
		3,
		23429
	],
	"./education-center/structured-data/fastest-expedited-sequencing.json": [
		23429,
		3,
		23429
	],
	"./education-center/structured-data/free-dna-upload-sites": [
		992934,
		3,
		992934
	],
	"./education-center/structured-data/free-dna-upload-sites/": [
		992934,
		3,
		992934
	],
	"./education-center/structured-data/free-dna-upload-sites/23andme-upload-data-tool": [
		818847,
		3,
		818847
	],
	"./education-center/structured-data/free-dna-upload-sites/23andme-upload-data-tool.json": [
		818847,
		3,
		818847
	],
	"./education-center/structured-data/free-dna-upload-sites/gedmatch-dna-upload-instructions": [
		813973,
		3,
		813973
	],
	"./education-center/structured-data/free-dna-upload-sites/gedmatch-dna-upload-instructions.json": [
		813973,
		3,
		813973
	],
	"./education-center/structured-data/free-dna-upload-sites/index": [
		992934,
		3,
		992934
	],
	"./education-center/structured-data/free-dna-upload-sites/index.json": [
		992934,
		3,
		992934
	],
	"./education-center/structured-data/free-dna-upload-sites/living-dna-upload": [
		244088,
		3,
		244088
	],
	"./education-center/structured-data/free-dna-upload-sites/living-dna-upload.json": [
		244088,
		3,
		244088
	],
	"./education-center/structured-data/free-dna-upload-sites/myheritage-dna-upload": [
		755469,
		3,
		755469
	],
	"./education-center/structured-data/free-dna-upload-sites/myheritage-dna-upload.json": [
		755469,
		3,
		755469
	],
	"./education-center/structured-data/free-dna-upload-sites/national-geographic-dna-upload-raw-data": [
		944822,
		3,
		944822
	],
	"./education-center/structured-data/free-dna-upload-sites/national-geographic-dna-upload-raw-data.json": [
		944822,
		3,
		944822
	],
	"./education-center/structured-data/free-dna-upload-sites/promethease-dna-upload": [
		772541,
		3,
		772541
	],
	"./education-center/structured-data/free-dna-upload-sites/promethease-dna-upload.json": [
		772541,
		3,
		772541
	],
	"./education-center/structured-data/free-dna-upload-sites/upload-dna-ancestry": [
		317157,
		3,
		317157
	],
	"./education-center/structured-data/free-dna-upload-sites/upload-dna-ancestry.json": [
		317157,
		3,
		317157
	],
	"./education-center/structured-data/genetic-genealogy": [
		996526,
		3,
		996526
	],
	"./education-center/structured-data/genetic-genealogy/": [
		996526,
		3,
		996526
	],
	"./education-center/structured-data/genetic-genealogy/ancestry-dna-test": [
		837436,
		3,
		837436
	],
	"./education-center/structured-data/genetic-genealogy/ancestry-dna-test.json": [
		837436,
		3,
		837436
	],
	"./education-center/structured-data/genetic-genealogy/dna-genealogy": [
		420840,
		3,
		420840
	],
	"./education-center/structured-data/genetic-genealogy/dna-genealogy.json": [
		420840,
		3,
		420840
	],
	"./education-center/structured-data/genetic-genealogy/index": [
		996526,
		3,
		996526
	],
	"./education-center/structured-data/genetic-genealogy/index.json": [
		996526,
		3,
		996526
	],
	"./education-center/structured-data/genetic-genealogy/myheritage-dna-test": [
		530057,
		3,
		530057
	],
	"./education-center/structured-data/genetic-genealogy/myheritage-dna-test.json": [
		530057,
		3,
		530057
	],
	"./education-center/structured-data/genetic-genealogy/what-is-genealogy": [
		625045,
		3,
		625045
	],
	"./education-center/structured-data/genetic-genealogy/what-is-genealogy.json": [
		625045,
		3,
		625045
	],
	"./education-center/structured-data/genetic-testing-baby": [
		498963,
		3,
		498963
	],
	"./education-center/structured-data/genetic-testing-baby/": [
		498963,
		3,
		498963
	],
	"./education-center/structured-data/genetic-testing-baby/carrier-screening": [
		915076,
		3,
		915076
	],
	"./education-center/structured-data/genetic-testing-baby/carrier-screening.json": [
		915076,
		3,
		915076
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-diseases-in-children": [
		101943,
		3,
		101943
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-diseases-in-children.json": [
		101943,
		3,
		101943
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-down-syndrome": [
		722471,
		3,
		722471
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-down-syndrome.json": [
		722471,
		3,
		722471
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-during-pregnancy": [
		367376,
		3,
		367376
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-during-pregnancy.json": [
		367376,
		3,
		367376
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-for-autism": [
		446058,
		3,
		446058
	],
	"./education-center/structured-data/genetic-testing-baby/genetic-testing-for-autism.json": [
		446058,
		3,
		446058
	],
	"./education-center/structured-data/genetic-testing-baby/index": [
		498963,
		3,
		498963
	],
	"./education-center/structured-data/genetic-testing-baby/index.json": [
		498963,
		3,
		498963
	],
	"./education-center/structured-data/genetic-testing-for-diseases": [
		970686,
		3,
		970686
	],
	"./education-center/structured-data/genetic-testing-for-diseases/": [
		970686,
		3,
		970686
	],
	"./education-center/structured-data/genetic-testing-for-diseases/cystic-fibrosis-gene-test": [
		331693,
		3,
		331693
	],
	"./education-center/structured-data/genetic-testing-for-diseases/cystic-fibrosis-gene-test.json": [
		331693,
		3,
		331693
	],
	"./education-center/structured-data/genetic-testing-for-diseases/how-choose-dna-test-diseases": [
		196155,
		3,
		196155
	],
	"./education-center/structured-data/genetic-testing-for-diseases/how-choose-dna-test-diseases.json": [
		196155,
		3,
		196155
	],
	"./education-center/structured-data/genetic-testing-for-diseases/index": [
		970686,
		3,
		970686
	],
	"./education-center/structured-data/genetic-testing-for-diseases/index.json": [
		970686,
		3,
		970686
	],
	"./education-center/structured-data/genetic-testing-for-diseases/what-diseases-can-be-detected-through-genetic-testing": [
		303082,
		3,
		303082
	],
	"./education-center/structured-data/genetic-testing-for-diseases/what-diseases-can-be-detected-through-genetic-testing.json": [
		303082,
		3,
		303082
	],
	"./education-center/structured-data/genetic-testing-for-diseases/what-is-a-genetic-disease": [
		364568,
		3,
		364568
	],
	"./education-center/structured-data/genetic-testing-for-diseases/what-is-a-genetic-disease.json": [
		364568,
		3,
		364568
	],
	"./education-center/structured-data/genetic-testing-weight-loss": [
		258762,
		3,
		258762
	],
	"./education-center/structured-data/genetic-testing-weight-loss/": [
		258762,
		3,
		258762
	],
	"./education-center/structured-data/genetic-testing-weight-loss/dna-testing-weight-loss-diets": [
		785716,
		3,
		785716
	],
	"./education-center/structured-data/genetic-testing-weight-loss/dna-testing-weight-loss-diets.json": [
		785716,
		3,
		785716
	],
	"./education-center/structured-data/genetic-testing-weight-loss/does-dna-work-weight-loss": [
		657535,
		3,
		657535
	],
	"./education-center/structured-data/genetic-testing-weight-loss/does-dna-work-weight-loss.json": [
		657535,
		3,
		657535
	],
	"./education-center/structured-data/genetic-testing-weight-loss/index": [
		258762,
		3,
		258762
	],
	"./education-center/structured-data/genetic-testing-weight-loss/index.json": [
		258762,
		3,
		258762
	],
	"./education-center/structured-data/genetic-testing-weight-loss/weight-loss-dna-tests": [
		418257,
		3,
		418257
	],
	"./education-center/structured-data/genetic-testing-weight-loss/weight-loss-dna-tests.json": [
		418257,
		3,
		418257
	],
	"./education-center/structured-data/genetic-testing/breast-cancer": [
		707824,
		3,
		707824
	],
	"./education-center/structured-data/genetic-testing/breast-cancer.json": [
		707824,
		3,
		707824
	],
	"./education-center/structured-data/genetic-testing/hair-loss": [
		423186,
		3,
		423186
	],
	"./education-center/structured-data/genetic-testing/hair-loss.json": [
		423186,
		3,
		423186
	],
	"./education-center/structured-data/guide-dna-tests": [
		320242,
		3,
		320242
	],
	"./education-center/structured-data/guide-dna-tests/": [
		320242,
		3,
		320242
	],
	"./education-center/structured-data/guide-dna-tests/dna-report-look-like": [
		665086,
		3,
		665086
	],
	"./education-center/structured-data/guide-dna-tests/dna-report-look-like.json": [
		665086,
		3,
		665086
	],
	"./education-center/structured-data/guide-dna-tests/how-accurate-are-dna-tests": [
		461069,
		3,
		461069
	],
	"./education-center/structured-data/guide-dna-tests/how-accurate-are-dna-tests.json": [
		461069,
		3,
		461069
	],
	"./education-center/structured-data/guide-dna-tests/how-does-dna-testing-work": [
		788434,
		3,
		788434
	],
	"./education-center/structured-data/guide-dna-tests/how-does-dna-testing-work.json": [
		788434,
		3,
		788434
	],
	"./education-center/structured-data/guide-dna-tests/index": [
		320242,
		3,
		320242
	],
	"./education-center/structured-data/guide-dna-tests/index.json": [
		320242,
		3,
		320242
	],
	"./education-center/structured-data/guide-dna-tests/what-is-a-dna-test": [
		765301,
		3,
		765301
	],
	"./education-center/structured-data/guide-dna-tests/what-is-a-dna-test.json": [
		765301,
		3,
		765301
	],
	"./education-center/structured-data/how-prevent-alzheimers/natural-ways-prevent-alzheimers": [
		52981,
		3,
		52981
	],
	"./education-center/structured-data/how-prevent-alzheimers/natural-ways-prevent-alzheimers.json": [
		52981,
		3,
		52981
	],
	"./education-center/structured-data/how-prevent-alzheimers/ways-prevent-alzheimers": [
		230101,
		3,
		230101
	],
	"./education-center/structured-data/how-prevent-alzheimers/ways-prevent-alzheimers.json": [
		230101,
		3,
		230101
	],
	"./education-center/structured-data/how-to-prevent-alzheimers": [
		546604,
		3,
		546604
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/": [
		546604,
		3,
		546604
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/genetic-testing-alzheimers": [
		433808,
		3,
		433808
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/genetic-testing-alzheimers.json": [
		433808,
		3,
		433808
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/index": [
		546604,
		3,
		546604
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/index.json": [
		546604,
		3,
		546604
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/medications-prevent-alzheimers": [
		921285,
		3,
		921285
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/medications-prevent-alzheimers.json": [
		921285,
		3,
		921285
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/risk-factors-alzheimers-disease": [
		3081,
		3,
		3081
	],
	"./education-center/structured-data/how-to-prevent-alzheimers/risk-factors-alzheimers-disease.json": [
		3081,
		3,
		3081
	],
	"./education-center/structured-data/index": [
		557073,
		3,
		557073
	],
	"./education-center/structured-data/index.json": [
		557073,
		3,
		557073
	],
	"./education-center/structured-data/medical/11q-partial-monosomy-syndrome": [
		509074,
		3,
		509074
	],
	"./education-center/structured-data/medical/11q-partial-monosomy-syndrome.json": [
		509074,
		3,
		509074
	],
	"./education-center/structured-data/medical/3-m-syndrome": [
		382380,
		3,
		382380
	],
	"./education-center/structured-data/medical/3-m-syndrome.json": [
		382380,
		3,
		382380
	],
	"./education-center/structured-data/medical/3-oxo-5-alpha-steroid-delta-4-dehydrogenase-deficiency": [
		830185,
		3,
		830185
	],
	"./education-center/structured-data/medical/3-oxo-5-alpha-steroid-delta-4-dehydrogenase-deficiency.json": [
		830185,
		3,
		830185
	],
	"./education-center/structured-data/medical/46xy-disorder-sex-development-due-testicular-1720-desmolase-deficiency": [
		772579,
		3,
		772579
	],
	"./education-center/structured-data/medical/46xy-disorder-sex-development-due-testicular-1720-desmolase-deficiency.json": [
		772579,
		3,
		772579
	],
	"./education-center/structured-data/medical/46xy-dsd46xy-cgd": [
		752626,
		3,
		752626
	],
	"./education-center/structured-data/medical/46xy-dsd46xy-cgd.json": [
		752626,
		3,
		752626
	],
	"./education-center/structured-data/medical/46xy-sex-reversal-4": [
		877395,
		3,
		877395
	],
	"./education-center/structured-data/medical/46xy-sex-reversal-4.json": [
		877395,
		3,
		877395
	],
	"./education-center/structured-data/medical/abacavir-hypersensitivity": [
		930788,
		3,
		930788
	],
	"./education-center/structured-data/medical/abacavir-hypersensitivity.json": [
		930788,
		3,
		930788
	],
	"./education-center/structured-data/medical/abca1-polymorphism": [
		440371,
		3,
		440371
	],
	"./education-center/structured-data/medical/abca1-polymorphism.json": [
		440371,
		3,
		440371
	],
	"./education-center/structured-data/medical/abca1-related-disorders": [
		442943,
		3,
		442943
	],
	"./education-center/structured-data/medical/abca1-related-disorders.json": [
		442943,
		3,
		442943
	],
	"./education-center/structured-data/medical/abca4-related-disorders": [
		939902,
		3,
		939902
	],
	"./education-center/structured-data/medical/abca4-related-disorders.json": [
		939902,
		3,
		939902
	],
	"./education-center/structured-data/medical/abcb4-related-intrahepatic-cholestasis": [
		941198,
		3,
		941198
	],
	"./education-center/structured-data/medical/abcb4-related-intrahepatic-cholestasis.json": [
		941198,
		3,
		941198
	],
	"./education-center/structured-data/medical/abcd-syndrome": [
		484333,
		3,
		484333
	],
	"./education-center/structured-data/medical/abcd-syndrome.json": [
		484333,
		3,
		484333
	],
	"./education-center/structured-data/medical/abnormal-activity-mitochondrial-respiratory-chain": [
		782594,
		3,
		782594
	],
	"./education-center/structured-data/medical/abnormal-activity-mitochondrial-respiratory-chain.json": [
		782594,
		3,
		782594
	],
	"./education-center/structured-data/medical/abnormal-anterior-chamber-morphology": [
		866365,
		3,
		866365
	],
	"./education-center/structured-data/medical/abnormal-anterior-chamber-morphology.json": [
		866365,
		3,
		866365
	],
	"./education-center/structured-data/medical/abnormal-anterior-eye-segment-morphology": [
		251577,
		3,
		251577
	],
	"./education-center/structured-data/medical/abnormal-anterior-eye-segment-morphology.json": [
		251577,
		3,
		251577
	],
	"./education-center/structured-data/medical/abnormal-aortic-valve-morphology": [
		751521,
		3,
		751521
	],
	"./education-center/structured-data/medical/abnormal-aortic-valve-morphology.json": [
		751521,
		3,
		751521
	],
	"./education-center/structured-data/medical/abnormal-aortic-valve-physiology": [
		530327,
		3,
		530327
	],
	"./education-center/structured-data/medical/abnormal-aortic-valve-physiology.json": [
		530327,
		3,
		530327
	],
	"./education-center/structured-data/medical/abnormal-bleeding": [
		254433,
		3,
		254433
	],
	"./education-center/structured-data/medical/abnormal-bleeding.json": [
		254433,
		3,
		254433
	],
	"./education-center/structured-data/medical/abnormal-blistering-skin": [
		701319,
		3,
		701319
	],
	"./education-center/structured-data/medical/abnormal-blistering-skin.json": [
		701319,
		3,
		701319
	],
	"./education-center/structured-data/medical/abnormal-bone-structure": [
		670107,
		3,
		670107
	],
	"./education-center/structured-data/medical/abnormal-bone-structure.json": [
		670107,
		3,
		670107
	],
	"./education-center/structured-data/medical/abnormal-cardiac-atrium-morphology": [
		306157,
		3,
		306157
	],
	"./education-center/structured-data/medical/abnormal-cardiac-atrium-morphology.json": [
		306157,
		3,
		306157
	],
	"./education-center/structured-data/medical/abnormal-cartilage-collagen": [
		544192,
		3,
		544192
	],
	"./education-center/structured-data/medical/abnormal-cartilage-collagen.json": [
		544192,
		3,
		544192
	],
	"./education-center/structured-data/medical/abnormal-central-motor-function": [
		927261,
		3,
		927261
	],
	"./education-center/structured-data/medical/abnormal-central-motor-function.json": [
		927261,
		3,
		927261
	],
	"./education-center/structured-data/medical/abnormal-cerebellar-vermis-morphology": [
		455069,
		3,
		455069
	],
	"./education-center/structured-data/medical/abnormal-cerebellar-vermis-morphology.json": [
		455069,
		3,
		455069
	],
	"./education-center/structured-data/medical/abnormal-cerebral-morphology": [
		455440,
		3,
		455440
	],
	"./education-center/structured-data/medical/abnormal-cerebral-morphology.json": [
		455440,
		3,
		455440
	],
	"./education-center/structured-data/medical/abnormal-circulating-carbohydrate-concentration": [
		515659,
		3,
		515659
	],
	"./education-center/structured-data/medical/abnormal-circulating-carbohydrate-concentration.json": [
		515659,
		3,
		515659
	],
	"./education-center/structured-data/medical/abnormal-circulating-glucose-6-phosphate-dehydrogenase-concentration": [
		615425,
		3,
		615425
	],
	"./education-center/structured-data/medical/abnormal-circulating-glucose-6-phosphate-dehydrogenase-concentration.json": [
		615425,
		3,
		615425
	],
	"./education-center/structured-data/medical/abnormal-circulating-lipid-concentration": [
		968682,
		3,
		968682
	],
	"./education-center/structured-data/medical/abnormal-circulating-lipid-concentration.json": [
		968682,
		3,
		968682
	],
	"./education-center/structured-data/medical/abnormal-circulating-porphyrin-concentration": [
		369595,
		3,
		369595
	],
	"./education-center/structured-data/medical/abnormal-circulating-porphyrin-concentration.json": [
		369595,
		3,
		369595
	],
	"./education-center/structured-data/medical/abnormal-circulating-thyroid-hormone-concentration": [
		455573,
		3,
		455573
	],
	"./education-center/structured-data/medical/abnormal-circulating-thyroid-hormone-concentration.json": [
		455573,
		3,
		455573
	],
	"./education-center/structured-data/medical/abnormal-corpus-callosum-morphology": [
		568348,
		3,
		568348
	],
	"./education-center/structured-data/medical/abnormal-corpus-callosum-morphology.json": [
		568348,
		3,
		568348
	],
	"./education-center/structured-data/medical/abnormal-cortical-gyration": [
		822176,
		3,
		822176
	],
	"./education-center/structured-data/medical/abnormal-cortical-gyration.json": [
		822176,
		3,
		822176
	],
	"./education-center/structured-data/medical/abnormal-facial-shape": [
		780184,
		3,
		780184
	],
	"./education-center/structured-data/medical/abnormal-facial-shape.json": [
		780184,
		3,
		780184
	],
	"./education-center/structured-data/medical/abnormal-finger-morphology": [
		257511,
		3,
		257511
	],
	"./education-center/structured-data/medical/abnormal-finger-morphology.json": [
		257511,
		3,
		257511
	],
	"./education-center/structured-data/medical/abnormal-hemoglobin": [
		593687,
		3,
		593687
	],
	"./education-center/structured-data/medical/abnormal-hemoglobin.json": [
		593687,
		3,
		593687
	],
	"./education-center/structured-data/medical/abnormal-immunoglobulin-level": [
		728767,
		3,
		728767
	],
	"./education-center/structured-data/medical/abnormal-immunoglobulin-level.json": [
		728767,
		3,
		728767
	],
	"./education-center/structured-data/medical/abnormal-intrahepatic-bile-duct-morphology": [
		880327,
		3,
		880327
	],
	"./education-center/structured-data/medical/abnormal-intrahepatic-bile-duct-morphology.json": [
		880327,
		3,
		880327
	],
	"./education-center/structured-data/medical/abnormal-lactate-dehydrogenase-level": [
		481314,
		3,
		481314
	],
	"./education-center/structured-data/medical/abnormal-lactate-dehydrogenase-level.json": [
		481314,
		3,
		481314
	],
	"./education-center/structured-data/medical/abnormal-mitral-valve-physiology": [
		540061,
		3,
		540061
	],
	"./education-center/structured-data/medical/abnormal-mitral-valve-physiology.json": [
		540061,
		3,
		540061
	],
	"./education-center/structured-data/medical/abnormal-platelet-aggregation": [
		883855,
		3,
		883855
	],
	"./education-center/structured-data/medical/abnormal-platelet-aggregation.json": [
		883855,
		3,
		883855
	],
	"./education-center/structured-data/medical/abnormal-platelet-function": [
		130940,
		3,
		130940
	],
	"./education-center/structured-data/medical/abnormal-platelet-function.json": [
		130940,
		3,
		130940
	],
	"./education-center/structured-data/medical/abnormal-protein-o-linked-glycosylation": [
		756246,
		3,
		756246
	],
	"./education-center/structured-data/medical/abnormal-protein-o-linked-glycosylation.json": [
		756246,
		3,
		756246
	],
	"./education-center/structured-data/medical/abnormal-pyramidal-sign": [
		776051,
		3,
		776051
	],
	"./education-center/structured-data/medical/abnormal-pyramidal-sign.json": [
		776051,
		3,
		776051
	],
	"./education-center/structured-data/medical/abnormal-radial-ray-morphology": [
		168095,
		3,
		168095
	],
	"./education-center/structured-data/medical/abnormal-radial-ray-morphology.json": [
		168095,
		3,
		168095
	],
	"./education-center/structured-data/medical/abnormal-sperm-tail-morphology": [
		753627,
		3,
		753627
	],
	"./education-center/structured-data/medical/abnormal-sperm-tail-morphology.json": [
		753627,
		3,
		753627
	],
	"./education-center/structured-data/medical/abnormal-spermatogenesis": [
		400416,
		3,
		400416
	],
	"./education-center/structured-data/medical/abnormal-spermatogenesis.json": [
		400416,
		3,
		400416
	],
	"./education-center/structured-data/medical/abnormal-synaptic-transmission": [
		381363,
		3,
		381363
	],
	"./education-center/structured-data/medical/abnormal-synaptic-transmission.json": [
		381363,
		3,
		381363
	],
	"./education-center/structured-data/medical/abnormality-blood-and-blood-forming-tissues": [
		994459,
		3,
		994459
	],
	"./education-center/structured-data/medical/abnormality-blood-and-blood-forming-tissues.json": [
		994459,
		3,
		994459
	],
	"./education-center/structured-data/medical/abnormality-bone-mineral-density": [
		331537,
		3,
		331537
	],
	"./education-center/structured-data/medical/abnormality-bone-mineral-density.json": [
		331537,
		3,
		331537
	],
	"./education-center/structured-data/medical/abnormality-brain-morphology": [
		62970,
		3,
		62970
	],
	"./education-center/structured-data/medical/abnormality-brain-morphology.json": [
		62970,
		3,
		62970
	],
	"./education-center/structured-data/medical/abnormality-cardiovascular-system": [
		844295,
		3,
		844295
	],
	"./education-center/structured-data/medical/abnormality-cardiovascular-system-morphology": [
		454586,
		3,
		454586
	],
	"./education-center/structured-data/medical/abnormality-cardiovascular-system-morphology.json": [
		454586,
		3,
		454586
	],
	"./education-center/structured-data/medical/abnormality-cardiovascular-system.json": [
		844295,
		3,
		844295
	],
	"./education-center/structured-data/medical/abnormality-coagulation": [
		886341,
		3,
		886341
	],
	"./education-center/structured-data/medical/abnormality-coagulation.json": [
		886341,
		3,
		886341
	],
	"./education-center/structured-data/medical/abnormality-connective-tissue": [
		446670,
		3,
		446670
	],
	"./education-center/structured-data/medical/abnormality-connective-tissue.json": [
		446670,
		3,
		446670
	],
	"./education-center/structured-data/medical/abnormality-dentition": [
		456684,
		3,
		456684
	],
	"./education-center/structured-data/medical/abnormality-dentition.json": [
		456684,
		3,
		456684
	],
	"./education-center/structured-data/medical/abnormality-female-genitalia": [
		394861,
		3,
		394861
	],
	"./education-center/structured-data/medical/abnormality-female-genitalia.json": [
		394861,
		3,
		394861
	],
	"./education-center/structured-data/medical/abnormality-immune-system": [
		955091,
		3,
		955091
	],
	"./education-center/structured-data/medical/abnormality-immune-system-physiology": [
		824549,
		3,
		824549
	],
	"./education-center/structured-data/medical/abnormality-immune-system-physiology.json": [
		824549,
		3,
		824549
	],
	"./education-center/structured-data/medical/abnormality-immune-system.json": [
		955091,
		3,
		955091
	],
	"./education-center/structured-data/medical/abnormality-iron-homeostasis": [
		579883,
		3,
		579883
	],
	"./education-center/structured-data/medical/abnormality-iron-homeostasis.json": [
		579883,
		3,
		579883
	],
	"./education-center/structured-data/medical/abnormality-lysosomal-metabolism": [
		161520,
		3,
		161520
	],
	"./education-center/structured-data/medical/abnormality-lysosomal-metabolism.json": [
		161520,
		3,
		161520
	],
	"./education-center/structured-data/medical/abnormality-metabolismhomeostasis": [
		583984,
		3,
		583984
	],
	"./education-center/structured-data/medical/abnormality-metabolismhomeostasis.json": [
		583984,
		3,
		583984
	],
	"./education-center/structured-data/medical/abnormality-mitochondrion": [
		628748,
		3,
		628748
	],
	"./education-center/structured-data/medical/abnormality-mitochondrion.json": [
		628748,
		3,
		628748
	],
	"./education-center/structured-data/medical/abnormality-mucopolysaccharide-metabolism": [
		93526,
		3,
		93526
	],
	"./education-center/structured-data/medical/abnormality-mucopolysaccharide-metabolism.json": [
		93526,
		3,
		93526
	],
	"./education-center/structured-data/medical/abnormality-musculature": [
		79906,
		3,
		79906
	],
	"./education-center/structured-data/medical/abnormality-musculature.json": [
		79906,
		3,
		79906
	],
	"./education-center/structured-data/medical/abnormality-neuronal-migration": [
		974475,
		3,
		974475
	],
	"./education-center/structured-data/medical/abnormality-neuronal-migration.json": [
		974475,
		3,
		974475
	],
	"./education-center/structured-data/medical/abnormality-ovary": [
		415197,
		3,
		415197
	],
	"./education-center/structured-data/medical/abnormality-ovary.json": [
		415197,
		3,
		415197
	],
	"./education-center/structured-data/medical/abnormality-pancreas": [
		101862,
		3,
		101862
	],
	"./education-center/structured-data/medical/abnormality-pancreas.json": [
		101862,
		3,
		101862
	],
	"./education-center/structured-data/medical/abnormality-prenatal-development-or-birth": [
		769787,
		3,
		769787
	],
	"./education-center/structured-data/medical/abnormality-prenatal-development-or-birth.json": [
		769787,
		3,
		769787
	],
	"./education-center/structured-data/medical/abnormality-pulmonary-vasculature": [
		834321,
		3,
		834321
	],
	"./education-center/structured-data/medical/abnormality-pulmonary-vasculature.json": [
		834321,
		3,
		834321
	],
	"./education-center/structured-data/medical/abnormality-refraction": [
		409121,
		3,
		409121
	],
	"./education-center/structured-data/medical/abnormality-refraction.json": [
		409121,
		3,
		409121
	],
	"./education-center/structured-data/medical/abnormality-skeletal-system": [
		898483,
		3,
		898483
	],
	"./education-center/structured-data/medical/abnormality-skeletal-system.json": [
		898483,
		3,
		898483
	],
	"./education-center/structured-data/medical/abnormality-urinary-system": [
		295066,
		3,
		295066
	],
	"./education-center/structured-data/medical/abnormality-urinary-system.json": [
		295066,
		3,
		295066
	],
	"./education-center/structured-data/medical/abo-blood-group-system": [
		844379,
		3,
		844379
	],
	"./education-center/structured-data/medical/abo-blood-group-system.json": [
		844379,
		3,
		844379
	],
	"./education-center/structured-data/medical/aborted-sudden-cardiac-death": [
		823303,
		3,
		823303
	],
	"./education-center/structured-data/medical/aborted-sudden-cardiac-death.json": [
		823303,
		3,
		823303
	],
	"./education-center/structured-data/medical/absent-radius": [
		205837,
		3,
		205837
	],
	"./education-center/structured-data/medical/absent-radius.json": [
		205837,
		3,
		205837
	],
	"./education-center/structured-data/medical/acampomelic-campomelic-dysplasia": [
		992841,
		3,
		992841
	],
	"./education-center/structured-data/medical/acampomelic-campomelic-dysplasia.json": [
		992841,
		3,
		992841
	],
	"./education-center/structured-data/medical/acanthocytosis": [
		750837,
		3,
		750837
	],
	"./education-center/structured-data/medical/acanthocytosis-due-band-3-ht": [
		71751,
		3,
		71751
	],
	"./education-center/structured-data/medical/acanthocytosis-due-band-3-ht.json": [
		71751,
		3,
		71751
	],
	"./education-center/structured-data/medical/acanthocytosis.json": [
		750837,
		3,
		750837
	],
	"./education-center/structured-data/medical/acanthosis-nigricans": [
		615511,
		3,
		615511
	],
	"./education-center/structured-data/medical/acanthosis-nigricans.json": [
		615511,
		3,
		615511
	],
	"./education-center/structured-data/medical/acatalasemia-japanese-type": [
		366693,
		3,
		366693
	],
	"./education-center/structured-data/medical/acatalasemia-japanese-type.json": [
		366693,
		3,
		366693
	],
	"./education-center/structured-data/medical/accelerated-tumor-formation-susceptibility": [
		309972,
		3,
		309972
	],
	"./education-center/structured-data/medical/accelerated-tumor-formation-susceptibility.json": [
		309972,
		3,
		309972
	],
	"./education-center/structured-data/medical/accessory-ectopic-thyroid-tissue": [
		186345,
		3,
		186345
	],
	"./education-center/structured-data/medical/accessory-ectopic-thyroid-tissue.json": [
		186345,
		3,
		186345
	],
	"./education-center/structured-data/medical/acenocoumarol-response-dosage": [
		256699,
		3,
		256699
	],
	"./education-center/structured-data/medical/acenocoumarol-response-dosage.json": [
		256699,
		3,
		256699
	],
	"./education-center/structured-data/medical/achondrogenesis-type-ii": [
		563182,
		3,
		563182
	],
	"./education-center/structured-data/medical/achondrogenesis-type-ii.json": [
		563182,
		3,
		563182
	],
	"./education-center/structured-data/medical/achondroplasia": [
		835365,
		3,
		835365
	],
	"./education-center/structured-data/medical/achondroplasia.json": [
		835365,
		3,
		835365
	],
	"./education-center/structured-data/medical/acid-alpha-glucosidase-allele-2": [
		84494,
		3,
		84494
	],
	"./education-center/structured-data/medical/acid-alpha-glucosidase-allele-2.json": [
		84494,
		3,
		84494
	],
	"./education-center/structured-data/medical/acne-inversa-familial-1": [
		322100,
		3,
		322100
	],
	"./education-center/structured-data/medical/acne-inversa-familial-1.json": [
		322100,
		3,
		322100
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-delayed-progression": [
		121862,
		3,
		121862
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-delayed-progression.json": [
		121862,
		3,
		121862
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-rapid-progression": [
		570921,
		3,
		570921
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-rapid-progression.json": [
		570921,
		3,
		570921
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-slow-progression": [
		207837,
		3,
		207837
	],
	"./education-center/structured-data/medical/acquired-immunodeficiency-syndrome-slow-progression.json": [
		207837,
		3,
		207837
	],
	"./education-center/structured-data/medical/acquired-susceptibility-long-qt-syndrome-1": [
		578650,
		3,
		578650
	],
	"./education-center/structured-data/medical/acquired-susceptibility-long-qt-syndrome-1.json": [
		578650,
		3,
		578650
	],
	"./education-center/structured-data/medical/acrocephalosyndactyly-type-i": [
		18372,
		3,
		18372
	],
	"./education-center/structured-data/medical/acrocephalosyndactyly-type-i.json": [
		18372,
		3,
		18372
	],
	"./education-center/structured-data/medical/acrodysostosis-1-or-without-hormone-resistance": [
		802987,
		3,
		802987
	],
	"./education-center/structured-data/medical/acrodysostosis-1-or-without-hormone-resistance.json": [
		802987,
		3,
		802987
	],
	"./education-center/structured-data/medical/acrokeratosis-verruciformis-hopf": [
		991706,
		3,
		991706
	],
	"./education-center/structured-data/medical/acrokeratosis-verruciformis-hopf.json": [
		991706,
		3,
		991706
	],
	"./education-center/structured-data/medical/acromicric-dysplasia": [
		875044,
		3,
		875044
	],
	"./education-center/structured-data/medical/acromicric-dysplasia.json": [
		875044,
		3,
		875044
	],
	"./education-center/structured-data/medical/actn3-deficiency": [
		809680,
		3,
		809680
	],
	"./education-center/structured-data/medical/actn3-deficiency.json": [
		809680,
		3,
		809680
	],
	"./education-center/structured-data/medical/aculeiform-cataract": [
		817970,
		3,
		817970
	],
	"./education-center/structured-data/medical/aculeiform-cataract.json": [
		817970,
		3,
		817970
	],
	"./education-center/structured-data/medical/acute-coronary-syndrome": [
		308653,
		3,
		506402
	],
	"./education-center/structured-data/medical/acute-coronary-syndrome.json": [
		308653,
		3,
		506402
	],
	"./education-center/structured-data/medical/acute-recurrent-myoglobinuria": [
		279479,
		3,
		279479
	],
	"./education-center/structured-data/medical/acute-recurrent-myoglobinuria.json": [
		279479,
		3,
		279479
	],
	"./education-center/structured-data/medical/acute-respiratory-failure": [
		313451,
		3,
		313451
	],
	"./education-center/structured-data/medical/acute-respiratory-failure.json": [
		313451,
		3,
		313451
	],
	"./education-center/structured-data/medical/adams-oliver-syndrome": [
		294565,
		3,
		294565
	],
	"./education-center/structured-data/medical/adams-oliver-syndrome.json": [
		294565,
		3,
		294565
	],
	"./education-center/structured-data/medical/adan-amyloidosis": [
		533396,
		3,
		533396
	],
	"./education-center/structured-data/medical/adan-amyloidosis.json": [
		533396,
		3,
		533396
	],
	"./education-center/structured-data/medical/adenocarcinoma-lung-response-tyrosine-kinase-inhibitor-somatic": [
		578831,
		3,
		578831
	],
	"./education-center/structured-data/medical/adenocarcinoma-lung-response-tyrosine-kinase-inhibitor-somatic.json": [
		578831,
		3,
		578831
	],
	"./education-center/structured-data/medical/adenoma-cortisol-producing": [
		876627,
		3,
		876627
	],
	"./education-center/structured-data/medical/adenoma-cortisol-producing.json": [
		876627,
		3,
		876627
	],
	"./education-center/structured-data/medical/adenomatous-colonic-polyposis": [
		800828,
		3,
		800828
	],
	"./education-center/structured-data/medical/adenomatous-colonic-polyposis.json": [
		800828,
		3,
		800828
	],
	"./education-center/structured-data/medical/adenomatous-polyposis-coli-attenuated": [
		95401,
		3,
		95401
	],
	"./education-center/structured-data/medical/adenomatous-polyposis-coli-attenuated.json": [
		95401,
		3,
		95401
	],
	"./education-center/structured-data/medical/adenomatous-polyposis-coli-congenital-cholesteatoma": [
		71519,
		3,
		71519
	],
	"./education-center/structured-data/medical/adenomatous-polyposis-coli-congenital-cholesteatoma.json": [
		71519,
		3,
		71519
	],
	"./education-center/structured-data/medical/adenylosuccinate-lyase-deficiency": [
		767498,
		3,
		767498
	],
	"./education-center/structured-data/medical/adenylosuccinate-lyase-deficiency.json": [
		767498,
		3,
		767498
	],
	"./education-center/structured-data/medical/adermatoglyphia": [
		538786,
		3,
		538786
	],
	"./education-center/structured-data/medical/adermatoglyphia.json": [
		538786,
		3,
		538786
	],
	"./education-center/structured-data/medical/adolescent-alopeciam-dentogingival-abnormalitites-and-intellectual-disability": [
		287500,
		3,
		287500
	],
	"./education-center/structured-data/medical/adolescent-alopeciam-dentogingival-abnormalitites-and-intellectual-disability.json": [
		287500,
		3,
		287500
	],
	"./education-center/structured-data/medical/adrenal-cortex-carcinoma": [
		89204,
		3,
		89204
	],
	"./education-center/structured-data/medical/adrenal-cortex-carcinoma.json": [
		89204,
		3,
		89204
	],
	"./education-center/structured-data/medical/adrenal-hyperplasia": [
		661266,
		3,
		661266
	],
	"./education-center/structured-data/medical/adrenal-hyperplasia.json": [
		661266,
		3,
		661266
	],
	"./education-center/structured-data/medical/adrenal-insufficiency": [
		235269,
		3,
		235269
	],
	"./education-center/structured-data/medical/adrenal-insufficiency-nr5a1-related": [
		464817,
		3,
		464817
	],
	"./education-center/structured-data/medical/adrenal-insufficiency-nr5a1-related.json": [
		464817,
		3,
		464817
	],
	"./education-center/structured-data/medical/adrenal-insufficiency.json": [
		235269,
		3,
		235269
	],
	"./education-center/structured-data/medical/adrenocortical-carcinoma-pediatric": [
		648155,
		3,
		648155
	],
	"./education-center/structured-data/medical/adrenocortical-carcinoma-pediatric.json": [
		648155,
		3,
		648155
	],
	"./education-center/structured-data/medical/adrenocortical-tumor-somatic": [
		64023,
		3,
		64023
	],
	"./education-center/structured-data/medical/adrenocortical-tumor-somatic.json": [
		64023,
		3,
		64023
	],
	"./education-center/structured-data/medical/adult-hypophosphatasia": [
		901355,
		3,
		901355
	],
	"./education-center/structured-data/medical/adult-hypophosphatasia.json": [
		901355,
		3,
		901355
	],
	"./education-center/structured-data/medical/adult-i-blood-group-or-without-congenital-cataract": [
		286492,
		3,
		286492
	],
	"./education-center/structured-data/medical/adult-i-blood-group-or-without-congenital-cataract.json": [
		286492,
		3,
		286492
	],
	"./education-center/structured-data/medical/adult-i-blood-group-phenotype": [
		847587,
		3,
		847587
	],
	"./education-center/structured-data/medical/adult-i-blood-group-phenotype.json": [
		847587,
		3,
		847587
	],
	"./education-center/structured-data/medical/adult-polyglucosan-body-neuropathy": [
		142643,
		3,
		142643
	],
	"./education-center/structured-data/medical/adult-polyglucosan-body-neuropathy.json": [
		142643,
		3,
		142643
	],
	"./education-center/structured-data/medical/adult-syndrome": [
		169750,
		3,
		169750
	],
	"./education-center/structured-data/medical/adult-syndrome.json": [
		169750,
		3,
		169750
	],
	"./education-center/structured-data/medical/aerodigestive-tract-cancer-squamous-cell-alcohol-related-protection-against": [
		629519,
		3,
		629519
	],
	"./education-center/structured-data/medical/aerodigestive-tract-cancer-squamous-cell-alcohol-related-protection-against.json": [
		629519,
		3,
		629519
	],
	"./education-center/structured-data/medical/afibrinogenemia": [
		631031,
		3,
		631031
	],
	"./education-center/structured-data/medical/afibrinogenemia.json": [
		631031,
		3,
		631031
	],
	"./education-center/structured-data/medical/age-related-macular-degeneration-2": [
		457385,
		3,
		457385
	],
	"./education-center/structured-data/medical/age-related-macular-degeneration-2.json": [
		457385,
		3,
		457385
	],
	"./education-center/structured-data/medical/agenesis-corpus-callosum-peripheral-neuropathy": [
		429853,
		3,
		429853
	],
	"./education-center/structured-data/medical/agenesis-corpus-callosum-peripheral-neuropathy.json": [
		429853,
		3,
		429853
	],
	"./education-center/structured-data/medical/agk-related-disorders": [
		788818,
		3,
		788818
	],
	"./education-center/structured-data/medical/agk-related-disorders.json": [
		788818,
		3,
		788818
	],
	"./education-center/structured-data/medical/aicardi-goutieres-syndrome-1-autosomal-dominant": [
		255272,
		3,
		255272
	],
	"./education-center/structured-data/medical/aicardi-goutieres-syndrome-1-autosomal-dominant.json": [
		255272,
		3,
		255272
	],
	"./education-center/structured-data/medical/aipl1-related-disorders": [
		25082,
		3,
		25082
	],
	"./education-center/structured-data/medical/aipl1-related-disorders.json": [
		25082,
		3,
		25082
	],
	"./education-center/structured-data/medical/alagille-syndrome-atp8b1-related": [
		431295,
		3,
		431295
	],
	"./education-center/structured-data/medical/alagille-syndrome-atp8b1-related.json": [
		431295,
		3,
		431295
	],
	"./education-center/structured-data/medical/alcohol-dependence": [
		895214,
		3,
		895214
	],
	"./education-center/structured-data/medical/alcohol-dependence.json": [
		895214,
		3,
		895214
	],
	"./education-center/structured-data/medical/aldosterone-producing-adrenal-adenoma-somatic": [
		691818,
		3,
		691818
	],
	"./education-center/structured-data/medical/aldosterone-producing-adrenal-adenoma-somatic.json": [
		691818,
		3,
		691818
	],
	"./education-center/structured-data/medical/aldosterone-renin-ratio-increased": [
		394029,
		3,
		394029
	],
	"./education-center/structured-data/medical/aldosterone-renin-ratio-increased.json": [
		394029,
		3,
		394029
	],
	"./education-center/structured-data/medical/alloalbuminemia": [
		263066,
		3,
		263066
	],
	"./education-center/structured-data/medical/alloalbuminemia.json": [
		263066,
		3,
		263066
	],
	"./education-center/structured-data/medical/alopecia-androgenetic-1": [
		109341,
		3,
		109341
	],
	"./education-center/structured-data/medical/alopecia-androgenetic-1.json": [
		109341,
		3,
		109341
	],
	"./education-center/structured-data/medical/alpha-fetoprotein-deficiency": [
		332519,
		3,
		332519
	],
	"./education-center/structured-data/medical/alpha-fetoprotein-deficiency.json": [
		332519,
		3,
		332519
	],
	"./education-center/structured-data/medical/alpha-fetoprotein-hereditary-persistence": [
		591158,
		3,
		591158
	],
	"./education-center/structured-data/medical/alpha-fetoprotein-hereditary-persistence.json": [
		591158,
		3,
		591158
	],
	"./education-center/structured-data/medical/alpha-thalassemia-2-nondeletional": [
		10647,
		3,
		10647
	],
	"./education-center/structured-data/medical/alpha-thalassemia-2-nondeletional.json": [
		10647,
		3,
		10647
	],
	"./education-center/structured-data/medical/alpha-thalassemia-dutch-type": [
		553435,
		3,
		553435
	],
	"./education-center/structured-data/medical/alpha-thalassemia-dutch-type.json": [
		553435,
		3,
		553435
	],
	"./education-center/structured-data/medical/alpha-thalassemia-hmong-type": [
		540427,
		3,
		540427
	],
	"./education-center/structured-data/medical/alpha-thalassemia-hmong-type.json": [
		540427,
		3,
		540427
	],
	"./education-center/structured-data/medical/alpha-thalassemiaintellectual-disability-syndrome": [
		586351,
		3,
		586351
	],
	"./education-center/structured-data/medical/alpha-thalassemiaintellectual-disability-syndrome.json": [
		586351,
		3,
		586351
	],
	"./education-center/structured-data/medical/alpha-trait-thalassemia": [
		985442,
		3,
		985442
	],
	"./education-center/structured-data/medical/alpha-trait-thalassemia.json": [
		985442,
		3,
		985442
	],
	"./education-center/structured-data/medical/als2-related-disorders": [
		662145,
		3,
		662145
	],
	"./education-center/structured-data/medical/als2-related-disorders.json": [
		662145,
		3,
		662145
	],
	"./education-center/structured-data/medical/altered-myosin-contractile-function": [
		681607,
		3,
		681607
	],
	"./education-center/structured-data/medical/altered-myosin-contractile-function.json": [
		681607,
		3,
		681607
	],
	"./education-center/structured-data/medical/altered-potassium-channel-function": [
		663328,
		3,
		663328
	],
	"./education-center/structured-data/medical/altered-potassium-channel-function.json": [
		663328,
		3,
		663328
	],
	"./education-center/structured-data/medical/alternating-hemiplegia-childhood-1": [
		793759,
		3,
		793759
	],
	"./education-center/structured-data/medical/alternating-hemiplegia-childhood-1.json": [
		793759,
		3,
		793759
	],
	"./education-center/structured-data/medical/alzheimer-disease-2": [
		997196,
		3,
		997196
	],
	"./education-center/structured-data/medical/alzheimer-disease-2.json": [
		997196,
		3,
		997196
	],
	"./education-center/structured-data/medical/alzheimer-disease-3": [
		76469,
		3,
		76469
	],
	"./education-center/structured-data/medical/alzheimer-disease-3.json": [
		76469,
		3,
		76469
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis": [
		52401,
		3,
		52401
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-apraxia": [
		531069,
		3,
		531069
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-apraxia.json": [
		531069,
		3,
		531069
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-unusual-plaques": [
		492006,
		3,
		492006
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis-and-unusual-plaques.json": [
		492006,
		3,
		492006
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-spastic-paraparesis.json": [
		52401,
		3,
		52401
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-unusual-plaques": [
		287929,
		3,
		287929
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-3-unusual-plaques.json": [
		287929,
		3,
		287929
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-spastic-paraparesis-and-unusual-plaques": [
		834841,
		3,
		834841
	],
	"./education-center/structured-data/medical/alzheimer-disease-familial-spastic-paraparesis-and-unusual-plaques.json": [
		834841,
		3,
		834841
	],
	"./education-center/structured-data/medical/alzheimer-disease-late-onset-susceptibility": [
		351896,
		3,
		351896
	],
	"./education-center/structured-data/medical/alzheimer-disease-late-onset-susceptibility.json": [
		351896,
		3,
		351896
	],
	"./education-center/structured-data/medical/alzheimer-disease-protection-against": [
		67393,
		3,
		67393
	],
	"./education-center/structured-data/medical/alzheimer-disease-protection-against.json": [
		67393,
		3,
		67393
	],
	"./education-center/structured-data/medical/alzheimer-disease-type-1": [
		362555,
		3,
		362555
	],
	"./education-center/structured-data/medical/alzheimer-disease-type-1.json": [
		362555,
		3,
		362555
	],
	"./education-center/structured-data/medical/ambiguous-genitalia": [
		475229,
		3,
		475229
	],
	"./education-center/structured-data/medical/ambiguous-genitalia.json": [
		475229,
		3,
		475229
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-dominant": [
		335796,
		3,
		335796
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-dominant.json": [
		335796,
		3,
		335796
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-hypocalcification-type": [
		174797,
		3,
		174797
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-hypocalcification-type.json": [
		174797,
		3,
		174797
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-hypoplastic-autosomal-dominant-local": [
		636045,
		3,
		636045
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-hypoplastic-autosomal-dominant-local.json": [
		636045,
		3,
		636045
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-recessive": [
		483219,
		3,
		483219
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-recessive.json": [
		483219,
		3,
		483219
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-type-1a": [
		222307,
		3,
		222307
	],
	"./education-center/structured-data/medical/amelogenesis-imperfecta-type-1a.json": [
		222307,
		3,
		222307
	],
	"./education-center/structured-data/medical/amyloid-cardiomyopathy-transthyretin-related": [
		738365,
		3,
		738365
	],
	"./education-center/structured-data/medical/amyloid-cardiomyopathy-transthyretin-related.json": [
		738365,
		3,
		738365
	],
	"./education-center/structured-data/medical/amyloidogenic-transthyretin-amyloidosis": [
		704871,
		3,
		704871
	],
	"./education-center/structured-data/medical/amyloidogenic-transthyretin-amyloidosis.json": [
		704871,
		3,
		704871
	],
	"./education-center/structured-data/medical/amyloidosis-cardiac-and-cutaneous": [
		413609,
		3,
		413609
	],
	"./education-center/structured-data/medical/amyloidosis-cardiac-and-cutaneous.json": [
		413609,
		3,
		413609
	],
	"./education-center/structured-data/medical/amyloidosis-leptomeningeal-transthyretin-related": [
		554930,
		3,
		554930
	],
	"./education-center/structured-data/medical/amyloidosis-leptomeningeal-transthyretin-related.json": [
		554930,
		3,
		554930
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-1-autosomal-recessive": [
		673575,
		3,
		673575
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-1-autosomal-recessive.json": [
		673575,
		3,
		673575
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-22-frontotemporal-dementia": [
		210165,
		3,
		210165
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-22-frontotemporal-dementia.json": [
		210165,
		3,
		210165
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-6-autosomal-recessive": [
		449045,
		3,
		449045
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-6-autosomal-recessive.json": [
		449045,
		3,
		449045
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-dominant": [
		933330,
		3,
		933330
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-dominant.json": [
		933330,
		3,
		933330
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-parkinsonism-dementia-complex": [
		116447,
		3,
		116447
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-parkinsonism-dementia-complex.json": [
		116447,
		3,
		116447
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-recessive": [
		615876,
		3,
		615876
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-recessive.json": [
		615876,
		3,
		615876
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-susceptibility": [
		861764,
		3,
		861764
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-susceptibility.json": [
		861764,
		3,
		861764
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-type-1": [
		22235,
		3,
		22235
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-type-1.json": [
		22235,
		3,
		22235
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-type-4": [
		361903,
		3,
		361903
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosis-type-4.json": [
		361903,
		3,
		361903
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosisfrontotemporal-dementia": [
		26567,
		3,
		26567
	],
	"./education-center/structured-data/medical/amyotrophic-lateral-sclerosisfrontotemporal-dementia.json": [
		26567,
		3,
		26567
	],
	"./education-center/structured-data/medical/anadysplasia-spontaneously-remitting-spondylometaphyseal-dysplasia": [
		715175,
		3,
		715175
	],
	"./education-center/structured-data/medical/anadysplasia-spontaneously-remitting-spondylometaphyseal-dysplasia.json": [
		715175,
		3,
		715175
	],
	"./education-center/structured-data/medical/analbuminemia": [
		887796,
		3,
		887796
	],
	"./education-center/structured-data/medical/analbuminemia-baghdad": [
		467903,
		3,
		467903
	],
	"./education-center/structured-data/medical/analbuminemia-baghdad.json": [
		467903,
		3,
		467903
	],
	"./education-center/structured-data/medical/analbuminemia.json": [
		887796,
		3,
		887796
	],
	"./education-center/structured-data/medical/anemia": [
		636584,
		3,
		636584
	],
	"./education-center/structured-data/medical/anemia-hereditary-sideroblastic-1-pyridoxine-refractory": [
		447804,
		3,
		447804
	],
	"./education-center/structured-data/medical/anemia-hereditary-sideroblastic-1-pyridoxine-refractory.json": [
		447804,
		3,
		447804
	],
	"./education-center/structured-data/medical/anemia-perinatal-hemolytic-fatal-or-near-fatal": [
		242631,
		3,
		242631
	],
	"./education-center/structured-data/medical/anemia-perinatal-hemolytic-fatal-or-near-fatal.json": [
		242631,
		3,
		242631
	],
	"./education-center/structured-data/medical/anemia.json": [
		636584,
		3,
		636584
	],
	"./education-center/structured-data/medical/anencephaly": [
		492512,
		3,
		492512
	],
	"./education-center/structured-data/medical/anencephaly.json": [
		492512,
		3,
		492512
	],
	"./education-center/structured-data/medical/angelman-syndrome": [
		849072,
		3,
		849072
	],
	"./education-center/structured-data/medical/angelman-syndrome-0": [
		72842,
		3,
		72842
	],
	"./education-center/structured-data/medical/angelman-syndrome-0.json": [
		72842,
		3,
		72842
	],
	"./education-center/structured-data/medical/angelman-syndrome.json": [
		849072,
		3,
		849072
	],
	"./education-center/structured-data/medical/angiofibroma-somatic": [
		659430,
		3,
		659430
	],
	"./education-center/structured-data/medical/angiofibroma-somatic.json": [
		659430,
		3,
		659430
	],
	"./education-center/structured-data/medical/angioma-serpiginosum-autosomal-dominant": [
		575233,
		3,
		575233
	],
	"./education-center/structured-data/medical/angioma-serpiginosum-autosomal-dominant.json": [
		575233,
		3,
		575233
	],
	"./education-center/structured-data/medical/angioosteohypertrophic-syndrome": [
		199482,
		3,
		199482
	],
	"./education-center/structured-data/medical/angioosteohypertrophic-syndrome.json": [
		199482,
		3,
		199482
	],
	"./education-center/structured-data/medical/angiotensin-i-converting-enzyme-benign-serum-increase": [
		868130,
		3,
		868130
	],
	"./education-center/structured-data/medical/angiotensin-i-converting-enzyme-benign-serum-increase.json": [
		868130,
		3,
		868130
	],
	"./education-center/structured-data/medical/anhydramnios": [
		908782,
		3,
		908782
	],
	"./education-center/structured-data/medical/anhydramnios.json": [
		908782,
		3,
		908782
	],
	"./education-center/structured-data/medical/aniridia-atypical": [
		943101,
		3,
		943101
	],
	"./education-center/structured-data/medical/aniridia-atypical.json": [
		943101,
		3,
		943101
	],
	"./education-center/structured-data/medical/aniridia-cerebellar-ataxia-and-intellectual-disability": [
		544193,
		3,
		544193
	],
	"./education-center/structured-data/medical/aniridia-cerebellar-ataxia-and-intellectual-disability.json": [
		544193,
		3,
		544193
	],
	"./education-center/structured-data/medical/ankrd1-related-dilated-cardiomyopathy": [
		84509,
		3,
		321681
	],
	"./education-center/structured-data/medical/ankrd1-related-dilated-cardiomyopathy.json": [
		84509,
		3,
		321681
	],
	"./education-center/structured-data/medical/ankyloblepharon-ectodermal-defects-cleft-lippalate-syndrome": [
		347026,
		3,
		347026
	],
	"./education-center/structured-data/medical/ankyloblepharon-ectodermal-defects-cleft-lippalate-syndrome.json": [
		347026,
		3,
		347026
	],
	"./education-center/structured-data/medical/ano5-related-disorders": [
		842668,
		3,
		842668
	],
	"./education-center/structured-data/medical/ano5-related-disorders.json": [
		842668,
		3,
		842668
	],
	"./education-center/structured-data/medical/ano5-related-muscle-diseases": [
		466113,
		3,
		466113
	],
	"./education-center/structured-data/medical/ano5-related-muscle-diseases.json": [
		466113,
		3,
		466113
	],
	"./education-center/structured-data/medical/anonychia": [
		602217,
		3,
		602217
	],
	"./education-center/structured-data/medical/anonychia.json": [
		602217,
		3,
		602217
	],
	"./education-center/structured-data/medical/anophthalmia": [
		76596,
		3,
		76596
	],
	"./education-center/structured-data/medical/anophthalmia.json": [
		76596,
		3,
		76596
	],
	"./education-center/structured-data/medical/anosmia": [
		206337,
		3,
		206337
	],
	"./education-center/structured-data/medical/anosmia.json": [
		206337,
		3,
		206337
	],
	"./education-center/structured-data/medical/anterior-segment-anomalies-and-cataract": [
		239097,
		3,
		239097
	],
	"./education-center/structured-data/medical/anterior-segment-anomalies-and-cataract.json": [
		239097,
		3,
		239097
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-1": [
		193349,
		3,
		193349
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-1-multiple-subtypes": [
		902464,
		3,
		902464
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-1-multiple-subtypes.json": [
		902464,
		3,
		902464
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-1.json": [
		193349,
		3,
		193349
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-4": [
		698493,
		3,
		698493
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-4.json": [
		698493,
		3,
		698493
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-5-multiple-subtypes": [
		269636,
		3,
		269636
	],
	"./education-center/structured-data/medical/anterior-segment-dysgenesis-5-multiple-subtypes.json": [
		269636,
		3,
		269636
	],
	"./education-center/structured-data/medical/anti-sema4d-monoclonal-antibody-vx152503": [
		14179,
		3,
		14179
	],
	"./education-center/structured-data/medical/anti-sema4d-monoclonal-antibody-vx152503.json": [
		14179,
		3,
		14179
	],
	"./education-center/structured-data/medical/antidepressant-drug-treatment-accelerated-response": [
		641114,
		3,
		641114
	],
	"./education-center/structured-data/medical/antidepressant-drug-treatment-accelerated-response.json": [
		641114,
		3,
		641114
	],
	"./education-center/structured-data/medical/antigen-scianna-blood-group-system": [
		798217,
		3,
		798217
	],
	"./education-center/structured-data/medical/antigen-scianna-blood-group-system.json": [
		798217,
		3,
		798217
	],
	"./education-center/structured-data/medical/aortic-aneurysm-familial-thoracic-4": [
		792135,
		3,
		792135
	],
	"./education-center/structured-data/medical/aortic-aneurysm-familial-thoracic-4.json": [
		792135,
		3,
		792135
	],
	"./education-center/structured-data/medical/aortic-aneurysm-familial-thoracic-tgfb2-related": [
		629121,
		3,
		629121
	],
	"./education-center/structured-data/medical/aortic-aneurysm-familial-thoracic-tgfb2-related.json": [
		629121,
		3,
		629121
	],
	"./education-center/structured-data/medical/aortic-dilatation": [
		551765,
		3,
		551765
	],
	"./education-center/structured-data/medical/aortic-dilatation.json": [
		551765,
		3,
		551765
	],
	"./education-center/structured-data/medical/aortic-dissection": [
		105099,
		3,
		105099
	],
	"./education-center/structured-data/medical/aortic-dissection.json": [
		105099,
		3,
		105099
	],
	"./education-center/structured-data/medical/aortic-root-aneurysm": [
		903302,
		3,
		903302
	],
	"./education-center/structured-data/medical/aortic-root-aneurysm.json": [
		903302,
		3,
		903302
	],
	"./education-center/structured-data/medical/aortic-valve-disease-2": [
		674630,
		3,
		674630
	],
	"./education-center/structured-data/medical/aortic-valve-disease-2.json": [
		674630,
		3,
		674630
	],
	"./education-center/structured-data/medical/apc-associated-polyposis-disorders": [
		438123,
		3,
		438123
	],
	"./education-center/structured-data/medical/apc-associated-polyposis-disorders.json": [
		438123,
		3,
		438123
	],
	"./education-center/structured-data/medical/apc-mutation-negative-familial-colorectal-cancer": [
		481273,
		3,
		481273
	],
	"./education-center/structured-data/medical/apc-mutation-negative-familial-colorectal-cancer.json": [
		481273,
		3,
		481273
	],
	"./education-center/structured-data/medical/aplasia-cutis-congenita": [
		344836,
		3,
		344836
	],
	"./education-center/structured-data/medical/aplasia-cutis-congenita.json": [
		344836,
		3,
		344836
	],
	"./education-center/structured-data/medical/apocrine-gland-secretion-variation": [
		172035,
		3,
		172035
	],
	"./education-center/structured-data/medical/apocrine-gland-secretion-variation.json": [
		172035,
		3,
		172035
	],
	"./education-center/structured-data/medical/apoe5-variant": [
		401198,
		3,
		401198
	],
	"./education-center/structured-data/medical/apoe5-variant.json": [
		401198,
		3,
		401198
	],
	"./education-center/structured-data/medical/apolipoprotein-ii-deficiency": [
		565723,
		3,
		565723
	],
	"./education-center/structured-data/medical/apolipoprotein-ii-deficiency.json": [
		565723,
		3,
		565723
	],
	"./education-center/structured-data/medical/apparent-mineralocorticoid-excess-mild": [
		134789,
		3,
		134789
	],
	"./education-center/structured-data/medical/apparent-mineralocorticoid-excess-mild.json": [
		134789,
		3,
		134789
	],
	"./education-center/structured-data/medical/appendicitis": [
		341045,
		3,
		341045
	],
	"./education-center/structured-data/medical/appendicitis.json": [
		341045,
		3,
		341045
	],
	"./education-center/structured-data/medical/appendicular-lean-mass-relative-body-height": [
		350174,
		3,
		350174
	],
	"./education-center/structured-data/medical/appendicular-lean-mass-relative-body-height.json": [
		350174,
		3,
		350174
	],
	"./education-center/structured-data/medical/aprt-deficiency-japanese-type": [
		672208,
		3,
		672208
	],
	"./education-center/structured-data/medical/aprt-deficiency-japanese-type.json": [
		672208,
		3,
		672208
	],
	"./education-center/structured-data/medical/armc9-related-joubert-syndrome": [
		122837,
		3,
		122837
	],
	"./education-center/structured-data/medical/armc9-related-joubert-syndrome.json": [
		122837,
		3,
		122837
	],
	"./education-center/structured-data/medical/aromatase-excess-syndrome": [
		279100,
		3,
		279100
	],
	"./education-center/structured-data/medical/aromatase-excess-syndrome.json": [
		279100,
		3,
		279100
	],
	"./education-center/structured-data/medical/arrhythmogenic-cardiomyopathy": [
		421828,
		3,
		421828
	],
	"./education-center/structured-data/medical/arrhythmogenic-cardiomyopathy.json": [
		421828,
		3,
		421828
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-1": [
		206856,
		3,
		206856
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-1.json": [
		206856,
		3,
		206856
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-13": [
		352687,
		3,
		352687
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-13.json": [
		352687,
		3,
		352687
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-familial-11-mild-palmoplantar-keratoderma-and-woolly-hair": [
		757642,
		3,
		757642
	],
	"./education-center/structured-data/medical/arrhythmogenic-right-ventricular-dysplasia-familial-11-mild-palmoplantar-keratoderma-and-woolly-hair.json": [
		757642,
		3,
		757642
	],
	"./education-center/structured-data/medical/arterial-dissection": [
		559745,
		3,
		559745
	],
	"./education-center/structured-data/medical/arterial-dissection.json": [
		559745,
		3,
		559745
	],
	"./education-center/structured-data/medical/arterial-tortuosity": [
		176956,
		3,
		176956
	],
	"./education-center/structured-data/medical/arterial-tortuosity.json": [
		176956,
		3,
		176956
	],
	"./education-center/structured-data/medical/arteriohepatic-dysplasia": [
		505200,
		3,
		505200
	],
	"./education-center/structured-data/medical/arteriohepatic-dysplasia.json": [
		505200,
		3,
		505200
	],
	"./education-center/structured-data/medical/arteriovenous-malformation": [
		974869,
		3,
		974869
	],
	"./education-center/structured-data/medical/arteriovenous-malformation.json": [
		974869,
		3,
		974869
	],
	"./education-center/structured-data/medical/arthrogryposis-distal-type-1a": [
		940779,
		3,
		940779
	],
	"./education-center/structured-data/medical/arthrogryposis-distal-type-1a.json": [
		940779,
		3,
		940779
	],
	"./education-center/structured-data/medical/arthrogryposis-oculomotor-limitation-electroretinal-anomalies-syndrome": [
		784015,
		3,
		784015
	],
	"./education-center/structured-data/medical/arthrogryposis-oculomotor-limitation-electroretinal-anomalies-syndrome.json": [
		784015,
		3,
		784015
	],
	"./education-center/structured-data/medical/arthyrgryposis-distal-type-2b": [
		820835,
		3,
		820835
	],
	"./education-center/structured-data/medical/arthyrgryposis-distal-type-2b.json": [
		820835,
		3,
		820835
	],
	"./education-center/structured-data/medical/arv1-related-condition": [
		916672,
		3,
		916672
	],
	"./education-center/structured-data/medical/arv1-related-condition.json": [
		916672,
		3,
		916672
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency": [
		885144,
		3,
		885144
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency-intermediate": [
		106493,
		3,
		106493
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency-intermediate.json": [
		106493,
		3,
		106493
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency-severe": [
		176056,
		3,
		176056
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency-severe.json": [
		176056,
		3,
		176056
	],
	"./education-center/structured-data/medical/arylsulfatase-pseudodeficiency.json": [
		885144,
		3,
		885144
	],
	"./education-center/structured-data/medical/ascending-aortic-dissection": [
		56573,
		3,
		56573
	],
	"./education-center/structured-data/medical/ascending-aortic-dissection.json": [
		56573,
		3,
		56573
	],
	"./education-center/structured-data/medical/asher": [
		470203,
		3,
		470203
	],
	"./education-center/structured-data/medical/asher.json": [
		470203,
		3,
		470203
	],
	"./education-center/structured-data/medical/aspartate-aminotransferase-serum-level-quantitative-trait-locus-1": [
		975589,
		3,
		975589
	],
	"./education-center/structured-data/medical/aspartate-aminotransferase-serum-level-quantitative-trait-locus-1.json": [
		975589,
		3,
		975589
	],
	"./education-center/structured-data/medical/aspartylglucosaminuria-finnish-type": [
		826282,
		3,
		826282
	],
	"./education-center/structured-data/medical/aspartylglucosaminuria-finnish-type.json": [
		826282,
		3,
		826282
	],
	"./education-center/structured-data/medical/asplenia": [
		529168,
		3,
		529168
	],
	"./education-center/structured-data/medical/asplenia.json": [
		529168,
		3,
		529168
	],
	"./education-center/structured-data/medical/association-systemic-lupus-erythematosus": [
		880980,
		3,
		880980
	],
	"./education-center/structured-data/medical/association-systemic-lupus-erythematosus.json": [
		880980,
		3,
		880980
	],
	"./education-center/structured-data/medical/asthma-and-nasal-polyps": [
		677888,
		3,
		677888
	],
	"./education-center/structured-data/medical/asthma-and-nasal-polyps.json": [
		677888,
		3,
		677888
	],
	"./education-center/structured-data/medical/asthma-protection-against": [
		457520,
		3,
		457520
	],
	"./education-center/structured-data/medical/asthma-protection-against.json": [
		457520,
		3,
		457520
	],
	"./education-center/structured-data/medical/astrocytoma-low-grade-somatic": [
		883735,
		3,
		883735
	],
	"./education-center/structured-data/medical/astrocytoma-low-grade-somatic.json": [
		883735,
		3,
		883735
	],
	"./education-center/structured-data/medical/ataxia-and-retinitis-pigmentosa-isolated-vitamin-e-deficiency": [
		14122,
		3,
		511250
	],
	"./education-center/structured-data/medical/ataxia-and-retinitis-pigmentosa-isolated-vitamin-e-deficiency.json": [
		14122,
		3,
		511250
	],
	"./education-center/structured-data/medical/ataxia-friedreich-isolated-vitamin-e-deficiency": [
		846990,
		3,
		846990
	],
	"./education-center/structured-data/medical/ataxia-friedreich-isolated-vitamin-e-deficiency.json": [
		846990,
		3,
		846990
	],
	"./education-center/structured-data/medical/ataxia-neuropathy-spectrum-disorders": [
		744821,
		3,
		744821
	],
	"./education-center/structured-data/medical/ataxia-neuropathy-spectrum-disorders.json": [
		744821,
		3,
		744821
	],
	"./education-center/structured-data/medical/ataxia-pancytopenia-syndrome": [
		450536,
		3,
		450536
	],
	"./education-center/structured-data/medical/ataxia-pancytopenia-syndrome.json": [
		450536,
		3,
		450536
	],
	"./education-center/structured-data/medical/ataxia-progressive-seizures-mental-deterioration-and-hearing-loss": [
		842744,
		3,
		842744
	],
	"./education-center/structured-data/medical/ataxia-progressive-seizures-mental-deterioration-and-hearing-loss.json": [
		842744,
		3,
		842744
	],
	"./education-center/structured-data/medical/ataxia-telangiectasia-without-immunodeficiency": [
		925638,
		3,
		925638
	],
	"./education-center/structured-data/medical/ataxia-telangiectasia-without-immunodeficiency.json": [
		925638,
		3,
		925638
	],
	"./education-center/structured-data/medical/atelis-syndrome-1": [
		346919,
		3,
		346919
	],
	"./education-center/structured-data/medical/atelis-syndrome-1.json": [
		346919,
		3,
		346919
	],
	"./education-center/structured-data/medical/atelis-syndrome-2": [
		85768,
		3,
		85768
	],
	"./education-center/structured-data/medical/atelis-syndrome-2.json": [
		85768,
		3,
		85768
	],
	"./education-center/structured-data/medical/atelosteogenesis": [
		242658,
		3,
		242658
	],
	"./education-center/structured-data/medical/atelosteogenesis-type-i": [
		448929,
		3,
		448929
	],
	"./education-center/structured-data/medical/atelosteogenesis-type-i.json": [
		448929,
		3,
		448929
	],
	"./education-center/structured-data/medical/atelosteogenesis-type-iii": [
		282947,
		3,
		282947
	],
	"./education-center/structured-data/medical/atelosteogenesis-type-iii.json": [
		282947,
		3,
		282947
	],
	"./education-center/structured-data/medical/atelosteogenesis.json": [
		242658,
		3,
		242658
	],
	"./education-center/structured-data/medical/atherosclerosis-susceptibility": [
		804757,
		3,
		804757
	],
	"./education-center/structured-data/medical/atherosclerosis-susceptibility.json": [
		804757,
		3,
		804757
	],
	"./education-center/structured-data/medical/atopy-resistance": [
		409738,
		3,
		409738
	],
	"./education-center/structured-data/medical/atopy-resistance.json": [
		409738,
		3,
		409738
	],
	"./education-center/structured-data/medical/atopy-susceptibility": [
		623481,
		3,
		623481
	],
	"./education-center/structured-data/medical/atopy-susceptibility.json": [
		623481,
		3,
		623481
	],
	"./education-center/structured-data/medical/atorvastatin-response": [
		225936,
		3,
		225936
	],
	"./education-center/structured-data/medical/atorvastatin-response-efficacy": [
		401799,
		3,
		401799
	],
	"./education-center/structured-data/medical/atorvastatin-response-efficacy.json": [
		401799,
		3,
		401799
	],
	"./education-center/structured-data/medical/atorvastatin-response.json": [
		225936,
		3,
		225936
	],
	"./education-center/structured-data/medical/atrial-fibrillation-somatic": [
		202109,
		3,
		202109
	],
	"./education-center/structured-data/medical/atrial-fibrillation-somatic.json": [
		202109,
		3,
		202109
	],
	"./education-center/structured-data/medical/atrial-septal-defect": [
		596125,
		3,
		596125
	],
	"./education-center/structured-data/medical/atrial-septal-defect-1": [
		811963,
		3,
		811963
	],
	"./education-center/structured-data/medical/atrial-septal-defect-1.json": [
		811963,
		3,
		811963
	],
	"./education-center/structured-data/medical/atrial-septal-defect-7": [
		575876,
		3,
		575876
	],
	"./education-center/structured-data/medical/atrial-septal-defect-7.json": [
		575876,
		3,
		575876
	],
	"./education-center/structured-data/medical/atrial-septal-defect.json": [
		596125,
		3,
		596125
	],
	"./education-center/structured-data/medical/atrial-standstill-1-digenic": [
		126718,
		3,
		126718
	],
	"./education-center/structured-data/medical/atrial-standstill-1-digenic.json": [
		126718,
		3,
		126718
	],
	"./education-center/structured-data/medical/atrioventricular-septal-defect-partial-heterotaxy-syndrome": [
		783057,
		3,
		783057
	],
	"./education-center/structured-data/medical/atrioventricular-septal-defect-partial-heterotaxy-syndrome.json": [
		783057,
		3,
		783057
	],
	"./education-center/structured-data/medical/atrioventricular-septal-defect-somatic": [
		797603,
		3,
		797603
	],
	"./education-center/structured-data/medical/atrioventricular-septal-defect-somatic.json": [
		797603,
		3,
		797603
	],
	"./education-center/structured-data/medical/attention-deficit-hyperactivity-disorder": [
		669659,
		3,
		669659
	],
	"./education-center/structured-data/medical/attention-deficit-hyperactivity-disorder.json": [
		669659,
		3,
		669659
	],
	"./education-center/structured-data/medical/atypical-behavior": [
		788906,
		3,
		788906
	],
	"./education-center/structured-data/medical/atypical-behavior.json": [
		788906,
		3,
		788906
	],
	"./education-center/structured-data/medical/atypical-cerebral-palsy": [
		604570,
		3,
		604570
	],
	"./education-center/structured-data/medical/atypical-cerebral-palsy.json": [
		604570,
		3,
		604570
	],
	"./education-center/structured-data/medical/atypical-gaucher-disease": [
		179818,
		3,
		179818
	],
	"./education-center/structured-data/medical/atypical-gaucher-disease.json": [
		179818,
		3,
		179818
	],
	"./education-center/structured-data/medical/auditory-neuropathy-autosomal-recessive-1": [
		176029,
		3,
		176029
	],
	"./education-center/structured-data/medical/auditory-neuropathy-autosomal-recessive-1.json": [
		176029,
		3,
		176029
	],
	"./education-center/structured-data/medical/auditory-neuropathy-spectrum-disorder": [
		382645,
		3,
		382645
	],
	"./education-center/structured-data/medical/auditory-neuropathy-spectrum-disorder.json": [
		382645,
		3,
		382645
	],
	"./education-center/structured-data/medical/auriculocondylar-syndrome": [
		338129,
		3,
		338129
	],
	"./education-center/structured-data/medical/auriculocondylar-syndrome.json": [
		338129,
		3,
		338129
	],
	"./education-center/structured-data/medical/autistic-behavior": [
		352608,
		3,
		352608
	],
	"./education-center/structured-data/medical/autistic-behavior.json": [
		352608,
		3,
		352608
	],
	"./education-center/structured-data/medical/autistic-spectrum-disorder-isolated-skills": [
		120244,
		3,
		120244
	],
	"./education-center/structured-data/medical/autistic-spectrum-disorder-isolated-skills.json": [
		120244,
		3,
		120244
	],
	"./education-center/structured-data/medical/autoimmune-lymphoproliferative-syndrome-type-1a": [
		322163,
		3,
		322163
	],
	"./education-center/structured-data/medical/autoimmune-lymphoproliferative-syndrome-type-1a.json": [
		322163,
		3,
		322163
	],
	"./education-center/structured-data/medical/autoimmune-lymphoproliferative-syndrome-type-1b": [
		870696,
		3,
		870696
	],
	"./education-center/structured-data/medical/autoimmune-lymphoproliferative-syndrome-type-1b.json": [
		870696,
		3,
		870696
	],
	"./education-center/structured-data/medical/autoimmune-polyglandular-syndrome-type-1-autosomal-dominant": [
		617434,
		3,
		617434
	],
	"./education-center/structured-data/medical/autoimmune-polyglandular-syndrome-type-1-autosomal-dominant.json": [
		617434,
		3,
		617434
	],
	"./education-center/structured-data/medical/autoimmune-polyglandular-syndrome-type-1-reversible-metaphyseal-dysplasia": [
		683161,
		3,
		683161
	],
	"./education-center/structured-data/medical/autoimmune-polyglandular-syndrome-type-1-reversible-metaphyseal-dysplasia.json": [
		683161,
		3,
		683161
	],
	"./education-center/structured-data/medical/autoinflammation-pulmonary-and-cutaneous-vasculitis": [
		761105,
		3,
		761105
	],
	"./education-center/structured-data/medical/autoinflammation-pulmonary-and-cutaneous-vasculitis.json": [
		761105,
		3,
		761105
	],
	"./education-center/structured-data/medical/autonomic-nervous-system-dysfunction": [
		383598,
		3,
		803968
	],
	"./education-center/structured-data/medical/autonomic-nervous-system-dysfunction.json": [
		383598,
		3,
		803968
	],
	"./education-center/structured-data/medical/autosomal-dominant-alport-syndrome": [
		720877,
		3,
		720877
	],
	"./education-center/structured-data/medical/autosomal-dominant-alport-syndrome.json": [
		720877,
		3,
		720877
	],
	"./education-center/structured-data/medical/autosomal-dominant-childhood-onset-proximal-spinal-muscular-atrophy-without-contractures": [
		740540,
		3,
		740540
	],
	"./education-center/structured-data/medical/autosomal-dominant-childhood-onset-proximal-spinal-muscular-atrophy-without-contractures.json": [
		740540,
		3,
		740540
	],
	"./education-center/structured-data/medical/autosomal-dominant-deafness-onychodystrophy-syndrome": [
		736680,
		3,
		736680
	],
	"./education-center/structured-data/medical/autosomal-dominant-deafness-onychodystrophy-syndrome.json": [
		736680,
		3,
		736680
	],
	"./education-center/structured-data/medical/autosomal-dominant-epilepsy": [
		3158,
		3,
		3158
	],
	"./education-center/structured-data/medical/autosomal-dominant-epilepsy.json": [
		3158,
		3,
		3158
	],
	"./education-center/structured-data/medical/autosomal-dominant-ichthyosis-vulgaris": [
		824435,
		3,
		824435
	],
	"./education-center/structured-data/medical/autosomal-dominant-ichthyosis-vulgaris.json": [
		824435,
		3,
		824435
	],
	"./education-center/structured-data/medical/autosomal-dominant-kenny-caffey-syndrome": [
		267977,
		3,
		267977
	],
	"./education-center/structured-data/medical/autosomal-dominant-kenny-caffey-syndrome.json": [
		267977,
		3,
		267977
	],
	"./education-center/structured-data/medical/autosomal-dominant-keratitis": [
		278762,
		3,
		278762
	],
	"./education-center/structured-data/medical/autosomal-dominant-keratitis-ichthyosis-hearing-loss-syndrome": [
		101839,
		3,
		101839
	],
	"./education-center/structured-data/medical/autosomal-dominant-keratitis-ichthyosis-hearing-loss-syndrome.json": [
		101839,
		3,
		101839
	],
	"./education-center/structured-data/medical/autosomal-dominant-keratitis.json": [
		278762,
		3,
		278762
	],
	"./education-center/structured-data/medical/autosomal-dominant-lamellar-ichthyosis": [
		430305,
		3,
		430305
	],
	"./education-center/structured-data/medical/autosomal-dominant-lamellar-ichthyosis.json": [
		430305,
		3,
		430305
	],
	"./education-center/structured-data/medical/autosomal-dominant-neovascular-inflammatory-vitreoretinopathy": [
		433925,
		3,
		433925
	],
	"./education-center/structured-data/medical/autosomal-dominant-neovascular-inflammatory-vitreoretinopathy.json": [
		433925,
		3,
		433925
	],
	"./education-center/structured-data/medical/autosomal-dominant-nonsyndromic-hearing-loss-1": [
		94945,
		3,
		94945
	],
	"./education-center/structured-data/medical/autosomal-dominant-nonsyndromic-hearing-loss-1.json": [
		94945,
		3,
		94945
	],
	"./education-center/structured-data/medical/autosomal-dominant-opitz-gbbb-syndrome": [
		128723,
		3,
		128723
	],
	"./education-center/structured-data/medical/autosomal-dominant-opitz-gbbb-syndrome.json": [
		128723,
		3,
		128723
	],
	"./education-center/structured-data/medical/autosomal-dominant-palmoplantar-keratoderma-and-congenital-alopecia": [
		797416,
		3,
		797416
	],
	"./education-center/structured-data/medical/autosomal-dominant-palmoplantar-keratoderma-and-congenital-alopecia.json": [
		797416,
		3,
		797416
	],
	"./education-center/structured-data/medical/autosomal-dominant-polycystic-liver-disease": [
		906903,
		3,
		906903
	],
	"./education-center/structured-data/medical/autosomal-dominant-polycystic-liver-disease.json": [
		906903,
		3,
		906903
	],
	"./education-center/structured-data/medical/autosomal-dominant-popliteal-pterygium-syndrome": [
		844525,
		3,
		844525
	],
	"./education-center/structured-data/medical/autosomal-dominant-popliteal-pterygium-syndrome.json": [
		844525,
		3,
		844525
	],
	"./education-center/structured-data/medical/autosomal-dominant-progressive-external-ophthalmoplegia": [
		142179,
		3,
		142179
	],
	"./education-center/structured-data/medical/autosomal-dominant-progressive-external-ophthalmoplegia.json": [
		142179,
		3,
		142179
	],
	"./education-center/structured-data/medical/autosomal-dominant-retinitis-pigmentosa": [
		154291,
		3,
		154291
	],
	"./education-center/structured-data/medical/autosomal-dominant-retinitis-pigmentosa.json": [
		154291,
		3,
		154291
	],
	"./education-center/structured-data/medical/autosomal-recessive-axonal-hereditary-motor-and-sensory-neuropathy": [
		823322,
		3,
		823322
	],
	"./education-center/structured-data/medical/autosomal-recessive-axonal-hereditary-motor-and-sensory-neuropathy.json": [
		823322,
		3,
		823322
	],
	"./education-center/structured-data/medical/autosomal-recessive-axonal-neuropathy-neuromyotonia": [
		165095,
		3,
		165095
	],
	"./education-center/structured-data/medical/autosomal-recessive-axonal-neuropathy-neuromyotonia.json": [
		165095,
		3,
		165095
	],
	"./education-center/structured-data/medical/autosomal-recessive-chorioretinopathy-microcephaly-syndrome": [
		270309,
		3,
		270309
	],
	"./education-center/structured-data/medical/autosomal-recessive-chorioretinopathy-microcephaly-syndrome.json": [
		270309,
		3,
		270309
	],
	"./education-center/structured-data/medical/autosomal-recessive-congenital-ichthyosis-5": [
		236662,
		3,
		236662
	],
	"./education-center/structured-data/medical/autosomal-recessive-congenital-ichthyosis-5.json": [
		236662,
		3,
		236662
	],
	"./education-center/structured-data/medical/autosomal-recessive-dejerine-sottas-syndrome": [
		13408,
		3,
		13408
	],
	"./education-center/structured-data/medical/autosomal-recessive-dejerine-sottas-syndrome.json": [
		13408,
		3,
		13408
	],
	"./education-center/structured-data/medical/autosomal-recessive-hearing-impairment-normal-menstrual-cycles": [
		142679,
		3,
		142679
	],
	"./education-center/structured-data/medical/autosomal-recessive-hearing-impairment-normal-menstrual-cycles.json": [
		142679,
		3,
		142679
	],
	"./education-center/structured-data/medical/autosomal-recessive-hypotrichosis-woolly-hair": [
		881368,
		3,
		881368
	],
	"./education-center/structured-data/medical/autosomal-recessive-hypotrichosis-woolly-hair.json": [
		881368,
		3,
		881368
	],
	"./education-center/structured-data/medical/autosomal-recessive-infantile-epilepsy": [
		465410,
		3,
		465410
	],
	"./education-center/structured-data/medical/autosomal-recessive-infantile-epilepsy.json": [
		465410,
		3,
		465410
	],
	"./education-center/structured-data/medical/autosomal-recessive-infantile-hypercalcemia": [
		219739,
		3,
		219739
	],
	"./education-center/structured-data/medical/autosomal-recessive-infantile-hypercalcemia.json": [
		219739,
		3,
		219739
	],
	"./education-center/structured-data/medical/autosomal-recessive-inheritance": [
		391849,
		3,
		391849
	],
	"./education-center/structured-data/medical/autosomal-recessive-inheritance.json": [
		391849,
		3,
		391849
	],
	"./education-center/structured-data/medical/autosomal-recessive-piezo2-associated-disease": [
		695006,
		3,
		695006
	],
	"./education-center/structured-data/medical/autosomal-recessive-piezo2-associated-disease.json": [
		695006,
		3,
		695006
	],
	"./education-center/structured-data/medical/autosomal-recessive-retinitis-pigmentosa": [
		846412,
		3,
		846412
	],
	"./education-center/structured-data/medical/autosomal-recessive-retinitis-pigmentosa.json": [
		846412,
		3,
		846412
	],
	"./education-center/structured-data/medical/autosomal-recessive-syndrome-syndactyly-undescended-testes-and-central-nervous-system-defects": [
		465371,
		3,
		465371
	],
	"./education-center/structured-data/medical/autosomal-recessive-syndrome-syndactyly-undescended-testes-and-central-nervous-system-defects.json": [
		465371,
		3,
		465371
	],
	"./education-center/structured-data/medical/av-block-third-degree-adverse-event": [
		968586,
		3,
		968586
	],
	"./education-center/structured-data/medical/av-block-third-degree-adverse-event.json": [
		968586,
		3,
		968586
	],
	"./education-center/structured-data/medical/av-junctional-rhythm": [
		622870,
		3,
		622870
	],
	"./education-center/structured-data/medical/av-junctional-rhythm.json": [
		622870,
		3,
		622870
	],
	"./education-center/structured-data/medical/axenfeld-rieger-anomaly-partially-absent-eye-muscles-distinctive-face-hydrocephaly-and-skeletal": [
		73634,
		3,
		73634
	],
	"./education-center/structured-data/medical/axenfeld-rieger-anomaly-partially-absent-eye-muscles-distinctive-face-hydrocephaly-and-skeletal.json": [
		73634,
		3,
		73634
	],
	"./education-center/structured-data/medical/axial-hypotonia": [
		345575,
		3,
		345575
	],
	"./education-center/structured-data/medical/axial-hypotonia.json": [
		345575,
		3,
		345575
	],
	"./education-center/structured-data/medical/axial-myopathy-late-onset": [
		581104,
		3,
		581104
	],
	"./education-center/structured-data/medical/axial-myopathy-late-onset.json": [
		581104,
		3,
		581104
	],
	"./education-center/structured-data/medical/axillary-odor": [
		475546,
		3,
		475546
	],
	"./education-center/structured-data/medical/axillary-odor.json": [
		475546,
		3,
		475546
	],
	"./education-center/structured-data/medical/azathioprine-response": [
		881309,
		3,
		881309
	],
	"./education-center/structured-data/medical/azathioprine-response.json": [
		881309,
		3,
		881309
	],
	"./education-center/structured-data/medical/azoospermia": [
		34098,
		3,
		34098
	],
	"./education-center/structured-data/medical/azoospermia.json": [
		34098,
		3,
		34098
	],
	"./education-center/structured-data/medical/azorean-disease": [
		453076,
		3,
		453076
	],
	"./education-center/structured-data/medical/azorean-disease.json": [
		453076,
		3,
		453076
	],
	"./education-center/structured-data/medical/b-acute-lymphoblastic-leukemia": [
		434568,
		3,
		434568
	],
	"./education-center/structured-data/medical/b-acute-lymphoblastic-leukemia.json": [
		434568,
		3,
		434568
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemia-lymphoma-no-icd-o-subtype": [
		184055,
		3,
		184055
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemia-lymphoma-no-icd-o-subtype.json": [
		184055,
		3,
		184055
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemia-lymphoma-t1221p13q22-tel-aml1-etv6-runx1": [
		156713,
		3,
		156713
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemia-lymphoma-t1221p13q22-tel-aml1-etv6-runx1.json": [
		156713,
		3,
		156713
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-not-otherwise-specified": [
		930637,
		3,
		930637
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-not-otherwise-specified.json": [
		930637,
		3,
		930637
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-t922q341q112-bcr-abl1": [
		873020,
		3,
		873020
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-t922q341q112-bcr-abl1.json": [
		873020,
		3,
		873020
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-tv11q233-kmt2a-rearranged": [
		113451,
		3,
		113451
	],
	"./education-center/structured-data/medical/b-lymphoblastic-leukemialymphoma-tv11q233-kmt2a-rearranged.json": [
		113451,
		3,
		113451
	],
	"./education-center/structured-data/medical/bacteremia-susceptibility": [
		995763,
		3,
		995763
	],
	"./education-center/structured-data/medical/bacteremia-susceptibility.json": [
		995763,
		3,
		995763
	],
	"./education-center/structured-data/medical/bannayan-riley-ruvalcaba-syndrome": [
		931965,
		3,
		931965
	],
	"./education-center/structured-data/medical/bannayan-riley-ruvalcaba-syndrome.json": [
		931965,
		3,
		931965
	],
	"./education-center/structured-data/medical/bap1-cancer-syndrome": [
		442906,
		3,
		442906
	],
	"./education-center/structured-data/medical/bap1-cancer-syndrome.json": [
		442906,
		3,
		442906
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-1-modifier": [
		269353,
		3,
		269353
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-1-modifier.json": [
		269353,
		3,
		269353
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-110-digenic": [
		768950,
		3,
		768950
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-110-digenic.json": [
		768950,
		3,
		768950
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-12-digenic": [
		985833,
		3,
		985833
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-12-digenic.json": [
		985833,
		3,
		985833
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-14-modifier": [
		538579,
		3,
		538579
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-14-modifier.json": [
		538579,
		3,
		538579
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-17-digenic": [
		470689,
		3,
		470689
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-17-digenic.json": [
		470689,
		3,
		470689
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-24-digenic": [
		648727,
		3,
		648727
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-24-digenic.json": [
		648727,
		3,
		648727
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-26-digenic": [
		654086,
		3,
		654086
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-26-digenic.json": [
		654086,
		3,
		654086
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-610-digenic": [
		704806,
		3,
		704806
	],
	"./education-center/structured-data/medical/bardet-biedl-syndrome-610-digenic.json": [
		704806,
		3,
		704806
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-2-complementation-group": [
		703147,
		3,
		703147
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-2-complementation-group-e": [
		50045,
		3,
		50045
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-2-complementation-group-e.json": [
		50045,
		3,
		50045
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-2-complementation-group.json": [
		703147,
		3,
		703147
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-b": [
		174331,
		3,
		174331
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-b.json": [
		174331,
		3,
		174331
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-c": [
		474562,
		3,
		474562
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-c.json": [
		474562,
		3,
		474562
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-d": [
		858318,
		3,
		858318
	],
	"./education-center/structured-data/medical/bare-lymphocyte-syndrome-type-ii-complementation-group-d.json": [
		858318,
		3,
		858318
	],
	"./education-center/structured-data/medical/barrett-esophagusesophageal-adenocarcinoma": [
		96196,
		3,
		96196
	],
	"./education-center/structured-data/medical/barrett-esophagusesophageal-adenocarcinoma.json": [
		96196,
		3,
		96196
	],
	"./education-center/structured-data/medical/bartter-disease-type-3": [
		977324,
		3,
		977324
	],
	"./education-center/structured-data/medical/bartter-disease-type-3.json": [
		977324,
		3,
		977324
	],
	"./education-center/structured-data/medical/bartter-disease-type-4b": [
		13578,
		3,
		13578
	],
	"./education-center/structured-data/medical/bartter-disease-type-4b.json": [
		13578,
		3,
		13578
	],
	"./education-center/structured-data/medical/bartter-syndrome-type-3-hypocalciuria": [
		12390,
		3,
		12390
	],
	"./education-center/structured-data/medical/bartter-syndrome-type-3-hypocalciuria.json": [
		12390,
		3,
		12390
	],
	"./education-center/structured-data/medical/basal-cell-carcinoma-somatic": [
		528828,
		3,
		528828
	],
	"./education-center/structured-data/medical/basal-cell-carcinoma-somatic.json": [
		528828,
		3,
		528828
	],
	"./education-center/structured-data/medical/basal-cell-nevus-syndrome-2": [
		301670,
		3,
		301670
	],
	"./education-center/structured-data/medical/basal-cell-nevus-syndrome-2.json": [
		301670,
		3,
		301670
	],
	"./education-center/structured-data/medical/basal-laminar-drusen": [
		706784,
		3,
		706784
	],
	"./education-center/structured-data/medical/basal-laminar-drusen.json": [
		706784,
		3,
		706784
	],
	"./education-center/structured-data/medical/basan-syndrome": [
		451073,
		3,
		451073
	],
	"./education-center/structured-data/medical/basan-syndrome.json": [
		451073,
		3,
		451073
	],
	"./education-center/structured-data/medical/bbs2-related-disorders": [
		589295,
		3,
		589295
	],
	"./education-center/structured-data/medical/bbs2-related-disorders.json": [
		589295,
		3,
		589295
	],
	"./education-center/structured-data/medical/bche-flouride-1": [
		886503,
		3,
		886503
	],
	"./education-center/structured-data/medical/bche-flouride-1.json": [
		886503,
		3,
		886503
	],
	"./education-center/structured-data/medical/bche-fluoride-2": [
		225656,
		3,
		225656
	],
	"./education-center/structured-data/medical/bche-fluoride-2.json": [
		225656,
		3,
		225656
	],
	"./education-center/structured-data/medical/bcs1l-related-disorders": [
		809545,
		3,
		809545
	],
	"./education-center/structured-data/medical/bcs1l-related-disorders.json": [
		809545,
		3,
		809545
	],
	"./education-center/structured-data/medical/beaded-hair": [
		921605,
		3,
		921605
	],
	"./education-center/structured-data/medical/beaded-hair.json": [
		921605,
		3,
		921605
	],
	"./education-center/structured-data/medical/beare-stevenson-cutis-gyrata-syndrome": [
		355265,
		3,
		355265
	],
	"./education-center/structured-data/medical/beare-stevenson-cutis-gyrata-syndrome.json": [
		355265,
		3,
		355265
	],
	"./education-center/structured-data/medical/beckwith-wiedemann-syndrome": [
		792109,
		3,
		792109
	],
	"./education-center/structured-data/medical/beckwith-wiedemann-syndrome.json": [
		792109,
		3,
		792109
	],
	"./education-center/structured-data/medical/behavior-disorder": [
		528916,
		3,
		528916
	],
	"./education-center/structured-data/medical/behavior-disorder.json": [
		528916,
		3,
		528916
	],
	"./education-center/structured-data/medical/behcet-disease": [
		195502,
		3,
		195502
	],
	"./education-center/structured-data/medical/behcet-disease.json": [
		195502,
		3,
		195502
	],
	"./education-center/structured-data/medical/benign-concentric-annular-macular-dystrophy": [
		896775,
		3,
		896775
	],
	"./education-center/structured-data/medical/benign-concentric-annular-macular-dystrophy.json": [
		896775,
		3,
		896775
	],
	"./education-center/structured-data/medical/benign-familial-hematuria": [
		585793,
		3,
		585793
	],
	"./education-center/structured-data/medical/benign-familial-hematuria.json": [
		585793,
		3,
		585793
	],
	"./education-center/structured-data/medical/benign-neonatal-epilepsy": [
		950513,
		3,
		950513
	],
	"./education-center/structured-data/medical/benign-neonatal-epilepsy.json": [
		950513,
		3,
		950513
	],
	"./education-center/structured-data/medical/benign-rolandic-epilepsy": [
		407501,
		3,
		407501
	],
	"./education-center/structured-data/medical/benign-rolandic-epilepsy.json": [
		407501,
		3,
		407501
	],
	"./education-center/structured-data/medical/benign-soft-tissue-neoplasm-uncertain-differentiation": [
		143170,
		3,
		143170
	],
	"./education-center/structured-data/medical/benign-soft-tissue-neoplasm-uncertain-differentiation.json": [
		143170,
		3,
		143170
	],
	"./education-center/structured-data/medical/bent-bone-dysplasia-syndrome-2": [
		661538,
		3,
		661538
	],
	"./education-center/structured-data/medical/bent-bone-dysplasia-syndrome-2.json": [
		661538,
		3,
		661538
	],
	"./education-center/structured-data/medical/benzene-toxicity-susceptibility": [
		510340,
		3,
		510340
	],
	"./education-center/structured-data/medical/benzene-toxicity-susceptibility.json": [
		510340,
		3,
		510340
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-a1": [
		319233,
		3,
		319233
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-a1.json": [
		319233,
		3,
		319233
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-a2-autosomal-dominant": [
		354651,
		3,
		354651
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-a2-autosomal-dominant.json": [
		354651,
		3,
		354651
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-b": [
		314339,
		3,
		314339
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-b.json": [
		314339,
		3,
		314339
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-c": [
		56369,
		3,
		56369
	],
	"./education-center/structured-data/medical/bernard-soulier-syndrome-type-c.json": [
		56369,
		3,
		56369
	],
	"./education-center/structured-data/medical/best1-related-disorders": [
		644141,
		3,
		644141
	],
	"./education-center/structured-data/medical/best1-related-disorders.json": [
		644141,
		3,
		644141
	],
	"./education-center/structured-data/medical/beta-2-adrenoreceptor-agonist-reduced-response": [
		224839,
		3,
		224839
	],
	"./education-center/structured-data/medical/beta-2-adrenoreceptor-agonist-reduced-response.json": [
		224839,
		3,
		224839
	],
	"./education-center/structured-data/medical/beta-glucopyranoside-tasting": [
		934240,
		3,
		934240
	],
	"./education-center/structured-data/medical/beta-glucopyranoside-tasting.json": [
		934240,
		3,
		934240
	],
	"./education-center/structured-data/medical/beta-hexosaminidase-pseudodeficiency": [
		519304,
		3,
		519304
	],
	"./education-center/structured-data/medical/beta-hexosaminidase-pseudodeficiency.json": [
		519304,
		3,
		519304
	],
	"./education-center/structured-data/medical/beta-knossos-thalassemia": [
		891793,
		3,
		891793
	],
	"./education-center/structured-data/medical/beta-knossos-thalassemia.json": [
		891793,
		3,
		891793
	],
	"./education-center/structured-data/medical/beta-malay-thalassemia": [
		591712,
		3,
		591712
	],
	"./education-center/structured-data/medical/beta-malay-thalassemia.json": [
		591712,
		3,
		591712
	],
	"./education-center/structured-data/medical/beta-plus-thalassemia": [
		641751,
		3,
		641751
	],
	"./education-center/structured-data/medical/beta-plus-thalassemia-dominant": [
		949853,
		3,
		949853
	],
	"./education-center/structured-data/medical/beta-plus-thalassemia-dominant.json": [
		949853,
		3,
		949853
	],
	"./education-center/structured-data/medical/beta-plus-thalassemia.json": [
		641751,
		3,
		641751
	],
	"./education-center/structured-data/medical/beta-showa-yakushiji-thalassemia": [
		60451,
		3,
		60451
	],
	"./education-center/structured-data/medical/beta-showa-yakushiji-thalassemia.json": [
		60451,
		3,
		60451
	],
	"./education-center/structured-data/medical/beta-thalassemia-lermontov-type": [
		155869,
		3,
		155869
	],
	"./education-center/structured-data/medical/beta-thalassemia-lermontov-type.json": [
		155869,
		3,
		155869
	],
	"./education-center/structured-data/medical/beta-zero-thalassemia": [
		212600,
		3,
		212600
	],
	"./education-center/structured-data/medical/beta-zero-thalassemia.json": [
		212600,
		3,
		212600
	],
	"./education-center/structured-data/medical/bethlem-myopathy": [
		367989,
		3,
		367989
	],
	"./education-center/structured-data/medical/bethlem-myopathy.json": [
		367989,
		3,
		367989
	],
	"./education-center/structured-data/medical/bh4-deficient-hyperphenylalaninemia": [
		198594,
		3,
		198594
	],
	"./education-center/structured-data/medical/bh4-deficient-hyperphenylalaninemia.json": [
		198594,
		3,
		198594
	],
	"./education-center/structured-data/medical/bilateral-breast-cancer": [
		246838,
		3,
		246838
	],
	"./education-center/structured-data/medical/bilateral-breast-cancer.json": [
		246838,
		3,
		246838
	],
	"./education-center/structured-data/medical/bilateral-cleft-lip": [
		93094,
		3,
		93094
	],
	"./education-center/structured-data/medical/bilateral-cleft-lip.json": [
		93094,
		3,
		93094
	],
	"./education-center/structured-data/medical/bilateral-congenital-mydriasis": [
		690221,
		3,
		690221
	],
	"./education-center/structured-data/medical/bilateral-congenital-mydriasis.json": [
		690221,
		3,
		690221
	],
	"./education-center/structured-data/medical/bilateral-cryptorchidism": [
		532655,
		3,
		532655
	],
	"./education-center/structured-data/medical/bilateral-cryptorchidism.json": [
		532655,
		3,
		532655
	],
	"./education-center/structured-data/medical/bilateral-microphthalmos": [
		104798,
		3,
		104798
	],
	"./education-center/structured-data/medical/bilateral-microphthalmos.json": [
		104798,
		3,
		104798
	],
	"./education-center/structured-data/medical/bilateral-sensorineural-hearing-impairment": [
		546712,
		3,
		546712
	],
	"./education-center/structured-data/medical/bilateral-sensorineural-hearing-impairment.json": [
		546712,
		3,
		546712
	],
	"./education-center/structured-data/medical/bilirubin-serum-level-quantitative-trait-locus-1": [
		479955,
		3,
		479955
	],
	"./education-center/structured-data/medical/bilirubin-serum-level-quantitative-trait-locus-1.json": [
		479955,
		3,
		479955
	],
	"./education-center/structured-data/medical/birk-barel-intellectual-disability-dysmorphism-syndrome": [
		513397,
		3,
		513397
	],
	"./education-center/structured-data/medical/birk-barel-intellectual-disability-dysmorphism-syndrome.json": [
		513397,
		3,
		513397
	],
	"./education-center/structured-data/medical/biventricular-noncompaction-cardiomyopathy": [
		851676,
		3,
		851676
	],
	"./education-center/structured-data/medical/biventricular-noncompaction-cardiomyopathy.json": [
		851676,
		3,
		851676
	],
	"./education-center/structured-data/medical/bjornstad-syndrome-mild-mitochondrial-complex-iii-deficiency": [
		157025,
		3,
		157025
	],
	"./education-center/structured-data/medical/bjornstad-syndrome-mild-mitochondrial-complex-iii-deficiency.json": [
		157025,
		3,
		157025
	],
	"./education-center/structured-data/medical/bladder-cancer-transitional-cell-somatic": [
		712313,
		3,
		712313
	],
	"./education-center/structured-data/medical/bladder-cancer-transitional-cell-somatic.json": [
		712313,
		3,
		712313
	],
	"./education-center/structured-data/medical/bleeding-disorder-platelet-type-macrothrombocytopenia": [
		638680,
		3,
		638680
	],
	"./education-center/structured-data/medical/bleeding-disorder-platelet-type-macrothrombocytopenia.json": [
		638680,
		3,
		638680
	],
	"./education-center/structured-data/medical/blepharophimosis": [
		896628,
		3,
		896628
	],
	"./education-center/structured-data/medical/blepharophimosis-ptosis-and-epicanthus-inversus-syndrome": [
		618309,
		3,
		618309
	],
	"./education-center/structured-data/medical/blepharophimosis-ptosis-and-epicanthus-inversus-syndrome.json": [
		618309,
		3,
		618309
	],
	"./education-center/structured-data/medical/blepharophimosis-ptosis-and-epicanthus-inversus-type-ii-duane-retraction-syndrome": [
		307107,
		3,
		307107
	],
	"./education-center/structured-data/medical/blepharophimosis-ptosis-and-epicanthus-inversus-type-ii-duane-retraction-syndrome.json": [
		307107,
		3,
		307107
	],
	"./education-center/structured-data/medical/blepharophimosis.json": [
		896628,
		3,
		896628
	],
	"./education-center/structured-data/medical/blindness": [
		679598,
		3,
		679598
	],
	"./education-center/structured-data/medical/blindness.json": [
		679598,
		3,
		679598
	],
	"./education-center/structured-data/medical/blood-group-diego-system": [
		652623,
		3,
		652623
	],
	"./education-center/structured-data/medical/blood-group-diego-system.json": [
		652623,
		3,
		652623
	],
	"./education-center/structured-data/medical/blood-group-dombrock-system": [
		552228,
		3,
		552228
	],
	"./education-center/structured-data/medical/blood-group-dombrock-system.json": [
		552228,
		3,
		552228
	],
	"./education-center/structured-data/medical/blood-group-er": [
		15879,
		3,
		15879
	],
	"./education-center/structured-data/medical/blood-group-er.json": [
		15879,
		3,
		15879
	],
	"./education-center/structured-data/medical/blood-group-erik": [
		958047,
		3,
		958047
	],
	"./education-center/structured-data/medical/blood-group-erik.json": [
		958047,
		3,
		958047
	],
	"./education-center/structured-data/medical/blood-group-froese": [
		901449,
		3,
		901449
	],
	"./education-center/structured-data/medical/blood-group-froese.json": [
		901449,
		3,
		901449
	],
	"./education-center/structured-data/medical/blood-group-gerbich-system": [
		459288,
		3,
		459288
	],
	"./education-center/structured-data/medical/blood-group-gerbich-system.json": [
		459288,
		3,
		459288
	],
	"./education-center/structured-data/medical/blood-group-indian-system": [
		338223,
		3,
		338223
	],
	"./education-center/structured-data/medical/blood-group-indian-system.json": [
		338223,
		3,
		338223
	],
	"./education-center/structured-data/medical/blood-group-junior-system": [
		503953,
		3,
		503953
	],
	"./education-center/structured-data/medical/blood-group-junior-system.json": [
		503953,
		3,
		503953
	],
	"./education-center/structured-data/medical/blood-group-lutheran-inhibitor": [
		395164,
		3,
		395164
	],
	"./education-center/structured-data/medical/blood-group-lutheran-inhibitor.json": [
		395164,
		3,
		395164
	],
	"./education-center/structured-data/medical/blood-group-lutheran-null": [
		962722,
		3,
		962722
	],
	"./education-center/structured-data/medical/blood-group-lutheran-null.json": [
		962722,
		3,
		962722
	],
	"./education-center/structured-data/medical/blood-group-ok": [
		737359,
		3,
		737359
	],
	"./education-center/structured-data/medical/blood-group-ok.json": [
		737359,
		3,
		737359
	],
	"./education-center/structured-data/medical/blood-group-sid-system": [
		809856,
		3,
		809856
	],
	"./education-center/structured-data/medical/blood-group-sid-system.json": [
		809856,
		3,
		809856
	],
	"./education-center/structured-data/medical/blood-group-ss": [
		825426,
		3,
		825426
	],
	"./education-center/structured-data/medical/blood-group-ss.json": [
		825426,
		3,
		825426
	],
	"./education-center/structured-data/medical/blood-group-waldner-type": [
		212065,
		3,
		212065
	],
	"./education-center/structured-data/medical/blood-group-waldner-type.json": [
		212065,
		3,
		212065
	],
	"./education-center/structured-data/medical/blood-group-wright-antigen": [
		24762,
		3,
		24762
	],
	"./education-center/structured-data/medical/blood-group-wright-antigen.json": [
		24762,
		3,
		24762
	],
	"./education-center/structured-data/medical/blue-rubber-bleb-nevus": [
		810162,
		3,
		810162
	],
	"./education-center/structured-data/medical/blue-rubber-bleb-nevus.json": [
		810162,
		3,
		810162
	],
	"./education-center/structured-data/medical/bmp4-related-syndromic-microphthalmia": [
		107494,
		3,
		107494
	],
	"./education-center/structured-data/medical/bmp4-related-syndromic-microphthalmia.json": [
		107494,
		3,
		107494
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-10": [
		942490,
		3,
		942490
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-10.json": [
		942490,
		3,
		942490
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-18": [
		995531,
		3,
		995531
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-18.json": [
		995531,
		3,
		995531
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-19": [
		760983,
		3,
		760983
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-19.json": [
		760983,
		3,
		760983
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-20": [
		415591,
		3,
		415591
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-20.json": [
		415591,
		3,
		415591
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-4": [
		340481,
		3,
		340481
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-4.json": [
		340481,
		3,
		340481
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-9": [
		911656,
		3,
		911656
	],
	"./education-center/structured-data/medical/body-mass-index-quantitative-trait-locus-9.json": [
		911656,
		3,
		911656
	],
	"./education-center/structured-data/medical/bombay-phenotype": [
		308646,
		3,
		308646
	],
	"./education-center/structured-data/medical/bombay-phenotype-digenic": [
		780281,
		3,
		780281
	],
	"./education-center/structured-data/medical/bombay-phenotype-digenic.json": [
		780281,
		3,
		780281
	],
	"./education-center/structured-data/medical/bombay-phenotype.json": [
		308646,
		3,
		308646
	],
	"./education-center/structured-data/medical/bone-marrow-hypocellularity": [
		943177,
		3,
		943177
	],
	"./education-center/structured-data/medical/bone-marrow-hypocellularity.json": [
		943177,
		3,
		943177
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-1": [
		626362,
		3,
		626362
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-1.json": [
		626362,
		3,
		626362
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-15": [
		409607,
		3,
		409607
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-15.json": [
		409607,
		3,
		409607
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-17": [
		695167,
		3,
		695167
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-17.json": [
		695167,
		3,
		695167
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-18": [
		826785,
		3,
		826785
	],
	"./education-center/structured-data/medical/bone-mineral-density-quantitative-trait-locus-18.json": [
		826785,
		3,
		826785
	],
	"./education-center/structured-data/medical/bone-mineral-density-variation": [
		101953,
		3,
		101953
	],
	"./education-center/structured-data/medical/bone-mineral-density-variation-quantitative-trait-locus": [
		895868,
		3,
		895868
	],
	"./education-center/structured-data/medical/bone-mineral-density-variation-quantitative-trait-locus.json": [
		895868,
		3,
		895868
	],
	"./education-center/structured-data/medical/bone-mineral-density-variation.json": [
		101953,
		3,
		101953
	],
	"./education-center/structured-data/medical/boomerang-dysplasia": [
		186469,
		3,
		186469
	],
	"./education-center/structured-data/medical/boomerang-dysplasia.json": [
		186469,
		3,
		186469
	],
	"./education-center/structured-data/medical/brachydactyly-arterial-hypertension-syndrome": [
		600613,
		3,
		600613
	],
	"./education-center/structured-data/medical/brachydactyly-arterial-hypertension-syndrome.json": [
		600613,
		3,
		600613
	],
	"./education-center/structured-data/medical/brachydactyly-preaxial-hallux-varus-syndrome": [
		425484,
		3,
		425484
	],
	"./education-center/structured-data/medical/brachydactyly-preaxial-hallux-varus-syndrome.json": [
		425484,
		3,
		425484
	],
	"./education-center/structured-data/medical/brachydactyly-syndrome-type-e": [
		937476,
		3,
		937476
	],
	"./education-center/structured-data/medical/brachydactyly-syndrome-type-e.json": [
		937476,
		3,
		937476
	],
	"./education-center/structured-data/medical/brachydactyly-type-a1": [
		176165,
		3,
		176165
	],
	"./education-center/structured-data/medical/brachydactyly-type-a1.json": [
		176165,
		3,
		176165
	],
	"./education-center/structured-data/medical/brachydactyly-type-a2": [
		545852,
		3,
		545852
	],
	"./education-center/structured-data/medical/brachydactyly-type-a2.json": [
		545852,
		3,
		545852
	],
	"./education-center/structured-data/medical/brachydactyly-type-b1": [
		364935,
		3,
		364935
	],
	"./education-center/structured-data/medical/brachydactyly-type-b1.json": [
		364935,
		3,
		364935
	],
	"./education-center/structured-data/medical/brachydactyly-type-b1robinow-syndrome-autosomal-recessive": [
		8089,
		3,
		8089
	],
	"./education-center/structured-data/medical/brachydactyly-type-b1robinow-syndrome-autosomal-recessive.json": [
		8089,
		3,
		8089
	],
	"./education-center/structured-data/medical/brachydactyly-type-c": [
		365242,
		3,
		365242
	],
	"./education-center/structured-data/medical/brachydactyly-type-c.json": [
		365242,
		3,
		365242
	],
	"./education-center/structured-data/medical/brachydactyly-type-d": [
		692280,
		3,
		692280
	],
	"./education-center/structured-data/medical/brachydactyly-type-d.json": [
		692280,
		3,
		692280
	],
	"./education-center/structured-data/medical/brachydactyly-type-e1": [
		439726,
		3,
		439726
	],
	"./education-center/structured-data/medical/brachydactyly-type-e1.json": [
		439726,
		3,
		439726
	],
	"./education-center/structured-data/medical/brachyrachia-short-spine-dysplasia": [
		674225,
		3,
		674225
	],
	"./education-center/structured-data/medical/brachyrachia-short-spine-dysplasia.json": [
		674225,
		3,
		674225
	],
	"./education-center/structured-data/medical/braddock-carey-syndrome-2": [
		540545,
		3,
		540545
	],
	"./education-center/structured-data/medical/braddock-carey-syndrome-2.json": [
		540545,
		3,
		540545
	],
	"./education-center/structured-data/medical/brain-tumor-polyposis-syndrome-2": [
		441187,
		3,
		441187
	],
	"./education-center/structured-data/medical/brain-tumor-polyposis-syndrome-2.json": [
		441187,
		3,
		441187
	],
	"./education-center/structured-data/medical/branchiooculofacial-syndrome": [
		797908,
		3,
		797908
	],
	"./education-center/structured-data/medical/branchiooculofacial-syndrome.json": [
		797908,
		3,
		797908
	],
	"./education-center/structured-data/medical/branchiootorenal-spectrum-disorders": [
		610223,
		3,
		610223
	],
	"./education-center/structured-data/medical/branchiootorenal-spectrum-disorders.json": [
		610223,
		3,
		610223
	],
	"./education-center/structured-data/medical/branchiootorenal-syndrome-1": [
		867898,
		3,
		867898
	],
	"./education-center/structured-data/medical/branchiootorenal-syndrome-1.json": [
		867898,
		3,
		867898
	],
	"./education-center/structured-data/medical/branchiootorenal-syndrome-cataract": [
		411922,
		3,
		411922
	],
	"./education-center/structured-data/medical/branchiootorenal-syndrome-cataract.json": [
		411922,
		3,
		411922
	],
	"./education-center/structured-data/medical/brca2-related-disorders": [
		826392,
		3,
		826392
	],
	"./education-center/structured-data/medical/brca2-related-disorders.json": [
		826392,
		3,
		826392
	],
	"./education-center/structured-data/medical/breast-and-colorectal-cancer": [
		673784,
		3,
		673784
	],
	"./education-center/structured-data/medical/breast-and-colorectal-cancer-susceptibility": [
		306273,
		3,
		306273
	],
	"./education-center/structured-data/medical/breast-and-colorectal-cancer-susceptibility.json": [
		306273,
		3,
		306273
	],
	"./education-center/structured-data/medical/breast-and-colorectal-cancer.json": [
		673784,
		3,
		673784
	],
	"./education-center/structured-data/medical/breast-and-ovarian-cancer-susceptibility": [
		523624,
		3,
		523624
	],
	"./education-center/structured-data/medical/breast-and-ovarian-cancer-susceptibility.json": [
		523624,
		3,
		523624
	],
	"./education-center/structured-data/medical/breast-andor-ovarian-cancer": [
		565786,
		3,
		565786
	],
	"./education-center/structured-data/medical/breast-andor-ovarian-cancer.json": [
		565786,
		3,
		565786
	],
	"./education-center/structured-data/medical/breast-cancer-early-onset": [
		408273,
		3,
		408273
	],
	"./education-center/structured-data/medical/breast-cancer-early-onset.json": [
		408273,
		3,
		408273
	],
	"./education-center/structured-data/medical/breast-cancer-post-chemotherapy-poor-survival": [
		308086,
		3,
		308086
	],
	"./education-center/structured-data/medical/breast-cancer-post-chemotherapy-poor-survival.json": [
		308086,
		3,
		308086
	],
	"./education-center/structured-data/medical/breast-cancer-protection-against": [
		409294,
		3,
		409294
	],
	"./education-center/structured-data/medical/breast-cancer-protection-against.json": [
		409294,
		3,
		409294
	],
	"./education-center/structured-data/medical/breast-cancer-susceptibility": [
		310765,
		3,
		310765
	],
	"./education-center/structured-data/medical/breast-cancer-susceptibility.json": [
		310765,
		3,
		310765
	],
	"./education-center/structured-data/medical/breast-lobular-carcinoma": [
		861276,
		3,
		861276
	],
	"./education-center/structured-data/medical/breast-lobular-carcinoma.json": [
		861276,
		3,
		861276
	],
	"./education-center/structured-data/medical/brip1-related-disorders": [
		402758,
		3,
		402758
	],
	"./education-center/structured-data/medical/brip1-related-disorders.json": [
		402758,
		3,
		402758
	],
	"./education-center/structured-data/medical/british-hpfh": [
		207699,
		3,
		207699
	],
	"./education-center/structured-data/medical/british-hpfh.json": [
		207699,
		3,
		207699
	],
	"./education-center/structured-data/medical/broad-distal-phalanx-thumb": [
		631697,
		3,
		631697
	],
	"./education-center/structured-data/medical/broad-distal-phalanx-thumb.json": [
		631697,
		3,
		631697
	],
	"./education-center/structured-data/medical/bronchiectasis-or-without-elevated-sweat-chloride-1-modifier": [
		645560,
		3,
		645560
	],
	"./education-center/structured-data/medical/bronchiectasis-or-without-elevated-sweat-chloride-1-modifier.json": [
		645560,
		3,
		645560
	],
	"./education-center/structured-data/medical/brown-oculocutaneous-albinism": [
		377631,
		3,
		377631
	],
	"./education-center/structured-data/medical/brown-oculocutaneous-albinism.json": [
		377631,
		3,
		377631
	],
	"./education-center/structured-data/medical/brugada-syndrome-lidocaine-induced": [
		915101,
		3,
		915101
	],
	"./education-center/structured-data/medical/brugada-syndrome-lidocaine-induced.json": [
		915101,
		3,
		915101
	],
	"./education-center/structured-data/medical/brugada-syndrome-shorter-normal-qt-interval": [
		265292,
		3,
		265292
	],
	"./education-center/structured-data/medical/brugada-syndrome-shorter-normal-qt-interval.json": [
		265292,
		3,
		265292
	],
	"./education-center/structured-data/medical/bullous-ichthyosiform-erythroderma": [
		5791,
		3,
		5791
	],
	"./education-center/structured-data/medical/bullous-ichthyosiform-erythroderma.json": [
		5791,
		3,
		5791
	],
	"./education-center/structured-data/medical/bun-creatinine-ratio-high-and-low-levels-normal-range": [
		580576,
		3,
		580576
	],
	"./education-center/structured-data/medical/bun-creatinine-ratio-high-and-low-levels-normal-range.json": [
		580576,
		3,
		580576
	],
	"./education-center/structured-data/medical/burkitt-lymphoma": [
		283618,
		3,
		283618
	],
	"./education-center/structured-data/medical/burkitt-lymphoma.json": [
		283618,
		3,
		283618
	],
	"./education-center/structured-data/medical/butyrylcholinesterase-deficiency-fluoride-resistant-japanese-type": [
		37439,
		3,
		37439
	],
	"./education-center/structured-data/medical/butyrylcholinesterase-deficiency-fluoride-resistant-japanese-type.json": [
		37439,
		3,
		37439
	],
	"./education-center/structured-data/medical/c1q-deficiency-2": [
		289097,
		3,
		289097
	],
	"./education-center/structured-data/medical/c1q-deficiency-2.json": [
		289097,
		3,
		289097
	],
	"./education-center/structured-data/medical/c1q-deficiency-3": [
		650873,
		3,
		650873
	],
	"./education-center/structured-data/medical/c1q-deficiency-3.json": [
		650873,
		3,
		650873
	],
	"./education-center/structured-data/medical/c2-deficiency-type-i": [
		201202,
		3,
		201202
	],
	"./education-center/structured-data/medical/c2-deficiency-type-i.json": [
		201202,
		3,
		201202
	],
	"./education-center/structured-data/medical/c2-deficiency-type-ii": [
		54622,
		3,
		54622
	],
	"./education-center/structured-data/medical/c2-deficiency-type-ii.json": [
		54622,
		3,
		54622
	],
	"./education-center/structured-data/medical/c3-deficiency": [
		709566,
		3,
		709566
	],
	"./education-center/structured-data/medical/c3-deficiency.json": [
		709566,
		3,
		709566
	],
	"./education-center/structured-data/medical/c3hex-ability-smell": [
		223652,
		3,
		223652
	],
	"./education-center/structured-data/medical/c3hex-ability-smell.json": [
		223652,
		3,
		223652
	],
	"./education-center/structured-data/medical/c6-deficiency-subtotal": [
		719855,
		3,
		719855
	],
	"./education-center/structured-data/medical/c6-deficiency-subtotal.json": [
		719855,
		3,
		719855
	],
	"./education-center/structured-data/medical/c7-and-c6-deficiency-combined-subtotal": [
		714339,
		3,
		714339
	],
	"./education-center/structured-data/medical/c7-and-c6-deficiency-combined-subtotal.json": [
		714339,
		3,
		714339
	],
	"./education-center/structured-data/medical/cafe-au-lait-spot": [
		255582,
		3,
		255582
	],
	"./education-center/structured-data/medical/cafe-au-lait-spot.json": [
		255582,
		3,
		255582
	],
	"./education-center/structured-data/medical/cafe-au-lait-spots-multiple": [
		337767,
		3,
		337767
	],
	"./education-center/structured-data/medical/cafe-au-lait-spots-multiple.json": [
		337767,
		3,
		337767
	],
	"./education-center/structured-data/medical/calfan-syndrome": [
		132773,
		3,
		132773
	],
	"./education-center/structured-data/medical/calfan-syndrome.json": [
		132773,
		3,
		132773
	],
	"./education-center/structured-data/medical/calvarial-doughnut-lesions-bone-fragility-or-without-spondylometaphyseal-dysplasia": [
		680182,
		3,
		680182
	],
	"./education-center/structured-data/medical/calvarial-doughnut-lesions-bone-fragility-or-without-spondylometaphyseal-dysplasia.json": [
		680182,
		3,
		680182
	],
	"./education-center/structured-data/medical/calvarial-doughnut-lesions-bone-fragility-syndrome": [
		958298,
		3,
		958298
	],
	"./education-center/structured-data/medical/calvarial-doughnut-lesions-bone-fragility-syndrome.json": [
		958298,
		3,
		958298
	],
	"./education-center/structured-data/medical/campomelic-dysplasia-autosomal-sex-reversal": [
		564747,
		3,
		564747
	],
	"./education-center/structured-data/medical/campomelic-dysplasia-autosomal-sex-reversal.json": [
		564747,
		3,
		564747
	],
	"./education-center/structured-data/medical/camptomelic-dysplasia": [
		286016,
		3,
		286016
	],
	"./education-center/structured-data/medical/camptomelic-dysplasia.json": [
		286016,
		3,
		286016
	],
	"./education-center/structured-data/medical/canavan-disease-familial-form": [
		37030,
		3,
		37030
	],
	"./education-center/structured-data/medical/canavan-disease-familial-form.json": [
		37030,
		3,
		37030
	],
	"./education-center/structured-data/medical/cancer-alopecia-pigment-dyscrasia-onychodystrophy-and-keratoderma": [
		328043,
		3,
		328043
	],
	"./education-center/structured-data/medical/cancer-alopecia-pigment-dyscrasia-onychodystrophy-and-keratoderma.json": [
		328043,
		3,
		328043
	],
	"./education-center/structured-data/medical/cancer-pancreas": [
		919699,
		3,
		919699
	],
	"./education-center/structured-data/medical/cancer-pancreas.json": [
		919699,
		3,
		919699
	],
	"./education-center/structured-data/medical/cancer-progression-and-tumor-cell-motility": [
		452881,
		3,
		452881
	],
	"./education-center/structured-data/medical/cancer-progression-and-tumor-cell-motility.json": [
		452881,
		3,
		452881
	],
	"./education-center/structured-data/medical/cap-congenital-myopathy-arthrogryposis-multiplex-congenita-without-heart-involvement": [
		280238,
		3,
		280238
	],
	"./education-center/structured-data/medical/cap-congenital-myopathy-arthrogryposis-multiplex-congenita-without-heart-involvement.json": [
		280238,
		3,
		280238
	],
	"./education-center/structured-data/medical/capn3-related-disorders": [
		152476,
		3,
		152476
	],
	"./education-center/structured-data/medical/capn3-related-disorders.json": [
		152476,
		3,
		152476
	],
	"./education-center/structured-data/medical/captopril-response-efficacy": [
		208343,
		3,
		208343
	],
	"./education-center/structured-data/medical/captopril-response-efficacy.json": [
		208343,
		3,
		208343
	],
	"./education-center/structured-data/medical/carbamazepine-hypersensitivity": [
		103555,
		3,
		103555
	],
	"./education-center/structured-data/medical/carbamazepine-hypersensitivity.json": [
		103555,
		3,
		103555
	],
	"./education-center/structured-data/medical/carbamazepine-response-dosage": [
		387645,
		3,
		387645
	],
	"./education-center/structured-data/medical/carbamazepine-response-dosage.json": [
		387645,
		3,
		387645
	],
	"./education-center/structured-data/medical/carbonic-anhydrase-i-deficiency": [
		542533,
		3,
		542533
	],
	"./education-center/structured-data/medical/carbonic-anhydrase-i-deficiency.json": [
		542533,
		3,
		542533
	],
	"./education-center/structured-data/medical/carbonic-anhydrase-i-guam": [
		304797,
		3,
		304797
	],
	"./education-center/structured-data/medical/carbonic-anhydrase-i-guam.json": [
		304797,
		3,
		304797
	],
	"./education-center/structured-data/medical/carboxymethyl-dextran-a2-gadolinium-dota": [
		823216,
		3,
		823216
	],
	"./education-center/structured-data/medical/carboxymethyl-dextran-a2-gadolinium-dota.json": [
		823216,
		3,
		823216
	],
	"./education-center/structured-data/medical/carcinoma-adrenocortical-androgen-secreting": [
		135183,
		3,
		135183
	],
	"./education-center/structured-data/medical/carcinoma-adrenocortical-androgen-secreting.json": [
		135183,
		3,
		135183
	],
	"./education-center/structured-data/medical/carcinoma-head-pancreas": [
		713541,
		3,
		713541
	],
	"./education-center/structured-data/medical/carcinoma-head-pancreas.json": [
		713541,
		3,
		713541
	],
	"./education-center/structured-data/medical/carcinoma-male-breast": [
		750079,
		3,
		750079
	],
	"./education-center/structured-data/medical/carcinoma-male-breast.json": [
		750079,
		3,
		750079
	],
	"./education-center/structured-data/medical/cardiac-arrest": [
		937038,
		3,
		937038
	],
	"./education-center/structured-data/medical/cardiac-arrest.json": [
		937038,
		3,
		937038
	],
	"./education-center/structured-data/medical/cardiac-conduction-defect-nonprogressive": [
		663134,
		3,
		663134
	],
	"./education-center/structured-data/medical/cardiac-conduction-defect-nonprogressive.json": [
		663134,
		3,
		663134
	],
	"./education-center/structured-data/medical/cardiac-valvular-dysplasia-2": [
		529237,
		3,
		529237
	],
	"./education-center/structured-data/medical/cardiac-valvular-dysplasia-2.json": [
		529237,
		3,
		529237
	],
	"./education-center/structured-data/medical/cardio-cutaneous-syndrome": [
		909790,
		3,
		909790
	],
	"./education-center/structured-data/medical/cardio-cutaneous-syndrome.json": [
		909790,
		3,
		909790
	],
	"./education-center/structured-data/medical/cardiofaciocutaneous-syndrome-1": [
		434235,
		3,
		434235
	],
	"./education-center/structured-data/medical/cardiofaciocutaneous-syndrome-1.json": [
		434235,
		3,
		434235
	],
	"./education-center/structured-data/medical/cardiomyopathy-and-deafness": [
		848698,
		3,
		848698
	],
	"./education-center/structured-data/medical/cardiomyopathy-and-deafness.json": [
		848698,
		3,
		848698
	],
	"./education-center/structured-data/medical/cardiomyopathy-apical-hypertrophic-and-neuropathy": [
		478853,
		3,
		478853
	],
	"./education-center/structured-data/medical/cardiomyopathy-apical-hypertrophic-and-neuropathy.json": [
		478853,
		3,
		478853
	],
	"./education-center/structured-data/medical/cardiomyopathy-familial-restrictive-1": [
		507342,
		3,
		507342
	],
	"./education-center/structured-data/medical/cardiomyopathy-familial-restrictive-1.json": [
		507342,
		3,
		507342
	],
	"./education-center/structured-data/medical/cardiomyopathy-familial-restrictive-4": [
		819567,
		3,
		385419
	],
	"./education-center/structured-data/medical/cardiomyopathy-familial-restrictive-4.json": [
		819567,
		3,
		385419
	],
	"./education-center/structured-data/medical/cardiomyopathy-fatal": [
		273772,
		3,
		273772
	],
	"./education-center/structured-data/medical/cardiomyopathy-fatal-infantile": [
		559897,
		3,
		559897
	],
	"./education-center/structured-data/medical/cardiomyopathy-fatal-infantile.json": [
		559897,
		3,
		559897
	],
	"./education-center/structured-data/medical/cardiomyopathy-fatal.json": [
		273772,
		3,
		273772
	],
	"./education-center/structured-data/medical/cardiomyopathy-hypertrophic-midventricular-digenic": [
		623405,
		3,
		623405
	],
	"./education-center/structured-data/medical/cardiomyopathy-hypertrophic-midventricular-digenic.json": [
		623405,
		3,
		623405
	],
	"./education-center/structured-data/medical/cardiomyopathy-hypertrophic-mitochondrial": [
		551592,
		3,
		551592
	],
	"./education-center/structured-data/medical/cardiomyopathy-hypertrophic-mitochondrial.json": [
		551592,
		3,
		551592
	],
	"./education-center/structured-data/medical/cardiomyopathy-idiopathic-dilated-mitochondrial": [
		697947,
		3,
		697947
	],
	"./education-center/structured-data/medical/cardiomyopathy-idiopathic-dilated-mitochondrial.json": [
		697947,
		3,
		697947
	],
	"./education-center/structured-data/medical/cardiomyopathy-mitochondrial": [
		178292,
		3,
		178292
	],
	"./education-center/structured-data/medical/cardiomyopathy-mitochondrial.json": [
		178292,
		3,
		178292
	],
	"./education-center/structured-data/medical/cardiomyopathy-or-without-skeletal-myopathy": [
		308151,
		3,
		308151
	],
	"./education-center/structured-data/medical/cardiomyopathy-or-without-skeletal-myopathy.json": [
		308151,
		3,
		308151
	],
	"./education-center/structured-data/medical/cardiospondylocarpofacial-syndrome": [
		960673,
		3,
		960673
	],
	"./education-center/structured-data/medical/cardiospondylocarpofacial-syndrome.json": [
		960673,
		3,
		960673
	],
	"./education-center/structured-data/medical/cardiovascular-phenotype": [
		698900,
		3,
		698900
	],
	"./education-center/structured-data/medical/cardiovascular-phenotype.json": [
		698900,
		3,
		698900
	],
	"./education-center/structured-data/medical/carotid-intimal-medial-thickness-1": [
		685800,
		3,
		685800
	],
	"./education-center/structured-data/medical/carotid-intimal-medial-thickness-1.json": [
		685800,
		3,
		685800
	],
	"./education-center/structured-data/medical/carpal-osteolysis": [
		151705,
		3,
		151705
	],
	"./education-center/structured-data/medical/carpal-osteolysis.json": [
		151705,
		3,
		151705
	],
	"./education-center/structured-data/medical/carpal-tunnel-syndrome": [
		582166,
		3,
		582166
	],
	"./education-center/structured-data/medical/carpal-tunnel-syndrome.json": [
		582166,
		3,
		582166
	],
	"./education-center/structured-data/medical/cartilage-hair-hypoplasia-anauxetic-dysplasia-spectrum-disorders": [
		99140,
		3,
		99140
	],
	"./education-center/structured-data/medical/cartilage-hair-hypoplasia-anauxetic-dysplasia-spectrum-disorders.json": [
		99140,
		3,
		99140
	],
	"./education-center/structured-data/medical/cataract-1-multiple-types": [
		777487,
		3,
		777487
	],
	"./education-center/structured-data/medical/cataract-1-multiple-types.json": [
		777487,
		3,
		777487
	],
	"./education-center/structured-data/medical/cataract-11-posterior-polar": [
		725876,
		3,
		725876
	],
	"./education-center/structured-data/medical/cataract-11-posterior-polar-microphthalmia-and-neurodevelopmental-abnormalities": [
		74238,
		3,
		74238
	],
	"./education-center/structured-data/medical/cataract-11-posterior-polar-microphthalmia-and-neurodevelopmental-abnormalities.json": [
		74238,
		3,
		74238
	],
	"./education-center/structured-data/medical/cataract-11-posterior-polar.json": [
		725876,
		3,
		725876
	],
	"./education-center/structured-data/medical/cataract-13-adult-i-phenotype": [
		112323,
		3,
		112323
	],
	"./education-center/structured-data/medical/cataract-13-adult-i-phenotype.json": [
		112323,
		3,
		112323
	],
	"./education-center/structured-data/medical/cataract-2-coppock": [
		76531,
		3,
		76531
	],
	"./education-center/structured-data/medical/cataract-2-coppock.json": [
		76531,
		3,
		76531
	],
	"./education-center/structured-data/medical/cataract-20-multiple-types": [
		204923,
		3,
		204923
	],
	"./education-center/structured-data/medical/cataract-20-multiple-types.json": [
		204923,
		3,
		204923
	],
	"./education-center/structured-data/medical/cataract-30": [
		103630,
		3,
		103630
	],
	"./education-center/structured-data/medical/cataract-30.json": [
		103630,
		3,
		103630
	],
	"./education-center/structured-data/medical/cataract-33": [
		222970,
		3,
		222970
	],
	"./education-center/structured-data/medical/cataract-33.json": [
		222970,
		3,
		222970
	],
	"./education-center/structured-data/medical/cataract-36": [
		570002,
		3,
		570002
	],
	"./education-center/structured-data/medical/cataract-36.json": [
		570002,
		3,
		570002
	],
	"./education-center/structured-data/medical/cataract-38": [
		923854,
		3,
		923854
	],
	"./education-center/structured-data/medical/cataract-38.json": [
		923854,
		3,
		923854
	],
	"./education-center/structured-data/medical/cataract-4-multiple-types": [
		233587,
		3,
		233587
	],
	"./education-center/structured-data/medical/cataract-4-multiple-types.json": [
		233587,
		3,
		233587
	],
	"./education-center/structured-data/medical/cataract-41": [
		99203,
		3,
		99203
	],
	"./education-center/structured-data/medical/cataract-41.json": [
		99203,
		3,
		99203
	],
	"./education-center/structured-data/medical/cataract-43": [
		535574,
		3,
		535574
	],
	"./education-center/structured-data/medical/cataract-43.json": [
		535574,
		3,
		535574
	],
	"./education-center/structured-data/medical/cataract-5-multiple-types": [
		688756,
		3,
		688756
	],
	"./education-center/structured-data/medical/cataract-5-multiple-types.json": [
		688756,
		3,
		688756
	],
	"./education-center/structured-data/medical/cataract-6-age-related-cortical": [
		825724,
		3,
		825724
	],
	"./education-center/structured-data/medical/cataract-6-age-related-cortical.json": [
		825724,
		3,
		825724
	],
	"./education-center/structured-data/medical/cataract-6-multiple-types": [
		982835,
		3,
		982835
	],
	"./education-center/structured-data/medical/cataract-6-multiple-types.json": [
		982835,
		3,
		982835
	],
	"./education-center/structured-data/medical/cataract-9-autosomal-recessive": [
		993099,
		3,
		993099
	],
	"./education-center/structured-data/medical/cataract-9-autosomal-recessive.json": [
		993099,
		3,
		993099
	],
	"./education-center/structured-data/medical/cataract-9-multiple-types-microcornea": [
		499680,
		3,
		499680
	],
	"./education-center/structured-data/medical/cataract-9-multiple-types-microcornea.json": [
		499680,
		3,
		499680
	],
	"./education-center/structured-data/medical/cataracts-congenital-late-onset-corneal-dystrophy": [
		414242,
		3,
		414242
	],
	"./education-center/structured-data/medical/cataracts-congenital-late-onset-corneal-dystrophy.json": [
		414242,
		3,
		414242
	],
	"./education-center/structured-data/medical/cataracts-spastic-paraparesis-and-speech-delay": [
		804369,
		3,
		804369
	],
	"./education-center/structured-data/medical/cataracts-spastic-paraparesis-and-speech-delay.json": [
		804369,
		3,
		804369
	],
	"./education-center/structured-data/medical/caused-mutation-tafazzin-gene": [
		113911,
		3,
		113911
	],
	"./education-center/structured-data/medical/caused-mutation-tafazzin-gene.json": [
		113911,
		3,
		113911
	],
	"./education-center/structured-data/medical/cc2d2a-related-disorders": [
		186226,
		3,
		186226
	],
	"./education-center/structured-data/medical/cc2d2a-related-disorders.json": [
		186226,
		3,
		186226
	],
	"./education-center/structured-data/medical/cd99-positive-neoplastic-cells-present": [
		911970,
		3,
		911970
	],
	"./education-center/structured-data/medical/cd99-positive-neoplastic-cells-present.json": [
		911970,
		3,
		911970
	],
	"./education-center/structured-data/medical/cdh23-related-disorders": [
		681840,
		3,
		681840
	],
	"./education-center/structured-data/medical/cdh23-related-disorders.json": [
		681840,
		3,
		681840
	],
	"./education-center/structured-data/medical/central-core-disease-autosomal-recessive": [
		790996,
		3,
		790996
	],
	"./education-center/structured-data/medical/central-core-disease-autosomal-recessive.json": [
		790996,
		3,
		790996
	],
	"./education-center/structured-data/medical/central-core-myopathy": [
		810063,
		3,
		810063
	],
	"./education-center/structured-data/medical/central-core-myopathy.json": [
		810063,
		3,
		810063
	],
	"./education-center/structured-data/medical/centromeric-instability-chromosomes-19-and-16-and-immunodeficiency": [
		552180,
		3,
		552180
	],
	"./education-center/structured-data/medical/centromeric-instability-chromosomes-19-and-16-and-immunodeficiency.json": [
		552180,
		3,
		552180
	],
	"./education-center/structured-data/medical/centronuclear-myopathy-dominant": [
		466506,
		3,
		466506
	],
	"./education-center/structured-data/medical/centronuclear-myopathy-dominant.json": [
		466506,
		3,
		466506
	],
	"./education-center/structured-data/medical/cep152-related-disorders": [
		750639,
		3,
		750639
	],
	"./education-center/structured-data/medical/cep152-related-disorders.json": [
		750639,
		3,
		750639
	],
	"./education-center/structured-data/medical/cep290-related-disorders": [
		419050,
		3,
		419050
	],
	"./education-center/structured-data/medical/cep290-related-disorders.json": [
		419050,
		3,
		419050
	],
	"./education-center/structured-data/medical/cerebellar-ataxia": [
		867879,
		3,
		867879
	],
	"./education-center/structured-data/medical/cerebellar-ataxia-cataract-and-diabetes-mellitus": [
		41341,
		3,
		41341
	],
	"./education-center/structured-data/medical/cerebellar-ataxia-cataract-and-diabetes-mellitus.json": [
		41341,
		3,
		41341
	],
	"./education-center/structured-data/medical/cerebellar-ataxia.json": [
		867879,
		3,
		867879
	],
	"./education-center/structured-data/medical/cerebellar-cyst": [
		14339,
		3,
		14339
	],
	"./education-center/structured-data/medical/cerebellar-cyst.json": [
		14339,
		3,
		14339
	],
	"./education-center/structured-data/medical/cerebellar-medulloblastoma": [
		406830,
		3,
		406830
	],
	"./education-center/structured-data/medical/cerebellar-medulloblastoma.json": [
		406830,
		3,
		406830
	],
	"./education-center/structured-data/medical/cerebellar-vermis-hypoplasia": [
		325623,
		3,
		325623
	],
	"./education-center/structured-data/medical/cerebellar-vermis-hypoplasia.json": [
		325623,
		3,
		325623
	],
	"./education-center/structured-data/medical/cerebral-amyloid-angiopathy-prnp-related": [
		373369,
		3,
		373369
	],
	"./education-center/structured-data/medical/cerebral-amyloid-angiopathy-prnp-related.json": [
		373369,
		3,
		373369
	],
	"./education-center/structured-data/medical/cerebral-arteriopathy-autosomal-dominant-subcortical-infarcts-and-leukoencephalopathy-type-1": [
		489436,
		3,
		489436
	],
	"./education-center/structured-data/medical/cerebral-arteriopathy-autosomal-dominant-subcortical-infarcts-and-leukoencephalopathy-type-1.json": [
		489436,
		3,
		489436
	],
	"./education-center/structured-data/medical/cerebral-arteriovenous-malformation": [
		256239,
		3,
		256239
	],
	"./education-center/structured-data/medical/cerebral-arteriovenous-malformation.json": [
		256239,
		3,
		256239
	],
	"./education-center/structured-data/medical/cerebral-atrophy": [
		47156,
		3,
		47156
	],
	"./education-center/structured-data/medical/cerebral-atrophy.json": [
		47156,
		3,
		47156
	],
	"./education-center/structured-data/medical/cerebral-autosomal-dominant-arteriopathy-subcortical-infarcts-and-leukoencephalopathy": [
		262949,
		3,
		262949
	],
	"./education-center/structured-data/medical/cerebral-autosomal-dominant-arteriopathy-subcortical-infarcts-and-leukoencephalopathy.json": [
		262949,
		3,
		262949
	],
	"./education-center/structured-data/medical/cerebral-cavernous-malformation": [
		581995,
		3,
		581995
	],
	"./education-center/structured-data/medical/cerebral-cavernous-malformation.json": [
		581995,
		3,
		581995
	],
	"./education-center/structured-data/medical/cerebral-creatine-deficiency-syndrome": [
		607496,
		3,
		607496
	],
	"./education-center/structured-data/medical/cerebral-creatine-deficiency-syndrome.json": [
		607496,
		3,
		607496
	],
	"./education-center/structured-data/medical/cerebral-edema": [
		851816,
		3,
		851816
	],
	"./education-center/structured-data/medical/cerebral-edema.json": [
		851816,
		3,
		851816
	],
	"./education-center/structured-data/medical/cerebral-hemorrhage": [
		470006,
		3,
		470006
	],
	"./education-center/structured-data/medical/cerebral-hemorrhage.json": [
		470006,
		3,
		470006
	],
	"./education-center/structured-data/medical/cerebral-hypomyelination": [
		231979,
		3,
		231979
	],
	"./education-center/structured-data/medical/cerebral-hypomyelination.json": [
		231979,
		3,
		231979
	],
	"./education-center/structured-data/medical/cerebral-infarction-susceptibility": [
		940370,
		3,
		940370
	],
	"./education-center/structured-data/medical/cerebral-infarction-susceptibility.json": [
		940370,
		3,
		940370
	],
	"./education-center/structured-data/medical/cerebral-palsy": [
		106214,
		3,
		106214
	],
	"./education-center/structured-data/medical/cerebral-palsy-spastic-quadriplegic": [
		677923,
		3,
		677923
	],
	"./education-center/structured-data/medical/cerebral-palsy-spastic-quadriplegic.json": [
		677923,
		3,
		677923
	],
	"./education-center/structured-data/medical/cerebral-palsy.json": [
		106214,
		3,
		106214
	],
	"./education-center/structured-data/medical/cerebral-visual-impairment-and-intellectual-disability": [
		155324,
		3,
		155324
	],
	"./education-center/structured-data/medical/cerebral-visual-impairment-and-intellectual-disability.json": [
		155324,
		3,
		155324
	],
	"./education-center/structured-data/medical/cerebro-costo-mandibular-syndrome": [
		526086,
		3,
		526086
	],
	"./education-center/structured-data/medical/cerebro-costo-mandibular-syndrome.json": [
		526086,
		3,
		526086
	],
	"./education-center/structured-data/medical/ceroid-lipofuscinosis-neuronal-3-protracted": [
		958823,
		3,
		958823
	],
	"./education-center/structured-data/medical/ceroid-lipofuscinosis-neuronal-3-protracted.json": [
		958823,
		3,
		958823
	],
	"./education-center/structured-data/medical/cfh-related-dense-deposit-disease-membranoproliferative-glomerulonephritis-type-ii": [
		947354,
		3,
		947354
	],
	"./education-center/structured-data/medical/cfh-related-dense-deposit-disease-membranoproliferative-glomerulonephritis-type-ii.json": [
		947354,
		3,
		947354
	],
	"./education-center/structured-data/medical/cfh-related-disorders": [
		598399,
		3,
		598399
	],
	"./education-center/structured-data/medical/cfh-related-disorders.json": [
		598399,
		3,
		598399
	],
	"./education-center/structured-data/medical/cfhr5-deficiency": [
		712396,
		3,
		712396
	],
	"./education-center/structured-data/medical/cfhr5-deficiency.json": [
		712396,
		3,
		712396
	],
	"./education-center/structured-data/medical/cfi-related-disorders": [
		670444,
		3,
		670444
	],
	"./education-center/structured-data/medical/cfi-related-disorders.json": [
		670444,
		3,
		670444
	],
	"./education-center/structured-data/medical/channelopathy": [
		996447,
		3,
		996447
	],
	"./education-center/structured-data/medical/channelopathy.json": [
		996447,
		3,
		996447
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-axonal-type-2p": [
		708643,
		3,
		708643
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-axonal-type-2p.json": [
		708643,
		3,
		708643
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-dominant-intermediate-b-neutropenia": [
		986747,
		3,
		986747
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-dominant-intermediate-b-neutropenia.json": [
		986747,
		3,
		986747
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1a-autosomal-recessive": [
		434910,
		3,
		434910
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1a-autosomal-recessive.json": [
		434910,
		3,
		434910
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1a-focally-folded-myelin-sheaths": [
		165503,
		3,
		165503
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1a-focally-folded-myelin-sheaths.json": [
		165503,
		3,
		165503
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1b": [
		133647,
		3,
		133647
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1b-focally-folded-myelin-sheaths": [
		893455,
		3,
		893455
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1b-focally-folded-myelin-sheaths.json": [
		893455,
		3,
		893455
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1b.json": [
		133647,
		3,
		133647
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1e": [
		139633,
		3,
		139633
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-1e.json": [
		139633,
		3,
		139633
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-2a1": [
		69477,
		3,
		69477
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-2a1.json": [
		69477,
		3,
		69477
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-4b2-early-onset-glaucoma": [
		544167,
		3,
		544167
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-4b2-early-onset-glaucoma.json": [
		544167,
		3,
		544167
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-ia": [
		905516,
		3,
		905516
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-disease-type-ia.json": [
		905516,
		3,
		905516
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-intermediate": [
		601717,
		3,
		601717
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-intermediate.json": [
		601717,
		3,
		601717
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-neuropathy-x": [
		421693,
		3,
		421693
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-neuropathy-x.json": [
		421693,
		3,
		421693
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-vocal-cord-paresis": [
		14052,
		3,
		14052
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-vocal-cord-paresis.json": [
		14052,
		3,
		14052
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-x-linked": [
		582128,
		3,
		582128
	],
	"./education-center/structured-data/medical/charcot-marie-tooth-x-linked.json": [
		582128,
		3,
		582128
	],
	"./education-center/structured-data/medical/chediak-higashi-syndrome-adult-type": [
		137278,
		3,
		137278
	],
	"./education-center/structured-data/medical/chediak-higashi-syndrome-adult-type.json": [
		137278,
		3,
		137278
	],
	"./education-center/structured-data/medical/chediak-higashi-syndrome-childhood-type": [
		64112,
		3,
		64112
	],
	"./education-center/structured-data/medical/chediak-higashi-syndrome-childhood-type.json": [
		64112,
		3,
		64112
	],
	"./education-center/structured-data/medical/chek2-related-cancer-susceptibility": [
		3330,
		3,
		3330
	],
	"./education-center/structured-data/medical/chek2-related-cancer-susceptibility.json": [
		3330,
		3,
		3330
	],
	"./education-center/structured-data/medical/chiari-malformation": [
		634120,
		3,
		634120
	],
	"./education-center/structured-data/medical/chiari-malformation.json": [
		634120,
		3,
		634120
	],
	"./education-center/structured-data/medical/childhood-epilepsy-centrotemporal-spikes": [
		601341,
		3,
		601341
	],
	"./education-center/structured-data/medical/childhood-epilepsy-centrotemporal-spikes.json": [
		601341,
		3,
		601341
	],
	"./education-center/structured-data/medical/childhood-ganglioglioma": [
		833848,
		3,
		833848
	],
	"./education-center/structured-data/medical/childhood-ganglioglioma.json": [
		833848,
		3,
		833848
	],
	"./education-center/structured-data/medical/childhood-hypophosphatasia": [
		740359,
		3,
		740359
	],
	"./education-center/structured-data/medical/childhood-hypophosphatasia.json": [
		740359,
		3,
		740359
	],
	"./education-center/structured-data/medical/childhood-myocerebrohepatopathy-spectrum": [
		360242,
		3,
		360242
	],
	"./education-center/structured-data/medical/childhood-myocerebrohepatopathy-spectrum.json": [
		360242,
		3,
		360242
	],
	"./education-center/structured-data/medical/childhood-onset-sensorineural-hearing-impairment": [
		789709,
		3,
		789709
	],
	"./education-center/structured-data/medical/childhood-onset-sensorineural-hearing-impairment.json": [
		789709,
		3,
		789709
	],
	"./education-center/structured-data/medical/chitotriosidase-deficiency": [
		514064,
		3,
		514064
	],
	"./education-center/structured-data/medical/chitotriosidase-deficiency.json": [
		514064,
		3,
		514064
	],
	"./education-center/structured-data/medical/chloramphenicol-resistance": [
		641717,
		3,
		641717
	],
	"./education-center/structured-data/medical/chloramphenicol-resistance.json": [
		641717,
		3,
		641717
	],
	"./education-center/structured-data/medical/cholestasis-intrahepatic-pregnancy-1": [
		959714,
		3,
		959714
	],
	"./education-center/structured-data/medical/cholestasis-intrahepatic-pregnancy-1.json": [
		959714,
		3,
		959714
	],
	"./education-center/structured-data/medical/cholesteatoma": [
		912278,
		3,
		912278
	],
	"./education-center/structured-data/medical/cholesteatoma-middle-ear": [
		594726,
		3,
		594726
	],
	"./education-center/structured-data/medical/cholesteatoma-middle-ear.json": [
		594726,
		3,
		594726
	],
	"./education-center/structured-data/medical/cholesteatoma.json": [
		912278,
		3,
		912278
	],
	"./education-center/structured-data/medical/chondrocalcinosis": [
		428508,
		3,
		428508
	],
	"./education-center/structured-data/medical/chondrocalcinosis-2": [
		819982,
		3,
		819982
	],
	"./education-center/structured-data/medical/chondrocalcinosis-2-sporadic": [
		544127,
		3,
		544127
	],
	"./education-center/structured-data/medical/chondrocalcinosis-2-sporadic.json": [
		544127,
		3,
		544127
	],
	"./education-center/structured-data/medical/chondrocalcinosis-2.json": [
		819982,
		3,
		819982
	],
	"./education-center/structured-data/medical/chondrocalcinosis.json": [
		428508,
		3,
		428508
	],
	"./education-center/structured-data/medical/chondrodysplasia-punctata-2-x-linked-dominant": [
		730570,
		3,
		730570
	],
	"./education-center/structured-data/medical/chondrodysplasia-punctata-2-x-linked-dominant.json": [
		730570,
		3,
		730570
	],
	"./education-center/structured-data/medical/chorioretinal-coloboma": [
		664529,
		3,
		664529
	],
	"./education-center/structured-data/medical/chorioretinal-coloboma.json": [
		664529,
		3,
		664529
	],
	"./education-center/structured-data/medical/choroidal-dystrophy": [
		920655,
		3,
		920655
	],
	"./education-center/structured-data/medical/choroidal-dystrophy.json": [
		920655,
		3,
		920655
	],
	"./education-center/structured-data/medical/chrna1-related-congenital-myasthenic-syndrome": [
		196891,
		3,
		196891
	],
	"./education-center/structured-data/medical/chrna1-related-congenital-myasthenic-syndrome.json": [
		196891,
		3,
		196891
	],
	"./education-center/structured-data/medical/chromosome-2q231-deletion-syndrome": [
		881526,
		3,
		881526
	],
	"./education-center/structured-data/medical/chromosome-2q231-deletion-syndrome.json": [
		881526,
		3,
		881526
	],
	"./education-center/structured-data/medical/chronic-adenoiditis": [
		941733,
		3,
		941733
	],
	"./education-center/structured-data/medical/chronic-adenoiditis.json": [
		941733,
		3,
		941733
	],
	"./education-center/structured-data/medical/chronic-and-progressive-ataxia": [
		233767,
		3,
		233767
	],
	"./education-center/structured-data/medical/chronic-and-progressive-ataxia.json": [
		233767,
		3,
		233767
	],
	"./education-center/structured-data/medical/chronic-granulomatous-disease-autosomal-due-deficiency-cyba": [
		810306,
		3,
		810306
	],
	"./education-center/structured-data/medical/chronic-granulomatous-disease-autosomal-due-deficiency-cyba.json": [
		810306,
		3,
		810306
	],
	"./education-center/structured-data/medical/chronic-granulomatous-disease-due-deficiency-ncf-1": [
		805741,
		3,
		805741
	],
	"./education-center/structured-data/medical/chronic-granulomatous-disease-due-deficiency-ncf-1.json": [
		805741,
		3,
		805741
	],
	"./education-center/structured-data/medical/chronic-lung-disease": [
		738611,
		3,
		738611
	],
	"./education-center/structured-data/medical/chronic-lung-disease.json": [
		738611,
		3,
		738611
	],
	"./education-center/structured-data/medical/chronic-sinusitis": [
		364426,
		3,
		364426
	],
	"./education-center/structured-data/medical/chronic-sinusitis.json": [
		364426,
		3,
		364426
	],
	"./education-center/structured-data/medical/cic-dux-sarcoma": [
		783013,
		3,
		783013
	],
	"./education-center/structured-data/medical/cic-dux-sarcoma.json": [
		783013,
		3,
		783013
	],
	"./education-center/structured-data/medical/cirrhosis-cryptogenic": [
		878770,
		3,
		878770
	],
	"./education-center/structured-data/medical/cirrhosis-cryptogenic.json": [
		878770,
		3,
		878770
	],
	"./education-center/structured-data/medical/cirrhosis-familial": [
		855757,
		3,
		855757
	],
	"./education-center/structured-data/medical/cirrhosis-familial.json": [
		855757,
		3,
		855757
	],
	"./education-center/structured-data/medical/citrullinemia-mild": [
		927378,
		3,
		927378
	],
	"./education-center/structured-data/medical/citrullinemia-mild.json": [
		927378,
		3,
		927378
	],
	"./education-center/structured-data/medical/classical-galactosemia-homozygous-duarte-type": [
		99110,
		3,
		99110
	],
	"./education-center/structured-data/medical/classical-galactosemia-homozygous-duarte-type.json": [
		99110,
		3,
		99110
	],
	"./education-center/structured-data/medical/classical-primary-microcephaly": [
		993867,
		3,
		993867
	],
	"./education-center/structured-data/medical/classical-primary-microcephaly.json": [
		993867,
		3,
		993867
	],
	"./education-center/structured-data/medical/clcn4-related-disorder": [
		576319,
		3,
		576319
	],
	"./education-center/structured-data/medical/clcn4-related-disorder.json": [
		576319,
		3,
		576319
	],
	"./education-center/structured-data/medical/cleft-lip-cleft-palate-autosomal-dominant": [
		284337,
		3,
		284337
	],
	"./education-center/structured-data/medical/cleft-lip-cleft-palate-autosomal-dominant.json": [
		284337,
		3,
		284337
	],
	"./education-center/structured-data/medical/cleft-palate-ankyloglossia": [
		270446,
		3,
		270446
	],
	"./education-center/structured-data/medical/cleft-palate-ankyloglossia.json": [
		270446,
		3,
		270446
	],
	"./education-center/structured-data/medical/cleidocranial-dysostosis": [
		67253,
		3,
		67253
	],
	"./education-center/structured-data/medical/cleidocranial-dysostosis.json": [
		67253,
		3,
		67253
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-1-forme-fruste-brachydactyly": [
		953498,
		3,
		953498
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-1-forme-fruste-brachydactyly.json": [
		953498,
		3,
		953498
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-1-forme-fruste-dental-anomalies-only": [
		727644,
		3,
		727644
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-1-forme-fruste-dental-anomalies-only.json": [
		727644,
		3,
		727644
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-2": [
		99263,
		3,
		99263
	],
	"./education-center/structured-data/medical/cleidocranial-dysplasia-2.json": [
		99263,
		3,
		99263
	],
	"./education-center/structured-data/medical/clopidogrel-response": [
		596096,
		3,
		596096
	],
	"./education-center/structured-data/medical/clopidogrel-response-efficacy": [
		966486,
		3,
		966486
	],
	"./education-center/structured-data/medical/clopidogrel-response-efficacy.json": [
		966486,
		3,
		966486
	],
	"./education-center/structured-data/medical/clopidogrel-response.json": [
		596096,
		3,
		596096
	],
	"./education-center/structured-data/medical/clubfoot": [
		473943,
		3,
		473943
	],
	"./education-center/structured-data/medical/clubfoot.json": [
		473943,
		3,
		473943
	],
	"./education-center/structured-data/medical/cngb3-related-disorders": [
		562493,
		3,
		562493
	],
	"./education-center/structured-data/medical/cngb3-related-disorders.json": [
		562493,
		3,
		562493
	],
	"./education-center/structured-data/medical/coagulation-factor-deficiency-syndrome": [
		130656,
		3,
		130656
	],
	"./education-center/structured-data/medical/coagulation-factor-deficiency-syndrome.json": [
		130656,
		3,
		130656
	],
	"./education-center/structured-data/medical/cocaine-related-disorders": [
		375059,
		3,
		375059
	],
	"./education-center/structured-data/medical/cocaine-related-disorders.json": [
		375059,
		3,
		375059
	],
	"./education-center/structured-data/medical/coenzyme-q10-deficiency-oculomotor-apraxia-type": [
		300964,
		3,
		300964
	],
	"./education-center/structured-data/medical/coenzyme-q10-deficiency-oculomotor-apraxia-type.json": [
		300964,
		3,
		300964
	],
	"./education-center/structured-data/medical/coenzyme-q10-deficiency-spinocerebellar-ataxia-type": [
		752373,
		3,
		752373
	],
	"./education-center/structured-data/medical/coenzyme-q10-deficiency-spinocerebellar-ataxia-type.json": [
		752373,
		3,
		752373
	],
	"./education-center/structured-data/medical/coffin-siris-syndrome-1": [
		559840,
		3,
		559840
	],
	"./education-center/structured-data/medical/coffin-siris-syndrome-1.json": [
		559840,
		3,
		559840
	],
	"./education-center/structured-data/medical/coffin-sirisintellectual-disability": [
		586099,
		3,
		586099
	],
	"./education-center/structured-data/medical/coffin-sirisintellectual-disability.json": [
		586099,
		3,
		586099
	],
	"./education-center/structured-data/medical/cognitive-impairment": [
		64536,
		3,
		64536
	],
	"./education-center/structured-data/medical/cognitive-impairment.json": [
		64536,
		3,
		64536
	],
	"./education-center/structured-data/medical/colchicine-resistance": [
		620498,
		3,
		620498
	],
	"./education-center/structured-data/medical/colchicine-resistance.json": [
		620498,
		3,
		620498
	],
	"./education-center/structured-data/medical/cole-carpenter-syndrome-1": [
		887766,
		3,
		887766
	],
	"./education-center/structured-data/medical/cole-carpenter-syndrome-1.json": [
		887766,
		3,
		887766
	],
	"./education-center/structured-data/medical/collapse-finding": [
		665319,
		3,
		665319
	],
	"./education-center/structured-data/medical/collapse-finding.json": [
		665319,
		3,
		665319
	],
	"./education-center/structured-data/medical/coloboma-congenital-heart-disease-ichthyosiform-dermatosis-intellectual-disability-and-ear-anomalies": [
		911425,
		3,
		911425
	],
	"./education-center/structured-data/medical/coloboma-congenital-heart-disease-ichthyosiform-dermatosis-intellectual-disability-and-ear-anomalies.json": [
		911425,
		3,
		911425
	],
	"./education-center/structured-data/medical/coloboma-ocular-autosomal-dominant": [
		432198,
		3,
		432198
	],
	"./education-center/structured-data/medical/coloboma-ocular-autosomal-dominant.json": [
		432198,
		3,
		432198
	],
	"./education-center/structured-data/medical/coloboma-optic-nerve": [
		896856,
		3,
		896856
	],
	"./education-center/structured-data/medical/coloboma-optic-nerve.json": [
		896856,
		3,
		896856
	],
	"./education-center/structured-data/medical/colon-cancer-advanced": [
		265355,
		3,
		265355
	],
	"./education-center/structured-data/medical/colon-cancer-advanced.json": [
		265355,
		3,
		265355
	],
	"./education-center/structured-data/medical/colon-cancer-susceptibility": [
		995903,
		3,
		995903
	],
	"./education-center/structured-data/medical/colon-cancer-susceptibility.json": [
		995903,
		3,
		995903
	],
	"./education-center/structured-data/medical/colonic-neoplasm": [
		651413,
		3,
		651413
	],
	"./education-center/structured-data/medical/colonic-neoplasm.json": [
		651413,
		3,
		651413
	],
	"./education-center/structured-data/medical/color-vision-defect": [
		139382,
		3,
		139382
	],
	"./education-center/structured-data/medical/color-vision-defect.json": [
		139382,
		3,
		139382
	],
	"./education-center/structured-data/medical/colorectal-adenoma": [
		880156,
		3,
		880156
	],
	"./education-center/structured-data/medical/colorectal-adenoma.json": [
		880156,
		3,
		880156
	],
	"./education-center/structured-data/medical/colorectal-adenomatous-polyposis-autosomal-recessive-pilomatricomas": [
		183171,
		3,
		183171
	],
	"./education-center/structured-data/medical/colorectal-adenomatous-polyposis-autosomal-recessive-pilomatricomas.json": [
		183171,
		3,
		183171
	],
	"./education-center/structured-data/medical/colorectal-cancer": [
		133946,
		3,
		133946
	],
	"./education-center/structured-data/medical/colorectal-cancer-chromosomal-instability-somatic": [
		133562,
		3,
		133562
	],
	"./education-center/structured-data/medical/colorectal-cancer-chromosomal-instability-somatic.json": [
		133562,
		3,
		133562
	],
	"./education-center/structured-data/medical/colorectal-cancer-early-onset": [
		932346,
		3,
		932346
	],
	"./education-center/structured-data/medical/colorectal-cancer-early-onset.json": [
		932346,
		3,
		932346
	],
	"./education-center/structured-data/medical/colorectal-cancer-non-polyposis": [
		952162,
		3,
		952162
	],
	"./education-center/structured-data/medical/colorectal-cancer-non-polyposis.json": [
		952162,
		3,
		952162
	],
	"./education-center/structured-data/medical/colorectal-cancer-protection-against": [
		541010,
		3,
		541010
	],
	"./education-center/structured-data/medical/colorectal-cancer-protection-against.json": [
		541010,
		3,
		541010
	],
	"./education-center/structured-data/medical/colorectal-cancer-susceptibility": [
		765730,
		3,
		765730
	],
	"./education-center/structured-data/medical/colorectal-cancer-susceptibility.json": [
		765730,
		3,
		765730
	],
	"./education-center/structured-data/medical/colorectal-cancer.json": [
		133946,
		3,
		133946
	],
	"./education-center/structured-data/medical/colorectal-endometrial-cancer": [
		636952,
		3,
		636952
	],
	"./education-center/structured-data/medical/colorectal-endometrial-cancer.json": [
		636952,
		3,
		636952
	],
	"./education-center/structured-data/medical/colostrum-secretion": [
		959097,
		3,
		959097
	],
	"./education-center/structured-data/medical/colostrum-secretion.json": [
		959097,
		3,
		959097
	],
	"./education-center/structured-data/medical/colton-null-phenotype": [
		678134,
		3,
		678134
	],
	"./education-center/structured-data/medical/colton-null-phenotype.json": [
		678134,
		3,
		678134
	],
	"./education-center/structured-data/medical/combined-oxidative-phosphorylation-deficiency": [
		716442,
		3,
		716442
	],
	"./education-center/structured-data/medical/combined-oxidative-phosphorylation-deficiency.json": [
		716442,
		3,
		716442
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-dominant": [
		864668,
		3,
		864668
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-dominant.json": [
		864668,
		3,
		864668
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-dominantrecessive": [
		12780,
		3,
		12780
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-dominantrecessive.json": [
		12780,
		3,
		12780
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-recessive": [
		757721,
		3,
		757721
	],
	"./education-center/structured-data/medical/combined-pituitary-hormone-deficiency-recessive.json": [
		757721,
		3,
		757721
	],
	"./education-center/structured-data/medical/common-variable-immune-deficiency-dominant": [
		94717,
		3,
		94717
	],
	"./education-center/structured-data/medical/common-variable-immune-deficiency-dominant.json": [
		94717,
		3,
		94717
	],
	"./education-center/structured-data/medical/common-variable-immune-deficiency-recessive": [
		521028,
		3,
		521028
	],
	"./education-center/structured-data/medical/common-variable-immune-deficiency-recessive.json": [
		521028,
		3,
		521028
	],
	"./education-center/structured-data/medical/complement-component-4-partial-deficiency-due-dysfunctional-c1-inhibitor": [
		637213,
		3,
		637213
	],
	"./education-center/structured-data/medical/complement-component-4-partial-deficiency-due-dysfunctional-c1-inhibitor.json": [
		637213,
		3,
		637213
	],
	"./education-center/structured-data/medical/complex-febrile-seizure": [
		496040,
		3,
		496040
	],
	"./education-center/structured-data/medical/complex-febrile-seizure.json": [
		496040,
		3,
		496040
	],
	"./education-center/structured-data/medical/concentric-hypertrophic-cardiomyopathy": [
		767252,
		3,
		767252
	],
	"./education-center/structured-data/medical/concentric-hypertrophic-cardiomyopathy.json": [
		767252,
		3,
		767252
	],
	"./education-center/structured-data/medical/cone-dystrophy": [
		651347,
		3,
		651347
	],
	"./education-center/structured-data/medical/cone-dystrophy.json": [
		651347,
		3,
		651347
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-2": [
		621547,
		3,
		621547
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-2.json": [
		621547,
		3,
		621547
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-24": [
		948692,
		3,
		948692
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-24.json": [
		948692,
		3,
		948692
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-aipl1-related": [
		66272,
		3,
		66272
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-aipl1-related.json": [
		66272,
		3,
		66272
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-dominant": [
		632441,
		3,
		632441
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-dominant.json": [
		632441,
		3,
		632441
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-recessive": [
		757381,
		3,
		757381
	],
	"./education-center/structured-data/medical/cone-rod-dystrophy-recessive.json": [
		757381,
		3,
		757381
	],
	"./education-center/structured-data/medical/congenital-adrenal-insufficiency": [
		22053,
		3,
		22053
	],
	"./education-center/structured-data/medical/congenital-adrenal-insufficiency.json": [
		22053,
		3,
		22053
	],
	"./education-center/structured-data/medical/congenital-and-infantile-nephrotic-syndrome": [
		241191,
		3,
		241191
	],
	"./education-center/structured-data/medical/congenital-and-infantile-nephrotic-syndrome.json": [
		241191,
		3,
		241191
	],
	"./education-center/structured-data/medical/congenital-blindness": [
		394818,
		3,
		394818
	],
	"./education-center/structured-data/medical/congenital-blindness.json": [
		394818,
		3,
		394818
	],
	"./education-center/structured-data/medical/congenital-contractural-arachnodactyly": [
		114701,
		3,
		114701
	],
	"./education-center/structured-data/medical/congenital-contractural-arachnodactyly.json": [
		114701,
		3,
		114701
	],
	"./education-center/structured-data/medical/congenital-diaphragmatic-hernia": [
		465444,
		3,
		465444
	],
	"./education-center/structured-data/medical/congenital-diaphragmatic-hernia.json": [
		465444,
		3,
		465444
	],
	"./education-center/structured-data/medical/congenital-disorder-glycosylation-type-i": [
		389365,
		3,
		389365
	],
	"./education-center/structured-data/medical/congenital-disorder-glycosylation-type-i.json": [
		389365,
		3,
		389365
	],
	"./education-center/structured-data/medical/congenital-disorder-glycosylation-type-ii": [
		518483,
		3,
		518483
	],
	"./education-center/structured-data/medical/congenital-disorder-glycosylation-type-ii.json": [
		518483,
		3,
		518483
	],
	"./education-center/structured-data/medical/congenital-disorders-glycosylation-type-ii": [
		315666,
		3,
		315666
	],
	"./education-center/structured-data/medical/congenital-disorders-glycosylation-type-ii.json": [
		315666,
		3,
		315666
	],
	"./education-center/structured-data/medical/congenital-dyserythropoietic-anemia-type-iii": [
		931816,
		3,
		931816
	],
	"./education-center/structured-data/medical/congenital-dyserythropoietic-anemia-type-iii.json": [
		931816,
		3,
		931816
	],
	"./education-center/structured-data/medical/congenital-fibrosis-extraocular-muscles": [
		639507,
		3,
		639507
	],
	"./education-center/structured-data/medical/congenital-fibrosis-extraocular-muscles.json": [
		639507,
		3,
		639507
	],
	"./education-center/structured-data/medical/congenital-generalized-lipodystrophy": [
		631078,
		3,
		631078
	],
	"./education-center/structured-data/medical/congenital-generalized-lipodystrophy.json": [
		631078,
		3,
		631078
	],
	"./education-center/structured-data/medical/congenital-heart-defects-1-nonsyndromic-1": [
		47319,
		3,
		47319
	],
	"./education-center/structured-data/medical/congenital-heart-defects-1-nonsyndromic-1.json": [
		47319,
		3,
		47319
	],
	"./education-center/structured-data/medical/congenital-heart-defects-multiple-types-8-or-without-heterotaxy": [
		229661,
		3,
		229661
	],
	"./education-center/structured-data/medical/congenital-heart-defects-multiple-types-8-or-without-heterotaxy.json": [
		229661,
		3,
		229661
	],
	"./education-center/structured-data/medical/congenital-heart-defects-multiple-types-9": [
		908440,
		3,
		908440
	],
	"./education-center/structured-data/medical/congenital-heart-defects-multiple-types-9.json": [
		908440,
		3,
		908440
	],
	"./education-center/structured-data/medical/congenital-heart-disease": [
		887686,
		3,
		887686
	],
	"./education-center/structured-data/medical/congenital-heart-disease-variable": [
		313344,
		3,
		313344
	],
	"./education-center/structured-data/medical/congenital-heart-disease-variable.json": [
		313344,
		3,
		313344
	],
	"./education-center/structured-data/medical/congenital-heart-disease.json": [
		887686,
		3,
		887686
	],
	"./education-center/structured-data/medical/congenital-hemolytic-anemia": [
		812108,
		3,
		812108
	],
	"./education-center/structured-data/medical/congenital-hemolytic-anemia.json": [
		812108,
		3,
		812108
	],
	"./education-center/structured-data/medical/congenital-ichthyosis-skin": [
		62262,
		3,
		62262
	],
	"./education-center/structured-data/medical/congenital-ichthyosis-skin.json": [
		62262,
		3,
		62262
	],
	"./education-center/structured-data/medical/congenital-indifference-pain": [
		52639,
		3,
		52639
	],
	"./education-center/structured-data/medical/congenital-indifference-pain.json": [
		52639,
		3,
		52639
	],
	"./education-center/structured-data/medical/congenital-lactic-acidosis": [
		356945,
		3,
		356945
	],
	"./education-center/structured-data/medical/congenital-lactic-acidosis.json": [
		356945,
		3,
		356945
	],
	"./education-center/structured-data/medical/congenital-macrodactylia": [
		818883,
		3,
		818883
	],
	"./education-center/structured-data/medical/congenital-macrodactylia.json": [
		818883,
		3,
		818883
	],
	"./education-center/structured-data/medical/congenital-microvillous-atrophy": [
		93521,
		3,
		93521
	],
	"./education-center/structured-data/medical/congenital-microvillous-atrophy.json": [
		93521,
		3,
		93521
	],
	"./education-center/structured-data/medical/congenital-multicore-myopathy-external-ophthalmoplegia": [
		595489,
		3,
		595489
	],
	"./education-center/structured-data/medical/congenital-multicore-myopathy-external-ophthalmoplegia.json": [
		595489,
		3,
		595489
	],
	"./education-center/structured-data/medical/congenital-muscular-alpha-dystroglycanopathy-brain-and-eye-anomalies": [
		712714,
		3,
		712714
	],
	"./education-center/structured-data/medical/congenital-muscular-alpha-dystroglycanopathy-brain-and-eye-anomalies.json": [
		712714,
		3,
		712714
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-alpha-dystroglycan-related": [
		705536,
		3,
		705536
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-alpha-dystroglycan-related.json": [
		705536,
		3,
		705536
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-chkb-related": [
		332115,
		3,
		332115
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-chkb-related.json": [
		332115,
		3,
		332115
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-due-partial-lama2-deficiency": [
		4493,
		3,
		4493
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-due-partial-lama2-deficiency.json": [
		4493,
		3,
		4493
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-itga7-related": [
		589663,
		3,
		589663
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-itga7-related.json": [
		589663,
		3,
		589663
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-lama2-related": [
		977374,
		3,
		977374
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-lama2-related.json": [
		977374,
		3,
		977374
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-rigid-spine": [
		869455,
		3,
		869455
	],
	"./education-center/structured-data/medical/congenital-muscular-dystrophy-rigid-spine.json": [
		869455,
		3,
		869455
	],
	"./education-center/structured-data/medical/congenital-myasthenic-syndrome-dominantrecessive": [
		790192,
		3,
		790192
	],
	"./education-center/structured-data/medical/congenital-myasthenic-syndrome-dominantrecessive.json": [
		790192,
		3,
		790192
	],
	"./education-center/structured-data/medical/congenital-myasthenic-syndrome-recessive": [
		54757,
		3,
		54757
	],
	"./education-center/structured-data/medical/congenital-myasthenic-syndrome-recessive.json": [
		54757,
		3,
		54757
	],
	"./education-center/structured-data/medical/congenital-myopathy-10b-mild-variant": [
		804200,
		3,
		804200
	],
	"./education-center/structured-data/medical/congenital-myopathy-10b-mild-variant.json": [
		804200,
		3,
		804200
	],
	"./education-center/structured-data/medical/congenital-myopathy-20": [
		455850,
		3,
		455850
	],
	"./education-center/structured-data/medical/congenital-myopathy-20.json": [
		455850,
		3,
		455850
	],
	"./education-center/structured-data/medical/congenital-myopathy-21-early-respiratory-failure": [
		234354,
		3,
		234354
	],
	"./education-center/structured-data/medical/congenital-myopathy-21-early-respiratory-failure.json": [
		234354,
		3,
		234354
	],
	"./education-center/structured-data/medical/congenital-myopathy-2b-severe-infantile-autosomal-recessive": [
		140222,
		3,
		140222
	],
	"./education-center/structured-data/medical/congenital-myopathy-2b-severe-infantile-autosomal-recessive.json": [
		140222,
		3,
		140222
	],
	"./education-center/structured-data/medical/congenital-myopathy-2c-severe-infantile-autosomal-dominant": [
		318410,
		3,
		318410
	],
	"./education-center/structured-data/medical/congenital-myopathy-2c-severe-infantile-autosomal-dominant.json": [
		318410,
		3,
		318410
	],
	"./education-center/structured-data/medical/congenital-myopathy-fiber-type-disproportion": [
		112501,
		3,
		112501
	],
	"./education-center/structured-data/medical/congenital-myopathy-fiber-type-disproportion.json": [
		112501,
		3,
		112501
	],
	"./education-center/structured-data/medical/congenital-myotonia-autosomal-dominant-form": [
		566446,
		3,
		566446
	],
	"./education-center/structured-data/medical/congenital-myotonia-autosomal-dominant-form.json": [
		566446,
		3,
		566446
	],
	"./education-center/structured-data/medical/congenital-nad-deficiency-disorder": [
		53717,
		3,
		53717
	],
	"./education-center/structured-data/medical/congenital-nad-deficiency-disorder.json": [
		53717,
		3,
		53717
	],
	"./education-center/structured-data/medical/congenital-neutropenia": [
		520351,
		3,
		520351
	],
	"./education-center/structured-data/medical/congenital-neutropenia.json": [
		520351,
		3,
		520351
	],
	"./education-center/structured-data/medical/congenital-nystagmus": [
		724553,
		3,
		724553
	],
	"./education-center/structured-data/medical/congenital-nystagmus.json": [
		724553,
		3,
		724553
	],
	"./education-center/structured-data/medical/congenital-ocular-coloboma": [
		385770,
		3,
		385770
	],
	"./education-center/structured-data/medical/congenital-ocular-coloboma.json": [
		385770,
		3,
		385770
	],
	"./education-center/structured-data/medical/congenital-pontocerebellar-hypoplasia": [
		797092,
		3,
		797092
	],
	"./education-center/structured-data/medical/congenital-pontocerebellar-hypoplasia.json": [
		797092,
		3,
		797092
	],
	"./education-center/structured-data/medical/congenital-scoliosis": [
		656644,
		3,
		656644
	],
	"./education-center/structured-data/medical/congenital-scoliosis.json": [
		656644,
		3,
		656644
	],
	"./education-center/structured-data/medical/congenital-sensorineural-hearing-impairment": [
		286876,
		3,
		286876
	],
	"./education-center/structured-data/medical/congenital-sensorineural-hearing-impairment.json": [
		286876,
		3,
		286876
	],
	"./education-center/structured-data/medical/congenital-short-bowel-syndrome-x-linked": [
		871862,
		3,
		871862
	],
	"./education-center/structured-data/medical/congenital-short-bowel-syndrome-x-linked.json": [
		871862,
		3,
		871862
	],
	"./education-center/structured-data/medical/congenital-stationary-night-blindness-dominant": [
		720377,
		3,
		720377
	],
	"./education-center/structured-data/medical/congenital-stationary-night-blindness-dominant.json": [
		720377,
		3,
		720377
	],
	"./education-center/structured-data/medical/congenital-stationary-night-blindness-recessive": [
		373629,
		3,
		373629
	],
	"./education-center/structured-data/medical/congenital-stationary-night-blindness-recessive.json": [
		373629,
		3,
		373629
	],
	"./education-center/structured-data/medical/congenital-total-pulmonary-venous-return-anomaly": [
		122886,
		3,
		122886
	],
	"./education-center/structured-data/medical/congenital-total-pulmonary-venous-return-anomaly.json": [
		122886,
		3,
		122886
	],
	"./education-center/structured-data/medical/congestive-heart-failure-and-beta-blocker-response-modifier": [
		557282,
		3,
		557282
	],
	"./education-center/structured-data/medical/congestive-heart-failure-and-beta-blocker-response-modifier.json": [
		557282,
		3,
		557282
	],
	"./education-center/structured-data/medical/conotruncal-anomaly-face-syndrome": [
		460647,
		3,
		460647
	],
	"./education-center/structured-data/medical/conotruncal-anomaly-face-syndrome.json": [
		460647,
		3,
		460647
	],
	"./education-center/structured-data/medical/conotruncal-defect": [
		949315,
		3,
		949315
	],
	"./education-center/structured-data/medical/conotruncal-defect.json": [
		949315,
		3,
		949315
	],
	"./education-center/structured-data/medical/conspicuously-happy-disposition": [
		713632,
		3,
		713632
	],
	"./education-center/structured-data/medical/conspicuously-happy-disposition.json": [
		713632,
		3,
		713632
	],
	"./education-center/structured-data/medical/coproporphyria": [
		687259,
		3,
		687259
	],
	"./education-center/structured-data/medical/coproporphyria-digenic": [
		640164,
		3,
		640164
	],
	"./education-center/structured-data/medical/coproporphyria-digenic.json": [
		640164,
		3,
		640164
	],
	"./education-center/structured-data/medical/coproporphyria.json": [
		687259,
		3,
		687259
	],
	"./education-center/structured-data/medical/corneal-dystrophy-dominant": [
		71478,
		3,
		71478
	],
	"./education-center/structured-data/medical/corneal-dystrophy-dominant.json": [
		71478,
		3,
		71478
	],
	"./education-center/structured-data/medical/corneal-dystrophy-dominantrecessive": [
		168169,
		3,
		168169
	],
	"./education-center/structured-data/medical/corneal-dystrophy-dominantrecessive.json": [
		168169,
		3,
		168169
	],
	"./education-center/structured-data/medical/corneal-dystrophy-fuchs-endothelial-1": [
		205654,
		3,
		205654
	],
	"./education-center/structured-data/medical/corneal-dystrophy-fuchs-endothelial-1.json": [
		205654,
		3,
		205654
	],
	"./education-center/structured-data/medical/corneal-dystrophy-punctiform-and-polychromatic-pre-descemet": [
		129633,
		3,
		129633
	],
	"./education-center/structured-data/medical/corneal-dystrophy-punctiform-and-polychromatic-pre-descemet.json": [
		129633,
		3,
		129633
	],
	"./education-center/structured-data/medical/corneal-dystrophy-recessive": [
		157514,
		3,
		157514
	],
	"./education-center/structured-data/medical/corneal-dystrophy-recessive.json": [
		157514,
		3,
		157514
	],
	"./education-center/structured-data/medical/corneal-intraepithelial-dyskeratosis-palmoplantar-hyperkeratosis-laryngeal-dyskeratosis-syndrome": [
		765471,
		3,
		765471
	],
	"./education-center/structured-data/medical/corneal-intraepithelial-dyskeratosis-palmoplantar-hyperkeratosis-laryngeal-dyskeratosis-syndrome.json": [
		765471,
		3,
		765471
	],
	"./education-center/structured-data/medical/cornelia-de-lange-syndrome-1": [
		978807,
		3,
		978807
	],
	"./education-center/structured-data/medical/cornelia-de-lange-syndrome-1.json": [
		978807,
		3,
		978807
	],
	"./education-center/structured-data/medical/coronal-craniosynostosis": [
		391321,
		3,
		391321
	],
	"./education-center/structured-data/medical/coronal-craniosynostosis.json": [
		391321,
		3,
		391321
	],
	"./education-center/structured-data/medical/coronary-artery-disease-development-hiv": [
		288683,
		3,
		288683
	],
	"./education-center/structured-data/medical/coronary-artery-disease-development-hiv.json": [
		288683,
		3,
		288683
	],
	"./education-center/structured-data/medical/coronary-artery-disease-modifier": [
		957160,
		3,
		957160
	],
	"./education-center/structured-data/medical/coronary-artery-disease-modifier.json": [
		957160,
		3,
		957160
	],
	"./education-center/structured-data/medical/coronary-artery-disease-susceptibility": [
		975334,
		3,
		975334
	],
	"./education-center/structured-data/medical/coronary-artery-disease-susceptibility.json": [
		975334,
		3,
		975334
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-1-susceptibility": [
		626226,
		3,
		626226
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-1-susceptibility.json": [
		626226,
		3,
		626226
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-2-susceptibility": [
		483804,
		3,
		483804
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-2-susceptibility.json": [
		483804,
		3,
		483804
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-3-susceptibility": [
		831096,
		3,
		831096
	],
	"./education-center/structured-data/medical/coronary-artery-spasm-3-susceptibility.json": [
		831096,
		3,
		831096
	],
	"./education-center/structured-data/medical/coronary-heart-disease-familial-hypercholesterolemia-protection-against": [
		616491,
		3,
		616491
	],
	"./education-center/structured-data/medical/coronary-heart-disease-familial-hypercholesterolemia-protection-against.json": [
		616491,
		3,
		616491
	],
	"./education-center/structured-data/medical/coronary-sclerosis-medial-infancy": [
		447445,
		3,
		447445
	],
	"./education-center/structured-data/medical/coronary-sclerosis-medial-infancy.json": [
		447445,
		3,
		447445
	],
	"./education-center/structured-data/medical/cortical-dysplasia-complex-other-brain-malformations-12": [
		524429,
		3,
		524429
	],
	"./education-center/structured-data/medical/cortical-dysplasia-complex-other-brain-malformations-12.json": [
		524429,
		3,
		524429
	],
	"./education-center/structured-data/medical/cortical-pulverulent-cataract": [
		277765,
		3,
		277765
	],
	"./education-center/structured-data/medical/cortical-pulverulent-cataract.json": [
		277765,
		3,
		277765
	],
	"./education-center/structured-data/medical/cortical-tubers": [
		361429,
		3,
		361429
	],
	"./education-center/structured-data/medical/cortical-tubers.json": [
		361429,
		3,
		361429
	],
	"./education-center/structured-data/medical/costello-syndrome-severe": [
		943520,
		3,
		943520
	],
	"./education-center/structured-data/medical/costello-syndrome-severe.json": [
		943520,
		3,
		943520
	],
	"./education-center/structured-data/medical/cowden-syndrome-1": [
		268204,
		3,
		268204
	],
	"./education-center/structured-data/medical/cowden-syndrome-1.json": [
		268204,
		3,
		268204
	],
	"./education-center/structured-data/medical/coxopodopatellar-syndrome": [
		679009,
		3,
		679009
	],
	"./education-center/structured-data/medical/coxopodopatellar-syndrome.json": [
		679009,
		3,
		679009
	],
	"./education-center/structured-data/medical/craniofacial-deafness-hand-syndrome": [
		46149,
		3,
		46149
	],
	"./education-center/structured-data/medical/craniofacial-deafness-hand-syndrome.json": [
		46149,
		3,
		46149
	],
	"./education-center/structured-data/medical/craniofacial-dysmorphism-skeletal-anomalies-and-impaired-intellectual-development-syndrome-2": [
		283111,
		3,
		283111
	],
	"./education-center/structured-data/medical/craniofacial-dysmorphism-skeletal-anomalies-and-impaired-intellectual-development-syndrome-2.json": [
		283111,
		3,
		283111
	],
	"./education-center/structured-data/medical/craniofacial-skeletal-dermatologic-dysplasia": [
		761004,
		3,
		761004
	],
	"./education-center/structured-data/medical/craniofacial-skeletal-dermatologic-dysplasia.json": [
		761004,
		3,
		761004
	],
	"./education-center/structured-data/medical/craniometaphyseal-dysplasia-autosomal-dominant": [
		578399,
		3,
		578399
	],
	"./education-center/structured-data/medical/craniometaphyseal-dysplasia-autosomal-dominant.json": [
		578399,
		3,
		578399
	],
	"./education-center/structured-data/medical/craniosynostosis-7-susceptibility": [
		409824,
		3,
		409824
	],
	"./education-center/structured-data/medical/craniosynostosis-7-susceptibility.json": [
		409824,
		3,
		409824
	],
	"./education-center/structured-data/medical/craniosynostosis-nonclassifiable-autosomal-dominant": [
		191475,
		3,
		191475
	],
	"./education-center/structured-data/medical/craniosynostosis-nonclassifiable-autosomal-dominant.json": [
		191475,
		3,
		191475
	],
	"./education-center/structured-data/medical/craniosynostosis-nonspecific": [
		302124,
		3,
		302124
	],
	"./education-center/structured-data/medical/craniosynostosis-nonspecific.json": [
		302124,
		3,
		302124
	],
	"./education-center/structured-data/medical/craniosynostosis-nonsyndromic-unicoronal": [
		980736,
		3,
		980736
	],
	"./education-center/structured-data/medical/craniosynostosis-nonsyndromic-unicoronal.json": [
		980736,
		3,
		980736
	],
	"./education-center/structured-data/medical/craniotubular-dysplasia-ikegawa-type": [
		73571,
		3,
		73571
	],
	"./education-center/structured-data/medical/craniotubular-dysplasia-ikegawa-type.json": [
		73571,
		3,
		73571
	],
	"./education-center/structured-data/medical/cranium-bifidum-occultum": [
		39204,
		3,
		39204
	],
	"./education-center/structured-data/medical/cranium-bifidum-occultum.json": [
		39204,
		3,
		39204
	],
	"./education-center/structured-data/medical/crohn-disease-associated-growth-failure-susceptibility": [
		255735,
		3,
		255735
	],
	"./education-center/structured-data/medical/crohn-disease-associated-growth-failure-susceptibility.json": [
		255735,
		3,
		255735
	],
	"./education-center/structured-data/medical/crohn-disease-association": [
		643054,
		3,
		643054
	],
	"./education-center/structured-data/medical/crohn-disease-association.json": [
		643054,
		3,
		643054
	],
	"./education-center/structured-data/medical/cromer-blood-group-system": [
		460111,
		3,
		460111
	],
	"./education-center/structured-data/medical/cromer-blood-group-system.json": [
		460111,
		3,
		460111
	],
	"./education-center/structured-data/medical/crouzon-syndrome": [
		254022,
		3,
		254022
	],
	"./education-center/structured-data/medical/crouzon-syndrome.json": [
		254022,
		3,
		254022
	],
	"./education-center/structured-data/medical/cryptozoospermia": [
		342441,
		3,
		342441
	],
	"./education-center/structured-data/medical/cryptozoospermia.json": [
		342441,
		3,
		342441
	],
	"./education-center/structured-data/medical/ctsc-related-disorders": [
		720641,
		3,
		720641
	],
	"./education-center/structured-data/medical/ctsc-related-disorders.json": [
		720641,
		3,
		720641
	],
	"./education-center/structured-data/medical/cutaneous-malignant-melanoma-dominant": [
		320342,
		3,
		320342
	],
	"./education-center/structured-data/medical/cutaneous-malignant-melanoma-dominant.json": [
		320342,
		3,
		320342
	],
	"./education-center/structured-data/medical/cutis-laxa-autosomal-dominant-1": [
		441841,
		3,
		441841
	],
	"./education-center/structured-data/medical/cutis-laxa-autosomal-dominant-1.json": [
		441841,
		3,
		441841
	],
	"./education-center/structured-data/medical/cutis-laxa-dominantrecessive": [
		856260,
		3,
		856260
	],
	"./education-center/structured-data/medical/cutis-laxa-dominantrecessive.json": [
		856260,
		3,
		856260
	],
	"./education-center/structured-data/medical/cyp1b1-related-disorders": [
		201073,
		3,
		201073
	],
	"./education-center/structured-data/medical/cyp1b1-related-disorders.json": [
		201073,
		3,
		201073
	],
	"./education-center/structured-data/medical/cystathioninuria": [
		453498,
		3,
		453498
	],
	"./education-center/structured-data/medical/cystathioninuria.json": [
		453498,
		3,
		453498
	],
	"./education-center/structured-data/medical/cystic-parathyroid-adenoma": [
		235167,
		3,
		235167
	],
	"./education-center/structured-data/medical/cystic-parathyroid-adenoma.json": [
		235167,
		3,
		235167
	],
	"./education-center/structured-data/medical/cystine-urolithiasis": [
		465353,
		3,
		465353
	],
	"./education-center/structured-data/medical/cystine-urolithiasis.json": [
		465353,
		3,
		465353
	],
	"./education-center/structured-data/medical/cystinosis-atypical-nephropathic": [
		588848,
		3,
		588848
	],
	"./education-center/structured-data/medical/cystinosis-atypical-nephropathic.json": [
		588848,
		3,
		588848
	],
	"./education-center/structured-data/medical/dabrafenib-response": [
		665204,
		3,
		665204
	],
	"./education-center/structured-data/medical/dabrafenib-response.json": [
		665204,
		3,
		665204
	],
	"./education-center/structured-data/medical/darier-disease-acral-hemorrhagic-type": [
		955937,
		3,
		955937
	],
	"./education-center/structured-data/medical/darier-disease-acral-hemorrhagic-type.json": [
		955937,
		3,
		955937
	],
	"./education-center/structured-data/medical/darier-disease-segmental": [
		769848,
		3,
		769848
	],
	"./education-center/structured-data/medical/darier-disease-segmental.json": [
		769848,
		3,
		769848
	],
	"./education-center/structured-data/medical/deafness-autosomal-dominant-nonsyndromic-sensorineural-39-dentinogenesis-imperfecta-1": [
		932972,
		3,
		932972
	],
	"./education-center/structured-data/medical/deafness-autosomal-dominant-nonsyndromic-sensorineural-39-dentinogenesis-imperfecta-1.json": [
		932972,
		3,
		932972
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-12-modifier": [
		71772,
		3,
		71772
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-12-modifier.json": [
		71772,
		3,
		71772
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-26-modifier": [
		547375,
		3,
		547375
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-26-modifier.json": [
		547375,
		3,
		547375
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-36-without-vestibular-involvement": [
		208944,
		3,
		208944
	],
	"./education-center/structured-data/medical/deafness-autosomal-recessive-36-without-vestibular-involvement.json": [
		208944,
		3,
		208944
	],
	"./education-center/structured-data/medical/deafness-digenic-gjb2gjb3": [
		907630,
		3,
		907630
	],
	"./education-center/structured-data/medical/deafness-digenic-gjb2gjb3.json": [
		907630,
		3,
		907630
	],
	"./education-center/structured-data/medical/deafness-digenic-gjb2gjb6": [
		384625,
		3,
		384625
	],
	"./education-center/structured-data/medical/deafness-digenic-gjb2gjb6.json": [
		384625,
		3,
		384625
	],
	"./education-center/structured-data/medical/deafness-mitochondrial-modifier": [
		290688,
		3,
		290688
	],
	"./education-center/structured-data/medical/deafness-mitochondrial-modifier.json": [
		290688,
		3,
		290688
	],
	"./education-center/structured-data/medical/deafness-neurosensory-autosomal-recessive-21": [
		885839,
		3,
		885839
	],
	"./education-center/structured-data/medical/deafness-neurosensory-autosomal-recessive-21.json": [
		885839,
		3,
		885839
	],
	"./education-center/structured-data/medical/deafness-sensorineural-neurologic-features": [
		807128,
		3,
		807128
	],
	"./education-center/structured-data/medical/deafness-sensorineural-neurologic-features.json": [
		807128,
		3,
		807128
	],
	"./education-center/structured-data/medical/deafness-smith-magenis-syndrome": [
		175398,
		3,
		175398
	],
	"./education-center/structured-data/medical/deafness-smith-magenis-syndrome.json": [
		175398,
		3,
		175398
	],
	"./education-center/structured-data/medical/deafness-without-vestibular-involvement-autosomal-dominant": [
		933011,
		3,
		933011
	],
	"./education-center/structured-data/medical/deafness-without-vestibular-involvement-autosomal-dominant.json": [
		933011,
		3,
		933011
	],
	"./education-center/structured-data/medical/deafness-x-linked-5": [
		753145,
		3,
		753145
	],
	"./education-center/structured-data/medical/deafness-x-linked-5.json": [
		753145,
		3,
		753145
	],
	"./education-center/structured-data/medical/death-early-adulthood": [
		345525,
		3,
		345525
	],
	"./education-center/structured-data/medical/death-early-adulthood.json": [
		345525,
		3,
		345525
	],
	"./education-center/structured-data/medical/death-infancy": [
		314254,
		3,
		314254
	],
	"./education-center/structured-data/medical/death-infancy.json": [
		314254,
		3,
		314254
	],
	"./education-center/structured-data/medical/debrisoquine-poor-metabolism": [
		874908,
		3,
		874908
	],
	"./education-center/structured-data/medical/debrisoquine-poor-metabolism.json": [
		874908,
		3,
		874908
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-atp-synthase-complex": [
		390816,
		3,
		390816
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-atp-synthase-complex.json": [
		390816,
		3,
		390816
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-complex-iii": [
		667259,
		3,
		667259
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-complex-iii.json": [
		667259,
		3,
		667259
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-complex-iv": [
		958063,
		3,
		958063
	],
	"./education-center/structured-data/medical/decreased-activity-mitochondrial-complex-iv.json": [
		958063,
		3,
		958063
	],
	"./education-center/structured-data/medical/decreased-activity-pyruvate-dehydrogenase-complex": [
		837641,
		3,
		837641
	],
	"./education-center/structured-data/medical/decreased-activity-pyruvate-dehydrogenase-complex.json": [
		837641,
		3,
		837641
	],
	"./education-center/structured-data/medical/decreased-blood-alpha-hydroxyisovalerate-levels": [
		480496,
		3,
		480496
	],
	"./education-center/structured-data/medical/decreased-blood-alpha-hydroxyisovalerate-levels.json": [
		480496,
		3,
		480496
	],
	"./education-center/structured-data/medical/decreased-circulating-antibody-level": [
		522015,
		3,
		522015
	],
	"./education-center/structured-data/medical/decreased-circulating-antibody-level.json": [
		522015,
		3,
		522015
	],
	"./education-center/structured-data/medical/decreased-circulating-igg2-level": [
		590749,
		3,
		590749
	],
	"./education-center/structured-data/medical/decreased-circulating-igg2-level.json": [
		590749,
		3,
		590749
	],
	"./education-center/structured-data/medical/decreased-glucose-6-phosphate-dehydrogenase-level-blood": [
		189586,
		3,
		189586
	],
	"./education-center/structured-data/medical/decreased-glucose-6-phosphate-dehydrogenase-level-blood.json": [
		189586,
		3,
		189586
	],
	"./education-center/structured-data/medical/decreased-plasma-carnitine": [
		3976,
		3,
		3976
	],
	"./education-center/structured-data/medical/decreased-plasma-carnitine.json": [
		3976,
		3,
		3976
	],
	"./education-center/structured-data/medical/decreased-response-growth-hormone-stimulation-test": [
		179780,
		3,
		179780
	],
	"./education-center/structured-data/medical/decreased-response-growth-hormone-stimulation-test.json": [
		179780,
		3,
		179780
	],
	"./education-center/structured-data/medical/decreased-testicular-size": [
		931238,
		3,
		931238
	],
	"./education-center/structured-data/medical/decreased-testicular-size.json": [
		931238,
		3,
		931238
	],
	"./education-center/structured-data/medical/deep-venous-thrombosis": [
		668615,
		3,
		668615
	],
	"./education-center/structured-data/medical/deep-venous-thrombosis-protection-against": [
		662660,
		3,
		662660
	],
	"./education-center/structured-data/medical/deep-venous-thrombosis-protection-against.json": [
		662660,
		3,
		662660
	],
	"./education-center/structured-data/medical/deep-venous-thrombosis.json": [
		668615,
		3,
		668615
	],
	"./education-center/structured-data/medical/dejerine-sottas-disease": [
		199306,
		3,
		199306
	],
	"./education-center/structured-data/medical/dejerine-sottas-disease.json": [
		199306,
		3,
		199306
	],
	"./education-center/structured-data/medical/dejerine-sottas-neuropathy-autosomal-dominant": [
		214999,
		3,
		214999
	],
	"./education-center/structured-data/medical/dejerine-sottas-neuropathy-autosomal-dominant.json": [
		214999,
		3,
		214999
	],
	"./education-center/structured-data/medical/dejerine-sottas-syndrome-autosomal-dominant": [
		523192,
		3,
		523192
	],
	"./education-center/structured-data/medical/dejerine-sottas-syndrome-autosomal-dominant.json": [
		523192,
		3,
		523192
	],
	"./education-center/structured-data/medical/delayed-ability-walk": [
		943217,
		3,
		943217
	],
	"./education-center/structured-data/medical/delayed-ability-walk.json": [
		943217,
		3,
		943217
	],
	"./education-center/structured-data/medical/delayed-gross-motor-development": [
		914670,
		3,
		914670
	],
	"./education-center/structured-data/medical/delayed-gross-motor-development.json": [
		914670,
		3,
		914670
	],
	"./education-center/structured-data/medical/delayed-skeletal-maturation": [
		191487,
		3,
		191487
	],
	"./education-center/structured-data/medical/delayed-skeletal-maturation.json": [
		191487,
		3,
		191487
	],
	"./education-center/structured-data/medical/delayed-speech-and-language-development": [
		283273,
		3,
		283273
	],
	"./education-center/structured-data/medical/delayed-speech-and-language-development.json": [
		283273,
		3,
		283273
	],
	"./education-center/structured-data/medical/deleterious-rad51d-gene-mutation": [
		129061,
		3,
		129061
	],
	"./education-center/structured-data/medical/deleterious-rad51d-gene-mutation.json": [
		129061,
		3,
		129061
	],
	"./education-center/structured-data/medical/delta-0-thalassemia": [
		519105,
		3,
		519105
	],
	"./education-center/structured-data/medical/delta-0-thalassemia.json": [
		519105,
		3,
		519105
	],
	"./education-center/structured-data/medical/delta-plus-thalassemia": [
		444438,
		3,
		444438
	],
	"./education-center/structured-data/medical/delta-plus-thalassemia.json": [
		444438,
		3,
		444438
	],
	"./education-center/structured-data/medical/delta-thalassemia": [
		737370,
		3,
		737370
	],
	"./education-center/structured-data/medical/delta-thalassemia.json": [
		737370,
		3,
		737370
	],
	"./education-center/structured-data/medical/delta-zero-thalassemia-knossos-type": [
		299695,
		3,
		299695
	],
	"./education-center/structured-data/medical/delta-zero-thalassemia-knossos-type.json": [
		299695,
		3,
		299695
	],
	"./education-center/structured-data/medical/dementia": [
		347044,
		3,
		347044
	],
	"./education-center/structured-data/medical/dementia-deafness-and-sensory-neuropathy": [
		469303,
		3,
		469303
	],
	"./education-center/structured-data/medical/dementia-deafness-and-sensory-neuropathy.json": [
		469303,
		3,
		469303
	],
	"./education-center/structured-data/medical/dementia-lewy-body-susceptibility": [
		680870,
		3,
		680870
	],
	"./education-center/structured-data/medical/dementia-lewy-body-susceptibility.json": [
		680870,
		3,
		680870
	],
	"./education-center/structured-data/medical/dementia.json": [
		347044,
		3,
		347044
	],
	"./education-center/structured-data/medical/dengue-fever-protection-against": [
		839983,
		3,
		839983
	],
	"./education-center/structured-data/medical/dengue-fever-protection-against.json": [
		839983,
		3,
		839983
	],
	"./education-center/structured-data/medical/dentatorubral-pallidoluysian-atrophy": [
		817362,
		3,
		874234
	],
	"./education-center/structured-data/medical/dentatorubral-pallidoluysian-atrophy.json": [
		817362,
		3,
		874234
	],
	"./education-center/structured-data/medical/denticles": [
		460884,
		3,
		460884
	],
	"./education-center/structured-data/medical/denticles.json": [
		460884,
		3,
		460884
	],
	"./education-center/structured-data/medical/dentin-dysplasia-type-i": [
		637556,
		3,
		637556
	],
	"./education-center/structured-data/medical/dentin-dysplasia-type-i-extreme-microdontia-and-misshapen-teeth": [
		198867,
		3,
		198867
	],
	"./education-center/structured-data/medical/dentin-dysplasia-type-i-extreme-microdontia-and-misshapen-teeth.json": [
		198867,
		3,
		198867
	],
	"./education-center/structured-data/medical/dentin-dysplasia-type-i.json": [
		637556,
		3,
		637556
	],
	"./education-center/structured-data/medical/dentinogenesis-imperfecta-type-2": [
		51227,
		3,
		51227
	],
	"./education-center/structured-data/medical/dentinogenesis-imperfecta-type-2.json": [
		51227,
		3,
		51227
	],
	"./education-center/structured-data/medical/dentinogenesis-imperfecta-type-3": [
		772625,
		3,
		772625
	],
	"./education-center/structured-data/medical/dentinogenesis-imperfecta-type-3.json": [
		772625,
		3,
		772625
	],
	"./education-center/structured-data/medical/dermatitis-atopic-2-susceptibility": [
		989322,
		3,
		989322
	],
	"./education-center/structured-data/medical/dermatitis-atopic-2-susceptibility.json": [
		989322,
		3,
		989322
	],
	"./education-center/structured-data/medical/dermatofibrosis-lenticularis-disseminata-isolated": [
		329392,
		3,
		329392
	],
	"./education-center/structured-data/medical/dermatofibrosis-lenticularis-disseminata-isolated.json": [
		329392,
		3,
		329392
	],
	"./education-center/structured-data/medical/dermatopathia-pigmentosa-reticularis": [
		204727,
		3,
		204727
	],
	"./education-center/structured-data/medical/dermatopathia-pigmentosa-reticularis.json": [
		204727,
		3,
		204727
	],
	"./education-center/structured-data/medical/desbuquois-dysplasia-1": [
		394747,
		3,
		394747
	],
	"./education-center/structured-data/medical/desbuquois-dysplasia-1.json": [
		394747,
		3,
		394747
	],
	"./education-center/structured-data/medical/descending-aortic-dissection": [
		930654,
		3,
		930654
	],
	"./education-center/structured-data/medical/descending-aortic-dissection.json": [
		930654,
		3,
		930654
	],
	"./education-center/structured-data/medical/desmoid-disease-hereditary": [
		165370,
		3,
		165370
	],
	"./education-center/structured-data/medical/desmoid-disease-hereditary.json": [
		165370,
		3,
		165370
	],
	"./education-center/structured-data/medical/desmoid-tumor": [
		437258,
		3,
		437258
	],
	"./education-center/structured-data/medical/desmoid-tumor.json": [
		437258,
		3,
		437258
	],
	"./education-center/structured-data/medical/deuteranomaly": [
		668240,
		3,
		668240
	],
	"./education-center/structured-data/medical/deuteranomaly.json": [
		668240,
		3,
		668240
	],
	"./education-center/structured-data/medical/deuteranopia": [
		756148,
		3,
		756148
	],
	"./education-center/structured-data/medical/deuteranopia.json": [
		756148,
		3,
		756148
	],
	"./education-center/structured-data/medical/deutetrabenazine-response": [
		981316,
		3,
		981316
	],
	"./education-center/structured-data/medical/deutetrabenazine-response.json": [
		981316,
		3,
		981316
	],
	"./education-center/structured-data/medical/developmental-and-epileptic-encephalopathy-31b-autosomal-recessive": [
		3303,
		3,
		3303
	],
	"./education-center/structured-data/medical/developmental-and-epileptic-encephalopathy-31b-autosomal-recessive.json": [
		3303,
		3,
		3303
	],
	"./education-center/structured-data/medical/developmental-delay": [
		606683,
		3,
		606683
	],
	"./education-center/structured-data/medical/developmental-delay.json": [
		606683,
		3,
		606683
	],
	"./education-center/structured-data/medical/developmental-dyslexia": [
		13221,
		3,
		13221
	],
	"./education-center/structured-data/medical/developmental-dyslexia.json": [
		13221,
		3,
		13221
	],
	"./education-center/structured-data/medical/developmental-regression": [
		812311,
		3,
		812311
	],
	"./education-center/structured-data/medical/developmental-regression.json": [
		812311,
		3,
		812311
	],
	"./education-center/structured-data/medical/diabetes-insipidus-nephrogenic-autosomal": [
		762059,
		3,
		762059
	],
	"./education-center/structured-data/medical/diabetes-insipidus-nephrogenic-autosomal.json": [
		762059,
		3,
		762059
	],
	"./education-center/structured-data/medical/diabetes-insipidus-neurohypophyseal-autosomal-recessive": [
		41124,
		3,
		41124
	],
	"./education-center/structured-data/medical/diabetes-insipidus-neurohypophyseal-autosomal-recessive.json": [
		41124,
		3,
		41124
	],
	"./education-center/structured-data/medical/diabetes-mellitus-ketosis-prone-susceptibility": [
		925120,
		3,
		925120
	],
	"./education-center/structured-data/medical/diabetes-mellitus-ketosis-prone-susceptibility.json": [
		925120,
		3,
		925120
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-acanthosis-nigricans-and-hypertension": [
		930351,
		3,
		930351
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-acanthosis-nigricans-and-hypertension.json": [
		930351,
		3,
		930351
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-association": [
		914042,
		3,
		914042
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-association.json": [
		914042,
		3,
		914042
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-maternally-transmitted": [
		508257,
		3,
		508257
	],
	"./education-center/structured-data/medical/diabetes-mellitus-noninsulin-dependent-maternally-transmitted.json": [
		508257,
		3,
		508257
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-1-susceptibility": [
		492874,
		3,
		492874
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-1-susceptibility.json": [
		492874,
		3,
		492874
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-2-susceptibility": [
		33834,
		3,
		33834
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-2-susceptibility.json": [
		33834,
		3,
		33834
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-ii-digenic": [
		334453,
		3,
		334453
	],
	"./education-center/structured-data/medical/diabetes-mellitus-type-ii-digenic.json": [
		334453,
		3,
		334453
	],
	"./education-center/structured-data/medical/diamond-blackfan-anemia-1": [
		890822,
		3,
		890822
	],
	"./education-center/structured-data/medical/diamond-blackfan-anemia-1.json": [
		890822,
		3,
		890822
	],
	"./education-center/structured-data/medical/diaphragmatic-hernia-4-cardiovascular-defects": [
		286339,
		3,
		286339
	],
	"./education-center/structured-data/medical/diaphragmatic-hernia-4-cardiovascular-defects.json": [
		286339,
		3,
		286339
	],
	"./education-center/structured-data/medical/diaphyseal-dysplasia": [
		627810,
		3,
		627810
	],
	"./education-center/structured-data/medical/diaphyseal-dysplasia.json": [
		627810,
		3,
		627810
	],
	"./education-center/structured-data/medical/diaphyseal-medullary-stenosis-bone-malignancy-syndrome": [
		569706,
		3,
		569706
	],
	"./education-center/structured-data/medical/diaphyseal-medullary-stenosis-bone-malignancy-syndrome.json": [
		569706,
		3,
		569706
	],
	"./education-center/structured-data/medical/diarrhea-microvillus-atrophy": [
		966927,
		3,
		966927
	],
	"./education-center/structured-data/medical/diarrhea-microvillus-atrophy.json": [
		966927,
		3,
		966927
	],
	"./education-center/structured-data/medical/diastema-dental-medial": [
		497464,
		3,
		497464
	],
	"./education-center/structured-data/medical/diastema-dental-medial.json": [
		497464,
		3,
		497464
	],
	"./education-center/structured-data/medical/diastolic-dysfunction": [
		338700,
		3,
		338700
	],
	"./education-center/structured-data/medical/diastolic-dysfunction.json": [
		338700,
		3,
		338700
	],
	"./education-center/structured-data/medical/diastrophic-dysplasia-broad-bone-platyspondylic-variant": [
		589865,
		3,
		589865
	],
	"./education-center/structured-data/medical/diastrophic-dysplasia-broad-bone-platyspondylic-variant.json": [
		589865,
		3,
		589865
	],
	"./education-center/structured-data/medical/diencephalic-mesencephalic-junction-dysplasia-syndrome-1": [
		987311,
		3,
		987311
	],
	"./education-center/structured-data/medical/diencephalic-mesencephalic-junction-dysplasia-syndrome-1.json": [
		987311,
		3,
		987311
	],
	"./education-center/structured-data/medical/diffuse-intrinsic-pontine-glioma": [
		289455,
		3,
		289455
	],
	"./education-center/structured-data/medical/diffuse-intrinsic-pontine-glioma.json": [
		289455,
		3,
		289455
	],
	"./education-center/structured-data/medical/diffuse-mesangial-sclerosis": [
		422150,
		3,
		422150
	],
	"./education-center/structured-data/medical/diffuse-mesangial-sclerosis.json": [
		422150,
		3,
		422150
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1a": [
		211260,
		3,
		211260
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1a.json": [
		211260,
		3,
		211260
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1m": [
		899634,
		3,
		899634
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1m.json": [
		899634,
		3,
		899634
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1t": [
		799033,
		3,
		799033
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-1t.json": [
		799033,
		3,
		799033
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-dominant": [
		213068,
		3,
		213068
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-dominant.json": [
		213068,
		3,
		213068
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-left-ventricular-noncompaction": [
		644019,
		3,
		644019
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-left-ventricular-noncompaction.json": [
		644019,
		3,
		644019
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-recessive": [
		857363,
		3,
		857363
	],
	"./education-center/structured-data/medical/dilated-cardiomyopathy-recessive.json": [
		857363,
		3,
		857363
	],
	"./education-center/structured-data/medical/dilated-left-ventricle": [
		177060,
		3,
		177060
	],
	"./education-center/structured-data/medical/dilated-left-ventricle.json": [
		177060,
		3,
		177060
	],
	"./education-center/structured-data/medical/disease": [
		488421,
		3,
		488421
	],
	"./education-center/structured-data/medical/disease-association-nos": [
		683913,
		3,
		683913
	],
	"./education-center/structured-data/medical/disease-association-nos.json": [
		683913,
		3,
		683913
	],
	"./education-center/structured-data/medical/disease.json": [
		488421,
		3,
		488421
	],
	"./education-center/structured-data/medical/disorders-intracellular-cobalamin-metabolism": [
		919910,
		3,
		919910
	],
	"./education-center/structured-data/medical/disorders-intracellular-cobalamin-metabolism.json": [
		919910,
		3,
		919910
	],
	"./education-center/structured-data/medical/disproportionate-short-stature": [
		270893,
		3,
		270893
	],
	"./education-center/structured-data/medical/disproportionate-short-stature.json": [
		270893,
		3,
		270893
	],
	"./education-center/structured-data/medical/disproportionate-tall-stature": [
		595061,
		3,
		595061
	],
	"./education-center/structured-data/medical/disproportionate-tall-stature.json": [
		595061,
		3,
		595061
	],
	"./education-center/structured-data/medical/disrupted-sleep-wake-cycle-developmental-delay-and-learning-difficulty": [
		251163,
		3,
		251163
	],
	"./education-center/structured-data/medical/disrupted-sleep-wake-cycle-developmental-delay-and-learning-difficulty.json": [
		251163,
		3,
		251163
	],
	"./education-center/structured-data/medical/disseminated-atypical-mycobacterial-infection": [
		567317,
		3,
		567317
	],
	"./education-center/structured-data/medical/disseminated-atypical-mycobacterial-infection.json": [
		567317,
		3,
		567317
	],
	"./education-center/structured-data/medical/distal-amyotrophy": [
		444522,
		3,
		444522
	],
	"./education-center/structured-data/medical/distal-amyotrophy.json": [
		444522,
		3,
		444522
	],
	"./education-center/structured-data/medical/distal-lower-limb-muscle-weakness": [
		959216,
		3,
		959216
	],
	"./education-center/structured-data/medical/distal-lower-limb-muscle-weakness.json": [
		959216,
		3,
		959216
	],
	"./education-center/structured-data/medical/distal-muscle-weakness": [
		484052,
		3,
		484052
	],
	"./education-center/structured-data/medical/distal-muscle-weakness.json": [
		484052,
		3,
		484052
	],
	"./education-center/structured-data/medical/distal-renal-tubular-acidosis-dominant": [
		922277,
		3,
		922277
	],
	"./education-center/structured-data/medical/distal-renal-tubular-acidosis-dominant.json": [
		922277,
		3,
		922277
	],
	"./education-center/structured-data/medical/distal-renal-tubular-acidosis-recessive": [
		234479,
		3,
		460362
	],
	"./education-center/structured-data/medical/distal-renal-tubular-acidosis-recessive.json": [
		234479,
		3,
		460362
	],
	"./education-center/structured-data/medical/distal-shortening-limbs": [
		433363,
		3,
		433363
	],
	"./education-center/structured-data/medical/distal-shortening-limbs.json": [
		433363,
		3,
		433363
	],
	"./education-center/structured-data/medical/distichiasis-lymphedema-syndrome": [
		481413,
		3,
		481413
	],
	"./education-center/structured-data/medical/distichiasis-lymphedema-syndrome.json": [
		481413,
		3,
		481413
	],
	"./education-center/structured-data/medical/dizygotic-twins": [
		141718,
		3,
		141718
	],
	"./education-center/structured-data/medical/dizygotic-twins.json": [
		141718,
		3,
		141718
	],
	"./education-center/structured-data/medical/dld-related-disorders": [
		409512,
		3,
		409512
	],
	"./education-center/structured-data/medical/dld-related-disorders.json": [
		409512,
		3,
		409512
	],
	"./education-center/structured-data/medical/dna-topoisomerase-i-camptothecin-resistant": [
		46451,
		3,
		46451
	],
	"./education-center/structured-data/medical/dna-topoisomerase-i-camptothecin-resistant.json": [
		46451,
		3,
		46451
	],
	"./education-center/structured-data/medical/dna-topoisomerase-ii-resistance-inhibition-amsacrine": [
		482460,
		3,
		482460
	],
	"./education-center/structured-data/medical/dna-topoisomerase-ii-resistance-inhibition-amsacrine.json": [
		482460,
		3,
		482460
	],
	"./education-center/structured-data/medical/dominant-dystrophic-epidermolysis-bullosa-absence-skin": [
		263592,
		3,
		263592
	],
	"./education-center/structured-data/medical/dominant-dystrophic-epidermolysis-bullosa-absence-skin.json": [
		263592,
		3,
		263592
	],
	"./education-center/structured-data/medical/dopamine-beta-hydroxylase-polymorphism": [
		360203,
		3,
		360203
	],
	"./education-center/structured-data/medical/dopamine-beta-hydroxylase-polymorphism.json": [
		360203,
		3,
		360203
	],
	"./education-center/structured-data/medical/dopamine-receptor-d2-reduced-brain-density": [
		899227,
		3,
		899227
	],
	"./education-center/structured-data/medical/dopamine-receptor-d2-reduced-brain-density.json": [
		899227,
		3,
		899227
	],
	"./education-center/structured-data/medical/doyne-honeycomb-retinal-dystrophy": [
		254428,
		3,
		254428
	],
	"./education-center/structured-data/medical/doyne-honeycomb-retinal-dystrophy.json": [
		254428,
		3,
		254428
	],
	"./education-center/structured-data/medical/drug-induced-liver-injury-due-flucloxacillin": [
		136883,
		3,
		136883
	],
	"./education-center/structured-data/medical/drug-induced-liver-injury-due-flucloxacillin.json": [
		136883,
		3,
		136883
	],
	"./education-center/structured-data/medical/drug-metabolism-altered-ces1-related": [
		792562,
		3,
		792562
	],
	"./education-center/structured-data/medical/drug-metabolism-altered-ces1-related.json": [
		792562,
		3,
		792562
	],
	"./education-center/structured-data/medical/drug-metabolism-altered-cyp2c8-related": [
		460008,
		3,
		460008
	],
	"./education-center/structured-data/medical/drug-metabolism-altered-cyp2c8-related.json": [
		460008,
		3,
		460008
	],
	"./education-center/structured-data/medical/duane-retraction-syndrome": [
		905215,
		3,
		905215
	],
	"./education-center/structured-data/medical/duane-retraction-syndrome.json": [
		905215,
		3,
		905215
	],
	"./education-center/structured-data/medical/ductal-breast-carcinoma": [
		89454,
		3,
		89454
	],
	"./education-center/structured-data/medical/ductal-breast-carcinoma.json": [
		89454,
		3,
		89454
	],
	"./education-center/structured-data/medical/duodenal-adenocarcinoma": [
		28337,
		3,
		28337
	],
	"./education-center/structured-data/medical/duodenal-adenocarcinoma.json": [
		28337,
		3,
		28337
	],
	"./education-center/structured-data/medical/duodenal-stenosis": [
		529342,
		3,
		529342
	],
	"./education-center/structured-data/medical/duodenal-stenosis.json": [
		529342,
		3,
		529342
	],
	"./education-center/structured-data/medical/dysequilibrium-syndrome": [
		804132,
		3,
		804132
	],
	"./education-center/structured-data/medical/dysequilibrium-syndrome.json": [
		804132,
		3,
		804132
	],
	"./education-center/structured-data/medical/dysf-related-disorders": [
		70277,
		3,
		70277
	],
	"./education-center/structured-data/medical/dysf-related-disorders.json": [
		70277,
		3,
		70277
	],
	"./education-center/structured-data/medical/dysfibrinogenemia": [
		30738,
		3,
		30738
	],
	"./education-center/structured-data/medical/dysfibrinogenemia.json": [
		30738,
		3,
		30738
	],
	"./education-center/structured-data/medical/dysgenesis-cerebellar-vermis": [
		954819,
		3,
		954819
	],
	"./education-center/structured-data/medical/dysgenesis-cerebellar-vermis.json": [
		954819,
		3,
		954819
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-autosomal-dominant-1": [
		50352,
		3,
		50352
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-autosomal-dominant-1.json": [
		50352,
		3,
		50352
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-dominant": [
		498201,
		3,
		498201
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-dominant.json": [
		498201,
		3,
		498201
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-recessive": [
		767588,
		3,
		767588
	],
	"./education-center/structured-data/medical/dyskeratosis-congenita-recessive.json": [
		767588,
		3,
		767588
	],
	"./education-center/structured-data/medical/dyslexia-susceptibility-1": [
		470475,
		3,
		470475
	],
	"./education-center/structured-data/medical/dyslexia-susceptibility-1.json": [
		470475,
		3,
		470475
	],
	"./education-center/structured-data/medical/dysmetria": [
		818983,
		3,
		818983
	],
	"./education-center/structured-data/medical/dysmetria.json": [
		818983,
		3,
		818983
	],
	"./education-center/structured-data/medical/dysostosis-multiplex-ain-naz-type": [
		801702,
		3,
		801702
	],
	"./education-center/structured-data/medical/dysostosis-multiplex-ain-naz-type.json": [
		801702,
		3,
		801702
	],
	"./education-center/structured-data/medical/dysplasminogenemia": [
		254673,
		3,
		254673
	],
	"./education-center/structured-data/medical/dysplasminogenemia.json": [
		254673,
		3,
		254673
	],
	"./education-center/structured-data/medical/dysplastic-corpus-callosum": [
		816065,
		3,
		816065
	],
	"./education-center/structured-data/medical/dysplastic-corpus-callosum.json": [
		816065,
		3,
		816065
	],
	"./education-center/structured-data/medical/dyssynergia": [
		553123,
		3,
		553123
	],
	"./education-center/structured-data/medical/dyssynergia.json": [
		553123,
		3,
		553123
	],
	"./education-center/structured-data/medical/dystonia-1-torsion-late-onset": [
		324893,
		3,
		324893
	],
	"./education-center/structured-data/medical/dystonia-1-torsion-late-onset.json": [
		324893,
		3,
		324893
	],
	"./education-center/structured-data/medical/dystonia-12": [
		213315,
		3,
		213315
	],
	"./education-center/structured-data/medical/dystonia-12.json": [
		213315,
		3,
		213315
	],
	"./education-center/structured-data/medical/dystonia-32": [
		213142,
		3,
		213142
	],
	"./education-center/structured-data/medical/dystonia-32.json": [
		213142,
		3,
		213142
	],
	"./education-center/structured-data/medical/dystonia-5": [
		406748,
		3,
		406748
	],
	"./education-center/structured-data/medical/dystonia-5.json": [
		406748,
		3,
		406748
	],
	"./education-center/structured-data/medical/dystonia-adult-onset": [
		187989,
		3,
		187989
	],
	"./education-center/structured-data/medical/dystonia-adult-onset.json": [
		187989,
		3,
		187989
	],
	"./education-center/structured-data/medical/dystonia-early-onset-atypical-myoclonic-features": [
		63156,
		3,
		63156
	],
	"./education-center/structured-data/medical/dystonia-early-onset-atypical-myoclonic-features.json": [
		63156,
		3,
		63156
	],
	"./education-center/structured-data/medical/dystonia-intellectual-disability-and-language-impairment": [
		108860,
		3,
		108860
	],
	"./education-center/structured-data/medical/dystonia-intellectual-disability-and-language-impairment.json": [
		108860,
		3,
		108860
	],
	"./education-center/structured-data/medical/dystonia-mitochondrial": [
		841028,
		3,
		841028
	],
	"./education-center/structured-data/medical/dystonia-mitochondrial.json": [
		841028,
		3,
		841028
	],
	"./education-center/structured-data/medical/dystonia-primary-cervical": [
		322640,
		3,
		322640
	],
	"./education-center/structured-data/medical/dystonia-primary-cervical.json": [
		322640,
		3,
		322640
	],
	"./education-center/structured-data/medical/ear-malformation": [
		108220,
		3,
		108220
	],
	"./education-center/structured-data/medical/ear-malformation.json": [
		108220,
		3,
		108220
	],
	"./education-center/structured-data/medical/early-infantile-epileptic-encephalopathy-autosomal-dominant": [
		152799,
		3,
		152799
	],
	"./education-center/structured-data/medical/early-infantile-epileptic-encephalopathy-autosomal-dominant.json": [
		152799,
		3,
		152799
	],
	"./education-center/structured-data/medical/early-infantile-epileptic-encephalopathy-autosomal-recessive": [
		702410,
		3,
		702410
	],
	"./education-center/structured-data/medical/early-infantile-epileptic-encephalopathy-autosomal-recessive.json": [
		702410,
		3,
		702410
	],
	"./education-center/structured-data/medical/early-onset-alzheimer-disease-behavioral-disturbance": [
		822680,
		3,
		822680
	],
	"./education-center/structured-data/medical/early-onset-alzheimer-disease-behavioral-disturbance.json": [
		822680,
		3,
		822680
	],
	"./education-center/structured-data/medical/early-onset-coronary-artery-disease": [
		116262,
		3,
		116262
	],
	"./education-center/structured-data/medical/early-onset-coronary-artery-disease.json": [
		116262,
		3,
		116262
	],
	"./education-center/structured-data/medical/early-onset-epileptic-encephalopathy": [
		78326,
		3,
		78326
	],
	"./education-center/structured-data/medical/early-onset-epileptic-encephalopathy.json": [
		78326,
		3,
		78326
	],
	"./education-center/structured-data/medical/early-onset-generalized-limb-onset-dystonia": [
		984033,
		3,
		984033
	],
	"./education-center/structured-data/medical/early-onset-generalized-limb-onset-dystonia.json": [
		984033,
		3,
		984033
	],
	"./education-center/structured-data/medical/early-spermatogenesis-maturation-arrest": [
		380687,
		3,
		380687
	],
	"./education-center/structured-data/medical/early-spermatogenesis-maturation-arrest.json": [
		380687,
		3,
		380687
	],
	"./education-center/structured-data/medical/ebf3-related-disorder": [
		738604,
		3,
		738604
	],
	"./education-center/structured-data/medical/ebf3-related-disorder.json": [
		738604,
		3,
		738604
	],
	"./education-center/structured-data/medical/eccrine-angiomatous-hamartoma": [
		320262,
		3,
		320262
	],
	"./education-center/structured-data/medical/eccrine-angiomatous-hamartoma.json": [
		320262,
		3,
		320262
	],
	"./education-center/structured-data/medical/ectodermal-dysplasia-10a-hypohidrotichairtooth-type-autosomal-dominant": [
		593896,
		3,
		593896
	],
	"./education-center/structured-data/medical/ectodermal-dysplasia-10a-hypohidrotichairtooth-type-autosomal-dominant.json": [
		593896,
		3,
		593896
	],
	"./education-center/structured-data/medical/ectopia-lentis-1-isolated-autosomal-dominant": [
		883107,
		3,
		883107
	],
	"./education-center/structured-data/medical/ectopia-lentis-1-isolated-autosomal-dominant.json": [
		883107,
		3,
		883107
	],
	"./education-center/structured-data/medical/ectrodactyly": [
		292117,
		3,
		292117
	],
	"./education-center/structured-data/medical/ectrodactyly-and-ectodermal-dysplasia-without-cleft-lippalate": [
		911876,
		3,
		911876
	],
	"./education-center/structured-data/medical/ectrodactyly-and-ectodermal-dysplasia-without-cleft-lippalate.json": [
		911876,
		3,
		911876
	],
	"./education-center/structured-data/medical/ectrodactyly.json": [
		292117,
		3,
		292117
	],
	"./education-center/structured-data/medical/eculizumab-poor-response": [
		284261,
		3,
		284261
	],
	"./education-center/structured-data/medical/eculizumab-poor-response.json": [
		284261,
		3,
		284261
	],
	"./education-center/structured-data/medical/eeg-focal-epileptiform-discharges": [
		517853,
		3,
		517853
	],
	"./education-center/structured-data/medical/eeg-focal-epileptiform-discharges.json": [
		517853,
		3,
		517853
	],
	"./education-center/structured-data/medical/efavirenz-response-metabolismpk": [
		254634,
		3,
		254634
	],
	"./education-center/structured-data/medical/efavirenz-response-metabolismpk.json": [
		254634,
		3,
		254634
	],
	"./education-center/structured-data/medical/effort-induced-polymorphic-ventricular-tachycardia": [
		23022,
		3,
		23022
	],
	"./education-center/structured-data/medical/effort-induced-polymorphic-ventricular-tachycardia.json": [
		23022,
		3,
		23022
	],
	"./education-center/structured-data/medical/egfr-related-lung-cancer": [
		773170,
		3,
		773170
	],
	"./education-center/structured-data/medical/egfr-related-lung-cancer.json": [
		773170,
		3,
		773170
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-arthrochalasis-type": [
		87230,
		3,
		87230
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-arthrochalasis-type.json": [
		87230,
		3,
		87230
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-classic-type": [
		948772,
		3,
		948772
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-classic-type.json": [
		948772,
		3,
		948772
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-progeroid-type": [
		913597,
		3,
		913597
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-progeroid-type.json": [
		913597,
		3,
		913597
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-type-3": [
		862750,
		3,
		862750
	],
	"./education-center/structured-data/medical/ehlers-danlos-syndrome-type-3.json": [
		862750,
		3,
		862750
	],
	"./education-center/structured-data/medical/elevated-basal-serum-calcitonin": [
		406524,
		3,
		406524
	],
	"./education-center/structured-data/medical/elevated-basal-serum-calcitonin.json": [
		406524,
		3,
		406524
	],
	"./education-center/structured-data/medical/elevated-circulating-alkaline-phosphatase-concentration": [
		240196,
		3,
		240196
	],
	"./education-center/structured-data/medical/elevated-circulating-alkaline-phosphatase-concentration.json": [
		240196,
		3,
		240196
	],
	"./education-center/structured-data/medical/elevated-circulating-creatine-kinase-concentration": [
		552621,
		3,
		552621
	],
	"./education-center/structured-data/medical/elevated-circulating-creatine-kinase-concentration.json": [
		552621,
		3,
		552621
	],
	"./education-center/structured-data/medical/elevated-circulating-glutaric-acid-concentration": [
		722003,
		3,
		722003
	],
	"./education-center/structured-data/medical/elevated-circulating-glutaric-acid-concentration.json": [
		722003,
		3,
		722003
	],
	"./education-center/structured-data/medical/elliptocytosis": [
		723697,
		3,
		723697
	],
	"./education-center/structured-data/medical/elliptocytosis-2": [
		690382,
		3,
		690382
	],
	"./education-center/structured-data/medical/elliptocytosis-2.json": [
		690382,
		3,
		690382
	],
	"./education-center/structured-data/medical/elliptocytosis.json": [
		723697,
		3,
		723697
	],
	"./education-center/structured-data/medical/emery-nelson-syndrome": [
		623557,
		3,
		623557
	],
	"./education-center/structured-data/medical/emery-nelson-syndrome.json": [
		623557,
		3,
		623557
	],
	"./education-center/structured-data/medical/emm-null-phenotype": [
		233176,
		3,
		233176
	],
	"./education-center/structured-data/medical/emm-null-phenotype.json": [
		233176,
		3,
		233176
	],
	"./education-center/structured-data/medical/empty-follicle-syndrome": [
		813158,
		3,
		813158
	],
	"./education-center/structured-data/medical/empty-follicle-syndrome.json": [
		813158,
		3,
		813158
	],
	"./education-center/structured-data/medical/empty-ovarian-follicle": [
		349081,
		3,
		349081
	],
	"./education-center/structured-data/medical/empty-ovarian-follicle.json": [
		349081,
		3,
		349081
	],
	"./education-center/structured-data/medical/encephalocardiomyopathy-mitochondrial": [
		582708,
		3,
		582708
	],
	"./education-center/structured-data/medical/encephalocardiomyopathy-mitochondrial.json": [
		582708,
		3,
		582708
	],
	"./education-center/structured-data/medical/encephalopathy-familial-progressive-necrotizing": [
		582997,
		3,
		582997
	],
	"./education-center/structured-data/medical/encephalopathy-familial-progressive-necrotizing.json": [
		582997,
		3,
		582997
	],
	"./education-center/structured-data/medical/endometrial-endometrioid-adenocarcinoma-variant-squamous-differentiation": [
		406600,
		3,
		406600
	],
	"./education-center/structured-data/medical/endometrial-endometrioid-adenocarcinoma-variant-squamous-differentiation.json": [
		406600,
		3,
		406600
	],
	"./education-center/structured-data/medical/endometrial-neoplasm": [
		67650,
		3,
		67650
	],
	"./education-center/structured-data/medical/endometrial-neoplasm.json": [
		67650,
		3,
		67650
	],
	"./education-center/structured-data/medical/endometriosis": [
		355519,
		3,
		355519
	],
	"./education-center/structured-data/medical/endometriosis.json": [
		355519,
		3,
		355519
	],
	"./education-center/structured-data/medical/enhancement-c-reflex": [
		524613,
		3,
		524613
	],
	"./education-center/structured-data/medical/enhancement-c-reflex.json": [
		524613,
		3,
		524613
	],
	"./education-center/structured-data/medical/enzyme-activity-finding": [
		84305,
		3,
		84305
	],
	"./education-center/structured-data/medical/enzyme-activity-finding.json": [
		84305,
		3,
		84305
	],
	"./education-center/structured-data/medical/epidermal-nevus-urothelial-cancer-somatic": [
		122017,
		3,
		122017
	],
	"./education-center/structured-data/medical/epidermal-nevus-urothelial-cancer-somatic.json": [
		122017,
		3,
		122017
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa": [
		851135,
		3,
		851135
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica": [
		750375,
		3,
		750375
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica-autosomal-recessive-localisata-variant": [
		436506,
		3,
		436506
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica-autosomal-recessive-localisata-variant.json": [
		436506,
		3,
		436506
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica-inversa-autosomal-recessive": [
		24440,
		3,
		24440
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica-inversa-autosomal-recessive.json": [
		24440,
		3,
		24440
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-dystrophica.json": [
		750375,
		3,
		750375
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-junctional-6-pyloric-atresia": [
		385393,
		3,
		385393
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-junctional-6-pyloric-atresia.json": [
		385393,
		3,
		385393
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pretibial-autosomal-recessive": [
		450253,
		3,
		450253
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pretibial-autosomal-recessive.json": [
		450253,
		3,
		450253
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pruriginosa-autosomal-dominant": [
		488583,
		3,
		488583
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pruriginosa-autosomal-dominant.json": [
		488583,
		3,
		488583
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pruriginosa-autosomal-recessive": [
		80681,
		3,
		80681
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-pruriginosa-autosomal-recessive.json": [
		80681,
		3,
		80681
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-1a-generalized-severe": [
		16186,
		3,
		16186
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-1a-generalized-severe.json": [
		16186,
		3,
		16186
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-1c-localized": [
		86081,
		3,
		86081
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-1c-localized.json": [
		86081,
		3,
		86081
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-koebner-type": [
		323806,
		3,
		323806
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-koebner-type.json": [
		323806,
		3,
		323806
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-mottled-pigmentation": [
		860907,
		3,
		860907
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-mottled-pigmentation.json": [
		860907,
		3,
		860907
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-ogna-type": [
		191191,
		3,
		191191
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa-simplex-ogna-type.json": [
		191191,
		3,
		191191
	],
	"./education-center/structured-data/medical/epidermolysis-bullosa.json": [
		851135,
		3,
		851135
	],
	"./education-center/structured-data/medical/epidermolytic-hyperkeratosis-late-onset": [
		557737,
		3,
		557737
	],
	"./education-center/structured-data/medical/epidermolytic-hyperkeratosis-late-onset.json": [
		557737,
		3,
		557737
	],
	"./education-center/structured-data/medical/epidermolytic-palmoplantar-keratoderma": [
		736632,
		3,
		736632
	],
	"./education-center/structured-data/medical/epidermolytic-palmoplantar-keratoderma.json": [
		736632,
		3,
		736632
	],
	"./education-center/structured-data/medical/epilepsy-childhood-absence-2": [
		529123,
		3,
		529123
	],
	"./education-center/structured-data/medical/epilepsy-childhood-absence-2.json": [
		529123,
		3,
		529123
	],
	"./education-center/structured-data/medical/epilepsy-childhood-absence-4": [
		89586,
		3,
		89586
	],
	"./education-center/structured-data/medical/epilepsy-childhood-absence-4.json": [
		89586,
		3,
		89586
	],
	"./education-center/structured-data/medical/epilepsy-due-perinatal-stroke": [
		556439,
		3,
		556439
	],
	"./education-center/structured-data/medical/epilepsy-due-perinatal-stroke.json": [
		556439,
		3,
		556439
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-absence-2": [
		13458,
		3,
		13458
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-absence-2.json": [
		13458,
		3,
		13458
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-myoclonic-7": [
		635108,
		3,
		635108
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-myoclonic-7.json": [
		635108,
		3,
		635108
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-myoclonic-8": [
		299315,
		3,
		299315
	],
	"./education-center/structured-data/medical/epilepsy-juvenile-myoclonic-8.json": [
		299315,
		3,
		299315
	],
	"./education-center/structured-data/medical/epilepsy-mitochondrial": [
		355065,
		3,
		355065
	],
	"./education-center/structured-data/medical/epilepsy-mitochondrial.json": [
		355065,
		3,
		355065
	],
	"./education-center/structured-data/medical/epilepsy-progressive-myoclonic-3-intracellular-inclusions": [
		78149,
		3,
		78149
	],
	"./education-center/structured-data/medical/epilepsy-progressive-myoclonic-3-intracellular-inclusions.json": [
		78149,
		3,
		78149
	],
	"./education-center/structured-data/medical/epilepsy-x-linked-2-or-without-impaired-intellectual-development-and-dysmorphic-features": [
		419858,
		3,
		419858
	],
	"./education-center/structured-data/medical/epilepsy-x-linked-2-or-without-impaired-intellectual-development-and-dysmorphic-features.json": [
		419858,
		3,
		419858
	],
	"./education-center/structured-data/medical/epileptic-encephalopathy": [
		888761,
		3,
		888761
	],
	"./education-center/structured-data/medical/epileptic-encephalopathy-early-infanitle-1": [
		551958,
		3,
		551958
	],
	"./education-center/structured-data/medical/epileptic-encephalopathy-early-infanitle-1.json": [
		551958,
		3,
		551958
	],
	"./education-center/structured-data/medical/epileptic-encephalopathy.json": [
		888761,
		3,
		888761
	],
	"./education-center/structured-data/medical/epileptic-spasm": [
		466181,
		3,
		466181
	],
	"./education-center/structured-data/medical/epileptic-spasm.json": [
		466181,
		3,
		466181
	],
	"./education-center/structured-data/medical/epiphyseal-dysplasia-multiple-1-severe": [
		783765,
		3,
		783765
	],
	"./education-center/structured-data/medical/epiphyseal-dysplasia-multiple-1-severe.json": [
		783765,
		3,
		783765
	],
	"./education-center/structured-data/medical/epiphyseal-dysplasia-multiple-3-myopathy": [
		200222,
		3,
		200222
	],
	"./education-center/structured-data/medical/epiphyseal-dysplasia-multiple-3-myopathy.json": [
		200222,
		3,
		200222
	],
	"./education-center/structured-data/medical/episodic-ataxia-type-2": [
		652123,
		3,
		652123
	],
	"./education-center/structured-data/medical/episodic-ataxia-type-2-and-epilepsy": [
		966605,
		3,
		966605
	],
	"./education-center/structured-data/medical/episodic-ataxia-type-2-and-epilepsy.json": [
		966605,
		3,
		966605
	],
	"./education-center/structured-data/medical/episodic-ataxia-type-2.json": [
		652123,
		3,
		652123
	],
	"./education-center/structured-data/medical/episodic-ataxiamyokymia-syndrome": [
		697608,
		3,
		697608
	],
	"./education-center/structured-data/medical/episodic-ataxiamyokymia-syndrome.json": [
		697608,
		3,
		697608
	],
	"./education-center/structured-data/medical/epithelial-basement-membrane-dystrophy": [
		707549,
		3,
		707549
	],
	"./education-center/structured-data/medical/epithelial-basement-membrane-dystrophy.json": [
		707549,
		3,
		707549
	],
	"./education-center/structured-data/medical/epithelial-recurrent-erosion-dystrophy": [
		532311,
		3,
		532311
	],
	"./education-center/structured-data/medical/epithelial-recurrent-erosion-dystrophy.json": [
		532311,
		3,
		532311
	],
	"./education-center/structured-data/medical/epithelial-stromal-tgfbi-dystrophy": [
		158142,
		3,
		158142
	],
	"./education-center/structured-data/medical/epithelial-stromal-tgfbi-dystrophy.json": [
		158142,
		3,
		158142
	],
	"./education-center/structured-data/medical/ercc2-related-disorders": [
		847003,
		3,
		847003
	],
	"./education-center/structured-data/medical/ercc2-related-disorders.json": [
		847003,
		3,
		847003
	],
	"./education-center/structured-data/medical/ercc6-related-disorders": [
		723051,
		3,
		723051
	],
	"./education-center/structured-data/medical/ercc6-related-disorders.json": [
		723051,
		3,
		723051
	],
	"./education-center/structured-data/medical/erlotinib-response": [
		542854,
		3,
		542854
	],
	"./education-center/structured-data/medical/erlotinib-response-efficacy": [
		980468,
		3,
		980468
	],
	"./education-center/structured-data/medical/erlotinib-response-efficacy.json": [
		980468,
		3,
		980468
	],
	"./education-center/structured-data/medical/erlotinib-response.json": [
		542854,
		3,
		542854
	],
	"./education-center/structured-data/medical/erythrocyte-amp-deaminase-deficiency": [
		995983,
		3,
		995983
	],
	"./education-center/structured-data/medical/erythrocyte-amp-deaminase-deficiency.json": [
		995983,
		3,
		995983
	],
	"./education-center/structured-data/medical/erythrocytosis": [
		479801,
		3,
		479801
	],
	"./education-center/structured-data/medical/erythrocytosis-jak2-related-somatic": [
		959335,
		3,
		959335
	],
	"./education-center/structured-data/medical/erythrocytosis-jak2-related-somatic.json": [
		959335,
		3,
		959335
	],
	"./education-center/structured-data/medical/erythrocytosis.json": [
		479801,
		3,
		479801
	],
	"./education-center/structured-data/medical/erythroleukemia-familial-susceptibility": [
		523295,
		3,
		523295
	],
	"./education-center/structured-data/medical/erythroleukemia-familial-susceptibility.json": [
		523295,
		3,
		523295
	],
	"./education-center/structured-data/medical/esophageal-atresia": [
		453723,
		3,
		453723
	],
	"./education-center/structured-data/medical/esophageal-atresia.json": [
		453723,
		3,
		453723
	],
	"./education-center/structured-data/medical/esophageal-cancer-alcohol-related-susceptibility": [
		81047,
		3,
		81047
	],
	"./education-center/structured-data/medical/esophageal-cancer-alcohol-related-susceptibility.json": [
		81047,
		3,
		81047
	],
	"./education-center/structured-data/medical/esophageal-carcinoma-somatic": [
		575116,
		3,
		575116
	],
	"./education-center/structured-data/medical/esophageal-carcinoma-somatic.json": [
		575116,
		3,
		575116
	],
	"./education-center/structured-data/medical/esophageal-squamous-cell-carcinoma": [
		110804,
		3,
		110804
	],
	"./education-center/structured-data/medical/esophageal-squamous-cell-carcinoma-somatic": [
		291809,
		3,
		291809
	],
	"./education-center/structured-data/medical/esophageal-squamous-cell-carcinoma-somatic.json": [
		291809,
		3,
		291809
	],
	"./education-center/structured-data/medical/esophageal-squamous-cell-carcinoma.json": [
		110804,
		3,
		110804
	],
	"./education-center/structured-data/medical/essential-hypertension": [
		312289,
		3,
		312289
	],
	"./education-center/structured-data/medical/essential-hypertension-genetic": [
		430646,
		3,
		430646
	],
	"./education-center/structured-data/medical/essential-hypertension-genetic.json": [
		430646,
		3,
		430646
	],
	"./education-center/structured-data/medical/essential-hypertension.json": [
		312289,
		3,
		312289
	],
	"./education-center/structured-data/medical/estrogen-receptor-mutant-temperature-sensitive": [
		344966,
		3,
		344966
	],
	"./education-center/structured-data/medical/estrogen-receptor-mutant-temperature-sensitive.json": [
		344966,
		3,
		344966
	],
	"./education-center/structured-data/medical/etanercept-response-efficacy": [
		418081,
		3,
		418081
	],
	"./education-center/structured-data/medical/etanercept-response-efficacy.json": [
		418081,
		3,
		418081
	],
	"./education-center/structured-data/medical/euthyroid-goiter": [
		941913,
		3,
		941913
	],
	"./education-center/structured-data/medical/euthyroid-goiter.json": [
		941913,
		3,
		941913
	],
	"./education-center/structured-data/medical/evans-syndrome-immunodeficiency-and-premature-immunosenescence-associated-tripeptidyl-peptidase-ii": [
		493474,
		3,
		493474
	],
	"./education-center/structured-data/medical/evans-syndrome-immunodeficiency-and-premature-immunosenescence-associated-tripeptidyl-peptidase-ii.json": [
		493474,
		3,
		493474
	],
	"./education-center/structured-data/medical/ewing-sarcoma-soft-tissue": [
		587846,
		3,
		587846
	],
	"./education-center/structured-data/medical/ewing-sarcoma-soft-tissue.json": [
		587846,
		3,
		587846
	],
	"./education-center/structured-data/medical/exaggerated-startle-response": [
		438505,
		3,
		438505
	],
	"./education-center/structured-data/medical/exaggerated-startle-response.json": [
		438505,
		3,
		438505
	],
	"./education-center/structured-data/medical/exercise-intolerance": [
		31444,
		3,
		31444
	],
	"./education-center/structured-data/medical/exercise-intolerance-and-complex-iii-deficiency-somatic": [
		224201,
		3,
		224201
	],
	"./education-center/structured-data/medical/exercise-intolerance-and-complex-iii-deficiency-somatic.json": [
		224201,
		3,
		224201
	],
	"./education-center/structured-data/medical/exercise-intolerance-muscle-pain-and-lactic-acidemia": [
		41731,
		3,
		41731
	],
	"./education-center/structured-data/medical/exercise-intolerance-muscle-pain-and-lactic-acidemia.json": [
		41731,
		3,
		41731
	],
	"./education-center/structured-data/medical/exercise-intolerance.json": [
		31444,
		3,
		31444
	],
	"./education-center/structured-data/medical/exercise-stress-response-impaired-association": [
		203339,
		3,
		203339
	],
	"./education-center/structured-data/medical/exercise-stress-response-impaired-association.json": [
		203339,
		3,
		203339
	],
	"./education-center/structured-data/medical/exertional-myalgia-muscle-stiffness-and-myoglobinuria": [
		463599,
		3,
		463599
	],
	"./education-center/structured-data/medical/exertional-myalgia-muscle-stiffness-and-myoglobinuria.json": [
		463599,
		3,
		463599
	],
	"./education-center/structured-data/medical/exostoses-multiple-type-1": [
		144428,
		3,
		144428
	],
	"./education-center/structured-data/medical/exostoses-multiple-type-1.json": [
		144428,
		3,
		144428
	],
	"./education-center/structured-data/medical/exostoses-multiple-type-2": [
		1895,
		3,
		1895
	],
	"./education-center/structured-data/medical/exostoses-multiple-type-2.json": [
		1895,
		3,
		1895
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-1": [
		589881,
		3,
		589881
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-1.json": [
		589881,
		3,
		589881
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-autosomal-dominant": [
		262097,
		3,
		262097
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-autosomal-dominant.json": [
		262097,
		3,
		262097
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-autosomal-recessive": [
		88971,
		3,
		88971
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-autosomal-recessive.json": [
		88971,
		3,
		88971
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-digenic": [
		859681,
		3,
		859681
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-4-digenic.json": [
		859681,
		3,
		859681
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-digenic": [
		352492,
		3,
		352492
	],
	"./education-center/structured-data/medical/exudative-vitreoretinopathy-digenic.json": [
		352492,
		3,
		352492
	],
	"./education-center/structured-data/medical/eya4-related-disorders": [
		3449,
		3,
		3449
	],
	"./education-center/structured-data/medical/eya4-related-disorders.json": [
		3449,
		3,
		3449
	],
	"./education-center/structured-data/medical/ezetimibe-response": [
		531816,
		3,
		531816
	],
	"./education-center/structured-data/medical/ezetimibe-response.json": [
		531816,
		3,
		531816
	],
	"./education-center/structured-data/medical/f12-related-disorders": [
		503059,
		3,
		503059
	],
	"./education-center/structured-data/medical/f12-related-disorders.json": [
		503059,
		3,
		503059
	],
	"./education-center/structured-data/medical/fabry-disease-cardiac-variant": [
		399847,
		3,
		399847
	],
	"./education-center/structured-data/medical/fabry-disease-cardiac-variant.json": [
		399847,
		3,
		399847
	],
	"./education-center/structured-data/medical/facial-hypotonia": [
		21490,
		3,
		21490
	],
	"./education-center/structured-data/medical/facial-hypotonia.json": [
		21490,
		3,
		21490
	],
	"./education-center/structured-data/medical/facioscapulohumeral-muscular-dystrophy-2": [
		562150,
		3,
		562150
	],
	"./education-center/structured-data/medical/facioscapulohumeral-muscular-dystrophy-2.json": [
		562150,
		3,
		562150
	],
	"./education-center/structured-data/medical/factor-v-hong-kong": [
		403724,
		3,
		403724
	],
	"./education-center/structured-data/medical/factor-v-hong-kong.json": [
		403724,
		3,
		403724
	],
	"./education-center/structured-data/medical/factor-vii-marburg-i-variant-thrombophilia": [
		746834,
		3,
		746834
	],
	"./education-center/structured-data/medical/factor-vii-marburg-i-variant-thrombophilia.json": [
		746834,
		3,
		746834
	],
	"./education-center/structured-data/medical/familial-amyloid-polyneuropathy-iowa-type": [
		757514,
		3,
		757514
	],
	"./education-center/structured-data/medical/familial-amyloid-polyneuropathy-iowa-type.json": [
		757514,
		3,
		757514
	],
	"./education-center/structured-data/medical/familial-aortic-aneurysms": [
		798429,
		3,
		798429
	],
	"./education-center/structured-data/medical/familial-aortic-aneurysms.json": [
		798429,
		3,
		798429
	],
	"./education-center/structured-data/medical/familial-aortopathy": [
		101205,
		3,
		101205
	],
	"./education-center/structured-data/medical/familial-aortopathy.json": [
		101205,
		3,
		101205
	],
	"./education-center/structured-data/medical/familial-atypical-hemolytic-uremic-syndrome": [
		277623,
		3,
		277623
	],
	"./education-center/structured-data/medical/familial-atypical-hemolytic-uremic-syndrome.json": [
		277623,
		3,
		277623
	],
	"./education-center/structured-data/medical/familial-atypical-mycobacteriosis-autosomal-dominant": [
		834331,
		3,
		834331
	],
	"./education-center/structured-data/medical/familial-atypical-mycobacteriosis-autosomal-dominant.json": [
		834331,
		3,
		834331
	],
	"./education-center/structured-data/medical/familial-atypical-mycobacteriosis-autosomal-recessive": [
		677102,
		3,
		677102
	],
	"./education-center/structured-data/medical/familial-atypical-mycobacteriosis-autosomal-recessive.json": [
		677102,
		3,
		677102
	],
	"./education-center/structured-data/medical/familial-candidiasis-recessive": [
		940578,
		3,
		940578
	],
	"./education-center/structured-data/medical/familial-candidiasis-recessive.json": [
		940578,
		3,
		940578
	],
	"./education-center/structured-data/medical/familial-cold-autoinflammatory-syndrome-1": [
		471310,
		3,
		471310
	],
	"./education-center/structured-data/medical/familial-cold-autoinflammatory-syndrome-1.json": [
		471310,
		3,
		471310
	],
	"./education-center/structured-data/medical/familial-congenital-nasolacrimal-duct-obstruction": [
		2566,
		3,
		2566
	],
	"./education-center/structured-data/medical/familial-congenital-nasolacrimal-duct-obstruction.json": [
		2566,
		3,
		2566
	],
	"./education-center/structured-data/medical/familial-cylindromatosis": [
		3790,
		3,
		3790
	],
	"./education-center/structured-data/medical/familial-cylindromatosis.json": [
		3790,
		3,
		3790
	],
	"./education-center/structured-data/medical/familial-ectopia-lentis": [
		349125,
		3,
		349125
	],
	"./education-center/structured-data/medical/familial-ectopia-lentis.json": [
		349125,
		3,
		349125
	],
	"./education-center/structured-data/medical/familial-erythrocytosis": [
		429269,
		3,
		429269
	],
	"./education-center/structured-data/medical/familial-erythrocytosis.json": [
		429269,
		3,
		429269
	],
	"./education-center/structured-data/medical/familial-hematuria": [
		28849,
		3,
		28849
	],
	"./education-center/structured-data/medical/familial-hematuria.json": [
		28849,
		3,
		28849
	],
	"./education-center/structured-data/medical/familial-hemiplegic-migraine": [
		913222,
		3,
		913222
	],
	"./education-center/structured-data/medical/familial-hemiplegic-migraine.json": [
		913222,
		3,
		913222
	],
	"./education-center/structured-data/medical/familial-high-density-lipoprotein-deficiency": [
		297919,
		3,
		297919
	],
	"./education-center/structured-data/medical/familial-high-density-lipoprotein-deficiency.json": [
		297919,
		3,
		297919
	],
	"./education-center/structured-data/medical/familial-hypercholesterolemia": [
		147452,
		3,
		147452
	],
	"./education-center/structured-data/medical/familial-hypercholesterolemia.json": [
		147452,
		3,
		147452
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-22": [
		81562,
		3,
		81562
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-22.json": [
		81562,
		3,
		81562
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-24": [
		697226,
		3,
		697226
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-24.json": [
		697226,
		3,
		697226
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-wolff-parkinson-white-syndrome": [
		524721,
		3,
		524721
	],
	"./education-center/structured-data/medical/familial-hypertrophic-cardiomyopathy-wolff-parkinson-white-syndrome.json": [
		524721,
		3,
		524721
	],
	"./education-center/structured-data/medical/familial-hypoalphalipoproteinemia": [
		102193,
		3,
		102193
	],
	"./education-center/structured-data/medical/familial-hypoalphalipoproteinemia.json": [
		102193,
		3,
		102193
	],
	"./education-center/structured-data/medical/familial-hypobetalipoproteinemia": [
		776000,
		3,
		776000
	],
	"./education-center/structured-data/medical/familial-hypobetalipoproteinemia.json": [
		776000,
		3,
		776000
	],
	"./education-center/structured-data/medical/familial-hypocalciuric-hypercalcemia-1": [
		272935,
		3,
		272935
	],
	"./education-center/structured-data/medical/familial-hypocalciuric-hypercalcemia-1.json": [
		272935,
		3,
		272935
	],
	"./education-center/structured-data/medical/familial-hypocalciuric-hypercalcemia-2": [
		992244,
		3,
		992244
	],
	"./education-center/structured-data/medical/familial-hypocalciuric-hypercalcemia-2.json": [
		992244,
		3,
		992244
	],
	"./education-center/structured-data/medical/familial-idiopathic-hypercalciuria": [
		975896,
		3,
		975896
	],
	"./education-center/structured-data/medical/familial-idiopathic-hypercalciuria.json": [
		975896,
		3,
		975896
	],
	"./education-center/structured-data/medical/familial-mediterranean-fever-autosomal-dominant": [
		301304,
		3,
		301304
	],
	"./education-center/structured-data/medical/familial-mediterranean-fever-autosomal-dominant.json": [
		301304,
		3,
		301304
	],
	"./education-center/structured-data/medical/familial-medullary-thyroid-carcinoma": [
		555774,
		3,
		555774
	],
	"./education-center/structured-data/medical/familial-medullary-thyroid-carcinoma.json": [
		555774,
		3,
		555774
	],
	"./education-center/structured-data/medical/familial-partial-lipodystrophy-dunnigan-type": [
		454548,
		3,
		454548
	],
	"./education-center/structured-data/medical/familial-partial-lipodystrophy-dunnigan-type.json": [
		454548,
		3,
		454548
	],
	"./education-center/structured-data/medical/familial-periodic-fever": [
		548204,
		3,
		548204
	],
	"./education-center/structured-data/medical/familial-periodic-fever.json": [
		548204,
		3,
		548204
	],
	"./education-center/structured-data/medical/familial-periodic-paralysis": [
		328831,
		3,
		328831
	],
	"./education-center/structured-data/medical/familial-periodic-paralysis.json": [
		328831,
		3,
		328831
	],
	"./education-center/structured-data/medical/familial-type-5-hyperlipoproteinemia": [
		622952,
		3,
		622952
	],
	"./education-center/structured-data/medical/familial-type-5-hyperlipoproteinemia.json": [
		622952,
		3,
		622952
	],
	"./education-center/structured-data/medical/familial-visceral-amyloidosis-ostertag-type": [
		693563,
		3,
		693563
	],
	"./education-center/structured-data/medical/familial-visceral-amyloidosis-ostertag-type.json": [
		693563,
		3,
		693563
	],
	"./education-center/structured-data/medical/family-history": [
		485989,
		3,
		485989
	],
	"./education-center/structured-data/medical/family-history-cardiomyopathy": [
		70929,
		3,
		70929
	],
	"./education-center/structured-data/medical/family-history-cardiomyopathy.json": [
		70929,
		3,
		70929
	],
	"./education-center/structured-data/medical/family-history-sudden-cardiac-death": [
		772635,
		3,
		772635
	],
	"./education-center/structured-data/medical/family-history-sudden-cardiac-death.json": [
		772635,
		3,
		772635
	],
	"./education-center/structured-data/medical/family-history.json": [
		485989,
		3,
		485989
	],
	"./education-center/structured-data/medical/fanconi-anemia-complementation-group-m": [
		851120,
		3,
		851120
	],
	"./education-center/structured-data/medical/fanconi-anemia-complementation-group-m.json": [
		851120,
		3,
		851120
	],
	"./education-center/structured-data/medical/fanconi-anemia-x-linked": [
		306585,
		3,
		306585
	],
	"./education-center/structured-data/medical/fanconi-anemia-x-linked.json": [
		306585,
		3,
		306585
	],
	"./education-center/structured-data/medical/fasting-plasma-glucose-level-quantitative-trait-locus-1": [
		982118,
		3,
		982118
	],
	"./education-center/structured-data/medical/fasting-plasma-glucose-level-quantitative-trait-locus-1.json": [
		982118,
		3,
		982118
	],
	"./education-center/structured-data/medical/fasting-plasma-glucose-level-quantitative-trait-locus-5": [
		960851,
		3,
		960851
	],
	"./education-center/structured-data/medical/fasting-plasma-glucose-level-quantitative-trait-locus-5.json": [
		960851,
		3,
		960851
	],
	"./education-center/structured-data/medical/fatal-infantile-cardioencephalomyopathy": [
		696947,
		3,
		696947
	],
	"./education-center/structured-data/medical/fatal-infantile-cardioencephalomyopathy.json": [
		696947,
		3,
		696947
	],
	"./education-center/structured-data/medical/fatal-infantile-mitochondrial-cardiomyopathy": [
		125328,
		3,
		125328
	],
	"./education-center/structured-data/medical/fatal-infantile-mitochondrial-cardiomyopathy.json": [
		125328,
		3,
		125328
	],
	"./education-center/structured-data/medical/febrile-seizures-familial": [
		170245,
		3,
		170245
	],
	"./education-center/structured-data/medical/febrile-seizures-familial-1": [
		77706,
		3,
		77706
	],
	"./education-center/structured-data/medical/febrile-seizures-familial-1.json": [
		77706,
		3,
		77706
	],
	"./education-center/structured-data/medical/febrile-seizures-familial.json": [
		170245,
		3,
		170245
	],
	"./education-center/structured-data/medical/fetal-cystic-hygroma": [
		898885,
		3,
		898885
	],
	"./education-center/structured-data/medical/fetal-cystic-hygroma.json": [
		898885,
		3,
		898885
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-1": [
		722569,
		3,
		722569
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-1.json": [
		722569,
		3,
		722569
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-5": [
		795642,
		3,
		795642
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-5.json": [
		795642,
		3,
		795642
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-6": [
		806421,
		3,
		806421
	],
	"./education-center/structured-data/medical/fetal-hemoglobin-quantitative-trait-locus-6.json": [
		806421,
		3,
		806421
	],
	"./education-center/structured-data/medical/fgfr2-related-craniosynostosis": [
		597796,
		3,
		597796
	],
	"./education-center/structured-data/medical/fgfr2-related-craniosynostosis.json": [
		597796,
		3,
		597796
	],
	"./education-center/structured-data/medical/fibrinogen-milano-xii-digenic": [
		633592,
		3,
		633592
	],
	"./education-center/structured-data/medical/fibrinogen-milano-xii-digenic.json": [
		633592,
		3,
		633592
	],
	"./education-center/structured-data/medical/fibromatosis-gingival-1": [
		107871,
		3,
		107871
	],
	"./education-center/structured-data/medical/fibromatosis-gingival-1.json": [
		107871,
		3,
		107871
	],
	"./education-center/structured-data/medical/fibromuscular-dysplasia-multifocal": [
		621883,
		3,
		621883
	],
	"./education-center/structured-data/medical/fibromuscular-dysplasia-multifocal.json": [
		621883,
		3,
		621883
	],
	"./education-center/structured-data/medical/fibrous-dysplasia-jaw": [
		108358,
		3,
		108358
	],
	"./education-center/structured-data/medical/fibrous-dysplasia-jaw.json": [
		108358,
		3,
		108358
	],
	"./education-center/structured-data/medical/fibrous-sheath-dysplasia": [
		117991,
		3,
		117991
	],
	"./education-center/structured-data/medical/fibrous-sheath-dysplasia.json": [
		117991,
		3,
		117991
	],
	"./education-center/structured-data/medical/fig4-related-disorders": [
		243275,
		3,
		243275
	],
	"./education-center/structured-data/medical/fig4-related-disorders.json": [
		243275,
		3,
		243275
	],
	"./education-center/structured-data/medical/first-degree-atrioventricular-block": [
		366065,
		3,
		366065
	],
	"./education-center/structured-data/medical/first-degree-atrioventricular-block.json": [
		366065,
		3,
		366065
	],
	"./education-center/structured-data/medical/fish-eye-disease": [
		467358,
		3,
		467358
	],
	"./education-center/structured-data/medical/fish-eye-disease.json": [
		467358,
		3,
		467358
	],
	"./education-center/structured-data/medical/fleck-corneal-dystrophy": [
		458042,
		3,
		458042
	],
	"./education-center/structured-data/medical/fleck-corneal-dystrophy.json": [
		458042,
		3,
		458042
	],
	"./education-center/structured-data/medical/flna-related-disorders": [
		171519,
		3,
		171519
	],
	"./education-center/structured-data/medical/flna-related-disorders.json": [
		171519,
		3,
		171519
	],
	"./education-center/structured-data/medical/flnb-related-disorders": [
		96096,
		3,
		96096
	],
	"./education-center/structured-data/medical/flnb-related-disorders.json": [
		96096,
		3,
		96096
	],
	"./education-center/structured-data/medical/flnb-related-spectrum-disorders": [
		142972,
		3,
		142972
	],
	"./education-center/structured-data/medical/flnb-related-spectrum-disorders.json": [
		142972,
		3,
		142972
	],
	"./education-center/structured-data/medical/floating-harbor-syndrome": [
		794933,
		3,
		794933
	],
	"./education-center/structured-data/medical/floating-harbor-syndrome.json": [
		794933,
		3,
		794933
	],
	"./education-center/structured-data/medical/flurbiprofen-response": [
		233053,
		3,
		233053
	],
	"./education-center/structured-data/medical/flurbiprofen-response.json": [
		233053,
		3,
		233053
	],
	"./education-center/structured-data/medical/fmo3-activity-decreased": [
		986407,
		3,
		986407
	],
	"./education-center/structured-data/medical/fmo3-activity-decreased.json": [
		986407,
		3,
		986407
	],
	"./education-center/structured-data/medical/focal-clonic-seizure": [
		560000,
		3,
		560000
	],
	"./education-center/structured-data/medical/focal-clonic-seizure.json": [
		560000,
		3,
		560000
	],
	"./education-center/structured-data/medical/focal-cortical-dysplasia-taylor-type-2b": [
		635926,
		3,
		635926
	],
	"./education-center/structured-data/medical/focal-cortical-dysplasia-taylor-type-2b.json": [
		635926,
		3,
		635926
	],
	"./education-center/structured-data/medical/focal-impaired-awareness-seizure": [
		962936,
		3,
		962936
	],
	"./education-center/structured-data/medical/focal-impaired-awareness-seizure.json": [
		962936,
		3,
		962936
	],
	"./education-center/structured-data/medical/focal-onset-seizure": [
		496733,
		3,
		496733
	],
	"./education-center/structured-data/medical/focal-onset-seizure.json": [
		496733,
		3,
		496733
	],
	"./education-center/structured-data/medical/focal-segmental-glomerulosclerosis-3": [
		169785,
		3,
		169785
	],
	"./education-center/structured-data/medical/focal-segmental-glomerulosclerosis-3.json": [
		169785,
		3,
		169785
	],
	"./education-center/structured-data/medical/focal-segmental-glomerulosclerosis-and-dilated-cardiomyopathy": [
		693125,
		3,
		693125
	],
	"./education-center/structured-data/medical/focal-segmental-glomerulosclerosis-and-dilated-cardiomyopathy.json": [
		693125,
		3,
		693125
	],
	"./education-center/structured-data/medical/forebrain-defects": [
		880228,
		3,
		880228
	],
	"./education-center/structured-data/medical/forebrain-defects.json": [
		880228,
		3,
		880228
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1": [
		222054,
		3,
		222054
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1-cataract": [
		340218,
		3,
		340218
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1-cataract.json": [
		340218,
		3,
		340218
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1-or-without-anterior-segment-anomalies": [
		430000,
		3,
		430000
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1-or-without-anterior-segment-anomalies.json": [
		430000,
		3,
		430000
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-1.json": [
		222054,
		3,
		222054
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-2-and-optic-nerve-misrouting-or-without-anterior-segment-dysgenesis": [
		320400,
		3,
		320400
	],
	"./education-center/structured-data/medical/foveal-hypoplasia-2-and-optic-nerve-misrouting-or-without-anterior-segment-dysgenesis.json": [
		320400,
		3,
		320400
	],
	"./education-center/structured-data/medical/frasier-syndrome": [
		436447,
		3,
		436447
	],
	"./education-center/structured-data/medical/frasier-syndrome.json": [
		436447,
		3,
		436447
	],
	"./education-center/structured-data/medical/frontorhiny": [
		135465,
		3,
		135465
	],
	"./education-center/structured-data/medical/frontorhiny.json": [
		135465,
		3,
		135465
	],
	"./education-center/structured-data/medical/frontotemporal-dementia-andor-amyotrophic-lateral-sclerosis-1": [
		787393,
		3,
		787393
	],
	"./education-center/structured-data/medical/frontotemporal-dementia-andor-amyotrophic-lateral-sclerosis-1.json": [
		787393,
		3,
		787393
	],
	"./education-center/structured-data/medical/frontotemporal-dementia-tdp43-inclusions-tardbp-related": [
		240759,
		3,
		240759
	],
	"./education-center/structured-data/medical/frontotemporal-dementia-tdp43-inclusions-tardbp-related.json": [
		240759,
		3,
		240759
	],
	"./education-center/structured-data/medical/frontotemporal-lobar-degeneration-tardbp-related": [
		655852,
		3,
		655852
	],
	"./education-center/structured-data/medical/frontotemporal-lobar-degeneration-tardbp-related.json": [
		655852,
		3,
		655852
	],
	"./education-center/structured-data/medical/fulminant-hepatic-failure": [
		775055,
		3,
		775055
	],
	"./education-center/structured-data/medical/fulminant-hepatic-failure.json": [
		775055,
		3,
		775055
	],
	"./education-center/structured-data/medical/fumarylacetoacetase-pseudodeficiency": [
		425756,
		3,
		425756
	],
	"./education-center/structured-data/medical/fumarylacetoacetase-pseudodeficiency.json": [
		425756,
		3,
		425756
	],
	"./education-center/structured-data/medical/fundus-albipunctatus-autosomal-recessive": [
		88355,
		3,
		88355
	],
	"./education-center/structured-data/medical/fundus-albipunctatus-autosomal-recessive.json": [
		88355,
		3,
		88355
	],
	"./education-center/structured-data/medical/g6pd-deficiency": [
		160654,
		3,
		160654
	],
	"./education-center/structured-data/medical/g6pd-deficiency.json": [
		160654,
		3,
		160654
	],
	"./education-center/structured-data/medical/galactose-epimerase-deficiency-severe": [
		272529,
		3,
		272529
	],
	"./education-center/structured-data/medical/galactose-epimerase-deficiency-severe.json": [
		272529,
		3,
		272529
	],
	"./education-center/structured-data/medical/galactosialidosis-adult": [
		802765,
		3,
		802765
	],
	"./education-center/structured-data/medical/galactosialidosis-adult.json": [
		802765,
		3,
		802765
	],
	"./education-center/structured-data/medical/galactosialidosis-early-infantile": [
		514298,
		3,
		514298
	],
	"./education-center/structured-data/medical/galactosialidosis-early-infantile.json": [
		514298,
		3,
		514298
	],
	"./education-center/structured-data/medical/galactosialidosis-late-infantile": [
		998635,
		3,
		998635
	],
	"./education-center/structured-data/medical/galactosialidosis-late-infantile.json": [
		998635,
		3,
		998635
	],
	"./education-center/structured-data/medical/gallbladder-cancer": [
		862549,
		3,
		862549
	],
	"./education-center/structured-data/medical/gallbladder-cancer.json": [
		862549,
		3,
		862549
	],
	"./education-center/structured-data/medical/gallbladder-disease-4": [
		284980,
		3,
		284980
	],
	"./education-center/structured-data/medical/gallbladder-disease-4.json": [
		284980,
		3,
		284980
	],
	"./education-center/structured-data/medical/galloway-mowat-syndrome": [
		687399,
		3,
		687399
	],
	"./education-center/structured-data/medical/galloway-mowat-syndrome.json": [
		687399,
		3,
		687399
	],
	"./education-center/structured-data/medical/gars-associated-axonal-neuropathy": [
		306262,
		3,
		306262
	],
	"./education-center/structured-data/medical/gars-associated-axonal-neuropathy.json": [
		306262,
		3,
		306262
	],
	"./education-center/structured-data/medical/gastric-cancer": [
		260018,
		3,
		260018
	],
	"./education-center/structured-data/medical/gastric-cancer-familial-diffuse-and-cleft-lip-or-without-cleft-palate": [
		134514,
		3,
		134514
	],
	"./education-center/structured-data/medical/gastric-cancer-familial-diffuse-and-cleft-lip-or-without-cleft-palate.json": [
		134514,
		3,
		134514
	],
	"./education-center/structured-data/medical/gastric-cancer.json": [
		260018,
		3,
		260018
	],
	"./education-center/structured-data/medical/gastrointestinal-hemorrhage": [
		311421,
		3,
		311421
	],
	"./education-center/structured-data/medical/gastrointestinal-hemorrhage.json": [
		311421,
		3,
		311421
	],
	"./education-center/structured-data/medical/gastrointestinal-polyposis": [
		635431,
		3,
		635431
	],
	"./education-center/structured-data/medical/gastrointestinal-polyposis.json": [
		635431,
		3,
		635431
	],
	"./education-center/structured-data/medical/gastrointestinal-stromal-tumor-familial": [
		462679,
		3,
		462679
	],
	"./education-center/structured-data/medical/gastrointestinal-stromal-tumor-familial.json": [
		462679,
		3,
		462679
	],
	"./education-center/structured-data/medical/gastrointestinal-stromal-tumor-small-intestine": [
		817945,
		3,
		817945
	],
	"./education-center/structured-data/medical/gastrointestinal-stromal-tumor-small-intestine.json": [
		817945,
		3,
		817945
	],
	"./education-center/structured-data/medical/gbe1-related-disorders": [
		469146,
		3,
		469146
	],
	"./education-center/structured-data/medical/gbe1-related-disorders.json": [
		469146,
		3,
		469146
	],
	"./education-center/structured-data/medical/gefitinib-response": [
		219314,
		3,
		219314
	],
	"./education-center/structured-data/medical/gefitinib-response-efficacy": [
		234524,
		3,
		234524
	],
	"./education-center/structured-data/medical/gefitinib-response-efficacy.json": [
		234524,
		3,
		234524
	],
	"./education-center/structured-data/medical/gefitinib-response.json": [
		219314,
		3,
		219314
	],
	"./education-center/structured-data/medical/geleophysic-dysplasia": [
		111325,
		3,
		111325
	],
	"./education-center/structured-data/medical/geleophysic-dysplasia.json": [
		111325,
		3,
		111325
	],
	"./education-center/structured-data/medical/gemcitabine-response": [
		798616,
		3,
		798616
	],
	"./education-center/structured-data/medical/gemcitabine-response.json": [
		798616,
		3,
		798616
	],
	"./education-center/structured-data/medical/generalized-cerebral-atrophyhypoplasia": [
		478475,
		3,
		478475
	],
	"./education-center/structured-data/medical/generalized-cerebral-atrophyhypoplasia.json": [
		478475,
		3,
		478475
	],
	"./education-center/structured-data/medical/generalized-dominant-dystrophic-epidermolysis-bullosa": [
		893370,
		3,
		893370
	],
	"./education-center/structured-data/medical/generalized-dominant-dystrophic-epidermolysis-bullosa.json": [
		893370,
		3,
		893370
	],
	"./education-center/structured-data/medical/generalized-dystonia": [
		798456,
		3,
		798456
	],
	"./education-center/structured-data/medical/generalized-dystonia.json": [
		798456,
		3,
		798456
	],
	"./education-center/structured-data/medical/generalized-epilepsy-febrile-seizures-plus-3": [
		449089,
		3,
		449089
	],
	"./education-center/structured-data/medical/generalized-epilepsy-febrile-seizures-plus-3.json": [
		449089,
		3,
		449089
	],
	"./education-center/structured-data/medical/generalized-epilepsy-febrile-seizures-plus-type-5": [
		829841,
		3,
		829841
	],
	"./education-center/structured-data/medical/generalized-epilepsy-febrile-seizures-plus-type-5.json": [
		829841,
		3,
		829841
	],
	"./education-center/structured-data/medical/generalized-hypotonia": [
		13372,
		3,
		13372
	],
	"./education-center/structured-data/medical/generalized-hypotonia.json": [
		13372,
		3,
		13372
	],
	"./education-center/structured-data/medical/generalized-muscle-weakness": [
		951293,
		3,
		951293
	],
	"./education-center/structured-data/medical/generalized-muscle-weakness.json": [
		951293,
		3,
		951293
	],
	"./education-center/structured-data/medical/generalized-myoclonic-seizure": [
		299818,
		3,
		299818
	],
	"./education-center/structured-data/medical/generalized-myoclonic-seizure.json": [
		299818,
		3,
		299818
	],
	"./education-center/structured-data/medical/generalized-non-motor-absence-seizure": [
		493876,
		3,
		493876
	],
	"./education-center/structured-data/medical/generalized-non-motor-absence-seizure.json": [
		493876,
		3,
		493876
	],
	"./education-center/structured-data/medical/generalized-onset-seizure": [
		639102,
		3,
		639102
	],
	"./education-center/structured-data/medical/generalized-onset-seizure.json": [
		639102,
		3,
		639102
	],
	"./education-center/structured-data/medical/generalized-tonic-clonic-seizures": [
		657937,
		3,
		657937
	],
	"./education-center/structured-data/medical/generalized-tonic-clonic-seizures.json": [
		657937,
		3,
		657937
	],
	"./education-center/structured-data/medical/genetic-non-acquired-premature-ovarian-failure": [
		109830,
		3,
		109830
	],
	"./education-center/structured-data/medical/genetic-non-acquired-premature-ovarian-failure.json": [
		109830,
		3,
		109830
	],
	"./education-center/structured-data/medical/gentamicin-response": [
		526144,
		3,
		526144
	],
	"./education-center/structured-data/medical/gentamicin-response.json": [
		526144,
		3,
		526144
	],
	"./education-center/structured-data/medical/gerstmann-straussler-scheinker-syndrome": [
		575730,
		3,
		575730
	],
	"./education-center/structured-data/medical/gerstmann-straussler-scheinker-syndrome.json": [
		575730,
		3,
		575730
	],
	"./education-center/structured-data/medical/gestational-diabetes": [
		106015,
		3,
		106015
	],
	"./education-center/structured-data/medical/gestational-diabetes-mellitus-uncontrolled": [
		311369,
		3,
		311369
	],
	"./education-center/structured-data/medical/gestational-diabetes-mellitus-uncontrolled.json": [
		311369,
		3,
		311369
	],
	"./education-center/structured-data/medical/gestational-diabetes.json": [
		106015,
		3,
		106015
	],
	"./education-center/structured-data/medical/ghosal-hematodiaphyseal-syndrome": [
		689469,
		3,
		689469
	],
	"./education-center/structured-data/medical/ghosal-hematodiaphyseal-syndrome.json": [
		689469,
		3,
		689469
	],
	"./education-center/structured-data/medical/gil-blood-group": [
		366547,
		3,
		366547
	],
	"./education-center/structured-data/medical/gil-blood-group.json": [
		366547,
		3,
		366547
	],
	"./education-center/structured-data/medical/gilbert-syndrome": [
		576812,
		3,
		576812
	],
	"./education-center/structured-data/medical/gilbert-syndrome-susceptibility": [
		824530,
		3,
		824530
	],
	"./education-center/structured-data/medical/gilbert-syndrome-susceptibility.json": [
		824530,
		3,
		824530
	],
	"./education-center/structured-data/medical/gilbert-syndrome.json": [
		576812,
		3,
		576812
	],
	"./education-center/structured-data/medical/gillessen-kaesbach-nishimura-dysplasia": [
		767173,
		3,
		767173
	],
	"./education-center/structured-data/medical/gillessen-kaesbach-nishimura-dysplasia.json": [
		767173,
		3,
		767173
	],
	"./education-center/structured-data/medical/gingival-fibromatosis-hypertrichosis-syndrome": [
		849938,
		3,
		849938
	],
	"./education-center/structured-data/medical/gingival-fibromatosis-hypertrichosis-syndrome.json": [
		849938,
		3,
		849938
	],
	"./education-center/structured-data/medical/gjb6-related-disorders": [
		103709,
		3,
		103709
	],
	"./education-center/structured-data/medical/gjb6-related-disorders.json": [
		103709,
		3,
		103709
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle": [
		62799,
		3,
		62799
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-autosomal-recessive": [
		559582,
		3,
		559582
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-autosomal-recessive.json": [
		559582,
		3,
		559582
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-b": [
		457548,
		3,
		457548
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-b.json": [
		457548,
		3,
		457548
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-digenic": [
		318046,
		3,
		318046
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-digenic.json": [
		318046,
		3,
		318046
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-e": [
		922320,
		3,
		922320
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-e.json": [
		922320,
		3,
		922320
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-f": [
		708813,
		3,
		708813
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-f.json": [
		708813,
		3,
		708813
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-g": [
		853152,
		3,
		853152
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-g.json": [
		853152,
		3,
		853152
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-p": [
		145699,
		3,
		145699
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle-p.json": [
		145699,
		3,
		145699
	],
	"./education-center/structured-data/medical/glaucoma-1-open-angle.json": [
		62799,
		3,
		62799
	],
	"./education-center/structured-data/medical/glaucoma-3-primary-congenital-digenic": [
		243217,
		3,
		243217
	],
	"./education-center/structured-data/medical/glaucoma-3-primary-congenital-digenic.json": [
		243217,
		3,
		243217
	],
	"./education-center/structured-data/medical/glaucoma-early-onset-digenic": [
		407419,
		3,
		407419
	],
	"./education-center/structured-data/medical/glaucoma-early-onset-digenic.json": [
		407419,
		3,
		407419
	],
	"./education-center/structured-data/medical/glaucoma-primary-open-angle-juvenile-onset": [
		192742,
		3,
		192742
	],
	"./education-center/structured-data/medical/glaucoma-primary-open-angle-juvenile-onset.json": [
		192742,
		3,
		192742
	],
	"./education-center/structured-data/medical/glb1-related-disorders": [
		69245,
		3,
		69245
	],
	"./education-center/structured-data/medical/glb1-related-disorders.json": [
		69245,
		3,
		69245
	],
	"./education-center/structured-data/medical/gli3-related-disorders": [
		107505,
		3,
		107505
	],
	"./education-center/structured-data/medical/gli3-related-disorders.json": [
		107505,
		3,
		107505
	],
	"./education-center/structured-data/medical/glibenclamide-response": [
		47102,
		3,
		47102
	],
	"./education-center/structured-data/medical/glibenclamide-response.json": [
		47102,
		3,
		47102
	],
	"./education-center/structured-data/medical/glioblastoma-multiforme": [
		338249,
		3,
		338249
	],
	"./education-center/structured-data/medical/glioblastoma-multiforme-somatic": [
		295617,
		3,
		295617
	],
	"./education-center/structured-data/medical/glioblastoma-multiforme-somatic.json": [
		295617,
		3,
		295617
	],
	"./education-center/structured-data/medical/glioblastoma-multiforme.json": [
		338249,
		3,
		338249
	],
	"./education-center/structured-data/medical/glipizide-response": [
		553969,
		3,
		553969
	],
	"./education-center/structured-data/medical/glipizide-response.json": [
		553969,
		3,
		553969
	],
	"./education-center/structured-data/medical/global-developmental-delay": [
		300523,
		3,
		300523
	],
	"./education-center/structured-data/medical/global-developmental-delay.json": [
		300523,
		3,
		300523
	],
	"./education-center/structured-data/medical/globozoospermia": [
		271724,
		3,
		271724
	],
	"./education-center/structured-data/medical/globozoospermia.json": [
		271724,
		3,
		271724
	],
	"./education-center/structured-data/medical/glomuvenous-malformation": [
		141713,
		3,
		141713
	],
	"./education-center/structured-data/medical/glomuvenous-malformation.json": [
		141713,
		3,
		141713
	],
	"./education-center/structured-data/medical/glucocorticoid-deficiency": [
		965264,
		3,
		965264
	],
	"./education-center/structured-data/medical/glucocorticoid-deficiency.json": [
		965264,
		3,
		965264
	],
	"./education-center/structured-data/medical/glucocorticoid-remediable-aldosteronism": [
		676006,
		3,
		676006
	],
	"./education-center/structured-data/medical/glucocorticoid-remediable-aldosteronism.json": [
		676006,
		3,
		676006
	],
	"./education-center/structured-data/medical/glucocorticoid-resistance-cellular": [
		765577,
		3,
		765577
	],
	"./education-center/structured-data/medical/glucocorticoid-resistance-cellular.json": [
		765577,
		3,
		765577
	],
	"./education-center/structured-data/medical/glucocorticoid-resistance-relative": [
		463059,
		3,
		463059
	],
	"./education-center/structured-data/medical/glucocorticoid-resistance-relative.json": [
		463059,
		3,
		463059
	],
	"./education-center/structured-data/medical/glucose-6-phosphate-transport-defect": [
		515330,
		3,
		515330
	],
	"./education-center/structured-data/medical/glucose-6-phosphate-transport-defect.json": [
		515330,
		3,
		515330
	],
	"./education-center/structured-data/medical/glut1-deficiency-syndrome": [
		998719,
		3,
		998719
	],
	"./education-center/structured-data/medical/glut1-deficiency-syndrome-1-autosomal-recessive": [
		17809,
		3,
		17809
	],
	"./education-center/structured-data/medical/glut1-deficiency-syndrome-1-autosomal-recessive.json": [
		17809,
		3,
		17809
	],
	"./education-center/structured-data/medical/glut1-deficiency-syndrome.json": [
		998719,
		3,
		998719
	],
	"./education-center/structured-data/medical/glutaric-acidemia-iic-late-onset": [
		988108,
		3,
		988108
	],
	"./education-center/structured-data/medical/glutaric-acidemia-iic-late-onset.json": [
		988108,
		3,
		988108
	],
	"./education-center/structured-data/medical/glycerol-release-during-exercise-defective": [
		279231,
		3,
		279231
	],
	"./education-center/structured-data/medical/glycerol-release-during-exercise-defective.json": [
		279231,
		3,
		279231
	],
	"./education-center/structured-data/medical/glycogen-phosphorylase-kinase-deficiency": [
		411636,
		3,
		411636
	],
	"./education-center/structured-data/medical/glycogen-phosphorylase-kinase-deficiency.json": [
		411636,
		3,
		411636
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-due-phosphoglycerate-kinase-1-deficiency": [
		302844,
		3,
		302844
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-due-phosphoglycerate-kinase-1-deficiency.json": [
		302844,
		3,
		302844
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-ii-adult-form": [
		20833,
		3,
		20833
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-ii-adult-form.json": [
		20833,
		3,
		20833
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiia": [
		746819,
		3,
		746819
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiia.json": [
		746819,
		3,
		746819
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiib": [
		470837,
		3,
		470837
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiib.json": [
		470837,
		3,
		470837
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiic": [
		979087,
		3,
		979087
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iiic.json": [
		979087,
		3,
		979087
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-classic-hepatic": [
		100944,
		3,
		100944
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-classic-hepatic.json": [
		100944,
		3,
		100944
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-combined-hepatic-and-myopathic": [
		674357,
		3,
		674357
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-combined-hepatic-and-myopathic.json": [
		674357,
		3,
		674357
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-nonprogressive-hepatic": [
		300696,
		3,
		300696
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-iv-nonprogressive-hepatic.json": [
		300696,
		3,
		300696
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-type-ii-infantile": [
		659437,
		3,
		659437
	],
	"./education-center/structured-data/medical/glycogen-storage-disease-type-ii-infantile.json": [
		659437,
		3,
		659437
	],
	"./education-center/structured-data/medical/gm1-gangliosidosis-type-i-cardiac-involvement": [
		182341,
		3,
		182341
	],
	"./education-center/structured-data/medical/gm1-gangliosidosis-type-i-cardiac-involvement.json": [
		182341,
		3,
		182341
	],
	"./education-center/structured-data/medical/gm2-ganglioside-accumulation": [
		898811,
		3,
		898811
	],
	"./education-center/structured-data/medical/gm2-ganglioside-accumulation.json": [
		898811,
		3,
		898811
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-adult-onset": [
		357036,
		3,
		357036
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-adult-onset.json": [
		357036,
		3,
		357036
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-chronic": [
		371455,
		3,
		371455
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-chronic.json": [
		371455,
		3,
		371455
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-juvenile": [
		995970,
		3,
		995970
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-juvenile.json": [
		995970,
		3,
		995970
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-variant-b1": [
		119297,
		3,
		119297
	],
	"./education-center/structured-data/medical/gm2-gangliosidosis-variant-b1.json": [
		119297,
		3,
		119297
	],
	"./education-center/structured-data/medical/gnptab-related-disorders": [
		214835,
		3,
		214835
	],
	"./education-center/structured-data/medical/gnptab-related-disorders.json": [
		214835,
		3,
		214835
	],
	"./education-center/structured-data/medical/gonadotropin-deficiency": [
		268562,
		3,
		268562
	],
	"./education-center/structured-data/medical/gonadotropin-deficiency.json": [
		268562,
		3,
		268562
	],
	"./education-center/structured-data/medical/gordon-syndrome": [
		744615,
		3,
		744615
	],
	"./education-center/structured-data/medical/gordon-syndrome.json": [
		744615,
		3,
		744615
	],
	"./education-center/structured-data/medical/gorham-stout-disease": [
		416917,
		3,
		416917
	],
	"./education-center/structured-data/medical/gorham-stout-disease.json": [
		416917,
		3,
		416917
	],
	"./education-center/structured-data/medical/gorlin-syndrome": [
		746670,
		3,
		746670
	],
	"./education-center/structured-data/medical/gorlin-syndrome.json": [
		746670,
		3,
		746670
	],
	"./education-center/structured-data/medical/gpsm2-related-disorders": [
		702962,
		3,
		702962
	],
	"./education-center/structured-data/medical/gpsm2-related-disorders.json": [
		702962,
		3,
		702962
	],
	"./education-center/structured-data/medical/graft-versus-host-disease-resistance": [
		674422,
		3,
		674422
	],
	"./education-center/structured-data/medical/graft-versus-host-disease-resistance.json": [
		674422,
		3,
		674422
	],
	"./education-center/structured-data/medical/granular-corneal-dystrophy": [
		616734,
		3,
		616734
	],
	"./education-center/structured-data/medical/granular-corneal-dystrophy.json": [
		616734,
		3,
		616734
	],
	"./education-center/structured-data/medical/granulomatous-disease-chronic-x-linked-variant": [
		186384,
		3,
		186384
	],
	"./education-center/structured-data/medical/granulomatous-disease-chronic-x-linked-variant.json": [
		186384,
		3,
		186384
	],
	"./education-center/structured-data/medical/granulosa-cell-tumor": [
		866911,
		3,
		866911
	],
	"./education-center/structured-data/medical/granulosa-cell-tumor.json": [
		866911,
		3,
		866911
	],
	"./education-center/structured-data/medical/gray-platelet-syndrome": [
		762101,
		3,
		762101
	],
	"./education-center/structured-data/medical/gray-platelet-syndrome.json": [
		762101,
		3,
		762101
	],
	"./education-center/structured-data/medical/greig-cephalopolysyndactyly-syndrome-severe": [
		68828,
		3,
		68828
	],
	"./education-center/structured-data/medical/greig-cephalopolysyndactyly-syndrome-severe.json": [
		68828,
		3,
		68828
	],
	"./education-center/structured-data/medical/groenouw-corneal-dystrophy-type-i": [
		385202,
		3,
		385202
	],
	"./education-center/structured-data/medical/groenouw-corneal-dystrophy-type-i.json": [
		385202,
		3,
		385202
	],
	"./education-center/structured-data/medical/growth-hormone-deficiency-pituitary-anomalies": [
		293514,
		3,
		293514
	],
	"./education-center/structured-data/medical/growth-hormone-deficiency-pituitary-anomalies.json": [
		293514,
		3,
		293514
	],
	"./education-center/structured-data/medical/guanidinoacetate-methyltransferase-gamt-deficiency": [
		175619,
		3,
		175619
	],
	"./education-center/structured-data/medical/guanidinoacetate-methyltransferase-gamt-deficiency.json": [
		175619,
		3,
		175619
	],
	"./education-center/structured-data/medical/gyrate-atrophy-choroid-and-retina-pyridoxine-responsive-ornithinemia": [
		28464,
		3,
		28464
	],
	"./education-center/structured-data/medical/gyrate-atrophy-choroid-and-retina-pyridoxine-responsive-ornithinemia.json": [
		28464,
		3,
		28464
	],
	"./education-center/structured-data/medical/haemorrhagic-telangiectasia-1": [
		461916,
		3,
		461916
	],
	"./education-center/structured-data/medical/haemorrhagic-telangiectasia-1.json": [
		461916,
		3,
		461916
	],
	"./education-center/structured-data/medical/haemorrhagic-telangiectasia-2": [
		306481,
		3,
		306481
	],
	"./education-center/structured-data/medical/haemorrhagic-telangiectasia-2.json": [
		306481,
		3,
		306481
	],
	"./education-center/structured-data/medical/hair-morphology-1-hair-thickness": [
		157794,
		3,
		157794
	],
	"./education-center/structured-data/medical/hair-morphology-1-hair-thickness.json": [
		157794,
		3,
		157794
	],
	"./education-center/structured-data/medical/hajdu-cheney-syndrome": [
		384026,
		3,
		384026
	],
	"./education-center/structured-data/medical/hajdu-cheney-syndrome.json": [
		384026,
		3,
		384026
	],
	"./education-center/structured-data/medical/hamartoma": [
		993046,
		3,
		993046
	],
	"./education-center/structured-data/medical/hamartoma.json": [
		993046,
		3,
		993046
	],
	"./education-center/structured-data/medical/hamartomatous-polyposis": [
		533777,
		3,
		533777
	],
	"./education-center/structured-data/medical/hamartomatous-polyposis.json": [
		533777,
		3,
		533777
	],
	"./education-center/structured-data/medical/hand-foot-genital-syndrome": [
		925777,
		3,
		925777
	],
	"./education-center/structured-data/medical/hand-foot-genital-syndrome.json": [
		925777,
		3,
		925777
	],
	"./education-center/structured-data/medical/hand-muscle-atrophy": [
		719796,
		3,
		719796
	],
	"./education-center/structured-data/medical/hand-muscle-atrophy.json": [
		719796,
		3,
		719796
	],
	"./education-center/structured-data/medical/hatipoglu-immunodeficiency-syndrome": [
		108140,
		3,
		108140
	],
	"./education-center/structured-data/medical/hatipoglu-immunodeficiency-syndrome.json": [
		108140,
		3,
		108140
	],
	"./education-center/structured-data/medical/hawkinsinuria": [
		937602,
		3,
		937602
	],
	"./education-center/structured-data/medical/hawkinsinuria.json": [
		937602,
		3,
		937602
	],
	"./education-center/structured-data/medical/hbb-related-disorders": [
		400993,
		3,
		400993
	],
	"./education-center/structured-data/medical/hbb-related-disorders.json": [
		400993,
		3,
		400993
	],
	"./education-center/structured-data/medical/head-and-neck-cancer": [
		681430,
		3,
		681430
	],
	"./education-center/structured-data/medical/head-and-neck-cancer.json": [
		681430,
		3,
		681430
	],
	"./education-center/structured-data/medical/head-and-neck-neoplasm": [
		191571,
		3,
		191571
	],
	"./education-center/structured-data/medical/head-and-neck-neoplasm.json": [
		191571,
		3,
		191571
	],
	"./education-center/structured-data/medical/hearing-loss": [
		874582,
		3,
		874582
	],
	"./education-center/structured-data/medical/hearing-loss.json": [
		874582,
		3,
		874582
	],
	"./education-center/structured-data/medical/heart-block-nonprogressive": [
		270940,
		3,
		270940
	],
	"./education-center/structured-data/medical/heart-block-nonprogressive.json": [
		270940,
		3,
		270940
	],
	"./education-center/structured-data/medical/hecht-syndrome": [
		65109,
		3,
		65109
	],
	"./education-center/structured-data/medical/hecht-syndrome.json": [
		65109,
		3,
		65109
	],
	"./education-center/structured-data/medical/heimler-syndrome-1": [
		757622,
		3,
		757622
	],
	"./education-center/structured-data/medical/heimler-syndrome-1.json": [
		757622,
		3,
		757622
	],
	"./education-center/structured-data/medical/heimler-syndrome-2": [
		141696,
		3,
		308653
	],
	"./education-center/structured-data/medical/heimler-syndrome-2.json": [
		141696,
		3,
		308653
	],
	"./education-center/structured-data/medical/heinz-body-anemia": [
		183832,
		3,
		183832
	],
	"./education-center/structured-data/medical/heinz-body-anemia.json": [
		183832,
		3,
		183832
	],
	"./education-center/structured-data/medical/helicoid-peripapillary-chorioretinal-degeneration": [
		966237,
		3,
		966237
	],
	"./education-center/structured-data/medical/helicoid-peripapillary-chorioretinal-degeneration.json": [
		966237,
		3,
		966237
	],
	"./education-center/structured-data/medical/hemangioma": [
		229312,
		3,
		229312
	],
	"./education-center/structured-data/medical/hemangioma.json": [
		229312,
		3,
		229312
	],
	"./education-center/structured-data/medical/hemangiomatosis": [
		635432,
		3,
		635432
	],
	"./education-center/structured-data/medical/hemangiomatosis.json": [
		635432,
		3,
		635432
	],
	"./education-center/structured-data/medical/hematologic-neoplasm": [
		55686,
		3,
		55686
	],
	"./education-center/structured-data/medical/hematologic-neoplasm.json": [
		55686,
		3,
		55686
	],
	"./education-center/structured-data/medical/hemihypertrophy": [
		693245,
		3,
		693245
	],
	"./education-center/structured-data/medical/hemihypertrophy.json": [
		693245,
		3,
		693245
	],
	"./education-center/structured-data/medical/hemiplegia": [
		813881,
		3,
		813881
	],
	"./education-center/structured-data/medical/hemiplegia.json": [
		813881,
		3,
		813881
	],
	"./education-center/structured-data/medical/hemiplegiahemiparesis": [
		50446,
		3,
		50446
	],
	"./education-center/structured-data/medical/hemiplegiahemiparesis.json": [
		50446,
		3,
		50446
	],
	"./education-center/structured-data/medical/hemochromatosis-juvenile-digenic": [
		506836,
		3,
		506836
	],
	"./education-center/structured-data/medical/hemochromatosis-juvenile-digenic.json": [
		506836,
		3,
		506836
	],
	"./education-center/structured-data/medical/hemoglobin-constant-spring": [
		743181,
		3,
		743181
	],
	"./education-center/structured-data/medical/hemoglobin-constant-spring.json": [
		743181,
		3,
		743181
	],
	"./education-center/structured-data/medical/hemoglobin-h-disease-nondeletional": [
		693098,
		3,
		693098
	],
	"./education-center/structured-data/medical/hemoglobin-h-disease-nondeletional.json": [
		693098,
		3,
		693098
	],
	"./education-center/structured-data/medical/hemoglobin-h-hydrops-fetalis-syndrome": [
		214557,
		3,
		214557
	],
	"./education-center/structured-data/medical/hemoglobin-h-hydrops-fetalis-syndrome.json": [
		214557,
		3,
		214557
	],
	"./education-center/structured-data/medical/hemoglobin-lepore-trait": [
		741854,
		3,
		741854
	],
	"./education-center/structured-data/medical/hemoglobin-lepore-trait.json": [
		741854,
		3,
		741854
	],
	"./education-center/structured-data/medical/hemoglobin-s": [
		219478,
		3,
		219478
	],
	"./education-center/structured-data/medical/hemoglobin-s.json": [
		219478,
		3,
		219478
	],
	"./education-center/structured-data/medical/hemoglobin-val-de-marne": [
		243243,
		3,
		243243
	],
	"./education-center/structured-data/medical/hemoglobin-val-de-marne.json": [
		243243,
		3,
		243243
	],
	"./education-center/structured-data/medical/hemolytic-anemia-nonspherocytic-and-neurologic-deficits-due-glucose-phosphate-isomerase-deficiency": [
		535930,
		3,
		535930
	],
	"./education-center/structured-data/medical/hemolytic-anemia-nonspherocytic-and-neurologic-deficits-due-glucose-phosphate-isomerase-deficiency.json": [
		535930,
		3,
		535930
	],
	"./education-center/structured-data/medical/hemolytic-disease-fetus-or-newborn-due-isoimmunization": [
		354883,
		3,
		354883
	],
	"./education-center/structured-data/medical/hemolytic-disease-fetus-or-newborn-due-isoimmunization.json": [
		354883,
		3,
		354883
	],
	"./education-center/structured-data/medical/hemolytic-uremic-syndrome": [
		136288,
		3,
		136288
	],
	"./education-center/structured-data/medical/hemolytic-uremic-syndrome-atypical-susceptibility-7": [
		626206,
		3,
		626206
	],
	"./education-center/structured-data/medical/hemolytic-uremic-syndrome-atypical-susceptibility-7.json": [
		626206,
		3,
		626206
	],
	"./education-center/structured-data/medical/hemolytic-uremic-syndrome.json": [
		136288,
		3,
		136288
	],
	"./education-center/structured-data/medical/hemophagocytosis": [
		698626,
		3,
		698626
	],
	"./education-center/structured-data/medical/hemophagocytosis.json": [
		698626,
		3,
		698626
	],
	"./education-center/structured-data/medical/hemophilia-b-factor-ix-deficiency": [
		734098,
		3,
		734098
	],
	"./education-center/structured-data/medical/hemophilia-b-factor-ix-deficiency.json": [
		734098,
		3,
		734098
	],
	"./education-center/structured-data/medical/hemophilia-bm": [
		653276,
		3,
		653276
	],
	"./education-center/structured-data/medical/hemophilia-bm.json": [
		653276,
		3,
		653276
	],
	"./education-center/structured-data/medical/hemophilia-fviii-deficiency": [
		921991,
		3,
		921991
	],
	"./education-center/structured-data/medical/hemophilia-fviii-deficiency.json": [
		921991,
		3,
		921991
	],
	"./education-center/structured-data/medical/hemorrhage": [
		288917,
		3,
		288917
	],
	"./education-center/structured-data/medical/hemorrhage.json": [
		288917,
		3,
		288917
	],
	"./education-center/structured-data/medical/hemosiderosis-systemic-due-aceruloplasminemia": [
		575963,
		3,
		575963
	],
	"./education-center/structured-data/medical/hemosiderosis-systemic-due-aceruloplasminemia.json": [
		575963,
		3,
		575963
	],
	"./education-center/structured-data/medical/hepatitis-b-virus-resistance": [
		248523,
		3,
		248523
	],
	"./education-center/structured-data/medical/hepatitis-b-virus-resistance.json": [
		248523,
		3,
		248523
	],
	"./education-center/structured-data/medical/hepatitis-c-virus-infection-response-therapy": [
		335375,
		3,
		335375
	],
	"./education-center/structured-data/medical/hepatitis-c-virus-infection-response-therapy.json": [
		335375,
		3,
		335375
	],
	"./education-center/structured-data/medical/hepatocellular-carcinoma": [
		11396,
		3,
		11396
	],
	"./education-center/structured-data/medical/hepatocellular-carcinoma.json": [
		11396,
		3,
		11396
	],
	"./education-center/structured-data/medical/hepatorenocardiac-degenerative-fibrosis": [
		870299,
		3,
		870299
	],
	"./education-center/structured-data/medical/hepatorenocardiac-degenerative-fibrosis.json": [
		870299,
		3,
		870299
	],
	"./education-center/structured-data/medical/her2-positive-breast-carcinoma": [
		120307,
		3,
		120307
	],
	"./education-center/structured-data/medical/her2-positive-breast-carcinoma.json": [
		120307,
		3,
		120307
	],
	"./education-center/structured-data/medical/hereditary-arterial-and-articular-multiple-calcification-syndrome": [
		145331,
		3,
		145331
	],
	"./education-center/structured-data/medical/hereditary-arterial-and-articular-multiple-calcification-syndrome.json": [
		145331,
		3,
		145331
	],
	"./education-center/structured-data/medical/hereditary-cancer": [
		911709,
		3,
		911709
	],
	"./education-center/structured-data/medical/hereditary-cancer.json": [
		911709,
		3,
		911709
	],
	"./education-center/structured-data/medical/hereditary-cerebral-amyloid-angiopathy-icelandic-type": [
		776130,
		3,
		776130
	],
	"./education-center/structured-data/medical/hereditary-cerebral-amyloid-angiopathy-icelandic-type.json": [
		776130,
		3,
		776130
	],
	"./education-center/structured-data/medical/hereditary-cerebral-hemorrhage-amyloidosis": [
		621695,
		3,
		621695
	],
	"./education-center/structured-data/medical/hereditary-cerebral-hemorrhage-amyloidosis.json": [
		621695,
		3,
		621695
	],
	"./education-center/structured-data/medical/hereditary-coproporphyria": [
		992817,
		3,
		992817
	],
	"./education-center/structured-data/medical/hereditary-coproporphyria.json": [
		992817,
		3,
		992817
	],
	"./education-center/structured-data/medical/hereditary-diffuse-gastric-adenocarcinoma": [
		623521,
		3,
		623521
	],
	"./education-center/structured-data/medical/hereditary-diffuse-gastric-adenocarcinoma.json": [
		623521,
		3,
		623521
	],
	"./education-center/structured-data/medical/hereditary-essential-tremor": [
		727496,
		3,
		727496
	],
	"./education-center/structured-data/medical/hereditary-essential-tremor.json": [
		727496,
		3,
		727496
	],
	"./education-center/structured-data/medical/hereditary-hearing-loss-and-deafness": [
		602066,
		3,
		602066
	],
	"./education-center/structured-data/medical/hereditary-hearing-loss-and-deafness.json": [
		602066,
		3,
		602066
	],
	"./education-center/structured-data/medical/hereditary-hemochromatosis": [
		104202,
		3,
		104202
	],
	"./education-center/structured-data/medical/hereditary-hemochromatosis.json": [
		104202,
		3,
		104202
	],
	"./education-center/structured-data/medical/hereditary-hypercarotenemia-and-vitamin-deficiency": [
		740443,
		3,
		740443
	],
	"./education-center/structured-data/medical/hereditary-hypercarotenemia-and-vitamin-deficiency.json": [
		740443,
		3,
		740443
	],
	"./education-center/structured-data/medical/hereditary-leiomyomatosis-and-renal-cell-cancer": [
		96689,
		3,
		96689
	],
	"./education-center/structured-data/medical/hereditary-leiomyomatosis-and-renal-cell-cancer.json": [
		96689,
		3,
		96689
	],
	"./education-center/structured-data/medical/hereditary-lymphedema-type-i": [
		781819,
		3,
		781819
	],
	"./education-center/structured-data/medical/hereditary-lymphedema-type-i.json": [
		781819,
		3,
		781819
	],
	"./education-center/structured-data/medical/hereditary-multiple-osteochondromatosis": [
		100801,
		3,
		100801
	],
	"./education-center/structured-data/medical/hereditary-multiple-osteochondromatosis.json": [
		100801,
		3,
		100801
	],
	"./education-center/structured-data/medical/hereditary-neuralgic-amyotrophy-hna": [
		819741,
		3,
		819741
	],
	"./education-center/structured-data/medical/hereditary-neuralgic-amyotrophy-hna.json": [
		819741,
		3,
		819741
	],
	"./education-center/structured-data/medical/hereditary-nonpolyposis-colorectal-carcinoma": [
		882530,
		3,
		882530
	],
	"./education-center/structured-data/medical/hereditary-nonpolyposis-colorectal-carcinoma.json": [
		882530,
		3,
		882530
	],
	"./education-center/structured-data/medical/hereditary-nonpolyposis-colorectal-neoplasms": [
		909788,
		3,
		909788
	],
	"./education-center/structured-data/medical/hereditary-nonpolyposis-colorectal-neoplasms.json": [
		909788,
		3,
		909788
	],
	"./education-center/structured-data/medical/hereditary-orotic-aciduria-type-1": [
		660665,
		3,
		660665
	],
	"./education-center/structured-data/medical/hereditary-orotic-aciduria-type-1.json": [
		660665,
		3,
		660665
	],
	"./education-center/structured-data/medical/hereditary-sideroblastic-anemia-myopathy-and-lactic-acidosis": [
		664794,
		3,
		664794
	],
	"./education-center/structured-data/medical/hereditary-sideroblastic-anemia-myopathy-and-lactic-acidosis.json": [
		664794,
		3,
		664794
	],
	"./education-center/structured-data/medical/hereditary-spherocytosis": [
		800050,
		3,
		800050
	],
	"./education-center/structured-data/medical/hereditary-spherocytosis-type-2": [
		614231,
		3,
		614231
	],
	"./education-center/structured-data/medical/hereditary-spherocytosis-type-2.json": [
		614231,
		3,
		614231
	],
	"./education-center/structured-data/medical/hereditary-spherocytosis.json": [
		800050,
		3,
		800050
	],
	"./education-center/structured-data/medical/heritable-thoracic-aortic-disease": [
		260550,
		3,
		260550
	],
	"./education-center/structured-data/medical/heritable-thoracic-aortic-disease.json": [
		260550,
		3,
		260550
	],
	"./education-center/structured-data/medical/heterogeneous-nuclear-ribonucleoprotein-g-human": [
		54114,
		3,
		54114
	],
	"./education-center/structured-data/medical/heterogeneous-nuclear-ribonucleoprotein-g-human.json": [
		54114,
		3,
		54114
	],
	"./education-center/structured-data/medical/heterotaxy": [
		554617,
		3,
		554617
	],
	"./education-center/structured-data/medical/heterotaxy-visceral-12-autosomal": [
		593880,
		3,
		593880
	],
	"./education-center/structured-data/medical/heterotaxy-visceral-12-autosomal.json": [
		593880,
		3,
		593880
	],
	"./education-center/structured-data/medical/heterotaxy.json": [
		554617,
		3,
		554617
	],
	"./education-center/structured-data/medical/hexosaminidase-b-paris": [
		62252,
		3,
		62252
	],
	"./education-center/structured-data/medical/hexosaminidase-b-paris.json": [
		62252,
		3,
		62252
	],
	"./education-center/structured-data/medical/hiatus-hernia": [
		464079,
		3,
		464079
	],
	"./education-center/structured-data/medical/hiatus-hernia.json": [
		464079,
		3,
		464079
	],
	"./education-center/structured-data/medical/hidrotic-ectodermal-dysplasia-syndrome": [
		692282,
		3,
		692282
	],
	"./education-center/structured-data/medical/hidrotic-ectodermal-dysplasia-syndrome.json": [
		692282,
		3,
		692282
	],
	"./education-center/structured-data/medical/high-bone-mass": [
		332276,
		3,
		332276
	],
	"./education-center/structured-data/medical/high-bone-mass.json": [
		332276,
		3,
		332276
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-10": [
		509252,
		3,
		509252
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-10.json": [
		509252,
		3,
		509252
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-11": [
		232362,
		3,
		232362
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-11.json": [
		232362,
		3,
		232362
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-12": [
		143896,
		3,
		143896
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-12.json": [
		143896,
		3,
		143896
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6": [
		156894,
		3,
		156894
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.json": [
		156894,
		3,
		156894
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7": [
		262064,
		3,
		642461
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.json": [
		262064,
		3,
		642461
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8": [
		419418,
		3,
		419418
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.json": [
		419418,
		3,
		419418
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-9": [
		967880,
		3,
		967880
	],
	"./education-center/structured-data/medical/high-density-lipoprotein-cholesterol-level-quantitative-trait-locus-9.json": [
		967880,
		3,
		967880
	],
	"./education-center/structured-data/medical/high-grade-surface-osteosarcoma": [
		373420,
		3,
		373420
	],
	"./education-center/structured-data/medical/high-grade-surface-osteosarcoma.json": [
		373420,
		3,
		373420
	],
	"./education-center/structured-data/medical/high-myopia": [
		781652,
		3,
		781652
	],
	"./education-center/structured-data/medical/high-myopia.json": [
		781652,
		3,
		781652
	],
	"./education-center/structured-data/medical/hip-dysplasia-beukes-type": [
		90845,
		3,
		90845
	],
	"./education-center/structured-data/medical/hip-dysplasia-beukes-type.json": [
		90845,
		3,
		90845
	],
	"./education-center/structured-data/medical/hirschsprung-disease-dominant": [
		545183,
		3,
		545183
	],
	"./education-center/structured-data/medical/hirschsprung-disease-dominant.json": [
		545183,
		3,
		545183
	],
	"./education-center/structured-data/medical/hirschsprung-disease-intellectual-disability-syndrome-late-infantile": [
		108647,
		3,
		108647
	],
	"./education-center/structured-data/medical/hirschsprung-disease-intellectual-disability-syndrome-late-infantile.json": [
		108647,
		3,
		108647
	],
	"./education-center/structured-data/medical/hirschsprung-disease-protection-against": [
		633111,
		3,
		633111
	],
	"./education-center/structured-data/medical/hirschsprung-disease-protection-against.json": [
		633111,
		3,
		633111
	],
	"./education-center/structured-data/medical/hirschsprung-disease-recessive": [
		786285,
		3,
		786285
	],
	"./education-center/structured-data/medical/hirschsprung-disease-recessive.json": [
		786285,
		3,
		786285
	],
	"./education-center/structured-data/medical/hirschsprung-disease-susceptibility-1": [
		222222,
		3,
		222222
	],
	"./education-center/structured-data/medical/hirschsprung-disease-susceptibility-1.json": [
		222222,
		3,
		222222
	],
	"./education-center/structured-data/medical/history-neurodevelopmental-disorder": [
		850130,
		3,
		850130
	],
	"./education-center/structured-data/medical/history-neurodevelopmental-disorder.json": [
		850130,
		3,
		850130
	],
	"./education-center/structured-data/medical/hiv-1-viremia-susceptibility": [
		153765,
		3,
		153765
	],
	"./education-center/structured-data/medical/hiv-1-viremia-susceptibility.json": [
		153765,
		3,
		153765
	],
	"./education-center/structured-data/medical/holoprosencephaly-2": [
		619204,
		3,
		619204
	],
	"./education-center/structured-data/medical/holoprosencephaly-2.json": [
		619204,
		3,
		619204
	],
	"./education-center/structured-data/medical/holoprosencephaly-3": [
		724567,
		3,
		724567
	],
	"./education-center/structured-data/medical/holoprosencephaly-3.json": [
		724567,
		3,
		724567
	],
	"./education-center/structured-data/medical/holoprosencephaly-4": [
		324150,
		3,
		324150
	],
	"./education-center/structured-data/medical/holoprosencephaly-4.json": [
		324150,
		3,
		324150
	],
	"./education-center/structured-data/medical/holt-oram-syndrome": [
		673678,
		3,
		673678
	],
	"./education-center/structured-data/medical/holt-oram-syndrome.json": [
		673678,
		3,
		673678
	],
	"./education-center/structured-data/medical/homocysteine-level-elevated": [
		385384,
		3,
		385384
	],
	"./education-center/structured-data/medical/homocysteine-level-elevated.json": [
		385384,
		3,
		385384
	],
	"./education-center/structured-data/medical/homocystinuria-cbld-type-variant-1": [
		369329,
		3,
		369329
	],
	"./education-center/structured-data/medical/homocystinuria-cbld-type-variant-1.json": [
		369329,
		3,
		369329
	],
	"./education-center/structured-data/medical/homocystinuria-due-mthfr-deficiency": [
		155860,
		3,
		155860
	],
	"./education-center/structured-data/medical/homocystinuria-due-mthfr-deficiency.json": [
		155860,
		3,
		155860
	],
	"./education-center/structured-data/medical/homocystinuria-pyridoxine-nonresponsive": [
		379021,
		3,
		379021
	],
	"./education-center/structured-data/medical/homocystinuria-pyridoxine-nonresponsive.json": [
		379021,
		3,
		379021
	],
	"./education-center/structured-data/medical/homocystinuria-pyridoxine-responsive": [
		970100,
		3,
		970100
	],
	"./education-center/structured-data/medical/homocystinuria-pyridoxine-responsive.json": [
		970100,
		3,
		970100
	],
	"./education-center/structured-data/medical/hr-related-disorders": [
		186197,
		3,
		186197
	],
	"./education-center/structured-data/medical/hr-related-disorders.json": [
		186197,
		3,
		186197
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-delayed-disease-progression-infection": [
		839295,
		3,
		839295
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-delayed-disease-progression-infection.json": [
		839295,
		3,
		839295
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-increased-perinatal-transmission": [
		840399,
		3,
		840399
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-increased-perinatal-transmission.json": [
		840399,
		3,
		840399
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-rapid-disease-progression-infection": [
		271526,
		3,
		271526
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-rapid-disease-progression-infection.json": [
		271526,
		3,
		271526
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-rapid-progression-aids": [
		55336,
		3,
		55336
	],
	"./education-center/structured-data/medical/human-immunodeficiency-virus-type-1-rapid-progression-aids.json": [
		55336,
		3,
		55336
	],
	"./education-center/structured-data/medical/huntington-disease": [
		407750,
		3,
		407750
	],
	"./education-center/structured-data/medical/huntington-disease.json": [
		407750,
		3,
		407750
	],
	"./education-center/structured-data/medical/hutchinson-gilford-progeria-syndrome-atypical": [
		865623,
		3,
		865623
	],
	"./education-center/structured-data/medical/hutchinson-gilford-progeria-syndrome-atypical.json": [
		865623,
		3,
		865623
	],
	"./education-center/structured-data/medical/hutchinson-gilford-progeria-syndrome-childhood-onset": [
		46442,
		3,
		46442
	],
	"./education-center/structured-data/medical/hutchinson-gilford-progeria-syndrome-childhood-onset.json": [
		46442,
		3,
		46442
	],
	"./education-center/structured-data/medical/hyalinosis-segmental-glomerular": [
		835389,
		3,
		835389
	],
	"./education-center/structured-data/medical/hyalinosis-segmental-glomerular.json": [
		835389,
		3,
		835389
	],
	"./education-center/structured-data/medical/hydatidiform-mole": [
		93098,
		3,
		93098
	],
	"./education-center/structured-data/medical/hydatidiform-mole.json": [
		93098,
		3,
		93098
	],
	"./education-center/structured-data/medical/hydranencephaly-abnormal-genitalia": [
		67724,
		3,
		67724
	],
	"./education-center/structured-data/medical/hydranencephaly-abnormal-genitalia.json": [
		67724,
		3,
		67724
	],
	"./education-center/structured-data/medical/hydrocephalus": [
		155847,
		3,
		155847
	],
	"./education-center/structured-data/medical/hydrocephalus-due-aqueductal-stenosis": [
		194866,
		3,
		194866
	],
	"./education-center/structured-data/medical/hydrocephalus-due-aqueductal-stenosis.json": [
		194866,
		3,
		194866
	],
	"./education-center/structured-data/medical/hydrocephalus-x-linked-congenital-idiopathic-intestinal-pseudoobstruction": [
		276566,
		3,
		276566
	],
	"./education-center/structured-data/medical/hydrocephalus-x-linked-congenital-idiopathic-intestinal-pseudoobstruction.json": [
		276566,
		3,
		276566
	],
	"./education-center/structured-data/medical/hydrocephalus.json": [
		155847,
		3,
		155847
	],
	"./education-center/structured-data/medical/hydrochlorothiazide-response-efficacy": [
		323083,
		3,
		323083
	],
	"./education-center/structured-data/medical/hydrochlorothiazide-response-efficacy.json": [
		323083,
		3,
		323083
	],
	"./education-center/structured-data/medical/hydrolethalus-syndrome": [
		930062,
		3,
		930062
	],
	"./education-center/structured-data/medical/hydrolethalus-syndrome.json": [
		930062,
		3,
		930062
	],
	"./education-center/structured-data/medical/hyper-ige-recurrent-infection-syndrome-1": [
		640770,
		3,
		640770
	],
	"./education-center/structured-data/medical/hyper-ige-recurrent-infection-syndrome-1.json": [
		640770,
		3,
		640770
	],
	"./education-center/structured-data/medical/hyperalphalipoproteinemia-1": [
		743715,
		3,
		743715
	],
	"./education-center/structured-data/medical/hyperalphalipoproteinemia-1.json": [
		743715,
		3,
		743715
	],
	"./education-center/structured-data/medical/hyperammonemia": [
		62347,
		3,
		62347
	],
	"./education-center/structured-data/medical/hyperammonemia.json": [
		62347,
		3,
		62347
	],
	"./education-center/structured-data/medical/hyperandrogenism-nonclassic-type-due-21-hydroxylase-deficiency": [
		559063,
		3,
		559063
	],
	"./education-center/structured-data/medical/hyperandrogenism-nonclassic-type-due-21-hydroxylase-deficiency.json": [
		559063,
		3,
		559063
	],
	"./education-center/structured-data/medical/hyperapobetalipoproteinemia-susceptibility": [
		334712,
		3,
		334712
	],
	"./education-center/structured-data/medical/hyperapobetalipoproteinemia-susceptibility.json": [
		334712,
		3,
		334712
	],
	"./education-center/structured-data/medical/hypercalcemia": [
		262800,
		3,
		262800
	],
	"./education-center/structured-data/medical/hypercalcemia.json": [
		262800,
		3,
		262800
	],
	"./education-center/structured-data/medical/hypercalciuria-childhood-self-limiting": [
		729496,
		3,
		729496
	],
	"./education-center/structured-data/medical/hypercalciuria-childhood-self-limiting.json": [
		729496,
		3,
		729496
	],
	"./education-center/structured-data/medical/hypercholesterolemia": [
		711592,
		3,
		711592
	],
	"./education-center/structured-data/medical/hypercholesterolemia-autosomal-dominant-type-b": [
		779853,
		3,
		779853
	],
	"./education-center/structured-data/medical/hypercholesterolemia-autosomal-dominant-type-b.json": [
		779853,
		3,
		779853
	],
	"./education-center/structured-data/medical/hypercholesterolemia-familial-1": [
		722281,
		3,
		722281
	],
	"./education-center/structured-data/medical/hypercholesterolemia-familial-1.json": [
		722281,
		3,
		722281
	],
	"./education-center/structured-data/medical/hypercholesterolemia-susceptibility": [
		676955,
		3,
		676955
	],
	"./education-center/structured-data/medical/hypercholesterolemia-susceptibility.json": [
		676955,
		3,
		676955
	],
	"./education-center/structured-data/medical/hypercholesterolemia.json": [
		711592,
		3,
		711592
	],
	"./education-center/structured-data/medical/hyperechogenic-kidneys": [
		64877,
		3,
		64877
	],
	"./education-center/structured-data/medical/hyperechogenic-kidneys.json": [
		64877,
		3,
		64877
	],
	"./education-center/structured-data/medical/hyperekplexia-1": [
		964596,
		3,
		964596
	],
	"./education-center/structured-data/medical/hyperekplexia-1.json": [
		964596,
		3,
		964596
	],
	"./education-center/structured-data/medical/hypereosinophilic-syndrome-idiopathic-resistant-imatinib": [
		37395,
		3,
		37395
	],
	"./education-center/structured-data/medical/hypereosinophilic-syndrome-idiopathic-resistant-imatinib.json": [
		37395,
		3,
		37395
	],
	"./education-center/structured-data/medical/hyperglycinuria": [
		984186,
		3,
		984186
	],
	"./education-center/structured-data/medical/hyperglycinuria.json": [
		984186,
		3,
		984186
	],
	"./education-center/structured-data/medical/hypergonadotropic-hypogonadism": [
		920570,
		3,
		920570
	],
	"./education-center/structured-data/medical/hypergonadotropic-hypogonadism.json": [
		920570,
		3,
		920570
	],
	"./education-center/structured-data/medical/hyperhomocysteinemia-thrombotic-cbs-related": [
		300210,
		3,
		300210
	],
	"./education-center/structured-data/medical/hyperhomocysteinemia-thrombotic-cbs-related.json": [
		300210,
		3,
		300210
	],
	"./education-center/structured-data/medical/hyperinsulinemic-hypoglycemia": [
		935825,
		3,
		935825
	],
	"./education-center/structured-data/medical/hyperinsulinemic-hypoglycemia.json": [
		935825,
		3,
		935825
	],
	"./education-center/structured-data/medical/hyperinsulinism-dominant": [
		263479,
		3,
		263479
	],
	"./education-center/structured-data/medical/hyperinsulinism-dominant.json": [
		263479,
		3,
		263479
	],
	"./education-center/structured-data/medical/hyperinsulinism-dominantrecessive": [
		571048,
		3,
		571048
	],
	"./education-center/structured-data/medical/hyperinsulinism-dominantrecessive.json": [
		571048,
		3,
		571048
	],
	"./education-center/structured-data/medical/hyperkeratotic-cutaneous-capillary-venous-malformations-associated-cerebral-capillary-malformations": [
		762759,
		3,
		762759
	],
	"./education-center/structured-data/medical/hyperkeratotic-cutaneous-capillary-venous-malformations-associated-cerebral-capillary-malformations.json": [
		762759,
		3,
		762759
	],
	"./education-center/structured-data/medical/hyperlipidemia-familial-combined-lpl-related": [
		807944,
		3,
		807944
	],
	"./education-center/structured-data/medical/hyperlipidemia-familial-combined-lpl-related.json": [
		807944,
		3,
		807944
	],
	"./education-center/structured-data/medical/hyperlipidemia-familial-combined-susceptibility": [
		75321,
		3,
		75321
	],
	"./education-center/structured-data/medical/hyperlipidemia-familial-combined-susceptibility.json": [
		75321,
		3,
		75321
	],
	"./education-center/structured-data/medical/hyperlipoproteinemia-type-iii-due-apoe2": [
		859271,
		3,
		859271
	],
	"./education-center/structured-data/medical/hyperlipoproteinemia-type-iii-due-apoe2.json": [
		859271,
		3,
		859271
	],
	"./education-center/structured-data/medical/hypermagnesemia": [
		847834,
		3,
		847834
	],
	"./education-center/structured-data/medical/hypermagnesemia.json": [
		847834,
		3,
		847834
	],
	"./education-center/structured-data/medical/hypermetabolism-due-uncoupled-mitochondrial-oxidative-phosphorylation-2": [
		756061,
		3,
		756061
	],
	"./education-center/structured-data/medical/hypermetabolism-due-uncoupled-mitochondrial-oxidative-phosphorylation-2.json": [
		756061,
		3,
		756061
	],
	"./education-center/structured-data/medical/hypermethioninemia": [
		549355,
		3,
		549355
	],
	"./education-center/structured-data/medical/hypermethioninemia.json": [
		549355,
		3,
		549355
	],
	"./education-center/structured-data/medical/hyperornithinemia": [
		244441,
		3,
		244441
	],
	"./education-center/structured-data/medical/hyperornithinemia.json": [
		244441,
		3,
		244441
	],
	"./education-center/structured-data/medical/hyperostosis-cranialis-interna": [
		878480,
		3,
		878480
	],
	"./education-center/structured-data/medical/hyperostosis-cranialis-interna.json": [
		878480,
		3,
		878480
	],
	"./education-center/structured-data/medical/hyperparathyroidism-1": [
		765263,
		3,
		765263
	],
	"./education-center/structured-data/medical/hyperparathyroidism-1.json": [
		765263,
		3,
		765263
	],
	"./education-center/structured-data/medical/hyperparathyroidism-2-jaw-tumors": [
		819480,
		3,
		819480
	],
	"./education-center/structured-data/medical/hyperparathyroidism-2-jaw-tumors.json": [
		819480,
		3,
		819480
	],
	"./education-center/structured-data/medical/hyperphenylalaninemia": [
		181689,
		3,
		181689
	],
	"./education-center/structured-data/medical/hyperphenylalaninemia-bh4-deficient-due-partial-pts-deficiency": [
		8387,
		3,
		8387
	],
	"./education-center/structured-data/medical/hyperphenylalaninemia-bh4-deficient-due-partial-pts-deficiency.json": [
		8387,
		3,
		8387
	],
	"./education-center/structured-data/medical/hyperphenylalaninemia.json": [
		181689,
		3,
		181689
	],
	"./education-center/structured-data/medical/hyperpigmentation-or-without-hypopigmentation-familial-progressive": [
		147818,
		3,
		147818
	],
	"./education-center/structured-data/medical/hyperpigmentation-or-without-hypopigmentation-familial-progressive.json": [
		147818,
		3,
		147818
	],
	"./education-center/structured-data/medical/hyperproreninemia-familial": [
		995299,
		3,
		995299
	],
	"./education-center/structured-data/medical/hyperproreninemia-familial.json": [
		995299,
		3,
		995299
	],
	"./education-center/structured-data/medical/hypertaurinuric-cardiomyopathy": [
		484269,
		3,
		484269
	],
	"./education-center/structured-data/medical/hypertaurinuric-cardiomyopathy.json": [
		484269,
		3,
		484269
	],
	"./education-center/structured-data/medical/hypertension-diastolic-resistance": [
		891631,
		3,
		891631
	],
	"./education-center/structured-data/medical/hypertension-diastolic-resistance.json": [
		891631,
		3,
		891631
	],
	"./education-center/structured-data/medical/hypertension-early-onset-autosomal-dominant-exacerbation-pregnancy": [
		609918,
		3,
		609918
	],
	"./education-center/structured-data/medical/hypertension-early-onset-autosomal-dominant-exacerbation-pregnancy.json": [
		609918,
		3,
		609918
	],
	"./education-center/structured-data/medical/hypertension-pregnancy-induced-susceptibility": [
		832565,
		3,
		832565
	],
	"./education-center/structured-data/medical/hypertension-pregnancy-induced-susceptibility.json": [
		832565,
		3,
		832565
	],
	"./education-center/structured-data/medical/hypertension-resistant-conventional-therapy": [
		85053,
		3,
		85053
	],
	"./education-center/structured-data/medical/hypertension-resistant-conventional-therapy.json": [
		85053,
		3,
		85053
	],
	"./education-center/structured-data/medical/hypertension-salt-sensitive-essential-susceptibility": [
		754565,
		3,
		754565
	],
	"./education-center/structured-data/medical/hypertension-salt-sensitive-essential-susceptibility.json": [
		754565,
		3,
		754565
	],
	"./education-center/structured-data/medical/hyperthyroxinemia-dysalbuminemic": [
		252561,
		3,
		252561
	],
	"./education-center/structured-data/medical/hyperthyroxinemia-dysalbuminemic.json": [
		252561,
		3,
		252561
	],
	"./education-center/structured-data/medical/hyperthyroxinemia-dystransthyretinemic": [
		556212,
		3,
		556212
	],
	"./education-center/structured-data/medical/hyperthyroxinemia-dystransthyretinemic.json": [
		556212,
		3,
		556212
	],
	"./education-center/structured-data/medical/hypertriglyceridemia-2": [
		727526,
		3,
		727526
	],
	"./education-center/structured-data/medical/hypertriglyceridemia-2.json": [
		727526,
		3,
		727526
	],
	"./education-center/structured-data/medical/hypertriglyceridemia-familial": [
		379878,
		3,
		379878
	],
	"./education-center/structured-data/medical/hypertriglyceridemia-familial.json": [
		379878,
		3,
		379878
	],
	"./education-center/structured-data/medical/hypertrophic-cardiomyopathy-2": [
		798842,
		3,
		798842
	],
	"./education-center/structured-data/medical/hypertrophic-cardiomyopathy-2.json": [
		798842,
		3,
		798842
	],
	"./education-center/structured-data/medical/hypertrophic-cardiomyopathy-4": [
		995279,
		3,
		995279
	],
	"./education-center/structured-data/medical/hypertrophic-cardiomyopathy-4.json": [
		995279,
		3,
		995279
	],
	"./education-center/structured-data/medical/hypertyrosinemia": [
		492659,
		3,
		492659
	],
	"./education-center/structured-data/medical/hypertyrosinemia.json": [
		492659,
		3,
		492659
	],
	"./education-center/structured-data/medical/hypoadiponectinemia": [
		296263,
		3,
		296263
	],
	"./education-center/structured-data/medical/hypoadiponectinemia.json": [
		296263,
		3,
		296263
	],
	"./education-center/structured-data/medical/hypoalphalipoproteinemia-primary-2-intermediate": [
		457046,
		3,
		457046
	],
	"./education-center/structured-data/medical/hypoalphalipoproteinemia-primary-2-intermediate.json": [
		457046,
		3,
		457046
	],
	"./education-center/structured-data/medical/hypoammonemia": [
		139678,
		3,
		139678
	],
	"./education-center/structured-data/medical/hypoammonemia.json": [
		139678,
		3,
		139678
	],
	"./education-center/structured-data/medical/hypoceruloplasminemia": [
		253985,
		3,
		253985
	],
	"./education-center/structured-data/medical/hypoceruloplasminemia.json": [
		253985,
		3,
		253985
	],
	"./education-center/structured-data/medical/hypochondroplasia": [
		648992,
		3,
		648992
	],
	"./education-center/structured-data/medical/hypochondroplasia.json": [
		648992,
		3,
		648992
	],
	"./education-center/structured-data/medical/hypodysfibrinogenemia": [
		760451,
		3,
		760451
	],
	"./education-center/structured-data/medical/hypodysfibrinogenemia.json": [
		760451,
		3,
		760451
	],
	"./education-center/structured-data/medical/hypofibrinogenemia": [
		890137,
		3,
		890137
	],
	"./education-center/structured-data/medical/hypofibrinogenemia.json": [
		890137,
		3,
		890137
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-10-without-anosmia": [
		840755,
		3,
		840755
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-10-without-anosmia.json": [
		840755,
		3,
		840755
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-14-anosmia": [
		401100,
		3,
		401100
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-14-anosmia.json": [
		401100,
		3,
		401100
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-15-anosmia": [
		486863,
		3,
		486863
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-15-anosmia.json": [
		486863,
		3,
		486863
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-18-anosmia": [
		387875,
		3,
		387875
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-18-anosmia.json": [
		387875,
		3,
		387875
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-2-anosmia": [
		619255,
		3,
		619255
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-2-anosmia.json": [
		619255,
		3,
		619255
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-2-or-without-anosmia": [
		83672,
		3,
		83672
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-2-or-without-anosmia.json": [
		83672,
		3,
		83672
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-20-without-anosmia": [
		504976,
		3,
		504976
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-20-without-anosmia.json": [
		504976,
		3,
		504976
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-22-anosmia": [
		330108,
		3,
		330108
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-22-anosmia.json": [
		330108,
		3,
		330108
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-3-without-anosmia": [
		278986,
		3,
		278986
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-3-without-anosmia.json": [
		278986,
		3,
		278986
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-5-without-anosmia": [
		98552,
		3,
		98552
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-5-without-anosmia.json": [
		98552,
		3,
		98552
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-7-or-without-anosmia": [
		746240,
		3,
		746240
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-7-or-without-anosmia.json": [
		746240,
		3,
		746240
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-8-without-anosmia": [
		194225,
		3,
		194225
	],
	"./education-center/structured-data/medical/hypogonadotropic-hypogonadism-8-without-anosmia.json": [
		194225,
		3,
		194225
	],
	"./education-center/structured-data/medical/hypohidrotic-ectodermal-dysplasia-dominant": [
		236405,
		3,
		236405
	],
	"./education-center/structured-data/medical/hypohidrotic-ectodermal-dysplasia-dominant.json": [
		236405,
		3,
		236405
	],
	"./education-center/structured-data/medical/hypohidrotic-ectodermal-dysplasia-recessive": [
		944964,
		3,
		944964
	],
	"./education-center/structured-data/medical/hypohidrotic-ectodermal-dysplasia-recessive.json": [
		944964,
		3,
		944964
	],
	"./education-center/structured-data/medical/hypoinsulinemia": [
		945332,
		3,
		945332
	],
	"./education-center/structured-data/medical/hypoinsulinemia.json": [
		945332,
		3,
		945332
	],
	"./education-center/structured-data/medical/hypokalemic-tubulopathy-and-deafness": [
		741121,
		3,
		741121
	],
	"./education-center/structured-data/medical/hypokalemic-tubulopathy-and-deafness.json": [
		741121,
		3,
		741121
	],
	"./education-center/structured-data/medical/hypokinetic-non-dilated-cardiomyopathy": [
		312657,
		3,
		312657
	],
	"./education-center/structured-data/medical/hypokinetic-non-dilated-cardiomyopathy.json": [
		312657,
		3,
		312657
	],
	"./education-center/structured-data/medical/hypomaturation-hypoplastic-amelogenesis-imperfecta-taurodontism": [
		160397,
		3,
		160397
	],
	"./education-center/structured-data/medical/hypomaturation-hypoplastic-amelogenesis-imperfecta-taurodontism.json": [
		160397,
		3,
		160397
	],
	"./education-center/structured-data/medical/hypoparathyroidism-deafness-renal-disease-syndrome": [
		827183,
		3,
		827183
	],
	"./education-center/structured-data/medical/hypoparathyroidism-deafness-renal-disease-syndrome.json": [
		827183,
		3,
		827183
	],
	"./education-center/structured-data/medical/hypoparathyroidism-familial-isolated-1": [
		286927,
		3,
		286927
	],
	"./education-center/structured-data/medical/hypoparathyroidism-familial-isolated-1.json": [
		286927,
		3,
		286927
	],
	"./education-center/structured-data/medical/hypophosphatemia": [
		119291,
		3,
		119291
	],
	"./education-center/structured-data/medical/hypophosphatemia.json": [
		119291,
		3,
		119291
	],
	"./education-center/structured-data/medical/hypophosphatemic-rickets-dominant": [
		640427,
		3,
		640427
	],
	"./education-center/structured-data/medical/hypophosphatemic-rickets-dominant.json": [
		640427,
		3,
		640427
	],
	"./education-center/structured-data/medical/hypophosphatemic-rickets-recessive": [
		48875,
		3,
		48875
	],
	"./education-center/structured-data/medical/hypophosphatemic-rickets-recessive.json": [
		48875,
		3,
		48875
	],
	"./education-center/structured-data/medical/hypoplasia-iris": [
		35390,
		3,
		35390
	],
	"./education-center/structured-data/medical/hypoplasia-iris.json": [
		35390,
		3,
		35390
	],
	"./education-center/structured-data/medical/hypothyroidism": [
		587893,
		3,
		587893
	],
	"./education-center/structured-data/medical/hypothyroidism.json": [
		587893,
		3,
		587893
	],
	"./education-center/structured-data/medical/hypotrichosis-2": [
		154465,
		3,
		154465
	],
	"./education-center/structured-data/medical/hypotrichosis-2.json": [
		154465,
		3,
		154465
	],
	"./education-center/structured-data/medical/hypotrichosis-3": [
		932648,
		3,
		932648
	],
	"./education-center/structured-data/medical/hypotrichosis-3.json": [
		932648,
		3,
		932648
	],
	"./education-center/structured-data/medical/ichthyosis-annular-epidermolytic-2": [
		308272,
		3,
		308272
	],
	"./education-center/structured-data/medical/ichthyosis-annular-epidermolytic-2.json": [
		308272,
		3,
		308272
	],
	"./education-center/structured-data/medical/ichthyosis-bullosa-siemens": [
		674810,
		3,
		674810
	],
	"./education-center/structured-data/medical/ichthyosis-bullosa-siemens.json": [
		674810,
		3,
		674810
	],
	"./education-center/structured-data/medical/ichthyosis-hystrix-curth-macklin": [
		566104,
		3,
		566104
	],
	"./education-center/structured-data/medical/ichthyosis-hystrix-curth-macklin.json": [
		566104,
		3,
		566104
	],
	"./education-center/structured-data/medical/idiopathic-environmental-intolerance": [
		131072,
		3,
		131072
	],
	"./education-center/structured-data/medical/idiopathic-environmental-intolerance.json": [
		131072,
		3,
		131072
	],
	"./education-center/structured-data/medical/idiopathic-generalized-epilepsy": [
		914583,
		3,
		914583
	],
	"./education-center/structured-data/medical/idiopathic-generalized-epilepsy.json": [
		914583,
		3,
		914583
	],
	"./education-center/structured-data/medical/idiopathic-growth-hormone-deficiency": [
		537502,
		3,
		537502
	],
	"./education-center/structured-data/medical/idiopathic-growth-hormone-deficiency.json": [
		537502,
		3,
		537502
	],
	"./education-center/structured-data/medical/idiopathic-scoliosis": [
		135331,
		3,
		135331
	],
	"./education-center/structured-data/medical/idiopathic-scoliosis.json": [
		135331,
		3,
		135331
	],
	"./education-center/structured-data/medical/idiopathic-transverse-myelitis": [
		793806,
		3,
		793806
	],
	"./education-center/structured-data/medical/idiopathic-transverse-myelitis.json": [
		793806,
		3,
		793806
	],
	"./education-center/structured-data/medical/idua-pseudodeficiency": [
		814702,
		3,
		814702
	],
	"./education-center/structured-data/medical/idua-pseudodeficiency.json": [
		814702,
		3,
		814702
	],
	"./education-center/structured-data/medical/ifn-gamma-receptor-1-deficiency": [
		607983,
		3,
		607983
	],
	"./education-center/structured-data/medical/ifn-gamma-receptor-1-deficiency.json": [
		607983,
		3,
		607983
	],
	"./education-center/structured-data/medical/iga-nephropathy-susceptibility": [
		635046,
		3,
		635046
	],
	"./education-center/structured-data/medical/iga-nephropathy-susceptibility.json": [
		635046,
		3,
		635046
	],
	"./education-center/structured-data/medical/ige-responsiveness-atopic": [
		75447,
		3,
		75447
	],
	"./education-center/structured-data/medical/ige-responsiveness-atopic.json": [
		75447,
		3,
		75447
	],
	"./education-center/structured-data/medical/igg-receptor-i-phagocytic-familial-deficiency": [
		821997,
		3,
		821997
	],
	"./education-center/structured-data/medical/igg-receptor-i-phagocytic-familial-deficiency.json": [
		821997,
		3,
		821997
	],
	"./education-center/structured-data/medical/iminoglycinuria-digenic": [
		788303,
		3,
		788303
	],
	"./education-center/structured-data/medical/iminoglycinuria-digenic.json": [
		788303,
		3,
		788303
	],
	"./education-center/structured-data/medical/immunodeficiency-109-lymphoproliferation": [
		739469,
		3,
		739469
	],
	"./education-center/structured-data/medical/immunodeficiency-109-lymphoproliferation.json": [
		739469,
		3,
		739469
	],
	"./education-center/structured-data/medical/immunodeficiency-18-severe-combined-immunodeficiency-variant": [
		252297,
		3,
		252297
	],
	"./education-center/structured-data/medical/immunodeficiency-18-severe-combined-immunodeficiency-variant.json": [
		252297,
		3,
		252297
	],
	"./education-center/structured-data/medical/immunodeficiency-26-without-neurologic-abnormalities": [
		832173,
		3,
		832173
	],
	"./education-center/structured-data/medical/immunodeficiency-26-without-neurologic-abnormalities.json": [
		832173,
		3,
		832173
	],
	"./education-center/structured-data/medical/immunodeficiency-37": [
		985940,
		3,
		985940
	],
	"./education-center/structured-data/medical/immunodeficiency-37.json": [
		985940,
		3,
		985940
	],
	"./education-center/structured-data/medical/immunodeficiency-60": [
		683458,
		3,
		683458
	],
	"./education-center/structured-data/medical/immunodeficiency-60.json": [
		683458,
		3,
		683458
	],
	"./education-center/structured-data/medical/immunodeficiency-66": [
		190242,
		3,
		190242
	],
	"./education-center/structured-data/medical/immunodeficiency-66.json": [
		190242,
		3,
		190242
	],
	"./education-center/structured-data/medical/immunodeficiency-due-defect-cd3-gamma": [
		660695,
		3,
		660695
	],
	"./education-center/structured-data/medical/immunodeficiency-due-defect-cd3-gamma.json": [
		660695,
		3,
		660695
	],
	"./education-center/structured-data/medical/immunodeficiency-x-linked-hyper-igm": [
		248781,
		3,
		248781
	],
	"./education-center/structured-data/medical/immunodeficiency-x-linked-hyper-igm.json": [
		248781,
		3,
		248781
	],
	"./education-center/structured-data/medical/impaired-adp-induced-platelet-aggregation": [
		280921,
		3,
		280921
	],
	"./education-center/structured-data/medical/impaired-adp-induced-platelet-aggregation.json": [
		280921,
		3,
		280921
	],
	"./education-center/structured-data/medical/impaired-intellectual-development-and-distinctive-facial-features-cardiac-defects": [
		93636,
		3,
		93636
	],
	"./education-center/structured-data/medical/impaired-intellectual-development-and-distinctive-facial-features-cardiac-defects.json": [
		93636,
		3,
		93636
	],
	"./education-center/structured-data/medical/impaired-ristocetin-induced-platelet-aggregation": [
		916440,
		3,
		916440
	],
	"./education-center/structured-data/medical/impaired-ristocetin-induced-platelet-aggregation.json": [
		916440,
		3,
		916440
	],
	"./education-center/structured-data/medical/impaired-temperature-sensation": [
		21750,
		3,
		21750
	],
	"./education-center/structured-data/medical/impaired-temperature-sensation.json": [
		21750,
		3,
		21750
	],
	"./education-center/structured-data/medical/impaired-thromboxane-a2-agonist-induced-platelet-aggregation": [
		28,
		3,
		28
	],
	"./education-center/structured-data/medical/impaired-thromboxane-a2-agonist-induced-platelet-aggregation.json": [
		28,
		3,
		28
	],
	"./education-center/structured-data/medical/impdh2-enzyme-activity-variation": [
		417493,
		3,
		417493
	],
	"./education-center/structured-data/medical/impdh2-enzyme-activity-variation.json": [
		417493,
		3,
		417493
	],
	"./education-center/structured-data/medical/inborn-genetic-diseases": [
		867415,
		3,
		867415
	],
	"./education-center/structured-data/medical/inborn-genetic-diseases.json": [
		867415,
		3,
		867415
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-dominant": [
		275449,
		3,
		275449
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-dominant.json": [
		275449,
		3,
		275449
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-paget-disease-bone-and-frontotemporal-dementia": [
		188494,
		3,
		188494
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-paget-disease-bone-and-frontotemporal-dementia.json": [
		188494,
		3,
		188494
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-recessive": [
		25961,
		3,
		25961
	],
	"./education-center/structured-data/medical/inclusion-body-myopathy-recessive.json": [
		25961,
		3,
		25961
	],
	"./education-center/structured-data/medical/increased-analgesia-kappa-opioid-receptor-agonist-female-specific": [
		666944,
		3,
		666944
	],
	"./education-center/structured-data/medical/increased-analgesia-kappa-opioid-receptor-agonist-female-specific.json": [
		666944,
		3,
		666944
	],
	"./education-center/structured-data/medical/increased-circulating-iga-level": [
		307101,
		3,
		307101
	],
	"./education-center/structured-data/medical/increased-circulating-iga-level.json": [
		307101,
		3,
		307101
	],
	"./education-center/structured-data/medical/increased-circulating-ige-level": [
		502754,
		3,
		502754
	],
	"./education-center/structured-data/medical/increased-circulating-ige-level.json": [
		502754,
		3,
		502754
	],
	"./education-center/structured-data/medical/increased-erythrocyte-protoporphyrin-concentration": [
		605854,
		3,
		605854
	],
	"./education-center/structured-data/medical/increased-erythrocyte-protoporphyrin-concentration.json": [
		605854,
		3,
		605854
	],
	"./education-center/structured-data/medical/increased-hepatic-glycogen-content": [
		108849,
		3,
		108849
	],
	"./education-center/structured-data/medical/increased-hepatic-glycogen-content.json": [
		108849,
		3,
		108849
	],
	"./education-center/structured-data/medical/increased-histidine": [
		556276,
		3,
		556276
	],
	"./education-center/structured-data/medical/increased-histidine.json": [
		556276,
		3,
		556276
	],
	"./education-center/structured-data/medical/increased-left-ventricular-wall-thickness": [
		203303,
		3,
		203303
	],
	"./education-center/structured-data/medical/increased-left-ventricular-wall-thickness.json": [
		203303,
		3,
		203303
	],
	"./education-center/structured-data/medical/increased-mean-platelet-volume": [
		741612,
		3,
		741612
	],
	"./education-center/structured-data/medical/increased-mean-platelet-volume.json": [
		741612,
		3,
		741612
	],
	"./education-center/structured-data/medical/increased-muscle-glycogen-content": [
		850539,
		3,
		850539
	],
	"./education-center/structured-data/medical/increased-muscle-glycogen-content.json": [
		850539,
		3,
		850539
	],
	"./education-center/structured-data/medical/increased-nuchal-translucency": [
		771073,
		3,
		771073
	],
	"./education-center/structured-data/medical/increased-nuchal-translucency.json": [
		771073,
		3,
		771073
	],
	"./education-center/structured-data/medical/increased-susceptibility-fractures": [
		167035,
		3,
		167035
	],
	"./education-center/structured-data/medical/increased-susceptibility-fractures.json": [
		167035,
		3,
		167035
	],
	"./education-center/structured-data/medical/indifference-pain-congenital-autosomal-dominant": [
		724459,
		3,
		724459
	],
	"./education-center/structured-data/medical/indifference-pain-congenital-autosomal-dominant.json": [
		724459,
		3,
		724459
	],
	"./education-center/structured-data/medical/infant-onset-multiple-organ-failure": [
		460724,
		3,
		460724
	],
	"./education-center/structured-data/medical/infant-onset-multiple-organ-failure.json": [
		460724,
		3,
		460724
	],
	"./education-center/structured-data/medical/infantile-cortical-hyperostosis": [
		343687,
		3,
		343687
	],
	"./education-center/structured-data/medical/infantile-cortical-hyperostosis.json": [
		343687,
		3,
		343687
	],
	"./education-center/structured-data/medical/infantile-encephalopathy": [
		988087,
		3,
		988087
	],
	"./education-center/structured-data/medical/infantile-encephalopathy.json": [
		988087,
		3,
		988087
	],
	"./education-center/structured-data/medical/infantile-epilepsy": [
		475900,
		3,
		475900
	],
	"./education-center/structured-data/medical/infantile-epilepsy.json": [
		475900,
		3,
		475900
	],
	"./education-center/structured-data/medical/infantile-hypercalcemia": [
		91106,
		3,
		91106
	],
	"./education-center/structured-data/medical/infantile-hypercalcemia.json": [
		91106,
		3,
		91106
	],
	"./education-center/structured-data/medical/infantile-hypophosphatasia": [
		833630,
		3,
		833630
	],
	"./education-center/structured-data/medical/infantile-hypophosphatasia.json": [
		833630,
		3,
		833630
	],
	"./education-center/structured-data/medical/infantile-liver-failure": [
		719009,
		3,
		719009
	],
	"./education-center/structured-data/medical/infantile-liver-failure.json": [
		719009,
		3,
		719009
	],
	"./education-center/structured-data/medical/infantile-nystagmus": [
		697589,
		3,
		697589
	],
	"./education-center/structured-data/medical/infantile-nystagmus.json": [
		697589,
		3,
		697589
	],
	"./education-center/structured-data/medical/infantile-spasms": [
		270630,
		3,
		270630
	],
	"./education-center/structured-data/medical/infantile-spasms.json": [
		270630,
		3,
		270630
	],
	"./education-center/structured-data/medical/infertility": [
		520194,
		3,
		520194
	],
	"./education-center/structured-data/medical/infertility.json": [
		520194,
		3,
		520194
	],
	"./education-center/structured-data/medical/infiltrating-duct-carcinoma-breast": [
		370837,
		3,
		370837
	],
	"./education-center/structured-data/medical/infiltrating-duct-carcinoma-breast.json": [
		370837,
		3,
		370837
	],
	"./education-center/structured-data/medical/inflammation": [
		132521,
		3,
		132521
	],
	"./education-center/structured-data/medical/inflammation.json": [
		132521,
		3,
		132521
	],
	"./education-center/structured-data/medical/inflammatory-bowel-disease-14-susceptibility": [
		808719,
		3,
		808719
	],
	"./education-center/structured-data/medical/inflammatory-bowel-disease-14-susceptibility.json": [
		808719,
		3,
		808719
	],
	"./education-center/structured-data/medical/inflammatory-bowel-disease-17-protection-against": [
		22959,
		3,
		22959
	],
	"./education-center/structured-data/medical/inflammatory-bowel-disease-17-protection-against.json": [
		22959,
		3,
		22959
	],
	"./education-center/structured-data/medical/inherited-bleeding-disorder-platelet-type": [
		737588,
		3,
		737588
	],
	"./education-center/structured-data/medical/inherited-bleeding-disorder-platelet-type.json": [
		737588,
		3,
		737588
	],
	"./education-center/structured-data/medical/inherited-creutzfeldt-jakob-disease": [
		185975,
		3,
		185975
	],
	"./education-center/structured-data/medical/inherited-creutzfeldt-jakob-disease.json": [
		185975,
		3,
		185975
	],
	"./education-center/structured-data/medical/inherited-erythromelalgia": [
		902310,
		3,
		902310
	],
	"./education-center/structured-data/medical/inherited-erythromelalgia.json": [
		902310,
		3,
		902310
	],
	"./education-center/structured-data/medical/inherited-immunodeficiency-diseases": [
		497998,
		3,
		497998
	],
	"./education-center/structured-data/medical/inherited-immunodeficiency-diseases.json": [
		497998,
		3,
		497998
	],
	"./education-center/structured-data/medical/inner-ear-malformation": [
		677366,
		3,
		677366
	],
	"./education-center/structured-data/medical/inner-ear-malformation.json": [
		677366,
		3,
		677366
	],
	"./education-center/structured-data/medical/insulin-resistance": [
		801186,
		3,
		801186
	],
	"./education-center/structured-data/medical/insulin-resistance-severe-digenic": [
		991174,
		3,
		991174
	],
	"./education-center/structured-data/medical/insulin-resistance-severe-digenic.json": [
		991174,
		3,
		991174
	],
	"./education-center/structured-data/medical/insulin-resistance-susceptibility": [
		684095,
		3,
		684095
	],
	"./education-center/structured-data/medical/insulin-resistance-susceptibility.json": [
		684095,
		3,
		684095
	],
	"./education-center/structured-data/medical/insulin-resistance.json": [
		801186,
		3,
		801186
	],
	"./education-center/structured-data/medical/insulin-resistant-diabetes-mellitus": [
		462443,
		3,
		462443
	],
	"./education-center/structured-data/medical/insulin-resistant-diabetes-mellitus.json": [
		462443,
		3,
		462443
	],
	"./education-center/structured-data/medical/intellectual-deficiency": [
		534516,
		3,
		534516
	],
	"./education-center/structured-data/medical/intellectual-deficiency.json": [
		534516,
		3,
		534516
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder": [
		336881,
		3,
		336881
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-autism-and-dysmorphic-facies": [
		64379,
		3,
		64379
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-autism-and-dysmorphic-facies.json": [
		64379,
		3,
		64379
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-autosomal-dominant-71-behavioral-abnormalities": [
		594727,
		3,
		594727
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-autosomal-dominant-71-behavioral-abnormalities.json": [
		594727,
		3,
		594727
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-x-linked-syndromic-16": [
		609798,
		3,
		609798
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder-x-linked-syndromic-16.json": [
		609798,
		3,
		609798
	],
	"./education-center/structured-data/medical/intellectual-developmental-disorder.json": [
		336881,
		3,
		336881
	],
	"./education-center/structured-data/medical/intellectual-disability": [
		984922,
		3,
		984922
	],
	"./education-center/structured-data/medical/intellectual-disability-and-seizures": [
		234970,
		3,
		234970
	],
	"./education-center/structured-data/medical/intellectual-disability-and-seizures.json": [
		234970,
		3,
		234970
	],
	"./education-center/structured-data/medical/intellectual-disability-autosomal-dominant-1": [
		755672,
		3,
		755672
	],
	"./education-center/structured-data/medical/intellectual-disability-autosomal-dominant-1.json": [
		755672,
		3,
		755672
	],
	"./education-center/structured-data/medical/intellectual-disability-cask-related-x-linked": [
		733755,
		3,
		733755
	],
	"./education-center/structured-data/medical/intellectual-disability-cask-related-x-linked.json": [
		733755,
		3,
		733755
	],
	"./education-center/structured-data/medical/intellectual-disability-dominant": [
		893388,
		3,
		893388
	],
	"./education-center/structured-data/medical/intellectual-disability-dominant.json": [
		893388,
		3,
		893388
	],
	"./education-center/structured-data/medical/intellectual-disability-episodic-ataxia-and-congenital-arthrogryposis": [
		983079,
		3,
		983079
	],
	"./education-center/structured-data/medical/intellectual-disability-episodic-ataxia-and-congenital-arthrogryposis.json": [
		983079,
		3,
		983079
	],
	"./education-center/structured-data/medical/intellectual-disability-fra12a-type": [
		576594,
		3,
		576594
	],
	"./education-center/structured-data/medical/intellectual-disability-fra12a-type.json": [
		576594,
		3,
		576594
	],
	"./education-center/structured-data/medical/intellectual-disability-language-impairment-and-autistic-features": [
		228812,
		3,
		228812
	],
	"./education-center/structured-data/medical/intellectual-disability-language-impairment-and-autistic-features.json": [
		228812,
		3,
		228812
	],
	"./education-center/structured-data/medical/intellectual-disability-profound": [
		586163,
		3,
		586163
	],
	"./education-center/structured-data/medical/intellectual-disability-profound.json": [
		586163,
		3,
		586163
	],
	"./education-center/structured-data/medical/intellectual-disability-recessive": [
		749960,
		3,
		749960
	],
	"./education-center/structured-data/medical/intellectual-disability-recessive.json": [
		749960,
		3,
		749960
	],
	"./education-center/structured-data/medical/intellectual-disability-severe-speech-impairment": [
		443779,
		3,
		443779
	],
	"./education-center/structured-data/medical/intellectual-disability-severe-speech-impairment.json": [
		443779,
		3,
		443779
	],
	"./education-center/structured-data/medical/intellectual-disability-stereotypic-movements-epilepsy-andor-cerebral-malformations": [
		376586,
		3,
		376586
	],
	"./education-center/structured-data/medical/intellectual-disability-stereotypic-movements-epilepsy-andor-cerebral-malformations.json": [
		376586,
		3,
		376586
	],
	"./education-center/structured-data/medical/intellectual-disability-x-linked-1": [
		839009,
		3,
		839009
	],
	"./education-center/structured-data/medical/intellectual-disability-x-linked-1.json": [
		839009,
		3,
		839009
	],
	"./education-center/structured-data/medical/intellectual-disability.json": [
		984922,
		3,
		984922
	],
	"./education-center/structured-data/medical/interferon-gamma-receptor-deficiency": [
		222991,
		3,
		222991
	],
	"./education-center/structured-data/medical/interferon-gamma-receptor-deficiency.json": [
		222991,
		3,
		222991
	],
	"./education-center/structured-data/medical/interferons-peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy": [
		123871,
		3,
		123871
	],
	"./education-center/structured-data/medical/interferons-peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.json": [
		123871,
		3,
		123871
	],
	"./education-center/structured-data/medical/interleukin-6-serum-level-quantitative-trait-locus": [
		860888,
		3,
		860888
	],
	"./education-center/structured-data/medical/interleukin-6-serum-level-quantitative-trait-locus.json": [
		860888,
		3,
		860888
	],
	"./education-center/structured-data/medical/intermediate-maple-syrup-urine-disease-type-2": [
		189410,
		3,
		189410
	],
	"./education-center/structured-data/medical/intermediate-maple-syrup-urine-disease-type-2.json": [
		189410,
		3,
		189410
	],
	"./education-center/structured-data/medical/interstitial-cardiac-fibrosis": [
		847919,
		3,
		847919
	],
	"./education-center/structured-data/medical/interstitial-cardiac-fibrosis.json": [
		847919,
		3,
		847919
	],
	"./education-center/structured-data/medical/interstitial-nephritis": [
		886028,
		3,
		886028
	],
	"./education-center/structured-data/medical/interstitial-nephritis.json": [
		886028,
		3,
		886028
	],
	"./education-center/structured-data/medical/intervertebral-disc-disease-susceptibility": [
		270564,
		3,
		270564
	],
	"./education-center/structured-data/medical/intervertebral-disc-disease-susceptibility.json": [
		270564,
		3,
		270564
	],
	"./education-center/structured-data/medical/intervertebral-disk-calcification": [
		857692,
		3,
		857692
	],
	"./education-center/structured-data/medical/intervertebral-disk-calcification.json": [
		857692,
		3,
		857692
	],
	"./education-center/structured-data/medical/intestinal-dysmotility-syndrome": [
		2920,
		3,
		2920
	],
	"./education-center/structured-data/medical/intestinal-dysmotility-syndrome.json": [
		2920,
		3,
		2920
	],
	"./education-center/structured-data/medical/intractable-seizure": [
		309890,
		3,
		309890
	],
	"./education-center/structured-data/medical/intractable-seizure.json": [
		309890,
		3,
		309890
	],
	"./education-center/structured-data/medical/intraventricular-hemorrhage": [
		629929,
		3,
		629929
	],
	"./education-center/structured-data/medical/intraventricular-hemorrhage.json": [
		629929,
		3,
		629929
	],
	"./education-center/structured-data/medical/intrinsic-cardiomyopathy": [
		81973,
		3,
		81973
	],
	"./education-center/structured-data/medical/intrinsic-cardiomyopathy.json": [
		81973,
		3,
		81973
	],
	"./education-center/structured-data/medical/invasive-breast-carcinoma": [
		149739,
		3,
		149739
	],
	"./education-center/structured-data/medical/invasive-breast-carcinoma.json": [
		149739,
		3,
		149739
	],
	"./education-center/structured-data/medical/invasive-pneumococcal-disease-protection-against": [
		102101,
		3,
		102101
	],
	"./education-center/structured-data/medical/invasive-pneumococcal-disease-protection-against.json": [
		102101,
		3,
		102101
	],
	"./education-center/structured-data/medical/invasive-pneumococcal-disease-recurrent-isolated": [
		16807,
		3,
		16807
	],
	"./education-center/structured-data/medical/invasive-pneumococcal-disease-recurrent-isolated.json": [
		16807,
		3,
		16807
	],
	"./education-center/structured-data/medical/irinotecan-response": [
		958345,
		3,
		958345
	],
	"./education-center/structured-data/medical/irinotecan-response.json": [
		958345,
		3,
		958345
	],
	"./education-center/structured-data/medical/iron-accumulation-brain": [
		843462,
		3,
		843462
	],
	"./education-center/structured-data/medical/iron-accumulation-brain.json": [
		843462,
		3,
		843462
	],
	"./education-center/structured-data/medical/iron-deficiency-anemia": [
		442939,
		3,
		876812
	],
	"./education-center/structured-data/medical/iron-deficiency-anemia.json": [
		442939,
		3,
		876812
	],
	"./education-center/structured-data/medical/iron-overload": [
		77395,
		3,
		77395
	],
	"./education-center/structured-data/medical/iron-overload.json": [
		77395,
		3,
		77395
	],
	"./education-center/structured-data/medical/ischemic-stroke": [
		608302,
		3,
		608302
	],
	"./education-center/structured-data/medical/ischemic-stroke.json": [
		608302,
		3,
		608302
	],
	"./education-center/structured-data/medical/islet-cell-adenomatosis": [
		17670,
		3,
		17670
	],
	"./education-center/structured-data/medical/islet-cell-adenomatosis.json": [
		17670,
		3,
		17670
	],
	"./education-center/structured-data/medical/isolated-anhidrosis-normal-sweat-glands": [
		657052,
		3,
		657052
	],
	"./education-center/structured-data/medical/isolated-anhidrosis-normal-sweat-glands.json": [
		657052,
		3,
		657052
	],
	"./education-center/structured-data/medical/isolated-cleft-palate": [
		820369,
		3,
		820369
	],
	"./education-center/structured-data/medical/isolated-cleft-palate.json": [
		820369,
		3,
		820369
	],
	"./education-center/structured-data/medical/isolated-congenital-digital-clubbing": [
		167538,
		3,
		167538
	],
	"./education-center/structured-data/medical/isolated-congenital-digital-clubbing.json": [
		167538,
		3,
		167538
	],
	"./education-center/structured-data/medical/isolated-congenital-growth-hormone-deficiency": [
		488399,
		3,
		488399
	],
	"./education-center/structured-data/medical/isolated-congenital-growth-hormone-deficiency.json": [
		488399,
		3,
		488399
	],
	"./education-center/structured-data/medical/isolated-coronal-synostosis": [
		928236,
		3,
		928236
	],
	"./education-center/structured-data/medical/isolated-coronal-synostosis.json": [
		928236,
		3,
		928236
	],
	"./education-center/structured-data/medical/isolated-cryptophthalmia": [
		434754,
		3,
		434754
	],
	"./education-center/structured-data/medical/isolated-cryptophthalmia.json": [
		434754,
		3,
		434754
	],
	"./education-center/structured-data/medical/isolated-gnrh-deficiency": [
		68296,
		3,
		68296
	],
	"./education-center/structured-data/medical/isolated-gnrh-deficiency.json": [
		68296,
		3,
		68296
	],
	"./education-center/structured-data/medical/isolated-hyperchlorhidrosis": [
		82209,
		3,
		82209
	],
	"./education-center/structured-data/medical/isolated-hyperchlorhidrosis.json": [
		82209,
		3,
		82209
	],
	"./education-center/structured-data/medical/isolated-hyperparathyroidism": [
		890681,
		3,
		890681
	],
	"./education-center/structured-data/medical/isolated-hyperparathyroidism.json": [
		890681,
		3,
		890681
	],
	"./education-center/structured-data/medical/isolated-macular-dystrophy": [
		509878,
		3,
		594616
	],
	"./education-center/structured-data/medical/isolated-macular-dystrophy.json": [
		509878,
		3,
		594616
	],
	"./education-center/structured-data/medical/isolated-nonsyndromic-congenital-heart-disease": [
		568564,
		3,
		568564
	],
	"./education-center/structured-data/medical/isolated-nonsyndromic-congenital-heart-disease.json": [
		568564,
		3,
		568564
	],
	"./education-center/structured-data/medical/isovaleric-acidemia-type-i": [
		464726,
		3,
		464726
	],
	"./education-center/structured-data/medical/isovaleric-acidemia-type-i.json": [
		464726,
		3,
		464726
	],
	"./education-center/structured-data/medical/isovaleric-acidemia-type-iii": [
		846228,
		3,
		846228
	],
	"./education-center/structured-data/medical/isovaleric-acidemia-type-iii.json": [
		846228,
		3,
		846228
	],
	"./education-center/structured-data/medical/ivacaftor-lumacaftor-response-efficacy": [
		754392,
		3,
		754392
	],
	"./education-center/structured-data/medical/ivacaftor-lumacaftor-response-efficacy.json": [
		754392,
		3,
		754392
	],
	"./education-center/structured-data/medical/ivacaftor-response-efficacy": [
		299643,
		3,
		299643
	],
	"./education-center/structured-data/medical/ivacaftor-response-efficacy.json": [
		299643,
		3,
		299643
	],
	"./education-center/structured-data/medical/jackson-weiss-syndrome": [
		217955,
		3,
		217955
	],
	"./education-center/structured-data/medical/jackson-weiss-syndrome.json": [
		217955,
		3,
		217955
	],
	"./education-center/structured-data/medical/jawad-syndrome": [
		419814,
		3,
		419814
	],
	"./education-center/structured-data/medical/jawad-syndrome.json": [
		419814,
		3,
		419814
	],
	"./education-center/structured-data/medical/john-milton-hagen-blood-group-system": [
		826848,
		3,
		826848
	],
	"./education-center/structured-data/medical/john-milton-hagen-blood-group-system.json": [
		826848,
		3,
		826848
	],
	"./education-center/structured-data/medical/joint-hypermobility": [
		225028,
		3,
		225028
	],
	"./education-center/structured-data/medical/joint-hypermobility.json": [
		225028,
		3,
		225028
	],
	"./education-center/structured-data/medical/joubert-syndrome-12": [
		503880,
		3,
		503880
	],
	"./education-center/structured-data/medical/joubert-syndrome-12.json": [
		503880,
		3,
		503880
	],
	"./education-center/structured-data/medical/joubert-syndrome-1215-digenic": [
		978620,
		3,
		978620
	],
	"./education-center/structured-data/medical/joubert-syndrome-1215-digenic.json": [
		978620,
		3,
		978620
	],
	"./education-center/structured-data/medical/joubert-syndrome-915-digenic": [
		422821,
		3,
		422821
	],
	"./education-center/structured-data/medical/joubert-syndrome-915-digenic.json": [
		422821,
		3,
		422821
	],
	"./education-center/structured-data/medical/juberg-hayward-syndrome": [
		383730,
		3,
		383730
	],
	"./education-center/structured-data/medical/juberg-hayward-syndrome.json": [
		383730,
		3,
		383730
	],
	"./education-center/structured-data/medical/juvenile-hemochromatosis": [
		417634,
		3,
		417634
	],
	"./education-center/structured-data/medical/juvenile-hemochromatosis.json": [
		417634,
		3,
		417634
	],
	"./education-center/structured-data/medical/juvenile-onset-psychosis": [
		561868,
		3,
		561868
	],
	"./education-center/structured-data/medical/juvenile-onset-psychosis.json": [
		561868,
		3,
		561868
	],
	"./education-center/structured-data/medical/juvenile-polyposis": [
		459472,
		3,
		459472
	],
	"./education-center/structured-data/medical/juvenile-polyposis-stomach": [
		816399,
		3,
		816399
	],
	"./education-center/structured-data/medical/juvenile-polyposis-stomach.json": [
		816399,
		3,
		816399
	],
	"./education-center/structured-data/medical/juvenile-polyposis.json": [
		459472,
		3,
		459472
	],
	"./education-center/structured-data/medical/juvenile-retinitis-pigmentosa-aipl1-related": [
		138497,
		3,
		138497
	],
	"./education-center/structured-data/medical/juvenile-retinitis-pigmentosa-aipl1-related.json": [
		138497,
		3,
		138497
	],
	"./education-center/structured-data/medical/kabuki-syndrome-1": [
		561507,
		3,
		561507
	],
	"./education-center/structured-data/medical/kabuki-syndrome-1.json": [
		561507,
		3,
		561507
	],
	"./education-center/structured-data/medical/karak-syndrome": [
		318432,
		3,
		318432
	],
	"./education-center/structured-data/medical/karak-syndrome.json": [
		318432,
		3,
		318432
	],
	"./education-center/structured-data/medical/kat6b-related-spectrum-disorders": [
		294368,
		3,
		294368
	],
	"./education-center/structured-data/medical/kat6b-related-spectrum-disorders.json": [
		294368,
		3,
		294368
	],
	"./education-center/structured-data/medical/kbg-syndrome": [
		123213,
		3,
		123213
	],
	"./education-center/structured-data/medical/kbg-syndrome.json": [
		123213,
		3,
		123213
	],
	"./education-center/structured-data/medical/kcne2-related-disorders": [
		701825,
		3,
		701825
	],
	"./education-center/structured-data/medical/kcne2-related-disorders.json": [
		701825,
		3,
		701825
	],
	"./education-center/structured-data/medical/kcnj10-related-disorders": [
		956318,
		3,
		956318
	],
	"./education-center/structured-data/medical/kcnj10-related-disorders.json": [
		956318,
		3,
		956318
	],
	"./education-center/structured-data/medical/kcnq1-related-disorders": [
		270020,
		3,
		270020
	],
	"./education-center/structured-data/medical/kcnq1-related-disorders.json": [
		270020,
		3,
		270020
	],
	"./education-center/structured-data/medical/kcnq2-related-disorders": [
		919586,
		3,
		919586
	],
	"./education-center/structured-data/medical/kcnq2-related-disorders.json": [
		919586,
		3,
		919586
	],
	"./education-center/structured-data/medical/kcnq3-related-developmental-disability": [
		76326,
		3,
		76326
	],
	"./education-center/structured-data/medical/kcnq3-related-developmental-disability.json": [
		76326,
		3,
		76326
	],
	"./education-center/structured-data/medical/kcnt2-related-condition": [
		268705,
		3,
		268705
	],
	"./education-center/structured-data/medical/kcnt2-related-condition.json": [
		268705,
		3,
		268705
	],
	"./education-center/structured-data/medical/kel6-antigen": [
		785603,
		3,
		785603
	],
	"./education-center/structured-data/medical/kel6-antigen.json": [
		785603,
		3,
		785603
	],
	"./education-center/structured-data/medical/keloid-formation": [
		290757,
		3,
		290757
	],
	"./education-center/structured-data/medical/keloid-formation.json": [
		290757,
		3,
		290757
	],
	"./education-center/structured-data/medical/keratitis-fugax-hereditaria": [
		612316,
		3,
		612316
	],
	"./education-center/structured-data/medical/keratitis-fugax-hereditaria.json": [
		612316,
		3,
		612316
	],
	"./education-center/structured-data/medical/keratoconus-1": [
		802534,
		3,
		802534
	],
	"./education-center/structured-data/medical/keratoconus-1.json": [
		802534,
		3,
		802534
	],
	"./education-center/structured-data/medical/keratolytic-winter-erythema": [
		673441,
		3,
		673441
	],
	"./education-center/structured-data/medical/keratolytic-winter-erythema.json": [
		673441,
		3,
		673441
	],
	"./education-center/structured-data/medical/keratosis-follicularis": [
		467885,
		3,
		467885
	],
	"./education-center/structured-data/medical/keratosis-follicularis.json": [
		467885,
		3,
		467885
	],
	"./education-center/structured-data/medical/kidney-damage": [
		332706,
		3,
		332706
	],
	"./education-center/structured-data/medical/kidney-damage.json": [
		332706,
		3,
		332706
	],
	"./education-center/structured-data/medical/kininogen-deficiency-total": [
		441696,
		3,
		441696
	],
	"./education-center/structured-data/medical/kininogen-deficiency-total.json": [
		441696,
		3,
		441696
	],
	"./education-center/structured-data/medical/kleine-levin-syndrome": [
		243454,
		3,
		243454
	],
	"./education-center/structured-data/medical/kleine-levin-syndrome.json": [
		243454,
		3,
		243454
	],
	"./education-center/structured-data/medical/klippel-feil-syndrome": [
		622315,
		3,
		622315
	],
	"./education-center/structured-data/medical/klippel-feil-syndrome-1-autosomal-dominant": [
		757312,
		3,
		757312
	],
	"./education-center/structured-data/medical/klippel-feil-syndrome-1-autosomal-dominant.json": [
		757312,
		3,
		757312
	],
	"./education-center/structured-data/medical/klippel-feil-syndrome.json": [
		622315,
		3,
		622315
	],
	"./education-center/structured-data/medical/klippel-trã©naunay-syndrome": [
		776546,
		3,
		776546
	],
	"./education-center/structured-data/medical/klippel-trã©naunay-syndrome.json": [
		776546,
		3,
		776546
	],
	"./education-center/structured-data/medical/kniest-dysplasia": [
		55646,
		3,
		55646
	],
	"./education-center/structured-data/medical/kniest-dysplasia.json": [
		55646,
		3,
		55646
	],
	"./education-center/structured-data/medical/knops-blood-group-system": [
		92427,
		3,
		92427
	],
	"./education-center/structured-data/medical/knops-blood-group-system.json": [
		92427,
		3,
		92427
	],
	"./education-center/structured-data/medical/knuckle-pads-deafness-and-leukonychia-syndrome": [
		153294,
		3,
		153294
	],
	"./education-center/structured-data/medical/knuckle-pads-deafness-and-leukonychia-syndrome.json": [
		153294,
		3,
		153294
	],
	"./education-center/structured-data/medical/kuru-protection-against": [
		285088,
		3,
		285088
	],
	"./education-center/structured-data/medical/kuru-protection-against.json": [
		285088,
		3,
		285088
	],
	"./education-center/structured-data/medical/l-ferritin-deficiency-autosomal-recessive": [
		695388,
		3,
		695388
	],
	"./education-center/structured-data/medical/l-ferritin-deficiency-autosomal-recessive.json": [
		695388,
		3,
		695388
	],
	"./education-center/structured-data/medical/lacrimoauriculodentodigital-syndrome-3": [
		947078,
		3,
		947078
	],
	"./education-center/structured-data/medical/lacrimoauriculodentodigital-syndrome-3.json": [
		947078,
		3,
		947078
	],
	"./education-center/structured-data/medical/lactase-persistence": [
		471074,
		3,
		471074
	],
	"./education-center/structured-data/medical/lactase-persistence.json": [
		471074,
		3,
		471074
	],
	"./education-center/structured-data/medical/lactic-acidosis": [
		902976,
		3,
		902976
	],
	"./education-center/structured-data/medical/lactic-acidosis.json": [
		902976,
		3,
		902976
	],
	"./education-center/structured-data/medical/landsteiner-wiener-phenotype": [
		243899,
		3,
		243899
	],
	"./education-center/structured-data/medical/landsteiner-wiener-phenotype.json": [
		243899,
		3,
		243899
	],
	"./education-center/structured-data/medical/langer-giedion-syndrome": [
		349994,
		3,
		349994
	],
	"./education-center/structured-data/medical/langer-giedion-syndrome.json": [
		349994,
		3,
		349994
	],
	"./education-center/structured-data/medical/langereis-blood-group": [
		878133,
		3,
		878133
	],
	"./education-center/structured-data/medical/langereis-blood-group.json": [
		878133,
		3,
		878133
	],
	"./education-center/structured-data/medical/language-retardation": [
		750815,
		3,
		750815
	],
	"./education-center/structured-data/medical/language-retardation.json": [
		750815,
		3,
		750815
	],
	"./education-center/structured-data/medical/large-gestational-age": [
		190428,
		3,
		190428
	],
	"./education-center/structured-data/medical/large-gestational-age.json": [
		190428,
		3,
		190428
	],
	"./education-center/structured-data/medical/large-vessel-vasculitis": [
		14278,
		3,
		14278
	],
	"./education-center/structured-data/medical/large-vessel-vasculitis.json": [
		14278,
		3,
		14278
	],
	"./education-center/structured-data/medical/laron-syndrome-elevated-serum-gh-binding-protein": [
		901365,
		3,
		901365
	],
	"./education-center/structured-data/medical/laron-syndrome-elevated-serum-gh-binding-protein.json": [
		901365,
		3,
		901365
	],
	"./education-center/structured-data/medical/laron-syndrome-undetectable-serum-gh-binding-protein": [
		250869,
		3,
		250869
	],
	"./education-center/structured-data/medical/laron-syndrome-undetectable-serum-gh-binding-protein.json": [
		250869,
		3,
		250869
	],
	"./education-center/structured-data/medical/larsen-syndrome": [
		76020,
		3,
		76020
	],
	"./education-center/structured-data/medical/larsen-syndrome.json": [
		76020,
		3,
		76020
	],
	"./education-center/structured-data/medical/late-onset-citrullinemia": [
		934524,
		3,
		934524
	],
	"./education-center/structured-data/medical/late-onset-citrullinemia.json": [
		934524,
		3,
		934524
	],
	"./education-center/structured-data/medical/lateral-meningocele-syndrome": [
		533563,
		3,
		533563
	],
	"./education-center/structured-data/medical/lateral-meningocele-syndrome.json": [
		533563,
		3,
		533563
	],
	"./education-center/structured-data/medical/lattice-corneal-dystrophy-type-i": [
		559654,
		3,
		559654
	],
	"./education-center/structured-data/medical/lattice-corneal-dystrophy-type-i.json": [
		559654,
		3,
		559654
	],
	"./education-center/structured-data/medical/lazy-leukocyte-syndrome": [
		427537,
		3,
		427537
	],
	"./education-center/structured-data/medical/lazy-leukocyte-syndrome.json": [
		427537,
		3,
		427537
	],
	"./education-center/structured-data/medical/lcat-deficiency": [
		905374,
		3,
		905374
	],
	"./education-center/structured-data/medical/lcat-deficiency.json": [
		905374,
		3,
		905374
	],
	"./education-center/structured-data/medical/lchad-deficiency-maternal-acute-fatty-liver-pregnancy": [
		990417,
		3,
		990417
	],
	"./education-center/structured-data/medical/lchad-deficiency-maternal-acute-fatty-liver-pregnancy.json": [
		990417,
		3,
		990417
	],
	"./education-center/structured-data/medical/leber-congenital-amaurosis": [
		577305,
		3,
		577305
	],
	"./education-center/structured-data/medical/leber-congenital-amaurosis-18": [
		875219,
		3,
		875219
	],
	"./education-center/structured-data/medical/leber-congenital-amaurosis-18.json": [
		875219,
		3,
		875219
	],
	"./education-center/structured-data/medical/leber-congenital-amaurosis.json": [
		577305,
		3,
		577305
	],
	"./education-center/structured-data/medical/left-right-axis-malformations": [
		348693,
		3,
		348693
	],
	"./education-center/structured-data/medical/left-right-axis-malformations.json": [
		348693,
		3,
		348693
	],
	"./education-center/structured-data/medical/left-ventricular-noncompaction-3": [
		244091,
		3,
		244091
	],
	"./education-center/structured-data/medical/left-ventricular-noncompaction-3.json": [
		244091,
		3,
		244091
	],
	"./education-center/structured-data/medical/left-ventricular-noncompaction-cardiomyopathy": [
		490777,
		3,
		490777
	],
	"./education-center/structured-data/medical/left-ventricular-noncompaction-cardiomyopathy.json": [
		490777,
		3,
		490777
	],
	"./education-center/structured-data/medical/legg-calve-perthes-disease": [
		938328,
		3,
		938328
	],
	"./education-center/structured-data/medical/legg-calve-perthes-disease.json": [
		938328,
		3,
		938328
	],
	"./education-center/structured-data/medical/leigh-syndrome-due-mitochondrial-complex-i-deficiency": [
		978729,
		3,
		978729
	],
	"./education-center/structured-data/medical/leigh-syndrome-due-mitochondrial-complex-i-deficiency.json": [
		978729,
		3,
		978729
	],
	"./education-center/structured-data/medical/lenz-majewski-hyperostosis-syndrome": [
		172678,
		3,
		172678
	],
	"./education-center/structured-data/medical/lenz-majewski-hyperostosis-syndrome.json": [
		172678,
		3,
		172678
	],
	"./education-center/structured-data/medical/leprosy-early-onset-susceptibility": [
		128387,
		3,
		128387
	],
	"./education-center/structured-data/medical/leprosy-early-onset-susceptibility.json": [
		128387,
		3,
		128387
	],
	"./education-center/structured-data/medical/leprosy-protection-against": [
		479791,
		3,
		479791
	],
	"./education-center/structured-data/medical/leprosy-protection-against.json": [
		479791,
		3,
		479791
	],
	"./education-center/structured-data/medical/leptin-dysfunction": [
		563872,
		3,
		563872
	],
	"./education-center/structured-data/medical/leptin-dysfunction.json": [
		563872,
		3,
		563872
	],
	"./education-center/structured-data/medical/leri-weill-dyschondrosteosis": [
		944956,
		3,
		944956
	],
	"./education-center/structured-data/medical/leri-weill-dyschondrosteosis.json": [
		944956,
		3,
		944956
	],
	"./education-center/structured-data/medical/lesch-nyhan-syndrome-neurologic-variant": [
		323282,
		3,
		323282
	],
	"./education-center/structured-data/medical/lesch-nyhan-syndrome-neurologic-variant.json": [
		323282,
		3,
		323282
	],
	"./education-center/structured-data/medical/lesinurad-response": [
		708255,
		3,
		708255
	],
	"./education-center/structured-data/medical/lesinurad-response.json": [
		708255,
		3,
		708255
	],
	"./education-center/structured-data/medical/lethal-encephalopathy": [
		755702,
		3,
		755702
	],
	"./education-center/structured-data/medical/lethal-encephalopathy.json": [
		755702,
		3,
		755702
	],
	"./education-center/structured-data/medical/lethal-skeletal-dysplasia": [
		729253,
		3,
		729253
	],
	"./education-center/structured-data/medical/lethal-skeletal-dysplasia.json": [
		729253,
		3,
		729253
	],
	"./education-center/structured-data/medical/leukemia-acute-lymphoblastic-susceptibility": [
		840904,
		3,
		840904
	],
	"./education-center/structured-data/medical/leukemia-acute-lymphoblastic-susceptibility.json": [
		840904,
		3,
		840904
	],
	"./education-center/structured-data/medical/leukemia-acute-myeloid-m0-subtype": [
		877888,
		3,
		877888
	],
	"./education-center/structured-data/medical/leukemia-acute-myeloid-m0-subtype.json": [
		877888,
		3,
		877888
	],
	"./education-center/structured-data/medical/leukemia-megakaryoblastic-down-syndrome-somatic": [
		567335,
		3,
		567335
	],
	"./education-center/structured-data/medical/leukemia-megakaryoblastic-down-syndrome-somatic.json": [
		567335,
		3,
		567335
	],
	"./education-center/structured-data/medical/leukemia-philadelphia-chromosome-positive-resistant-imatinib": [
		774461,
		3,
		774461
	],
	"./education-center/structured-data/medical/leukemia-philadelphia-chromosome-positive-resistant-imatinib.json": [
		774461,
		3,
		774461
	],
	"./education-center/structured-data/medical/leukemia-post-chemotherapy-susceptibility": [
		565210,
		3,
		565210
	],
	"./education-center/structured-data/medical/leukemia-post-chemotherapy-susceptibility.json": [
		565210,
		3,
		565210
	],
	"./education-center/structured-data/medical/leukemoid-reaction": [
		525784,
		3,
		525784
	],
	"./education-center/structured-data/medical/leukemoid-reaction.json": [
		525784,
		3,
		525784
	],
	"./education-center/structured-data/medical/leukocyte-adhesion-deficiency-1": [
		569486,
		3,
		569486
	],
	"./education-center/structured-data/medical/leukocyte-adhesion-deficiency-1.json": [
		569486,
		3,
		569486
	],
	"./education-center/structured-data/medical/leukodystrophy-adult-onset": [
		707069,
		3,
		707069
	],
	"./education-center/structured-data/medical/leukodystrophy-adult-onset.json": [
		707069,
		3,
		707069
	],
	"./education-center/structured-data/medical/leukodystrophy-childhood-onset-remitting": [
		588840,
		3,
		588840
	],
	"./education-center/structured-data/medical/leukodystrophy-childhood-onset-remitting.json": [
		588840,
		3,
		588840
	],
	"./education-center/structured-data/medical/leukodystrophy-hypomyelinating-26-chondrodysplasia": [
		401262,
		3,
		401262
	],
	"./education-center/structured-data/medical/leukodystrophy-hypomyelinating-26-chondrodysplasia.json": [
		401262,
		3,
		401262
	],
	"./education-center/structured-data/medical/leukoencephalopathy": [
		787292,
		3,
		787292
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-2": [
		490613,
		3,
		490613
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-2.json": [
		490613,
		3,
		490613
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-3": [
		708374,
		3,
		708374
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-3.json": [
		708374,
		3,
		708374
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-4": [
		460835,
		3,
		460835
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-4.json": [
		460835,
		3,
		460835
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-5": [
		771225,
		3,
		771225
	],
	"./education-center/structured-data/medical/leukoencephalopathy-vanishing-white-matter-5.json": [
		771225,
		3,
		771225
	],
	"./education-center/structured-data/medical/leukoencephalopathy.json": [
		787292,
		3,
		787292
	],
	"./education-center/structured-data/medical/levy-hollister-syndrome": [
		513946,
		3,
		513946
	],
	"./education-center/structured-data/medical/levy-hollister-syndrome.json": [
		513946,
		3,
		513946
	],
	"./education-center/structured-data/medical/lewy-body-dementia": [
		59055,
		3,
		59055
	],
	"./education-center/structured-data/medical/lewy-body-dementia.json": [
		59055,
		3,
		59055
	],
	"./education-center/structured-data/medical/leydig-cell-adenoma-somatic-male-limited-precocious-puberty": [
		151438,
		3,
		151438
	],
	"./education-center/structured-data/medical/leydig-cell-adenoma-somatic-male-limited-precocious-puberty.json": [
		151438,
		3,
		151438
	],
	"./education-center/structured-data/medical/leydig-cell-hypoplasia-type-ii": [
		743409,
		3,
		743409
	],
	"./education-center/structured-data/medical/leydig-cell-hypoplasia-type-ii.json": [
		743409,
		3,
		743409
	],
	"./education-center/structured-data/medical/leydig-hypoplasia-type-i": [
		268954,
		3,
		268954
	],
	"./education-center/structured-data/medical/leydig-hypoplasia-type-i.json": [
		268954,
		3,
		268954
	],
	"./education-center/structured-data/medical/lhermitte-duclos-disease": [
		797191,
		3,
		797191
	],
	"./education-center/structured-data/medical/lhermitte-duclos-disease.json": [
		797191,
		3,
		797191
	],
	"./education-center/structured-data/medical/li-fraumeni-syndrome-1": [
		24295,
		3,
		24295
	],
	"./education-center/structured-data/medical/li-fraumeni-syndrome-1.json": [
		24295,
		3,
		24295
	],
	"./education-center/structured-data/medical/lig4-related-disorders": [
		225235,
		3,
		225235
	],
	"./education-center/structured-data/medical/lig4-related-disorders.json": [
		225235,
		3,
		225235
	],
	"./education-center/structured-data/medical/limb-girdle-muscular-dystrophy-dominant": [
		626681,
		3,
		626681
	],
	"./education-center/structured-data/medical/limb-girdle-muscular-dystrophy-dominant.json": [
		626681,
		3,
		626681
	],
	"./education-center/structured-data/medical/limb-girdle-muscular-dystrophy-recessive": [
		734565,
		3,
		734565
	],
	"./education-center/structured-data/medical/limb-girdle-muscular-dystrophy-recessive.json": [
		734565,
		3,
		734565
	],
	"./education-center/structured-data/medical/lingual-thyroid": [
		305098,
		3,
		305098
	],
	"./education-center/structured-data/medical/lingual-thyroid.json": [
		305098,
		3,
		305098
	],
	"./education-center/structured-data/medical/lipoatrophy-diabetes-hepatic-steatosis-hypertrophic-cardiomyopathy-and-leukomelanodermic-papules": [
		636226,
		3,
		636226
	],
	"./education-center/structured-data/medical/lipoatrophy-diabetes-hepatic-steatosis-hypertrophic-cardiomyopathy-and-leukomelanodermic-papules.json": [
		636226,
		3,
		636226
	],
	"./education-center/structured-data/medical/lipodystrophy": [
		686822,
		3,
		686822
	],
	"./education-center/structured-data/medical/lipodystrophy.json": [
		686822,
		3,
		686822
	],
	"./education-center/structured-data/medical/lipoid-nephrosis": [
		519567,
		3,
		519567
	],
	"./education-center/structured-data/medical/lipoid-nephrosis.json": [
		519567,
		3,
		519567
	],
	"./education-center/structured-data/medical/lipoma-somatic": [
		662084,
		3,
		662084
	],
	"./education-center/structured-data/medical/lipoma-somatic.json": [
		662084,
		3,
		662084
	],
	"./education-center/structured-data/medical/lipoproteina-deficiency-congenital": [
		720920,
		3,
		720920
	],
	"./education-center/structured-data/medical/lipoproteina-deficiency-congenital.json": [
		720920,
		3,
		720920
	],
	"./education-center/structured-data/medical/lissencephaly-4": [
		978694,
		3,
		978694
	],
	"./education-center/structured-data/medical/lissencephaly-4.json": [
		978694,
		3,
		978694
	],
	"./education-center/structured-data/medical/lissencephaly-recessive": [
		640884,
		3,
		640884
	],
	"./education-center/structured-data/medical/lissencephaly-recessive.json": [
		640884,
		3,
		640884
	],
	"./education-center/structured-data/medical/lissencephalysubcortical-band-heterotopia": [
		979384,
		3,
		979384
	],
	"./education-center/structured-data/medical/lissencephalysubcortical-band-heterotopia.json": [
		979384,
		3,
		979384
	],
	"./education-center/structured-data/medical/liver-disease-severe-congenital": [
		314980,
		3,
		314980
	],
	"./education-center/structured-data/medical/liver-disease-severe-congenital.json": [
		314980,
		3,
		314980
	],
	"./education-center/structured-data/medical/long-qt-syndrome-1-recessive": [
		977522,
		3,
		977522
	],
	"./education-center/structured-data/medical/long-qt-syndrome-1-recessive.json": [
		977522,
		3,
		977522
	],
	"./education-center/structured-data/medical/long-qt-syndrome-12-digenic": [
		706668,
		3,
		706668
	],
	"./education-center/structured-data/medical/long-qt-syndrome-12-digenic.json": [
		706668,
		3,
		706668
	],
	"./education-center/structured-data/medical/long-qt-syndrome-2-acquired-susceptibility": [
		164478,
		3,
		164478
	],
	"./education-center/structured-data/medical/long-qt-syndrome-2-acquired-susceptibility.json": [
		164478,
		3,
		164478
	],
	"./education-center/structured-data/medical/long-qt-syndrome-23-digenic": [
		717871,
		3,
		717871
	],
	"./education-center/structured-data/medical/long-qt-syndrome-23-digenic.json": [
		717871,
		3,
		717871
	],
	"./education-center/structured-data/medical/long-qt-syndrome-25-digenic": [
		203752,
		3,
		203752
	],
	"./education-center/structured-data/medical/long-qt-syndrome-25-digenic.json": [
		203752,
		3,
		203752
	],
	"./education-center/structured-data/medical/long-qt-syndrome-29-digenic": [
		546153,
		3,
		546153
	],
	"./education-center/structured-data/medical/long-qt-syndrome-29-digenic.json": [
		546153,
		3,
		546153
	],
	"./education-center/structured-data/medical/long-qt-syndrome-3-acquired-susceptibility": [
		643334,
		3,
		643334
	],
	"./education-center/structured-data/medical/long-qt-syndrome-3-acquired-susceptibility.json": [
		643334,
		3,
		643334
	],
	"./education-center/structured-data/medical/long-qt-syndrome-36-digenic": [
		832729,
		3,
		832729
	],
	"./education-center/structured-data/medical/long-qt-syndrome-36-digenic.json": [
		832729,
		3,
		832729
	],
	"./education-center/structured-data/medical/long-qt-syndrome-5-acquired-susceptibility": [
		875661,
		3,
		875661
	],
	"./education-center/structured-data/medical/long-qt-syndrome-5-acquired-susceptibility.json": [
		875661,
		3,
		875661
	],
	"./education-center/structured-data/medical/long-qt-syndrome-6-acquired-susceptibility": [
		368243,
		3,
		368243
	],
	"./education-center/structured-data/medical/long-qt-syndrome-6-acquired-susceptibility.json": [
		368243,
		3,
		368243
	],
	"./education-center/structured-data/medical/long-qt-syndrome-bradycardia-induced": [
		968581,
		3,
		968581
	],
	"./education-center/structured-data/medical/long-qt-syndrome-bradycardia-induced.json": [
		968581,
		3,
		968581
	],
	"./education-center/structured-data/medical/long-qt-syndrome-drug-associated": [
		55438,
		3,
		55438
	],
	"./education-center/structured-data/medical/long-qt-syndrome-drug-associated.json": [
		55438,
		3,
		55438
	],
	"./education-center/structured-data/medical/low-alkaline-phosphatase": [
		293409,
		3,
		293409
	],
	"./education-center/structured-data/medical/low-alkaline-phosphatase.json": [
		293409,
		3,
		293409
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-1": [
		248000,
		3,
		248000
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-1.json": [
		248000,
		3,
		248000
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-3": [
		197977,
		3,
		197977
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-3.json": [
		197977,
		3,
		197977
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6": [
		927430,
		3,
		927430
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-6.json": [
		927430,
		3,
		927430
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7": [
		752136,
		3,
		752136
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-7.json": [
		752136,
		3,
		752136
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8": [
		282460,
		3,
		282460
	],
	"./education-center/structured-data/medical/low-density-lipoprotein-cholesterol-level-quantitative-trait-locus-8.json": [
		282460,
		3,
		282460
	],
	"./education-center/structured-data/medical/low-serum-calcitriol": [
		316619,
		3,
		316619
	],
	"./education-center/structured-data/medical/low-serum-calcitriol.json": [
		316619,
		3,
		316619
	],
	"./education-center/structured-data/medical/low-set-posteriorly-rotated-ears": [
		98776,
		3,
		98776
	],
	"./education-center/structured-data/medical/low-set-posteriorly-rotated-ears.json": [
		98776,
		3,
		98776
	],
	"./education-center/structured-data/medical/lower-limb-muscle-weakness": [
		250853,
		3,
		250853
	],
	"./education-center/structured-data/medical/lower-limb-muscle-weakness.json": [
		250853,
		3,
		250853
	],
	"./education-center/structured-data/medical/lower-limb-spasticity": [
		294010,
		3,
		294010
	],
	"./education-center/structured-data/medical/lower-limb-spasticity.json": [
		294010,
		3,
		294010
	],
	"./education-center/structured-data/medical/lung-cancer": [
		951958,
		3,
		951958
	],
	"./education-center/structured-data/medical/lung-cancer-protection-against": [
		424975,
		3,
		424975
	],
	"./education-center/structured-data/medical/lung-cancer-protection-against-smokers": [
		212070,
		3,
		212070
	],
	"./education-center/structured-data/medical/lung-cancer-protection-against-smokers.json": [
		212070,
		3,
		212070
	],
	"./education-center/structured-data/medical/lung-cancer-protection-against.json": [
		424975,
		3,
		424975
	],
	"./education-center/structured-data/medical/lung-cancer-susceptibility-2": [
		348408,
		3,
		348408
	],
	"./education-center/structured-data/medical/lung-cancer-susceptibility-2.json": [
		348408,
		3,
		348408
	],
	"./education-center/structured-data/medical/lung-cancer.json": [
		951958,
		3,
		951958
	],
	"./education-center/structured-data/medical/lung-carcinoid-tumor": [
		939024,
		3,
		939024
	],
	"./education-center/structured-data/medical/lung-carcinoid-tumor.json": [
		939024,
		3,
		939024
	],
	"./education-center/structured-data/medical/lung-carcinoma": [
		46495,
		3,
		46495
	],
	"./education-center/structured-data/medical/lung-carcinoma.json": [
		46495,
		3,
		46495
	],
	"./education-center/structured-data/medical/lung-damage-immunodeficiency-and-chromosome-breakage-syndrome": [
		419125,
		3,
		419125
	],
	"./education-center/structured-data/medical/lung-damage-immunodeficiency-and-chromosome-breakage-syndrome.json": [
		419125,
		3,
		419125
	],
	"./education-center/structured-data/medical/lung-disease-non-specific": [
		73887,
		3,
		73887
	],
	"./education-center/structured-data/medical/lung-disease-non-specific.json": [
		73887,
		3,
		73887
	],
	"./education-center/structured-data/medical/luteinizing-hormone-resistance-female": [
		846619,
		3,
		846619
	],
	"./education-center/structured-data/medical/luteinizing-hormone-resistance-female.json": [
		846619,
		3,
		846619
	],
	"./education-center/structured-data/medical/lymphedema-distichiasis-syndrome-renal-disease-and-diabetes-mellitus": [
		198562,
		3,
		198562
	],
	"./education-center/structured-data/medical/lymphedema-distichiasis-syndrome-renal-disease-and-diabetes-mellitus.json": [
		198562,
		3,
		198562
	],
	"./education-center/structured-data/medical/lynch-syndrome": [
		949337,
		3,
		949337
	],
	"./education-center/structured-data/medical/lynch-syndrome-1": [
		462050,
		3,
		462050
	],
	"./education-center/structured-data/medical/lynch-syndrome-1.json": [
		462050,
		3,
		462050
	],
	"./education-center/structured-data/medical/lynch-syndrome.json": [
		949337,
		3,
		949337
	],
	"./education-center/structured-data/medical/macrocephaly": [
		552387,
		3,
		552387
	],
	"./education-center/structured-data/medical/macrocephaly-and-epileptic-encephalopathy": [
		95015,
		3,
		95015
	],
	"./education-center/structured-data/medical/macrocephaly-and-epileptic-encephalopathy.json": [
		95015,
		3,
		95015
	],
	"./education-center/structured-data/medical/macrocephaly-macrosomia-facial-dysmorphism-syndrome": [
		206798,
		3,
		206798
	],
	"./education-center/structured-data/medical/macrocephaly-macrosomia-facial-dysmorphism-syndrome.json": [
		206798,
		3,
		206798
	],
	"./education-center/structured-data/medical/macrocephaly-neurodevelopmental-delay-lymphoid-hyperplasia-and-persistent-fetal-hemoglobin": [
		664091,
		3,
		664091
	],
	"./education-center/structured-data/medical/macrocephaly-neurodevelopmental-delay-lymphoid-hyperplasia-and-persistent-fetal-hemoglobin.json": [
		664091,
		3,
		664091
	],
	"./education-center/structured-data/medical/macrocephaly.json": [
		552387,
		3,
		552387
	],
	"./education-center/structured-data/medical/macroglobulinemia-waldenstrom-somatic": [
		425721,
		3,
		425721
	],
	"./education-center/structured-data/medical/macroglobulinemia-waldenstrom-somatic.json": [
		425721,
		3,
		425721
	],
	"./education-center/structured-data/medical/macronodular-adrenal-hyperplasia": [
		67968,
		3,
		67968
	],
	"./education-center/structured-data/medical/macronodular-adrenal-hyperplasia.json": [
		67968,
		3,
		67968
	],
	"./education-center/structured-data/medical/macroscopic-hematuria": [
		432765,
		3,
		432765
	],
	"./education-center/structured-data/medical/macroscopic-hematuria.json": [
		432765,
		3,
		432765
	],
	"./education-center/structured-data/medical/macrothrombocytopenia": [
		235581,
		3,
		235581
	],
	"./education-center/structured-data/medical/macrothrombocytopenia-familial-bernard-soulier-type": [
		149689,
		3,
		149689
	],
	"./education-center/structured-data/medical/macrothrombocytopenia-familial-bernard-soulier-type.json": [
		149689,
		3,
		149689
	],
	"./education-center/structured-data/medical/macrothrombocytopenia.json": [
		235581,
		3,
		235581
	],
	"./education-center/structured-data/medical/macular-corneal-dystrophy-type-ii": [
		826650,
		3,
		826650
	],
	"./education-center/structured-data/medical/macular-corneal-dystrophy-type-ii.json": [
		826650,
		3,
		826650
	],
	"./education-center/structured-data/medical/macular-degeneration-age-related-13-susceptibility": [
		504842,
		3,
		504842
	],
	"./education-center/structured-data/medical/macular-degeneration-age-related-13-susceptibility.json": [
		504842,
		3,
		504842
	],
	"./education-center/structured-data/medical/macular-dystrophy": [
		439621,
		3,
		439621
	],
	"./education-center/structured-data/medical/macular-dystrophy-retinal-4": [
		180696,
		3,
		180696
	],
	"./education-center/structured-data/medical/macular-dystrophy-retinal-4.json": [
		180696,
		3,
		180696
	],
	"./education-center/structured-data/medical/macular-dystrophy-retinal-5": [
		614556,
		3,
		614556
	],
	"./education-center/structured-data/medical/macular-dystrophy-retinal-5.json": [
		614556,
		3,
		614556
	],
	"./education-center/structured-data/medical/macular-dystrophy.json": [
		439621,
		3,
		439621
	],
	"./education-center/structured-data/medical/major-depressive-disorder-response-citalopram-therapy": [
		706197,
		3,
		706197
	],
	"./education-center/structured-data/medical/major-depressive-disorder-response-citalopram-therapy.json": [
		706197,
		3,
		706197
	],
	"./education-center/structured-data/medical/malaria-cerebral-resistance": [
		453038,
		3,
		453038
	],
	"./education-center/structured-data/medical/malaria-cerebral-resistance.json": [
		453038,
		3,
		453038
	],
	"./education-center/structured-data/medical/malaria-cerebral-susceptibility": [
		742315,
		3,
		742315
	],
	"./education-center/structured-data/medical/malaria-cerebral-susceptibility.json": [
		742315,
		3,
		742315
	],
	"./education-center/structured-data/medical/malaria-resistance": [
		998356,
		3,
		998356
	],
	"./education-center/structured-data/medical/malaria-resistance.json": [
		998356,
		3,
		998356
	],
	"./education-center/structured-data/medical/malaria-severe-resistance": [
		552367,
		3,
		552367
	],
	"./education-center/structured-data/medical/malaria-severe-resistance.json": [
		552367,
		3,
		552367
	],
	"./education-center/structured-data/medical/malaria-severe-susceptibility": [
		513004,
		3,
		513004
	],
	"./education-center/structured-data/medical/malaria-severe-susceptibility.json": [
		513004,
		3,
		513004
	],
	"./education-center/structured-data/medical/malattia-leventinese": [
		239770,
		3,
		239770
	],
	"./education-center/structured-data/medical/malattia-leventinese.json": [
		239770,
		3,
		239770
	],
	"./education-center/structured-data/medical/male-germ-cell-tumor-somatic": [
		7017,
		3,
		7017
	],
	"./education-center/structured-data/medical/male-germ-cell-tumor-somatic.json": [
		7017,
		3,
		7017
	],
	"./education-center/structured-data/medical/male-infertility-due-obstructive-azoospermia": [
		235517,
		3,
		235517
	],
	"./education-center/structured-data/medical/male-infertility-due-obstructive-azoospermia.json": [
		235517,
		3,
		235517
	],
	"./education-center/structured-data/medical/male-infertility-spermatogenesis-disorder": [
		176174,
		3,
		176174
	],
	"./education-center/structured-data/medical/male-infertility-spermatogenesis-disorder.json": [
		176174,
		3,
		176174
	],
	"./education-center/structured-data/medical/male-pseudohermaphroditism": [
		156381,
		3,
		156381
	],
	"./education-center/structured-data/medical/male-pseudohermaphroditism.json": [
		156381,
		3,
		156381
	],
	"./education-center/structured-data/medical/malformation-heart-and-great-vessels": [
		403179,
		3,
		403179
	],
	"./education-center/structured-data/medical/malformation-heart-and-great-vessels.json": [
		403179,
		3,
		403179
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-and-exertional-rhabdomyolosis": [
		812126,
		3,
		812126
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-and-exertional-rhabdomyolosis.json": [
		812126,
		3,
		812126
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-equivocal-halotane": [
		356411,
		3,
		356411
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-equivocal-halotane.json": [
		356411,
		3,
		356411
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-susceptibility-1": [
		695755,
		3,
		695755
	],
	"./education-center/structured-data/medical/malignant-hyperthermia-susceptibility-1.json": [
		695755,
		3,
		695755
	],
	"./education-center/structured-data/medical/malignant-hypothermia": [
		877052,
		3,
		877052
	],
	"./education-center/structured-data/medical/malignant-hypothermia.json": [
		877052,
		3,
		877052
	],
	"./education-center/structured-data/medical/malignant-melanoma-susceptibility": [
		641352,
		3,
		641352
	],
	"./education-center/structured-data/medical/malignant-melanoma-susceptibility.json": [
		641352,
		3,
		641352
	],
	"./education-center/structured-data/medical/malignant-neoplasm-brain": [
		709789,
		3,
		709789
	],
	"./education-center/structured-data/medical/malignant-neoplasm-brain.json": [
		709789,
		3,
		709789
	],
	"./education-center/structured-data/medical/malignant-peritoneal-mesothelioma": [
		653499,
		3,
		653499
	],
	"./education-center/structured-data/medical/malignant-peritoneal-mesothelioma.json": [
		653499,
		3,
		653499
	],
	"./education-center/structured-data/medical/malignant-rhabdoid-tumor-somatic": [
		636575,
		3,
		636575
	],
	"./education-center/structured-data/medical/malignant-rhabdoid-tumor-somatic.json": [
		636575,
		3,
		636575
	],
	"./education-center/structured-data/medical/malignant-tumor-breast": [
		273487,
		3,
		273487
	],
	"./education-center/structured-data/medical/malignant-tumor-breast.json": [
		273487,
		3,
		273487
	],
	"./education-center/structured-data/medical/malignant-tumor-esophagus": [
		263518,
		3,
		263518
	],
	"./education-center/structured-data/medical/malignant-tumor-esophagus.json": [
		263518,
		3,
		263518
	],
	"./education-center/structured-data/medical/malignant-tumor-testis": [
		25969,
		3,
		25969
	],
	"./education-center/structured-data/medical/malignant-tumor-testis.json": [
		25969,
		3,
		25969
	],
	"./education-center/structured-data/medical/malignant-tumor-urinary-bladder": [
		129732,
		3,
		129732
	],
	"./education-center/structured-data/medical/malignant-tumor-urinary-bladder.json": [
		129732,
		3,
		129732
	],
	"./education-center/structured-data/medical/mandibuloacral-dysplasia-type-lipodystrophy-atypical": [
		877884,
		3,
		877884
	],
	"./education-center/structured-data/medical/mandibuloacral-dysplasia-type-lipodystrophy-atypical.json": [
		877884,
		3,
		877884
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-classic-type-ib": [
		689477,
		3,
		689477
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-classic-type-ib.json": [
		689477,
		3,
		689477
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-intermediate-type-ia": [
		697442,
		3,
		697442
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-intermediate-type-ia.json": [
		697442,
		3,
		697442
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-thiamine-responsive-type-ii": [
		642673,
		3,
		642673
	],
	"./education-center/structured-data/medical/maple-syrup-urine-disease-thiamine-responsive-type-ii.json": [
		642673,
		3,
		642673
	],
	"./education-center/structured-data/medical/mapt-related-spectrum-disorders": [
		722579,
		3,
		722579
	],
	"./education-center/structured-data/medical/mapt-related-spectrum-disorders.json": [
		722579,
		3,
		722579
	],
	"./education-center/structured-data/medical/marfan-syndrome": [
		714712,
		3,
		714712
	],
	"./education-center/structured-data/medical/marfan-syndrome-atypical": [
		201535,
		3,
		201535
	],
	"./education-center/structured-data/medical/marfan-syndrome-atypical.json": [
		201535,
		3,
		201535
	],
	"./education-center/structured-data/medical/marfan-syndrome-autosomal-recessive": [
		205050,
		3,
		205050
	],
	"./education-center/structured-data/medical/marfan-syndrome-autosomal-recessive.json": [
		205050,
		3,
		205050
	],
	"./education-center/structured-data/medical/marfan-syndrome-incomplete": [
		619976,
		3,
		619976
	],
	"./education-center/structured-data/medical/marfan-syndrome-incomplete.json": [
		619976,
		3,
		619976
	],
	"./education-center/structured-data/medical/marfan-syndrome-mild": [
		908116,
		3,
		908116
	],
	"./education-center/structured-data/medical/marfan-syndrome-mild-variable": [
		598523,
		3,
		598523
	],
	"./education-center/structured-data/medical/marfan-syndrome-mild-variable.json": [
		598523,
		3,
		598523
	],
	"./education-center/structured-data/medical/marfan-syndrome-mild.json": [
		908116,
		3,
		908116
	],
	"./education-center/structured-data/medical/marfan-syndrome-severe-classic": [
		839489,
		3,
		839489
	],
	"./education-center/structured-data/medical/marfan-syndrome-severe-classic.json": [
		839489,
		3,
		839489
	],
	"./education-center/structured-data/medical/marfan-syndrome.json": [
		714712,
		3,
		714712
	],
	"./education-center/structured-data/medical/marfan-syndromeloeys-dietz-syndromefamilial-thoracic-aortic-aneurysms-and-dissections": [
		275664,
		3,
		275664
	],
	"./education-center/structured-data/medical/marfan-syndromeloeys-dietz-syndromefamilial-thoracic-aortic-aneurysms-and-dissections.json": [
		275664,
		3,
		275664
	],
	"./education-center/structured-data/medical/marfanoid-habitus-and-intellectual-disability": [
		303680,
		3,
		303680
	],
	"./education-center/structured-data/medical/marfanoid-habitus-and-intellectual-disability.json": [
		303680,
		3,
		303680
	],
	"./education-center/structured-data/medical/marshall-syndrome": [
		237346,
		3,
		237346
	],
	"./education-center/structured-data/medical/marshall-syndrome.json": [
		237346,
		3,
		237346
	],
	"./education-center/structured-data/medical/marshallstickler-syndrome": [
		339416,
		3,
		339416
	],
	"./education-center/structured-data/medical/marshallstickler-syndrome.json": [
		339416,
		3,
		339416
	],
	"./education-center/structured-data/medical/mastocytosis": [
		935260,
		3,
		935260
	],
	"./education-center/structured-data/medical/mastocytosis-cutaneous-and-systemic-somatic": [
		261974,
		3,
		261974
	],
	"./education-center/structured-data/medical/mastocytosis-cutaneous-and-systemic-somatic.json": [
		261974,
		3,
		261974
	],
	"./education-center/structured-data/medical/mastocytosis.json": [
		935260,
		3,
		935260
	],
	"./education-center/structured-data/medical/maturity-onset-diabetes-young-type-1": [
		657381,
		3,
		657381
	],
	"./education-center/structured-data/medical/maturity-onset-diabetes-young-type-1.json": [
		657381,
		3,
		657381
	],
	"./education-center/structured-data/medical/maturity-onset-diabetes-young-type-2": [
		775939,
		3,
		775939
	],
	"./education-center/structured-data/medical/maturity-onset-diabetes-young-type-2.json": [
		775939,
		3,
		775939
	],
	"./education-center/structured-data/medical/mbd5-associated-neurodevelopmental-disorder": [
		229375,
		3,
		229375
	],
	"./education-center/structured-data/medical/mbd5-associated-neurodevelopmental-disorder.json": [
		229375,
		3,
		229375
	],
	"./education-center/structured-data/medical/mcardle-disease-mild": [
		156063,
		3,
		156063
	],
	"./education-center/structured-data/medical/mcardle-disease-mild.json": [
		156063,
		3,
		156063
	],
	"./education-center/structured-data/medical/median-cleft-lip-and-palate": [
		137740,
		3,
		137740
	],
	"./education-center/structured-data/medical/median-cleft-lip-and-palate.json": [
		137740,
		3,
		137740
	],
	"./education-center/structured-data/medical/medium-chain-dicarboxylic-aciduria": [
		465542,
		3,
		465542
	],
	"./education-center/structured-data/medical/medium-chain-dicarboxylic-aciduria.json": [
		465542,
		3,
		465542
	],
	"./education-center/structured-data/medical/medulloblastoma": [
		320140,
		3,
		320140
	],
	"./education-center/structured-data/medical/medulloblastoma.json": [
		320140,
		3,
		320140
	],
	"./education-center/structured-data/medical/megacolon": [
		589619,
		3,
		589619
	],
	"./education-center/structured-data/medical/megacolon.json": [
		589619,
		3,
		589619
	],
	"./education-center/structured-data/medical/megalencephaly-thick-corpus-callosum-cerebellar-atrophy-and-intellectual-disability": [
		898581,
		3,
		898581
	],
	"./education-center/structured-data/medical/megalencephaly-thick-corpus-callosum-cerebellar-atrophy-and-intellectual-disability.json": [
		898581,
		3,
		898581
	],
	"./education-center/structured-data/medical/melanoma": [
		152205,
		3,
		152205
	],
	"./education-center/structured-data/medical/melanoma-and-neural-system-tumor-syndrome": [
		850166,
		3,
		850166
	],
	"./education-center/structured-data/medical/melanoma-and-neural-system-tumor-syndrome.json": [
		850166,
		3,
		850166
	],
	"./education-center/structured-data/medical/melanoma-cutaneous-malignant-susceptibility-1": [
		141558,
		3,
		141558
	],
	"./education-center/structured-data/medical/melanoma-cutaneous-malignant-susceptibility-1.json": [
		141558,
		3,
		141558
	],
	"./education-center/structured-data/medical/melanoma-cutaneous-malignant-susceptibility-2": [
		4361,
		3,
		4361
	],
	"./education-center/structured-data/medical/melanoma-cutaneous-malignant-susceptibility-2.json": [
		4361,
		3,
		4361
	],
	"./education-center/structured-data/medical/melanoma.json": [
		152205,
		3,
		152205
	],
	"./education-center/structured-data/medical/melioidosis-resistance": [
		211449,
		3,
		211449
	],
	"./education-center/structured-data/medical/melioidosis-resistance.json": [
		211449,
		3,
		211449
	],
	"./education-center/structured-data/medical/melnick-fraser-syndrome": [
		144896,
		3,
		144896
	],
	"./education-center/structured-data/medical/melnick-fraser-syndrome.json": [
		144896,
		3,
		144896
	],
	"./education-center/structured-data/medical/melorheostosis": [
		380385,
		3,
		380385
	],
	"./education-center/structured-data/medical/melorheostosis.json": [
		380385,
		3,
		380385
	],
	"./education-center/structured-data/medical/memory-quantitative-trait-locus": [
		939463,
		3,
		939463
	],
	"./education-center/structured-data/medical/memory-quantitative-trait-locus.json": [
		939463,
		3,
		939463
	],
	"./education-center/structured-data/medical/men2-phenotype-unclassified": [
		721724,
		3,
		721724
	],
	"./education-center/structured-data/medical/men2-phenotype-unclassified.json": [
		721724,
		3,
		721724
	],
	"./education-center/structured-data/medical/meniere-disease": [
		723789,
		3,
		723789
	],
	"./education-center/structured-data/medical/meniere-disease.json": [
		723789,
		3,
		723789
	],
	"./education-center/structured-data/medical/menkes-disease-copper-replacement-responsive": [
		302003,
		3,
		302003
	],
	"./education-center/structured-data/medical/menkes-disease-copper-replacement-responsive.json": [
		302003,
		3,
		302003
	],
	"./education-center/structured-data/medical/menkes-disease-mild": [
		44578,
		3,
		44578
	],
	"./education-center/structured-data/medical/menkes-disease-mild.json": [
		44578,
		3,
		44578
	],
	"./education-center/structured-data/medical/mephenytoin-poor-metabolism": [
		489377,
		3,
		489377
	],
	"./education-center/structured-data/medical/mephenytoin-poor-metabolism.json": [
		489377,
		3,
		489377
	],
	"./education-center/structured-data/medical/meretoja-syndrome": [
		356253,
		3,
		356253
	],
	"./education-center/structured-data/medical/meretoja-syndrome.json": [
		356253,
		3,
		356253
	],
	"./education-center/structured-data/medical/merff-syndrome": [
		235100,
		3,
		235100
	],
	"./education-center/structured-data/medical/merff-syndrome.json": [
		235100,
		3,
		235100
	],
	"./education-center/structured-data/medical/merrfmelas-overlap-syndrome": [
		785970,
		3,
		785970
	],
	"./education-center/structured-data/medical/merrfmelas-overlap-syndrome.json": [
		785970,
		3,
		785970
	],
	"./education-center/structured-data/medical/metabolic-syndrome-susceptibility": [
		59827,
		3,
		59827
	],
	"./education-center/structured-data/medical/metabolic-syndrome-susceptibility.json": [
		59827,
		3,
		59827
	],
	"./education-center/structured-data/medical/metachondromatosis": [
		281513,
		3,
		281513
	],
	"./education-center/structured-data/medical/metachondromatosis.json": [
		281513,
		3,
		281513
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-late-onset": [
		611921,
		3,
		611921
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-late-onset.json": [
		611921,
		3,
		611921
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-mild": [
		433254,
		3,
		433254
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-mild.json": [
		433254,
		3,
		433254
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-severe": [
		287425,
		3,
		287425
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-severe.json": [
		287425,
		3,
		287425
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-variant": [
		779516,
		3,
		779516
	],
	"./education-center/structured-data/medical/metachromatic-leukodystrophy-variant.json": [
		779516,
		3,
		779516
	],
	"./education-center/structured-data/medical/metaphyseal-anadysplasia-1-autosomal-dominant": [
		978606,
		3,
		978606
	],
	"./education-center/structured-data/medical/metaphyseal-anadysplasia-1-autosomal-dominant.json": [
		978606,
		3,
		978606
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia": [
		811250,
		3,
		811250
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia-jansen-type": [
		4773,
		3,
		4773
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia-jansen-type.json": [
		4773,
		3,
		4773
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia-schmid-type": [
		601609,
		3,
		601609
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia-schmid-type.json": [
		601609,
		3,
		601609
	],
	"./education-center/structured-data/medical/metaphyseal-chondrodysplasia.json": [
		811250,
		3,
		811250
	],
	"./education-center/structured-data/medical/metaphyseal-dysplasia-maxillary-hypoplasia-brachydacty-syndrome": [
		330152,
		3,
		330152
	],
	"./education-center/structured-data/medical/metaphyseal-dysplasia-maxillary-hypoplasia-brachydacty-syndrome.json": [
		330152,
		3,
		330152
	],
	"./education-center/structured-data/medical/metastatic-prostate-small-cell-carcinoma": [
		860895,
		3,
		860895
	],
	"./education-center/structured-data/medical/metastatic-prostate-small-cell-carcinoma.json": [
		860895,
		3,
		860895
	],
	"./education-center/structured-data/medical/metatropic-dysplasia": [
		706286,
		3,
		706286
	],
	"./education-center/structured-data/medical/metatropic-dysplasia.json": [
		706286,
		3,
		706286
	],
	"./education-center/structured-data/medical/methemoglobinemia-beta-globin-type": [
		348723,
		3,
		348723
	],
	"./education-center/structured-data/medical/methemoglobinemia-beta-globin-type.json": [
		348723,
		3,
		348723
	],
	"./education-center/structured-data/medical/methemoglobinemia-type-2": [
		809949,
		3,
		809949
	],
	"./education-center/structured-data/medical/methemoglobinemia-type-2.json": [
		809949,
		3,
		809949
	],
	"./education-center/structured-data/medical/methemoglobinemia-type-i": [
		269580,
		3,
		269580
	],
	"./education-center/structured-data/medical/methemoglobinemia-type-i.json": [
		269580,
		3,
		269580
	],
	"./education-center/structured-data/medical/methotrexate-response-efficacy": [
		758984,
		3,
		758984
	],
	"./education-center/structured-data/medical/methotrexate-response-efficacy.json": [
		758984,
		3,
		758984
	],
	"./education-center/structured-data/medical/methylmalonic-acidemia-homocystinuria-cblc": [
		243295,
		3,
		243295
	],
	"./education-center/structured-data/medical/methylmalonic-acidemia-homocystinuria-cblc.json": [
		243295,
		3,
		243295
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-and-homocystinuria-cblc-type-digenic": [
		327714,
		3,
		327714
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-and-homocystinuria-cblc-type-digenic.json": [
		327714,
		3,
		327714
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-mut-type": [
		846183,
		3,
		846183
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-mut-type.json": [
		846183,
		3,
		846183
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-mut0-type": [
		546890,
		3,
		546890
	],
	"./education-center/structured-data/medical/methylmalonic-aciduria-mut0-type.json": [
		546890,
		3,
		546890
	],
	"./education-center/structured-data/medical/mevalonic-aciduria": [
		250442,
		3,
		250442
	],
	"./education-center/structured-data/medical/mevalonic-aciduria.json": [
		250442,
		3,
		250442
	],
	"./education-center/structured-data/medical/microcephalic-osteodysplastic-primordial-dwarfism": [
		413391,
		3,
		413391
	],
	"./education-center/structured-data/medical/microcephalic-osteodysplastic-primordial-dwarfism.json": [
		413391,
		3,
		413391
	],
	"./education-center/structured-data/medical/microcephaly": [
		242770,
		3,
		242770
	],
	"./education-center/structured-data/medical/microcephaly-and-chorioretinopathy-or-without-intellectual-disability": [
		402155,
		3,
		402155
	],
	"./education-center/structured-data/medical/microcephaly-and-chorioretinopathy-or-without-intellectual-disability.json": [
		402155,
		3,
		402155
	],
	"./education-center/structured-data/medical/microcephaly-cortical-malformations-and-intellectual-disability": [
		986026,
		3,
		986026
	],
	"./education-center/structured-data/medical/microcephaly-cortical-malformations-and-intellectual-disability.json": [
		986026,
		3,
		986026
	],
	"./education-center/structured-data/medical/microcephaly-or-without-chorioretinopathy-lymphedema-or-intellectual-disability": [
		514577,
		3,
		514577
	],
	"./education-center/structured-data/medical/microcephaly-or-without-chorioretinopathy-lymphedema-or-intellectual-disability.json": [
		514577,
		3,
		514577
	],
	"./education-center/structured-data/medical/microcephaly-short-stature-and-impaired-glucose-metabolism-1": [
		393902,
		3,
		393902
	],
	"./education-center/structured-data/medical/microcephaly-short-stature-and-impaired-glucose-metabolism-1.json": [
		393902,
		3,
		393902
	],
	"./education-center/structured-data/medical/microcephaly-short-stature-and-polymicrogyria-seizures": [
		221385,
		3,
		221385
	],
	"./education-center/structured-data/medical/microcephaly-short-stature-and-polymicrogyria-seizures.json": [
		221385,
		3,
		221385
	],
	"./education-center/structured-data/medical/microcephaly.json": [
		242770,
		3,
		242770
	],
	"./education-center/structured-data/medical/microcytic-anemia": [
		677358,
		3,
		677358
	],
	"./education-center/structured-data/medical/microcytic-anemia.json": [
		677358,
		3,
		677358
	],
	"./education-center/structured-data/medical/micropenis": [
		698196,
		3,
		698196
	],
	"./education-center/structured-data/medical/micropenis.json": [
		698196,
		3,
		698196
	],
	"./education-center/structured-data/medical/microphthalmia-cataracts-and-iris-abnormalities": [
		180315,
		3,
		180315
	],
	"./education-center/structured-data/medical/microphthalmia-cataracts-and-iris-abnormalities.json": [
		180315,
		3,
		180315
	],
	"./education-center/structured-data/medical/microphthalmia-syndromic-15": [
		815572,
		3,
		815572
	],
	"./education-center/structured-data/medical/microphthalmia-syndromic-15.json": [
		815572,
		3,
		815572
	],
	"./education-center/structured-data/medical/microprolactinoma": [
		286025,
		3,
		286025
	],
	"./education-center/structured-data/medical/microprolactinoma.json": [
		286025,
		3,
		286025
	],
	"./education-center/structured-data/medical/microscopic-hematuria": [
		872198,
		3,
		872198
	],
	"./education-center/structured-data/medical/microscopic-hematuria.json": [
		872198,
		3,
		872198
	],
	"./education-center/structured-data/medical/microspherophakia": [
		247368,
		3,
		247368
	],
	"./education-center/structured-data/medical/microspherophakia.json": [
		247368,
		3,
		247368
	],
	"./education-center/structured-data/medical/microtia-or-without-hearing-impairment": [
		418926,
		3,
		418926
	],
	"./education-center/structured-data/medical/microtia-or-without-hearing-impairment.json": [
		418926,
		3,
		418926
	],
	"./education-center/structured-data/medical/migalastat-response": [
		948174,
		3,
		948174
	],
	"./education-center/structured-data/medical/migalastat-response.json": [
		948174,
		3,
		948174
	],
	"./education-center/structured-data/medical/migraine": [
		364204,
		3,
		364204
	],
	"./education-center/structured-data/medical/migraine-familial-basilar": [
		448415,
		3,
		448415
	],
	"./education-center/structured-data/medical/migraine-familial-basilar.json": [
		448415,
		3,
		448415
	],
	"./education-center/structured-data/medical/migraine-or-without-aura-susceptibility-1": [
		892514,
		3,
		892514
	],
	"./education-center/structured-data/medical/migraine-or-without-aura-susceptibility-1.json": [
		892514,
		3,
		892514
	],
	"./education-center/structured-data/medical/migraine-resistance": [
		346147,
		3,
		346147
	],
	"./education-center/structured-data/medical/migraine-resistance.json": [
		346147,
		3,
		346147
	],
	"./education-center/structured-data/medical/migraine-sporadic-hemiplegic-progressive-cerebellar-ataxia": [
		502088,
		3,
		502088
	],
	"./education-center/structured-data/medical/migraine-sporadic-hemiplegic-progressive-cerebellar-ataxia.json": [
		502088,
		3,
		502088
	],
	"./education-center/structured-data/medical/migraine.json": [
		364204,
		3,
		364204
	],
	"./education-center/structured-data/medical/mild-global-developmental-delay": [
		151668,
		3,
		151668
	],
	"./education-center/structured-data/medical/mild-global-developmental-delay.json": [
		151668,
		3,
		151668
	],
	"./education-center/structured-data/medical/mild-non-pku-hyperphenylalanemia": [
		793691,
		3,
		793691
	],
	"./education-center/structured-data/medical/mild-non-pku-hyperphenylalanemia.json": [
		793691,
		3,
		793691
	],
	"./education-center/structured-data/medical/mild-short-stature": [
		291873,
		3,
		291873
	],
	"./education-center/structured-data/medical/mild-short-stature.json": [
		291873,
		3,
		291873
	],
	"./education-center/structured-data/medical/mineralocorticoid-deficiency-isolated": [
		606275,
		3,
		606275
	],
	"./education-center/structured-data/medical/mineralocorticoid-deficiency-isolated.json": [
		606275,
		3,
		606275
	],
	"./education-center/structured-data/medical/mirror-movements-1": [
		703733,
		3,
		703733
	],
	"./education-center/structured-data/medical/mirror-movements-1.json": [
		703733,
		3,
		703733
	],
	"./education-center/structured-data/medical/mitochondrial-complex-iii-deficiency-nuclear-type-1": [
		315658,
		3,
		315658
	],
	"./education-center/structured-data/medical/mitochondrial-complex-iii-deficiency-nuclear-type-1.json": [
		315658,
		3,
		315658
	],
	"./education-center/structured-data/medical/mitochondrial-complex-iv-deficiency-recurrent-myoglobinuria": [
		342084,
		3,
		342084
	],
	"./education-center/structured-data/medical/mitochondrial-complex-iv-deficiency-recurrent-myoglobinuria.json": [
		342084,
		3,
		342084
	],
	"./education-center/structured-data/medical/mitochondrial-cytochrome-c-oxidase-deficiency": [
		612989,
		3,
		612989
	],
	"./education-center/structured-data/medical/mitochondrial-cytochrome-c-oxidase-deficiency.json": [
		612989,
		3,
		612989
	],
	"./education-center/structured-data/medical/mitochondrial-disorder-due-defect-assembly-or-maturation-respiratory-chain-complexes": [
		460210,
		3,
		460210
	],
	"./education-center/structured-data/medical/mitochondrial-disorder-due-defect-assembly-or-maturation-respiratory-chain-complexes.json": [
		460210,
		3,
		460210
	],
	"./education-center/structured-data/medical/mitochondrial-dna-associated-leigh-syndrome-and-narp": [
		739161,
		3,
		739161
	],
	"./education-center/structured-data/medical/mitochondrial-dna-associated-leigh-syndrome-and-narp.json": [
		739161,
		3,
		739161
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-16a": [
		746166,
		3,
		746166
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-16a.json": [
		746166,
		3,
		746166
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-8b-mngie-type": [
		845895,
		3,
		845895
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-8b-mngie-type.json": [
		845895,
		3,
		845895
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-hepatocerebral-form": [
		591294,
		3,
		591294
	],
	"./education-center/structured-data/medical/mitochondrial-dna-depletion-syndrome-hepatocerebral-form.json": [
		591294,
		3,
		591294
	],
	"./education-center/structured-data/medical/mitochondrial-dna-related-disorder": [
		573059,
		3,
		573059
	],
	"./education-center/structured-data/medical/mitochondrial-dna-related-disorder.json": [
		573059,
		3,
		573059
	],
	"./education-center/structured-data/medical/mitochondrial-encephalomyopathy": [
		680940,
		3,
		680940
	],
	"./education-center/structured-data/medical/mitochondrial-encephalomyopathy.json": [
		680940,
		3,
		680940
	],
	"./education-center/structured-data/medical/mitochondrial-encephalopathy": [
		87451,
		3,
		87451
	],
	"./education-center/structured-data/medical/mitochondrial-encephalopathy.json": [
		87451,
		3,
		87451
	],
	"./education-center/structured-data/medical/mitochondrial-hepatopathy": [
		550281,
		3,
		550281
	],
	"./education-center/structured-data/medical/mitochondrial-hepatopathy.json": [
		550281,
		3,
		550281
	],
	"./education-center/structured-data/medical/mitochondrial-inheritance": [
		414588,
		3,
		414588
	],
	"./education-center/structured-data/medical/mitochondrial-inheritance.json": [
		414588,
		3,
		414588
	],
	"./education-center/structured-data/medical/mitochondrial-myopathy-episodic-without-optic-atrophy-and-reversible-leukoencephalopathy": [
		864969,
		3,
		864969
	],
	"./education-center/structured-data/medical/mitochondrial-myopathy-episodic-without-optic-atrophy-and-reversible-leukoencephalopathy.json": [
		864969,
		3,
		864969
	],
	"./education-center/structured-data/medical/mitochondrial-myopathy-isolated": [
		364625,
		3,
		364625
	],
	"./education-center/structured-data/medical/mitochondrial-myopathy-isolated.json": [
		364625,
		3,
		364625
	],
	"./education-center/structured-data/medical/mitochondrial-trifunctional-protein-deficiency-2": [
		412675,
		3,
		412675
	],
	"./education-center/structured-data/medical/mitochondrial-trifunctional-protein-deficiency-2-myopathy-and-neuropathy": [
		855809,
		3,
		855809
	],
	"./education-center/structured-data/medical/mitochondrial-trifunctional-protein-deficiency-2-myopathy-and-neuropathy.json": [
		855809,
		3,
		855809
	],
	"./education-center/structured-data/medical/mitochondrial-trifunctional-protein-deficiency-2.json": [
		412675,
		3,
		412675
	],
	"./education-center/structured-data/medical/mixed-phenotype-acute-leukemia-tv11q233-kmt2a-rearranged": [
		843488,
		3,
		843488
	],
	"./education-center/structured-data/medical/mixed-phenotype-acute-leukemia-tv11q233-kmt2a-rearranged.json": [
		843488,
		3,
		843488
	],
	"./education-center/structured-data/medical/mks1-related-disorders": [
		514188,
		3,
		514188
	],
	"./education-center/structured-data/medical/mks1-related-disorders.json": [
		514188,
		3,
		514188
	],
	"./education-center/structured-data/medical/moderate-global-developmental-delay": [
		477041,
		3,
		477041
	],
	"./education-center/structured-data/medical/moderate-global-developmental-delay.json": [
		477041,
		3,
		477041
	],
	"./education-center/structured-data/medical/moderate-intellectual-deficiency": [
		372329,
		3,
		372329
	],
	"./education-center/structured-data/medical/moderate-intellectual-deficiency.json": [
		372329,
		3,
		372329
	],
	"./education-center/structured-data/medical/monocarboxylate-transporter-1-deficiency-autosomal-dominant": [
		167583,
		3,
		167583
	],
	"./education-center/structured-data/medical/monocarboxylate-transporter-1-deficiency-autosomal-dominant.json": [
		167583,
		3,
		167583
	],
	"./education-center/structured-data/medical/monocarboxylate-transporter-1-deficiency-autosomal-recessive": [
		360252,
		3,
		360252
	],
	"./education-center/structured-data/medical/monocarboxylate-transporter-1-deficiency-autosomal-recessive.json": [
		360252,
		3,
		360252
	],
	"./education-center/structured-data/medical/monochromacy": [
		531064,
		3,
		531064
	],
	"./education-center/structured-data/medical/monochromacy.json": [
		531064,
		3,
		531064
	],
	"./education-center/structured-data/medical/monoclonal-b-cell-lymphocytosis": [
		691108,
		3,
		691108
	],
	"./education-center/structured-data/medical/monoclonal-b-cell-lymphocytosis.json": [
		691108,
		3,
		691108
	],
	"./education-center/structured-data/medical/monogenic-non-syndromic-obesity": [
		286512,
		3,
		286512
	],
	"./education-center/structured-data/medical/monogenic-non-syndromic-obesity.json": [
		286512,
		3,
		286512
	],
	"./education-center/structured-data/medical/monomelic-amyotrophy": [
		854905,
		3,
		854905
	],
	"./education-center/structured-data/medical/monomelic-amyotrophy.json": [
		854905,
		3,
		854905
	],
	"./education-center/structured-data/medical/mononeuropathy-median-nerve": [
		849059,
		3,
		849059
	],
	"./education-center/structured-data/medical/mononeuropathy-median-nerve.json": [
		849059,
		3,
		849059
	],
	"./education-center/structured-data/medical/morbid-obesity": [
		567958,
		3,
		567958
	],
	"./education-center/structured-data/medical/morbid-obesity.json": [
		567958,
		3,
		567958
	],
	"./education-center/structured-data/medical/morm-syndrome": [
		304212,
		3,
		304212
	],
	"./education-center/structured-data/medical/morm-syndrome.json": [
		304212,
		3,
		304212
	],
	"./education-center/structured-data/medical/mosaic-variegated-aneuploidy-syndrome": [
		663529,
		3,
		663529
	],
	"./education-center/structured-data/medical/mosaic-variegated-aneuploidy-syndrome.json": [
		663529,
		3,
		663529
	],
	"./education-center/structured-data/medical/motor-axonal-neuropathy": [
		695162,
		3,
		695162
	],
	"./education-center/structured-data/medical/motor-axonal-neuropathy.json": [
		695162,
		3,
		695162
	],
	"./education-center/structured-data/medical/motor-delay": [
		523096,
		3,
		523096
	],
	"./education-center/structured-data/medical/motor-delay.json": [
		523096,
		3,
		523096
	],
	"./education-center/structured-data/medical/motor-tics": [
		99345,
		3,
		99345
	],
	"./education-center/structured-data/medical/motor-tics.json": [
		99345,
		3,
		99345
	],
	"./education-center/structured-data/medical/movement-disorder": [
		672007,
		3,
		672007
	],
	"./education-center/structured-data/medical/movement-disorder.json": [
		672007,
		3,
		672007
	],
	"./education-center/structured-data/medical/mpv17-related-disorders": [
		511042,
		3,
		511042
	],
	"./education-center/structured-data/medical/mpv17-related-disorders.json": [
		511042,
		3,
		511042
	],
	"./education-center/structured-data/medical/mthfr-thermolabile-polymorphism": [
		227902,
		3,
		227902
	],
	"./education-center/structured-data/medical/mthfr-thermolabile-polymorphism.json": [
		227902,
		3,
		227902
	],
	"./education-center/structured-data/medical/mucolipidosis": [
		930561,
		3,
		930561
	],
	"./education-center/structured-data/medical/mucolipidosis-iii-alphabeta-atypical": [
		630967,
		3,
		630967
	],
	"./education-center/structured-data/medical/mucolipidosis-iii-alphabeta-atypical.json": [
		630967,
		3,
		630967
	],
	"./education-center/structured-data/medical/mucolipidosis-type-iii-alphabeta": [
		195773,
		3,
		195773
	],
	"./education-center/structured-data/medical/mucolipidosis-type-iii-alphabeta.json": [
		195773,
		3,
		195773
	],
	"./education-center/structured-data/medical/mucolipidosis.json": [
		930561,
		3,
		930561
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-1": [
		886459,
		3,
		886459
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-1.json": [
		886459,
		3,
		886459
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-ii-mild-form": [
		548314,
		3,
		548314
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-ii-mild-form.json": [
		548314,
		3,
		548314
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-intermediate": [
		553005,
		3,
		553005
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-intermediate.json": [
		553005,
		3,
		553005
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-mild": [
		71994,
		3,
		71994
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-mild.json": [
		71994,
		3,
		71994
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-severe": [
		213017,
		3,
		213017
	],
	"./education-center/structured-data/medical/mucopolysaccharidosis-type-vi-severe.json": [
		213017,
		3,
		213017
	],
	"./education-center/structured-data/medical/mucopolysacchariduria": [
		473722,
		3,
		473722
	],
	"./education-center/structured-data/medical/mucopolysacchariduria.json": [
		473722,
		3,
		473722
	],
	"./education-center/structured-data/medical/mucosa-associated-lymphoma": [
		38723,
		3,
		38723
	],
	"./education-center/structured-data/medical/mucosa-associated-lymphoma.json": [
		38723,
		3,
		38723
	],
	"./education-center/structured-data/medical/muir-torré-syndrome": [
		829809,
		3,
		829809
	],
	"./education-center/structured-data/medical/muir-torré-syndrome.json": [
		829809,
		3,
		829809
	],
	"./education-center/structured-data/medical/mullerian-aplasia-and-hyperandrogenism": [
		728302,
		3,
		728302
	],
	"./education-center/structured-data/medical/mullerian-aplasia-and-hyperandrogenism.json": [
		728302,
		3,
		728302
	],
	"./education-center/structured-data/medical/multi-minicore-disease-and-atypical-periodic-paralysis": [
		739438,
		3,
		739438
	],
	"./education-center/structured-data/medical/multi-minicore-disease-and-atypical-periodic-paralysis.json": [
		739438,
		3,
		739438
	],
	"./education-center/structured-data/medical/multicentric-osteolysis-nodulosis-arthropathy-mona-spectrum-disorders": [
		518249,
		3,
		518249
	],
	"./education-center/structured-data/medical/multicentric-osteolysis-nodulosis-arthropathy-mona-spectrum-disorders.json": [
		518249,
		3,
		518249
	],
	"./education-center/structured-data/medical/multifocal-breast-carcinoma": [
		764797,
		3,
		764797
	],
	"./education-center/structured-data/medical/multifocal-breast-carcinoma.json": [
		764797,
		3,
		764797
	],
	"./education-center/structured-data/medical/multiminicoreminicoremulticore-disease": [
		969707,
		3,
		969707
	],
	"./education-center/structured-data/medical/multiminicoreminicoremulticore-disease.json": [
		969707,
		3,
		969707
	],
	"./education-center/structured-data/medical/multiple-congenital-anomalies": [
		752340,
		3,
		752340
	],
	"./education-center/structured-data/medical/multiple-congenital-anomalies.json": [
		752340,
		3,
		752340
	],
	"./education-center/structured-data/medical/multiple-congenital-exostosis": [
		806663,
		3,
		806663
	],
	"./education-center/structured-data/medical/multiple-congenital-exostosis.json": [
		806663,
		3,
		806663
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-1": [
		361917,
		3,
		361917
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-1.json": [
		361917,
		3,
		361917
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-iia-hirschsprung-disease": [
		158637,
		3,
		158637
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-iia-hirschsprung-disease.json": [
		158637,
		3,
		158637
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-iia-without-pheochromocytoma": [
		408212,
		3,
		408212
	],
	"./education-center/structured-data/medical/multiple-endocrine-neoplasia-type-iia-without-pheochromocytoma.json": [
		408212,
		3,
		408212
	],
	"./education-center/structured-data/medical/multiple-epiphyseal-dysplasia-dominant": [
		766888,
		3,
		766888
	],
	"./education-center/structured-data/medical/multiple-epiphyseal-dysplasia-dominant.json": [
		766888,
		3,
		766888
	],
	"./education-center/structured-data/medical/multiple-epiphyseal-dysplasia-type-1": [
		281567,
		3,
		281567
	],
	"./education-center/structured-data/medical/multiple-epiphyseal-dysplasia-type-1.json": [
		281567,
		3,
		281567
	],
	"./education-center/structured-data/medical/multiple-fibrofolliculomas": [
		240018,
		3,
		240018
	],
	"./education-center/structured-data/medical/multiple-fibrofolliculomas.json": [
		240018,
		3,
		240018
	],
	"./education-center/structured-data/medical/multiple-myeloma-resistance": [
		556201,
		3,
		556201
	],
	"./education-center/structured-data/medical/multiple-myeloma-resistance.json": [
		556201,
		3,
		556201
	],
	"./education-center/structured-data/medical/multiple-myeloma-translocation-1114-type": [
		883308,
		3,
		883308
	],
	"./education-center/structured-data/medical/multiple-myeloma-translocation-1114-type.json": [
		883308,
		3,
		883308
	],
	"./education-center/structured-data/medical/multiple-sclerosis-modifier-disease-progression": [
		484046,
		3,
		484046
	],
	"./education-center/structured-data/medical/multiple-sclerosis-modifier-disease-progression.json": [
		484046,
		3,
		484046
	],
	"./education-center/structured-data/medical/multiple-sclerosis-susceptibility": [
		775000,
		3,
		775000
	],
	"./education-center/structured-data/medical/multiple-sclerosis-susceptibility.json": [
		775000,
		3,
		775000
	],
	"./education-center/structured-data/medical/multiple-self-healing-squamous-epithelioma": [
		631430,
		3,
		631430
	],
	"./education-center/structured-data/medical/multiple-self-healing-squamous-epithelioma.json": [
		631430,
		3,
		631430
	],
	"./education-center/structured-data/medical/multiple-system-atrophy": [
		501630,
		3,
		501630
	],
	"./education-center/structured-data/medical/multiple-system-atrophy.json": [
		501630,
		3,
		501630
	],
	"./education-center/structured-data/medical/multisystem-disorder": [
		950147,
		3,
		950147
	],
	"./education-center/structured-data/medical/multisystem-disorder.json": [
		950147,
		3,
		950147
	],
	"./education-center/structured-data/medical/multisystem-inflammatory-syndrome-children": [
		667846,
		3,
		667846
	],
	"./education-center/structured-data/medical/multisystem-inflammatory-syndrome-children.json": [
		667846,
		3,
		667846
	],
	"./education-center/structured-data/medical/muscle-stiffness-painful": [
		191465,
		3,
		191465
	],
	"./education-center/structured-data/medical/muscle-stiffness-painful.json": [
		191465,
		3,
		191465
	],
	"./education-center/structured-data/medical/muscular-dystrophy-and-arthrogryposis": [
		408230,
		3,
		408230
	],
	"./education-center/structured-data/medical/muscular-dystrophy-and-arthrogryposis.json": [
		408230,
		3,
		408230
	],
	"./education-center/structured-data/medical/muscular-dystrophy-congenital-or-without-seizures": [
		327477,
		3,
		327477
	],
	"./education-center/structured-data/medical/muscular-dystrophy-congenital-or-without-seizures.json": [
		327477,
		3,
		327477
	],
	"./education-center/structured-data/medical/muscular-dystrophy-dystroglycanopathy-congenital-without-impaired-intellectual-development-type-b-5": [
		346333,
		3,
		346333
	],
	"./education-center/structured-data/medical/muscular-dystrophy-dystroglycanopathy-congenital-without-impaired-intellectual-development-type-b-5.json": [
		346333,
		3,
		346333
	],
	"./education-center/structured-data/medical/mutilating-keratoderma": [
		939410,
		3,
		939410
	],
	"./education-center/structured-data/medical/mutilating-keratoderma.json": [
		939410,
		3,
		939410
	],
	"./education-center/structured-data/medical/mvk-related-disorders": [
		195281,
		3,
		195281
	],
	"./education-center/structured-data/medical/mvk-related-disorders.json": [
		195281,
		3,
		195281
	],
	"./education-center/structured-data/medical/myasthenic-syndrome-slow-channel-congenital": [
		352887,
		3,
		352887
	],
	"./education-center/structured-data/medical/myasthenic-syndrome-slow-channel-congenital.json": [
		352887,
		3,
		352887
	],
	"./education-center/structured-data/medical/mybpc3-related-disorders": [
		819346,
		3,
		819346
	],
	"./education-center/structured-data/medical/mybpc3-related-disorders.json": [
		819346,
		3,
		819346
	],
	"./education-center/structured-data/medical/mycobacterium-tuberculosis-protection-against": [
		338102,
		3,
		338102
	],
	"./education-center/structured-data/medical/mycobacterium-tuberculosis-protection-against.json": [
		338102,
		3,
		338102
	],
	"./education-center/structured-data/medical/myelodysplastic-syndrome-progressed-acute-myeloid-leukemia": [
		125355,
		3,
		125355
	],
	"./education-center/structured-data/medical/myelodysplastic-syndrome-progressed-acute-myeloid-leukemia.json": [
		125355,
		3,
		125355
	],
	"./education-center/structured-data/medical/myeloproliferative-disorder": [
		949916,
		3,
		949916
	],
	"./education-center/structured-data/medical/myeloproliferative-disorder-chronic-eosinophilia": [
		852828,
		3,
		852828
	],
	"./education-center/structured-data/medical/myeloproliferative-disorder-chronic-eosinophilia.json": [
		852828,
		3,
		852828
	],
	"./education-center/structured-data/medical/myeloproliferative-disorder.json": [
		949916,
		3,
		949916
	],
	"./education-center/structured-data/medical/myh3-related-disorders": [
		763249,
		3,
		763249
	],
	"./education-center/structured-data/medical/myh3-related-disorders.json": [
		763249,
		3,
		763249
	],
	"./education-center/structured-data/medical/myh7-related-disorders": [
		955627,
		3,
		955627
	],
	"./education-center/structured-data/medical/myh7-related-disorders.json": [
		955627,
		3,
		955627
	],
	"./education-center/structured-data/medical/myh7-related-skeletal-myopathy": [
		344636,
		3,
		344636
	],
	"./education-center/structured-data/medical/myh7-related-skeletal-myopathy.json": [
		344636,
		3,
		344636
	],
	"./education-center/structured-data/medical/myh9-related-disorder": [
		489528,
		3,
		489528
	],
	"./education-center/structured-data/medical/myh9-related-disorder.json": [
		489528,
		3,
		489528
	],
	"./education-center/structured-data/medical/myhre-syndrome": [
		807885,
		3,
		807885
	],
	"./education-center/structured-data/medical/myhre-syndrome.json": [
		807885,
		3,
		807885
	],
	"./education-center/structured-data/medical/myo7a-related-disorders": [
		133795,
		3,
		133795
	],
	"./education-center/structured-data/medical/myo7a-related-disorders.json": [
		133795,
		3,
		133795
	],
	"./education-center/structured-data/medical/myoc-related-disorders": [
		903670,
		3,
		903670
	],
	"./education-center/structured-data/medical/myoc-related-disorders.json": [
		903670,
		3,
		903670
	],
	"./education-center/structured-data/medical/myocardial-infarction-1": [
		71849,
		3,
		71849
	],
	"./education-center/structured-data/medical/myocardial-infarction-1.json": [
		71849,
		3,
		71849
	],
	"./education-center/structured-data/medical/myocardial-infarction-protection-against": [
		322377,
		3,
		322377
	],
	"./education-center/structured-data/medical/myocardial-infarction-protection-against.json": [
		322377,
		3,
		322377
	],
	"./education-center/structured-data/medical/myoclonic-absence-seizure": [
		739347,
		3,
		739347
	],
	"./education-center/structured-data/medical/myoclonic-absence-seizure.json": [
		739347,
		3,
		739347
	],
	"./education-center/structured-data/medical/myoclonic-encephalopathy": [
		16546,
		3,
		16546
	],
	"./education-center/structured-data/medical/myoclonic-encephalopathy.json": [
		16546,
		3,
		16546
	],
	"./education-center/structured-data/medical/myofibrillar-myopathy-dominant": [
		474981,
		3,
		474981
	],
	"./education-center/structured-data/medical/myofibrillar-myopathy-dominant.json": [
		474981,
		3,
		474981
	],
	"./education-center/structured-data/medical/myokymia": [
		605170,
		3,
		605170
	],
	"./education-center/structured-data/medical/myokymia-1-hypomagnesemia": [
		391721,
		3,
		391721
	],
	"./education-center/structured-data/medical/myokymia-1-hypomagnesemia.json": [
		391721,
		3,
		391721
	],
	"./education-center/structured-data/medical/myokymia.json": [
		605170,
		3,
		605170
	],
	"./education-center/structured-data/medical/myopathy-centronuclear-2": [
		183522,
		3,
		183522
	],
	"./education-center/structured-data/medical/myopathy-centronuclear-2.json": [
		183522,
		3,
		183522
	],
	"./education-center/structured-data/medical/myopathy-congenital-due-dihydropyridine-receptor-defect": [
		378682,
		3,
		378682
	],
	"./education-center/structured-data/medical/myopathy-congenital-due-dihydropyridine-receptor-defect.json": [
		378682,
		3,
		378682
	],
	"./education-center/structured-data/medical/myopathy-congenital-neonatal-respiratory-insufficiency": [
		992659,
		3,
		992659
	],
	"./education-center/structured-data/medical/myopathy-congenital-neonatal-respiratory-insufficiency.json": [
		992659,
		3,
		992659
	],
	"./education-center/structured-data/medical/myopathy-congenital-nonprogressive": [
		173354,
		3,
		173354
	],
	"./education-center/structured-data/medical/myopathy-congenital-nonprogressive.json": [
		173354,
		3,
		173354
	],
	"./education-center/structured-data/medical/myopathy-lactic-acidosis-and-sideroblastic-anemia": [
		351534,
		3,
		351534
	],
	"./education-center/structured-data/medical/myopathy-lactic-acidosis-and-sideroblastic-anemia.json": [
		351534,
		3,
		351534
	],
	"./education-center/structured-data/medical/myopathy-mitochondrial-diabetes-mellitus": [
		968250,
		3,
		968250
	],
	"./education-center/structured-data/medical/myopathy-mitochondrial-diabetes-mellitus.json": [
		968250,
		3,
		968250
	],
	"./education-center/structured-data/medical/myopathy-mitochondrial-late-onset": [
		188888,
		3,
		188888
	],
	"./education-center/structured-data/medical/myopathy-mitochondrial-late-onset.json": [
		188888,
		3,
		188888
	],
	"./education-center/structured-data/medical/myopathy-myalgia-increased-serum-creatine-kinase-and-or-without-episodic-rhabdomyolysis": [
		593108,
		3,
		593108
	],
	"./education-center/structured-data/medical/myopathy-myalgia-increased-serum-creatine-kinase-and-or-without-episodic-rhabdomyolysis.json": [
		593108,
		3,
		593108
	],
	"./education-center/structured-data/medical/myopathy-progressive-axial-cataracts": [
		245336,
		3,
		245336
	],
	"./education-center/structured-data/medical/myopathy-progressive-axial-cataracts.json": [
		245336,
		3,
		245336
	],
	"./education-center/structured-data/medical/myopathy-ryr1-associated": [
		788141,
		3,
		788141
	],
	"./education-center/structured-data/medical/myopathy-ryr1-associated.json": [
		788141,
		3,
		788141
	],
	"./education-center/structured-data/medical/myopia": [
		697501,
		3,
		697501
	],
	"./education-center/structured-data/medical/myopia.json": [
		697501,
		3,
		697501
	],
	"./education-center/structured-data/medical/myositis-eosinophilic": [
		673083,
		3,
		673083
	],
	"./education-center/structured-data/medical/myositis-eosinophilic.json": [
		673083,
		3,
		673083
	],
	"./education-center/structured-data/medical/myotonia": [
		808843,
		3,
		808843
	],
	"./education-center/structured-data/medical/myotonia-congenita-atypical-acetazolamide-responsive": [
		255080,
		3,
		255080
	],
	"./education-center/structured-data/medical/myotonia-congenita-atypical-acetazolamide-responsive.json": [
		255080,
		3,
		255080
	],
	"./education-center/structured-data/medical/myotonia-levior": [
		649458,
		3,
		649458
	],
	"./education-center/structured-data/medical/myotonia-levior.json": [
		649458,
		3,
		649458
	],
	"./education-center/structured-data/medical/myotonia.json": [
		808843,
		3,
		808843
	],
	"./education-center/structured-data/medical/nager-syndrome": [
		329310,
		3,
		329310
	],
	"./education-center/structured-data/medical/nager-syndrome.json": [
		329310,
		3,
		329310
	],
	"./education-center/structured-data/medical/nanophthalmia": [
		558567,
		3,
		558567
	],
	"./education-center/structured-data/medical/nanophthalmia.json": [
		558567,
		3,
		558567
	],
	"./education-center/structured-data/medical/nemaline-myopathy-3-autosomal-dominant-or-recessive": [
		747591,
		3,
		747591
	],
	"./education-center/structured-data/medical/nemaline-myopathy-3-autosomal-dominant-or-recessive.json": [
		747591,
		3,
		747591
	],
	"./education-center/structured-data/medical/nemaline-myopathy-7": [
		528740,
		3,
		528740
	],
	"./education-center/structured-data/medical/nemaline-myopathy-7.json": [
		528740,
		3,
		528740
	],
	"./education-center/structured-data/medical/nemaline-myopathy-dominant": [
		457038,
		3,
		457038
	],
	"./education-center/structured-data/medical/nemaline-myopathy-dominant.json": [
		457038,
		3,
		457038
	],
	"./education-center/structured-data/medical/nemaline-myopathy-recessive": [
		683317,
		3,
		683317
	],
	"./education-center/structured-data/medical/nemaline-myopathy-recessive.json": [
		683317,
		3,
		683317
	],
	"./education-center/structured-data/medical/neonatal-death": [
		799633,
		3,
		799633
	],
	"./education-center/structured-data/medical/neonatal-death.json": [
		799633,
		3,
		799633
	],
	"./education-center/structured-data/medical/neonatal-encephalopathy": [
		343629,
		3,
		343629
	],
	"./education-center/structured-data/medical/neonatal-encephalopathy.json": [
		343629,
		3,
		343629
	],
	"./education-center/structured-data/medical/neonatal-epileptic-spasm": [
		59522,
		3,
		59522
	],
	"./education-center/structured-data/medical/neonatal-epileptic-spasm.json": [
		59522,
		3,
		59522
	],
	"./education-center/structured-data/medical/neonatal-hypotonia": [
		372929,
		3,
		372929
	],
	"./education-center/structured-data/medical/neonatal-hypotonia.json": [
		372929,
		3,
		372929
	],
	"./education-center/structured-data/medical/neonatal-insulin-dependent-diabetes-mellitus": [
		222388,
		3,
		222388
	],
	"./education-center/structured-data/medical/neonatal-insulin-dependent-diabetes-mellitus.json": [
		222388,
		3,
		222388
	],
	"./education-center/structured-data/medical/neonatal-lactic-acidosis": [
		488935,
		3,
		488935
	],
	"./education-center/structured-data/medical/neonatal-lactic-acidosis.json": [
		488935,
		3,
		488935
	],
	"./education-center/structured-data/medical/neonatal-respiratory-distress": [
		367531,
		3,
		367531
	],
	"./education-center/structured-data/medical/neonatal-respiratory-distress.json": [
		367531,
		3,
		367531
	],
	"./education-center/structured-data/medical/neoplasm-central-nervous-system": [
		810898,
		3,
		810898
	],
	"./education-center/structured-data/medical/neoplasm-central-nervous-system.json": [
		810898,
		3,
		810898
	],
	"./education-center/structured-data/medical/neoplasm-parathyroid-gland": [
		560060,
		3,
		560060
	],
	"./education-center/structured-data/medical/neoplasm-parathyroid-gland.json": [
		560060,
		3,
		560060
	],
	"./education-center/structured-data/medical/nephritis": [
		762131,
		3,
		762131
	],
	"./education-center/structured-data/medical/nephritis.json": [
		762131,
		3,
		762131
	],
	"./education-center/structured-data/medical/nephroblastoma": [
		494110,
		3,
		494110
	],
	"./education-center/structured-data/medical/nephroblastoma.json": [
		494110,
		3,
		494110
	],
	"./education-center/structured-data/medical/nephrocalcinosis": [
		527181,
		3,
		527181
	],
	"./education-center/structured-data/medical/nephrocalcinosis.json": [
		527181,
		3,
		527181
	],
	"./education-center/structured-data/medical/nephrolithiasisnephrocalcinosis": [
		739533,
		3,
		739533
	],
	"./education-center/structured-data/medical/nephrolithiasisnephrocalcinosis.json": [
		739533,
		3,
		739533
	],
	"./education-center/structured-data/medical/nephrolithiasisosteoporosis-hypophosphatemic": [
		747362,
		3,
		747362
	],
	"./education-center/structured-data/medical/nephrolithiasisosteoporosis-hypophosphatemic.json": [
		747362,
		3,
		747362
	],
	"./education-center/structured-data/medical/nephronophthisis-14": [
		639781,
		3,
		639781
	],
	"./education-center/structured-data/medical/nephronophthisis-14.json": [
		639781,
		3,
		639781
	],
	"./education-center/structured-data/medical/nephronophthisis-8": [
		427362,
		3,
		427362
	],
	"./education-center/structured-data/medical/nephronophthisis-8.json": [
		427362,
		3,
		427362
	],
	"./education-center/structured-data/medical/nephronophthisis-nephropathy": [
		872144,
		3,
		872144
	],
	"./education-center/structured-data/medical/nephronophthisis-nephropathy.json": [
		872144,
		3,
		872144
	],
	"./education-center/structured-data/medical/nephrotic-range-proteinuria": [
		466390,
		3,
		466390
	],
	"./education-center/structured-data/medical/nephrotic-range-proteinuria.json": [
		466390,
		3,
		466390
	],
	"./education-center/structured-data/medical/neuroblastoma": [
		837029,
		3,
		837029
	],
	"./education-center/structured-data/medical/neuroblastoma-susceptibility": [
		374393,
		3,
		374393
	],
	"./education-center/structured-data/medical/neuroblastoma-susceptibility.json": [
		374393,
		3,
		374393
	],
	"./education-center/structured-data/medical/neuroblastoma.json": [
		837029,
		3,
		837029
	],
	"./education-center/structured-data/medical/neurocirculatory-asthenia": [
		171687,
		3,
		171687
	],
	"./education-center/structured-data/medical/neurocirculatory-asthenia.json": [
		171687,
		3,
		171687
	],
	"./education-center/structured-data/medical/neurodegeneration": [
		369177,
		3,
		369177
	],
	"./education-center/structured-data/medical/neurodegeneration-and-seizures-due-copper-transport-defect": [
		897902,
		3,
		897902
	],
	"./education-center/structured-data/medical/neurodegeneration-and-seizures-due-copper-transport-defect.json": [
		897902,
		3,
		897902
	],
	"./education-center/structured-data/medical/neurodegeneration-brain-iron-accumulation-1-atypical": [
		13198,
		3,
		13198
	],
	"./education-center/structured-data/medical/neurodegeneration-brain-iron-accumulation-1-atypical.json": [
		13198,
		3,
		13198
	],
	"./education-center/structured-data/medical/neurodegeneration-developmental-delay-early-respiratory-failure-myoclonic-seizures-and-brain": [
		868831,
		3,
		868831
	],
	"./education-center/structured-data/medical/neurodegeneration-developmental-delay-early-respiratory-failure-myoclonic-seizures-and-brain.json": [
		868831,
		3,
		868831
	],
	"./education-center/structured-data/medical/neurodegeneration-due-3-hydroxyisobutyryl-coenzyme-hydrolase-deficiency": [
		332615,
		3,
		332615
	],
	"./education-center/structured-data/medical/neurodegeneration-due-3-hydroxyisobutyryl-coenzyme-hydrolase-deficiency.json": [
		332615,
		3,
		332615
	],
	"./education-center/structured-data/medical/neurodegeneration.json": [
		369177,
		3,
		369177
	],
	"./education-center/structured-data/medical/neurodegenerative-illness-progressing-crippling-dystonia-and-death-relentless-cerebral-atrophy": [
		134840,
		3,
		134840
	],
	"./education-center/structured-data/medical/neurodegenerative-illness-progressing-crippling-dystonia-and-death-relentless-cerebral-atrophy.json": [
		134840,
		3,
		134840
	],
	"./education-center/structured-data/medical/neurodevelopmental-abnormality": [
		188545,
		3,
		188545
	],
	"./education-center/structured-data/medical/neurodevelopmental-abnormality.json": [
		188545,
		3,
		188545
	],
	"./education-center/structured-data/medical/neurodevelopmental-delay": [
		869343,
		3,
		869343
	],
	"./education-center/structured-data/medical/neurodevelopmental-delay.json": [
		869343,
		3,
		869343
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-epilepsy-and-hemochromatosis": [
		27017,
		3,
		27017
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-epilepsy-and-hemochromatosis.json": [
		27017,
		3,
		27017
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-microcephaly-and-speech-delay-or-without-brain-abnormalities": [
		875009,
		3,
		875009
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-microcephaly-and-speech-delay-or-without-brain-abnormalities.json": [
		875009,
		3,
		875009
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-mtor-related": [
		693945,
		3,
		693945
	],
	"./education-center/structured-data/medical/neurodevelopmental-disorder-mtor-related.json": [
		693945,
		3,
		693945
	],
	"./education-center/structured-data/medical/neuroendocrine-tumor-pancreas": [
		585211,
		3,
		585211
	],
	"./education-center/structured-data/medical/neuroendocrine-tumor-pancreas.json": [
		585211,
		3,
		585211
	],
	"./education-center/structured-data/medical/neurofibromatosis-type-2": [
		624831,
		3,
		624831
	],
	"./education-center/structured-data/medical/neurofibromatosis-type-2.json": [
		624831,
		3,
		624831
	],
	"./education-center/structured-data/medical/neurogastrointestinal-syndrome-mitochondrial": [
		910039,
		3,
		910039
	],
	"./education-center/structured-data/medical/neurogastrointestinal-syndrome-mitochondrial.json": [
		910039,
		3,
		910039
	],
	"./education-center/structured-data/medical/neurohypophyseal-diabetes-insipidus": [
		377270,
		3,
		377270
	],
	"./education-center/structured-data/medical/neurohypophyseal-diabetes-insipidus.json": [
		377270,
		3,
		377270
	],
	"./education-center/structured-data/medical/neuromuscular-disease-congenital-uniform-type-1-fiber": [
		389659,
		3,
		389659
	],
	"./education-center/structured-data/medical/neuromuscular-disease-congenital-uniform-type-1-fiber.json": [
		389659,
		3,
		389659
	],
	"./education-center/structured-data/medical/neuronal-ceroid-lipofuscinosis-dominantrecessive": [
		12078,
		3,
		12078
	],
	"./education-center/structured-data/medical/neuronal-ceroid-lipofuscinosis-dominantrecessive.json": [
		12078,
		3,
		12078
	],
	"./education-center/structured-data/medical/neuronal-ceroid-lipofuscinosis-recessive": [
		829105,
		3,
		829105
	],
	"./education-center/structured-data/medical/neuronal-ceroid-lipofuscinosis-recessive.json": [
		829105,
		3,
		829105
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor": [
		784406,
		3,
		784406
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor-type-2a": [
		233665,
		3,
		233665
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor-type-2a.json": [
		233665,
		3,
		233665
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor-type-7a": [
		44642,
		3,
		44642
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor-type-7a.json": [
		44642,
		3,
		44642
	],
	"./education-center/structured-data/medical/neuronopathy-distal-hereditary-motor.json": [
		784406,
		3,
		784406
	],
	"./education-center/structured-data/medical/neurooculorenal-syndrome": [
		278895,
		3,
		278895
	],
	"./education-center/structured-data/medical/neurooculorenal-syndrome.json": [
		278895,
		3,
		278895
	],
	"./education-center/structured-data/medical/neuropathy-axonal-vocal-cord-paresis-autosomal-recessive": [
		47462,
		3,
		47462
	],
	"./education-center/structured-data/medical/neuropathy-axonal-vocal-cord-paresis-autosomal-recessive.json": [
		47462,
		3,
		47462
	],
	"./education-center/structured-data/medical/neuropathy-hereditary-sensory-and-autonomic-type-ia-severe": [
		879153,
		3,
		879153
	],
	"./education-center/structured-data/medical/neuropathy-hereditary-sensory-and-autonomic-type-ia-severe.json": [
		879153,
		3,
		879153
	],
	"./education-center/structured-data/medical/neuropathy-hereditary-sensory-and-autonomic-type-ic-severe": [
		539087,
		3,
		539087
	],
	"./education-center/structured-data/medical/neuropathy-hereditary-sensory-and-autonomic-type-ic-severe.json": [
		539087,
		3,
		539087
	],
	"./education-center/structured-data/medical/neuropsychiatric-disorder-and-early-onset-cataract": [
		279641,
		3,
		279641
	],
	"./education-center/structured-data/medical/neuropsychiatric-disorder-and-early-onset-cataract.json": [
		279641,
		3,
		279641
	],
	"./education-center/structured-data/medical/neutropenia": [
		77324,
		3,
		77324
	],
	"./education-center/structured-data/medical/neutropenia.json": [
		77324,
		3,
		77324
	],
	"./education-center/structured-data/medical/neutrophil-inclusion-bodies": [
		328870,
		3,
		328870
	],
	"./education-center/structured-data/medical/neutrophil-inclusion-bodies.json": [
		328870,
		3,
		328870
	],
	"./education-center/structured-data/medical/nevus-sebaceous": [
		101842,
		3,
		101842
	],
	"./education-center/structured-data/medical/nevus-sebaceous.json": [
		101842,
		3,
		101842
	],
	"./education-center/structured-data/medical/newfoundland-cone-rod-dystrophy": [
		324714,
		3,
		324714
	],
	"./education-center/structured-data/medical/newfoundland-cone-rod-dystrophy.json": [
		324714,
		3,
		324714
	],
	"./education-center/structured-data/medical/nicotine-addiction-protection-against": [
		753256,
		3,
		753256
	],
	"./education-center/structured-data/medical/nicotine-addiction-protection-against.json": [
		753256,
		3,
		753256
	],
	"./education-center/structured-data/medical/nicotine-dependence-protection-against": [
		772099,
		3,
		772099
	],
	"./education-center/structured-data/medical/nicotine-dependence-protection-against.json": [
		772099,
		3,
		772099
	],
	"./education-center/structured-data/medical/nicotine-poor-metabolism": [
		150580,
		3,
		150580
	],
	"./education-center/structured-data/medical/nicotine-poor-metabolism.json": [
		150580,
		3,
		150580
	],
	"./education-center/structured-data/medical/niemann-pick-disease-intermediate-protracted-neurovisceral": [
		278733,
		3,
		278733
	],
	"./education-center/structured-data/medical/niemann-pick-disease-intermediate-protracted-neurovisceral.json": [
		278733,
		3,
		278733
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-c1-adult-form": [
		591714,
		3,
		591714
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-c1-adult-form.json": [
		591714,
		3,
		591714
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-c1-juvenile-form": [
		777854,
		3,
		777854
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-c1-juvenile-form.json": [
		777854,
		3,
		777854
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-d": [
		801746,
		3,
		801746
	],
	"./education-center/structured-data/medical/niemann-pick-disease-type-d.json": [
		801746,
		3,
		801746
	],
	"./education-center/structured-data/medical/nik-deficiency": [
		457596,
		3,
		457596
	],
	"./education-center/structured-data/medical/nik-deficiency.json": [
		457596,
		3,
		457596
	],
	"./education-center/structured-data/medical/nodal-related-disorders": [
		537340,
		3,
		537340
	],
	"./education-center/structured-data/medical/nodal-related-disorders.json": [
		537340,
		3,
		537340
	],
	"./education-center/structured-data/medical/non-obstructive-azoospermia": [
		166420,
		3,
		166420
	],
	"./education-center/structured-data/medical/non-obstructive-azoospermia.json": [
		166420,
		3,
		166420
	],
	"./education-center/structured-data/medical/non-syndromic-intellectual-disability": [
		326845,
		3,
		326845
	],
	"./education-center/structured-data/medical/non-syndromic-intellectual-disability.json": [
		326845,
		3,
		326845
	],
	"./education-center/structured-data/medical/non-syndromic-oligodontia": [
		813487,
		3,
		813487
	],
	"./education-center/structured-data/medical/non-syndromic-oligodontia.json": [
		813487,
		3,
		813487
	],
	"./education-center/structured-data/medical/noncompaction-cardiomyopathy": [
		11395,
		3,
		11395
	],
	"./education-center/structured-data/medical/noncompaction-cardiomyopathy.json": [
		11395,
		3,
		11395
	],
	"./education-center/structured-data/medical/nonpapillary-renal-cell-carcinoma": [
		155954,
		3,
		181613
	],
	"./education-center/structured-data/medical/nonpapillary-renal-cell-carcinoma.json": [
		155954,
		3,
		181613
	],
	"./education-center/structured-data/medical/nonpersistence-intestinal-lactase": [
		799302,
		3,
		799302
	],
	"./education-center/structured-data/medical/nonpersistence-intestinal-lactase.json": [
		799302,
		3,
		799302
	],
	"./education-center/structured-data/medical/nonsmall-cell-lung-cancer-resistance-tyrosine-kinase-inhibitor": [
		919753,
		3,
		919753
	],
	"./education-center/structured-data/medical/nonsmall-cell-lung-cancer-resistance-tyrosine-kinase-inhibitor.json": [
		919753,
		3,
		919753
	],
	"./education-center/structured-data/medical/nonsmall-cell-lung-cancer-response-tyrosine-kinase-inhibitor-somatic": [
		891438,
		3,
		891438
	],
	"./education-center/structured-data/medical/nonsmall-cell-lung-cancer-response-tyrosine-kinase-inhibitor-somatic.json": [
		891438,
		3,
		891438
	],
	"./education-center/structured-data/medical/nonsyndromic-cleft-lip-or-without-cleft-palate": [
		476575,
		3,
		476575
	],
	"./education-center/structured-data/medical/nonsyndromic-cleft-lip-or-without-cleft-palate.json": [
		476575,
		3,
		476575
	],
	"./education-center/structured-data/medical/nonsyndromic-congenital-nail-disorder-3": [
		977301,
		3,
		977301
	],
	"./education-center/structured-data/medical/nonsyndromic-congenital-nail-disorder-3.json": [
		977301,
		3,
		977301
	],
	"./education-center/structured-data/medical/nonsyndromic-deafness": [
		130897,
		3,
		130897
	],
	"./education-center/structured-data/medical/nonsyndromic-deafness.json": [
		130897,
		3,
		130897
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-and-deafness-autosomal-recessive": [
		952282,
		3,
		952282
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-and-deafness-autosomal-recessive.json": [
		952282,
		3,
		952282
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-dominant": [
		803680,
		3,
		803680
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-dominant.json": [
		803680,
		3,
		803680
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-mixed": [
		330276,
		3,
		330276
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-mixed.json": [
		330276,
		3,
		330276
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-recessive": [
		337340,
		3,
		337340
	],
	"./education-center/structured-data/medical/nonsyndromic-hearing-loss-recessive.json": [
		337340,
		3,
		337340
	],
	"./education-center/structured-data/medical/nonsyndromic-hypergonadotropic-hypogonadism": [
		316254,
		3,
		316254
	],
	"./education-center/structured-data/medical/nonsyndromic-hypergonadotropic-hypogonadism.json": [
		316254,
		3,
		316254
	],
	"./education-center/structured-data/medical/nonsyndromic-oculocutaneous-albinism": [
		271643,
		3,
		271643
	],
	"./education-center/structured-data/medical/nonsyndromic-oculocutaneous-albinism.json": [
		271643,
		3,
		271643
	],
	"./education-center/structured-data/medical/nonsyndromic-otitis-media": [
		237304,
		3,
		237304
	],
	"./education-center/structured-data/medical/nonsyndromic-otitis-media.json": [
		237304,
		3,
		237304
	],
	"./education-center/structured-data/medical/nonsyndromic-sensorineural-hearing-loss": [
		626867,
		3,
		626867
	],
	"./education-center/structured-data/medical/nonsyndromic-sensorineural-hearing-loss.json": [
		626867,
		3,
		626867
	],
	"./education-center/structured-data/medical/noonan-syndrome": [
		861595,
		3,
		861595
	],
	"./education-center/structured-data/medical/noonan-syndrome-disorder-juvenile-myelomonocytic-leukemia": [
		587119,
		3,
		587119
	],
	"./education-center/structured-data/medical/noonan-syndrome-disorder-juvenile-myelomonocytic-leukemia.json": [
		587119,
		3,
		587119
	],
	"./education-center/structured-data/medical/noonan-syndrome-multiple-lentigines": [
		348217,
		3,
		348217
	],
	"./education-center/structured-data/medical/noonan-syndrome-multiple-lentigines.json": [
		348217,
		3,
		348217
	],
	"./education-center/structured-data/medical/noonan-syndrome.json": [
		861595,
		3,
		861595
	],
	"./education-center/structured-data/medical/nor-polyagglutination-syndrome": [
		675401,
		3,
		675401
	],
	"./education-center/structured-data/medical/nor-polyagglutination-syndrome.json": [
		675401,
		3,
		675401
	],
	"./education-center/structured-data/medical/normal-pregnancy": [
		844564,
		3,
		844564
	],
	"./education-center/structured-data/medical/normal-pregnancy.json": [
		844564,
		3,
		844564
	],
	"./education-center/structured-data/medical/normokalemic-periodic-paralysis-potassium-sensitive": [
		66285,
		3,
		66285
	],
	"./education-center/structured-data/medical/normokalemic-periodic-paralysis-potassium-sensitive.json": [
		66285,
		3,
		66285
	],
	"./education-center/structured-data/medical/north-carolina-macular-dystrophy": [
		621778,
		3,
		621778
	],
	"./education-center/structured-data/medical/north-carolina-macular-dystrophy.json": [
		621778,
		3,
		621778
	],
	"./education-center/structured-data/medical/nphp4-related-disorders": [
		335066,
		3,
		335066
	],
	"./education-center/structured-data/medical/nphp4-related-disorders.json": [
		335066,
		3,
		335066
	],
	"./education-center/structured-data/medical/nr2e3-related-disorders": [
		459253,
		3,
		459253
	],
	"./education-center/structured-data/medical/nr2e3-related-disorders.json": [
		459253,
		3,
		459253
	],
	"./education-center/structured-data/medical/nuclear-pulverulent-cataract": [
		712042,
		3,
		712042
	],
	"./education-center/structured-data/medical/nuclear-pulverulent-cataract.json": [
		712042,
		3,
		712042
	],
	"./education-center/structured-data/medical/obesity-age-onset": [
		462400,
		3,
		462400
	],
	"./education-center/structured-data/medical/obesity-age-onset.json": [
		462400,
		3,
		462400
	],
	"./education-center/structured-data/medical/obesity-association": [
		990392,
		3,
		990392
	],
	"./education-center/structured-data/medical/obesity-association.json": [
		990392,
		3,
		990392
	],
	"./education-center/structured-data/medical/obesity-autosomal-dominant": [
		7402,
		3,
		7402
	],
	"./education-center/structured-data/medical/obesity-autosomal-dominant.json": [
		7402,
		3,
		7402
	],
	"./education-center/structured-data/medical/obesity-bmiq12-susceptibility": [
		661754,
		3,
		661754
	],
	"./education-center/structured-data/medical/obesity-bmiq12-susceptibility.json": [
		661754,
		3,
		661754
	],
	"./education-center/structured-data/medical/obesity-early-onset-susceptibility": [
		339331,
		3,
		339331
	],
	"./education-center/structured-data/medical/obesity-early-onset-susceptibility.json": [
		339331,
		3,
		339331
	],
	"./education-center/structured-data/medical/obesity-mild-early-onset": [
		698439,
		3,
		698439
	],
	"./education-center/structured-data/medical/obesity-mild-early-onset.json": [
		698439,
		3,
		698439
	],
	"./education-center/structured-data/medical/obesity-resistance": [
		833224,
		3,
		833224
	],
	"./education-center/structured-data/medical/obesity-resistance.json": [
		833224,
		3,
		833224
	],
	"./education-center/structured-data/medical/obesity-severe-and-type-ii-diabetes": [
		81640,
		3,
		81640
	],
	"./education-center/structured-data/medical/obesity-severe-and-type-ii-diabetes.json": [
		81640,
		3,
		81640
	],
	"./education-center/structured-data/medical/obstructive-azoospermia": [
		543243,
		3,
		543243
	],
	"./education-center/structured-data/medical/obstructive-azoospermia.json": [
		543243,
		3,
		543243
	],
	"./education-center/structured-data/medical/ochoa-syndrome": [
		955926,
		3,
		955926
	],
	"./education-center/structured-data/medical/ochoa-syndrome.json": [
		955926,
		3,
		955926
	],
	"./education-center/structured-data/medical/ocular-albinism-congenital-sensorineural-hearing-loss": [
		50187,
		3,
		50187
	],
	"./education-center/structured-data/medical/ocular-albinism-congenital-sensorineural-hearing-loss.json": [
		50187,
		3,
		50187
	],
	"./education-center/structured-data/medical/oculocutaneous-albinism-type-ii-modifier": [
		580618,
		3,
		580618
	],
	"./education-center/structured-data/medical/oculocutaneous-albinism-type-ii-modifier.json": [
		580618,
		3,
		580618
	],
	"./education-center/structured-data/medical/oculomotor-apraxia": [
		146896,
		3,
		146896
	],
	"./education-center/structured-data/medical/oculomotor-apraxia.json": [
		146896,
		3,
		146896
	],
	"./education-center/structured-data/medical/oculootoradial-syndrome": [
		241557,
		3,
		241557
	],
	"./education-center/structured-data/medical/oculootoradial-syndrome.json": [
		241557,
		3,
		241557
	],
	"./education-center/structured-data/medical/oculoskeletodental-syndrome": [
		770403,
		3,
		770403
	],
	"./education-center/structured-data/medical/oculoskeletodental-syndrome.json": [
		770403,
		3,
		770403
	],
	"./education-center/structured-data/medical/oligodontia": [
		867785,
		3,
		867785
	],
	"./education-center/structured-data/medical/oligodontia.json": [
		867785,
		3,
		867785
	],
	"./education-center/structured-data/medical/olivopontocerebellar-hypoplasia": [
		21961,
		3,
		21961
	],
	"./education-center/structured-data/medical/olivopontocerebellar-hypoplasia.json": [
		21961,
		3,
		21961
	],
	"./education-center/structured-data/medical/oocytezygoteembryo-maturation-arrest-17": [
		900591,
		3,
		900591
	],
	"./education-center/structured-data/medical/oocytezygoteembryo-maturation-arrest-17.json": [
		900591,
		3,
		900591
	],
	"./education-center/structured-data/medical/oocytezygoteembryo-maturation-arrest-19": [
		94180,
		3,
		94180
	],
	"./education-center/structured-data/medical/oocytezygoteembryo-maturation-arrest-19.json": [
		94180,
		3,
		94180
	],
	"./education-center/structured-data/medical/ophthalmoplegia-isolated": [
		89681,
		3,
		89681
	],
	"./education-center/structured-data/medical/ophthalmoplegia-isolated.json": [
		89681,
		3,
		89681
	],
	"./education-center/structured-data/medical/optic-atrophy-dominant": [
		136472,
		3,
		136472
	],
	"./education-center/structured-data/medical/optic-atrophy-dominant.json": [
		136472,
		3,
		136472
	],
	"./education-center/structured-data/medical/optic-atrophy-or-without-deafness-ophthalmoplegia-myopathy-ataxia-and-neuropathy": [
		560995,
		3,
		560995
	],
	"./education-center/structured-data/medical/optic-atrophy-or-without-deafness-ophthalmoplegia-myopathy-ataxia-and-neuropathy.json": [
		560995,
		3,
		560995
	],
	"./education-center/structured-data/medical/optic-atrophy-recessive": [
		241014,
		3,
		241014
	],
	"./education-center/structured-data/medical/optic-atrophy-recessive.json": [
		241014,
		3,
		241014
	],
	"./education-center/structured-data/medical/optic-nerve-aplasia-bilateral": [
		952562,
		3,
		952562
	],
	"./education-center/structured-data/medical/optic-nerve-aplasia-bilateral.json": [
		952562,
		3,
		952562
	],
	"./education-center/structured-data/medical/optic-nerve-dysplasia": [
		36246,
		3,
		36246
	],
	"./education-center/structured-data/medical/optic-nerve-dysplasia.json": [
		36246,
		3,
		36246
	],
	"./education-center/structured-data/medical/optic-nerve-hypoplasia": [
		827138,
		3,
		827138
	],
	"./education-center/structured-data/medical/optic-nerve-hypoplasia-and-abnormalities-central-nervous-system": [
		824743,
		3,
		824743
	],
	"./education-center/structured-data/medical/optic-nerve-hypoplasia-and-abnormalities-central-nervous-system.json": [
		824743,
		3,
		824743
	],
	"./education-center/structured-data/medical/optic-nerve-hypoplasia.json": [
		827138,
		3,
		827138
	],
	"./education-center/structured-data/medical/ornithine-decarboxylase-1-polymorphism": [
		773093,
		3,
		773093
	],
	"./education-center/structured-data/medical/ornithine-decarboxylase-1-polymorphism.json": [
		773093,
		3,
		773093
	],
	"./education-center/structured-data/medical/orofacial-cleft": [
		151662,
		3,
		151662
	],
	"./education-center/structured-data/medical/orofacial-cleft-7": [
		446669,
		3,
		446669
	],
	"./education-center/structured-data/medical/orofacial-cleft-7.json": [
		446669,
		3,
		446669
	],
	"./education-center/structured-data/medical/orofacial-cleft.json": [
		151662,
		3,
		151662
	],
	"./education-center/structured-data/medical/oromandibular-limb-hypogenesis-spectrum": [
		12598,
		3,
		12598
	],
	"./education-center/structured-data/medical/oromandibular-limb-hypogenesis-spectrum.json": [
		12598,
		3,
		12598
	],
	"./education-center/structured-data/medical/orthostatic-hypotension": [
		112037,
		3,
		112037
	],
	"./education-center/structured-data/medical/orthostatic-hypotension.json": [
		112037,
		3,
		112037
	],
	"./education-center/structured-data/medical/ossifying-fibroma-jaw": [
		814674,
		3,
		814674
	],
	"./education-center/structured-data/medical/ossifying-fibroma-jaw.json": [
		814674,
		3,
		814674
	],
	"./education-center/structured-data/medical/osteoarthritis-hip": [
		2301,
		3,
		2301
	],
	"./education-center/structured-data/medical/osteoarthritis-hip.json": [
		2301,
		3,
		2301
	],
	"./education-center/structured-data/medical/osteoarthritis-susceptibility-2": [
		964246,
		3,
		964246
	],
	"./education-center/structured-data/medical/osteoarthritis-susceptibility-2.json": [
		964246,
		3,
		964246
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-dominant": [
		540180,
		3,
		540180
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-dominant.json": [
		540180,
		3,
		540180
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-mild": [
		634446,
		3,
		634446
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-mild.json": [
		634446,
		3,
		634446
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-recessive": [
		705222,
		3,
		705222
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-recessive.json": [
		705222,
		3,
		705222
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-1-mild": [
		126791,
		3,
		126791
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-1-mild.json": [
		126791,
		3,
		126791
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-2-thin-bone": [
		387938,
		3,
		387938
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-2-thin-bone.json": [
		387938,
		3,
		387938
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-iic": [
		448902,
		3,
		448902
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-iic.json": [
		448902,
		3,
		448902
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-iiiiv": [
		145761,
		3,
		145761
	],
	"./education-center/structured-data/medical/osteogenesis-imperfecta-type-iiiiv.json": [
		145761,
		3,
		145761
	],
	"./education-center/structured-data/medical/osteopoikilosis": [
		605126,
		3,
		605126
	],
	"./education-center/structured-data/medical/osteopoikilosis.json": [
		605126,
		3,
		605126
	],
	"./education-center/structured-data/medical/osteoporosis-early-onset-susceptibility": [
		414070,
		3,
		414070
	],
	"./education-center/structured-data/medical/osteoporosis-early-onset-susceptibility.json": [
		414070,
		3,
		414070
	],
	"./education-center/structured-data/medical/otitis-media": [
		187564,
		3,
		187564
	],
	"./education-center/structured-data/medical/otitis-media.json": [
		187564,
		3,
		187564
	],
	"./education-center/structured-data/medical/otx2-related-syndromic-microphthalmia": [
		895844,
		3,
		895844
	],
	"./education-center/structured-data/medical/otx2-related-syndromic-microphthalmia.json": [
		895844,
		3,
		895844
	],
	"./education-center/structured-data/medical/ovarian-cancer-epithelial-somatic": [
		940773,
		3,
		940773
	],
	"./education-center/structured-data/medical/ovarian-cancer-epithelial-somatic.json": [
		940773,
		3,
		940773
	],
	"./education-center/structured-data/medical/ovarian-carcinoma": [
		58235,
		3,
		58235
	],
	"./education-center/structured-data/medical/ovarian-carcinoma.json": [
		58235,
		3,
		58235
	],
	"./education-center/structured-data/medical/ovarian-dysgenesis": [
		297475,
		3,
		297475
	],
	"./education-center/structured-data/medical/ovarian-dysgenesis.json": [
		297475,
		3,
		297475
	],
	"./education-center/structured-data/medical/ovarian-papillary-adenocarcinoma": [
		963761,
		3,
		963761
	],
	"./education-center/structured-data/medical/ovarian-papillary-adenocarcinoma.json": [
		963761,
		3,
		963761
	],
	"./education-center/structured-data/medical/ovarian-response-fsh-stimulation": [
		215094,
		3,
		215094
	],
	"./education-center/structured-data/medical/ovarian-response-fsh-stimulation.json": [
		215094,
		3,
		215094
	],
	"./education-center/structured-data/medical/ovarian-serous-cystadenocarcinoma": [
		433934,
		3,
		433934
	],
	"./education-center/structured-data/medical/ovarian-serous-cystadenocarcinoma.json": [
		433934,
		3,
		433934
	],
	"./education-center/structured-data/medical/p-phenotype": [
		639428,
		3,
		639428
	],
	"./education-center/structured-data/medical/p-phenotype.json": [
		639428,
		3,
		639428
	],
	"./education-center/structured-data/medical/pain-insensitivity": [
		666946,
		3,
		666946
	],
	"./education-center/structured-data/medical/pain-insensitivity.json": [
		666946,
		3,
		666946
	],
	"./education-center/structured-data/medical/palb2-related-disorders": [
		801678,
		3,
		801678
	],
	"./education-center/structured-data/medical/palb2-related-disorders.json": [
		801678,
		3,
		801678
	],
	"./education-center/structured-data/medical/pallister-hall-syndrome": [
		565250,
		3,
		565250
	],
	"./education-center/structured-data/medical/pallister-hall-syndrome.json": [
		565250,
		3,
		565250
	],
	"./education-center/structured-data/medical/palmoplantar-hyperkeratosis-and-true-hermaphroditism": [
		884291,
		3,
		884291
	],
	"./education-center/structured-data/medical/palmoplantar-hyperkeratosis-and-true-hermaphroditism.json": [
		884291,
		3,
		884291
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma": [
		233363,
		3,
		233363
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-deafness-syndrome": [
		845897,
		3,
		845897
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-deafness-syndrome.json": [
		845897,
		3,
		845897
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-epidermolytic-knuckle-pads": [
		921419,
		3,
		921419
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-epidermolytic-knuckle-pads.json": [
		921419,
		3,
		921419
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-esophageal-carcinoma-syndrome": [
		244605,
		3,
		244605
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-esophageal-carcinoma-syndrome.json": [
		244605,
		3,
		244605
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-i-striate-focal-or-diffuse": [
		506003,
		3,
		506003
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-i-striate-focal-or-diffuse.json": [
		506003,
		3,
		506003
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-punctate-type-1a": [
		106133,
		3,
		106133
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma-punctate-type-1a.json": [
		106133,
		3,
		106133
	],
	"./education-center/structured-data/medical/palmoplantar-keratoderma.json": [
		233363,
		3,
		233363
	],
	"./education-center/structured-data/medical/pancreatic-adenocarcinoma": [
		752431,
		3,
		752431
	],
	"./education-center/structured-data/medical/pancreatic-adenocarcinoma.json": [
		752431,
		3,
		752431
	],
	"./education-center/structured-data/medical/pancreatic-hypoplasia": [
		75882,
		3,
		75882
	],
	"./education-center/structured-data/medical/pancreatic-hypoplasia.json": [
		75882,
		3,
		75882
	],
	"./education-center/structured-data/medical/pancreatitis-chronic-protection-against": [
		866840,
		3,
		866840
	],
	"./education-center/structured-data/medical/pancreatitis-chronic-protection-against.json": [
		866840,
		3,
		866840
	],
	"./education-center/structured-data/medical/pancreatitis-chronic-susceptibility": [
		908318,
		3,
		908318
	],
	"./education-center/structured-data/medical/pancreatitis-chronic-susceptibility.json": [
		908318,
		3,
		908318
	],
	"./education-center/structured-data/medical/pancytopenia": [
		214019,
		3,
		214019
	],
	"./education-center/structured-data/medical/pancytopenia.json": [
		214019,
		3,
		214019
	],
	"./education-center/structured-data/medical/papillary-renal-cell-carcinoma-sporadic": [
		994051,
		3,
		994051
	],
	"./education-center/structured-data/medical/papillary-renal-cell-carcinoma-sporadic.json": [
		994051,
		3,
		994051
	],
	"./education-center/structured-data/medical/papillary-renal-cell-carcinoma-type-1": [
		994896,
		3,
		994896
	],
	"./education-center/structured-data/medical/papillary-renal-cell-carcinoma-type-1.json": [
		994896,
		3,
		994896
	],
	"./education-center/structured-data/medical/papillary-thyroid-carcinoma": [
		433843,
		3,
		433843
	],
	"./education-center/structured-data/medical/papillary-thyroid-carcinoma.json": [
		433843,
		3,
		433843
	],
	"./education-center/structured-data/medical/papillorenal-syndrome-macular-abnormalities": [
		836728,
		3,
		836728
	],
	"./education-center/structured-data/medical/papillorenal-syndrome-macular-abnormalities.json": [
		836728,
		3,
		836728
	],
	"./education-center/structured-data/medical/para-bombay-phenotype": [
		340722,
		3,
		340722
	],
	"./education-center/structured-data/medical/para-bombay-phenotype.json": [
		340722,
		3,
		340722
	],
	"./education-center/structured-data/medical/paraganglioma": [
		263414,
		3,
		263414
	],
	"./education-center/structured-data/medical/paraganglioma.json": [
		263414,
		3,
		263414
	],
	"./education-center/structured-data/medical/paragangliomas-1-sensorineural-hearing-loss": [
		114832,
		3,
		114832
	],
	"./education-center/structured-data/medical/paragangliomas-1-sensorineural-hearing-loss.json": [
		114832,
		3,
		114832
	],
	"./education-center/structured-data/medical/paragangliomas-4": [
		491317,
		3,
		491317
	],
	"./education-center/structured-data/medical/paragangliomas-4.json": [
		491317,
		3,
		491317
	],
	"./education-center/structured-data/medical/paramyotonia-congenitahyperkalemic-periodic-paralysis": [
		986872,
		3,
		986872
	],
	"./education-center/structured-data/medical/paramyotonia-congenitahyperkalemic-periodic-paralysis.json": [
		986872,
		3,
		986872
	],
	"./education-center/structured-data/medical/paramyotonia-congenitamyotonia-congenita": [
		884421,
		3,
		884421
	],
	"./education-center/structured-data/medical/paramyotonia-congenitamyotonia-congenita.json": [
		884421,
		3,
		884421
	],
	"./education-center/structured-data/medical/parathyroid-adenoma-somatic": [
		13987,
		3,
		13987
	],
	"./education-center/structured-data/medical/parathyroid-adenoma-somatic.json": [
		13987,
		3,
		13987
	],
	"./education-center/structured-data/medical/parathyroid-gland-adenoma": [
		629876,
		3,
		629876
	],
	"./education-center/structured-data/medical/parathyroid-gland-adenoma.json": [
		629876,
		3,
		629876
	],
	"./education-center/structured-data/medical/parkes-weber-syndrome": [
		642802,
		3,
		642802
	],
	"./education-center/structured-data/medical/parkes-weber-syndrome.json": [
		642802,
		3,
		642802
	],
	"./education-center/structured-data/medical/parkinson-disease-6": [
		712949,
		3,
		712949
	],
	"./education-center/structured-data/medical/parkinson-disease-6.json": [
		712949,
		3,
		712949
	],
	"./education-center/structured-data/medical/parkinson-disease-autosomal-recessive-early-onset-digenic-pink1dj1": [
		842989,
		3,
		842989
	],
	"./education-center/structured-data/medical/parkinson-disease-autosomal-recessive-early-onset-digenic-pink1dj1.json": [
		842989,
		3,
		842989
	],
	"./education-center/structured-data/medical/parkinson-disease-dominant": [
		141894,
		3,
		141894
	],
	"./education-center/structured-data/medical/parkinson-disease-dominant.json": [
		141894,
		3,
		141894
	],
	"./education-center/structured-data/medical/parkinson-disease-dominantrecessive": [
		761956,
		3,
		761956
	],
	"./education-center/structured-data/medical/parkinson-disease-dominantrecessive.json": [
		761956,
		3,
		761956
	],
	"./education-center/structured-data/medical/parkinson-disease-juvenile": [
		513855,
		3,
		513855
	],
	"./education-center/structured-data/medical/parkinson-disease-juvenile.json": [
		513855,
		3,
		513855
	],
	"./education-center/structured-data/medical/parkinson-disease-recessive": [
		825578,
		3,
		825578
	],
	"./education-center/structured-data/medical/parkinson-disease-recessive.json": [
		825578,
		3,
		825578
	],
	"./education-center/structured-data/medical/parkinson-disease-x-linked-dominant": [
		461638,
		3,
		461638
	],
	"./education-center/structured-data/medical/parkinson-disease-x-linked-dominant.json": [
		461638,
		3,
		461638
	],
	"./education-center/structured-data/medical/parkinsonism": [
		341931,
		3,
		341931
	],
	"./education-center/structured-data/medical/parkinsonism-plus": [
		815293,
		3,
		815293
	],
	"./education-center/structured-data/medical/parkinsonism-plus.json": [
		815293,
		3,
		815293
	],
	"./education-center/structured-data/medical/parkinsonism.json": [
		341931,
		3,
		341931
	],
	"./education-center/structured-data/medical/paroxysmal-atrial-fibrillation": [
		617703,
		3,
		617703
	],
	"./education-center/structured-data/medical/paroxysmal-atrial-fibrillation.json": [
		617703,
		3,
		617703
	],
	"./education-center/structured-data/medical/partial-adenosine-deaminase-deficiency": [
		353483,
		3,
		353483
	],
	"./education-center/structured-data/medical/partial-adenosine-deaminase-deficiency.json": [
		353483,
		3,
		353483
	],
	"./education-center/structured-data/medical/partial-agenesis-corpus-callosum": [
		179459,
		3,
		179459
	],
	"./education-center/structured-data/medical/partial-agenesis-corpus-callosum.json": [
		179459,
		3,
		179459
	],
	"./education-center/structured-data/medical/partial-congenital-absence-teeth": [
		273666,
		3,
		273666
	],
	"./education-center/structured-data/medical/partial-congenital-absence-teeth.json": [
		273666,
		3,
		273666
	],
	"./education-center/structured-data/medical/pazopanib-response": [
		501895,
		3,
		501895
	],
	"./education-center/structured-data/medical/pazopanib-response.json": [
		501895,
		3,
		501895
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy": [
		138966,
		3,
		138966
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-and-ribavirin-response-efficacy.json": [
		138966,
		3,
		138966
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-ribavirin-and-telaprevir-response-efficacy": [
		921025,
		3,
		921025
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-peginterferon-alfa-2b-ribavirin-and-telaprevir-response-efficacy.json": [
		921025,
		3,
		921025
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-response-efficacy": [
		328305,
		3,
		328305
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2a-response-efficacy.json": [
		328305,
		3,
		328305
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2b-response-efficacy": [
		190525,
		3,
		190525
	],
	"./education-center/structured-data/medical/peginterferon-alfa-2b-response-efficacy.json": [
		190525,
		3,
		190525
	],
	"./education-center/structured-data/medical/pelizaeus-merzbacher-disease-atypical": [
		514161,
		3,
		514161
	],
	"./education-center/structured-data/medical/pelizaeus-merzbacher-disease-atypical.json": [
		514161,
		3,
		514161
	],
	"./education-center/structured-data/medical/periampullary-adenoma": [
		959049,
		3,
		959049
	],
	"./education-center/structured-data/medical/periampullary-adenoma.json": [
		959049,
		3,
		959049
	],
	"./education-center/structured-data/medical/pericementitis": [
		386769,
		3,
		386769
	],
	"./education-center/structured-data/medical/pericementitis.json": [
		386769,
		3,
		386769
	],
	"./education-center/structured-data/medical/periventricular-laminar-heterotopia": [
		296202,
		3,
		296202
	],
	"./education-center/structured-data/medical/periventricular-laminar-heterotopia.json": [
		296202,
		3,
		296202
	],
	"./education-center/structured-data/medical/periventricular-nodular-heterotopia-syndactyly-cleft-palate-and-developmental-delay": [
		212579,
		3,
		212579
	],
	"./education-center/structured-data/medical/periventricular-nodular-heterotopia-syndactyly-cleft-palate-and-developmental-delay.json": [
		212579,
		3,
		212579
	],
	"./education-center/structured-data/medical/perlman-syndrome": [
		101779,
		3,
		101779
	],
	"./education-center/structured-data/medical/perlman-syndrome.json": [
		101779,
		3,
		101779
	],
	"./education-center/structured-data/medical/peroxisomal-biogenesis-disorder-3b": [
		488306,
		3,
		488306
	],
	"./education-center/structured-data/medical/peroxisomal-biogenesis-disorder-3b.json": [
		488306,
		3,
		488306
	],
	"./education-center/structured-data/medical/peroxisome-biogenesis-disorder-complementation-group-7": [
		812214,
		3,
		812214
	],
	"./education-center/structured-data/medical/peroxisome-biogenesis-disorder-complementation-group-7.json": [
		812214,
		3,
		812214
	],
	"./education-center/structured-data/medical/persistent-mullerian-duct-syndrome-type-i": [
		277436,
		3,
		277436
	],
	"./education-center/structured-data/medical/persistent-mullerian-duct-syndrome-type-i.json": [
		277436,
		3,
		277436
	],
	"./education-center/structured-data/medical/persistent-mullerian-duct-syndrome-type-ii": [
		318985,
		3,
		318985
	],
	"./education-center/structured-data/medical/persistent-mullerian-duct-syndrome-type-ii.json": [
		318985,
		3,
		318985
	],
	"./education-center/structured-data/medical/pervasive-developmental-disorder": [
		287702,
		3,
		287702
	],
	"./education-center/structured-data/medical/pervasive-developmental-disorder.json": [
		287702,
		3,
		287702
	],
	"./education-center/structured-data/medical/pes-cavus": [
		680373,
		3,
		680373
	],
	"./education-center/structured-data/medical/pes-cavus.json": [
		680373,
		3,
		680373
	],
	"./education-center/structured-data/medical/pex7-related-disorders": [
		866639,
		3,
		866639
	],
	"./education-center/structured-data/medical/pex7-related-disorders.json": [
		866639,
		3,
		866639
	],
	"./education-center/structured-data/medical/pfeiffer-syndrome": [
		176567,
		3,
		176567
	],
	"./education-center/structured-data/medical/pfeiffer-syndrome.json": [
		176567,
		3,
		176567
	],
	"./education-center/structured-data/medical/phenprocoumon-response-dosage": [
		479286,
		3,
		479286
	],
	"./education-center/structured-data/medical/phenprocoumon-response-dosage.json": [
		479286,
		3,
		479286
	],
	"./education-center/structured-data/medical/phenylthiocarbamide-tasting": [
		976099,
		3,
		976099
	],
	"./education-center/structured-data/medical/phenylthiocarbamide-tasting.json": [
		976099,
		3,
		976099
	],
	"./education-center/structured-data/medical/phenytoin-response": [
		345766,
		3,
		345766
	],
	"./education-center/structured-data/medical/phenytoin-response.json": [
		345766,
		3,
		345766
	],
	"./education-center/structured-data/medical/pheochromocytoma-susceptibility": [
		216330,
		3,
		216330
	],
	"./education-center/structured-data/medical/pheochromocytoma-susceptibility.json": [
		216330,
		3,
		216330
	],
	"./education-center/structured-data/medical/phonic-tics": [
		916179,
		3,
		916179
	],
	"./education-center/structured-data/medical/phonic-tics.json": [
		916179,
		3,
		916179
	],
	"./education-center/structured-data/medical/phosphoglycerate-kinase-electrophoretic-variant-pgk-ii": [
		924114,
		3,
		924114
	],
	"./education-center/structured-data/medical/phosphoglycerate-kinase-electrophoretic-variant-pgk-ii.json": [
		924114,
		3,
		924114
	],
	"./education-center/structured-data/medical/piebaldism-progressive": [
		647550,
		3,
		647550
	],
	"./education-center/structured-data/medical/piebaldism-progressive.json": [
		647550,
		3,
		647550
	],
	"./education-center/structured-data/medical/piebaldism-sensorineural-deafness": [
		422691,
		3,
		422691
	],
	"./education-center/structured-data/medical/piebaldism-sensorineural-deafness.json": [
		422691,
		3,
		422691
	],
	"./education-center/structured-data/medical/pierre-robin-syndrome": [
		98900,
		3,
		98900
	],
	"./education-center/structured-data/medical/pierre-robin-syndrome.json": [
		98900,
		3,
		98900
	],
	"./education-center/structured-data/medical/pigmentary-retinal-dystrophy": [
		983563,
		3,
		983563
	],
	"./education-center/structured-data/medical/pigmentary-retinal-dystrophy.json": [
		983563,
		3,
		983563
	],
	"./education-center/structured-data/medical/pigmentary-retinopathy": [
		903094,
		3,
		903094
	],
	"./education-center/structured-data/medical/pigmentary-retinopathy-and-sensorineural-deafness": [
		81948,
		3,
		81948
	],
	"./education-center/structured-data/medical/pigmentary-retinopathy-and-sensorineural-deafness.json": [
		81948,
		3,
		81948
	],
	"./education-center/structured-data/medical/pigmentary-retinopathy.json": [
		903094,
		3,
		903094
	],
	"./education-center/structured-data/medical/pilomatrixoma": [
		416524,
		3,
		416524
	],
	"./education-center/structured-data/medical/pilomatrixoma.json": [
		416524,
		3,
		416524
	],
	"./education-center/structured-data/medical/piroxicam-response": [
		202244,
		3,
		202244
	],
	"./education-center/structured-data/medical/piroxicam-response.json": [
		202244,
		3,
		202244
	],
	"./education-center/structured-data/medical/pituitary-adenoma-predisposition": [
		518605,
		3,
		518605
	],
	"./education-center/structured-data/medical/pituitary-adenoma-predisposition.json": [
		518605,
		3,
		518605
	],
	"./education-center/structured-data/medical/pituitary-hormone-deficiency-combined-5": [
		264427,
		3,
		264427
	],
	"./education-center/structured-data/medical/pituitary-hormone-deficiency-combined-5.json": [
		264427,
		3,
		264427
	],
	"./education-center/structured-data/medical/pituitary-hormone-deficiency-combined-or-isolated-8": [
		102602,
		3,
		102602
	],
	"./education-center/structured-data/medical/pituitary-hormone-deficiency-combined-or-isolated-8.json": [
		102602,
		3,
		102602
	],
	"./education-center/structured-data/medical/pituitary-hypothyroidism": [
		392316,
		3,
		392316
	],
	"./education-center/structured-data/medical/pituitary-hypothyroidism.json": [
		392316,
		3,
		392316
	],
	"./education-center/structured-data/medical/pitx2-related-eye-abnormalities": [
		851596,
		3,
		851596
	],
	"./education-center/structured-data/medical/pitx2-related-eye-abnormalities.json": [
		851596,
		3,
		851596
	],
	"./education-center/structured-data/medical/plasma-triglyceride-level-quantitative-trait-locus": [
		89227,
		3,
		89227
	],
	"./education-center/structured-data/medical/plasma-triglyceride-level-quantitative-trait-locus.json": [
		89227,
		3,
		89227
	],
	"./education-center/structured-data/medical/plasminogen-deficiency-type-i": [
		993733,
		3,
		993733
	],
	"./education-center/structured-data/medical/plasminogen-deficiency-type-i.json": [
		993733,
		3,
		993733
	],
	"./education-center/structured-data/medical/plasmodium-vivax-resistance": [
		775443,
		3,
		775443
	],
	"./education-center/structured-data/medical/plasmodium-vivax-resistance.json": [
		775443,
		3,
		775443
	],
	"./education-center/structured-data/medical/platyspondylic-dysplasia-torrance-type": [
		24650,
		3,
		24650
	],
	"./education-center/structured-data/medical/platyspondylic-dysplasia-torrance-type.json": [
		24650,
		3,
		24650
	],
	"./education-center/structured-data/medical/pol-iii-related-leukodystrophy": [
		437967,
		3,
		437967
	],
	"./education-center/structured-data/medical/pol-iii-related-leukodystrophy.json": [
		437967,
		3,
		437967
	],
	"./education-center/structured-data/medical/pole-exonuclease-domain-mutation": [
		958189,
		3,
		958189
	],
	"./education-center/structured-data/medical/pole-exonuclease-domain-mutation.json": [
		958189,
		3,
		958189
	],
	"./education-center/structured-data/medical/polg-related-disorders": [
		464219,
		3,
		464219
	],
	"./education-center/structured-data/medical/polg-related-disorders.json": [
		464219,
		3,
		464219
	],
	"./education-center/structured-data/medical/polg-related-spectrum-disorders": [
		545914,
		3,
		545914
	],
	"./education-center/structured-data/medical/polg-related-spectrum-disorders.json": [
		545914,
		3,
		545914
	],
	"./education-center/structured-data/medical/polr1c-related-disorders": [
		417839,
		3,
		417839
	],
	"./education-center/structured-data/medical/polr1c-related-disorders.json": [
		417839,
		3,
		417839
	],
	"./education-center/structured-data/medical/polr3-related-leukodystrophy": [
		916050,
		3,
		916050
	],
	"./education-center/structured-data/medical/polr3-related-leukodystrophy.json": [
		916050,
		3,
		916050
	],
	"./education-center/structured-data/medical/poly-adp-ribose-polymerase-inhibitor-response": [
		635575,
		3,
		635575
	],
	"./education-center/structured-data/medical/poly-adp-ribose-polymerase-inhibitor-response.json": [
		635575,
		3,
		635575
	],
	"./education-center/structured-data/medical/polycythemia": [
		698509,
		3,
		698509
	],
	"./education-center/structured-data/medical/polycythemia.json": [
		698509,
		3,
		698509
	],
	"./education-center/structured-data/medical/polyglucosan-body-myopathy-1-immunodeficiency": [
		253402,
		3,
		253402
	],
	"./education-center/structured-data/medical/polyglucosan-body-myopathy-1-immunodeficiency.json": [
		253402,
		3,
		253402
	],
	"./education-center/structured-data/medical/polyglucosan-body-myopathy-1-without-immunodeficiency": [
		489823,
		3,
		489823
	],
	"./education-center/structured-data/medical/polyglucosan-body-myopathy-1-without-immunodeficiency.json": [
		489823,
		3,
		489823
	],
	"./education-center/structured-data/medical/polymerase-proofreading-associated-polyposis": [
		785382,
		3,
		785382
	],
	"./education-center/structured-data/medical/polymerase-proofreading-associated-polyposis.json": [
		785382,
		3,
		785382
	],
	"./education-center/structured-data/medical/polymicrogyria": [
		614094,
		3,
		614094
	],
	"./education-center/structured-data/medical/polymicrogyria.json": [
		614094,
		3,
		614094
	],
	"./education-center/structured-data/medical/polyostotic-fibrous-dysplasia-somatic-mosaic": [
		403176,
		3,
		403176
	],
	"./education-center/structured-data/medical/polyostotic-fibrous-dysplasia-somatic-mosaic.json": [
		403176,
		3,
		403176
	],
	"./education-center/structured-data/medical/polysyndactyly": [
		157944,
		3,
		157944
	],
	"./education-center/structured-data/medical/polysyndactyly.json": [
		157944,
		3,
		157944
	],
	"./education-center/structured-data/medical/pomgnt1-related-disorders": [
		190364,
		3,
		190364
	],
	"./education-center/structured-data/medical/pomgnt1-related-disorders.json": [
		190364,
		3,
		190364
	],
	"./education-center/structured-data/medical/pontocerebellar-hypoplasia-type-1a": [
		158050,
		3,
		158050
	],
	"./education-center/structured-data/medical/pontocerebellar-hypoplasia-type-1a.json": [
		158050,
		3,
		158050
	],
	"./education-center/structured-data/medical/porencephalic-cyst": [
		911474,
		3,
		911474
	],
	"./education-center/structured-data/medical/porencephalic-cyst.json": [
		911474,
		3,
		911474
	],
	"./education-center/structured-data/medical/porphyria-acute-hepatic-digenic": [
		225147,
		3,
		225147
	],
	"./education-center/structured-data/medical/porphyria-acute-hepatic-digenic.json": [
		225147,
		3,
		225147
	],
	"./education-center/structured-data/medical/porphyria-acute-intermittent-nonerythroid-variant": [
		490325,
		3,
		490325
	],
	"./education-center/structured-data/medical/porphyria-acute-intermittent-nonerythroid-variant.json": [
		490325,
		3,
		490325
	],
	"./education-center/structured-data/medical/postanesthetic-apnea": [
		118175,
		3,
		118175
	],
	"./education-center/structured-data/medical/postanesthetic-apnea.json": [
		118175,
		3,
		118175
	],
	"./education-center/structured-data/medical/postaxial-polydactyly-type-a1b": [
		680846,
		3,
		680846
	],
	"./education-center/structured-data/medical/postaxial-polydactyly-type-a1b.json": [
		680846,
		3,
		680846
	],
	"./education-center/structured-data/medical/posterior-polar-cataract": [
		960455,
		3,
		960455
	],
	"./education-center/structured-data/medical/posterior-polar-cataract.json": [
		960455,
		3,
		960455
	],
	"./education-center/structured-data/medical/posterior-polymorphous-corneal-dystrophy-1": [
		409130,
		3,
		409130
	],
	"./education-center/structured-data/medical/posterior-polymorphous-corneal-dystrophy-1.json": [
		409130,
		3,
		409130
	],
	"./education-center/structured-data/medical/postural-tremor": [
		553847,
		3,
		553847
	],
	"./education-center/structured-data/medical/postural-tremor.json": [
		553847,
		3,
		553847
	],
	"./education-center/structured-data/medical/ppargc1b-polymorphism": [
		606781,
		3,
		606781
	],
	"./education-center/structured-data/medical/ppargc1b-polymorphism.json": [
		606781,
		3,
		606781
	],
	"./education-center/structured-data/medical/pravastatin-response-efficacy": [
		186849,
		3,
		186849
	],
	"./education-center/structured-data/medical/pravastatin-response-efficacy.json": [
		186849,
		3,
		186849
	],
	"./education-center/structured-data/medical/precocious-puberty-males": [
		237621,
		3,
		237621
	],
	"./education-center/structured-data/medical/precocious-puberty-males.json": [
		237621,
		3,
		237621
	],
	"./education-center/structured-data/medical/predisposition-invasive-fungal-disease-due-card9-deficiency": [
		140292,
		3,
		140292
	],
	"./education-center/structured-data/medical/predisposition-invasive-fungal-disease-due-card9-deficiency.json": [
		140292,
		3,
		140292
	],
	"./education-center/structured-data/medical/prednisolone-response": [
		451615,
		3,
		451615
	],
	"./education-center/structured-data/medical/prednisolone-response.json": [
		451615,
		3,
		451615
	],
	"./education-center/structured-data/medical/preimplantation-embryonic-lethality-1": [
		997542,
		3,
		997542
	],
	"./education-center/structured-data/medical/preimplantation-embryonic-lethality-1.json": [
		997542,
		3,
		997542
	],
	"./education-center/structured-data/medical/preimplantation-embryonic-lethality-2": [
		891704,
		3,
		891704
	],
	"./education-center/structured-data/medical/preimplantation-embryonic-lethality-2.json": [
		891704,
		3,
		891704
	],
	"./education-center/structured-data/medical/preimplantation-lethality": [
		8889,
		3,
		8889
	],
	"./education-center/structured-data/medical/preimplantation-lethality.json": [
		8889,
		3,
		8889
	],
	"./education-center/structured-data/medical/prelingual-sensorineural-hearing-impairment": [
		661128,
		3,
		661128
	],
	"./education-center/structured-data/medical/prelingual-sensorineural-hearing-impairment.json": [
		661128,
		3,
		661128
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait": [
		822503,
		3,
		822503
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-0": [
		908691,
		3,
		908691
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-0.json": [
		908691,
		3,
		908691
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-1": [
		587753,
		3,
		587753
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-1.json": [
		587753,
		3,
		587753
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-10": [
		139241,
		3,
		139241
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-10.json": [
		139241,
		3,
		139241
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-11": [
		172053,
		3,
		172053
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-11.json": [
		172053,
		3,
		172053
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-12": [
		844549,
		3,
		844549
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-12.json": [
		844549,
		3,
		844549
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-13": [
		517717,
		3,
		517717
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-13.json": [
		517717,
		3,
		517717
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-14": [
		982960,
		3,
		982960
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-14.json": [
		982960,
		3,
		982960
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-15": [
		3574,
		3,
		3574
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-15.json": [
		3574,
		3,
		3574
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-16": [
		252384,
		3,
		252384
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-16.json": [
		252384,
		3,
		252384
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-17": [
		432324,
		3,
		432324
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-17.json": [
		432324,
		3,
		432324
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-18": [
		577610,
		3,
		577610
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-18.json": [
		577610,
		3,
		577610
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-19": [
		885854,
		3,
		885854
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-19.json": [
		885854,
		3,
		885854
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-2": [
		461474,
		3,
		461474
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-2.json": [
		461474,
		3,
		461474
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-20": [
		115806,
		3,
		115806
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-20.json": [
		115806,
		3,
		115806
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-21": [
		185844,
		3,
		185844
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-21.json": [
		185844,
		3,
		185844
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-22": [
		566860,
		3,
		566860
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-22.json": [
		566860,
		3,
		566860
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-23": [
		721096,
		3,
		721096
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-23.json": [
		721096,
		3,
		721096
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-24": [
		983810,
		3,
		983810
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-24.json": [
		983810,
		3,
		983810
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-25": [
		131374,
		3,
		131374
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-25.json": [
		131374,
		3,
		131374
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-26": [
		717539,
		3,
		717539
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-26.json": [
		717539,
		3,
		717539
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-27": [
		116231,
		3,
		116231
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-27.json": [
		116231,
		3,
		116231
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-28": [
		228332,
		3,
		228332
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-28.json": [
		228332,
		3,
		228332
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-29": [
		295321,
		3,
		295321
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-29.json": [
		295321,
		3,
		295321
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-3": [
		493421,
		3,
		493421
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-3.json": [
		493421,
		3,
		493421
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-30": [
		544653,
		3,
		544653
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-30.json": [
		544653,
		3,
		544653
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-4": [
		113192,
		3,
		113192
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-4.json": [
		113192,
		3,
		113192
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-5": [
		481138,
		3,
		817806
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-5.json": [
		481138,
		3,
		817806
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-6": [
		750858,
		3,
		750858
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-6.json": [
		750858,
		3,
		750858
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-7": [
		966783,
		3,
		966783
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-7.json": [
		966783,
		3,
		966783
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-8": [
		871789,
		3,
		871789
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-8.json": [
		871789,
		3,
		871789
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-9": [
		700894,
		3,
		700894
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait-9.json": [
		700894,
		3,
		700894
	],
	"./education-center/structured-data/medical/premature-chromatid-separation-trait.json": [
		822503,
		3,
		822503
	],
	"./education-center/structured-data/medical/premature-coronary-artery-atherosclerosis": [
		943602,
		3,
		943602
	],
	"./education-center/structured-data/medical/premature-coronary-artery-atherosclerosis.json": [
		943602,
		3,
		943602
	],
	"./education-center/structured-data/medical/premature-ovarian-failure": [
		382910,
		3,
		382910
	],
	"./education-center/structured-data/medical/premature-ovarian-failure-21": [
		276585,
		3,
		276585
	],
	"./education-center/structured-data/medical/premature-ovarian-failure-21.json": [
		276585,
		3,
		276585
	],
	"./education-center/structured-data/medical/premature-ovarian-failure.json": [
		382910,
		3,
		382910
	],
	"./education-center/structured-data/medical/premature-ovarian-insufficiency": [
		379475,
		3,
		379475
	],
	"./education-center/structured-data/medical/premature-ovarian-insufficiency.json": [
		379475,
		3,
		379475
	],
	"./education-center/structured-data/medical/preterm-intraventricular-hemorrhage": [
		431166,
		3,
		431166
	],
	"./education-center/structured-data/medical/preterm-intraventricular-hemorrhage.json": [
		431166,
		3,
		431166
	],
	"./education-center/structured-data/medical/pretibial-dystrophic-epidermolysis-bullosa": [
		59506,
		3,
		59506
	],
	"./education-center/structured-data/medical/pretibial-dystrophic-epidermolysis-bullosa.json": [
		59506,
		3,
		59506
	],
	"./education-center/structured-data/medical/primary-aldosteronism": [
		174476,
		3,
		174476
	],
	"./education-center/structured-data/medical/primary-aldosteronism.json": [
		174476,
		3,
		174476
	],
	"./education-center/structured-data/medical/primary-amenorrhea": [
		77358,
		3,
		77358
	],
	"./education-center/structured-data/medical/primary-amenorrhea.json": [
		77358,
		3,
		77358
	],
	"./education-center/structured-data/medical/primary-congenital-glaucoma": [
		180490,
		3,
		180490
	],
	"./education-center/structured-data/medical/primary-congenital-glaucoma.json": [
		180490,
		3,
		180490
	],
	"./education-center/structured-data/medical/primary-degenerative-dementia-alzheimer-type-presenile-onset": [
		895734,
		3,
		895734
	],
	"./education-center/structured-data/medical/primary-degenerative-dementia-alzheimer-type-presenile-onset.json": [
		895734,
		3,
		895734
	],
	"./education-center/structured-data/medical/primary-erythromelalgia": [
		339483,
		3,
		339483
	],
	"./education-center/structured-data/medical/primary-erythromelalgia.json": [
		339483,
		3,
		339483
	],
	"./education-center/structured-data/medical/primary-failure-tooth-eruption": [
		117094,
		3,
		117094
	],
	"./education-center/structured-data/medical/primary-failure-tooth-eruption.json": [
		117094,
		3,
		117094
	],
	"./education-center/structured-data/medical/primary-familial-polycythemia-due-epo-receptor-mutation": [
		906179,
		3,
		906179
	],
	"./education-center/structured-data/medical/primary-familial-polycythemia-due-epo-receptor-mutation.json": [
		906179,
		3,
		906179
	],
	"./education-center/structured-data/medical/primary-interstitial-lung-disease-specific-childhood-due-pulmonary-surfactant-protein-anomalies": [
		829321,
		3,
		829321
	],
	"./education-center/structured-data/medical/primary-interstitial-lung-disease-specific-childhood-due-pulmonary-surfactant-protein-anomalies.json": [
		829321,
		3,
		829321
	],
	"./education-center/structured-data/medical/primary-low-grade-serous-adenocarcinoma-ovary": [
		630562,
		3,
		630562
	],
	"./education-center/structured-data/medical/primary-low-grade-serous-adenocarcinoma-ovary.json": [
		630562,
		3,
		630562
	],
	"./education-center/structured-data/medical/primary-microcephaly": [
		132357,
		3,
		132357
	],
	"./education-center/structured-data/medical/primary-microcephaly-2-or-without-cortical-malformations": [
		809449,
		3,
		809449
	],
	"./education-center/structured-data/medical/primary-microcephaly-2-or-without-cortical-malformations.json": [
		809449,
		3,
		809449
	],
	"./education-center/structured-data/medical/primary-microcephaly-recessive": [
		43832,
		3,
		43832
	],
	"./education-center/structured-data/medical/primary-microcephaly-recessive.json": [
		43832,
		3,
		43832
	],
	"./education-center/structured-data/medical/primary-microcephaly.json": [
		132357,
		3,
		132357
	],
	"./education-center/structured-data/medical/primary-open-angle-glaucoma": [
		250535,
		3,
		250535
	],
	"./education-center/structured-data/medical/primary-open-angle-glaucoma.json": [
		250535,
		3,
		250535
	],
	"./education-center/structured-data/medical/primitive-neuroectodermal-tumor": [
		346409,
		3,
		346409
	],
	"./education-center/structured-data/medical/primitive-neuroectodermal-tumor.json": [
		346409,
		3,
		346409
	],
	"./education-center/structured-data/medical/prkag2-cardiac-syndrome": [
		660203,
		3,
		660203
	],
	"./education-center/structured-data/medical/prkag2-cardiac-syndrome.json": [
		660203,
		3,
		660203
	],
	"./education-center/structured-data/medical/profound-global-developmental-delay": [
		993343,
		3,
		993343
	],
	"./education-center/structured-data/medical/profound-global-developmental-delay.json": [
		993343,
		3,
		993343
	],
	"./education-center/structured-data/medical/profound-hearing-impairment": [
		151021,
		3,
		151021
	],
	"./education-center/structured-data/medical/profound-hearing-impairment.json": [
		151021,
		3,
		151021
	],
	"./education-center/structured-data/medical/programmed-death-ligand-1-pd-l1-blocking-antibody-response": [
		598633,
		3,
		598633
	],
	"./education-center/structured-data/medical/programmed-death-ligand-1-pd-l1-blocking-antibody-response.json": [
		598633,
		3,
		598633
	],
	"./education-center/structured-data/medical/progressive-cerebellar-ataxia": [
		415359,
		3,
		415359
	],
	"./education-center/structured-data/medical/progressive-cerebellar-ataxia.json": [
		415359,
		3,
		415359
	],
	"./education-center/structured-data/medical/progressive-childhood-encephalopathy": [
		945910,
		3,
		945910
	],
	"./education-center/structured-data/medical/progressive-childhood-encephalopathy.json": [
		945910,
		3,
		945910
	],
	"./education-center/structured-data/medical/progressive-cone-degeneration": [
		652326,
		3,
		652326
	],
	"./education-center/structured-data/medical/progressive-cone-degeneration.json": [
		652326,
		3,
		652326
	],
	"./education-center/structured-data/medical/progressive-cone-dystrophy-without-rod-involvement": [
		836566,
		3,
		836566
	],
	"./education-center/structured-data/medical/progressive-cone-dystrophy-without-rod-involvement.json": [
		836566,
		3,
		836566
	],
	"./education-center/structured-data/medical/progressive-congenital-scoliosis": [
		558076,
		3,
		558076
	],
	"./education-center/structured-data/medical/progressive-congenital-scoliosis.json": [
		558076,
		3,
		558076
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions": [
		520327,
		3,
		520327
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions-digenic": [
		609361,
		3,
		609361
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions-digenic.json": [
		609361,
		3,
		609361
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-mitochondrial-dna-deletions.json": [
		520327,
		3,
		520327
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-myoclonus": [
		693263,
		3,
		693263
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-myoclonus.json": [
		693263,
		3,
		693263
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-proximal-myopathy-and-sudden-death": [
		649773,
		3,
		649773
	],
	"./education-center/structured-data/medical/progressive-external-ophthalmoplegia-proximal-myopathy-and-sudden-death.json": [
		649773,
		3,
		649773
	],
	"./education-center/structured-data/medical/progressive-familial-heart-block-type-1a": [
		501075,
		3,
		501075
	],
	"./education-center/structured-data/medical/progressive-familial-heart-block-type-1a.json": [
		501075,
		3,
		501075
	],
	"./education-center/structured-data/medical/progressive-microcephaly": [
		946478,
		3,
		946478
	],
	"./education-center/structured-data/medical/progressive-microcephaly.json": [
		946478,
		3,
		946478
	],
	"./education-center/structured-data/medical/progressive-muscle-weakness": [
		122458,
		3,
		122458
	],
	"./education-center/structured-data/medical/progressive-muscle-weakness.json": [
		122458,
		3,
		122458
	],
	"./education-center/structured-data/medical/progressive-myoclonic-epilepsy-type-5": [
		70340,
		3,
		70340
	],
	"./education-center/structured-data/medical/progressive-myoclonic-epilepsy-type-5.json": [
		70340,
		3,
		70340
	],
	"./education-center/structured-data/medical/progressive-myositis-ossificans": [
		332895,
		3,
		332895
	],
	"./education-center/structured-data/medical/progressive-myositis-ossificans.json": [
		332895,
		3,
		332895
	],
	"./education-center/structured-data/medical/progressive-neurodegenerative-disease": [
		296397,
		3,
		296397
	],
	"./education-center/structured-data/medical/progressive-neurodegenerative-disease.json": [
		296397,
		3,
		296397
	],
	"./education-center/structured-data/medical/progressive-psychomotor-deterioration": [
		297730,
		3,
		297730
	],
	"./education-center/structured-data/medical/progressive-psychomotor-deterioration.json": [
		297730,
		3,
		297730
	],
	"./education-center/structured-data/medical/progressive-pulmonary-failure": [
		884824,
		3,
		884824
	],
	"./education-center/structured-data/medical/progressive-pulmonary-failure.json": [
		884824,
		3,
		884824
	],
	"./education-center/structured-data/medical/progressive-sensorineural-hearing-impairment": [
		995751,
		3,
		995751
	],
	"./education-center/structured-data/medical/progressive-sensorineural-hearing-impairment.json": [
		995751,
		3,
		995751
	],
	"./education-center/structured-data/medical/progressive-spastic-paraparesis": [
		724370,
		3,
		724370
	],
	"./education-center/structured-data/medical/progressive-spastic-paraparesis.json": [
		724370,
		3,
		724370
	],
	"./education-center/structured-data/medical/progressive-supranuclear-ophthalmoplegia": [
		412958,
		3,
		412958
	],
	"./education-center/structured-data/medical/progressive-supranuclear-ophthalmoplegia.json": [
		412958,
		3,
		412958
	],
	"./education-center/structured-data/medical/progressive-ventriculomegaly": [
		127834,
		3,
		127834
	],
	"./education-center/structured-data/medical/progressive-ventriculomegaly.json": [
		127834,
		3,
		127834
	],
	"./education-center/structured-data/medical/proguanil-poor-metabolism": [
		779273,
		3,
		779273
	],
	"./education-center/structured-data/medical/proguanil-poor-metabolism.json": [
		779273,
		3,
		779273
	],
	"./education-center/structured-data/medical/prolonged-prothrombin-time": [
		274412,
		3,
		274412
	],
	"./education-center/structured-data/medical/prolonged-prothrombin-time.json": [
		274412,
		3,
		274412
	],
	"./education-center/structured-data/medical/properdin-deficiency-type-ii": [
		946230,
		3,
		946230
	],
	"./education-center/structured-data/medical/properdin-deficiency-type-ii.json": [
		946230,
		3,
		946230
	],
	"./education-center/structured-data/medical/properdin-deficiency-type-iii": [
		358487,
		3,
		358487
	],
	"./education-center/structured-data/medical/properdin-deficiency-type-iii.json": [
		358487,
		3,
		358487
	],
	"./education-center/structured-data/medical/proportionate-short-stature": [
		842672,
		3,
		842672
	],
	"./education-center/structured-data/medical/proportionate-short-stature.json": [
		842672,
		3,
		842672
	],
	"./education-center/structured-data/medical/prostate-cancer-somatic": [
		151993,
		3,
		151993
	],
	"./education-center/structured-data/medical/prostate-cancer-somatic.json": [
		151993,
		3,
		151993
	],
	"./education-center/structured-data/medical/prostate-cancer-susceptibility": [
		594144,
		3,
		594144
	],
	"./education-center/structured-data/medical/prostate-cancer-susceptibility-0": [
		934659,
		3,
		934659
	],
	"./education-center/structured-data/medical/prostate-cancer-susceptibility-0.json": [
		934659,
		3,
		934659
	],
	"./education-center/structured-data/medical/prostate-cancer-susceptibility.json": [
		594144,
		3,
		594144
	],
	"./education-center/structured-data/medical/proteasome-associated-autoinflammatory-syndrome-1-digenic": [
		115418,
		3,
		115418
	],
	"./education-center/structured-data/medical/proteasome-associated-autoinflammatory-syndrome-1-digenic.json": [
		115418,
		3,
		115418
	],
	"./education-center/structured-data/medical/proximal-16p112-microdeletion-syndrome": [
		127329,
		3,
		127329
	],
	"./education-center/structured-data/medical/proximal-16p112-microdeletion-syndrome.json": [
		127329,
		3,
		127329
	],
	"./education-center/structured-data/medical/proximal-muscle-weakness": [
		480601,
		3,
		480601
	],
	"./education-center/structured-data/medical/proximal-muscle-weakness-upper-limbs": [
		373858,
		3,
		373858
	],
	"./education-center/structured-data/medical/proximal-muscle-weakness-upper-limbs.json": [
		373858,
		3,
		373858
	],
	"./education-center/structured-data/medical/proximal-muscle-weakness.json": [
		480601,
		3,
		480601
	],
	"./education-center/structured-data/medical/prph2-related-disorders": [
		682773,
		3,
		682773
	],
	"./education-center/structured-data/medical/prph2-related-disorders.json": [
		682773,
		3,
		682773
	],
	"./education-center/structured-data/medical/prune-belly-syndrome": [
		741118,
		3,
		741118
	],
	"./education-center/structured-data/medical/prune-belly-syndrome.json": [
		741118,
		3,
		741118
	],
	"./education-center/structured-data/medical/pseudo-fractures": [
		623497,
		3,
		623497
	],
	"./education-center/structured-data/medical/pseudo-fractures.json": [
		623497,
		3,
		623497
	],
	"./education-center/structured-data/medical/pseudoarylsulfatase-deficiency": [
		221032,
		3,
		221032
	],
	"./education-center/structured-data/medical/pseudoarylsulfatase-deficiency.json": [
		221032,
		3,
		221032
	],
	"./education-center/structured-data/medical/pseudocholinesterase-deficiency": [
		348741,
		3,
		348741
	],
	"./education-center/structured-data/medical/pseudocholinesterase-deficiency.json": [
		348741,
		3,
		348741
	],
	"./education-center/structured-data/medical/pseudohermaphroditism": [
		691915,
		3,
		691915
	],
	"./education-center/structured-data/medical/pseudohermaphroditism-female-hypokalemia-due-glucocorticoid-resistance": [
		522148,
		3,
		522148
	],
	"./education-center/structured-data/medical/pseudohermaphroditism-female-hypokalemia-due-glucocorticoid-resistance.json": [
		522148,
		3,
		522148
	],
	"./education-center/structured-data/medical/pseudohermaphroditism.json": [
		691915,
		3,
		691915
	],
	"./education-center/structured-data/medical/pseudohypoaldosteronism-type-2a": [
		999594,
		3,
		999594
	],
	"./education-center/structured-data/medical/pseudohypoaldosteronism-type-2a.json": [
		999594,
		3,
		999594
	],
	"./education-center/structured-data/medical/pseudohypoparathyroidism-type-i": [
		283706,
		3,
		283706
	],
	"./education-center/structured-data/medical/pseudohypoparathyroidism-type-i.json": [
		283706,
		3,
		283706
	],
	"./education-center/structured-data/medical/pseudohypoparathyroidism-type-ia-testotoxicosis": [
		210273,
		3,
		210273
	],
	"./education-center/structured-data/medical/pseudohypoparathyroidism-type-ia-testotoxicosis.json": [
		210273,
		3,
		210273
	],
	"./education-center/structured-data/medical/pseudoxanthoma-elasticum-modifier-severity": [
		161389,
		3,
		161389
	],
	"./education-center/structured-data/medical/pseudoxanthoma-elasticum-modifier-severity.json": [
		161389,
		3,
		161389
	],
	"./education-center/structured-data/medical/psoriasis-2-pustular": [
		123960,
		3,
		123960
	],
	"./education-center/structured-data/medical/psoriasis-2-pustular.json": [
		123960,
		3,
		123960
	],
	"./education-center/structured-data/medical/psoriasis-protection-against": [
		165107,
		3,
		165107
	],
	"./education-center/structured-data/medical/psoriasis-protection-against.json": [
		165107,
		3,
		165107
	],
	"./education-center/structured-data/medical/psychomotor-retardation": [
		89577,
		3,
		89577
	],
	"./education-center/structured-data/medical/psychomotor-retardation.json": [
		89577,
		3,
		89577
	],
	"./education-center/structured-data/medical/psychotic-disorder": [
		661062,
		3,
		661062
	],
	"./education-center/structured-data/medical/psychotic-disorder.json": [
		661062,
		3,
		661062
	],
	"./education-center/structured-data/medical/pulmonary-alveolar-proteinosis": [
		262819,
		3,
		262819
	],
	"./education-center/structured-data/medical/pulmonary-alveolar-proteinosis.json": [
		262819,
		3,
		262819
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-associated-another-disease": [
		293360,
		3,
		293360
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-associated-another-disease.json": [
		293360,
		3,
		293360
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-associated-congenital-heart-disease": [
		397792,
		3,
		397792
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-associated-congenital-heart-disease.json": [
		397792,
		3,
		397792
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-related-hereditary-hemorrhagic-telangiectasia": [
		6091,
		3,
		6091
	],
	"./education-center/structured-data/medical/pulmonary-arterial-hypertension-related-hereditary-hemorrhagic-telangiectasia.json": [
		6091,
		3,
		6091
	],
	"./education-center/structured-data/medical/pulmonary-artery-atresia": [
		64627,
		3,
		64627
	],
	"./education-center/structured-data/medical/pulmonary-artery-atresia.json": [
		64627,
		3,
		64627
	],
	"./education-center/structured-data/medical/pulmonary-fibrosis-idiopathic-susceptibility": [
		335728,
		3,
		335728
	],
	"./education-center/structured-data/medical/pulmonary-fibrosis-idiopathic-susceptibility.json": [
		335728,
		3,
		335728
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-1-hereditary-hemorrhagic-telangiectasia": [
		246140,
		3,
		246140
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-1-hereditary-hemorrhagic-telangiectasia.json": [
		246140,
		3,
		246140
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-dexfenfluramine-associated": [
		698804,
		3,
		698804
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-dexfenfluramine-associated.json": [
		698804,
		3,
		698804
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-fenfluramine-associated": [
		684811,
		3,
		684811
	],
	"./education-center/structured-data/medical/pulmonary-hypertension-primary-fenfluramine-associated.json": [
		684811,
		3,
		684811
	],
	"./education-center/structured-data/medical/pulmonary-lymphangiectasia": [
		68431,
		3,
		68431
	],
	"./education-center/structured-data/medical/pulmonary-lymphangiectasia.json": [
		68431,
		3,
		68431
	],
	"./education-center/structured-data/medical/pulmonary-surfactant-metabolism-dysfunction-dominant": [
		270315,
		3,
		270315
	],
	"./education-center/structured-data/medical/pulmonary-surfactant-metabolism-dysfunction-dominant.json": [
		270315,
		3,
		270315
	],
	"./education-center/structured-data/medical/pulmonary-surfactant-metabolism-dysfunction-recessive": [
		748079,
		3,
		748079
	],
	"./education-center/structured-data/medical/pulmonary-surfactant-metabolism-dysfunction-recessive.json": [
		748079,
		3,
		748079
	],
	"./education-center/structured-data/medical/pulmonary-venoocclusive-disease-1-autosomal-dominant": [
		519508,
		3,
		519508
	],
	"./education-center/structured-data/medical/pulmonary-venoocclusive-disease-1-autosomal-dominant.json": [
		519508,
		3,
		519508
	],
	"./education-center/structured-data/medical/pura-syndrome": [
		214460,
		3,
		214460
	],
	"./education-center/structured-data/medical/pura-syndrome.json": [
		214460,
		3,
		214460
	],
	"./education-center/structured-data/medical/pyruvate-kinase-hyperactivity": [
		178358,
		3,
		178358
	],
	"./education-center/structured-data/medical/pyruvate-kinase-hyperactivity.json": [
		178358,
		3,
		178358
	],
	"./education-center/structured-data/medical/qualitative-or-quantitative-defects-collagen-6": [
		638688,
		3,
		638688
	],
	"./education-center/structured-data/medical/qualitative-or-quantitative-defects-collagen-6.json": [
		638688,
		3,
		638688
	],
	"./education-center/structured-data/medical/radin-blood-group": [
		198112,
		3,
		198112
	],
	"./education-center/structured-data/medical/radin-blood-group.json": [
		198112,
		3,
		198112
	],
	"./education-center/structured-data/medical/rapsn-related-disorders": [
		206740,
		3,
		206740
	],
	"./education-center/structured-data/medical/rapsn-related-disorders.json": [
		206740,
		3,
		206740
	],
	"./education-center/structured-data/medical/rare-disease-autism": [
		68172,
		3,
		68172
	],
	"./education-center/structured-data/medical/rare-disease-autism.json": [
		68172,
		3,
		68172
	],
	"./education-center/structured-data/medical/rare-genetic-deafness": [
		197111,
		3,
		197111
	],
	"./education-center/structured-data/medical/rare-genetic-deafness.json": [
		197111,
		3,
		197111
	],
	"./education-center/structured-data/medical/rare-genetic-intellectual-disability": [
		170840,
		3,
		170840
	],
	"./education-center/structured-data/medical/rare-genetic-intellectual-disability.json": [
		170840,
		3,
		170840
	],
	"./education-center/structured-data/medical/rare-isolated-myopia": [
		296388,
		3,
		296388
	],
	"./education-center/structured-data/medical/rare-isolated-myopia.json": [
		296388,
		3,
		296388
	],
	"./education-center/structured-data/medical/rare-syndromic-intellectual-disability": [
		142285,
		3,
		142285
	],
	"./education-center/structured-data/medical/rare-syndromic-intellectual-disability.json": [
		142285,
		3,
		142285
	],
	"./education-center/structured-data/medical/ras-inhibitor-response": [
		551917,
		3,
		551917
	],
	"./education-center/structured-data/medical/ras-inhibitor-response.json": [
		551917,
		3,
		551917
	],
	"./education-center/structured-data/medical/rbbp8-related-disorders": [
		415557,
		3,
		415557
	],
	"./education-center/structured-data/medical/rbbp8-related-disorders.json": [
		415557,
		3,
		415557
	],
	"./education-center/structured-data/medical/reclassified-mttp-polymorphism": [
		279043,
		3,
		279043
	],
	"./education-center/structured-data/medical/reclassified-mttp-polymorphism.json": [
		279043,
		3,
		279043
	],
	"./education-center/structured-data/medical/recombination-rate-quantitative-trait-locus-1": [
		719086,
		3,
		719086
	],
	"./education-center/structured-data/medical/recombination-rate-quantitative-trait-locus-1.json": [
		719086,
		3,
		719086
	],
	"./education-center/structured-data/medical/recurrent-fever": [
		329602,
		3,
		329602
	],
	"./education-center/structured-data/medical/recurrent-fever.json": [
		329602,
		3,
		329602
	],
	"./education-center/structured-data/medical/recurrent-hand-flapping": [
		516190,
		3,
		516190
	],
	"./education-center/structured-data/medical/recurrent-hand-flapping.json": [
		516190,
		3,
		516190
	],
	"./education-center/structured-data/medical/recurrent-infections": [
		81552,
		3,
		81552
	],
	"./education-center/structured-data/medical/recurrent-infections.json": [
		81552,
		3,
		81552
	],
	"./education-center/structured-data/medical/recurrent-pancreatitis": [
		873270,
		3,
		873270
	],
	"./education-center/structured-data/medical/recurrent-pancreatitis.json": [
		873270,
		3,
		873270
	],
	"./education-center/structured-data/medical/recurrent-spontaneous-abortion": [
		261959,
		3,
		261959
	],
	"./education-center/structured-data/medical/recurrent-spontaneous-abortion.json": [
		261959,
		3,
		261959
	],
	"./education-center/structured-data/medical/recurrent-subcortical-infarcts": [
		596840,
		3,
		596840
	],
	"./education-center/structured-data/medical/recurrent-subcortical-infarcts.json": [
		596840,
		3,
		596840
	],
	"./education-center/structured-data/medical/reduced-delayed-hypersensitivity": [
		219727,
		3,
		219727
	],
	"./education-center/structured-data/medical/reduced-delayed-hypersensitivity.json": [
		219727,
		3,
		219727
	],
	"./education-center/structured-data/medical/reduced-factor-ix-activity": [
		889611,
		3,
		889611
	],
	"./education-center/structured-data/medical/reduced-factor-ix-activity.json": [
		889611,
		3,
		889611
	],
	"./education-center/structured-data/medical/reduced-muscle-fiber-perlecan": [
		863378,
		3,
		863378
	],
	"./education-center/structured-data/medical/reduced-muscle-fiber-perlecan.json": [
		863378,
		3,
		863378
	],
	"./education-center/structured-data/medical/reduced-phenylalanine-hydroxylase-level": [
		594031,
		3,
		594031
	],
	"./education-center/structured-data/medical/reduced-phenylalanine-hydroxylase-level.json": [
		594031,
		3,
		594031
	],
	"./education-center/structured-data/medical/reduced-protein-c-activity": [
		863573,
		3,
		863573
	],
	"./education-center/structured-data/medical/reduced-protein-c-activity.json": [
		863573,
		3,
		863573
	],
	"./education-center/structured-data/medical/reduced-serum-alpha-1-antitrypsin": [
		55451,
		3,
		55451
	],
	"./education-center/structured-data/medical/reduced-serum-alpha-1-antitrypsin.json": [
		55451,
		3,
		55451
	],
	"./education-center/structured-data/medical/reduced-von-willebrand-factor-activity": [
		273367,
		3,
		273367
	],
	"./education-center/structured-data/medical/reduced-von-willebrand-factor-activity.json": [
		273367,
		3,
		273367
	],
	"./education-center/structured-data/medical/refractory-anemia-ringed-sideroblasts-clinical": [
		823219,
		3,
		823219
	],
	"./education-center/structured-data/medical/refractory-anemia-ringed-sideroblasts-clinical.json": [
		823219,
		3,
		823219
	],
	"./education-center/structured-data/medical/refractory-epilepsy": [
		215624,
		3,
		215624
	],
	"./education-center/structured-data/medical/refractory-epilepsy.json": [
		215624,
		3,
		215624
	],
	"./education-center/structured-data/medical/refsum-disease-adult-1": [
		571074,
		3,
		819567
	],
	"./education-center/structured-data/medical/refsum-disease-adult-1.json": [
		571074,
		3,
		819567
	],
	"./education-center/structured-data/medical/regorafenib-response": [
		658401,
		3,
		658401
	],
	"./education-center/structured-data/medical/regorafenib-response.json": [
		658401,
		3,
		658401
	],
	"./education-center/structured-data/medical/regression-motor-development-severe-dystonia-and-corresponding-basal-ganglia-lesions": [
		660703,
		3,
		660703
	],
	"./education-center/structured-data/medical/regression-motor-development-severe-dystonia-and-corresponding-basal-ganglia-lesions.json": [
		660703,
		3,
		660703
	],
	"./education-center/structured-data/medical/renal-cell-carcinoma-paraneoplastic-erythrocytosis": [
		277586,
		3,
		277586
	],
	"./education-center/structured-data/medical/renal-cell-carcinoma-paraneoplastic-erythrocytosis.json": [
		277586,
		3,
		277586
	],
	"./education-center/structured-data/medical/renal-coloboma-syndrome": [
		813604,
		3,
		813604
	],
	"./education-center/structured-data/medical/renal-coloboma-syndrome.json": [
		813604,
		3,
		813604
	],
	"./education-center/structured-data/medical/renal-cortical-hyperechogenicity": [
		857239,
		3,
		857239
	],
	"./education-center/structured-data/medical/renal-cortical-hyperechogenicity.json": [
		857239,
		3,
		857239
	],
	"./education-center/structured-data/medical/renal-cysts-and-diabetes-syndrome": [
		149977,
		3,
		149977
	],
	"./education-center/structured-data/medical/renal-cysts-and-diabetes-syndrome.json": [
		149977,
		3,
		149977
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-2": [
		425531,
		3,
		425531
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-2.json": [
		425531,
		3,
		425531
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-dominant": [
		764065,
		3,
		764065
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-dominant.json": [
		764065,
		3,
		764065
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-recessive": [
		705954,
		3,
		705954
	],
	"./education-center/structured-data/medical/renal-hypomagnesemia-recessive.json": [
		705954,
		3,
		705954
	],
	"./education-center/structured-data/medical/renal-hypoplasiaaplasia": [
		319517,
		3,
		319517
	],
	"./education-center/structured-data/medical/renal-hypoplasiaaplasia.json": [
		319517,
		3,
		319517
	],
	"./education-center/structured-data/medical/renal-insufficiency": [
		865847,
		3,
		865847
	],
	"./education-center/structured-data/medical/renal-insufficiency.json": [
		865847,
		3,
		865847
	],
	"./education-center/structured-data/medical/renal-transitional-cell-carcinoma": [
		619002,
		3,
		619002
	],
	"./education-center/structured-data/medical/renal-transitional-cell-carcinoma.json": [
		619002,
		3,
		619002
	],
	"./education-center/structured-data/medical/renal-tubular-acidosis-distal-normal-red-cell-morphology": [
		270318,
		3,
		270318
	],
	"./education-center/structured-data/medical/renal-tubular-acidosis-distal-normal-red-cell-morphology.json": [
		270318,
		3,
		270318
	],
	"./education-center/structured-data/medical/renal-tubular-epithelial-cell-apoptosis": [
		991338,
		3,
		991338
	],
	"./education-center/structured-data/medical/renal-tubular-epithelial-cell-apoptosis.json": [
		991338,
		3,
		991338
	],
	"./education-center/structured-data/medical/renier-gabreels-jasper-syndrome": [
		601313,
		3,
		601313
	],
	"./education-center/structured-data/medical/renier-gabreels-jasper-syndrome.json": [
		601313,
		3,
		601313
	],
	"./education-center/structured-data/medical/repeat-number-microsatellite": [
		662977,
		3,
		662977
	],
	"./education-center/structured-data/medical/repeat-number-microsatellite.json": [
		662977,
		3,
		662977
	],
	"./education-center/structured-data/medical/resistance-hepatitis-c-virus": [
		270136,
		3,
		270136
	],
	"./education-center/structured-data/medical/resistance-hepatitis-c-virus.json": [
		270136,
		3,
		270136
	],
	"./education-center/structured-data/medical/respiratory-infections-recurrent-and-failure-thrive-or-without-diarrhea": [
		831666,
		3,
		831666
	],
	"./education-center/structured-data/medical/respiratory-infections-recurrent-and-failure-thrive-or-without-diarrhea.json": [
		831666,
		3,
		831666
	],
	"./education-center/structured-data/medical/resting-heart-rate": [
		893611,
		3,
		893611
	],
	"./education-center/structured-data/medical/resting-heart-rate.json": [
		893611,
		3,
		893611
	],
	"./education-center/structured-data/medical/retinal-arterial-macroaneurysm-supravascular-pulmonic-stenosis": [
		966666,
		3,
		966666
	],
	"./education-center/structured-data/medical/retinal-arterial-macroaneurysm-supravascular-pulmonic-stenosis.json": [
		966666,
		3,
		966666
	],
	"./education-center/structured-data/medical/retinal-atrophy": [
		401395,
		3,
		401395
	],
	"./education-center/structured-data/medical/retinal-atrophy.json": [
		401395,
		3,
		401395
	],
	"./education-center/structured-data/medical/retinal-degeneration-autosomal-recessive-clumped-pigment-type": [
		740880,
		3,
		740880
	],
	"./education-center/structured-data/medical/retinal-degeneration-autosomal-recessive-clumped-pigment-type.json": [
		740880,
		3,
		740880
	],
	"./education-center/structured-data/medical/retinal-detachment": [
		223356,
		3,
		223356
	],
	"./education-center/structured-data/medical/retinal-detachment.json": [
		223356,
		3,
		223356
	],
	"./education-center/structured-data/medical/retinal-dystrophy-and-microvillus-inclusion-disease": [
		468774,
		3,
		468774
	],
	"./education-center/structured-data/medical/retinal-dystrophy-and-microvillus-inclusion-disease.json": [
		468774,
		3,
		468774
	],
	"./education-center/structured-data/medical/retinal-dystrophy-early-onset-severe": [
		751627,
		3,
		751627
	],
	"./education-center/structured-data/medical/retinal-dystrophy-early-onset-severe-lrat-related": [
		315802,
		3,
		315802
	],
	"./education-center/structured-data/medical/retinal-dystrophy-early-onset-severe-lrat-related.json": [
		315802,
		3,
		315802
	],
	"./education-center/structured-data/medical/retinal-dystrophy-early-onset-severe.json": [
		751627,
		3,
		751627
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-39": [
		331239,
		3,
		331239
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-39.json": [
		331239,
		3,
		331239
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-4-autosomal-recessive": [
		210540,
		3,
		210540
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-4-autosomal-recessive.json": [
		210540,
		3,
		210540
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-43": [
		531908,
		3,
		531908
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-43.json": [
		531908,
		3,
		531908
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-6": [
		633093,
		3,
		633093
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-6.json": [
		633093,
		3,
		633093
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-61": [
		821198,
		3,
		821198
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-61.json": [
		821198,
		3,
		821198
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-7-digenic": [
		943792,
		3,
		943792
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-7-digenic.json": [
		943792,
		3,
		943792
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-dominant": [
		466408,
		3,
		466408
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-dominant.json": [
		466408,
		3,
		466408
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-dominantrecessive": [
		442804,
		3,
		442804
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-dominantrecessive.json": [
		442804,
		3,
		442804
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-juvenile-lrat-related": [
		68212,
		3,
		68212
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-juvenile-lrat-related.json": [
		68212,
		3,
		68212
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-recessive": [
		50284,
		3,
		50284
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-recessive.json": [
		50284,
		3,
		50284
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-x-linked-and-sinorespiratory-infections-or-without-deafness": [
		561947,
		3,
		561947
	],
	"./education-center/structured-data/medical/retinitis-pigmentosa-x-linked-and-sinorespiratory-infections-or-without-deafness.json": [
		561947,
		3,
		561947
	],
	"./education-center/structured-data/medical/retinitis-punctata-albescens-autosomal-dominant": [
		634033,
		3,
		634033
	],
	"./education-center/structured-data/medical/retinitis-punctata-albescens-autosomal-dominant.json": [
		634033,
		3,
		634033
	],
	"./education-center/structured-data/medical/retinoblastoma": [
		444098,
		3,
		444098
	],
	"./education-center/structured-data/medical/retinoblastoma.json": [
		444098,
		3,
		444098
	],
	"./education-center/structured-data/medical/retinopathy-prematurity": [
		363300,
		3,
		363300
	],
	"./education-center/structured-data/medical/retinopathy-prematurity.json": [
		363300,
		3,
		363300
	],
	"./education-center/structured-data/medical/rett-syndrome-zappella-variant": [
		973016,
		3,
		973016
	],
	"./education-center/structured-data/medical/rett-syndrome-zappella-variant.json": [
		973016,
		3,
		973016
	],
	"./education-center/structured-data/medical/rh-mod-blood-group-phenotype": [
		49149,
		3,
		49149
	],
	"./education-center/structured-data/medical/rh-mod-blood-group-phenotype.json": [
		49149,
		3,
		49149
	],
	"./education-center/structured-data/medical/rh-null-amorph-type": [
		243492,
		3,
		243492
	],
	"./education-center/structured-data/medical/rh-null-amorph-type.json": [
		243492,
		3,
		243492
	],
	"./education-center/structured-data/medical/rh-null-regulator-type": [
		60996,
		3,
		60996
	],
	"./education-center/structured-data/medical/rh-null-regulator-type.json": [
		60996,
		3,
		60996
	],
	"./education-center/structured-data/medical/rhabdomyosarcoma-somatic": [
		921626,
		3,
		921626
	],
	"./education-center/structured-data/medical/rhabdomyosarcoma-somatic.json": [
		921626,
		3,
		921626
	],
	"./education-center/structured-data/medical/rhd-negative": [
		211204,
		3,
		211204
	],
	"./education-center/structured-data/medical/rhd-negative.json": [
		211204,
		3,
		211204
	],
	"./education-center/structured-data/medical/rheumatic-heart-disease": [
		71636,
		3,
		71636
	],
	"./education-center/structured-data/medical/rheumatic-heart-disease.json": [
		71636,
		3,
		71636
	],
	"./education-center/structured-data/medical/rheumatoid-arthritis": [
		772398,
		3,
		772398
	],
	"./education-center/structured-data/medical/rheumatoid-arthritis-progression": [
		575783,
		3,
		575783
	],
	"./education-center/structured-data/medical/rheumatoid-arthritis-progression.json": [
		575783,
		3,
		575783
	],
	"./education-center/structured-data/medical/rheumatoid-arthritis.json": [
		772398,
		3,
		772398
	],
	"./education-center/structured-data/medical/rhizomelic-dysplasia-ain-naz-type": [
		487937,
		3,
		487937
	],
	"./education-center/structured-data/medical/rhizomelic-dysplasia-ain-naz-type.json": [
		487937,
		3,
		487937
	],
	"./education-center/structured-data/medical/ribavirin-response-efficacy": [
		766947,
		3,
		766947
	],
	"./education-center/structured-data/medical/ribavirin-response-efficacy.json": [
		766947,
		3,
		766947
	],
	"./education-center/structured-data/medical/right-ventricular-cardiomyopathy": [
		533861,
		3,
		533861
	],
	"./education-center/structured-data/medical/right-ventricular-cardiomyopathy.json": [
		533861,
		3,
		533861
	],
	"./education-center/structured-data/medical/rippling-muscle-disease-2-autosomal-recessive": [
		978837,
		3,
		978837
	],
	"./education-center/structured-data/medical/rippling-muscle-disease-2-autosomal-recessive.json": [
		978837,
		3,
		978837
	],
	"./education-center/structured-data/medical/rlbp1-related-disorders": [
		223549,
		3,
		223549
	],
	"./education-center/structured-data/medical/rlbp1-related-disorders.json": [
		223549,
		3,
		223549
	],
	"./education-center/structured-data/medical/robinow-syndrome-autosomal-recessive-aplasiahypoplasia-phalanges-and-metacarpalsmetatarsals": [
		37300,
		3,
		37300
	],
	"./education-center/structured-data/medical/robinow-syndrome-autosomal-recessive-aplasiahypoplasia-phalanges-and-metacarpalsmetatarsals.json": [
		37300,
		3,
		37300
	],
	"./education-center/structured-data/medical/robinow-syndrome-autosomal-recessive-brachy-syn-polydactyly": [
		70919,
		3,
		70919
	],
	"./education-center/structured-data/medical/robinow-syndrome-autosomal-recessive-brachy-syn-polydactyly.json": [
		70919,
		3,
		70919
	],
	"./education-center/structured-data/medical/rod-cone-dystrophy": [
		680711,
		3,
		680711
	],
	"./education-center/structured-data/medical/rod-cone-dystrophy.json": [
		680711,
		3,
		680711
	],
	"./education-center/structured-data/medical/rosuvastatin-response-efficacy": [
		948156,
		3,
		948156
	],
	"./education-center/structured-data/medical/rosuvastatin-response-efficacy.json": [
		948156,
		3,
		948156
	],
	"./education-center/structured-data/medical/rpe65-related-disorders": [
		716484,
		3,
		716484
	],
	"./education-center/structured-data/medical/rpe65-related-disorders.json": [
		716484,
		3,
		716484
	],
	"./education-center/structured-data/medical/rrm2b-related-mitochondrial-disease": [
		527707,
		3,
		527707
	],
	"./education-center/structured-data/medical/rrm2b-related-mitochondrial-disease.json": [
		527707,
		3,
		527707
	],
	"./education-center/structured-data/medical/ryr1-related-disorders": [
		879816,
		3,
		879816
	],
	"./education-center/structured-data/medical/ryr1-related-disorders.json": [
		879816,
		3,
		879816
	],
	"./education-center/structured-data/medical/sacral-defect-anterior-meningocele": [
		692591,
		3,
		692591
	],
	"./education-center/structured-data/medical/sacral-defect-anterior-meningocele.json": [
		692591,
		3,
		692591
	],
	"./education-center/structured-data/medical/saethre-chotzen-syndrome": [
		9413,
		3,
		9413
	],
	"./education-center/structured-data/medical/saethre-chotzen-syndrome-eyelid-anomalies": [
		107730,
		3,
		107730
	],
	"./education-center/structured-data/medical/saethre-chotzen-syndrome-eyelid-anomalies.json": [
		107730,
		3,
		107730
	],
	"./education-center/structured-data/medical/saethre-chotzen-syndrome.json": [
		9413,
		3,
		9413
	],
	"./education-center/structured-data/medical/saldino-mainzer-syndrome": [
		814584,
		3,
		814584
	],
	"./education-center/structured-data/medical/saldino-mainzer-syndrome.json": [
		814584,
		3,
		814584
	],
	"./education-center/structured-data/medical/sall4-related-spectrum-disorders": [
		662012,
		3,
		662012
	],
	"./education-center/structured-data/medical/sall4-related-spectrum-disorders.json": [
		662012,
		3,
		662012
	],
	"./education-center/structured-data/medical/salmeterol-response-efficacy": [
		545841,
		3,
		545841
	],
	"./education-center/structured-data/medical/salmeterol-response-efficacy.json": [
		545841,
		3,
		545841
	],
	"./education-center/structured-data/medical/sandhoff-disease-chronic": [
		981816,
		3,
		981816
	],
	"./education-center/structured-data/medical/sandhoff-disease-chronic.json": [
		981816,
		3,
		981816
	],
	"./education-center/structured-data/medical/sardinian-hpfh": [
		170526,
		3,
		170526
	],
	"./education-center/structured-data/medical/sardinian-hpfh.json": [
		170526,
		3,
		170526
	],
	"./education-center/structured-data/medical/scaphocephaly-and-axenfeld-rieger-anomaly": [
		61442,
		3,
		61442
	],
	"./education-center/structured-data/medical/scaphocephaly-and-axenfeld-rieger-anomaly.json": [
		61442,
		3,
		61442
	],
	"./education-center/structured-data/medical/scapular-winging": [
		133872,
		3,
		133872
	],
	"./education-center/structured-data/medical/scapular-winging.json": [
		133872,
		3,
		133872
	],
	"./education-center/structured-data/medical/scapuloperoneal-myopathy": [
		436809,
		3,
		436809
	],
	"./education-center/structured-data/medical/scapuloperoneal-myopathy.json": [
		436809,
		3,
		436809
	],
	"./education-center/structured-data/medical/scapuloperoneal-weakness": [
		492826,
		3,
		492826
	],
	"./education-center/structured-data/medical/scapuloperoneal-weakness.json": [
		492826,
		3,
		492826
	],
	"./education-center/structured-data/medical/schizophrenia-15": [
		702022,
		3,
		702022
	],
	"./education-center/structured-data/medical/schizophrenia-15.json": [
		702022,
		3,
		702022
	],
	"./education-center/structured-data/medical/schnyder-crystalline-corneal-dystrophy": [
		219834,
		3,
		219834
	],
	"./education-center/structured-data/medical/schnyder-crystalline-corneal-dystrophy.json": [
		219834,
		3,
		219834
	],
	"./education-center/structured-data/medical/schwannomatosis-1-somatic": [
		140736,
		3,
		140736
	],
	"./education-center/structured-data/medical/schwannomatosis-1-somatic.json": [
		140736,
		3,
		140736
	],
	"./education-center/structured-data/medical/scid-due-ada-deficiency-delayed-onset": [
		647258,
		3,
		647258
	],
	"./education-center/structured-data/medical/scid-due-ada-deficiency-delayed-onset.json": [
		647258,
		3,
		647258
	],
	"./education-center/structured-data/medical/scn2a-related-generalized-epilepsy-febrile-seizures-plus": [
		975406,
		3,
		975406
	],
	"./education-center/structured-data/medical/scn2a-related-generalized-epilepsy-febrile-seizures-plus.json": [
		975406,
		3,
		975406
	],
	"./education-center/structured-data/medical/scn5a-related-disorders": [
		214942,
		3,
		214942
	],
	"./education-center/structured-data/medical/scn5a-related-disorders.json": [
		214942,
		3,
		214942
	],
	"./education-center/structured-data/medical/scoliosis": [
		193271,
		3,
		193271
	],
	"./education-center/structured-data/medical/scoliosis.json": [
		193271,
		3,
		193271
	],
	"./education-center/structured-data/medical/sdhb-related-disorders": [
		140901,
		3,
		140901
	],
	"./education-center/structured-data/medical/sdhb-related-disorders.json": [
		140901,
		3,
		140901
	],
	"./education-center/structured-data/medical/seizures-benign-familial-infantile-6": [
		449249,
		3,
		449249
	],
	"./education-center/structured-data/medical/seizures-benign-familial-infantile-6.json": [
		449249,
		3,
		449249
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-1": [
		366214,
		3,
		366214
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-1-andor-myokymia": [
		468373,
		3,
		468373
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-1-andor-myokymia.json": [
		468373,
		3,
		468373
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-1.json": [
		366214,
		3,
		366214
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-2": [
		176734,
		3,
		176734
	],
	"./education-center/structured-data/medical/seizures-benign-familial-neonatal-2.json": [
		176734,
		3,
		176734
	],
	"./education-center/structured-data/medical/seizures-sensorineural-deafness-ataxia-intellectual-disability-and-electrolyte-imbalance-syndrome": [
		655940,
		3,
		655940
	],
	"./education-center/structured-data/medical/seizures-sensorineural-deafness-ataxia-intellectual-disability-and-electrolyte-imbalance-syndrome.json": [
		655940,
		3,
		655940
	],
	"./education-center/structured-data/medical/selective-pituitary-resistance-thyroid-hormone": [
		289059,
		3,
		289059
	],
	"./education-center/structured-data/medical/selective-pituitary-resistance-thyroid-hormone.json": [
		289059,
		3,
		289059
	],
	"./education-center/structured-data/medical/selective-tooth-agenesis": [
		379719,
		3,
		379719
	],
	"./education-center/structured-data/medical/selective-tooth-agenesis.json": [
		379719,
		3,
		379719
	],
	"./education-center/structured-data/medical/senior-loken-syndrome-1": [
		905044,
		3,
		905044
	],
	"./education-center/structured-data/medical/senior-loken-syndrome-1.json": [
		905044,
		3,
		905044
	],
	"./education-center/structured-data/medical/sensorimotor-neuropathy": [
		327612,
		3,
		614002
	],
	"./education-center/structured-data/medical/sensorimotor-neuropathy.json": [
		327612,
		3,
		614002
	],
	"./education-center/structured-data/medical/sensorineural-deafness-and-migraine": [
		530052,
		3,
		530052
	],
	"./education-center/structured-data/medical/sensorineural-deafness-and-migraine.json": [
		530052,
		3,
		530052
	],
	"./education-center/structured-data/medical/sensorineural-deafness-hypertrophic-cardiomyopathy": [
		443208,
		3,
		443208
	],
	"./education-center/structured-data/medical/sensorineural-deafness-hypertrophic-cardiomyopathy.json": [
		443208,
		3,
		443208
	],
	"./education-center/structured-data/medical/sensorineural-deafness-mild-renal-dysfunction": [
		398001,
		3,
		398001
	],
	"./education-center/structured-data/medical/sensorineural-deafness-mild-renal-dysfunction.json": [
		398001,
		3,
		398001
	],
	"./education-center/structured-data/medical/sensory-axonal-neuropathy": [
		570613,
		3,
		570613
	],
	"./education-center/structured-data/medical/sensory-axonal-neuropathy.json": [
		570613,
		3,
		570613
	],
	"./education-center/structured-data/medical/sensory-neuropathy-spastic-paraplegia": [
		218473,
		3,
		218473
	],
	"./education-center/structured-data/medical/sensory-neuropathy-spastic-paraplegia.json": [
		218473,
		3,
		218473
	],
	"./education-center/structured-data/medical/sepn1-related-disorders": [
		728442,
		3,
		728442
	],
	"./education-center/structured-data/medical/sepn1-related-disorders.json": [
		728442,
		3,
		728442
	],
	"./education-center/structured-data/medical/septooptic-dysplasia-mild": [
		70710,
		3,
		70710
	],
	"./education-center/structured-data/medical/septooptic-dysplasia-mild.json": [
		70710,
		3,
		70710
	],
	"./education-center/structured-data/medical/serum-level-adiponectin-1": [
		18295,
		3,
		18295
	],
	"./education-center/structured-data/medical/serum-level-adiponectin-1.json": [
		18295,
		3,
		18295
	],
	"./education-center/structured-data/medical/setx-related-disorders": [
		2766,
		3,
		2766
	],
	"./education-center/structured-data/medical/setx-related-disorders.json": [
		2766,
		3,
		2766
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-athabascan-type": [
		304375,
		3,
		304375
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-athabascan-type.json": [
		304375,
		3,
		304375
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-autosomal-recessive-t-cell-negative-b-cell-negative-nk-cell": [
		34601,
		3,
		34601
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-autosomal-recessive-t-cell-negative-b-cell-negative-nk-cell.json": [
		34601,
		3,
		34601
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-b-cell-negative": [
		672248,
		3,
		672248
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-b-cell-negative.json": [
		672248,
		3,
		672248
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-partial": [
		926651,
		3,
		926651
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-partial.json": [
		926651,
		3,
		926651
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-sensitivity-ionizing-radiation-due-nhej1-deficiency": [
		647556,
		3,
		647556
	],
	"./education-center/structured-data/medical/severe-combined-immunodeficiency-sensitivity-ionizing-radiation-due-nhej1-deficiency.json": [
		647556,
		3,
		647556
	],
	"./education-center/structured-data/medical/severe-global-developmental-delay": [
		817795,
		3,
		817795
	],
	"./education-center/structured-data/medical/severe-global-developmental-delay.json": [
		817795,
		3,
		817795
	],
	"./education-center/structured-data/medical/severe-hydrocephalus": [
		421345,
		3,
		421345
	],
	"./education-center/structured-data/medical/severe-hydrocephalus.json": [
		421345,
		3,
		421345
	],
	"./education-center/structured-data/medical/severe-intellectual-deficiency": [
		582406,
		3,
		582406
	],
	"./education-center/structured-data/medical/severe-intellectual-deficiency.json": [
		582406,
		3,
		582406
	],
	"./education-center/structured-data/medical/severe-lactic-acidosis": [
		780922,
		3,
		780922
	],
	"./education-center/structured-data/medical/severe-lactic-acidosis.json": [
		780922,
		3,
		780922
	],
	"./education-center/structured-data/medical/severe-neonatal-hypotonia-improving-age": [
		87831,
		3,
		87831
	],
	"./education-center/structured-data/medical/severe-neonatal-hypotonia-improving-age.json": [
		87831,
		3,
		87831
	],
	"./education-center/structured-data/medical/severe-postnatal-growth-retardation": [
		696127,
		3,
		696127
	],
	"./education-center/structured-data/medical/severe-postnatal-growth-retardation.json": [
		696127,
		3,
		696127
	],
	"./education-center/structured-data/medical/severe-sensorineural-hearing-impairment": [
		246387,
		3,
		246387
	],
	"./education-center/structured-data/medical/severe-sensorineural-hearing-impairment.json": [
		246387,
		3,
		246387
	],
	"./education-center/structured-data/medical/severe-short-limb-dwarfism": [
		612391,
		3,
		612391
	],
	"./education-center/structured-data/medical/severe-short-limb-dwarfism.json": [
		612391,
		3,
		612391
	],
	"./education-center/structured-data/medical/sex-cord-stromal-tumor": [
		866279,
		3,
		866279
	],
	"./education-center/structured-data/medical/sex-cord-stromal-tumor.json": [
		866279,
		3,
		866279
	],
	"./education-center/structured-data/medical/sex-hormone-binding-globulin-deficiency": [
		724456,
		3,
		724456
	],
	"./education-center/structured-data/medical/sex-hormone-binding-globulin-deficiency.json": [
		724456,
		3,
		724456
	],
	"./education-center/structured-data/medical/sex-reversal": [
		143642,
		3,
		143642
	],
	"./education-center/structured-data/medical/sex-reversal.json": [
		143642,
		3,
		143642
	],
	"./education-center/structured-data/medical/sh3tc2-related-disorders": [
		157487,
		3,
		157487
	],
	"./education-center/structured-data/medical/sh3tc2-related-disorders.json": [
		157487,
		3,
		157487
	],
	"./education-center/structured-data/medical/short-fetal-femur-length": [
		409948,
		3,
		409948
	],
	"./education-center/structured-data/medical/short-fetal-femur-length.json": [
		409948,
		3,
		409948
	],
	"./education-center/structured-data/medical/short-nose": [
		447541,
		3,
		447541
	],
	"./education-center/structured-data/medical/short-nose.json": [
		447541,
		3,
		447541
	],
	"./education-center/structured-data/medical/short-qt-syndrome": [
		683506,
		3,
		683506
	],
	"./education-center/structured-data/medical/short-qt-syndrome-4": [
		372642,
		3,
		372642
	],
	"./education-center/structured-data/medical/short-qt-syndrome-4.json": [
		372642,
		3,
		372642
	],
	"./education-center/structured-data/medical/short-qt-syndrome-5": [
		857273,
		3,
		857273
	],
	"./education-center/structured-data/medical/short-qt-syndrome-5.json": [
		857273,
		3,
		857273
	],
	"./education-center/structured-data/medical/short-qt-syndrome.json": [
		683506,
		3,
		683506
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-10-polydactyly": [
		969413,
		3,
		969413
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-10-polydactyly.json": [
		969413,
		3,
		969413
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-10-without-polydactyly": [
		789952,
		3,
		789952
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-10-without-polydactyly.json": [
		789952,
		3,
		789952
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-without-polydactyly": [
		761651,
		3,
		761651
	],
	"./education-center/structured-data/medical/short-rib-thoracic-dysplasia-without-polydactyly.json": [
		761651,
		3,
		761651
	],
	"./education-center/structured-data/medical/short-sleep-familial-natural-1": [
		641529,
		3,
		641529
	],
	"./education-center/structured-data/medical/short-sleep-familial-natural-1.json": [
		641529,
		3,
		641529
	],
	"./education-center/structured-data/medical/short-sleep-familial-natural-2": [
		139195,
		3,
		139195
	],
	"./education-center/structured-data/medical/short-sleep-familial-natural-2.json": [
		139195,
		3,
		139195
	],
	"./education-center/structured-data/medical/short-stature": [
		971658,
		3,
		971658
	],
	"./education-center/structured-data/medical/short-stature-and-advanced-bone-age": [
		560463,
		3,
		560463
	],
	"./education-center/structured-data/medical/short-stature-and-advanced-bone-age-early-onset-osteoarthritis": [
		805776,
		3,
		805776
	],
	"./education-center/structured-data/medical/short-stature-and-advanced-bone-age-early-onset-osteoarthritis.json": [
		805776,
		3,
		805776
	],
	"./education-center/structured-data/medical/short-stature-and-advanced-bone-age.json": [
		560463,
		3,
		560463
	],
	"./education-center/structured-data/medical/short-stature.json": [
		971658,
		3,
		971658
	],
	"./education-center/structured-data/medical/shoulder-girdle-muscle-weakness": [
		566439,
		3,
		566439
	],
	"./education-center/structured-data/medical/shoulder-girdle-muscle-weakness.json": [
		566439,
		3,
		566439
	],
	"./education-center/structured-data/medical/shoulder-subluxation": [
		705955,
		3,
		705955
	],
	"./education-center/structured-data/medical/shoulder-subluxation.json": [
		705955,
		3,
		705955
	],
	"./education-center/structured-data/medical/sickle-cell-hemoglobin-o-arab-disease": [
		37883,
		3,
		37883
	],
	"./education-center/structured-data/medical/sickle-cell-hemoglobin-o-arab-disease.json": [
		37883,
		3,
		37883
	],
	"./education-center/structured-data/medical/sideroblastic-anemia-1-late-onset": [
		526163,
		3,
		526163
	],
	"./education-center/structured-data/medical/sideroblastic-anemia-1-late-onset.json": [
		526163,
		3,
		526163
	],
	"./education-center/structured-data/medical/sideroblastic-anemia-and-ataxia": [
		179996,
		3,
		179996
	],
	"./education-center/structured-data/medical/sideroblastic-anemia-and-ataxia.json": [
		179996,
		3,
		179996
	],
	"./education-center/structured-data/medical/sigmoid-colon-cancer": [
		964519,
		3,
		964519
	],
	"./education-center/structured-data/medical/sigmoid-colon-cancer.json": [
		964519,
		3,
		964519
	],
	"./education-center/structured-data/medical/simplified-gyral-pattern": [
		4584,
		3,
		4584
	],
	"./education-center/structured-data/medical/simplified-gyral-pattern.json": [
		4584,
		3,
		4584
	],
	"./education-center/structured-data/medical/sinus-node-disease": [
		953625,
		3,
		953625
	],
	"./education-center/structured-data/medical/sinus-node-disease.json": [
		953625,
		3,
		953625
	],
	"./education-center/structured-data/medical/skeletal-dysplasia-acanthosis-nigricans": [
		548611,
		3,
		548611
	],
	"./education-center/structured-data/medical/skeletal-dysplasia-acanthosis-nigricans.json": [
		548611,
		3,
		548611
	],
	"./education-center/structured-data/medical/skeletal-muscle-glycogen-content-and-metabolism-quantitative-trait-locus": [
		311540,
		3,
		311540
	],
	"./education-center/structured-data/medical/skeletal-muscle-glycogen-content-and-metabolism-quantitative-trait-locus.json": [
		311540,
		3,
		311540
	],
	"./education-center/structured-data/medical/skeletal-myopathy-responsive-riboflavin": [
		675399,
		3,
		675399
	],
	"./education-center/structured-data/medical/skeletal-myopathy-responsive-riboflavin.json": [
		675399,
		3,
		675399
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-2-blond-hairfair-skin": [
		305238,
		3,
		305238
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-2-blond-hairfair-skin.json": [
		305238,
		3,
		305238
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-2-red-hairfair-skin": [
		143967,
		3,
		143967
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-2-red-hairfair-skin.json": [
		143967,
		3,
		143967
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-3-bluegreen-eyes": [
		59797,
		3,
		59797
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-3-bluegreen-eyes.json": [
		59797,
		3,
		59797
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-3-lightdark-skin": [
		947477,
		3,
		947477
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-3-lightdark-skin.json": [
		947477,
		3,
		947477
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-6-blondbrown-hair": [
		558092,
		3,
		558092
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-6-blondbrown-hair.json": [
		558092,
		3,
		558092
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-7-darklight-skin": [
		400391,
		3,
		400391
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-7-darklight-skin.json": [
		400391,
		3,
		400391
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-9-darklight-hair": [
		191383,
		3,
		191383
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-9-darklight-hair.json": [
		191383,
		3,
		191383
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-2": [
		868187,
		3,
		868187
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-2.json": [
		868187,
		3,
		868187
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-5": [
		778590,
		3,
		778590
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-5.json": [
		778590,
		3,
		778590
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-8": [
		218095,
		3,
		218095
	],
	"./education-center/structured-data/medical/skinhaireye-pigmentation-variation-8.json": [
		218095,
		3,
		218095
	],
	"./education-center/structured-data/medical/slc26a2-related-disorders": [
		688860,
		3,
		688860
	],
	"./education-center/structured-data/medical/slc26a2-related-disorders.json": [
		688860,
		3,
		688860
	],
	"./education-center/structured-data/medical/slc26a4-related-disorders": [
		415827,
		3,
		415827
	],
	"./education-center/structured-data/medical/slc26a4-related-disorders.json": [
		415827,
		3,
		415827
	],
	"./education-center/structured-data/medical/sleep-myoclonus": [
		815326,
		3,
		815326
	],
	"./education-center/structured-data/medical/sleep-myoclonus.json": [
		815326,
		3,
		815326
	],
	"./education-center/structured-data/medical/sleep-related-hypermotor-epilepsy": [
		324996,
		3,
		324996
	],
	"./education-center/structured-data/medical/sleep-related-hypermotor-epilepsy.json": [
		324996,
		3,
		324996
	],
	"./education-center/structured-data/medical/small-cell-carcinoma-ovary-hypercalcemic-type": [
		4472,
		3,
		4472
	],
	"./education-center/structured-data/medical/small-cell-carcinoma-ovary-hypercalcemic-type.json": [
		4472,
		3,
		4472
	],
	"./education-center/structured-data/medical/small-cervical-vertebral-bodies": [
		288935,
		3,
		288935
	],
	"./education-center/structured-data/medical/small-cervical-vertebral-bodies.json": [
		288935,
		3,
		288935
	],
	"./education-center/structured-data/medical/small-gestational-age": [
		723778,
		3,
		723778
	],
	"./education-center/structured-data/medical/small-gestational-age.json": [
		723778,
		3,
		723778
	],
	"./education-center/structured-data/medical/small-intestine-carcinoid": [
		245463,
		3,
		245463
	],
	"./education-center/structured-data/medical/small-intestine-carcinoid.json": [
		245463,
		3,
		245463
	],
	"./education-center/structured-data/medical/small-scrotum": [
		454551,
		3,
		454551
	],
	"./education-center/structured-data/medical/small-scrotum.json": [
		454551,
		3,
		454551
	],
	"./education-center/structured-data/medical/small-vessel-cerebrovascular-disease": [
		792798,
		3,
		792798
	],
	"./education-center/structured-data/medical/small-vessel-cerebrovascular-disease.json": [
		792798,
		3,
		792798
	],
	"./education-center/structured-data/medical/smith-magenis-syndrome": [
		798531,
		3,
		798531
	],
	"./education-center/structured-data/medical/smith-magenis-syndrome.json": [
		798531,
		3,
		798531
	],
	"./education-center/structured-data/medical/smoking-quantitative-trait-locus-3": [
		711562,
		3,
		711562
	],
	"./education-center/structured-data/medical/smoking-quantitative-trait-locus-3.json": [
		711562,
		3,
		711562
	],
	"./education-center/structured-data/medical/sodium-serum-level-quantitative-trait-locus-1": [
		159190,
		3,
		159190
	],
	"./education-center/structured-data/medical/sodium-serum-level-quantitative-trait-locus-1.json": [
		159190,
		3,
		159190
	],
	"./education-center/structured-data/medical/solitary-median-maxillary-central-incisor-syndrome": [
		938985,
		3,
		938985
	],
	"./education-center/structured-data/medical/solitary-median-maxillary-central-incisor-syndrome.json": [
		938985,
		3,
		938985
	],
	"./education-center/structured-data/medical/soluble-interleukin-6-receptor-serum-level-quantitative-trait-locus": [
		197353,
		3,
		197353
	],
	"./education-center/structured-data/medical/soluble-interleukin-6-receptor-serum-level-quantitative-trait-locus.json": [
		197353,
		3,
		197353
	],
	"./education-center/structured-data/medical/somatostatin-analog-resistance": [
		721781,
		3,
		721781
	],
	"./education-center/structured-data/medical/somatostatin-analog-resistance.json": [
		721781,
		3,
		721781
	],
	"./education-center/structured-data/medical/somatotroph-adenoma": [
		212916,
		3,
		212916
	],
	"./education-center/structured-data/medical/somatotroph-adenoma.json": [
		212916,
		3,
		212916
	],
	"./education-center/structured-data/medical/sorsby-fundus-dystrophy": [
		213338,
		3,
		213338
	],
	"./education-center/structured-data/medical/sorsby-fundus-dystrophy.json": [
		213338,
		3,
		213338
	],
	"./education-center/structured-data/medical/sotos-syndrome-1": [
		549857,
		3,
		549857
	],
	"./education-center/structured-data/medical/sotos-syndrome-1.json": [
		549857,
		3,
		549857
	],
	"./education-center/structured-data/medical/spastic-ataxia-1": [
		571148,
		3,
		571148
	],
	"./education-center/structured-data/medical/spastic-ataxia-1.json": [
		571148,
		3,
		571148
	],
	"./education-center/structured-data/medical/spastic-cerebral-palsy": [
		806509,
		3,
		806509
	],
	"./education-center/structured-data/medical/spastic-cerebral-palsy.json": [
		806509,
		3,
		806509
	],
	"./education-center/structured-data/medical/spastic-paraplegia-70-autosomal-recessive": [
		948862,
		3,
		948862
	],
	"./education-center/structured-data/medical/spastic-paraplegia-70-autosomal-recessive.json": [
		948862,
		3,
		948862
	],
	"./education-center/structured-data/medical/spastic-paraplegia-72-autosomal-dominant": [
		272434,
		3,
		272434
	],
	"./education-center/structured-data/medical/spastic-paraplegia-72-autosomal-dominant.json": [
		272434,
		3,
		272434
	],
	"./education-center/structured-data/medical/spastic-paraplegia-autosomal-dominant": [
		751227,
		3,
		751227
	],
	"./education-center/structured-data/medical/spastic-paraplegia-autosomal-dominant.json": [
		751227,
		3,
		751227
	],
	"./education-center/structured-data/medical/spastic-paraplegia-recessive": [
		854296,
		3,
		854296
	],
	"./education-center/structured-data/medical/spastic-paraplegia-recessive.json": [
		854296,
		3,
		854296
	],
	"./education-center/structured-data/medical/spastic-tetraparesis": [
		778558,
		3,
		778558
	],
	"./education-center/structured-data/medical/spastic-tetraparesis.json": [
		778558,
		3,
		778558
	],
	"./education-center/structured-data/medical/spata7-related-disorders": [
		892256,
		3,
		892256
	],
	"./education-center/structured-data/medical/spata7-related-disorders.json": [
		892256,
		3,
		892256
	],
	"./education-center/structured-data/medical/spermatogenesis-maturation-arrest": [
		547204,
		3,
		547204
	],
	"./education-center/structured-data/medical/spermatogenesis-maturation-arrest.json": [
		547204,
		3,
		547204
	],
	"./education-center/structured-data/medical/spermatogenic-failure-2": [
		743812,
		3,
		743812
	],
	"./education-center/structured-data/medical/spermatogenic-failure-2.json": [
		743812,
		3,
		743812
	],
	"./education-center/structured-data/medical/spermatogenic-failure-x-linked-7": [
		462260,
		3,
		462260
	],
	"./education-center/structured-data/medical/spermatogenic-failure-x-linked-7.json": [
		462260,
		3,
		462260
	],
	"./education-center/structured-data/medical/spherocytosis": [
		819083,
		3,
		819083
	],
	"./education-center/structured-data/medical/spherocytosis-dominant": [
		209268,
		3,
		209268
	],
	"./education-center/structured-data/medical/spherocytosis-dominant.json": [
		209268,
		3,
		209268
	],
	"./education-center/structured-data/medical/spherocytosis-recessive": [
		32352,
		3,
		32352
	],
	"./education-center/structured-data/medical/spherocytosis-recessive.json": [
		32352,
		3,
		32352
	],
	"./education-center/structured-data/medical/spherocytosis-type-1-autosomal-recessive": [
		275932,
		3,
		275932
	],
	"./education-center/structured-data/medical/spherocytosis-type-1-autosomal-recessive.json": [
		275932,
		3,
		275932
	],
	"./education-center/structured-data/medical/spherocytosis-type-3-autosomal-recessive": [
		373846,
		3,
		373846
	],
	"./education-center/structured-data/medical/spherocytosis-type-3-autosomal-recessive.json": [
		373846,
		3,
		373846
	],
	"./education-center/structured-data/medical/spherocytosis.json": [
		819083,
		3,
		819083
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy": [
		959183,
		3,
		959183
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy-dominant": [
		509630,
		3,
		509630
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy-dominant.json": [
		509630,
		3,
		509630
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy-lower-extremity-predominant-2-ad": [
		770187,
		3,
		770187
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy-lower-extremity-predominant-2-ad.json": [
		770187,
		3,
		770187
	],
	"./education-center/structured-data/medical/spinal-muscular-atrophy.json": [
		959183,
		3,
		959183
	],
	"./education-center/structured-data/medical/spinal-neurofibromas": [
		629091,
		3,
		629091
	],
	"./education-center/structured-data/medical/spinal-neurofibromas.json": [
		629091,
		3,
		629091
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-29": [
		984718,
		3,
		984718
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-29.json": [
		984718,
		3,
		984718
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-31": [
		593083,
		3,
		593083
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-31.json": [
		593083,
		3,
		593083
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-34": [
		459418,
		3,
		459418
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-type-34.json": [
		459418,
		3,
		459418
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-x-linked": [
		196399,
		3,
		196399
	],
	"./education-center/structured-data/medical/spinocerebellar-ataxia-x-linked.json": [
		196399,
		3,
		196399
	],
	"./education-center/structured-data/medical/spinocerebellar-atrophy": [
		66428,
		3,
		66428
	],
	"./education-center/structured-data/medical/spinocerebellar-atrophy.json": [
		66428,
		3,
		66428
	],
	"./education-center/structured-data/medical/spondylocostal-dysostosis": [
		848157,
		3,
		848157
	],
	"./education-center/structured-data/medical/spondylocostal-dysostosis-5": [
		438529,
		3,
		438529
	],
	"./education-center/structured-data/medical/spondylocostal-dysostosis-5.json": [
		438529,
		3,
		438529
	],
	"./education-center/structured-data/medical/spondylocostal-dysostosis.json": [
		848157,
		3,
		848157
	],
	"./education-center/structured-data/medical/spondyloepimetaphyseal-dysplasia-joint-laxity-type-1-fractures": [
		814122,
		3,
		814122
	],
	"./education-center/structured-data/medical/spondyloepimetaphyseal-dysplasia-joint-laxity-type-1-fractures.json": [
		814122,
		3,
		814122
	],
	"./education-center/structured-data/medical/spondyloepiphyseal-dysplasia-congenital-joint-dislocations": [
		600630,
		3,
		600630
	],
	"./education-center/structured-data/medical/spondyloepiphyseal-dysplasia-congenital-joint-dislocations.json": [
		600630,
		3,
		600630
	],
	"./education-center/structured-data/medical/spontaneous-recurrent-epistaxis": [
		981317,
		3,
		981317
	],
	"./education-center/structured-data/medical/spontaneous-recurrent-epistaxis.json": [
		981317,
		3,
		981317
	],
	"./education-center/structured-data/medical/sporadic-abdominal-aortic-aneurysm": [
		441131,
		3,
		441131
	],
	"./education-center/structured-data/medical/sporadic-abdominal-aortic-aneurysm.json": [
		441131,
		3,
		441131
	],
	"./education-center/structured-data/medical/sprinting-performance": [
		945231,
		3,
		945231
	],
	"./education-center/structured-data/medical/sprinting-performance.json": [
		945231,
		3,
		945231
	],
	"./education-center/structured-data/medical/squamous-cell-carcinoma-burn-scar-related-somatic": [
		295785,
		3,
		295785
	],
	"./education-center/structured-data/medical/squamous-cell-carcinoma-burn-scar-related-somatic.json": [
		295785,
		3,
		295785
	],
	"./education-center/structured-data/medical/squamous-cell-lung-carcinoma": [
		583646,
		3,
		583646
	],
	"./education-center/structured-data/medical/squamous-cell-lung-carcinoma.json": [
		583646,
		3,
		583646
	],
	"./education-center/structured-data/medical/stargardt-disease-dominant": [
		195115,
		3,
		195115
	],
	"./education-center/structured-data/medical/stargardt-disease-dominant.json": [
		195115,
		3,
		195115
	],
	"./education-center/structured-data/medical/stargardt-disease-recessive": [
		85387,
		3,
		85387
	],
	"./education-center/structured-data/medical/stargardt-disease-recessive.json": [
		85387,
		3,
		85387
	],
	"./education-center/structured-data/medical/statins-attenuated-cholesterol-lowering": [
		775292,
		3,
		775292
	],
	"./education-center/structured-data/medical/statins-attenuated-cholesterol-lowering.json": [
		775292,
		3,
		775292
	],
	"./education-center/structured-data/medical/stickler-syndrome-dominant": [
		112763,
		3,
		112763
	],
	"./education-center/structured-data/medical/stickler-syndrome-dominant.json": [
		112763,
		3,
		112763
	],
	"./education-center/structured-data/medical/stickler-syndrome-recessive": [
		253825,
		3,
		253825
	],
	"./education-center/structured-data/medical/stickler-syndrome-recessive.json": [
		253825,
		3,
		253825
	],
	"./education-center/structured-data/medical/stickler-syndrome-type-1": [
		696091,
		3,
		696091
	],
	"./education-center/structured-data/medical/stickler-syndrome-type-1.json": [
		696091,
		3,
		696091
	],
	"./education-center/structured-data/medical/striatal-degeneration": [
		988765,
		3,
		988765
	],
	"./education-center/structured-data/medical/striatal-degeneration.json": [
		988765,
		3,
		988765
	],
	"./education-center/structured-data/medical/striatal-necrosis-bilateral-dystonia": [
		598650,
		3,
		598650
	],
	"./education-center/structured-data/medical/striatal-necrosis-bilateral-dystonia.json": [
		598650,
		3,
		598650
	],
	"./education-center/structured-data/medical/subcortical-laminar-heterotopia-x-linked": [
		316562,
		3,
		316562
	],
	"./education-center/structured-data/medical/subcortical-laminar-heterotopia-x-linked.json": [
		316562,
		3,
		316562
	],
	"./education-center/structured-data/medical/sublingual-nitroglycerin-susceptibility-poor-response": [
		563503,
		3,
		563503
	],
	"./education-center/structured-data/medical/sublingual-nitroglycerin-susceptibility-poor-response.json": [
		563503,
		3,
		563503
	],
	"./education-center/structured-data/medical/subvalvular-aortic-stenosis": [
		182168,
		3,
		182168
	],
	"./education-center/structured-data/medical/subvalvular-aortic-stenosis.json": [
		182168,
		3,
		182168
	],
	"./education-center/structured-data/medical/sudden-unexplained-death": [
		79203,
		3,
		79203
	],
	"./education-center/structured-data/medical/sudden-unexplained-death-childhood": [
		560976,
		3,
		560976
	],
	"./education-center/structured-data/medical/sudden-unexplained-death-childhood.json": [
		560976,
		3,
		560976
	],
	"./education-center/structured-data/medical/sudden-unexplained-death.json": [
		79203,
		3,
		79203
	],
	"./education-center/structured-data/medical/sulfate-transporter-related-osteochondrodysplasia": [
		490623,
		3,
		490623
	],
	"./education-center/structured-data/medical/sulfate-transporter-related-osteochondrodysplasia.json": [
		490623,
		3,
		490623
	],
	"./education-center/structured-data/medical/superoxide-dismutase-elevated-extracellular": [
		115725,
		3,
		115725
	],
	"./education-center/structured-data/medical/superoxide-dismutase-elevated-extracellular.json": [
		115725,
		3,
		115725
	],
	"./education-center/structured-data/medical/susceptibility-hangover": [
		594521,
		3,
		594521
	],
	"./education-center/structured-data/medical/susceptibility-hangover.json": [
		594521,
		3,
		594521
	],
	"./education-center/structured-data/medical/susceptibility-leprosy-and-multibacillary-leprosy": [
		637538,
		3,
		637538
	],
	"./education-center/structured-data/medical/susceptibility-leprosy-and-multibacillary-leprosy.json": [
		637538,
		3,
		637538
	],
	"./education-center/structured-data/medical/susceptibility-neovascular-type-age-related-macular-degeneration": [
		256522,
		3,
		256522
	],
	"./education-center/structured-data/medical/susceptibility-neovascular-type-age-related-macular-degeneration.json": [
		256522,
		3,
		256522
	],
	"./education-center/structured-data/medical/susceptibility-nonalcoholic-fatty-liver-disease": [
		4080,
		3,
		4080
	],
	"./education-center/structured-data/medical/susceptibility-nonalcoholic-fatty-liver-disease.json": [
		4080,
		3,
		4080
	],
	"./education-center/structured-data/medical/susceptibility-progression-renal-failure-iga-nephropathy": [
		535184,
		3,
		535184
	],
	"./education-center/structured-data/medical/susceptibility-progression-renal-failure-iga-nephropathy.json": [
		535184,
		3,
		535184
	],
	"./education-center/structured-data/medical/susceptibility-severe-cutaneous-adverse-reaction": [
		707554,
		3,
		707554
	],
	"./education-center/structured-data/medical/susceptibility-severe-cutaneous-adverse-reaction.json": [
		707554,
		3,
		707554
	],
	"./education-center/structured-data/medical/sweat-chloride-elevation-without-cystic-fibrosis": [
		901354,
		3,
		901354
	],
	"./education-center/structured-data/medical/sweat-chloride-elevation-without-cystic-fibrosis.json": [
		901354,
		3,
		901354
	],
	"./education-center/structured-data/medical/symmetrical-dyschromatosis-extremities": [
		502513,
		3,
		502513
	],
	"./education-center/structured-data/medical/symmetrical-dyschromatosis-extremities.json": [
		502513,
		3,
		502513
	],
	"./education-center/structured-data/medical/symphalangism-affecting-proximal-phalanx-4th-finger": [
		489890,
		3,
		489890
	],
	"./education-center/structured-data/medical/symphalangism-affecting-proximal-phalanx-4th-finger.json": [
		489890,
		3,
		489890
	],
	"./education-center/structured-data/medical/syndrome-entercolitis-and-autoinflmmation-caused-mutation-nlrc4-scan4": [
		694125,
		3,
		694125
	],
	"./education-center/structured-data/medical/syndrome-entercolitis-and-autoinflmmation-caused-mutation-nlrc4-scan4.json": [
		694125,
		3,
		694125
	],
	"./education-center/structured-data/medical/syndrome-microcephaly-major-feature": [
		711812,
		3,
		711812
	],
	"./education-center/structured-data/medical/syndrome-microcephaly-major-feature.json": [
		711812,
		3,
		711812
	],
	"./education-center/structured-data/medical/syndromic-intellectual-disability": [
		278044,
		3,
		278044
	],
	"./education-center/structured-data/medical/syndromic-intellectual-disability.json": [
		278044,
		3,
		278044
	],
	"./education-center/structured-data/medical/syndromic-microphthalmia-dominant": [
		79787,
		3,
		79787
	],
	"./education-center/structured-data/medical/syndromic-microphthalmia-dominant.json": [
		79787,
		3,
		79787
	],
	"./education-center/structured-data/medical/syndromic-microphthalmia-recessive": [
		220813,
		3,
		220813
	],
	"./education-center/structured-data/medical/syndromic-microphthalmia-recessive.json": [
		220813,
		3,
		220813
	],
	"./education-center/structured-data/medical/synovial-plica-syndrome": [
		99014,
		3,
		99014
	],
	"./education-center/structured-data/medical/synovial-plica-syndrome.json": [
		99014,
		3,
		99014
	],
	"./education-center/structured-data/medical/systemic-autoinflammation": [
		366205,
		3,
		366205
	],
	"./education-center/structured-data/medical/systemic-autoinflammation.json": [
		366205,
		3,
		366205
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus": [
		192428,
		3,
		192428
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-association-susceptibility-10": [
		567091,
		3,
		567091
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-association-susceptibility-10.json": [
		567091,
		3,
		567091
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-resistance-1": [
		802279,
		3,
		802279
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-resistance-1.json": [
		802279,
		3,
		802279
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-susceptibility": [
		868293,
		3,
		868293
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus-susceptibility.json": [
		868293,
		3,
		868293
	],
	"./education-center/structured-data/medical/systemic-lupus-erythematosus.json": [
		192428,
		3,
		192428
	],
	"./education-center/structured-data/medical/systolic-heart-failure": [
		335154,
		3,
		335154
	],
	"./education-center/structured-data/medical/systolic-heart-failure.json": [
		335154,
		3,
		335154
	],
	"./education-center/structured-data/medical/tacrolimus-response": [
		329009,
		3,
		329009
	],
	"./education-center/structured-data/medical/tacrolimus-response.json": [
		329009,
		3,
		329009
	],
	"./education-center/structured-data/medical/tamoxifen-response": [
		346757,
		3,
		346757
	],
	"./education-center/structured-data/medical/tamoxifen-response.json": [
		346757,
		3,
		346757
	],
	"./education-center/structured-data/medical/tap1-deficiency-somatic": [
		157575,
		3,
		157575
	],
	"./education-center/structured-data/medical/tap1-deficiency-somatic.json": [
		157575,
		3,
		157575
	],
	"./education-center/structured-data/medical/tay-sachs-disease-juvenile": [
		640476,
		3,
		640476
	],
	"./education-center/structured-data/medical/tay-sachs-disease-juvenile.json": [
		640476,
		3,
		640476
	],
	"./education-center/structured-data/medical/tctn2-related-disorders": [
		983650,
		3,
		983650
	],
	"./education-center/structured-data/medical/tctn2-related-disorders.json": [
		983650,
		3,
		983650
	],
	"./education-center/structured-data/medical/tegafur-response": [
		629359,
		3,
		629359
	],
	"./education-center/structured-data/medical/tegafur-response.json": [
		629359,
		3,
		629359
	],
	"./education-center/structured-data/medical/telomere-length-mean-leukocyte": [
		217950,
		3,
		217950
	],
	"./education-center/structured-data/medical/telomere-length-mean-leukocyte.json": [
		217950,
		3,
		217950
	],
	"./education-center/structured-data/medical/teratoid-tumor-atypical": [
		590381,
		3,
		590381
	],
	"./education-center/structured-data/medical/teratoid-tumor-atypical.json": [
		590381,
		3,
		590381
	],
	"./education-center/structured-data/medical/testicular-atrophy": [
		897452,
		3,
		897452
	],
	"./education-center/structured-data/medical/testicular-atrophy.json": [
		897452,
		3,
		897452
	],
	"./education-center/structured-data/medical/thalassemia": [
		401139,
		3,
		401139
	],
	"./education-center/structured-data/medical/thalassemia.json": [
		401139,
		3,
		401139
	],
	"./education-center/structured-data/medical/thecoma-somatic": [
		595621,
		3,
		595621
	],
	"./education-center/structured-data/medical/thecoma-somatic.json": [
		595621,
		3,
		595621
	],
	"./education-center/structured-data/medical/thiamine-metabolism-dysfunction-syndrome": [
		569331,
		3,
		569331
	],
	"./education-center/structured-data/medical/thiamine-metabolism-dysfunction-syndrome.json": [
		569331,
		3,
		569331
	],
	"./education-center/structured-data/medical/thiamine-responsive-megaloblastic-anemia": [
		205134,
		3,
		205134
	],
	"./education-center/structured-data/medical/thiamine-responsive-megaloblastic-anemia.json": [
		205134,
		3,
		205134
	],
	"./education-center/structured-data/medical/thiopurine-response": [
		769349,
		3,
		769349
	],
	"./education-center/structured-data/medical/thiopurine-response.json": [
		769349,
		3,
		769349
	],
	"./education-center/structured-data/medical/thiopurines-poor-metabolism-2": [
		157796,
		3,
		157796
	],
	"./education-center/structured-data/medical/thiopurines-poor-metabolism-2.json": [
		157796,
		3,
		157796
	],
	"./education-center/structured-data/medical/third-degree-atrioventricular-block": [
		658190,
		3,
		658190
	],
	"./education-center/structured-data/medical/third-degree-atrioventricular-block.json": [
		658190,
		3,
		658190
	],
	"./education-center/structured-data/medical/thoracic-aortic-aneurysm": [
		426096,
		3,
		426096
	],
	"./education-center/structured-data/medical/thoracic-aortic-aneurysm.json": [
		426096,
		3,
		426096
	],
	"./education-center/structured-data/medical/three-vessel-coronary-disease": [
		55737,
		3,
		55737
	],
	"./education-center/structured-data/medical/three-vessel-coronary-disease.json": [
		55737,
		3,
		55737
	],
	"./education-center/structured-data/medical/thrombocythemia-2-somatic": [
		388577,
		3,
		388577
	],
	"./education-center/structured-data/medical/thrombocythemia-2-somatic.json": [
		388577,
		3,
		388577
	],
	"./education-center/structured-data/medical/thrombocytopenia-x-linked-intermittent": [
		691499,
		3,
		691499
	],
	"./education-center/structured-data/medical/thrombocytopenia-x-linked-intermittent.json": [
		691499,
		3,
		691499
	],
	"./education-center/structured-data/medical/thrombophilia-13-x-linked-due-factor-viii-defect": [
		338006,
		3,
		338006
	],
	"./education-center/structured-data/medical/thrombophilia-13-x-linked-due-factor-viii-defect.json": [
		338006,
		3,
		338006
	],
	"./education-center/structured-data/medical/thrombotic-stroke": [
		249755,
		3,
		249755
	],
	"./education-center/structured-data/medical/thrombotic-stroke.json": [
		249755,
		3,
		249755
	],
	"./education-center/structured-data/medical/thrombus": [
		913230,
		3,
		913230
	],
	"./education-center/structured-data/medical/thrombus.json": [
		913230,
		3,
		913230
	],
	"./education-center/structured-data/medical/thymoma": [
		11765,
		3,
		11765
	],
	"./education-center/structured-data/medical/thymoma.json": [
		11765,
		3,
		11765
	],
	"./education-center/structured-data/medical/thyroid-adenoma-hyperfunctioning": [
		782039,
		3,
		782039
	],
	"./education-center/structured-data/medical/thyroid-adenoma-hyperfunctioning.json": [
		782039,
		3,
		782039
	],
	"./education-center/structured-data/medical/thyroid-carcinoma-sporadic-medullary": [
		664148,
		3,
		664148
	],
	"./education-center/structured-data/medical/thyroid-carcinoma-sporadic-medullary.json": [
		664148,
		3,
		664148
	],
	"./education-center/structured-data/medical/thyroid-dyshormonogenesis": [
		136210,
		3,
		136210
	],
	"./education-center/structured-data/medical/thyroid-dyshormonogenesis.json": [
		136210,
		3,
		136210
	],
	"./education-center/structured-data/medical/thyroid-gland-undifferentiated-anaplastic-carcinoma": [
		406986,
		3,
		406986
	],
	"./education-center/structured-data/medical/thyroid-gland-undifferentiated-anaplastic-carcinoma.json": [
		406986,
		3,
		406986
	],
	"./education-center/structured-data/medical/thyroid-hormone-resistance-syndrome": [
		311212,
		3,
		311212
	],
	"./education-center/structured-data/medical/thyroid-hormone-resistance-syndrome.json": [
		311212,
		3,
		311212
	],
	"./education-center/structured-data/medical/thyroid-hormonogenesis-defect": [
		578814,
		3,
		578814
	],
	"./education-center/structured-data/medical/thyroid-hormonogenesis-defect.json": [
		578814,
		3,
		578814
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-deficiency": [
		643360,
		3,
		643360
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-deficiency-partial": [
		912250,
		3,
		912250
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-deficiency-partial.json": [
		912250,
		3,
		912250
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-deficiency.json": [
		643360,
		3,
		643360
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-quantitative-trait-locus": [
		308074,
		3,
		308074
	],
	"./education-center/structured-data/medical/thyroxine-binding-globulin-quantitative-trait-locus.json": [
		308074,
		3,
		308074
	],
	"./education-center/structured-data/medical/tibial-pseudarthrosis": [
		737899,
		3,
		737899
	],
	"./education-center/structured-data/medical/tibial-pseudarthrosis.json": [
		737899,
		3,
		737899
	],
	"./education-center/structured-data/medical/tietz-syndrome": [
		62439,
		3,
		62439
	],
	"./education-center/structured-data/medical/tietz-syndrome.json": [
		62439,
		3,
		62439
	],
	"./education-center/structured-data/medical/tip-toe-gait": [
		89192,
		3,
		89192
	],
	"./education-center/structured-data/medical/tip-toe-gait.json": [
		89192,
		3,
		89192
	],
	"./education-center/structured-data/medical/tmem67-related-disorders": [
		448372,
		3,
		448372
	],
	"./education-center/structured-data/medical/tmem67-related-disorders.json": [
		448372,
		3,
		448372
	],
	"./education-center/structured-data/medical/tnf-receptor-associated-periodic-fever-syndrome-traps": [
		304511,
		3,
		304511
	],
	"./education-center/structured-data/medical/tnf-receptor-associated-periodic-fever-syndrome-traps.json": [
		304511,
		3,
		304511
	],
	"./education-center/structured-data/medical/tnf-receptor-binding-altered": [
		338534,
		3,
		338534
	],
	"./education-center/structured-data/medical/tnf-receptor-binding-altered.json": [
		338534,
		3,
		338534
	],
	"./education-center/structured-data/medical/tolbutamide-response": [
		943919,
		3,
		943919
	],
	"./education-center/structured-data/medical/tolbutamide-response.json": [
		943919,
		3,
		943919
	],
	"./education-center/structured-data/medical/tooth-agenesis": [
		863005,
		3,
		863005
	],
	"./education-center/structured-data/medical/tooth-agenesis-selective-1": [
		705843,
		3,
		705843
	],
	"./education-center/structured-data/medical/tooth-agenesis-selective-1.json": [
		705843,
		3,
		705843
	],
	"./education-center/structured-data/medical/tooth-agenesis-selective-4": [
		495096,
		3,
		495096
	],
	"./education-center/structured-data/medical/tooth-agenesis-selective-4.json": [
		495096,
		3,
		495096
	],
	"./education-center/structured-data/medical/tooth-agenesis.json": [
		863005,
		3,
		863005
	],
	"./education-center/structured-data/medical/torsion-dystonia-4": [
		897039,
		3,
		897039
	],
	"./education-center/structured-data/medical/torsion-dystonia-4.json": [
		897039,
		3,
		897039
	],
	"./education-center/structured-data/medical/tourette-syndrome": [
		467782,
		3,
		948994
	],
	"./education-center/structured-data/medical/tourette-syndrome.json": [
		467782,
		3,
		948994
	],
	"./education-center/structured-data/medical/townes-brocks-branchiootorenal-syndrome": [
		39538,
		3,
		39538
	],
	"./education-center/structured-data/medical/townes-brocks-branchiootorenal-syndrome.json": [
		39538,
		3,
		39538
	],
	"./education-center/structured-data/medical/townes-syndrome": [
		396811,
		3,
		396811
	],
	"./education-center/structured-data/medical/townes-syndrome.json": [
		396811,
		3,
		396811
	],
	"./education-center/structured-data/medical/tp63-related-spectrum-disorders": [
		888579,
		3,
		888579
	],
	"./education-center/structured-data/medical/tp63-related-spectrum-disorders.json": [
		888579,
		3,
		888579
	],
	"./education-center/structured-data/medical/tpm2-related-cap-myopathy": [
		626413,
		3,
		626413
	],
	"./education-center/structured-data/medical/tpm2-related-cap-myopathy.json": [
		626413,
		3,
		626413
	],
	"./education-center/structured-data/medical/tramadol-response": [
		792457,
		3,
		792457
	],
	"./education-center/structured-data/medical/tramadol-response.json": [
		792457,
		3,
		792457
	],
	"./education-center/structured-data/medical/transferrin-serum-level-quantitative-trait-locus-2": [
		191346,
		3,
		191346
	],
	"./education-center/structured-data/medical/transferrin-serum-level-quantitative-trait-locus-2.json": [
		191346,
		3,
		191346
	],
	"./education-center/structured-data/medical/transient-hyperlipidemia": [
		670964,
		3,
		670964
	],
	"./education-center/structured-data/medical/transient-hyperlipidemia.json": [
		670964,
		3,
		670964
	],
	"./education-center/structured-data/medical/transient-myeloproliferative-disorder-down-syndrome": [
		584887,
		3,
		584887
	],
	"./education-center/structured-data/medical/transient-myeloproliferative-disorder-down-syndrome.json": [
		584887,
		3,
		584887
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-dominant": [
		263366,
		3,
		263366
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-dominant.json": [
		263366,
		3,
		263366
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-dominantrecessive": [
		444117,
		3,
		444117
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-dominantrecessive.json": [
		444117,
		3,
		444117
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-recessive": [
		516279,
		3,
		516279
	],
	"./education-center/structured-data/medical/transient-neonatal-diabetes-recessive.json": [
		516279,
		3,
		516279
	],
	"./education-center/structured-data/medical/transitional-cell-carcinoma-bladder": [
		896534,
		3,
		896534
	],
	"./education-center/structured-data/medical/transitional-cell-carcinoma-bladder.json": [
		896534,
		3,
		896534
	],
	"./education-center/structured-data/medical/transposition-great-arteries": [
		684022,
		3,
		684022
	],
	"./education-center/structured-data/medical/transposition-great-arteries.json": [
		684022,
		3,
		684022
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-1": [
		888526,
		3,
		888526
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-1.json": [
		888526,
		3,
		888526
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-dominant": [
		158102,
		3,
		158102
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-dominant.json": [
		158102,
		3,
		158102
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-recessive": [
		511266,
		3,
		511266
	],
	"./education-center/structured-data/medical/treacher-collins-syndrome-recessive.json": [
		511266,
		3,
		511266
	],
	"./education-center/structured-data/medical/tretinoin-response": [
		132449,
		3,
		132449
	],
	"./education-center/structured-data/medical/tretinoin-response.json": [
		132449,
		3,
		132449
	],
	"./education-center/structured-data/medical/trichothiodystrophy-5-nonphotosensitive": [
		249325,
		3,
		249325
	],
	"./education-center/structured-data/medical/trichothiodystrophy-5-nonphotosensitive.json": [
		249325,
		3,
		249325
	],
	"./education-center/structured-data/medical/trichotillomania": [
		77104,
		3,
		77104
	],
	"./education-center/structured-data/medical/trichotillomania.json": [
		77104,
		3,
		77104
	],
	"./education-center/structured-data/medical/trifascicular-block-electrocardiogram": [
		457343,
		3,
		457343
	],
	"./education-center/structured-data/medical/trifascicular-block-electrocardiogram.json": [
		457343,
		3,
		457343
	],
	"./education-center/structured-data/medical/trigonocephaly": [
		241386,
		3,
		241386
	],
	"./education-center/structured-data/medical/trigonocephaly.json": [
		241386,
		3,
		241386
	],
	"./education-center/structured-data/medical/triosephosphate-isomerase-manchester": [
		120689,
		3,
		120689
	],
	"./education-center/structured-data/medical/triosephosphate-isomerase-manchester.json": [
		120689,
		3,
		120689
	],
	"./education-center/structured-data/medical/triphalangeal-thumb": [
		781568,
		3,
		781568
	],
	"./education-center/structured-data/medical/triphalangeal-thumb.json": [
		781568,
		3,
		781568
	],
	"./education-center/structured-data/medical/triple-negative-breast-cancer": [
		116627,
		3,
		116627
	],
	"./education-center/structured-data/medical/triple-negative-breast-cancer-finding": [
		446480,
		3,
		446480
	],
	"./education-center/structured-data/medical/triple-negative-breast-cancer-finding.json": [
		446480,
		3,
		446480
	],
	"./education-center/structured-data/medical/triple-negative-breast-cancer.json": [
		116627,
		3,
		116627
	],
	"./education-center/structured-data/medical/triple-negative-breast-carcinoma": [
		82949,
		3,
		82949
	],
	"./education-center/structured-data/medical/triple-negative-breast-carcinoma.json": [
		82949,
		3,
		82949
	],
	"./education-center/structured-data/medical/trit1-deficiency": [
		301521,
		3,
		301521
	],
	"./education-center/structured-data/medical/trit1-deficiency.json": [
		301521,
		3,
		301521
	],
	"./education-center/structured-data/medical/trpm4-related-disorders": [
		351958,
		3,
		351958
	],
	"./education-center/structured-data/medical/trpm4-related-disorders.json": [
		351958,
		3,
		351958
	],
	"./education-center/structured-data/medical/tryptophan-5-monooxygenase-deficiency": [
		182862,
		3,
		182862
	],
	"./education-center/structured-data/medical/tryptophan-5-monooxygenase-deficiency.json": [
		182862,
		3,
		182862
	],
	"./education-center/structured-data/medical/tuberculosis-susceptibility": [
		376821,
		3,
		376821
	],
	"./education-center/structured-data/medical/tuberculosis-susceptibility.json": [
		376821,
		3,
		376821
	],
	"./education-center/structured-data/medical/tuberous-sclerosis-and-lymphangiomyomatosis": [
		689974,
		3,
		689974
	],
	"./education-center/structured-data/medical/tuberous-sclerosis-and-lymphangiomyomatosis.json": [
		689974,
		3,
		689974
	],
	"./education-center/structured-data/medical/twist1-related-craniosynostosis": [
		637390,
		3,
		637390
	],
	"./education-center/structured-data/medical/twist1-related-craniosynostosis.json": [
		637390,
		3,
		637390
	],
	"./education-center/structured-data/medical/type-1-diabetes-mellitus-2": [
		990314,
		3,
		990314
	],
	"./education-center/structured-data/medical/type-1-diabetes-mellitus-2.json": [
		990314,
		3,
		990314
	],
	"./education-center/structured-data/medical/type-2-diabetes-mellitus-1-susceptibility": [
		735501,
		3,
		735501
	],
	"./education-center/structured-data/medical/type-2-diabetes-mellitus-1-susceptibility.json": [
		735501,
		3,
		735501
	],
	"./education-center/structured-data/medical/type-i-truncus-arteriosus": [
		926972,
		3,
		926972
	],
	"./education-center/structured-data/medical/type-i-truncus-arteriosus.json": [
		926972,
		3,
		926972
	],
	"./education-center/structured-data/medical/type-ii-collagenopathies": [
		947379,
		3,
		947379
	],
	"./education-center/structured-data/medical/type-ii-collagenopathies.json": [
		947379,
		3,
		947379
	],
	"./education-center/structured-data/medical/tyrosine-kinase-inhibitor-response": [
		279365,
		3,
		279365
	],
	"./education-center/structured-data/medical/tyrosine-kinase-inhibitor-response.json": [
		279365,
		3,
		279365
	],
	"./education-center/structured-data/medical/ullrich-congenital-muscular-dystrophy": [
		828053,
		3,
		828053
	],
	"./education-center/structured-data/medical/ullrich-congenital-muscular-dystrophy-1-autosomal-dominant": [
		28691,
		3,
		28691
	],
	"./education-center/structured-data/medical/ullrich-congenital-muscular-dystrophy-1-autosomal-dominant.json": [
		28691,
		3,
		28691
	],
	"./education-center/structured-data/medical/ullrich-congenital-muscular-dystrophy.json": [
		828053,
		3,
		828053
	],
	"./education-center/structured-data/medical/ulnar-deviation-wrist": [
		571394,
		3,
		571394
	],
	"./education-center/structured-data/medical/ulnar-deviation-wrist.json": [
		571394,
		3,
		571394
	],
	"./education-center/structured-data/medical/unilateral-deafness": [
		59523,
		3,
		59523
	],
	"./education-center/structured-data/medical/unilateral-deafness.json": [
		59523,
		3,
		59523
	],
	"./education-center/structured-data/medical/unilateral-microphthalmos": [
		367207,
		3,
		367207
	],
	"./education-center/structured-data/medical/unilateral-microphthalmos.json": [
		367207,
		3,
		367207
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-1": [
		259974,
		3,
		259974
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-1.json": [
		259974,
		3,
		259974
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-2": [
		218603,
		3,
		218603
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-2.json": [
		218603,
		3,
		218603
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-4": [
		675769,
		3,
		675769
	],
	"./education-center/structured-data/medical/uric-acid-concentration-serum-quantitative-trait-locus-4.json": [
		675769,
		3,
		675769
	],
	"./education-center/structured-data/medical/ush2a-related-disorders": [
		974921,
		3,
		974921
	],
	"./education-center/structured-data/medical/ush2a-related-disorders.json": [
		974921,
		3,
		974921
	],
	"./education-center/structured-data/medical/usher-syndrome-type-idf-digenic": [
		780803,
		3,
		780803
	],
	"./education-center/structured-data/medical/usher-syndrome-type-idf-digenic.json": [
		780803,
		3,
		780803
	],
	"./education-center/structured-data/medical/usher-syndrome-type-iic-gpr98pdzd7-digenic": [
		196547,
		3,
		196547
	],
	"./education-center/structured-data/medical/usher-syndrome-type-iic-gpr98pdzd7-digenic.json": [
		196547,
		3,
		196547
	],
	"./education-center/structured-data/medical/uterine-carcinosarcoma": [
		938714,
		3,
		938714
	],
	"./education-center/structured-data/medical/uterine-carcinosarcoma.json": [
		938714,
		3,
		938714
	],
	"./education-center/structured-data/medical/uterine-corpus-cancer": [
		986635,
		3,
		986635
	],
	"./education-center/structured-data/medical/uterine-corpus-cancer.json": [
		986635,
		3,
		986635
	],
	"./education-center/structured-data/medical/uterine-leiomyoma": [
		815869,
		3,
		815869
	],
	"./education-center/structured-data/medical/uterine-leiomyoma.json": [
		815869,
		3,
		815869
	],
	"./education-center/structured-data/medical/uveal-coloboma-cleft-lip-and-palate-intellectual-disability": [
		227843,
		3,
		227843
	],
	"./education-center/structured-data/medical/uveal-coloboma-cleft-lip-and-palate-intellectual-disability.json": [
		227843,
		3,
		227843
	],
	"./education-center/structured-data/medical/uveal-melanoma": [
		855710,
		3,
		855710
	],
	"./education-center/structured-data/medical/uveal-melanoma.json": [
		855710,
		3,
		855710
	],
	"./education-center/structured-data/medical/vacterl-association": [
		84393,
		3,
		84393
	],
	"./education-center/structured-data/medical/vacterl-association.json": [
		84393,
		3,
		84393
	],
	"./education-center/structured-data/medical/van-der-woude-syndrome-1": [
		551431,
		3,
		551431
	],
	"./education-center/structured-data/medical/van-der-woude-syndrome-1.json": [
		551431,
		3,
		551431
	],
	"./education-center/structured-data/medical/variegate-porphyria-homozygous": [
		761008,
		3,
		761008
	],
	"./education-center/structured-data/medical/variegate-porphyria-homozygous.json": [
		761008,
		3,
		761008
	],
	"./education-center/structured-data/medical/vascular-dementia": [
		914514,
		3,
		914514
	],
	"./education-center/structured-data/medical/vascular-dementia.json": [
		914514,
		3,
		914514
	],
	"./education-center/structured-data/medical/vascular-endothelial-growth-factor-vegf-inhibitor-response": [
		505556,
		3,
		505556
	],
	"./education-center/structured-data/medical/vascular-endothelial-growth-factor-vegf-inhibitor-response.json": [
		505556,
		3,
		505556
	],
	"./education-center/structured-data/medical/vater-association-macrocephaly-and-ventriculomegaly": [
		938182,
		3,
		938182
	],
	"./education-center/structured-data/medical/vater-association-macrocephaly-and-ventriculomegaly.json": [
		938182,
		3,
		938182
	],
	"./education-center/structured-data/medical/vatervacterl-association-cns-malformations": [
		820243,
		3,
		820243
	],
	"./education-center/structured-data/medical/vatervacterl-association-cns-malformations.json": [
		820243,
		3,
		820243
	],
	"./education-center/structured-data/medical/vel-blood-group-system": [
		78713,
		3,
		78713
	],
	"./education-center/structured-data/medical/vel-blood-group-system.json": [
		78713,
		3,
		78713
	],
	"./education-center/structured-data/medical/venous-malformation": [
		852615,
		3,
		852615
	],
	"./education-center/structured-data/medical/venous-malformation.json": [
		852615,
		3,
		852615
	],
	"./education-center/structured-data/medical/venous-thromboembolism": [
		438762,
		3,
		438762
	],
	"./education-center/structured-data/medical/venous-thromboembolism-susceptibility": [
		834480,
		3,
		834480
	],
	"./education-center/structured-data/medical/venous-thromboembolism-susceptibility.json": [
		834480,
		3,
		834480
	],
	"./education-center/structured-data/medical/venous-thromboembolism.json": [
		438762,
		3,
		438762
	],
	"./education-center/structured-data/medical/venous-thrombosis-protection-against": [
		8252,
		3,
		8252
	],
	"./education-center/structured-data/medical/venous-thrombosis-protection-against.json": [
		8252,
		3,
		8252
	],
	"./education-center/structured-data/medical/venous-thrombosis-susceptibility": [
		994898,
		3,
		994898
	],
	"./education-center/structured-data/medical/venous-thrombosis-susceptibility.json": [
		994898,
		3,
		994898
	],
	"./education-center/structured-data/medical/ventricular-tachycardia-somatic": [
		446872,
		3,
		446872
	],
	"./education-center/structured-data/medical/ventricular-tachycardia-somatic.json": [
		446872,
		3,
		446872
	],
	"./education-center/structured-data/medical/ventriculomegaly": [
		301407,
		3,
		301407
	],
	"./education-center/structured-data/medical/ventriculomegaly-and-arthrogryposis": [
		188511,
		3,
		188511
	],
	"./education-center/structured-data/medical/ventriculomegaly-and-arthrogryposis.json": [
		188511,
		3,
		188511
	],
	"./education-center/structured-data/medical/ventriculomegaly-cystic-kidney-disease": [
		377365,
		3,
		377365
	],
	"./education-center/structured-data/medical/ventriculomegaly-cystic-kidney-disease.json": [
		377365,
		3,
		377365
	],
	"./education-center/structured-data/medical/ventriculomegaly.json": [
		301407,
		3,
		301407
	],
	"./education-center/structured-data/medical/very-long-chain-fatty-acid-accumulation": [
		541953,
		3,
		541953
	],
	"./education-center/structured-data/medical/very-long-chain-fatty-acid-accumulation.json": [
		541953,
		3,
		541953
	],
	"./education-center/structured-data/medical/vesicoureteral-reflux": [
		728381,
		3,
		728381
	],
	"./education-center/structured-data/medical/vesicoureteral-reflux.json": [
		728381,
		3,
		728381
	],
	"./education-center/structured-data/medical/vibratory-urticaria": [
		935121,
		3,
		935121
	],
	"./education-center/structured-data/medical/vibratory-urticaria.json": [
		935121,
		3,
		935121
	],
	"./education-center/structured-data/medical/virus-induced-diabetes": [
		735533,
		3,
		735533
	],
	"./education-center/structured-data/medical/virus-induced-diabetes.json": [
		735533,
		3,
		735533
	],
	"./education-center/structured-data/medical/vitamin-b12-plasma-level-quantitative-trait-locus-1": [
		287889,
		3,
		287889
	],
	"./education-center/structured-data/medical/vitamin-b12-plasma-level-quantitative-trait-locus-1.json": [
		287889,
		3,
		287889
	],
	"./education-center/structured-data/medical/vitamin-d-dependent-rickets-type-1": [
		604435,
		3,
		604435
	],
	"./education-center/structured-data/medical/vitamin-d-dependent-rickets-type-1.json": [
		604435,
		3,
		604435
	],
	"./education-center/structured-data/medical/vitamin-k-dependent-clotting-factors": [
		770637,
		3,
		770637
	],
	"./education-center/structured-data/medical/vitamin-k-dependent-clotting-factors.json": [
		770637,
		3,
		770637
	],
	"./education-center/structured-data/medical/vitelliform-macular-dystrophy": [
		699575,
		3,
		699575
	],
	"./education-center/structured-data/medical/vitelliform-macular-dystrophy-2": [
		552429,
		3,
		552429
	],
	"./education-center/structured-data/medical/vitelliform-macular-dystrophy-2.json": [
		552429,
		3,
		552429
	],
	"./education-center/structured-data/medical/vitelliform-macular-dystrophy.json": [
		699575,
		3,
		699575
	],
	"./education-center/structured-data/medical/vsx2-related-microphthalmia": [
		857948,
		3,
		857948
	],
	"./education-center/structured-data/medical/vsx2-related-microphthalmia.json": [
		857948,
		3,
		857948
	],
	"./education-center/structured-data/medical/vulvar-adenocarcinoma-mammary-gland-type": [
		74104,
		3,
		74104
	],
	"./education-center/structured-data/medical/vulvar-adenocarcinoma-mammary-gland-type.json": [
		74104,
		3,
		74104
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2a": [
		49480,
		3,
		49480
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2a.json": [
		49480,
		3,
		49480
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2e-neurologic-involvement": [
		508707,
		3,
		508707
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2e-neurologic-involvement.json": [
		508707,
		3,
		508707
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2e-without-neurologic-involvement": [
		780706,
		3,
		780706
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-2e-without-neurologic-involvement.json": [
		780706,
		3,
		780706
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-3": [
		373099,
		3,
		373099
	],
	"./education-center/structured-data/medical/waardenburg-syndrome-type-3.json": [
		373099,
		3,
		373099
	],
	"./education-center/structured-data/medical/wagner-syndrome": [
		558087,
		3,
		558087
	],
	"./education-center/structured-data/medical/wagner-syndrome.json": [
		558087,
		3,
		558087
	],
	"./education-center/structured-data/medical/walker-warburg-congenital-muscular-dystrophy": [
		706431,
		3,
		706431
	],
	"./education-center/structured-data/medical/walker-warburg-congenital-muscular-dystrophy.json": [
		706431,
		3,
		706431
	],
	"./education-center/structured-data/medical/warfarin-response": [
		489977,
		3,
		489977
	],
	"./education-center/structured-data/medical/warfarin-response-dosage": [
		331858,
		3,
		331858
	],
	"./education-center/structured-data/medical/warfarin-response-dosage.json": [
		331858,
		3,
		331858
	],
	"./education-center/structured-data/medical/warfarin-response-toxicityadr": [
		749013,
		3,
		749013
	],
	"./education-center/structured-data/medical/warfarin-response-toxicityadr.json": [
		749013,
		3,
		749013
	],
	"./education-center/structured-data/medical/warfarin-response.json": [
		489977,
		3,
		489977
	],
	"./education-center/structured-data/medical/warfarin-sensitivity-x-linked": [
		605050,
		3,
		605050
	],
	"./education-center/structured-data/medical/warfarin-sensitivity-x-linked.json": [
		605050,
		3,
		605050
	],
	"./education-center/structured-data/medical/wdr1-deficiency": [
		537075,
		3,
		537075
	],
	"./education-center/structured-data/medical/wdr1-deficiency.json": [
		537075,
		3,
		537075
	],
	"./education-center/structured-data/medical/wdr35-related-disorders": [
		855795,
		3,
		855795
	],
	"./education-center/structured-data/medical/wdr35-related-disorders.json": [
		855795,
		3,
		855795
	],
	"./education-center/structured-data/medical/weakness-facial-musculature": [
		139143,
		3,
		139143
	],
	"./education-center/structured-data/medical/weakness-facial-musculature.json": [
		139143,
		3,
		139143
	],
	"./education-center/structured-data/medical/wee1-inhibitor-response": [
		910980,
		3,
		910980
	],
	"./education-center/structured-data/medical/wee1-inhibitor-response.json": [
		910980,
		3,
		910980
	],
	"./education-center/structured-data/medical/wfs1-related-spectrum-disorders": [
		914663,
		3,
		914663
	],
	"./education-center/structured-data/medical/wfs1-related-spectrum-disorders.json": [
		914663,
		3,
		914663
	],
	"./education-center/structured-data/medical/white-blood-cell-count-quantitative-trait-locus-1": [
		851179,
		3,
		851179
	],
	"./education-center/structured-data/medical/white-blood-cell-count-quantitative-trait-locus-1.json": [
		851179,
		3,
		851179
	],
	"./education-center/structured-data/medical/wieacker-wolff-syndrome": [
		908326,
		3,
		908326
	],
	"./education-center/structured-data/medical/wieacker-wolff-syndrome.json": [
		908326,
		3,
		908326
	],
	"./education-center/structured-data/medical/wolff-parkinson-white-syndrome-childhood-onset": [
		512105,
		3,
		512105
	],
	"./education-center/structured-data/medical/wolff-parkinson-white-syndrome-childhood-onset.json": [
		512105,
		3,
		512105
	],
	"./education-center/structured-data/medical/woolly-hair-autosomal-recessive-2-or-without-hypotrichosis": [
		168657,
		3,
		168657
	],
	"./education-center/structured-data/medical/woolly-hair-autosomal-recessive-2-or-without-hypotrichosis.json": [
		168657,
		3,
		168657
	],
	"./education-center/structured-data/medical/worth-disease": [
		41750,
		3,
		41750
	],
	"./education-center/structured-data/medical/worth-disease.json": [
		41750,
		3,
		41750
	],
	"./education-center/structured-data/medical/wt1-related-disorders": [
		327840,
		3,
		327840
	],
	"./education-center/structured-data/medical/wt1-related-disorders.json": [
		327840,
		3,
		327840
	],
	"./education-center/structured-data/medical/x-linked-intellectual-disability-cabezas-type": [
		881348,
		3,
		881348
	],
	"./education-center/structured-data/medical/x-linked-intellectual-disability-cabezas-type.json": [
		881348,
		3,
		881348
	],
	"./education-center/structured-data/medical/x-linked-retinitis-pigmentosa": [
		762553,
		3,
		762553
	],
	"./education-center/structured-data/medical/x-linked-retinitis-pigmentosa.json": [
		762553,
		3,
		762553
	],
	"./education-center/structured-data/medical/xanthinuria": [
		727863,
		3,
		727863
	],
	"./education-center/structured-data/medical/xanthinuria-type-ii": [
		902319,
		3,
		902319
	],
	"./education-center/structured-data/medical/xanthinuria-type-ii.json": [
		902319,
		3,
		902319
	],
	"./education-center/structured-data/medical/xanthinuria.json": [
		727863,
		3,
		727863
	],
	"./education-center/structured-data/medical/zmpste24-related-disorders": [
		922150,
		3,
		922150
	],
	"./education-center/structured-data/medical/zmpste24-related-disorders.json": [
		922150,
		3,
		922150
	],
	"./education-center/structured-data/medical/zonular-pulverulent-cataract": [
		393729,
		3,
		393729
	],
	"./education-center/structured-data/medical/zonular-pulverulent-cataract.json": [
		393729,
		3,
		393729
	],
	"./education-center/structured-data/medication-side-effects": [
		829020,
		3,
		829020
	],
	"./education-center/structured-data/medication-side-effects/": [
		829020,
		3,
		829020
	],
	"./education-center/structured-data/medication-side-effects/dna-tests-medication-side-effects": [
		12596,
		3,
		12596
	],
	"./education-center/structured-data/medication-side-effects/dna-tests-medication-side-effects.json": [
		12596,
		3,
		12596
	],
	"./education-center/structured-data/medication-side-effects/effects-medicine-body": [
		365483,
		3,
		365483
	],
	"./education-center/structured-data/medication-side-effects/effects-medicine-body.json": [
		365483,
		3,
		365483
	],
	"./education-center/structured-data/medication-side-effects/how-long-do-side-effects-last": [
		948978,
		3,
		948978
	],
	"./education-center/structured-data/medication-side-effects/how-long-do-side-effects-last.json": [
		948978,
		3,
		948978
	],
	"./education-center/structured-data/medication-side-effects/how-quickly-side-effects-happen": [
		155248,
		3,
		155248
	],
	"./education-center/structured-data/medication-side-effects/how-quickly-side-effects-happen.json": [
		155248,
		3,
		155248
	],
	"./education-center/structured-data/medication-side-effects/how-to-reduce-side-effects-medicine": [
		798855,
		3,
		798855
	],
	"./education-center/structured-data/medication-side-effects/how-to-reduce-side-effects-medicine.json": [
		798855,
		3,
		798855
	],
	"./education-center/structured-data/medication-side-effects/index": [
		829020,
		3,
		829020
	],
	"./education-center/structured-data/medication-side-effects/index.json": [
		829020,
		3,
		829020
	],
	"./education-center/structured-data/medication-side-effects/what-do-when-medicines-have-side-effects": [
		643942,
		3,
		643942
	],
	"./education-center/structured-data/medication-side-effects/what-do-when-medicines-have-side-effects.json": [
		643942,
		3,
		643942
	],
	"./education-center/structured-data/node/16272": [
		198195,
		3,
		198195
	],
	"./education-center/structured-data/node/16272/": [
		198195,
		3,
		198195
	],
	"./education-center/structured-data/node/16272/index": [
		198195,
		3,
		198195
	],
	"./education-center/structured-data/node/16272/index.json": [
		198195,
		3,
		198195
	],
	"./education-center/structured-data/outsmart-your-genes": [
		325571,
		3,
		325571
	],
	"./education-center/structured-data/outsmart-your-genes/": [
		325571,
		3,
		325571
	],
	"./education-center/structured-data/outsmart-your-genes/index": [
		325571,
		3,
		325571
	],
	"./education-center/structured-data/outsmart-your-genes/index.json": [
		325571,
		3,
		325571
	],
	"./education-center/structured-data/outsmart-your-genes/power-dna-testing-predictive-medicine": [
		632281,
		3,
		632281
	],
	"./education-center/structured-data/outsmart-your-genes/power-dna-testing-predictive-medicine.json": [
		632281,
		3,
		632281
	],
	"./education-center/structured-data/preventive-measures-breast-cancer": [
		471159,
		3,
		471159
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/": [
		471159,
		3,
		471159
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/breast-cancer-genetic-testing-cost": [
		874835,
		3,
		874835
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/breast-cancer-genetic-testing-cost.json": [
		874835,
		3,
		874835
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/breast-cancer-genetic-testing-pros-and-cons": [
		262920,
		3,
		262920
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/breast-cancer-genetic-testing-pros-and-cons.json": [
		262920,
		3,
		262920
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/dna-tests-breast-cancer-genetic-testing": [
		128080,
		3,
		128080
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/dna-tests-breast-cancer-genetic-testing.json": [
		128080,
		3,
		128080
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/genetic-testing-breast-cancer": [
		267885,
		3,
		267885
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/genetic-testing-breast-cancer.json": [
		267885,
		3,
		267885
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/home-genetic-testing-breast-cancer": [
		334626,
		3,
		334626
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/home-genetic-testing-breast-cancer.json": [
		334626,
		3,
		334626
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/index": [
		471159,
		3,
		471159
	],
	"./education-center/structured-data/preventive-measures-breast-cancer/index.json": [
		471159,
		3,
		471159
	],
	"./education-center/structured-data/sequencing": [
		547857,
		3,
		547857
	],
	"./education-center/structured-data/sequencing-education-center/definitions": [
		178447,
		3,
		178447
	],
	"./education-center/structured-data/sequencing-education-center/definitions/": [
		178447,
		3,
		178447
	],
	"./education-center/structured-data/sequencing-education-center/definitions/index": [
		178447,
		3,
		178447
	],
	"./education-center/structured-data/sequencing-education-center/definitions/index.json": [
		178447,
		3,
		178447
	],
	"./education-center/structured-data/sequencing-education-center/genetic-testing-disease/genetic-screening-ehlers-danlos-syndrome-eds": [
		259303,
		3,
		259303
	],
	"./education-center/structured-data/sequencing-education-center/genetic-testing-disease/genetic-screening-ehlers-danlos-syndrome-eds.json": [
		259303,
		3,
		259303
	],
	"./education-center/structured-data/sequencing.json": [
		547857,
		3,
		547857
	],
	"./education-center/structured-data/whole-genome-sequencing": [
		926935,
		3,
		926935
	],
	"./education-center/structured-data/whole-genome-sequencing/": [
		926935,
		3,
		926935
	],
	"./education-center/structured-data/whole-genome-sequencing/importance-whole-genome-sequencing": [
		974611,
		3,
		974611
	],
	"./education-center/structured-data/whole-genome-sequencing/importance-whole-genome-sequencing.json": [
		974611,
		3,
		974611
	],
	"./education-center/structured-data/whole-genome-sequencing/index": [
		926935,
		3,
		926935
	],
	"./education-center/structured-data/whole-genome-sequencing/index.json": [
		926935,
		3,
		926935
	],
	"./education-center/structured-data/whole-genome-sequencing/what-can-whole-genome-sequencing-detect": [
		892974,
		3,
		892974
	],
	"./education-center/structured-data/whole-genome-sequencing/what-can-whole-genome-sequencing-detect.json": [
		892974,
		3,
		892974
	],
	"./education-center/structured-data/whole-genome-sequencing/whole-genome-sequencing-cost": [
		679365,
		3,
		679365
	],
	"./education-center/structured-data/whole-genome-sequencing/whole-genome-sequencing-cost.json": [
		679365,
		3,
		679365
	],
	"./education-center/structured-data/whole-genome-sequencing/whole-genome-shotgun-sequencing": [
		516346,
		3,
		516346
	],
	"./education-center/structured-data/whole-genome-sequencing/whole-genome-shotgun-sequencing.json": [
		516346,
		3,
		516346
	],
	"./knowledge-center/images/sites/default/files/dante-labs-logo-sequencing.com-dna-genetic-testing.png": [
		746863,
		9,
		746863
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/autodetect-reference-genome-sequencing-com.png": [
		527143,
		9,
		527143
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-file-uploader-apple-mac-os-sequencing.png": [
		520606,
		9,
		520606
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-file-uploader-windows-msft-sequencing.png": [
		197197,
		9,
		197197
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-raw-dna-data-file-uploader-debian-linux-sequencing.png": [
		236095,
		9,
		236095
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-raw-dna-data-file-uploader-linux-debian-headless-sequencing.png": [
		850411,
		9,
		850411
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-raw-dna-data-file-uploader-linux-rpm-headless-sequencing.png": [
		514691,
		9,
		514691
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-raw-dna-data-file-uploader-linux-rpm-sequencing.png": [
		425623,
		9,
		425623
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-troubleshooting-step1.png": [
		896688,
		9,
		896688
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big-yotta-troubleshooting-step2.png": [
		164262,
		9,
		164262
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/big_yotta_file_uploader_from_sequencing.com_-_linux_headless.png": [
		109321,
		9,
		109321
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/credit-debit-cards-sequencing-payment-methods.jpg": [
		967328,
		9,
		967328
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/dna.land-logo-sequencing.com-marketplace-simple-genetic-data-import.png": [
		564031,
		9,
		564031
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/download-familytreedna-gene-data-sequencing.com-instructions1_0.png": [
		444350,
		9,
		444350
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/download-familytreedna-gene-data-sequencing.com-instructions_0.png": [
		937189,
		9,
		937189
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/hipaa-compliant-200x200.jpg": [
		715649,
		9,
		715649
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/homedna-genetic-dna-testing-sequencing.com-genome-app-store.png": [
		477240,
		9,
		477240
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/hsa-fsa-eligible-dna-test.jpg": [
		315057,
		9,
		315057
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/klarna-afterpay-affirm-sequencing-payment-methods_0.jpg": [
		695058,
		9,
		695058
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/living-dna-logo-sequencing.com-compatibility.png": [
		930209,
		9,
		930209
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/livingdna-download-options-sequencing.com-raw-genetic-data-files.jpg": [
		754832,
		9,
		754832
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/nebula-genomics-logo_0.png": [
		720949,
		9,
		720949
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/sequencing-apps-health-scan-next-gen-disease-screen-genome-explorer.jpg": [
		253807,
		9,
		253807
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/sequencing-lab-clia-cap.jpg": [
		650207,
		9,
		650207
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/sequencing-wgs-kit-instructions.jpg": [
		589408,
		9,
		589408
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/tellmegen-dna-testing-company.jpg": [
		30721,
		9,
		30721
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/upload-dna-data-sequencing.jpg": [
		982881,
		9,
		982881
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/us-eu-privacy-sheild-seal-sequencingcom.png": [
		218756,
		9,
		218756
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/14/whole-genome-sequencing-kit-turnaround-times.png": [
		80753,
		9,
		80753
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/283026/ancestrydna.jpg": [
		918892,
		9,
		918892
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/283026/ftdna_dna_data_upload.jpg": [
		474801,
		9,
		474801
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/283026/ftdna_test.jpg": [
		560929,
		9,
		560929
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/283026/living_dna_testing_kit.jpg": [
		955830,
		9,
		955830
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/283026/livingdna-mtdna-heat.png": [
		335635,
		9,
		335635
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/049661b5-bf-header-single-ped-1.png": [
		881945,
		9,
		881945
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/920_x_200_gray_padding_1200w.png": [
		792229,
		9,
		792229
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/apple.png": [
		967569,
		9,
		967569
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/chain.png": [
		333494,
		9,
		333494
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/developer.png": [
		555072,
		9,
		555072
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/developers.png": [
		301877,
		9,
		301877
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/dna_computer.png": [
		61797,
		9,
		61797
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/dna_computer_0.png": [
		546331,
		9,
		546331
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/dna_computer_1.png": [
		3582,
		9,
		3582
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/dnalab.png": [
		29594,
		9,
		29594
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/dnapc.png": [
		30664,
		9,
		30664
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/droid.png": [
		416424,
		9,
		416424
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/family_dna.png": [
		680187,
		9,
		680187
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/genome_file_dl.png": [
		104502,
		9,
		104502
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/get.png": [
		497494,
		9,
		497494
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/gttingstarted.png": [
		302365,
		9,
		302365
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/healthcare_pro.webp": [
		101453,
		9,
		101453
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/healthcare_pro_0.webp": [
		48568,
		9,
		48568
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/lightbulb_logo_dark_blue_0.png": [
		863262,
		9,
		863262
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/marketplace.png": [
		370905,
		9,
		370905
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/marketplace_0.png": [
		517838,
		9,
		517838
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/medical_professionals.png": [
		886638,
		9,
		886638
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/mydnadata.png": [
		516955,
		9,
		516955
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/mydnadata_0.png": [
		601480,
		9,
		601480
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/processing.png": [
		460925,
		9,
		460925
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/report_dl.png": [
		982849,
		9,
		982849
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/researchers.png": [
		948125,
		9,
		948125
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/researchers_0.png": [
		540913,
		9,
		540913
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/screenshot_2023-06-22_at_1.00.51_pm.png": [
		738068,
		9,
		738068
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/sequencing-logo-1200x1200.png": [
		13994,
		9,
		13994
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/sequencing-logo-1200x1200_0.png": [
		556496,
		9,
		556496
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/shield1_512w.webp": [
		302849,
		9,
		302849
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/shield1_512w_0.webp": [
		870353,
		9,
		870353
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/shield1_512w_1.webp": [
		736308,
		9,
		736308
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/signin_desk.png": [
		864629,
		9,
		864629
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/signinmobile.png": [
		253767,
		9,
		253767
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/support.png": [
		39878,
		9,
		39878
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/upload_center_from_pc.png": [
		150245,
		9,
		150245
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/uploads.webp": [
		964628,
		9,
		964628
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/uploads_0.webp": [
		514149,
		9,
		514149
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/uploads_1.webp": [
		638627,
		9,
		638627
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/uploads_2.webp": [
		470458,
		9,
		470458
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/uploads_3.webp": [
		274958,
		9,
		274958
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/vcf.png": [
		574984,
		9,
		574984
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/356407/wellness-longevity-ico.webp": [
		595821,
		9,
		595821
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/360347/big-yotta-icon-v1-120w.png": [
		159961,
		9,
		159961
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/360347/signing_up_for_sequencing.webp": [
		17905,
		9,
		17905
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/399272/whole-genome-sequencing-kit-turnaround-times.jpg": [
		764751,
		9,
		764751
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/order-whole-genome-sequencing-dna-test-kits_1.jpg": [
		110071,
		9,
		110071
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-05-26_143230.png": [
		744236,
		9,
		744236
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-06-20_160533.png": [
		663799,
		9,
		663799
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-06-21_160954.png": [
		211604,
		9,
		211604
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-07-28_150647.png": [
		117662,
		9,
		117662
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-08-22_084143.png": [
		245704,
		9,
		245704
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-08-22_140743.png": [
		594997,
		9,
		594997
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-08-29_130354.png": [
		90905,
		9,
		90905
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2023-11-17_141812.png": [
		272804,
		9,
		272804
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/screenshot_2024-11-08_122231.png": [
		343815,
		9,
		343815
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/416942/shield1_512w.png": [
		559675,
		9,
		559675
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/456/genes-for-good-logo-sequencing.com-universal-genetic-data-compatibility.png": [
		374726,
		9,
		374726
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/23andme_1.png": [
		450148,
		9,
		450148
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/7_5.png": [
		416508,
		9,
		416508
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/ancestrydnafullcolor_2.png": [
		327305,
		9,
		150414
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/android-app-google-play-sequencing-com-real-time-personalization-rtp-v2_1_1.png": [
		664576,
		9,
		664576
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/apple-app-store-sequencingcom-genomics-real-time-personalization-rtp-v2_0.png": [
		87910,
		9,
		87910
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/family-tree-dna-ftdna-logo.png": [
		133320,
		9,
		133320
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/family-tree-dna-ftdna-logo_0.png": [
		283165,
		9,
		283165
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/genes-for-good-use-genetic-dna-data-with-sequencing.com-apps-for-interpretation.jpg": [
		720564,
		9,
		720564
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_0_0.png": [
		838142,
		9,
		838142
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_10.png": [
		326157,
		9,
		326157
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_11.png": [
		261841,
		9,
		261841
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_3.png": [
		362662,
		9,
		362662
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_4.png": [
		963285,
		9,
		963285
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_5.png": [
		38727,
		9,
		38727
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_6_0.png": [
		1140,
		9,
		1140
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_7.png": [
		608240,
		9,
		608240
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/global-alliance-for-genomics-and-health-member-seal-sequencing-com_9.png": [
		730740,
		9,
		730740
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200.jpeg": [
		269482,
		9,
		269482
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200_0.jpeg": [
		557966,
		9,
		557966
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200_1.jpeg": [
		849426,
		9,
		849426
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200_2.jpeg": [
		138478,
		9,
		138478
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200_3.jpeg": [
		616936,
		9,
		616936
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/hipaa-compliant-200x200_4.jpeg": [
		753466,
		9,
		753466
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/myheritage-dna-logo-sequencing_1_0.png": [
		582115,
		9,
		582115
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/nih-all-of-us-sequencing.com-dna-genetic-data-logo2.png": [
		826372,
		9,
		826372
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/nih-all-of-us-sequencing.com-dna-genetic-data-logo_0.png": [
		805851,
		9,
		805851
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_0.png": [
		16946,
		9,
		16946
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_1.png": [
		996498,
		9,
		996498
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_2.png": [
		305704,
		9,
		305704
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_3.png": [
		984487,
		9,
		984487
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_5.png": [
		477878,
		9,
		477878
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_6.png": [
		912443,
		9,
		912443
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_8.png": [
		661952,
		9,
		661952
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/us-eu-privacy-sheild-seal-sequencingcom_9.png": [
		936026,
		9,
		936026
	],
	"./knowledge-center/images/sites/default/files/wysiwyg/735/vitagene-logo-sequencing.com-app-market-universal-genetic-data-compatibility_1.png": [
		780203,
		9,
		780203
	],
	"./knowledge-center/markdown": [
		368782,
		9,
		368782
	],
	"./knowledge-center/markdown/": [
		368782,
		9,
		368782
	],
	"./knowledge-center/markdown/app-ideas-suggestions": [
		990510,
		9,
		990510
	],
	"./knowledge-center/markdown/app-ideas-suggestions.md": [
		990510,
		9,
		990510
	],
	"./knowledge-center/markdown/big-yotta-genome-upload": [
		816984,
		9,
		816984
	],
	"./knowledge-center/markdown/big-yotta-genome-upload/": [
		816984,
		9,
		816984
	],
	"./knowledge-center/markdown/big-yotta-genome-upload/index": [
		816984,
		9,
		816984
	],
	"./knowledge-center/markdown/big-yotta-genome-upload/index.md": [
		816984,
		9,
		816984
	],
	"./knowledge-center/markdown/big-yotta-support": [
		456724,
		9,
		456724
	],
	"./knowledge-center/markdown/big-yotta-support.md": [
		456724,
		9,
		456724
	],
	"./knowledge-center/markdown/buy-dna-test": [
		214352,
		9,
		214352
	],
	"./knowledge-center/markdown/buy-dna-test/": [
		214352,
		9,
		214352
	],
	"./knowledge-center/markdown/buy-dna-test/index": [
		214352,
		9,
		214352
	],
	"./knowledge-center/markdown/buy-dna-test/index.md": [
		214352,
		9,
		214352
	],
	"./knowledge-center/markdown/buy-dna-test/kit-instructions-blue-top": [
		806362,
		9,
		806362
	],
	"./knowledge-center/markdown/buy-dna-test/kit-instructions-blue-top.md": [
		806362,
		9,
		806362
	],
	"./knowledge-center/markdown/data-0": [
		830898,
		9,
		830898
	],
	"./knowledge-center/markdown/data-0/": [
		830898,
		9,
		830898
	],
	"./knowledge-center/markdown/data-0/index": [
		830898,
		9,
		830898
	],
	"./knowledge-center/markdown/data-0/index.md": [
		830898,
		9,
		830898
	],
	"./knowledge-center/markdown/developers": [
		63563,
		9,
		63563
	],
	"./knowledge-center/markdown/developers/": [
		63563,
		9,
		63563
	],
	"./knowledge-center/markdown/developers/app-chains": [
		733978,
		9,
		733978
	],
	"./knowledge-center/markdown/developers/app-chains.md": [
		733978,
		9,
		733978
	],
	"./knowledge-center/markdown/developers/developer-center": [
		923382,
		9,
		923382
	],
	"./knowledge-center/markdown/developers/developer-center.md": [
		923382,
		9,
		923382
	],
	"./knowledge-center/markdown/developers/index": [
		63563,
		9,
		63563
	],
	"./knowledge-center/markdown/developers/index.md": [
		63563,
		9,
		63563
	],
	"./knowledge-center/markdown/developers/submitting-app-chain": [
		766497,
		9,
		766497
	],
	"./knowledge-center/markdown/developers/submitting-app-chain.md": [
		766497,
		9,
		766497
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts": [
		287510,
		9,
		287510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/": [
		287510,
		9,
		287510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/ambiguity-genetic-data-file": [
		913908,
		9,
		913908
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/ambiguity-genetic-data-file.md": [
		913908,
		9,
		913908
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/incomplete-genetic-data": [
		799259,
		9,
		799259
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/incomplete-genetic-data.md": [
		799259,
		9,
		799259
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/index": [
		287510,
		9,
		287510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-alerts/index.md": [
		287510,
		9,
		287510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-processing-times": [
		263157,
		9,
		263157
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-processing-times.md": [
		263157,
		9,
		263157
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-results/viewing": [
		914510,
		9,
		914510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/app-results/viewing.md": [
		914510,
		9,
		914510
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/dna-app-market/security-encryption": [
		144173,
		9,
		144173
	],
	"./knowledge-center/markdown/dna-analysis-apps-reports/dna-app-market/security-encryption.md": [
		144173,
		9,
		144173
	],
	"./knowledge-center/markdown/dna-collection-kit-images": [
		999784,
		9,
		999784
	],
	"./knowledge-center/markdown/dna-collection-kit-images.md": [
		999784,
		9,
		999784
	],
	"./knowledge-center/markdown/dna-data-privacy-confidentiality-ownership": [
		39663,
		9,
		39663
	],
	"./knowledge-center/markdown/dna-data-privacy-confidentiality-ownership.md": [
		39663,
		9,
		39663
	],
	"./knowledge-center/markdown/dna-data-storage": [
		319685,
		9,
		319685
	],
	"./knowledge-center/markdown/dna-data-storage/": [
		319685,
		9,
		319685
	],
	"./knowledge-center/markdown/dna-data-storage/accessing": [
		155280,
		9,
		155280
	],
	"./knowledge-center/markdown/dna-data-storage/accessing.md": [
		155280,
		9,
		155280
	],
	"./knowledge-center/markdown/dna-data-storage/confidentiality": [
		535682,
		9,
		535682
	],
	"./knowledge-center/markdown/dna-data-storage/confidentiality.md": [
		535682,
		9,
		535682
	],
	"./knowledge-center/markdown/dna-data-storage/datasets": [
		39495,
		9,
		39495
	],
	"./knowledge-center/markdown/dna-data-storage/datasets.md": [
		39495,
		9,
		39495
	],
	"./knowledge-center/markdown/dna-data-storage/deleting-dna-data-files": [
		223435,
		9,
		223435
	],
	"./knowledge-center/markdown/dna-data-storage/deleting-dna-data-files.md": [
		223435,
		9,
		223435
	],
	"./knowledge-center/markdown/dna-data-storage/downloading": [
		735192,
		9,
		735192
	],
	"./knowledge-center/markdown/dna-data-storage/downloading.md": [
		735192,
		9,
		735192
	],
	"./knowledge-center/markdown/dna-data-storage/european-union-data-protection": [
		597858,
		9,
		597858
	],
	"./knowledge-center/markdown/dna-data-storage/european-union-data-protection.md": [
		597858,
		9,
		597858
	],
	"./knowledge-center/markdown/dna-data-storage/formats": [
		450686,
		9,
		450686
	],
	"./knowledge-center/markdown/dna-data-storage/formats/": [
		450686,
		9,
		450686
	],
	"./knowledge-center/markdown/dna-data-storage/formats/clinical-vcf": [
		737632,
		9,
		737632
	],
	"./knowledge-center/markdown/dna-data-storage/formats/clinical-vcf.md": [
		737632,
		9,
		737632
	],
	"./knowledge-center/markdown/dna-data-storage/formats/fastq-format-compatibility": [
		191502,
		9,
		191502
	],
	"./knowledge-center/markdown/dna-data-storage/formats/fastq-format-compatibility.md": [
		191502,
		9,
		191502
	],
	"./knowledge-center/markdown/dna-data-storage/formats/index": [
		450686,
		9,
		450686
	],
	"./knowledge-center/markdown/dna-data-storage/formats/index.md": [
		450686,
		9,
		450686
	],
	"./knowledge-center/markdown/dna-data-storage/index": [
		319685,
		9,
		319685
	],
	"./knowledge-center/markdown/dna-data-storage/index.md": [
		319685,
		9,
		319685
	],
	"./knowledge-center/markdown/dna-data-storage/ownership": [
		290619,
		9,
		290619
	],
	"./knowledge-center/markdown/dna-data-storage/ownership.md": [
		290619,
		9,
		290619
	],
	"./knowledge-center/markdown/dna-data-storage/security": [
		233217,
		9,
		233217
	],
	"./knowledge-center/markdown/dna-data-storage/security.md": [
		233217,
		9,
		233217
	],
	"./knowledge-center/markdown/dna-data-storage/storing": [
		647305,
		9,
		647305
	],
	"./knowledge-center/markdown/dna-data-storage/storing.md": [
		647305,
		9,
		647305
	],
	"./knowledge-center/markdown/dna-data-storage/universal-data-compatibility": [
		236035,
		9,
		236035
	],
	"./knowledge-center/markdown/dna-data-storage/universal-data-compatibility.md": [
		236035,
		9,
		236035
	],
	"./knowledge-center/markdown/dna-data-storage/uploading": [
		231642,
		9,
		231642
	],
	"./knowledge-center/markdown/dna-data-storage/uploading.md": [
		231642,
		9,
		231642
	],
	"./knowledge-center/markdown/dna-reports-app-analysis": [
		517755,
		9,
		517755
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/": [
		517755,
		9,
		517755
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results": [
		390240,
		9,
		390240
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results/": [
		390240,
		9,
		390240
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results/downloading-results": [
		996058,
		9,
		996058
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results/downloading-results.md": [
		996058,
		9,
		996058
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results/index": [
		390240,
		9,
		390240
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/app-and-report-results/index.md": [
		390240,
		9,
		390240
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/index": [
		517755,
		9,
		517755
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/index.md": [
		517755,
		9,
		517755
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace": [
		675087,
		9,
		675087
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/": [
		675087,
		9,
		675087
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/exploring-marketplace": [
		380868,
		9,
		380868
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/exploring-marketplace.md": [
		380868,
		9,
		380868
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/free-apps-reports": [
		246966,
		9,
		246966
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/free-apps-reports.md": [
		246966,
		9,
		246966
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/index": [
		675087,
		9,
		675087
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/index.md": [
		675087,
		9,
		675087
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/payment-methods": [
		908411,
		9,
		908411
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/payment-methods/": [
		908411,
		9,
		908411
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/payment-methods/index": [
		908411,
		9,
		908411
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/payment-methods/index.md": [
		908411,
		9,
		908411
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/premium-apps-reports": [
		641741,
		9,
		641741
	],
	"./knowledge-center/markdown/dna-reports-app-analysis/report-marketplace/premium-apps-reports.md": [
		641741,
		9,
		641741
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer": [
		206500,
		9,
		206500
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/": [
		206500,
		9,
		206500
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-faq": [
		785715,
		9,
		785715
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-faq.md": [
		785715,
		9,
		785715
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-plus-benefits": [
		77850,
		9,
		77850
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-plus-benefits.md": [
		77850,
		9,
		77850
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-premium-benefits": [
		638141,
		9,
		638141
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/genome-explorer-premium-benefits.md": [
		638141,
		9,
		638141
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/guide-to-genome-explorer-free": [
		855892,
		9,
		855892
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/guide-to-genome-explorer-free.md": [
		855892,
		9,
		855892
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/index": [
		206500,
		9,
		206500
	],
	"./knowledge-center/markdown/education-center/what-is-genome-explorer/index.md": [
		206500,
		9,
		206500
	],
	"./knowledge-center/markdown/faqs": [
		562126,
		9,
		562126
	],
	"./knowledge-center/markdown/faqs/": [
		562126,
		9,
		562126
	],
	"./knowledge-center/markdown/faqs/can-i-access-and-download-my-raw-dna-data": [
		744915,
		9,
		744915
	],
	"./knowledge-center/markdown/faqs/can-i-access-and-download-my-raw-dna-data.md": [
		744915,
		9,
		744915
	],
	"./knowledge-center/markdown/faqs/can-i-delete-my-data": [
		243115,
		9,
		243115
	],
	"./knowledge-center/markdown/faqs/can-i-delete-my-data.md": [
		243115,
		9,
		243115
	],
	"./knowledge-center/markdown/faqs/can-i-upload-dna-data-or-genome-sequencing-data-i-already-have": [
		811902,
		9,
		811902
	],
	"./knowledge-center/markdown/faqs/can-i-upload-dna-data-or-genome-sequencing-data-i-already-have.md": [
		811902,
		9,
		811902
	],
	"./knowledge-center/markdown/faqs/can-i-upload-my-raw-dna-data-sequencingcom-third-party-sites-such-online": [
		511836,
		9,
		511836
	],
	"./knowledge-center/markdown/faqs/can-i-upload-my-raw-dna-data-sequencingcom-third-party-sites-such-online.md": [
		511836,
		9,
		511836
	],
	"./knowledge-center/markdown/faqs/chimerism-test": [
		122539,
		9,
		122539
	],
	"./knowledge-center/markdown/faqs/chimerism-test.md": [
		122539,
		9,
		122539
	],
	"./knowledge-center/markdown/faqs/digital-genome-missing-data": [
		18106,
		9,
		18106
	],
	"./knowledge-center/markdown/faqs/digital-genome-missing-data.md": [
		18106,
		9,
		18106
	],
	"./knowledge-center/markdown/faqs/do-you-accept-hsa-and-fsa-cards": [
		468174,
		9,
		468174
	],
	"./knowledge-center/markdown/faqs/do-you-accept-hsa-and-fsa-cards.md": [
		468174,
		9,
		468174
	],
	"./knowledge-center/markdown/faqs/do-you-sell-or-share-my-data-anyone": [
		920670,
		9,
		920670
	],
	"./knowledge-center/markdown/faqs/do-you-sell-or-share-my-data-anyone.md": [
		920670,
		9,
		920670
	],
	"./knowledge-center/markdown/faqs/does-23andme-ancestrycom-myheritage-test-my-entire-genome": [
		499500,
		9,
		499500
	],
	"./knowledge-center/markdown/faqs/does-23andme-ancestrycom-myheritage-test-my-entire-genome.md": [
		499500,
		9,
		499500
	],
	"./knowledge-center/markdown/faqs/guide-disease-specific-results-next-gen-screening": [
		980870,
		9,
		980870
	],
	"./knowledge-center/markdown/faqs/guide-disease-specific-results-next-gen-screening.md": [
		980870,
		9,
		980870
	],
	"./knowledge-center/markdown/faqs/how-do-i-check-kit-status": [
		581830,
		9,
		581830
	],
	"./knowledge-center/markdown/faqs/how-do-i-check-kit-status.md": [
		581830,
		9,
		581830
	],
	"./knowledge-center/markdown/faqs/index": [
		562126,
		9,
		562126
	],
	"./knowledge-center/markdown/faqs/index.md": [
		562126,
		9,
		562126
	],
	"./knowledge-center/markdown/faqs/one-genome-technology": [
		135567,
		9,
		135567
	],
	"./knowledge-center/markdown/faqs/one-genome-technology.md": [
		135567,
		9,
		135567
	],
	"./knowledge-center/markdown/faqs/privacy-first-policy": [
		926834,
		9,
		926834
	],
	"./knowledge-center/markdown/faqs/privacy-first-policy.md": [
		926834,
		9,
		926834
	],
	"./knowledge-center/markdown/faqs/turnaround-time-whole-genome-sequencing": [
		965125,
		9,
		965125
	],
	"./knowledge-center/markdown/faqs/turnaround-time-whole-genome-sequencing.md": [
		965125,
		9,
		965125
	],
	"./knowledge-center/markdown/faqs/what-certifications-does-laboratory-have": [
		907687,
		9,
		907687
	],
	"./knowledge-center/markdown/faqs/what-certifications-does-laboratory-have.md": [
		907687,
		9,
		907687
	],
	"./knowledge-center/markdown/faqs/what-does-it-mean-when-genome-explorer-says-variant-pathogenic": [
		849821,
		9,
		849821
	],
	"./knowledge-center/markdown/faqs/what-does-it-mean-when-genome-explorer-says-variant-pathogenic.md": [
		849821,
		9,
		849821
	],
	"./knowledge-center/markdown/faqs/what-happens-if-issue-with-kit-or-sequencing": [
		803194,
		9,
		803194
	],
	"./knowledge-center/markdown/faqs/what-happens-if-issue-with-kit-or-sequencing.md": [
		803194,
		9,
		803194
	],
	"./knowledge-center/markdown/faqs/what-sequencing-platform-and-bioinformatics-pipeline-do-you-use": [
		193676,
		9,
		193676
	],
	"./knowledge-center/markdown/faqs/what-sequencing-platform-and-bioinformatics-pipeline-do-you-use.md": [
		193676,
		9,
		193676
	],
	"./knowledge-center/markdown/faqs/what-sequencings-dna-membership-program": [
		973117,
		9,
		973117
	],
	"./knowledge-center/markdown/faqs/what-sequencings-dna-membership-program.md": [
		973117,
		9,
		973117
	],
	"./knowledge-center/markdown/faqs/what-types-data-are-provided-your-dna-testing-and-genome-sequencing": [
		215683,
		9,
		215683
	],
	"./knowledge-center/markdown/faqs/what-types-data-are-provided-your-dna-testing-and-genome-sequencing.md": [
		215683,
		9,
		215683
	],
	"./knowledge-center/markdown/faqs/what’s-difference-between-your-standard-expedited-and-ultra-rapid-genome": [
		654817,
		9,
		654817
	],
	"./knowledge-center/markdown/faqs/what’s-difference-between-your-standard-expedited-and-ultra-rapid-genome.md": [
		654817,
		9,
		654817
	],
	"./knowledge-center/markdown/faqs/where-do-you-ship-your-dna-collection-kits": [
		855015,
		9,
		855015
	],
	"./knowledge-center/markdown/faqs/where-do-you-ship-your-dna-collection-kits.md": [
		855015,
		9,
		855015
	],
	"./knowledge-center/markdown/faqs/who-is-sequencing": [
		72896,
		9,
		72896
	],
	"./knowledge-center/markdown/faqs/who-is-sequencing.md": [
		72896,
		9,
		72896
	],
	"./knowledge-center/markdown/free-unlimited-dna-genome-data-storage": [
		244928,
		9,
		244928
	],
	"./knowledge-center/markdown/free-unlimited-dna-genome-data-storage.md": [
		244928,
		9,
		244928
	],
	"./knowledge-center/markdown/getting-started": [
		656282,
		9,
		656282
	],
	"./knowledge-center/markdown/getting-started/": [
		656282,
		9,
		656282
	],
	"./knowledge-center/markdown/getting-started/account-security-features": [
		962876,
		9,
		962876
	],
	"./knowledge-center/markdown/getting-started/account-security-features.md": [
		962876,
		9,
		962876
	],
	"./knowledge-center/markdown/getting-started/account-status": [
		532745,
		9,
		532745
	],
	"./knowledge-center/markdown/getting-started/account-status/": [
		532745,
		9,
		532745
	],
	"./knowledge-center/markdown/getting-started/account-status/delete-account": [
		9869,
		9,
		9869
	],
	"./knowledge-center/markdown/getting-started/account-status/delete-account.md": [
		9869,
		9,
		9869
	],
	"./knowledge-center/markdown/getting-started/account-status/index": [
		532745,
		9,
		532745
	],
	"./knowledge-center/markdown/getting-started/account-status/index.md": [
		532745,
		9,
		532745
	],
	"./knowledge-center/markdown/getting-started/index": [
		656282,
		9,
		656282
	],
	"./knowledge-center/markdown/getting-started/index.md": [
		656282,
		9,
		656282
	],
	"./knowledge-center/markdown/getting-started/membership": [
		818278,
		9,
		818278
	],
	"./knowledge-center/markdown/getting-started/membership/": [
		818278,
		9,
		818278
	],
	"./knowledge-center/markdown/getting-started/membership/genome-plan-membership-faqs": [
		301633,
		9,
		301633
	],
	"./knowledge-center/markdown/getting-started/membership/genome-plan-membership-faqs/": [
		301633,
		9,
		301633
	],
	"./knowledge-center/markdown/getting-started/membership/genome-plan-membership-faqs/index": [
		301633,
		9,
		301633
	],
	"./knowledge-center/markdown/getting-started/membership/genome-plan-membership-faqs/index.md": [
		301633,
		9,
		301633
	],
	"./knowledge-center/markdown/getting-started/membership/genomes-genome-plans-genome-scans": [
		125509,
		9,
		125509
	],
	"./knowledge-center/markdown/getting-started/membership/genomes-genome-plans-genome-scans.md": [
		125509,
		9,
		125509
	],
	"./knowledge-center/markdown/getting-started/membership/index": [
		818278,
		9,
		818278
	],
	"./knowledge-center/markdown/getting-started/membership/index.md": [
		818278,
		9,
		818278
	],
	"./knowledge-center/markdown/getting-started/sign": [
		968999,
		9,
		968999
	],
	"./knowledge-center/markdown/getting-started/sign.md": [
		968999,
		9,
		968999
	],
	"./knowledge-center/markdown/getting-started/uploading-genetic-data": [
		838342,
		9,
		838342
	],
	"./knowledge-center/markdown/getting-started/uploading-genetic-data.md": [
		838342,
		9,
		838342
	],
	"./knowledge-center/markdown/global-alliance-beacon-network": [
		86986,
		9,
		86986
	],
	"./knowledge-center/markdown/global-alliance-beacon-network.md": [
		86986,
		9,
		86986
	],
	"./knowledge-center/markdown/healthcare-professionals": [
		464131,
		9,
		464131
	],
	"./knowledge-center/markdown/healthcare-professionals/": [
		464131,
		9,
		464131
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports": [
		768019,
		9,
		768019
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/": [
		768019,
		9,
		768019
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/healthcare-pro-report": [
		88870,
		9,
		88870
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/healthcare-pro-report.md": [
		88870,
		9,
		88870
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/index": [
		768019,
		9,
		768019
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/index.md": [
		768019,
		9,
		768019
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/patient-reports": [
		43844,
		9,
		43844
	],
	"./knowledge-center/markdown/healthcare-professionals/genetic-reports/patient-reports.md": [
		43844,
		9,
		43844
	],
	"./knowledge-center/markdown/healthcare-professionals/hipaa-business-associate-agreement-baa": [
		319062,
		9,
		319062
	],
	"./knowledge-center/markdown/healthcare-professionals/hipaa-business-associate-agreement-baa.md": [
		319062,
		9,
		319062
	],
	"./knowledge-center/markdown/healthcare-professionals/hipaa-compliance-certifications": [
		657622,
		9,
		657622
	],
	"./knowledge-center/markdown/healthcare-professionals/hipaa-compliance-certifications.md": [
		657622,
		9,
		657622
	],
	"./knowledge-center/markdown/healthcare-professionals/index": [
		464131,
		9,
		464131
	],
	"./knowledge-center/markdown/healthcare-professionals/index.md": [
		464131,
		9,
		464131
	],
	"./knowledge-center/markdown/healthcare-professionals/spotlight-healthcare-pro": [
		26393,
		9,
		26393
	],
	"./knowledge-center/markdown/healthcare-professionals/spotlight-healthcare-pro.md": [
		26393,
		9,
		26393
	],
	"./knowledge-center/markdown/import-from-laboratory": [
		74799,
		9,
		74799
	],
	"./knowledge-center/markdown/import-from-laboratory.md": [
		74799,
		9,
		74799
	],
	"./knowledge-center/markdown/index": [
		368782,
		9,
		368782
	],
	"./knowledge-center/markdown/index.md": [
		368782,
		9,
		368782
	],
	"./knowledge-center/markdown/individuals-families": [
		42800,
		9,
		42800
	],
	"./knowledge-center/markdown/individuals-families/": [
		42800,
		9,
		42800
	],
	"./knowledge-center/markdown/individuals-families/how-use-report": [
		431576,
		9,
		431576
	],
	"./knowledge-center/markdown/individuals-families/how-use-report.md": [
		431576,
		9,
		431576
	],
	"./knowledge-center/markdown/individuals-families/index": [
		42800,
		9,
		42800
	],
	"./knowledge-center/markdown/individuals-families/index.md": [
		42800,
		9,
		42800
	],
	"./knowledge-center/markdown/individuals-families/types-analysis": [
		27528,
		9,
		27528
	],
	"./knowledge-center/markdown/individuals-families/types-analysis.md": [
		27528,
		9,
		27528
	],
	"./knowledge-center/markdown/intro-to-site-universal-dna-compatibility": [
		664465,
		9,
		664465
	],
	"./knowledge-center/markdown/intro-to-site-universal-dna-compatibility/": [
		664465,
		9,
		664465
	],
	"./knowledge-center/markdown/intro-to-site-universal-dna-compatibility/index": [
		664465,
		9,
		664465
	],
	"./knowledge-center/markdown/intro-to-site-universal-dna-compatibility/index.md": [
		664465,
		9,
		664465
	],
	"./knowledge-center/markdown/introduction/i-have-genetic-data": [
		275662,
		9,
		275662
	],
	"./knowledge-center/markdown/introduction/i-have-genetic-data.md": [
		275662,
		9,
		275662
	],
	"./knowledge-center/markdown/laboratories": [
		411375,
		9,
		411375
	],
	"./knowledge-center/markdown/laboratories/": [
		411375,
		9,
		411375
	],
	"./knowledge-center/markdown/laboratories/become-preferred-provider-genetic-testing": [
		748490,
		9,
		748490
	],
	"./knowledge-center/markdown/laboratories/become-preferred-provider-genetic-testing.md": [
		748490,
		9,
		748490
	],
	"./knowledge-center/markdown/laboratories/data-storage": [
		791349,
		9,
		791349
	],
	"./knowledge-center/markdown/laboratories/data-storage/": [
		791349,
		9,
		791349
	],
	"./knowledge-center/markdown/laboratories/data-storage/index": [
		791349,
		9,
		791349
	],
	"./knowledge-center/markdown/laboratories/data-storage/index.md": [
		791349,
		9,
		791349
	],
	"./knowledge-center/markdown/laboratories/data-storage/uploading-data-and-batch-uploads": [
		846577,
		9,
		846577
	],
	"./knowledge-center/markdown/laboratories/data-storage/uploading-data-and-batch-uploads.md": [
		846577,
		9,
		846577
	],
	"./knowledge-center/markdown/laboratories/hipaa-business-associate-agreement-baa": [
		329887,
		9,
		329887
	],
	"./knowledge-center/markdown/laboratories/hipaa-business-associate-agreement-baa.md": [
		329887,
		9,
		329887
	],
	"./knowledge-center/markdown/laboratories/hipaa-compliance-certifications": [
		394896,
		9,
		394896
	],
	"./knowledge-center/markdown/laboratories/hipaa-compliance-certifications.md": [
		394896,
		9,
		394896
	],
	"./knowledge-center/markdown/laboratories/index": [
		411375,
		9,
		411375
	],
	"./knowledge-center/markdown/laboratories/index.md": [
		411375,
		9,
		411375
	],
	"./knowledge-center/markdown/laboratories/obtain-more-data-you-generate": [
		747159,
		9,
		747159
	],
	"./knowledge-center/markdown/laboratories/obtain-more-data-you-generate.md": [
		747159,
		9,
		747159
	],
	"./knowledge-center/markdown/logging-in": [
		842094,
		9,
		842094
	],
	"./knowledge-center/markdown/logging-in.md": [
		842094,
		9,
		842094
	],
	"./knowledge-center/markdown/membership-plans": [
		840241,
		9,
		840241
	],
	"./knowledge-center/markdown/membership-plans.md": [
		840241,
		9,
		840241
	],
	"./knowledge-center/markdown/node/15984": [
		546742,
		9,
		546742
	],
	"./knowledge-center/markdown/node/15984.md": [
		546742,
		9,
		546742
	],
	"./knowledge-center/markdown/node/16092": [
		414584,
		9,
		414584
	],
	"./knowledge-center/markdown/node/16092.md": [
		414584,
		9,
		414584
	],
	"./knowledge-center/markdown/node/5224": [
		539535,
		9,
		539535
	],
	"./knowledge-center/markdown/node/5224.md": [
		539535,
		9,
		539535
	],
	"./knowledge-center/markdown/one-genome": [
		777470,
		9,
		777470
	],
	"./knowledge-center/markdown/one-genome.md": [
		777470,
		9,
		777470
	],
	"./knowledge-center/markdown/patient-data": [
		801707,
		9,
		801707
	],
	"./knowledge-center/markdown/patient-data.md": [
		801707,
		9,
		801707
	],
	"./knowledge-center/markdown/problem-solving": [
		403047,
		9,
		403047
	],
	"./knowledge-center/markdown/problem-solving.md": [
		403047,
		9,
		403047
	],
	"./knowledge-center/markdown/promethease": [
		813605,
		9,
		813605
	],
	"./knowledge-center/markdown/promethease.md": [
		813605,
		9,
		813605
	],
	"./knowledge-center/markdown/researchers": [
		388396,
		9,
		388396
	],
	"./knowledge-center/markdown/researchers/": [
		388396,
		9,
		388396
	],
	"./knowledge-center/markdown/researchers/certifications-and-compliance": [
		525618,
		9,
		525618
	],
	"./knowledge-center/markdown/researchers/certifications-and-compliance.md": [
		525618,
		9,
		525618
	],
	"./knowledge-center/markdown/researchers/data": [
		980640,
		9,
		980640
	],
	"./knowledge-center/markdown/researchers/data.md": [
		980640,
		9,
		980640
	],
	"./knowledge-center/markdown/researchers/hipaa-business-associate-agreement-baa": [
		363284,
		9,
		363284
	],
	"./knowledge-center/markdown/researchers/hipaa-business-associate-agreement-baa.md": [
		363284,
		9,
		363284
	],
	"./knowledge-center/markdown/researchers/index": [
		388396,
		9,
		388396
	],
	"./knowledge-center/markdown/researchers/index.md": [
		388396,
		9,
		388396
	],
	"./knowledge-center/markdown/researchers/miame-compliance": [
		979587,
		9,
		979587
	],
	"./knowledge-center/markdown/researchers/miame-compliance.md": [
		979587,
		9,
		979587
	],
	"./knowledge-center/markdown/researchers/reference-genomes": [
		3826,
		9,
		3826
	],
	"./knowledge-center/markdown/researchers/reference-genomes/": [
		3826,
		9,
		3826
	],
	"./knowledge-center/markdown/researchers/reference-genomes/autodetect": [
		402744,
		9,
		402744
	],
	"./knowledge-center/markdown/researchers/reference-genomes/autodetect.md": [
		402744,
		9,
		402744
	],
	"./knowledge-center/markdown/researchers/reference-genomes/index": [
		3826,
		9,
		3826
	],
	"./knowledge-center/markdown/researchers/reference-genomes/index.md": [
		3826,
		9,
		3826
	],
	"./knowledge-center/markdown/researchers/uploading-and-importing": [
		443718,
		9,
		443718
	],
	"./knowledge-center/markdown/researchers/uploading-and-importing.md": [
		443718,
		9,
		443718
	],
	"./knowledge-center/markdown/saving-a-card-on-file": [
		99876,
		9,
		99876
	],
	"./knowledge-center/markdown/saving-a-card-on-file.md": [
		99876,
		9,
		99876
	],
	"./knowledge-center/markdown/sequencing-apps": [
		106587,
		9,
		106587
	],
	"./knowledge-center/markdown/sequencing-apps-genome-explorer": [
		92481,
		9,
		92481
	],
	"./knowledge-center/markdown/sequencing-apps-genome-explorer/": [
		92481,
		9,
		92481
	],
	"./knowledge-center/markdown/sequencing-apps-genome-explorer/index": [
		92481,
		9,
		92481
	],
	"./knowledge-center/markdown/sequencing-apps-genome-explorer/index.md": [
		92481,
		9,
		92481
	],
	"./knowledge-center/markdown/sequencing-apps-health-scan": [
		79554,
		9,
		79554
	],
	"./knowledge-center/markdown/sequencing-apps-health-scan.md": [
		79554,
		9,
		79554
	],
	"./knowledge-center/markdown/sequencing-apps-ngds": [
		802821,
		9,
		802821
	],
	"./knowledge-center/markdown/sequencing-apps-ngds/": [
		802821,
		9,
		802821
	],
	"./knowledge-center/markdown/sequencing-apps-ngds/index": [
		802821,
		9,
		802821
	],
	"./knowledge-center/markdown/sequencing-apps-ngds/index.md": [
		802821,
		9,
		802821
	],
	"./knowledge-center/markdown/sequencing-apps/": [
		106587,
		9,
		106587
	],
	"./knowledge-center/markdown/sequencing-apps/index": [
		106587,
		9,
		106587
	],
	"./knowledge-center/markdown/sequencing-apps/index.md": [
		106587,
		9,
		106587
	],
	"./knowledge-center/markdown/sequencing-apps/next-gen-disease-screen-ngds/sequencingai-result-summary-report": [
		22651,
		9,
		22651
	],
	"./knowledge-center/markdown/sequencing-apps/next-gen-disease-screen-ngds/sequencingai-result-summary-report.md": [
		22651,
		9,
		22651
	],
	"./knowledge-center/markdown/shipping-handling-dna-collection-kits": [
		222537,
		9,
		442939
	],
	"./knowledge-center/markdown/shipping-handling-dna-collection-kits.md": [
		222537,
		9,
		442939
	],
	"./knowledge-center/markdown/sign-in-options": [
		185468,
		9,
		185468
	],
	"./knowledge-center/markdown/sign-in-options/": [
		185468,
		9,
		185468
	],
	"./knowledge-center/markdown/sign-in-options/index": [
		185468,
		9,
		185468
	],
	"./knowledge-center/markdown/sign-in-options/index.md": [
		185468,
		9,
		185468
	],
	"./knowledge-center/markdown/single-sign-on": [
		16234,
		9,
		16234
	],
	"./knowledge-center/markdown/single-sign-on.md": [
		16234,
		9,
		16234
	],
	"./knowledge-center/markdown/site-guide": [
		7415,
		9,
		7415
	],
	"./knowledge-center/markdown/site-guide/": [
		7415,
		9,
		7415
	],
	"./knowledge-center/markdown/site-guide/account-settings": [
		258069,
		9,
		258069
	],
	"./knowledge-center/markdown/site-guide/account-settings/": [
		258069,
		9,
		258069
	],
	"./knowledge-center/markdown/site-guide/account-settings/index": [
		258069,
		9,
		258069
	],
	"./knowledge-center/markdown/site-guide/account-settings/index.md": [
		258069,
		9,
		258069
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership": [
		30356,
		9,
		30356
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership/": [
		30356,
		9,
		30356
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership/how-modify-your-genome-plan": [
		356137,
		9,
		356137
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership/how-modify-your-genome-plan.md": [
		356137,
		9,
		356137
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership/index": [
		30356,
		9,
		30356
	],
	"./knowledge-center/markdown/site-guide/account-settings/membership/index.md": [
		30356,
		9,
		30356
	],
	"./knowledge-center/markdown/site-guide/account-settings/order-history": [
		397181,
		9,
		397181
	],
	"./knowledge-center/markdown/site-guide/account-settings/order-history.md": [
		397181,
		9,
		397181
	],
	"./knowledge-center/markdown/site-guide/account-settings/payment-methods": [
		766625,
		9,
		766625
	],
	"./knowledge-center/markdown/site-guide/account-settings/payment-methods.md": [
		766625,
		9,
		766625
	],
	"./knowledge-center/markdown/site-guide/account-settings/personal-information": [
		254968,
		9,
		254968
	],
	"./knowledge-center/markdown/site-guide/account-settings/personal-information.md": [
		254968,
		9,
		254968
	],
	"./knowledge-center/markdown/site-guide/account-settings/settings": [
		681900,
		9,
		681900
	],
	"./knowledge-center/markdown/site-guide/account-settings/settings.md": [
		681900,
		9,
		681900
	],
	"./knowledge-center/markdown/site-guide/data/apps/usage": [
		9881,
		9,
		9881
	],
	"./knowledge-center/markdown/site-guide/data/apps/usage.md": [
		9881,
		9,
		9881
	],
	"./knowledge-center/markdown/site-guide/data/big-yotta-upload-large-data-files/linux-headless-mode": [
		692204,
		9,
		692204
	],
	"./knowledge-center/markdown/site-guide/data/big-yotta-upload-large-data-files/linux-headless-mode.md": [
		692204,
		9,
		692204
	],
	"./knowledge-center/markdown/site-guide/data/big-yotta-upload-large-data-files/logging-big-yotta": [
		969773,
		9,
		969773
	],
	"./knowledge-center/markdown/site-guide/data/big-yotta-upload-large-data-files/logging-big-yotta.md": [
		969773,
		9,
		969773
	],
	"./knowledge-center/markdown/site-guide/home": [
		157395,
		9,
		157395
	],
	"./knowledge-center/markdown/site-guide/home.md": [
		157395,
		9,
		157395
	],
	"./knowledge-center/markdown/site-guide/index": [
		7415,
		9,
		7415
	],
	"./knowledge-center/markdown/site-guide/index.md": [
		7415,
		9,
		7415
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/apps/processing-files": [
		956782,
		9,
		956782
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/apps/processing-files.md": [
		956782,
		9,
		956782
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/incompatible-files": [
		462256,
		9,
		462256
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/incompatible-files.md": [
		462256,
		9,
		462256
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/upload-center": [
		729457,
		9,
		729457
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/upload-center/": [
		729457,
		9,
		729457
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/upload-center/index": [
		729457,
		9,
		729457
	],
	"./knowledge-center/markdown/site-guide/my-dna-data/upload-center/index.md": [
		729457,
		9,
		729457
	],
	"./knowledge-center/markdown/site-guide/my-files/downloading-files": [
		123149,
		9,
		123149
	],
	"./knowledge-center/markdown/site-guide/my-files/downloading-files.md": [
		123149,
		9,
		123149
	],
	"./knowledge-center/markdown/site-guide/settings/login-history": [
		829729,
		9,
		829729
	],
	"./knowledge-center/markdown/site-guide/settings/login-history.md": [
		829729,
		9,
		829729
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification": [
		531851,
		9,
		531851
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification/": [
		531851,
		9,
		531851
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification/enabling-2-step-verification": [
		79246,
		9,
		79246
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification/enabling-2-step-verification.md": [
		79246,
		9,
		79246
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification/index": [
		531851,
		9,
		531851
	],
	"./knowledge-center/markdown/site-guide/settings/sign-options/2-step-verification/index.md": [
		531851,
		9,
		531851
	],
	"./knowledge-center/markdown/site-guide/signing": [
		353257,
		9,
		353257
	],
	"./knowledge-center/markdown/site-guide/signing/": [
		353257,
		9,
		353257
	],
	"./knowledge-center/markdown/site-guide/signing/index": [
		353257,
		9,
		353257
	],
	"./knowledge-center/markdown/site-guide/signing/index.md": [
		353257,
		9,
		353257
	],
	"./knowledge-center/markdown/site-guide/signing/sign-options/2-step-verification/google-authenticator-app": [
		930453,
		9,
		930453
	],
	"./knowledge-center/markdown/site-guide/signing/sign-options/2-step-verification/google-authenticator-app.md": [
		930453,
		9,
		930453
	],
	"./knowledge-center/markdown/submitting-an-app": [
		282429,
		9,
		282429
	],
	"./knowledge-center/markdown/submitting-an-app.md": [
		282429,
		9,
		282429
	],
	"./knowledge-center/markdown/support": [
		849677,
		9,
		849677
	],
	"./knowledge-center/markdown/support.md": [
		849677,
		9,
		849677
	],
	"./knowledge-center/markdown/upload-from-computer": [
		876368,
		9,
		876368
	],
	"./knowledge-center/markdown/upload-from-computer.md": [
		876368,
		9,
		876368
	],
	"./knowledge-center/markdown/upload-my-dna-data-free": [
		877532,
		9,
		877532
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/": [
		877532,
		9,
		877532
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/23andme": [
		58012,
		9,
		58012
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/23andme.md": [
		58012,
		9,
		58012
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/all-of-us-nih": [
		308911,
		9,
		308911
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/all-of-us-nih.md": [
		308911,
		9,
		308911
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/ancestrydna": [
		174593,
		9,
		174593
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/ancestrydna.md": [
		174593,
		9,
		174593
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dante-labs": [
		292237,
		9,
		292237
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dante-labs.md": [
		292237,
		9,
		292237
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dna-land": [
		85299,
		9,
		85299
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dna-land.md": [
		85299,
		9,
		85299
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dna-test-providers": [
		110028,
		9,
		110028
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/dna-test-providers.md": [
		110028,
		9,
		110028
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/familytreedna": [
		134286,
		9,
		134286
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/familytreedna.md": [
		134286,
		9,
		134286
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/genes-for-good": [
		632140,
		9,
		632140
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/genes-for-good.md": [
		632140,
		9,
		632140
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/homedna": [
		283798,
		9,
		283798
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/homedna.md": [
		283798,
		9,
		283798
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/index": [
		877532,
		9,
		877532
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/index.md": [
		877532,
		9,
		877532
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/living-dna": [
		509092,
		9,
		509092
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/living-dna.md": [
		509092,
		9,
		509092
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/myheritage": [
		366166,
		9,
		366166
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/myheritage.md": [
		366166,
		9,
		366166
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/nebula-genomics": [
		695192,
		9,
		695192
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/nebula-genomics.md": [
		695192,
		9,
		695192
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/tellmegen-dna": [
		250090,
		9,
		250090
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/tellmegen-dna.md": [
		250090,
		9,
		250090
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/vitagene": [
		145169,
		9,
		145169
	],
	"./knowledge-center/markdown/upload-my-dna-data-free/vitagene.md": [
		145169,
		9,
		145169
	],
	"./knowledge-center/structured-data": [
		283416,
		3,
		283416
	],
	"./knowledge-center/structured-data/": [
		283416,
		3,
		283416
	],
	"./knowledge-center/structured-data/app-ideas-suggestions": [
		663362,
		3,
		663362
	],
	"./knowledge-center/structured-data/app-ideas-suggestions.json": [
		663362,
		3,
		663362
	],
	"./knowledge-center/structured-data/big-yotta-genome-upload": [
		766808,
		3,
		766808
	],
	"./knowledge-center/structured-data/big-yotta-genome-upload/": [
		766808,
		3,
		766808
	],
	"./knowledge-center/structured-data/big-yotta-genome-upload/index": [
		766808,
		3,
		766808
	],
	"./knowledge-center/structured-data/big-yotta-genome-upload/index.json": [
		766808,
		3,
		766808
	],
	"./knowledge-center/structured-data/big-yotta-support": [
		850638,
		3,
		850638
	],
	"./knowledge-center/structured-data/big-yotta-support.json": [
		850638,
		3,
		850638
	],
	"./knowledge-center/structured-data/buy-dna-test": [
		789683,
		3,
		789683
	],
	"./knowledge-center/structured-data/buy-dna-test/": [
		789683,
		3,
		789683
	],
	"./knowledge-center/structured-data/buy-dna-test/index": [
		789683,
		3,
		789683
	],
	"./knowledge-center/structured-data/buy-dna-test/index.json": [
		789683,
		3,
		789683
	],
	"./knowledge-center/structured-data/buy-dna-test/kit-instructions-blue-top": [
		248110,
		3,
		248110
	],
	"./knowledge-center/structured-data/buy-dna-test/kit-instructions-blue-top.json": [
		248110,
		3,
		248110
	],
	"./knowledge-center/structured-data/data-0": [
		577552,
		3,
		577552
	],
	"./knowledge-center/structured-data/data-0/": [
		577552,
		3,
		577552
	],
	"./knowledge-center/structured-data/data-0/index": [
		577552,
		3,
		577552
	],
	"./knowledge-center/structured-data/data-0/index.json": [
		577552,
		3,
		577552
	],
	"./knowledge-center/structured-data/developers": [
		376297,
		3,
		376297
	],
	"./knowledge-center/structured-data/developers/": [
		376297,
		3,
		376297
	],
	"./knowledge-center/structured-data/developers/app-chains": [
		624937,
		3,
		624937
	],
	"./knowledge-center/structured-data/developers/app-chains.json": [
		624937,
		3,
		624937
	],
	"./knowledge-center/structured-data/developers/developer-center": [
		462471,
		3,
		462471
	],
	"./knowledge-center/structured-data/developers/developer-center.json": [
		462471,
		3,
		462471
	],
	"./knowledge-center/structured-data/developers/index": [
		376297,
		3,
		376297
	],
	"./knowledge-center/structured-data/developers/index.json": [
		376297,
		3,
		376297
	],
	"./knowledge-center/structured-data/developers/submitting-app-chain": [
		135997,
		3,
		135997
	],
	"./knowledge-center/structured-data/developers/submitting-app-chain.json": [
		135997,
		3,
		135997
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts": [
		865177,
		3,
		865177
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/": [
		865177,
		3,
		865177
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/ambiguity-genetic-data-file": [
		298750,
		3,
		298750
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/ambiguity-genetic-data-file.json": [
		298750,
		3,
		298750
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/incomplete-genetic-data": [
		908124,
		3,
		908124
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/incomplete-genetic-data.json": [
		908124,
		3,
		908124
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/index": [
		865177,
		3,
		865177
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-alerts/index.json": [
		865177,
		3,
		865177
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-processing-times": [
		161831,
		3,
		161831
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-processing-times.json": [
		161831,
		3,
		161831
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-results/viewing": [
		369480,
		3,
		369480
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/app-results/viewing.json": [
		369480,
		3,
		369480
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/dna-app-market/security-encryption": [
		10166,
		3,
		10166
	],
	"./knowledge-center/structured-data/dna-analysis-apps-reports/dna-app-market/security-encryption.json": [
		10166,
		3,
		10166
	],
	"./knowledge-center/structured-data/dna-collection-kit-images": [
		668174,
		3,
		668174
	],
	"./knowledge-center/structured-data/dna-collection-kit-images.json": [
		668174,
		3,
		668174
	],
	"./knowledge-center/structured-data/dna-data-privacy-confidentiality-ownership": [
		732819,
		3,
		732819
	],
	"./knowledge-center/structured-data/dna-data-privacy-confidentiality-ownership.json": [
		732819,
		3,
		732819
	],
	"./knowledge-center/structured-data/dna-data-storage": [
		905021,
		3,
		905021
	],
	"./knowledge-center/structured-data/dna-data-storage/": [
		905021,
		3,
		905021
	],
	"./knowledge-center/structured-data/dna-data-storage/accessing": [
		24890,
		3,
		24890
	],
	"./knowledge-center/structured-data/dna-data-storage/accessing.json": [
		24890,
		3,
		24890
	],
	"./knowledge-center/structured-data/dna-data-storage/confidentiality": [
		845248,
		3,
		845248
	],
	"./knowledge-center/structured-data/dna-data-storage/confidentiality.json": [
		845248,
		3,
		845248
	],
	"./knowledge-center/structured-data/dna-data-storage/datasets": [
		644238,
		3,
		644238
	],
	"./knowledge-center/structured-data/dna-data-storage/datasets.json": [
		644238,
		3,
		644238
	],
	"./knowledge-center/structured-data/dna-data-storage/deleting-dna-data-files": [
		60378,
		3,
		60378
	],
	"./knowledge-center/structured-data/dna-data-storage/deleting-dna-data-files.json": [
		60378,
		3,
		60378
	],
	"./knowledge-center/structured-data/dna-data-storage/downloading": [
		10854,
		3,
		10854
	],
	"./knowledge-center/structured-data/dna-data-storage/downloading.json": [
		10854,
		3,
		10854
	],
	"./knowledge-center/structured-data/dna-data-storage/european-union-data-protection": [
		870495,
		3,
		870495
	],
	"./knowledge-center/structured-data/dna-data-storage/european-union-data-protection.json": [
		870495,
		3,
		870495
	],
	"./knowledge-center/structured-data/dna-data-storage/formats": [
		593067,
		3,
		593067
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/": [
		593067,
		3,
		593067
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/clinical-vcf": [
		127600,
		3,
		127600
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/clinical-vcf.json": [
		127600,
		3,
		127600
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/fastq-format-compatibility": [
		516297,
		3,
		516297
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/fastq-format-compatibility.json": [
		516297,
		3,
		516297
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/index": [
		593067,
		3,
		593067
	],
	"./knowledge-center/structured-data/dna-data-storage/formats/index.json": [
		593067,
		3,
		593067
	],
	"./knowledge-center/structured-data/dna-data-storage/index": [
		905021,
		3,
		905021
	],
	"./knowledge-center/structured-data/dna-data-storage/index.json": [
		905021,
		3,
		905021
	],
	"./knowledge-center/structured-data/dna-data-storage/ownership": [
		305991,
		3,
		305991
	],
	"./knowledge-center/structured-data/dna-data-storage/ownership.json": [
		305991,
		3,
		305991
	],
	"./knowledge-center/structured-data/dna-data-storage/security": [
		190831,
		3,
		190831
	],
	"./knowledge-center/structured-data/dna-data-storage/security.json": [
		190831,
		3,
		190831
	],
	"./knowledge-center/structured-data/dna-data-storage/storing": [
		357536,
		3,
		357536
	],
	"./knowledge-center/structured-data/dna-data-storage/storing.json": [
		357536,
		3,
		357536
	],
	"./knowledge-center/structured-data/dna-data-storage/universal-data-compatibility": [
		149715,
		3,
		149715
	],
	"./knowledge-center/structured-data/dna-data-storage/universal-data-compatibility.json": [
		149715,
		3,
		149715
	],
	"./knowledge-center/structured-data/dna-data-storage/uploading": [
		419208,
		3,
		419208
	],
	"./knowledge-center/structured-data/dna-data-storage/uploading.json": [
		419208,
		3,
		419208
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis": [
		512184,
		3,
		512184
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/": [
		512184,
		3,
		512184
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results": [
		409857,
		3,
		409857
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results/": [
		409857,
		3,
		409857
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results/downloading-results": [
		693081,
		3,
		693081
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results/downloading-results.json": [
		693081,
		3,
		693081
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results/index": [
		409857,
		3,
		409857
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/app-and-report-results/index.json": [
		409857,
		3,
		409857
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/index": [
		512184,
		3,
		512184
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/index.json": [
		512184,
		3,
		512184
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace": [
		458567,
		3,
		458567
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/": [
		458567,
		3,
		458567
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/exploring-marketplace": [
		877269,
		3,
		877269
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/exploring-marketplace.json": [
		877269,
		3,
		877269
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/free-apps-reports": [
		53756,
		3,
		53756
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/free-apps-reports.json": [
		53756,
		3,
		53756
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/index": [
		458567,
		3,
		458567
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/index.json": [
		458567,
		3,
		458567
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/payment-methods": [
		513245,
		3,
		513245
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/payment-methods/": [
		513245,
		3,
		513245
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/payment-methods/index": [
		513245,
		3,
		513245
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/payment-methods/index.json": [
		513245,
		3,
		513245
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/premium-apps-reports": [
		256800,
		3,
		256800
	],
	"./knowledge-center/structured-data/dna-reports-app-analysis/report-marketplace/premium-apps-reports.json": [
		256800,
		3,
		256800
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer": [
		222462,
		3,
		222462
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/": [
		222462,
		3,
		222462
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-faq": [
		606989,
		3,
		606989
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-faq.json": [
		606989,
		3,
		606989
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-plus-benefits": [
		978338,
		3,
		978338
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-plus-benefits.json": [
		978338,
		3,
		978338
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-premium-benefits": [
		457314,
		3,
		457314
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/genome-explorer-premium-benefits.json": [
		457314,
		3,
		457314
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/guide-to-genome-explorer-free": [
		773939,
		3,
		773939
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/guide-to-genome-explorer-free.json": [
		773939,
		3,
		773939
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/index": [
		222462,
		3,
		222462
	],
	"./knowledge-center/structured-data/education-center/what-is-genome-explorer/index.json": [
		222462,
		3,
		222462
	],
	"./knowledge-center/structured-data/faqs": [
		90669,
		3,
		90669
	],
	"./knowledge-center/structured-data/faqs/": [
		90669,
		3,
		90669
	],
	"./knowledge-center/structured-data/faqs/can-i-access-and-download-my-raw-dna-data": [
		512480,
		3,
		512480
	],
	"./knowledge-center/structured-data/faqs/can-i-access-and-download-my-raw-dna-data.json": [
		512480,
		3,
		512480
	],
	"./knowledge-center/structured-data/faqs/can-i-delete-my-data": [
		426616,
		3,
		426616
	],
	"./knowledge-center/structured-data/faqs/can-i-delete-my-data.json": [
		426616,
		3,
		426616
	],
	"./knowledge-center/structured-data/faqs/can-i-upload-dna-data-or-genome-sequencing-data-i-already-have": [
		695678,
		3,
		695678
	],
	"./knowledge-center/structured-data/faqs/can-i-upload-dna-data-or-genome-sequencing-data-i-already-have.json": [
		695678,
		3,
		695678
	],
	"./knowledge-center/structured-data/faqs/can-i-upload-my-raw-dna-data-sequencingcom-third-party-sites-such-online": [
		879726,
		3,
		879726
	],
	"./knowledge-center/structured-data/faqs/can-i-upload-my-raw-dna-data-sequencingcom-third-party-sites-such-online.json": [
		879726,
		3,
		879726
	],
	"./knowledge-center/structured-data/faqs/chimerism-test": [
		49574,
		3,
		49574
	],
	"./knowledge-center/structured-data/faqs/chimerism-test.json": [
		49574,
		3,
		49574
	],
	"./knowledge-center/structured-data/faqs/digital-genome-missing-data": [
		524619,
		3,
		524619
	],
	"./knowledge-center/structured-data/faqs/digital-genome-missing-data.json": [
		524619,
		3,
		524619
	],
	"./knowledge-center/structured-data/faqs/do-you-accept-hsa-and-fsa-cards": [
		800065,
		3,
		800065
	],
	"./knowledge-center/structured-data/faqs/do-you-accept-hsa-and-fsa-cards.json": [
		800065,
		3,
		800065
	],
	"./knowledge-center/structured-data/faqs/do-you-sell-or-share-my-data-anyone": [
		511289,
		3,
		511289
	],
	"./knowledge-center/structured-data/faqs/do-you-sell-or-share-my-data-anyone.json": [
		511289,
		3,
		511289
	],
	"./knowledge-center/structured-data/faqs/does-23andme-ancestrycom-myheritage-test-my-entire-genome": [
		250306,
		3,
		250306
	],
	"./knowledge-center/structured-data/faqs/does-23andme-ancestrycom-myheritage-test-my-entire-genome.json": [
		250306,
		3,
		250306
	],
	"./knowledge-center/structured-data/faqs/guide-disease-specific-results-next-gen-screening": [
		606182,
		3,
		606182
	],
	"./knowledge-center/structured-data/faqs/guide-disease-specific-results-next-gen-screening.json": [
		606182,
		3,
		606182
	],
	"./knowledge-center/structured-data/faqs/how-do-i-check-kit-status": [
		605482,
		3,
		605482
	],
	"./knowledge-center/structured-data/faqs/how-do-i-check-kit-status.json": [
		605482,
		3,
		605482
	],
	"./knowledge-center/structured-data/faqs/index": [
		90669,
		3,
		90669
	],
	"./knowledge-center/structured-data/faqs/index.json": [
		90669,
		3,
		90669
	],
	"./knowledge-center/structured-data/faqs/one-genome-technology": [
		463981,
		3,
		463981
	],
	"./knowledge-center/structured-data/faqs/one-genome-technology.json": [
		463981,
		3,
		463981
	],
	"./knowledge-center/structured-data/faqs/privacy-first-policy": [
		984436,
		3,
		984436
	],
	"./knowledge-center/structured-data/faqs/privacy-first-policy.json": [
		984436,
		3,
		984436
	],
	"./knowledge-center/structured-data/faqs/turnaround-time-whole-genome-sequencing": [
		246429,
		3,
		246429
	],
	"./knowledge-center/structured-data/faqs/turnaround-time-whole-genome-sequencing.json": [
		246429,
		3,
		246429
	],
	"./knowledge-center/structured-data/faqs/what-certifications-does-laboratory-have": [
		363865,
		3,
		363865
	],
	"./knowledge-center/structured-data/faqs/what-certifications-does-laboratory-have.json": [
		363865,
		3,
		363865
	],
	"./knowledge-center/structured-data/faqs/what-does-it-mean-when-genome-explorer-says-variant-pathogenic": [
		738453,
		3,
		738453
	],
	"./knowledge-center/structured-data/faqs/what-does-it-mean-when-genome-explorer-says-variant-pathogenic.json": [
		738453,
		3,
		738453
	],
	"./knowledge-center/structured-data/faqs/what-happens-if-issue-with-kit-or-sequencing": [
		410189,
		3,
		410189
	],
	"./knowledge-center/structured-data/faqs/what-happens-if-issue-with-kit-or-sequencing.json": [
		410189,
		3,
		410189
	],
	"./knowledge-center/structured-data/faqs/what-sequencing-platform-and-bioinformatics-pipeline-do-you-use": [
		636944,
		3,
		636944
	],
	"./knowledge-center/structured-data/faqs/what-sequencing-platform-and-bioinformatics-pipeline-do-you-use.json": [
		636944,
		3,
		636944
	],
	"./knowledge-center/structured-data/faqs/what-sequencings-dna-membership-program": [
		216966,
		3,
		216966
	],
	"./knowledge-center/structured-data/faqs/what-sequencings-dna-membership-program.json": [
		216966,
		3,
		216966
	],
	"./knowledge-center/structured-data/faqs/what-types-data-are-provided-your-dna-testing-and-genome-sequencing": [
		68685,
		3,
		68685
	],
	"./knowledge-center/structured-data/faqs/what-types-data-are-provided-your-dna-testing-and-genome-sequencing.json": [
		68685,
		3,
		68685
	],
	"./knowledge-center/structured-data/faqs/what’s-difference-between-your-standard-expedited-and-ultra-rapid-genome": [
		237720,
		3,
		237720
	],
	"./knowledge-center/structured-data/faqs/what’s-difference-between-your-standard-expedited-and-ultra-rapid-genome.json": [
		237720,
		3,
		237720
	],
	"./knowledge-center/structured-data/faqs/where-do-you-ship-your-dna-collection-kits": [
		323424,
		3,
		323424
	],
	"./knowledge-center/structured-data/faqs/where-do-you-ship-your-dna-collection-kits.json": [
		323424,
		3,
		323424
	],
	"./knowledge-center/structured-data/faqs/who-is-sequencing": [
		412071,
		3,
		412071
	],
	"./knowledge-center/structured-data/faqs/who-is-sequencing.json": [
		412071,
		3,
		412071
	],
	"./knowledge-center/structured-data/free-unlimited-dna-genome-data-storage": [
		105505,
		3,
		105505
	],
	"./knowledge-center/structured-data/free-unlimited-dna-genome-data-storage.json": [
		105505,
		3,
		105505
	],
	"./knowledge-center/structured-data/getting-started": [
		115212,
		3,
		115212
	],
	"./knowledge-center/structured-data/getting-started/": [
		115212,
		3,
		115212
	],
	"./knowledge-center/structured-data/getting-started/account-security-features": [
		32874,
		3,
		32874
	],
	"./knowledge-center/structured-data/getting-started/account-security-features.json": [
		32874,
		3,
		32874
	],
	"./knowledge-center/structured-data/getting-started/account-status": [
		920486,
		3,
		920486
	],
	"./knowledge-center/structured-data/getting-started/account-status/": [
		920486,
		3,
		920486
	],
	"./knowledge-center/structured-data/getting-started/account-status/delete-account": [
		108744,
		3,
		108744
	],
	"./knowledge-center/structured-data/getting-started/account-status/delete-account.json": [
		108744,
		3,
		108744
	],
	"./knowledge-center/structured-data/getting-started/account-status/index": [
		920486,
		3,
		920486
	],
	"./knowledge-center/structured-data/getting-started/account-status/index.json": [
		920486,
		3,
		920486
	],
	"./knowledge-center/structured-data/getting-started/index": [
		115212,
		3,
		115212
	],
	"./knowledge-center/structured-data/getting-started/index.json": [
		115212,
		3,
		115212
	],
	"./knowledge-center/structured-data/getting-started/membership": [
		123054,
		3,
		123054
	],
	"./knowledge-center/structured-data/getting-started/membership/": [
		123054,
		3,
		123054
	],
	"./knowledge-center/structured-data/getting-started/membership/genome-plan-membership-faqs": [
		871233,
		3,
		871233
	],
	"./knowledge-center/structured-data/getting-started/membership/genome-plan-membership-faqs/": [
		871233,
		3,
		871233
	],
	"./knowledge-center/structured-data/getting-started/membership/genome-plan-membership-faqs/index": [
		871233,
		3,
		871233
	],
	"./knowledge-center/structured-data/getting-started/membership/genome-plan-membership-faqs/index.json": [
		871233,
		3,
		871233
	],
	"./knowledge-center/structured-data/getting-started/membership/genomes-genome-plans-genome-scans": [
		269401,
		3,
		965163
	],
	"./knowledge-center/structured-data/getting-started/membership/genomes-genome-plans-genome-scans.json": [
		269401,
		3,
		965163
	],
	"./knowledge-center/structured-data/getting-started/membership/index": [
		123054,
		3,
		123054
	],
	"./knowledge-center/structured-data/getting-started/membership/index.json": [
		123054,
		3,
		123054
	],
	"./knowledge-center/structured-data/getting-started/sign": [
		586959,
		3,
		586959
	],
	"./knowledge-center/structured-data/getting-started/sign.json": [
		586959,
		3,
		586959
	],
	"./knowledge-center/structured-data/getting-started/uploading-genetic-data": [
		181332,
		3,
		181332
	],
	"./knowledge-center/structured-data/getting-started/uploading-genetic-data.json": [
		181332,
		3,
		181332
	],
	"./knowledge-center/structured-data/global-alliance-beacon-network": [
		598309,
		3,
		598309
	],
	"./knowledge-center/structured-data/global-alliance-beacon-network.json": [
		598309,
		3,
		598309
	],
	"./knowledge-center/structured-data/healthcare-professionals": [
		228480,
		3,
		955261
	],
	"./knowledge-center/structured-data/healthcare-professionals/": [
		228480,
		3,
		955261
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports": [
		76517,
		3,
		76517
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/": [
		76517,
		3,
		76517
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/healthcare-pro-report": [
		851326,
		3,
		851326
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/healthcare-pro-report.json": [
		851326,
		3,
		851326
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/index": [
		76517,
		3,
		76517
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/index.json": [
		76517,
		3,
		76517
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/patient-reports": [
		972302,
		3,
		972302
	],
	"./knowledge-center/structured-data/healthcare-professionals/genetic-reports/patient-reports.json": [
		972302,
		3,
		972302
	],
	"./knowledge-center/structured-data/healthcare-professionals/hipaa-business-associate-agreement-baa": [
		947312,
		3,
		947312
	],
	"./knowledge-center/structured-data/healthcare-professionals/hipaa-business-associate-agreement-baa.json": [
		947312,
		3,
		947312
	],
	"./knowledge-center/structured-data/healthcare-professionals/hipaa-compliance-certifications": [
		703500,
		3,
		703500
	],
	"./knowledge-center/structured-data/healthcare-professionals/hipaa-compliance-certifications.json": [
		703500,
		3,
		703500
	],
	"./knowledge-center/structured-data/healthcare-professionals/index": [
		228480,
		3,
		955261
	],
	"./knowledge-center/structured-data/healthcare-professionals/index.json": [
		228480,
		3,
		955261
	],
	"./knowledge-center/structured-data/healthcare-professionals/spotlight-healthcare-pro": [
		238581,
		3,
		238581
	],
	"./knowledge-center/structured-data/healthcare-professionals/spotlight-healthcare-pro.json": [
		238581,
		3,
		238581
	],
	"./knowledge-center/structured-data/import-from-laboratory": [
		757599,
		3,
		757599
	],
	"./knowledge-center/structured-data/import-from-laboratory.json": [
		757599,
		3,
		757599
	],
	"./knowledge-center/structured-data/index": [
		283416,
		3,
		283416
	],
	"./knowledge-center/structured-data/index.json": [
		283416,
		3,
		283416
	],
	"./knowledge-center/structured-data/individuals-families": [
		791751,
		3,
		791751
	],
	"./knowledge-center/structured-data/individuals-families/": [
		791751,
		3,
		791751
	],
	"./knowledge-center/structured-data/individuals-families/how-use-report": [
		770627,
		3,
		770627
	],
	"./knowledge-center/structured-data/individuals-families/how-use-report.json": [
		770627,
		3,
		770627
	],
	"./knowledge-center/structured-data/individuals-families/index": [
		791751,
		3,
		791751
	],
	"./knowledge-center/structured-data/individuals-families/index.json": [
		791751,
		3,
		791751
	],
	"./knowledge-center/structured-data/individuals-families/types-analysis": [
		980793,
		3,
		980793
	],
	"./knowledge-center/structured-data/individuals-families/types-analysis.json": [
		980793,
		3,
		980793
	],
	"./knowledge-center/structured-data/intro-to-site-universal-dna-compatibility": [
		782609,
		3,
		782609
	],
	"./knowledge-center/structured-data/intro-to-site-universal-dna-compatibility/": [
		782609,
		3,
		782609
	],
	"./knowledge-center/structured-data/intro-to-site-universal-dna-compatibility/index": [
		782609,
		3,
		782609
	],
	"./knowledge-center/structured-data/intro-to-site-universal-dna-compatibility/index.json": [
		782609,
		3,
		782609
	],
	"./knowledge-center/structured-data/introduction/i-have-genetic-data": [
		674057,
		3,
		674057
	],
	"./knowledge-center/structured-data/introduction/i-have-genetic-data.json": [
		674057,
		3,
		674057
	],
	"./knowledge-center/structured-data/laboratories": [
		611844,
		3,
		611844
	],
	"./knowledge-center/structured-data/laboratories/": [
		611844,
		3,
		611844
	],
	"./knowledge-center/structured-data/laboratories/become-preferred-provider-genetic-testing": [
		36898,
		3,
		36898
	],
	"./knowledge-center/structured-data/laboratories/become-preferred-provider-genetic-testing.json": [
		36898,
		3,
		36898
	],
	"./knowledge-center/structured-data/laboratories/data-storage": [
		613834,
		3,
		613834
	],
	"./knowledge-center/structured-data/laboratories/data-storage/": [
		613834,
		3,
		613834
	],
	"./knowledge-center/structured-data/laboratories/data-storage/index": [
		613834,
		3,
		613834
	],
	"./knowledge-center/structured-data/laboratories/data-storage/index.json": [
		613834,
		3,
		613834
	],
	"./knowledge-center/structured-data/laboratories/data-storage/uploading-data-and-batch-uploads": [
		32865,
		3,
		32865
	],
	"./knowledge-center/structured-data/laboratories/data-storage/uploading-data-and-batch-uploads.json": [
		32865,
		3,
		32865
	],
	"./knowledge-center/structured-data/laboratories/hipaa-business-associate-agreement-baa": [
		502504,
		3,
		502504
	],
	"./knowledge-center/structured-data/laboratories/hipaa-business-associate-agreement-baa.json": [
		502504,
		3,
		502504
	],
	"./knowledge-center/structured-data/laboratories/hipaa-compliance-certifications": [
		141056,
		3,
		141056
	],
	"./knowledge-center/structured-data/laboratories/hipaa-compliance-certifications.json": [
		141056,
		3,
		141056
	],
	"./knowledge-center/structured-data/laboratories/index": [
		611844,
		3,
		611844
	],
	"./knowledge-center/structured-data/laboratories/index.json": [
		611844,
		3,
		611844
	],
	"./knowledge-center/structured-data/laboratories/obtain-more-data-you-generate": [
		762420,
		3,
		762420
	],
	"./knowledge-center/structured-data/laboratories/obtain-more-data-you-generate.json": [
		762420,
		3,
		762420
	],
	"./knowledge-center/structured-data/logging-in": [
		358384,
		3,
		358384
	],
	"./knowledge-center/structured-data/logging-in.json": [
		358384,
		3,
		358384
	],
	"./knowledge-center/structured-data/membership-plans": [
		451810,
		3,
		451810
	],
	"./knowledge-center/structured-data/membership-plans.json": [
		451810,
		3,
		451810
	],
	"./knowledge-center/structured-data/node/15984": [
		862561,
		3,
		862561
	],
	"./knowledge-center/structured-data/node/15984.json": [
		862561,
		3,
		862561
	],
	"./knowledge-center/structured-data/node/16092": [
		919421,
		3,
		919421
	],
	"./knowledge-center/structured-data/node/16092.json": [
		919421,
		3,
		919421
	],
	"./knowledge-center/structured-data/node/5224": [
		993394,
		3,
		993394
	],
	"./knowledge-center/structured-data/node/5224.json": [
		993394,
		3,
		993394
	],
	"./knowledge-center/structured-data/one-genome": [
		3653,
		3,
		3653
	],
	"./knowledge-center/structured-data/one-genome.json": [
		3653,
		3,
		3653
	],
	"./knowledge-center/structured-data/patient-data": [
		938569,
		3,
		938569
	],
	"./knowledge-center/structured-data/patient-data.json": [
		938569,
		3,
		938569
	],
	"./knowledge-center/structured-data/problem-solving": [
		67156,
		3,
		67156
	],
	"./knowledge-center/structured-data/problem-solving.json": [
		67156,
		3,
		67156
	],
	"./knowledge-center/structured-data/promethease": [
		352895,
		3,
		352895
	],
	"./knowledge-center/structured-data/promethease.json": [
		352895,
		3,
		352895
	],
	"./knowledge-center/structured-data/researchers": [
		382693,
		3,
		382693
	],
	"./knowledge-center/structured-data/researchers/": [
		382693,
		3,
		382693
	],
	"./knowledge-center/structured-data/researchers/certifications-and-compliance": [
		176157,
		3,
		176157
	],
	"./knowledge-center/structured-data/researchers/certifications-and-compliance.json": [
		176157,
		3,
		176157
	],
	"./knowledge-center/structured-data/researchers/data": [
		190169,
		3,
		190169
	],
	"./knowledge-center/structured-data/researchers/data.json": [
		190169,
		3,
		190169
	],
	"./knowledge-center/structured-data/researchers/hipaa-business-associate-agreement-baa": [
		344569,
		3,
		344569
	],
	"./knowledge-center/structured-data/researchers/hipaa-business-associate-agreement-baa.json": [
		344569,
		3,
		344569
	],
	"./knowledge-center/structured-data/researchers/index": [
		382693,
		3,
		382693
	],
	"./knowledge-center/structured-data/researchers/index.json": [
		382693,
		3,
		382693
	],
	"./knowledge-center/structured-data/researchers/miame-compliance": [
		232133,
		3,
		232133
	],
	"./knowledge-center/structured-data/researchers/miame-compliance.json": [
		232133,
		3,
		232133
	],
	"./knowledge-center/structured-data/researchers/reference-genomes": [
		550110,
		3,
		550110
	],
	"./knowledge-center/structured-data/researchers/reference-genomes/": [
		550110,
		3,
		550110
	],
	"./knowledge-center/structured-data/researchers/reference-genomes/autodetect": [
		619983,
		3,
		619983
	],
	"./knowledge-center/structured-data/researchers/reference-genomes/autodetect.json": [
		619983,
		3,
		619983
	],
	"./knowledge-center/structured-data/researchers/reference-genomes/index": [
		550110,
		3,
		550110
	],
	"./knowledge-center/structured-data/researchers/reference-genomes/index.json": [
		550110,
		3,
		550110
	],
	"./knowledge-center/structured-data/researchers/uploading-and-importing": [
		774913,
		3,
		774913
	],
	"./knowledge-center/structured-data/researchers/uploading-and-importing.json": [
		774913,
		3,
		774913
	],
	"./knowledge-center/structured-data/saving-a-card-on-file": [
		816860,
		3,
		816860
	],
	"./knowledge-center/structured-data/saving-a-card-on-file.json": [
		816860,
		3,
		816860
	],
	"./knowledge-center/structured-data/sequencing-apps": [
		505246,
		3,
		505246
	],
	"./knowledge-center/structured-data/sequencing-apps-genome-explorer": [
		230664,
		3,
		230664
	],
	"./knowledge-center/structured-data/sequencing-apps-genome-explorer/": [
		230664,
		3,
		230664
	],
	"./knowledge-center/structured-data/sequencing-apps-genome-explorer/index": [
		230664,
		3,
		230664
	],
	"./knowledge-center/structured-data/sequencing-apps-genome-explorer/index.json": [
		230664,
		3,
		230664
	],
	"./knowledge-center/structured-data/sequencing-apps-health-scan": [
		93350,
		3,
		93350
	],
	"./knowledge-center/structured-data/sequencing-apps-health-scan.json": [
		93350,
		3,
		93350
	],
	"./knowledge-center/structured-data/sequencing-apps-ngds": [
		132826,
		3,
		132826
	],
	"./knowledge-center/structured-data/sequencing-apps-ngds/": [
		132826,
		3,
		132826
	],
	"./knowledge-center/structured-data/sequencing-apps-ngds/index": [
		132826,
		3,
		132826
	],
	"./knowledge-center/structured-data/sequencing-apps-ngds/index.json": [
		132826,
		3,
		132826
	],
	"./knowledge-center/structured-data/sequencing-apps/": [
		505246,
		3,
		505246
	],
	"./knowledge-center/structured-data/sequencing-apps/index": [
		505246,
		3,
		505246
	],
	"./knowledge-center/structured-data/sequencing-apps/index.json": [
		505246,
		3,
		505246
	],
	"./knowledge-center/structured-data/sequencing-apps/next-gen-disease-screen-ngds/sequencingai-result-summary-report": [
		865698,
		3,
		865698
	],
	"./knowledge-center/structured-data/sequencing-apps/next-gen-disease-screen-ngds/sequencingai-result-summary-report.json": [
		865698,
		3,
		865698
	],
	"./knowledge-center/structured-data/shipping-handling-dna-collection-kits": [
		261898,
		3,
		261898
	],
	"./knowledge-center/structured-data/shipping-handling-dna-collection-kits.json": [
		261898,
		3,
		261898
	],
	"./knowledge-center/structured-data/sign-in-options": [
		952583,
		3,
		952583
	],
	"./knowledge-center/structured-data/sign-in-options/": [
		952583,
		3,
		952583
	],
	"./knowledge-center/structured-data/sign-in-options/index": [
		952583,
		3,
		952583
	],
	"./knowledge-center/structured-data/sign-in-options/index.json": [
		952583,
		3,
		952583
	],
	"./knowledge-center/structured-data/single-sign-on": [
		819790,
		3,
		819790
	],
	"./knowledge-center/structured-data/single-sign-on.json": [
		819790,
		3,
		819790
	],
	"./knowledge-center/structured-data/site-guide": [
		870437,
		3,
		870437
	],
	"./knowledge-center/structured-data/site-guide/": [
		870437,
		3,
		870437
	],
	"./knowledge-center/structured-data/site-guide/account-settings": [
		37921,
		3,
		37921
	],
	"./knowledge-center/structured-data/site-guide/account-settings/": [
		37921,
		3,
		37921
	],
	"./knowledge-center/structured-data/site-guide/account-settings/index": [
		37921,
		3,
		37921
	],
	"./knowledge-center/structured-data/site-guide/account-settings/index.json": [
		37921,
		3,
		37921
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership": [
		483840,
		3,
		483840
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership/": [
		483840,
		3,
		483840
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership/how-modify-your-genome-plan": [
		604617,
		3,
		604617
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership/how-modify-your-genome-plan.json": [
		604617,
		3,
		604617
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership/index": [
		483840,
		3,
		483840
	],
	"./knowledge-center/structured-data/site-guide/account-settings/membership/index.json": [
		483840,
		3,
		483840
	],
	"./knowledge-center/structured-data/site-guide/account-settings/order-history": [
		4469,
		3,
		4469
	],
	"./knowledge-center/structured-data/site-guide/account-settings/order-history.json": [
		4469,
		3,
		4469
	],
	"./knowledge-center/structured-data/site-guide/account-settings/payment-methods": [
		557075,
		3,
		557075
	],
	"./knowledge-center/structured-data/site-guide/account-settings/payment-methods.json": [
		557075,
		3,
		557075
	],
	"./knowledge-center/structured-data/site-guide/account-settings/personal-information": [
		623689,
		3,
		623689
	],
	"./knowledge-center/structured-data/site-guide/account-settings/personal-information.json": [
		623689,
		3,
		623689
	],
	"./knowledge-center/structured-data/site-guide/account-settings/settings": [
		810381,
		3,
		810381
	],
	"./knowledge-center/structured-data/site-guide/account-settings/settings.json": [
		810381,
		3,
		810381
	],
	"./knowledge-center/structured-data/site-guide/data/apps/usage": [
		377791,
		3,
		377791
	],
	"./knowledge-center/structured-data/site-guide/data/apps/usage.json": [
		377791,
		3,
		377791
	],
	"./knowledge-center/structured-data/site-guide/data/big-yotta-upload-large-data-files/linux-headless-mode": [
		306360,
		3,
		306360
	],
	"./knowledge-center/structured-data/site-guide/data/big-yotta-upload-large-data-files/linux-headless-mode.json": [
		306360,
		3,
		306360
	],
	"./knowledge-center/structured-data/site-guide/data/big-yotta-upload-large-data-files/logging-big-yotta": [
		177240,
		3,
		177240
	],
	"./knowledge-center/structured-data/site-guide/data/big-yotta-upload-large-data-files/logging-big-yotta.json": [
		177240,
		3,
		177240
	],
	"./knowledge-center/structured-data/site-guide/home": [
		972219,
		3,
		972219
	],
	"./knowledge-center/structured-data/site-guide/home.json": [
		972219,
		3,
		972219
	],
	"./knowledge-center/structured-data/site-guide/index": [
		870437,
		3,
		870437
	],
	"./knowledge-center/structured-data/site-guide/index.json": [
		870437,
		3,
		870437
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/apps/processing-files": [
		546983,
		3,
		546983
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/apps/processing-files.json": [
		546983,
		3,
		546983
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/incompatible-files": [
		997997,
		3,
		997997
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/incompatible-files.json": [
		997997,
		3,
		997997
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/upload-center": [
		973364,
		3,
		973364
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/upload-center/": [
		973364,
		3,
		973364
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/upload-center/index": [
		973364,
		3,
		973364
	],
	"./knowledge-center/structured-data/site-guide/my-dna-data/upload-center/index.json": [
		973364,
		3,
		973364
	],
	"./knowledge-center/structured-data/site-guide/my-files/downloading-files": [
		244136,
		3,
		244136
	],
	"./knowledge-center/structured-data/site-guide/my-files/downloading-files.json": [
		244136,
		3,
		244136
	],
	"./knowledge-center/structured-data/site-guide/settings/login-history": [
		652765,
		3,
		652765
	],
	"./knowledge-center/structured-data/site-guide/settings/login-history.json": [
		652765,
		3,
		652765
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification": [
		392348,
		3,
		392348
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification/": [
		392348,
		3,
		392348
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification/enabling-2-step-verification": [
		598648,
		3,
		598648
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification/enabling-2-step-verification.json": [
		598648,
		3,
		598648
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification/index": [
		392348,
		3,
		392348
	],
	"./knowledge-center/structured-data/site-guide/settings/sign-options/2-step-verification/index.json": [
		392348,
		3,
		392348
	],
	"./knowledge-center/structured-data/site-guide/signing": [
		318471,
		3,
		318471
	],
	"./knowledge-center/structured-data/site-guide/signing/": [
		318471,
		3,
		318471
	],
	"./knowledge-center/structured-data/site-guide/signing/index": [
		318471,
		3,
		318471
	],
	"./knowledge-center/structured-data/site-guide/signing/index.json": [
		318471,
		3,
		318471
	],
	"./knowledge-center/structured-data/site-guide/signing/sign-options/2-step-verification/google-authenticator-app": [
		68420,
		3,
		68420
	],
	"./knowledge-center/structured-data/site-guide/signing/sign-options/2-step-verification/google-authenticator-app.json": [
		68420,
		3,
		68420
	],
	"./knowledge-center/structured-data/submitting-an-app": [
		4226,
		3,
		4226
	],
	"./knowledge-center/structured-data/submitting-an-app.json": [
		4226,
		3,
		4226
	],
	"./knowledge-center/structured-data/support": [
		855034,
		3,
		855034
	],
	"./knowledge-center/structured-data/support.json": [
		855034,
		3,
		855034
	],
	"./knowledge-center/structured-data/upload-from-computer": [
		542330,
		3,
		542330
	],
	"./knowledge-center/structured-data/upload-from-computer.json": [
		542330,
		3,
		542330
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free": [
		687251,
		3,
		687251
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/": [
		687251,
		3,
		687251
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/23andme": [
		912826,
		3,
		912826
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/23andme.json": [
		912826,
		3,
		912826
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/all-of-us-nih": [
		158010,
		3,
		158010
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/all-of-us-nih.json": [
		158010,
		3,
		158010
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/ancestrydna": [
		221350,
		3,
		221350
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/ancestrydna.json": [
		221350,
		3,
		221350
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dante-labs": [
		353185,
		3,
		353185
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dante-labs.json": [
		353185,
		3,
		353185
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dna-land": [
		458171,
		3,
		458171
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dna-land.json": [
		458171,
		3,
		458171
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dna-test-providers": [
		294716,
		3,
		294716
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/dna-test-providers.json": [
		294716,
		3,
		294716
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/familytreedna": [
		349957,
		3,
		349957
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/familytreedna.json": [
		349957,
		3,
		349957
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/genes-for-good": [
		862743,
		3,
		862743
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/genes-for-good.json": [
		862743,
		3,
		862743
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/homedna": [
		578314,
		3,
		578314
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/homedna.json": [
		578314,
		3,
		578314
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/index": [
		687251,
		3,
		687251
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/index.json": [
		687251,
		3,
		687251
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/living-dna": [
		303683,
		3,
		303683
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/living-dna.json": [
		303683,
		3,
		303683
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/myheritage": [
		723209,
		3,
		723209
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/myheritage.json": [
		723209,
		3,
		723209
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/nebula-genomics": [
		168102,
		3,
		168102
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/nebula-genomics.json": [
		168102,
		3,
		168102
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/tellmegen-dna": [
		807379,
		3,
		807379
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/tellmegen-dna.json": [
		807379,
		3,
		807379
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/vitagene": [
		208361,
		3,
		208361
	],
	"./knowledge-center/structured-data/upload-my-dna-data-free/vitagene.json": [
		208361,
		3,
		208361
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 852573;
module.exports = webpackAsyncContext;